var jT = Object.defineProperty;
var HT = (e, t, r) => t in e ? jT(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var c0 = (e, t, r) => (HT(e, typeof t != "symbol" ? t + "" : t, r), r);
import * as we from "react";
import ht, { useRef as qt, useEffect as gt, createContext as kn, forwardRef as Je, useState as rt, useLayoutEffect as Xu, useMemo as Jt, createElement as xa, useContext as Pn, useSyncExternalStore as $T, useCallback as Nt, Children as Qx, isValidElement as Xx, cloneElement as Zx, useId as Co, useReducer as Jx, Fragment as UT, memo as VT, Component as WT, useImperativeHandle as e8 } from "react";
import * as GT from "react-dom";
import { createPortal as t8 } from "react-dom";
var s1 = /* @__PURE__ */ ((e) => (e[e.None = 0] = "None", e[e.Errors = 1] = "Errors", e[e.Messages = 2] = "Messages", e[e.Verbose = 3] = "Verbose", e))(s1 || {}), r8 = /* @__PURE__ */ ((e) => (e[e.None = 0] = "None", e[e.AnonymousErrors = 1] = "AnonymousErrors", e[e.IdentifiableErrors = 2] = "IdentifiableErrors", e[e.ExtensiveTroubleShooting = 3] = "ExtensiveTroubleShooting", e))(r8 || {});
const fue = [
  "submitCurrentInputMessage",
  "updateInputMessage",
  "submitNewMessage",
  "clearChat",
  "openForm"
], gue = ["updateSearchQuery"], F1 = {
  organizationDisplayName: "",
  optOutAnalyticalCookies: !1,
  // disable use of cookies for analytics. Default is false.
  optOutAllAnalytics: !1,
  // disable all event logging, even analytics that don't use cookies (e.g. anonymous events)
  optOutFunctionalCookies: !1,
  // disable all cookies that are used for functionality, like caching chat sessions cross-tabs. Default is false.
  remoteErrorLogsLevel: 2,
  // set to true to disable remote error logging. Default is false.
  breadcrumbRules: {
    style: "TITLE_CASE"
  },
  consoleDebugLevel: 1,
  env: "PRODUCTION"
}, Hl = {
  placeholder: "How do I get started?",
  botName: void 0,
  shouldOpenLinksInNewTab: !0,
  alignMessagesToTop: !1,
  disclaimerSettings: {
    isDisclaimerEnabled: !1,
    disclaimerLabel: "Usage policy"
  },
  isChatSharingEnabled: !1,
  isViewOnly: !1,
  shouldScrollToBottomOnLoad: !1,
  defaultChatMode: "AUTO",
  toggleButtonSettings: {
    isChatModeToggleEnabled: !1
  },
  quickQuestionsLabel: "Example questions",
  quickQuestions: [],
  shouldHighlightFirstQuickQuestion: !0,
  shouldShowCopyChatButton: !1,
  getHelpCallToActions: [],
  workflowsHeader: "Workflows",
  workflows: [],
  actionButtonLabels: {
    clearButtonLabel: "Clear",
    shareButtonLabel: "Share",
    getHelpButtonLabel: "Get help",
    stopButtonLabel: "Stop",
    copyChatButtonLabel: "Copy"
  }
}, l1 = {
  prefilledQuery: "",
  tabSettings: {
    isAllTabEnabled: !0
  },
  shouldOpenLinksInNewTab: !1,
  maximumHitsLimit: 40,
  shouldShowAskAICard: !0
}, K_ = {
  isModeSwitchingEnabled: !0,
  defaultView: "SEARCH",
  forceInitialDefaultView: !1,
  isShortcutKeyEnabled: !0,
  openShortcutKey: "k",
  isAlignedToTop: !0,
  isAlignedToRight: !1,
  closeOnBlur: !0,
  switchToSearchMessage: "Search"
}, u5 = {
  chatButtonType: "PILL",
  isPositionFixed: !0,
  fixedPositionXOffset: "1.5rem",
  fixedPositionYOffset: "1.5rem",
  modalSettings: {
    defaultView: "AI_CHAT",
    forceInitialDefaultView: !1,
    isAlignedToTop: !0,
    isAlignedToRight: !1,
    closeOnBlur: !0,
    isShortcutKeyEnabled: !1,
    openShortcutKey: "/"
  }
}, c5 = {
  modalSettings: {
    defaultView: "SEARCH",
    forceInitialDefaultView: !1,
    isShortcutKeyEnabled: !0,
    openShortcutKey: "k",
    isAlignedToTop: !0,
    isAlignedToRight: !1,
    closeOnBlur: !0
  }
};
var L0 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function is(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Eb = { exports: {} }, d0 = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var d5;
function KT() {
  if (d5)
    return d0;
  d5 = 1;
  var e = ht, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, l, u) {
    var d, c = {}, p = null, f = null;
    u !== void 0 && (p = "" + u), l.key !== void 0 && (p = "" + l.key), l.ref !== void 0 && (f = l.ref);
    for (d in l)
      i.call(l, d) && !a.hasOwnProperty(d) && (c[d] = l[d]);
    if (s && s.defaultProps)
      for (d in l = s.defaultProps, l)
        c[d] === void 0 && (c[d] = l[d]);
    return { $$typeof: t, type: s, key: p, ref: f, props: c, _owner: n.current };
  }
  return d0.Fragment = r, d0.jsx = o, d0.jsxs = o, d0;
}
var p0 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var p5;
function YT() {
  return p5 || (p5 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = ht, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), c = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), g = Symbol.iterator, k = "@@iterator";
    function y(te) {
      if (te === null || typeof te != "object")
        return null;
      var $e = g && te[g] || te[k];
      return typeof $e == "function" ? $e : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function A(te) {
      {
        for (var $e = arguments.length, tt = new Array($e > 1 ? $e - 1 : 0), Et = 1; Et < $e; Et++)
          tt[Et - 1] = arguments[Et];
        T("error", te, tt);
      }
    }
    function T(te, $e, tt) {
      {
        var Et = _.ReactDebugCurrentFrame, Vt = Et.getStackAddendum();
        Vt !== "" && ($e += "%s", tt = tt.concat([Vt]));
        var Rt = tt.map(function(Gt) {
          return String(Gt);
        });
        Rt.unshift("Warning: " + $e), Function.prototype.apply.call(console[te], console, Rt);
      }
    }
    var N = !1, P = !1, B = !1, M = !1, X = !1, U;
    U = Symbol.for("react.module.reference");
    function K(te) {
      return !!(typeof te == "string" || typeof te == "function" || te === i || te === a || X || te === n || te === u || te === d || M || te === f || N || P || B || typeof te == "object" && te !== null && (te.$$typeof === p || te.$$typeof === c || te.$$typeof === o || te.$$typeof === s || te.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      te.$$typeof === U || te.getModuleId !== void 0));
    }
    function z(te, $e, tt) {
      var Et = te.displayName;
      if (Et)
        return Et;
      var Vt = $e.displayName || $e.name || "";
      return Vt !== "" ? tt + "(" + Vt + ")" : tt;
    }
    function j(te) {
      return te.displayName || "Context";
    }
    function J(te) {
      if (te == null)
        return null;
      if (typeof te.tag == "number" && A("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof te == "function")
        return te.displayName || te.name || null;
      if (typeof te == "string")
        return te;
      switch (te) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case a:
          return "Profiler";
        case n:
          return "StrictMode";
        case u:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof te == "object")
        switch (te.$$typeof) {
          case s:
            var $e = te;
            return j($e) + ".Consumer";
          case o:
            var tt = te;
            return j(tt._context) + ".Provider";
          case l:
            return z(te, te.render, "ForwardRef");
          case c:
            var Et = te.displayName || null;
            return Et !== null ? Et : J(te.type) || "Memo";
          case p: {
            var Vt = te, Rt = Vt._payload, Gt = Vt._init;
            try {
              return J(Gt(Rt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ie = Object.assign, ue = 0, de, he, Ee, Le, L, me, Se;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function He() {
      {
        if (ue === 0) {
          de = console.log, he = console.info, Ee = console.warn, Le = console.error, L = console.group, me = console.groupCollapsed, Se = console.groupEnd;
          var te = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: te,
            log: te,
            warn: te,
            error: te,
            group: te,
            groupCollapsed: te,
            groupEnd: te
          });
        }
        ue++;
      }
    }
    function xe() {
      {
        if (ue--, ue === 0) {
          var te = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ie({}, te, {
              value: de
            }),
            info: ie({}, te, {
              value: he
            }),
            warn: ie({}, te, {
              value: Ee
            }),
            error: ie({}, te, {
              value: Le
            }),
            group: ie({}, te, {
              value: L
            }),
            groupCollapsed: ie({}, te, {
              value: me
            }),
            groupEnd: ie({}, te, {
              value: Se
            })
          });
        }
        ue < 0 && A("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var _e = _.ReactCurrentDispatcher, Ze;
    function qe(te, $e, tt) {
      {
        if (Ze === void 0)
          try {
            throw Error();
          } catch (Vt) {
            var Et = Vt.stack.trim().match(/\n( *(at )?)/);
            Ze = Et && Et[1] || "";
          }
        return `
` + Ze + te;
      }
    }
    var nt = !1, at;
    {
      var At = typeof WeakMap == "function" ? WeakMap : Map;
      at = new At();
    }
    function Oe(te, $e) {
      if (!te || nt)
        return "";
      {
        var tt = at.get(te);
        if (tt !== void 0)
          return tt;
      }
      var Et;
      nt = !0;
      var Vt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Rt;
      Rt = _e.current, _e.current = null, He();
      try {
        if ($e) {
          var Gt = function() {
            throw Error();
          };
          if (Object.defineProperty(Gt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Gt, []);
            } catch (jr) {
              Et = jr;
            }
            Reflect.construct(te, [], Gt);
          } else {
            try {
              Gt.call();
            } catch (jr) {
              Et = jr;
            }
            te.call(Gt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (jr) {
            Et = jr;
          }
          te();
        }
      } catch (jr) {
        if (jr && Et && typeof jr.stack == "string") {
          for (var Lt = jr.stack.split(`
`), Mr = Et.stack.split(`
`), ar = Lt.length - 1, or = Mr.length - 1; ar >= 1 && or >= 0 && Lt[ar] !== Mr[or]; )
            or--;
          for (; ar >= 1 && or >= 0; ar--, or--)
            if (Lt[ar] !== Mr[or]) {
              if (ar !== 1 || or !== 1)
                do
                  if (ar--, or--, or < 0 || Lt[ar] !== Mr[or]) {
                    var dr = `
` + Lt[ar].replace(" at new ", " at ");
                    return te.displayName && dr.includes("<anonymous>") && (dr = dr.replace("<anonymous>", te.displayName)), typeof te == "function" && at.set(te, dr), dr;
                  }
                while (ar >= 1 && or >= 0);
              break;
            }
        }
      } finally {
        nt = !1, _e.current = Rt, xe(), Error.prepareStackTrace = Vt;
      }
      var Si = te ? te.displayName || te.name : "", hn = Si ? qe(Si) : "";
      return typeof te == "function" && at.set(te, hn), hn;
    }
    function wt(te, $e, tt) {
      return Oe(te, !1);
    }
    function Ge(te) {
      var $e = te.prototype;
      return !!($e && $e.isReactComponent);
    }
    function nr(te, $e, tt) {
      if (te == null)
        return "";
      if (typeof te == "function")
        return Oe(te, Ge(te));
      if (typeof te == "string")
        return qe(te);
      switch (te) {
        case u:
          return qe("Suspense");
        case d:
          return qe("SuspenseList");
      }
      if (typeof te == "object")
        switch (te.$$typeof) {
          case l:
            return wt(te.render);
          case c:
            return nr(te.type, $e, tt);
          case p: {
            var Et = te, Vt = Et._payload, Rt = Et._init;
            try {
              return nr(Rt(Vt), $e, tt);
            } catch {
            }
          }
        }
      return "";
    }
    var vr = Object.prototype.hasOwnProperty, zr = {}, Wr = _.ReactDebugCurrentFrame;
    function ne(te) {
      if (te) {
        var $e = te._owner, tt = nr(te.type, te._source, $e ? $e.type : null);
        Wr.setExtraStackFrame(tt);
      } else
        Wr.setExtraStackFrame(null);
    }
    function pe(te, $e, tt, Et, Vt) {
      {
        var Rt = Function.call.bind(vr);
        for (var Gt in te)
          if (Rt(te, Gt)) {
            var Lt = void 0;
            try {
              if (typeof te[Gt] != "function") {
                var Mr = Error((Et || "React class") + ": " + tt + " type `" + Gt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof te[Gt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Mr.name = "Invariant Violation", Mr;
              }
              Lt = te[Gt]($e, Gt, Et, tt, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ar) {
              Lt = ar;
            }
            Lt && !(Lt instanceof Error) && (ne(Vt), A("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Et || "React class", tt, Gt, typeof Lt), ne(null)), Lt instanceof Error && !(Lt.message in zr) && (zr[Lt.message] = !0, ne(Vt), A("Failed %s type: %s", tt, Lt.message), ne(null));
          }
      }
    }
    var Fe = Array.isArray;
    function Ye(te) {
      return Fe(te);
    }
    function Ue(te) {
      {
        var $e = typeof Symbol == "function" && Symbol.toStringTag, tt = $e && te[Symbol.toStringTag] || te.constructor.name || "Object";
        return tt;
      }
    }
    function Re(te) {
      try {
        return ot(te), !1;
      } catch {
        return !0;
      }
    }
    function ot(te) {
      return "" + te;
    }
    function Ut(te) {
      if (Re(te))
        return A("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ue(te)), ot(te);
    }
    var ge = _.ReactCurrentOwner, Ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ut, xt, Bt;
    Bt = {};
    function gr(te) {
      if (vr.call(te, "ref")) {
        var $e = Object.getOwnPropertyDescriptor(te, "ref").get;
        if ($e && $e.isReactWarning)
          return !1;
      }
      return te.ref !== void 0;
    }
    function Gr(te) {
      if (vr.call(te, "key")) {
        var $e = Object.getOwnPropertyDescriptor(te, "key").get;
        if ($e && $e.isReactWarning)
          return !1;
      }
      return te.key !== void 0;
    }
    function kr(te, $e) {
      if (typeof te.ref == "string" && ge.current && $e && ge.current.stateNode !== $e) {
        var tt = J(ge.current.type);
        Bt[tt] || (A('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', J(ge.current.type), te.ref), Bt[tt] = !0);
      }
    }
    function Xr(te, $e) {
      {
        var tt = function() {
          ut || (ut = !0, A("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", $e));
        };
        tt.isReactWarning = !0, Object.defineProperty(te, "key", {
          get: tt,
          configurable: !0
        });
      }
    }
    function Er(te, $e) {
      {
        var tt = function() {
          xt || (xt = !0, A("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", $e));
        };
        tt.isReactWarning = !0, Object.defineProperty(te, "ref", {
          get: tt,
          configurable: !0
        });
      }
    }
    var tr = function(te, $e, tt, Et, Vt, Rt, Gt) {
      var Lt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: te,
        key: $e,
        ref: tt,
        props: Gt,
        // Record the component responsible for creating this element.
        _owner: Rt
      };
      return Lt._store = {}, Object.defineProperty(Lt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Lt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Et
      }), Object.defineProperty(Lt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Vt
      }), Object.freeze && (Object.freeze(Lt.props), Object.freeze(Lt)), Lt;
    };
    function Ti(te, $e, tt, Et, Vt) {
      {
        var Rt, Gt = {}, Lt = null, Mr = null;
        tt !== void 0 && (Ut(tt), Lt = "" + tt), Gr($e) && (Ut($e.key), Lt = "" + $e.key), gr($e) && (Mr = $e.ref, kr($e, Vt));
        for (Rt in $e)
          vr.call($e, Rt) && !Ie.hasOwnProperty(Rt) && (Gt[Rt] = $e[Rt]);
        if (te && te.defaultProps) {
          var ar = te.defaultProps;
          for (Rt in ar)
            Gt[Rt] === void 0 && (Gt[Rt] = ar[Rt]);
        }
        if (Lt || Mr) {
          var or = typeof te == "function" ? te.displayName || te.name || "Unknown" : te;
          Lt && Xr(Gt, or), Mr && Er(Gt, or);
        }
        return tr(te, Lt, Mr, Vt, Et, ge.current, Gt);
      }
    }
    var lt = _.ReactCurrentOwner, _r = _.ReactDebugCurrentFrame;
    function hr(te) {
      if (te) {
        var $e = te._owner, tt = nr(te.type, te._source, $e ? $e.type : null);
        _r.setExtraStackFrame(tt);
      } else
        _r.setExtraStackFrame(null);
    }
    var $t;
    $t = !1;
    function pi(te) {
      return typeof te == "object" && te !== null && te.$$typeof === t;
    }
    function Di() {
      {
        if (lt.current) {
          var te = J(lt.current.type);
          if (te)
            return `

Check the render method of \`` + te + "`.";
        }
        return "";
      }
    }
    function Zi(te) {
      {
        if (te !== void 0) {
          var $e = te.fileName.replace(/^.*[\\\/]/, ""), tt = te.lineNumber;
          return `

Check your code at ` + $e + ":" + tt + ".";
        }
        return "";
      }
    }
    var yi = {};
    function pn(te) {
      {
        var $e = Di();
        if (!$e) {
          var tt = typeof te == "string" ? te : te.displayName || te.name;
          tt && ($e = `

Check the top-level render call using <` + tt + ">.");
        }
        return $e;
      }
    }
    function vi(te, $e) {
      {
        if (!te._store || te._store.validated || te.key != null)
          return;
        te._store.validated = !0;
        var tt = pn($e);
        if (yi[tt])
          return;
        yi[tt] = !0;
        var Et = "";
        te && te._owner && te._owner !== lt.current && (Et = " It was passed a child from " + J(te._owner.type) + "."), hr(te), A('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', tt, Et), hr(null);
      }
    }
    function Cr(te, $e) {
      {
        if (typeof te != "object")
          return;
        if (Ye(te))
          for (var tt = 0; tt < te.length; tt++) {
            var Et = te[tt];
            pi(Et) && vi(Et, $e);
          }
        else if (pi(te))
          te._store && (te._store.validated = !0);
        else if (te) {
          var Vt = y(te);
          if (typeof Vt == "function" && Vt !== te.entries)
            for (var Rt = Vt.call(te), Gt; !(Gt = Rt.next()).done; )
              pi(Gt.value) && vi(Gt.value, $e);
        }
      }
    }
    function ca(te) {
      {
        var $e = te.type;
        if ($e == null || typeof $e == "string")
          return;
        var tt;
        if (typeof $e == "function")
          tt = $e.propTypes;
        else if (typeof $e == "object" && ($e.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        $e.$$typeof === c))
          tt = $e.propTypes;
        else
          return;
        if (tt) {
          var Et = J($e);
          pe(tt, te.props, "prop", Et, te);
        } else if ($e.PropTypes !== void 0 && !$t) {
          $t = !0;
          var Vt = J($e);
          A("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Vt || "Unknown");
        }
        typeof $e.getDefaultProps == "function" && !$e.getDefaultProps.isReactClassApproved && A("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function da(te) {
      {
        for (var $e = Object.keys(te.props), tt = 0; tt < $e.length; tt++) {
          var Et = $e[tt];
          if (Et !== "children" && Et !== "key") {
            hr(te), A("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Et), hr(null);
            break;
          }
        }
        te.ref !== null && (hr(te), A("Invalid attribute `ref` supplied to `React.Fragment`."), hr(null));
      }
    }
    function pa(te, $e, tt, Et, Vt, Rt) {
      {
        var Gt = K(te);
        if (!Gt) {
          var Lt = "";
          (te === void 0 || typeof te == "object" && te !== null && Object.keys(te).length === 0) && (Lt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Mr = Zi(Vt);
          Mr ? Lt += Mr : Lt += Di();
          var ar;
          te === null ? ar = "null" : Ye(te) ? ar = "array" : te !== void 0 && te.$$typeof === t ? (ar = "<" + (J(te.type) || "Unknown") + " />", Lt = " Did you accidentally export a JSX literal instead of a component?") : ar = typeof te, A("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ar, Lt);
        }
        var or = Ti(te, $e, tt, Vt, Rt);
        if (or == null)
          return or;
        if (Gt) {
          var dr = $e.children;
          if (dr !== void 0)
            if (Et)
              if (Ye(dr)) {
                for (var Si = 0; Si < dr.length; Si++)
                  Cr(dr[Si], te);
                Object.freeze && Object.freeze(dr);
              } else
                A("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cr(dr, te);
        }
        return te === i ? da(or) : ca(or), or;
      }
    }
    function Lr(te, $e, tt) {
      return pa(te, $e, tt, !0);
    }
    function Ln(te, $e, tt) {
      return pa(te, $e, tt, !1);
    }
    var ha = Ln, Ji = Lr;
    p0.Fragment = i, p0.jsx = ha, p0.jsxs = Ji;
  }()), p0;
}
process.env.NODE_ENV === "production" ? Eb.exports = KT() : Eb.exports = YT();
var v = Eb.exports, i8 = { exports: {} };
(function(e) {
  (function(t) {
    var r = function(_, A, T) {
      if (!u(A) || c(A) || p(A) || f(A) || l(A))
        return A;
      var N, P = 0, B = 0;
      if (d(A))
        for (N = [], B = A.length; P < B; P++)
          N.push(r(_, A[P], T));
      else {
        N = {};
        for (var M in A)
          Object.prototype.hasOwnProperty.call(A, M) && (N[_(M, T)] = r(_, A[M], T));
      }
      return N;
    }, i = function(_, A) {
      A = A || {};
      var T = A.separator || "_", N = A.split || /(?=[A-Z])/;
      return _.split(N).join(T);
    }, n = function(_) {
      return g(_) ? _ : (_ = _.replace(/[\-_\s]+(.)?/g, function(A, T) {
        return T ? T.toUpperCase() : "";
      }), _.substr(0, 1).toLowerCase() + _.substr(1));
    }, a = function(_) {
      var A = n(_);
      return A.substr(0, 1).toUpperCase() + A.substr(1);
    }, o = function(_, A) {
      return i(_, A).toLowerCase();
    }, s = Object.prototype.toString, l = function(_) {
      return typeof _ == "function";
    }, u = function(_) {
      return _ === Object(_);
    }, d = function(_) {
      return s.call(_) == "[object Array]";
    }, c = function(_) {
      return s.call(_) == "[object Date]";
    }, p = function(_) {
      return s.call(_) == "[object RegExp]";
    }, f = function(_) {
      return s.call(_) == "[object Boolean]";
    }, g = function(_) {
      return _ = _ - 0, _ === _;
    }, k = function(_, A) {
      var T = A && "process" in A ? A.process : A;
      return typeof T != "function" ? _ : function(N, P) {
        return T(N, _, P);
      };
    }, y = {
      camelize: n,
      decamelize: o,
      pascalize: a,
      depascalize: o,
      camelizeKeys: function(_, A) {
        return r(k(n, A), _);
      },
      decamelizeKeys: function(_, A) {
        return r(k(o, A), _, A);
      },
      pascalizeKeys: function(_, A) {
        return r(k(a, A), _);
      },
      depascalizeKeys: function() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };
    e.exports ? e.exports = y : t.humps = y;
  })(L0);
})(i8);
var qT = i8.exports, Fu = {};
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h5;
function QT() {
  if (h5)
    return Fu;
  h5 = 1;
  var e = ht;
  function t(E) {
    for (var I = "https://reactjs.org/docs/error-decoder.html?invariant=" + E, V = 1; V < arguments.length; V++)
      I += "&args[]=" + encodeURIComponent(arguments[V]);
    return "Minified React error #" + E + "; visit " + I + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var r = Object.prototype.hasOwnProperty, i = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, n = {}, a = {};
  function o(E) {
    return r.call(a, E) ? !0 : r.call(n, E) ? !1 : i.test(E) ? a[E] = !0 : (n[E] = !0, !1);
  }
  function s(E, I, V, q, ve, ce, Ae) {
    this.acceptsBooleans = I === 2 || I === 3 || I === 4, this.attributeName = q, this.attributeNamespace = ve, this.mustUseProperty = V, this.propertyName = E, this.type = I, this.sanitizeURL = ce, this.removeEmptyString = Ae;
  }
  var l = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(E) {
    l[E] = new s(E, 0, !1, E, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(E) {
    var I = E[0];
    l[I] = new s(I, 1, !1, E[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(E) {
    l[E] = new s(E, 2, !1, E.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(E) {
    l[E] = new s(E, 2, !1, E, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(E) {
    l[E] = new s(E, 3, !1, E.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(E) {
    l[E] = new s(E, 3, !0, E, null, !1, !1);
  }), ["capture", "download"].forEach(function(E) {
    l[E] = new s(E, 4, !1, E, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(E) {
    l[E] = new s(E, 6, !1, E, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(E) {
    l[E] = new s(E, 5, !1, E.toLowerCase(), null, !1, !1);
  });
  var u = /[\-:]([a-z])/g;
  function d(E) {
    return E[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(E) {
    var I = E.replace(
      u,
      d
    );
    l[I] = new s(I, 1, !1, E, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(E) {
    var I = E.replace(u, d);
    l[I] = new s(I, 1, !1, E, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(E) {
    var I = E.replace(u, d);
    l[I] = new s(I, 1, !1, E, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(E) {
    l[E] = new s(E, 1, !1, E.toLowerCase(), null, !1, !1);
  }), l.xlinkHref = new s("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(E) {
    l[E] = new s(E, 1, !1, E.toLowerCase(), null, !0, !0);
  });
  var c = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, p = ["Webkit", "ms", "Moz", "O"];
  Object.keys(c).forEach(function(E) {
    p.forEach(function(I) {
      I = I + E.charAt(0).toUpperCase() + E.substring(1), c[I] = c[E];
    });
  });
  var f = /["'&<>]/;
  function g(E) {
    if (typeof E == "boolean" || typeof E == "number")
      return "" + E;
    E = "" + E;
    var I = f.exec(E);
    if (I) {
      var V = "", q, ve = 0;
      for (q = I.index; q < E.length; q++) {
        switch (E.charCodeAt(q)) {
          case 34:
            I = "&quot;";
            break;
          case 38:
            I = "&amp;";
            break;
          case 39:
            I = "&#x27;";
            break;
          case 60:
            I = "&lt;";
            break;
          case 62:
            I = "&gt;";
            break;
          default:
            continue;
        }
        ve !== q && (V += E.substring(ve, q)), ve = q + 1, V += I;
      }
      E = ve !== q ? V + E.substring(ve, q) : V;
    }
    return E;
  }
  var k = /([A-Z])/g, y = /^ms-/, _ = Array.isArray;
  function A(E, I) {
    return { insertionMode: E, selectedValue: I };
  }
  function T(E, I, V) {
    switch (I) {
      case "select":
        return A(1, V.value != null ? V.value : V.defaultValue);
      case "svg":
        return A(2, null);
      case "math":
        return A(3, null);
      case "foreignObject":
        return A(1, null);
      case "table":
        return A(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return A(5, null);
      case "colgroup":
        return A(7, null);
      case "tr":
        return A(6, null);
    }
    return 4 <= E.insertionMode || E.insertionMode === 0 ? A(1, null) : E;
  }
  var N = /* @__PURE__ */ new Map();
  function P(E, I, V) {
    if (typeof V != "object")
      throw Error(t(62));
    I = !0;
    for (var q in V)
      if (r.call(V, q)) {
        var ve = V[q];
        if (ve != null && typeof ve != "boolean" && ve !== "") {
          if (q.indexOf("--") === 0) {
            var ce = g(q);
            ve = g(("" + ve).trim());
          } else {
            ce = q;
            var Ae = N.get(ce);
            Ae !== void 0 || (Ae = g(ce.replace(k, "-$1").toLowerCase().replace(y, "-ms-")), N.set(ce, Ae)), ce = Ae, ve = typeof ve == "number" ? ve === 0 || r.call(c, q) ? "" + ve : ve + "px" : g(("" + ve).trim());
          }
          I ? (I = !1, E.push(' style="', ce, ":", ve)) : E.push(";", ce, ":", ve);
        }
      }
    I || E.push('"');
  }
  function B(E, I, V, q) {
    switch (V) {
      case "style":
        P(E, I, q);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < V.length) || V[0] !== "o" && V[0] !== "O" || V[1] !== "n" && V[1] !== "N") {
      if (I = l.hasOwnProperty(V) ? l[V] : null, I !== null) {
        switch (typeof q) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!I.acceptsBooleans)
              return;
        }
        switch (V = I.attributeName, I.type) {
          case 3:
            q && E.push(" ", V, '=""');
            break;
          case 4:
            q === !0 ? E.push(" ", V, '=""') : q !== !1 && E.push(" ", V, '="', g(q), '"');
            break;
          case 5:
            isNaN(q) || E.push(" ", V, '="', g(q), '"');
            break;
          case 6:
            !isNaN(q) && 1 <= q && E.push(" ", V, '="', g(q), '"');
            break;
          default:
            I.sanitizeURL && (q = "" + q), E.push(" ", V, '="', g(q), '"');
        }
      } else if (o(V)) {
        switch (typeof q) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (I = V.toLowerCase().slice(0, 5), I !== "data-" && I !== "aria-")
              return;
        }
        E.push(" ", V, '="', g(q), '"');
      }
    }
  }
  function M(E, I, V) {
    if (I != null) {
      if (V != null)
        throw Error(t(60));
      if (typeof I != "object" || !("__html" in I))
        throw Error(t(61));
      I = I.__html, I != null && E.push("" + I);
    }
  }
  function X(E) {
    var I = "";
    return e.Children.forEach(E, function(V) {
      V != null && (I += V);
    }), I;
  }
  function U(E, I, V, q) {
    E.push(j(V));
    var ve = V = null, ce;
    for (ce in I)
      if (r.call(I, ce)) {
        var Ae = I[ce];
        if (Ae != null)
          switch (ce) {
            case "children":
              V = Ae;
              break;
            case "dangerouslySetInnerHTML":
              ve = Ae;
              break;
            default:
              B(E, q, ce, Ae);
          }
      }
    return E.push(">"), M(E, ve, V), typeof V == "string" ? (E.push(g(V)), null) : V;
  }
  var K = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, z = /* @__PURE__ */ new Map();
  function j(E) {
    var I = z.get(E);
    if (I === void 0) {
      if (!K.test(E))
        throw Error(t(65, E));
      I = "<" + E, z.set(E, I);
    }
    return I;
  }
  function J(E, I, V, q, ve) {
    switch (I) {
      case "select":
        E.push(j("select"));
        var ce = null, Ae = null;
        for (Dt in V)
          if (r.call(V, Dt)) {
            var Ve = V[Dt];
            if (Ve != null)
              switch (Dt) {
                case "children":
                  ce = Ve;
                  break;
                case "dangerouslySetInnerHTML":
                  Ae = Ve;
                  break;
                case "defaultValue":
                case "value":
                  break;
                default:
                  B(E, q, Dt, Ve);
              }
          }
        return E.push(">"), M(E, Ae, ce), ce;
      case "option":
        Ae = ve.selectedValue, E.push(j("option"));
        var dt = Ve = null, yt = null, Dt = null;
        for (ce in V)
          if (r.call(V, ce)) {
            var rr = V[ce];
            if (rr != null)
              switch (ce) {
                case "children":
                  Ve = rr;
                  break;
                case "selected":
                  yt = rr;
                  break;
                case "dangerouslySetInnerHTML":
                  Dt = rr;
                  break;
                case "value":
                  dt = rr;
                default:
                  B(E, q, ce, rr);
              }
          }
        if (Ae != null)
          if (V = dt !== null ? "" + dt : X(Ve), _(Ae)) {
            for (q = 0; q < Ae.length; q++)
              if ("" + Ae[q] === V) {
                E.push(' selected=""');
                break;
              }
          } else
            "" + Ae === V && E.push(' selected=""');
        else
          yt && E.push(' selected=""');
        return E.push(">"), M(E, Dt, Ve), Ve;
      case "textarea":
        E.push(j("textarea")), Dt = Ae = ce = null;
        for (Ve in V)
          if (r.call(V, Ve) && (dt = V[Ve], dt != null))
            switch (Ve) {
              case "children":
                Dt = dt;
                break;
              case "value":
                ce = dt;
                break;
              case "defaultValue":
                Ae = dt;
                break;
              case "dangerouslySetInnerHTML":
                throw Error(t(91));
              default:
                B(
                  E,
                  q,
                  Ve,
                  dt
                );
            }
        if (ce === null && Ae !== null && (ce = Ae), E.push(">"), Dt != null) {
          if (ce != null)
            throw Error(t(92));
          if (_(Dt) && 1 < Dt.length)
            throw Error(t(93));
          ce = "" + Dt;
        }
        return typeof ce == "string" && ce[0] === `
` && E.push(`
`), ce !== null && E.push(g("" + ce)), null;
      case "input":
        E.push(j("input")), dt = Dt = Ve = ce = null;
        for (Ae in V)
          if (r.call(V, Ae) && (yt = V[Ae], yt != null))
            switch (Ae) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(t(399, "input"));
              case "defaultChecked":
                dt = yt;
                break;
              case "defaultValue":
                Ve = yt;
                break;
              case "checked":
                Dt = yt;
                break;
              case "value":
                ce = yt;
                break;
              default:
                B(E, q, Ae, yt);
            }
        return Dt !== null ? B(E, q, "checked", Dt) : dt !== null && B(E, q, "checked", dt), ce !== null ? B(E, q, "value", ce) : Ve !== null && B(E, q, "value", Ve), E.push("/>"), null;
      case "menuitem":
        E.push(j("menuitem"));
        for (var Zr in V)
          if (r.call(V, Zr) && (ce = V[Zr], ce != null))
            switch (Zr) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(t(400));
              default:
                B(E, q, Zr, ce);
            }
        return E.push(">"), null;
      case "title":
        E.push(j("title")), ce = null;
        for (rr in V)
          if (r.call(V, rr) && (Ae = V[rr], Ae != null))
            switch (rr) {
              case "children":
                ce = Ae;
                break;
              case "dangerouslySetInnerHTML":
                throw Error(t(434));
              default:
                B(E, q, rr, Ae);
            }
        return E.push(">"), ce;
      case "listing":
      case "pre":
        E.push(j(I)), Ae = ce = null;
        for (dt in V)
          if (r.call(V, dt) && (Ve = V[dt], Ve != null))
            switch (dt) {
              case "children":
                ce = Ve;
                break;
              case "dangerouslySetInnerHTML":
                Ae = Ve;
                break;
              default:
                B(E, q, dt, Ve);
            }
        if (E.push(">"), Ae != null) {
          if (ce != null)
            throw Error(t(60));
          if (typeof Ae != "object" || !("__html" in Ae))
            throw Error(t(61));
          V = Ae.__html, V != null && (typeof V == "string" && 0 < V.length && V[0] === `
` ? E.push(`
`, V) : E.push("" + V));
        }
        return typeof ce == "string" && ce[0] === `
` && E.push(`
`), ce;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        E.push(j(I));
        for (var Ei in V)
          if (r.call(V, Ei) && (ce = V[Ei], ce != null))
            switch (Ei) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(t(399, I));
              default:
                B(E, q, Ei, ce);
            }
        return E.push("/>"), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return U(
          E,
          V,
          I,
          q
        );
      case "html":
        return ve.insertionMode === 0 && E.push("<!DOCTYPE html>"), U(E, V, I, q);
      default:
        if (I.indexOf("-") === -1 && typeof V.is != "string")
          return U(E, V, I, q);
        E.push(j(I)), Ae = ce = null;
        for (yt in V)
          if (r.call(V, yt) && (Ve = V[yt], Ve != null))
            switch (yt) {
              case "children":
                ce = Ve;
                break;
              case "dangerouslySetInnerHTML":
                Ae = Ve;
                break;
              case "style":
                P(E, q, Ve);
                break;
              case "suppressContentEditableWarning":
              case "suppressHydrationWarning":
                break;
              default:
                o(yt) && typeof Ve != "function" && typeof Ve != "symbol" && E.push(" ", yt, '="', g(Ve), '"');
            }
        return E.push(">"), M(E, Ae, ce), ce;
    }
  }
  function ie(E, I, V) {
    if (E.push('<!--$?--><template id="'), V === null)
      throw Error(t(395));
    return E.push(V), E.push('"></template>');
  }
  function ue(E, I, V, q) {
    switch (V.insertionMode) {
      case 0:
      case 1:
        return E.push('<div hidden id="'), E.push(I.segmentPrefix), I = q.toString(16), E.push(I), E.push('">');
      case 2:
        return E.push('<svg aria-hidden="true" style="display:none" id="'), E.push(I.segmentPrefix), I = q.toString(16), E.push(I), E.push('">');
      case 3:
        return E.push('<math aria-hidden="true" style="display:none" id="'), E.push(I.segmentPrefix), I = q.toString(16), E.push(I), E.push('">');
      case 4:
        return E.push('<table hidden id="'), E.push(I.segmentPrefix), I = q.toString(16), E.push(I), E.push('">');
      case 5:
        return E.push('<table hidden><tbody id="'), E.push(I.segmentPrefix), I = q.toString(16), E.push(I), E.push('">');
      case 6:
        return E.push('<table hidden><tr id="'), E.push(I.segmentPrefix), I = q.toString(16), E.push(I), E.push('">');
      case 7:
        return E.push('<table hidden><colgroup id="'), E.push(I.segmentPrefix), I = q.toString(16), E.push(I), E.push('">');
      default:
        throw Error(t(397));
    }
  }
  function de(E, I) {
    switch (I.insertionMode) {
      case 0:
      case 1:
        return E.push("</div>");
      case 2:
        return E.push("</svg>");
      case 3:
        return E.push("</math>");
      case 4:
        return E.push("</table>");
      case 5:
        return E.push("</tbody></table>");
      case 6:
        return E.push("</tr></table>");
      case 7:
        return E.push("</colgroup></table>");
      default:
        throw Error(t(397));
    }
  }
  var he = /[<\u2028\u2029]/g;
  function Ee(E) {
    return JSON.stringify(E).replace(he, function(I) {
      switch (I) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  function Le(E, I) {
    return I = I === void 0 ? "" : I, { bootstrapChunks: [], startInlineScript: "<script>", placeholderPrefix: I + "P:", segmentPrefix: I + "S:", boundaryPrefix: I + "B:", idPrefix: I, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1, generateStaticMarkup: E };
  }
  function L(E, I, V, q) {
    return V.generateStaticMarkup ? (E.push(g(I)), !1) : (I === "" ? E = q : (q && E.push("<!-- -->"), E.push(g(I)), E = !0), E);
  }
  var me = Object.assign, Se = Symbol.for("react.element"), G = Symbol.for("react.portal"), He = Symbol.for("react.fragment"), xe = Symbol.for("react.strict_mode"), _e = Symbol.for("react.profiler"), Ze = Symbol.for("react.provider"), qe = Symbol.for("react.context"), nt = Symbol.for("react.forward_ref"), at = Symbol.for("react.suspense"), At = Symbol.for("react.suspense_list"), Oe = Symbol.for("react.memo"), wt = Symbol.for("react.lazy"), Ge = Symbol.for("react.scope"), nr = Symbol.for("react.debug_trace_mode"), vr = Symbol.for("react.legacy_hidden"), zr = Symbol.for("react.default_value"), Wr = Symbol.iterator;
  function ne(E) {
    if (E == null)
      return null;
    if (typeof E == "function")
      return E.displayName || E.name || null;
    if (typeof E == "string")
      return E;
    switch (E) {
      case He:
        return "Fragment";
      case G:
        return "Portal";
      case _e:
        return "Profiler";
      case xe:
        return "StrictMode";
      case at:
        return "Suspense";
      case At:
        return "SuspenseList";
    }
    if (typeof E == "object")
      switch (E.$$typeof) {
        case qe:
          return (E.displayName || "Context") + ".Consumer";
        case Ze:
          return (E._context.displayName || "Context") + ".Provider";
        case nt:
          var I = E.render;
          return E = E.displayName, E || (E = I.displayName || I.name || "", E = E !== "" ? "ForwardRef(" + E + ")" : "ForwardRef"), E;
        case Oe:
          return I = E.displayName || null, I !== null ? I : ne(E.type) || "Memo";
        case wt:
          I = E._payload, E = E._init;
          try {
            return ne(E(I));
          } catch {
          }
      }
    return null;
  }
  var pe = {};
  function Fe(E, I) {
    if (E = E.contextTypes, !E)
      return pe;
    var V = {}, q;
    for (q in E)
      V[q] = I[q];
    return V;
  }
  var Ye = null;
  function Ue(E, I) {
    if (E !== I) {
      E.context._currentValue2 = E.parentValue, E = E.parent;
      var V = I.parent;
      if (E === null) {
        if (V !== null)
          throw Error(t(401));
      } else {
        if (V === null)
          throw Error(t(401));
        Ue(E, V);
      }
      I.context._currentValue2 = I.value;
    }
  }
  function Re(E) {
    E.context._currentValue2 = E.parentValue, E = E.parent, E !== null && Re(E);
  }
  function ot(E) {
    var I = E.parent;
    I !== null && ot(I), E.context._currentValue2 = E.value;
  }
  function Ut(E, I) {
    if (E.context._currentValue2 = E.parentValue, E = E.parent, E === null)
      throw Error(t(402));
    E.depth === I.depth ? Ue(E, I) : Ut(E, I);
  }
  function ge(E, I) {
    var V = I.parent;
    if (V === null)
      throw Error(t(402));
    E.depth === V.depth ? Ue(E, V) : ge(E, V), I.context._currentValue2 = I.value;
  }
  function Ie(E) {
    var I = Ye;
    I !== E && (I === null ? ot(E) : E === null ? Re(I) : I.depth === E.depth ? Ue(I, E) : I.depth > E.depth ? Ut(I, E) : ge(I, E), Ye = E);
  }
  var ut = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(E, I) {
    E = E._reactInternals, E.queue !== null && E.queue.push(I);
  }, enqueueReplaceState: function(E, I) {
    E = E._reactInternals, E.replace = !0, E.queue = [I];
  }, enqueueForceUpdate: function() {
  } };
  function xt(E, I, V, q) {
    var ve = E.state !== void 0 ? E.state : null;
    E.updater = ut, E.props = V, E.state = ve;
    var ce = { queue: [], replace: !1 };
    E._reactInternals = ce;
    var Ae = I.contextType;
    if (E.context = typeof Ae == "object" && Ae !== null ? Ae._currentValue2 : q, Ae = I.getDerivedStateFromProps, typeof Ae == "function" && (Ae = Ae(V, ve), ve = Ae == null ? ve : me({}, ve, Ae), E.state = ve), typeof I.getDerivedStateFromProps != "function" && typeof E.getSnapshotBeforeUpdate != "function" && (typeof E.UNSAFE_componentWillMount == "function" || typeof E.componentWillMount == "function"))
      if (I = E.state, typeof E.componentWillMount == "function" && E.componentWillMount(), typeof E.UNSAFE_componentWillMount == "function" && E.UNSAFE_componentWillMount(), I !== E.state && ut.enqueueReplaceState(E, E.state, null), ce.queue !== null && 0 < ce.queue.length)
        if (I = ce.queue, Ae = ce.replace, ce.queue = null, ce.replace = !1, Ae && I.length === 1)
          E.state = I[0];
        else {
          for (ce = Ae ? I[0] : E.state, ve = !0, Ae = Ae ? 1 : 0; Ae < I.length; Ae++) {
            var Ve = I[Ae];
            Ve = typeof Ve == "function" ? Ve.call(E, ce, V, q) : Ve, Ve != null && (ve ? (ve = !1, ce = me({}, ce, Ve)) : me(ce, Ve));
          }
          E.state = ce;
        }
      else
        ce.queue = null;
  }
  var Bt = { id: 1, overflow: "" };
  function gr(E, I, V) {
    var q = E.id;
    E = E.overflow;
    var ve = 32 - Gr(q) - 1;
    q &= ~(1 << ve), V += 1;
    var ce = 32 - Gr(I) + ve;
    if (30 < ce) {
      var Ae = ve - ve % 5;
      return ce = (q & (1 << Ae) - 1).toString(32), q >>= Ae, ve -= Ae, { id: 1 << 32 - Gr(I) + ve | V << ve | q, overflow: ce + E };
    }
    return { id: 1 << ce | V << ve | q, overflow: E };
  }
  var Gr = Math.clz32 ? Math.clz32 : Er, kr = Math.log, Xr = Math.LN2;
  function Er(E) {
    return E >>>= 0, E === 0 ? 32 : 31 - (kr(E) / Xr | 0) | 0;
  }
  function tr(E, I) {
    return E === I && (E !== 0 || 1 / E === 1 / I) || E !== E && I !== I;
  }
  var Ti = typeof Object.is == "function" ? Object.is : tr, lt = null, _r = null, hr = null, $t = null, pi = !1, Di = !1, Zi = 0, yi = null, pn = 0;
  function vi() {
    if (lt === null)
      throw Error(t(321));
    return lt;
  }
  function Cr() {
    if (0 < pn)
      throw Error(t(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function ca() {
    return $t === null ? hr === null ? (pi = !1, hr = $t = Cr()) : (pi = !0, $t = hr) : $t.next === null ? (pi = !1, $t = $t.next = Cr()) : (pi = !0, $t = $t.next), $t;
  }
  function da() {
    _r = lt = null, Di = !1, hr = null, pn = 0, $t = yi = null;
  }
  function pa(E, I) {
    return typeof I == "function" ? I(E) : I;
  }
  function Lr(E, I, V) {
    if (lt = vi(), $t = ca(), pi) {
      var q = $t.queue;
      if (I = q.dispatch, yi !== null && (V = yi.get(q), V !== void 0)) {
        yi.delete(q), q = $t.memoizedState;
        do
          q = E(q, V.action), V = V.next;
        while (V !== null);
        return $t.memoizedState = q, [q, I];
      }
      return [$t.memoizedState, I];
    }
    return E = E === pa ? typeof I == "function" ? I() : I : V !== void 0 ? V(I) : I, $t.memoizedState = E, E = $t.queue = { last: null, dispatch: null }, E = E.dispatch = ha.bind(null, lt, E), [$t.memoizedState, E];
  }
  function Ln(E, I) {
    if (lt = vi(), $t = ca(), I = I === void 0 ? null : I, $t !== null) {
      var V = $t.memoizedState;
      if (V !== null && I !== null) {
        var q = V[1];
        e:
          if (q === null)
            q = !1;
          else {
            for (var ve = 0; ve < q.length && ve < I.length; ve++)
              if (!Ti(I[ve], q[ve])) {
                q = !1;
                break e;
              }
            q = !0;
          }
        if (q)
          return V[0];
      }
    }
    return E = E(), $t.memoizedState = [E, I], E;
  }
  function ha(E, I, V) {
    if (25 <= pn)
      throw Error(t(301));
    if (E === lt)
      if (Di = !0, E = { action: V, next: null }, yi === null && (yi = /* @__PURE__ */ new Map()), V = yi.get(I), V === void 0)
        yi.set(I, E);
      else {
        for (I = V; I.next !== null; )
          I = I.next;
        I.next = E;
      }
  }
  function Ji() {
    throw Error(t(394));
  }
  function te() {
  }
  var $e = { readContext: function(E) {
    return E._currentValue2;
  }, useContext: function(E) {
    return vi(), E._currentValue2;
  }, useMemo: Ln, useReducer: Lr, useRef: function(E) {
    lt = vi(), $t = ca();
    var I = $t.memoizedState;
    return I === null ? (E = { current: E }, $t.memoizedState = E) : I;
  }, useState: function(E) {
    return Lr(pa, E);
  }, useInsertionEffect: te, useLayoutEffect: function() {
  }, useCallback: function(E, I) {
    return Ln(function() {
      return E;
    }, I);
  }, useImperativeHandle: te, useEffect: te, useDebugValue: te, useDeferredValue: function(E) {
    return vi(), E;
  }, useTransition: function() {
    return vi(), [
      !1,
      Ji
    ];
  }, useId: function() {
    var E = _r.treeContext, I = E.overflow;
    E = E.id, E = (E & ~(1 << 32 - Gr(E) - 1)).toString(32) + I;
    var V = tt;
    if (V === null)
      throw Error(t(404));
    return I = Zi++, E = ":" + V.idPrefix + "R" + E, 0 < I && (E += "H" + I.toString(32)), E + ":";
  }, useMutableSource: function(E, I) {
    return vi(), I(E._source);
  }, useSyncExternalStore: function(E, I, V) {
    if (V === void 0)
      throw Error(t(407));
    return V();
  } }, tt = null, Et = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function Vt(E) {
    return console.error(E), null;
  }
  function Rt() {
  }
  function Gt(E, I, V, q, ve, ce, Ae, Ve, dt) {
    var yt = [], Dt = /* @__PURE__ */ new Set();
    return I = { destination: null, responseState: I, progressiveChunkSize: q === void 0 ? 12800 : q, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: Dt, pingedTasks: yt, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: ve === void 0 ? Vt : ve, onAllReady: ce === void 0 ? Rt : ce, onShellReady: Ae === void 0 ? Rt : Ae, onShellError: Ve === void 0 ? Rt : Ve, onFatalError: dt === void 0 ? Rt : dt }, V = Mr(I, 0, null, V, !1, !1), V.parentFlushed = !0, E = Lt(I, E, null, V, Dt, pe, null, Bt), yt.push(E), I;
  }
  function Lt(E, I, V, q, ve, ce, Ae, Ve) {
    E.allPendingTasks++, V === null ? E.pendingRootTasks++ : V.pendingTasks++;
    var dt = { node: I, ping: function() {
      var yt = E.pingedTasks;
      yt.push(dt), yt.length === 1 && Bi(E);
    }, blockedBoundary: V, blockedSegment: q, abortSet: ve, legacyContext: ce, context: Ae, treeContext: Ve };
    return ve.add(dt), dt;
  }
  function Mr(E, I, V, q, ve, ce) {
    return { status: 0, id: -1, index: I, parentFlushed: !1, chunks: [], children: [], formatContext: q, boundary: V, lastPushedText: ve, textEmbedded: ce };
  }
  function ar(E, I) {
    if (E = E.onError(I), E != null && typeof E != "string")
      throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof E + '" instead');
    return E;
  }
  function or(E, I) {
    var V = E.onShellError;
    V(I), V = E.onFatalError, V(I), E.destination !== null ? (E.status = 2, E.destination.destroy(I)) : (E.status = 1, E.fatalError = I);
  }
  function dr(E, I, V, q, ve) {
    for (lt = {}, _r = I, Zi = 0, E = V(q, ve); Di; )
      Di = !1, Zi = 0, pn += 1, $t = null, E = V(q, ve);
    return da(), E;
  }
  function Si(E, I, V, q) {
    var ve = V.render(), ce = q.childContextTypes;
    if (ce != null) {
      var Ae = I.legacyContext;
      if (typeof V.getChildContext != "function")
        q = Ae;
      else {
        V = V.getChildContext();
        for (var Ve in V)
          if (!(Ve in ce))
            throw Error(t(108, ne(q) || "Unknown", Ve));
        q = me({}, Ae, V);
      }
      I.legacyContext = q, Hr(E, I, ve), I.legacyContext = Ae;
    } else
      Hr(E, I, ve);
  }
  function hn(E, I) {
    if (E && E.defaultProps) {
      I = me({}, I), E = E.defaultProps;
      for (var V in E)
        I[V] === void 0 && (I[V] = E[V]);
      return I;
    }
    return I;
  }
  function jr(E, I, V, q, ve) {
    if (typeof V == "function")
      if (V.prototype && V.prototype.isReactComponent) {
        ve = Fe(V, I.legacyContext);
        var ce = V.contextType;
        ce = new V(q, typeof ce == "object" && ce !== null ? ce._currentValue2 : ve), xt(ce, V, q, ve), Si(E, I, ce, V);
      } else {
        ce = Fe(V, I.legacyContext), ve = dr(E, I, V, q, ce);
        var Ae = Zi !== 0;
        if (typeof ve == "object" && ve !== null && typeof ve.render == "function" && ve.$$typeof === void 0)
          xt(ve, V, q, ce), Si(E, I, ve, V);
        else if (Ae) {
          q = I.treeContext, I.treeContext = gr(q, 1, 0);
          try {
            Hr(E, I, ve);
          } finally {
            I.treeContext = q;
          }
        } else
          Hr(E, I, ve);
      }
    else if (typeof V == "string") {
      switch (ve = I.blockedSegment, ce = J(ve.chunks, V, q, E.responseState, ve.formatContext), ve.lastPushedText = !1, Ae = ve.formatContext, ve.formatContext = T(Ae, V, q), Ii(E, I, ce), ve.formatContext = Ae, V) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          ve.chunks.push("</", V, ">");
      }
      ve.lastPushedText = !1;
    } else {
      switch (V) {
        case vr:
        case nr:
        case xe:
        case _e:
        case He:
          Hr(E, I, q.children);
          return;
        case At:
          Hr(E, I, q.children);
          return;
        case Ge:
          throw Error(t(343));
        case at:
          e: {
            V = I.blockedBoundary, ve = I.blockedSegment, ce = q.fallback, q = q.children, Ae = /* @__PURE__ */ new Set();
            var Ve = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: Ae, errorDigest: null }, dt = Mr(E, ve.chunks.length, Ve, ve.formatContext, !1, !1);
            ve.children.push(dt), ve.lastPushedText = !1;
            var yt = Mr(E, 0, null, ve.formatContext, !1, !1);
            yt.parentFlushed = !0, I.blockedBoundary = Ve, I.blockedSegment = yt;
            try {
              if (Ii(
                E,
                I,
                q
              ), E.responseState.generateStaticMarkup || yt.lastPushedText && yt.textEmbedded && yt.chunks.push("<!-- -->"), yt.status = 1, gi(Ve, yt), Ve.pendingTasks === 0)
                break e;
            } catch (Dt) {
              yt.status = 4, Ve.forceClientRender = !0, Ve.errorDigest = ar(E, Dt);
            } finally {
              I.blockedBoundary = V, I.blockedSegment = ve;
            }
            I = Lt(E, ce, V, dt, Ae, I.legacyContext, I.context, I.treeContext), E.pingedTasks.push(I);
          }
          return;
      }
      if (typeof V == "object" && V !== null)
        switch (V.$$typeof) {
          case nt:
            if (q = dr(E, I, V.render, q, ve), Zi !== 0) {
              V = I.treeContext, I.treeContext = gr(V, 1, 0);
              try {
                Hr(E, I, q);
              } finally {
                I.treeContext = V;
              }
            } else
              Hr(E, I, q);
            return;
          case Oe:
            V = V.type, q = hn(V, q), jr(E, I, V, q, ve);
            return;
          case Ze:
            if (ve = q.children, V = V._context, q = q.value, ce = V._currentValue2, V._currentValue2 = q, Ae = Ye, Ye = q = { parent: Ae, depth: Ae === null ? 0 : Ae.depth + 1, context: V, parentValue: ce, value: q }, I.context = q, Hr(E, I, ve), E = Ye, E === null)
              throw Error(t(403));
            q = E.parentValue, E.context._currentValue2 = q === zr ? E.context._defaultValue : q, E = Ye = E.parent, I.context = E;
            return;
          case qe:
            q = q.children, q = q(V._currentValue2), Hr(E, I, q);
            return;
          case wt:
            ve = V._init, V = ve(V._payload), q = hn(V, q), jr(
              E,
              I,
              V,
              q,
              void 0
            );
            return;
        }
      throw Error(t(130, V == null ? V : typeof V, ""));
    }
  }
  function Hr(E, I, V) {
    if (I.node = V, typeof V == "object" && V !== null) {
      switch (V.$$typeof) {
        case Se:
          jr(E, I, V.type, V.props, V.ref);
          return;
        case G:
          throw Error(t(257));
        case wt:
          var q = V._init;
          V = q(V._payload), Hr(E, I, V);
          return;
      }
      if (_(V)) {
        fn(E, I, V);
        return;
      }
      if (V === null || typeof V != "object" ? q = null : (q = Wr && V[Wr] || V["@@iterator"], q = typeof q == "function" ? q : null), q && (q = q.call(V))) {
        if (V = q.next(), !V.done) {
          var ve = [];
          do
            ve.push(V.value), V = q.next();
          while (!V.done);
          fn(E, I, ve);
        }
        return;
      }
      throw E = Object.prototype.toString.call(V), Error(t(31, E === "[object Object]" ? "object with keys {" + Object.keys(V).join(", ") + "}" : E));
    }
    typeof V == "string" ? (q = I.blockedSegment, q.lastPushedText = L(I.blockedSegment.chunks, V, E.responseState, q.lastPushedText)) : typeof V == "number" && (q = I.blockedSegment, q.lastPushedText = L(I.blockedSegment.chunks, "" + V, E.responseState, q.lastPushedText));
  }
  function fn(E, I, V) {
    for (var q = V.length, ve = 0; ve < q; ve++) {
      var ce = I.treeContext;
      I.treeContext = gr(ce, q, ve);
      try {
        Ii(E, I, V[ve]);
      } finally {
        I.treeContext = ce;
      }
    }
  }
  function Ii(E, I, V) {
    var q = I.blockedSegment.formatContext, ve = I.legacyContext, ce = I.context;
    try {
      return Hr(E, I, V);
    } catch (dt) {
      if (da(), typeof dt == "object" && dt !== null && typeof dt.then == "function") {
        V = dt;
        var Ae = I.blockedSegment, Ve = Mr(E, Ae.chunks.length, null, Ae.formatContext, Ae.lastPushedText, !0);
        Ae.children.push(Ve), Ae.lastPushedText = !1, E = Lt(E, I.node, I.blockedBoundary, Ve, I.abortSet, I.legacyContext, I.context, I.treeContext).ping, V.then(E, E), I.blockedSegment.formatContext = q, I.legacyContext = ve, I.context = ce, Ie(ce);
      } else
        throw I.blockedSegment.formatContext = q, I.legacyContext = ve, I.context = ce, Ie(ce), dt;
    }
  }
  function fi(E) {
    var I = E.blockedBoundary;
    E = E.blockedSegment, E.status = 3, gn(this, I, E);
  }
  function Fa(E, I, V) {
    var q = E.blockedBoundary;
    E.blockedSegment.status = 3, q === null ? (I.allPendingTasks--, I.status !== 2 && (I.status = 2, I.destination !== null && I.destination.push(null))) : (q.pendingTasks--, q.forceClientRender || (q.forceClientRender = !0, E = V === void 0 ? Error(t(432)) : V, q.errorDigest = I.onError(E), q.parentFlushed && I.clientRenderedBoundaries.push(q)), q.fallbackAbortableTasks.forEach(function(ve) {
      return Fa(ve, I, V);
    }), q.fallbackAbortableTasks.clear(), I.allPendingTasks--, I.allPendingTasks === 0 && (q = I.onAllReady, q()));
  }
  function gi(E, I) {
    if (I.chunks.length === 0 && I.children.length === 1 && I.children[0].boundary === null) {
      var V = I.children[0];
      V.id = I.id, V.parentFlushed = !0, V.status === 1 && gi(E, V);
    } else
      E.completedSegments.push(I);
  }
  function gn(E, I, V) {
    if (I === null) {
      if (V.parentFlushed) {
        if (E.completedRootSegment !== null)
          throw Error(t(389));
        E.completedRootSegment = V;
      }
      E.pendingRootTasks--, E.pendingRootTasks === 0 && (E.onShellError = Rt, I = E.onShellReady, I());
    } else
      I.pendingTasks--, I.forceClientRender || (I.pendingTasks === 0 ? (V.parentFlushed && V.status === 1 && gi(I, V), I.parentFlushed && E.completedBoundaries.push(I), I.fallbackAbortableTasks.forEach(fi, E), I.fallbackAbortableTasks.clear()) : V.parentFlushed && V.status === 1 && (gi(I, V), I.completedSegments.length === 1 && I.parentFlushed && E.partialBoundaries.push(I)));
    E.allPendingTasks--, E.allPendingTasks === 0 && (E = E.onAllReady, E());
  }
  function Bi(E) {
    if (E.status !== 2) {
      var I = Ye, V = Et.current;
      Et.current = $e;
      var q = tt;
      tt = E.responseState;
      try {
        var ve = E.pingedTasks, ce;
        for (ce = 0; ce < ve.length; ce++) {
          var Ae = ve[ce], Ve = E, dt = Ae.blockedSegment;
          if (dt.status === 0) {
            Ie(Ae.context);
            try {
              Hr(Ve, Ae, Ae.node), Ve.responseState.generateStaticMarkup || dt.lastPushedText && dt.textEmbedded && dt.chunks.push("<!-- -->"), Ae.abortSet.delete(Ae), dt.status = 1, gn(Ve, Ae.blockedBoundary, dt);
            } catch (Ci) {
              if (da(), typeof Ci == "object" && Ci !== null && typeof Ci.then == "function") {
                var yt = Ae.ping;
                Ci.then(yt, yt);
              } else {
                Ae.abortSet.delete(Ae), dt.status = 4;
                var Dt = Ae.blockedBoundary, rr = Ci, Zr = ar(Ve, rr);
                if (Dt === null ? or(Ve, rr) : (Dt.pendingTasks--, Dt.forceClientRender || (Dt.forceClientRender = !0, Dt.errorDigest = Zr, Dt.parentFlushed && Ve.clientRenderedBoundaries.push(Dt))), Ve.allPendingTasks--, Ve.allPendingTasks === 0) {
                  var Ei = Ve.onAllReady;
                  Ei();
                }
              }
            } finally {
            }
          }
        }
        ve.splice(0, ce), E.destination !== null && jn(E, E.destination);
      } catch (Ci) {
        ar(E, Ci), or(E, Ci);
      } finally {
        tt = q, Et.current = V, V === $e && Ie(I);
      }
    }
  }
  function _n(E, I, V) {
    switch (V.parentFlushed = !0, V.status) {
      case 0:
        var q = V.id = E.nextSegmentId++;
        return V.lastPushedText = !1, V.textEmbedded = !1, E = E.responseState, I.push('<template id="'), I.push(E.placeholderPrefix), E = q.toString(16), I.push(E), I.push('"></template>');
      case 1:
        V.status = 2;
        var ve = !0;
        q = V.chunks;
        var ce = 0;
        V = V.children;
        for (var Ae = 0; Ae < V.length; Ae++) {
          for (ve = V[Ae]; ce < ve.index; ce++)
            I.push(q[ce]);
          ve = Mn(E, I, ve);
        }
        for (; ce < q.length - 1; ce++)
          I.push(q[ce]);
        return ce < q.length && (ve = I.push(q[ce])), ve;
      default:
        throw Error(t(390));
    }
  }
  function Mn(E, I, V) {
    var q = V.boundary;
    if (q === null)
      return _n(E, I, V);
    if (q.parentFlushed = !0, q.forceClientRender)
      return E.responseState.generateStaticMarkup || (q = q.errorDigest, I.push("<!--$!-->"), I.push("<template"), q && (I.push(' data-dgst="'), q = g(q), I.push(q), I.push('"')), I.push("></template>")), _n(E, I, V), E = E.responseState.generateStaticMarkup ? !0 : I.push("<!--/$-->"), E;
    if (0 < q.pendingTasks) {
      q.rootSegmentID = E.nextSegmentId++, 0 < q.completedSegments.length && E.partialBoundaries.push(q);
      var ve = E.responseState, ce = ve.nextSuspenseID++;
      return ve = ve.boundaryPrefix + ce.toString(16), q = q.id = ve, ie(I, E.responseState, q), _n(E, I, V), I.push("<!--/$-->");
    }
    if (q.byteSize > E.progressiveChunkSize)
      return q.rootSegmentID = E.nextSegmentId++, E.completedBoundaries.push(q), ie(I, E.responseState, q.id), _n(E, I, V), I.push("<!--/$-->");
    if (E.responseState.generateStaticMarkup || I.push("<!--$-->"), V = q.completedSegments, V.length !== 1)
      throw Error(t(391));
    return Mn(E, I, V[0]), E = E.responseState.generateStaticMarkup ? !0 : I.push("<!--/$-->"), E;
  }
  function to(E, I, V) {
    return ue(I, E.responseState, V.formatContext, V.id), Mn(E, I, V), de(I, V.formatContext);
  }
  function ro(E, I, V) {
    for (var q = V.completedSegments, ve = 0; ve < q.length; ve++)
      Dn(E, I, V, q[ve]);
    if (q.length = 0, E = E.responseState, q = V.id, V = V.rootSegmentID, I.push(E.startInlineScript), E.sentCompleteBoundaryFunction ? I.push('$RC("') : (E.sentCompleteBoundaryFunction = !0, I.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("')), q === null)
      throw Error(t(395));
    return V = V.toString(16), I.push(q), I.push('","'), I.push(E.segmentPrefix), I.push(V), I.push('")<\/script>');
  }
  function Dn(E, I, V, q) {
    if (q.status === 2)
      return !0;
    var ve = q.id;
    if (ve === -1) {
      if ((q.id = V.rootSegmentID) === -1)
        throw Error(t(392));
      return to(E, I, q);
    }
    return to(E, I, q), E = E.responseState, I.push(E.startInlineScript), E.sentCompleteSegmentFunction ? I.push('$RS("') : (E.sentCompleteSegmentFunction = !0, I.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("')), I.push(E.segmentPrefix), ve = ve.toString(16), I.push(ve), I.push('","'), I.push(E.placeholderPrefix), I.push(ve), I.push('")<\/script>');
  }
  function jn(E, I) {
    try {
      var V = E.completedRootSegment;
      if (V !== null && E.pendingRootTasks === 0) {
        Mn(E, I, V), E.completedRootSegment = null;
        var q = E.responseState.bootstrapChunks;
        for (V = 0; V < q.length - 1; V++)
          I.push(q[V]);
        V < q.length && I.push(q[V]);
      }
      var ve = E.clientRenderedBoundaries, ce;
      for (ce = 0; ce < ve.length; ce++) {
        var Ae = ve[ce];
        q = I;
        var Ve = E.responseState, dt = Ae.id, yt = Ae.errorDigest, Dt = Ae.errorMessage, rr = Ae.errorComponentStack;
        if (q.push(Ve.startInlineScript), Ve.sentClientRenderFunction ? q.push('$RX("') : (Ve.sentClientRenderFunction = !0, q.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("')), dt === null)
          throw Error(t(395));
        if (q.push(dt), q.push('"'), yt || Dt || rr) {
          q.push(",");
          var Zr = Ee(yt || "");
          q.push(Zr);
        }
        if (Dt || rr) {
          q.push(",");
          var Ei = Ee(Dt || "");
          q.push(Ei);
        }
        if (rr) {
          q.push(",");
          var Ci = Ee(rr);
          q.push(Ci);
        }
        if (!q.push(")<\/script>")) {
          E.destination = null, ce++, ve.splice(0, ce);
          return;
        }
      }
      ve.splice(0, ce);
      var En = E.completedBoundaries;
      for (ce = 0; ce < En.length; ce++)
        if (!ro(E, I, En[ce])) {
          E.destination = null, ce++, En.splice(0, ce);
          return;
        }
      En.splice(0, ce);
      var en = E.partialBoundaries;
      for (ce = 0; ce < en.length; ce++) {
        var Ta = en[ce];
        e: {
          ve = E, Ae = I;
          var Ri = Ta.completedSegments;
          for (Ve = 0; Ve < Ri.length; Ve++)
            if (!Dn(ve, Ae, Ta, Ri[Ve])) {
              Ve++, Ri.splice(0, Ve);
              var Hn = !1;
              break e;
            }
          Ri.splice(0, Ve), Hn = !0;
        }
        if (!Hn) {
          E.destination = null, ce++, en.splice(0, ce);
          return;
        }
      }
      en.splice(0, ce);
      var Cn = E.completedBoundaries;
      for (ce = 0; ce < Cn.length; ce++)
        if (!ro(E, I, Cn[ce])) {
          E.destination = null, ce++, Cn.splice(0, ce);
          return;
        }
      Cn.splice(0, ce);
    } finally {
      E.allPendingTasks === 0 && E.pingedTasks.length === 0 && E.clientRenderedBoundaries.length === 0 && E.completedBoundaries.length === 0 && I.push(null);
    }
  }
  function yn(E, I) {
    try {
      var V = E.abortableTasks;
      V.forEach(function(q) {
        return Fa(q, E, I);
      }), V.clear(), E.destination !== null && jn(E, E.destination);
    } catch (q) {
      ar(E, q), or(E, q);
    }
  }
  function fa() {
  }
  function ga(E, I, V, q) {
    var ve = !1, ce = null, Ae = "", Ve = { push: function(yt) {
      return yt !== null && (Ae += yt), !0;
    }, destroy: function(yt) {
      ve = !0, ce = yt;
    } }, dt = !1;
    if (E = Gt(E, Le(V, I ? I.identifierPrefix : void 0), { insertionMode: 1, selectedValue: null }, 1 / 0, fa, void 0, function() {
      dt = !0;
    }, void 0, void 0), Bi(E), yn(E, q), E.status === 1)
      E.status = 2, Ve.destroy(E.fatalError);
    else if (E.status !== 2 && E.destination === null) {
      E.destination = Ve;
      try {
        jn(E, Ve);
      } catch (yt) {
        ar(E, yt), or(E, yt);
      }
    }
    if (ve)
      throw ce;
    if (!dt)
      throw Error(t(426));
    return Ae;
  }
  return Fu.renderToNodeStream = function() {
    throw Error(t(207));
  }, Fu.renderToStaticMarkup = function(E, I) {
    return ga(E, I, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, Fu.renderToStaticNodeStream = function() {
    throw Error(t(208));
  }, Fu.renderToString = function(E, I) {
    return ga(E, I, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, Fu.version = "18.2.0", Fu;
}
var Wh = {};
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f5;
function XT() {
  if (f5)
    return Wh;
  f5 = 1;
  var e = ht;
  function t(C) {
    for (var R = "https://reactjs.org/docs/error-decoder.html?invariant=" + C, $ = 1; $ < arguments.length; $++)
      R += "&args[]=" + encodeURIComponent(arguments[$]);
    return "Minified React error #" + C + "; visit " + R + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var r = null, i = 0;
  function n(C, R) {
    if (R.length !== 0)
      if (512 < R.length)
        0 < i && (C.enqueue(new Uint8Array(r.buffer, 0, i)), r = new Uint8Array(512), i = 0), C.enqueue(R);
      else {
        var $ = r.length - i;
        $ < R.length && ($ === 0 ? C.enqueue(r) : (r.set(R.subarray(0, $), i), C.enqueue(r), R = R.subarray($)), r = new Uint8Array(512), i = 0), r.set(R, i), i += R.length;
      }
  }
  function a(C, R) {
    return n(C, R), !0;
  }
  function o(C) {
    r && 0 < i && (C.enqueue(new Uint8Array(r.buffer, 0, i)), r = null, i = 0);
  }
  var s = new TextEncoder();
  function l(C) {
    return s.encode(C);
  }
  function u(C) {
    return s.encode(C);
  }
  function d(C, R) {
    typeof C.error == "function" ? C.error(R) : C.close();
  }
  var c = Object.prototype.hasOwnProperty, p = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, f = {}, g = {};
  function k(C) {
    return c.call(g, C) ? !0 : c.call(f, C) ? !1 : p.test(C) ? g[C] = !0 : (f[C] = !0, !1);
  }
  function y(C, R, $, Q, be, fe, Be) {
    this.acceptsBooleans = R === 2 || R === 3 || R === 4, this.attributeName = Q, this.attributeNamespace = be, this.mustUseProperty = $, this.propertyName = C, this.type = R, this.sanitizeURL = fe, this.removeEmptyString = Be;
  }
  var _ = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(C) {
    _[C] = new y(C, 0, !1, C, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(C) {
    var R = C[0];
    _[R] = new y(R, 1, !1, C[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(C) {
    _[C] = new y(C, 2, !1, C.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(C) {
    _[C] = new y(C, 2, !1, C, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(C) {
    _[C] = new y(C, 3, !1, C.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(C) {
    _[C] = new y(C, 3, !0, C, null, !1, !1);
  }), ["capture", "download"].forEach(function(C) {
    _[C] = new y(C, 4, !1, C, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(C) {
    _[C] = new y(C, 6, !1, C, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(C) {
    _[C] = new y(C, 5, !1, C.toLowerCase(), null, !1, !1);
  });
  var A = /[\-:]([a-z])/g;
  function T(C) {
    return C[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(C) {
    var R = C.replace(
      A,
      T
    );
    _[R] = new y(R, 1, !1, C, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(C) {
    var R = C.replace(A, T);
    _[R] = new y(R, 1, !1, C, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(C) {
    var R = C.replace(A, T);
    _[R] = new y(R, 1, !1, C, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(C) {
    _[C] = new y(C, 1, !1, C.toLowerCase(), null, !1, !1);
  }), _.xlinkHref = new y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(C) {
    _[C] = new y(C, 1, !1, C.toLowerCase(), null, !0, !0);
  });
  var N = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, P = ["Webkit", "ms", "Moz", "O"];
  Object.keys(N).forEach(function(C) {
    P.forEach(function(R) {
      R = R + C.charAt(0).toUpperCase() + C.substring(1), N[R] = N[C];
    });
  });
  var B = /["'&<>]/;
  function M(C) {
    if (typeof C == "boolean" || typeof C == "number")
      return "" + C;
    C = "" + C;
    var R = B.exec(C);
    if (R) {
      var $ = "", Q, be = 0;
      for (Q = R.index; Q < C.length; Q++) {
        switch (C.charCodeAt(Q)) {
          case 34:
            R = "&quot;";
            break;
          case 38:
            R = "&amp;";
            break;
          case 39:
            R = "&#x27;";
            break;
          case 60:
            R = "&lt;";
            break;
          case 62:
            R = "&gt;";
            break;
          default:
            continue;
        }
        be !== Q && ($ += C.substring(be, Q)), be = Q + 1, $ += R;
      }
      C = be !== Q ? $ + C.substring(be, Q) : $;
    }
    return C;
  }
  var X = /([A-Z])/g, U = /^ms-/, K = Array.isArray, z = u("<script>"), j = u("<\/script>"), J = u('<script src="'), ie = u('<script type="module" src="'), ue = u('" async=""><\/script>'), de = /(<\/|<)(s)(cript)/gi;
  function he(C, R, $, Q) {
    return "" + R + ($ === "s" ? "\\u0073" : "\\u0053") + Q;
  }
  function Ee(C, R, $, Q, be) {
    C = C === void 0 ? "" : C, R = R === void 0 ? z : u('<script nonce="' + M(R) + '">');
    var fe = [];
    if ($ !== void 0 && fe.push(R, l(("" + $).replace(de, he)), j), Q !== void 0)
      for ($ = 0; $ < Q.length; $++)
        fe.push(J, l(M(Q[$])), ue);
    if (be !== void 0)
      for (Q = 0; Q < be.length; Q++)
        fe.push(ie, l(M(be[Q])), ue);
    return { bootstrapChunks: fe, startInlineScript: R, placeholderPrefix: u(C + "P:"), segmentPrefix: u(C + "S:"), boundaryPrefix: C + "B:", idPrefix: C, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1 };
  }
  function Le(C, R) {
    return { insertionMode: C, selectedValue: R };
  }
  function L(C) {
    return Le(C === "http://www.w3.org/2000/svg" ? 2 : C === "http://www.w3.org/1998/Math/MathML" ? 3 : 0, null);
  }
  function me(C, R, $) {
    switch (R) {
      case "select":
        return Le(1, $.value != null ? $.value : $.defaultValue);
      case "svg":
        return Le(2, null);
      case "math":
        return Le(3, null);
      case "foreignObject":
        return Le(1, null);
      case "table":
        return Le(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return Le(5, null);
      case "colgroup":
        return Le(7, null);
      case "tr":
        return Le(6, null);
    }
    return 4 <= C.insertionMode || C.insertionMode === 0 ? Le(1, null) : C;
  }
  var Se = u("<!-- -->");
  function G(C, R, $, Q) {
    return R === "" ? Q : (Q && C.push(Se), C.push(l(M(R))), !0);
  }
  var He = /* @__PURE__ */ new Map(), xe = u(' style="'), _e = u(":"), Ze = u(";");
  function qe(C, R, $) {
    if (typeof $ != "object")
      throw Error(t(62));
    R = !0;
    for (var Q in $)
      if (c.call($, Q)) {
        var be = $[Q];
        if (be != null && typeof be != "boolean" && be !== "") {
          if (Q.indexOf("--") === 0) {
            var fe = l(M(Q));
            be = l(M(("" + be).trim()));
          } else {
            fe = Q;
            var Be = He.get(fe);
            Be !== void 0 || (Be = u(M(fe.replace(X, "-$1").toLowerCase().replace(U, "-ms-"))), He.set(fe, Be)), fe = Be, be = typeof be == "number" ? be === 0 || c.call(N, Q) ? l("" + be) : l(be + "px") : l(M(("" + be).trim()));
          }
          R ? (R = !1, C.push(xe, fe, _e, be)) : C.push(Ze, fe, _e, be);
        }
      }
    R || C.push(At);
  }
  var nt = u(" "), at = u('="'), At = u('"'), Oe = u('=""');
  function wt(C, R, $, Q) {
    switch ($) {
      case "style":
        qe(C, R, Q);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < $.length) || $[0] !== "o" && $[0] !== "O" || $[1] !== "n" && $[1] !== "N") {
      if (R = _.hasOwnProperty($) ? _[$] : null, R !== null) {
        switch (typeof Q) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!R.acceptsBooleans)
              return;
        }
        switch ($ = l(R.attributeName), R.type) {
          case 3:
            Q && C.push(nt, $, Oe);
            break;
          case 4:
            Q === !0 ? C.push(nt, $, Oe) : Q !== !1 && C.push(nt, $, at, l(M(Q)), At);
            break;
          case 5:
            isNaN(Q) || C.push(nt, $, at, l(M(Q)), At);
            break;
          case 6:
            !isNaN(Q) && 1 <= Q && C.push(nt, $, at, l(M(Q)), At);
            break;
          default:
            R.sanitizeURL && (Q = "" + Q), C.push(nt, $, at, l(M(Q)), At);
        }
      } else if (k($)) {
        switch (typeof Q) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (R = $.toLowerCase().slice(0, 5), R !== "data-" && R !== "aria-")
              return;
        }
        C.push(nt, l($), at, l(M(Q)), At);
      }
    }
  }
  var Ge = u(">"), nr = u("/>");
  function vr(C, R, $) {
    if (R != null) {
      if ($ != null)
        throw Error(t(60));
      if (typeof R != "object" || !("__html" in R))
        throw Error(t(61));
      R = R.__html, R != null && C.push(l("" + R));
    }
  }
  function zr(C) {
    var R = "";
    return e.Children.forEach(C, function($) {
      $ != null && (R += $);
    }), R;
  }
  var Wr = u(' selected=""');
  function ne(C, R, $, Q) {
    C.push(Ue($));
    var be = $ = null, fe;
    for (fe in R)
      if (c.call(R, fe)) {
        var Be = R[fe];
        if (Be != null)
          switch (fe) {
            case "children":
              $ = Be;
              break;
            case "dangerouslySetInnerHTML":
              be = Be;
              break;
            default:
              wt(C, Q, fe, Be);
          }
      }
    return C.push(Ge), vr(C, be, $), typeof $ == "string" ? (C.push(l(M($))), null) : $;
  }
  var pe = u(`
`), Fe = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Ye = /* @__PURE__ */ new Map();
  function Ue(C) {
    var R = Ye.get(C);
    if (R === void 0) {
      if (!Fe.test(C))
        throw Error(t(65, C));
      R = u("<" + C), Ye.set(C, R);
    }
    return R;
  }
  var Re = u("<!DOCTYPE html>");
  function ot(C, R, $, Q, be) {
    switch (R) {
      case "select":
        C.push(Ue("select"));
        var fe = null, Be = null;
        for (Wt in $)
          if (c.call($, Wt)) {
            var Ke = $[Wt];
            if (Ke != null)
              switch (Wt) {
                case "children":
                  fe = Ke;
                  break;
                case "dangerouslySetInnerHTML":
                  Be = Ke;
                  break;
                case "defaultValue":
                case "value":
                  break;
                default:
                  wt(C, Q, Wt, Ke);
              }
          }
        return C.push(Ge), vr(C, Be, fe), fe;
      case "option":
        Be = be.selectedValue, C.push(Ue("option"));
        var Tt = Ke = null, Yt = null, Wt = null;
        for (fe in $)
          if (c.call($, fe)) {
            var Or = $[fe];
            if (Or != null)
              switch (fe) {
                case "children":
                  Ke = Or;
                  break;
                case "selected":
                  Yt = Or;
                  break;
                case "dangerouslySetInnerHTML":
                  Wt = Or;
                  break;
                case "value":
                  Tt = Or;
                default:
                  wt(C, Q, fe, Or);
              }
          }
        if (Be != null)
          if ($ = Tt !== null ? "" + Tt : zr(Ke), K(Be)) {
            for (Q = 0; Q < Be.length; Q++)
              if ("" + Be[Q] === $) {
                C.push(Wr);
                break;
              }
          } else
            "" + Be === $ && C.push(Wr);
        else
          Yt && C.push(Wr);
        return C.push(Ge), vr(C, Wt, Ke), Ke;
      case "textarea":
        C.push(Ue("textarea")), Wt = Be = fe = null;
        for (Ke in $)
          if (c.call($, Ke) && (Tt = $[Ke], Tt != null))
            switch (Ke) {
              case "children":
                Wt = Tt;
                break;
              case "value":
                fe = Tt;
                break;
              case "defaultValue":
                Be = Tt;
                break;
              case "dangerouslySetInnerHTML":
                throw Error(t(91));
              default:
                wt(C, Q, Ke, Tt);
            }
        if (fe === null && Be !== null && (fe = Be), C.push(Ge), Wt != null) {
          if (fe != null)
            throw Error(t(92));
          if (K(Wt) && 1 < Wt.length)
            throw Error(t(93));
          fe = "" + Wt;
        }
        return typeof fe == "string" && fe[0] === `
` && C.push(pe), fe !== null && C.push(l(M("" + fe))), null;
      case "input":
        C.push(Ue("input")), Tt = Wt = Ke = fe = null;
        for (Be in $)
          if (c.call($, Be) && (Yt = $[Be], Yt != null))
            switch (Be) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(t(399, "input"));
              case "defaultChecked":
                Tt = Yt;
                break;
              case "defaultValue":
                Ke = Yt;
                break;
              case "checked":
                Wt = Yt;
                break;
              case "value":
                fe = Yt;
                break;
              default:
                wt(C, Q, Be, Yt);
            }
        return Wt !== null ? wt(
          C,
          Q,
          "checked",
          Wt
        ) : Tt !== null && wt(C, Q, "checked", Tt), fe !== null ? wt(C, Q, "value", fe) : Ke !== null && wt(C, Q, "value", Ke), C.push(nr), null;
      case "menuitem":
        C.push(Ue("menuitem"));
        for (var an in $)
          if (c.call($, an) && (fe = $[an], fe != null))
            switch (an) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(t(400));
              default:
                wt(C, Q, an, fe);
            }
        return C.push(Ge), null;
      case "title":
        C.push(Ue("title")), fe = null;
        for (Or in $)
          if (c.call($, Or) && (Be = $[Or], Be != null))
            switch (Or) {
              case "children":
                fe = Be;
                break;
              case "dangerouslySetInnerHTML":
                throw Error(t(434));
              default:
                wt(C, Q, Or, Be);
            }
        return C.push(Ge), fe;
      case "listing":
      case "pre":
        C.push(Ue(R)), Be = fe = null;
        for (Tt in $)
          if (c.call($, Tt) && (Ke = $[Tt], Ke != null))
            switch (Tt) {
              case "children":
                fe = Ke;
                break;
              case "dangerouslySetInnerHTML":
                Be = Ke;
                break;
              default:
                wt(C, Q, Tt, Ke);
            }
        if (C.push(Ge), Be != null) {
          if (fe != null)
            throw Error(t(60));
          if (typeof Be != "object" || !("__html" in Be))
            throw Error(t(61));
          $ = Be.__html, $ != null && (typeof $ == "string" && 0 < $.length && $[0] === `
` ? C.push(pe, l($)) : C.push(l("" + $)));
        }
        return typeof fe == "string" && fe[0] === `
` && C.push(pe), fe;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        C.push(Ue(R));
        for (var Fn in $)
          if (c.call($, Fn) && (fe = $[Fn], fe != null))
            switch (Fn) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(t(399, R));
              default:
                wt(C, Q, Fn, fe);
            }
        return C.push(nr), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return ne(C, $, R, Q);
      case "html":
        return be.insertionMode === 0 && C.push(Re), ne(C, $, R, Q);
      default:
        if (R.indexOf("-") === -1 && typeof $.is != "string")
          return ne(C, $, R, Q);
        C.push(Ue(R)), Be = fe = null;
        for (Yt in $)
          if (c.call($, Yt) && (Ke = $[Yt], Ke != null))
            switch (Yt) {
              case "children":
                fe = Ke;
                break;
              case "dangerouslySetInnerHTML":
                Be = Ke;
                break;
              case "style":
                qe(C, Q, Ke);
                break;
              case "suppressContentEditableWarning":
              case "suppressHydrationWarning":
                break;
              default:
                k(Yt) && typeof Ke != "function" && typeof Ke != "symbol" && C.push(nt, l(Yt), at, l(M(Ke)), At);
            }
        return C.push(Ge), vr(C, Be, fe), fe;
    }
  }
  var Ut = u("</"), ge = u(">"), Ie = u('<template id="'), ut = u('"></template>'), xt = u("<!--$-->"), Bt = u('<!--$?--><template id="'), gr = u('"></template>'), Gr = u("<!--$!-->"), kr = u("<!--/$-->"), Xr = u("<template"), Er = u('"'), tr = u(' data-dgst="');
  u(' data-msg="'), u(' data-stck="');
  var Ti = u("></template>");
  function lt(C, R, $) {
    if (n(C, Bt), $ === null)
      throw Error(t(395));
    return n(C, $), a(C, gr);
  }
  var _r = u('<div hidden id="'), hr = u('">'), $t = u("</div>"), pi = u('<svg aria-hidden="true" style="display:none" id="'), Di = u('">'), Zi = u("</svg>"), yi = u('<math aria-hidden="true" style="display:none" id="'), pn = u('">'), vi = u("</math>"), Cr = u('<table hidden id="'), ca = u('">'), da = u("</table>"), pa = u('<table hidden><tbody id="'), Lr = u('">'), Ln = u("</tbody></table>"), ha = u('<table hidden><tr id="'), Ji = u('">'), te = u("</tr></table>"), $e = u('<table hidden><colgroup id="'), tt = u('">'), Et = u("</colgroup></table>");
  function Vt(C, R, $, Q) {
    switch ($.insertionMode) {
      case 0:
      case 1:
        return n(C, _r), n(C, R.segmentPrefix), n(C, l(Q.toString(16))), a(C, hr);
      case 2:
        return n(C, pi), n(C, R.segmentPrefix), n(C, l(Q.toString(16))), a(C, Di);
      case 3:
        return n(C, yi), n(C, R.segmentPrefix), n(C, l(Q.toString(16))), a(C, pn);
      case 4:
        return n(C, Cr), n(C, R.segmentPrefix), n(C, l(Q.toString(16))), a(C, ca);
      case 5:
        return n(C, pa), n(C, R.segmentPrefix), n(C, l(Q.toString(16))), a(C, Lr);
      case 6:
        return n(C, ha), n(C, R.segmentPrefix), n(C, l(Q.toString(16))), a(C, Ji);
      case 7:
        return n(
          C,
          $e
        ), n(C, R.segmentPrefix), n(C, l(Q.toString(16))), a(C, tt);
      default:
        throw Error(t(397));
    }
  }
  function Rt(C, R) {
    switch (R.insertionMode) {
      case 0:
      case 1:
        return a(C, $t);
      case 2:
        return a(C, Zi);
      case 3:
        return a(C, vi);
      case 4:
        return a(C, da);
      case 5:
        return a(C, Ln);
      case 6:
        return a(C, te);
      case 7:
        return a(C, Et);
      default:
        throw Error(t(397));
    }
  }
  var Gt = u('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), Lt = u('$RS("'), Mr = u('","'), ar = u('")<\/script>'), or = u('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), dr = u('$RC("'), Si = u('","'), hn = u('")<\/script>'), jr = u('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), Hr = u('$RX("'), fn = u('"'), Ii = u(")<\/script>"), fi = u(","), Fa = /[<\u2028\u2029]/g;
  function gi(C) {
    return JSON.stringify(C).replace(Fa, function(R) {
      switch (R) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  var gn = Object.assign, Bi = Symbol.for("react.element"), _n = Symbol.for("react.portal"), Mn = Symbol.for("react.fragment"), to = Symbol.for("react.strict_mode"), ro = Symbol.for("react.profiler"), Dn = Symbol.for("react.provider"), jn = Symbol.for("react.context"), yn = Symbol.for("react.forward_ref"), fa = Symbol.for("react.suspense"), ga = Symbol.for("react.suspense_list"), E = Symbol.for("react.memo"), I = Symbol.for("react.lazy"), V = Symbol.for("react.scope"), q = Symbol.for("react.debug_trace_mode"), ve = Symbol.for("react.legacy_hidden"), ce = Symbol.for("react.default_value"), Ae = Symbol.iterator;
  function Ve(C) {
    if (C == null)
      return null;
    if (typeof C == "function")
      return C.displayName || C.name || null;
    if (typeof C == "string")
      return C;
    switch (C) {
      case Mn:
        return "Fragment";
      case _n:
        return "Portal";
      case ro:
        return "Profiler";
      case to:
        return "StrictMode";
      case fa:
        return "Suspense";
      case ga:
        return "SuspenseList";
    }
    if (typeof C == "object")
      switch (C.$$typeof) {
        case jn:
          return (C.displayName || "Context") + ".Consumer";
        case Dn:
          return (C._context.displayName || "Context") + ".Provider";
        case yn:
          var R = C.render;
          return C = C.displayName, C || (C = R.displayName || R.name || "", C = C !== "" ? "ForwardRef(" + C + ")" : "ForwardRef"), C;
        case E:
          return R = C.displayName || null, R !== null ? R : Ve(C.type) || "Memo";
        case I:
          R = C._payload, C = C._init;
          try {
            return Ve(C(R));
          } catch {
          }
      }
    return null;
  }
  var dt = {};
  function yt(C, R) {
    if (C = C.contextTypes, !C)
      return dt;
    var $ = {}, Q;
    for (Q in C)
      $[Q] = R[Q];
    return $;
  }
  var Dt = null;
  function rr(C, R) {
    if (C !== R) {
      C.context._currentValue = C.parentValue, C = C.parent;
      var $ = R.parent;
      if (C === null) {
        if ($ !== null)
          throw Error(t(401));
      } else {
        if ($ === null)
          throw Error(t(401));
        rr(C, $);
      }
      R.context._currentValue = R.value;
    }
  }
  function Zr(C) {
    C.context._currentValue = C.parentValue, C = C.parent, C !== null && Zr(C);
  }
  function Ei(C) {
    var R = C.parent;
    R !== null && Ei(R), C.context._currentValue = C.value;
  }
  function Ci(C, R) {
    if (C.context._currentValue = C.parentValue, C = C.parent, C === null)
      throw Error(t(402));
    C.depth === R.depth ? rr(C, R) : Ci(C, R);
  }
  function En(C, R) {
    var $ = R.parent;
    if ($ === null)
      throw Error(t(402));
    C.depth === $.depth ? rr(C, $) : En(C, $), R.context._currentValue = R.value;
  }
  function en(C) {
    var R = Dt;
    R !== C && (R === null ? Ei(C) : C === null ? Zr(R) : R.depth === C.depth ? rr(R, C) : R.depth > C.depth ? Ci(R, C) : En(R, C), Dt = C);
  }
  var Ta = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(C, R) {
    C = C._reactInternals, C.queue !== null && C.queue.push(R);
  }, enqueueReplaceState: function(C, R) {
    C = C._reactInternals, C.replace = !0, C.queue = [R];
  }, enqueueForceUpdate: function() {
  } };
  function Ri(C, R, $, Q) {
    var be = C.state !== void 0 ? C.state : null;
    C.updater = Ta, C.props = $, C.state = be;
    var fe = { queue: [], replace: !1 };
    C._reactInternals = fe;
    var Be = R.contextType;
    if (C.context = typeof Be == "object" && Be !== null ? Be._currentValue : Q, Be = R.getDerivedStateFromProps, typeof Be == "function" && (Be = Be($, be), be = Be == null ? be : gn({}, be, Be), C.state = be), typeof R.getDerivedStateFromProps != "function" && typeof C.getSnapshotBeforeUpdate != "function" && (typeof C.UNSAFE_componentWillMount == "function" || typeof C.componentWillMount == "function"))
      if (R = C.state, typeof C.componentWillMount == "function" && C.componentWillMount(), typeof C.UNSAFE_componentWillMount == "function" && C.UNSAFE_componentWillMount(), R !== C.state && Ta.enqueueReplaceState(C, C.state, null), fe.queue !== null && 0 < fe.queue.length)
        if (R = fe.queue, Be = fe.replace, fe.queue = null, fe.replace = !1, Be && R.length === 1)
          C.state = R[0];
        else {
          for (fe = Be ? R[0] : C.state, be = !0, Be = Be ? 1 : 0; Be < R.length; Be++) {
            var Ke = R[Be];
            Ke = typeof Ke == "function" ? Ke.call(C, fe, $, Q) : Ke, Ke != null && (be ? (be = !1, fe = gn({}, fe, Ke)) : gn(fe, Ke));
          }
          C.state = fe;
        }
      else
        fe.queue = null;
  }
  var Hn = { id: 1, overflow: "" };
  function Cn(C, R, $) {
    var Q = C.id;
    C = C.overflow;
    var be = 32 - $n(Q) - 1;
    Q &= ~(1 << be), $ += 1;
    var fe = 32 - $n(R) + be;
    if (30 < fe) {
      var Be = be - be % 5;
      return fe = (Q & (1 << Be) - 1).toString(32), Q >>= Be, be -= Be, { id: 1 << 32 - $n(R) + be | $ << be | Q, overflow: fe + C };
    }
    return { id: 1 << fe | $ << be | Q, overflow: C };
  }
  var $n = Math.clz32 ? Math.clz32 : hs, Jl = Math.log, ps = Math.LN2;
  function hs(C) {
    return C >>>= 0, C === 0 ? 32 : 31 - (Jl(C) / ps | 0) | 0;
  }
  function Ks(C, R) {
    return C === R && (C !== 0 || 1 / C === 1 / R) || C !== C && R !== R;
  }
  var Fo = typeof Object.is == "function" ? Object.is : Ks, mn = null, xn = null, io = null, br = null, Un = !1, ji = !1, Y = 0, le = null, Pe = 0;
  function it() {
    if (mn === null)
      throw Error(t(321));
    return mn;
  }
  function Zt() {
    if (0 < Pe)
      throw Error(t(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function Pt() {
    return br === null ? io === null ? (Un = !1, io = br = Zt()) : (Un = !0, br = io) : br.next === null ? (Un = !1, br = br.next = Zt()) : (Un = !0, br = br.next), br;
  }
  function xr() {
    xn = mn = null, ji = !1, io = null, Pe = 0, br = le = null;
  }
  function ai(C, R) {
    return typeof R == "function" ? R(C) : R;
  }
  function hi(C, R, $) {
    if (mn = it(), br = Pt(), Un) {
      var Q = br.queue;
      if (R = Q.dispatch, le !== null && ($ = le.get(Q), $ !== void 0)) {
        le.delete(Q), Q = br.memoizedState;
        do
          Q = C(Q, $.action), $ = $.next;
        while ($ !== null);
        return br.memoizedState = Q, [Q, R];
      }
      return [br.memoizedState, R];
    }
    return C = C === ai ? typeof R == "function" ? R() : R : $ !== void 0 ? $(R) : R, br.memoizedState = C, C = br.queue = { last: null, dispatch: null }, C = C.dispatch = Hi.bind(null, mn, C), [br.memoizedState, C];
  }
  function Ar(C, R) {
    if (mn = it(), br = Pt(), R = R === void 0 ? null : R, br !== null) {
      var $ = br.memoizedState;
      if ($ !== null && R !== null) {
        var Q = $[1];
        e:
          if (Q === null)
            Q = !1;
          else {
            for (var be = 0; be < Q.length && be < R.length; be++)
              if (!Fo(R[be], Q[be])) {
                Q = !1;
                break e;
              }
            Q = !0;
          }
        if (Q)
          return $[0];
      }
    }
    return C = C(), br.memoizedState = [C, R], C;
  }
  function Hi(C, R, $) {
    if (25 <= Pe)
      throw Error(t(301));
    if (C === mn)
      if (ji = !0, C = { action: $, next: null }, le === null && (le = /* @__PURE__ */ new Map()), $ = le.get(R), $ === void 0)
        le.set(R, C);
      else {
        for (R = $; R.next !== null; )
          R = R.next;
        R.next = C;
      }
  }
  function tn() {
    throw Error(t(394));
  }
  function oi() {
  }
  var xi = { readContext: function(C) {
    return C._currentValue;
  }, useContext: function(C) {
    return it(), C._currentValue;
  }, useMemo: Ar, useReducer: hi, useRef: function(C) {
    mn = it(), br = Pt();
    var R = br.memoizedState;
    return R === null ? (C = { current: C }, br.memoizedState = C) : R;
  }, useState: function(C) {
    return hi(ai, C);
  }, useInsertionEffect: oi, useLayoutEffect: function() {
  }, useCallback: function(C, R) {
    return Ar(function() {
      return C;
    }, R);
  }, useImperativeHandle: oi, useEffect: oi, useDebugValue: oi, useDeferredValue: function(C) {
    return it(), C;
  }, useTransition: function() {
    return it(), [!1, tn];
  }, useId: function() {
    var C = xn.treeContext, R = C.overflow;
    C = C.id, C = (C & ~(1 << 32 - $n(C) - 1)).toString(32) + R;
    var $ = Ai;
    if ($ === null)
      throw Error(t(404));
    return R = Y++, C = ":" + $.idPrefix + "R" + C, 0 < R && (C += "H" + R.toString(32)), C + ":";
  }, useMutableSource: function(C, R) {
    return it(), R(C._source);
  }, useSyncExternalStore: function(C, R, $) {
    if ($ === void 0)
      throw Error(t(407));
    return $();
  } }, Ai = null, Ki = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function An(C) {
    return console.error(C), null;
  }
  function rn() {
  }
  function To(C, R, $, Q, be, fe, Be, Ke, Tt) {
    var Yt = [], Wt = /* @__PURE__ */ new Set();
    return R = { destination: null, responseState: R, progressiveChunkSize: Q === void 0 ? 12800 : Q, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: Wt, pingedTasks: Yt, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: be === void 0 ? An : be, onAllReady: fe === void 0 ? rn : fe, onShellReady: Be === void 0 ? rn : Be, onShellError: Ke === void 0 ? rn : Ke, onFatalError: Tt === void 0 ? rn : Tt }, $ = wn(R, 0, null, $, !1, !1), $.parentFlushed = !0, C = Sa(R, C, null, $, Wt, dt, null, Hn), Yt.push(C), R;
  }
  function Sa(C, R, $, Q, be, fe, Be, Ke) {
    C.allPendingTasks++, $ === null ? C.pendingRootTasks++ : $.pendingTasks++;
    var Tt = { node: R, ping: function() {
      var Yt = C.pingedTasks;
      Yt.push(Tt), Yt.length === 1 && Dc(C);
    }, blockedBoundary: $, blockedSegment: Q, abortSet: be, legacyContext: fe, context: Be, treeContext: Ke };
    return be.add(Tt), Tt;
  }
  function wn(C, R, $, Q, be, fe) {
    return { status: 0, id: -1, index: R, parentFlushed: !1, chunks: [], children: [], formatContext: Q, boundary: $, lastPushedText: be, textEmbedded: fe };
  }
  function So(C, R) {
    if (C = C.onError(R), C != null && typeof C != "string")
      throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof C + '" instead');
    return C;
  }
  function Ys(C, R) {
    var $ = C.onShellError;
    $(R), $ = C.onFatalError, $(R), C.destination !== null ? (C.status = 2, d(C.destination, R)) : (C.status = 1, C.fatalError = R);
  }
  function mc(C, R, $, Q, be) {
    for (mn = {}, xn = R, Y = 0, C = $(Q, be); ji; )
      ji = !1, Y = 0, Pe += 1, br = null, C = $(Q, be);
    return xr(), C;
  }
  function eu(C, R, $, Q) {
    var be = $.render(), fe = Q.childContextTypes;
    if (fe != null) {
      var Be = R.legacyContext;
      if (typeof $.getChildContext != "function")
        Q = Be;
      else {
        $ = $.getChildContext();
        for (var Ke in $)
          if (!(Ke in fe))
            throw Error(t(108, Ve(Q) || "Unknown", Ke));
        Q = gn({}, Be, $);
      }
      R.legacyContext = Q, nn(C, R, be), R.legacyContext = Be;
    } else
      nn(C, R, be);
  }
  function vc(C, R) {
    if (C && C.defaultProps) {
      R = gn({}, R), C = C.defaultProps;
      for (var $ in C)
        R[$] === void 0 && (R[$] = C[$]);
      return R;
    }
    return R;
  }
  function qs(C, R, $, Q, be) {
    if (typeof $ == "function")
      if ($.prototype && $.prototype.isReactComponent) {
        be = yt($, R.legacyContext);
        var fe = $.contextType;
        fe = new $(Q, typeof fe == "object" && fe !== null ? fe._currentValue : be), Ri(fe, $, Q, be), eu(C, R, fe, $);
      } else {
        fe = yt($, R.legacyContext), be = mc(C, R, $, Q, fe);
        var Be = Y !== 0;
        if (typeof be == "object" && be !== null && typeof be.render == "function" && be.$$typeof === void 0)
          Ri(be, $, Q, fe), eu(C, R, be, $);
        else if (Be) {
          Q = R.treeContext, R.treeContext = Cn(Q, 1, 0);
          try {
            nn(C, R, be);
          } finally {
            R.treeContext = Q;
          }
        } else
          nn(C, R, be);
      }
    else if (typeof $ == "string") {
      switch (be = R.blockedSegment, fe = ot(be.chunks, $, Q, C.responseState, be.formatContext), be.lastPushedText = !1, Be = be.formatContext, be.formatContext = me(Be, $, Q), Qs(C, R, fe), be.formatContext = Be, $) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          be.chunks.push(Ut, l($), ge);
      }
      be.lastPushedText = !1;
    } else {
      switch ($) {
        case ve:
        case q:
        case to:
        case ro:
        case Mn:
          nn(C, R, Q.children);
          return;
        case ga:
          nn(C, R, Q.children);
          return;
        case V:
          throw Error(t(343));
        case fa:
          e: {
            $ = R.blockedBoundary, be = R.blockedSegment, fe = Q.fallback, Q = Q.children, Be = /* @__PURE__ */ new Set();
            var Ke = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: Be, errorDigest: null }, Tt = wn(C, be.chunks.length, Ke, be.formatContext, !1, !1);
            be.children.push(Tt), be.lastPushedText = !1;
            var Yt = wn(C, 0, null, be.formatContext, !1, !1);
            Yt.parentFlushed = !0, R.blockedBoundary = Ke, R.blockedSegment = Yt;
            try {
              if (Qs(
                C,
                R,
                Q
              ), Yt.lastPushedText && Yt.textEmbedded && Yt.chunks.push(Se), Yt.status = 1, Xs(Ke, Yt), Ke.pendingTasks === 0)
                break e;
            } catch (Wt) {
              Yt.status = 4, Ke.forceClientRender = !0, Ke.errorDigest = So(C, Wt);
            } finally {
              R.blockedBoundary = $, R.blockedSegment = be;
            }
            R = Sa(C, fe, $, Tt, Be, R.legacyContext, R.context, R.treeContext), C.pingedTasks.push(R);
          }
          return;
      }
      if (typeof $ == "object" && $ !== null)
        switch ($.$$typeof) {
          case yn:
            if (Q = mc(C, R, $.render, Q, be), Y !== 0) {
              $ = R.treeContext, R.treeContext = Cn($, 1, 0);
              try {
                nn(C, R, Q);
              } finally {
                R.treeContext = $;
              }
            } else
              nn(C, R, Q);
            return;
          case E:
            $ = $.type, Q = vc($, Q), qs(C, R, $, Q, be);
            return;
          case Dn:
            if (be = Q.children, $ = $._context, Q = Q.value, fe = $._currentValue, $._currentValue = Q, Be = Dt, Dt = Q = { parent: Be, depth: Be === null ? 0 : Be.depth + 1, context: $, parentValue: fe, value: Q }, R.context = Q, nn(C, R, be), C = Dt, C === null)
              throw Error(t(403));
            Q = C.parentValue, C.context._currentValue = Q === ce ? C.context._defaultValue : Q, C = Dt = C.parent, R.context = C;
            return;
          case jn:
            Q = Q.children, Q = Q($._currentValue), nn(C, R, Q);
            return;
          case I:
            be = $._init, $ = be($._payload), Q = vc($, Q), qs(C, R, $, Q, void 0);
            return;
        }
      throw Error(t(
        130,
        $ == null ? $ : typeof $,
        ""
      ));
    }
  }
  function nn(C, R, $) {
    if (R.node = $, typeof $ == "object" && $ !== null) {
      switch ($.$$typeof) {
        case Bi:
          qs(C, R, $.type, $.props, $.ref);
          return;
        case _n:
          throw Error(t(257));
        case I:
          var Q = $._init;
          $ = Q($._payload), nn(C, R, $);
          return;
      }
      if (K($)) {
        kc(C, R, $);
        return;
      }
      if ($ === null || typeof $ != "object" ? Q = null : (Q = Ae && $[Ae] || $["@@iterator"], Q = typeof Q == "function" ? Q : null), Q && (Q = Q.call($))) {
        if ($ = Q.next(), !$.done) {
          var be = [];
          do
            be.push($.value), $ = Q.next();
          while (!$.done);
          kc(C, R, be);
        }
        return;
      }
      throw C = Object.prototype.toString.call($), Error(t(31, C === "[object Object]" ? "object with keys {" + Object.keys($).join(", ") + "}" : C));
    }
    typeof $ == "string" ? (Q = R.blockedSegment, Q.lastPushedText = G(R.blockedSegment.chunks, $, C.responseState, Q.lastPushedText)) : typeof $ == "number" && (Q = R.blockedSegment, Q.lastPushedText = G(R.blockedSegment.chunks, "" + $, C.responseState, Q.lastPushedText));
  }
  function kc(C, R, $) {
    for (var Q = $.length, be = 0; be < Q; be++) {
      var fe = R.treeContext;
      R.treeContext = Cn(fe, Q, be);
      try {
        Qs(C, R, $[be]);
      } finally {
        R.treeContext = fe;
      }
    }
  }
  function Qs(C, R, $) {
    var Q = R.blockedSegment.formatContext, be = R.legacyContext, fe = R.context;
    try {
      return nn(C, R, $);
    } catch (Tt) {
      if (xr(), typeof Tt == "object" && Tt !== null && typeof Tt.then == "function") {
        $ = Tt;
        var Be = R.blockedSegment, Ke = wn(C, Be.chunks.length, null, Be.formatContext, Be.lastPushedText, !0);
        Be.children.push(Ke), Be.lastPushedText = !1, C = Sa(C, R.node, R.blockedBoundary, Ke, R.abortSet, R.legacyContext, R.context, R.treeContext).ping, $.then(C, C), R.blockedSegment.formatContext = Q, R.legacyContext = be, R.context = fe, en(fe);
      } else
        throw R.blockedSegment.formatContext = Q, R.legacyContext = be, R.context = fe, en(fe), Tt;
    }
  }
  function bp(C) {
    var R = C.blockedBoundary;
    C = C.blockedSegment, C.status = 3, _c(this, R, C);
  }
  function bc(C, R, $) {
    var Q = C.blockedBoundary;
    C.blockedSegment.status = 3, Q === null ? (R.allPendingTasks--, R.status !== 2 && (R.status = 2, R.destination !== null && R.destination.close())) : (Q.pendingTasks--, Q.forceClientRender || (Q.forceClientRender = !0, C = $ === void 0 ? Error(t(432)) : $, Q.errorDigest = R.onError(C), Q.parentFlushed && R.clientRenderedBoundaries.push(Q)), Q.fallbackAbortableTasks.forEach(function(be) {
      return bc(be, R, $);
    }), Q.fallbackAbortableTasks.clear(), R.allPendingTasks--, R.allPendingTasks === 0 && (Q = R.onAllReady, Q()));
  }
  function Xs(C, R) {
    if (R.chunks.length === 0 && R.children.length === 1 && R.children[0].boundary === null) {
      var $ = R.children[0];
      $.id = R.id, $.parentFlushed = !0, $.status === 1 && Xs(C, $);
    } else
      C.completedSegments.push(R);
  }
  function _c(C, R, $) {
    if (R === null) {
      if ($.parentFlushed) {
        if (C.completedRootSegment !== null)
          throw Error(t(389));
        C.completedRootSegment = $;
      }
      C.pendingRootTasks--, C.pendingRootTasks === 0 && (C.onShellError = rn, R = C.onShellReady, R());
    } else
      R.pendingTasks--, R.forceClientRender || (R.pendingTasks === 0 ? ($.parentFlushed && $.status === 1 && Xs(R, $), R.parentFlushed && C.completedBoundaries.push(R), R.fallbackAbortableTasks.forEach(bp, C), R.fallbackAbortableTasks.clear()) : $.parentFlushed && $.status === 1 && (Xs(R, $), R.completedSegments.length === 1 && R.parentFlushed && C.partialBoundaries.push(R)));
    C.allPendingTasks--, C.allPendingTasks === 0 && (C = C.onAllReady, C());
  }
  function Dc(C) {
    if (C.status !== 2) {
      var R = Dt, $ = Ki.current;
      Ki.current = xi;
      var Q = Ai;
      Ai = C.responseState;
      try {
        var be = C.pingedTasks, fe;
        for (fe = 0; fe < be.length; fe++) {
          var Be = be[fe], Ke = C, Tt = Be.blockedSegment;
          if (Tt.status === 0) {
            en(Be.context);
            try {
              nn(Ke, Be, Be.node), Tt.lastPushedText && Tt.textEmbedded && Tt.chunks.push(Se), Be.abortSet.delete(Be), Tt.status = 1, _c(Ke, Be.blockedBoundary, Tt);
            } catch (Tn) {
              if (xr(), typeof Tn == "object" && Tn !== null && typeof Tn.then == "function") {
                var Yt = Be.ping;
                Tn.then(Yt, Yt);
              } else {
                Be.abortSet.delete(Be), Tt.status = 4;
                var Wt = Be.blockedBoundary, Or = Tn, an = So(Ke, Or);
                if (Wt === null ? Ys(Ke, Or) : (Wt.pendingTasks--, Wt.forceClientRender || (Wt.forceClientRender = !0, Wt.errorDigest = an, Wt.parentFlushed && Ke.clientRenderedBoundaries.push(Wt))), Ke.allPendingTasks--, Ke.allPendingTasks === 0) {
                  var Fn = Ke.onAllReady;
                  Fn();
                }
              }
            } finally {
            }
          }
        }
        be.splice(0, fe), C.destination !== null && tu(C, C.destination);
      } catch (Tn) {
        So(C, Tn), Ys(C, Tn);
      } finally {
        Ai = Q, Ki.current = $, $ === xi && en(R);
      }
    }
  }
  function Zs(C, R, $) {
    switch ($.parentFlushed = !0, $.status) {
      case 0:
        var Q = $.id = C.nextSegmentId++;
        return $.lastPushedText = !1, $.textEmbedded = !1, C = C.responseState, n(R, Ie), n(R, C.placeholderPrefix), C = l(Q.toString(16)), n(R, C), a(R, ut);
      case 1:
        $.status = 2;
        var be = !0;
        Q = $.chunks;
        var fe = 0;
        $ = $.children;
        for (var Be = 0; Be < $.length; Be++) {
          for (be = $[Be]; fe < be.index; fe++)
            n(R, Q[fe]);
          be = Js(C, R, be);
        }
        for (; fe < Q.length - 1; fe++)
          n(R, Q[fe]);
        return fe < Q.length && (be = a(R, Q[fe])), be;
      default:
        throw Error(t(390));
    }
  }
  function Js(C, R, $) {
    var Q = $.boundary;
    if (Q === null)
      return Zs(C, R, $);
    if (Q.parentFlushed = !0, Q.forceClientRender)
      Q = Q.errorDigest, a(R, Gr), n(R, Xr), Q && (n(R, tr), n(R, l(M(Q))), n(R, Er)), a(R, Ti), Zs(C, R, $);
    else if (0 < Q.pendingTasks) {
      Q.rootSegmentID = C.nextSegmentId++, 0 < Q.completedSegments.length && C.partialBoundaries.push(Q);
      var be = C.responseState, fe = be.nextSuspenseID++;
      be = u(be.boundaryPrefix + fe.toString(16)), Q = Q.id = be, lt(R, C.responseState, Q), Zs(C, R, $);
    } else if (Q.byteSize > C.progressiveChunkSize)
      Q.rootSegmentID = C.nextSegmentId++, C.completedBoundaries.push(Q), lt(R, C.responseState, Q.id), Zs(C, R, $);
    else {
      if (a(R, xt), $ = Q.completedSegments, $.length !== 1)
        throw Error(t(391));
      Js(C, R, $[0]);
    }
    return a(R, kr);
  }
  function yc(C, R, $) {
    return Vt(R, C.responseState, $.formatContext, $.id), Js(C, R, $), Rt(R, $.formatContext);
  }
  function Ec(C, R, $) {
    for (var Q = $.completedSegments, be = 0; be < Q.length; be++)
      Cc(C, R, $, Q[be]);
    if (Q.length = 0, C = C.responseState, Q = $.id, $ = $.rootSegmentID, n(R, C.startInlineScript), C.sentCompleteBoundaryFunction ? n(R, dr) : (C.sentCompleteBoundaryFunction = !0, n(R, or)), Q === null)
      throw Error(t(395));
    return $ = l($.toString(16)), n(R, Q), n(R, Si), n(R, C.segmentPrefix), n(R, $), a(R, hn);
  }
  function Cc(C, R, $, Q) {
    if (Q.status === 2)
      return !0;
    var be = Q.id;
    if (be === -1) {
      if ((Q.id = $.rootSegmentID) === -1)
        throw Error(t(392));
      return yc(C, R, Q);
    }
    return yc(C, R, Q), C = C.responseState, n(R, C.startInlineScript), C.sentCompleteSegmentFunction ? n(R, Lt) : (C.sentCompleteSegmentFunction = !0, n(R, Gt)), n(R, C.segmentPrefix), be = l(be.toString(16)), n(R, be), n(R, Mr), n(R, C.placeholderPrefix), n(R, be), a(R, ar);
  }
  function tu(C, R) {
    r = new Uint8Array(512), i = 0;
    try {
      var $ = C.completedRootSegment;
      if ($ !== null && C.pendingRootTasks === 0) {
        Js(C, R, $), C.completedRootSegment = null;
        var Q = C.responseState.bootstrapChunks;
        for ($ = 0; $ < Q.length - 1; $++)
          n(R, Q[$]);
        $ < Q.length && a(R, Q[$]);
      }
      var be = C.clientRenderedBoundaries, fe;
      for (fe = 0; fe < be.length; fe++) {
        var Be = be[fe];
        Q = R;
        var Ke = C.responseState, Tt = Be.id, Yt = Be.errorDigest, Wt = Be.errorMessage, Or = Be.errorComponentStack;
        if (n(Q, Ke.startInlineScript), Ke.sentClientRenderFunction ? n(Q, Hr) : (Ke.sentClientRenderFunction = !0, n(
          Q,
          jr
        )), Tt === null)
          throw Error(t(395));
        n(Q, Tt), n(Q, fn), (Yt || Wt || Or) && (n(Q, fi), n(Q, l(gi(Yt || "")))), (Wt || Or) && (n(Q, fi), n(Q, l(gi(Wt || "")))), Or && (n(Q, fi), n(Q, l(gi(Or)))), a(Q, Ii);
      }
      be.splice(0, fe);
      var an = C.completedBoundaries;
      for (fe = 0; fe < an.length; fe++)
        Ec(C, R, an[fe]);
      an.splice(0, fe), o(R), r = new Uint8Array(512), i = 0;
      var Fn = C.partialBoundaries;
      for (fe = 0; fe < Fn.length; fe++) {
        var Tn = Fn[fe];
        e: {
          be = C, Be = R;
          var el = Tn.completedSegments;
          for (Ke = 0; Ke < el.length; Ke++)
            if (!Cc(
              be,
              Be,
              Tn,
              el[Ke]
            )) {
              Ke++, el.splice(0, Ke);
              var Ac = !1;
              break e;
            }
          el.splice(0, Ke), Ac = !0;
        }
        if (!Ac) {
          C.destination = null, fe++, Fn.splice(0, fe);
          return;
        }
      }
      Fn.splice(0, fe);
      var ru = C.completedBoundaries;
      for (fe = 0; fe < ru.length; fe++)
        Ec(C, R, ru[fe]);
      ru.splice(0, fe);
    } finally {
      o(R), C.allPendingTasks === 0 && C.pingedTasks.length === 0 && C.clientRenderedBoundaries.length === 0 && C.completedBoundaries.length === 0 && R.close();
    }
  }
  function xc(C, R) {
    try {
      var $ = C.abortableTasks;
      $.forEach(function(Q) {
        return bc(Q, C, R);
      }), $.clear(), C.destination !== null && tu(C, C.destination);
    } catch (Q) {
      So(C, Q), Ys(C, Q);
    }
  }
  return Wh.renderToReadableStream = function(C, R) {
    return new Promise(function($, Q) {
      var be, fe, Be = new Promise(function(Wt, Or) {
        fe = Wt, be = Or;
      }), Ke = To(C, Ee(R ? R.identifierPrefix : void 0, R ? R.nonce : void 0, R ? R.bootstrapScriptContent : void 0, R ? R.bootstrapScripts : void 0, R ? R.bootstrapModules : void 0), L(R ? R.namespaceURI : void 0), R ? R.progressiveChunkSize : void 0, R ? R.onError : void 0, fe, function() {
        var Wt = new ReadableStream({ type: "bytes", pull: function(Or) {
          if (Ke.status === 1)
            Ke.status = 2, d(Or, Ke.fatalError);
          else if (Ke.status !== 2 && Ke.destination === null) {
            Ke.destination = Or;
            try {
              tu(Ke, Or);
            } catch (an) {
              So(Ke, an), Ys(Ke, an);
            }
          }
        }, cancel: function() {
          xc(Ke);
        } }, { highWaterMark: 0 });
        Wt.allReady = Be, $(Wt);
      }, function(Wt) {
        Be.catch(function() {
        }), Q(Wt);
      }, be);
      if (R && R.signal) {
        var Tt = R.signal, Yt = function() {
          xc(Ke, Tt.reason), Tt.removeEventListener("abort", Yt);
        };
        Tt.addEventListener("abort", Yt);
      }
      Dc(Ke);
    });
  }, Wh.version = "18.2.0", Wh;
}
var Tu = {};
/**
 * @license React
 * react-dom-server-legacy.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var g5;
function ZT() {
  return g5 || (g5 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = ht, t = "18.2.0", r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function i(h) {
      {
        for (var b = arguments.length, x = new Array(b > 1 ? b - 1 : 0), S = 1; S < b; S++)
          x[S - 1] = arguments[S];
        a("warn", h, x);
      }
    }
    function n(h) {
      {
        for (var b = arguments.length, x = new Array(b > 1 ? b - 1 : 0), S = 1; S < b; S++)
          x[S - 1] = arguments[S];
        a("error", h, x);
      }
    }
    function a(h, b, x) {
      {
        var S = r.ReactDebugCurrentFrame, H = S.getStackAddendum();
        H !== "" && (b += "%s", x = x.concat([H]));
        var Z = x.map(function(oe) {
          return String(oe);
        });
        Z.unshift("Warning: " + b), Function.prototype.apply.call(console[h], console, Z);
      }
    }
    function o(h) {
      h();
    }
    function s(h) {
    }
    function l(h, b) {
      u(h, b);
    }
    function u(h, b) {
      return h.push(b);
    }
    function d(h) {
    }
    function c(h) {
      h.push(null);
    }
    function p(h) {
      return h;
    }
    function f(h) {
      return h;
    }
    function g(h, b) {
      h.destroy(b);
    }
    function k(h) {
      {
        var b = typeof Symbol == "function" && Symbol.toStringTag, x = b && h[Symbol.toStringTag] || h.constructor.name || "Object";
        return x;
      }
    }
    function y(h) {
      try {
        return _(h), !1;
      } catch {
        return !0;
      }
    }
    function _(h) {
      return "" + h;
    }
    function A(h, b) {
      if (y(h))
        return n("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", b, k(h)), _(h);
    }
    function T(h, b) {
      if (y(h))
        return n("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", b, k(h)), _(h);
    }
    function N(h) {
      if (y(h))
        return n("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", k(h)), _(h);
    }
    var P = Object.prototype.hasOwnProperty, B = 0, M = 1, X = 2, U = 3, K = 4, z = 5, j = 6, J = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", ie = J + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", ue = new RegExp("^[" + J + "][" + ie + "]*$"), de = {}, he = {};
    function Ee(h) {
      return P.call(he, h) ? !0 : P.call(de, h) ? !1 : ue.test(h) ? (he[h] = !0, !0) : (de[h] = !0, n("Invalid attribute name: `%s`", h), !1);
    }
    function Le(h, b, x, S) {
      if (x !== null && x.type === B)
        return !1;
      switch (typeof b) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (S)
            return !1;
          if (x !== null)
            return !x.acceptsBooleans;
          var H = h.toLowerCase().slice(0, 5);
          return H !== "data-" && H !== "aria-";
        }
        default:
          return !1;
      }
    }
    function L(h) {
      return Se.hasOwnProperty(h) ? Se[h] : null;
    }
    function me(h, b, x, S, H, Z, oe) {
      this.acceptsBooleans = b === X || b === U || b === K, this.attributeName = S, this.attributeNamespace = H, this.mustUseProperty = x, this.propertyName = h, this.type = b, this.sanitizeURL = Z, this.removeEmptyString = oe;
    }
    var Se = {}, G = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    G.forEach(function(h) {
      Se[h] = new me(
        h,
        B,
        !1,
        // mustUseProperty
        h,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(h) {
      var b = h[0], x = h[1];
      Se[b] = new me(
        b,
        M,
        !1,
        // mustUseProperty
        x,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(h) {
      Se[h] = new me(
        h,
        X,
        !1,
        // mustUseProperty
        h.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(h) {
      Se[h] = new me(
        h,
        X,
        !1,
        // mustUseProperty
        h,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(h) {
      Se[h] = new me(
        h,
        U,
        !1,
        // mustUseProperty
        h.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(h) {
      Se[h] = new me(
        h,
        U,
        !0,
        // mustUseProperty
        h,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(h) {
      Se[h] = new me(
        h,
        K,
        !1,
        // mustUseProperty
        h,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(h) {
      Se[h] = new me(
        h,
        j,
        !1,
        // mustUseProperty
        h,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(h) {
      Se[h] = new me(
        h,
        z,
        !1,
        // mustUseProperty
        h.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var He = /[\-\:]([a-z])/g, xe = function(h) {
      return h[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(h) {
      var b = h.replace(He, xe);
      Se[b] = new me(
        b,
        M,
        !1,
        // mustUseProperty
        h,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(h) {
      var b = h.replace(He, xe);
      Se[b] = new me(
        b,
        M,
        !1,
        // mustUseProperty
        h,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(h) {
      var b = h.replace(He, xe);
      Se[b] = new me(
        b,
        M,
        !1,
        // mustUseProperty
        h,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(h) {
      Se[h] = new me(
        h,
        M,
        !1,
        // mustUseProperty
        h.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var _e = "xlinkHref";
    Se[_e] = new me(
      "xlinkHref",
      M,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(h) {
      Se[h] = new me(
        h,
        M,
        !1,
        // mustUseProperty
        h.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var Ze = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function qe(h, b) {
      return h + b.charAt(0).toUpperCase() + b.substring(1);
    }
    var nt = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Ze).forEach(function(h) {
      nt.forEach(function(b) {
        Ze[qe(b, h)] = Ze[h];
      });
    });
    var at = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function At(h, b) {
      at[b.type] || b.onChange || b.onInput || b.readOnly || b.disabled || b.value == null || n("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), b.onChange || b.readOnly || b.disabled || b.checked == null || n("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function Oe(h, b) {
      if (h.indexOf("-") === -1)
        return typeof b.is == "string";
      switch (h) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var wt = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, Ge = {}, nr = new RegExp("^(aria)-[" + ie + "]*$"), vr = new RegExp("^(aria)[A-Z][" + ie + "]*$");
    function zr(h, b) {
      {
        if (P.call(Ge, b) && Ge[b])
          return !0;
        if (vr.test(b)) {
          var x = "aria-" + b.slice(4).toLowerCase(), S = wt.hasOwnProperty(x) ? x : null;
          if (S == null)
            return n("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", b), Ge[b] = !0, !0;
          if (b !== S)
            return n("Invalid ARIA attribute `%s`. Did you mean `%s`?", b, S), Ge[b] = !0, !0;
        }
        if (nr.test(b)) {
          var H = b.toLowerCase(), Z = wt.hasOwnProperty(H) ? H : null;
          if (Z == null)
            return Ge[b] = !0, !1;
          if (b !== Z)
            return n("Unknown ARIA attribute `%s`. Did you mean `%s`?", b, Z), Ge[b] = !0, !0;
        }
      }
      return !0;
    }
    function Wr(h, b) {
      {
        var x = [];
        for (var S in b) {
          var H = zr(h, S);
          H || x.push(S);
        }
        var Z = x.map(function(oe) {
          return "`" + oe + "`";
        }).join(", ");
        x.length === 1 ? n("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", Z, h) : x.length > 1 && n("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", Z, h);
      }
    }
    function ne(h, b) {
      Oe(h, b) || Wr(h, b);
    }
    var pe = !1;
    function Fe(h, b) {
      {
        if (h !== "input" && h !== "textarea" && h !== "select")
          return;
        b != null && b.value === null && !pe && (pe = !0, h === "select" && b.multiple ? n("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", h) : n("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", h));
      }
    }
    var Ye = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Ue = function() {
    };
    {
      var Re = {}, ot = /^on./, Ut = /^on[^A-Z]/, ge = new RegExp("^(aria)-[" + ie + "]*$"), Ie = new RegExp("^(aria)[A-Z][" + ie + "]*$");
      Ue = function(h, b, x, S) {
        if (P.call(Re, b) && Re[b])
          return !0;
        var H = b.toLowerCase();
        if (H === "onfocusin" || H === "onfocusout")
          return n("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), Re[b] = !0, !0;
        if (S != null) {
          var Z = S.registrationNameDependencies, oe = S.possibleRegistrationNames;
          if (Z.hasOwnProperty(b))
            return !0;
          var De = oe.hasOwnProperty(H) ? oe[H] : null;
          if (De != null)
            return n("Invalid event handler property `%s`. Did you mean `%s`?", b, De), Re[b] = !0, !0;
          if (ot.test(b))
            return n("Unknown event handler property `%s`. It will be ignored.", b), Re[b] = !0, !0;
        } else if (ot.test(b))
          return Ut.test(b) && n("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", b), Re[b] = !0, !0;
        if (ge.test(b) || Ie.test(b))
          return !0;
        if (H === "innerhtml")
          return n("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), Re[b] = !0, !0;
        if (H === "aria")
          return n("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), Re[b] = !0, !0;
        if (H === "is" && x !== null && x !== void 0 && typeof x != "string")
          return n("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof x), Re[b] = !0, !0;
        if (typeof x == "number" && isNaN(x))
          return n("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", b), Re[b] = !0, !0;
        var je = L(b), ct = je !== null && je.type === B;
        if (Ye.hasOwnProperty(H)) {
          var kt = Ye[H];
          if (kt !== b)
            return n("Invalid DOM property `%s`. Did you mean `%s`?", b, kt), Re[b] = !0, !0;
        } else if (!ct && b !== H)
          return n("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", b, H), Re[b] = !0, !0;
        return typeof x == "boolean" && Le(b, x, je, !1) ? (x ? n('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', x, b, b, x, b) : n('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', x, b, b, x, b, b, b), Re[b] = !0, !0) : ct ? !0 : Le(b, x, je, !1) ? (Re[b] = !0, !1) : ((x === "false" || x === "true") && je !== null && je.type === U && (n("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", x, b, x === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', b, x), Re[b] = !0), !0);
      };
    }
    var ut = function(h, b, x) {
      {
        var S = [];
        for (var H in b) {
          var Z = Ue(h, H, b[H], x);
          Z || S.push(H);
        }
        var oe = S.map(function(De) {
          return "`" + De + "`";
        }).join(", ");
        S.length === 1 ? n("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", oe, h) : S.length > 1 && n("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", oe, h);
      }
    };
    function xt(h, b, x) {
      Oe(h, b) || ut(h, b, x);
    }
    var Bt = function() {
    };
    {
      var gr = /^(?:webkit|moz|o)[A-Z]/, Gr = /^-ms-/, kr = /-(.)/g, Xr = /;\s*$/, Er = {}, tr = {}, Ti = !1, lt = !1, _r = function(h) {
        return h.replace(kr, function(b, x) {
          return x.toUpperCase();
        });
      }, hr = function(h) {
        Er.hasOwnProperty(h) && Er[h] || (Er[h] = !0, n(
          "Unsupported style property %s. Did you mean %s?",
          h,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          _r(h.replace(Gr, "ms-"))
        ));
      }, $t = function(h) {
        Er.hasOwnProperty(h) && Er[h] || (Er[h] = !0, n("Unsupported vendor-prefixed style property %s. Did you mean %s?", h, h.charAt(0).toUpperCase() + h.slice(1)));
      }, pi = function(h, b) {
        tr.hasOwnProperty(b) && tr[b] || (tr[b] = !0, n(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, h, b.replace(Xr, "")));
      }, Di = function(h, b) {
        Ti || (Ti = !0, n("`NaN` is an invalid value for the `%s` css style property.", h));
      }, Zi = function(h, b) {
        lt || (lt = !0, n("`Infinity` is an invalid value for the `%s` css style property.", h));
      };
      Bt = function(h, b) {
        h.indexOf("-") > -1 ? hr(h) : gr.test(h) ? $t(h) : Xr.test(b) && pi(h, b), typeof b == "number" && (isNaN(b) ? Di(h, b) : isFinite(b) || Zi(h, b));
      };
    }
    var yi = Bt, pn = /["'&<>]/;
    function vi(h) {
      N(h);
      var b = "" + h, x = pn.exec(b);
      if (!x)
        return b;
      var S, H = "", Z, oe = 0;
      for (Z = x.index; Z < b.length; Z++) {
        switch (b.charCodeAt(Z)) {
          case 34:
            S = "&quot;";
            break;
          case 38:
            S = "&amp;";
            break;
          case 39:
            S = "&#x27;";
            break;
          case 60:
            S = "&lt;";
            break;
          case 62:
            S = "&gt;";
            break;
          default:
            continue;
        }
        oe !== Z && (H += b.substring(oe, Z)), oe = Z + 1, H += S;
      }
      return oe !== Z ? H + b.substring(oe, Z) : H;
    }
    function Cr(h) {
      return typeof h == "boolean" || typeof h == "number" ? "" + h : vi(h);
    }
    var ca = /([A-Z])/g, da = /^ms-/;
    function pa(h) {
      return h.replace(ca, "-$1").toLowerCase().replace(da, "-ms-");
    }
    var Lr = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, Ln = !1;
    function ha(h) {
      !Ln && Lr.test(h) && (Ln = !0, n("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(h)));
    }
    var Ji = Array.isArray;
    function te(h) {
      return Ji(h);
    }
    var $e = "<script>", tt = "<\/script>", Et = '<script src="', Vt = '<script type="module" src="', Rt = '" async=""><\/script>';
    function Gt(h) {
      return N(h), ("" + h).replace(Lt, Mr);
    }
    var Lt = /(<\/|<)(s)(cript)/gi, Mr = function(h, b, x, S) {
      return "" + b + (x === "s" ? "\\u0073" : "\\u0053") + S;
    };
    function ar(h, b, x, S, H) {
      var Z = h === void 0 ? "" : h, oe = b === void 0 ? $e : '<script nonce="' + Cr(b) + '">', De = [];
      if (x !== void 0 && De.push(oe, Gt(x), tt), S !== void 0)
        for (var je = 0; je < S.length; je++)
          De.push(Et, Cr(S[je]), Rt);
      if (H !== void 0)
        for (var ct = 0; ct < H.length; ct++)
          De.push(Vt, Cr(H[ct]), Rt);
      return {
        bootstrapChunks: De,
        startInlineScript: oe,
        placeholderPrefix: Z + "P:",
        segmentPrefix: Z + "S:",
        boundaryPrefix: Z + "B:",
        idPrefix: Z,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
      };
    }
    var or = 0, dr = 1, Si = 2, hn = 3, jr = 4, Hr = 5, fn = 6, Ii = 7;
    function fi(h, b) {
      return {
        insertionMode: h,
        selectedValue: b
      };
    }
    function Fa(h, b, x) {
      switch (b) {
        case "select":
          return fi(dr, x.value != null ? x.value : x.defaultValue);
        case "svg":
          return fi(Si, null);
        case "math":
          return fi(hn, null);
        case "foreignObject":
          return fi(dr, null);
        case "table":
          return fi(jr, null);
        case "thead":
        case "tbody":
        case "tfoot":
          return fi(Hr, null);
        case "colgroup":
          return fi(Ii, null);
        case "tr":
          return fi(fn, null);
      }
      return h.insertionMode >= jr || h.insertionMode === or ? fi(dr, null) : h;
    }
    var gi = null;
    function gn(h) {
      var b = h.nextSuspenseID++;
      return h.boundaryPrefix + b.toString(16);
    }
    function Bi(h, b, x) {
      var S = h.idPrefix, H = ":" + S + "R" + b;
      return x > 0 && (H += "H" + x.toString(32)), H + ":";
    }
    function _n(h) {
      return Cr(h);
    }
    var Mn = "<!-- -->";
    function to(h, b, x, S) {
      return b === "" ? S : (S && h.push(Mn), h.push(_n(b)), !0);
    }
    function ro(h, b, x, S) {
      x && S && h.push(Mn);
    }
    var Dn = /* @__PURE__ */ new Map();
    function jn(h) {
      var b = Dn.get(h);
      if (b !== void 0)
        return b;
      var x = Cr(pa(h));
      return Dn.set(h, x), x;
    }
    var yn = ' style="', fa = ":", ga = ";";
    function E(h, b, x) {
      if (typeof x != "object")
        throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      var S = !0;
      for (var H in x)
        if (P.call(x, H)) {
          var Z = x[H];
          if (!(Z == null || typeof Z == "boolean" || Z === "")) {
            var oe = void 0, De = void 0, je = H.indexOf("--") === 0;
            je ? (oe = Cr(H), T(Z, H), De = Cr(("" + Z).trim())) : (yi(H, Z), oe = jn(H), typeof Z == "number" ? Z !== 0 && !P.call(Ze, H) ? De = Z + "px" : De = "" + Z : (T(Z, H), De = Cr(("" + Z).trim()))), S ? (S = !1, h.push(yn, oe, fa, De)) : h.push(ga, oe, fa, De);
          }
        }
      S || h.push(q);
    }
    var I = " ", V = '="', q = '"', ve = '=""';
    function ce(h, b, x, S) {
      switch (x) {
        case "style": {
          E(h, b, S);
          return;
        }
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
          return;
      }
      if (
        // shouldIgnoreAttribute
        // We have already filtered out null/undefined and reserved words.
        !(x.length > 2 && (x[0] === "o" || x[0] === "O") && (x[1] === "n" || x[1] === "N"))
      ) {
        var H = L(x);
        if (H !== null) {
          switch (typeof S) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              if (!H.acceptsBooleans)
                return;
          }
          var Z = H.attributeName, oe = Z;
          switch (H.type) {
            case U:
              S && h.push(I, oe, ve);
              return;
            case K:
              S === !0 ? h.push(I, oe, ve) : S === !1 || h.push(I, oe, V, Cr(S), q);
              return;
            case z:
              isNaN(S) || h.push(I, oe, V, Cr(S), q);
              break;
            case j:
              !isNaN(S) && S >= 1 && h.push(I, oe, V, Cr(S), q);
              break;
            default:
              H.sanitizeURL && (A(S, Z), S = "" + S, ha(S)), h.push(I, oe, V, Cr(S), q);
          }
        } else if (Ee(x)) {
          switch (typeof S) {
            case "function":
            case "symbol":
              return;
            case "boolean": {
              var De = x.toLowerCase().slice(0, 5);
              if (De !== "data-" && De !== "aria-")
                return;
            }
          }
          h.push(I, x, V, Cr(S), q);
        }
      }
    }
    var Ae = ">", Ve = "/>";
    function dt(h, b, x) {
      if (b != null) {
        if (x != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof b != "object" || !("__html" in b))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var S = b.__html;
        S != null && (N(S), h.push("" + S));
      }
    }
    var yt = !1, Dt = !1, rr = !1, Zr = !1, Ei = !1, Ci = !1, En = !1;
    function en(h, b) {
      {
        var x = h[b];
        if (x != null) {
          var S = te(x);
          h.multiple && !S ? n("The `%s` prop supplied to <select> must be an array if `multiple` is true.", b) : !h.multiple && S && n("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", b);
        }
      }
    }
    function Ta(h, b, x) {
      At("select", b), en(b, "value"), en(b, "defaultValue"), b.value !== void 0 && b.defaultValue !== void 0 && !rr && (n("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), rr = !0), h.push(ji("select"));
      var S = null, H = null;
      for (var Z in b)
        if (P.call(b, Z)) {
          var oe = b[Z];
          if (oe == null)
            continue;
          switch (Z) {
            case "children":
              S = oe;
              break;
            case "dangerouslySetInnerHTML":
              H = oe;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              ce(h, x, Z, oe);
              break;
          }
        }
      return h.push(Ae), dt(h, H, S), S;
    }
    function Ri(h) {
      var b = "";
      return e.Children.forEach(h, function(x) {
        x != null && (b += x, !Ei && typeof x != "string" && typeof x != "number" && (Ei = !0, n("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }), b;
    }
    var Hn = ' selected=""';
    function Cn(h, b, x, S) {
      var H = S.selectedValue;
      h.push(ji("option"));
      var Z = null, oe = null, De = null, je = null;
      for (var ct in b)
        if (P.call(b, ct)) {
          var kt = b[ct];
          if (kt == null)
            continue;
          switch (ct) {
            case "children":
              Z = kt;
              break;
            case "selected":
              De = kt, En || (n("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), En = !0);
              break;
            case "dangerouslySetInnerHTML":
              je = kt;
              break;
            case "value":
              oe = kt;
            default:
              ce(h, x, ct, kt);
              break;
          }
        }
      if (H != null) {
        var Mt;
        if (oe !== null ? (A(oe, "value"), Mt = "" + oe) : (je !== null && (Ci || (Ci = !0, n("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."))), Mt = Ri(Z)), te(H))
          for (var Kr = 0; Kr < H.length; Kr++) {
            A(H[Kr], "value");
            var Ui = "" + H[Kr];
            if (Ui === Mt) {
              h.push(Hn);
              break;
            }
          }
        else
          A(H, "select.value"), "" + H === Mt && h.push(Hn);
      } else
        De && h.push(Hn);
      return h.push(Ae), dt(h, je, Z), Z;
    }
    function $n(h, b, x) {
      At("input", b), b.checked !== void 0 && b.defaultChecked !== void 0 && !Dt && (n("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", b.type), Dt = !0), b.value !== void 0 && b.defaultValue !== void 0 && !yt && (n("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", b.type), yt = !0), h.push(ji("input"));
      var S = null, H = null, Z = null, oe = null;
      for (var De in b)
        if (P.call(b, De)) {
          var je = b[De];
          if (je == null)
            continue;
          switch (De) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            case "defaultChecked":
              oe = je;
              break;
            case "defaultValue":
              H = je;
              break;
            case "checked":
              Z = je;
              break;
            case "value":
              S = je;
              break;
            default:
              ce(h, x, De, je);
              break;
          }
        }
      return Z !== null ? ce(h, x, "checked", Z) : oe !== null && ce(h, x, "checked", oe), S !== null ? ce(h, x, "value", S) : H !== null && ce(h, x, "value", H), h.push(Ve), null;
    }
    function Jl(h, b, x) {
      At("textarea", b), b.value !== void 0 && b.defaultValue !== void 0 && !Zr && (n("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Zr = !0), h.push(ji("textarea"));
      var S = null, H = null, Z = null;
      for (var oe in b)
        if (P.call(b, oe)) {
          var De = b[oe];
          if (De == null)
            continue;
          switch (oe) {
            case "children":
              Z = De;
              break;
            case "value":
              S = De;
              break;
            case "defaultValue":
              H = De;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
            default:
              ce(h, x, oe, De);
              break;
          }
        }
      if (S === null && H !== null && (S = H), h.push(Ae), Z != null) {
        if (n("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), S != null)
          throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
        if (te(Z)) {
          if (Z.length > 1)
            throw new Error("<textarea> can only have at most one child.");
          N(Z[0]), S = "" + Z[0];
        }
        N(Z), S = "" + Z;
      }
      return typeof S == "string" && S[0] === `
` && h.push(xn), S !== null && (A(S, "value"), h.push(_n("" + S))), null;
    }
    function ps(h, b, x, S) {
      h.push(ji(x));
      for (var H in b)
        if (P.call(b, H)) {
          var Z = b[H];
          if (Z == null)
            continue;
          switch (H) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error(x + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            default:
              ce(h, S, H, Z);
              break;
          }
        }
      return h.push(Ve), null;
    }
    function hs(h, b, x) {
      h.push(ji("menuitem"));
      for (var S in b)
        if (P.call(b, S)) {
          var H = b[S];
          if (H == null)
            continue;
          switch (S) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");
            default:
              ce(h, x, S, H);
              break;
          }
        }
      return h.push(Ae), null;
    }
    function Ks(h, b, x) {
      h.push(ji("title"));
      var S = null;
      for (var H in b)
        if (P.call(b, H)) {
          var Z = b[H];
          if (Z == null)
            continue;
          switch (H) {
            case "children":
              S = Z;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");
            default:
              ce(h, x, H, Z);
              break;
          }
        }
      h.push(Ae);
      {
        var oe = Array.isArray(S) && S.length < 2 ? S[0] || null : S;
        Array.isArray(S) && S.length > 1 ? n("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : oe != null && oe.$$typeof != null ? n("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : oe != null && typeof oe != "string" && typeof oe != "number" && n("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
      }
      return S;
    }
    function Fo(h, b, x, S) {
      h.push(ji(x));
      var H = null, Z = null;
      for (var oe in b)
        if (P.call(b, oe)) {
          var De = b[oe];
          if (De == null)
            continue;
          switch (oe) {
            case "children":
              H = De;
              break;
            case "dangerouslySetInnerHTML":
              Z = De;
              break;
            default:
              ce(h, S, oe, De);
              break;
          }
        }
      return h.push(Ae), dt(h, Z, H), typeof H == "string" ? (h.push(_n(H)), null) : H;
    }
    function mn(h, b, x, S) {
      h.push(ji(x));
      var H = null, Z = null;
      for (var oe in b)
        if (P.call(b, oe)) {
          var De = b[oe];
          if (De == null)
            continue;
          switch (oe) {
            case "children":
              H = De;
              break;
            case "dangerouslySetInnerHTML":
              Z = De;
              break;
            case "style":
              E(h, S, De);
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
              break;
            default:
              Ee(oe) && typeof De != "function" && typeof De != "symbol" && h.push(I, oe, V, Cr(De), q);
              break;
          }
        }
      return h.push(Ae), dt(h, Z, H), H;
    }
    var xn = `
`;
    function io(h, b, x, S) {
      h.push(ji(x));
      var H = null, Z = null;
      for (var oe in b)
        if (P.call(b, oe)) {
          var De = b[oe];
          if (De == null)
            continue;
          switch (oe) {
            case "children":
              H = De;
              break;
            case "dangerouslySetInnerHTML":
              Z = De;
              break;
            default:
              ce(h, S, oe, De);
              break;
          }
        }
      if (h.push(Ae), Z != null) {
        if (H != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof Z != "object" || !("__html" in Z))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var je = Z.__html;
        je != null && (typeof je == "string" && je.length > 0 && je[0] === `
` ? h.push(xn, je) : (N(je), h.push("" + je)));
      }
      return typeof H == "string" && H[0] === `
` && h.push(xn), H;
    }
    var br = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Un = /* @__PURE__ */ new Map();
    function ji(h) {
      var b = Un.get(h);
      if (b === void 0) {
        if (!br.test(h))
          throw new Error("Invalid tag: " + h);
        b = "<" + h, Un.set(h, b);
      }
      return b;
    }
    var Y = "<!DOCTYPE html>";
    function le(h, b, x, S, H) {
      switch (ne(b, x), Fe(b, x), xt(b, x, null), !x.suppressContentEditableWarning && x.contentEditable && x.children != null && n("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), H.insertionMode !== Si && H.insertionMode !== hn && b.indexOf("-") === -1 && typeof x.is != "string" && b.toLowerCase() !== b && n("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", b), b) {
        case "select":
          return Ta(h, x, S);
        case "option":
          return Cn(h, x, S, H);
        case "textarea":
          return Jl(h, x, S);
        case "input":
          return $n(h, x, S);
        case "menuitem":
          return hs(h, x, S);
        case "title":
          return Ks(h, x, S);
        case "listing":
        case "pre":
          return io(h, x, b, S);
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          return ps(h, x, b, S);
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return Fo(h, x, b, S);
        case "html":
          return H.insertionMode === or && h.push(Y), Fo(h, x, b, S);
        default:
          return b.indexOf("-") === -1 && typeof x.is != "string" ? Fo(h, x, b, S) : mn(h, x, b, S);
      }
    }
    var Pe = "</", it = ">";
    function Zt(h, b, x) {
      switch (b) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          h.push(Pe, b, it);
      }
    }
    function Pt(h, b) {
      for (var x = b.bootstrapChunks, S = 0; S < x.length - 1; S++)
        l(h, x[S]);
      return S < x.length ? u(h, x[S]) : !0;
    }
    var xr = '<template id="', ai = '"></template>';
    function hi(h, b, x) {
      l(h, xr), l(h, b.placeholderPrefix);
      var S = x.toString(16);
      return l(h, S), u(h, ai);
    }
    var Ar = "<!--$-->", Hi = '<!--$?--><template id="', tn = '"></template>', oi = "<!--$!-->", xi = "<!--/$-->", Ai = "<template", Ki = '"', An = ' data-dgst="', rn = ' data-msg="', To = ' data-stck="', Sa = "></template>";
    function wn(h, b) {
      return u(h, Ar);
    }
    function So(h, b, x) {
      if (l(h, Hi), x === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return l(h, x), u(h, tn);
    }
    function Ys(h, b, x, S, H) {
      var Z;
      return Z = u(h, oi), l(h, Ai), x && (l(h, An), l(h, Cr(x)), l(h, Ki)), S && (l(h, rn), l(h, Cr(S)), l(h, Ki)), H && (l(h, To), l(h, Cr(H)), l(h, Ki)), Z = u(h, Sa), Z;
    }
    function mc(h, b) {
      return u(h, xi);
    }
    function eu(h, b) {
      return u(h, xi);
    }
    function vc(h, b) {
      return u(h, xi);
    }
    var qs = '<div hidden id="', nn = '">', kc = "</div>", Qs = '<svg aria-hidden="true" style="display:none" id="', bp = '">', bc = "</svg>", Xs = '<math aria-hidden="true" style="display:none" id="', _c = '">', Dc = "</math>", Zs = '<table hidden id="', Js = '">', yc = "</table>", Ec = '<table hidden><tbody id="', Cc = '">', tu = "</tbody></table>", xc = '<table hidden><tr id="', C = '">', R = "</tr></table>", $ = '<table hidden><colgroup id="', Q = '">', be = "</colgroup></table>";
    function fe(h, b, x, S) {
      switch (x.insertionMode) {
        case or:
        case dr:
          return l(h, qs), l(h, b.segmentPrefix), l(h, S.toString(16)), u(h, nn);
        case Si:
          return l(h, Qs), l(h, b.segmentPrefix), l(h, S.toString(16)), u(h, bp);
        case hn:
          return l(h, Xs), l(h, b.segmentPrefix), l(h, S.toString(16)), u(h, _c);
        case jr:
          return l(h, Zs), l(h, b.segmentPrefix), l(h, S.toString(16)), u(h, Js);
        case Hr:
          return l(h, Ec), l(h, b.segmentPrefix), l(h, S.toString(16)), u(h, Cc);
        case fn:
          return l(h, xc), l(h, b.segmentPrefix), l(h, S.toString(16)), u(h, C);
        case Ii:
          return l(h, $), l(h, b.segmentPrefix), l(h, S.toString(16)), u(h, Q);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    function Be(h, b) {
      switch (b.insertionMode) {
        case or:
        case dr:
          return u(h, kc);
        case Si:
          return u(h, bc);
        case hn:
          return u(h, Dc);
        case jr:
          return u(h, yc);
        case Hr:
          return u(h, tu);
        case fn:
          return u(h, R);
        case Ii:
          return u(h, be);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    var Ke = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}", Tt = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}', Yt = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}', Wt = Ke + ';$RS("', Or = '$RS("', an = '","', Fn = '")<\/script>';
    function Tn(h, b, x) {
      l(h, b.startInlineScript), b.sentCompleteSegmentFunction ? l(h, Or) : (b.sentCompleteSegmentFunction = !0, l(h, Wt)), l(h, b.segmentPrefix);
      var S = x.toString(16);
      return l(h, S), l(h, an), l(h, b.placeholderPrefix), l(h, S), u(h, Fn);
    }
    var el = Tt + ';$RC("', Ac = '$RC("', ru = '","', tv = '")<\/script>';
    function rv(h, b, x, S) {
      if (l(h, b.startInlineScript), b.sentCompleteBoundaryFunction ? l(h, Ac) : (b.sentCompleteBoundaryFunction = !0, l(h, el)), x === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      var H = S.toString(16);
      return l(h, x), l(h, ru), l(h, b.segmentPrefix), l(h, H), u(h, tv);
    }
    var iv = Yt + ';$RX("', nv = '$RX("', av = '"', ov = ")<\/script>", _p = ",";
    function sv(h, b, x, S, H, Z) {
      if (l(h, b.startInlineScript), b.sentClientRenderFunction ? l(h, nv) : (b.sentClientRenderFunction = !0, l(h, iv)), x === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return l(h, x), l(h, av), (S || H || Z) && (l(h, _p), l(h, Dp(S || ""))), (H || Z) && (l(h, _p), l(h, Dp(H || ""))), Z && (l(h, _p), l(h, Dp(Z))), u(h, ov);
    }
    var lv = /[<\u2028\u2029]/g;
    function Dp(h) {
      var b = JSON.stringify(h);
      return b.replace(lv, function(x) {
        switch (x) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
      });
    }
    function uv(h, b) {
      var x = ar(b, void 0);
      return {
        // Keep this in sync with ReactDOMServerFormatConfig
        bootstrapChunks: x.bootstrapChunks,
        startInlineScript: x.startInlineScript,
        placeholderPrefix: x.placeholderPrefix,
        segmentPrefix: x.segmentPrefix,
        boundaryPrefix: x.boundaryPrefix,
        idPrefix: x.idPrefix,
        nextSuspenseID: x.nextSuspenseID,
        sentCompleteSegmentFunction: x.sentCompleteSegmentFunction,
        sentCompleteBoundaryFunction: x.sentCompleteBoundaryFunction,
        sentClientRenderFunction: x.sentClientRenderFunction,
        // This is an extra field for the legacy renderer
        generateStaticMarkup: h
      };
    }
    function yp() {
      return {
        insertionMode: dr,
        // We skip the root mode because we don't want to emit the DOCTYPE in legacy mode.
        selectedValue: null
      };
    }
    function ih(h, b, x, S) {
      return x.generateStaticMarkup ? (h.push(Cr(b)), !1) : to(h, b, x, S);
    }
    function nh(h, b, x, S) {
      if (!b.generateStaticMarkup)
        return ro(h, b, x, S);
    }
    function Ep(h, b) {
      return b.generateStaticMarkup ? !0 : wn(h);
    }
    function Vn(h, b, x, S, H) {
      return b.generateStaticMarkup ? !0 : Ys(h, b, x, S, H);
    }
    function cv(h, b) {
      return b.generateStaticMarkup ? !0 : mc(h);
    }
    function ah(h, b) {
      return b.generateStaticMarkup ? !0 : vc(h);
    }
    var Sn = Object.assign, oh = Symbol.for("react.element"), Cp = Symbol.for("react.portal"), wc = Symbol.for("react.fragment"), Fc = Symbol.for("react.strict_mode"), Tc = Symbol.for("react.profiler"), iu = Symbol.for("react.provider"), nu = Symbol.for("react.context"), au = Symbol.for("react.forward_ref"), tl = Symbol.for("react.suspense"), xp = Symbol.for("react.suspense_list"), Ap = Symbol.for("react.memo"), Sc = Symbol.for("react.lazy"), dv = Symbol.for("react.scope"), sh = Symbol.for("react.debug_trace_mode"), pv = Symbol.for("react.legacy_hidden"), hv = Symbol.for("react.default_value"), lh = Symbol.iterator, uh = "@@iterator";
    function si(h) {
      if (h === null || typeof h != "object")
        return null;
      var b = lh && h[lh] || h[uh];
      return typeof b == "function" ? b : null;
    }
    function ou(h, b, x) {
      var S = h.displayName;
      if (S)
        return S;
      var H = b.displayName || b.name || "";
      return H !== "" ? x + "(" + H + ")" : x;
    }
    function wp(h) {
      return h.displayName || "Context";
    }
    function Jr(h) {
      if (h == null)
        return null;
      if (typeof h.tag == "number" && n("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof h == "function")
        return h.displayName || h.name || null;
      if (typeof h == "string")
        return h;
      switch (h) {
        case wc:
          return "Fragment";
        case Cp:
          return "Portal";
        case Tc:
          return "Profiler";
        case Fc:
          return "StrictMode";
        case tl:
          return "Suspense";
        case xp:
          return "SuspenseList";
      }
      if (typeof h == "object")
        switch (h.$$typeof) {
          case nu:
            var b = h;
            return wp(b) + ".Consumer";
          case iu:
            var x = h;
            return wp(x._context) + ".Provider";
          case au:
            return ou(h, h.render, "ForwardRef");
          case Ap:
            var S = h.displayName || null;
            return S !== null ? S : Jr(h.type) || "Memo";
          case Sc: {
            var H = h, Z = H._payload, oe = H._init;
            try {
              return Jr(oe(Z));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var rl = 0, Fp, Tp, Sp, Ip, Bp, ch, dh;
    function Ic() {
    }
    Ic.__reactDisabledLog = !0;
    function Rp() {
      {
        if (rl === 0) {
          Fp = console.log, Tp = console.info, Sp = console.warn, Ip = console.error, Bp = console.group, ch = console.groupCollapsed, dh = console.groupEnd;
          var h = {
            configurable: !0,
            enumerable: !0,
            value: Ic,
            writable: !0
          };
          Object.defineProperties(console, {
            info: h,
            log: h,
            warn: h,
            error: h,
            group: h,
            groupCollapsed: h,
            groupEnd: h
          });
        }
        rl++;
      }
    }
    function su() {
      {
        if (rl--, rl === 0) {
          var h = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Sn({}, h, {
              value: Fp
            }),
            info: Sn({}, h, {
              value: Tp
            }),
            warn: Sn({}, h, {
              value: Sp
            }),
            error: Sn({}, h, {
              value: Ip
            }),
            group: Sn({}, h, {
              value: Bp
            }),
            groupCollapsed: Sn({}, h, {
              value: ch
            }),
            groupEnd: Sn({}, h, {
              value: dh
            })
          });
        }
        rl < 0 && n("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var lu = r.ReactCurrentDispatcher, il;
    function uu(h, b, x) {
      {
        if (il === void 0)
          try {
            throw Error();
          } catch (H) {
            var S = H.stack.trim().match(/\n( *(at )?)/);
            il = S && S[1] || "";
          }
        return `
` + il + h;
      }
    }
    var cu = !1, Bc;
    {
      var ph = typeof WeakMap == "function" ? WeakMap : Map;
      Bc = new ph();
    }
    function Op(h, b) {
      if (!h || cu)
        return "";
      {
        var x = Bc.get(h);
        if (x !== void 0)
          return x;
      }
      var S;
      cu = !0;
      var H = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Z;
      Z = lu.current, lu.current = null, Rp();
      try {
        if (b) {
          var oe = function() {
            throw Error();
          };
          if (Object.defineProperty(oe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(oe, []);
            } catch (Yn) {
              S = Yn;
            }
            Reflect.construct(h, [], oe);
          } else {
            try {
              oe.call();
            } catch (Yn) {
              S = Yn;
            }
            h.call(oe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Yn) {
            S = Yn;
          }
          h();
        }
      } catch (Yn) {
        if (Yn && S && typeof Yn.stack == "string") {
          for (var De = Yn.stack.split(`
`), je = S.stack.split(`
`), ct = De.length - 1, kt = je.length - 1; ct >= 1 && kt >= 0 && De[ct] !== je[kt]; )
            kt--;
          for (; ct >= 1 && kt >= 0; ct--, kt--)
            if (De[ct] !== je[kt]) {
              if (ct !== 1 || kt !== 1)
                do
                  if (ct--, kt--, kt < 0 || De[ct] !== je[kt]) {
                    var Mt = `
` + De[ct].replace(" at new ", " at ");
                    return h.displayName && Mt.includes("<anonymous>") && (Mt = Mt.replace("<anonymous>", h.displayName)), typeof h == "function" && Bc.set(h, Mt), Mt;
                  }
                while (ct >= 1 && kt >= 0);
              break;
            }
        }
      } finally {
        cu = !1, lu.current = Z, su(), Error.prepareStackTrace = H;
      }
      var Kr = h ? h.displayName || h.name : "", Ui = Kr ? uu(Kr) : "";
      return typeof h == "function" && Bc.set(h, Ui), Ui;
    }
    function Pp(h, b, x) {
      return Op(h, !0);
    }
    function Np(h, b, x) {
      return Op(h, !1);
    }
    function hh(h) {
      var b = h.prototype;
      return !!(b && b.isReactComponent);
    }
    function nl(h, b, x) {
      if (h == null)
        return "";
      if (typeof h == "function")
        return Op(h, hh(h));
      if (typeof h == "string")
        return uu(h);
      switch (h) {
        case tl:
          return uu("Suspense");
        case xp:
          return uu("SuspenseList");
      }
      if (typeof h == "object")
        switch (h.$$typeof) {
          case au:
            return Np(h.render);
          case Ap:
            return nl(h.type, b, x);
          case Sc: {
            var S = h, H = S._payload, Z = S._init;
            try {
              return nl(Z(H), b, x);
            } catch {
            }
          }
        }
      return "";
    }
    var zp = {}, Rc = r.ReactDebugCurrentFrame;
    function fs(h) {
      if (h) {
        var b = h._owner, x = nl(h.type, h._source, b ? b.type : null);
        Rc.setExtraStackFrame(x);
      } else
        Rc.setExtraStackFrame(null);
    }
    function Lp(h, b, x, S, H) {
      {
        var Z = Function.call.bind(P);
        for (var oe in h)
          if (Z(h, oe)) {
            var De = void 0;
            try {
              if (typeof h[oe] != "function") {
                var je = Error((S || "React class") + ": " + x + " type `" + oe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof h[oe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw je.name = "Invariant Violation", je;
              }
              De = h[oe](b, oe, S, x, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ct) {
              De = ct;
            }
            De && !(De instanceof Error) && (fs(H), n("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", S || "React class", x, oe, typeof De), fs(null)), De instanceof Error && !(De.message in zp) && (zp[De.message] = !0, fs(H), n("Failed %s type: %s", x, De.message), fs(null));
          }
      }
    }
    var Mp;
    Mp = {};
    var Io = {};
    Object.freeze(Io);
    function fh(h, b) {
      {
        var x = h.contextTypes;
        if (!x)
          return Io;
        var S = {};
        for (var H in x)
          S[H] = b[H];
        {
          var Z = Jr(h) || "Unknown";
          Lp(x, S, "context", Z);
        }
        return S;
      }
    }
    function gs(h, b, x, S) {
      {
        if (typeof h.getChildContext != "function") {
          {
            var H = Jr(b) || "Unknown";
            Mp[H] || (Mp[H] = !0, n("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", H, H));
          }
          return x;
        }
        var Z = h.getChildContext();
        for (var oe in Z)
          if (!(oe in S))
            throw new Error((Jr(b) || "Unknown") + '.getChildContext(): key "' + oe + '" is not defined in childContextTypes.');
        {
          var De = Jr(b) || "Unknown";
          Lp(S, Z, "child context", De);
        }
        return Sn({}, x, Z);
      }
    }
    var ms;
    ms = {};
    var jp = null, Ia = null;
    function Oc(h) {
      h.context._currentValue2 = h.parentValue;
    }
    function Pc(h) {
      h.context._currentValue2 = h.value;
    }
    function du(h, b) {
      if (h !== b) {
        Oc(h);
        var x = h.parent, S = b.parent;
        if (x === null) {
          if (S !== null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
        } else {
          if (S === null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
          du(x, S);
        }
        Pc(b);
      }
    }
    function Hp(h) {
      Oc(h);
      var b = h.parent;
      b !== null && Hp(b);
    }
    function pu(h) {
      var b = h.parent;
      b !== null && pu(b), Pc(h);
    }
    function gh(h, b) {
      Oc(h);
      var x = h.parent;
      if (x === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      x.depth === b.depth ? du(x, b) : gh(x, b);
    }
    function mh(h, b) {
      var x = b.parent;
      if (x === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      h.depth === x.depth ? du(h, x) : mh(h, x), Pc(b);
    }
    function Nc(h) {
      var b = Ia, x = h;
      b !== x && (b === null ? pu(x) : x === null ? Hp(b) : b.depth === x.depth ? du(b, x) : b.depth > x.depth ? gh(b, x) : mh(b, x), Ia = x);
    }
    function hu(h, b) {
      var x;
      x = h._currentValue2, h._currentValue2 = b, h._currentRenderer2 !== void 0 && h._currentRenderer2 !== null && h._currentRenderer2 !== ms && n("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), h._currentRenderer2 = ms;
      var S = Ia, H = {
        parent: S,
        depth: S === null ? 0 : S.depth + 1,
        context: h,
        parentValue: x,
        value: b
      };
      return Ia = H, H;
    }
    function $p(h) {
      var b = Ia;
      if (b === null)
        throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
      b.context !== h && n("The parent context is not the expected context. This is probably a bug in React.");
      {
        var x = b.parentValue;
        x === hv ? b.context._currentValue2 = b.context._defaultValue : b.context._currentValue2 = x, h._currentRenderer2 !== void 0 && h._currentRenderer2 !== null && h._currentRenderer2 !== ms && n("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), h._currentRenderer2 = ms;
      }
      return Ia = b.parent;
    }
    function fv() {
      return Ia;
    }
    function al(h) {
      var b = h._currentValue2;
      return b;
    }
    function zc(h) {
      return h._reactInternals;
    }
    function Up(h, b) {
      h._reactInternals = b;
    }
    var Lc = {}, Mc = {}, fu, jc, ol, gu, Hc, sl, $c, Uc, Vc;
    {
      fu = /* @__PURE__ */ new Set(), jc = /* @__PURE__ */ new Set(), ol = /* @__PURE__ */ new Set(), $c = /* @__PURE__ */ new Set(), gu = /* @__PURE__ */ new Set(), Uc = /* @__PURE__ */ new Set(), Vc = /* @__PURE__ */ new Set();
      var vh = /* @__PURE__ */ new Set();
      sl = function(h, b) {
        if (!(h === null || typeof h == "function")) {
          var x = b + "_" + h;
          vh.has(x) || (vh.add(x), n("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", b, h));
        }
      }, Hc = function(h, b) {
        if (b === void 0) {
          var x = Jr(h) || "Component";
          gu.has(x) || (gu.add(x), n("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", x));
        }
      };
    }
    function kh(h, b) {
      {
        var x = h.constructor, S = x && Jr(x) || "ReactClass", H = S + "." + b;
        if (Lc[H])
          return;
        n(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, b, b, S), Lc[H] = !0;
      }
    }
    var bh = {
      isMounted: function(h) {
        return !1;
      },
      enqueueSetState: function(h, b, x) {
        var S = zc(h);
        S.queue === null ? kh(h, "setState") : (S.queue.push(b), x != null && sl(x, "setState"));
      },
      enqueueReplaceState: function(h, b, x) {
        var S = zc(h);
        S.replace = !0, S.queue = [b], x != null && sl(x, "setState");
      },
      enqueueForceUpdate: function(h, b) {
        var x = zc(h);
        x.queue === null ? kh(h, "forceUpdate") : b != null && sl(b, "setState");
      }
    };
    function gv(h, b, x, S, H) {
      var Z = x(H, S);
      Hc(b, Z);
      var oe = Z == null ? S : Sn({}, S, Z);
      return oe;
    }
    function mv(h, b, x) {
      var S = Io, H = h.contextType;
      if ("contextType" in h) {
        var Z = (
          // Allow null for conditional declaration
          H === null || H !== void 0 && H.$$typeof === nu && H._context === void 0
        );
        if (!Z && !Vc.has(h)) {
          Vc.add(h);
          var oe = "";
          H === void 0 ? oe = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof H != "object" ? oe = " However, it is set to a " + typeof H + "." : H.$$typeof === iu ? oe = " Did you accidentally pass the Context.Provider instead?" : H._context !== void 0 ? oe = " Did you accidentally pass the Context.Consumer instead?" : oe = " However, it is set to an object with keys {" + Object.keys(H).join(", ") + "}.", n("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Jr(h) || "Component", oe);
        }
      }
      typeof H == "object" && H !== null ? S = al(H) : S = x;
      var De = new h(b, S);
      {
        if (typeof h.getDerivedStateFromProps == "function" && (De.state === null || De.state === void 0)) {
          var je = Jr(h) || "Component";
          fu.has(je) || (fu.add(je), n("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", je, De.state === null ? "null" : "undefined", je));
        }
        if (typeof h.getDerivedStateFromProps == "function" || typeof De.getSnapshotBeforeUpdate == "function") {
          var ct = null, kt = null, Mt = null;
          if (typeof De.componentWillMount == "function" && De.componentWillMount.__suppressDeprecationWarning !== !0 ? ct = "componentWillMount" : typeof De.UNSAFE_componentWillMount == "function" && (ct = "UNSAFE_componentWillMount"), typeof De.componentWillReceiveProps == "function" && De.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? kt = "componentWillReceiveProps" : typeof De.UNSAFE_componentWillReceiveProps == "function" && (kt = "UNSAFE_componentWillReceiveProps"), typeof De.componentWillUpdate == "function" && De.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Mt = "componentWillUpdate" : typeof De.UNSAFE_componentWillUpdate == "function" && (Mt = "UNSAFE_componentWillUpdate"), ct !== null || kt !== null || Mt !== null) {
            var Kr = Jr(h) || "Component", Ui = typeof h.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            ol.has(Kr) || (ol.add(Kr), n(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, Kr, Ui, ct !== null ? `
  ` + ct : "", kt !== null ? `
  ` + kt : "", Mt !== null ? `
  ` + Mt : ""));
          }
        }
      }
      return De;
    }
    function _h(h, b, x) {
      {
        var S = Jr(b) || "Component", H = h.render;
        H || (b.prototype && typeof b.prototype.render == "function" ? n("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", S) : n("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", S)), h.getInitialState && !h.getInitialState.isReactClassApproved && !h.state && n("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", S), h.getDefaultProps && !h.getDefaultProps.isReactClassApproved && n("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", S), h.propTypes && n("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", S), h.contextType && n("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", S), h.contextTypes && n("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", S), b.contextType && b.contextTypes && !Uc.has(b) && (Uc.add(b), n("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", S)), typeof h.componentShouldUpdate == "function" && n("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", S), b.prototype && b.prototype.isPureReactComponent && typeof h.shouldComponentUpdate < "u" && n("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Jr(b) || "A pure component"), typeof h.componentDidUnmount == "function" && n("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", S), typeof h.componentDidReceiveProps == "function" && n("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", S), typeof h.componentWillRecieveProps == "function" && n("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", S), typeof h.UNSAFE_componentWillRecieveProps == "function" && n("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", S);
        var Z = h.props !== x;
        h.props !== void 0 && Z && n("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", S, S), h.defaultProps && n("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", S, S), typeof h.getSnapshotBeforeUpdate == "function" && typeof h.componentDidUpdate != "function" && !jc.has(b) && (jc.add(b), n("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Jr(b))), typeof h.getDerivedStateFromProps == "function" && n("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", S), typeof h.getDerivedStateFromError == "function" && n("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", S), typeof b.getSnapshotBeforeUpdate == "function" && n("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", S);
        var oe = h.state;
        oe && (typeof oe != "object" || te(oe)) && n("%s.state: must be set to an object or null", S), typeof h.getChildContext == "function" && typeof b.childContextTypes != "object" && n("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", S);
      }
    }
    function vv(h, b) {
      var x = b.state;
      if (typeof b.componentWillMount == "function") {
        if (b.componentWillMount.__suppressDeprecationWarning !== !0) {
          var S = Jr(h) || "Unknown";
          Mc[S] || (i(
            // keep this warning in sync with ReactStrictModeWarning.js
            `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
            S
          ), Mc[S] = !0);
        }
        b.componentWillMount();
      }
      typeof b.UNSAFE_componentWillMount == "function" && b.UNSAFE_componentWillMount(), x !== b.state && (n("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Jr(h) || "Component"), bh.enqueueReplaceState(b, b.state, null));
    }
    function kv(h, b, x, S) {
      if (h.queue !== null && h.queue.length > 0) {
        var H = h.queue, Z = h.replace;
        if (h.queue = null, h.replace = !1, Z && H.length === 1)
          b.state = H[0];
        else {
          for (var oe = Z ? H[0] : b.state, De = !0, je = Z ? 1 : 0; je < H.length; je++) {
            var ct = H[je], kt = typeof ct == "function" ? ct.call(b, oe, x, S) : ct;
            kt != null && (De ? (De = !1, oe = Sn({}, oe, kt)) : Sn(oe, kt));
          }
          b.state = oe;
        }
      } else
        h.queue = null;
    }
    function Wc(h, b, x, S) {
      _h(h, b, x);
      var H = h.state !== void 0 ? h.state : null;
      h.updater = bh, h.props = x, h.state = H;
      var Z = {
        queue: [],
        replace: !1
      };
      Up(h, Z);
      var oe = b.contextType;
      if (typeof oe == "object" && oe !== null ? h.context = al(oe) : h.context = S, h.state === x) {
        var De = Jr(b) || "Component";
        $c.has(De) || ($c.add(De), n("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", De));
      }
      var je = b.getDerivedStateFromProps;
      typeof je == "function" && (h.state = gv(h, b, je, H, x)), typeof b.getDerivedStateFromProps != "function" && typeof h.getSnapshotBeforeUpdate != "function" && (typeof h.UNSAFE_componentWillMount == "function" || typeof h.componentWillMount == "function") && (vv(b, h), kv(Z, h, x, S));
    }
    var Gc = {
      id: 1,
      overflow: ""
    };
    function bv(h) {
      var b = h.overflow, x = h.id, S = x & ~_v(x);
      return S.toString(32) + b;
    }
    function Vp(h, b, x) {
      var S = h.id, H = h.overflow, Z = Kc(S) - 1, oe = S & ~(1 << Z), De = x + 1, je = Kc(b) + Z;
      if (je > 30) {
        var ct = Z - Z % 5, kt = (1 << ct) - 1, Mt = (oe & kt).toString(32), Kr = oe >> ct, Ui = Z - ct, Yn = Kc(b) + Ui, $h = De << Ui, Uh = $h | Kr, Vh = Mt + H;
        return {
          id: 1 << Yn | Uh,
          overflow: Vh
        };
      } else {
        var ud = De << Z, LT = ud | oe, MT = H;
        return {
          id: 1 << je | LT,
          overflow: MT
        };
      }
    }
    function Kc(h) {
      return 32 - Dv(h);
    }
    function _v(h) {
      return 1 << Kc(h) - 1;
    }
    var Dv = Math.clz32 ? Math.clz32 : no, yv = Math.log, Ev = Math.LN2;
    function no(h) {
      var b = h >>> 0;
      return b === 0 ? 32 : 31 - (yv(b) / Ev | 0) | 0;
    }
    function Wp(h, b) {
      return h === b && (h !== 0 || 1 / h === 1 / b) || h !== h && b !== b;
    }
    var Yc = typeof Object.is == "function" ? Object.is : Wp, sr = null, vs = null, ks = null, Dr = null, Wn = !1, bs = !1, qc = 0, $i = null, ao = 0, _s = 25, Ba = !1, Ds;
    function oo() {
      if (sr === null)
        throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return Ba && n("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks"), sr;
    }
    function Cv(h, b) {
      if (b === null)
        return n("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", Ds), !1;
      h.length !== b.length && n(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, Ds, "[" + h.join(", ") + "]", "[" + b.join(", ") + "]");
      for (var x = 0; x < b.length && x < h.length; x++)
        if (!Yc(h[x], b[x]))
          return !1;
      return !0;
    }
    function Dh() {
      if (ao > 0)
        throw new Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function Qc() {
      return Dr === null ? ks === null ? (Wn = !1, ks = Dr = Dh()) : (Wn = !0, Dr = ks) : Dr.next === null ? (Wn = !1, Dr = Dr.next = Dh()) : (Wn = !0, Dr = Dr.next), Dr;
    }
    function Gp(h, b) {
      sr = b, vs = h, Ba = !1, qc = 0;
    }
    function xv(h, b, x, S) {
      for (; bs; )
        bs = !1, qc = 0, ao += 1, Dr = null, x = h(b, S);
      return mu(), x;
    }
    function yh() {
      var h = qc !== 0;
      return h;
    }
    function mu() {
      Ba = !1, sr = null, vs = null, bs = !1, ks = null, ao = 0, $i = null, Dr = null;
    }
    function Av(h) {
      return Ba && n("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), al(h);
    }
    function Eh(h) {
      return Ds = "useContext", oo(), al(h);
    }
    function Xc(h, b) {
      return typeof b == "function" ? b(h) : b;
    }
    function wv(h) {
      return Ds = "useState", Ch(
        Xc,
        // useReducer has a special case to support lazy useState initializers
        h
      );
    }
    function Ch(h, b, x) {
      if (h !== Xc && (Ds = "useReducer"), sr = oo(), Dr = Qc(), Wn) {
        var S = Dr.queue, H = S.dispatch;
        if ($i !== null) {
          var Z = $i.get(S);
          if (Z !== void 0) {
            $i.delete(S);
            var oe = Dr.memoizedState, De = Z;
            do {
              var je = De.action;
              Ba = !0, oe = h(oe, je), Ba = !1, De = De.next;
            } while (De !== null);
            return Dr.memoizedState = oe, [oe, H];
          }
        }
        return [Dr.memoizedState, H];
      } else {
        Ba = !0;
        var ct;
        h === Xc ? ct = typeof b == "function" ? b() : b : ct = x !== void 0 ? x(b) : b, Ba = !1, Dr.memoizedState = ct;
        var kt = Dr.queue = {
          last: null,
          dispatch: null
        }, Mt = kt.dispatch = Sv.bind(null, sr, kt);
        return [Dr.memoizedState, Mt];
      }
    }
    function xh(h, b) {
      sr = oo(), Dr = Qc();
      var x = b === void 0 ? null : b;
      if (Dr !== null) {
        var S = Dr.memoizedState;
        if (S !== null && x !== null) {
          var H = S[1];
          if (Cv(x, H))
            return S[0];
        }
      }
      Ba = !0;
      var Z = h();
      return Ba = !1, Dr.memoizedState = [Z, x], Z;
    }
    function Fv(h) {
      sr = oo(), Dr = Qc();
      var b = Dr.memoizedState;
      if (b === null) {
        var x = {
          current: h
        };
        return Object.seal(x), Dr.memoizedState = x, x;
      } else
        return b;
    }
    function Tv(h, b) {
      Ds = "useLayoutEffect", n("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function Sv(h, b, x) {
      if (ao >= _s)
        throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (h === sr) {
        bs = !0;
        var S = {
          action: x,
          next: null
        };
        $i === null && ($i = /* @__PURE__ */ new Map());
        var H = $i.get(b);
        if (H === void 0)
          $i.set(b, S);
        else {
          for (var Z = H; Z.next !== null; )
            Z = Z.next;
          Z.next = S;
        }
      }
    }
    function Iv(h, b) {
      return xh(function() {
        return h;
      }, b);
    }
    function Bv(h, b, x) {
      return oo(), b(h._source);
    }
    function Rv(h, b, x) {
      if (x === void 0)
        throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
      return x();
    }
    function Ov(h) {
      return oo(), h;
    }
    function Zc() {
      throw new Error("startTransition cannot be called during server rendering.");
    }
    function Ah() {
      return oo(), [!1, Zc];
    }
    function Kp() {
      var h = vs, b = bv(h.treeContext), x = ku;
      if (x === null)
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
      var S = qc++;
      return Bi(x, b, S);
    }
    function vu() {
    }
    var wh = {
      readContext: Av,
      useContext: Eh,
      useMemo: xh,
      useReducer: Ch,
      useRef: Fv,
      useState: wv,
      useInsertionEffect: vu,
      useLayoutEffect: Tv,
      useCallback: Iv,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: vu,
      // Effects are not run in the server environment.
      useEffect: vu,
      // Debugging effect
      useDebugValue: vu,
      useDeferredValue: Ov,
      useTransition: Ah,
      useId: Kp,
      // Subscriptions are not setup in a server environment.
      useMutableSource: Bv,
      useSyncExternalStore: Rv
    }, ku = null;
    function Jc(h) {
      ku = h;
    }
    function Yp(h) {
      try {
        var b = "", x = h;
        do {
          switch (x.tag) {
            case 0:
              b += uu(x.type, null, null);
              break;
            case 1:
              b += Np(x.type, null, null);
              break;
            case 2:
              b += Pp(x.type, null, null);
              break;
          }
          x = x.parent;
        } while (x);
        return b;
      } catch (S) {
        return `
Error generating stack: ` + S.message + `
` + S.stack;
      }
    }
    var Bo = r.ReactCurrentDispatcher, ed = r.ReactDebugCurrentFrame, td = 0, ys = 1, Fh = 2, qp = 3, Es = 4, Pv = 0, Th = 1, Ra = 2, Nv = 12800;
    function zv(h) {
      return console.error(h), null;
    }
    function bu() {
    }
    function Qp(h, b, x, S, H, Z, oe, De, je) {
      var ct = [], kt = /* @__PURE__ */ new Set(), Mt = {
        destination: null,
        responseState: b,
        progressiveChunkSize: S === void 0 ? Nv : S,
        status: Pv,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: kt,
        pingedTasks: ct,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: H === void 0 ? zv : H,
        onAllReady: Z === void 0 ? bu : Z,
        onShellReady: oe === void 0 ? bu : oe,
        onShellError: De === void 0 ? bu : De,
        onFatalError: je === void 0 ? bu : je
      }, Kr = Ro(
        Mt,
        0,
        null,
        x,
        // Root segments are never embedded in Text on either edge
        !1,
        !1
      );
      Kr.parentFlushed = !0;
      var Ui = _u(Mt, h, null, Kr, kt, Io, jp, Gc);
      return ct.push(Ui), Mt;
    }
    function rd(h, b) {
      var x = h.pingedTasks;
      x.push(b), x.length === 1 && o(function() {
        return jh(h);
      });
    }
    function so(h, b) {
      return {
        id: gi,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        forceClientRender: !1,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: b,
        errorDigest: null
      };
    }
    function _u(h, b, x, S, H, Z, oe, De) {
      h.allPendingTasks++, x === null ? h.pendingRootTasks++ : x.pendingTasks++;
      var je = {
        node: b,
        ping: function() {
          return rd(h, je);
        },
        blockedBoundary: x,
        blockedSegment: S,
        abortSet: H,
        legacyContext: Z,
        context: oe,
        treeContext: De
      };
      return je.componentStack = null, H.add(je), je;
    }
    function Ro(h, b, x, S, H, Z) {
      return {
        status: td,
        id: -1,
        // lazily assigned later
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: S,
        boundary: x,
        lastPushedText: H,
        textEmbedded: Z
      };
    }
    var Oa = null;
    function Xp() {
      return Oa === null || Oa.componentStack === null ? "" : Yp(Oa.componentStack);
    }
    function Gn(h, b) {
      h.componentStack = {
        tag: 0,
        parent: h.componentStack,
        type: b
      };
    }
    function ll(h, b) {
      h.componentStack = {
        tag: 1,
        parent: h.componentStack,
        type: b
      };
    }
    function Zp(h, b) {
      h.componentStack = {
        tag: 2,
        parent: h.componentStack,
        type: b
      };
    }
    function Kn(h) {
      h.componentStack === null ? n("Unexpectedly popped too many stack frames. This is a bug in React.") : h.componentStack = h.componentStack.parent;
    }
    var Oo = null;
    function Jp(h, b) {
      {
        var x;
        typeof b == "string" ? x = b : b && typeof b.message == "string" ? x = b.message : x = String(b);
        var S = Oo || Xp();
        Oo = null, h.errorMessage = x, h.errorComponentStack = S;
      }
    }
    function Du(h, b) {
      var x = h.onError(b);
      if (x != null && typeof x != "string")
        throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof x + '" instead');
      return x;
    }
    function id(h, b) {
      var x = h.onShellError;
      x(b);
      var S = h.onFatalError;
      S(b), h.destination !== null ? (h.status = Ra, g(h.destination, b)) : (h.status = Th, h.fatalError = b);
    }
    function Sh(h, b, x) {
      Gn(b, "Suspense");
      var S = b.blockedBoundary, H = b.blockedSegment, Z = x.fallback, oe = x.children, De = /* @__PURE__ */ new Set(), je = so(h, De), ct = H.chunks.length, kt = Ro(
        h,
        ct,
        je,
        H.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      H.children.push(kt), H.lastPushedText = !1;
      var Mt = Ro(
        h,
        0,
        null,
        H.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      Mt.parentFlushed = !0, b.blockedBoundary = je, b.blockedSegment = Mt;
      try {
        if (nd(h, b, oe), nh(Mt.chunks, h.responseState, Mt.lastPushedText, Mt.textEmbedded), Mt.status = ys, Cu(je, Mt), je.pendingTasks === 0) {
          Kn(b);
          return;
        }
      } catch (Ui) {
        Mt.status = Es, je.forceClientRender = !0, je.errorDigest = Du(h, Ui), Jp(je, Ui);
      } finally {
        b.blockedBoundary = S, b.blockedSegment = H;
      }
      var Kr = _u(h, Z, S, kt, De, b.legacyContext, b.context, b.treeContext);
      Kr.componentStack = b.componentStack, h.pingedTasks.push(Kr), Kn(b);
    }
    function Ih(h, b, x, S) {
      Gn(b, x);
      var H = b.blockedSegment, Z = le(H.chunks, x, S, h.responseState, H.formatContext);
      H.lastPushedText = !1;
      var oe = H.formatContext;
      H.formatContext = Fa(oe, x, S), nd(h, b, Z), H.formatContext = oe, Zt(H.chunks, x), H.lastPushedText = !1, Kn(b);
    }
    function Lv(h) {
      return h.prototype && h.prototype.isReactComponent;
    }
    function e0(h, b, x, S, H) {
      var Z = {};
      Gp(b, Z);
      var oe = x(S, H);
      return xv(x, S, oe, H);
    }
    function yu(h, b, x, S, H) {
      var Z = x.render();
      x.props !== H && (n0 || n("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", Jr(S) || "a component"), n0 = !0);
      {
        var oe = S.childContextTypes;
        if (oe != null) {
          var De = b.legacyContext, je = gs(x, S, De, oe);
          b.legacyContext = je, Bn(h, b, Z), b.legacyContext = De;
          return;
        }
      }
      Bn(h, b, Z);
    }
    function Bh(h, b, x, S) {
      Zp(b, x);
      var H = fh(x, b.legacyContext), Z = mv(x, S, H);
      Wc(Z, x, S, H), yu(h, b, Z, x, S), Kn(b);
    }
    var t0 = {}, Eu = {}, r0 = {}, i0 = {}, n0 = !1, Rh = !1, Oh = !1, a0 = !1;
    function Mv(h, b, x, S) {
      var H;
      if (H = fh(x, b.legacyContext), ll(b, x), x.prototype && typeof x.prototype.render == "function") {
        var Z = Jr(x) || "Unknown";
        t0[Z] || (n("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", Z, Z), t0[Z] = !0);
      }
      var oe = e0(h, b, x, S, H), De = yh();
      if (typeof oe == "object" && oe !== null && typeof oe.render == "function" && oe.$$typeof === void 0) {
        var je = Jr(x) || "Unknown";
        Eu[je] || (n("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", je, je, je), Eu[je] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof oe == "object" && oe !== null && typeof oe.render == "function" && oe.$$typeof === void 0
      ) {
        {
          var ct = Jr(x) || "Unknown";
          Eu[ct] || (n("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", ct, ct, ct), Eu[ct] = !0);
        }
        Wc(oe, x, S, H), yu(h, b, oe, x, S);
      } else if (jv(x), De) {
        var kt = b.treeContext, Mt = 1, Kr = 0;
        b.treeContext = Vp(kt, Mt, Kr);
        try {
          Bn(h, b, oe);
        } finally {
          b.treeContext = kt;
        }
      } else
        Bn(h, b, oe);
      Kn(b);
    }
    function jv(h) {
      {
        if (h && h.childContextTypes && n("%s(...): childContextTypes cannot be defined on a function component.", h.displayName || h.name || "Component"), typeof h.getDerivedStateFromProps == "function") {
          var b = Jr(h) || "Unknown";
          i0[b] || (n("%s: Function components do not support getDerivedStateFromProps.", b), i0[b] = !0);
        }
        if (typeof h.contextType == "object" && h.contextType !== null) {
          var x = Jr(h) || "Unknown";
          r0[x] || (n("%s: Function components do not support contextType.", x), r0[x] = !0);
        }
      }
    }
    function Ph(h, b) {
      if (h && h.defaultProps) {
        var x = Sn({}, b), S = h.defaultProps;
        for (var H in S)
          x[H] === void 0 && (x[H] = S[H]);
        return x;
      }
      return b;
    }
    function Hv(h, b, x, S, H) {
      ll(b, x.render);
      var Z = e0(h, b, x.render, S, H), oe = yh();
      if (oe) {
        var De = b.treeContext, je = 1, ct = 0;
        b.treeContext = Vp(De, je, ct);
        try {
          Bn(h, b, Z);
        } finally {
          b.treeContext = De;
        }
      } else
        Bn(h, b, Z);
      Kn(b);
    }
    function $v(h, b, x, S, H) {
      var Z = x.type, oe = Ph(Z, S);
      s0(h, b, Z, oe, H);
    }
    function o0(h, b, x, S) {
      x._context === void 0 ? x !== x.Consumer && (a0 || (a0 = !0, n("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : x = x._context;
      var H = S.children;
      typeof H != "function" && n("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
      var Z = al(x), oe = H(Z);
      Bn(h, b, oe);
    }
    function Uv(h, b, x, S) {
      var H = x._context, Z = S.value, oe = S.children, De;
      De = b.context, b.context = hu(H, Z), Bn(h, b, oe), b.context = $p(H), De !== b.context && n("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
    }
    function In(h, b, x, S, H) {
      Gn(b, "Lazy");
      var Z = x._payload, oe = x._init, De = oe(Z), je = Ph(De, S);
      s0(h, b, De, je, H), Kn(b);
    }
    function s0(h, b, x, S, H) {
      if (typeof x == "function")
        if (Lv(x)) {
          Bh(h, b, x, S);
          return;
        } else {
          Mv(h, b, x, S);
          return;
        }
      if (typeof x == "string") {
        Ih(h, b, x, S);
        return;
      }
      switch (x) {
        case pv:
        case sh:
        case Fc:
        case Tc:
        case wc: {
          Bn(h, b, S.children);
          return;
        }
        case xp: {
          Gn(b, "SuspenseList"), Bn(h, b, S.children), Kn(b);
          return;
        }
        case dv:
          throw new Error("ReactDOMServer does not yet support scope components.");
        case tl: {
          Sh(h, b, S);
          return;
        }
      }
      if (typeof x == "object" && x !== null)
        switch (x.$$typeof) {
          case au: {
            Hv(h, b, x, S, H);
            return;
          }
          case Ap: {
            $v(h, b, x, S, H);
            return;
          }
          case iu: {
            Uv(h, b, x, S);
            return;
          }
          case nu: {
            o0(h, b, x, S);
            return;
          }
          case Sc: {
            In(h, b, x, S);
            return;
          }
        }
      var Z = "";
      throw (x === void 0 || typeof x == "object" && x !== null && Object.keys(x).length === 0) && (Z += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (x == null ? x : typeof x) + "." + Z));
    }
    function Nh(h, b) {
      typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
      h[Symbol.toStringTag] === "Generator" && (Rh || n("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), Rh = !0), h.entries === b && (Oh || n("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Oh = !0);
    }
    function Bn(h, b, x) {
      try {
        return l0(h, b, x);
      } catch (S) {
        throw typeof S == "object" && S !== null && typeof S.then == "function" || (Oo = Oo !== null ? Oo : Xp()), S;
      }
    }
    function l0(h, b, x) {
      if (b.node = x, typeof x == "object" && x !== null) {
        switch (x.$$typeof) {
          case oh: {
            var S = x, H = S.type, Z = S.props, oe = S.ref;
            s0(h, b, H, Z, oe);
            return;
          }
          case Cp:
            throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
          case Sc: {
            var De = x, je = De._payload, ct = De._init, kt;
            try {
              kt = ct(je);
            } catch (ud) {
              throw typeof ud == "object" && ud !== null && typeof ud.then == "function" && Gn(b, "Lazy"), ud;
            }
            Bn(h, b, kt);
            return;
          }
        }
        if (te(x)) {
          zh(h, b, x);
          return;
        }
        var Mt = si(x);
        if (Mt) {
          Nh(x, Mt);
          var Kr = Mt.call(x);
          if (Kr) {
            var Ui = Kr.next();
            if (!Ui.done) {
              var Yn = [];
              do
                Yn.push(Ui.value), Ui = Kr.next();
              while (!Ui.done);
              zh(h, b, Yn);
              return;
            }
            return;
          }
        }
        var $h = Object.prototype.toString.call(x);
        throw new Error("Objects are not valid as a React child (found: " + ($h === "[object Object]" ? "object with keys {" + Object.keys(x).join(", ") + "}" : $h) + "). If you meant to render a collection of children, use an array instead.");
      }
      if (typeof x == "string") {
        var Uh = b.blockedSegment;
        Uh.lastPushedText = ih(b.blockedSegment.chunks, x, h.responseState, Uh.lastPushedText);
        return;
      }
      if (typeof x == "number") {
        var Vh = b.blockedSegment;
        Vh.lastPushedText = ih(b.blockedSegment.chunks, "" + x, h.responseState, Vh.lastPushedText);
        return;
      }
      typeof x == "function" && n("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function zh(h, b, x) {
      for (var S = x.length, H = 0; H < S; H++) {
        var Z = b.treeContext;
        b.treeContext = Vp(Z, S, H);
        try {
          nd(h, b, x[H]);
        } finally {
          b.treeContext = Z;
        }
      }
    }
    function Vv(h, b, x) {
      var S = b.blockedSegment, H = S.chunks.length, Z = Ro(
        h,
        H,
        null,
        S.formatContext,
        // Adopt the parent segment's leading text embed
        S.lastPushedText,
        // Assume we are text embedded at the trailing edge
        !0
      );
      S.children.push(Z), S.lastPushedText = !1;
      var oe = _u(h, b.node, b.blockedBoundary, Z, b.abortSet, b.legacyContext, b.context, b.treeContext);
      b.componentStack !== null && (oe.componentStack = b.componentStack.parent);
      var De = oe.ping;
      x.then(De, De);
    }
    function nd(h, b, x) {
      var S = b.blockedSegment.formatContext, H = b.legacyContext, Z = b.context, oe = null;
      oe = b.componentStack;
      try {
        return Bn(h, b, x);
      } catch (De) {
        if (mu(), typeof De == "object" && De !== null && typeof De.then == "function") {
          Vv(h, b, De), b.blockedSegment.formatContext = S, b.legacyContext = H, b.context = Z, Nc(Z), b.componentStack = oe;
          return;
        } else
          throw b.blockedSegment.formatContext = S, b.legacyContext = H, b.context = Z, Nc(Z), b.componentStack = oe, De;
      }
    }
    function ad(h, b, x, S) {
      var H = Du(h, S);
      if (b === null ? id(h, S) : (b.pendingTasks--, b.forceClientRender || (b.forceClientRender = !0, b.errorDigest = H, Jp(b, S), b.parentFlushed && h.clientRenderedBoundaries.push(b))), h.allPendingTasks--, h.allPendingTasks === 0) {
        var Z = h.onAllReady;
        Z();
      }
    }
    function Lh(h) {
      var b = this, x = h.blockedBoundary, S = h.blockedSegment;
      S.status = qp, xu(b, x, S);
    }
    function Mh(h, b, x) {
      var S = h.blockedBoundary, H = h.blockedSegment;
      if (H.status = qp, S === null)
        b.allPendingTasks--, b.status !== Ra && (b.status = Ra, b.destination !== null && c(b.destination));
      else {
        if (S.pendingTasks--, !S.forceClientRender) {
          S.forceClientRender = !0;
          var Z = x === void 0 ? new Error("The render was aborted by the server without a reason.") : x;
          S.errorDigest = b.onError(Z);
          {
            var oe = "The server did not finish this Suspense boundary: ";
            Z && typeof Z.message == "string" ? Z = oe + Z.message : Z = oe + String(Z);
            var De = Oa;
            Oa = h;
            try {
              Jp(S, Z);
            } finally {
              Oa = De;
            }
          }
          S.parentFlushed && b.clientRenderedBoundaries.push(S);
        }
        if (S.fallbackAbortableTasks.forEach(function(ct) {
          return Mh(ct, b, x);
        }), S.fallbackAbortableTasks.clear(), b.allPendingTasks--, b.allPendingTasks === 0) {
          var je = b.onAllReady;
          je();
        }
      }
    }
    function Cu(h, b) {
      if (b.chunks.length === 0 && b.children.length === 1 && b.children[0].boundary === null) {
        var x = b.children[0];
        x.id = b.id, x.parentFlushed = !0, x.status === ys && Cu(h, x);
      } else {
        var S = h.completedSegments;
        S.push(b);
      }
    }
    function xu(h, b, x) {
      if (b === null) {
        if (x.parentFlushed) {
          if (h.completedRootSegment !== null)
            throw new Error("There can only be one root segment. This is a bug in React.");
          h.completedRootSegment = x;
        }
        if (h.pendingRootTasks--, h.pendingRootTasks === 0) {
          h.onShellError = bu;
          var S = h.onShellReady;
          S();
        }
      } else if (b.pendingTasks--, !b.forceClientRender) {
        if (b.pendingTasks === 0)
          x.parentFlushed && x.status === ys && Cu(b, x), b.parentFlushed && h.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach(Lh, h), b.fallbackAbortableTasks.clear();
        else if (x.parentFlushed && x.status === ys) {
          Cu(b, x);
          var H = b.completedSegments;
          H.length === 1 && b.parentFlushed && h.partialBoundaries.push(b);
        }
      }
      if (h.allPendingTasks--, h.allPendingTasks === 0) {
        var Z = h.onAllReady;
        Z();
      }
    }
    function od(h, b) {
      var x = b.blockedSegment;
      if (x.status === td) {
        Nc(b.context);
        var S = null;
        S = Oa, Oa = b;
        try {
          Bn(h, b, b.node), nh(x.chunks, h.responseState, x.lastPushedText, x.textEmbedded), b.abortSet.delete(b), x.status = ys, xu(h, b.blockedBoundary, x);
        } catch (Z) {
          if (mu(), typeof Z == "object" && Z !== null && typeof Z.then == "function") {
            var H = b.ping;
            Z.then(H, H);
          } else
            b.abortSet.delete(b), x.status = Es, ad(h, b.blockedBoundary, x, Z);
        } finally {
          Oa = S;
        }
      }
    }
    function jh(h) {
      if (h.status !== Ra) {
        var b = fv(), x = Bo.current;
        Bo.current = wh;
        var S;
        S = ed.getCurrentStack, ed.getCurrentStack = Xp;
        var H = ku;
        Jc(h.responseState);
        try {
          var Z = h.pingedTasks, oe;
          for (oe = 0; oe < Z.length; oe++) {
            var De = Z[oe];
            od(h, De);
          }
          Z.splice(0, oe), h.destination !== null && ld(h, h.destination);
        } catch (je) {
          Du(h, je), id(h, je);
        } finally {
          Jc(H), Bo.current = x, ed.getCurrentStack = S, x === wh && Nc(b);
        }
      }
    }
    function Au(h, b, x) {
      switch (x.parentFlushed = !0, x.status) {
        case td: {
          var S = x.id = h.nextSegmentId++;
          return x.lastPushedText = !1, x.textEmbedded = !1, hi(b, h.responseState, S);
        }
        case ys: {
          x.status = Fh;
          for (var H = !0, Z = x.chunks, oe = 0, De = x.children, je = 0; je < De.length; je++) {
            for (var ct = De[je]; oe < ct.index; oe++)
              l(b, Z[oe]);
            H = wu(h, b, ct);
          }
          for (; oe < Z.length - 1; oe++)
            l(b, Z[oe]);
          return oe < Z.length && (H = u(b, Z[oe])), H;
        }
        default:
          throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
      }
    }
    function wu(h, b, x) {
      var S = x.boundary;
      if (S === null)
        return Au(h, b, x);
      if (S.parentFlushed = !0, S.forceClientRender)
        return Vn(b, h.responseState, S.errorDigest, S.errorMessage, S.errorComponentStack), Au(h, b, x), ah(b, h.responseState);
      if (S.pendingTasks > 0) {
        S.rootSegmentID = h.nextSegmentId++, S.completedSegments.length > 0 && h.partialBoundaries.push(S);
        var H = S.id = gn(h.responseState);
        return So(b, h.responseState, H), Au(h, b, x), eu(b, h.responseState);
      } else {
        if (S.byteSize > h.progressiveChunkSize)
          return S.rootSegmentID = h.nextSegmentId++, h.completedBoundaries.push(S), So(b, h.responseState, S.id), Au(h, b, x), eu(b, h.responseState);
        Ep(b, h.responseState);
        var Z = S.completedSegments;
        if (Z.length !== 1)
          throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
        var oe = Z[0];
        return wu(h, b, oe), cv(b, h.responseState);
      }
    }
    function Wv(h, b, x) {
      return sv(b, h.responseState, x.id, x.errorDigest, x.errorMessage, x.errorComponentStack);
    }
    function u0(h, b, x) {
      return fe(b, h.responseState, x.formatContext, x.id), wu(h, b, x), Be(b, x.formatContext);
    }
    function sd(h, b, x) {
      for (var S = x.completedSegments, H = 0; H < S.length; H++) {
        var Z = S[H];
        Hh(h, b, x, Z);
      }
      return S.length = 0, rv(b, h.responseState, x.id, x.rootSegmentID);
    }
    function Gv(h, b, x) {
      for (var S = x.completedSegments, H = 0; H < S.length; H++) {
        var Z = S[H];
        if (!Hh(h, b, x, Z))
          return H++, S.splice(0, H), !1;
      }
      return S.splice(0, H), !0;
    }
    function Hh(h, b, x, S) {
      if (S.status === Fh)
        return !0;
      var H = S.id;
      if (H === -1) {
        var Z = S.id = x.rootSegmentID;
        if (Z === -1)
          throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
        return u0(h, b, S);
      } else
        return u0(h, b, S), Tn(b, h.responseState, H);
    }
    function ld(h, b) {
      try {
        var x = h.completedRootSegment;
        x !== null && h.pendingRootTasks === 0 && (wu(h, b, x), h.completedRootSegment = null, Pt(b, h.responseState));
        var S = h.clientRenderedBoundaries, H;
        for (H = 0; H < S.length; H++) {
          var Z = S[H];
          if (!Wv(h, b, Z)) {
            h.destination = null, H++, S.splice(0, H);
            return;
          }
        }
        S.splice(0, H);
        var oe = h.completedBoundaries;
        for (H = 0; H < oe.length; H++) {
          var De = oe[H];
          if (!sd(h, b, De)) {
            h.destination = null, H++, oe.splice(0, H);
            return;
          }
        }
        oe.splice(0, H);
        var je = h.partialBoundaries;
        for (H = 0; H < je.length; H++) {
          var ct = je[H];
          if (!Gv(h, b, ct)) {
            h.destination = null, H++, je.splice(0, H);
            return;
          }
        }
        je.splice(0, H);
        var kt = h.completedBoundaries;
        for (H = 0; H < kt.length; H++) {
          var Mt = kt[H];
          if (!sd(h, b, Mt)) {
            h.destination = null, H++, kt.splice(0, H);
            return;
          }
        }
        kt.splice(0, H);
      } finally {
        h.allPendingTasks === 0 && h.pingedTasks.length === 0 && h.clientRenderedBoundaries.length === 0 && h.completedBoundaries.length === 0 && (h.abortableTasks.size !== 0 && n("There was still abortable task at the root when we closed. This is a bug in React."), c(b));
      }
    }
    function Kv(h) {
      o(function() {
        return jh(h);
      });
    }
    function m(h, b) {
      if (h.status === Th) {
        h.status = Ra, g(b, h.fatalError);
        return;
      }
      if (h.status !== Ra && h.destination === null) {
        h.destination = b;
        try {
          ld(h, b);
        } catch (x) {
          Du(h, x), id(h, x);
        }
      }
    }
    function D(h, b) {
      try {
        var x = h.abortableTasks;
        x.forEach(function(S) {
          return Mh(S, h, b);
        }), x.clear(), h.destination !== null && ld(h, h.destination);
      } catch (S) {
        Du(h, S), id(h, S);
      }
    }
    function F() {
    }
    function O(h, b, x, S) {
      var H = !1, Z = null, oe = "", De = {
        push: function(Mt) {
          return Mt !== null && (oe += Mt), !0;
        },
        destroy: function(Mt) {
          H = !0, Z = Mt;
        }
      }, je = !1;
      function ct() {
        je = !0;
      }
      var kt = Qp(h, uv(x, b ? b.identifierPrefix : void 0), yp(), 1 / 0, F, void 0, ct, void 0, void 0);
      if (Kv(kt), D(kt, S), m(kt, De), H)
        throw Z;
      if (!je)
        throw new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
      return oe;
    }
    function W(h, b) {
      return O(h, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
    }
    function ee(h, b) {
      return O(h, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
    }
    function se() {
      throw new Error("ReactDOMServer.renderToNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToString() instead.");
    }
    function Ce() {
      throw new Error("ReactDOMServer.renderToStaticNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToStaticMarkup() instead.");
    }
    Tu.renderToNodeStream = se, Tu.renderToStaticMarkup = ee, Tu.renderToStaticNodeStream = Ce, Tu.renderToString = W, Tu.version = t;
  }()), Tu;
}
var Gh = {};
/**
 * @license React
 * react-dom-server.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var m5;
function JT() {
  return m5 || (m5 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = ht, t = "18.2.0", r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function i(m) {
      {
        for (var D = arguments.length, F = new Array(D > 1 ? D - 1 : 0), O = 1; O < D; O++)
          F[O - 1] = arguments[O];
        a("warn", m, F);
      }
    }
    function n(m) {
      {
        for (var D = arguments.length, F = new Array(D > 1 ? D - 1 : 0), O = 1; O < D; O++)
          F[O - 1] = arguments[O];
        a("error", m, F);
      }
    }
    function a(m, D, F) {
      {
        var O = r.ReactDebugCurrentFrame, W = O.getStackAddendum();
        W !== "" && (D += "%s", F = F.concat([W]));
        var ee = F.map(function(se) {
          return String(se);
        });
        ee.unshift("Warning: " + D), Function.prototype.apply.call(console[m], console, ee);
      }
    }
    function o(m) {
      m();
    }
    var s = 512, l = null, u = 0;
    function d(m) {
      l = new Uint8Array(s), u = 0;
    }
    function c(m, D) {
      if (D.length !== 0) {
        if (D.length > s) {
          u > 0 && (m.enqueue(new Uint8Array(l.buffer, 0, u)), l = new Uint8Array(s), u = 0), m.enqueue(D);
          return;
        }
        var F = D, O = l.length - u;
        O < F.length && (O === 0 ? m.enqueue(l) : (l.set(F.subarray(0, O), u), m.enqueue(l), F = F.subarray(O)), l = new Uint8Array(s), u = 0), l.set(F, u), u += F.length;
      }
    }
    function p(m, D) {
      return c(m, D), !0;
    }
    function f(m) {
      l && u > 0 && (m.enqueue(new Uint8Array(l.buffer, 0, u)), l = null, u = 0);
    }
    function g(m) {
      m.close();
    }
    var k = new TextEncoder();
    function y(m) {
      return k.encode(m);
    }
    function _(m) {
      return k.encode(m);
    }
    function A(m, D) {
      typeof m.error == "function" ? m.error(D) : m.close();
    }
    function T(m) {
      {
        var D = typeof Symbol == "function" && Symbol.toStringTag, F = D && m[Symbol.toStringTag] || m.constructor.name || "Object";
        return F;
      }
    }
    function N(m) {
      try {
        return P(m), !1;
      } catch {
        return !0;
      }
    }
    function P(m) {
      return "" + m;
    }
    function B(m, D) {
      if (N(m))
        return n("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", D, T(m)), P(m);
    }
    function M(m, D) {
      if (N(m))
        return n("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", D, T(m)), P(m);
    }
    function X(m) {
      if (N(m))
        return n("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", T(m)), P(m);
    }
    var U = Object.prototype.hasOwnProperty, K = 0, z = 1, j = 2, J = 3, ie = 4, ue = 5, de = 6, he = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", Ee = he + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", Le = new RegExp("^[" + he + "][" + Ee + "]*$"), L = {}, me = {};
    function Se(m) {
      return U.call(me, m) ? !0 : U.call(L, m) ? !1 : Le.test(m) ? (me[m] = !0, !0) : (L[m] = !0, n("Invalid attribute name: `%s`", m), !1);
    }
    function G(m, D, F, O) {
      if (F !== null && F.type === K)
        return !1;
      switch (typeof D) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (O)
            return !1;
          if (F !== null)
            return !F.acceptsBooleans;
          var W = m.toLowerCase().slice(0, 5);
          return W !== "data-" && W !== "aria-";
        }
        default:
          return !1;
      }
    }
    function He(m) {
      return _e.hasOwnProperty(m) ? _e[m] : null;
    }
    function xe(m, D, F, O, W, ee, se) {
      this.acceptsBooleans = D === j || D === J || D === ie, this.attributeName = O, this.attributeNamespace = W, this.mustUseProperty = F, this.propertyName = m, this.type = D, this.sanitizeURL = ee, this.removeEmptyString = se;
    }
    var _e = {}, Ze = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    Ze.forEach(function(m) {
      _e[m] = new xe(
        m,
        K,
        !1,
        // mustUseProperty
        m,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(m) {
      var D = m[0], F = m[1];
      _e[D] = new xe(
        D,
        z,
        !1,
        // mustUseProperty
        F,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(m) {
      _e[m] = new xe(
        m,
        j,
        !1,
        // mustUseProperty
        m.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(m) {
      _e[m] = new xe(
        m,
        j,
        !1,
        // mustUseProperty
        m,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(m) {
      _e[m] = new xe(
        m,
        J,
        !1,
        // mustUseProperty
        m.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(m) {
      _e[m] = new xe(
        m,
        J,
        !0,
        // mustUseProperty
        m,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(m) {
      _e[m] = new xe(
        m,
        ie,
        !1,
        // mustUseProperty
        m,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(m) {
      _e[m] = new xe(
        m,
        de,
        !1,
        // mustUseProperty
        m,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(m) {
      _e[m] = new xe(
        m,
        ue,
        !1,
        // mustUseProperty
        m.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var qe = /[\-\:]([a-z])/g, nt = function(m) {
      return m[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(m) {
      var D = m.replace(qe, nt);
      _e[D] = new xe(
        D,
        z,
        !1,
        // mustUseProperty
        m,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(m) {
      var D = m.replace(qe, nt);
      _e[D] = new xe(
        D,
        z,
        !1,
        // mustUseProperty
        m,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(m) {
      var D = m.replace(qe, nt);
      _e[D] = new xe(
        D,
        z,
        !1,
        // mustUseProperty
        m,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(m) {
      _e[m] = new xe(
        m,
        z,
        !1,
        // mustUseProperty
        m.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var at = "xlinkHref";
    _e[at] = new xe(
      "xlinkHref",
      z,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(m) {
      _e[m] = new xe(
        m,
        z,
        !1,
        // mustUseProperty
        m.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var At = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function Oe(m, D) {
      return m + D.charAt(0).toUpperCase() + D.substring(1);
    }
    var wt = ["Webkit", "ms", "Moz", "O"];
    Object.keys(At).forEach(function(m) {
      wt.forEach(function(D) {
        At[Oe(D, m)] = At[m];
      });
    });
    var Ge = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function nr(m, D) {
      Ge[D.type] || D.onChange || D.onInput || D.readOnly || D.disabled || D.value == null || n("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), D.onChange || D.readOnly || D.disabled || D.checked == null || n("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function vr(m, D) {
      if (m.indexOf("-") === -1)
        return typeof D.is == "string";
      switch (m) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var zr = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, Wr = {}, ne = new RegExp("^(aria)-[" + Ee + "]*$"), pe = new RegExp("^(aria)[A-Z][" + Ee + "]*$");
    function Fe(m, D) {
      {
        if (U.call(Wr, D) && Wr[D])
          return !0;
        if (pe.test(D)) {
          var F = "aria-" + D.slice(4).toLowerCase(), O = zr.hasOwnProperty(F) ? F : null;
          if (O == null)
            return n("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", D), Wr[D] = !0, !0;
          if (D !== O)
            return n("Invalid ARIA attribute `%s`. Did you mean `%s`?", D, O), Wr[D] = !0, !0;
        }
        if (ne.test(D)) {
          var W = D.toLowerCase(), ee = zr.hasOwnProperty(W) ? W : null;
          if (ee == null)
            return Wr[D] = !0, !1;
          if (D !== ee)
            return n("Unknown ARIA attribute `%s`. Did you mean `%s`?", D, ee), Wr[D] = !0, !0;
        }
      }
      return !0;
    }
    function Ye(m, D) {
      {
        var F = [];
        for (var O in D) {
          var W = Fe(m, O);
          W || F.push(O);
        }
        var ee = F.map(function(se) {
          return "`" + se + "`";
        }).join(", ");
        F.length === 1 ? n("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", ee, m) : F.length > 1 && n("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", ee, m);
      }
    }
    function Ue(m, D) {
      vr(m, D) || Ye(m, D);
    }
    var Re = !1;
    function ot(m, D) {
      {
        if (m !== "input" && m !== "textarea" && m !== "select")
          return;
        D != null && D.value === null && !Re && (Re = !0, m === "select" && D.multiple ? n("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", m) : n("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", m));
      }
    }
    var Ut = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, ge = function() {
    };
    {
      var Ie = {}, ut = /^on./, xt = /^on[^A-Z]/, Bt = new RegExp("^(aria)-[" + Ee + "]*$"), gr = new RegExp("^(aria)[A-Z][" + Ee + "]*$");
      ge = function(m, D, F, O) {
        if (U.call(Ie, D) && Ie[D])
          return !0;
        var W = D.toLowerCase();
        if (W === "onfocusin" || W === "onfocusout")
          return n("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), Ie[D] = !0, !0;
        if (O != null) {
          var ee = O.registrationNameDependencies, se = O.possibleRegistrationNames;
          if (ee.hasOwnProperty(D))
            return !0;
          var Ce = se.hasOwnProperty(W) ? se[W] : null;
          if (Ce != null)
            return n("Invalid event handler property `%s`. Did you mean `%s`?", D, Ce), Ie[D] = !0, !0;
          if (ut.test(D))
            return n("Unknown event handler property `%s`. It will be ignored.", D), Ie[D] = !0, !0;
        } else if (ut.test(D))
          return xt.test(D) && n("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", D), Ie[D] = !0, !0;
        if (Bt.test(D) || gr.test(D))
          return !0;
        if (W === "innerhtml")
          return n("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), Ie[D] = !0, !0;
        if (W === "aria")
          return n("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), Ie[D] = !0, !0;
        if (W === "is" && F !== null && F !== void 0 && typeof F != "string")
          return n("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof F), Ie[D] = !0, !0;
        if (typeof F == "number" && isNaN(F))
          return n("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", D), Ie[D] = !0, !0;
        var h = He(D), b = h !== null && h.type === K;
        if (Ut.hasOwnProperty(W)) {
          var x = Ut[W];
          if (x !== D)
            return n("Invalid DOM property `%s`. Did you mean `%s`?", D, x), Ie[D] = !0, !0;
        } else if (!b && D !== W)
          return n("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", D, W), Ie[D] = !0, !0;
        return typeof F == "boolean" && G(D, F, h, !1) ? (F ? n('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', F, D, D, F, D) : n('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', F, D, D, F, D, D, D), Ie[D] = !0, !0) : b ? !0 : G(D, F, h, !1) ? (Ie[D] = !0, !1) : ((F === "false" || F === "true") && h !== null && h.type === J && (n("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", F, D, F === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', D, F), Ie[D] = !0), !0);
      };
    }
    var Gr = function(m, D, F) {
      {
        var O = [];
        for (var W in D) {
          var ee = ge(m, W, D[W], F);
          ee || O.push(W);
        }
        var se = O.map(function(Ce) {
          return "`" + Ce + "`";
        }).join(", ");
        O.length === 1 ? n("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", se, m) : O.length > 1 && n("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", se, m);
      }
    };
    function kr(m, D, F) {
      vr(m, D) || Gr(m, D, F);
    }
    var Xr = function() {
    };
    {
      var Er = /^(?:webkit|moz|o)[A-Z]/, tr = /^-ms-/, Ti = /-(.)/g, lt = /;\s*$/, _r = {}, hr = {}, $t = !1, pi = !1, Di = function(m) {
        return m.replace(Ti, function(D, F) {
          return F.toUpperCase();
        });
      }, Zi = function(m) {
        _r.hasOwnProperty(m) && _r[m] || (_r[m] = !0, n(
          "Unsupported style property %s. Did you mean %s?",
          m,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Di(m.replace(tr, "ms-"))
        ));
      }, yi = function(m) {
        _r.hasOwnProperty(m) && _r[m] || (_r[m] = !0, n("Unsupported vendor-prefixed style property %s. Did you mean %s?", m, m.charAt(0).toUpperCase() + m.slice(1)));
      }, pn = function(m, D) {
        hr.hasOwnProperty(D) && hr[D] || (hr[D] = !0, n(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, m, D.replace(lt, "")));
      }, vi = function(m, D) {
        $t || ($t = !0, n("`NaN` is an invalid value for the `%s` css style property.", m));
      }, Cr = function(m, D) {
        pi || (pi = !0, n("`Infinity` is an invalid value for the `%s` css style property.", m));
      };
      Xr = function(m, D) {
        m.indexOf("-") > -1 ? Zi(m) : Er.test(m) ? yi(m) : lt.test(D) && pn(m, D), typeof D == "number" && (isNaN(D) ? vi(m, D) : isFinite(D) || Cr(m, D));
      };
    }
    var ca = Xr, da = /["'&<>]/;
    function pa(m) {
      X(m);
      var D = "" + m, F = da.exec(D);
      if (!F)
        return D;
      var O, W = "", ee, se = 0;
      for (ee = F.index; ee < D.length; ee++) {
        switch (D.charCodeAt(ee)) {
          case 34:
            O = "&quot;";
            break;
          case 38:
            O = "&amp;";
            break;
          case 39:
            O = "&#x27;";
            break;
          case 60:
            O = "&lt;";
            break;
          case 62:
            O = "&gt;";
            break;
          default:
            continue;
        }
        se !== ee && (W += D.substring(se, ee)), se = ee + 1, W += O;
      }
      return se !== ee ? W + D.substring(se, ee) : W;
    }
    function Lr(m) {
      return typeof m == "boolean" || typeof m == "number" ? "" + m : pa(m);
    }
    var Ln = /([A-Z])/g, ha = /^ms-/;
    function Ji(m) {
      return m.replace(Ln, "-$1").toLowerCase().replace(ha, "-ms-");
    }
    var te = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, $e = !1;
    function tt(m) {
      !$e && te.test(m) && ($e = !0, n("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(m)));
    }
    var Et = Array.isArray;
    function Vt(m) {
      return Et(m);
    }
    var Rt = _("<script>"), Gt = _("<\/script>"), Lt = _('<script src="'), Mr = _('<script type="module" src="'), ar = _('" async=""><\/script>');
    function or(m) {
      return X(m), ("" + m).replace(dr, Si);
    }
    var dr = /(<\/|<)(s)(cript)/gi, Si = function(m, D, F, O) {
      return "" + D + (F === "s" ? "\\u0073" : "\\u0053") + O;
    };
    function hn(m, D, F, O, W) {
      var ee = m === void 0 ? "" : m, se = D === void 0 ? Rt : _('<script nonce="' + Lr(D) + '">'), Ce = [];
      if (F !== void 0 && Ce.push(se, y(or(F)), Gt), O !== void 0)
        for (var h = 0; h < O.length; h++)
          Ce.push(Lt, y(Lr(O[h])), ar);
      if (W !== void 0)
        for (var b = 0; b < W.length; b++)
          Ce.push(Mr, y(Lr(W[b])), ar);
      return {
        bootstrapChunks: Ce,
        startInlineScript: se,
        placeholderPrefix: _(ee + "P:"),
        segmentPrefix: _(ee + "S:"),
        boundaryPrefix: ee + "B:",
        idPrefix: ee,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
      };
    }
    var jr = 0, Hr = 1, fn = 2, Ii = 3, fi = 4, Fa = 5, gi = 6, gn = 7;
    function Bi(m, D) {
      return {
        insertionMode: m,
        selectedValue: D
      };
    }
    function _n(m) {
      var D = m === "http://www.w3.org/2000/svg" ? fn : m === "http://www.w3.org/1998/Math/MathML" ? Ii : jr;
      return Bi(D, null);
    }
    function Mn(m, D, F) {
      switch (D) {
        case "select":
          return Bi(Hr, F.value != null ? F.value : F.defaultValue);
        case "svg":
          return Bi(fn, null);
        case "math":
          return Bi(Ii, null);
        case "foreignObject":
          return Bi(Hr, null);
        case "table":
          return Bi(fi, null);
        case "thead":
        case "tbody":
        case "tfoot":
          return Bi(Fa, null);
        case "colgroup":
          return Bi(gn, null);
        case "tr":
          return Bi(gi, null);
      }
      return m.insertionMode >= fi || m.insertionMode === jr ? Bi(Hr, null) : m;
    }
    var to = null;
    function ro(m) {
      var D = m.nextSuspenseID++;
      return _(m.boundaryPrefix + D.toString(16));
    }
    function Dn(m, D, F) {
      var O = m.idPrefix, W = ":" + O + "R" + D;
      return F > 0 && (W += "H" + F.toString(32)), W + ":";
    }
    function jn(m) {
      return Lr(m);
    }
    var yn = _("<!-- -->");
    function fa(m, D, F, O) {
      return D === "" ? O : (O && m.push(yn), m.push(y(jn(D))), !0);
    }
    function ga(m, D, F, O) {
      F && O && m.push(yn);
    }
    var E = /* @__PURE__ */ new Map();
    function I(m) {
      var D = E.get(m);
      if (D !== void 0)
        return D;
      var F = _(Lr(Ji(m)));
      return E.set(m, F), F;
    }
    var V = _(' style="'), q = _(":"), ve = _(";");
    function ce(m, D, F) {
      if (typeof F != "object")
        throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      var O = !0;
      for (var W in F)
        if (U.call(F, W)) {
          var ee = F[W];
          if (!(ee == null || typeof ee == "boolean" || ee === "")) {
            var se = void 0, Ce = void 0, h = W.indexOf("--") === 0;
            h ? (se = y(Lr(W)), M(ee, W), Ce = y(Lr(("" + ee).trim()))) : (ca(W, ee), se = I(W), typeof ee == "number" ? ee !== 0 && !U.call(At, W) ? Ce = y(ee + "px") : Ce = y("" + ee) : (M(ee, W), Ce = y(Lr(("" + ee).trim())))), O ? (O = !1, m.push(V, se, q, Ce)) : m.push(ve, se, q, Ce);
          }
        }
      O || m.push(dt);
    }
    var Ae = _(" "), Ve = _('="'), dt = _('"'), yt = _('=""');
    function Dt(m, D, F, O) {
      switch (F) {
        case "style": {
          ce(m, D, O);
          return;
        }
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
          return;
      }
      if (
        // shouldIgnoreAttribute
        // We have already filtered out null/undefined and reserved words.
        !(F.length > 2 && (F[0] === "o" || F[0] === "O") && (F[1] === "n" || F[1] === "N"))
      ) {
        var W = He(F);
        if (W !== null) {
          switch (typeof O) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              if (!W.acceptsBooleans)
                return;
          }
          var ee = W.attributeName, se = y(ee);
          switch (W.type) {
            case J:
              O && m.push(Ae, se, yt);
              return;
            case ie:
              O === !0 ? m.push(Ae, se, yt) : O === !1 || m.push(Ae, se, Ve, y(Lr(O)), dt);
              return;
            case ue:
              isNaN(O) || m.push(Ae, se, Ve, y(Lr(O)), dt);
              break;
            case de:
              !isNaN(O) && O >= 1 && m.push(Ae, se, Ve, y(Lr(O)), dt);
              break;
            default:
              W.sanitizeURL && (B(O, ee), O = "" + O, tt(O)), m.push(Ae, se, Ve, y(Lr(O)), dt);
          }
        } else if (Se(F)) {
          switch (typeof O) {
            case "function":
            case "symbol":
              return;
            case "boolean": {
              var Ce = F.toLowerCase().slice(0, 5);
              if (Ce !== "data-" && Ce !== "aria-")
                return;
            }
          }
          m.push(Ae, y(F), Ve, y(Lr(O)), dt);
        }
      }
    }
    var rr = _(">"), Zr = _("/>");
    function Ei(m, D, F) {
      if (D != null) {
        if (F != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof D != "object" || !("__html" in D))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var O = D.__html;
        O != null && (X(O), m.push(y("" + O)));
      }
    }
    var Ci = !1, En = !1, en = !1, Ta = !1, Ri = !1, Hn = !1, Cn = !1;
    function $n(m, D) {
      {
        var F = m[D];
        if (F != null) {
          var O = Vt(F);
          m.multiple && !O ? n("The `%s` prop supplied to <select> must be an array if `multiple` is true.", D) : !m.multiple && O && n("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", D);
        }
      }
    }
    function Jl(m, D, F) {
      nr("select", D), $n(D, "value"), $n(D, "defaultValue"), D.value !== void 0 && D.defaultValue !== void 0 && !en && (n("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), en = !0), m.push(Zt("select"));
      var O = null, W = null;
      for (var ee in D)
        if (U.call(D, ee)) {
          var se = D[ee];
          if (se == null)
            continue;
          switch (ee) {
            case "children":
              O = se;
              break;
            case "dangerouslySetInnerHTML":
              W = se;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              Dt(m, F, ee, se);
              break;
          }
        }
      return m.push(rr), Ei(m, W, O), O;
    }
    function ps(m) {
      var D = "";
      return e.Children.forEach(m, function(F) {
        F != null && (D += F, !Ri && typeof F != "string" && typeof F != "number" && (Ri = !0, n("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }), D;
    }
    var hs = _(' selected=""');
    function Ks(m, D, F, O) {
      var W = O.selectedValue;
      m.push(Zt("option"));
      var ee = null, se = null, Ce = null, h = null;
      for (var b in D)
        if (U.call(D, b)) {
          var x = D[b];
          if (x == null)
            continue;
          switch (b) {
            case "children":
              ee = x;
              break;
            case "selected":
              Ce = x, Cn || (n("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Cn = !0);
              break;
            case "dangerouslySetInnerHTML":
              h = x;
              break;
            case "value":
              se = x;
            default:
              Dt(m, F, b, x);
              break;
          }
        }
      if (W != null) {
        var S;
        if (se !== null ? (B(se, "value"), S = "" + se) : (h !== null && (Hn || (Hn = !0, n("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."))), S = ps(ee)), Vt(W))
          for (var H = 0; H < W.length; H++) {
            B(W[H], "value");
            var Z = "" + W[H];
            if (Z === S) {
              m.push(hs);
              break;
            }
          }
        else
          B(W, "select.value"), "" + W === S && m.push(hs);
      } else
        Ce && m.push(hs);
      return m.push(rr), Ei(m, h, ee), ee;
    }
    function Fo(m, D, F) {
      nr("input", D), D.checked !== void 0 && D.defaultChecked !== void 0 && !En && (n("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", D.type), En = !0), D.value !== void 0 && D.defaultValue !== void 0 && !Ci && (n("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", D.type), Ci = !0), m.push(Zt("input"));
      var O = null, W = null, ee = null, se = null;
      for (var Ce in D)
        if (U.call(D, Ce)) {
          var h = D[Ce];
          if (h == null)
            continue;
          switch (Ce) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            case "defaultChecked":
              se = h;
              break;
            case "defaultValue":
              W = h;
              break;
            case "checked":
              ee = h;
              break;
            case "value":
              O = h;
              break;
            default:
              Dt(m, F, Ce, h);
              break;
          }
        }
      return ee !== null ? Dt(m, F, "checked", ee) : se !== null && Dt(m, F, "checked", se), O !== null ? Dt(m, F, "value", O) : W !== null && Dt(m, F, "value", W), m.push(Zr), null;
    }
    function mn(m, D, F) {
      nr("textarea", D), D.value !== void 0 && D.defaultValue !== void 0 && !Ta && (n("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Ta = !0), m.push(Zt("textarea"));
      var O = null, W = null, ee = null;
      for (var se in D)
        if (U.call(D, se)) {
          var Ce = D[se];
          if (Ce == null)
            continue;
          switch (se) {
            case "children":
              ee = Ce;
              break;
            case "value":
              O = Ce;
              break;
            case "defaultValue":
              W = Ce;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
            default:
              Dt(m, F, se, Ce);
              break;
          }
        }
      if (O === null && W !== null && (O = W), m.push(rr), ee != null) {
        if (n("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), O != null)
          throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
        if (Vt(ee)) {
          if (ee.length > 1)
            throw new Error("<textarea> can only have at most one child.");
          X(ee[0]), O = "" + ee[0];
        }
        X(ee), O = "" + ee;
      }
      return typeof O == "string" && O[0] === `
` && m.push(Y), O !== null && (B(O, "value"), m.push(y(jn("" + O)))), null;
    }
    function xn(m, D, F, O) {
      m.push(Zt(F));
      for (var W in D)
        if (U.call(D, W)) {
          var ee = D[W];
          if (ee == null)
            continue;
          switch (W) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error(F + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            default:
              Dt(m, O, W, ee);
              break;
          }
        }
      return m.push(Zr), null;
    }
    function io(m, D, F) {
      m.push(Zt("menuitem"));
      for (var O in D)
        if (U.call(D, O)) {
          var W = D[O];
          if (W == null)
            continue;
          switch (O) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");
            default:
              Dt(m, F, O, W);
              break;
          }
        }
      return m.push(rr), null;
    }
    function br(m, D, F) {
      m.push(Zt("title"));
      var O = null;
      for (var W in D)
        if (U.call(D, W)) {
          var ee = D[W];
          if (ee == null)
            continue;
          switch (W) {
            case "children":
              O = ee;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");
            default:
              Dt(m, F, W, ee);
              break;
          }
        }
      m.push(rr);
      {
        var se = Array.isArray(O) && O.length < 2 ? O[0] || null : O;
        Array.isArray(O) && O.length > 1 ? n("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : se != null && se.$$typeof != null ? n("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : se != null && typeof se != "string" && typeof se != "number" && n("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
      }
      return O;
    }
    function Un(m, D, F, O) {
      m.push(Zt(F));
      var W = null, ee = null;
      for (var se in D)
        if (U.call(D, se)) {
          var Ce = D[se];
          if (Ce == null)
            continue;
          switch (se) {
            case "children":
              W = Ce;
              break;
            case "dangerouslySetInnerHTML":
              ee = Ce;
              break;
            default:
              Dt(m, O, se, Ce);
              break;
          }
        }
      return m.push(rr), Ei(m, ee, W), typeof W == "string" ? (m.push(y(jn(W))), null) : W;
    }
    function ji(m, D, F, O) {
      m.push(Zt(F));
      var W = null, ee = null;
      for (var se in D)
        if (U.call(D, se)) {
          var Ce = D[se];
          if (Ce == null)
            continue;
          switch (se) {
            case "children":
              W = Ce;
              break;
            case "dangerouslySetInnerHTML":
              ee = Ce;
              break;
            case "style":
              ce(m, O, Ce);
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
              break;
            default:
              Se(se) && typeof Ce != "function" && typeof Ce != "symbol" && m.push(Ae, y(se), Ve, y(Lr(Ce)), dt);
              break;
          }
        }
      return m.push(rr), Ei(m, ee, W), W;
    }
    var Y = _(`
`);
    function le(m, D, F, O) {
      m.push(Zt(F));
      var W = null, ee = null;
      for (var se in D)
        if (U.call(D, se)) {
          var Ce = D[se];
          if (Ce == null)
            continue;
          switch (se) {
            case "children":
              W = Ce;
              break;
            case "dangerouslySetInnerHTML":
              ee = Ce;
              break;
            default:
              Dt(m, O, se, Ce);
              break;
          }
        }
      if (m.push(rr), ee != null) {
        if (W != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof ee != "object" || !("__html" in ee))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var h = ee.__html;
        h != null && (typeof h == "string" && h.length > 0 && h[0] === `
` ? m.push(Y, y(h)) : (X(h), m.push(y("" + h))));
      }
      return typeof W == "string" && W[0] === `
` && m.push(Y), W;
    }
    var Pe = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, it = /* @__PURE__ */ new Map();
    function Zt(m) {
      var D = it.get(m);
      if (D === void 0) {
        if (!Pe.test(m))
          throw new Error("Invalid tag: " + m);
        D = _("<" + m), it.set(m, D);
      }
      return D;
    }
    var Pt = _("<!DOCTYPE html>");
    function xr(m, D, F, O, W) {
      switch (Ue(D, F), ot(D, F), kr(D, F, null), !F.suppressContentEditableWarning && F.contentEditable && F.children != null && n("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), W.insertionMode !== fn && W.insertionMode !== Ii && D.indexOf("-") === -1 && typeof F.is != "string" && D.toLowerCase() !== D && n("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", D), D) {
        case "select":
          return Jl(m, F, O);
        case "option":
          return Ks(m, F, O, W);
        case "textarea":
          return mn(m, F, O);
        case "input":
          return Fo(m, F, O);
        case "menuitem":
          return io(m, F, O);
        case "title":
          return br(m, F, O);
        case "listing":
        case "pre":
          return le(m, F, D, O);
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          return xn(m, F, D, O);
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return Un(m, F, D, O);
        case "html":
          return W.insertionMode === jr && m.push(Pt), Un(m, F, D, O);
        default:
          return D.indexOf("-") === -1 && typeof F.is != "string" ? Un(m, F, D, O) : ji(m, F, D, O);
      }
    }
    var ai = _("</"), hi = _(">");
    function Ar(m, D, F) {
      switch (D) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          m.push(ai, y(D), hi);
      }
    }
    function Hi(m, D) {
      for (var F = D.bootstrapChunks, O = 0; O < F.length - 1; O++)
        c(m, F[O]);
      return O < F.length ? p(m, F[O]) : !0;
    }
    var tn = _('<template id="'), oi = _('"></template>');
    function xi(m, D, F) {
      c(m, tn), c(m, D.placeholderPrefix);
      var O = y(F.toString(16));
      return c(m, O), p(m, oi);
    }
    var Ai = _("<!--$-->"), Ki = _('<!--$?--><template id="'), An = _('"></template>'), rn = _("<!--$!-->"), To = _("<!--/$-->"), Sa = _("<template"), wn = _('"'), So = _(' data-dgst="'), Ys = _(' data-msg="'), mc = _(' data-stck="'), eu = _("></template>");
    function vc(m, D) {
      return p(m, Ai);
    }
    function qs(m, D, F) {
      if (c(m, Ki), F === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return c(m, F), p(m, An);
    }
    function nn(m, D, F, O, W) {
      var ee;
      return ee = p(m, rn), c(m, Sa), F && (c(m, So), c(m, y(Lr(F))), c(m, wn)), O && (c(m, Ys), c(m, y(Lr(O))), c(m, wn)), W && (c(m, mc), c(m, y(Lr(W))), c(m, wn)), ee = p(m, eu), ee;
    }
    function kc(m, D) {
      return p(m, To);
    }
    function Qs(m, D) {
      return p(m, To);
    }
    function bp(m, D) {
      return p(m, To);
    }
    var bc = _('<div hidden id="'), Xs = _('">'), _c = _("</div>"), Dc = _('<svg aria-hidden="true" style="display:none" id="'), Zs = _('">'), Js = _("</svg>"), yc = _('<math aria-hidden="true" style="display:none" id="'), Ec = _('">'), Cc = _("</math>"), tu = _('<table hidden id="'), xc = _('">'), C = _("</table>"), R = _('<table hidden><tbody id="'), $ = _('">'), Q = _("</tbody></table>"), be = _('<table hidden><tr id="'), fe = _('">'), Be = _("</tr></table>"), Ke = _('<table hidden><colgroup id="'), Tt = _('">'), Yt = _("</colgroup></table>");
    function Wt(m, D, F, O) {
      switch (F.insertionMode) {
        case jr:
        case Hr:
          return c(m, bc), c(m, D.segmentPrefix), c(m, y(O.toString(16))), p(m, Xs);
        case fn:
          return c(m, Dc), c(m, D.segmentPrefix), c(m, y(O.toString(16))), p(m, Zs);
        case Ii:
          return c(m, yc), c(m, D.segmentPrefix), c(m, y(O.toString(16))), p(m, Ec);
        case fi:
          return c(m, tu), c(m, D.segmentPrefix), c(m, y(O.toString(16))), p(m, xc);
        case Fa:
          return c(m, R), c(m, D.segmentPrefix), c(m, y(O.toString(16))), p(m, $);
        case gi:
          return c(m, be), c(m, D.segmentPrefix), c(m, y(O.toString(16))), p(m, fe);
        case gn:
          return c(m, Ke), c(m, D.segmentPrefix), c(m, y(O.toString(16))), p(m, Tt);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    function Or(m, D) {
      switch (D.insertionMode) {
        case jr:
        case Hr:
          return p(m, _c);
        case fn:
          return p(m, Js);
        case Ii:
          return p(m, Cc);
        case fi:
          return p(m, C);
        case Fa:
          return p(m, Q);
        case gi:
          return p(m, Be);
        case gn:
          return p(m, Yt);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    var an = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}", Fn = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}', Tn = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}', el = _(an + ';$RS("'), Ac = _('$RS("'), ru = _('","'), tv = _('")<\/script>');
    function rv(m, D, F) {
      c(m, D.startInlineScript), D.sentCompleteSegmentFunction ? c(m, Ac) : (D.sentCompleteSegmentFunction = !0, c(m, el)), c(m, D.segmentPrefix);
      var O = y(F.toString(16));
      return c(m, O), c(m, ru), c(m, D.placeholderPrefix), c(m, O), p(m, tv);
    }
    var iv = _(Fn + ';$RC("'), nv = _('$RC("'), av = _('","'), ov = _('")<\/script>');
    function _p(m, D, F, O) {
      if (c(m, D.startInlineScript), D.sentCompleteBoundaryFunction ? c(m, nv) : (D.sentCompleteBoundaryFunction = !0, c(m, iv)), F === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      var W = y(O.toString(16));
      return c(m, F), c(m, av), c(m, D.segmentPrefix), c(m, W), p(m, ov);
    }
    var sv = _(Tn + ';$RX("'), lv = _('$RX("'), Dp = _('"'), uv = _(")<\/script>"), yp = _(",");
    function ih(m, D, F, O, W, ee) {
      if (c(m, D.startInlineScript), D.sentClientRenderFunction ? c(m, lv) : (D.sentClientRenderFunction = !0, c(m, sv)), F === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return c(m, F), c(m, Dp), (O || W || ee) && (c(m, yp), c(m, y(Ep(O || "")))), (W || ee) && (c(m, yp), c(m, y(Ep(W || "")))), ee && (c(m, yp), c(m, y(Ep(ee)))), p(m, uv);
    }
    var nh = /[<\u2028\u2029]/g;
    function Ep(m) {
      var D = JSON.stringify(m);
      return D.replace(nh, function(F) {
        switch (F) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
      });
    }
    var Vn = Object.assign, cv = Symbol.for("react.element"), ah = Symbol.for("react.portal"), Sn = Symbol.for("react.fragment"), oh = Symbol.for("react.strict_mode"), Cp = Symbol.for("react.profiler"), wc = Symbol.for("react.provider"), Fc = Symbol.for("react.context"), Tc = Symbol.for("react.forward_ref"), iu = Symbol.for("react.suspense"), nu = Symbol.for("react.suspense_list"), au = Symbol.for("react.memo"), tl = Symbol.for("react.lazy"), xp = Symbol.for("react.scope"), Ap = Symbol.for("react.debug_trace_mode"), Sc = Symbol.for("react.legacy_hidden"), dv = Symbol.for("react.default_value"), sh = Symbol.iterator, pv = "@@iterator";
    function hv(m) {
      if (m === null || typeof m != "object")
        return null;
      var D = sh && m[sh] || m[pv];
      return typeof D == "function" ? D : null;
    }
    function lh(m, D, F) {
      var O = m.displayName;
      if (O)
        return O;
      var W = D.displayName || D.name || "";
      return W !== "" ? F + "(" + W + ")" : F;
    }
    function uh(m) {
      return m.displayName || "Context";
    }
    function si(m) {
      if (m == null)
        return null;
      if (typeof m.tag == "number" && n("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof m == "function")
        return m.displayName || m.name || null;
      if (typeof m == "string")
        return m;
      switch (m) {
        case Sn:
          return "Fragment";
        case ah:
          return "Portal";
        case Cp:
          return "Profiler";
        case oh:
          return "StrictMode";
        case iu:
          return "Suspense";
        case nu:
          return "SuspenseList";
      }
      if (typeof m == "object")
        switch (m.$$typeof) {
          case Fc:
            var D = m;
            return uh(D) + ".Consumer";
          case wc:
            var F = m;
            return uh(F._context) + ".Provider";
          case Tc:
            return lh(m, m.render, "ForwardRef");
          case au:
            var O = m.displayName || null;
            return O !== null ? O : si(m.type) || "Memo";
          case tl: {
            var W = m, ee = W._payload, se = W._init;
            try {
              return si(se(ee));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ou = 0, wp, Jr, rl, Fp, Tp, Sp, Ip;
    function Bp() {
    }
    Bp.__reactDisabledLog = !0;
    function ch() {
      {
        if (ou === 0) {
          wp = console.log, Jr = console.info, rl = console.warn, Fp = console.error, Tp = console.group, Sp = console.groupCollapsed, Ip = console.groupEnd;
          var m = {
            configurable: !0,
            enumerable: !0,
            value: Bp,
            writable: !0
          };
          Object.defineProperties(console, {
            info: m,
            log: m,
            warn: m,
            error: m,
            group: m,
            groupCollapsed: m,
            groupEnd: m
          });
        }
        ou++;
      }
    }
    function dh() {
      {
        if (ou--, ou === 0) {
          var m = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Vn({}, m, {
              value: wp
            }),
            info: Vn({}, m, {
              value: Jr
            }),
            warn: Vn({}, m, {
              value: rl
            }),
            error: Vn({}, m, {
              value: Fp
            }),
            group: Vn({}, m, {
              value: Tp
            }),
            groupCollapsed: Vn({}, m, {
              value: Sp
            }),
            groupEnd: Vn({}, m, {
              value: Ip
            })
          });
        }
        ou < 0 && n("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ic = r.ReactCurrentDispatcher, Rp;
    function su(m, D, F) {
      {
        if (Rp === void 0)
          try {
            throw Error();
          } catch (W) {
            var O = W.stack.trim().match(/\n( *(at )?)/);
            Rp = O && O[1] || "";
          }
        return `
` + Rp + m;
      }
    }
    var lu = !1, il;
    {
      var uu = typeof WeakMap == "function" ? WeakMap : Map;
      il = new uu();
    }
    function cu(m, D) {
      if (!m || lu)
        return "";
      {
        var F = il.get(m);
        if (F !== void 0)
          return F;
      }
      var O;
      lu = !0;
      var W = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ee;
      ee = Ic.current, Ic.current = null, ch();
      try {
        if (D) {
          var se = function() {
            throw Error();
          };
          if (Object.defineProperty(se.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(se, []);
            } catch (oe) {
              O = oe;
            }
            Reflect.construct(m, [], se);
          } else {
            try {
              se.call();
            } catch (oe) {
              O = oe;
            }
            m.call(se.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (oe) {
            O = oe;
          }
          m();
        }
      } catch (oe) {
        if (oe && O && typeof oe.stack == "string") {
          for (var Ce = oe.stack.split(`
`), h = O.stack.split(`
`), b = Ce.length - 1, x = h.length - 1; b >= 1 && x >= 0 && Ce[b] !== h[x]; )
            x--;
          for (; b >= 1 && x >= 0; b--, x--)
            if (Ce[b] !== h[x]) {
              if (b !== 1 || x !== 1)
                do
                  if (b--, x--, x < 0 || Ce[b] !== h[x]) {
                    var S = `
` + Ce[b].replace(" at new ", " at ");
                    return m.displayName && S.includes("<anonymous>") && (S = S.replace("<anonymous>", m.displayName)), typeof m == "function" && il.set(m, S), S;
                  }
                while (b >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        lu = !1, Ic.current = ee, dh(), Error.prepareStackTrace = W;
      }
      var H = m ? m.displayName || m.name : "", Z = H ? su(H) : "";
      return typeof m == "function" && il.set(m, Z), Z;
    }
    function Bc(m, D, F) {
      return cu(m, !0);
    }
    function ph(m, D, F) {
      return cu(m, !1);
    }
    function Op(m) {
      var D = m.prototype;
      return !!(D && D.isReactComponent);
    }
    function Pp(m, D, F) {
      if (m == null)
        return "";
      if (typeof m == "function")
        return cu(m, Op(m));
      if (typeof m == "string")
        return su(m);
      switch (m) {
        case iu:
          return su("Suspense");
        case nu:
          return su("SuspenseList");
      }
      if (typeof m == "object")
        switch (m.$$typeof) {
          case Tc:
            return ph(m.render);
          case au:
            return Pp(m.type, D, F);
          case tl: {
            var O = m, W = O._payload, ee = O._init;
            try {
              return Pp(ee(W), D, F);
            } catch {
            }
          }
        }
      return "";
    }
    var Np = {}, hh = r.ReactDebugCurrentFrame;
    function nl(m) {
      if (m) {
        var D = m._owner, F = Pp(m.type, m._source, D ? D.type : null);
        hh.setExtraStackFrame(F);
      } else
        hh.setExtraStackFrame(null);
    }
    function zp(m, D, F, O, W) {
      {
        var ee = Function.call.bind(U);
        for (var se in m)
          if (ee(m, se)) {
            var Ce = void 0;
            try {
              if (typeof m[se] != "function") {
                var h = Error((O || "React class") + ": " + F + " type `" + se + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof m[se] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw h.name = "Invariant Violation", h;
              }
              Ce = m[se](D, se, O, F, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (b) {
              Ce = b;
            }
            Ce && !(Ce instanceof Error) && (nl(W), n("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", O || "React class", F, se, typeof Ce), nl(null)), Ce instanceof Error && !(Ce.message in Np) && (Np[Ce.message] = !0, nl(W), n("Failed %s type: %s", F, Ce.message), nl(null));
          }
      }
    }
    var Rc;
    Rc = {};
    var fs = {};
    Object.freeze(fs);
    function Lp(m, D) {
      {
        var F = m.contextTypes;
        if (!F)
          return fs;
        var O = {};
        for (var W in F)
          O[W] = D[W];
        {
          var ee = si(m) || "Unknown";
          zp(F, O, "context", ee);
        }
        return O;
      }
    }
    function Mp(m, D, F, O) {
      {
        if (typeof m.getChildContext != "function") {
          {
            var W = si(D) || "Unknown";
            Rc[W] || (Rc[W] = !0, n("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", W, W));
          }
          return F;
        }
        var ee = m.getChildContext();
        for (var se in ee)
          if (!(se in O))
            throw new Error((si(D) || "Unknown") + '.getChildContext(): key "' + se + '" is not defined in childContextTypes.');
        {
          var Ce = si(D) || "Unknown";
          zp(O, ee, "child context", Ce);
        }
        return Vn({}, F, ee);
      }
    }
    var Io;
    Io = {};
    var fh = null, gs = null;
    function ms(m) {
      m.context._currentValue = m.parentValue;
    }
    function jp(m) {
      m.context._currentValue = m.value;
    }
    function Ia(m, D) {
      if (m !== D) {
        ms(m);
        var F = m.parent, O = D.parent;
        if (F === null) {
          if (O !== null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
        } else {
          if (O === null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
          Ia(F, O);
        }
        jp(D);
      }
    }
    function Oc(m) {
      ms(m);
      var D = m.parent;
      D !== null && Oc(D);
    }
    function Pc(m) {
      var D = m.parent;
      D !== null && Pc(D), jp(m);
    }
    function du(m, D) {
      ms(m);
      var F = m.parent;
      if (F === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      F.depth === D.depth ? Ia(F, D) : du(F, D);
    }
    function Hp(m, D) {
      var F = D.parent;
      if (F === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      m.depth === F.depth ? Ia(m, F) : Hp(m, F), jp(D);
    }
    function pu(m) {
      var D = gs, F = m;
      D !== F && (D === null ? Pc(F) : F === null ? Oc(D) : D.depth === F.depth ? Ia(D, F) : D.depth > F.depth ? du(D, F) : Hp(D, F), gs = F);
    }
    function gh(m, D) {
      var F;
      F = m._currentValue, m._currentValue = D, m._currentRenderer !== void 0 && m._currentRenderer !== null && m._currentRenderer !== Io && n("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), m._currentRenderer = Io;
      var O = gs, W = {
        parent: O,
        depth: O === null ? 0 : O.depth + 1,
        context: m,
        parentValue: F,
        value: D
      };
      return gs = W, W;
    }
    function mh(m) {
      var D = gs;
      if (D === null)
        throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
      D.context !== m && n("The parent context is not the expected context. This is probably a bug in React.");
      {
        var F = D.parentValue;
        F === dv ? D.context._currentValue = D.context._defaultValue : D.context._currentValue = F, m._currentRenderer !== void 0 && m._currentRenderer !== null && m._currentRenderer !== Io && n("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), m._currentRenderer = Io;
      }
      return gs = D.parent;
    }
    function Nc() {
      return gs;
    }
    function hu(m) {
      var D = m._currentValue;
      return D;
    }
    function $p(m) {
      return m._reactInternals;
    }
    function fv(m, D) {
      m._reactInternals = D;
    }
    var al = {}, zc = {}, Up, Lc, Mc, fu, jc, ol, gu, Hc, sl;
    {
      Up = /* @__PURE__ */ new Set(), Lc = /* @__PURE__ */ new Set(), Mc = /* @__PURE__ */ new Set(), gu = /* @__PURE__ */ new Set(), fu = /* @__PURE__ */ new Set(), Hc = /* @__PURE__ */ new Set(), sl = /* @__PURE__ */ new Set();
      var $c = /* @__PURE__ */ new Set();
      ol = function(m, D) {
        if (!(m === null || typeof m == "function")) {
          var F = D + "_" + m;
          $c.has(F) || ($c.add(F), n("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", D, m));
        }
      }, jc = function(m, D) {
        if (D === void 0) {
          var F = si(m) || "Component";
          fu.has(F) || (fu.add(F), n("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", F));
        }
      };
    }
    function Uc(m, D) {
      {
        var F = m.constructor, O = F && si(F) || "ReactClass", W = O + "." + D;
        if (al[W])
          return;
        n(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, D, D, O), al[W] = !0;
      }
    }
    var Vc = {
      isMounted: function(m) {
        return !1;
      },
      enqueueSetState: function(m, D, F) {
        var O = $p(m);
        O.queue === null ? Uc(m, "setState") : (O.queue.push(D), F != null && ol(F, "setState"));
      },
      enqueueReplaceState: function(m, D, F) {
        var O = $p(m);
        O.replace = !0, O.queue = [D], F != null && ol(F, "setState");
      },
      enqueueForceUpdate: function(m, D) {
        var F = $p(m);
        F.queue === null ? Uc(m, "forceUpdate") : D != null && ol(D, "setState");
      }
    };
    function vh(m, D, F, O, W) {
      var ee = F(W, O);
      jc(D, ee);
      var se = ee == null ? O : Vn({}, O, ee);
      return se;
    }
    function kh(m, D, F) {
      var O = fs, W = m.contextType;
      if ("contextType" in m) {
        var ee = (
          // Allow null for conditional declaration
          W === null || W !== void 0 && W.$$typeof === Fc && W._context === void 0
        );
        if (!ee && !sl.has(m)) {
          sl.add(m);
          var se = "";
          W === void 0 ? se = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof W != "object" ? se = " However, it is set to a " + typeof W + "." : W.$$typeof === wc ? se = " Did you accidentally pass the Context.Provider instead?" : W._context !== void 0 ? se = " Did you accidentally pass the Context.Consumer instead?" : se = " However, it is set to an object with keys {" + Object.keys(W).join(", ") + "}.", n("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", si(m) || "Component", se);
        }
      }
      typeof W == "object" && W !== null ? O = hu(W) : O = F;
      var Ce = new m(D, O);
      {
        if (typeof m.getDerivedStateFromProps == "function" && (Ce.state === null || Ce.state === void 0)) {
          var h = si(m) || "Component";
          Up.has(h) || (Up.add(h), n("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", h, Ce.state === null ? "null" : "undefined", h));
        }
        if (typeof m.getDerivedStateFromProps == "function" || typeof Ce.getSnapshotBeforeUpdate == "function") {
          var b = null, x = null, S = null;
          if (typeof Ce.componentWillMount == "function" && Ce.componentWillMount.__suppressDeprecationWarning !== !0 ? b = "componentWillMount" : typeof Ce.UNSAFE_componentWillMount == "function" && (b = "UNSAFE_componentWillMount"), typeof Ce.componentWillReceiveProps == "function" && Ce.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? x = "componentWillReceiveProps" : typeof Ce.UNSAFE_componentWillReceiveProps == "function" && (x = "UNSAFE_componentWillReceiveProps"), typeof Ce.componentWillUpdate == "function" && Ce.componentWillUpdate.__suppressDeprecationWarning !== !0 ? S = "componentWillUpdate" : typeof Ce.UNSAFE_componentWillUpdate == "function" && (S = "UNSAFE_componentWillUpdate"), b !== null || x !== null || S !== null) {
            var H = si(m) || "Component", Z = typeof m.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            Mc.has(H) || (Mc.add(H), n(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, H, Z, b !== null ? `
  ` + b : "", x !== null ? `
  ` + x : "", S !== null ? `
  ` + S : ""));
          }
        }
      }
      return Ce;
    }
    function bh(m, D, F) {
      {
        var O = si(D) || "Component", W = m.render;
        W || (D.prototype && typeof D.prototype.render == "function" ? n("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", O) : n("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", O)), m.getInitialState && !m.getInitialState.isReactClassApproved && !m.state && n("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", O), m.getDefaultProps && !m.getDefaultProps.isReactClassApproved && n("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", O), m.propTypes && n("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", O), m.contextType && n("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", O), m.contextTypes && n("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", O), D.contextType && D.contextTypes && !Hc.has(D) && (Hc.add(D), n("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", O)), typeof m.componentShouldUpdate == "function" && n("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", O), D.prototype && D.prototype.isPureReactComponent && typeof m.shouldComponentUpdate < "u" && n("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", si(D) || "A pure component"), typeof m.componentDidUnmount == "function" && n("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", O), typeof m.componentDidReceiveProps == "function" && n("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", O), typeof m.componentWillRecieveProps == "function" && n("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", O), typeof m.UNSAFE_componentWillRecieveProps == "function" && n("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", O);
        var ee = m.props !== F;
        m.props !== void 0 && ee && n("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", O, O), m.defaultProps && n("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", O, O), typeof m.getSnapshotBeforeUpdate == "function" && typeof m.componentDidUpdate != "function" && !Lc.has(D) && (Lc.add(D), n("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", si(D))), typeof m.getDerivedStateFromProps == "function" && n("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", O), typeof m.getDerivedStateFromError == "function" && n("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", O), typeof D.getSnapshotBeforeUpdate == "function" && n("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", O);
        var se = m.state;
        se && (typeof se != "object" || Vt(se)) && n("%s.state: must be set to an object or null", O), typeof m.getChildContext == "function" && typeof D.childContextTypes != "object" && n("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", O);
      }
    }
    function gv(m, D) {
      var F = D.state;
      if (typeof D.componentWillMount == "function") {
        if (D.componentWillMount.__suppressDeprecationWarning !== !0) {
          var O = si(m) || "Unknown";
          zc[O] || (i(
            // keep this warning in sync with ReactStrictModeWarning.js
            `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
            O
          ), zc[O] = !0);
        }
        D.componentWillMount();
      }
      typeof D.UNSAFE_componentWillMount == "function" && D.UNSAFE_componentWillMount(), F !== D.state && (n("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", si(m) || "Component"), Vc.enqueueReplaceState(D, D.state, null));
    }
    function mv(m, D, F, O) {
      if (m.queue !== null && m.queue.length > 0) {
        var W = m.queue, ee = m.replace;
        if (m.queue = null, m.replace = !1, ee && W.length === 1)
          D.state = W[0];
        else {
          for (var se = ee ? W[0] : D.state, Ce = !0, h = ee ? 1 : 0; h < W.length; h++) {
            var b = W[h], x = typeof b == "function" ? b.call(D, se, F, O) : b;
            x != null && (Ce ? (Ce = !1, se = Vn({}, se, x)) : Vn(se, x));
          }
          D.state = se;
        }
      } else
        m.queue = null;
    }
    function _h(m, D, F, O) {
      bh(m, D, F);
      var W = m.state !== void 0 ? m.state : null;
      m.updater = Vc, m.props = F, m.state = W;
      var ee = {
        queue: [],
        replace: !1
      };
      fv(m, ee);
      var se = D.contextType;
      if (typeof se == "object" && se !== null ? m.context = hu(se) : m.context = O, m.state === F) {
        var Ce = si(D) || "Component";
        gu.has(Ce) || (gu.add(Ce), n("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", Ce));
      }
      var h = D.getDerivedStateFromProps;
      typeof h == "function" && (m.state = vh(m, D, h, W, F)), typeof D.getDerivedStateFromProps != "function" && typeof m.getSnapshotBeforeUpdate != "function" && (typeof m.UNSAFE_componentWillMount == "function" || typeof m.componentWillMount == "function") && (gv(D, m), mv(ee, m, F, O));
    }
    var vv = {
      id: 1,
      overflow: ""
    };
    function kv(m) {
      var D = m.overflow, F = m.id, O = F & ~bv(F);
      return O.toString(32) + D;
    }
    function Wc(m, D, F) {
      var O = m.id, W = m.overflow, ee = Gc(O) - 1, se = O & ~(1 << ee), Ce = F + 1, h = Gc(D) + ee;
      if (h > 30) {
        var b = ee - ee % 5, x = (1 << b) - 1, S = (se & x).toString(32), H = se >> b, Z = ee - b, oe = Gc(D) + Z, De = Ce << Z, je = De | H, ct = S + W;
        return {
          id: 1 << oe | je,
          overflow: ct
        };
      } else {
        var kt = Ce << ee, Mt = kt | se, Kr = W;
        return {
          id: 1 << h | Mt,
          overflow: Kr
        };
      }
    }
    function Gc(m) {
      return 32 - Vp(m);
    }
    function bv(m) {
      return 1 << Gc(m) - 1;
    }
    var Vp = Math.clz32 ? Math.clz32 : Dv, Kc = Math.log, _v = Math.LN2;
    function Dv(m) {
      var D = m >>> 0;
      return D === 0 ? 32 : 31 - (Kc(D) / _v | 0) | 0;
    }
    function yv(m, D) {
      return m === D && (m !== 0 || 1 / m === 1 / D) || m !== m && D !== D;
    }
    var Ev = typeof Object.is == "function" ? Object.is : yv, no = null, Wp = null, Yc = null, sr = null, vs = !1, ks = !1, Dr = 0, Wn = null, bs = 0, qc = 25, $i = !1, ao;
    function _s() {
      if (no === null)
        throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return $i && n("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks"), no;
    }
    function Ba(m, D) {
      if (D === null)
        return n("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", ao), !1;
      m.length !== D.length && n(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, ao, "[" + m.join(", ") + "]", "[" + D.join(", ") + "]");
      for (var F = 0; F < D.length && F < m.length; F++)
        if (!Ev(m[F], D[F]))
          return !1;
      return !0;
    }
    function Ds() {
      if (bs > 0)
        throw new Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function oo() {
      return sr === null ? Yc === null ? (vs = !1, Yc = sr = Ds()) : (vs = !0, sr = Yc) : sr.next === null ? (vs = !1, sr = sr.next = Ds()) : (vs = !0, sr = sr.next), sr;
    }
    function Cv(m, D) {
      no = D, Wp = m, $i = !1, Dr = 0;
    }
    function Dh(m, D, F, O) {
      for (; ks; )
        ks = !1, Dr = 0, bs += 1, sr = null, F = m(D, O);
      return Gp(), F;
    }
    function Qc() {
      var m = Dr !== 0;
      return m;
    }
    function Gp() {
      $i = !1, no = null, Wp = null, ks = !1, Yc = null, bs = 0, Wn = null, sr = null;
    }
    function xv(m) {
      return $i && n("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), hu(m);
    }
    function yh(m) {
      return ao = "useContext", _s(), hu(m);
    }
    function mu(m, D) {
      return typeof D == "function" ? D(m) : D;
    }
    function Av(m) {
      return ao = "useState", Eh(
        mu,
        // useReducer has a special case to support lazy useState initializers
        m
      );
    }
    function Eh(m, D, F) {
      if (m !== mu && (ao = "useReducer"), no = _s(), sr = oo(), vs) {
        var O = sr.queue, W = O.dispatch;
        if (Wn !== null) {
          var ee = Wn.get(O);
          if (ee !== void 0) {
            Wn.delete(O);
            var se = sr.memoizedState, Ce = ee;
            do {
              var h = Ce.action;
              $i = !0, se = m(se, h), $i = !1, Ce = Ce.next;
            } while (Ce !== null);
            return sr.memoizedState = se, [se, W];
          }
        }
        return [sr.memoizedState, W];
      } else {
        $i = !0;
        var b;
        m === mu ? b = typeof D == "function" ? D() : D : b = F !== void 0 ? F(D) : D, $i = !1, sr.memoizedState = b;
        var x = sr.queue = {
          last: null,
          dispatch: null
        }, S = x.dispatch = xh.bind(null, no, x);
        return [sr.memoizedState, S];
      }
    }
    function Xc(m, D) {
      no = _s(), sr = oo();
      var F = D === void 0 ? null : D;
      if (sr !== null) {
        var O = sr.memoizedState;
        if (O !== null && F !== null) {
          var W = O[1];
          if (Ba(F, W))
            return O[0];
        }
      }
      $i = !0;
      var ee = m();
      return $i = !1, sr.memoizedState = [ee, F], ee;
    }
    function wv(m) {
      no = _s(), sr = oo();
      var D = sr.memoizedState;
      if (D === null) {
        var F = {
          current: m
        };
        return Object.seal(F), sr.memoizedState = F, F;
      } else
        return D;
    }
    function Ch(m, D) {
      ao = "useLayoutEffect", n("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function xh(m, D, F) {
      if (bs >= qc)
        throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (m === no) {
        ks = !0;
        var O = {
          action: F,
          next: null
        };
        Wn === null && (Wn = /* @__PURE__ */ new Map());
        var W = Wn.get(D);
        if (W === void 0)
          Wn.set(D, O);
        else {
          for (var ee = W; ee.next !== null; )
            ee = ee.next;
          ee.next = O;
        }
      }
    }
    function Fv(m, D) {
      return Xc(function() {
        return m;
      }, D);
    }
    function Tv(m, D, F) {
      return _s(), D(m._source);
    }
    function Sv(m, D, F) {
      if (F === void 0)
        throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
      return F();
    }
    function Iv(m) {
      return _s(), m;
    }
    function Bv() {
      throw new Error("startTransition cannot be called during server rendering.");
    }
    function Rv() {
      return _s(), [!1, Bv];
    }
    function Ov() {
      var m = Wp, D = kv(m.treeContext), F = Kp;
      if (F === null)
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
      var O = Dr++;
      return Dn(F, D, O);
    }
    function Zc() {
    }
    var Ah = {
      readContext: xv,
      useContext: yh,
      useMemo: Xc,
      useReducer: Eh,
      useRef: wv,
      useState: Av,
      useInsertionEffect: Zc,
      useLayoutEffect: Ch,
      useCallback: Fv,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: Zc,
      // Effects are not run in the server environment.
      useEffect: Zc,
      // Debugging effect
      useDebugValue: Zc,
      useDeferredValue: Iv,
      useTransition: Rv,
      useId: Ov,
      // Subscriptions are not setup in a server environment.
      useMutableSource: Tv,
      useSyncExternalStore: Sv
    }, Kp = null;
    function vu(m) {
      Kp = m;
    }
    function wh(m) {
      try {
        var D = "", F = m;
        do {
          switch (F.tag) {
            case 0:
              D += su(F.type, null, null);
              break;
            case 1:
              D += ph(F.type, null, null);
              break;
            case 2:
              D += Bc(F.type, null, null);
              break;
          }
          F = F.parent;
        } while (F);
        return D;
      } catch (O) {
        return `
Error generating stack: ` + O.message + `
` + O.stack;
      }
    }
    var ku = r.ReactCurrentDispatcher, Jc = r.ReactDebugCurrentFrame, Yp = 0, Bo = 1, ed = 2, td = 3, ys = 4, Fh = 0, qp = 1, Es = 2, Pv = 12800;
    function Th(m) {
      return console.error(m), null;
    }
    function Ra() {
    }
    function Nv(m, D, F, O, W, ee, se, Ce, h) {
      var b = [], x = /* @__PURE__ */ new Set(), S = {
        destination: null,
        responseState: D,
        progressiveChunkSize: O === void 0 ? Pv : O,
        status: Fh,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: x,
        pingedTasks: b,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: W === void 0 ? Th : W,
        onAllReady: ee === void 0 ? Ra : ee,
        onShellReady: se === void 0 ? Ra : se,
        onShellError: Ce === void 0 ? Ra : Ce,
        onFatalError: h === void 0 ? Ra : h
      }, H = rd(
        S,
        0,
        null,
        F,
        // Root segments are never embedded in Text on either edge
        !1,
        !1
      );
      H.parentFlushed = !0;
      var Z = Qp(S, m, null, H, x, fs, fh, vv);
      return b.push(Z), S;
    }
    function zv(m, D) {
      var F = m.pingedTasks;
      F.push(D), F.length === 1 && o(function() {
        return Cu(m);
      });
    }
    function bu(m, D) {
      return {
        id: to,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        forceClientRender: !1,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: D,
        errorDigest: null
      };
    }
    function Qp(m, D, F, O, W, ee, se, Ce) {
      m.allPendingTasks++, F === null ? m.pendingRootTasks++ : F.pendingTasks++;
      var h = {
        node: D,
        ping: function() {
          return zv(m, h);
        },
        blockedBoundary: F,
        blockedSegment: O,
        abortSet: W,
        legacyContext: ee,
        context: se,
        treeContext: Ce
      };
      return h.componentStack = null, W.add(h), h;
    }
    function rd(m, D, F, O, W, ee) {
      return {
        status: Yp,
        id: -1,
        // lazily assigned later
        index: D,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: O,
        boundary: F,
        lastPushedText: W,
        textEmbedded: ee
      };
    }
    var so = null;
    function _u() {
      return so === null || so.componentStack === null ? "" : wh(so.componentStack);
    }
    function Ro(m, D) {
      m.componentStack = {
        tag: 0,
        parent: m.componentStack,
        type: D
      };
    }
    function Oa(m, D) {
      m.componentStack = {
        tag: 1,
        parent: m.componentStack,
        type: D
      };
    }
    function Xp(m, D) {
      m.componentStack = {
        tag: 2,
        parent: m.componentStack,
        type: D
      };
    }
    function Gn(m) {
      m.componentStack === null ? n("Unexpectedly popped too many stack frames. This is a bug in React.") : m.componentStack = m.componentStack.parent;
    }
    var ll = null;
    function Zp(m, D) {
      {
        var F;
        typeof D == "string" ? F = D : D && typeof D.message == "string" ? F = D.message : F = String(D);
        var O = ll || _u();
        ll = null, m.errorMessage = F, m.errorComponentStack = O;
      }
    }
    function Kn(m, D) {
      var F = m.onError(D);
      if (F != null && typeof F != "string")
        throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof F + '" instead');
      return F;
    }
    function Oo(m, D) {
      var F = m.onShellError;
      F(D);
      var O = m.onFatalError;
      O(D), m.destination !== null ? (m.status = Es, A(m.destination, D)) : (m.status = qp, m.fatalError = D);
    }
    function Jp(m, D, F) {
      Ro(D, "Suspense");
      var O = D.blockedBoundary, W = D.blockedSegment, ee = F.fallback, se = F.children, Ce = /* @__PURE__ */ new Set(), h = bu(m, Ce), b = W.chunks.length, x = rd(
        m,
        b,
        h,
        W.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      W.children.push(x), W.lastPushedText = !1;
      var S = rd(
        m,
        0,
        null,
        W.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      S.parentFlushed = !0, D.blockedBoundary = h, D.blockedSegment = S;
      try {
        if (l0(m, D, se), ga(S.chunks, m.responseState, S.lastPushedText, S.textEmbedded), S.status = Bo, ad(h, S), h.pendingTasks === 0) {
          Gn(D);
          return;
        }
      } catch (Z) {
        S.status = ys, h.forceClientRender = !0, h.errorDigest = Kn(m, Z), Zp(h, Z);
      } finally {
        D.blockedBoundary = O, D.blockedSegment = W;
      }
      var H = Qp(m, ee, O, x, Ce, D.legacyContext, D.context, D.treeContext);
      H.componentStack = D.componentStack, m.pingedTasks.push(H), Gn(D);
    }
    function Du(m, D, F, O) {
      Ro(D, F);
      var W = D.blockedSegment, ee = xr(W.chunks, F, O, m.responseState, W.formatContext);
      W.lastPushedText = !1;
      var se = W.formatContext;
      W.formatContext = Mn(se, F, O), l0(m, D, ee), W.formatContext = se, Ar(W.chunks, F), W.lastPushedText = !1, Gn(D);
    }
    function id(m) {
      return m.prototype && m.prototype.isReactComponent;
    }
    function Sh(m, D, F, O, W) {
      var ee = {};
      Cv(D, ee);
      var se = F(O, W);
      return Dh(F, O, se, W);
    }
    function Ih(m, D, F, O, W) {
      var ee = F.render();
      F.props !== W && (Eu || n("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", si(O) || "a component"), Eu = !0);
      {
        var se = O.childContextTypes;
        if (se != null) {
          var Ce = D.legacyContext, h = Mp(F, O, Ce, se);
          D.legacyContext = h, In(m, D, ee), D.legacyContext = Ce;
          return;
        }
      }
      In(m, D, ee);
    }
    function Lv(m, D, F, O) {
      Xp(D, F);
      var W = Lp(F, D.legacyContext), ee = kh(F, O, W);
      _h(ee, F, O, W), Ih(m, D, ee, F, O), Gn(D);
    }
    var e0 = {}, yu = {}, Bh = {}, t0 = {}, Eu = !1, r0 = !1, i0 = !1, n0 = !1;
    function Rh(m, D, F, O) {
      var W;
      if (W = Lp(F, D.legacyContext), Oa(D, F), F.prototype && typeof F.prototype.render == "function") {
        var ee = si(F) || "Unknown";
        e0[ee] || (n("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", ee, ee), e0[ee] = !0);
      }
      var se = Sh(m, D, F, O, W), Ce = Qc();
      if (typeof se == "object" && se !== null && typeof se.render == "function" && se.$$typeof === void 0) {
        var h = si(F) || "Unknown";
        yu[h] || (n("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", h, h, h), yu[h] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof se == "object" && se !== null && typeof se.render == "function" && se.$$typeof === void 0
      ) {
        {
          var b = si(F) || "Unknown";
          yu[b] || (n("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", b, b, b), yu[b] = !0);
        }
        _h(se, F, O, W), Ih(m, D, se, F, O);
      } else if (Oh(F), Ce) {
        var x = D.treeContext, S = 1, H = 0;
        D.treeContext = Wc(x, S, H);
        try {
          In(m, D, se);
        } finally {
          D.treeContext = x;
        }
      } else
        In(m, D, se);
      Gn(D);
    }
    function Oh(m) {
      {
        if (m && m.childContextTypes && n("%s(...): childContextTypes cannot be defined on a function component.", m.displayName || m.name || "Component"), typeof m.getDerivedStateFromProps == "function") {
          var D = si(m) || "Unknown";
          t0[D] || (n("%s: Function components do not support getDerivedStateFromProps.", D), t0[D] = !0);
        }
        if (typeof m.contextType == "object" && m.contextType !== null) {
          var F = si(m) || "Unknown";
          Bh[F] || (n("%s: Function components do not support contextType.", F), Bh[F] = !0);
        }
      }
    }
    function a0(m, D) {
      if (m && m.defaultProps) {
        var F = Vn({}, D), O = m.defaultProps;
        for (var W in O)
          F[W] === void 0 && (F[W] = O[W]);
        return F;
      }
      return D;
    }
    function Mv(m, D, F, O, W) {
      Oa(D, F.render);
      var ee = Sh(m, D, F.render, O, W), se = Qc();
      if (se) {
        var Ce = D.treeContext, h = 1, b = 0;
        D.treeContext = Wc(Ce, h, b);
        try {
          In(m, D, ee);
        } finally {
          D.treeContext = Ce;
        }
      } else
        In(m, D, ee);
      Gn(D);
    }
    function jv(m, D, F, O, W) {
      var ee = F.type, se = a0(ee, O);
      o0(m, D, ee, se, W);
    }
    function Ph(m, D, F, O) {
      F._context === void 0 ? F !== F.Consumer && (n0 || (n0 = !0, n("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : F = F._context;
      var W = O.children;
      typeof W != "function" && n("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
      var ee = hu(F), se = W(ee);
      In(m, D, se);
    }
    function Hv(m, D, F, O) {
      var W = F._context, ee = O.value, se = O.children, Ce;
      Ce = D.context, D.context = gh(W, ee), In(m, D, se), D.context = mh(W), Ce !== D.context && n("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
    }
    function $v(m, D, F, O, W) {
      Ro(D, "Lazy");
      var ee = F._payload, se = F._init, Ce = se(ee), h = a0(Ce, O);
      o0(m, D, Ce, h, W), Gn(D);
    }
    function o0(m, D, F, O, W) {
      if (typeof F == "function")
        if (id(F)) {
          Lv(m, D, F, O);
          return;
        } else {
          Rh(m, D, F, O);
          return;
        }
      if (typeof F == "string") {
        Du(m, D, F, O);
        return;
      }
      switch (F) {
        case Sc:
        case Ap:
        case oh:
        case Cp:
        case Sn: {
          In(m, D, O.children);
          return;
        }
        case nu: {
          Ro(D, "SuspenseList"), In(m, D, O.children), Gn(D);
          return;
        }
        case xp:
          throw new Error("ReactDOMServer does not yet support scope components.");
        case iu: {
          Jp(m, D, O);
          return;
        }
      }
      if (typeof F == "object" && F !== null)
        switch (F.$$typeof) {
          case Tc: {
            Mv(m, D, F, O, W);
            return;
          }
          case au: {
            jv(m, D, F, O, W);
            return;
          }
          case wc: {
            Hv(m, D, F, O);
            return;
          }
          case Fc: {
            Ph(m, D, F, O);
            return;
          }
          case tl: {
            $v(m, D, F, O);
            return;
          }
        }
      var ee = "";
      throw (F === void 0 || typeof F == "object" && F !== null && Object.keys(F).length === 0) && (ee += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (F == null ? F : typeof F) + "." + ee));
    }
    function Uv(m, D) {
      typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
      m[Symbol.toStringTag] === "Generator" && (r0 || n("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), r0 = !0), m.entries === D && (i0 || n("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), i0 = !0);
    }
    function In(m, D, F) {
      try {
        return s0(m, D, F);
      } catch (O) {
        throw typeof O == "object" && O !== null && typeof O.then == "function" || (ll = ll !== null ? ll : _u()), O;
      }
    }
    function s0(m, D, F) {
      if (D.node = F, typeof F == "object" && F !== null) {
        switch (F.$$typeof) {
          case cv: {
            var O = F, W = O.type, ee = O.props, se = O.ref;
            o0(m, D, W, ee, se);
            return;
          }
          case ah:
            throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
          case tl: {
            var Ce = F, h = Ce._payload, b = Ce._init, x;
            try {
              x = b(h);
            } catch (kt) {
              throw typeof kt == "object" && kt !== null && typeof kt.then == "function" && Ro(D, "Lazy"), kt;
            }
            In(m, D, x);
            return;
          }
        }
        if (Vt(F)) {
          Nh(m, D, F);
          return;
        }
        var S = hv(F);
        if (S) {
          Uv(F, S);
          var H = S.call(F);
          if (H) {
            var Z = H.next();
            if (!Z.done) {
              var oe = [];
              do
                oe.push(Z.value), Z = H.next();
              while (!Z.done);
              Nh(m, D, oe);
              return;
            }
            return;
          }
        }
        var De = Object.prototype.toString.call(F);
        throw new Error("Objects are not valid as a React child (found: " + (De === "[object Object]" ? "object with keys {" + Object.keys(F).join(", ") + "}" : De) + "). If you meant to render a collection of children, use an array instead.");
      }
      if (typeof F == "string") {
        var je = D.blockedSegment;
        je.lastPushedText = fa(D.blockedSegment.chunks, F, m.responseState, je.lastPushedText);
        return;
      }
      if (typeof F == "number") {
        var ct = D.blockedSegment;
        ct.lastPushedText = fa(D.blockedSegment.chunks, "" + F, m.responseState, ct.lastPushedText);
        return;
      }
      typeof F == "function" && n("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function Nh(m, D, F) {
      for (var O = F.length, W = 0; W < O; W++) {
        var ee = D.treeContext;
        D.treeContext = Wc(ee, O, W);
        try {
          l0(m, D, F[W]);
        } finally {
          D.treeContext = ee;
        }
      }
    }
    function Bn(m, D, F) {
      var O = D.blockedSegment, W = O.chunks.length, ee = rd(
        m,
        W,
        null,
        O.formatContext,
        // Adopt the parent segment's leading text embed
        O.lastPushedText,
        // Assume we are text embedded at the trailing edge
        !0
      );
      O.children.push(ee), O.lastPushedText = !1;
      var se = Qp(m, D.node, D.blockedBoundary, ee, D.abortSet, D.legacyContext, D.context, D.treeContext);
      D.componentStack !== null && (se.componentStack = D.componentStack.parent);
      var Ce = se.ping;
      F.then(Ce, Ce);
    }
    function l0(m, D, F) {
      var O = D.blockedSegment.formatContext, W = D.legacyContext, ee = D.context, se = null;
      se = D.componentStack;
      try {
        return In(m, D, F);
      } catch (Ce) {
        if (Gp(), typeof Ce == "object" && Ce !== null && typeof Ce.then == "function") {
          Bn(m, D, Ce), D.blockedSegment.formatContext = O, D.legacyContext = W, D.context = ee, pu(ee), D.componentStack = se;
          return;
        } else
          throw D.blockedSegment.formatContext = O, D.legacyContext = W, D.context = ee, pu(ee), D.componentStack = se, Ce;
      }
    }
    function zh(m, D, F, O) {
      var W = Kn(m, O);
      if (D === null ? Oo(m, O) : (D.pendingTasks--, D.forceClientRender || (D.forceClientRender = !0, D.errorDigest = W, Zp(D, O), D.parentFlushed && m.clientRenderedBoundaries.push(D))), m.allPendingTasks--, m.allPendingTasks === 0) {
        var ee = m.onAllReady;
        ee();
      }
    }
    function Vv(m) {
      var D = this, F = m.blockedBoundary, O = m.blockedSegment;
      O.status = td, Lh(D, F, O);
    }
    function nd(m, D, F) {
      var O = m.blockedBoundary, W = m.blockedSegment;
      if (W.status = td, O === null)
        D.allPendingTasks--, D.status !== Es && (D.status = Es, D.destination !== null && g(D.destination));
      else {
        if (O.pendingTasks--, !O.forceClientRender) {
          O.forceClientRender = !0;
          var ee = F === void 0 ? new Error("The render was aborted by the server without a reason.") : F;
          O.errorDigest = D.onError(ee);
          {
            var se = "The server did not finish this Suspense boundary: ";
            ee && typeof ee.message == "string" ? ee = se + ee.message : ee = se + String(ee);
            var Ce = so;
            so = m;
            try {
              Zp(O, ee);
            } finally {
              so = Ce;
            }
          }
          O.parentFlushed && D.clientRenderedBoundaries.push(O);
        }
        if (O.fallbackAbortableTasks.forEach(function(b) {
          return nd(b, D, F);
        }), O.fallbackAbortableTasks.clear(), D.allPendingTasks--, D.allPendingTasks === 0) {
          var h = D.onAllReady;
          h();
        }
      }
    }
    function ad(m, D) {
      if (D.chunks.length === 0 && D.children.length === 1 && D.children[0].boundary === null) {
        var F = D.children[0];
        F.id = D.id, F.parentFlushed = !0, F.status === Bo && ad(m, F);
      } else {
        var O = m.completedSegments;
        O.push(D);
      }
    }
    function Lh(m, D, F) {
      if (D === null) {
        if (F.parentFlushed) {
          if (m.completedRootSegment !== null)
            throw new Error("There can only be one root segment. This is a bug in React.");
          m.completedRootSegment = F;
        }
        if (m.pendingRootTasks--, m.pendingRootTasks === 0) {
          m.onShellError = Ra;
          var O = m.onShellReady;
          O();
        }
      } else if (D.pendingTasks--, !D.forceClientRender) {
        if (D.pendingTasks === 0)
          F.parentFlushed && F.status === Bo && ad(D, F), D.parentFlushed && m.completedBoundaries.push(D), D.fallbackAbortableTasks.forEach(Vv, m), D.fallbackAbortableTasks.clear();
        else if (F.parentFlushed && F.status === Bo) {
          ad(D, F);
          var W = D.completedSegments;
          W.length === 1 && D.parentFlushed && m.partialBoundaries.push(D);
        }
      }
      if (m.allPendingTasks--, m.allPendingTasks === 0) {
        var ee = m.onAllReady;
        ee();
      }
    }
    function Mh(m, D) {
      var F = D.blockedSegment;
      if (F.status === Yp) {
        pu(D.context);
        var O = null;
        O = so, so = D;
        try {
          In(m, D, D.node), ga(F.chunks, m.responseState, F.lastPushedText, F.textEmbedded), D.abortSet.delete(D), F.status = Bo, Lh(m, D.blockedBoundary, F);
        } catch (ee) {
          if (Gp(), typeof ee == "object" && ee !== null && typeof ee.then == "function") {
            var W = D.ping;
            ee.then(W, W);
          } else
            D.abortSet.delete(D), F.status = ys, zh(m, D.blockedBoundary, F, ee);
        } finally {
          so = O;
        }
      }
    }
    function Cu(m) {
      if (m.status !== Es) {
        var D = Nc(), F = ku.current;
        ku.current = Ah;
        var O;
        O = Jc.getCurrentStack, Jc.getCurrentStack = _u;
        var W = Kp;
        vu(m.responseState);
        try {
          var ee = m.pingedTasks, se;
          for (se = 0; se < ee.length; se++) {
            var Ce = ee[se];
            Mh(m, Ce);
          }
          ee.splice(0, se), m.destination !== null && sd(m, m.destination);
        } catch (h) {
          Kn(m, h), Oo(m, h);
        } finally {
          vu(W), ku.current = F, Jc.getCurrentStack = O, F === Ah && pu(D);
        }
      }
    }
    function xu(m, D, F) {
      switch (F.parentFlushed = !0, F.status) {
        case Yp: {
          var O = F.id = m.nextSegmentId++;
          return F.lastPushedText = !1, F.textEmbedded = !1, xi(D, m.responseState, O);
        }
        case Bo: {
          F.status = ed;
          for (var W = !0, ee = F.chunks, se = 0, Ce = F.children, h = 0; h < Ce.length; h++) {
            for (var b = Ce[h]; se < b.index; se++)
              c(D, ee[se]);
            W = od(m, D, b);
          }
          for (; se < ee.length - 1; se++)
            c(D, ee[se]);
          return se < ee.length && (W = p(D, ee[se])), W;
        }
        default:
          throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
      }
    }
    function od(m, D, F) {
      var O = F.boundary;
      if (O === null)
        return xu(m, D, F);
      if (O.parentFlushed = !0, O.forceClientRender)
        return nn(D, m.responseState, O.errorDigest, O.errorMessage, O.errorComponentStack), xu(m, D, F), bp(D, m.responseState);
      if (O.pendingTasks > 0) {
        O.rootSegmentID = m.nextSegmentId++, O.completedSegments.length > 0 && m.partialBoundaries.push(O);
        var W = O.id = ro(m.responseState);
        return qs(D, m.responseState, W), xu(m, D, F), Qs(D, m.responseState);
      } else {
        if (O.byteSize > m.progressiveChunkSize)
          return O.rootSegmentID = m.nextSegmentId++, m.completedBoundaries.push(O), qs(D, m.responseState, O.id), xu(m, D, F), Qs(D, m.responseState);
        vc(D, m.responseState);
        var ee = O.completedSegments;
        if (ee.length !== 1)
          throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
        var se = ee[0];
        return od(m, D, se), kc(D, m.responseState);
      }
    }
    function jh(m, D, F) {
      return ih(D, m.responseState, F.id, F.errorDigest, F.errorMessage, F.errorComponentStack);
    }
    function Au(m, D, F) {
      return Wt(D, m.responseState, F.formatContext, F.id), od(m, D, F), Or(D, F.formatContext);
    }
    function wu(m, D, F) {
      for (var O = F.completedSegments, W = 0; W < O.length; W++) {
        var ee = O[W];
        u0(m, D, F, ee);
      }
      return O.length = 0, _p(D, m.responseState, F.id, F.rootSegmentID);
    }
    function Wv(m, D, F) {
      for (var O = F.completedSegments, W = 0; W < O.length; W++) {
        var ee = O[W];
        if (!u0(m, D, F, ee))
          return W++, O.splice(0, W), !1;
      }
      return O.splice(0, W), !0;
    }
    function u0(m, D, F, O) {
      if (O.status === ed)
        return !0;
      var W = O.id;
      if (W === -1) {
        var ee = O.id = F.rootSegmentID;
        if (ee === -1)
          throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
        return Au(m, D, O);
      } else
        return Au(m, D, O), rv(D, m.responseState, W);
    }
    function sd(m, D) {
      d();
      try {
        var F = m.completedRootSegment;
        F !== null && m.pendingRootTasks === 0 && (od(m, D, F), m.completedRootSegment = null, Hi(D, m.responseState));
        var O = m.clientRenderedBoundaries, W;
        for (W = 0; W < O.length; W++) {
          var ee = O[W];
          jh(m, D, ee);
        }
        O.splice(0, W);
        var se = m.completedBoundaries;
        for (W = 0; W < se.length; W++) {
          var Ce = se[W];
          wu(m, D, Ce);
        }
        se.splice(0, W), f(D), d(D);
        var h = m.partialBoundaries;
        for (W = 0; W < h.length; W++) {
          var b = h[W];
          if (!Wv(m, D, b)) {
            m.destination = null, W++, h.splice(0, W);
            return;
          }
        }
        h.splice(0, W);
        var x = m.completedBoundaries;
        for (W = 0; W < x.length; W++) {
          var S = x[W];
          wu(m, D, S);
        }
        x.splice(0, W);
      } finally {
        f(D), m.allPendingTasks === 0 && m.pingedTasks.length === 0 && m.clientRenderedBoundaries.length === 0 && m.completedBoundaries.length === 0 && (m.abortableTasks.size !== 0 && n("There was still abortable task at the root when we closed. This is a bug in React."), g(D));
      }
    }
    function Gv(m) {
      o(function() {
        return Cu(m);
      });
    }
    function Hh(m, D) {
      if (m.status === qp) {
        m.status = Es, A(D, m.fatalError);
        return;
      }
      if (m.status !== Es && m.destination === null) {
        m.destination = D;
        try {
          sd(m, D);
        } catch (F) {
          Kn(m, F), Oo(m, F);
        }
      }
    }
    function ld(m, D) {
      try {
        var F = m.abortableTasks;
        F.forEach(function(O) {
          return nd(O, m, D);
        }), F.clear(), m.destination !== null && sd(m, m.destination);
      } catch (O) {
        Kn(m, O), Oo(m, O);
      }
    }
    function Kv(m, D) {
      return new Promise(function(F, O) {
        var W, ee, se = new Promise(function(H, Z) {
          ee = H, W = Z;
        });
        function Ce() {
          var H = new ReadableStream(
            {
              type: "bytes",
              pull: function(Z) {
                Hh(b, Z);
              },
              cancel: function(Z) {
                ld(b);
              }
            },
            // $FlowFixMe size() methods are not allowed on byte streams.
            {
              highWaterMark: 0
            }
          );
          H.allReady = se, F(H);
        }
        function h(H) {
          se.catch(function() {
          }), O(H);
        }
        var b = Nv(m, hn(D ? D.identifierPrefix : void 0, D ? D.nonce : void 0, D ? D.bootstrapScriptContent : void 0, D ? D.bootstrapScripts : void 0, D ? D.bootstrapModules : void 0), _n(D ? D.namespaceURI : void 0), D ? D.progressiveChunkSize : void 0, D ? D.onError : void 0, ee, Ce, h, W);
        if (D && D.signal) {
          var x = D.signal, S = function() {
            ld(b, x.reason), x.removeEventListener("abort", S);
          };
          x.addEventListener("abort", S);
        }
        Gv(b);
      });
    }
    Gh.renderToReadableStream = Kv, Gh.version = t;
  }()), Gh;
}
var Zu, Cb;
process.env.NODE_ENV === "production" ? (Zu = QT(), Cb = XT()) : (Zu = ZT(), Cb = JT());
Zu.version;
var eS = Zu.renderToString;
Zu.renderToStaticMarkup;
Zu.renderToNodeStream;
Zu.renderToStaticNodeStream;
Cb.renderToReadableStream;
function tS(e) {
  const t = qt(e == null ? void 0 : e.current);
  return gt(() => {
    e && (e.current = t.current);
  }, [e]), t;
}
const rS = kn(null);
function iS({ error: e, styleSheets: t, root: r }) {
  switch (e == null ? void 0 : e.name) {
    case "NotSupportedError":
      t.length > 0 && r && (r.adoptedStyleSheets = t);
      break;
    default:
      throw e;
  }
}
function nS({ children: e = "", ...t }) {
  let r = "";
  return ht.isValidElement(e) ? r = eS(e) : typeof e == "string" && (r = e), /* @__PURE__ */ v.jsx("template", { ...t, dangerouslySetInnerHTML: { __html: r } });
}
function aS({ root: e, children: t = null }) {
  return t8(t, e);
}
function oS(e) {
  return Je(
    ({
      mode: r = "open",
      delegatesFocus: i = !1,
      styleSheets: n = [],
      ssr: a = !1,
      children: o = null,
      ...s
    }, l) => {
      const u = tS(l), [d, c] = rt(null), p = `node_${r}${i}`;
      return Xu(() => {
        if (u.current)
          try {
            if (typeof l == "function" && l(u.current), a) {
              const { shadowRoot: g } = u.current;
              c(g);
              return;
            }
            const f = u.current.attachShadow({
              mode: r,
              delegatesFocus: i
            });
            n.length > 0 && (f.adoptedStyleSheets = n), c(f);
          } catch (f) {
            iS({ error: f, styleSheets: n, root: d });
          }
      }, [l, u, n]), /* @__PURE__ */ v.jsx(e.tag, { ref: u, ...s, children: (d || a) && /* @__PURE__ */ v.jsx(rS.Provider, { value: d, children: a ? /* @__PURE__ */ v.jsx(nS, { shadowroot: r, shadowrootmode: r, children: e.render({
        root: d,
        ssr: a,
        children: o
      }) }) : /* @__PURE__ */ v.jsx(aS, { root: d, children: e.render({
        root: d,
        ssr: a,
        children: o
      }) }) }) }, p);
    }
  );
}
const Yv = /* @__PURE__ */ new Map();
function sS(e = {}, t = "core", r = ({ children: i }) => i) {
  return new Proxy(e, {
    get: function(n, a) {
      const o = qT.decamelize(a, { separator: "-" }), s = `${t}-${o}`;
      if (!Yv.has(s)) {
        const l = oS({ tag: o, render: r });
        Yv.set(s, l);
      }
      return Yv.get(s);
    }
  });
}
const lS = sS(), uS = `@layer reset,base,tokens,recipes,utilities;@layer base{:root{--made-with-panda:"🐼"}*,::backdrop,:after,:before{--blur: !important;--brightness: !important;--contrast: !important;--grayscale: !important;--hue-rotate: !important;--invert: !important;--saturate: !important;--sepia: !important;--drop-shadow: !important;--backdrop-blur: !important;--backdrop-brightness: !important;--backdrop-contrast: !important;--backdrop-grayscale: !important;--backdrop-hue-rotate: !important;--backdrop-invert: !important;--backdrop-opacity: !important;--backdrop-saturate: !important;--backdrop-sepia: !important;--scroll-snap-strictness:proximity;--border-spacing-x:0;--border-spacing-y:0;--translate-x:0;--translate-y:0;--rotate:0;--skew-x:0;--skew-y:0;--scale-x:1;--scale-y:1}:where(.inkeep-widget-vars) pre{padding:var(--ikp-spacing-0);background:var(--ikp-colors-transparent)}:where(.inkeep-widget-vars){font-family:var(--ikp-fonts-body,inherit);color:var(--ikp-colors-gray-800)}.dark :where(.inkeep-widget-vars),[data-theme=dark] :where(.inkeep-widget-vars){color:var(--ikp-colors-white-alpha-900);background:var(--ikp-colors-gray-dark-900)}:where(.inkeep-widget-vars){background:var(--ikp-colors-white);line-height:var(--ikp-line-heights-base)}:where(.inkeep-widget-vars) *,:before,:where(.inkeep-widget-vars) *{border-color:var(--ikp-colors-gray-200)}.dark :where(.inkeep-widget-vars) *,[data-theme=dark] :where(.inkeep-widget-vars) *,.dark :where(.inkeep-widget-vars) *,[data-theme=dark] &:after,[data-theme=dark] :before,[data-theme=dark] :where(.inkeep-widget-vars) *{border-color:var(--ikp-colors-white-alpha-300)}:where(.inkeep-widget-vars) body{font-family:var(--ikp-fonts-body);color:var(--ikp-colors-chakra-body-text);background:var(--ikp-colors-chakra-body-bg);--transition-prop:background-color;transition-property:background-color;--transition-duration:var(--ikp-durations-normal);transition-duration:var(--ikp-durations-normal);line-height:var(--ikp-line-heights-base)}:where(.inkeep-widget-vars) ::placeholder{color:var(--ikp-colors-chakra-placeholder-color)}}@layer tokens{:where(.inkeep-widget-vars){--ikp-blurs-sm:4px;--ikp-blurs-base:8px;--ikp-blurs-md:12px;--ikp-blurs-lg:16px;--ikp-blurs-xl:24px;--ikp-blurs-2xl:40px;--ikp-blurs-3xl:64px;--ikp-spacing-0:0rem;--ikp-spacing-1:.25rem;--ikp-spacing-2:.5rem;--ikp-spacing-3:.75rem;--ikp-spacing-4:1rem;--ikp-spacing-5:1.25rem;--ikp-spacing-6:1.5rem;--ikp-spacing-7:1.75rem;--ikp-spacing-8:2rem;--ikp-spacing-9:2.25rem;--ikp-spacing-10:2.5rem;--ikp-spacing-11:2.75rem;--ikp-spacing-12:3rem;--ikp-spacing-14:3.5rem;--ikp-spacing-16:4rem;--ikp-spacing-20:5rem;--ikp-spacing-24:6rem;--ikp-spacing-28:7rem;--ikp-spacing-32:8rem;--ikp-spacing-36:9rem;--ikp-spacing-40:10rem;--ikp-spacing-44:11rem;--ikp-spacing-48:12rem;--ikp-spacing-52:13rem;--ikp-spacing-56:14rem;--ikp-spacing-60:15rem;--ikp-spacing-64:16rem;--ikp-spacing-72:18rem;--ikp-spacing-80:20rem;--ikp-spacing-96:24rem;--ikp-spacing-0\\.5:.125rem;--ikp-spacing-1\\.5:.375rem;--ikp-spacing-2\\.5:.625rem;--ikp-spacing-3\\.5:.875rem;--ikp-borders-none:0;--ikp-borders-1px:1px solid;--ikp-borders-2px:2px solid;--ikp-borders-4px:4px solid;--ikp-borders-8px:8px solid;--ikp-font-sizes-3xs:.45rem;--ikp-font-sizes-2xs:.625rem;--ikp-font-sizes-xs:.75rem;--ikp-font-sizes-sm:.875rem;--ikp-font-sizes-md:1rem;--ikp-font-sizes-lg:1.125rem;--ikp-font-sizes-xl:1.25rem;--ikp-font-sizes-2xl:1.5rem;--ikp-font-sizes-3xl:1.875rem;--ikp-font-sizes-4xl:2.25rem;--ikp-font-sizes-5xl:3rem;--ikp-font-sizes-6xl:3.75rem;--ikp-font-sizes-7xl:4.5rem;--ikp-font-sizes-8xl:6rem;--ikp-font-sizes-9xl:8rem;--ikp-font-weights-extralight:200;--ikp-font-weights-hairline:100;--ikp-font-weights-thin:200;--ikp-font-weights-light:300;--ikp-font-weights-normal:400;--ikp-font-weights-medium:500;--ikp-font-weights-semibold:600;--ikp-font-weights-bold:700;--ikp-font-weights-extrabold:800;--ikp-font-weights-black:900;--ikp-letter-spacings-tighter:-.05em;--ikp-letter-spacings-tight:-.025em;--ikp-letter-spacings-normal:0;--ikp-letter-spacings-wide:.025em;--ikp-letter-spacings-wider:.05em;--ikp-letter-spacings-widest:.1em;--ikp-line-heights-3:.75rem;--ikp-line-heights-4:1rem;--ikp-line-heights-5:1.25rem;--ikp-line-heights-6:1.5rem;--ikp-line-heights-7:1.75rem;--ikp-line-heights-8:2rem;--ikp-line-heights-9:2.25rem;--ikp-line-heights-10:2.5rem;--ikp-line-heights-tight:1.25;--ikp-line-heights-snug:1.375;--ikp-line-heights-relaxed:1.625;--ikp-line-heights-loose:2;--ikp-line-heights-normal:normal;--ikp-line-heights-none:1;--ikp-line-heights-shorter:1.25;--ikp-line-heights-short:1.375;--ikp-line-heights-base:1.5;--ikp-line-heights-tall:1.625;--ikp-line-heights-taller:2;--ikp-radii-xs:.125rem;--ikp-radii-none:0;--ikp-radii-sm:.125rem;--ikp-radii-base:.25rem;--ikp-radii-md:.375rem;--ikp-radii-lg:.5rem;--ikp-radii-xl:.75rem;--ikp-radii-2xl:1rem;--ikp-radii-3xl:1.5rem;--ikp-radii-full:9999px;--ikp-sizes-0:0;--ikp-sizes-1:.25rem;--ikp-sizes-2:.5rem;--ikp-sizes-3:.75rem;--ikp-sizes-4:1rem;--ikp-sizes-5:1.25rem;--ikp-sizes-6:1.5rem;--ikp-sizes-7:1.75rem;--ikp-sizes-8:2rem;--ikp-sizes-9:2.25rem;--ikp-sizes-10:2.5rem;--ikp-sizes-11:2.75rem;--ikp-sizes-12:3rem;--ikp-sizes-14:3.5rem;--ikp-sizes-16:4rem;--ikp-sizes-20:5rem;--ikp-sizes-24:6rem;--ikp-sizes-28:7rem;--ikp-sizes-32:8rem;--ikp-sizes-36:9rem;--ikp-sizes-40:10rem;--ikp-sizes-44:11rem;--ikp-sizes-48:12rem;--ikp-sizes-52:13rem;--ikp-sizes-56:14rem;--ikp-sizes-60:15rem;--ikp-sizes-64:16rem;--ikp-sizes-72:18rem;--ikp-sizes-80:20rem;--ikp-sizes-96:24rem;--ikp-sizes-fit:fit-content;--ikp-sizes-auto:auto;--ikp-sizes-none:none;--ikp-sizes-px:1px;--ikp-sizes-0\\.5:.125rem;--ikp-sizes-1\\.5:.375rem;--ikp-sizes-2\\.5:.625rem;--ikp-sizes-3\\.5:.875rem;--ikp-sizes-max:max-content;--ikp-sizes-min:min-content;--ikp-sizes-full:100%;--ikp-sizes-3xs:14rem;--ikp-sizes-2xs:16rem;--ikp-sizes-xs:20rem;--ikp-sizes-sm:24rem;--ikp-sizes-md:28rem;--ikp-sizes-lg:32rem;--ikp-sizes-xl:36rem;--ikp-sizes-2xl:42rem;--ikp-sizes-3xl:48rem;--ikp-sizes-4xl:56rem;--ikp-sizes-5xl:64rem;--ikp-sizes-6xl:72rem;--ikp-sizes-7xl:80rem;--ikp-sizes-8xl:90rem;--ikp-sizes-prose:60ch;--ikp-sizes-container-sm:640px;--ikp-sizes-container-md:768px;--ikp-sizes-container-lg:1024px;--ikp-sizes-container-xl:1280px;--ikp-sizes-breakpoint-md:768px;--ikp-sizes-breakpoint-lg:1024px;--ikp-sizes-breakpoint-xl:1280px;--ikp-sizes-breakpoint-2xl:1536px;--ikp-sizes-breakpoint-sm:33em;--ikp-space-0:0;--ikp-space-1:.25rem;--ikp-space-2:.5rem;--ikp-space-3:.75rem;--ikp-space-4:1rem;--ikp-space-5:1.25rem;--ikp-space-6:1.5rem;--ikp-space-7:1.75rem;--ikp-space-8:2rem;--ikp-space-9:2.25rem;--ikp-space-10:2.5rem;--ikp-space-12:3rem;--ikp-space-14:3.5rem;--ikp-space-16:4rem;--ikp-space-20:5rem;--ikp-space-24:6rem;--ikp-space-28:7rem;--ikp-space-32:8rem;--ikp-space-36:9rem;--ikp-space-40:10rem;--ikp-space-44:11rem;--ikp-space-48:12rem;--ikp-space-52:13rem;--ikp-space-56:14rem;--ikp-space-60:15rem;--ikp-space-64:16rem;--ikp-space-72:18rem;--ikp-space-80:20rem;--ikp-space-96:24rem;--ikp-space-auto:auto;--ikp-space-none:none;--ikp-space-px:1px;--ikp-space-0\\.5:.125rem;--ikp-space-1\\.5:.375rem;--ikp-space-2\\.5:.625rem;--ikp-space-3\\.5:.875rem;--ikp-z-index-hide:-1;--ikp-z-index-auto:auto;--ikp-z-index-base:0;--ikp-z-index-docked:10;--ikp-z-index-dropdown:1000;--ikp-z-index-sticky:1100;--ikp-z-index-banner:1200;--ikp-z-index-overlay:1300;--ikp-z-index-modal:1400;--ikp-z-index-popover:1500;--ikp-z-index-skip-link:1600;--ikp-z-index-toast:1700;--ikp-z-index-tooltip:1800;--ikp-colors-rose-50:#fff1f2;--ikp-colors-rose-100:#ffe4e6;--ikp-colors-rose-200:#fecdd3;--ikp-colors-rose-300:#fda4af;--ikp-colors-rose-400:#fb7185;--ikp-colors-rose-500:#f43f5e;--ikp-colors-rose-600:#e11d48;--ikp-colors-rose-700:#be123c;--ikp-colors-rose-800:#9f1239;--ikp-colors-rose-900:#881337;--ikp-colors-rose-950:#4c0519;--ikp-colors-fuchsia-50:#fdf4ff;--ikp-colors-fuchsia-100:#fae8ff;--ikp-colors-fuchsia-200:#f5d0fe;--ikp-colors-fuchsia-300:#f0abfc;--ikp-colors-fuchsia-400:#e879f9;--ikp-colors-fuchsia-500:#d946ef;--ikp-colors-fuchsia-600:#c026d3;--ikp-colors-fuchsia-700:#a21caf;--ikp-colors-fuchsia-800:#86198f;--ikp-colors-fuchsia-900:#701a75;--ikp-colors-fuchsia-950:#4a044e;--ikp-colors-violet-50:#f5f3ff;--ikp-colors-violet-100:#ede9fe;--ikp-colors-violet-200:#ddd6fe;--ikp-colors-violet-300:#c4b5fd;--ikp-colors-violet-400:#a78bfa;--ikp-colors-violet-500:#8b5cf6;--ikp-colors-violet-600:#7c3aed;--ikp-colors-violet-700:#6d28d9;--ikp-colors-violet-800:#5b21b6;--ikp-colors-violet-900:#4c1d95;--ikp-colors-violet-950:#2e1065;--ikp-colors-indigo-50:#eef2ff;--ikp-colors-indigo-100:#e0e7ff;--ikp-colors-indigo-200:#c7d2fe;--ikp-colors-indigo-300:#a5b4fc;--ikp-colors-indigo-400:#818cf8;--ikp-colors-indigo-500:#6366f1;--ikp-colors-indigo-600:#4f46e5;--ikp-colors-indigo-700:#4338ca;--ikp-colors-indigo-800:#3730a3;--ikp-colors-indigo-900:#312e81;--ikp-colors-indigo-950:#1e1b4b;--ikp-colors-sky-50:#f0f9ff;--ikp-colors-sky-100:#e0f2fe;--ikp-colors-sky-200:#bae6fd;--ikp-colors-sky-300:#7dd3fc;--ikp-colors-sky-400:#38bdf8;--ikp-colors-sky-500:#0ea5e9;--ikp-colors-sky-600:#0284c7;--ikp-colors-sky-700:#0369a1;--ikp-colors-sky-800:#075985;--ikp-colors-sky-900:#0c4a6e;--ikp-colors-sky-950:#082f49;--ikp-colors-emerald-50:#ecfdf5;--ikp-colors-emerald-100:#d1fae5;--ikp-colors-emerald-200:#a7f3d0;--ikp-colors-emerald-300:#6ee7b7;--ikp-colors-emerald-400:#34d399;--ikp-colors-emerald-500:#10b981;--ikp-colors-emerald-600:#059669;--ikp-colors-emerald-700:#047857;--ikp-colors-emerald-800:#065f46;--ikp-colors-emerald-900:#064e3b;--ikp-colors-emerald-950:#022c22;--ikp-colors-lime-50:#f7fee7;--ikp-colors-lime-100:#ecfccb;--ikp-colors-lime-200:#d9f99d;--ikp-colors-lime-300:#bef264;--ikp-colors-lime-400:#a3e635;--ikp-colors-lime-500:#84cc16;--ikp-colors-lime-600:#65a30d;--ikp-colors-lime-700:#4d7c0f;--ikp-colors-lime-800:#3f6212;--ikp-colors-lime-900:#365314;--ikp-colors-lime-950:#1a2e05;--ikp-colors-amber-50:#fffbeb;--ikp-colors-amber-100:#fef3c7;--ikp-colors-amber-200:#fde68a;--ikp-colors-amber-300:#fcd34d;--ikp-colors-amber-400:#fbbf24;--ikp-colors-amber-500:#f59e0b;--ikp-colors-amber-600:#d97706;--ikp-colors-amber-700:#b45309;--ikp-colors-amber-800:#92400e;--ikp-colors-amber-900:#78350f;--ikp-colors-amber-950:#451a03;--ikp-colors-neutral-50:#fafafa;--ikp-colors-neutral-100:#f5f5f5;--ikp-colors-neutral-200:#e5e5e5;--ikp-colors-neutral-300:#d4d4d4;--ikp-colors-neutral-400:#a3a3a3;--ikp-colors-neutral-500:#737373;--ikp-colors-neutral-600:#525252;--ikp-colors-neutral-700:#404040;--ikp-colors-neutral-800:#262626;--ikp-colors-neutral-900:#171717;--ikp-colors-neutral-950:#0a0a0a;--ikp-colors-stone-50:#fafaf9;--ikp-colors-stone-100:#f5f5f4;--ikp-colors-stone-200:#e7e5e4;--ikp-colors-stone-300:#d6d3d1;--ikp-colors-stone-400:#a8a29e;--ikp-colors-stone-500:#78716c;--ikp-colors-stone-600:#57534e;--ikp-colors-stone-700:#44403c;--ikp-colors-stone-800:#292524;--ikp-colors-stone-900:#1c1917;--ikp-colors-stone-950:#0c0a09;--ikp-colors-zinc-50:#fafafa;--ikp-colors-zinc-100:#f4f4f5;--ikp-colors-zinc-200:#e4e4e7;--ikp-colors-zinc-300:#d4d4d8;--ikp-colors-zinc-400:#a1a1aa;--ikp-colors-zinc-500:#71717a;--ikp-colors-zinc-600:#52525b;--ikp-colors-zinc-700:#3f3f46;--ikp-colors-zinc-800:#27272a;--ikp-colors-zinc-900:#18181b;--ikp-colors-zinc-950:#09090b;--ikp-colors-slate-50:#f8fafc;--ikp-colors-slate-100:#f1f5f9;--ikp-colors-slate-200:#e2e8f0;--ikp-colors-slate-300:#cbd5e1;--ikp-colors-slate-400:#94a3b8;--ikp-colors-slate-500:#64748b;--ikp-colors-slate-600:#475569;--ikp-colors-slate-700:#334155;--ikp-colors-slate-800:#1e293b;--ikp-colors-slate-900:#0f172a;--ikp-colors-slate-950:#020617;--ikp-colors-transparent:transparent;--ikp-colors-current:currentColor;--ikp-colors-black:#000000;--ikp-colors-white:#FFFFFF;--ikp-colors-white-alpha-50:rgba(255,255,255,.04);--ikp-colors-white-alpha-100:rgba(255,255,255,.06);--ikp-colors-white-alpha-200:rgba(255,255,255,.08);--ikp-colors-white-alpha-300:rgba(255,255,255,.16);--ikp-colors-white-alpha-400:rgba(255,255,255,.24);--ikp-colors-white-alpha-500:rgba(255,255,255,.36);--ikp-colors-white-alpha-600:rgba(255,255,255,.48);--ikp-colors-white-alpha-700:rgba(255,255,255,.64);--ikp-colors-white-alpha-800:rgba(255,255,255,.8);--ikp-colors-white-alpha-900:rgba(255,255,255,.92);--ikp-colors-black-alpha-50:rgba(0,0,0,.04);--ikp-colors-black-alpha-100:rgba(0,0,0,.06);--ikp-colors-black-alpha-200:rgba(0,0,0,.08);--ikp-colors-black-alpha-300:rgba(0,0,0,.16);--ikp-colors-black-alpha-400:rgba(0,0,0,.24);--ikp-colors-black-alpha-500:rgba(0,0,0,.36);--ikp-colors-black-alpha-600:rgba(0,0,0,.48);--ikp-colors-black-alpha-700:rgba(0,0,0,.64);--ikp-colors-black-alpha-800:rgba(0,0,0,.8);--ikp-colors-black-alpha-900:rgba(0,0,0,.92);--ikp-colors-red-50:#FFF5F5;--ikp-colors-red-100:#FED7D7;--ikp-colors-red-200:#FEB2B2;--ikp-colors-red-300:#FC8181;--ikp-colors-red-400:#F56565;--ikp-colors-red-500:#E53E3E;--ikp-colors-red-600:#C53030;--ikp-colors-red-700:#9B2C2C;--ikp-colors-red-800:#822727;--ikp-colors-red-900:#63171B;--ikp-colors-red-950:#450a0a;--ikp-colors-orange-50:#FFFAF0;--ikp-colors-orange-100:#FEEBC8;--ikp-colors-orange-200:#FBD38D;--ikp-colors-orange-300:#F6AD55;--ikp-colors-orange-400:#ED8936;--ikp-colors-orange-500:#DD6B20;--ikp-colors-orange-600:#C05621;--ikp-colors-orange-700:#9C4221;--ikp-colors-orange-800:#7B341E;--ikp-colors-orange-900:#652B19;--ikp-colors-orange-950:#431407;--ikp-colors-yellow-50:#FFFFF0;--ikp-colors-yellow-100:#FEFCBF;--ikp-colors-yellow-200:#FAF089;--ikp-colors-yellow-300:#F6E05E;--ikp-colors-yellow-400:#ECC94B;--ikp-colors-yellow-500:#D69E2E;--ikp-colors-yellow-600:#B7791F;--ikp-colors-yellow-700:#975A16;--ikp-colors-yellow-800:#744210;--ikp-colors-yellow-900:#5F370E;--ikp-colors-yellow-950:#422006;--ikp-colors-green-50:#F0FFF4;--ikp-colors-green-100:#C6F6D5;--ikp-colors-green-200:#9AE6B4;--ikp-colors-green-300:#68D391;--ikp-colors-green-400:#48BB78;--ikp-colors-green-500:#38A169;--ikp-colors-green-600:#2F855A;--ikp-colors-green-700:#276749;--ikp-colors-green-800:#22543D;--ikp-colors-green-900:#1C4532;--ikp-colors-green-950:#052e16;--ikp-colors-teal-50:#E6FFFA;--ikp-colors-teal-100:#B2F5EA;--ikp-colors-teal-200:#81E6D9;--ikp-colors-teal-300:#4FD1C5;--ikp-colors-teal-400:#38B2AC;--ikp-colors-teal-500:#319795;--ikp-colors-teal-600:#2C7A7B;--ikp-colors-teal-700:#285E61;--ikp-colors-teal-800:#234E52;--ikp-colors-teal-900:#1D4044;--ikp-colors-teal-950:#042f2e;--ikp-colors-blue-50:#ebf8ff;--ikp-colors-blue-100:#bee3f8;--ikp-colors-blue-200:#90cdf4;--ikp-colors-blue-300:#63b3ed;--ikp-colors-blue-400:#4299e1;--ikp-colors-blue-500:#3182ce;--ikp-colors-blue-600:#2b6cb0;--ikp-colors-blue-700:#2c5282;--ikp-colors-blue-800:#2a4365;--ikp-colors-blue-900:#1A365D;--ikp-colors-blue-950:#172554;--ikp-colors-cyan-50:#EDFDFD;--ikp-colors-cyan-100:#C4F1F9;--ikp-colors-cyan-200:#9DECF9;--ikp-colors-cyan-300:#76E4F7;--ikp-colors-cyan-400:#0BC5EA;--ikp-colors-cyan-500:#00B5D8;--ikp-colors-cyan-600:#00A3C4;--ikp-colors-cyan-700:#0987A0;--ikp-colors-cyan-800:#086F83;--ikp-colors-cyan-900:#065666;--ikp-colors-cyan-950:#083344;--ikp-colors-purple-50:#FAF5FF;--ikp-colors-purple-100:#E9D8FD;--ikp-colors-purple-200:#D6BCFA;--ikp-colors-purple-300:#B794F4;--ikp-colors-purple-400:#9F7AEA;--ikp-colors-purple-500:#805AD5;--ikp-colors-purple-600:#6B46C1;--ikp-colors-purple-700:#553C9A;--ikp-colors-purple-800:#44337A;--ikp-colors-purple-900:#322659;--ikp-colors-purple-950:#3b0764;--ikp-colors-pink-50:#FFF5F7;--ikp-colors-pink-100:#FED7E2;--ikp-colors-pink-200:#FBB6CE;--ikp-colors-pink-300:#F687B3;--ikp-colors-pink-400:#ED64A6;--ikp-colors-pink-500:#D53F8C;--ikp-colors-pink-600:#B83280;--ikp-colors-pink-700:#97266D;--ikp-colors-pink-800:#702459;--ikp-colors-pink-900:#521B41;--ikp-colors-pink-950:#500724;--ikp-colors-linkedin-50:#E8F4F9;--ikp-colors-linkedin-100:#CFEDFB;--ikp-colors-linkedin-200:#9BDAF3;--ikp-colors-linkedin-300:#68C7EC;--ikp-colors-linkedin-400:#34B3E4;--ikp-colors-linkedin-500:#00A0DC;--ikp-colors-linkedin-600:#008CC9;--ikp-colors-linkedin-700:#0077B5;--ikp-colors-linkedin-800:#005E93;--ikp-colors-linkedin-900:#004471;--ikp-colors-facebook-50:#E8F4F9;--ikp-colors-facebook-100:#D9DEE9;--ikp-colors-facebook-200:#B7C2DA;--ikp-colors-facebook-300:#6482C0;--ikp-colors-facebook-400:#4267B2;--ikp-colors-facebook-500:#385898;--ikp-colors-facebook-600:#314E89;--ikp-colors-facebook-700:#29487D;--ikp-colors-facebook-800:#223B67;--ikp-colors-facebook-900:#1E355B;--ikp-colors-messenger-50:#D0E6FF;--ikp-colors-messenger-100:#B9DAFF;--ikp-colors-messenger-200:#A2CDFF;--ikp-colors-messenger-300:#7AB8FF;--ikp-colors-messenger-400:#2E90FF;--ikp-colors-messenger-500:#0078FF;--ikp-colors-messenger-600:#0063D1;--ikp-colors-messenger-700:#0052AC;--ikp-colors-messenger-800:#003C7E;--ikp-colors-messenger-900:#002C5C;--ikp-colors-whatsapp-50:#dffeec;--ikp-colors-whatsapp-100:#b9f5d0;--ikp-colors-whatsapp-200:#90edb3;--ikp-colors-whatsapp-300:#65e495;--ikp-colors-whatsapp-400:#3cdd78;--ikp-colors-whatsapp-500:#22c35e;--ikp-colors-whatsapp-600:#179848;--ikp-colors-whatsapp-700:#0c6c33;--ikp-colors-whatsapp-800:#01421c;--ikp-colors-whatsapp-900:#001803;--ikp-colors-twitter-50:#E5F4FD;--ikp-colors-twitter-100:#C8E9FB;--ikp-colors-twitter-200:#A8DCFA;--ikp-colors-twitter-300:#83CDF7;--ikp-colors-twitter-400:#57BBF5;--ikp-colors-twitter-500:#1DA1F2;--ikp-colors-twitter-600:#1A94DA;--ikp-colors-twitter-700:#1681BF;--ikp-colors-twitter-800:#136B9E;--ikp-colors-twitter-900:#0D4D71;--ikp-colors-telegram-50:#E3F2F9;--ikp-colors-telegram-100:#C5E4F3;--ikp-colors-telegram-200:#A2D4EC;--ikp-colors-telegram-300:#7AC1E4;--ikp-colors-telegram-400:#47A9DA;--ikp-colors-telegram-500:#0088CC;--ikp-colors-telegram-600:#007AB8;--ikp-colors-telegram-700:#006BA1;--ikp-colors-telegram-800:#005885;--ikp-colors-telegram-900:#003F5E;--ikp-colors-gray-50:#f8f9fa;--ikp-colors-gray-100:#f1f3f5;--ikp-colors-gray-200:#eceef0;--ikp-colors-gray-300:#e6e8eb;--ikp-colors-gray-400:#dfe3e6;--ikp-colors-gray-500:#BDC2C7;--ikp-colors-gray-600:#889096;--ikp-colors-gray-700:#687076;--ikp-colors-gray-800:#36424A;--ikp-colors-gray-900:#11181c;--ikp-colors-gray-950:#030712;--ikp-colors-gray-alpha-50:rgba(22,56,90,.03);--ikp-colors-gray-alpha-100:rgba(22,56,90,.06);--ikp-colors-gray-alpha-200:rgba(18,43,68,.08);--ikp-colors-gray-alpha-300:rgba(5,26,56,.1);--ikp-colors-gray-alpha-400:rgba(9,39,62,.13);--ikp-colors-gray-alpha-500:rgba(1,20,40,.26);--ikp-colors-gray-alpha-600:rgba(2,20,34,.47);--ikp-colors-gray-alpha-700:rgba(3,17,28,.6);--ikp-colors-gray-alpha-800:rgba(1,15,25,.79);--ikp-colors-gray-alpha-900:rgba(2,9,13,.94);--ikp-colors-gray-dark-50:#ededed;--ikp-colors-gray-dark-100:#a0a0a0;--ikp-colors-gray-dark-200:#7e7e7e;--ikp-colors-gray-dark-300:#707070;--ikp-colors-gray-dark-400:#505050;--ikp-colors-gray-dark-500:#3e3e3e;--ikp-colors-gray-dark-600:#343434;--ikp-colors-gray-dark-700:#2e2e2e;--ikp-colors-gray-dark-800:#282828;--ikp-colors-gray-dark-900:#1c1c1c;--ikp-fonts-sans:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";--ikp-fonts-serif:ui-serif,Georgia,Cambria,"Times New Roman",Times,serif;--ikp-fonts-mono:SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;--ikp-fonts-body:"Inter",sans-serif;--ikp-fonts-heading:"Inter",sans-serif;--ikp-easings-linear:linear;--ikp-easings-in:cubic-bezier(.4,0,1,1);--ikp-easings-out:cubic-bezier(0,0,.2,1);--ikp-easings-in-out:cubic-bezier(.4,0,.2,1);--ikp-easings-default:cubic-bezier(.2,0,0,1);--ikp-easings-emphasized-in:cubic-bezier(.05,.7,.1,1);--ikp-easings-emphasized-out:cubic-bezier(.3,0,.8,.15);--ikp-animations-spin:spin 1s linear infinite;--ikp-animations-ping:ping 1s cubic-bezier(0,0,.2,1) infinite;--ikp-animations-pulse:pulse 2s cubic-bezier(.4,0,.6,1) infinite;--ikp-animations-bounce:bounce 1s infinite;--ikp-animations-backdrop-in:fade-in .25s var(--ikp-easings-default);--ikp-animations-backdrop-out:fade-out .2s var(--ikp-easings-default);--ikp-animations-dialog-in:slide-in .4s var(--ikp-easings-emphasized-in);--ikp-animations-dialog-out:slide-out .2s var(--ikp-easings-emphasized-out);--ikp-durations-fastest:50ms;--ikp-durations-normal:.2s;--ikp-durations-slower:.4s;--ikp-durations-slowest:.5s;--ikp-durations-faster:.1s;--ikp-durations-fast:.18s;--ikp-durations-medium:.3s;--ikp-durations-slow:.5s;--ikp-shadows-xs:0px 1px 2px rgba(23,23,23,.1);--ikp-shadows-sm:0px 2px 4px rgba(23,23,23,.1);--ikp-shadows-base:0 1px 3px 0 rgba(0,0,0,.1),0 1px 2px 0 rgba(0,0,0,.06);--ikp-shadows-md:0px 4px 8px rgba(23,23,23,.1);--ikp-shadows-lg:0px 8px 16px rgba(23,23,23,.1);--ikp-shadows-xl:0px 16px 24px rgba(23,23,23,.1);--ikp-shadows-2xl:0 25px 50px -12px rgba(0,0,0,.25);--ikp-shadows-inner:inset 0 2px 4px 0 rgba(0,0,0,.06);--ikp-shadows-none:none;--ikp-shadows-dark-lg:rgba(0,0,0,.1) 0px 0px 0px 1px,rgba(0,0,0,.2) 0px 5px 10px,rgba(0,0,0,.4) 0px 15px 40px;--ikp-shadows-outline:0 0 0 1px var(--ikp-colors-border-outline);--ikp-shadows-box-shadow:none;--ikp-shadows-tooltip-shadow:0 8px 30px rgba(0,0,0,.12);--ikp-breakpoints-md:768px;--ikp-breakpoints-lg:1024px;--ikp-breakpoints-xl:1280px;--ikp-breakpoints-2xl:1536px;--ikp-breakpoints-sm:33em;--ikp-shadows-accent:0 0 0 1px var(--ikp-colors-border-accent);--ikp-colors-chakra-body-text:var(--ikp-colors-gray-800);--ikp-colors-chakra-body-bg:white;--ikp-colors-chakra-border-color:var(--ikp-colors-gray-200);--ikp-colors-chakra-inverse-text:white;--ikp-colors-chakra-subtle-bg:var(--ikp-colors-gray-100);--ikp-colors-chakra-subtle-text:var(--ikp-colors-gray-600);--ikp-colors-chakra-placeholder-color:var(--ikp-colors-gray-500);--ikp-colors-background:var(--ikp-colors-white);--ikp-colors-foreground:var(--ikp-colors-gray-700);--ikp-colors-bg-canvas:var(--ikp-colors-gray-25);--ikp-colors-bg-default:var(--ikp-colors-white);--ikp-colors-bg-subtle:var(--ikp-colors-gray-100);--ikp-colors-bg-muted:var(--ikp-colors-gray-200);--ikp-colors-bg-emphasized:var(--ikp-colors-gray-300);--ikp-colors-bg-disabled:var(--ikp-colors-gray-200);--ikp-colors-fg-default:var(--ikp-colors-gray-950);--ikp-colors-fg-emphasized:var(--ikp-colors-gray-700);--ikp-colors-fg-muted:var(--ikp-colors-gray-600);--ikp-colors-fg-subtle:var(--ikp-colors-gray-500);--ikp-colors-fg-disabled:var(--ikp-colors-gray-300);--ikp-colors-accent-default:var(--ikp-colors-gray-950);--ikp-colors-accent-emphasized:var(--ikp-colors-gray-800);--ikp-colors-accent-fg:var(--ikp-colors-white);--ikp-colors-border-default:var(--ikp-colors-gray-200);--ikp-colors-border-emphasized:var(--ikp-colors-gray-300);--ikp-colors-border-outline:var(--ikp-colors-gray-600);--ikp-colors-border-accent:var(--ikp-colors-gray-900);--ikp-colors-border-disabled:var(--ikp-colors-gray-200);--ikp-colors-inkeep-primary-hit-content-preview:#000;--ikp-colors-inkeep-primary-hit-content-preview-hover:#000;--ikp-colors-inkeep-primary-text-bold:#1b1b1b;--ikp-colors-inkeep-primary-text-subtle:#474747;--ikp-colors-inkeep-primary-lighter:#f9f9f9;--ikp-colors-inkeep-primary-light:#dfdfdf;--ikp-colors-inkeep-primary-light-subtle:#f9f9f9;--ikp-colors-inkeep-primary-medium:#000;--ikp-colors-inkeep-primary-medium-subtle:#0000004d;--ikp-colors-inkeep-primary-strong:#000;--ikp-colors-inkeep-primary-stronger:#000;--ikp-colors-inkeep-primary-text-color-on-primary:#ffffff;--ikp-colors-inkeep-expanded-primary-50:#f9f9f9;--ikp-colors-inkeep-expanded-primary-100:#ececec;--ikp-colors-inkeep-expanded-primary-200:#dfdfdf;--ikp-colors-inkeep-expanded-primary-300:#696969;--ikp-colors-inkeep-expanded-primary-400:#353535;--ikp-colors-inkeep-expanded-primary-500:#000;--ikp-colors-inkeep-expanded-primary-600:#000;--ikp-colors-inkeep-expanded-primary-700:#000;--ikp-colors-inkeep-expanded-primary-800:#000;--ikp-colors-inkeep-expanded-primary-900:#000 }:where(.dark,[data-theme=dark]){--ikp-shadows-xs:0px 1px 2px rgba(0,0,0,1);--ikp-shadows-sm:0px 2px 4px rgba(0,0,0,1);--ikp-shadows-md:0px 4px 8px rgba(0,0,0,1);--ikp-shadows-lg:0px 8px 16px rgba(0,0,0,1);--ikp-shadows-xl:0px 16px 24px rgba(0,0,0,1);--ikp-colors-chakra-body-text:var(--ikp-colors-white-alpha-900);--ikp-colors-chakra-body-bg:var(--ikp-colors-gray-800);--ikp-colors-chakra-border-color:var(--ikp-colors-white-alpha-300);--ikp-colors-chakra-inverse-text:var(--ikp-colors-gray-800);--ikp-colors-chakra-subtle-bg:var(--ikp-colors-gray-700);--ikp-colors-chakra-subtle-text:var(--ikp-colors-gray-400);--ikp-colors-chakra-placeholder-color:var(--ikp-colors-white-alpha-400);--ikp-colors-background:var(--ikp-colors-gray-800);--ikp-colors-foreground:var(--ikp-colors-gray-100);--ikp-colors-bg-canvas:var(--ikp-colors-gray-950);--ikp-colors-bg-default:var(--ikp-colors-gray-800);--ikp-colors-bg-subtle:var(--ikp-colors-gray-900);--ikp-colors-bg-muted:var(--ikp-colors-gray-800);--ikp-colors-bg-emphasized:var(--ikp-colors-gray-600);--ikp-colors-bg-disabled:var(--ikp-colors-gray-700);--ikp-colors-fg-default:var(--ikp-colors-white);--ikp-colors-fg-emphasized:var(--ikp-colors-gray-200);--ikp-colors-fg-muted:var(--ikp-colors-gray-300);--ikp-colors-fg-subtle:var(--ikp-colors-gray-400);--ikp-colors-fg-disabled:var(--ikp-colors-gray-700);--ikp-colors-accent-default:var(--ikp-colors-white);--ikp-colors-accent-emphasized:var(--ikp-colors-gray-200);--ikp-colors-accent-fg:var(--ikp-colors-gray-950);--ikp-colors-border-default:var(--ikp-colors-gray-800);--ikp-colors-border-emphasized:var(--ikp-colors-gray-700);--ikp-colors-border-outline:var(--ikp-colors-gray-400);--ikp-colors-border-accent:var(--ikp-colors-white);--ikp-colors-border-disabled:var(--ikp-colors-gray-800) }@keyframes ping{75%,to{transform:scale(2);opacity:0}}@keyframes pulse{50%{opacity:.5}}@keyframes bounce{0%,to{transform:translateY(-25%);animation-timing-function:cubic-bezier(.8,0,1,1)}50%{transform:none;animation-timing-function:cubic-bezier(0,0,.2,1)}}@keyframes checkAnim{0%{opacity:0;stroke-dashoffset:16;transform:scale(.95)}to{opacity:1;stroke-dashoffset:0;transform:scale(1)}}@keyframes indeterminateOpacityAnim{0%{opacity:0}to{opacity:1}}@keyframes indeterminateScaleAnim{0%{transform:scaleX(.65)}to{transform:scaleX(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}@keyframes fade-in{0%{opacity:0}to{opacity:1}}@keyframes fade-out{0%{opacity:1}to{opacity:0}}@keyframes slide-in{0%{opacity:0;transform:translateY(64px)}to{opacity:1;transform:translateY(0)}}@keyframes slide-out{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(64px)}}@keyframes skeleton-bg-fade{0%{border-color:var(--skeleton-start-color);background:var(--skeleton-start-color)}to{border-color:var(--skeleton-end-color);background:var(--skeleton-end-color)}}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes shake-rotate{0%{transform:rotate(0)}7%{transform:rotate(3deg)}15%{transform:rotate(-3deg)}23%{transform:rotate(3deg)}30%{transform:rotate(-3deg)}38%{transform:rotate(3deg)}46%{transform:rotate(-3deg)}54%{transform:rotate(3deg)}62%{transform:rotate(-3deg)}69%{transform:rotate(3deg)}77%{transform:rotate(-3deg)}85%{transform:rotate(3deg)}92%{transform:rotate(-3deg)}to{transform:rotate(0)}}@keyframes shadow-glow{0%{box-shadow:0 0 0 0 var(--ikp-colors-inkeep-expanded-primary-100)}50%{box-shadow:0 0 7px 0 var(--ikp-colors-inkeep-expanded-primary-200)}to{box-shadow:0 0 0 0 var(--ikp-colors-inkeep-expanded-primary-100)}}}@layer recipes{.ikp-btn--colorPalette_blue{--ikp-colors-color-palette-50:var(--ikp-colors-blue-50);--ikp-colors-color-palette-100:var(--ikp-colors-blue-100);--ikp-colors-color-palette-200:var(--ikp-colors-blue-200);--ikp-colors-color-palette-300:var(--ikp-colors-blue-300);--ikp-colors-color-palette-400:var(--ikp-colors-blue-400);--ikp-colors-color-palette-500:var(--ikp-colors-blue-500);--ikp-colors-color-palette-600:var(--ikp-colors-blue-600);--ikp-colors-color-palette-700:var(--ikp-colors-blue-700);--ikp-colors-color-palette-800:var(--ikp-colors-blue-800);--ikp-colors-color-palette-900:var(--ikp-colors-blue-900);--ikp-colors-color-palette-950:var(--ikp-colors-blue-950)}.ikp-btn--colorPalette_teal{--ikp-colors-color-palette-50:var(--ikp-colors-teal-50);--ikp-colors-color-palette-100:var(--ikp-colors-teal-100);--ikp-colors-color-palette-200:var(--ikp-colors-teal-200);--ikp-colors-color-palette-300:var(--ikp-colors-teal-300);--ikp-colors-color-palette-400:var(--ikp-colors-teal-400);--ikp-colors-color-palette-500:var(--ikp-colors-teal-500);--ikp-colors-color-palette-600:var(--ikp-colors-teal-600);--ikp-colors-color-palette-700:var(--ikp-colors-teal-700);--ikp-colors-color-palette-800:var(--ikp-colors-teal-800);--ikp-colors-color-palette-900:var(--ikp-colors-teal-900);--ikp-colors-color-palette-950:var(--ikp-colors-teal-950)}.ikp-btn--colorPalette_inkeepPrimary{--ikp-colors-color-palette-hit-content-preview:var(--ikp-colors-inkeep-primary-hit-content-preview);--ikp-colors-color-palette-hit-content-preview-hover:var(--ikp-colors-inkeep-primary-hit-content-preview-hover);--ikp-colors-color-palette-text-bold:var(--ikp-colors-inkeep-primary-text-bold);--ikp-colors-color-palette-text-subtle:var(--ikp-colors-inkeep-primary-text-subtle);--ikp-colors-color-palette-lighter:var(--ikp-colors-inkeep-primary-lighter);--ikp-colors-color-palette-light:var(--ikp-colors-inkeep-primary-light);--ikp-colors-color-palette-light-subtle:var(--ikp-colors-inkeep-primary-light-subtle);--ikp-colors-color-palette-medium:var(--ikp-colors-inkeep-primary-medium);--ikp-colors-color-palette-medium-subtle:var(--ikp-colors-inkeep-primary-medium-subtle);--ikp-colors-color-palette-strong:var(--ikp-colors-inkeep-primary-strong);--ikp-colors-color-palette-stronger:var(--ikp-colors-inkeep-primary-stronger);--ikp-colors-color-palette-text-color-on-primary:var(--ikp-colors-inkeep-primary-text-color-on-primary)}.ikp-btn--variant_outlineFilled{background:var(--ikp-colors-white);border:1px solid;border-color:var(--ikp-colors-inkeep-primary-strong);color:var(--ikp-colors-inkeep-primary-strong)}.ikp-btn--variant_outlineFilledActive{background:var(--ikp-colors-inkeep-primary-strong);color:var(--ikp-colors-white)}.ikp-btn--variant_filledCTA{background:var(--ikp-colors-inkeep-primary-medium);color:var(--ikp-colors-white);border:var(--ikp-borders-none);border-radius:80px}.ikp-btn--variant_primaryFilled{background:var(--ikp-colors-inkeep-primary-medium);color:var(--ikp-colors-inkeep-primary-text-color-on-primary)}.ikp-btn--size_lg{height:var(--ikp-sizes-12);min-width:var(--ikp-sizes-12);font-size:var(--ikp-font-sizes-lg);padding-inline:var(--ikp-spacing-6)}.ikp-close-btn--size_lg{--btn-bg:var(--ikp-sizes-10);font-size:var(--ikp-font-sizes-md)}.ikp-close-btn--size_sm{--btn-bg:var(--ikp-sizes-6);font-size:var(--ikp-font-sizes-2xs)}.ikp-code--variant_outline{--badge-color:var(--ikp-colors-color-palette-500);--badge-shadow:inset 0 0 0px 1px var(--badge-color,inherit)}.dark .ikp-code--variant_outline,[data-theme=dark] .ikp-code--variant_outline{--badge-bg-alpha:color-mix(in srgb,transparent 80%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) }.ikp-badge--variant_solid{--badge-bg:var(--ikp-colors-color-palette-500);--badge-color:var(--ikp-colors-white)}.dark .ikp-badge--variant_solid,[data-theme=dark] .ikp-badge--variant_solid{--badge-bg-alpha:color-mix(in srgb,transparent 60%,var(--colors-color-palette-500)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-500)) ;--badge-color:var(--ikp-colors-white-alpha-800) }.ikp-badge--variant_subtle{--badge-bg:colorPalette.1;--badge-color:var(--ikp-colors-color-palette-800)}.dark .ikp-badge--variant_subtle,[data-theme=dark] .ikp-badge--variant_subtle{--badge-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) ;--badge-color:var(--ikp-colors-color-palette-200) }.ikp-heading--size_4xl{font-size:var(--ikp-font-sizes-6xl);line-height:1}.ikp-heading--size_3xl{font-size:var(--ikp-font-sizes-5xl);line-height:1}.ikp-heading--size_2xl{font-size:var(--ikp-font-sizes-4xl);line-height:1.2}.ikp-heading--size_lg{font-size:var(--ikp-font-sizes-2xl);line-height:1.33}.ikp-heading--size_xs{font-size:var(--ikp-font-sizes-sm);line-height:1.2}.ikp-heading--uppercase_true{text-transform:uppercase;letter-spacing:1px;font-weight:600;color:var(--ikp-colors-gray-600)}.ikp-icon--variant_dark{color:var(--ikp-colors-white)}.ikp-icon--variant_lightPrimary{color:var(--ikp-colors-inkeep-primary-text-subtle)}.ikp-icon--variant_light{color:var(--ikp-colors-gray-600)}.ikp-kbd--variant_dark{background:primaryDark.9;border-color:primaryDark.6;border-radius:3px;border-bottom:2px solid}.ikp-kbd--variant_dark,.ikp-kbd--variant_darkOutline{color:var(--ikp-colors-white)}.ikp-kbd--variant_darkOutline,.ikp-kbd--variant_light{background:primary.1;border-color:var(--ikp-colors-inkeep-primary-medium);border-radius:3px;border-bottom:2px solid}.ikp-kbd--variant_light{color:var(--ikp-colors-inkeep-primary-medium)}.ikp-kbd--variant_grayLight{background:var(--ikp-colors-gray-400);height:40px;padding:2px 6px;color:var(--ikp-colors-gray-600);border-color:var(--ikp-colors-gray-600);border-radius:3px;border-bottom:2px solid gray.7}.ikp-kbd--variant_outline{box-shadow:var(--ikp-shadows-none)}.ikp-tag--variant_solid{--badge-bg:var(--ikp-colors-color-palette-500);--badge-color:var(--ikp-colors-white)}.dark .ikp-tag--variant_solid,[data-theme=dark] .ikp-tag--variant_solid{--badge-bg-alpha:color-mix(in srgb,transparent 60%,var(--colors-color-palette-500)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-500)) ;--badge-color:var(--ikp-colors-white-alpha-800) }.ikp-tag--variant_outline{--badge-color:var(--ikp-colors-color-palette-500);--badge-shadow:inset 0 0 0px 1px var(--badge-color,inherit)}.dark .ikp-tag--variant_outline,[data-theme=dark] .ikp-tag--variant_outline{--badge-bg-alpha:color-mix(in srgb,transparent 80%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) }.ikp-tag--size_sm{--tag-min-height:var(--ikp-sizes-5);--tag-min-width:var(--ikp-sizes-5);--tag-font-size:var(--ikp-font-sizes-xs);--tag-padding-inline:var(--ikp-space-2)}.ikp-tag--size_md{--tag-min-height:var(--ikp-sizes-6);--tag-min-width:var(--ikp-sizes-6);--tag-font-size:var(--ikp-font-sizes-sm);--tag-padding-inline:var(--ikp-space-2)}.ikp-tag--size_lg{--tag-min-height:var(--ikp-sizes-8);--tag-min-width:var(--ikp-sizes-8);--tag-font-size:var(--ikp-font-sizes-md);--tag-padding-inline:var(--ikp-space-3)}.ikp-tag--variant_subtle{--badge-bg:colorPalette.1;--badge-color:var(--ikp-colors-color-palette-800)}.dark .ikp-tag--variant_subtle,[data-theme=dark] .ikp-tag--variant_subtle{--badge-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) ;--badge-color:var(--ikp-colors-color-palette-200) }.ikp-textarea--variant_flushed{border-bottom:1px solid;border-color:inherit;border-radius:0;padding-inline:var(--ikp-spacing-0);background:var(--ikp-colors-transparent)}.ikp-textarea--variant_flushed:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.ikp-textarea--variant_flushed[aria-invalid=true],.ikp-textarea--variant_flushed[data-invalid] .ikp-textarea--variant_flushed{border-color:var(--input-error-border-color);box-shadow:0 1px 0 0 var(--input-error-border-color)}.ikp-textarea--variant_filled{border:2px solid;border-color:var(--ikp-colors-transparent);background:var(--ikp-colors-gray-100)}.dark .ikp-textarea--variant_filled,[data-theme=dark] .ikp-textarea--variant_filled{background:var(--ikp-colors-white-alpha-50)}.ikp-textarea--variant_filled:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.ikp-textarea--variant_filled[aria-invalid=true],.ikp-textarea--variant_filled[data-invalid] .ikp-textarea--variant_filled{border-color:var(--input-error-border-color)}.ikp-textarea--variant_unstyled{background:var(--ikp-colors-transparent);padding-inline:var(--ikp-spacing-0);height:var(--ikp-sizes-auto)}.ikp-textarea--size_xs{--input-font-size:var(--ikp-font-sizes-xs);--input-padding:var(--ikp-space-2);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-6)}.ikp-textarea--size_sm{--input-font-size:var(--ikp-font-sizes-sm);--input-padding:var(--ikp-space-3);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-8)}.ikp-textarea--size_lg{--input-font-size:var(--ikp-font-sizes-lg);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-12)}.ikp-ai-chat-page-wrapper--size_expand{width:100%;height:100%}.ikp-ai-chat-page-wrapper--size_shrink-vertically{width:100%;height:var(--ikp-sizes-auto);align-self:flex-start;max-height:100%}.ikp-ai-chat-page-wrapper--size_full-viewport{position:fixed;top:var(--ikp-spacing-0);left:var(--ikp-spacing-0);z-index:1000;width:100vw;height:100vh}.ikp-ai-chat-page-wrapper--variant_no-shadow{box-shadow:var(--ikp-shadows-none)}.light .ikp-preview-content-header--variant_title,[data-theme=light] .ikp-preview-content-header--variant_title{color:var(--ikp-colors-inkeep-primary-text-subtle)}.dark .ikp-preview-content-header--variant_title,[data-theme=dark] .ikp-preview-content-header--variant_title{color:var(--ikp-colors-inkeep-primary-lighter)}.light .ikp-preview-content-header--variant_hitContentPreview,[data-theme=light] .ikp-preview-content-header--variant_hitContentPreview{color:var(--ikp-colors-inkeep-primary-hit-content-preview)}.dark .ikp-preview-content-header--variant_hitContentPreview,[data-theme=dark] .ikp-preview-content-header--variant_hitContentPreview{color:var(--ikp-colors-inkeep-expanded-primary-300)}.ikp-btn--variant_unstyled{background:none;color:inherit;display:inline;line-height:inherit;margin:var(--ikp-spacing-0);padding:var(--ikp-spacing-0);border-radius:unset}.ikp-btn--variant_outlinePrimary{border:1px solid}.light .ikp-btn--variant_outlinePrimary,[data-theme=light] .ikp-btn--variant_outlinePrimary{color:var(--ikp-colors-inkeep-primary-strong);border-color:var(--ikp-colors-inkeep-expanded-primary-200)}.dark .ikp-btn--variant_outlinePrimary,[data-theme=dark] .ikp-btn--variant_outlinePrimary{color:var(--ikp-colors-inkeep-expanded-primary-300)}.ikp-btn--variant_chatButton{background:var(--ikp-colors-inkeep-primary-text-bold);box-shadow:var(--ikp-shadows-2xl);border-radius:var(--ikp-radii-lg);color:var(--ikp-colors-white);font-weight:var(--ikp-font-weights-medium)}.dark .ikp-btn--variant_chatButton,[data-theme=dark] .ikp-btn--variant_chatButton{background:var(--ikp-colors-gray-dark-600);box-shadow:var(--ikp-shadows-none)}.ikp-btn--variant_solid{background:var(--ikp-colors-color-palette-500);color:var(--ikp-colors-white)}.dark .ikp-btn--variant_solid,[data-theme=dark] .ikp-btn--variant_solid{background:var(--ikp-colors-color-palette-200);color:var(--ikp-colors-gray-800)}.ikp-btn--variant_outline{border:1px solid;border-color:currentColor;color:var(--ikp-colors-color-palette-600);background:var(--ikp-colors-transparent)}.dark .ikp-btn--variant_outline,[data-theme=dark] .ikp-btn--variant_outline{color:var(--ikp-colors-white-alpha-700)}.light .ikp-btn--variant_outline,[data-theme=light] .ikp-btn--variant_outline{color:var(--ikp-colors-gray-700)}.ikp-btn--size_xs{height:var(--ikp-sizes-6);min-width:var(--ikp-sizes-6);font-size:var(--ikp-font-sizes-xs);padding-inline:var(--ikp-spacing-2)}.ikp-btn--variant_neutralFilled{background:var(--ikp-colors-gray-900);color:var(--ikp-colors-white)}.dark .ikp-btn--variant_neutralFilled,[data-theme=dark] .ikp-btn--variant_neutralFilled{background:var(--ikp-colors-inkeep-expanded-primary-300);color:var(--ikp-colors-gray-dark-900)}.ikp-btn--variant_iconButton{background:var(--ikp-colors-transparent);border-radius:0;padding-inline:var(--ikp-spacing-1);color:var(--ikp-colors-gray-600)}.dark .ikp-btn--variant_iconButton,[data-theme=dark] .ikp-btn--variant_iconButton{color:var(--ikp-colors-white-alpha-600)}.ikp-btn--variant_link{padding:var(--ikp-spacing-0)!important;height:var(--ikp-sizes-auto)!important;line-height:var(--ikp-line-heights-base);vertical-align:baseline;font-weight:var(--ikp-font-weights-normal);color:var(--ikp-colors-color-palette-500)}.dark .ikp-btn--variant_link,[data-theme=dark] .ikp-btn--variant_link{color:var(--ikp-colors-color-palette-200)}.ikp-btn--size_md{height:var(--ikp-sizes-10);min-width:var(--ikp-sizes-10);font-size:var(--ikp-font-sizes-md);padding-inline:var(--ikp-spacing-4)}.ikp-btn--colorPalette_gray{--ikp-colors-color-palette-50:var(--ikp-colors-gray-50);--ikp-colors-color-palette-100:var(--ikp-colors-gray-100);--ikp-colors-color-palette-200:var(--ikp-colors-gray-200);--ikp-colors-color-palette-300:var(--ikp-colors-gray-300);--ikp-colors-color-palette-400:var(--ikp-colors-gray-400);--ikp-colors-color-palette-500:var(--ikp-colors-gray-500);--ikp-colors-color-palette-600:var(--ikp-colors-gray-600);--ikp-colors-color-palette-700:var(--ikp-colors-gray-700);--ikp-colors-color-palette-800:var(--ikp-colors-gray-800);--ikp-colors-color-palette-900:var(--ikp-colors-gray-900);--ikp-colors-color-palette-950:var(--ikp-colors-gray-950)}.ikp-btn--variant_ghost{color:var(--ikp-colors-color-palette-600);background:var(--ikp-colors-transparent)}.dark .ikp-btn--variant_ghost,[data-theme=dark] .ikp-btn--variant_ghost{color:var(--ikp-colors-color-palette-200)}.ikp-btn--size_sm{height:var(--ikp-sizes-8);min-width:var(--ikp-sizes-8);font-size:var(--ikp-font-sizes-sm);padding-inline:var(--ikp-spacing-3)}.ikp-ai-chat-page-wrapper--size_default{max-width:100vw;max-height:100vw;margin:auto;align-self:center;justify-self:center;flex-grow:0}.ikp-ai-chat-page-wrapper--variant_container-with-shadow{box-shadow:var(--ikp-shadows-2xl)}.dark .ikp-ai-chat-page-wrapper--variant_container-with-shadow,[data-theme=dark] .ikp-ai-chat-page-wrapper--variant_container-with-shadow{box-shadow:var(--ikp-shadows-none)}.ikp-code--variant_solid{--badge-bg:var(--ikp-colors-color-palette-500);--badge-color:var(--ikp-colors-white)}.dark .ikp-code--variant_solid,[data-theme=dark] .ikp-code--variant_solid{--badge-bg-alpha:color-mix(in srgb,transparent 60%,var(--colors-color-palette-500)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-500)) ;--badge-color:var(--ikp-colors-white-alpha-800) }.ikp-code--variant_subtle{--badge-bg:colorPalette.1;--badge-color:var(--ikp-colors-color-palette-800)}.dark .ikp-code--variant_subtle,[data-theme=dark] .ikp-code--variant_subtle{--badge-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) ;--badge-color:var(--ikp-colors-color-palette-200) }.ikp-heading--size_sm{font-size:var(--ikp-font-sizes-md);line-height:1.2}.ikp-heading--size_xl{font-size:var(--ikp-font-sizes-3xl);line-height:1.33}.ikp-heading--size_md{font-size:var(--ikp-font-sizes-xl);line-height:1.2}.ikp-close-btn--size_md{--btn-bg:var(--ikp-sizes-8);font-size:var(--ikp-font-sizes-xs)}.ikp-badge--variant_outline{--badge-color:var(--ikp-colors-color-palette-500);--badge-shadow:inset 0 0 0px 1px var(--badge-color,inherit)}.dark .ikp-badge--variant_outline,[data-theme=dark] .ikp-badge--variant_outline{--badge-bg-alpha:color-mix(in srgb,transparent 80%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) }.ikp-textarea--size_md{--input-font-size:var(--ikp-font-sizes-md);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-10)}.ikp-textarea--variant_outline{border:1px solid;border-color:inherit;background:inherit}.ikp-textarea--variant_outline:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.ikp-textarea--variant_outline[aria-invalid=true],.ikp-textarea--variant_outline[data-invalid] .ikp-textarea--variant_outline{border-color:var(--input-error-border-color);box-shadow:0 0 0 1px var(--input-error-border-color)}.ikp-textarea--variant_flushed:is(:focus-visible,[data-focus-visible]){border-color:var(--input-focus-border-color);box-shadow:0 1px 0 0 var(--input-focus-border-color)}.ikp-textarea--variant_filled:is(:focus-visible,[data-focus-visible]){background:var(--ikp-colors-transparent);border-color:var(--input-focus-border-color)}.ikp-textarea--variant_outline:is(:focus-visible,[data-focus-visible]){z-index:1;border-color:var(--input-focus-border-color);box-shadow:0 0 0 1px var(--input-focus-border-color)}.ikp-btn--variant_outlineFilled:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-strong);color:var(--ikp-colors-white)}.ikp-btn--variant_filledCTA:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-medium)}.ikp-btn--variant_primaryFilled:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-strong)}.ikp-textarea--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-gray-200)}.dark .ikp-textarea--variant_filled:is(:hover,[data-hover]),[data-theme=dark] .ikp-textarea--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-100)}.light .ikp-preview-content-header--variant_title:is(:hover,[data-hover]),[data-theme=light] .ikp-preview-content-header--variant_title:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-primary-stronger)}.dark .ikp-preview-content-header--variant_title:is(:hover,[data-hover]),[data-theme=dark] .ikp-preview-content-header--variant_title:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-expanded-primary-100)}.ikp-preview-content-header--variant_hitContentPreview .light a:hover,.ikp-preview-content-header--variant_hitContentPreview [data-theme=light] a:hover{color:var(--ikp-colors-inkeep-primary-stronger)}.ikp-preview-content-header--variant_hitContentPreview .dark a:hover,.ikp-preview-content-header--variant_hitContentPreview [data-theme=dark] a:hover{color:var(--ikp-colors-inkeep-expanded-primary-100)}.light .ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]),[data-theme=light] .ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-light-subtle);color:var(--ikp-colors-inkeep-primary-strong)}.dark .ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]),[data-theme=dark] .ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-200);color:var(--ikp-colors-inkeep-expanded-primary-200)}.ikp-btn--variant_solid:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-600)}.dark .ikp-btn--variant_solid:is(:hover,[data-hover]),[data-theme=dark] .ikp-btn--variant_solid:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-300)}.ikp-btn--variant_solid:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){background:var(--ikp-colors-color-palette-500)}.dark .ikp-btn--variant_solid:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]),[data-theme=dark] .ikp-btn--variant_solid:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){background:var(--ikp-colors-color-palette-200)}.ikp-btn--variant_outline:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-50));background-color:var(--bga,var(--ikp-colors-color-palette-50))}.dark .ikp-btn--variant_outline:is(:hover,[data-hover]),[data-theme=dark] .ikp-btn--variant_outline:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 88%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200));color:var(--ikp-colors-white-alpha-800);background:var(--ikp-colors-white-alpha-200)}.light .ikp-btn--variant_outline:is(:hover,[data-hover]),[data-theme=light] .ikp-btn--variant_outline:is(:hover,[data-hover]){color:var(--ikp-colors-gray-800)}.ikp-btn--variant_neutralFilled:is(:hover,[data-hover]){background:var(--ikp-colors-gray-800)}.dark .ikp-btn--variant_neutralFilled:is(:hover,[data-hover]),[data-theme=dark] .ikp-btn--variant_neutralFilled:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-expanded-primary-200)}.ikp-btn--variant_iconButton:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-primary-stronger);background:var(--ikp-colors-transparent)}.dark .ikp-btn--variant_iconButton:is(:hover,[data-hover]),[data-theme=dark] .ikp-btn--variant_iconButton:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-expanded-primary-300)}.ikp-btn--variant_link:is(:hover,[data-hover]){text-decoration:underline}.ikp-btn--variant_link:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){text-decoration:none}.ikp-btn--variant_ghost:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-50));background-color:var(--bga,var(--ikp-colors-color-palette-50))}.dark .ikp-btn--variant_ghost:is(:hover,[data-hover]),[data-theme=dark] .ikp-btn--variant_ghost:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 88%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200))}.ikp-textarea--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-300)}.dark .ikp-textarea--variant_outline:is(:hover,[data-hover]),[data-theme=dark] .ikp-textarea--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}.ikp-btn--variant_outlineFilled:is(:active,[data-active]){background:var(--ikp-colors-inkeep-primary-strong)}.ikp-btn--variant_filledCTA:is(:active,[data-active]){background:var(--ikp-colors-inkeep-primary-medium)}.ikp-btn--variant_primaryFilled:is(:active,[data-active]){background:var(--ikp-colors-inkeep-primary-strong)}.ikp-btn--variant_solid:is(:active,[data-active]){background:var(--ikp-colors-color-palette-700)}.dark .ikp-btn--variant_solid:is(:active,[data-active]),[data-theme=dark] .ikp-btn--variant_solid:is(:active,[data-active]){background:var(--ikp-colors-color-palette-400)}.ikp-btn--variant_outline:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-100));background-color:var(--bga,var(--ikp-colors-color-palette-100))}.dark .ikp-btn--variant_outline:is(:active,[data-active]),[data-theme=dark] .ikp-btn--variant_outline:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 76%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200))}.ikp-btn--variant_neutralFilled:is(:active,[data-active]){background:var(--ikp-colors-gray-800)}.dark .ikp-btn--variant_neutralFilled:is(:active,[data-active]),[data-theme=dark] .ikp-btn--variant_neutralFilled:is(:active,[data-active]){background:var(--ikp-colors-inkeep-expanded-primary-200)}.ikp-btn--variant_link:is(:active,[data-active]){color:var(--ikp-colors-color-palette-700)}.dark .ikp-btn--variant_link:is(:active,[data-active]),[data-theme=dark] .ikp-btn--variant_link:is(:active,[data-active]){color:var(--ikp-colors-color-palette-500)}.ikp-btn--variant_ghost:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-100));background-color:var(--bga,var(--ikp-colors-color-palette-100))}.dark .ikp-btn--variant_ghost:is(:active,[data-active]),[data-theme=dark] .ikp-btn--variant_ghost:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 76%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200))}@layer _base{.ikp-kbd{--kbd-bg:gray.1;background:var(--kbd-bg);border-radius:var(--ikp-radii-md);border-width:1px;border-bottom-width:3px;font-size:.8em;font-weight:var(--ikp-font-weights-bold);line-height:var(--ikp-line-heights-normal);padding-inline:.4em;white-space:nowrap}.dark .ikp-kbd,[data-theme=dark] .ikp-kbd{--kbd-bg:whiteAlpha.1 }.ikp-tag{--ikp-colors-color-palette-50:var(--ikp-colors-gray-50);--ikp-colors-color-palette-100:var(--ikp-colors-gray-100);--ikp-colors-color-palette-200:var(--ikp-colors-gray-200);--ikp-colors-color-palette-300:var(--ikp-colors-gray-300);--ikp-colors-color-palette-400:var(--ikp-colors-gray-400);--ikp-colors-color-palette-500:var(--ikp-colors-gray-500);--ikp-colors-color-palette-600:var(--ikp-colors-gray-600);--ikp-colors-color-palette-700:var(--ikp-colors-gray-700);--ikp-colors-color-palette-800:var(--ikp-colors-gray-800);--ikp-colors-color-palette-900:var(--ikp-colors-gray-900);--ikp-colors-color-palette-950:var(--ikp-colors-gray-950);font-weight:var(--ikp-font-weights-medium);line-height:1.2;outline:0;--tag-color:var(--badge-color,inherit);--tag-bg:var(--badge-bg,inherit);--tag-shadow:var(--badge-shadow);color:var(--tag-color);background:var(--tag-bg);box-shadow:var(--tag-shadow);border-radius:var(--ikp-radii-md);min-height:var(--tag-min-height);min-width:var(--tag-min-width);font-size:var(--tag-font-size);padding-inline:var(--tag-padding-inline);display:inline-flex;vertical-align:top;align-items:center;max-width:100%}.light .ikp-preview-content-header,[data-theme=light] .ikp-preview-content-header{color:var(--ikp-colors-gray-700)}.dark .ikp-preview-content-header,[data-theme=dark] .ikp-preview-content-header{color:var(--ikp-colors-white-alpha-700)}.ikp-link,.ikp-preview-content-header a:hover{text-decoration:none}.ikp-link{--transition-prop:common;transition-property:common;--transition-duration:var(--ikp-durations-fast);transition-duration:var(--ikp-durations-fast);--transition-easing:ease-out;transition-timing-function:ease-out;cursor:pointer;color:inherit}.ikp-btn,.ikp-link{outline:var(--ikp-borders-none)}.ikp-btn{line-height:1.2;border-radius:var(--ikp-radii-md);font-weight:var(--ikp-font-weights-semibold);--transition-prop:common;transition-property:common;--transition-duration:var(--ikp-durations-normal);transition-duration:var(--ikp-durations-normal);display:inline-flex;-moz-appearance:none;appearance:none;-webkit-appearance:none;align-items:center;justify-content:center;-webkit-user-select:none;user-select:none;position:relative;white-space:nowrap;vertical-align:middle}.ikp-btn:is(:disabled,[disabled],[data-disabled]){opacity:.4;cursor:not-allowed;box-shadow:var(--ikp-shadows-none)}.ikp-icon{width:1em;height:1em;display:inline-block;line-height:1em;flex-shrink:0;color:currentColor;vertical-align:middle}.ikp-ai-chat-page-wrapper{max-height:100vh;max-width:100vw;position:relative;flex-grow:5;margin-inline:auto;justify-self:center;text-align:left}.ikp-code{font-family:var(--ikp-fonts-mono);font-size:var(--ikp-font-sizes-sm);padding-inline:.2em;border-radius:var(--ikp-radii-sm);background:var(--badge-bg,inherit);color:var(--badge-color,inherit);box-shadow:var(--badge-shadow)}.ikp-heading{font-family:var(--ikp-fonts-heading);font-weight:var(--ikp-font-weights-bold)}.ikp-close-btn{width:var(--btn-bg);height:var(--btn-bg);border-radius:var(--ikp-radii-md);--transition-prop:common;transition-property:common;--transition-duration:var(--ikp-durations-normal);transition-duration:var(--ikp-durations-normal);background:var(--btn-size)}.ikp-close-btn:is(:disabled,[disabled],[data-disabled]){opacity:.4;cursor:not-allowed;box-shadow:var(--ikp-shadows-none)}.ikp-skeleton{height:20px;--skeleton-start-color:var(--ikp-colors-gray-100);--skeleton-end-color:var(--ikp-colors-gray-400);background:var(--skeleton-start-color);border-color:var(--skeleton-end-color);opacity:.7;border-radius:var(--ikp-radii-sm);box-shadow:var(--ikp-shadows-none);background-clip:padding-box;-webkit-background-clip:padding-box;cursor:default;pointer-events:none;-webkit-user-select:none;user-select:none;animation:var(--skeleton-speed,.8s) linear infinite alternate skeleton-bg-fade}.dark .ikp-skeleton,[data-theme=dark] .ikp-skeleton{--skeleton-start-color:var(--ikp-colors-gray-800) ;--skeleton-end-color:var(--ikp-colors-gray-600) }.ikp-skeleton *,.ikp-skeleton:after,.ikp-skeleton:before{visibility:hidden}.ikp-badge{--ikp-colors-color-palette-50:var(--ikp-colors-gray-50);--ikp-colors-color-palette-100:var(--ikp-colors-gray-100);--ikp-colors-color-palette-200:var(--ikp-colors-gray-200);--ikp-colors-color-palette-300:var(--ikp-colors-gray-300);--ikp-colors-color-palette-400:var(--ikp-colors-gray-400);--ikp-colors-color-palette-500:var(--ikp-colors-gray-500);--ikp-colors-color-palette-600:var(--ikp-colors-gray-600);--ikp-colors-color-palette-700:var(--ikp-colors-gray-700);--ikp-colors-color-palette-800:var(--ikp-colors-gray-800);--ikp-colors-color-palette-900:var(--ikp-colors-gray-900);--ikp-colors-color-palette-950:var(--ikp-colors-gray-950);padding-inline:var(--ikp-spacing-1);text-transform:uppercase;font-size:var(--ikp-font-sizes-xs);border-radius:var(--ikp-radii-sm);font-weight:var(--ikp-font-weights-bold);background:var(--badge-bg,inherit);color:var(--badge-color,inherit);box-shadow:var(--badge-shadow);display:inline-block;white-space:nowrap;vertical-align:middle}.ikp-textarea{height:var(--input-height);font-size:var(--input-font-size);padding-inline:var(--input-padding);border-radius:var(--input-border-radius);width:100%;min-width:var(--ikp-sizes-0);outline:0;position:relative;-moz-appearance:none;appearance:none;-webkit-appearance:none;--transition-prop:common;transition-property:common;--transition-duration:var(--ikp-durations-normal);transition-duration:var(--ikp-durations-normal);--input-focus-border-color:var(--ikp-colors-blue-500);--input-error-border-color:var(--ikp-colors-red-500);padding-block:var(--ikp-spacing-2);min-height:var(--ikp-sizes-20);line-height:var(--ikp-line-heights-short);vertical-align:top}.ikp-textarea:is(:disabled,[disabled],[data-disabled]){opacity:.4;cursor:not-allowed}.dark .ikp-textarea,[data-theme=dark] .ikp-textarea{--input-focus-border-color:var(--ikp-colors-blue-300) ;--input-error-border-color:var(--ikp-colors-red-300) }.ikp-tag:is(:focus-visible,[data-focus-visible]){--tag-shadow:var(--ikp-shadows-outline) }.ikp-link:is(:focus-visible,[data-focus-visible]){box-shadow:var(--ikp-shadows-outline)}.ikp-btn:is(:focus-visible,[data-focus-visible]){box-shadow:var(--ikp-shadows-outline)}.ikp-btn:is(:focus,[data-focus]){z-index:1}.ikp-close-btn:is(:focus-visible,[data-focus-visible]){box-shadow:var(--ikp-shadows-outline)}.ikp-preview-content-header .light a:hover,.ikp-preview-content-header [data-theme=light] a:hover{color:var(--ikp-colors-inkeep-primary-stronger)}.ikp-preview-content-header .dark a:hover,.ikp-preview-content-header [data-theme=dark] a:hover{color:var(--ikp-colors-inkeep-expanded-primary-100)}.ikp-link:is(:hover,[data-hover]){text-decoration:underline}.ikp-btn:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){background:initial}.ikp-close-btn:is(:hover,[data-hover]){--btn-size:var(--ikp-colors-black-alpha-100) }.dark .ikp-close-btn:is(:hover,[data-hover]),[data-theme=dark] .ikp-close-btn:is(:hover,[data-hover]){--btn-size:var(--ikp-colors-white-alpha-100) }.ikp-close-btn:is(:active,[data-active]){--btn-size:var(--ikp-colors-black-alpha-200) }.dark .ikp-close-btn:is(:active,[data-active]),[data-theme=dark] .ikp-close-btn:is(:active,[data-active]){--btn-size:var(--ikp-colors-white-alpha-200) }@media screen and (min-width: 48em){.ikp-ai-chat-page-wrapper{max-height:100vh;max-width:100vw}}}@media screen and (min-width: 33em){.sm\\:ikp-btn--colorPalette_gray{--ikp-colors-color-palette-50:var(--ikp-colors-gray-50);--ikp-colors-color-palette-100:var(--ikp-colors-gray-100);--ikp-colors-color-palette-200:var(--ikp-colors-gray-200);--ikp-colors-color-palette-300:var(--ikp-colors-gray-300);--ikp-colors-color-palette-400:var(--ikp-colors-gray-400);--ikp-colors-color-palette-500:var(--ikp-colors-gray-500);--ikp-colors-color-palette-600:var(--ikp-colors-gray-600);--ikp-colors-color-palette-700:var(--ikp-colors-gray-700);--ikp-colors-color-palette-800:var(--ikp-colors-gray-800);--ikp-colors-color-palette-900:var(--ikp-colors-gray-900);--ikp-colors-color-palette-950:var(--ikp-colors-gray-950)}.sm\\:ikp-btn--colorPalette_blue{--ikp-colors-color-palette-50:var(--ikp-colors-blue-50);--ikp-colors-color-palette-100:var(--ikp-colors-blue-100);--ikp-colors-color-palette-200:var(--ikp-colors-blue-200);--ikp-colors-color-palette-300:var(--ikp-colors-blue-300);--ikp-colors-color-palette-400:var(--ikp-colors-blue-400);--ikp-colors-color-palette-500:var(--ikp-colors-blue-500);--ikp-colors-color-palette-600:var(--ikp-colors-blue-600);--ikp-colors-color-palette-700:var(--ikp-colors-blue-700);--ikp-colors-color-palette-800:var(--ikp-colors-blue-800);--ikp-colors-color-palette-900:var(--ikp-colors-blue-900);--ikp-colors-color-palette-950:var(--ikp-colors-blue-950)}.sm\\:ikp-btn--colorPalette_teal{--ikp-colors-color-palette-50:var(--ikp-colors-teal-50);--ikp-colors-color-palette-100:var(--ikp-colors-teal-100);--ikp-colors-color-palette-200:var(--ikp-colors-teal-200);--ikp-colors-color-palette-300:var(--ikp-colors-teal-300);--ikp-colors-color-palette-400:var(--ikp-colors-teal-400);--ikp-colors-color-palette-500:var(--ikp-colors-teal-500);--ikp-colors-color-palette-600:var(--ikp-colors-teal-600);--ikp-colors-color-palette-700:var(--ikp-colors-teal-700);--ikp-colors-color-palette-800:var(--ikp-colors-teal-800);--ikp-colors-color-palette-900:var(--ikp-colors-teal-900);--ikp-colors-color-palette-950:var(--ikp-colors-teal-950)}.sm\\:ikp-btn--colorPalette_inkeepPrimary{--ikp-colors-color-palette-hit-content-preview:var(--ikp-colors-inkeep-primary-hit-content-preview);--ikp-colors-color-palette-hit-content-preview-hover:var(--ikp-colors-inkeep-primary-hit-content-preview-hover);--ikp-colors-color-palette-text-bold:var(--ikp-colors-inkeep-primary-text-bold);--ikp-colors-color-palette-text-subtle:var(--ikp-colors-inkeep-primary-text-subtle);--ikp-colors-color-palette-lighter:var(--ikp-colors-inkeep-primary-lighter);--ikp-colors-color-palette-light:var(--ikp-colors-inkeep-primary-light);--ikp-colors-color-palette-light-subtle:var(--ikp-colors-inkeep-primary-light-subtle);--ikp-colors-color-palette-medium:var(--ikp-colors-inkeep-primary-medium);--ikp-colors-color-palette-medium-subtle:var(--ikp-colors-inkeep-primary-medium-subtle);--ikp-colors-color-palette-strong:var(--ikp-colors-inkeep-primary-strong);--ikp-colors-color-palette-stronger:var(--ikp-colors-inkeep-primary-stronger);--ikp-colors-color-palette-text-color-on-primary:var(--ikp-colors-inkeep-primary-text-color-on-primary)}.sm\\:ikp-btn--variant_ghost{color:var(--ikp-colors-color-palette-600);background:var(--ikp-colors-transparent)}.dark .sm\\:ikp-btn--variant_ghost,[data-theme=dark] .sm\\:ikp-btn--variant_ghost{color:var(--ikp-colors-color-palette-200)}}@media screen and (min-width: 33em){.sm\\:ikp-btn--variant_ghost:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-50));background-color:var(--bga,var(--ikp-colors-color-palette-50))}.dark .sm\\:ikp-btn--variant_ghost:is(:hover,[data-hover]),[data-theme=dark] .sm\\:ikp-btn--variant_ghost:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 88%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200))}.sm\\:ikp-btn--variant_ghost:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-100));background-color:var(--bga,var(--ikp-colors-color-palette-100))}.dark .sm\\:ikp-btn--variant_ghost:is(:active,[data-active]),[data-theme=dark] .sm\\:ikp-btn--variant_ghost:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 76%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200))}}@media screen and (min-width: 33em){.sm\\:ikp-btn--variant_solid{background:var(--ikp-colors-color-palette-500);color:var(--ikp-colors-white)}.dark .sm\\:ikp-btn--variant_solid,[data-theme=dark] .sm\\:ikp-btn--variant_solid{background:var(--ikp-colors-color-palette-200);color:var(--ikp-colors-gray-800)}.sm\\:ikp-btn--variant_solid:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-600)}.dark .sm\\:ikp-btn--variant_solid:is(:hover,[data-hover]),[data-theme=dark] .sm\\:ikp-btn--variant_solid:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-300)}.sm\\:ikp-btn--variant_solid:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){background:var(--ikp-colors-color-palette-500)}.dark .sm\\:ikp-btn--variant_solid:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]),[data-theme=dark] .sm\\:ikp-btn--variant_solid:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){background:var(--ikp-colors-color-palette-200)}.sm\\:ikp-btn--variant_solid:is(:active,[data-active]){background:var(--ikp-colors-color-palette-700)}.dark .sm\\:ikp-btn--variant_solid:is(:active,[data-active]),[data-theme=dark] .sm\\:ikp-btn--variant_solid:is(:active,[data-active]){background:var(--ikp-colors-color-palette-400)}}@media screen and (min-width: 33em){.sm\\:ikp-btn--variant_link{padding:var(--ikp-spacing-0)!important;height:var(--ikp-sizes-auto)!important;line-height:var(--ikp-line-heights-base);vertical-align:baseline;font-weight:var(--ikp-font-weights-normal);color:var(--ikp-colors-color-palette-500)}.dark .sm\\:ikp-btn--variant_link,[data-theme=dark] .sm\\:ikp-btn--variant_link{color:var(--ikp-colors-color-palette-200)}.sm\\:ikp-btn--variant_link:is(:hover,[data-hover]){text-decoration:underline}.sm\\:ikp-btn--variant_link:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){text-decoration:none}.sm\\:ikp-btn--variant_link:is(:active,[data-active]){color:var(--ikp-colors-color-palette-700)}.dark .sm\\:ikp-btn--variant_link:is(:active,[data-active]),[data-theme=dark] .sm\\:ikp-btn--variant_link:is(:active,[data-active]){color:var(--ikp-colors-color-palette-500)}}@media screen and (min-width: 33em){.sm\\:ikp-btn--variant_unstyled{background:none;color:inherit;display:inline;line-height:inherit;margin:var(--ikp-spacing-0);padding:var(--ikp-spacing-0);border-radius:unset}.sm\\:ikp-btn--variant_outlinePrimary{border:1px solid}.light .sm\\:ikp-btn--variant_outlinePrimary,[data-theme=light] .sm\\:ikp-btn--variant_outlinePrimary{color:var(--ikp-colors-inkeep-primary-strong);border-color:var(--ikp-colors-inkeep-expanded-primary-200)}.dark .sm\\:ikp-btn--variant_outlinePrimary,[data-theme=dark] .sm\\:ikp-btn--variant_outlinePrimary{color:var(--ikp-colors-inkeep-expanded-primary-300)}}@media screen and (min-width: 33em){.light .sm\\:ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]),[data-theme=light] .sm\\:ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-light-subtle);color:var(--ikp-colors-inkeep-primary-strong)}.dark .sm\\:ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]),[data-theme=dark] .sm\\:ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-200);color:var(--ikp-colors-inkeep-expanded-primary-200)}}@media screen and (min-width: 33em){.sm\\:ikp-btn--variant_outlineFilled{background:var(--ikp-colors-white);border:1px solid;border-color:var(--ikp-colors-inkeep-primary-strong);color:var(--ikp-colors-inkeep-primary-strong)}.sm\\:ikp-btn--variant_outlineFilled:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-strong);color:var(--ikp-colors-white)}.sm\\:ikp-btn--variant_outlineFilled:is(:active,[data-active]){background:var(--ikp-colors-inkeep-primary-strong)}}@media screen and (min-width: 33em){.sm\\:ikp-btn--variant_outlineFilledActive{background:var(--ikp-colors-inkeep-primary-strong);color:var(--ikp-colors-white)}.sm\\:ikp-btn--variant_chatButton{background:var(--ikp-colors-inkeep-primary-text-bold);box-shadow:var(--ikp-shadows-2xl);border-radius:var(--ikp-radii-lg);color:var(--ikp-colors-white);font-weight:var(--ikp-font-weights-medium)}.dark .sm\\:ikp-btn--variant_chatButton,[data-theme=dark] .sm\\:ikp-btn--variant_chatButton{background:var(--ikp-colors-gray-dark-600);box-shadow:var(--ikp-shadows-none)}.sm\\:ikp-btn--variant_filledCTA{background:var(--ikp-colors-inkeep-primary-medium);color:var(--ikp-colors-white);border:var(--ikp-borders-none);border-radius:80px}}@media screen and (min-width: 33em){.sm\\:ikp-btn--variant_filledCTA:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-medium)}.sm\\:ikp-btn--variant_filledCTA:is(:active,[data-active]){background:var(--ikp-colors-inkeep-primary-medium)}}@media screen and (min-width: 33em){.sm\\:ikp-btn--variant_primaryFilled{background:var(--ikp-colors-inkeep-primary-medium);color:var(--ikp-colors-inkeep-primary-text-color-on-primary)}.sm\\:ikp-btn--variant_primaryFilled:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-strong)}.sm\\:ikp-btn--variant_primaryFilled:is(:active,[data-active]){background:var(--ikp-colors-inkeep-primary-strong)}}@media screen and (min-width: 33em){.sm\\:ikp-btn--variant_neutralFilled{background:var(--ikp-colors-gray-900);color:var(--ikp-colors-white)}.dark .sm\\:ikp-btn--variant_neutralFilled,[data-theme=dark] .sm\\:ikp-btn--variant_neutralFilled{background:var(--ikp-colors-inkeep-expanded-primary-300);color:var(--ikp-colors-gray-dark-900)}.sm\\:ikp-btn--variant_neutralFilled:is(:hover,[data-hover]){background:var(--ikp-colors-gray-800)}.dark .sm\\:ikp-btn--variant_neutralFilled:is(:hover,[data-hover]),[data-theme=dark] .sm\\:ikp-btn--variant_neutralFilled:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-expanded-primary-200)}.sm\\:ikp-btn--variant_neutralFilled:is(:active,[data-active]){background:var(--ikp-colors-gray-800)}.dark .sm\\:ikp-btn--variant_neutralFilled:is(:active,[data-active]),[data-theme=dark] .sm\\:ikp-btn--variant_neutralFilled:is(:active,[data-active]){background:var(--ikp-colors-inkeep-expanded-primary-200)}}@media screen and (min-width: 33em){.sm\\:ikp-btn--variant_outline{border:1px solid;border-color:currentColor;color:var(--ikp-colors-color-palette-600);background:var(--ikp-colors-transparent)}.dark .sm\\:ikp-btn--variant_outline,[data-theme=dark] .sm\\:ikp-btn--variant_outline{color:var(--ikp-colors-white-alpha-700)}.light .sm\\:ikp-btn--variant_outline,[data-theme=light] .sm\\:ikp-btn--variant_outline{color:var(--ikp-colors-gray-700)}.sm\\:ikp-btn--variant_outline:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-50));background-color:var(--bga,var(--ikp-colors-color-palette-50))}.dark .sm\\:ikp-btn--variant_outline:is(:hover,[data-hover]),[data-theme=dark] .sm\\:ikp-btn--variant_outline:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 88%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200));color:var(--ikp-colors-white-alpha-800);background:var(--ikp-colors-white-alpha-200)}.light .sm\\:ikp-btn--variant_outline:is(:hover,[data-hover]),[data-theme=light] .sm\\:ikp-btn--variant_outline:is(:hover,[data-hover]){color:var(--ikp-colors-gray-800)}.sm\\:ikp-btn--variant_outline:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-100));background-color:var(--bga,var(--ikp-colors-color-palette-100))}.dark .sm\\:ikp-btn--variant_outline:is(:active,[data-active]),[data-theme=dark] .sm\\:ikp-btn--variant_outline:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 76%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200))}}@media screen and (min-width: 33em){.sm\\:ikp-btn--variant_iconButton{background:var(--ikp-colors-transparent);border-radius:0;padding-inline:var(--ikp-spacing-1);color:var(--ikp-colors-gray-600)}.dark .sm\\:ikp-btn--variant_iconButton,[data-theme=dark] .sm\\:ikp-btn--variant_iconButton{color:var(--ikp-colors-white-alpha-600)}.sm\\:ikp-btn--variant_iconButton:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-primary-stronger);background:var(--ikp-colors-transparent)}.dark .sm\\:ikp-btn--variant_iconButton:is(:hover,[data-hover]),[data-theme=dark] .sm\\:ikp-btn--variant_iconButton:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-expanded-primary-300)}}@media screen and (min-width: 33em){.sm\\:ikp-btn--size_lg{height:var(--ikp-sizes-12);min-width:var(--ikp-sizes-12);font-size:var(--ikp-font-sizes-lg);padding-inline:var(--ikp-spacing-6)}.sm\\:ikp-btn--size_md{height:var(--ikp-sizes-10);min-width:var(--ikp-sizes-10);font-size:var(--ikp-font-sizes-md);padding-inline:var(--ikp-spacing-4)}.sm\\:ikp-btn--size_sm{height:var(--ikp-sizes-8);min-width:var(--ikp-sizes-8);font-size:var(--ikp-font-sizes-sm);padding-inline:var(--ikp-spacing-3)}.sm\\:ikp-btn--size_xs{height:var(--ikp-sizes-6);min-width:var(--ikp-sizes-6);font-size:var(--ikp-font-sizes-xs);padding-inline:var(--ikp-spacing-2)}.sm\\:ikp-close-btn--size_lg{--btn-bg:var(--ikp-sizes-10);font-size:var(--ikp-font-sizes-md)}.sm\\:ikp-close-btn--size_md{--btn-bg:var(--ikp-sizes-8);font-size:var(--ikp-font-sizes-xs)}.sm\\:ikp-close-btn--size_sm{--btn-bg:var(--ikp-sizes-6);font-size:var(--ikp-font-sizes-2xs)}.sm\\:ikp-code--variant_solid{--badge-bg:var(--ikp-colors-color-palette-500);--badge-color:var(--ikp-colors-white)}.dark .sm\\:ikp-code--variant_solid,[data-theme=dark] .sm\\:ikp-code--variant_solid{--badge-bg-alpha:color-mix(in srgb,transparent 60%,var(--colors-color-palette-500)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-500)) ;--badge-color:var(--ikp-colors-white-alpha-800) }.sm\\:ikp-code--variant_subtle{--badge-bg:colorPalette.1;--badge-color:var(--ikp-colors-color-palette-800)}.dark .sm\\:ikp-code--variant_subtle,[data-theme=dark] .sm\\:ikp-code--variant_subtle{--badge-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) ;--badge-color:var(--ikp-colors-color-palette-200) }.sm\\:ikp-code--variant_outline{--badge-color:var(--ikp-colors-color-palette-500);--badge-shadow:inset 0 0 0px 1px var(--badge-color,inherit)}.dark .sm\\:ikp-code--variant_outline,[data-theme=dark] .sm\\:ikp-code--variant_outline{--badge-bg-alpha:color-mix(in srgb,transparent 80%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) }.sm\\:ikp-badge--variant_solid{--badge-bg:var(--ikp-colors-color-palette-500);--badge-color:var(--ikp-colors-white)}.dark .sm\\:ikp-badge--variant_solid,[data-theme=dark] .sm\\:ikp-badge--variant_solid{--badge-bg-alpha:color-mix(in srgb,transparent 60%,var(--colors-color-palette-500)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-500)) ;--badge-color:var(--ikp-colors-white-alpha-800) }.sm\\:ikp-badge--variant_subtle{--badge-bg:colorPalette.1;--badge-color:var(--ikp-colors-color-palette-800)}.dark .sm\\:ikp-badge--variant_subtle,[data-theme=dark] .sm\\:ikp-badge--variant_subtle{--badge-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) ;--badge-color:var(--ikp-colors-color-palette-200) }.sm\\:ikp-badge--variant_outline{--badge-color:var(--ikp-colors-color-palette-500);--badge-shadow:inset 0 0 0px 1px var(--badge-color,inherit)}.dark .sm\\:ikp-badge--variant_outline,[data-theme=dark] .sm\\:ikp-badge--variant_outline{--badge-bg-alpha:color-mix(in srgb,transparent 80%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) }.sm\\:ikp-heading--size_4xl{font-size:var(--ikp-font-sizes-6xl);line-height:1}}@media screen and (min-width: 33em){@media screen and (min-width: 48em){.sm\\:ikp-heading--size_4xl{font-size:var(--ikp-font-sizes-7xl)}}}@media screen and (min-width: 33em){.sm\\:ikp-heading--size_3xl{font-size:var(--ikp-font-sizes-5xl);line-height:1}@media screen and (min-width: 48em){.sm\\:ikp-heading--size_3xl{font-size:var(--ikp-font-sizes-6xl)}}}@media screen and (min-width: 33em){.sm\\:ikp-heading--size_2xl{font-size:var(--ikp-font-sizes-4xl);line-height:1.2}@media screen and (min-width: 48em){.sm\\:ikp-heading--size_2xl{font-size:var(--ikp-font-sizes-5xl);line-height:1}}}@media screen and (min-width: 33em){.sm\\:ikp-heading--size_xl{font-size:var(--ikp-font-sizes-3xl);line-height:1.33}@media screen and (min-width: 48em){.sm\\:ikp-heading--size_xl{font-size:var(--ikp-font-sizes-4xl);line-height:1.2}}}@media screen and (min-width: 33em){.sm\\:ikp-heading--size_lg{font-size:var(--ikp-font-sizes-2xl);line-height:1.33}@media screen and (min-width: 48em){.sm\\:ikp-heading--size_lg{font-size:var(--ikp-font-sizes-3xl);line-height:1.2}}}@media screen and (min-width: 33em){.sm\\:ikp-heading--size_md{font-size:var(--ikp-font-sizes-xl);line-height:1.2}.sm\\:ikp-heading--size_sm{font-size:var(--ikp-font-sizes-md);line-height:1.2}.sm\\:ikp-heading--size_xs{font-size:var(--ikp-font-sizes-sm);line-height:1.2}.sm\\:ikp-heading--uppercase_true{text-transform:uppercase;letter-spacing:1px;font-weight:600;color:var(--ikp-colors-gray-600)}.sm\\:ikp-icon--variant_dark{color:var(--ikp-colors-white)}.sm\\:ikp-icon--variant_lightPrimary{color:var(--ikp-colors-inkeep-primary-text-subtle)}.sm\\:ikp-icon--variant_light{color:var(--ikp-colors-gray-600)}.sm\\:ikp-kbd--variant_dark{background:primaryDark.9;color:var(--ikp-colors-white);border-color:primaryDark.6;border-radius:3px;border-bottom:2px solid}.sm\\:ikp-kbd--variant_darkOutline{color:var(--ikp-colors-white)}.sm\\:ikp-kbd--variant_darkOutline,.sm\\:ikp-kbd--variant_light{background:primary.1;border-color:var(--ikp-colors-inkeep-primary-medium);border-radius:3px;border-bottom:2px solid}.sm\\:ikp-kbd--variant_light{color:var(--ikp-colors-inkeep-primary-medium)}.sm\\:ikp-kbd--variant_grayLight{background:var(--ikp-colors-gray-400);height:40px;padding:2px 6px;color:var(--ikp-colors-gray-600);border-color:var(--ikp-colors-gray-600);border-radius:3px;border-bottom:2px solid gray.7}.sm\\:ikp-kbd--variant_outline{box-shadow:var(--ikp-shadows-none)}.sm\\:ikp-tag--variant_solid{--badge-bg:var(--ikp-colors-color-palette-500);--badge-color:var(--ikp-colors-white)}.dark .sm\\:ikp-tag--variant_solid,[data-theme=dark] .sm\\:ikp-tag--variant_solid{--badge-bg-alpha:color-mix(in srgb,transparent 60%,var(--colors-color-palette-500)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-500)) ;--badge-color:var(--ikp-colors-white-alpha-800) }.sm\\:ikp-tag--variant_subtle{--badge-bg:colorPalette.1;--badge-color:var(--ikp-colors-color-palette-800)}.dark .sm\\:ikp-tag--variant_subtle,[data-theme=dark] .sm\\:ikp-tag--variant_subtle{--badge-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) ;--badge-color:var(--ikp-colors-color-palette-200) }.sm\\:ikp-tag--variant_outline{--badge-color:var(--ikp-colors-color-palette-500);--badge-shadow:inset 0 0 0px 1px var(--badge-color,inherit)}.dark .sm\\:ikp-tag--variant_outline,[data-theme=dark] .sm\\:ikp-tag--variant_outline{--badge-bg-alpha:color-mix(in srgb,transparent 80%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) }.sm\\:ikp-tag--size_sm{--tag-min-height:var(--ikp-sizes-5);--tag-min-width:var(--ikp-sizes-5);--tag-font-size:var(--ikp-font-sizes-xs);--tag-padding-inline:var(--ikp-space-2)}.sm\\:ikp-tag--size_md{--tag-min-height:var(--ikp-sizes-6);--tag-min-width:var(--ikp-sizes-6);--tag-font-size:var(--ikp-font-sizes-sm);--tag-padding-inline:var(--ikp-space-2)}.sm\\:ikp-tag--size_lg{--tag-min-height:var(--ikp-sizes-8);--tag-min-width:var(--ikp-sizes-8);--tag-font-size:var(--ikp-font-sizes-md);--tag-padding-inline:var(--ikp-space-3)}.sm\\:ikp-textarea--variant_outline{border:1px solid;border-color:inherit;background:inherit}}@media screen and (min-width: 33em){.sm\\:ikp-textarea--variant_outline:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.sm\\:ikp-textarea--variant_outline[aria-invalid=true],.sm\\:ikp-textarea--variant_outline[data-invalid] .sm\\:ikp-textarea--variant_outline{border-color:var(--input-error-border-color);box-shadow:0 0 0 1px var(--input-error-border-color)}.sm\\:ikp-textarea--variant_outline:is(:focus-visible,[data-focus-visible]){z-index:1;border-color:var(--input-focus-border-color);box-shadow:0 0 0 1px var(--input-focus-border-color)}.sm\\:ikp-textarea--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-300)}.dark .sm\\:ikp-textarea--variant_outline:is(:hover,[data-hover]),[data-theme=dark] .sm\\:ikp-textarea--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}}@media screen and (min-width: 33em){.sm\\:ikp-textarea--variant_flushed{border-bottom:1px solid;border-color:inherit;border-radius:0;padding-inline:var(--ikp-spacing-0);background:var(--ikp-colors-transparent)}.sm\\:ikp-textarea--variant_flushed:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.sm\\:ikp-textarea--variant_flushed[aria-invalid=true],.sm\\:ikp-textarea--variant_flushed[data-invalid] .sm\\:ikp-textarea--variant_flushed{border-color:var(--input-error-border-color);box-shadow:0 1px 0 0 var(--input-error-border-color)}.sm\\:ikp-textarea--variant_flushed:is(:focus-visible,[data-focus-visible]){border-color:var(--input-focus-border-color);box-shadow:0 1px 0 0 var(--input-focus-border-color)}}@media screen and (min-width: 33em){.sm\\:ikp-textarea--variant_filled{border:2px solid;border-color:var(--ikp-colors-transparent);background:var(--ikp-colors-gray-100)}.dark .sm\\:ikp-textarea--variant_filled,[data-theme=dark] .sm\\:ikp-textarea--variant_filled{background:var(--ikp-colors-white-alpha-50)}.sm\\:ikp-textarea--variant_filled:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.sm\\:ikp-textarea--variant_filled[aria-invalid=true],.sm\\:ikp-textarea--variant_filled[data-invalid] .sm\\:ikp-textarea--variant_filled{border-color:var(--input-error-border-color)}.sm\\:ikp-textarea--variant_filled:is(:focus-visible,[data-focus-visible]){background:var(--ikp-colors-transparent);border-color:var(--input-focus-border-color)}.sm\\:ikp-textarea--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-gray-200)}.dark .sm\\:ikp-textarea--variant_filled:is(:hover,[data-hover]),[data-theme=dark] .sm\\:ikp-textarea--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-100)}}@media screen and (min-width: 33em){.sm\\:ikp-textarea--variant_unstyled{background:var(--ikp-colors-transparent);padding-inline:var(--ikp-spacing-0);height:var(--ikp-sizes-auto)}.sm\\:ikp-textarea--size_xs{--input-font-size:var(--ikp-font-sizes-xs);--input-padding:var(--ikp-space-2);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-6)}.sm\\:ikp-textarea--size_sm{--input-font-size:var(--ikp-font-sizes-sm);--input-padding:var(--ikp-space-3);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-8)}.sm\\:ikp-textarea--size_md{--input-font-size:var(--ikp-font-sizes-md);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-10)}.sm\\:ikp-textarea--size_lg{--input-font-size:var(--ikp-font-sizes-lg);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-12)}.sm\\:ikp-ai-chat-page-wrapper--size_expand{width:100%;height:100%}.sm\\:ikp-ai-chat-page-wrapper--size_default{max-width:100vw;max-height:100vw;margin:auto;align-self:center;justify-self:center;flex-grow:0}}@media screen and (min-width: 33em){@media screen and (min-width: 48em){.sm\\:ikp-ai-chat-page-wrapper--size_default{width:min(600px,100%);height:min(760px,100%)}}@media screen and (min-width: 64em){.sm\\:ikp-ai-chat-page-wrapper--size_default{width:min(640px,100%);height:min(800px,100%)}}@media screen and (min-width: 96em){.sm\\:ikp-ai-chat-page-wrapper--size_default{width:min(760px,100%);height:min(900px,100%)}}}@media screen and (min-width: 33em){.sm\\:ikp-ai-chat-page-wrapper--size_shrink-vertically{width:100%;height:var(--ikp-sizes-auto);align-self:flex-start;max-height:100%}@media screen and (min-width: 48em){.sm\\:ikp-ai-chat-page-wrapper--size_shrink-vertically{width:100%}}}@media screen and (min-width: 33em){.sm\\:ikp-ai-chat-page-wrapper--size_full-viewport{position:fixed;top:var(--ikp-spacing-0);left:var(--ikp-spacing-0);z-index:1000;width:100vw;height:100vh}.sm\\:ikp-ai-chat-page-wrapper--variant_no-shadow{box-shadow:var(--ikp-shadows-none)}.sm\\:ikp-ai-chat-page-wrapper--variant_container-with-shadow{box-shadow:var(--ikp-shadows-2xl)}.dark .sm\\:ikp-ai-chat-page-wrapper--variant_container-with-shadow,[data-theme=dark] .sm\\:ikp-ai-chat-page-wrapper--variant_container-with-shadow{box-shadow:var(--ikp-shadows-none)}.light .sm\\:ikp-preview-content-header--variant_title,[data-theme=light] .sm\\:ikp-preview-content-header--variant_title{color:var(--ikp-colors-inkeep-primary-text-subtle)}.dark .sm\\:ikp-preview-content-header--variant_title,[data-theme=dark] .sm\\:ikp-preview-content-header--variant_title{color:var(--ikp-colors-inkeep-primary-lighter)}}@media screen and (min-width: 33em){.light .sm\\:ikp-preview-content-header--variant_title:is(:hover,[data-hover]),[data-theme=light] .sm\\:ikp-preview-content-header--variant_title:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-primary-stronger)}.dark .sm\\:ikp-preview-content-header--variant_title:is(:hover,[data-hover]),[data-theme=dark] .sm\\:ikp-preview-content-header--variant_title:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-expanded-primary-100)}}@media screen and (min-width: 33em){.light .sm\\:ikp-preview-content-header--variant_hitContentPreview,[data-theme=light] .sm\\:ikp-preview-content-header--variant_hitContentPreview{color:var(--ikp-colors-inkeep-primary-hit-content-preview)}.dark .sm\\:ikp-preview-content-header--variant_hitContentPreview,[data-theme=dark] .sm\\:ikp-preview-content-header--variant_hitContentPreview{color:var(--ikp-colors-inkeep-expanded-primary-300)}.sm\\:ikp-preview-content-header--variant_hitContentPreview .light a:hover,.sm\\:ikp-preview-content-header--variant_hitContentPreview [data-theme=light] a:hover{color:var(--ikp-colors-inkeep-primary-stronger)}.sm\\:ikp-preview-content-header--variant_hitContentPreview .dark a:hover,.sm\\:ikp-preview-content-header--variant_hitContentPreview [data-theme=dark] a:hover{color:var(--ikp-colors-inkeep-expanded-primary-100)}}@media screen and (min-width: 48em){.ikp-heading--size_4xl{font-size:var(--ikp-font-sizes-7xl)}.ikp-heading--size_3xl{font-size:var(--ikp-font-sizes-6xl)}.ikp-heading--size_2xl{font-size:var(--ikp-font-sizes-5xl);line-height:1}.ikp-heading--size_lg{font-size:var(--ikp-font-sizes-3xl);line-height:1.2}.ikp-ai-chat-page-wrapper--size_shrink-vertically{width:100%}.ikp-ai-chat-page-wrapper--size_default{width:min(600px,100%);height:min(760px,100%)}.ikp-heading--size_xl{font-size:var(--ikp-font-sizes-4xl);line-height:1.2}.md\\:ikp-btn--colorPalette_gray{--ikp-colors-color-palette-50:var(--ikp-colors-gray-50);--ikp-colors-color-palette-100:var(--ikp-colors-gray-100);--ikp-colors-color-palette-200:var(--ikp-colors-gray-200);--ikp-colors-color-palette-300:var(--ikp-colors-gray-300);--ikp-colors-color-palette-400:var(--ikp-colors-gray-400);--ikp-colors-color-palette-500:var(--ikp-colors-gray-500);--ikp-colors-color-palette-600:var(--ikp-colors-gray-600);--ikp-colors-color-palette-700:var(--ikp-colors-gray-700);--ikp-colors-color-palette-800:var(--ikp-colors-gray-800);--ikp-colors-color-palette-900:var(--ikp-colors-gray-900);--ikp-colors-color-palette-950:var(--ikp-colors-gray-950)}.md\\:ikp-btn--colorPalette_blue{--ikp-colors-color-palette-50:var(--ikp-colors-blue-50);--ikp-colors-color-palette-100:var(--ikp-colors-blue-100);--ikp-colors-color-palette-200:var(--ikp-colors-blue-200);--ikp-colors-color-palette-300:var(--ikp-colors-blue-300);--ikp-colors-color-palette-400:var(--ikp-colors-blue-400);--ikp-colors-color-palette-500:var(--ikp-colors-blue-500);--ikp-colors-color-palette-600:var(--ikp-colors-blue-600);--ikp-colors-color-palette-700:var(--ikp-colors-blue-700);--ikp-colors-color-palette-800:var(--ikp-colors-blue-800);--ikp-colors-color-palette-900:var(--ikp-colors-blue-900);--ikp-colors-color-palette-950:var(--ikp-colors-blue-950)}.md\\:ikp-btn--colorPalette_teal{--ikp-colors-color-palette-50:var(--ikp-colors-teal-50);--ikp-colors-color-palette-100:var(--ikp-colors-teal-100);--ikp-colors-color-palette-200:var(--ikp-colors-teal-200);--ikp-colors-color-palette-300:var(--ikp-colors-teal-300);--ikp-colors-color-palette-400:var(--ikp-colors-teal-400);--ikp-colors-color-palette-500:var(--ikp-colors-teal-500);--ikp-colors-color-palette-600:var(--ikp-colors-teal-600);--ikp-colors-color-palette-700:var(--ikp-colors-teal-700);--ikp-colors-color-palette-800:var(--ikp-colors-teal-800);--ikp-colors-color-palette-900:var(--ikp-colors-teal-900);--ikp-colors-color-palette-950:var(--ikp-colors-teal-950)}.md\\:ikp-btn--colorPalette_inkeepPrimary{--ikp-colors-color-palette-hit-content-preview:var(--ikp-colors-inkeep-primary-hit-content-preview);--ikp-colors-color-palette-hit-content-preview-hover:var(--ikp-colors-inkeep-primary-hit-content-preview-hover);--ikp-colors-color-palette-text-bold:var(--ikp-colors-inkeep-primary-text-bold);--ikp-colors-color-palette-text-subtle:var(--ikp-colors-inkeep-primary-text-subtle);--ikp-colors-color-palette-lighter:var(--ikp-colors-inkeep-primary-lighter);--ikp-colors-color-palette-light:var(--ikp-colors-inkeep-primary-light);--ikp-colors-color-palette-light-subtle:var(--ikp-colors-inkeep-primary-light-subtle);--ikp-colors-color-palette-medium:var(--ikp-colors-inkeep-primary-medium);--ikp-colors-color-palette-medium-subtle:var(--ikp-colors-inkeep-primary-medium-subtle);--ikp-colors-color-palette-strong:var(--ikp-colors-inkeep-primary-strong);--ikp-colors-color-palette-stronger:var(--ikp-colors-inkeep-primary-stronger);--ikp-colors-color-palette-text-color-on-primary:var(--ikp-colors-inkeep-primary-text-color-on-primary)}.md\\:ikp-btn--variant_ghost{color:var(--ikp-colors-color-palette-600);background:var(--ikp-colors-transparent)}.dark .md\\:ikp-btn--variant_ghost,[data-theme=dark] .md\\:ikp-btn--variant_ghost{color:var(--ikp-colors-color-palette-200)}}@media screen and (min-width: 48em){.md\\:ikp-btn--variant_ghost:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-50));background-color:var(--bga,var(--ikp-colors-color-palette-50))}.dark .md\\:ikp-btn--variant_ghost:is(:hover,[data-hover]),[data-theme=dark] .md\\:ikp-btn--variant_ghost:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 88%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200))}.md\\:ikp-btn--variant_ghost:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-100));background-color:var(--bga,var(--ikp-colors-color-palette-100))}.dark .md\\:ikp-btn--variant_ghost:is(:active,[data-active]),[data-theme=dark] .md\\:ikp-btn--variant_ghost:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 76%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200))}}@media screen and (min-width: 48em){.md\\:ikp-btn--variant_solid{background:var(--ikp-colors-color-palette-500);color:var(--ikp-colors-white)}.dark .md\\:ikp-btn--variant_solid,[data-theme=dark] .md\\:ikp-btn--variant_solid{background:var(--ikp-colors-color-palette-200);color:var(--ikp-colors-gray-800)}.md\\:ikp-btn--variant_solid:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-600)}.dark .md\\:ikp-btn--variant_solid:is(:hover,[data-hover]),[data-theme=dark] .md\\:ikp-btn--variant_solid:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-300)}.md\\:ikp-btn--variant_solid:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){background:var(--ikp-colors-color-palette-500)}.dark .md\\:ikp-btn--variant_solid:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]),[data-theme=dark] .md\\:ikp-btn--variant_solid:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){background:var(--ikp-colors-color-palette-200)}.md\\:ikp-btn--variant_solid:is(:active,[data-active]){background:var(--ikp-colors-color-palette-700)}.dark .md\\:ikp-btn--variant_solid:is(:active,[data-active]),[data-theme=dark] .md\\:ikp-btn--variant_solid:is(:active,[data-active]){background:var(--ikp-colors-color-palette-400)}}@media screen and (min-width: 48em){.md\\:ikp-btn--variant_link{padding:var(--ikp-spacing-0)!important;height:var(--ikp-sizes-auto)!important;line-height:var(--ikp-line-heights-base);vertical-align:baseline;font-weight:var(--ikp-font-weights-normal);color:var(--ikp-colors-color-palette-500)}.dark .md\\:ikp-btn--variant_link,[data-theme=dark] .md\\:ikp-btn--variant_link{color:var(--ikp-colors-color-palette-200)}.md\\:ikp-btn--variant_link:is(:hover,[data-hover]){text-decoration:underline}.md\\:ikp-btn--variant_link:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){text-decoration:none}.md\\:ikp-btn--variant_link:is(:active,[data-active]){color:var(--ikp-colors-color-palette-700)}.dark .md\\:ikp-btn--variant_link:is(:active,[data-active]),[data-theme=dark] .md\\:ikp-btn--variant_link:is(:active,[data-active]){color:var(--ikp-colors-color-palette-500)}}@media screen and (min-width: 48em){.md\\:ikp-btn--variant_unstyled{background:none;color:inherit;display:inline;line-height:inherit;margin:var(--ikp-spacing-0);padding:var(--ikp-spacing-0);border-radius:unset}.md\\:ikp-btn--variant_outlinePrimary{border:1px solid}.light .md\\:ikp-btn--variant_outlinePrimary,[data-theme=light] .md\\:ikp-btn--variant_outlinePrimary{color:var(--ikp-colors-inkeep-primary-strong);border-color:var(--ikp-colors-inkeep-expanded-primary-200)}.dark .md\\:ikp-btn--variant_outlinePrimary,[data-theme=dark] .md\\:ikp-btn--variant_outlinePrimary{color:var(--ikp-colors-inkeep-expanded-primary-300)}}@media screen and (min-width: 48em){.light .md\\:ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]),[data-theme=light] .md\\:ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-light-subtle);color:var(--ikp-colors-inkeep-primary-strong)}.dark .md\\:ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]),[data-theme=dark] .md\\:ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-200);color:var(--ikp-colors-inkeep-expanded-primary-200)}}@media screen and (min-width: 48em){.md\\:ikp-btn--variant_outlineFilled{background:var(--ikp-colors-white);border:1px solid;border-color:var(--ikp-colors-inkeep-primary-strong);color:var(--ikp-colors-inkeep-primary-strong)}.md\\:ikp-btn--variant_outlineFilled:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-strong);color:var(--ikp-colors-white)}.md\\:ikp-btn--variant_outlineFilled:is(:active,[data-active]){background:var(--ikp-colors-inkeep-primary-strong)}}@media screen and (min-width: 48em){.md\\:ikp-btn--variant_outlineFilledActive{background:var(--ikp-colors-inkeep-primary-strong);color:var(--ikp-colors-white)}.md\\:ikp-btn--variant_chatButton{background:var(--ikp-colors-inkeep-primary-text-bold);box-shadow:var(--ikp-shadows-2xl);border-radius:var(--ikp-radii-lg);color:var(--ikp-colors-white);font-weight:var(--ikp-font-weights-medium)}.dark .md\\:ikp-btn--variant_chatButton,[data-theme=dark] .md\\:ikp-btn--variant_chatButton{background:var(--ikp-colors-gray-dark-600);box-shadow:var(--ikp-shadows-none)}.md\\:ikp-btn--variant_filledCTA{background:var(--ikp-colors-inkeep-primary-medium);color:var(--ikp-colors-white);border:var(--ikp-borders-none);border-radius:80px}}@media screen and (min-width: 48em){.md\\:ikp-btn--variant_filledCTA:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-medium)}.md\\:ikp-btn--variant_filledCTA:is(:active,[data-active]){background:var(--ikp-colors-inkeep-primary-medium)}}@media screen and (min-width: 48em){.md\\:ikp-btn--variant_primaryFilled{background:var(--ikp-colors-inkeep-primary-medium);color:var(--ikp-colors-inkeep-primary-text-color-on-primary)}.md\\:ikp-btn--variant_primaryFilled:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-strong)}.md\\:ikp-btn--variant_primaryFilled:is(:active,[data-active]){background:var(--ikp-colors-inkeep-primary-strong)}}@media screen and (min-width: 48em){.md\\:ikp-btn--variant_neutralFilled{background:var(--ikp-colors-gray-900);color:var(--ikp-colors-white)}.dark .md\\:ikp-btn--variant_neutralFilled,[data-theme=dark] .md\\:ikp-btn--variant_neutralFilled{background:var(--ikp-colors-inkeep-expanded-primary-300);color:var(--ikp-colors-gray-dark-900)}.md\\:ikp-btn--variant_neutralFilled:is(:hover,[data-hover]){background:var(--ikp-colors-gray-800)}.dark .md\\:ikp-btn--variant_neutralFilled:is(:hover,[data-hover]),[data-theme=dark] .md\\:ikp-btn--variant_neutralFilled:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-expanded-primary-200)}.md\\:ikp-btn--variant_neutralFilled:is(:active,[data-active]){background:var(--ikp-colors-gray-800)}.dark .md\\:ikp-btn--variant_neutralFilled:is(:active,[data-active]),[data-theme=dark] .md\\:ikp-btn--variant_neutralFilled:is(:active,[data-active]){background:var(--ikp-colors-inkeep-expanded-primary-200)}}@media screen and (min-width: 48em){.md\\:ikp-btn--variant_outline{border:1px solid;border-color:currentColor;color:var(--ikp-colors-color-palette-600);background:var(--ikp-colors-transparent)}.dark .md\\:ikp-btn--variant_outline,[data-theme=dark] .md\\:ikp-btn--variant_outline{color:var(--ikp-colors-white-alpha-700)}.light .md\\:ikp-btn--variant_outline,[data-theme=light] .md\\:ikp-btn--variant_outline{color:var(--ikp-colors-gray-700)}.md\\:ikp-btn--variant_outline:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-50));background-color:var(--bga,var(--ikp-colors-color-palette-50))}.dark .md\\:ikp-btn--variant_outline:is(:hover,[data-hover]),[data-theme=dark] .md\\:ikp-btn--variant_outline:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 88%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200));color:var(--ikp-colors-white-alpha-800);background:var(--ikp-colors-white-alpha-200)}.light .md\\:ikp-btn--variant_outline:is(:hover,[data-hover]),[data-theme=light] .md\\:ikp-btn--variant_outline:is(:hover,[data-hover]){color:var(--ikp-colors-gray-800)}.md\\:ikp-btn--variant_outline:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-100));background-color:var(--bga,var(--ikp-colors-color-palette-100))}.dark .md\\:ikp-btn--variant_outline:is(:active,[data-active]),[data-theme=dark] .md\\:ikp-btn--variant_outline:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 76%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200))}}@media screen and (min-width: 48em){.md\\:ikp-btn--variant_iconButton{background:var(--ikp-colors-transparent);border-radius:0;padding-inline:var(--ikp-spacing-1);color:var(--ikp-colors-gray-600)}.dark .md\\:ikp-btn--variant_iconButton,[data-theme=dark] .md\\:ikp-btn--variant_iconButton{color:var(--ikp-colors-white-alpha-600)}.md\\:ikp-btn--variant_iconButton:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-primary-stronger);background:var(--ikp-colors-transparent)}.dark .md\\:ikp-btn--variant_iconButton:is(:hover,[data-hover]),[data-theme=dark] .md\\:ikp-btn--variant_iconButton:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-expanded-primary-300)}}@media screen and (min-width: 48em){.md\\:ikp-btn--size_lg{height:var(--ikp-sizes-12);min-width:var(--ikp-sizes-12);font-size:var(--ikp-font-sizes-lg);padding-inline:var(--ikp-spacing-6)}.md\\:ikp-btn--size_md{height:var(--ikp-sizes-10);min-width:var(--ikp-sizes-10);font-size:var(--ikp-font-sizes-md);padding-inline:var(--ikp-spacing-4)}.md\\:ikp-btn--size_sm{height:var(--ikp-sizes-8);min-width:var(--ikp-sizes-8);font-size:var(--ikp-font-sizes-sm);padding-inline:var(--ikp-spacing-3)}.md\\:ikp-btn--size_xs{height:var(--ikp-sizes-6);min-width:var(--ikp-sizes-6);font-size:var(--ikp-font-sizes-xs);padding-inline:var(--ikp-spacing-2)}.md\\:ikp-close-btn--size_lg{--btn-bg:var(--ikp-sizes-10);font-size:var(--ikp-font-sizes-md)}.md\\:ikp-close-btn--size_md{--btn-bg:var(--ikp-sizes-8);font-size:var(--ikp-font-sizes-xs)}.md\\:ikp-close-btn--size_sm{--btn-bg:var(--ikp-sizes-6);font-size:var(--ikp-font-sizes-2xs)}.md\\:ikp-code--variant_solid{--badge-bg:var(--ikp-colors-color-palette-500);--badge-color:var(--ikp-colors-white)}.dark .md\\:ikp-code--variant_solid,[data-theme=dark] .md\\:ikp-code--variant_solid{--badge-bg-alpha:color-mix(in srgb,transparent 60%,var(--colors-color-palette-500)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-500)) ;--badge-color:var(--ikp-colors-white-alpha-800) }.md\\:ikp-code--variant_subtle{--badge-bg:colorPalette.1;--badge-color:var(--ikp-colors-color-palette-800)}.dark .md\\:ikp-code--variant_subtle,[data-theme=dark] .md\\:ikp-code--variant_subtle{--badge-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) ;--badge-color:var(--ikp-colors-color-palette-200) }.md\\:ikp-code--variant_outline{--badge-color:var(--ikp-colors-color-palette-500);--badge-shadow:inset 0 0 0px 1px var(--badge-color,inherit)}.dark .md\\:ikp-code--variant_outline,[data-theme=dark] .md\\:ikp-code--variant_outline{--badge-bg-alpha:color-mix(in srgb,transparent 80%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) }.md\\:ikp-badge--variant_solid{--badge-bg:var(--ikp-colors-color-palette-500);--badge-color:var(--ikp-colors-white)}.dark .md\\:ikp-badge--variant_solid,[data-theme=dark] .md\\:ikp-badge--variant_solid{--badge-bg-alpha:color-mix(in srgb,transparent 60%,var(--colors-color-palette-500)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-500)) ;--badge-color:var(--ikp-colors-white-alpha-800) }.md\\:ikp-badge--variant_subtle{--badge-bg:colorPalette.1;--badge-color:var(--ikp-colors-color-palette-800)}.dark .md\\:ikp-badge--variant_subtle,[data-theme=dark] .md\\:ikp-badge--variant_subtle{--badge-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) ;--badge-color:var(--ikp-colors-color-palette-200) }.md\\:ikp-badge--variant_outline{--badge-color:var(--ikp-colors-color-palette-500);--badge-shadow:inset 0 0 0px 1px var(--badge-color,inherit)}.dark .md\\:ikp-badge--variant_outline,[data-theme=dark] .md\\:ikp-badge--variant_outline{--badge-bg-alpha:color-mix(in srgb,transparent 80%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) }.md\\:ikp-heading--size_4xl{font-size:var(--ikp-font-sizes-6xl);line-height:1}}@media screen and (min-width: 48em){@media screen and (min-width: 48em){.md\\:ikp-heading--size_4xl{font-size:var(--ikp-font-sizes-7xl)}}}@media screen and (min-width: 48em){.md\\:ikp-heading--size_3xl{font-size:var(--ikp-font-sizes-5xl);line-height:1}@media screen and (min-width: 48em){.md\\:ikp-heading--size_3xl{font-size:var(--ikp-font-sizes-6xl)}}}@media screen and (min-width: 48em){.md\\:ikp-heading--size_2xl{font-size:var(--ikp-font-sizes-4xl);line-height:1.2}@media screen and (min-width: 48em){.md\\:ikp-heading--size_2xl{font-size:var(--ikp-font-sizes-5xl);line-height:1}}}@media screen and (min-width: 48em){.md\\:ikp-heading--size_xl{font-size:var(--ikp-font-sizes-3xl);line-height:1.33}@media screen and (min-width: 48em){.md\\:ikp-heading--size_xl{font-size:var(--ikp-font-sizes-4xl);line-height:1.2}}}@media screen and (min-width: 48em){.md\\:ikp-heading--size_lg{font-size:var(--ikp-font-sizes-2xl);line-height:1.33}@media screen and (min-width: 48em){.md\\:ikp-heading--size_lg{font-size:var(--ikp-font-sizes-3xl);line-height:1.2}}}@media screen and (min-width: 48em){.md\\:ikp-heading--size_md{font-size:var(--ikp-font-sizes-xl);line-height:1.2}.md\\:ikp-heading--size_sm{font-size:var(--ikp-font-sizes-md);line-height:1.2}.md\\:ikp-heading--size_xs{font-size:var(--ikp-font-sizes-sm);line-height:1.2}.md\\:ikp-heading--uppercase_true{text-transform:uppercase;letter-spacing:1px;font-weight:600;color:var(--ikp-colors-gray-600)}.md\\:ikp-icon--variant_dark{color:var(--ikp-colors-white)}.md\\:ikp-icon--variant_lightPrimary{color:var(--ikp-colors-inkeep-primary-text-subtle)}.md\\:ikp-icon--variant_light{color:var(--ikp-colors-gray-600)}.md\\:ikp-kbd--variant_dark{background:primaryDark.9;color:var(--ikp-colors-white);border-color:primaryDark.6;border-radius:3px;border-bottom:2px solid}.md\\:ikp-kbd--variant_darkOutline{color:var(--ikp-colors-white)}.md\\:ikp-kbd--variant_darkOutline,.md\\:ikp-kbd--variant_light{background:primary.1;border-color:var(--ikp-colors-inkeep-primary-medium);border-radius:3px;border-bottom:2px solid}.md\\:ikp-kbd--variant_light{color:var(--ikp-colors-inkeep-primary-medium)}.md\\:ikp-kbd--variant_grayLight{background:var(--ikp-colors-gray-400);height:40px;padding:2px 6px;color:var(--ikp-colors-gray-600);border-color:var(--ikp-colors-gray-600);border-radius:3px;border-bottom:2px solid gray.7}.md\\:ikp-kbd--variant_outline{box-shadow:var(--ikp-shadows-none)}.md\\:ikp-tag--variant_solid{--badge-bg:var(--ikp-colors-color-palette-500);--badge-color:var(--ikp-colors-white)}.dark .md\\:ikp-tag--variant_solid,[data-theme=dark] .md\\:ikp-tag--variant_solid{--badge-bg-alpha:color-mix(in srgb,transparent 60%,var(--colors-color-palette-500)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-500)) ;--badge-color:var(--ikp-colors-white-alpha-800) }.md\\:ikp-tag--variant_subtle{--badge-bg:colorPalette.1;--badge-color:var(--ikp-colors-color-palette-800)}.dark .md\\:ikp-tag--variant_subtle,[data-theme=dark] .md\\:ikp-tag--variant_subtle{--badge-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) ;--badge-color:var(--ikp-colors-color-palette-200) }.md\\:ikp-tag--variant_outline{--badge-color:var(--ikp-colors-color-palette-500);--badge-shadow:inset 0 0 0px 1px var(--badge-color,inherit)}.dark .md\\:ikp-tag--variant_outline,[data-theme=dark] .md\\:ikp-tag--variant_outline{--badge-bg-alpha:color-mix(in srgb,transparent 80%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) }.md\\:ikp-tag--size_sm{--tag-min-height:var(--ikp-sizes-5);--tag-min-width:var(--ikp-sizes-5);--tag-font-size:var(--ikp-font-sizes-xs);--tag-padding-inline:var(--ikp-space-2)}.md\\:ikp-tag--size_md{--tag-min-height:var(--ikp-sizes-6);--tag-min-width:var(--ikp-sizes-6);--tag-font-size:var(--ikp-font-sizes-sm);--tag-padding-inline:var(--ikp-space-2)}.md\\:ikp-tag--size_lg{--tag-min-height:var(--ikp-sizes-8);--tag-min-width:var(--ikp-sizes-8);--tag-font-size:var(--ikp-font-sizes-md);--tag-padding-inline:var(--ikp-space-3)}.md\\:ikp-textarea--variant_outline{border:1px solid;border-color:inherit;background:inherit}}@media screen and (min-width: 48em){.md\\:ikp-textarea--variant_outline:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.md\\:ikp-textarea--variant_outline[aria-invalid=true],.md\\:ikp-textarea--variant_outline[data-invalid] .md\\:ikp-textarea--variant_outline{border-color:var(--input-error-border-color);box-shadow:0 0 0 1px var(--input-error-border-color)}.md\\:ikp-textarea--variant_outline:is(:focus-visible,[data-focus-visible]){z-index:1;border-color:var(--input-focus-border-color);box-shadow:0 0 0 1px var(--input-focus-border-color)}.md\\:ikp-textarea--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-300)}.dark .md\\:ikp-textarea--variant_outline:is(:hover,[data-hover]),[data-theme=dark] .md\\:ikp-textarea--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}}@media screen and (min-width: 48em){.md\\:ikp-textarea--variant_flushed{border-bottom:1px solid;border-color:inherit;border-radius:0;padding-inline:var(--ikp-spacing-0);background:var(--ikp-colors-transparent)}.md\\:ikp-textarea--variant_flushed:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.md\\:ikp-textarea--variant_flushed[aria-invalid=true],.md\\:ikp-textarea--variant_flushed[data-invalid] .md\\:ikp-textarea--variant_flushed{border-color:var(--input-error-border-color);box-shadow:0 1px 0 0 var(--input-error-border-color)}.md\\:ikp-textarea--variant_flushed:is(:focus-visible,[data-focus-visible]){border-color:var(--input-focus-border-color);box-shadow:0 1px 0 0 var(--input-focus-border-color)}}@media screen and (min-width: 48em){.md\\:ikp-textarea--variant_filled{border:2px solid;border-color:var(--ikp-colors-transparent);background:var(--ikp-colors-gray-100)}.dark .md\\:ikp-textarea--variant_filled,[data-theme=dark] .md\\:ikp-textarea--variant_filled{background:var(--ikp-colors-white-alpha-50)}.md\\:ikp-textarea--variant_filled:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.md\\:ikp-textarea--variant_filled[aria-invalid=true],.md\\:ikp-textarea--variant_filled[data-invalid] .md\\:ikp-textarea--variant_filled{border-color:var(--input-error-border-color)}.md\\:ikp-textarea--variant_filled:is(:focus-visible,[data-focus-visible]){background:var(--ikp-colors-transparent);border-color:var(--input-focus-border-color)}.md\\:ikp-textarea--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-gray-200)}.dark .md\\:ikp-textarea--variant_filled:is(:hover,[data-hover]),[data-theme=dark] .md\\:ikp-textarea--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-100)}}@media screen and (min-width: 48em){.md\\:ikp-textarea--variant_unstyled{background:var(--ikp-colors-transparent);padding-inline:var(--ikp-spacing-0);height:var(--ikp-sizes-auto)}.md\\:ikp-textarea--size_xs{--input-font-size:var(--ikp-font-sizes-xs);--input-padding:var(--ikp-space-2);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-6)}.md\\:ikp-textarea--size_sm{--input-font-size:var(--ikp-font-sizes-sm);--input-padding:var(--ikp-space-3);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-8)}.md\\:ikp-textarea--size_md{--input-font-size:var(--ikp-font-sizes-md);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-10)}.md\\:ikp-textarea--size_lg{--input-font-size:var(--ikp-font-sizes-lg);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-12)}.md\\:ikp-ai-chat-page-wrapper--size_expand{width:100%;height:100%}.md\\:ikp-ai-chat-page-wrapper--size_default{max-width:100vw;max-height:100vw;margin:auto;align-self:center;justify-self:center;flex-grow:0}}@media screen and (min-width: 48em){@media screen and (min-width: 48em){.md\\:ikp-ai-chat-page-wrapper--size_default{width:min(600px,100%);height:min(760px,100%)}}@media screen and (min-width: 64em){.md\\:ikp-ai-chat-page-wrapper--size_default{width:min(640px,100%);height:min(800px,100%)}}@media screen and (min-width: 96em){.md\\:ikp-ai-chat-page-wrapper--size_default{width:min(760px,100%);height:min(900px,100%)}}}@media screen and (min-width: 48em){.md\\:ikp-ai-chat-page-wrapper--size_shrink-vertically{width:100%;height:var(--ikp-sizes-auto);align-self:flex-start;max-height:100%}@media screen and (min-width: 48em){.md\\:ikp-ai-chat-page-wrapper--size_shrink-vertically{width:100%}}}@media screen and (min-width: 48em){.md\\:ikp-ai-chat-page-wrapper--size_full-viewport{position:fixed;top:var(--ikp-spacing-0);left:var(--ikp-spacing-0);z-index:1000;width:100vw;height:100vh}.md\\:ikp-ai-chat-page-wrapper--variant_no-shadow{box-shadow:var(--ikp-shadows-none)}.md\\:ikp-ai-chat-page-wrapper--variant_container-with-shadow{box-shadow:var(--ikp-shadows-2xl)}.dark .md\\:ikp-ai-chat-page-wrapper--variant_container-with-shadow,[data-theme=dark] .md\\:ikp-ai-chat-page-wrapper--variant_container-with-shadow{box-shadow:var(--ikp-shadows-none)}.light .md\\:ikp-preview-content-header--variant_title,[data-theme=light] .md\\:ikp-preview-content-header--variant_title{color:var(--ikp-colors-inkeep-primary-text-subtle)}.dark .md\\:ikp-preview-content-header--variant_title,[data-theme=dark] .md\\:ikp-preview-content-header--variant_title{color:var(--ikp-colors-inkeep-primary-lighter)}}@media screen and (min-width: 48em){.light .md\\:ikp-preview-content-header--variant_title:is(:hover,[data-hover]),[data-theme=light] .md\\:ikp-preview-content-header--variant_title:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-primary-stronger)}.dark .md\\:ikp-preview-content-header--variant_title:is(:hover,[data-hover]),[data-theme=dark] .md\\:ikp-preview-content-header--variant_title:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-expanded-primary-100)}}@media screen and (min-width: 48em){.light .md\\:ikp-preview-content-header--variant_hitContentPreview,[data-theme=light] .md\\:ikp-preview-content-header--variant_hitContentPreview{color:var(--ikp-colors-inkeep-primary-hit-content-preview)}.dark .md\\:ikp-preview-content-header--variant_hitContentPreview,[data-theme=dark] .md\\:ikp-preview-content-header--variant_hitContentPreview{color:var(--ikp-colors-inkeep-expanded-primary-300)}.md\\:ikp-preview-content-header--variant_hitContentPreview .light a:hover,.md\\:ikp-preview-content-header--variant_hitContentPreview [data-theme=light] a:hover{color:var(--ikp-colors-inkeep-primary-stronger)}.md\\:ikp-preview-content-header--variant_hitContentPreview .dark a:hover,.md\\:ikp-preview-content-header--variant_hitContentPreview [data-theme=dark] a:hover{color:var(--ikp-colors-inkeep-expanded-primary-100)}}@media screen and (min-width: 64em){.ikp-ai-chat-page-wrapper--size_default{width:min(640px,100%);height:min(800px,100%)}.lg\\:ikp-btn--colorPalette_gray{--ikp-colors-color-palette-50:var(--ikp-colors-gray-50);--ikp-colors-color-palette-100:var(--ikp-colors-gray-100);--ikp-colors-color-palette-200:var(--ikp-colors-gray-200);--ikp-colors-color-palette-300:var(--ikp-colors-gray-300);--ikp-colors-color-palette-400:var(--ikp-colors-gray-400);--ikp-colors-color-palette-500:var(--ikp-colors-gray-500);--ikp-colors-color-palette-600:var(--ikp-colors-gray-600);--ikp-colors-color-palette-700:var(--ikp-colors-gray-700);--ikp-colors-color-palette-800:var(--ikp-colors-gray-800);--ikp-colors-color-palette-900:var(--ikp-colors-gray-900);--ikp-colors-color-palette-950:var(--ikp-colors-gray-950)}.lg\\:ikp-btn--colorPalette_blue{--ikp-colors-color-palette-50:var(--ikp-colors-blue-50);--ikp-colors-color-palette-100:var(--ikp-colors-blue-100);--ikp-colors-color-palette-200:var(--ikp-colors-blue-200);--ikp-colors-color-palette-300:var(--ikp-colors-blue-300);--ikp-colors-color-palette-400:var(--ikp-colors-blue-400);--ikp-colors-color-palette-500:var(--ikp-colors-blue-500);--ikp-colors-color-palette-600:var(--ikp-colors-blue-600);--ikp-colors-color-palette-700:var(--ikp-colors-blue-700);--ikp-colors-color-palette-800:var(--ikp-colors-blue-800);--ikp-colors-color-palette-900:var(--ikp-colors-blue-900);--ikp-colors-color-palette-950:var(--ikp-colors-blue-950)}.lg\\:ikp-btn--colorPalette_teal{--ikp-colors-color-palette-50:var(--ikp-colors-teal-50);--ikp-colors-color-palette-100:var(--ikp-colors-teal-100);--ikp-colors-color-palette-200:var(--ikp-colors-teal-200);--ikp-colors-color-palette-300:var(--ikp-colors-teal-300);--ikp-colors-color-palette-400:var(--ikp-colors-teal-400);--ikp-colors-color-palette-500:var(--ikp-colors-teal-500);--ikp-colors-color-palette-600:var(--ikp-colors-teal-600);--ikp-colors-color-palette-700:var(--ikp-colors-teal-700);--ikp-colors-color-palette-800:var(--ikp-colors-teal-800);--ikp-colors-color-palette-900:var(--ikp-colors-teal-900);--ikp-colors-color-palette-950:var(--ikp-colors-teal-950)}.lg\\:ikp-btn--colorPalette_inkeepPrimary{--ikp-colors-color-palette-hit-content-preview:var(--ikp-colors-inkeep-primary-hit-content-preview);--ikp-colors-color-palette-hit-content-preview-hover:var(--ikp-colors-inkeep-primary-hit-content-preview-hover);--ikp-colors-color-palette-text-bold:var(--ikp-colors-inkeep-primary-text-bold);--ikp-colors-color-palette-text-subtle:var(--ikp-colors-inkeep-primary-text-subtle);--ikp-colors-color-palette-lighter:var(--ikp-colors-inkeep-primary-lighter);--ikp-colors-color-palette-light:var(--ikp-colors-inkeep-primary-light);--ikp-colors-color-palette-light-subtle:var(--ikp-colors-inkeep-primary-light-subtle);--ikp-colors-color-palette-medium:var(--ikp-colors-inkeep-primary-medium);--ikp-colors-color-palette-medium-subtle:var(--ikp-colors-inkeep-primary-medium-subtle);--ikp-colors-color-palette-strong:var(--ikp-colors-inkeep-primary-strong);--ikp-colors-color-palette-stronger:var(--ikp-colors-inkeep-primary-stronger);--ikp-colors-color-palette-text-color-on-primary:var(--ikp-colors-inkeep-primary-text-color-on-primary)}.lg\\:ikp-btn--variant_ghost{color:var(--ikp-colors-color-palette-600);background:var(--ikp-colors-transparent)}.dark .lg\\:ikp-btn--variant_ghost,[data-theme=dark] .lg\\:ikp-btn--variant_ghost{color:var(--ikp-colors-color-palette-200)}}@media screen and (min-width: 64em){.lg\\:ikp-btn--variant_ghost:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-50));background-color:var(--bga,var(--ikp-colors-color-palette-50))}.dark .lg\\:ikp-btn--variant_ghost:is(:hover,[data-hover]),[data-theme=dark] .lg\\:ikp-btn--variant_ghost:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 88%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200))}.lg\\:ikp-btn--variant_ghost:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-100));background-color:var(--bga,var(--ikp-colors-color-palette-100))}.dark .lg\\:ikp-btn--variant_ghost:is(:active,[data-active]),[data-theme=dark] .lg\\:ikp-btn--variant_ghost:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 76%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200))}}@media screen and (min-width: 64em){.lg\\:ikp-btn--variant_solid{background:var(--ikp-colors-color-palette-500);color:var(--ikp-colors-white)}.dark .lg\\:ikp-btn--variant_solid,[data-theme=dark] .lg\\:ikp-btn--variant_solid{background:var(--ikp-colors-color-palette-200);color:var(--ikp-colors-gray-800)}.lg\\:ikp-btn--variant_solid:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-600)}.dark .lg\\:ikp-btn--variant_solid:is(:hover,[data-hover]),[data-theme=dark] .lg\\:ikp-btn--variant_solid:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-300)}.lg\\:ikp-btn--variant_solid:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){background:var(--ikp-colors-color-palette-500)}.dark .lg\\:ikp-btn--variant_solid:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]),[data-theme=dark] .lg\\:ikp-btn--variant_solid:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){background:var(--ikp-colors-color-palette-200)}.lg\\:ikp-btn--variant_solid:is(:active,[data-active]){background:var(--ikp-colors-color-palette-700)}.dark .lg\\:ikp-btn--variant_solid:is(:active,[data-active]),[data-theme=dark] .lg\\:ikp-btn--variant_solid:is(:active,[data-active]){background:var(--ikp-colors-color-palette-400)}}@media screen and (min-width: 64em){.lg\\:ikp-btn--variant_link{padding:var(--ikp-spacing-0)!important;height:var(--ikp-sizes-auto)!important;line-height:var(--ikp-line-heights-base);vertical-align:baseline;font-weight:var(--ikp-font-weights-normal);color:var(--ikp-colors-color-palette-500)}.dark .lg\\:ikp-btn--variant_link,[data-theme=dark] .lg\\:ikp-btn--variant_link{color:var(--ikp-colors-color-palette-200)}.lg\\:ikp-btn--variant_link:is(:hover,[data-hover]){text-decoration:underline}.lg\\:ikp-btn--variant_link:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){text-decoration:none}.lg\\:ikp-btn--variant_link:is(:active,[data-active]){color:var(--ikp-colors-color-palette-700)}.dark .lg\\:ikp-btn--variant_link:is(:active,[data-active]),[data-theme=dark] .lg\\:ikp-btn--variant_link:is(:active,[data-active]){color:var(--ikp-colors-color-palette-500)}}@media screen and (min-width: 64em){.lg\\:ikp-btn--variant_unstyled{background:none;color:inherit;display:inline;line-height:inherit;margin:var(--ikp-spacing-0);padding:var(--ikp-spacing-0);border-radius:unset}.lg\\:ikp-btn--variant_outlinePrimary{border:1px solid}.light .lg\\:ikp-btn--variant_outlinePrimary,[data-theme=light] .lg\\:ikp-btn--variant_outlinePrimary{color:var(--ikp-colors-inkeep-primary-strong);border-color:var(--ikp-colors-inkeep-expanded-primary-200)}.dark .lg\\:ikp-btn--variant_outlinePrimary,[data-theme=dark] .lg\\:ikp-btn--variant_outlinePrimary{color:var(--ikp-colors-inkeep-expanded-primary-300)}}@media screen and (min-width: 64em){.light .lg\\:ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]),[data-theme=light] .lg\\:ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-light-subtle);color:var(--ikp-colors-inkeep-primary-strong)}.dark .lg\\:ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]),[data-theme=dark] .lg\\:ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-200);color:var(--ikp-colors-inkeep-expanded-primary-200)}}@media screen and (min-width: 64em){.lg\\:ikp-btn--variant_outlineFilled{background:var(--ikp-colors-white);border:1px solid;border-color:var(--ikp-colors-inkeep-primary-strong);color:var(--ikp-colors-inkeep-primary-strong)}.lg\\:ikp-btn--variant_outlineFilled:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-strong);color:var(--ikp-colors-white)}.lg\\:ikp-btn--variant_outlineFilled:is(:active,[data-active]){background:var(--ikp-colors-inkeep-primary-strong)}}@media screen and (min-width: 64em){.lg\\:ikp-btn--variant_outlineFilledActive{background:var(--ikp-colors-inkeep-primary-strong);color:var(--ikp-colors-white)}.lg\\:ikp-btn--variant_chatButton{background:var(--ikp-colors-inkeep-primary-text-bold);box-shadow:var(--ikp-shadows-2xl);border-radius:var(--ikp-radii-lg);color:var(--ikp-colors-white);font-weight:var(--ikp-font-weights-medium)}.dark .lg\\:ikp-btn--variant_chatButton,[data-theme=dark] .lg\\:ikp-btn--variant_chatButton{background:var(--ikp-colors-gray-dark-600);box-shadow:var(--ikp-shadows-none)}.lg\\:ikp-btn--variant_filledCTA{background:var(--ikp-colors-inkeep-primary-medium);color:var(--ikp-colors-white);border:var(--ikp-borders-none);border-radius:80px}}@media screen and (min-width: 64em){.lg\\:ikp-btn--variant_filledCTA:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-medium)}.lg\\:ikp-btn--variant_filledCTA:is(:active,[data-active]){background:var(--ikp-colors-inkeep-primary-medium)}}@media screen and (min-width: 64em){.lg\\:ikp-btn--variant_primaryFilled{background:var(--ikp-colors-inkeep-primary-medium);color:var(--ikp-colors-inkeep-primary-text-color-on-primary)}.lg\\:ikp-btn--variant_primaryFilled:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-strong)}.lg\\:ikp-btn--variant_primaryFilled:is(:active,[data-active]){background:var(--ikp-colors-inkeep-primary-strong)}}@media screen and (min-width: 64em){.lg\\:ikp-btn--variant_neutralFilled{background:var(--ikp-colors-gray-900);color:var(--ikp-colors-white)}.dark .lg\\:ikp-btn--variant_neutralFilled,[data-theme=dark] .lg\\:ikp-btn--variant_neutralFilled{background:var(--ikp-colors-inkeep-expanded-primary-300);color:var(--ikp-colors-gray-dark-900)}.lg\\:ikp-btn--variant_neutralFilled:is(:hover,[data-hover]){background:var(--ikp-colors-gray-800)}.dark .lg\\:ikp-btn--variant_neutralFilled:is(:hover,[data-hover]),[data-theme=dark] .lg\\:ikp-btn--variant_neutralFilled:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-expanded-primary-200)}.lg\\:ikp-btn--variant_neutralFilled:is(:active,[data-active]){background:var(--ikp-colors-gray-800)}.dark .lg\\:ikp-btn--variant_neutralFilled:is(:active,[data-active]),[data-theme=dark] .lg\\:ikp-btn--variant_neutralFilled:is(:active,[data-active]){background:var(--ikp-colors-inkeep-expanded-primary-200)}}@media screen and (min-width: 64em){.lg\\:ikp-btn--variant_outline{border:1px solid;border-color:currentColor;color:var(--ikp-colors-color-palette-600);background:var(--ikp-colors-transparent)}.dark .lg\\:ikp-btn--variant_outline,[data-theme=dark] .lg\\:ikp-btn--variant_outline{color:var(--ikp-colors-white-alpha-700)}.light .lg\\:ikp-btn--variant_outline,[data-theme=light] .lg\\:ikp-btn--variant_outline{color:var(--ikp-colors-gray-700)}.lg\\:ikp-btn--variant_outline:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-50));background-color:var(--bga,var(--ikp-colors-color-palette-50))}.dark .lg\\:ikp-btn--variant_outline:is(:hover,[data-hover]),[data-theme=dark] .lg\\:ikp-btn--variant_outline:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 88%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200));color:var(--ikp-colors-white-alpha-800);background:var(--ikp-colors-white-alpha-200)}.light .lg\\:ikp-btn--variant_outline:is(:hover,[data-hover]),[data-theme=light] .lg\\:ikp-btn--variant_outline:is(:hover,[data-hover]){color:var(--ikp-colors-gray-800)}.lg\\:ikp-btn--variant_outline:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-100));background-color:var(--bga,var(--ikp-colors-color-palette-100))}.dark .lg\\:ikp-btn--variant_outline:is(:active,[data-active]),[data-theme=dark] .lg\\:ikp-btn--variant_outline:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 76%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200))}}@media screen and (min-width: 64em){.lg\\:ikp-btn--variant_iconButton{background:var(--ikp-colors-transparent);border-radius:0;padding-inline:var(--ikp-spacing-1);color:var(--ikp-colors-gray-600)}.dark .lg\\:ikp-btn--variant_iconButton,[data-theme=dark] .lg\\:ikp-btn--variant_iconButton{color:var(--ikp-colors-white-alpha-600)}.lg\\:ikp-btn--variant_iconButton:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-primary-stronger);background:var(--ikp-colors-transparent)}.dark .lg\\:ikp-btn--variant_iconButton:is(:hover,[data-hover]),[data-theme=dark] .lg\\:ikp-btn--variant_iconButton:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-expanded-primary-300)}}@media screen and (min-width: 64em){.lg\\:ikp-btn--size_lg{height:var(--ikp-sizes-12);min-width:var(--ikp-sizes-12);font-size:var(--ikp-font-sizes-lg);padding-inline:var(--ikp-spacing-6)}.lg\\:ikp-btn--size_md{height:var(--ikp-sizes-10);min-width:var(--ikp-sizes-10);font-size:var(--ikp-font-sizes-md);padding-inline:var(--ikp-spacing-4)}.lg\\:ikp-btn--size_sm{height:var(--ikp-sizes-8);min-width:var(--ikp-sizes-8);font-size:var(--ikp-font-sizes-sm);padding-inline:var(--ikp-spacing-3)}.lg\\:ikp-btn--size_xs{height:var(--ikp-sizes-6);min-width:var(--ikp-sizes-6);font-size:var(--ikp-font-sizes-xs);padding-inline:var(--ikp-spacing-2)}.lg\\:ikp-close-btn--size_lg{--btn-bg:var(--ikp-sizes-10);font-size:var(--ikp-font-sizes-md)}.lg\\:ikp-close-btn--size_md{--btn-bg:var(--ikp-sizes-8);font-size:var(--ikp-font-sizes-xs)}.lg\\:ikp-close-btn--size_sm{--btn-bg:var(--ikp-sizes-6);font-size:var(--ikp-font-sizes-2xs)}.lg\\:ikp-code--variant_solid{--badge-bg:var(--ikp-colors-color-palette-500);--badge-color:var(--ikp-colors-white)}.dark .lg\\:ikp-code--variant_solid,[data-theme=dark] .lg\\:ikp-code--variant_solid{--badge-bg-alpha:color-mix(in srgb,transparent 60%,var(--colors-color-palette-500)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-500)) ;--badge-color:var(--ikp-colors-white-alpha-800) }.lg\\:ikp-code--variant_subtle{--badge-bg:colorPalette.1;--badge-color:var(--ikp-colors-color-palette-800)}.dark .lg\\:ikp-code--variant_subtle,[data-theme=dark] .lg\\:ikp-code--variant_subtle{--badge-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) ;--badge-color:var(--ikp-colors-color-palette-200) }.lg\\:ikp-code--variant_outline{--badge-color:var(--ikp-colors-color-palette-500);--badge-shadow:inset 0 0 0px 1px var(--badge-color,inherit)}.dark .lg\\:ikp-code--variant_outline,[data-theme=dark] .lg\\:ikp-code--variant_outline{--badge-bg-alpha:color-mix(in srgb,transparent 80%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) }.lg\\:ikp-badge--variant_solid{--badge-bg:var(--ikp-colors-color-palette-500);--badge-color:var(--ikp-colors-white)}.dark .lg\\:ikp-badge--variant_solid,[data-theme=dark] .lg\\:ikp-badge--variant_solid{--badge-bg-alpha:color-mix(in srgb,transparent 60%,var(--colors-color-palette-500)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-500)) ;--badge-color:var(--ikp-colors-white-alpha-800) }.lg\\:ikp-badge--variant_subtle{--badge-bg:colorPalette.1;--badge-color:var(--ikp-colors-color-palette-800)}.dark .lg\\:ikp-badge--variant_subtle,[data-theme=dark] .lg\\:ikp-badge--variant_subtle{--badge-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) ;--badge-color:var(--ikp-colors-color-palette-200) }.lg\\:ikp-badge--variant_outline{--badge-color:var(--ikp-colors-color-palette-500);--badge-shadow:inset 0 0 0px 1px var(--badge-color,inherit)}.dark .lg\\:ikp-badge--variant_outline,[data-theme=dark] .lg\\:ikp-badge--variant_outline{--badge-bg-alpha:color-mix(in srgb,transparent 80%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) }.lg\\:ikp-heading--size_4xl{font-size:var(--ikp-font-sizes-6xl);line-height:1}}@media screen and (min-width: 64em){@media screen and (min-width: 48em){.lg\\:ikp-heading--size_4xl{font-size:var(--ikp-font-sizes-7xl)}}}@media screen and (min-width: 64em){.lg\\:ikp-heading--size_3xl{font-size:var(--ikp-font-sizes-5xl);line-height:1}@media screen and (min-width: 48em){.lg\\:ikp-heading--size_3xl{font-size:var(--ikp-font-sizes-6xl)}}}@media screen and (min-width: 64em){.lg\\:ikp-heading--size_2xl{font-size:var(--ikp-font-sizes-4xl);line-height:1.2}@media screen and (min-width: 48em){.lg\\:ikp-heading--size_2xl{font-size:var(--ikp-font-sizes-5xl);line-height:1}}}@media screen and (min-width: 64em){.lg\\:ikp-heading--size_xl{font-size:var(--ikp-font-sizes-3xl);line-height:1.33}@media screen and (min-width: 48em){.lg\\:ikp-heading--size_xl{font-size:var(--ikp-font-sizes-4xl);line-height:1.2}}}@media screen and (min-width: 64em){.lg\\:ikp-heading--size_lg{font-size:var(--ikp-font-sizes-2xl);line-height:1.33}@media screen and (min-width: 48em){.lg\\:ikp-heading--size_lg{font-size:var(--ikp-font-sizes-3xl);line-height:1.2}}}@media screen and (min-width: 64em){.lg\\:ikp-heading--size_md{font-size:var(--ikp-font-sizes-xl);line-height:1.2}.lg\\:ikp-heading--size_sm{font-size:var(--ikp-font-sizes-md);line-height:1.2}.lg\\:ikp-heading--size_xs{font-size:var(--ikp-font-sizes-sm);line-height:1.2}.lg\\:ikp-heading--uppercase_true{text-transform:uppercase;letter-spacing:1px;font-weight:600;color:var(--ikp-colors-gray-600)}.lg\\:ikp-icon--variant_dark{color:var(--ikp-colors-white)}.lg\\:ikp-icon--variant_lightPrimary{color:var(--ikp-colors-inkeep-primary-text-subtle)}.lg\\:ikp-icon--variant_light{color:var(--ikp-colors-gray-600)}.lg\\:ikp-kbd--variant_dark{background:primaryDark.9;color:var(--ikp-colors-white);border-color:primaryDark.6;border-radius:3px;border-bottom:2px solid}.lg\\:ikp-kbd--variant_darkOutline{color:var(--ikp-colors-white)}.lg\\:ikp-kbd--variant_darkOutline,.lg\\:ikp-kbd--variant_light{background:primary.1;border-color:var(--ikp-colors-inkeep-primary-medium);border-radius:3px;border-bottom:2px solid}.lg\\:ikp-kbd--variant_light{color:var(--ikp-colors-inkeep-primary-medium)}.lg\\:ikp-kbd--variant_grayLight{background:var(--ikp-colors-gray-400);height:40px;padding:2px 6px;color:var(--ikp-colors-gray-600);border-color:var(--ikp-colors-gray-600);border-radius:3px;border-bottom:2px solid gray.7}.lg\\:ikp-kbd--variant_outline{box-shadow:var(--ikp-shadows-none)}.lg\\:ikp-tag--variant_solid{--badge-bg:var(--ikp-colors-color-palette-500);--badge-color:var(--ikp-colors-white)}.dark .lg\\:ikp-tag--variant_solid,[data-theme=dark] .lg\\:ikp-tag--variant_solid{--badge-bg-alpha:color-mix(in srgb,transparent 60%,var(--colors-color-palette-500)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-500)) ;--badge-color:var(--ikp-colors-white-alpha-800) }.lg\\:ikp-tag--variant_subtle{--badge-bg:colorPalette.1;--badge-color:var(--ikp-colors-color-palette-800)}.dark .lg\\:ikp-tag--variant_subtle,[data-theme=dark] .lg\\:ikp-tag--variant_subtle{--badge-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) ;--badge-color:var(--ikp-colors-color-palette-200) }.lg\\:ikp-tag--variant_outline{--badge-color:var(--ikp-colors-color-palette-500);--badge-shadow:inset 0 0 0px 1px var(--badge-color,inherit)}.dark .lg\\:ikp-tag--variant_outline,[data-theme=dark] .lg\\:ikp-tag--variant_outline{--badge-bg-alpha:color-mix(in srgb,transparent 80%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) }.lg\\:ikp-tag--size_sm{--tag-min-height:var(--ikp-sizes-5);--tag-min-width:var(--ikp-sizes-5);--tag-font-size:var(--ikp-font-sizes-xs);--tag-padding-inline:var(--ikp-space-2)}.lg\\:ikp-tag--size_md{--tag-min-height:var(--ikp-sizes-6);--tag-min-width:var(--ikp-sizes-6);--tag-font-size:var(--ikp-font-sizes-sm);--tag-padding-inline:var(--ikp-space-2)}.lg\\:ikp-tag--size_lg{--tag-min-height:var(--ikp-sizes-8);--tag-min-width:var(--ikp-sizes-8);--tag-font-size:var(--ikp-font-sizes-md);--tag-padding-inline:var(--ikp-space-3)}.lg\\:ikp-textarea--variant_outline{border:1px solid;border-color:inherit;background:inherit}}@media screen and (min-width: 64em){.lg\\:ikp-textarea--variant_outline:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.lg\\:ikp-textarea--variant_outline[aria-invalid=true],.lg\\:ikp-textarea--variant_outline[data-invalid] .lg\\:ikp-textarea--variant_outline{border-color:var(--input-error-border-color);box-shadow:0 0 0 1px var(--input-error-border-color)}.lg\\:ikp-textarea--variant_outline:is(:focus-visible,[data-focus-visible]){z-index:1;border-color:var(--input-focus-border-color);box-shadow:0 0 0 1px var(--input-focus-border-color)}.lg\\:ikp-textarea--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-300)}.dark .lg\\:ikp-textarea--variant_outline:is(:hover,[data-hover]),[data-theme=dark] .lg\\:ikp-textarea--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}}@media screen and (min-width: 64em){.lg\\:ikp-textarea--variant_flushed{border-bottom:1px solid;border-color:inherit;border-radius:0;padding-inline:var(--ikp-spacing-0);background:var(--ikp-colors-transparent)}.lg\\:ikp-textarea--variant_flushed:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.lg\\:ikp-textarea--variant_flushed[aria-invalid=true],.lg\\:ikp-textarea--variant_flushed[data-invalid] .lg\\:ikp-textarea--variant_flushed{border-color:var(--input-error-border-color);box-shadow:0 1px 0 0 var(--input-error-border-color)}.lg\\:ikp-textarea--variant_flushed:is(:focus-visible,[data-focus-visible]){border-color:var(--input-focus-border-color);box-shadow:0 1px 0 0 var(--input-focus-border-color)}}@media screen and (min-width: 64em){.lg\\:ikp-textarea--variant_filled{border:2px solid;border-color:var(--ikp-colors-transparent);background:var(--ikp-colors-gray-100)}.dark .lg\\:ikp-textarea--variant_filled,[data-theme=dark] .lg\\:ikp-textarea--variant_filled{background:var(--ikp-colors-white-alpha-50)}.lg\\:ikp-textarea--variant_filled:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.lg\\:ikp-textarea--variant_filled[aria-invalid=true],.lg\\:ikp-textarea--variant_filled[data-invalid] .lg\\:ikp-textarea--variant_filled{border-color:var(--input-error-border-color)}.lg\\:ikp-textarea--variant_filled:is(:focus-visible,[data-focus-visible]){background:var(--ikp-colors-transparent);border-color:var(--input-focus-border-color)}.lg\\:ikp-textarea--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-gray-200)}.dark .lg\\:ikp-textarea--variant_filled:is(:hover,[data-hover]),[data-theme=dark] .lg\\:ikp-textarea--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-100)}}@media screen and (min-width: 64em){.lg\\:ikp-textarea--variant_unstyled{background:var(--ikp-colors-transparent);padding-inline:var(--ikp-spacing-0);height:var(--ikp-sizes-auto)}.lg\\:ikp-textarea--size_xs{--input-font-size:var(--ikp-font-sizes-xs);--input-padding:var(--ikp-space-2);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-6)}.lg\\:ikp-textarea--size_sm{--input-font-size:var(--ikp-font-sizes-sm);--input-padding:var(--ikp-space-3);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-8)}.lg\\:ikp-textarea--size_md{--input-font-size:var(--ikp-font-sizes-md);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-10)}.lg\\:ikp-textarea--size_lg{--input-font-size:var(--ikp-font-sizes-lg);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-12)}.lg\\:ikp-ai-chat-page-wrapper--size_expand{width:100%;height:100%}.lg\\:ikp-ai-chat-page-wrapper--size_default{max-width:100vw;max-height:100vw;margin:auto;align-self:center;justify-self:center;flex-grow:0}}@media screen and (min-width: 64em){@media screen and (min-width: 48em){.lg\\:ikp-ai-chat-page-wrapper--size_default{width:min(600px,100%);height:min(760px,100%)}}@media screen and (min-width: 64em){.lg\\:ikp-ai-chat-page-wrapper--size_default{width:min(640px,100%);height:min(800px,100%)}}@media screen and (min-width: 96em){.lg\\:ikp-ai-chat-page-wrapper--size_default{width:min(760px,100%);height:min(900px,100%)}}}@media screen and (min-width: 64em){.lg\\:ikp-ai-chat-page-wrapper--size_shrink-vertically{width:100%;height:var(--ikp-sizes-auto);align-self:flex-start;max-height:100%}@media screen and (min-width: 48em){.lg\\:ikp-ai-chat-page-wrapper--size_shrink-vertically{width:100%}}}@media screen and (min-width: 64em){.lg\\:ikp-ai-chat-page-wrapper--size_full-viewport{position:fixed;top:var(--ikp-spacing-0);left:var(--ikp-spacing-0);z-index:1000;width:100vw;height:100vh}.lg\\:ikp-ai-chat-page-wrapper--variant_no-shadow{box-shadow:var(--ikp-shadows-none)}.lg\\:ikp-ai-chat-page-wrapper--variant_container-with-shadow{box-shadow:var(--ikp-shadows-2xl)}.dark .lg\\:ikp-ai-chat-page-wrapper--variant_container-with-shadow,[data-theme=dark] .lg\\:ikp-ai-chat-page-wrapper--variant_container-with-shadow{box-shadow:var(--ikp-shadows-none)}.light .lg\\:ikp-preview-content-header--variant_title,[data-theme=light] .lg\\:ikp-preview-content-header--variant_title{color:var(--ikp-colors-inkeep-primary-text-subtle)}.dark .lg\\:ikp-preview-content-header--variant_title,[data-theme=dark] .lg\\:ikp-preview-content-header--variant_title{color:var(--ikp-colors-inkeep-primary-lighter)}}@media screen and (min-width: 64em){.light .lg\\:ikp-preview-content-header--variant_title:is(:hover,[data-hover]),[data-theme=light] .lg\\:ikp-preview-content-header--variant_title:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-primary-stronger)}.dark .lg\\:ikp-preview-content-header--variant_title:is(:hover,[data-hover]),[data-theme=dark] .lg\\:ikp-preview-content-header--variant_title:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-expanded-primary-100)}}@media screen and (min-width: 64em){.light .lg\\:ikp-preview-content-header--variant_hitContentPreview,[data-theme=light] .lg\\:ikp-preview-content-header--variant_hitContentPreview{color:var(--ikp-colors-inkeep-primary-hit-content-preview)}.dark .lg\\:ikp-preview-content-header--variant_hitContentPreview,[data-theme=dark] .lg\\:ikp-preview-content-header--variant_hitContentPreview{color:var(--ikp-colors-inkeep-expanded-primary-300)}.lg\\:ikp-preview-content-header--variant_hitContentPreview .light a:hover,.lg\\:ikp-preview-content-header--variant_hitContentPreview [data-theme=light] a:hover{color:var(--ikp-colors-inkeep-primary-stronger)}.lg\\:ikp-preview-content-header--variant_hitContentPreview .dark a:hover,.lg\\:ikp-preview-content-header--variant_hitContentPreview [data-theme=dark] a:hover{color:var(--ikp-colors-inkeep-expanded-primary-100)}}@media screen and (min-width: 80em){.xl\\:ikp-btn--colorPalette_gray{--ikp-colors-color-palette-50:var(--ikp-colors-gray-50);--ikp-colors-color-palette-100:var(--ikp-colors-gray-100);--ikp-colors-color-palette-200:var(--ikp-colors-gray-200);--ikp-colors-color-palette-300:var(--ikp-colors-gray-300);--ikp-colors-color-palette-400:var(--ikp-colors-gray-400);--ikp-colors-color-palette-500:var(--ikp-colors-gray-500);--ikp-colors-color-palette-600:var(--ikp-colors-gray-600);--ikp-colors-color-palette-700:var(--ikp-colors-gray-700);--ikp-colors-color-palette-800:var(--ikp-colors-gray-800);--ikp-colors-color-palette-900:var(--ikp-colors-gray-900);--ikp-colors-color-palette-950:var(--ikp-colors-gray-950)}.xl\\:ikp-btn--colorPalette_blue{--ikp-colors-color-palette-50:var(--ikp-colors-blue-50);--ikp-colors-color-palette-100:var(--ikp-colors-blue-100);--ikp-colors-color-palette-200:var(--ikp-colors-blue-200);--ikp-colors-color-palette-300:var(--ikp-colors-blue-300);--ikp-colors-color-palette-400:var(--ikp-colors-blue-400);--ikp-colors-color-palette-500:var(--ikp-colors-blue-500);--ikp-colors-color-palette-600:var(--ikp-colors-blue-600);--ikp-colors-color-palette-700:var(--ikp-colors-blue-700);--ikp-colors-color-palette-800:var(--ikp-colors-blue-800);--ikp-colors-color-palette-900:var(--ikp-colors-blue-900);--ikp-colors-color-palette-950:var(--ikp-colors-blue-950)}.xl\\:ikp-btn--colorPalette_teal{--ikp-colors-color-palette-50:var(--ikp-colors-teal-50);--ikp-colors-color-palette-100:var(--ikp-colors-teal-100);--ikp-colors-color-palette-200:var(--ikp-colors-teal-200);--ikp-colors-color-palette-300:var(--ikp-colors-teal-300);--ikp-colors-color-palette-400:var(--ikp-colors-teal-400);--ikp-colors-color-palette-500:var(--ikp-colors-teal-500);--ikp-colors-color-palette-600:var(--ikp-colors-teal-600);--ikp-colors-color-palette-700:var(--ikp-colors-teal-700);--ikp-colors-color-palette-800:var(--ikp-colors-teal-800);--ikp-colors-color-palette-900:var(--ikp-colors-teal-900);--ikp-colors-color-palette-950:var(--ikp-colors-teal-950)}.xl\\:ikp-btn--colorPalette_inkeepPrimary{--ikp-colors-color-palette-hit-content-preview:var(--ikp-colors-inkeep-primary-hit-content-preview);--ikp-colors-color-palette-hit-content-preview-hover:var(--ikp-colors-inkeep-primary-hit-content-preview-hover);--ikp-colors-color-palette-text-bold:var(--ikp-colors-inkeep-primary-text-bold);--ikp-colors-color-palette-text-subtle:var(--ikp-colors-inkeep-primary-text-subtle);--ikp-colors-color-palette-lighter:var(--ikp-colors-inkeep-primary-lighter);--ikp-colors-color-palette-light:var(--ikp-colors-inkeep-primary-light);--ikp-colors-color-palette-light-subtle:var(--ikp-colors-inkeep-primary-light-subtle);--ikp-colors-color-palette-medium:var(--ikp-colors-inkeep-primary-medium);--ikp-colors-color-palette-medium-subtle:var(--ikp-colors-inkeep-primary-medium-subtle);--ikp-colors-color-palette-strong:var(--ikp-colors-inkeep-primary-strong);--ikp-colors-color-palette-stronger:var(--ikp-colors-inkeep-primary-stronger);--ikp-colors-color-palette-text-color-on-primary:var(--ikp-colors-inkeep-primary-text-color-on-primary)}.xl\\:ikp-btn--variant_ghost{color:var(--ikp-colors-color-palette-600);background:var(--ikp-colors-transparent)}.dark .xl\\:ikp-btn--variant_ghost,[data-theme=dark] .xl\\:ikp-btn--variant_ghost{color:var(--ikp-colors-color-palette-200)}}@media screen and (min-width: 80em){.xl\\:ikp-btn--variant_ghost:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-50));background-color:var(--bga,var(--ikp-colors-color-palette-50))}.dark .xl\\:ikp-btn--variant_ghost:is(:hover,[data-hover]),[data-theme=dark] .xl\\:ikp-btn--variant_ghost:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 88%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200))}.xl\\:ikp-btn--variant_ghost:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-100));background-color:var(--bga,var(--ikp-colors-color-palette-100))}.dark .xl\\:ikp-btn--variant_ghost:is(:active,[data-active]),[data-theme=dark] .xl\\:ikp-btn--variant_ghost:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 76%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200))}}@media screen and (min-width: 80em){.xl\\:ikp-btn--variant_solid{background:var(--ikp-colors-color-palette-500);color:var(--ikp-colors-white)}.dark .xl\\:ikp-btn--variant_solid,[data-theme=dark] .xl\\:ikp-btn--variant_solid{background:var(--ikp-colors-color-palette-200);color:var(--ikp-colors-gray-800)}.xl\\:ikp-btn--variant_solid:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-600)}.dark .xl\\:ikp-btn--variant_solid:is(:hover,[data-hover]),[data-theme=dark] .xl\\:ikp-btn--variant_solid:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-300)}.xl\\:ikp-btn--variant_solid:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){background:var(--ikp-colors-color-palette-500)}.dark .xl\\:ikp-btn--variant_solid:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]),[data-theme=dark] .xl\\:ikp-btn--variant_solid:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){background:var(--ikp-colors-color-palette-200)}.xl\\:ikp-btn--variant_solid:is(:active,[data-active]){background:var(--ikp-colors-color-palette-700)}.dark .xl\\:ikp-btn--variant_solid:is(:active,[data-active]),[data-theme=dark] .xl\\:ikp-btn--variant_solid:is(:active,[data-active]){background:var(--ikp-colors-color-palette-400)}}@media screen and (min-width: 80em){.xl\\:ikp-btn--variant_link{padding:var(--ikp-spacing-0)!important;height:var(--ikp-sizes-auto)!important;line-height:var(--ikp-line-heights-base);vertical-align:baseline;font-weight:var(--ikp-font-weights-normal);color:var(--ikp-colors-color-palette-500)}.dark .xl\\:ikp-btn--variant_link,[data-theme=dark] .xl\\:ikp-btn--variant_link{color:var(--ikp-colors-color-palette-200)}.xl\\:ikp-btn--variant_link:is(:hover,[data-hover]){text-decoration:underline}.xl\\:ikp-btn--variant_link:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){text-decoration:none}.xl\\:ikp-btn--variant_link:is(:active,[data-active]){color:var(--ikp-colors-color-palette-700)}.dark .xl\\:ikp-btn--variant_link:is(:active,[data-active]),[data-theme=dark] .xl\\:ikp-btn--variant_link:is(:active,[data-active]){color:var(--ikp-colors-color-palette-500)}}@media screen and (min-width: 80em){.xl\\:ikp-btn--variant_unstyled{background:none;color:inherit;display:inline;line-height:inherit;margin:var(--ikp-spacing-0);padding:var(--ikp-spacing-0);border-radius:unset}.xl\\:ikp-btn--variant_outlinePrimary{border:1px solid}.light .xl\\:ikp-btn--variant_outlinePrimary,[data-theme=light] .xl\\:ikp-btn--variant_outlinePrimary{color:var(--ikp-colors-inkeep-primary-strong);border-color:var(--ikp-colors-inkeep-expanded-primary-200)}.dark .xl\\:ikp-btn--variant_outlinePrimary,[data-theme=dark] .xl\\:ikp-btn--variant_outlinePrimary{color:var(--ikp-colors-inkeep-expanded-primary-300)}}@media screen and (min-width: 80em){.light .xl\\:ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]),[data-theme=light] .xl\\:ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-light-subtle);color:var(--ikp-colors-inkeep-primary-strong)}.dark .xl\\:ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]),[data-theme=dark] .xl\\:ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-200);color:var(--ikp-colors-inkeep-expanded-primary-200)}}@media screen and (min-width: 80em){.xl\\:ikp-btn--variant_outlineFilled{background:var(--ikp-colors-white);border:1px solid;border-color:var(--ikp-colors-inkeep-primary-strong);color:var(--ikp-colors-inkeep-primary-strong)}.xl\\:ikp-btn--variant_outlineFilled:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-strong);color:var(--ikp-colors-white)}.xl\\:ikp-btn--variant_outlineFilled:is(:active,[data-active]){background:var(--ikp-colors-inkeep-primary-strong)}}@media screen and (min-width: 80em){.xl\\:ikp-btn--variant_outlineFilledActive{background:var(--ikp-colors-inkeep-primary-strong);color:var(--ikp-colors-white)}.xl\\:ikp-btn--variant_chatButton{background:var(--ikp-colors-inkeep-primary-text-bold);box-shadow:var(--ikp-shadows-2xl);border-radius:var(--ikp-radii-lg);color:var(--ikp-colors-white);font-weight:var(--ikp-font-weights-medium)}.dark .xl\\:ikp-btn--variant_chatButton,[data-theme=dark] .xl\\:ikp-btn--variant_chatButton{background:var(--ikp-colors-gray-dark-600);box-shadow:var(--ikp-shadows-none)}.xl\\:ikp-btn--variant_filledCTA{background:var(--ikp-colors-inkeep-primary-medium);color:var(--ikp-colors-white);border:var(--ikp-borders-none);border-radius:80px}}@media screen and (min-width: 80em){.xl\\:ikp-btn--variant_filledCTA:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-medium)}.xl\\:ikp-btn--variant_filledCTA:is(:active,[data-active]){background:var(--ikp-colors-inkeep-primary-medium)}}@media screen and (min-width: 80em){.xl\\:ikp-btn--variant_primaryFilled{background:var(--ikp-colors-inkeep-primary-medium);color:var(--ikp-colors-inkeep-primary-text-color-on-primary)}.xl\\:ikp-btn--variant_primaryFilled:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-strong)}.xl\\:ikp-btn--variant_primaryFilled:is(:active,[data-active]){background:var(--ikp-colors-inkeep-primary-strong)}}@media screen and (min-width: 80em){.xl\\:ikp-btn--variant_neutralFilled{background:var(--ikp-colors-gray-900);color:var(--ikp-colors-white)}.dark .xl\\:ikp-btn--variant_neutralFilled,[data-theme=dark] .xl\\:ikp-btn--variant_neutralFilled{background:var(--ikp-colors-inkeep-expanded-primary-300);color:var(--ikp-colors-gray-dark-900)}.xl\\:ikp-btn--variant_neutralFilled:is(:hover,[data-hover]){background:var(--ikp-colors-gray-800)}.dark .xl\\:ikp-btn--variant_neutralFilled:is(:hover,[data-hover]),[data-theme=dark] .xl\\:ikp-btn--variant_neutralFilled:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-expanded-primary-200)}.xl\\:ikp-btn--variant_neutralFilled:is(:active,[data-active]){background:var(--ikp-colors-gray-800)}.dark .xl\\:ikp-btn--variant_neutralFilled:is(:active,[data-active]),[data-theme=dark] .xl\\:ikp-btn--variant_neutralFilled:is(:active,[data-active]){background:var(--ikp-colors-inkeep-expanded-primary-200)}}@media screen and (min-width: 80em){.xl\\:ikp-btn--variant_outline{border:1px solid;border-color:currentColor;color:var(--ikp-colors-color-palette-600);background:var(--ikp-colors-transparent)}.dark .xl\\:ikp-btn--variant_outline,[data-theme=dark] .xl\\:ikp-btn--variant_outline{color:var(--ikp-colors-white-alpha-700)}.light .xl\\:ikp-btn--variant_outline,[data-theme=light] .xl\\:ikp-btn--variant_outline{color:var(--ikp-colors-gray-700)}.xl\\:ikp-btn--variant_outline:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-50));background-color:var(--bga,var(--ikp-colors-color-palette-50))}.dark .xl\\:ikp-btn--variant_outline:is(:hover,[data-hover]),[data-theme=dark] .xl\\:ikp-btn--variant_outline:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 88%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200));color:var(--ikp-colors-white-alpha-800);background:var(--ikp-colors-white-alpha-200)}.light .xl\\:ikp-btn--variant_outline:is(:hover,[data-hover]),[data-theme=light] .xl\\:ikp-btn--variant_outline:is(:hover,[data-hover]){color:var(--ikp-colors-gray-800)}.xl\\:ikp-btn--variant_outline:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-100));background-color:var(--bga,var(--ikp-colors-color-palette-100))}.dark .xl\\:ikp-btn--variant_outline:is(:active,[data-active]),[data-theme=dark] .xl\\:ikp-btn--variant_outline:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 76%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200))}}@media screen and (min-width: 80em){.xl\\:ikp-btn--variant_iconButton{background:var(--ikp-colors-transparent);border-radius:0;padding-inline:var(--ikp-spacing-1);color:var(--ikp-colors-gray-600)}.dark .xl\\:ikp-btn--variant_iconButton,[data-theme=dark] .xl\\:ikp-btn--variant_iconButton{color:var(--ikp-colors-white-alpha-600)}.xl\\:ikp-btn--variant_iconButton:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-primary-stronger);background:var(--ikp-colors-transparent)}.dark .xl\\:ikp-btn--variant_iconButton:is(:hover,[data-hover]),[data-theme=dark] .xl\\:ikp-btn--variant_iconButton:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-expanded-primary-300)}}@media screen and (min-width: 80em){.xl\\:ikp-btn--size_lg{height:var(--ikp-sizes-12);min-width:var(--ikp-sizes-12);font-size:var(--ikp-font-sizes-lg);padding-inline:var(--ikp-spacing-6)}.xl\\:ikp-btn--size_md{height:var(--ikp-sizes-10);min-width:var(--ikp-sizes-10);font-size:var(--ikp-font-sizes-md);padding-inline:var(--ikp-spacing-4)}.xl\\:ikp-btn--size_sm{height:var(--ikp-sizes-8);min-width:var(--ikp-sizes-8);font-size:var(--ikp-font-sizes-sm);padding-inline:var(--ikp-spacing-3)}.xl\\:ikp-btn--size_xs{height:var(--ikp-sizes-6);min-width:var(--ikp-sizes-6);font-size:var(--ikp-font-sizes-xs);padding-inline:var(--ikp-spacing-2)}.xl\\:ikp-close-btn--size_lg{--btn-bg:var(--ikp-sizes-10);font-size:var(--ikp-font-sizes-md)}.xl\\:ikp-close-btn--size_md{--btn-bg:var(--ikp-sizes-8);font-size:var(--ikp-font-sizes-xs)}.xl\\:ikp-close-btn--size_sm{--btn-bg:var(--ikp-sizes-6);font-size:var(--ikp-font-sizes-2xs)}.xl\\:ikp-code--variant_solid{--badge-bg:var(--ikp-colors-color-palette-500);--badge-color:var(--ikp-colors-white)}.dark .xl\\:ikp-code--variant_solid,[data-theme=dark] .xl\\:ikp-code--variant_solid{--badge-bg-alpha:color-mix(in srgb,transparent 60%,var(--colors-color-palette-500)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-500)) ;--badge-color:var(--ikp-colors-white-alpha-800) }.xl\\:ikp-code--variant_subtle{--badge-bg:colorPalette.1;--badge-color:var(--ikp-colors-color-palette-800)}.dark .xl\\:ikp-code--variant_subtle,[data-theme=dark] .xl\\:ikp-code--variant_subtle{--badge-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) ;--badge-color:var(--ikp-colors-color-palette-200) }.xl\\:ikp-code--variant_outline{--badge-color:var(--ikp-colors-color-palette-500);--badge-shadow:inset 0 0 0px 1px var(--badge-color,inherit)}.dark .xl\\:ikp-code--variant_outline,[data-theme=dark] .xl\\:ikp-code--variant_outline{--badge-bg-alpha:color-mix(in srgb,transparent 80%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) }.xl\\:ikp-badge--variant_solid{--badge-bg:var(--ikp-colors-color-palette-500);--badge-color:var(--ikp-colors-white)}.dark .xl\\:ikp-badge--variant_solid,[data-theme=dark] .xl\\:ikp-badge--variant_solid{--badge-bg-alpha:color-mix(in srgb,transparent 60%,var(--colors-color-palette-500)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-500)) ;--badge-color:var(--ikp-colors-white-alpha-800) }.xl\\:ikp-badge--variant_subtle{--badge-bg:colorPalette.1;--badge-color:var(--ikp-colors-color-palette-800)}.dark .xl\\:ikp-badge--variant_subtle,[data-theme=dark] .xl\\:ikp-badge--variant_subtle{--badge-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) ;--badge-color:var(--ikp-colors-color-palette-200) }.xl\\:ikp-badge--variant_outline{--badge-color:var(--ikp-colors-color-palette-500);--badge-shadow:inset 0 0 0px 1px var(--badge-color,inherit)}.dark .xl\\:ikp-badge--variant_outline,[data-theme=dark] .xl\\:ikp-badge--variant_outline{--badge-bg-alpha:color-mix(in srgb,transparent 80%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) }.xl\\:ikp-heading--size_4xl{font-size:var(--ikp-font-sizes-6xl);line-height:1}}@media screen and (min-width: 80em){@media screen and (min-width: 48em){.xl\\:ikp-heading--size_4xl{font-size:var(--ikp-font-sizes-7xl)}}}@media screen and (min-width: 80em){.xl\\:ikp-heading--size_3xl{font-size:var(--ikp-font-sizes-5xl);line-height:1}@media screen and (min-width: 48em){.xl\\:ikp-heading--size_3xl{font-size:var(--ikp-font-sizes-6xl)}}}@media screen and (min-width: 80em){.xl\\:ikp-heading--size_2xl{font-size:var(--ikp-font-sizes-4xl);line-height:1.2}@media screen and (min-width: 48em){.xl\\:ikp-heading--size_2xl{font-size:var(--ikp-font-sizes-5xl);line-height:1}}}@media screen and (min-width: 80em){.xl\\:ikp-heading--size_xl{font-size:var(--ikp-font-sizes-3xl);line-height:1.33}@media screen and (min-width: 48em){.xl\\:ikp-heading--size_xl{font-size:var(--ikp-font-sizes-4xl);line-height:1.2}}}@media screen and (min-width: 80em){.xl\\:ikp-heading--size_lg{font-size:var(--ikp-font-sizes-2xl);line-height:1.33}@media screen and (min-width: 48em){.xl\\:ikp-heading--size_lg{font-size:var(--ikp-font-sizes-3xl);line-height:1.2}}}@media screen and (min-width: 80em){.xl\\:ikp-heading--size_md{font-size:var(--ikp-font-sizes-xl);line-height:1.2}.xl\\:ikp-heading--size_sm{font-size:var(--ikp-font-sizes-md);line-height:1.2}.xl\\:ikp-heading--size_xs{font-size:var(--ikp-font-sizes-sm);line-height:1.2}.xl\\:ikp-heading--uppercase_true{text-transform:uppercase;letter-spacing:1px;font-weight:600;color:var(--ikp-colors-gray-600)}.xl\\:ikp-icon--variant_dark{color:var(--ikp-colors-white)}.xl\\:ikp-icon--variant_lightPrimary{color:var(--ikp-colors-inkeep-primary-text-subtle)}.xl\\:ikp-icon--variant_light{color:var(--ikp-colors-gray-600)}.xl\\:ikp-kbd--variant_dark{background:primaryDark.9;color:var(--ikp-colors-white);border-color:primaryDark.6;border-radius:3px;border-bottom:2px solid}.xl\\:ikp-kbd--variant_darkOutline{color:var(--ikp-colors-white)}.xl\\:ikp-kbd--variant_darkOutline,.xl\\:ikp-kbd--variant_light{background:primary.1;border-color:var(--ikp-colors-inkeep-primary-medium);border-radius:3px;border-bottom:2px solid}.xl\\:ikp-kbd--variant_light{color:var(--ikp-colors-inkeep-primary-medium)}.xl\\:ikp-kbd--variant_grayLight{background:var(--ikp-colors-gray-400);height:40px;padding:2px 6px;color:var(--ikp-colors-gray-600);border-color:var(--ikp-colors-gray-600);border-radius:3px;border-bottom:2px solid gray.7}.xl\\:ikp-kbd--variant_outline{box-shadow:var(--ikp-shadows-none)}.xl\\:ikp-tag--variant_solid{--badge-bg:var(--ikp-colors-color-palette-500);--badge-color:var(--ikp-colors-white)}.dark .xl\\:ikp-tag--variant_solid,[data-theme=dark] .xl\\:ikp-tag--variant_solid{--badge-bg-alpha:color-mix(in srgb,transparent 60%,var(--colors-color-palette-500)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-500)) ;--badge-color:var(--ikp-colors-white-alpha-800) }.xl\\:ikp-tag--variant_subtle{--badge-bg:colorPalette.1;--badge-color:var(--ikp-colors-color-palette-800)}.dark .xl\\:ikp-tag--variant_subtle,[data-theme=dark] .xl\\:ikp-tag--variant_subtle{--badge-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) ;--badge-color:var(--ikp-colors-color-palette-200) }.xl\\:ikp-tag--variant_outline{--badge-color:var(--ikp-colors-color-palette-500);--badge-shadow:inset 0 0 0px 1px var(--badge-color,inherit)}.dark .xl\\:ikp-tag--variant_outline,[data-theme=dark] .xl\\:ikp-tag--variant_outline{--badge-bg-alpha:color-mix(in srgb,transparent 80%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) }.xl\\:ikp-tag--size_sm{--tag-min-height:var(--ikp-sizes-5);--tag-min-width:var(--ikp-sizes-5);--tag-font-size:var(--ikp-font-sizes-xs);--tag-padding-inline:var(--ikp-space-2)}.xl\\:ikp-tag--size_md{--tag-min-height:var(--ikp-sizes-6);--tag-min-width:var(--ikp-sizes-6);--tag-font-size:var(--ikp-font-sizes-sm);--tag-padding-inline:var(--ikp-space-2)}.xl\\:ikp-tag--size_lg{--tag-min-height:var(--ikp-sizes-8);--tag-min-width:var(--ikp-sizes-8);--tag-font-size:var(--ikp-font-sizes-md);--tag-padding-inline:var(--ikp-space-3)}.xl\\:ikp-textarea--variant_outline{border:1px solid;border-color:inherit;background:inherit}}@media screen and (min-width: 80em){.xl\\:ikp-textarea--variant_outline:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.xl\\:ikp-textarea--variant_outline[aria-invalid=true],.xl\\:ikp-textarea--variant_outline[data-invalid] .xl\\:ikp-textarea--variant_outline{border-color:var(--input-error-border-color);box-shadow:0 0 0 1px var(--input-error-border-color)}.xl\\:ikp-textarea--variant_outline:is(:focus-visible,[data-focus-visible]){z-index:1;border-color:var(--input-focus-border-color);box-shadow:0 0 0 1px var(--input-focus-border-color)}.xl\\:ikp-textarea--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-300)}.dark .xl\\:ikp-textarea--variant_outline:is(:hover,[data-hover]),[data-theme=dark] .xl\\:ikp-textarea--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}}@media screen and (min-width: 80em){.xl\\:ikp-textarea--variant_flushed{border-bottom:1px solid;border-color:inherit;border-radius:0;padding-inline:var(--ikp-spacing-0);background:var(--ikp-colors-transparent)}.xl\\:ikp-textarea--variant_flushed:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.xl\\:ikp-textarea--variant_flushed[aria-invalid=true],.xl\\:ikp-textarea--variant_flushed[data-invalid] .xl\\:ikp-textarea--variant_flushed{border-color:var(--input-error-border-color);box-shadow:0 1px 0 0 var(--input-error-border-color)}.xl\\:ikp-textarea--variant_flushed:is(:focus-visible,[data-focus-visible]){border-color:var(--input-focus-border-color);box-shadow:0 1px 0 0 var(--input-focus-border-color)}}@media screen and (min-width: 80em){.xl\\:ikp-textarea--variant_filled{border:2px solid;border-color:var(--ikp-colors-transparent);background:var(--ikp-colors-gray-100)}.dark .xl\\:ikp-textarea--variant_filled,[data-theme=dark] .xl\\:ikp-textarea--variant_filled{background:var(--ikp-colors-white-alpha-50)}.xl\\:ikp-textarea--variant_filled:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.xl\\:ikp-textarea--variant_filled[aria-invalid=true],.xl\\:ikp-textarea--variant_filled[data-invalid] .xl\\:ikp-textarea--variant_filled{border-color:var(--input-error-border-color)}.xl\\:ikp-textarea--variant_filled:is(:focus-visible,[data-focus-visible]){background:var(--ikp-colors-transparent);border-color:var(--input-focus-border-color)}.xl\\:ikp-textarea--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-gray-200)}.dark .xl\\:ikp-textarea--variant_filled:is(:hover,[data-hover]),[data-theme=dark] .xl\\:ikp-textarea--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-100)}}@media screen and (min-width: 80em){.xl\\:ikp-textarea--variant_unstyled{background:var(--ikp-colors-transparent);padding-inline:var(--ikp-spacing-0);height:var(--ikp-sizes-auto)}.xl\\:ikp-textarea--size_xs{--input-font-size:var(--ikp-font-sizes-xs);--input-padding:var(--ikp-space-2);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-6)}.xl\\:ikp-textarea--size_sm{--input-font-size:var(--ikp-font-sizes-sm);--input-padding:var(--ikp-space-3);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-8)}.xl\\:ikp-textarea--size_md{--input-font-size:var(--ikp-font-sizes-md);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-10)}.xl\\:ikp-textarea--size_lg{--input-font-size:var(--ikp-font-sizes-lg);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-12)}.xl\\:ikp-ai-chat-page-wrapper--size_expand{width:100%;height:100%}.xl\\:ikp-ai-chat-page-wrapper--size_default{max-width:100vw;max-height:100vw;margin:auto;align-self:center;justify-self:center;flex-grow:0}}@media screen and (min-width: 80em){@media screen and (min-width: 48em){.xl\\:ikp-ai-chat-page-wrapper--size_default{width:min(600px,100%);height:min(760px,100%)}}@media screen and (min-width: 64em){.xl\\:ikp-ai-chat-page-wrapper--size_default{width:min(640px,100%);height:min(800px,100%)}}@media screen and (min-width: 96em){.xl\\:ikp-ai-chat-page-wrapper--size_default{width:min(760px,100%);height:min(900px,100%)}}}@media screen and (min-width: 80em){.xl\\:ikp-ai-chat-page-wrapper--size_shrink-vertically{width:100%;height:var(--ikp-sizes-auto);align-self:flex-start;max-height:100%}@media screen and (min-width: 48em){.xl\\:ikp-ai-chat-page-wrapper--size_shrink-vertically{width:100%}}}@media screen and (min-width: 80em){.xl\\:ikp-ai-chat-page-wrapper--size_full-viewport{position:fixed;top:var(--ikp-spacing-0);left:var(--ikp-spacing-0);z-index:1000;width:100vw;height:100vh}.xl\\:ikp-ai-chat-page-wrapper--variant_no-shadow{box-shadow:var(--ikp-shadows-none)}.xl\\:ikp-ai-chat-page-wrapper--variant_container-with-shadow{box-shadow:var(--ikp-shadows-2xl)}.dark .xl\\:ikp-ai-chat-page-wrapper--variant_container-with-shadow,[data-theme=dark] .xl\\:ikp-ai-chat-page-wrapper--variant_container-with-shadow{box-shadow:var(--ikp-shadows-none)}.light .xl\\:ikp-preview-content-header--variant_title,[data-theme=light] .xl\\:ikp-preview-content-header--variant_title{color:var(--ikp-colors-inkeep-primary-text-subtle)}.dark .xl\\:ikp-preview-content-header--variant_title,[data-theme=dark] .xl\\:ikp-preview-content-header--variant_title{color:var(--ikp-colors-inkeep-primary-lighter)}}@media screen and (min-width: 80em){.light .xl\\:ikp-preview-content-header--variant_title:is(:hover,[data-hover]),[data-theme=light] .xl\\:ikp-preview-content-header--variant_title:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-primary-stronger)}.dark .xl\\:ikp-preview-content-header--variant_title:is(:hover,[data-hover]),[data-theme=dark] .xl\\:ikp-preview-content-header--variant_title:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-expanded-primary-100)}}@media screen and (min-width: 80em){.light .xl\\:ikp-preview-content-header--variant_hitContentPreview,[data-theme=light] .xl\\:ikp-preview-content-header--variant_hitContentPreview{color:var(--ikp-colors-inkeep-primary-hit-content-preview)}.dark .xl\\:ikp-preview-content-header--variant_hitContentPreview,[data-theme=dark] .xl\\:ikp-preview-content-header--variant_hitContentPreview{color:var(--ikp-colors-inkeep-expanded-primary-300)}.xl\\:ikp-preview-content-header--variant_hitContentPreview .light a:hover,.xl\\:ikp-preview-content-header--variant_hitContentPreview [data-theme=light] a:hover{color:var(--ikp-colors-inkeep-primary-stronger)}.xl\\:ikp-preview-content-header--variant_hitContentPreview .dark a:hover,.xl\\:ikp-preview-content-header--variant_hitContentPreview [data-theme=dark] a:hover{color:var(--ikp-colors-inkeep-expanded-primary-100)}}@media screen and (min-width: 96em){.ikp-ai-chat-page-wrapper--size_default{width:min(760px,100%);height:min(900px,100%)}.\\32xl\\:ikp-btn--colorPalette_gray{--ikp-colors-color-palette-50:var(--ikp-colors-gray-50);--ikp-colors-color-palette-100:var(--ikp-colors-gray-100);--ikp-colors-color-palette-200:var(--ikp-colors-gray-200);--ikp-colors-color-palette-300:var(--ikp-colors-gray-300);--ikp-colors-color-palette-400:var(--ikp-colors-gray-400);--ikp-colors-color-palette-500:var(--ikp-colors-gray-500);--ikp-colors-color-palette-600:var(--ikp-colors-gray-600);--ikp-colors-color-palette-700:var(--ikp-colors-gray-700);--ikp-colors-color-palette-800:var(--ikp-colors-gray-800);--ikp-colors-color-palette-900:var(--ikp-colors-gray-900);--ikp-colors-color-palette-950:var(--ikp-colors-gray-950)}.\\32xl\\:ikp-btn--colorPalette_blue{--ikp-colors-color-palette-50:var(--ikp-colors-blue-50);--ikp-colors-color-palette-100:var(--ikp-colors-blue-100);--ikp-colors-color-palette-200:var(--ikp-colors-blue-200);--ikp-colors-color-palette-300:var(--ikp-colors-blue-300);--ikp-colors-color-palette-400:var(--ikp-colors-blue-400);--ikp-colors-color-palette-500:var(--ikp-colors-blue-500);--ikp-colors-color-palette-600:var(--ikp-colors-blue-600);--ikp-colors-color-palette-700:var(--ikp-colors-blue-700);--ikp-colors-color-palette-800:var(--ikp-colors-blue-800);--ikp-colors-color-palette-900:var(--ikp-colors-blue-900);--ikp-colors-color-palette-950:var(--ikp-colors-blue-950)}.\\32xl\\:ikp-btn--colorPalette_teal{--ikp-colors-color-palette-50:var(--ikp-colors-teal-50);--ikp-colors-color-palette-100:var(--ikp-colors-teal-100);--ikp-colors-color-palette-200:var(--ikp-colors-teal-200);--ikp-colors-color-palette-300:var(--ikp-colors-teal-300);--ikp-colors-color-palette-400:var(--ikp-colors-teal-400);--ikp-colors-color-palette-500:var(--ikp-colors-teal-500);--ikp-colors-color-palette-600:var(--ikp-colors-teal-600);--ikp-colors-color-palette-700:var(--ikp-colors-teal-700);--ikp-colors-color-palette-800:var(--ikp-colors-teal-800);--ikp-colors-color-palette-900:var(--ikp-colors-teal-900);--ikp-colors-color-palette-950:var(--ikp-colors-teal-950)}.\\32xl\\:ikp-btn--colorPalette_inkeepPrimary{--ikp-colors-color-palette-hit-content-preview:var(--ikp-colors-inkeep-primary-hit-content-preview);--ikp-colors-color-palette-hit-content-preview-hover:var(--ikp-colors-inkeep-primary-hit-content-preview-hover);--ikp-colors-color-palette-text-bold:var(--ikp-colors-inkeep-primary-text-bold);--ikp-colors-color-palette-text-subtle:var(--ikp-colors-inkeep-primary-text-subtle);--ikp-colors-color-palette-lighter:var(--ikp-colors-inkeep-primary-lighter);--ikp-colors-color-palette-light:var(--ikp-colors-inkeep-primary-light);--ikp-colors-color-palette-light-subtle:var(--ikp-colors-inkeep-primary-light-subtle);--ikp-colors-color-palette-medium:var(--ikp-colors-inkeep-primary-medium);--ikp-colors-color-palette-medium-subtle:var(--ikp-colors-inkeep-primary-medium-subtle);--ikp-colors-color-palette-strong:var(--ikp-colors-inkeep-primary-strong);--ikp-colors-color-palette-stronger:var(--ikp-colors-inkeep-primary-stronger);--ikp-colors-color-palette-text-color-on-primary:var(--ikp-colors-inkeep-primary-text-color-on-primary)}.\\32xl\\:ikp-btn--variant_ghost{color:var(--ikp-colors-color-palette-600);background:var(--ikp-colors-transparent)}.dark .\\32xl\\:ikp-btn--variant_ghost,[data-theme=dark] .\\32xl\\:ikp-btn--variant_ghost{color:var(--ikp-colors-color-palette-200)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-btn--variant_ghost:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-50));background-color:var(--bga,var(--ikp-colors-color-palette-50))}.dark .\\32xl\\:ikp-btn--variant_ghost:is(:hover,[data-hover]),[data-theme=dark] .\\32xl\\:ikp-btn--variant_ghost:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 88%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200))}.\\32xl\\:ikp-btn--variant_ghost:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-100));background-color:var(--bga,var(--ikp-colors-color-palette-100))}.dark .\\32xl\\:ikp-btn--variant_ghost:is(:active,[data-active]),[data-theme=dark] .\\32xl\\:ikp-btn--variant_ghost:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 76%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200))}}@media screen and (min-width: 96em){.\\32xl\\:ikp-btn--variant_solid{background:var(--ikp-colors-color-palette-500);color:var(--ikp-colors-white)}.dark .\\32xl\\:ikp-btn--variant_solid,[data-theme=dark] .\\32xl\\:ikp-btn--variant_solid{background:var(--ikp-colors-color-palette-200);color:var(--ikp-colors-gray-800)}.\\32xl\\:ikp-btn--variant_solid:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-600)}.dark .\\32xl\\:ikp-btn--variant_solid:is(:hover,[data-hover]),[data-theme=dark] .\\32xl\\:ikp-btn--variant_solid:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-300)}.\\32xl\\:ikp-btn--variant_solid:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){background:var(--ikp-colors-color-palette-500)}.dark .\\32xl\\:ikp-btn--variant_solid:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]),[data-theme=dark] .\\32xl\\:ikp-btn--variant_solid:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){background:var(--ikp-colors-color-palette-200)}.\\32xl\\:ikp-btn--variant_solid:is(:active,[data-active]){background:var(--ikp-colors-color-palette-700)}.dark .\\32xl\\:ikp-btn--variant_solid:is(:active,[data-active]),[data-theme=dark] .\\32xl\\:ikp-btn--variant_solid:is(:active,[data-active]){background:var(--ikp-colors-color-palette-400)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-btn--variant_link{padding:var(--ikp-spacing-0)!important;height:var(--ikp-sizes-auto)!important;line-height:var(--ikp-line-heights-base);vertical-align:baseline;font-weight:var(--ikp-font-weights-normal);color:var(--ikp-colors-color-palette-500)}.dark .\\32xl\\:ikp-btn--variant_link,[data-theme=dark] .\\32xl\\:ikp-btn--variant_link{color:var(--ikp-colors-color-palette-200)}.\\32xl\\:ikp-btn--variant_link:is(:hover,[data-hover]){text-decoration:underline}.\\32xl\\:ikp-btn--variant_link:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){text-decoration:none}.\\32xl\\:ikp-btn--variant_link:is(:active,[data-active]){color:var(--ikp-colors-color-palette-700)}.dark .\\32xl\\:ikp-btn--variant_link:is(:active,[data-active]),[data-theme=dark] .\\32xl\\:ikp-btn--variant_link:is(:active,[data-active]){color:var(--ikp-colors-color-palette-500)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-btn--variant_unstyled{background:none;color:inherit;display:inline;line-height:inherit;margin:var(--ikp-spacing-0);padding:var(--ikp-spacing-0);border-radius:unset}.\\32xl\\:ikp-btn--variant_outlinePrimary{border:1px solid}.light .\\32xl\\:ikp-btn--variant_outlinePrimary,[data-theme=light] .\\32xl\\:ikp-btn--variant_outlinePrimary{color:var(--ikp-colors-inkeep-primary-strong);border-color:var(--ikp-colors-inkeep-expanded-primary-200)}.dark .\\32xl\\:ikp-btn--variant_outlinePrimary,[data-theme=dark] .\\32xl\\:ikp-btn--variant_outlinePrimary{color:var(--ikp-colors-inkeep-expanded-primary-300)}}@media screen and (min-width: 96em){.light .\\32xl\\:ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]),[data-theme=light] .\\32xl\\:ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-light-subtle);color:var(--ikp-colors-inkeep-primary-strong)}.dark .\\32xl\\:ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]),[data-theme=dark] .\\32xl\\:ikp-btn--variant_outlinePrimary:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-200);color:var(--ikp-colors-inkeep-expanded-primary-200)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-btn--variant_outlineFilled{background:var(--ikp-colors-white);border:1px solid;border-color:var(--ikp-colors-inkeep-primary-strong);color:var(--ikp-colors-inkeep-primary-strong)}.\\32xl\\:ikp-btn--variant_outlineFilled:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-strong);color:var(--ikp-colors-white)}.\\32xl\\:ikp-btn--variant_outlineFilled:is(:active,[data-active]){background:var(--ikp-colors-inkeep-primary-strong)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-btn--variant_outlineFilledActive{background:var(--ikp-colors-inkeep-primary-strong);color:var(--ikp-colors-white)}.\\32xl\\:ikp-btn--variant_chatButton{background:var(--ikp-colors-inkeep-primary-text-bold);box-shadow:var(--ikp-shadows-2xl);border-radius:var(--ikp-radii-lg);color:var(--ikp-colors-white);font-weight:var(--ikp-font-weights-medium)}.dark .\\32xl\\:ikp-btn--variant_chatButton,[data-theme=dark] .\\32xl\\:ikp-btn--variant_chatButton{background:var(--ikp-colors-gray-dark-600);box-shadow:var(--ikp-shadows-none)}.\\32xl\\:ikp-btn--variant_filledCTA{background:var(--ikp-colors-inkeep-primary-medium);color:var(--ikp-colors-white);border:var(--ikp-borders-none);border-radius:80px}}@media screen and (min-width: 96em){.\\32xl\\:ikp-btn--variant_filledCTA:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-medium)}.\\32xl\\:ikp-btn--variant_filledCTA:is(:active,[data-active]){background:var(--ikp-colors-inkeep-primary-medium)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-btn--variant_primaryFilled{background:var(--ikp-colors-inkeep-primary-medium);color:var(--ikp-colors-inkeep-primary-text-color-on-primary)}.\\32xl\\:ikp-btn--variant_primaryFilled:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-strong)}.\\32xl\\:ikp-btn--variant_primaryFilled:is(:active,[data-active]){background:var(--ikp-colors-inkeep-primary-strong)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-btn--variant_neutralFilled{background:var(--ikp-colors-gray-900);color:var(--ikp-colors-white)}.dark .\\32xl\\:ikp-btn--variant_neutralFilled,[data-theme=dark] .\\32xl\\:ikp-btn--variant_neutralFilled{background:var(--ikp-colors-inkeep-expanded-primary-300);color:var(--ikp-colors-gray-dark-900)}.\\32xl\\:ikp-btn--variant_neutralFilled:is(:hover,[data-hover]){background:var(--ikp-colors-gray-800)}.dark .\\32xl\\:ikp-btn--variant_neutralFilled:is(:hover,[data-hover]),[data-theme=dark] .\\32xl\\:ikp-btn--variant_neutralFilled:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-expanded-primary-200)}.\\32xl\\:ikp-btn--variant_neutralFilled:is(:active,[data-active]){background:var(--ikp-colors-gray-800)}.dark .\\32xl\\:ikp-btn--variant_neutralFilled:is(:active,[data-active]),[data-theme=dark] .\\32xl\\:ikp-btn--variant_neutralFilled:is(:active,[data-active]){background:var(--ikp-colors-inkeep-expanded-primary-200)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-btn--variant_outline{border:1px solid;border-color:currentColor;color:var(--ikp-colors-color-palette-600);background:var(--ikp-colors-transparent)}.dark .\\32xl\\:ikp-btn--variant_outline,[data-theme=dark] .\\32xl\\:ikp-btn--variant_outline{color:var(--ikp-colors-white-alpha-700)}.light .\\32xl\\:ikp-btn--variant_outline,[data-theme=light] .\\32xl\\:ikp-btn--variant_outline{color:var(--ikp-colors-gray-700)}.\\32xl\\:ikp-btn--variant_outline:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-50));background-color:var(--bga,var(--ikp-colors-color-palette-50))}.dark .\\32xl\\:ikp-btn--variant_outline:is(:hover,[data-hover]),[data-theme=dark] .\\32xl\\:ikp-btn--variant_outline:is(:hover,[data-hover]){--bga:color-mix(in srgb,transparent 88%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200));color:var(--ikp-colors-white-alpha-800);background:var(--ikp-colors-white-alpha-200)}.light .\\32xl\\:ikp-btn--variant_outline:is(:hover,[data-hover]),[data-theme=light] .\\32xl\\:ikp-btn--variant_outline:is(:hover,[data-hover]){color:var(--ikp-colors-gray-800)}.\\32xl\\:ikp-btn--variant_outline:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 0%,var(--ikp-colors-color-palette-100));background-color:var(--bga,var(--ikp-colors-color-palette-100))}.dark .\\32xl\\:ikp-btn--variant_outline:is(:active,[data-active]),[data-theme=dark] .\\32xl\\:ikp-btn--variant_outline:is(:active,[data-active]){--bga:color-mix(in srgb,transparent 76%,var(--ikp-colors-color-palette-200));background-color:var(--bga,var(--ikp-colors-color-palette-200))}}@media screen and (min-width: 96em){.\\32xl\\:ikp-btn--variant_iconButton{background:var(--ikp-colors-transparent);border-radius:0;padding-inline:var(--ikp-spacing-1);color:var(--ikp-colors-gray-600)}.dark .\\32xl\\:ikp-btn--variant_iconButton,[data-theme=dark] .\\32xl\\:ikp-btn--variant_iconButton{color:var(--ikp-colors-white-alpha-600)}.\\32xl\\:ikp-btn--variant_iconButton:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-primary-stronger);background:var(--ikp-colors-transparent)}.dark .\\32xl\\:ikp-btn--variant_iconButton:is(:hover,[data-hover]),[data-theme=dark] .\\32xl\\:ikp-btn--variant_iconButton:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-expanded-primary-300)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-btn--size_lg{height:var(--ikp-sizes-12);min-width:var(--ikp-sizes-12);font-size:var(--ikp-font-sizes-lg);padding-inline:var(--ikp-spacing-6)}.\\32xl\\:ikp-btn--size_md{height:var(--ikp-sizes-10);min-width:var(--ikp-sizes-10);font-size:var(--ikp-font-sizes-md);padding-inline:var(--ikp-spacing-4)}.\\32xl\\:ikp-btn--size_sm{height:var(--ikp-sizes-8);min-width:var(--ikp-sizes-8);font-size:var(--ikp-font-sizes-sm);padding-inline:var(--ikp-spacing-3)}.\\32xl\\:ikp-btn--size_xs{height:var(--ikp-sizes-6);min-width:var(--ikp-sizes-6);font-size:var(--ikp-font-sizes-xs);padding-inline:var(--ikp-spacing-2)}.\\32xl\\:ikp-close-btn--size_lg{--btn-bg:var(--ikp-sizes-10);font-size:var(--ikp-font-sizes-md)}.\\32xl\\:ikp-close-btn--size_md{--btn-bg:var(--ikp-sizes-8);font-size:var(--ikp-font-sizes-xs)}.\\32xl\\:ikp-close-btn--size_sm{--btn-bg:var(--ikp-sizes-6);font-size:var(--ikp-font-sizes-2xs)}.\\32xl\\:ikp-code--variant_solid{--badge-bg:var(--ikp-colors-color-palette-500);--badge-color:var(--ikp-colors-white)}.dark .\\32xl\\:ikp-code--variant_solid,[data-theme=dark] .\\32xl\\:ikp-code--variant_solid{--badge-bg-alpha:color-mix(in srgb,transparent 60%,var(--colors-color-palette-500)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-500)) ;--badge-color:var(--ikp-colors-white-alpha-800) }.\\32xl\\:ikp-code--variant_subtle{--badge-bg:colorPalette.1;--badge-color:var(--ikp-colors-color-palette-800)}.dark .\\32xl\\:ikp-code--variant_subtle,[data-theme=dark] .\\32xl\\:ikp-code--variant_subtle{--badge-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) ;--badge-color:var(--ikp-colors-color-palette-200) }.\\32xl\\:ikp-code--variant_outline{--badge-color:var(--ikp-colors-color-palette-500);--badge-shadow:inset 0 0 0px 1px var(--badge-color,inherit)}.dark .\\32xl\\:ikp-code--variant_outline,[data-theme=dark] .\\32xl\\:ikp-code--variant_outline{--badge-bg-alpha:color-mix(in srgb,transparent 80%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) }.\\32xl\\:ikp-badge--variant_solid{--badge-bg:var(--ikp-colors-color-palette-500);--badge-color:var(--ikp-colors-white)}.dark .\\32xl\\:ikp-badge--variant_solid,[data-theme=dark] .\\32xl\\:ikp-badge--variant_solid{--badge-bg-alpha:color-mix(in srgb,transparent 60%,var(--colors-color-palette-500)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-500)) ;--badge-color:var(--ikp-colors-white-alpha-800) }.\\32xl\\:ikp-badge--variant_subtle{--badge-bg:colorPalette.1;--badge-color:var(--ikp-colors-color-palette-800)}.dark .\\32xl\\:ikp-badge--variant_subtle,[data-theme=dark] .\\32xl\\:ikp-badge--variant_subtle{--badge-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) ;--badge-color:var(--ikp-colors-color-palette-200) }.\\32xl\\:ikp-badge--variant_outline{--badge-color:var(--ikp-colors-color-palette-500);--badge-shadow:inset 0 0 0px 1px var(--badge-color,inherit)}.dark .\\32xl\\:ikp-badge--variant_outline,[data-theme=dark] .\\32xl\\:ikp-badge--variant_outline{--badge-bg-alpha:color-mix(in srgb,transparent 80%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) }.\\32xl\\:ikp-heading--size_4xl{font-size:var(--ikp-font-sizes-6xl);line-height:1}}@media screen and (min-width: 96em){@media screen and (min-width: 48em){.\\32xl\\:ikp-heading--size_4xl{font-size:var(--ikp-font-sizes-7xl)}}}@media screen and (min-width: 96em){.\\32xl\\:ikp-heading--size_3xl{font-size:var(--ikp-font-sizes-5xl);line-height:1}@media screen and (min-width: 48em){.\\32xl\\:ikp-heading--size_3xl{font-size:var(--ikp-font-sizes-6xl)}}}@media screen and (min-width: 96em){.\\32xl\\:ikp-heading--size_2xl{font-size:var(--ikp-font-sizes-4xl);line-height:1.2}@media screen and (min-width: 48em){.\\32xl\\:ikp-heading--size_2xl{font-size:var(--ikp-font-sizes-5xl);line-height:1}}}@media screen and (min-width: 96em){.\\32xl\\:ikp-heading--size_xl{font-size:var(--ikp-font-sizes-3xl);line-height:1.33}@media screen and (min-width: 48em){.\\32xl\\:ikp-heading--size_xl{font-size:var(--ikp-font-sizes-4xl);line-height:1.2}}}@media screen and (min-width: 96em){.\\32xl\\:ikp-heading--size_lg{font-size:var(--ikp-font-sizes-2xl);line-height:1.33}@media screen and (min-width: 48em){.\\32xl\\:ikp-heading--size_lg{font-size:var(--ikp-font-sizes-3xl);line-height:1.2}}}@media screen and (min-width: 96em){.\\32xl\\:ikp-heading--size_md{font-size:var(--ikp-font-sizes-xl);line-height:1.2}.\\32xl\\:ikp-heading--size_sm{font-size:var(--ikp-font-sizes-md);line-height:1.2}.\\32xl\\:ikp-heading--size_xs{font-size:var(--ikp-font-sizes-sm);line-height:1.2}.\\32xl\\:ikp-heading--uppercase_true{text-transform:uppercase;letter-spacing:1px;font-weight:600;color:var(--ikp-colors-gray-600)}.\\32xl\\:ikp-icon--variant_dark{color:var(--ikp-colors-white)}.\\32xl\\:ikp-icon--variant_lightPrimary{color:var(--ikp-colors-inkeep-primary-text-subtle)}.\\32xl\\:ikp-icon--variant_light{color:var(--ikp-colors-gray-600)}.\\32xl\\:ikp-kbd--variant_dark{background:primaryDark.9;color:var(--ikp-colors-white);border-color:primaryDark.6;border-radius:3px;border-bottom:2px solid}.\\32xl\\:ikp-kbd--variant_darkOutline{color:var(--ikp-colors-white)}.\\32xl\\:ikp-kbd--variant_darkOutline,.\\32xl\\:ikp-kbd--variant_light{background:primary.1;border-color:var(--ikp-colors-inkeep-primary-medium);border-radius:3px;border-bottom:2px solid}.\\32xl\\:ikp-kbd--variant_light{color:var(--ikp-colors-inkeep-primary-medium)}.\\32xl\\:ikp-kbd--variant_grayLight{background:var(--ikp-colors-gray-400);height:40px;padding:2px 6px;color:var(--ikp-colors-gray-600);border-color:var(--ikp-colors-gray-600);border-radius:3px;border-bottom:2px solid gray.7}.\\32xl\\:ikp-kbd--variant_outline{box-shadow:var(--ikp-shadows-none)}.\\32xl\\:ikp-tag--variant_solid{--badge-bg:var(--ikp-colors-color-palette-500);--badge-color:var(--ikp-colors-white)}.dark .\\32xl\\:ikp-tag--variant_solid,[data-theme=dark] .\\32xl\\:ikp-tag--variant_solid{--badge-bg-alpha:color-mix(in srgb,transparent 60%,var(--colors-color-palette-500)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-500)) ;--badge-color:var(--ikp-colors-white-alpha-800) }.\\32xl\\:ikp-tag--variant_subtle{--badge-bg:colorPalette.1;--badge-color:var(--ikp-colors-color-palette-800)}.dark .\\32xl\\:ikp-tag--variant_subtle,[data-theme=dark] .\\32xl\\:ikp-tag--variant_subtle{--badge-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) ;--badge-color:var(--ikp-colors-color-palette-200) }.\\32xl\\:ikp-tag--variant_outline{--badge-color:var(--ikp-colors-color-palette-500);--badge-shadow:inset 0 0 0px 1px var(--badge-color,inherit)}.dark .\\32xl\\:ikp-tag--variant_outline,[data-theme=dark] .\\32xl\\:ikp-tag--variant_outline{--badge-bg-alpha:color-mix(in srgb,transparent 80%,var(--colors-color-palette-200)) ;--badge-bg:var(--badge-bg-alpha,var(--colors-color-palette-200)) }.\\32xl\\:ikp-tag--size_sm{--tag-min-height:var(--ikp-sizes-5);--tag-min-width:var(--ikp-sizes-5);--tag-font-size:var(--ikp-font-sizes-xs);--tag-padding-inline:var(--ikp-space-2)}.\\32xl\\:ikp-tag--size_md{--tag-min-height:var(--ikp-sizes-6);--tag-min-width:var(--ikp-sizes-6);--tag-font-size:var(--ikp-font-sizes-sm);--tag-padding-inline:var(--ikp-space-2)}.\\32xl\\:ikp-tag--size_lg{--tag-min-height:var(--ikp-sizes-8);--tag-min-width:var(--ikp-sizes-8);--tag-font-size:var(--ikp-font-sizes-md);--tag-padding-inline:var(--ikp-space-3)}.\\32xl\\:ikp-textarea--variant_outline{border:1px solid;border-color:inherit;background:inherit}}@media screen and (min-width: 96em){.\\32xl\\:ikp-textarea--variant_outline:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.\\32xl\\:ikp-textarea--variant_outline[aria-invalid=true],.\\32xl\\:ikp-textarea--variant_outline[data-invalid] .\\32xl\\:ikp-textarea--variant_outline{border-color:var(--input-error-border-color);box-shadow:0 0 0 1px var(--input-error-border-color)}.\\32xl\\:ikp-textarea--variant_outline:is(:focus-visible,[data-focus-visible]){z-index:1;border-color:var(--input-focus-border-color);box-shadow:0 0 0 1px var(--input-focus-border-color)}.\\32xl\\:ikp-textarea--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-300)}.dark .\\32xl\\:ikp-textarea--variant_outline:is(:hover,[data-hover]),[data-theme=dark] .\\32xl\\:ikp-textarea--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-textarea--variant_flushed{border-bottom:1px solid;border-color:inherit;border-radius:0;padding-inline:var(--ikp-spacing-0);background:var(--ikp-colors-transparent)}.\\32xl\\:ikp-textarea--variant_flushed:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.\\32xl\\:ikp-textarea--variant_flushed[aria-invalid=true],.\\32xl\\:ikp-textarea--variant_flushed[data-invalid] .\\32xl\\:ikp-textarea--variant_flushed{border-color:var(--input-error-border-color);box-shadow:0 1px 0 0 var(--input-error-border-color)}.\\32xl\\:ikp-textarea--variant_flushed:is(:focus-visible,[data-focus-visible]){border-color:var(--input-focus-border-color);box-shadow:0 1px 0 0 var(--input-focus-border-color)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-textarea--variant_filled{border:2px solid;border-color:var(--ikp-colors-transparent);background:var(--ikp-colors-gray-100)}.dark .\\32xl\\:ikp-textarea--variant_filled,[data-theme=dark] .\\32xl\\:ikp-textarea--variant_filled{background:var(--ikp-colors-white-alpha-50)}.\\32xl\\:ikp-textarea--variant_filled:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.\\32xl\\:ikp-textarea--variant_filled[aria-invalid=true],.\\32xl\\:ikp-textarea--variant_filled[data-invalid] .\\32xl\\:ikp-textarea--variant_filled{border-color:var(--input-error-border-color)}.\\32xl\\:ikp-textarea--variant_filled:is(:focus-visible,[data-focus-visible]){background:var(--ikp-colors-transparent);border-color:var(--input-focus-border-color)}.\\32xl\\:ikp-textarea--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-gray-200)}.dark .\\32xl\\:ikp-textarea--variant_filled:is(:hover,[data-hover]),[data-theme=dark] .\\32xl\\:ikp-textarea--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-100)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-textarea--variant_unstyled{background:var(--ikp-colors-transparent);padding-inline:var(--ikp-spacing-0);height:var(--ikp-sizes-auto)}.\\32xl\\:ikp-textarea--size_xs{--input-font-size:var(--ikp-font-sizes-xs);--input-padding:var(--ikp-space-2);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-6)}.\\32xl\\:ikp-textarea--size_sm{--input-font-size:var(--ikp-font-sizes-sm);--input-padding:var(--ikp-space-3);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-8)}.\\32xl\\:ikp-textarea--size_md{--input-font-size:var(--ikp-font-sizes-md);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-10)}.\\32xl\\:ikp-textarea--size_lg{--input-font-size:var(--ikp-font-sizes-lg);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-12)}.\\32xl\\:ikp-ai-chat-page-wrapper--size_expand{width:100%;height:100%}.\\32xl\\:ikp-ai-chat-page-wrapper--size_default{max-width:100vw;max-height:100vw;margin:auto;align-self:center;justify-self:center;flex-grow:0}}@media screen and (min-width: 96em){@media screen and (min-width: 48em){.\\32xl\\:ikp-ai-chat-page-wrapper--size_default{width:min(600px,100%);height:min(760px,100%)}}@media screen and (min-width: 64em){.\\32xl\\:ikp-ai-chat-page-wrapper--size_default{width:min(640px,100%);height:min(800px,100%)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-ai-chat-page-wrapper--size_default{width:min(760px,100%);height:min(900px,100%)}}}@media screen and (min-width: 96em){.\\32xl\\:ikp-ai-chat-page-wrapper--size_shrink-vertically{width:100%;height:var(--ikp-sizes-auto);align-self:flex-start;max-height:100%}@media screen and (min-width: 48em){.\\32xl\\:ikp-ai-chat-page-wrapper--size_shrink-vertically{width:100%}}}@media screen and (min-width: 96em){.\\32xl\\:ikp-ai-chat-page-wrapper--size_full-viewport{position:fixed;top:var(--ikp-spacing-0);left:var(--ikp-spacing-0);z-index:1000;width:100vw;height:100vh}.\\32xl\\:ikp-ai-chat-page-wrapper--variant_no-shadow{box-shadow:var(--ikp-shadows-none)}.\\32xl\\:ikp-ai-chat-page-wrapper--variant_container-with-shadow{box-shadow:var(--ikp-shadows-2xl)}.dark .\\32xl\\:ikp-ai-chat-page-wrapper--variant_container-with-shadow,[data-theme=dark] .\\32xl\\:ikp-ai-chat-page-wrapper--variant_container-with-shadow{box-shadow:var(--ikp-shadows-none)}.light .\\32xl\\:ikp-preview-content-header--variant_title,[data-theme=light] .\\32xl\\:ikp-preview-content-header--variant_title{color:var(--ikp-colors-inkeep-primary-text-subtle)}.dark .\\32xl\\:ikp-preview-content-header--variant_title,[data-theme=dark] .\\32xl\\:ikp-preview-content-header--variant_title{color:var(--ikp-colors-inkeep-primary-lighter)}}@media screen and (min-width: 96em){.light .\\32xl\\:ikp-preview-content-header--variant_title:is(:hover,[data-hover]),[data-theme=light] .\\32xl\\:ikp-preview-content-header--variant_title:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-primary-stronger)}.dark .\\32xl\\:ikp-preview-content-header--variant_title:is(:hover,[data-hover]),[data-theme=dark] .\\32xl\\:ikp-preview-content-header--variant_title:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-expanded-primary-100)}}@media screen and (min-width: 96em){.light .\\32xl\\:ikp-preview-content-header--variant_hitContentPreview,[data-theme=light] .\\32xl\\:ikp-preview-content-header--variant_hitContentPreview{color:var(--ikp-colors-inkeep-primary-hit-content-preview)}.dark .\\32xl\\:ikp-preview-content-header--variant_hitContentPreview,[data-theme=dark] .\\32xl\\:ikp-preview-content-header--variant_hitContentPreview{color:var(--ikp-colors-inkeep-expanded-primary-300)}.\\32xl\\:ikp-preview-content-header--variant_hitContentPreview .light a:hover,.\\32xl\\:ikp-preview-content-header--variant_hitContentPreview [data-theme=light] a:hover{color:var(--ikp-colors-inkeep-primary-stronger)}.\\32xl\\:ikp-preview-content-header--variant_hitContentPreview .dark a:hover,.\\32xl\\:ikp-preview-content-header--variant_hitContentPreview [data-theme=dark] a:hover{color:var(--ikp-colors-inkeep-expanded-primary-100)}}}@layer recipes.slots{.ikp-alert__container--variant_left-accent{--alert-fg:var(--ikp-colors-color-palette-500);--alert-bg:var(--ikp-colors-color-palette-100);padding-inline-start:var(--ikp-spacing-3);border-inline-start-width:4px;border-inline-start-color:var(--alert-fg)}.dark .ikp-alert__container--variant_left-accent,[data-theme=dark] .ikp-alert__container--variant_left-accent{--alert-fg:var(--ikp-colors-color-palette-200) ;--alert-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) }.ikp-alert__container--variant_top-accent{--alert-fg:var(--ikp-colors-color-palette-500);--alert-bg:var(--ikp-colors-color-palette-100);padding-top:var(--ikp-spacing-2);border-top-width:4px;border-top-color:var(--alert-fg)}.dark .ikp-alert__container--variant_top-accent,[data-theme=dark] .ikp-alert__container--variant_top-accent{--alert-fg:var(--ikp-colors-color-palette-200) ;--alert-bg:var(--alert-bg-alpha,var(--colors-color-palette-200)) }.ikp-alert__container--variant_solid{--alert-fg:var(--ikp-colors-white);--alert-bg:var(--ikp-colors-color-palette-500);color:var(--alert-fg)}.dark .ikp-alert__container--variant_solid,[data-theme=dark] .ikp-alert__container--variant_solid{--alert-fg:var(--ikp-colors-gray-900) ;--alert-bg:var(--ikp-colors-color-palette-200) }.ikp-avatar__root--size_2xs{--avatar-size:var(--ikp-sizes-4);--avatar-font-size:var(--ikp-font-sizes-3xs)}.ikp-avatar__root--size_xs{--avatar-size:var(--ikp-sizes-6);--avatar-font-size:var(--ikp-font-sizes-2xs)}.ikp-avatar__root--size_lg{--avatar-size:var(--ikp-sizes-16);--avatar-font-size:var(--ikp-font-sizes-lg)}.ikp-avatar__root--size_xl{--avatar-size:var(--ikp-sizes-24);--avatar-font-size:var(--ikp-font-sizes-3xl)}.ikp-avatar__root--size_2xl{--avatar-size:var(--ikp-sizes-32);--avatar-font-size:var(--ikp-font-sizes-4xl)}.ikp-card__container--variant_outline{--card-border-width:1px;--card-border-color:var(--ikp-colors-chakra-border-color)}.dark .ikp-card__container--variant_outline,[data-theme=dark] .ikp-card__container--variant_outline{--card-border-color:var(--ikp-colors-white-alpha-300) }.ikp-card__container--variant_filled{--card-bg:var(--ikp-colors-chakra-subtle-bg)}.ikp-card__container--size_sm{--card-radius:var(--ikp-radii-base);--card-padding:var(--ikp-space-3)}.ikp-card__container--size_lg{--card-radius:var(--ikp-radii-xl);--card-padding:var(--ikp-space-7)}.ikp-checkbox__control--size_sm{--checkbox-size:var(--ikp-sizes-3)}.ikp-checkbox__label--size_sm{font-size:var(--ikp-font-sizes-sm)}.ikp-checkbox__icon--size_sm{font-size:var(--ikp-font-sizes-3xs)}.ikp-checkbox__control--size_lg{--checkbox-size:var(--ikp-sizes-5)}.ikp-checkbox__label--size_lg{font-size:var(--ikp-font-sizes-lg)}.ikp-checkbox__icon--size_lg{font-size:var(--ikp-font-sizes-2xs)}.ikp-checkbox__control--shape_circular{border-radius:var(--ikp-radii-full)}.ikp-input__addon--size_lg,.ikp-input__field--size_lg,.ikp-input__group--size_lg{--input-font-size:var(--ikp-font-sizes-lg);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-12)}.ikp-input__addon--size_sm,.ikp-input__field--size_sm,.ikp-input__group--size_sm{--input-font-size:var(--ikp-font-sizes-sm);--input-padding:var(--ikp-space-3);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-8)}.ikp-input__addon--size_xs,.ikp-input__field--size_xs,.ikp-input__group--size_xs{--input-font-size:var(--ikp-font-sizes-xs);--input-padding:var(--ikp-space-2);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-6)}.ikp-input__field--variant_filled{border:2px solid;border-color:var(--ikp-colors-transparent);background:var(--ikp-colors-gray-100)}.dark .ikp-input__field--variant_filled,[data-theme=dark] .ikp-input__field--variant_filled{background:var(--ikp-colors-white-alpha-50)}.ikp-input__field--variant_filled:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.ikp-input__field--variant_filled[aria-invalid=true],.ikp-input__field--variant_filled[data-invalid] .ikp-input__field--variant_filled{border-color:var(--input-error-border-color)}.ikp-input__addon--variant_filled{border:2px solid;border-color:var(--ikp-colors-transparent);background:var(--ikp-colors-gray-100)}.dark .ikp-input__addon--variant_filled,[data-theme=dark] .ikp-input__addon--variant_filled{background:var(--ikp-colors-white-alpha-50)}.ikp-input__field--variant_flushed{border-bottom:1px solid;border-color:inherit;border-radius:0;padding-inline:var(--ikp-spacing-0);background:var(--ikp-colors-transparent)}.ikp-input__field--variant_flushed:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.ikp-input__field--variant_flushed[aria-invalid=true],.ikp-input__field--variant_flushed[data-invalid] .ikp-input__field--variant_flushed{border-color:var(--input-error-border-color);box-shadow:0 1px 0 0 var(--input-error-border-color)}.ikp-input__addon--variant_flushed{border-bottom:2px solid;border-color:inherit;border-radius:0;padding-inline:var(--ikp-spacing-0);background:var(--ikp-colors-transparent)}.ikp-input__addon--variant_unstyled,.ikp-input__field--variant_unstyled{background:var(--ikp-colors-transparent);padding-inline:var(--ikp-spacing-0);height:var(--ikp-sizes-auto)}.ikp-modal__content--size_xs{max-width:var(--ikp-sizes-xs)}.ikp-modal__content--size_sm{max-width:var(--ikp-sizes-sm)}.ikp-modal__content--size_lg{max-width:var(--ikp-sizes-lg)}.ikp-modal__content--size_xl{max-width:var(--ikp-sizes-xl)}.ikp-modal__content--size_3xl{max-width:var(--ikp-sizes-3xl)}.ikp-modal__content--size_4xl{max-width:var(--ikp-sizes-4xl)}.ikp-modal__content--size_5xl{max-width:var(--ikp-sizes-5xl)}.ikp-modal__content--size_6xl{max-width:var(--ikp-sizes-6xl)}.ikp-modal__container--scrollOverflowBehavior_inside{overflow:hidden}.ikp-modal__content--scrollOverflowBehavior_inside{max-height:calc(100% - 7.5rem)}.ikp-select__label--size_sm{font-size:.875rem;line-height:1.25rem}.ikp-select__trigger--size_sm{padding-inline:var(--ikp-spacing-2\\.5);height:var(--ikp-sizes-9);min-width:var(--ikp-sizes-9);font-size:var(--ikp-font-sizes-sm);gap:var(--ikp-spacing-2)}.ikp-select__trigger--size_sm :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}.ikp-select__item--size_sm{font-size:.875rem;line-height:1.25rem;padding-inline:var(--ikp-spacing-2);height:var(--ikp-sizes-9)}.ikp-select__itemIndicator--size_sm :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}.ikp-select__itemGroupLabel--size_sm{padding-inline:var(--ikp-spacing-2);padding-block:var(--ikp-spacing-1\\.5)}.ikp-select__content--size_sm{padding:var(--ikp-spacing-0\\.5);gap:var(--ikp-spacing-1)}.ikp-select__label--size_lg{font-size:.875rem;line-height:1.25rem}.ikp-select__trigger--size_lg{padding-inline:var(--ikp-spacing-3\\.5);height:var(--ikp-sizes-11);min-width:var(--ikp-sizes-11);font-size:var(--ikp-font-sizes-md);gap:var(--ikp-spacing-2)}.ikp-select__trigger--size_lg :where(svg){width:var(--ikp-sizes-5);height:var(--ikp-sizes-5)}.ikp-select__item--size_lg{font-size:1rem;line-height:1.5rem;padding-inline:var(--ikp-spacing-2);height:var(--ikp-sizes-11)}.ikp-select__itemIndicator--size_lg :where(svg){width:var(--ikp-sizes-5);height:var(--ikp-sizes-5)}.ikp-select__itemGroupLabel--size_lg{padding-inline:var(--ikp-spacing-2);padding-block:var(--ikp-spacing-1\\.5)}.ikp-select__content--size_lg{padding:var(--ikp-spacing-1\\.5);gap:var(--ikp-spacing-1)}.ikp-switch__root--size_md{--switch-track-width:1.875rem;--switch-track-height:var(--ikp-sizes-4)}.ikp-switch__root--size_lg{--switch-track-width:2.875rem;--switch-track-height:var(--ikp-sizes-6)}.ikp-switch__control--size_xss{width:24px;height:12px}.ikp-switch__thumb--size_xss{width:12px;height:12px}.ikp-tabs__trigger--size_lg{font-size:var(--ikp-font-sizes-lg);padding-block:var(--ikp-spacing-3);padding-inline:var(--ikp-spacing-4)}.ikp-tabs__list--variant_enclosed{margin-bottom:-1px;border-bottom:1px solid;border-color:inherit}.ikp-tabs__trigger--variant_enclosed{border-top-left-radius:var(--ikp-radii-md);border-top-right-radius:var(--ikp-radii-md);border:1px solid;border-color:var(--ikp-colors-transparent);margin-bottom:-1px;--tabs-border-color:transparent;color:var(--tabs-color)}.ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-600) ;--tabs-border-color:var(--ikp-colors-white) }.dark .ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]),[data-theme=dark] .ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-300) ;--tabs-border-color:var(--ikp-colors-gray-800) }.ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]){border-color:inherit;border-bottom-color:var(--tabs-border-color)}.ikp-tabs__list--variant_enclosed-colored{margin-bottom:-1px;border-bottom:1px solid;border-color:inherit}.ikp-tabs__trigger--variant_enclosed-colored{border:1px solid;border-color:inherit;--tabs-bg:var(--ikp-colors-gray-50);margin-bottom:-1px;color:var(--tabs-color);background:var(--tabs-bg)}.dark .ikp-tabs__trigger--variant_enclosed-colored,[data-theme=dark] .ikp-tabs__trigger--variant_enclosed-colored{--tabs-bg:var(--ikp-colors-white-alpha-50) }.ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]){--tabs-bg:var(--ikp-colors-white) ;--tabs-color:var(--ikp-colors-color-palette-600) }.dark .ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]),[data-theme=dark] .ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]){--tabs-bg:var(--ikp-colors-gray-800) ;--tabs-color:var(--ikp-colors-color-palette-300) }.ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]){border-color:inherit;border-top-color:currentColor;border-bottom-color:var(--ikp-colors-transparent)}.ikp-tabs__trigger--variant_enclosed-colored _notLast{margin-inline-end:-1px}.ikp-tabs__trigger--variant_soft-rounded{border-radius:var(--ikp-radii-full);font-weight:var(--ikp-font-weights-semibold);color:var(--ikp-colors-gray-600)}.ikp-tabs__trigger--variant_soft-rounded:is([aria-selected=true],[data-selected]){color:var(--ikp-colors-color-palette-700);background:var(--ikp-colors-color-palette-100)}.ikp-tabs__trigger--variant_solid-rounded{border-radius:var(--ikp-radii-full);font-weight:var(--ikp-font-weights-semibold);--tabs-color:var(--ikp-colors-gray-600);color:var(--tabs-color);background:var(--tabs-bg)}.dark .ikp-tabs__trigger--variant_solid-rounded,[data-theme=dark] .ikp-tabs__trigger--variant_solid-rounded{--tabs-color:inherit }.ikp-tabs__trigger--variant_solid-rounded:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-white) ;--tabs-bg:var(--ikp-colors-color-palette-600) }.dark .ikp-tabs__trigger--variant_solid-rounded:is([aria-selected=true],[data-selected]),[data-theme=dark] .ikp-tabs__trigger--variant_solid-rounded:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-gray-800) ;--tabs-bg:var(--ikp-colors-color-palette-300) }.ikp-tabs__trigger--isFitted_true{flex:1 1 0%}.ikp-table__tr--variant_tfoot th:last-of-type{border-bottom-width:0}.ikp-table__caption--variant_striped{color:var(--ikp-colors-gray-600)}.dark .ikp-table__caption--variant_striped,[data-theme=dark] .ikp-table__caption--variant_striped{color:var(--ikp-colors-gray-100)}.ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,.ikp-table__tbody--variant_striped tr:nth-of-type(odd) th{border-bottom-width:1px;border-color:var(--ikp-colors-color-palette-100)}.dark .ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,.dark .ikp-table__tbody--variant_striped tr:nth-of-type(odd) th,[data-theme=dark] .ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,[data-theme=dark] .ikp-table__tbody--variant_striped tr:nth-of-type(odd) th{border-color:var(--ikp-colors-color-palette-700)}.ikp-table__tbody--variant_striped tr:nth-of-type(odd) td{background:var(--ikp-colors-color-palette-100)}.dark .ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,[data-theme=dark] .ikp-table__tbody--variant_striped tr:nth-of-type(odd) td{background:var(--ikp-colors-color-palette-700)}.ikp-table__td--variant_striped{border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .ikp-table__td--variant_striped,[data-theme=dark] .ikp-table__td--variant_striped{border-color:var(--ikp-colors-color-palette-700)}.ikp-table__td--variant_striped[data-is-numeric=true]{text-align:end}.ikp-table__tfoot--variant_striped th tr:last-of-type{border-bottom-width:0}.ikp-table__th--variant_striped{color:var(--ikp-colors-gray-600);border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .ikp-table__th--variant_striped,[data-theme=dark] .ikp-table__th--variant_striped{color:var(--ikp-colors-gray-400);border-color:var(--ikp-colors-color-palette-700)}.ikp-table__th--variant_striped[data-is-numeric=true]{text-align:end}.ikp-table__caption--size_sm{font-size:var(--ikp-font-sizes-xs)}.ikp-table__caption--size_sm,.ikp-table__td--size_sm{padding-inline:var(--ikp-spacing-4);padding-block:var(--ikp-spacing-2)}.ikp-table__td--size_sm{font-size:var(--ikp-font-sizes-sm);line-height:var(--ikp-line-heights-4)}.ikp-table__th--size_sm{padding-inline:var(--ikp-spacing-4);padding-block:var(--ikp-spacing-1);line-height:var(--ikp-line-heights-4);font-size:var(--ikp-font-sizes-xs)}.ikp-table__caption--size_lg{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-2);font-size:var(--ikp-font-sizes-md)}.ikp-table__td--size_lg{padding-inline:var(--ikp-spacing-8);padding-block:var(--ikp-spacing-5);line-height:var(--ikp-line-heights-6)}.ikp-table__th--size_lg{padding-inline:var(--ikp-spacing-8);padding-block:var(--ikp-spacing-4);line-height:var(--ikp-line-heights-5);font-size:var(--ikp-font-sizes-sm)}.ikp-search-bar-trigger__container--size_expand{height:100%!important}.ikp-search-bar-trigger__wrapper--size_expand{width:100%;height:100%}.ikp-search-bar-trigger__container--size_shrink{padding-inline:var(--ikp-spacing-2)!important;height:var(--ikp-sizes-9)!important}.ikp-search-bar-trigger__kbd--size_shrink,.ikp-search-bar-trigger__text--size_shrink{display:none}.ikp-search-bar-trigger__icon--size_shrink{width:var(--ikp-sizes-5)!important;margin-right:var(--ikp-spacing-0)!important}.ikp-search-bar-trigger__container--size_medium{height:100%!important}.light .ikp-search-bar-trigger__container--variant_emphasized,[data-theme=light] .ikp-search-bar-trigger__container--variant_emphasized{border-color:var(--ikp-colors-gray-100);box-shadow:var(--ikp-shadows-sm)}.ikp-search-bar-trigger__container--variant_subtle{border-color:var(--ikp-colors-gray-300);color:var(--ikp-colors-gray-500)!important}.dark .ikp-search-bar-trigger__container--variant_subtle,[data-theme=dark] .ikp-search-bar-trigger__container--variant_subtle{color:var(--ikp-colors-white-alpha-500)!important;border-color:var(--ikp-colors-white-alpha-300)}.ikp-search-bar-trigger__kbd--variant_subtle{border:var(--ikp-borders-none);padding-inline:var(--ikp-spacing-0);color:var(--ikp-colors-gray-500)}.dark .ikp-search-bar-trigger__kbd--variant_subtle,[data-theme=dark] .ikp-search-bar-trigger__kbd--variant_subtle{color:var(--ikp-colors-white-alpha-500)}.ikp-search-bar-trigger__icon--variant_subtle{width:18px}.ikp-tooltip__content--variant_default{font-weight:var(--ikp-font-weights-normal)}.light .ikp-tooltip__content--variant_default,[data-theme=light] .ikp-tooltip__content--variant_default{background:var(--ikp-colors-white);box-shadow:0 8px 30px #0000001f;color:var(--ikp-colors-gray-800);--tooltip-arrow-bg:white }.dark .ikp-tooltip__content--variant_default,[data-theme=dark] .ikp-tooltip__content--variant_default{background:var(--ikp-colors-gray-dark-800);color:var(--ikp-colors-white-alpha-800);--tooltip-arrow-bg:var(--ikp-colors-gray-dark-800) }.ikp-table__caption--variant_simple{color:var(--ikp-colors-gray-600)}.dark .ikp-table__caption--variant_simple,[data-theme=dark] .ikp-table__caption--variant_simple{color:var(--ikp-colors-gray-100)}.ikp-table__caption--size_md{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-2);font-size:var(--ikp-font-sizes-sm)}.ikp-table__td--variant_simple{border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .ikp-table__td--variant_simple,[data-theme=dark] .ikp-table__td--variant_simple{border-color:var(--ikp-colors-color-palette-700)}.ikp-table__td--variant_simple[data-is-numeric=true]{text-align:end}.ikp-table__td--size_md{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-4);line-height:var(--ikp-line-heights-5)}.ikp-table__th--variant_simple{color:var(--ikp-colors-gray-600);border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .ikp-table__th--variant_simple,[data-theme=dark] .ikp-table__th--variant_simple{color:var(--ikp-colors-gray-400);border-color:var(--ikp-colors-color-palette-700)}.ikp-table__th--variant_simple[data-is-numeric=true]{text-align:end}.ikp-table__th--size_md{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-3);line-height:var(--ikp-line-heights-4);font-size:var(--ikp-font-sizes-xs)}.ikp-card__body--variant_unstyled,.ikp-card__footer--variant_unstyled,.ikp-card__header--variant_unstyled{--card-padding:0}.ikp-card__container--variant_elevated{--card-shadow:var(--ikp-shadows-base)}.dark .ikp-card__container--variant_elevated,[data-theme=dark] .ikp-card__container--variant_elevated{--card-bg:var(--ikp-colors-gray-700) }.ikp-card__container--size_md{--card-radius:var(--ikp-radii-md);--card-padding:var(--ikp-space-5)}.ikp-tabs__trigger--size_sm{padding-block:var(--ikp-spacing-1);padding-inline:var(--ikp-spacing-4);font-size:var(--ikp-font-sizes-sm)}.ikp-tabs__list--variant_line{--tabs-border-color:2px solid;border-color:inherit}.ikp-tabs__trigger--size_md{font-size:var(--ikp-font-sizes-md);padding-block:var(--ikp-spacing-2);padding-inline:var(--ikp-spacing-4)}.ikp-tabs__trigger--variant_line{--tabs-border-color:2px solid;border-color:var(--ikp-colors-transparent);--tabs-margin-prop:-2px;color:var(--tabs-color);background:var(--tabs-bg)}.ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-600) }.dark .ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]),[data-theme=dark] .ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-300) }.ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]){border-color:currentColor}.ikp-modal__container--variant_clickThrough{pointer-events:none;z-index:var(--ikp-z-index-modal) - 1}.ikp-modal__content--variant_clickThrough{pointer-events:auto}.ikp-modal__content--size_full{max-width:100vw;min-height:100vh;margin-block:var(--ikp-spacing-0);border-radius:0}.ikp-modal__content--size_2xl{max-width:var(--ikp-sizes-2xl)}.ikp-modal__container--isCentered_false{align-items:flex-start}.ikp-modal__content--isCentered_false{margin-block:var(--ikp-spacing-16)}.ikp-modal__container--scrollOverflowBehavior_outside{overflow:auto}.ikp-modal__container--isCentered_true{align-items:center}.ikp-modal__content--size_md{max-width:var(--ikp-sizes-md)}.ikp-modal__content--isCentered_true{margin-block:auto;margin-inline:auto}.ikp-input__field--size_md,.ikp-input__group--size_md{--input-font-size:var(--ikp-font-sizes-md);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-10)}.ikp-input__field--variant_outline{border:1px solid;border-color:inherit;background:inherit}.ikp-input__field--variant_outline:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.ikp-input__field--variant_outline[aria-invalid=true],.ikp-input__field--variant_outline[data-invalid] .ikp-input__field--variant_outline{border-color:var(--input-error-border-color);box-shadow:0 0 0 1px var(--input-error-border-color)}.ikp-input__addon--size_md{--input-font-size:var(--ikp-font-sizes-md);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-10)}.ikp-input__addon--variant_outline{border:1px solid;border-color:inherit;background:var(--ikp-colors-gray-100)}.dark .ikp-input__addon--variant_outline,[data-theme=dark] .ikp-input__addon--variant_outline{border-color:var(--ikp-colors-white-alpha-50);background:var(--ikp-colors-white-alpha-300)}.ikp-avatar__root--size_sm{--avatar-size:var(--ikp-sizes-8);--avatar-font-size:var(--ikp-font-sizes-xs)}.ikp-avatar__root--size_md{--avatar-size:var(--ikp-sizes-12);--avatar-font-size:var(--ikp-font-sizes-md)}.ikp-alert__container--variant_subtle{--alert-fg:var(--ikp-colors-color-palette-500);--alert-bg:var(--ikp-colors-color-palette-100)}.dark .ikp-alert__container--variant_subtle,[data-theme=dark] .ikp-alert__container--variant_subtle{--alert-fg:var(--ikp-colors-color-palette-200) ;--alert-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--alert-bg:var(--alert-bg-alpha,var(--colors-color-palette-200)) }.ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){background:var(--ikp-colors-gray-900)}.dark .ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]),[data-theme=dark] .ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){background:var(--ikp-colors-white-alpha-900);border-color:var(--ikp-colors-white-alpha-900)}.ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){border-color:var(--ikp-colors-gray-900)}.ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){background:var(--ikp-colors-gray-900)}.dark .ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]),[data-theme=dark] .ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){background:var(--ikp-colors-white-alpha-900);border-color:var(--ikp-colors-white-alpha-900)}.ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){border-color:var(--ikp-colors-gray-900)}.ikp-checkbox__control--size_md{--checkbox-size:var(--ikp-sizes-4)}.ikp-checkbox__label--size_md{font-size:var(--ikp-font-sizes-md)}.ikp-checkbox__icon--size_md{font-size:var(--ikp-font-sizes-2xs)}.ikp-select__trigger--variant_ikpOutline{background:var(--ikp-colors-white);border-width:1px}.dark .ikp-select__trigger--variant_ikpOutline,[data-theme=dark] .ikp-select__trigger--variant_ikpOutline{background:var(--ikp-colors-color-palette-900)}.ikp-select__label--size_md{font-size:.875rem;line-height:1.25rem}.ikp-select__trigger--size_md{padding-inline:var(--ikp-spacing-3);height:var(--ikp-sizes-10);min-width:var(--ikp-sizes-10);font-size:var(--ikp-font-sizes-md);gap:var(--ikp-spacing-2)}.ikp-select__trigger--size_md :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}.ikp-select__trigger--variant_outline{background:var(--ikp-colors-white);border-width:1px}.dark .ikp-select__trigger--variant_outline,[data-theme=dark] .ikp-select__trigger--variant_outline{background:var(--ikp-colors-color-palette-800)}.ikp-select__item--size_md{font-size:1rem;line-height:1.5rem;padding-inline:var(--ikp-spacing-2);height:var(--ikp-sizes-10)}.ikp-select__itemIndicator--size_md :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}.ikp-select__itemGroupLabel--size_md{padding-inline:var(--ikp-spacing-2);padding-block:var(--ikp-spacing-1\\.5)}.ikp-select__content--size_md{padding:var(--ikp-spacing-1);gap:var(--ikp-spacing-1)}.ikp-switch__root--size_sm{--switch-track-width:1.375rem;--switch-track-height:var(--ikp-sizes-3)}.ikp-input__field--variant_filled:is(:focus-visible,[data-focus-visible]){background:var(--ikp-colors-transparent);border-color:var(--input-focus-border-color)}.ikp-input__field--variant_flushed:is(:focus-visible,[data-focus-visible]){border-color:var(--input-focus-border-color);box-shadow:0 1px 0 0 var(--input-focus-border-color)}.ikp-select__trigger--variant_ghost:is(:focus,[data-focus]){background:var(--ikp-colors-color-palette-100)}.dark .ikp-select__trigger--variant_ghost:is(:focus,[data-focus]),[data-theme=dark] .ikp-select__trigger--variant_ghost:is(:focus,[data-focus]){background:var(--ikp-colors-color-palette-900)}.ikp-input__field--variant_outline:is(:focus-visible,[data-focus-visible]){z-index:1;border-color:var(--input-focus-border-color);box-shadow:0 0 0 1px var(--input-focus-border-color)}.ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]){border-color:var(--ikp-colors-color-palette-200)}.dark .ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]),[data-theme=dark] .ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]){border-color:var(--ikp-colors-white-alpha-300)}.ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]){box-shadow:var(--ikp-shadows-accent)}.ikp-select__trigger--variant_outline:is(:focus,[data-focus]){border-color:var(--ikp-colors-color-palette-200)}.dark .ikp-select__trigger--variant_outline:is(:focus,[data-focus]),[data-theme=dark] .ikp-select__trigger--variant_outline:is(:focus,[data-focus]){border-color:var(--ikp-colors-color-palette-800)}.ikp-select__trigger--variant_outline:is(:focus,[data-focus]){box-shadow:var(--ikp-shadows-accent)}.ikp-input__field--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-gray-200)}.dark .ikp-input__field--variant_filled:is(:hover,[data-hover]),[data-theme=dark] .ikp-input__field--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-100)}.ikp-select__trigger--variant_ghost:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-100)}.dark .ikp-select__trigger--variant_ghost:is(:hover,[data-hover]),[data-theme=dark] .ikp-select__trigger--variant_ghost:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-900)}.light .ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]),[data-theme=light] .ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]){box-shadow:var(--ikp-shadows-md);background:none!important}.dark .ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]),[data-theme=dark] .ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]){background:none!important}.ikp-search-bar-trigger__container--variant_subtle:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-400);background:none!important}.dark .ikp-search-bar-trigger__container--variant_subtle:is(:hover,[data-hover]),[data-theme=dark] .ikp-search-bar-trigger__container--variant_subtle:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}.ikp-input__field--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-300)}.dark .ikp-input__field--variant_outline:is(:hover,[data-hover]),[data-theme=dark] .ikp-input__field--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}.ikp-select__trigger--variant_ikpOutline:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-300)}.dark .ikp-select__trigger--variant_ikpOutline:is(:hover,[data-hover]),[data-theme=dark] .ikp-select__trigger--variant_ikpOutline:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}.ikp-tabs__trigger--variant_line:is(:active,[data-active]){--tabs-bg:var(--ikp-colors-gray-200) }.dark .ikp-tabs__trigger--variant_line:is(:active,[data-active]),[data-theme=dark] .ikp-tabs__trigger--variant_line:is(:active,[data-active]){--tabs-bg:var(--ikp-colors-white-alpha-300) }.ikp-tabs__trigger--variant_line:is(:disabled,[disabled],[data-disabled]):is(:active,[data-active]){background:none}@layer _base{.ikp-search-bar-trigger__container{width:100%;height:100%;color:var(--ikp-colors-gray-600)!important;background:none;border:1px solid;display:flex;justify-content:space-between!important;padding-inline:var(--ikp-spacing-3);align-items:center;border-radius:var(--ikp-radii-md);flex-grow:5;transition:all .3s ease-in-out}.dark .ikp-search-bar-trigger__container,[data-theme=dark] .ikp-search-bar-trigger__container{border-color:var(--ikp-colors-gray-dark-600);color:var(--ikp-colors-white-alpha-500)!important}.ikp-search-bar-trigger__text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:inline-block;font-weight:var(--ikp-font-weights-normal);color:inherit;margin-right:var(--ikp-spacing-4)}.ikp-search-bar-trigger__kbd{display:flex;align-items:center;background:var(--ikp-colors-transparent)!important;padding-inline:var(--ikp-spacing-2);padding-block:var(--ikp-spacing-1);box-shadow:var(--ikp-shadows-none);border-color:var(--ikp-colors-chakra-border-color);color:var(--ikp-colors-gray-600)}.dark .ikp-search-bar-trigger__kbd,[data-theme=dark] .ikp-search-bar-trigger__kbd{color:var(--ikp-colors-white-alpha-600);border-color:var(--ikp-colors-white-alpha-300)}.ikp-search-bar-trigger__icon{width:var(--ikp-sizes-5)}.ikp-tooltip__arrow{--arrow-size:var(--ikp-sizes-3);--arrow-background:var(--tooltip-arrow-bg)}.ikp-tooltip__arrowTip:is([open],[data-open],[data-state=open]){animation:fade-in .25s ease-out}.ikp-tooltip__arrowTip:is([data-state=closed]){animation:fade-out .2s ease-out}.ikp-tooltip__positioner{--tooltip-arrow-bg:var(--tooltip-bg);--tooltip-bg:var(--ikp-colors-gray-700);--tooltip-fg:var(--ikp-colors-white-alpha-900)}.dark .ikp-tooltip__positioner,[data-theme=dark] .ikp-tooltip__positioner{--tooltip-bg:var(--ikp-colors-gray-300) ;--tooltip-fg:var(--ikp-colors-gray-900) }.ikp-tooltip__content{background:var(--tooltip-bg);color:var(--tooltip-fg);font-weight:var(--ikp-font-weights-medium);font-size:var(--ikp-font-sizes-sm);box-shadow:var(--ikp-shadows-md);max-width:var(--ikp-sizes-xs);z-index:var(--ikp-z-index-tooltip);padding-block:var(--ikp-spacing-2);padding-inline:var(--ikp-spacing-3);border-radius:var(--ikp-radii-md)}.ikp-tooltip__content:is([open],[data-open],[data-state=open]){animation:fade-in .25s ease-out}.ikp-tooltip__content:is([data-state=closed]){animation:fade-out .2s ease-out}.ikp-content-parser__sup{margin-left:3px;cursor:pointer}.ikp-content-parser__sup a{background:var(--ikp-colors-inkeep-primary-light);padding-inline:4px;padding-block:1px;border-radius:var(--ikp-radii-base);text-decoration:none;color:var(--ikp-colors-inkeep-primary-text-subtle);font-weight:var(--ikp-font-weights-semibold)}.ikp-content-parser__text{margin-bottom:12px;overflow-wrap:break-word;white-space:pre-wrap}.ikp-content-parser__text+li,.ikp-content-parser__text+ol{margin-top:0}.ikp-content-parser__ol{overflow-wrap:break-word;padding-bottom:var(--ikp-spacing-3);padding-left:var(--ikp-spacing-7);position:relative}.ikp-content-parser__ol li{margin-bottom:var(--ikp-spacing-1);counter-increment:item}.ikp-content-parser__ol a{display:inline!important;overflow-wrap:break-word}.ikp-content-parser__ul{overflow-wrap:break-word;padding-bottom:var(--ikp-spacing-3);padding-left:var(--ikp-spacing-7);position:relative}.ikp-content-parser__ul li{margin-bottom:var(--ikp-spacing-1)}.ikp-content-parser__ul li:before{margin-right:var(--ikp-spacing-2)}.ikp-content-parser__ul a{display:inline!important;overflow-wrap:break-word}.ikp-content-parser__image{object-fit:cover;width:100%;height:var(--ikp-sizes-auto)}.ikp-content-parser__link{overflow-wrap:break-word;word-wrap:break-word;text-decoration:underline;display:inline}.light .ikp-content-parser__link,[data-theme=light] .ikp-content-parser__link{color:var(--ikp-colors-inkeep-primary-stronger)}.dark .ikp-content-parser__link,[data-theme=dark] .ikp-content-parser__link{color:var(--ikp-colors-inkeep-expanded-primary-100)}.ikp-content-parser__code{overflow-wrap:anywhere;min-width:var(--ikp-sizes-0);padding-block:.2rem;margin-block:.1rem;padding-inline:.4rem!important;border-radius:6px!important;font-size:85%!important;color:var(--ikp-colors-inkeep-primary-text-color-on-primary);background-color:var(--ikp-colors-inkeep-primary-medium);font-weight:var(--ikp-font-weights-semibold);display:inline-block}.ikp-table__container{display:block;white-space:nowrap;-webkit-overflow-scrolling:touch;overflow-x:auto;overflow-y:hidden;max-width:100%}.ikp-table__table{font-variant-numeric:lining-nums tabular-nums;border-collapse:collapse;width:var(--ikp-sizes-full);--ikp-colors-color-palette-50:var(--ikp-colors-gray-50);--ikp-colors-color-palette-100:var(--ikp-colors-gray-100);--ikp-colors-color-palette-200:var(--ikp-colors-gray-200);--ikp-colors-color-palette-300:var(--ikp-colors-gray-300);--ikp-colors-color-palette-400:var(--ikp-colors-gray-400);--ikp-colors-color-palette-500:var(--ikp-colors-gray-500);--ikp-colors-color-palette-600:var(--ikp-colors-gray-600);--ikp-colors-color-palette-700:var(--ikp-colors-gray-700);--ikp-colors-color-palette-800:var(--ikp-colors-gray-800);--ikp-colors-color-palette-900:var(--ikp-colors-gray-900);--ikp-colors-color-palette-950:var(--ikp-colors-gray-950)}.ikp-table__caption{margin-top:var(--ikp-spacing-4);font-family:var(--ikp-fonts-heading);text-align:center;font-weight:var(--ikp-font-weights-medium);caption-side:bottom}.ikp-table__td,.ikp-table__th{text-align:start}.ikp-table__th{font-family:var(--ikp-fonts-heading);font-weight:var(--ikp-font-weights-bold);text-transform:uppercase;letter-spacing:var(--ikp-letter-spacings-wider)}.ikp-form-control__container{width:100%;position:relative}.ikp-form-control__required-indicator{margin-inline-start:var(--ikp-spacing-1);--form-control-color:var(--ikp-colors-red-500);color:var(--form-control-color)}.dark .ikp-form-control__required-indicator,[data-theme=dark] .ikp-form-control__required-indicator{--form-control-color:var(--ikp-colors-red-300) }.ikp-form-control__helper{margin-top:var(--ikp-spacing-2);--form-control-color:var(--ikp-colors-gray-600);color:var(--form-control-color);line-height:var(--ikp-line-heights-normal);font-size:var(--ikp-font-sizes-sm)}.dark .ikp-form-control__helper,[data-theme=dark] .ikp-form-control__helper{--form-control-color:var(--ikp-colors-white-alpha-600) }.ikp-form-control__label{display:block;text-align:start;font-size:var(--ikp-font-sizes-md);margin-inline-end:var(--ikp-spacing-3);margin-bottom:var(--ikp-spacing-2);font-weight:var(--ikp-font-weights-medium);--transition-prop:common;transition-property:common;--transition-duration:var(--ikp-durations-normal);transition-duration:var(--ikp-durations-normal);opacity:1}.ikp-form-control__label:is(:disabled,[disabled],[data-disabled]){opacity:.4}.ikp-form-control__error{display:flex;align-items:center;--form-error-color:var(--ikp-colors-red-500);color:var(--form-error-color);margin-top:var(--ikp-spacing-2);font-size:var(--ikp-font-sizes-sm);line-height:var(--ikp-line-heights-normal)}.dark .ikp-form-control__error,[data-theme=dark] .ikp-form-control__error{--form-error-color:var(--ikp-colors-red-300) }.ikp-form-control__error-icon{margin-inline-end:.5em;--form-error-color:var(--ikp-colors-red-500);color:var(--form-error-color)}.dark .ikp-form-control__error-icon,[data-theme=dark] .ikp-form-control__error-icon{--form-error-color:var(--ikp-colors-red-300) }.ikp-card__container{--card-bg:var(--ikp-colors-chakra-body-bg);background-color:var(--card-bg);box-shadow:var(--card-shadow);border-radius:var(--card-radius);color:var(--ikp-colors-chakra-body-text);border-width:var(--card-border-width,0);border-color:var(--card-border-color)}.ikp-card__body{flex:1 1 0%}.ikp-card__body,.ikp-card__footer,.ikp-card__header{padding:var(--card-padding)}.ikp-tabs__root{--ikp-colors-color-palette-50:var(--ikp-colors-blue-50);--ikp-colors-color-palette-100:var(--ikp-colors-blue-100);--ikp-colors-color-palette-200:var(--ikp-colors-blue-200);--ikp-colors-color-palette-300:var(--ikp-colors-blue-300);--ikp-colors-color-palette-400:var(--ikp-colors-blue-400);--ikp-colors-color-palette-500:var(--ikp-colors-blue-500);--ikp-colors-color-palette-600:var(--ikp-colors-blue-600);--ikp-colors-color-palette-700:var(--ikp-colors-blue-700);--ikp-colors-color-palette-800:var(--ikp-colors-blue-800);--ikp-colors-color-palette-900:var(--ikp-colors-blue-900);--ikp-colors-color-palette-950:var(--ikp-colors-blue-950)}.ikp-tabs__root[data-orientation=vertical]{display:flex}.ikp-tabs__root[data-orientation=horizontal]{display:block}.ikp-tabs__list{position:relative;scrollbar-width:none;display:flex}.ikp-tabs__list::-webkit-scrollbar{display:none}.ikp-tabs__list[data-orientation=vertical]{flex-direction:column;border-inline-start:var(--tabs-border-color);margin-inline-start:var(--tabs-margin-prop)}.ikp-tabs__list[data-orientation=horizontal]{flex-direction:row;border-bottom:var(--tabs-border-color);margin-bottom:var(--tabs-margin-prop)}.ikp-tabs__trigger{outline:0;display:flex;align-items:center;justify-content:center;--transition-prop:common;transition-property:common;--transition-duration:var(--ikp-durations-normal);transition-duration:var(--ikp-durations-normal)}.ikp-tabs__trigger:is(:disabled,[disabled],[data-disabled]){cursor:not-allowed;opacity:.4}.ikp-tabs__content{outline:0;padding:var(--ikp-spacing-4)}.ikp-tabs__indicator{display:none;background-color:var(--ikp-colors-inkeep-expanded-primary-600)}.ikp-tabs__indicator[data-orientation=vertical]{width:2px;left:var(--ikp-spacing-0)}.ikp-tabs__indicator[data-orientation=horizontal]{height:2px;bottom:-2px}.ikp-tabs__panels{width:100%}.ikp-modal__backdrop{background:var(--ikp-colors-black-alpha-600);z-index:var(--ikp-z-index-modal);position:fixed;left:var(--ikp-spacing-0);top:var(--ikp-spacing-0);width:100vw;height:100vh;backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px)}.light .ikp-modal__backdrop,[data-theme=light] .ikp-modal__backdrop{background-color:#6870767f}.dark .ikp-modal__backdrop,[data-theme=dark] .ikp-modal__backdrop{background-color:#8890967f}.ikp-modal__backdrop:is([open],[data-open],[data-state=open]){animation:var(--ikp-animations-backdrop-in)}.ikp-modal__backdrop:is([data-state=closed]){animation:var(--ikp-animations-backdrop-out)}.ikp-modal__container{justify-content:center;overscroll-behavior-y:none;width:100vw;height:100vh;position:fixed;left:var(--ikp-spacing-0);top:var(--ikp-spacing-0)}.ikp-modal__container,.ikp-modal__content{display:flex;z-index:var(--ikp-z-index-modal)}.ikp-modal__content{flex-direction:column;position:relative;width:100%;outline:0;border-radius:var(--ikp-radii-md);color:inherit;--modal-bg:var(--ikp-colors-white);--modal-shadow:var(--ikp-shadows-lg);background:var(--modal-bg);box-shadow:var(--modal-shadow);padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-2);flex:1 1 0%}.dark .ikp-modal__content,[data-theme=dark] .ikp-modal__content{--modal-bg:var(--ikp-colors-gray-700) ;--modal-shadow:var(--ikp-shadows-dark-lg) ;background:var(--ikp-colors-gray-dark-900)}.ikp-modal__content:is([open],[data-open],[data-state=open]){animation:var(--ikp-animations-backdrop-in)}.ikp-modal__content:is([data-state=closed]){animation:var(--ikp-animations-backdrop-out)}.ikp-modal__title{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-4);font-size:var(--ikp-font-sizes-xl);font-weight:var(--ikp-font-weights-semibold);flex:0}.ikp-modal__description{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-2);flex:1 1 0%}.ikp-modal__closeTrigger{position:absolute;top:var(--ikp-spacing-2);inset-inline-end:var(--ikp-spacing-3)}.ikp-modal__footer{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-4);display:flex;align-items:center;justify-content:flex-end}.ikp-input__group{width:100%;display:flex;position:relative;isolation:isolate;--input-border-radius:0}.ikp-input__group>[data-placement=left]{border-start-start-radius:0;border-end-start-radius:0}.ikp-input__group>[data-placement=right]{border-start-end-radius:0;border-end-end-radius:0}.ikp-input__group:has([data-placement=right])>input{border-start-end-radius:0;border-end-end-radius:0}.ikp-input__field{height:var(--input-height);font-size:var(--input-font-size);padding-inline:var(--input-padding);border-radius:var(--input-border-radius);width:100%;min-width:var(--ikp-sizes-0);outline:0;position:relative;-moz-appearance:none;appearance:none;-webkit-appearance:none;--transition-prop:common;transition-property:common;--transition-duration:var(--ikp-durations-normal);transition-duration:var(--ikp-durations-normal);--input-focus-border-color:var(--ikp-colors-blue-500);--input-error-border-color:var(--ikp-colors-red-500)}.ikp-input__field:is(:disabled,[disabled],[data-disabled]){opacity:.4;cursor:not-allowed}.dark .ikp-input__field,[data-theme=dark] .ikp-input__field{--input-focus-border-color:var(--ikp-colors-blue-300) ;--input-error-border-color:var(--ikp-colors-red-300) }.ikp-input__addon{height:var(--input-height);font-size:var(--input-font-size);padding-inline:var(--input-padding);border-radius:var(--input-border-radius)}.ikp-input__addon+input{border-start-start-radius:0;border-end-start-radius:0}.ikp-popover__arrow{--arrow-size:var(--ikp-sizes-3);--arrow-background:var(--popper-arrow-bg)}.ikp-popover__arrowTip{border-top-width:1px;border-left-width:1px}.ikp-popover__positioner{position:relative;z-index:var(--ikp-z-index-popover)}.ikp-popover__content{position:relative;display:flex;flex-direction:column;--popper-bg:var(--ikp-colors-white);background:var(--popper-bg);--popper-arrow-bg:var(--popper-bg);--popper-arrow-shadow-color:var(--ikp-colors-gray-200);width:var(--ikp-sizes-xs);border:1px solid;border-color:inherit;border-radius:var(--ikp-radii-md);box-shadow:var(--ikp-shadows-sm);z-index:inherit}.dark .ikp-popover__content,[data-theme=dark] .ikp-popover__content{--popper-bg:var(--ikp-colors-gray-dark-800) ;--popper-arrow-shadow-color:var(--ikp-colors-white-alpha-300) }.ikp-popover__content:is([open],[data-open],[data-state=open]){animation:fade-in .25s ease-out}.ikp-popover__content:is([data-state=closed]){animation:fade-out .2s ease-out}.ikp-popover__title{border-bottom-width:1px}.ikp-popover__description,.ikp-popover__title{padding-inline:var(--ikp-spacing-3);padding-block:var(--ikp-spacing-2)}.ikp-popover__closeTrigger{position:absolute;border-radius:var(--ikp-radii-md);top:var(--ikp-spacing-1);inset-inline-end:var(--ikp-spacing-2);padding:var(--ikp-spacing-2)}.ikp-popover__footer{padding-inline:var(--ikp-spacing-3);padding-block:var(--ikp-spacing-2);border-top-width:1px}.ikp-avatar__root{background:var(--avatar-bg);font-size:var(--avatar-font-size);color:var(--ikp-colors-white);border-color:var(--avatar-border-color);vertical-align:top;width:var(--avatar-size);height:var(--avatar-size);--avatar-border-color:var(--ikp-colors-white);display:inline-flex;justify-content:center;text-align:center;text-transform:uppercase;font-weight:var(--ikp-font-weights-medium);position:relative;flex-shrink:0;border-radius:var(--avatar-border-radius,var(--ikp-sizes-full))}.ikp-avatar__root[data-is-bg-dark]{color:var(--ikp-colors-gray-800)}.ikp-avatar__root:not([data-loaded]){--avatar-bg:var(--ikp-colors-gray-400) }.dark .ikp-avatar__root,[data-theme=dark] .ikp-avatar__root{--avatar-border-color:var(--ikp-colors-gray-800) }.ikp-avatar__fallback{align-items:center;display:flex;font-weight:var(--ikp-font-weights-semibold);height:inherit;justify-content:center}.ikp-avatar__image{width:100%;height:100%;object-fit:cover;border-radius:var(--avatar-border-radius,var(--ikp-sizes-full))}.ikp-alert__container{--ikp-colors-color-palette-50:var(--ikp-colors-blue-50);--ikp-colors-color-palette-100:var(--ikp-colors-blue-100);--ikp-colors-color-palette-200:var(--ikp-colors-blue-200);--ikp-colors-color-palette-300:var(--ikp-colors-blue-300);--ikp-colors-color-palette-400:var(--ikp-colors-blue-400);--ikp-colors-color-palette-500:var(--ikp-colors-blue-500);--ikp-colors-color-palette-600:var(--ikp-colors-blue-600);--ikp-colors-color-palette-700:var(--ikp-colors-blue-700);--ikp-colors-color-palette-800:var(--ikp-colors-blue-800);--ikp-colors-color-palette-900:var(--ikp-colors-blue-900);--ikp-colors-color-palette-950:var(--ikp-colors-blue-950);background:var(--alert-bg);padding-inline:var(--ikp-spacing-4);padding-block:var(--ikp-spacing-3);width:100%;display:flex;align-items:center;position:relative;overflow:hidden}.ikp-alert__icon{height:var(--ikp-sizes-6);display:inherit}.ikp-alert__icon,.ikp-alert__spinner{color:var(--alert-fg);flex-shrink:0;margin-inline-end:var(--ikp-spacing-3);width:var(--ikp-sizes-5)}.ikp-alert__spinner{height:var(--ikp-sizes-5)}.ikp-alert__title{font-weight:var(--ikp-font-weights-bold);margin-inline-end:var(--ikp-spacing-2)}.ikp-alert__description,.ikp-alert__title{line-height:var(--ikp-line-heights-6)}.ikp-checkbox__container{cursor:pointer;display:inline-flex;align-items:center;vertical-align:top;position:relative;--ikp-colors-color-palette-50:var(--ikp-colors-blue-50);--ikp-colors-color-palette-100:var(--ikp-colors-blue-100);--ikp-colors-color-palette-200:var(--ikp-colors-blue-200);--ikp-colors-color-palette-300:var(--ikp-colors-blue-300);--ikp-colors-color-palette-400:var(--ikp-colors-blue-400);--ikp-colors-color-palette-500:var(--ikp-colors-blue-500);--ikp-colors-color-palette-600:var(--ikp-colors-blue-600);--ikp-colors-color-palette-700:var(--ikp-colors-blue-700);--ikp-colors-color-palette-800:var(--ikp-colors-blue-800);--ikp-colors-color-palette-900:var(--ikp-colors-blue-900);--ikp-colors-color-palette-950:var(--ikp-colors-blue-950)}.ikp-checkbox__container:is(:disabled,[disabled],[data-disabled]){cursor:not-allowed}.ikp-checkbox__control{display:inline-flex;align-items:center;justify-content:center;vertical-align:top;-webkit-user-select:none;user-select:none;flex-shrink:0;width:var(--checkbox-size,1em);height:var(--checkbox-size,1em);--transition-prop:box-shadow;transition-property:box-shadow;--transition-duration:var(--ikp-durations-normal);transition-duration:var(--ikp-durations-normal);border:2px solid;border-radius:var(--ikp-radii-sm);border-color:inherit;color:var(--ikp-colors-white)}.ikp-checkbox__control:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){background:var(--ikp-colors-color-palette-500)}.dark .ikp-checkbox__control:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]),[data-theme=dark] .ikp-checkbox__control:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){background:var(--ikp-colors-color-palette-200);border-color:var(--ikp-colors-color-palette-200);color:var(--ikp-colors-gray-900)}.ikp-checkbox__control:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){border-color:var(--ikp-colors-color-palette-500);color:var(--ikp-colors-white)}.ikp-checkbox__control:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]):is(:disabled,[disabled],[data-disabled]){border-color:var(--ikp-colors-gray-200)}.dark .ikp-checkbox__control:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]):is(:disabled,[disabled],[data-disabled]),[data-theme=dark] .ikp-checkbox__control:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]):is(:disabled,[disabled],[data-disabled]){border-color:var(--ikp-colors-transparent);background:var(--ikp-colors-white-alpha-300);color:var(--ikp-colors-white-alpha-500)}.ikp-checkbox__control:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]):is(:disabled,[disabled],[data-disabled]){background:var(--ikp-colors-gray-200);color:var(--ikp-colors-gray-500)}.ikp-checkbox__control:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){background:var(--ikp-colors-color-palette-500)}.dark .ikp-checkbox__control:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]),[data-theme=dark] .ikp-checkbox__control:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){background:var(--ikp-colors-color-palette-200);border-color:var(--ikp-colors-color-palette-200);color:var(--ikp-colors-gray-900)}.ikp-checkbox__control:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){border-color:var(--ikp-colors-color-palette-500);color:var(--ikp-colors-white)}.ikp-checkbox__control:is(:disabled,[disabled],[data-disabled]){background:var(--ikp-colors-gray-100)}.dark .ikp-checkbox__control:is(:disabled,[disabled],[data-disabled]),[data-theme=dark] .ikp-checkbox__control:is(:disabled,[disabled],[data-disabled]){background:var(--ikp-colors-white-alpha-100);border-color:var(--ikp-colors-transparent)}.ikp-checkbox__control:is(:disabled,[disabled],[data-disabled]){border-color:var(--ikp-colors-gray-100)}.ikp-checkbox__control[aria-invalid=true],.ikp-checkbox__control[data-invalid] .ikp-checkbox__control{border-color:var(--ikp-colors-red-500)}.dark .ikp-checkbox__control[aria-invalid=true],.dark .ikp-checkbox__control[data-invalid] .ikp-checkbox__control,[data-theme=dark] .ikp-checkbox__control[aria-invalid=true],[data-theme=dark] .ikp-checkbox__control[data-invalid] .ikp-checkbox__control{border-color:var(--ikp-colors-red-300)}.ikp-checkbox__label{margin-left:.5rem;-webkit-user-select:none;user-select:none}.ikp-checkbox__label:is(:disabled,[disabled],[data-disabled]){opacity:.4}.ikp-checkbox__icon{animation:checkAnim .2s linear;font-size:var(--checkbox-size,1em);color:var(--checkbox-icon-color,unset);--transition-prop:transform;transition-property:transform;--transition-duration:var(--ikp-durations-normal);transition-duration:var(--ikp-durations-normal)}.ikp-checkbox__icon:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){animation:indeterminateOpacityAnim 20ms linear,indeterminateScaleAnim .2s linear}.ikp-select__label{color:var(--ikp-colors-color-palette-700);font-weight:var(--ikp-font-weights-medium)}.dark .ikp-select__label,[data-theme=dark] .ikp-select__label{color:var(--ikp-colors-color-palette-200)}.ikp-select__positioner{z-index:var(--ikp-z-index-dropdown)}.ikp-select__trigger{height:var(--input-height);font-size:var(--input-font-size);padding-inline:var(--input-padding);border-radius:var(--ikp-radii-md);width:var(--ikp-sizes-full);min-width:var(--ikp-sizes-0);outline:0;position:relative;-moz-appearance:none;appearance:none;-webkit-appearance:none;--transition-prop:background,box-shadow,border-color;transition-property:background,box-shadow,border-color;--transition-duration:var(--ikp-durations-normal);transition-duration:var(--ikp-durations-normal);--input-focus-border-color:var(--ikp-colors-blue-500);--input-error-border-color:var(--ikp-colors-red-500);padding-bottom:1px;line-height:var(--ikp-line-heights-normal);background:var(--select-bg);--select-bg:var(--ikp-colors-white);align-items:center;border-color:var(--ikp-colors-color-palette-300);cursor:pointer;display:inline-flex;justify-content:space-between;--transition-easing:var(--ikp-easings-default);transition-timing-function:var(--ikp-easings-default)}.ikp-select__trigger:is(:disabled,[disabled],[data-disabled]){opacity:.4;cursor:not-allowed}.dark .ikp-select__trigger,[data-theme=dark] .ikp-select__trigger{--select-bg:var(--ikp-colors-color-palette-700) ;border-color:var(--ikp-colors-color-palette-700)}.ikp-select__trigger:placeholder-shown{color:var(--ikp-colors-color-palette-500)}.dark .ikp-select__trigger:placeholder-shown,[data-theme=dark] .ikp-select__trigger:placeholder-shown{color:var(--ikp-colors-color-palette-400)}.ikp-select__trigger :where(svg){color:var(--ikp-colors-color-palette-500)}.dark .ikp-select__trigger :where(svg),[data-theme=dark] .ikp-select__trigger :where(svg){color:var(--ikp-colors-color-palette-400)}.ikp-select__item{align-items:center;border-radius:var(--ikp-radii-xs);cursor:pointer;display:flex;justify-content:space-between;--transition-duration:var(--ikp-durations-fast);transition-duration:var(--ikp-durations-fast);--transition-prop:background,color;transition-property:background,color;--transition-easing:var(--ikp-easings-default);transition-timing-function:var(--ikp-easings-default)}.ikp-select__item[data-highlighted]{background:var(--ikp-colors-color-palette-100)}.dark .ikp-select__item[data-highlighted],[data-theme=dark] .ikp-select__item[data-highlighted]{background:var(--ikp-colors-color-palette-800)}.ikp-select__item:is(:disabled,[disabled],[data-disabled]){--color-alpha:color-mix(in srgb,transparent 0%,var(--ikp-colors-gray-300));color:var(--color-alpha,var(--ikp-colors-gray-300))}.dark .ikp-select__item:is(:disabled,[disabled],[data-disabled]),[data-theme=dark] .ikp-select__item:is(:disabled,[disabled],[data-disabled]){--color-alpha:color-mix(in srgb,transparent 50%,var(--ikp-colors-gray-300));color:var(--color-alpha,var(--ikp-colors-gray-300))}.ikp-select__item:is(:disabled,[disabled],[data-disabled]){cursor:not-allowed}.ikp-select__itemIndicator{color:var(--ikp-colors-accent-default)}.ikp-select__itemGroupLabel{font-weight:var(--ikp-font-weights-semibold);font-size:.875rem;line-height:1.25rem}.ikp-select__content{background:var(--ikp-colors-white);border-radius:var(--ikp-radii-md);border-width:1px;box-shadow:var(--ikp-shadows-sm);display:flex;flex-direction:column;--ikp-colors-color-palette-50:var(--ikp-colors-gray-50);--ikp-colors-color-palette-100:var(--ikp-colors-gray-100);--ikp-colors-color-palette-200:var(--ikp-colors-gray-200);--ikp-colors-color-palette-300:var(--ikp-colors-gray-300);--ikp-colors-color-palette-400:var(--ikp-colors-gray-400);--ikp-colors-color-palette-500:var(--ikp-colors-gray-500);--ikp-colors-color-palette-600:var(--ikp-colors-gray-600);--ikp-colors-color-palette-700:var(--ikp-colors-gray-700);--ikp-colors-color-palette-800:var(--ikp-colors-gray-800);--ikp-colors-color-palette-900:var(--ikp-colors-gray-900);--ikp-colors-color-palette-950:var(--ikp-colors-gray-950)}.dark .ikp-select__content,[data-theme=dark] .ikp-select__content{background:var(--ikp-colors-color-palette-900);--ikp-colors-color-palette-50:var(--ikp-colors-gray-dark-50);--ikp-colors-color-palette-100:var(--ikp-colors-gray-dark-100);--ikp-colors-color-palette-200:var(--ikp-colors-gray-dark-200);--ikp-colors-color-palette-300:var(--ikp-colors-gray-dark-300);--ikp-colors-color-palette-400:var(--ikp-colors-gray-dark-400);--ikp-colors-color-palette-500:var(--ikp-colors-gray-dark-500);--ikp-colors-color-palette-600:var(--ikp-colors-gray-dark-600);--ikp-colors-color-palette-700:var(--ikp-colors-gray-dark-700);--ikp-colors-color-palette-800:var(--ikp-colors-gray-dark-800);--ikp-colors-color-palette-900:var(--ikp-colors-gray-dark-900) }.ikp-select__content[data-hidden],.ikp-select__content[hidden]{display:none}.ikp-select__content:is([open],[data-open],[data-state=open]){animation:fade-in .25s ease-out}.ikp-select__content:is([data-state=closed]){animation:fade-out .2s ease-out}.ikp-select__root{display:flex;flex-direction:column;gap:var(--ikp-spacing-1\\.5);width:var(--ikp-sizes-full);--ikp-colors-color-palette-50:var(--ikp-colors-gray-50);--ikp-colors-color-palette-100:var(--ikp-colors-gray-100);--ikp-colors-color-palette-200:var(--ikp-colors-gray-200);--ikp-colors-color-palette-300:var(--ikp-colors-gray-300);--ikp-colors-color-palette-400:var(--ikp-colors-gray-400);--ikp-colors-color-palette-500:var(--ikp-colors-gray-500);--ikp-colors-color-palette-600:var(--ikp-colors-gray-600);--ikp-colors-color-palette-700:var(--ikp-colors-gray-700);--ikp-colors-color-palette-800:var(--ikp-colors-gray-800);--ikp-colors-color-palette-900:var(--ikp-colors-gray-900);--ikp-colors-color-palette-950:var(--ikp-colors-gray-950)}.dark .ikp-select__root,[data-theme=dark] .ikp-select__root{--ikp-colors-color-palette-50:var(--ikp-colors-gray-dark-50);--ikp-colors-color-palette-100:var(--ikp-colors-gray-dark-100);--ikp-colors-color-palette-200:var(--ikp-colors-gray-dark-200);--ikp-colors-color-palette-300:var(--ikp-colors-gray-dark-300);--ikp-colors-color-palette-400:var(--ikp-colors-gray-dark-400);--ikp-colors-color-palette-500:var(--ikp-colors-gray-dark-500);--ikp-colors-color-palette-600:var(--ikp-colors-gray-dark-600);--ikp-colors-color-palette-700:var(--ikp-colors-gray-dark-700);--ikp-colors-color-palette-800:var(--ikp-colors-gray-dark-800);--ikp-colors-color-palette-900:var(--ikp-colors-gray-dark-900) }.ikp-switch__root{--ikp-colors-color-palette-50:var(--ikp-colors-blue-50);--ikp-colors-color-palette-100:var(--ikp-colors-blue-100);--ikp-colors-color-palette-200:var(--ikp-colors-blue-200);--ikp-colors-color-palette-300:var(--ikp-colors-blue-300);--ikp-colors-color-palette-400:var(--ikp-colors-blue-400);--ikp-colors-color-palette-500:var(--ikp-colors-blue-500);--ikp-colors-color-palette-600:var(--ikp-colors-blue-600);--ikp-colors-color-palette-700:var(--ikp-colors-blue-700);--ikp-colors-color-palette-800:var(--ikp-colors-blue-800);--ikp-colors-color-palette-900:var(--ikp-colors-blue-900);--ikp-colors-color-palette-950:var(--ikp-colors-blue-950);--switch-track-diff:calc(var(--switch-track-width) - var(--switch-track-height));--switch-thumb-x:var(--switch-track-diff);position:relative;vertical-align:middle;line-height:0;display:inline-flex;align-items:center}[dir=rtl] .ikp-switch__root{--switch-thumb-x:calc(var(--switch-track-diff) * -1) }.ikp-switch__label{-webkit-user-select:none;user-select:none;margin-inline-start:.5rem}.ikp-switch__control{border-radius:var(--ikp-radii-full);padding:var(--ikp-spacing-0\\.5);width:var(--switch-track-width);height:var(--switch-track-height);--transition-prop:background,transform;transition-property:background,transform;--transition-duration:var(--ikp-durations-fast);transition-duration:var(--ikp-durations-fast);--switch-bg:var(--ikp-colors-gray-300);background:var(--switch-bg);display:inline-flex;flex-shrink:0;justify-content:flex-start;box-sizing:content-box;cursor:pointer}.dark .ikp-switch__control,[data-theme=dark] .ikp-switch__control{--switch-bg:var(--ikp-colors-white-alpha-400) }.ikp-switch__control:is(:disabled,[disabled],[data-disabled]){opacity:.4;cursor:not-allowed}.ikp-switch__control:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){--switch-bg:var(--ikp-colors-color-palette-500) }.dark .ikp-switch__control:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]),[data-theme=dark] .ikp-switch__control:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){--switch-bg:var(--ikp-colors-color-palette-200) }.ikp-switch__thumb{background:var(--ikp-colors-white);--transition-prop:transform;transition-property:transform;--transition-duration:var(--ikp-durations-normal);transition-duration:var(--ikp-durations-normal);border-radius:inherit;width:var(--switch-track-height);height:var(--switch-track-height)}.ikp-switch__thumb:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){transform:translate(var(--switch-thumb-x))}.ikp-tabs__trigger:is(:focus-visible,[data-focus-visible]){z-index:1;box-shadow:var(--ikp-shadows-outline)}.ikp-popover__content:is(:focus-visible,[data-focus-visible]){outline:0;box-shadow:var(--ikp-shadows-outline)}.ikp-checkbox__control:is(:focus-visible,[data-focus-visible]){box-shadow:var(--ikp-shadows-outline)}.ikp-select__content:is(:focus-visible,[data-focus-visible]){outline-offset:2px;outline:2px solid;outline-color:var(--ikp-colors-color-palette-600)}.dark .ikp-select__content:is(:focus-visible,[data-focus-visible]),[data-theme=dark] .ikp-select__content:is(:focus-visible,[data-focus-visible]){outline-color:var(--ikp-colors-color-palette-400)}.ikp-switch__control:is(:focus-visible,[data-focus-visible]){box-shadow:var(--ikp-shadows-outline)}.dark .ikp-search-bar-trigger__container:is(:hover,[data-hover]),[data-theme=dark] .ikp-search-bar-trigger__container:is(:hover,[data-hover]){background:inherit;color:var(--ikp-colors-white-alpha-600)!important;border-color:var(--ikp-colors-gray-dark-500);transition:all .3s ease-in-out}.light .ikp-search-bar-trigger__container:is(:hover,[data-hover]),[data-theme=light] .ikp-search-bar-trigger__container:is(:hover,[data-hover]){background:inherit}.light .ikp-content-parser__link:is(:hover,[data-hover]),[data-theme=light] .ikp-content-parser__link:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-primary-strong)}.dark .ikp-content-parser__link:is(:hover,[data-hover]),[data-theme=dark] .ikp-content-parser__link:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-expanded-primary-300)}.ikp-checkbox__control:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]):is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-600)}.dark .ikp-checkbox__control:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]):is(:hover,[data-hover]),[data-theme=dark] .ikp-checkbox__control:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]):is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-300);border-color:var(--ikp-colors-color-palette-300)}.ikp-checkbox__control:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]):is(:hover,[data-hover]){border-color:var(--ikp-colors-color-palette-600)}.ikp-select__item:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-100)}.dark .ikp-select__item:is(:hover,[data-hover]),[data-theme=dark] .ikp-select__item:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-800)}.ikp-select__item:is(:disabled,[disabled],[data-disabled]):is(:hover,[data-hover]){background:var(--ikp-colors-transparent)}}@media screen and (min-width: 33em){.ikp-search-bar-trigger__text--size_shrink{display:inline-block}.ikp-search-bar-trigger__kbd--size_shrink{display:flex}.ikp-search-bar-trigger__icon--size_shrink{width:var(--ikp-sizes-5)!important;margin-right:var(--ikp-spacing-2)!important}.sm\\:ikp-alert__container--variant_subtle{--alert-fg:var(--ikp-colors-color-palette-500);--alert-bg:var(--ikp-colors-color-palette-100)}.dark .sm\\:ikp-alert__container--variant_subtle,[data-theme=dark] .sm\\:ikp-alert__container--variant_subtle{--alert-fg:var(--ikp-colors-color-palette-200) ;--alert-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--alert-bg:var(--alert-bg-alpha,var(--colors-color-palette-200)) }.sm\\:ikp-alert__container--variant_left-accent{--alert-fg:var(--ikp-colors-color-palette-500);--alert-bg:var(--ikp-colors-color-palette-100);padding-inline-start:var(--ikp-spacing-3);border-inline-start-width:4px;border-inline-start-color:var(--alert-fg)}.dark .sm\\:ikp-alert__container--variant_left-accent,[data-theme=dark] .sm\\:ikp-alert__container--variant_left-accent{--alert-fg:var(--ikp-colors-color-palette-200) ;--alert-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) }.sm\\:ikp-alert__container--variant_top-accent{--alert-fg:var(--ikp-colors-color-palette-500);--alert-bg:var(--ikp-colors-color-palette-100);padding-top:var(--ikp-spacing-2);border-top-width:4px;border-top-color:var(--alert-fg)}.dark .sm\\:ikp-alert__container--variant_top-accent,[data-theme=dark] .sm\\:ikp-alert__container--variant_top-accent{--alert-fg:var(--ikp-colors-color-palette-200) ;--alert-bg:var(--alert-bg-alpha,var(--colors-color-palette-200)) }.sm\\:ikp-alert__container--variant_solid{--alert-fg:var(--ikp-colors-white);--alert-bg:var(--ikp-colors-color-palette-500);color:var(--alert-fg)}.dark .sm\\:ikp-alert__container--variant_solid,[data-theme=dark] .sm\\:ikp-alert__container--variant_solid{--alert-fg:var(--ikp-colors-gray-900) ;--alert-bg:var(--ikp-colors-color-palette-200) }.sm\\:ikp-avatar__root--size_2xs{--avatar-size:var(--ikp-sizes-4);--avatar-font-size:var(--ikp-font-sizes-3xs)}.sm\\:ikp-avatar__root--size_xs{--avatar-size:var(--ikp-sizes-6);--avatar-font-size:var(--ikp-font-sizes-2xs)}.sm\\:ikp-avatar__root--size_sm{--avatar-size:var(--ikp-sizes-8);--avatar-font-size:var(--ikp-font-sizes-xs)}.sm\\:ikp-avatar__root--size_md{--avatar-size:var(--ikp-sizes-12);--avatar-font-size:var(--ikp-font-sizes-md)}.sm\\:ikp-avatar__root--size_lg{--avatar-size:var(--ikp-sizes-16);--avatar-font-size:var(--ikp-font-sizes-lg)}.sm\\:ikp-avatar__root--size_xl{--avatar-size:var(--ikp-sizes-24);--avatar-font-size:var(--ikp-font-sizes-3xl)}.sm\\:ikp-avatar__root--size_2xl{--avatar-size:var(--ikp-sizes-32);--avatar-font-size:var(--ikp-font-sizes-4xl)}.sm\\:ikp-card__container--variant_elevated{--card-shadow:var(--ikp-shadows-base)}.dark .sm\\:ikp-card__container--variant_elevated,[data-theme=dark] .sm\\:ikp-card__container--variant_elevated{--card-bg:var(--ikp-colors-gray-700) }.sm\\:ikp-card__container--variant_outline{--card-border-width:1px;--card-border-color:var(--ikp-colors-chakra-border-color)}.dark .sm\\:ikp-card__container--variant_outline,[data-theme=dark] .sm\\:ikp-card__container--variant_outline{--card-border-color:var(--ikp-colors-white-alpha-300) }.sm\\:ikp-card__container--variant_filled{--card-bg:var(--ikp-colors-chakra-subtle-bg)}.sm\\:ikp-card__body--variant_unstyled,.sm\\:ikp-card__footer--variant_unstyled,.sm\\:ikp-card__header--variant_unstyled{--card-padding:0}.sm\\:ikp-card__container--size_sm{--card-radius:var(--ikp-radii-base);--card-padding:var(--ikp-space-3)}.sm\\:ikp-card__container--size_md{--card-radius:var(--ikp-radii-md);--card-padding:var(--ikp-space-5)}.sm\\:ikp-card__container--size_lg{--card-radius:var(--ikp-radii-xl);--card-padding:var(--ikp-space-7)}.sm\\:ikp-checkbox__control--size_sm{--checkbox-size:var(--ikp-sizes-3)}.sm\\:ikp-checkbox__label--size_sm{font-size:var(--ikp-font-sizes-sm)}.sm\\:ikp-checkbox__icon--size_sm{font-size:var(--ikp-font-sizes-3xs)}.sm\\:ikp-checkbox__control--size_md{--checkbox-size:var(--ikp-sizes-4)}.sm\\:ikp-checkbox__label--size_md{font-size:var(--ikp-font-sizes-md)}.sm\\:ikp-checkbox__icon--size_md{font-size:var(--ikp-font-sizes-2xs)}.sm\\:ikp-checkbox__control--size_lg{--checkbox-size:var(--ikp-sizes-5)}.sm\\:ikp-checkbox__label--size_lg{font-size:var(--ikp-font-sizes-lg)}.sm\\:ikp-checkbox__icon--size_lg{font-size:var(--ikp-font-sizes-2xs)}.sm\\:ikp-checkbox__control--shape_circular{border-radius:var(--ikp-radii-full)}}@media screen and (min-width: 33em){.sm\\:ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){background:var(--ikp-colors-gray-900)}.dark .sm\\:ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]),[data-theme=dark] .sm\\:ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){background:var(--ikp-colors-white-alpha-900);border-color:var(--ikp-colors-white-alpha-900)}.sm\\:ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){border-color:var(--ikp-colors-gray-900)}.sm\\:ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){background:var(--ikp-colors-gray-900)}.dark .sm\\:ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]),[data-theme=dark] .sm\\:ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){background:var(--ikp-colors-white-alpha-900);border-color:var(--ikp-colors-white-alpha-900)}.sm\\:ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){border-color:var(--ikp-colors-gray-900)}}@media screen and (min-width: 33em){.sm\\:ikp-input__addon--size_lg,.sm\\:ikp-input__field--size_lg,.sm\\:ikp-input__group--size_lg{--input-font-size:var(--ikp-font-sizes-lg);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-12)}.sm\\:ikp-input__addon--size_md,.sm\\:ikp-input__field--size_md,.sm\\:ikp-input__group--size_md{--input-font-size:var(--ikp-font-sizes-md);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-10)}.sm\\:ikp-input__addon--size_sm,.sm\\:ikp-input__field--size_sm,.sm\\:ikp-input__group--size_sm{--input-font-size:var(--ikp-font-sizes-sm);--input-padding:var(--ikp-space-3);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-8)}.sm\\:ikp-input__addon--size_xs,.sm\\:ikp-input__field--size_xs,.sm\\:ikp-input__group--size_xs{--input-font-size:var(--ikp-font-sizes-xs);--input-padding:var(--ikp-space-2);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-6)}.sm\\:ikp-input__field--variant_outline{border:1px solid;border-color:inherit;background:inherit}}@media screen and (min-width: 33em){.sm\\:ikp-input__field--variant_outline:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.sm\\:ikp-input__field--variant_outline[aria-invalid=true],.sm\\:ikp-input__field--variant_outline[data-invalid] .sm\\:ikp-input__field--variant_outline{border-color:var(--input-error-border-color);box-shadow:0 0 0 1px var(--input-error-border-color)}.sm\\:ikp-input__field--variant_outline:is(:focus-visible,[data-focus-visible]){z-index:1;border-color:var(--input-focus-border-color);box-shadow:0 0 0 1px var(--input-focus-border-color)}.sm\\:ikp-input__field--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-300)}.dark .sm\\:ikp-input__field--variant_outline:is(:hover,[data-hover]),[data-theme=dark] .sm\\:ikp-input__field--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}}@media screen and (min-width: 33em){.sm\\:ikp-input__addon--variant_outline{border:1px solid;border-color:inherit;background:var(--ikp-colors-gray-100)}.dark .sm\\:ikp-input__addon--variant_outline,[data-theme=dark] .sm\\:ikp-input__addon--variant_outline{border-color:var(--ikp-colors-white-alpha-50);background:var(--ikp-colors-white-alpha-300)}.sm\\:ikp-input__field--variant_filled{border:2px solid;border-color:var(--ikp-colors-transparent);background:var(--ikp-colors-gray-100)}.dark .sm\\:ikp-input__field--variant_filled,[data-theme=dark] .sm\\:ikp-input__field--variant_filled{background:var(--ikp-colors-white-alpha-50)}}@media screen and (min-width: 33em){.sm\\:ikp-input__field--variant_filled:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.sm\\:ikp-input__field--variant_filled[aria-invalid=true],.sm\\:ikp-input__field--variant_filled[data-invalid] .sm\\:ikp-input__field--variant_filled{border-color:var(--input-error-border-color)}.sm\\:ikp-input__field--variant_filled:is(:focus-visible,[data-focus-visible]){background:var(--ikp-colors-transparent);border-color:var(--input-focus-border-color)}.sm\\:ikp-input__field--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-gray-200)}.dark .sm\\:ikp-input__field--variant_filled:is(:hover,[data-hover]),[data-theme=dark] .sm\\:ikp-input__field--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-100)}}@media screen and (min-width: 33em){.sm\\:ikp-input__addon--variant_filled{border:2px solid;border-color:var(--ikp-colors-transparent);background:var(--ikp-colors-gray-100)}.dark .sm\\:ikp-input__addon--variant_filled,[data-theme=dark] .sm\\:ikp-input__addon--variant_filled{background:var(--ikp-colors-white-alpha-50)}.sm\\:ikp-input__field--variant_flushed{border-bottom:1px solid;border-color:inherit;border-radius:0;padding-inline:var(--ikp-spacing-0);background:var(--ikp-colors-transparent)}}@media screen and (min-width: 33em){.sm\\:ikp-input__field--variant_flushed:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.sm\\:ikp-input__field--variant_flushed[aria-invalid=true],.sm\\:ikp-input__field--variant_flushed[data-invalid] .sm\\:ikp-input__field--variant_flushed{border-color:var(--input-error-border-color);box-shadow:0 1px 0 0 var(--input-error-border-color)}.sm\\:ikp-input__field--variant_flushed:is(:focus-visible,[data-focus-visible]){border-color:var(--input-focus-border-color);box-shadow:0 1px 0 0 var(--input-focus-border-color)}}@media screen and (min-width: 33em){.sm\\:ikp-input__addon--variant_flushed{border-bottom:2px solid;border-color:inherit;border-radius:0;padding-inline:var(--ikp-spacing-0);background:var(--ikp-colors-transparent)}.sm\\:ikp-input__addon--variant_unstyled,.sm\\:ikp-input__field--variant_unstyled{background:var(--ikp-colors-transparent);padding-inline:var(--ikp-spacing-0);height:var(--ikp-sizes-auto)}.sm\\:ikp-modal__content--size_xs{max-width:var(--ikp-sizes-xs)}.sm\\:ikp-modal__content--size_sm{max-width:var(--ikp-sizes-sm)}.sm\\:ikp-modal__content--size_md{max-width:var(--ikp-sizes-md)}.sm\\:ikp-modal__content--size_lg{max-width:var(--ikp-sizes-lg)}.sm\\:ikp-modal__content--size_xl{max-width:var(--ikp-sizes-xl)}.sm\\:ikp-modal__content--size_2xl{max-width:var(--ikp-sizes-2xl)}.sm\\:ikp-modal__content--size_3xl{max-width:var(--ikp-sizes-3xl)}.sm\\:ikp-modal__content--size_4xl{max-width:var(--ikp-sizes-4xl)}.sm\\:ikp-modal__content--size_5xl{max-width:var(--ikp-sizes-5xl)}.sm\\:ikp-modal__content--size_6xl{max-width:var(--ikp-sizes-6xl)}.sm\\:ikp-modal__content--size_full{max-width:100vw;min-height:100vh;margin-block:var(--ikp-spacing-0);border-radius:0}.sm\\:ikp-modal__container--scrollOverflowBehavior_inside{overflow:hidden}.sm\\:ikp-modal__content--scrollOverflowBehavior_inside{max-height:calc(100% - 7.5rem)}.sm\\:ikp-modal__container--scrollOverflowBehavior_outside{overflow:auto}.sm\\:ikp-modal__container--isCentered_false{align-items:flex-start}.sm\\:ikp-modal__content--isCentered_false{margin-block:var(--ikp-spacing-16)}.sm\\:ikp-modal__container--isCentered_true{align-items:center}.sm\\:ikp-modal__content--isCentered_true{margin-block:auto;margin-inline:auto}.sm\\:ikp-modal__container--variant_clickThrough{pointer-events:none;z-index:var(--ikp-z-index-modal) - 1}.sm\\:ikp-modal__content--variant_clickThrough{pointer-events:auto}.sm\\:ikp-select__label--size_sm{font-size:.875rem;line-height:1.25rem}.sm\\:ikp-select__trigger--size_sm{padding-inline:var(--ikp-spacing-2\\.5);height:var(--ikp-sizes-9);min-width:var(--ikp-sizes-9);font-size:var(--ikp-font-sizes-sm);gap:var(--ikp-spacing-2)}}@media screen and (min-width: 33em){.sm\\:ikp-select__trigger--size_sm :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}}@media screen and (min-width: 33em){.sm\\:ikp-select__item--size_sm{font-size:.875rem;line-height:1.25rem;padding-inline:var(--ikp-spacing-2);height:var(--ikp-sizes-9)}}@media screen and (min-width: 33em){.sm\\:ikp-select__itemIndicator--size_sm :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}}@media screen and (min-width: 33em){.sm\\:ikp-select__itemGroupLabel--size_sm{padding-inline:var(--ikp-spacing-2);padding-block:var(--ikp-spacing-1\\.5)}.sm\\:ikp-select__content--size_sm{padding:var(--ikp-spacing-0\\.5);gap:var(--ikp-spacing-1)}.sm\\:ikp-select__label--size_md{font-size:.875rem;line-height:1.25rem}.sm\\:ikp-select__trigger--size_md{padding-inline:var(--ikp-spacing-3);height:var(--ikp-sizes-10);min-width:var(--ikp-sizes-10);font-size:var(--ikp-font-sizes-md);gap:var(--ikp-spacing-2)}}@media screen and (min-width: 33em){.sm\\:ikp-select__trigger--size_md :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}}@media screen and (min-width: 33em){.sm\\:ikp-select__item--size_md{font-size:1rem;line-height:1.5rem;padding-inline:var(--ikp-spacing-2);height:var(--ikp-sizes-10)}}@media screen and (min-width: 33em){.sm\\:ikp-select__itemIndicator--size_md :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}}@media screen and (min-width: 33em){.sm\\:ikp-select__itemGroupLabel--size_md{padding-inline:var(--ikp-spacing-2);padding-block:var(--ikp-spacing-1\\.5)}.sm\\:ikp-select__content--size_md{padding:var(--ikp-spacing-1);gap:var(--ikp-spacing-1)}.sm\\:ikp-select__label--size_lg{font-size:.875rem;line-height:1.25rem}.sm\\:ikp-select__trigger--size_lg{padding-inline:var(--ikp-spacing-3\\.5);height:var(--ikp-sizes-11);min-width:var(--ikp-sizes-11);font-size:var(--ikp-font-sizes-md);gap:var(--ikp-spacing-2)}}@media screen and (min-width: 33em){.sm\\:ikp-select__trigger--size_lg :where(svg){width:var(--ikp-sizes-5);height:var(--ikp-sizes-5)}}@media screen and (min-width: 33em){.sm\\:ikp-select__item--size_lg{font-size:1rem;line-height:1.5rem;padding-inline:var(--ikp-spacing-2);height:var(--ikp-sizes-11)}}@media screen and (min-width: 33em){.sm\\:ikp-select__itemIndicator--size_lg :where(svg){width:var(--ikp-sizes-5);height:var(--ikp-sizes-5)}}@media screen and (min-width: 33em){.sm\\:ikp-select__itemGroupLabel--size_lg{padding-inline:var(--ikp-spacing-2);padding-block:var(--ikp-spacing-1\\.5)}.sm\\:ikp-select__content--size_lg{padding:var(--ikp-spacing-1\\.5);gap:var(--ikp-spacing-1)}.sm\\:ikp-select__trigger--variant_outline{background:var(--ikp-colors-white);border-width:1px}.dark .sm\\:ikp-select__trigger--variant_outline,[data-theme=dark] .sm\\:ikp-select__trigger--variant_outline{background:var(--ikp-colors-color-palette-800)}}@media screen and (min-width: 33em){.sm\\:ikp-select__trigger--variant_outline:is(:focus,[data-focus]){border-color:var(--ikp-colors-color-palette-200)}.dark .sm\\:ikp-select__trigger--variant_outline:is(:focus,[data-focus]),[data-theme=dark] .sm\\:ikp-select__trigger--variant_outline:is(:focus,[data-focus]){border-color:var(--ikp-colors-color-palette-800)}.sm\\:ikp-select__trigger--variant_outline:is(:focus,[data-focus]){box-shadow:var(--ikp-shadows-accent)}}@media screen and (min-width: 33em){.sm\\:ikp-select__trigger--variant_ghost:is(:focus,[data-focus]){background:var(--ikp-colors-color-palette-100)}.dark .sm\\:ikp-select__trigger--variant_ghost:is(:focus,[data-focus]),[data-theme=dark] .sm\\:ikp-select__trigger--variant_ghost:is(:focus,[data-focus]){background:var(--ikp-colors-color-palette-900)}.sm\\:ikp-select__trigger--variant_ghost:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-100)}.dark .sm\\:ikp-select__trigger--variant_ghost:is(:hover,[data-hover]),[data-theme=dark] .sm\\:ikp-select__trigger--variant_ghost:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-900)}}@media screen and (min-width: 33em){.sm\\:ikp-select__trigger--variant_ikpOutline{background:var(--ikp-colors-white);border-width:1px}.dark .sm\\:ikp-select__trigger--variant_ikpOutline,[data-theme=dark] .sm\\:ikp-select__trigger--variant_ikpOutline{background:var(--ikp-colors-color-palette-900)}.sm\\:ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]){border-color:var(--ikp-colors-color-palette-200)}.dark .sm\\:ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]),[data-theme=dark] .sm\\:ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]){border-color:var(--ikp-colors-white-alpha-300)}.sm\\:ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]){box-shadow:var(--ikp-shadows-accent)}.sm\\:ikp-select__trigger--variant_ikpOutline:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-300)}.dark .sm\\:ikp-select__trigger--variant_ikpOutline:is(:hover,[data-hover]),[data-theme=dark] .sm\\:ikp-select__trigger--variant_ikpOutline:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}}@media screen and (min-width: 33em){.sm\\:ikp-switch__root--size_sm{--switch-track-width:1.375rem;--switch-track-height:var(--ikp-sizes-3)}.sm\\:ikp-switch__root--size_md{--switch-track-width:1.875rem;--switch-track-height:var(--ikp-sizes-4)}.sm\\:ikp-switch__root--size_lg{--switch-track-width:2.875rem;--switch-track-height:var(--ikp-sizes-6)}.sm\\:ikp-switch__control--size_xss{width:24px;height:12px}.sm\\:ikp-switch__thumb--size_xss{width:12px;height:12px}.sm\\:ikp-tabs__trigger--size_sm{padding-block:var(--ikp-spacing-1);padding-inline:var(--ikp-spacing-4);font-size:var(--ikp-font-sizes-sm)}.sm\\:ikp-tabs__trigger--size_md{font-size:var(--ikp-font-sizes-md);padding-block:var(--ikp-spacing-2);padding-inline:var(--ikp-spacing-4)}.sm\\:ikp-tabs__trigger--size_lg{font-size:var(--ikp-font-sizes-lg);padding-block:var(--ikp-spacing-3);padding-inline:var(--ikp-spacing-4)}.sm\\:ikp-tabs__list--variant_line{--tabs-border-color:2px solid;border-color:inherit}.sm\\:ikp-tabs__trigger--variant_line{--tabs-border-color:2px solid;border-color:var(--ikp-colors-transparent);--tabs-margin-prop:-2px;color:var(--tabs-color);background:var(--tabs-bg)}}@media screen and (min-width: 33em){.sm\\:ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-600) }.dark .sm\\:ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]),[data-theme=dark] .sm\\:ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-300) }.sm\\:ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]){border-color:currentColor}.sm\\:ikp-tabs__trigger--variant_line:is(:active,[data-active]){--tabs-bg:var(--ikp-colors-gray-200) }.dark .sm\\:ikp-tabs__trigger--variant_line:is(:active,[data-active]),[data-theme=dark] .sm\\:ikp-tabs__trigger--variant_line:is(:active,[data-active]){--tabs-bg:var(--ikp-colors-white-alpha-300) }.sm\\:ikp-tabs__trigger--variant_line:is(:disabled,[disabled],[data-disabled]):is(:active,[data-active]){background:none}}@media screen and (min-width: 33em){.sm\\:ikp-tabs__list--variant_enclosed{margin-bottom:-1px;border-bottom:1px solid;border-color:inherit}.sm\\:ikp-tabs__trigger--variant_enclosed{border-top-left-radius:var(--ikp-radii-md);border-top-right-radius:var(--ikp-radii-md);border:1px solid;border-color:var(--ikp-colors-transparent);margin-bottom:-1px;--tabs-border-color:transparent;color:var(--tabs-color)}}@media screen and (min-width: 33em){.sm\\:ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-600) ;--tabs-border-color:var(--ikp-colors-white) }.dark .sm\\:ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]),[data-theme=dark] .sm\\:ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-300) ;--tabs-border-color:var(--ikp-colors-gray-800) }.sm\\:ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]){border-color:inherit;border-bottom-color:var(--tabs-border-color)}}@media screen and (min-width: 33em){.sm\\:ikp-tabs__list--variant_enclosed-colored{margin-bottom:-1px;border-bottom:1px solid;border-color:inherit}.sm\\:ikp-tabs__trigger--variant_enclosed-colored{border:1px solid;border-color:inherit;--tabs-bg:var(--ikp-colors-gray-50);margin-bottom:-1px;color:var(--tabs-color);background:var(--tabs-bg)}.dark .sm\\:ikp-tabs__trigger--variant_enclosed-colored,[data-theme=dark] .sm\\:ikp-tabs__trigger--variant_enclosed-colored{--tabs-bg:var(--ikp-colors-white-alpha-50) }}@media screen and (min-width: 33em){.sm\\:ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]){--tabs-bg:var(--ikp-colors-white) ;--tabs-color:var(--ikp-colors-color-palette-600) }.dark .sm\\:ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]),[data-theme=dark] .sm\\:ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]){--tabs-bg:var(--ikp-colors-gray-800) ;--tabs-color:var(--ikp-colors-color-palette-300) }.sm\\:ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]){border-color:inherit;border-top-color:currentColor;border-bottom-color:var(--ikp-colors-transparent)}.sm\\:ikp-tabs__trigger--variant_enclosed-colored _notLast{margin-inline-end:-1px}.sm\\:ikp-tabs__trigger--variant_soft-rounded{border-radius:var(--ikp-radii-full);font-weight:var(--ikp-font-weights-semibold);color:var(--ikp-colors-gray-600)}}@media screen and (min-width: 33em){.sm\\:ikp-tabs__trigger--variant_soft-rounded:is([aria-selected=true],[data-selected]){color:var(--ikp-colors-color-palette-700);background:var(--ikp-colors-color-palette-100)}}@media screen and (min-width: 33em){.sm\\:ikp-tabs__trigger--variant_solid-rounded{border-radius:var(--ikp-radii-full);font-weight:var(--ikp-font-weights-semibold);--tabs-color:var(--ikp-colors-gray-600);color:var(--tabs-color);background:var(--tabs-bg)}.dark .sm\\:ikp-tabs__trigger--variant_solid-rounded,[data-theme=dark] .sm\\:ikp-tabs__trigger--variant_solid-rounded{--tabs-color:inherit }.sm\\:ikp-tabs__trigger--variant_solid-rounded:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-white) ;--tabs-bg:var(--ikp-colors-color-palette-600) }.dark .sm\\:ikp-tabs__trigger--variant_solid-rounded:is([aria-selected=true],[data-selected]),[data-theme=dark] .sm\\:ikp-tabs__trigger--variant_solid-rounded:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-gray-800) ;--tabs-bg:var(--ikp-colors-color-palette-300) }}@media screen and (min-width: 33em){.sm\\:ikp-tabs__trigger--isFitted_true{flex:1 1 0%}.sm\\:ikp-table__caption--variant_simple{color:var(--ikp-colors-gray-600)}.dark .sm\\:ikp-table__caption--variant_simple,[data-theme=dark] .sm\\:ikp-table__caption--variant_simple{color:var(--ikp-colors-gray-100)}.sm\\:ikp-table__td--variant_simple{border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .sm\\:ikp-table__td--variant_simple,[data-theme=dark] .sm\\:ikp-table__td--variant_simple{border-color:var(--ikp-colors-color-palette-700)}.sm\\:ikp-table__td--variant_simple[data-is-numeric=true]{text-align:end}.sm\\:ikp-table__th--variant_simple{color:var(--ikp-colors-gray-600);border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .sm\\:ikp-table__th--variant_simple,[data-theme=dark] .sm\\:ikp-table__th--variant_simple{color:var(--ikp-colors-gray-400);border-color:var(--ikp-colors-color-palette-700)}.sm\\:ikp-table__th--variant_simple[data-is-numeric=true]{text-align:end}.sm\\:ikp-table__tr--variant_tfoot th:last-of-type{border-bottom-width:0}.sm\\:ikp-table__caption--variant_striped{color:var(--ikp-colors-gray-600)}.dark .sm\\:ikp-table__caption--variant_striped,[data-theme=dark] .sm\\:ikp-table__caption--variant_striped{color:var(--ikp-colors-gray-100)}.sm\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,.sm\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) th{border-bottom-width:1px;border-color:var(--ikp-colors-color-palette-100)}.dark .sm\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,.dark .sm\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) th,[data-theme=dark] .sm\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,[data-theme=dark] .sm\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) th{border-color:var(--ikp-colors-color-palette-700)}.sm\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td{background:var(--ikp-colors-color-palette-100)}.dark .sm\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,[data-theme=dark] .sm\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td{background:var(--ikp-colors-color-palette-700)}.sm\\:ikp-table__td--variant_striped{border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .sm\\:ikp-table__td--variant_striped,[data-theme=dark] .sm\\:ikp-table__td--variant_striped{border-color:var(--ikp-colors-color-palette-700)}.sm\\:ikp-table__td--variant_striped[data-is-numeric=true]{text-align:end}.sm\\:ikp-table__tfoot--variant_striped th tr:last-of-type{border-bottom-width:0}.sm\\:ikp-table__th--variant_striped{color:var(--ikp-colors-gray-600);border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .sm\\:ikp-table__th--variant_striped,[data-theme=dark] .sm\\:ikp-table__th--variant_striped{color:var(--ikp-colors-gray-400);border-color:var(--ikp-colors-color-palette-700)}.sm\\:ikp-table__th--variant_striped[data-is-numeric=true]{text-align:end}.sm\\:ikp-table__caption--size_sm{font-size:var(--ikp-font-sizes-xs)}.sm\\:ikp-table__caption--size_sm,.sm\\:ikp-table__td--size_sm{padding-inline:var(--ikp-spacing-4);padding-block:var(--ikp-spacing-2)}.sm\\:ikp-table__td--size_sm{font-size:var(--ikp-font-sizes-sm);line-height:var(--ikp-line-heights-4)}.sm\\:ikp-table__th--size_sm{padding-inline:var(--ikp-spacing-4);padding-block:var(--ikp-spacing-1);line-height:var(--ikp-line-heights-4);font-size:var(--ikp-font-sizes-xs)}.sm\\:ikp-table__caption--size_md{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-2);font-size:var(--ikp-font-sizes-sm)}.sm\\:ikp-table__td--size_md{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-4);line-height:var(--ikp-line-heights-5)}.sm\\:ikp-table__th--size_md{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-3);line-height:var(--ikp-line-heights-4);font-size:var(--ikp-font-sizes-xs)}.sm\\:ikp-table__caption--size_lg{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-2);font-size:var(--ikp-font-sizes-md)}.sm\\:ikp-table__td--size_lg{padding-inline:var(--ikp-spacing-8);padding-block:var(--ikp-spacing-5);line-height:var(--ikp-line-heights-6)}.sm\\:ikp-table__th--size_lg{padding-inline:var(--ikp-spacing-8);padding-block:var(--ikp-spacing-4);line-height:var(--ikp-line-heights-5);font-size:var(--ikp-font-sizes-sm)}.sm\\:ikp-tooltip__content--variant_default{font-weight:var(--ikp-font-weights-normal)}.light .sm\\:ikp-tooltip__content--variant_default,[data-theme=light] .sm\\:ikp-tooltip__content--variant_default{background:var(--ikp-colors-white);box-shadow:0 8px 30px #0000001f;color:var(--ikp-colors-gray-800);--tooltip-arrow-bg:white }.dark .sm\\:ikp-tooltip__content--variant_default,[data-theme=dark] .sm\\:ikp-tooltip__content--variant_default{background:var(--ikp-colors-gray-dark-800);color:var(--ikp-colors-white-alpha-800);--tooltip-arrow-bg:var(--ikp-colors-gray-dark-800) }.sm\\:ikp-search-bar-trigger__container--size_expand{height:100%!important}.sm\\:ikp-search-bar-trigger__wrapper--size_expand{width:100%;height:100%}}@media screen and (min-width: 33em){@media screen and (min-width: 48em){.sm\\:ikp-search-bar-trigger__wrapper--size_compact{width:min(340px,100%);height:min(40px,100%)}}}@media screen and (min-width: 33em){.sm\\:ikp-search-bar-trigger__container--size_shrink{padding-inline:var(--ikp-spacing-2)!important;height:var(--ikp-sizes-9)!important}@media screen and (min-width: 48em){.sm\\:ikp-search-bar-trigger__container--size_shrink{padding-inline:var(--ikp-spacing-3)!important}.sm\\:ikp-search-bar-trigger__wrapper--size_shrink{width:min(340px,100%);height:min(36px,100%)}}}@media screen and (min-width: 33em){.sm\\:ikp-search-bar-trigger__text--size_shrink{display:none}@media screen and (min-width: 33em){.sm\\:ikp-search-bar-trigger__text--size_shrink{display:inline-block}}}@media screen and (min-width: 33em){.sm\\:ikp-search-bar-trigger__kbd--size_shrink{display:none}@media screen and (min-width: 33em){.sm\\:ikp-search-bar-trigger__kbd--size_shrink{display:flex}}}@media screen and (min-width: 33em){.sm\\:ikp-search-bar-trigger__icon--size_shrink{width:var(--ikp-sizes-5)!important;margin-right:var(--ikp-spacing-0)!important}@media screen and (min-width: 33em){.sm\\:ikp-search-bar-trigger__icon--size_shrink{width:var(--ikp-sizes-5)!important;margin-right:var(--ikp-spacing-2)!important}}}@media screen and (min-width: 33em){.sm\\:ikp-search-bar-trigger__container--size_medium{height:100%!important}}@media screen and (min-width: 33em){@media screen and (min-width: 48em){.sm\\:ikp-search-bar-trigger__wrapper--size_medium{width:min(500px,100%);height:min(3rem,100%)}}}@media screen and (min-width: 33em){.light .sm\\:ikp-search-bar-trigger__container--variant_emphasized,[data-theme=light] .sm\\:ikp-search-bar-trigger__container--variant_emphasized{border-color:var(--ikp-colors-gray-100);box-shadow:var(--ikp-shadows-sm)}.light .sm\\:ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]),[data-theme=light] .sm\\:ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]){box-shadow:var(--ikp-shadows-md);background:none!important}.dark .sm\\:ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]),[data-theme=dark] .sm\\:ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]){background:none!important}}@media screen and (min-width: 33em){.sm\\:ikp-search-bar-trigger__container--variant_subtle{border-color:var(--ikp-colors-gray-300);color:var(--ikp-colors-gray-500)!important}.dark .sm\\:ikp-search-bar-trigger__container--variant_subtle,[data-theme=dark] .sm\\:ikp-search-bar-trigger__container--variant_subtle{color:var(--ikp-colors-white-alpha-500)!important;border-color:var(--ikp-colors-white-alpha-300)}.sm\\:ikp-search-bar-trigger__container--variant_subtle:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-400);background:none!important}.dark .sm\\:ikp-search-bar-trigger__container--variant_subtle:is(:hover,[data-hover]),[data-theme=dark] .sm\\:ikp-search-bar-trigger__container--variant_subtle:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}}@media screen and (min-width: 33em){.sm\\:ikp-search-bar-trigger__kbd--variant_subtle{border:var(--ikp-borders-none);padding-inline:var(--ikp-spacing-0);color:var(--ikp-colors-gray-500)}.dark .sm\\:ikp-search-bar-trigger__kbd--variant_subtle,[data-theme=dark] .sm\\:ikp-search-bar-trigger__kbd--variant_subtle{color:var(--ikp-colors-white-alpha-500)}.sm\\:ikp-search-bar-trigger__icon--variant_subtle{width:18px}}@media screen and (min-width: 48em){.ikp-search-bar-trigger__container--size_shrink{padding-inline:var(--ikp-spacing-3)!important}.md\\:ikp-alert__container--variant_subtle{--alert-fg:var(--ikp-colors-color-palette-500);--alert-bg:var(--ikp-colors-color-palette-100)}.dark .md\\:ikp-alert__container--variant_subtle,[data-theme=dark] .md\\:ikp-alert__container--variant_subtle{--alert-fg:var(--ikp-colors-color-palette-200) ;--alert-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--alert-bg:var(--alert-bg-alpha,var(--colors-color-palette-200)) }.md\\:ikp-alert__container--variant_left-accent{--alert-fg:var(--ikp-colors-color-palette-500);--alert-bg:var(--ikp-colors-color-palette-100);padding-inline-start:var(--ikp-spacing-3);border-inline-start-width:4px;border-inline-start-color:var(--alert-fg)}.dark .md\\:ikp-alert__container--variant_left-accent,[data-theme=dark] .md\\:ikp-alert__container--variant_left-accent{--alert-fg:var(--ikp-colors-color-palette-200) ;--alert-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) }.md\\:ikp-alert__container--variant_top-accent{--alert-fg:var(--ikp-colors-color-palette-500);--alert-bg:var(--ikp-colors-color-palette-100);padding-top:var(--ikp-spacing-2);border-top-width:4px;border-top-color:var(--alert-fg)}.dark .md\\:ikp-alert__container--variant_top-accent,[data-theme=dark] .md\\:ikp-alert__container--variant_top-accent{--alert-fg:var(--ikp-colors-color-palette-200) ;--alert-bg:var(--alert-bg-alpha,var(--colors-color-palette-200)) }.md\\:ikp-alert__container--variant_solid{--alert-fg:var(--ikp-colors-white);--alert-bg:var(--ikp-colors-color-palette-500);color:var(--alert-fg)}.dark .md\\:ikp-alert__container--variant_solid,[data-theme=dark] .md\\:ikp-alert__container--variant_solid{--alert-fg:var(--ikp-colors-gray-900) ;--alert-bg:var(--ikp-colors-color-palette-200) }.md\\:ikp-avatar__root--size_2xs{--avatar-size:var(--ikp-sizes-4);--avatar-font-size:var(--ikp-font-sizes-3xs)}.md\\:ikp-avatar__root--size_xs{--avatar-size:var(--ikp-sizes-6);--avatar-font-size:var(--ikp-font-sizes-2xs)}.md\\:ikp-avatar__root--size_sm{--avatar-size:var(--ikp-sizes-8);--avatar-font-size:var(--ikp-font-sizes-xs)}.md\\:ikp-avatar__root--size_md{--avatar-size:var(--ikp-sizes-12);--avatar-font-size:var(--ikp-font-sizes-md)}.md\\:ikp-avatar__root--size_lg{--avatar-size:var(--ikp-sizes-16);--avatar-font-size:var(--ikp-font-sizes-lg)}.md\\:ikp-avatar__root--size_xl{--avatar-size:var(--ikp-sizes-24);--avatar-font-size:var(--ikp-font-sizes-3xl)}.md\\:ikp-avatar__root--size_2xl{--avatar-size:var(--ikp-sizes-32);--avatar-font-size:var(--ikp-font-sizes-4xl)}.md\\:ikp-card__container--variant_elevated{--card-shadow:var(--ikp-shadows-base)}.dark .md\\:ikp-card__container--variant_elevated,[data-theme=dark] .md\\:ikp-card__container--variant_elevated{--card-bg:var(--ikp-colors-gray-700) }.md\\:ikp-card__container--variant_outline{--card-border-width:1px;--card-border-color:var(--ikp-colors-chakra-border-color)}.dark .md\\:ikp-card__container--variant_outline,[data-theme=dark] .md\\:ikp-card__container--variant_outline{--card-border-color:var(--ikp-colors-white-alpha-300) }.md\\:ikp-card__container--variant_filled{--card-bg:var(--ikp-colors-chakra-subtle-bg)}.md\\:ikp-card__body--variant_unstyled,.md\\:ikp-card__footer--variant_unstyled,.md\\:ikp-card__header--variant_unstyled{--card-padding:0}.md\\:ikp-card__container--size_sm{--card-radius:var(--ikp-radii-base);--card-padding:var(--ikp-space-3)}.md\\:ikp-card__container--size_md{--card-radius:var(--ikp-radii-md);--card-padding:var(--ikp-space-5)}.md\\:ikp-card__container--size_lg{--card-radius:var(--ikp-radii-xl);--card-padding:var(--ikp-space-7)}.md\\:ikp-checkbox__control--size_sm{--checkbox-size:var(--ikp-sizes-3)}.md\\:ikp-checkbox__label--size_sm{font-size:var(--ikp-font-sizes-sm)}.md\\:ikp-checkbox__icon--size_sm{font-size:var(--ikp-font-sizes-3xs)}.md\\:ikp-checkbox__control--size_md{--checkbox-size:var(--ikp-sizes-4)}.md\\:ikp-checkbox__label--size_md{font-size:var(--ikp-font-sizes-md)}.md\\:ikp-checkbox__icon--size_md{font-size:var(--ikp-font-sizes-2xs)}.md\\:ikp-checkbox__control--size_lg{--checkbox-size:var(--ikp-sizes-5)}.md\\:ikp-checkbox__label--size_lg{font-size:var(--ikp-font-sizes-lg)}.md\\:ikp-checkbox__icon--size_lg{font-size:var(--ikp-font-sizes-2xs)}.md\\:ikp-checkbox__control--shape_circular{border-radius:var(--ikp-radii-full)}}@media screen and (min-width: 48em){.md\\:ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){background:var(--ikp-colors-gray-900)}.dark .md\\:ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]),[data-theme=dark] .md\\:ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){background:var(--ikp-colors-white-alpha-900);border-color:var(--ikp-colors-white-alpha-900)}.md\\:ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){border-color:var(--ikp-colors-gray-900)}.md\\:ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){background:var(--ikp-colors-gray-900)}.dark .md\\:ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]),[data-theme=dark] .md\\:ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){background:var(--ikp-colors-white-alpha-900);border-color:var(--ikp-colors-white-alpha-900)}.md\\:ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){border-color:var(--ikp-colors-gray-900)}}@media screen and (min-width: 48em){.md\\:ikp-input__addon--size_lg,.md\\:ikp-input__field--size_lg,.md\\:ikp-input__group--size_lg{--input-font-size:var(--ikp-font-sizes-lg);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-12)}.md\\:ikp-input__addon--size_md,.md\\:ikp-input__field--size_md,.md\\:ikp-input__group--size_md{--input-font-size:var(--ikp-font-sizes-md);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-10)}.md\\:ikp-input__addon--size_sm,.md\\:ikp-input__field--size_sm,.md\\:ikp-input__group--size_sm{--input-font-size:var(--ikp-font-sizes-sm);--input-padding:var(--ikp-space-3);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-8)}.md\\:ikp-input__addon--size_xs,.md\\:ikp-input__field--size_xs,.md\\:ikp-input__group--size_xs{--input-font-size:var(--ikp-font-sizes-xs);--input-padding:var(--ikp-space-2);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-6)}.md\\:ikp-input__field--variant_outline{border:1px solid;border-color:inherit;background:inherit}}@media screen and (min-width: 48em){.md\\:ikp-input__field--variant_outline:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.md\\:ikp-input__field--variant_outline[aria-invalid=true],.md\\:ikp-input__field--variant_outline[data-invalid] .md\\:ikp-input__field--variant_outline{border-color:var(--input-error-border-color);box-shadow:0 0 0 1px var(--input-error-border-color)}.md\\:ikp-input__field--variant_outline:is(:focus-visible,[data-focus-visible]){z-index:1;border-color:var(--input-focus-border-color);box-shadow:0 0 0 1px var(--input-focus-border-color)}.md\\:ikp-input__field--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-300)}.dark .md\\:ikp-input__field--variant_outline:is(:hover,[data-hover]),[data-theme=dark] .md\\:ikp-input__field--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}}@media screen and (min-width: 48em){.md\\:ikp-input__addon--variant_outline{border:1px solid;border-color:inherit;background:var(--ikp-colors-gray-100)}.dark .md\\:ikp-input__addon--variant_outline,[data-theme=dark] .md\\:ikp-input__addon--variant_outline{border-color:var(--ikp-colors-white-alpha-50);background:var(--ikp-colors-white-alpha-300)}.md\\:ikp-input__field--variant_filled{border:2px solid;border-color:var(--ikp-colors-transparent);background:var(--ikp-colors-gray-100)}.dark .md\\:ikp-input__field--variant_filled,[data-theme=dark] .md\\:ikp-input__field--variant_filled{background:var(--ikp-colors-white-alpha-50)}}@media screen and (min-width: 48em){.md\\:ikp-input__field--variant_filled:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.md\\:ikp-input__field--variant_filled[aria-invalid=true],.md\\:ikp-input__field--variant_filled[data-invalid] .md\\:ikp-input__field--variant_filled{border-color:var(--input-error-border-color)}.md\\:ikp-input__field--variant_filled:is(:focus-visible,[data-focus-visible]){background:var(--ikp-colors-transparent);border-color:var(--input-focus-border-color)}.md\\:ikp-input__field--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-gray-200)}.dark .md\\:ikp-input__field--variant_filled:is(:hover,[data-hover]),[data-theme=dark] .md\\:ikp-input__field--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-100)}}@media screen and (min-width: 48em){.md\\:ikp-input__addon--variant_filled{border:2px solid;border-color:var(--ikp-colors-transparent);background:var(--ikp-colors-gray-100)}.dark .md\\:ikp-input__addon--variant_filled,[data-theme=dark] .md\\:ikp-input__addon--variant_filled{background:var(--ikp-colors-white-alpha-50)}.md\\:ikp-input__field--variant_flushed{border-bottom:1px solid;border-color:inherit;border-radius:0;padding-inline:var(--ikp-spacing-0);background:var(--ikp-colors-transparent)}}@media screen and (min-width: 48em){.md\\:ikp-input__field--variant_flushed:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.md\\:ikp-input__field--variant_flushed[aria-invalid=true],.md\\:ikp-input__field--variant_flushed[data-invalid] .md\\:ikp-input__field--variant_flushed{border-color:var(--input-error-border-color);box-shadow:0 1px 0 0 var(--input-error-border-color)}.md\\:ikp-input__field--variant_flushed:is(:focus-visible,[data-focus-visible]){border-color:var(--input-focus-border-color);box-shadow:0 1px 0 0 var(--input-focus-border-color)}}@media screen and (min-width: 48em){.md\\:ikp-input__addon--variant_flushed{border-bottom:2px solid;border-color:inherit;border-radius:0;padding-inline:var(--ikp-spacing-0);background:var(--ikp-colors-transparent)}.md\\:ikp-input__addon--variant_unstyled,.md\\:ikp-input__field--variant_unstyled{background:var(--ikp-colors-transparent);padding-inline:var(--ikp-spacing-0);height:var(--ikp-sizes-auto)}.md\\:ikp-modal__content--size_xs{max-width:var(--ikp-sizes-xs)}.md\\:ikp-modal__content--size_sm{max-width:var(--ikp-sizes-sm)}.md\\:ikp-modal__content--size_md{max-width:var(--ikp-sizes-md)}.md\\:ikp-modal__content--size_lg{max-width:var(--ikp-sizes-lg)}.md\\:ikp-modal__content--size_xl{max-width:var(--ikp-sizes-xl)}.md\\:ikp-modal__content--size_2xl{max-width:var(--ikp-sizes-2xl)}.md\\:ikp-modal__content--size_3xl{max-width:var(--ikp-sizes-3xl)}.md\\:ikp-modal__content--size_4xl{max-width:var(--ikp-sizes-4xl)}.md\\:ikp-modal__content--size_5xl{max-width:var(--ikp-sizes-5xl)}.md\\:ikp-modal__content--size_6xl{max-width:var(--ikp-sizes-6xl)}.md\\:ikp-modal__content--size_full{max-width:100vw;min-height:100vh;margin-block:var(--ikp-spacing-0);border-radius:0}.md\\:ikp-modal__container--scrollOverflowBehavior_inside{overflow:hidden}.md\\:ikp-modal__content--scrollOverflowBehavior_inside{max-height:calc(100% - 7.5rem)}.md\\:ikp-modal__container--scrollOverflowBehavior_outside{overflow:auto}.md\\:ikp-modal__container--isCentered_false{align-items:flex-start}.md\\:ikp-modal__content--isCentered_false{margin-block:var(--ikp-spacing-16)}.md\\:ikp-modal__container--isCentered_true{align-items:center}.md\\:ikp-modal__content--isCentered_true{margin-block:auto;margin-inline:auto}.md\\:ikp-modal__container--variant_clickThrough{pointer-events:none;z-index:var(--ikp-z-index-modal) - 1}.md\\:ikp-modal__content--variant_clickThrough{pointer-events:auto}.md\\:ikp-select__label--size_sm{font-size:.875rem;line-height:1.25rem}.md\\:ikp-select__trigger--size_sm{padding-inline:var(--ikp-spacing-2\\.5);height:var(--ikp-sizes-9);min-width:var(--ikp-sizes-9);font-size:var(--ikp-font-sizes-sm);gap:var(--ikp-spacing-2)}}@media screen and (min-width: 48em){.md\\:ikp-select__trigger--size_sm :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}}@media screen and (min-width: 48em){.md\\:ikp-select__item--size_sm{font-size:.875rem;line-height:1.25rem;padding-inline:var(--ikp-spacing-2);height:var(--ikp-sizes-9)}}@media screen and (min-width: 48em){.md\\:ikp-select__itemIndicator--size_sm :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}}@media screen and (min-width: 48em){.md\\:ikp-select__itemGroupLabel--size_sm{padding-inline:var(--ikp-spacing-2);padding-block:var(--ikp-spacing-1\\.5)}.md\\:ikp-select__content--size_sm{padding:var(--ikp-spacing-0\\.5);gap:var(--ikp-spacing-1)}.md\\:ikp-select__label--size_md{font-size:.875rem;line-height:1.25rem}.md\\:ikp-select__trigger--size_md{padding-inline:var(--ikp-spacing-3);height:var(--ikp-sizes-10);min-width:var(--ikp-sizes-10);font-size:var(--ikp-font-sizes-md);gap:var(--ikp-spacing-2)}}@media screen and (min-width: 48em){.md\\:ikp-select__trigger--size_md :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}}@media screen and (min-width: 48em){.md\\:ikp-select__item--size_md{font-size:1rem;line-height:1.5rem;padding-inline:var(--ikp-spacing-2);height:var(--ikp-sizes-10)}}@media screen and (min-width: 48em){.md\\:ikp-select__itemIndicator--size_md :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}}@media screen and (min-width: 48em){.md\\:ikp-select__itemGroupLabel--size_md{padding-inline:var(--ikp-spacing-2);padding-block:var(--ikp-spacing-1\\.5)}.md\\:ikp-select__content--size_md{padding:var(--ikp-spacing-1);gap:var(--ikp-spacing-1)}.md\\:ikp-select__label--size_lg{font-size:.875rem;line-height:1.25rem}.md\\:ikp-select__trigger--size_lg{padding-inline:var(--ikp-spacing-3\\.5);height:var(--ikp-sizes-11);min-width:var(--ikp-sizes-11);font-size:var(--ikp-font-sizes-md);gap:var(--ikp-spacing-2)}}@media screen and (min-width: 48em){.md\\:ikp-select__trigger--size_lg :where(svg){width:var(--ikp-sizes-5);height:var(--ikp-sizes-5)}}@media screen and (min-width: 48em){.md\\:ikp-select__item--size_lg{font-size:1rem;line-height:1.5rem;padding-inline:var(--ikp-spacing-2);height:var(--ikp-sizes-11)}}@media screen and (min-width: 48em){.md\\:ikp-select__itemIndicator--size_lg :where(svg){width:var(--ikp-sizes-5);height:var(--ikp-sizes-5)}}@media screen and (min-width: 48em){.md\\:ikp-select__itemGroupLabel--size_lg{padding-inline:var(--ikp-spacing-2);padding-block:var(--ikp-spacing-1\\.5)}.md\\:ikp-select__content--size_lg{padding:var(--ikp-spacing-1\\.5);gap:var(--ikp-spacing-1)}.md\\:ikp-select__trigger--variant_outline{background:var(--ikp-colors-white);border-width:1px}.dark .md\\:ikp-select__trigger--variant_outline,[data-theme=dark] .md\\:ikp-select__trigger--variant_outline{background:var(--ikp-colors-color-palette-800)}}@media screen and (min-width: 48em){.md\\:ikp-select__trigger--variant_outline:is(:focus,[data-focus]){border-color:var(--ikp-colors-color-palette-200)}.dark .md\\:ikp-select__trigger--variant_outline:is(:focus,[data-focus]),[data-theme=dark] .md\\:ikp-select__trigger--variant_outline:is(:focus,[data-focus]){border-color:var(--ikp-colors-color-palette-800)}.md\\:ikp-select__trigger--variant_outline:is(:focus,[data-focus]){box-shadow:var(--ikp-shadows-accent)}}@media screen and (min-width: 48em){.md\\:ikp-select__trigger--variant_ghost:is(:focus,[data-focus]){background:var(--ikp-colors-color-palette-100)}.dark .md\\:ikp-select__trigger--variant_ghost:is(:focus,[data-focus]),[data-theme=dark] .md\\:ikp-select__trigger--variant_ghost:is(:focus,[data-focus]){background:var(--ikp-colors-color-palette-900)}.md\\:ikp-select__trigger--variant_ghost:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-100)}.dark .md\\:ikp-select__trigger--variant_ghost:is(:hover,[data-hover]),[data-theme=dark] .md\\:ikp-select__trigger--variant_ghost:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-900)}}@media screen and (min-width: 48em){.md\\:ikp-select__trigger--variant_ikpOutline{background:var(--ikp-colors-white);border-width:1px}.dark .md\\:ikp-select__trigger--variant_ikpOutline,[data-theme=dark] .md\\:ikp-select__trigger--variant_ikpOutline{background:var(--ikp-colors-color-palette-900)}.md\\:ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]){border-color:var(--ikp-colors-color-palette-200)}.dark .md\\:ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]),[data-theme=dark] .md\\:ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]){border-color:var(--ikp-colors-white-alpha-300)}.md\\:ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]){box-shadow:var(--ikp-shadows-accent)}.md\\:ikp-select__trigger--variant_ikpOutline:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-300)}.dark .md\\:ikp-select__trigger--variant_ikpOutline:is(:hover,[data-hover]),[data-theme=dark] .md\\:ikp-select__trigger--variant_ikpOutline:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}}@media screen and (min-width: 48em){.md\\:ikp-switch__root--size_sm{--switch-track-width:1.375rem;--switch-track-height:var(--ikp-sizes-3)}.md\\:ikp-switch__root--size_md{--switch-track-width:1.875rem;--switch-track-height:var(--ikp-sizes-4)}.md\\:ikp-switch__root--size_lg{--switch-track-width:2.875rem;--switch-track-height:var(--ikp-sizes-6)}.md\\:ikp-switch__control--size_xss{width:24px;height:12px}.md\\:ikp-switch__thumb--size_xss{width:12px;height:12px}.md\\:ikp-tabs__trigger--size_sm{padding-block:var(--ikp-spacing-1);padding-inline:var(--ikp-spacing-4);font-size:var(--ikp-font-sizes-sm)}.md\\:ikp-tabs__trigger--size_md{font-size:var(--ikp-font-sizes-md);padding-block:var(--ikp-spacing-2);padding-inline:var(--ikp-spacing-4)}.md\\:ikp-tabs__trigger--size_lg{font-size:var(--ikp-font-sizes-lg);padding-block:var(--ikp-spacing-3);padding-inline:var(--ikp-spacing-4)}.md\\:ikp-tabs__list--variant_line{--tabs-border-color:2px solid;border-color:inherit}.md\\:ikp-tabs__trigger--variant_line{--tabs-border-color:2px solid;border-color:var(--ikp-colors-transparent);--tabs-margin-prop:-2px;color:var(--tabs-color);background:var(--tabs-bg)}}@media screen and (min-width: 48em){.md\\:ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-600) }.dark .md\\:ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]),[data-theme=dark] .md\\:ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-300) }.md\\:ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]){border-color:currentColor}.md\\:ikp-tabs__trigger--variant_line:is(:active,[data-active]){--tabs-bg:var(--ikp-colors-gray-200) }.dark .md\\:ikp-tabs__trigger--variant_line:is(:active,[data-active]),[data-theme=dark] .md\\:ikp-tabs__trigger--variant_line:is(:active,[data-active]){--tabs-bg:var(--ikp-colors-white-alpha-300) }.md\\:ikp-tabs__trigger--variant_line:is(:disabled,[disabled],[data-disabled]):is(:active,[data-active]){background:none}}@media screen and (min-width: 48em){.md\\:ikp-tabs__list--variant_enclosed{margin-bottom:-1px;border-bottom:1px solid;border-color:inherit}.md\\:ikp-tabs__trigger--variant_enclosed{border-top-left-radius:var(--ikp-radii-md);border-top-right-radius:var(--ikp-radii-md);border:1px solid;border-color:var(--ikp-colors-transparent);margin-bottom:-1px;--tabs-border-color:transparent;color:var(--tabs-color)}}@media screen and (min-width: 48em){.md\\:ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-600) ;--tabs-border-color:var(--ikp-colors-white) }.dark .md\\:ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]),[data-theme=dark] .md\\:ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-300) ;--tabs-border-color:var(--ikp-colors-gray-800) }.md\\:ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]){border-color:inherit;border-bottom-color:var(--tabs-border-color)}}@media screen and (min-width: 48em){.md\\:ikp-tabs__list--variant_enclosed-colored{margin-bottom:-1px;border-bottom:1px solid;border-color:inherit}.md\\:ikp-tabs__trigger--variant_enclosed-colored{border:1px solid;border-color:inherit;--tabs-bg:var(--ikp-colors-gray-50);margin-bottom:-1px;color:var(--tabs-color);background:var(--tabs-bg)}.dark .md\\:ikp-tabs__trigger--variant_enclosed-colored,[data-theme=dark] .md\\:ikp-tabs__trigger--variant_enclosed-colored{--tabs-bg:var(--ikp-colors-white-alpha-50) }}@media screen and (min-width: 48em){.md\\:ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]){--tabs-bg:var(--ikp-colors-white) ;--tabs-color:var(--ikp-colors-color-palette-600) }.dark .md\\:ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]),[data-theme=dark] .md\\:ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]){--tabs-bg:var(--ikp-colors-gray-800) ;--tabs-color:var(--ikp-colors-color-palette-300) }.md\\:ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]){border-color:inherit;border-top-color:currentColor;border-bottom-color:var(--ikp-colors-transparent)}.md\\:ikp-tabs__trigger--variant_enclosed-colored _notLast{margin-inline-end:-1px}.md\\:ikp-tabs__trigger--variant_soft-rounded{border-radius:var(--ikp-radii-full);font-weight:var(--ikp-font-weights-semibold);color:var(--ikp-colors-gray-600)}}@media screen and (min-width: 48em){.md\\:ikp-tabs__trigger--variant_soft-rounded:is([aria-selected=true],[data-selected]){color:var(--ikp-colors-color-palette-700);background:var(--ikp-colors-color-palette-100)}}@media screen and (min-width: 48em){.md\\:ikp-tabs__trigger--variant_solid-rounded{border-radius:var(--ikp-radii-full);font-weight:var(--ikp-font-weights-semibold);--tabs-color:var(--ikp-colors-gray-600);color:var(--tabs-color);background:var(--tabs-bg)}.dark .md\\:ikp-tabs__trigger--variant_solid-rounded,[data-theme=dark] .md\\:ikp-tabs__trigger--variant_solid-rounded{--tabs-color:inherit }.md\\:ikp-tabs__trigger--variant_solid-rounded:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-white) ;--tabs-bg:var(--ikp-colors-color-palette-600) }.dark .md\\:ikp-tabs__trigger--variant_solid-rounded:is([aria-selected=true],[data-selected]),[data-theme=dark] .md\\:ikp-tabs__trigger--variant_solid-rounded:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-gray-800) ;--tabs-bg:var(--ikp-colors-color-palette-300) }}@media screen and (min-width: 48em){.md\\:ikp-tabs__trigger--isFitted_true{flex:1 1 0%}.md\\:ikp-table__caption--variant_simple{color:var(--ikp-colors-gray-600)}.dark .md\\:ikp-table__caption--variant_simple,[data-theme=dark] .md\\:ikp-table__caption--variant_simple{color:var(--ikp-colors-gray-100)}.md\\:ikp-table__td--variant_simple{border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .md\\:ikp-table__td--variant_simple,[data-theme=dark] .md\\:ikp-table__td--variant_simple{border-color:var(--ikp-colors-color-palette-700)}.md\\:ikp-table__td--variant_simple[data-is-numeric=true]{text-align:end}.md\\:ikp-table__th--variant_simple{color:var(--ikp-colors-gray-600);border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .md\\:ikp-table__th--variant_simple,[data-theme=dark] .md\\:ikp-table__th--variant_simple{color:var(--ikp-colors-gray-400);border-color:var(--ikp-colors-color-palette-700)}.md\\:ikp-table__th--variant_simple[data-is-numeric=true]{text-align:end}.md\\:ikp-table__tr--variant_tfoot th:last-of-type{border-bottom-width:0}.md\\:ikp-table__caption--variant_striped{color:var(--ikp-colors-gray-600)}.dark .md\\:ikp-table__caption--variant_striped,[data-theme=dark] .md\\:ikp-table__caption--variant_striped{color:var(--ikp-colors-gray-100)}.md\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,.md\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) th{border-bottom-width:1px;border-color:var(--ikp-colors-color-palette-100)}.dark .md\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,.dark .md\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) th,[data-theme=dark] .md\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,[data-theme=dark] .md\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) th{border-color:var(--ikp-colors-color-palette-700)}.md\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td{background:var(--ikp-colors-color-palette-100)}.dark .md\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,[data-theme=dark] .md\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td{background:var(--ikp-colors-color-palette-700)}.md\\:ikp-table__td--variant_striped{border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .md\\:ikp-table__td--variant_striped,[data-theme=dark] .md\\:ikp-table__td--variant_striped{border-color:var(--ikp-colors-color-palette-700)}.md\\:ikp-table__td--variant_striped[data-is-numeric=true]{text-align:end}.md\\:ikp-table__tfoot--variant_striped th tr:last-of-type{border-bottom-width:0}.md\\:ikp-table__th--variant_striped{color:var(--ikp-colors-gray-600);border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .md\\:ikp-table__th--variant_striped,[data-theme=dark] .md\\:ikp-table__th--variant_striped{color:var(--ikp-colors-gray-400);border-color:var(--ikp-colors-color-palette-700)}.md\\:ikp-table__th--variant_striped[data-is-numeric=true]{text-align:end}.md\\:ikp-table__caption--size_sm{font-size:var(--ikp-font-sizes-xs)}.md\\:ikp-table__caption--size_sm,.md\\:ikp-table__td--size_sm{padding-inline:var(--ikp-spacing-4);padding-block:var(--ikp-spacing-2)}.md\\:ikp-table__td--size_sm{font-size:var(--ikp-font-sizes-sm);line-height:var(--ikp-line-heights-4)}.md\\:ikp-table__th--size_sm{padding-inline:var(--ikp-spacing-4);padding-block:var(--ikp-spacing-1);line-height:var(--ikp-line-heights-4);font-size:var(--ikp-font-sizes-xs)}.md\\:ikp-table__caption--size_md{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-2);font-size:var(--ikp-font-sizes-sm)}.md\\:ikp-table__td--size_md{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-4);line-height:var(--ikp-line-heights-5)}.md\\:ikp-table__th--size_md{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-3);line-height:var(--ikp-line-heights-4);font-size:var(--ikp-font-sizes-xs)}.md\\:ikp-table__caption--size_lg{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-2);font-size:var(--ikp-font-sizes-md)}.md\\:ikp-table__td--size_lg{padding-inline:var(--ikp-spacing-8);padding-block:var(--ikp-spacing-5);line-height:var(--ikp-line-heights-6)}.md\\:ikp-table__th--size_lg{padding-inline:var(--ikp-spacing-8);padding-block:var(--ikp-spacing-4);line-height:var(--ikp-line-heights-5);font-size:var(--ikp-font-sizes-sm)}.md\\:ikp-tooltip__content--variant_default{font-weight:var(--ikp-font-weights-normal)}.light .md\\:ikp-tooltip__content--variant_default,[data-theme=light] .md\\:ikp-tooltip__content--variant_default{background:var(--ikp-colors-white);box-shadow:0 8px 30px #0000001f;color:var(--ikp-colors-gray-800);--tooltip-arrow-bg:white }.dark .md\\:ikp-tooltip__content--variant_default,[data-theme=dark] .md\\:ikp-tooltip__content--variant_default{background:var(--ikp-colors-gray-dark-800);color:var(--ikp-colors-white-alpha-800);--tooltip-arrow-bg:var(--ikp-colors-gray-dark-800) }.md\\:ikp-search-bar-trigger__container--size_expand{height:100%!important}.md\\:ikp-search-bar-trigger__wrapper--size_expand{width:100%;height:100%}}@media screen and (min-width: 48em){@media screen and (min-width: 48em){.md\\:ikp-search-bar-trigger__wrapper--size_compact{width:min(340px,100%);height:min(40px,100%)}}}@media screen and (min-width: 48em){.md\\:ikp-search-bar-trigger__container--size_shrink{padding-inline:var(--ikp-spacing-2)!important;height:var(--ikp-sizes-9)!important}@media screen and (min-width: 48em){.md\\:ikp-search-bar-trigger__container--size_shrink{padding-inline:var(--ikp-spacing-3)!important}}}@media screen and (min-width: 48em){.ikp-search-bar-trigger__wrapper--size_shrink{width:min(340px,100%);height:min(36px,100%)}}@media screen and (min-width: 48em){@media screen and (min-width: 48em){.md\\:ikp-search-bar-trigger__wrapper--size_shrink{width:min(340px,100%);height:min(36px,100%)}}}@media screen and (min-width: 48em){.md\\:ikp-search-bar-trigger__text--size_shrink{display:none}@media screen and (min-width: 33em){.md\\:ikp-search-bar-trigger__text--size_shrink{display:inline-block}}}@media screen and (min-width: 48em){.md\\:ikp-search-bar-trigger__kbd--size_shrink{display:none}@media screen and (min-width: 33em){.md\\:ikp-search-bar-trigger__kbd--size_shrink{display:flex}}}@media screen and (min-width: 48em){.md\\:ikp-search-bar-trigger__icon--size_shrink{width:var(--ikp-sizes-5)!important;margin-right:var(--ikp-spacing-0)!important}@media screen and (min-width: 33em){.md\\:ikp-search-bar-trigger__icon--size_shrink{width:var(--ikp-sizes-5)!important;margin-right:var(--ikp-spacing-2)!important}}}@media screen and (min-width: 48em){.md\\:ikp-search-bar-trigger__container--size_medium{height:100%!important}.ikp-search-bar-trigger__wrapper--size_medium{width:min(500px,100%);height:min(3rem,100%)}}@media screen and (min-width: 48em){@media screen and (min-width: 48em){.md\\:ikp-search-bar-trigger__wrapper--size_medium{width:min(500px,100%);height:min(3rem,100%)}}}@media screen and (min-width: 48em){.light .md\\:ikp-search-bar-trigger__container--variant_emphasized,[data-theme=light] .md\\:ikp-search-bar-trigger__container--variant_emphasized{border-color:var(--ikp-colors-gray-100);box-shadow:var(--ikp-shadows-sm)}.light .md\\:ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]),[data-theme=light] .md\\:ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]){box-shadow:var(--ikp-shadows-md);background:none!important}.dark .md\\:ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]),[data-theme=dark] .md\\:ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]){background:none!important}}@media screen and (min-width: 48em){.md\\:ikp-search-bar-trigger__container--variant_subtle{border-color:var(--ikp-colors-gray-300);color:var(--ikp-colors-gray-500)!important}.dark .md\\:ikp-search-bar-trigger__container--variant_subtle,[data-theme=dark] .md\\:ikp-search-bar-trigger__container--variant_subtle{color:var(--ikp-colors-white-alpha-500)!important;border-color:var(--ikp-colors-white-alpha-300)}.md\\:ikp-search-bar-trigger__container--variant_subtle:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-400);background:none!important}.dark .md\\:ikp-search-bar-trigger__container--variant_subtle:is(:hover,[data-hover]),[data-theme=dark] .md\\:ikp-search-bar-trigger__container--variant_subtle:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}}@media screen and (min-width: 48em){.md\\:ikp-search-bar-trigger__kbd--variant_subtle{border:var(--ikp-borders-none);padding-inline:var(--ikp-spacing-0);color:var(--ikp-colors-gray-500)}.dark .md\\:ikp-search-bar-trigger__kbd--variant_subtle,[data-theme=dark] .md\\:ikp-search-bar-trigger__kbd--variant_subtle{color:var(--ikp-colors-white-alpha-500)}.md\\:ikp-search-bar-trigger__icon--variant_subtle{width:18px}.ikp-search-bar-trigger__wrapper--size_compact{width:min(340px,100%);height:min(40px,100%)}}@media screen and (min-width: 64em){.lg\\:ikp-alert__container--variant_subtle{--alert-fg:var(--ikp-colors-color-palette-500);--alert-bg:var(--ikp-colors-color-palette-100)}.dark .lg\\:ikp-alert__container--variant_subtle,[data-theme=dark] .lg\\:ikp-alert__container--variant_subtle{--alert-fg:var(--ikp-colors-color-palette-200) ;--alert-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--alert-bg:var(--alert-bg-alpha,var(--colors-color-palette-200)) }.lg\\:ikp-alert__container--variant_left-accent{--alert-fg:var(--ikp-colors-color-palette-500);--alert-bg:var(--ikp-colors-color-palette-100);padding-inline-start:var(--ikp-spacing-3);border-inline-start-width:4px;border-inline-start-color:var(--alert-fg)}.dark .lg\\:ikp-alert__container--variant_left-accent,[data-theme=dark] .lg\\:ikp-alert__container--variant_left-accent{--alert-fg:var(--ikp-colors-color-palette-200) ;--alert-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) }.lg\\:ikp-alert__container--variant_top-accent{--alert-fg:var(--ikp-colors-color-palette-500);--alert-bg:var(--ikp-colors-color-palette-100);padding-top:var(--ikp-spacing-2);border-top-width:4px;border-top-color:var(--alert-fg)}.dark .lg\\:ikp-alert__container--variant_top-accent,[data-theme=dark] .lg\\:ikp-alert__container--variant_top-accent{--alert-fg:var(--ikp-colors-color-palette-200) ;--alert-bg:var(--alert-bg-alpha,var(--colors-color-palette-200)) }.lg\\:ikp-alert__container--variant_solid{--alert-fg:var(--ikp-colors-white);--alert-bg:var(--ikp-colors-color-palette-500);color:var(--alert-fg)}.dark .lg\\:ikp-alert__container--variant_solid,[data-theme=dark] .lg\\:ikp-alert__container--variant_solid{--alert-fg:var(--ikp-colors-gray-900) ;--alert-bg:var(--ikp-colors-color-palette-200) }.lg\\:ikp-avatar__root--size_2xs{--avatar-size:var(--ikp-sizes-4);--avatar-font-size:var(--ikp-font-sizes-3xs)}.lg\\:ikp-avatar__root--size_xs{--avatar-size:var(--ikp-sizes-6);--avatar-font-size:var(--ikp-font-sizes-2xs)}.lg\\:ikp-avatar__root--size_sm{--avatar-size:var(--ikp-sizes-8);--avatar-font-size:var(--ikp-font-sizes-xs)}.lg\\:ikp-avatar__root--size_md{--avatar-size:var(--ikp-sizes-12);--avatar-font-size:var(--ikp-font-sizes-md)}.lg\\:ikp-avatar__root--size_lg{--avatar-size:var(--ikp-sizes-16);--avatar-font-size:var(--ikp-font-sizes-lg)}.lg\\:ikp-avatar__root--size_xl{--avatar-size:var(--ikp-sizes-24);--avatar-font-size:var(--ikp-font-sizes-3xl)}.lg\\:ikp-avatar__root--size_2xl{--avatar-size:var(--ikp-sizes-32);--avatar-font-size:var(--ikp-font-sizes-4xl)}.lg\\:ikp-card__container--variant_elevated{--card-shadow:var(--ikp-shadows-base)}.dark .lg\\:ikp-card__container--variant_elevated,[data-theme=dark] .lg\\:ikp-card__container--variant_elevated{--card-bg:var(--ikp-colors-gray-700) }.lg\\:ikp-card__container--variant_outline{--card-border-width:1px;--card-border-color:var(--ikp-colors-chakra-border-color)}.dark .lg\\:ikp-card__container--variant_outline,[data-theme=dark] .lg\\:ikp-card__container--variant_outline{--card-border-color:var(--ikp-colors-white-alpha-300) }.lg\\:ikp-card__container--variant_filled{--card-bg:var(--ikp-colors-chakra-subtle-bg)}.lg\\:ikp-card__body--variant_unstyled,.lg\\:ikp-card__footer--variant_unstyled,.lg\\:ikp-card__header--variant_unstyled{--card-padding:0}.lg\\:ikp-card__container--size_sm{--card-radius:var(--ikp-radii-base);--card-padding:var(--ikp-space-3)}.lg\\:ikp-card__container--size_md{--card-radius:var(--ikp-radii-md);--card-padding:var(--ikp-space-5)}.lg\\:ikp-card__container--size_lg{--card-radius:var(--ikp-radii-xl);--card-padding:var(--ikp-space-7)}.lg\\:ikp-checkbox__control--size_sm{--checkbox-size:var(--ikp-sizes-3)}.lg\\:ikp-checkbox__label--size_sm{font-size:var(--ikp-font-sizes-sm)}.lg\\:ikp-checkbox__icon--size_sm{font-size:var(--ikp-font-sizes-3xs)}.lg\\:ikp-checkbox__control--size_md{--checkbox-size:var(--ikp-sizes-4)}.lg\\:ikp-checkbox__label--size_md{font-size:var(--ikp-font-sizes-md)}.lg\\:ikp-checkbox__icon--size_md{font-size:var(--ikp-font-sizes-2xs)}.lg\\:ikp-checkbox__control--size_lg{--checkbox-size:var(--ikp-sizes-5)}.lg\\:ikp-checkbox__label--size_lg{font-size:var(--ikp-font-sizes-lg)}.lg\\:ikp-checkbox__icon--size_lg{font-size:var(--ikp-font-sizes-2xs)}.lg\\:ikp-checkbox__control--shape_circular{border-radius:var(--ikp-radii-full)}}@media screen and (min-width: 64em){.lg\\:ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){background:var(--ikp-colors-gray-900)}.dark .lg\\:ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]),[data-theme=dark] .lg\\:ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){background:var(--ikp-colors-white-alpha-900);border-color:var(--ikp-colors-white-alpha-900)}.lg\\:ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){border-color:var(--ikp-colors-gray-900)}.lg\\:ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){background:var(--ikp-colors-gray-900)}.dark .lg\\:ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]),[data-theme=dark] .lg\\:ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){background:var(--ikp-colors-white-alpha-900);border-color:var(--ikp-colors-white-alpha-900)}.lg\\:ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){border-color:var(--ikp-colors-gray-900)}}@media screen and (min-width: 64em){.lg\\:ikp-input__addon--size_lg,.lg\\:ikp-input__field--size_lg,.lg\\:ikp-input__group--size_lg{--input-font-size:var(--ikp-font-sizes-lg);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-12)}.lg\\:ikp-input__addon--size_md,.lg\\:ikp-input__field--size_md,.lg\\:ikp-input__group--size_md{--input-font-size:var(--ikp-font-sizes-md);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-10)}.lg\\:ikp-input__addon--size_sm,.lg\\:ikp-input__field--size_sm,.lg\\:ikp-input__group--size_sm{--input-font-size:var(--ikp-font-sizes-sm);--input-padding:var(--ikp-space-3);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-8)}.lg\\:ikp-input__addon--size_xs,.lg\\:ikp-input__field--size_xs,.lg\\:ikp-input__group--size_xs{--input-font-size:var(--ikp-font-sizes-xs);--input-padding:var(--ikp-space-2);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-6)}.lg\\:ikp-input__field--variant_outline{border:1px solid;border-color:inherit;background:inherit}}@media screen and (min-width: 64em){.lg\\:ikp-input__field--variant_outline:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.lg\\:ikp-input__field--variant_outline[aria-invalid=true],.lg\\:ikp-input__field--variant_outline[data-invalid] .lg\\:ikp-input__field--variant_outline{border-color:var(--input-error-border-color);box-shadow:0 0 0 1px var(--input-error-border-color)}.lg\\:ikp-input__field--variant_outline:is(:focus-visible,[data-focus-visible]){z-index:1;border-color:var(--input-focus-border-color);box-shadow:0 0 0 1px var(--input-focus-border-color)}.lg\\:ikp-input__field--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-300)}.dark .lg\\:ikp-input__field--variant_outline:is(:hover,[data-hover]),[data-theme=dark] .lg\\:ikp-input__field--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}}@media screen and (min-width: 64em){.lg\\:ikp-input__addon--variant_outline{border:1px solid;border-color:inherit;background:var(--ikp-colors-gray-100)}.dark .lg\\:ikp-input__addon--variant_outline,[data-theme=dark] .lg\\:ikp-input__addon--variant_outline{border-color:var(--ikp-colors-white-alpha-50);background:var(--ikp-colors-white-alpha-300)}.lg\\:ikp-input__field--variant_filled{border:2px solid;border-color:var(--ikp-colors-transparent);background:var(--ikp-colors-gray-100)}.dark .lg\\:ikp-input__field--variant_filled,[data-theme=dark] .lg\\:ikp-input__field--variant_filled{background:var(--ikp-colors-white-alpha-50)}}@media screen and (min-width: 64em){.lg\\:ikp-input__field--variant_filled:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.lg\\:ikp-input__field--variant_filled[aria-invalid=true],.lg\\:ikp-input__field--variant_filled[data-invalid] .lg\\:ikp-input__field--variant_filled{border-color:var(--input-error-border-color)}.lg\\:ikp-input__field--variant_filled:is(:focus-visible,[data-focus-visible]){background:var(--ikp-colors-transparent);border-color:var(--input-focus-border-color)}.lg\\:ikp-input__field--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-gray-200)}.dark .lg\\:ikp-input__field--variant_filled:is(:hover,[data-hover]),[data-theme=dark] .lg\\:ikp-input__field--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-100)}}@media screen and (min-width: 64em){.lg\\:ikp-input__addon--variant_filled{border:2px solid;border-color:var(--ikp-colors-transparent);background:var(--ikp-colors-gray-100)}.dark .lg\\:ikp-input__addon--variant_filled,[data-theme=dark] .lg\\:ikp-input__addon--variant_filled{background:var(--ikp-colors-white-alpha-50)}.lg\\:ikp-input__field--variant_flushed{border-bottom:1px solid;border-color:inherit;border-radius:0;padding-inline:var(--ikp-spacing-0);background:var(--ikp-colors-transparent)}}@media screen and (min-width: 64em){.lg\\:ikp-input__field--variant_flushed:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.lg\\:ikp-input__field--variant_flushed[aria-invalid=true],.lg\\:ikp-input__field--variant_flushed[data-invalid] .lg\\:ikp-input__field--variant_flushed{border-color:var(--input-error-border-color);box-shadow:0 1px 0 0 var(--input-error-border-color)}.lg\\:ikp-input__field--variant_flushed:is(:focus-visible,[data-focus-visible]){border-color:var(--input-focus-border-color);box-shadow:0 1px 0 0 var(--input-focus-border-color)}}@media screen and (min-width: 64em){.lg\\:ikp-input__addon--variant_flushed{border-bottom:2px solid;border-color:inherit;border-radius:0;padding-inline:var(--ikp-spacing-0);background:var(--ikp-colors-transparent)}.lg\\:ikp-input__addon--variant_unstyled,.lg\\:ikp-input__field--variant_unstyled{background:var(--ikp-colors-transparent);padding-inline:var(--ikp-spacing-0);height:var(--ikp-sizes-auto)}.lg\\:ikp-modal__content--size_xs{max-width:var(--ikp-sizes-xs)}.lg\\:ikp-modal__content--size_sm{max-width:var(--ikp-sizes-sm)}.lg\\:ikp-modal__content--size_md{max-width:var(--ikp-sizes-md)}.lg\\:ikp-modal__content--size_lg{max-width:var(--ikp-sizes-lg)}.lg\\:ikp-modal__content--size_xl{max-width:var(--ikp-sizes-xl)}.lg\\:ikp-modal__content--size_2xl{max-width:var(--ikp-sizes-2xl)}.lg\\:ikp-modal__content--size_3xl{max-width:var(--ikp-sizes-3xl)}.lg\\:ikp-modal__content--size_4xl{max-width:var(--ikp-sizes-4xl)}.lg\\:ikp-modal__content--size_5xl{max-width:var(--ikp-sizes-5xl)}.lg\\:ikp-modal__content--size_6xl{max-width:var(--ikp-sizes-6xl)}.lg\\:ikp-modal__content--size_full{max-width:100vw;min-height:100vh;margin-block:var(--ikp-spacing-0);border-radius:0}.lg\\:ikp-modal__container--scrollOverflowBehavior_inside{overflow:hidden}.lg\\:ikp-modal__content--scrollOverflowBehavior_inside{max-height:calc(100% - 7.5rem)}.lg\\:ikp-modal__container--scrollOverflowBehavior_outside{overflow:auto}.lg\\:ikp-modal__container--isCentered_false{align-items:flex-start}.lg\\:ikp-modal__content--isCentered_false{margin-block:var(--ikp-spacing-16)}.lg\\:ikp-modal__container--isCentered_true{align-items:center}.lg\\:ikp-modal__content--isCentered_true{margin-block:auto;margin-inline:auto}.lg\\:ikp-modal__container--variant_clickThrough{pointer-events:none;z-index:var(--ikp-z-index-modal) - 1}.lg\\:ikp-modal__content--variant_clickThrough{pointer-events:auto}.lg\\:ikp-select__label--size_sm{font-size:.875rem;line-height:1.25rem}.lg\\:ikp-select__trigger--size_sm{padding-inline:var(--ikp-spacing-2\\.5);height:var(--ikp-sizes-9);min-width:var(--ikp-sizes-9);font-size:var(--ikp-font-sizes-sm);gap:var(--ikp-spacing-2)}}@media screen and (min-width: 64em){.lg\\:ikp-select__trigger--size_sm :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}}@media screen and (min-width: 64em){.lg\\:ikp-select__item--size_sm{font-size:.875rem;line-height:1.25rem;padding-inline:var(--ikp-spacing-2);height:var(--ikp-sizes-9)}}@media screen and (min-width: 64em){.lg\\:ikp-select__itemIndicator--size_sm :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}}@media screen and (min-width: 64em){.lg\\:ikp-select__itemGroupLabel--size_sm{padding-inline:var(--ikp-spacing-2);padding-block:var(--ikp-spacing-1\\.5)}.lg\\:ikp-select__content--size_sm{padding:var(--ikp-spacing-0\\.5);gap:var(--ikp-spacing-1)}.lg\\:ikp-select__label--size_md{font-size:.875rem;line-height:1.25rem}.lg\\:ikp-select__trigger--size_md{padding-inline:var(--ikp-spacing-3);height:var(--ikp-sizes-10);min-width:var(--ikp-sizes-10);font-size:var(--ikp-font-sizes-md);gap:var(--ikp-spacing-2)}}@media screen and (min-width: 64em){.lg\\:ikp-select__trigger--size_md :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}}@media screen and (min-width: 64em){.lg\\:ikp-select__item--size_md{font-size:1rem;line-height:1.5rem;padding-inline:var(--ikp-spacing-2);height:var(--ikp-sizes-10)}}@media screen and (min-width: 64em){.lg\\:ikp-select__itemIndicator--size_md :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}}@media screen and (min-width: 64em){.lg\\:ikp-select__itemGroupLabel--size_md{padding-inline:var(--ikp-spacing-2);padding-block:var(--ikp-spacing-1\\.5)}.lg\\:ikp-select__content--size_md{padding:var(--ikp-spacing-1);gap:var(--ikp-spacing-1)}.lg\\:ikp-select__label--size_lg{font-size:.875rem;line-height:1.25rem}.lg\\:ikp-select__trigger--size_lg{padding-inline:var(--ikp-spacing-3\\.5);height:var(--ikp-sizes-11);min-width:var(--ikp-sizes-11);font-size:var(--ikp-font-sizes-md);gap:var(--ikp-spacing-2)}}@media screen and (min-width: 64em){.lg\\:ikp-select__trigger--size_lg :where(svg){width:var(--ikp-sizes-5);height:var(--ikp-sizes-5)}}@media screen and (min-width: 64em){.lg\\:ikp-select__item--size_lg{font-size:1rem;line-height:1.5rem;padding-inline:var(--ikp-spacing-2);height:var(--ikp-sizes-11)}}@media screen and (min-width: 64em){.lg\\:ikp-select__itemIndicator--size_lg :where(svg){width:var(--ikp-sizes-5);height:var(--ikp-sizes-5)}}@media screen and (min-width: 64em){.lg\\:ikp-select__itemGroupLabel--size_lg{padding-inline:var(--ikp-spacing-2);padding-block:var(--ikp-spacing-1\\.5)}.lg\\:ikp-select__content--size_lg{padding:var(--ikp-spacing-1\\.5);gap:var(--ikp-spacing-1)}.lg\\:ikp-select__trigger--variant_outline{background:var(--ikp-colors-white);border-width:1px}.dark .lg\\:ikp-select__trigger--variant_outline,[data-theme=dark] .lg\\:ikp-select__trigger--variant_outline{background:var(--ikp-colors-color-palette-800)}}@media screen and (min-width: 64em){.lg\\:ikp-select__trigger--variant_outline:is(:focus,[data-focus]){border-color:var(--ikp-colors-color-palette-200)}.dark .lg\\:ikp-select__trigger--variant_outline:is(:focus,[data-focus]),[data-theme=dark] .lg\\:ikp-select__trigger--variant_outline:is(:focus,[data-focus]){border-color:var(--ikp-colors-color-palette-800)}.lg\\:ikp-select__trigger--variant_outline:is(:focus,[data-focus]){box-shadow:var(--ikp-shadows-accent)}}@media screen and (min-width: 64em){.lg\\:ikp-select__trigger--variant_ghost:is(:focus,[data-focus]){background:var(--ikp-colors-color-palette-100)}.dark .lg\\:ikp-select__trigger--variant_ghost:is(:focus,[data-focus]),[data-theme=dark] .lg\\:ikp-select__trigger--variant_ghost:is(:focus,[data-focus]){background:var(--ikp-colors-color-palette-900)}.lg\\:ikp-select__trigger--variant_ghost:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-100)}.dark .lg\\:ikp-select__trigger--variant_ghost:is(:hover,[data-hover]),[data-theme=dark] .lg\\:ikp-select__trigger--variant_ghost:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-900)}}@media screen and (min-width: 64em){.lg\\:ikp-select__trigger--variant_ikpOutline{background:var(--ikp-colors-white);border-width:1px}.dark .lg\\:ikp-select__trigger--variant_ikpOutline,[data-theme=dark] .lg\\:ikp-select__trigger--variant_ikpOutline{background:var(--ikp-colors-color-palette-900)}.lg\\:ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]){border-color:var(--ikp-colors-color-palette-200)}.dark .lg\\:ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]),[data-theme=dark] .lg\\:ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]){border-color:var(--ikp-colors-white-alpha-300)}.lg\\:ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]){box-shadow:var(--ikp-shadows-accent)}.lg\\:ikp-select__trigger--variant_ikpOutline:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-300)}.dark .lg\\:ikp-select__trigger--variant_ikpOutline:is(:hover,[data-hover]),[data-theme=dark] .lg\\:ikp-select__trigger--variant_ikpOutline:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}}@media screen and (min-width: 64em){.lg\\:ikp-switch__root--size_sm{--switch-track-width:1.375rem;--switch-track-height:var(--ikp-sizes-3)}.lg\\:ikp-switch__root--size_md{--switch-track-width:1.875rem;--switch-track-height:var(--ikp-sizes-4)}.lg\\:ikp-switch__root--size_lg{--switch-track-width:2.875rem;--switch-track-height:var(--ikp-sizes-6)}.lg\\:ikp-switch__control--size_xss{width:24px;height:12px}.lg\\:ikp-switch__thumb--size_xss{width:12px;height:12px}.lg\\:ikp-tabs__trigger--size_sm{padding-block:var(--ikp-spacing-1);padding-inline:var(--ikp-spacing-4);font-size:var(--ikp-font-sizes-sm)}.lg\\:ikp-tabs__trigger--size_md{font-size:var(--ikp-font-sizes-md);padding-block:var(--ikp-spacing-2);padding-inline:var(--ikp-spacing-4)}.lg\\:ikp-tabs__trigger--size_lg{font-size:var(--ikp-font-sizes-lg);padding-block:var(--ikp-spacing-3);padding-inline:var(--ikp-spacing-4)}.lg\\:ikp-tabs__list--variant_line{--tabs-border-color:2px solid;border-color:inherit}.lg\\:ikp-tabs__trigger--variant_line{--tabs-border-color:2px solid;border-color:var(--ikp-colors-transparent);--tabs-margin-prop:-2px;color:var(--tabs-color);background:var(--tabs-bg)}}@media screen and (min-width: 64em){.lg\\:ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-600) }.dark .lg\\:ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]),[data-theme=dark] .lg\\:ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-300) }.lg\\:ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]){border-color:currentColor}.lg\\:ikp-tabs__trigger--variant_line:is(:active,[data-active]){--tabs-bg:var(--ikp-colors-gray-200) }.dark .lg\\:ikp-tabs__trigger--variant_line:is(:active,[data-active]),[data-theme=dark] .lg\\:ikp-tabs__trigger--variant_line:is(:active,[data-active]){--tabs-bg:var(--ikp-colors-white-alpha-300) }.lg\\:ikp-tabs__trigger--variant_line:is(:disabled,[disabled],[data-disabled]):is(:active,[data-active]){background:none}}@media screen and (min-width: 64em){.lg\\:ikp-tabs__list--variant_enclosed{margin-bottom:-1px;border-bottom:1px solid;border-color:inherit}.lg\\:ikp-tabs__trigger--variant_enclosed{border-top-left-radius:var(--ikp-radii-md);border-top-right-radius:var(--ikp-radii-md);border:1px solid;border-color:var(--ikp-colors-transparent);margin-bottom:-1px;--tabs-border-color:transparent;color:var(--tabs-color)}}@media screen and (min-width: 64em){.lg\\:ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-600) ;--tabs-border-color:var(--ikp-colors-white) }.dark .lg\\:ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]),[data-theme=dark] .lg\\:ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-300) ;--tabs-border-color:var(--ikp-colors-gray-800) }.lg\\:ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]){border-color:inherit;border-bottom-color:var(--tabs-border-color)}}@media screen and (min-width: 64em){.lg\\:ikp-tabs__list--variant_enclosed-colored{margin-bottom:-1px;border-bottom:1px solid;border-color:inherit}.lg\\:ikp-tabs__trigger--variant_enclosed-colored{border:1px solid;border-color:inherit;--tabs-bg:var(--ikp-colors-gray-50);margin-bottom:-1px;color:var(--tabs-color);background:var(--tabs-bg)}.dark .lg\\:ikp-tabs__trigger--variant_enclosed-colored,[data-theme=dark] .lg\\:ikp-tabs__trigger--variant_enclosed-colored{--tabs-bg:var(--ikp-colors-white-alpha-50) }}@media screen and (min-width: 64em){.lg\\:ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]){--tabs-bg:var(--ikp-colors-white) ;--tabs-color:var(--ikp-colors-color-palette-600) }.dark .lg\\:ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]),[data-theme=dark] .lg\\:ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]){--tabs-bg:var(--ikp-colors-gray-800) ;--tabs-color:var(--ikp-colors-color-palette-300) }.lg\\:ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]){border-color:inherit;border-top-color:currentColor;border-bottom-color:var(--ikp-colors-transparent)}.lg\\:ikp-tabs__trigger--variant_enclosed-colored _notLast{margin-inline-end:-1px}.lg\\:ikp-tabs__trigger--variant_soft-rounded{border-radius:var(--ikp-radii-full);font-weight:var(--ikp-font-weights-semibold);color:var(--ikp-colors-gray-600)}}@media screen and (min-width: 64em){.lg\\:ikp-tabs__trigger--variant_soft-rounded:is([aria-selected=true],[data-selected]){color:var(--ikp-colors-color-palette-700);background:var(--ikp-colors-color-palette-100)}}@media screen and (min-width: 64em){.lg\\:ikp-tabs__trigger--variant_solid-rounded{border-radius:var(--ikp-radii-full);font-weight:var(--ikp-font-weights-semibold);--tabs-color:var(--ikp-colors-gray-600);color:var(--tabs-color);background:var(--tabs-bg)}.dark .lg\\:ikp-tabs__trigger--variant_solid-rounded,[data-theme=dark] .lg\\:ikp-tabs__trigger--variant_solid-rounded{--tabs-color:inherit }.lg\\:ikp-tabs__trigger--variant_solid-rounded:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-white) ;--tabs-bg:var(--ikp-colors-color-palette-600) }.dark .lg\\:ikp-tabs__trigger--variant_solid-rounded:is([aria-selected=true],[data-selected]),[data-theme=dark] .lg\\:ikp-tabs__trigger--variant_solid-rounded:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-gray-800) ;--tabs-bg:var(--ikp-colors-color-palette-300) }}@media screen and (min-width: 64em){.lg\\:ikp-tabs__trigger--isFitted_true{flex:1 1 0%}.lg\\:ikp-table__caption--variant_simple{color:var(--ikp-colors-gray-600)}.dark .lg\\:ikp-table__caption--variant_simple,[data-theme=dark] .lg\\:ikp-table__caption--variant_simple{color:var(--ikp-colors-gray-100)}.lg\\:ikp-table__td--variant_simple{border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .lg\\:ikp-table__td--variant_simple,[data-theme=dark] .lg\\:ikp-table__td--variant_simple{border-color:var(--ikp-colors-color-palette-700)}.lg\\:ikp-table__td--variant_simple[data-is-numeric=true]{text-align:end}.lg\\:ikp-table__th--variant_simple{color:var(--ikp-colors-gray-600);border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .lg\\:ikp-table__th--variant_simple,[data-theme=dark] .lg\\:ikp-table__th--variant_simple{color:var(--ikp-colors-gray-400);border-color:var(--ikp-colors-color-palette-700)}.lg\\:ikp-table__th--variant_simple[data-is-numeric=true]{text-align:end}.lg\\:ikp-table__tr--variant_tfoot th:last-of-type{border-bottom-width:0}.lg\\:ikp-table__caption--variant_striped{color:var(--ikp-colors-gray-600)}.dark .lg\\:ikp-table__caption--variant_striped,[data-theme=dark] .lg\\:ikp-table__caption--variant_striped{color:var(--ikp-colors-gray-100)}.lg\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,.lg\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) th{border-bottom-width:1px;border-color:var(--ikp-colors-color-palette-100)}.dark .lg\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,.dark .lg\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) th,[data-theme=dark] .lg\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,[data-theme=dark] .lg\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) th{border-color:var(--ikp-colors-color-palette-700)}.lg\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td{background:var(--ikp-colors-color-palette-100)}.dark .lg\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,[data-theme=dark] .lg\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td{background:var(--ikp-colors-color-palette-700)}.lg\\:ikp-table__td--variant_striped{border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .lg\\:ikp-table__td--variant_striped,[data-theme=dark] .lg\\:ikp-table__td--variant_striped{border-color:var(--ikp-colors-color-palette-700)}.lg\\:ikp-table__td--variant_striped[data-is-numeric=true]{text-align:end}.lg\\:ikp-table__tfoot--variant_striped th tr:last-of-type{border-bottom-width:0}.lg\\:ikp-table__th--variant_striped{color:var(--ikp-colors-gray-600);border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .lg\\:ikp-table__th--variant_striped,[data-theme=dark] .lg\\:ikp-table__th--variant_striped{color:var(--ikp-colors-gray-400);border-color:var(--ikp-colors-color-palette-700)}.lg\\:ikp-table__th--variant_striped[data-is-numeric=true]{text-align:end}.lg\\:ikp-table__caption--size_sm{font-size:var(--ikp-font-sizes-xs)}.lg\\:ikp-table__caption--size_sm,.lg\\:ikp-table__td--size_sm{padding-inline:var(--ikp-spacing-4);padding-block:var(--ikp-spacing-2)}.lg\\:ikp-table__td--size_sm{font-size:var(--ikp-font-sizes-sm);line-height:var(--ikp-line-heights-4)}.lg\\:ikp-table__th--size_sm{padding-inline:var(--ikp-spacing-4);padding-block:var(--ikp-spacing-1);line-height:var(--ikp-line-heights-4);font-size:var(--ikp-font-sizes-xs)}.lg\\:ikp-table__caption--size_md{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-2);font-size:var(--ikp-font-sizes-sm)}.lg\\:ikp-table__td--size_md{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-4);line-height:var(--ikp-line-heights-5)}.lg\\:ikp-table__th--size_md{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-3);line-height:var(--ikp-line-heights-4);font-size:var(--ikp-font-sizes-xs)}.lg\\:ikp-table__caption--size_lg{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-2);font-size:var(--ikp-font-sizes-md)}.lg\\:ikp-table__td--size_lg{padding-inline:var(--ikp-spacing-8);padding-block:var(--ikp-spacing-5);line-height:var(--ikp-line-heights-6)}.lg\\:ikp-table__th--size_lg{padding-inline:var(--ikp-spacing-8);padding-block:var(--ikp-spacing-4);line-height:var(--ikp-line-heights-5);font-size:var(--ikp-font-sizes-sm)}.lg\\:ikp-tooltip__content--variant_default{font-weight:var(--ikp-font-weights-normal)}.light .lg\\:ikp-tooltip__content--variant_default,[data-theme=light] .lg\\:ikp-tooltip__content--variant_default{background:var(--ikp-colors-white);box-shadow:0 8px 30px #0000001f;color:var(--ikp-colors-gray-800);--tooltip-arrow-bg:white }.dark .lg\\:ikp-tooltip__content--variant_default,[data-theme=dark] .lg\\:ikp-tooltip__content--variant_default{background:var(--ikp-colors-gray-dark-800);color:var(--ikp-colors-white-alpha-800);--tooltip-arrow-bg:var(--ikp-colors-gray-dark-800) }.lg\\:ikp-search-bar-trigger__container--size_expand{height:100%!important}.lg\\:ikp-search-bar-trigger__wrapper--size_expand{width:100%;height:100%}}@media screen and (min-width: 64em){@media screen and (min-width: 48em){.lg\\:ikp-search-bar-trigger__wrapper--size_compact{width:min(340px,100%);height:min(40px,100%)}}}@media screen and (min-width: 64em){.lg\\:ikp-search-bar-trigger__container--size_shrink{padding-inline:var(--ikp-spacing-2)!important;height:var(--ikp-sizes-9)!important}@media screen and (min-width: 48em){.lg\\:ikp-search-bar-trigger__container--size_shrink{padding-inline:var(--ikp-spacing-3)!important}.lg\\:ikp-search-bar-trigger__wrapper--size_shrink{width:min(340px,100%);height:min(36px,100%)}}}@media screen and (min-width: 64em){.lg\\:ikp-search-bar-trigger__text--size_shrink{display:none}@media screen and (min-width: 33em){.lg\\:ikp-search-bar-trigger__text--size_shrink{display:inline-block}}}@media screen and (min-width: 64em){.lg\\:ikp-search-bar-trigger__kbd--size_shrink{display:none}@media screen and (min-width: 33em){.lg\\:ikp-search-bar-trigger__kbd--size_shrink{display:flex}}}@media screen and (min-width: 64em){.lg\\:ikp-search-bar-trigger__icon--size_shrink{width:var(--ikp-sizes-5)!important;margin-right:var(--ikp-spacing-0)!important}@media screen and (min-width: 33em){.lg\\:ikp-search-bar-trigger__icon--size_shrink{width:var(--ikp-sizes-5)!important;margin-right:var(--ikp-spacing-2)!important}}}@media screen and (min-width: 64em){.lg\\:ikp-search-bar-trigger__container--size_medium{height:100%!important}}@media screen and (min-width: 64em){@media screen and (min-width: 48em){.lg\\:ikp-search-bar-trigger__wrapper--size_medium{width:min(500px,100%);height:min(3rem,100%)}}}@media screen and (min-width: 64em){.light .lg\\:ikp-search-bar-trigger__container--variant_emphasized,[data-theme=light] .lg\\:ikp-search-bar-trigger__container--variant_emphasized{border-color:var(--ikp-colors-gray-100);box-shadow:var(--ikp-shadows-sm)}.light .lg\\:ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]),[data-theme=light] .lg\\:ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]){box-shadow:var(--ikp-shadows-md);background:none!important}.dark .lg\\:ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]),[data-theme=dark] .lg\\:ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]){background:none!important}}@media screen and (min-width: 64em){.lg\\:ikp-search-bar-trigger__container--variant_subtle{border-color:var(--ikp-colors-gray-300);color:var(--ikp-colors-gray-500)!important}.dark .lg\\:ikp-search-bar-trigger__container--variant_subtle,[data-theme=dark] .lg\\:ikp-search-bar-trigger__container--variant_subtle{color:var(--ikp-colors-white-alpha-500)!important;border-color:var(--ikp-colors-white-alpha-300)}.lg\\:ikp-search-bar-trigger__container--variant_subtle:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-400);background:none!important}.dark .lg\\:ikp-search-bar-trigger__container--variant_subtle:is(:hover,[data-hover]),[data-theme=dark] .lg\\:ikp-search-bar-trigger__container--variant_subtle:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}}@media screen and (min-width: 64em){.lg\\:ikp-search-bar-trigger__kbd--variant_subtle{border:var(--ikp-borders-none);padding-inline:var(--ikp-spacing-0);color:var(--ikp-colors-gray-500)}.dark .lg\\:ikp-search-bar-trigger__kbd--variant_subtle,[data-theme=dark] .lg\\:ikp-search-bar-trigger__kbd--variant_subtle{color:var(--ikp-colors-white-alpha-500)}.lg\\:ikp-search-bar-trigger__icon--variant_subtle{width:18px}}@media screen and (min-width: 80em){.xl\\:ikp-alert__container--variant_subtle{--alert-fg:var(--ikp-colors-color-palette-500);--alert-bg:var(--ikp-colors-color-palette-100)}.dark .xl\\:ikp-alert__container--variant_subtle,[data-theme=dark] .xl\\:ikp-alert__container--variant_subtle{--alert-fg:var(--ikp-colors-color-palette-200) ;--alert-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--alert-bg:var(--alert-bg-alpha,var(--colors-color-palette-200)) }.xl\\:ikp-alert__container--variant_left-accent{--alert-fg:var(--ikp-colors-color-palette-500);--alert-bg:var(--ikp-colors-color-palette-100);padding-inline-start:var(--ikp-spacing-3);border-inline-start-width:4px;border-inline-start-color:var(--alert-fg)}.dark .xl\\:ikp-alert__container--variant_left-accent,[data-theme=dark] .xl\\:ikp-alert__container--variant_left-accent{--alert-fg:var(--ikp-colors-color-palette-200) ;--alert-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) }.xl\\:ikp-alert__container--variant_top-accent{--alert-fg:var(--ikp-colors-color-palette-500);--alert-bg:var(--ikp-colors-color-palette-100);padding-top:var(--ikp-spacing-2);border-top-width:4px;border-top-color:var(--alert-fg)}.dark .xl\\:ikp-alert__container--variant_top-accent,[data-theme=dark] .xl\\:ikp-alert__container--variant_top-accent{--alert-fg:var(--ikp-colors-color-palette-200) ;--alert-bg:var(--alert-bg-alpha,var(--colors-color-palette-200)) }.xl\\:ikp-alert__container--variant_solid{--alert-fg:var(--ikp-colors-white);--alert-bg:var(--ikp-colors-color-palette-500);color:var(--alert-fg)}.dark .xl\\:ikp-alert__container--variant_solid,[data-theme=dark] .xl\\:ikp-alert__container--variant_solid{--alert-fg:var(--ikp-colors-gray-900) ;--alert-bg:var(--ikp-colors-color-palette-200) }.xl\\:ikp-avatar__root--size_2xs{--avatar-size:var(--ikp-sizes-4);--avatar-font-size:var(--ikp-font-sizes-3xs)}.xl\\:ikp-avatar__root--size_xs{--avatar-size:var(--ikp-sizes-6);--avatar-font-size:var(--ikp-font-sizes-2xs)}.xl\\:ikp-avatar__root--size_sm{--avatar-size:var(--ikp-sizes-8);--avatar-font-size:var(--ikp-font-sizes-xs)}.xl\\:ikp-avatar__root--size_md{--avatar-size:var(--ikp-sizes-12);--avatar-font-size:var(--ikp-font-sizes-md)}.xl\\:ikp-avatar__root--size_lg{--avatar-size:var(--ikp-sizes-16);--avatar-font-size:var(--ikp-font-sizes-lg)}.xl\\:ikp-avatar__root--size_xl{--avatar-size:var(--ikp-sizes-24);--avatar-font-size:var(--ikp-font-sizes-3xl)}.xl\\:ikp-avatar__root--size_2xl{--avatar-size:var(--ikp-sizes-32);--avatar-font-size:var(--ikp-font-sizes-4xl)}.xl\\:ikp-card__container--variant_elevated{--card-shadow:var(--ikp-shadows-base)}.dark .xl\\:ikp-card__container--variant_elevated,[data-theme=dark] .xl\\:ikp-card__container--variant_elevated{--card-bg:var(--ikp-colors-gray-700) }.xl\\:ikp-card__container--variant_outline{--card-border-width:1px;--card-border-color:var(--ikp-colors-chakra-border-color)}.dark .xl\\:ikp-card__container--variant_outline,[data-theme=dark] .xl\\:ikp-card__container--variant_outline{--card-border-color:var(--ikp-colors-white-alpha-300) }.xl\\:ikp-card__container--variant_filled{--card-bg:var(--ikp-colors-chakra-subtle-bg)}.xl\\:ikp-card__body--variant_unstyled,.xl\\:ikp-card__footer--variant_unstyled,.xl\\:ikp-card__header--variant_unstyled{--card-padding:0}.xl\\:ikp-card__container--size_sm{--card-radius:var(--ikp-radii-base);--card-padding:var(--ikp-space-3)}.xl\\:ikp-card__container--size_md{--card-radius:var(--ikp-radii-md);--card-padding:var(--ikp-space-5)}.xl\\:ikp-card__container--size_lg{--card-radius:var(--ikp-radii-xl);--card-padding:var(--ikp-space-7)}.xl\\:ikp-checkbox__control--size_sm{--checkbox-size:var(--ikp-sizes-3)}.xl\\:ikp-checkbox__label--size_sm{font-size:var(--ikp-font-sizes-sm)}.xl\\:ikp-checkbox__icon--size_sm{font-size:var(--ikp-font-sizes-3xs)}.xl\\:ikp-checkbox__control--size_md{--checkbox-size:var(--ikp-sizes-4)}.xl\\:ikp-checkbox__label--size_md{font-size:var(--ikp-font-sizes-md)}.xl\\:ikp-checkbox__icon--size_md{font-size:var(--ikp-font-sizes-2xs)}.xl\\:ikp-checkbox__control--size_lg{--checkbox-size:var(--ikp-sizes-5)}.xl\\:ikp-checkbox__label--size_lg{font-size:var(--ikp-font-sizes-lg)}.xl\\:ikp-checkbox__icon--size_lg{font-size:var(--ikp-font-sizes-2xs)}.xl\\:ikp-checkbox__control--shape_circular{border-radius:var(--ikp-radii-full)}}@media screen and (min-width: 80em){.xl\\:ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){background:var(--ikp-colors-gray-900)}.dark .xl\\:ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]),[data-theme=dark] .xl\\:ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){background:var(--ikp-colors-white-alpha-900);border-color:var(--ikp-colors-white-alpha-900)}.xl\\:ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){border-color:var(--ikp-colors-gray-900)}.xl\\:ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){background:var(--ikp-colors-gray-900)}.dark .xl\\:ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]),[data-theme=dark] .xl\\:ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){background:var(--ikp-colors-white-alpha-900);border-color:var(--ikp-colors-white-alpha-900)}.xl\\:ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){border-color:var(--ikp-colors-gray-900)}}@media screen and (min-width: 80em){.xl\\:ikp-input__addon--size_lg,.xl\\:ikp-input__field--size_lg,.xl\\:ikp-input__group--size_lg{--input-font-size:var(--ikp-font-sizes-lg);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-12)}.xl\\:ikp-input__addon--size_md,.xl\\:ikp-input__field--size_md,.xl\\:ikp-input__group--size_md{--input-font-size:var(--ikp-font-sizes-md);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-10)}.xl\\:ikp-input__addon--size_sm,.xl\\:ikp-input__field--size_sm,.xl\\:ikp-input__group--size_sm{--input-font-size:var(--ikp-font-sizes-sm);--input-padding:var(--ikp-space-3);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-8)}.xl\\:ikp-input__addon--size_xs,.xl\\:ikp-input__field--size_xs,.xl\\:ikp-input__group--size_xs{--input-font-size:var(--ikp-font-sizes-xs);--input-padding:var(--ikp-space-2);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-6)}.xl\\:ikp-input__field--variant_outline{border:1px solid;border-color:inherit;background:inherit}}@media screen and (min-width: 80em){.xl\\:ikp-input__field--variant_outline:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.xl\\:ikp-input__field--variant_outline[aria-invalid=true],.xl\\:ikp-input__field--variant_outline[data-invalid] .xl\\:ikp-input__field--variant_outline{border-color:var(--input-error-border-color);box-shadow:0 0 0 1px var(--input-error-border-color)}.xl\\:ikp-input__field--variant_outline:is(:focus-visible,[data-focus-visible]){z-index:1;border-color:var(--input-focus-border-color);box-shadow:0 0 0 1px var(--input-focus-border-color)}.xl\\:ikp-input__field--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-300)}.dark .xl\\:ikp-input__field--variant_outline:is(:hover,[data-hover]),[data-theme=dark] .xl\\:ikp-input__field--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}}@media screen and (min-width: 80em){.xl\\:ikp-input__addon--variant_outline{border:1px solid;border-color:inherit;background:var(--ikp-colors-gray-100)}.dark .xl\\:ikp-input__addon--variant_outline,[data-theme=dark] .xl\\:ikp-input__addon--variant_outline{border-color:var(--ikp-colors-white-alpha-50);background:var(--ikp-colors-white-alpha-300)}.xl\\:ikp-input__field--variant_filled{border:2px solid;border-color:var(--ikp-colors-transparent);background:var(--ikp-colors-gray-100)}.dark .xl\\:ikp-input__field--variant_filled,[data-theme=dark] .xl\\:ikp-input__field--variant_filled{background:var(--ikp-colors-white-alpha-50)}}@media screen and (min-width: 80em){.xl\\:ikp-input__field--variant_filled:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.xl\\:ikp-input__field--variant_filled[aria-invalid=true],.xl\\:ikp-input__field--variant_filled[data-invalid] .xl\\:ikp-input__field--variant_filled{border-color:var(--input-error-border-color)}.xl\\:ikp-input__field--variant_filled:is(:focus-visible,[data-focus-visible]){background:var(--ikp-colors-transparent);border-color:var(--input-focus-border-color)}.xl\\:ikp-input__field--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-gray-200)}.dark .xl\\:ikp-input__field--variant_filled:is(:hover,[data-hover]),[data-theme=dark] .xl\\:ikp-input__field--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-100)}}@media screen and (min-width: 80em){.xl\\:ikp-input__addon--variant_filled{border:2px solid;border-color:var(--ikp-colors-transparent);background:var(--ikp-colors-gray-100)}.dark .xl\\:ikp-input__addon--variant_filled,[data-theme=dark] .xl\\:ikp-input__addon--variant_filled{background:var(--ikp-colors-white-alpha-50)}.xl\\:ikp-input__field--variant_flushed{border-bottom:1px solid;border-color:inherit;border-radius:0;padding-inline:var(--ikp-spacing-0);background:var(--ikp-colors-transparent)}}@media screen and (min-width: 80em){.xl\\:ikp-input__field--variant_flushed:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.xl\\:ikp-input__field--variant_flushed[aria-invalid=true],.xl\\:ikp-input__field--variant_flushed[data-invalid] .xl\\:ikp-input__field--variant_flushed{border-color:var(--input-error-border-color);box-shadow:0 1px 0 0 var(--input-error-border-color)}.xl\\:ikp-input__field--variant_flushed:is(:focus-visible,[data-focus-visible]){border-color:var(--input-focus-border-color);box-shadow:0 1px 0 0 var(--input-focus-border-color)}}@media screen and (min-width: 80em){.xl\\:ikp-input__addon--variant_flushed{border-bottom:2px solid;border-color:inherit;border-radius:0;padding-inline:var(--ikp-spacing-0);background:var(--ikp-colors-transparent)}.xl\\:ikp-input__addon--variant_unstyled,.xl\\:ikp-input__field--variant_unstyled{background:var(--ikp-colors-transparent);padding-inline:var(--ikp-spacing-0);height:var(--ikp-sizes-auto)}.xl\\:ikp-modal__content--size_xs{max-width:var(--ikp-sizes-xs)}.xl\\:ikp-modal__content--size_sm{max-width:var(--ikp-sizes-sm)}.xl\\:ikp-modal__content--size_md{max-width:var(--ikp-sizes-md)}.xl\\:ikp-modal__content--size_lg{max-width:var(--ikp-sizes-lg)}.xl\\:ikp-modal__content--size_xl{max-width:var(--ikp-sizes-xl)}.xl\\:ikp-modal__content--size_2xl{max-width:var(--ikp-sizes-2xl)}.xl\\:ikp-modal__content--size_3xl{max-width:var(--ikp-sizes-3xl)}.xl\\:ikp-modal__content--size_4xl{max-width:var(--ikp-sizes-4xl)}.xl\\:ikp-modal__content--size_5xl{max-width:var(--ikp-sizes-5xl)}.xl\\:ikp-modal__content--size_6xl{max-width:var(--ikp-sizes-6xl)}.xl\\:ikp-modal__content--size_full{max-width:100vw;min-height:100vh;margin-block:var(--ikp-spacing-0);border-radius:0}.xl\\:ikp-modal__container--scrollOverflowBehavior_inside{overflow:hidden}.xl\\:ikp-modal__content--scrollOverflowBehavior_inside{max-height:calc(100% - 7.5rem)}.xl\\:ikp-modal__container--scrollOverflowBehavior_outside{overflow:auto}.xl\\:ikp-modal__container--isCentered_false{align-items:flex-start}.xl\\:ikp-modal__content--isCentered_false{margin-block:var(--ikp-spacing-16)}.xl\\:ikp-modal__container--isCentered_true{align-items:center}.xl\\:ikp-modal__content--isCentered_true{margin-block:auto;margin-inline:auto}.xl\\:ikp-modal__container--variant_clickThrough{pointer-events:none;z-index:var(--ikp-z-index-modal) - 1}.xl\\:ikp-modal__content--variant_clickThrough{pointer-events:auto}.xl\\:ikp-select__label--size_sm{font-size:.875rem;line-height:1.25rem}.xl\\:ikp-select__trigger--size_sm{padding-inline:var(--ikp-spacing-2\\.5);height:var(--ikp-sizes-9);min-width:var(--ikp-sizes-9);font-size:var(--ikp-font-sizes-sm);gap:var(--ikp-spacing-2)}}@media screen and (min-width: 80em){.xl\\:ikp-select__trigger--size_sm :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}}@media screen and (min-width: 80em){.xl\\:ikp-select__item--size_sm{font-size:.875rem;line-height:1.25rem;padding-inline:var(--ikp-spacing-2);height:var(--ikp-sizes-9)}}@media screen and (min-width: 80em){.xl\\:ikp-select__itemIndicator--size_sm :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}}@media screen and (min-width: 80em){.xl\\:ikp-select__itemGroupLabel--size_sm{padding-inline:var(--ikp-spacing-2);padding-block:var(--ikp-spacing-1\\.5)}.xl\\:ikp-select__content--size_sm{padding:var(--ikp-spacing-0\\.5);gap:var(--ikp-spacing-1)}.xl\\:ikp-select__label--size_md{font-size:.875rem;line-height:1.25rem}.xl\\:ikp-select__trigger--size_md{padding-inline:var(--ikp-spacing-3);height:var(--ikp-sizes-10);min-width:var(--ikp-sizes-10);font-size:var(--ikp-font-sizes-md);gap:var(--ikp-spacing-2)}}@media screen and (min-width: 80em){.xl\\:ikp-select__trigger--size_md :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}}@media screen and (min-width: 80em){.xl\\:ikp-select__item--size_md{font-size:1rem;line-height:1.5rem;padding-inline:var(--ikp-spacing-2);height:var(--ikp-sizes-10)}}@media screen and (min-width: 80em){.xl\\:ikp-select__itemIndicator--size_md :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}}@media screen and (min-width: 80em){.xl\\:ikp-select__itemGroupLabel--size_md{padding-inline:var(--ikp-spacing-2);padding-block:var(--ikp-spacing-1\\.5)}.xl\\:ikp-select__content--size_md{padding:var(--ikp-spacing-1);gap:var(--ikp-spacing-1)}.xl\\:ikp-select__label--size_lg{font-size:.875rem;line-height:1.25rem}.xl\\:ikp-select__trigger--size_lg{padding-inline:var(--ikp-spacing-3\\.5);height:var(--ikp-sizes-11);min-width:var(--ikp-sizes-11);font-size:var(--ikp-font-sizes-md);gap:var(--ikp-spacing-2)}}@media screen and (min-width: 80em){.xl\\:ikp-select__trigger--size_lg :where(svg){width:var(--ikp-sizes-5);height:var(--ikp-sizes-5)}}@media screen and (min-width: 80em){.xl\\:ikp-select__item--size_lg{font-size:1rem;line-height:1.5rem;padding-inline:var(--ikp-spacing-2);height:var(--ikp-sizes-11)}}@media screen and (min-width: 80em){.xl\\:ikp-select__itemIndicator--size_lg :where(svg){width:var(--ikp-sizes-5);height:var(--ikp-sizes-5)}}@media screen and (min-width: 80em){.xl\\:ikp-select__itemGroupLabel--size_lg{padding-inline:var(--ikp-spacing-2);padding-block:var(--ikp-spacing-1\\.5)}.xl\\:ikp-select__content--size_lg{padding:var(--ikp-spacing-1\\.5);gap:var(--ikp-spacing-1)}.xl\\:ikp-select__trigger--variant_outline{background:var(--ikp-colors-white);border-width:1px}.dark .xl\\:ikp-select__trigger--variant_outline,[data-theme=dark] .xl\\:ikp-select__trigger--variant_outline{background:var(--ikp-colors-color-palette-800)}}@media screen and (min-width: 80em){.xl\\:ikp-select__trigger--variant_outline:is(:focus,[data-focus]){border-color:var(--ikp-colors-color-palette-200)}.dark .xl\\:ikp-select__trigger--variant_outline:is(:focus,[data-focus]),[data-theme=dark] .xl\\:ikp-select__trigger--variant_outline:is(:focus,[data-focus]){border-color:var(--ikp-colors-color-palette-800)}.xl\\:ikp-select__trigger--variant_outline:is(:focus,[data-focus]){box-shadow:var(--ikp-shadows-accent)}}@media screen and (min-width: 80em){.xl\\:ikp-select__trigger--variant_ghost:is(:focus,[data-focus]){background:var(--ikp-colors-color-palette-100)}.dark .xl\\:ikp-select__trigger--variant_ghost:is(:focus,[data-focus]),[data-theme=dark] .xl\\:ikp-select__trigger--variant_ghost:is(:focus,[data-focus]){background:var(--ikp-colors-color-palette-900)}.xl\\:ikp-select__trigger--variant_ghost:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-100)}.dark .xl\\:ikp-select__trigger--variant_ghost:is(:hover,[data-hover]),[data-theme=dark] .xl\\:ikp-select__trigger--variant_ghost:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-900)}}@media screen and (min-width: 80em){.xl\\:ikp-select__trigger--variant_ikpOutline{background:var(--ikp-colors-white);border-width:1px}.dark .xl\\:ikp-select__trigger--variant_ikpOutline,[data-theme=dark] .xl\\:ikp-select__trigger--variant_ikpOutline{background:var(--ikp-colors-color-palette-900)}.xl\\:ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]){border-color:var(--ikp-colors-color-palette-200)}.dark .xl\\:ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]),[data-theme=dark] .xl\\:ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]){border-color:var(--ikp-colors-white-alpha-300)}.xl\\:ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]){box-shadow:var(--ikp-shadows-accent)}.xl\\:ikp-select__trigger--variant_ikpOutline:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-300)}.dark .xl\\:ikp-select__trigger--variant_ikpOutline:is(:hover,[data-hover]),[data-theme=dark] .xl\\:ikp-select__trigger--variant_ikpOutline:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}}@media screen and (min-width: 80em){.xl\\:ikp-switch__root--size_sm{--switch-track-width:1.375rem;--switch-track-height:var(--ikp-sizes-3)}.xl\\:ikp-switch__root--size_md{--switch-track-width:1.875rem;--switch-track-height:var(--ikp-sizes-4)}.xl\\:ikp-switch__root--size_lg{--switch-track-width:2.875rem;--switch-track-height:var(--ikp-sizes-6)}.xl\\:ikp-switch__control--size_xss{width:24px;height:12px}.xl\\:ikp-switch__thumb--size_xss{width:12px;height:12px}.xl\\:ikp-tabs__trigger--size_sm{padding-block:var(--ikp-spacing-1);padding-inline:var(--ikp-spacing-4);font-size:var(--ikp-font-sizes-sm)}.xl\\:ikp-tabs__trigger--size_md{font-size:var(--ikp-font-sizes-md);padding-block:var(--ikp-spacing-2);padding-inline:var(--ikp-spacing-4)}.xl\\:ikp-tabs__trigger--size_lg{font-size:var(--ikp-font-sizes-lg);padding-block:var(--ikp-spacing-3);padding-inline:var(--ikp-spacing-4)}.xl\\:ikp-tabs__list--variant_line{--tabs-border-color:2px solid;border-color:inherit}.xl\\:ikp-tabs__trigger--variant_line{--tabs-border-color:2px solid;border-color:var(--ikp-colors-transparent);--tabs-margin-prop:-2px;color:var(--tabs-color);background:var(--tabs-bg)}}@media screen and (min-width: 80em){.xl\\:ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-600) }.dark .xl\\:ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]),[data-theme=dark] .xl\\:ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-300) }.xl\\:ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]){border-color:currentColor}.xl\\:ikp-tabs__trigger--variant_line:is(:active,[data-active]){--tabs-bg:var(--ikp-colors-gray-200) }.dark .xl\\:ikp-tabs__trigger--variant_line:is(:active,[data-active]),[data-theme=dark] .xl\\:ikp-tabs__trigger--variant_line:is(:active,[data-active]){--tabs-bg:var(--ikp-colors-white-alpha-300) }.xl\\:ikp-tabs__trigger--variant_line:is(:disabled,[disabled],[data-disabled]):is(:active,[data-active]){background:none}}@media screen and (min-width: 80em){.xl\\:ikp-tabs__list--variant_enclosed{margin-bottom:-1px;border-bottom:1px solid;border-color:inherit}.xl\\:ikp-tabs__trigger--variant_enclosed{border-top-left-radius:var(--ikp-radii-md);border-top-right-radius:var(--ikp-radii-md);border:1px solid;border-color:var(--ikp-colors-transparent);margin-bottom:-1px;--tabs-border-color:transparent;color:var(--tabs-color)}}@media screen and (min-width: 80em){.xl\\:ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-600) ;--tabs-border-color:var(--ikp-colors-white) }.dark .xl\\:ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]),[data-theme=dark] .xl\\:ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-300) ;--tabs-border-color:var(--ikp-colors-gray-800) }.xl\\:ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]){border-color:inherit;border-bottom-color:var(--tabs-border-color)}}@media screen and (min-width: 80em){.xl\\:ikp-tabs__list--variant_enclosed-colored{margin-bottom:-1px;border-bottom:1px solid;border-color:inherit}.xl\\:ikp-tabs__trigger--variant_enclosed-colored{border:1px solid;border-color:inherit;--tabs-bg:var(--ikp-colors-gray-50);margin-bottom:-1px;color:var(--tabs-color);background:var(--tabs-bg)}.dark .xl\\:ikp-tabs__trigger--variant_enclosed-colored,[data-theme=dark] .xl\\:ikp-tabs__trigger--variant_enclosed-colored{--tabs-bg:var(--ikp-colors-white-alpha-50) }}@media screen and (min-width: 80em){.xl\\:ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]){--tabs-bg:var(--ikp-colors-white) ;--tabs-color:var(--ikp-colors-color-palette-600) }.dark .xl\\:ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]),[data-theme=dark] .xl\\:ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]){--tabs-bg:var(--ikp-colors-gray-800) ;--tabs-color:var(--ikp-colors-color-palette-300) }.xl\\:ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]){border-color:inherit;border-top-color:currentColor;border-bottom-color:var(--ikp-colors-transparent)}.xl\\:ikp-tabs__trigger--variant_enclosed-colored _notLast{margin-inline-end:-1px}.xl\\:ikp-tabs__trigger--variant_soft-rounded{border-radius:var(--ikp-radii-full);font-weight:var(--ikp-font-weights-semibold);color:var(--ikp-colors-gray-600)}}@media screen and (min-width: 80em){.xl\\:ikp-tabs__trigger--variant_soft-rounded:is([aria-selected=true],[data-selected]){color:var(--ikp-colors-color-palette-700);background:var(--ikp-colors-color-palette-100)}}@media screen and (min-width: 80em){.xl\\:ikp-tabs__trigger--variant_solid-rounded{border-radius:var(--ikp-radii-full);font-weight:var(--ikp-font-weights-semibold);--tabs-color:var(--ikp-colors-gray-600);color:var(--tabs-color);background:var(--tabs-bg)}.dark .xl\\:ikp-tabs__trigger--variant_solid-rounded,[data-theme=dark] .xl\\:ikp-tabs__trigger--variant_solid-rounded{--tabs-color:inherit }.xl\\:ikp-tabs__trigger--variant_solid-rounded:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-white) ;--tabs-bg:var(--ikp-colors-color-palette-600) }.dark .xl\\:ikp-tabs__trigger--variant_solid-rounded:is([aria-selected=true],[data-selected]),[data-theme=dark] .xl\\:ikp-tabs__trigger--variant_solid-rounded:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-gray-800) ;--tabs-bg:var(--ikp-colors-color-palette-300) }}@media screen and (min-width: 80em){.xl\\:ikp-tabs__trigger--isFitted_true{flex:1 1 0%}.xl\\:ikp-table__caption--variant_simple{color:var(--ikp-colors-gray-600)}.dark .xl\\:ikp-table__caption--variant_simple,[data-theme=dark] .xl\\:ikp-table__caption--variant_simple{color:var(--ikp-colors-gray-100)}.xl\\:ikp-table__td--variant_simple{border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .xl\\:ikp-table__td--variant_simple,[data-theme=dark] .xl\\:ikp-table__td--variant_simple{border-color:var(--ikp-colors-color-palette-700)}.xl\\:ikp-table__td--variant_simple[data-is-numeric=true]{text-align:end}.xl\\:ikp-table__th--variant_simple{color:var(--ikp-colors-gray-600);border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .xl\\:ikp-table__th--variant_simple,[data-theme=dark] .xl\\:ikp-table__th--variant_simple{color:var(--ikp-colors-gray-400);border-color:var(--ikp-colors-color-palette-700)}.xl\\:ikp-table__th--variant_simple[data-is-numeric=true]{text-align:end}.xl\\:ikp-table__tr--variant_tfoot th:last-of-type{border-bottom-width:0}.xl\\:ikp-table__caption--variant_striped{color:var(--ikp-colors-gray-600)}.dark .xl\\:ikp-table__caption--variant_striped,[data-theme=dark] .xl\\:ikp-table__caption--variant_striped{color:var(--ikp-colors-gray-100)}.xl\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,.xl\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) th{border-bottom-width:1px;border-color:var(--ikp-colors-color-palette-100)}.dark .xl\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,.dark .xl\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) th,[data-theme=dark] .xl\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,[data-theme=dark] .xl\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) th{border-color:var(--ikp-colors-color-palette-700)}.xl\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td{background:var(--ikp-colors-color-palette-100)}.dark .xl\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,[data-theme=dark] .xl\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td{background:var(--ikp-colors-color-palette-700)}.xl\\:ikp-table__td--variant_striped{border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .xl\\:ikp-table__td--variant_striped,[data-theme=dark] .xl\\:ikp-table__td--variant_striped{border-color:var(--ikp-colors-color-palette-700)}.xl\\:ikp-table__td--variant_striped[data-is-numeric=true]{text-align:end}.xl\\:ikp-table__tfoot--variant_striped th tr:last-of-type{border-bottom-width:0}.xl\\:ikp-table__th--variant_striped{color:var(--ikp-colors-gray-600);border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .xl\\:ikp-table__th--variant_striped,[data-theme=dark] .xl\\:ikp-table__th--variant_striped{color:var(--ikp-colors-gray-400);border-color:var(--ikp-colors-color-palette-700)}.xl\\:ikp-table__th--variant_striped[data-is-numeric=true]{text-align:end}.xl\\:ikp-table__caption--size_sm{font-size:var(--ikp-font-sizes-xs)}.xl\\:ikp-table__caption--size_sm,.xl\\:ikp-table__td--size_sm{padding-inline:var(--ikp-spacing-4);padding-block:var(--ikp-spacing-2)}.xl\\:ikp-table__td--size_sm{font-size:var(--ikp-font-sizes-sm);line-height:var(--ikp-line-heights-4)}.xl\\:ikp-table__th--size_sm{padding-inline:var(--ikp-spacing-4);padding-block:var(--ikp-spacing-1);line-height:var(--ikp-line-heights-4);font-size:var(--ikp-font-sizes-xs)}.xl\\:ikp-table__caption--size_md{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-2);font-size:var(--ikp-font-sizes-sm)}.xl\\:ikp-table__td--size_md{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-4);line-height:var(--ikp-line-heights-5)}.xl\\:ikp-table__th--size_md{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-3);line-height:var(--ikp-line-heights-4);font-size:var(--ikp-font-sizes-xs)}.xl\\:ikp-table__caption--size_lg{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-2);font-size:var(--ikp-font-sizes-md)}.xl\\:ikp-table__td--size_lg{padding-inline:var(--ikp-spacing-8);padding-block:var(--ikp-spacing-5);line-height:var(--ikp-line-heights-6)}.xl\\:ikp-table__th--size_lg{padding-inline:var(--ikp-spacing-8);padding-block:var(--ikp-spacing-4);line-height:var(--ikp-line-heights-5);font-size:var(--ikp-font-sizes-sm)}.xl\\:ikp-tooltip__content--variant_default{font-weight:var(--ikp-font-weights-normal)}.light .xl\\:ikp-tooltip__content--variant_default,[data-theme=light] .xl\\:ikp-tooltip__content--variant_default{background:var(--ikp-colors-white);box-shadow:0 8px 30px #0000001f;color:var(--ikp-colors-gray-800);--tooltip-arrow-bg:white }.dark .xl\\:ikp-tooltip__content--variant_default,[data-theme=dark] .xl\\:ikp-tooltip__content--variant_default{background:var(--ikp-colors-gray-dark-800);color:var(--ikp-colors-white-alpha-800);--tooltip-arrow-bg:var(--ikp-colors-gray-dark-800) }.xl\\:ikp-search-bar-trigger__container--size_expand{height:100%!important}.xl\\:ikp-search-bar-trigger__wrapper--size_expand{width:100%;height:100%}}@media screen and (min-width: 80em){@media screen and (min-width: 48em){.xl\\:ikp-search-bar-trigger__wrapper--size_compact{width:min(340px,100%);height:min(40px,100%)}}}@media screen and (min-width: 80em){.xl\\:ikp-search-bar-trigger__container--size_shrink{padding-inline:var(--ikp-spacing-2)!important;height:var(--ikp-sizes-9)!important}@media screen and (min-width: 48em){.xl\\:ikp-search-bar-trigger__container--size_shrink{padding-inline:var(--ikp-spacing-3)!important}.xl\\:ikp-search-bar-trigger__wrapper--size_shrink{width:min(340px,100%);height:min(36px,100%)}}}@media screen and (min-width: 80em){.xl\\:ikp-search-bar-trigger__text--size_shrink{display:none}@media screen and (min-width: 33em){.xl\\:ikp-search-bar-trigger__text--size_shrink{display:inline-block}}}@media screen and (min-width: 80em){.xl\\:ikp-search-bar-trigger__kbd--size_shrink{display:none}@media screen and (min-width: 33em){.xl\\:ikp-search-bar-trigger__kbd--size_shrink{display:flex}}}@media screen and (min-width: 80em){.xl\\:ikp-search-bar-trigger__icon--size_shrink{width:var(--ikp-sizes-5)!important;margin-right:var(--ikp-spacing-0)!important}@media screen and (min-width: 33em){.xl\\:ikp-search-bar-trigger__icon--size_shrink{width:var(--ikp-sizes-5)!important;margin-right:var(--ikp-spacing-2)!important}}}@media screen and (min-width: 80em){.xl\\:ikp-search-bar-trigger__container--size_medium{height:100%!important}}@media screen and (min-width: 80em){@media screen and (min-width: 48em){.xl\\:ikp-search-bar-trigger__wrapper--size_medium{width:min(500px,100%);height:min(3rem,100%)}}}@media screen and (min-width: 80em){.light .xl\\:ikp-search-bar-trigger__container--variant_emphasized,[data-theme=light] .xl\\:ikp-search-bar-trigger__container--variant_emphasized{border-color:var(--ikp-colors-gray-100);box-shadow:var(--ikp-shadows-sm)}.light .xl\\:ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]),[data-theme=light] .xl\\:ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]){box-shadow:var(--ikp-shadows-md);background:none!important}.dark .xl\\:ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]),[data-theme=dark] .xl\\:ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]){background:none!important}}@media screen and (min-width: 80em){.xl\\:ikp-search-bar-trigger__container--variant_subtle{border-color:var(--ikp-colors-gray-300);color:var(--ikp-colors-gray-500)!important}.dark .xl\\:ikp-search-bar-trigger__container--variant_subtle,[data-theme=dark] .xl\\:ikp-search-bar-trigger__container--variant_subtle{color:var(--ikp-colors-white-alpha-500)!important;border-color:var(--ikp-colors-white-alpha-300)}.xl\\:ikp-search-bar-trigger__container--variant_subtle:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-400);background:none!important}.dark .xl\\:ikp-search-bar-trigger__container--variant_subtle:is(:hover,[data-hover]),[data-theme=dark] .xl\\:ikp-search-bar-trigger__container--variant_subtle:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}}@media screen and (min-width: 80em){.xl\\:ikp-search-bar-trigger__kbd--variant_subtle{border:var(--ikp-borders-none);padding-inline:var(--ikp-spacing-0);color:var(--ikp-colors-gray-500)}.dark .xl\\:ikp-search-bar-trigger__kbd--variant_subtle,[data-theme=dark] .xl\\:ikp-search-bar-trigger__kbd--variant_subtle{color:var(--ikp-colors-white-alpha-500)}.xl\\:ikp-search-bar-trigger__icon--variant_subtle{width:18px}}@media screen and (min-width: 96em){.\\32xl\\:ikp-alert__container--variant_subtle{--alert-fg:var(--ikp-colors-color-palette-500);--alert-bg:var(--ikp-colors-color-palette-100)}.dark .\\32xl\\:ikp-alert__container--variant_subtle,[data-theme=dark] .\\32xl\\:ikp-alert__container--variant_subtle{--alert-fg:var(--ikp-colors-color-palette-200) ;--alert-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) ;--alert-bg:var(--alert-bg-alpha,var(--colors-color-palette-200)) }.\\32xl\\:ikp-alert__container--variant_left-accent{--alert-fg:var(--ikp-colors-color-palette-500);--alert-bg:var(--ikp-colors-color-palette-100);padding-inline-start:var(--ikp-spacing-3);border-inline-start-width:4px;border-inline-start-color:var(--alert-fg)}.dark .\\32xl\\:ikp-alert__container--variant_left-accent,[data-theme=dark] .\\32xl\\:ikp-alert__container--variant_left-accent{--alert-fg:var(--ikp-colors-color-palette-200) ;--alert-bg-alpha:color-mix(in srgb,transparent 84%,var(--colors-color-palette-200)) }.\\32xl\\:ikp-alert__container--variant_top-accent{--alert-fg:var(--ikp-colors-color-palette-500);--alert-bg:var(--ikp-colors-color-palette-100);padding-top:var(--ikp-spacing-2);border-top-width:4px;border-top-color:var(--alert-fg)}.dark .\\32xl\\:ikp-alert__container--variant_top-accent,[data-theme=dark] .\\32xl\\:ikp-alert__container--variant_top-accent{--alert-fg:var(--ikp-colors-color-palette-200) ;--alert-bg:var(--alert-bg-alpha,var(--colors-color-palette-200)) }.\\32xl\\:ikp-alert__container--variant_solid{--alert-fg:var(--ikp-colors-white);--alert-bg:var(--ikp-colors-color-palette-500);color:var(--alert-fg)}.dark .\\32xl\\:ikp-alert__container--variant_solid,[data-theme=dark] .\\32xl\\:ikp-alert__container--variant_solid{--alert-fg:var(--ikp-colors-gray-900) ;--alert-bg:var(--ikp-colors-color-palette-200) }.\\32xl\\:ikp-avatar__root--size_2xs{--avatar-size:var(--ikp-sizes-4);--avatar-font-size:var(--ikp-font-sizes-3xs)}.\\32xl\\:ikp-avatar__root--size_xs{--avatar-size:var(--ikp-sizes-6);--avatar-font-size:var(--ikp-font-sizes-2xs)}.\\32xl\\:ikp-avatar__root--size_sm{--avatar-size:var(--ikp-sizes-8);--avatar-font-size:var(--ikp-font-sizes-xs)}.\\32xl\\:ikp-avatar__root--size_md{--avatar-size:var(--ikp-sizes-12);--avatar-font-size:var(--ikp-font-sizes-md)}.\\32xl\\:ikp-avatar__root--size_lg{--avatar-size:var(--ikp-sizes-16);--avatar-font-size:var(--ikp-font-sizes-lg)}.\\32xl\\:ikp-avatar__root--size_xl{--avatar-size:var(--ikp-sizes-24);--avatar-font-size:var(--ikp-font-sizes-3xl)}.\\32xl\\:ikp-avatar__root--size_2xl{--avatar-size:var(--ikp-sizes-32);--avatar-font-size:var(--ikp-font-sizes-4xl)}.\\32xl\\:ikp-card__container--variant_elevated{--card-shadow:var(--ikp-shadows-base)}.dark .\\32xl\\:ikp-card__container--variant_elevated,[data-theme=dark] .\\32xl\\:ikp-card__container--variant_elevated{--card-bg:var(--ikp-colors-gray-700) }.\\32xl\\:ikp-card__container--variant_outline{--card-border-width:1px;--card-border-color:var(--ikp-colors-chakra-border-color)}.dark .\\32xl\\:ikp-card__container--variant_outline,[data-theme=dark] .\\32xl\\:ikp-card__container--variant_outline{--card-border-color:var(--ikp-colors-white-alpha-300) }.\\32xl\\:ikp-card__container--variant_filled{--card-bg:var(--ikp-colors-chakra-subtle-bg)}.\\32xl\\:ikp-card__body--variant_unstyled,.\\32xl\\:ikp-card__footer--variant_unstyled,.\\32xl\\:ikp-card__header--variant_unstyled{--card-padding:0}.\\32xl\\:ikp-card__container--size_sm{--card-radius:var(--ikp-radii-base);--card-padding:var(--ikp-space-3)}.\\32xl\\:ikp-card__container--size_md{--card-radius:var(--ikp-radii-md);--card-padding:var(--ikp-space-5)}.\\32xl\\:ikp-card__container--size_lg{--card-radius:var(--ikp-radii-xl);--card-padding:var(--ikp-space-7)}.\\32xl\\:ikp-checkbox__control--size_sm{--checkbox-size:var(--ikp-sizes-3)}.\\32xl\\:ikp-checkbox__label--size_sm{font-size:var(--ikp-font-sizes-sm)}.\\32xl\\:ikp-checkbox__icon--size_sm{font-size:var(--ikp-font-sizes-3xs)}.\\32xl\\:ikp-checkbox__control--size_md{--checkbox-size:var(--ikp-sizes-4)}.\\32xl\\:ikp-checkbox__label--size_md{font-size:var(--ikp-font-sizes-md)}.\\32xl\\:ikp-checkbox__icon--size_md{font-size:var(--ikp-font-sizes-2xs)}.\\32xl\\:ikp-checkbox__control--size_lg{--checkbox-size:var(--ikp-sizes-5)}.\\32xl\\:ikp-checkbox__label--size_lg{font-size:var(--ikp-font-sizes-lg)}.\\32xl\\:ikp-checkbox__icon--size_lg{font-size:var(--ikp-font-sizes-2xs)}.\\32xl\\:ikp-checkbox__control--shape_circular{border-radius:var(--ikp-radii-full)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){background:var(--ikp-colors-gray-900)}.dark .\\32xl\\:ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]),[data-theme=dark] .\\32xl\\:ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){background:var(--ikp-colors-white-alpha-900);border-color:var(--ikp-colors-white-alpha-900)}.\\32xl\\:ikp-checkbox__control--variant_neutral:is(:checked,[data-checked],[aria-checked=true],[data-state=checked]){border-color:var(--ikp-colors-gray-900)}.\\32xl\\:ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){background:var(--ikp-colors-gray-900)}.dark .\\32xl\\:ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]),[data-theme=dark] .\\32xl\\:ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){background:var(--ikp-colors-white-alpha-900);border-color:var(--ikp-colors-white-alpha-900)}.\\32xl\\:ikp-checkbox__control--variant_neutral:is(:indeterminate,[data-indeterminate],[aria-checked=mixed],[data-state=indeterminate]){border-color:var(--ikp-colors-gray-900)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-input__addon--size_lg,.\\32xl\\:ikp-input__field--size_lg,.\\32xl\\:ikp-input__group--size_lg{--input-font-size:var(--ikp-font-sizes-lg);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-12)}.\\32xl\\:ikp-input__addon--size_md,.\\32xl\\:ikp-input__field--size_md,.\\32xl\\:ikp-input__group--size_md{--input-font-size:var(--ikp-font-sizes-md);--input-padding:var(--ikp-space-4);--input-border-radius:var(--ikp-radii-md);--input-height:var(--ikp-sizes-10)}.\\32xl\\:ikp-input__addon--size_sm,.\\32xl\\:ikp-input__field--size_sm,.\\32xl\\:ikp-input__group--size_sm{--input-font-size:var(--ikp-font-sizes-sm);--input-padding:var(--ikp-space-3);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-8)}.\\32xl\\:ikp-input__addon--size_xs,.\\32xl\\:ikp-input__field--size_xs,.\\32xl\\:ikp-input__group--size_xs{--input-font-size:var(--ikp-font-sizes-xs);--input-padding:var(--ikp-space-2);--input-border-radius:var(--ikp-radii-sm);--input-height:var(--ikp-sizes-6)}.\\32xl\\:ikp-input__field--variant_outline{border:1px solid;border-color:inherit;background:inherit}}@media screen and (min-width: 96em){.\\32xl\\:ikp-input__field--variant_outline:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.\\32xl\\:ikp-input__field--variant_outline[aria-invalid=true],.\\32xl\\:ikp-input__field--variant_outline[data-invalid] .\\32xl\\:ikp-input__field--variant_outline{border-color:var(--input-error-border-color);box-shadow:0 0 0 1px var(--input-error-border-color)}.\\32xl\\:ikp-input__field--variant_outline:is(:focus-visible,[data-focus-visible]){z-index:1;border-color:var(--input-focus-border-color);box-shadow:0 0 0 1px var(--input-focus-border-color)}.\\32xl\\:ikp-input__field--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-300)}.dark .\\32xl\\:ikp-input__field--variant_outline:is(:hover,[data-hover]),[data-theme=dark] .\\32xl\\:ikp-input__field--variant_outline:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-input__addon--variant_outline{border:1px solid;border-color:inherit;background:var(--ikp-colors-gray-100)}.dark .\\32xl\\:ikp-input__addon--variant_outline,[data-theme=dark] .\\32xl\\:ikp-input__addon--variant_outline{border-color:var(--ikp-colors-white-alpha-50);background:var(--ikp-colors-white-alpha-300)}.\\32xl\\:ikp-input__field--variant_filled{border:2px solid;border-color:var(--ikp-colors-transparent);background:var(--ikp-colors-gray-100)}.dark .\\32xl\\:ikp-input__field--variant_filled,[data-theme=dark] .\\32xl\\:ikp-input__field--variant_filled{background:var(--ikp-colors-white-alpha-50)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-input__field--variant_filled:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.\\32xl\\:ikp-input__field--variant_filled[aria-invalid=true],.\\32xl\\:ikp-input__field--variant_filled[data-invalid] .\\32xl\\:ikp-input__field--variant_filled{border-color:var(--input-error-border-color)}.\\32xl\\:ikp-input__field--variant_filled:is(:focus-visible,[data-focus-visible]){background:var(--ikp-colors-transparent);border-color:var(--input-focus-border-color)}.\\32xl\\:ikp-input__field--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-gray-200)}.dark .\\32xl\\:ikp-input__field--variant_filled:is(:hover,[data-hover]),[data-theme=dark] .\\32xl\\:ikp-input__field--variant_filled:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-100)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-input__addon--variant_filled{border:2px solid;border-color:var(--ikp-colors-transparent);background:var(--ikp-colors-gray-100)}.dark .\\32xl\\:ikp-input__addon--variant_filled,[data-theme=dark] .\\32xl\\:ikp-input__addon--variant_filled{background:var(--ikp-colors-white-alpha-50)}.\\32xl\\:ikp-input__field--variant_flushed{border-bottom:1px solid;border-color:inherit;border-radius:0;padding-inline:var(--ikp-spacing-0);background:var(--ikp-colors-transparent)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-input__field--variant_flushed:is(:read-only,[data-read-only]){box-shadow:var(--ikp-shadows-none)!important;-webkit-user-select:all;user-select:all}.\\32xl\\:ikp-input__field--variant_flushed[aria-invalid=true],.\\32xl\\:ikp-input__field--variant_flushed[data-invalid] .\\32xl\\:ikp-input__field--variant_flushed{border-color:var(--input-error-border-color);box-shadow:0 1px 0 0 var(--input-error-border-color)}.\\32xl\\:ikp-input__field--variant_flushed:is(:focus-visible,[data-focus-visible]){border-color:var(--input-focus-border-color);box-shadow:0 1px 0 0 var(--input-focus-border-color)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-input__addon--variant_flushed{border-bottom:2px solid;border-color:inherit;border-radius:0;padding-inline:var(--ikp-spacing-0);background:var(--ikp-colors-transparent)}.\\32xl\\:ikp-input__addon--variant_unstyled,.\\32xl\\:ikp-input__field--variant_unstyled{background:var(--ikp-colors-transparent);padding-inline:var(--ikp-spacing-0);height:var(--ikp-sizes-auto)}.\\32xl\\:ikp-modal__content--size_xs{max-width:var(--ikp-sizes-xs)}.\\32xl\\:ikp-modal__content--size_sm{max-width:var(--ikp-sizes-sm)}.\\32xl\\:ikp-modal__content--size_md{max-width:var(--ikp-sizes-md)}.\\32xl\\:ikp-modal__content--size_lg{max-width:var(--ikp-sizes-lg)}.\\32xl\\:ikp-modal__content--size_xl{max-width:var(--ikp-sizes-xl)}.\\32xl\\:ikp-modal__content--size_2xl{max-width:var(--ikp-sizes-2xl)}.\\32xl\\:ikp-modal__content--size_3xl{max-width:var(--ikp-sizes-3xl)}.\\32xl\\:ikp-modal__content--size_4xl{max-width:var(--ikp-sizes-4xl)}.\\32xl\\:ikp-modal__content--size_5xl{max-width:var(--ikp-sizes-5xl)}.\\32xl\\:ikp-modal__content--size_6xl{max-width:var(--ikp-sizes-6xl)}.\\32xl\\:ikp-modal__content--size_full{max-width:100vw;min-height:100vh;margin-block:var(--ikp-spacing-0);border-radius:0}.\\32xl\\:ikp-modal__container--scrollOverflowBehavior_inside{overflow:hidden}.\\32xl\\:ikp-modal__content--scrollOverflowBehavior_inside{max-height:calc(100% - 7.5rem)}.\\32xl\\:ikp-modal__container--scrollOverflowBehavior_outside{overflow:auto}.\\32xl\\:ikp-modal__container--isCentered_false{align-items:flex-start}.\\32xl\\:ikp-modal__content--isCentered_false{margin-block:var(--ikp-spacing-16)}.\\32xl\\:ikp-modal__container--isCentered_true{align-items:center}.\\32xl\\:ikp-modal__content--isCentered_true{margin-block:auto;margin-inline:auto}.\\32xl\\:ikp-modal__container--variant_clickThrough{pointer-events:none;z-index:var(--ikp-z-index-modal) - 1}.\\32xl\\:ikp-modal__content--variant_clickThrough{pointer-events:auto}.\\32xl\\:ikp-select__label--size_sm{font-size:.875rem;line-height:1.25rem}.\\32xl\\:ikp-select__trigger--size_sm{padding-inline:var(--ikp-spacing-2\\.5);height:var(--ikp-sizes-9);min-width:var(--ikp-sizes-9);font-size:var(--ikp-font-sizes-sm);gap:var(--ikp-spacing-2)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-select__trigger--size_sm :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-select__item--size_sm{font-size:.875rem;line-height:1.25rem;padding-inline:var(--ikp-spacing-2);height:var(--ikp-sizes-9)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-select__itemIndicator--size_sm :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-select__itemGroupLabel--size_sm{padding-inline:var(--ikp-spacing-2);padding-block:var(--ikp-spacing-1\\.5)}.\\32xl\\:ikp-select__content--size_sm{padding:var(--ikp-spacing-0\\.5);gap:var(--ikp-spacing-1)}.\\32xl\\:ikp-select__label--size_md{font-size:.875rem;line-height:1.25rem}.\\32xl\\:ikp-select__trigger--size_md{padding-inline:var(--ikp-spacing-3);height:var(--ikp-sizes-10);min-width:var(--ikp-sizes-10);font-size:var(--ikp-font-sizes-md);gap:var(--ikp-spacing-2)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-select__trigger--size_md :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-select__item--size_md{font-size:1rem;line-height:1.5rem;padding-inline:var(--ikp-spacing-2);height:var(--ikp-sizes-10)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-select__itemIndicator--size_md :where(svg){width:var(--ikp-sizes-4);height:var(--ikp-sizes-4)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-select__itemGroupLabel--size_md{padding-inline:var(--ikp-spacing-2);padding-block:var(--ikp-spacing-1\\.5)}.\\32xl\\:ikp-select__content--size_md{padding:var(--ikp-spacing-1);gap:var(--ikp-spacing-1)}.\\32xl\\:ikp-select__label--size_lg{font-size:.875rem;line-height:1.25rem}.\\32xl\\:ikp-select__trigger--size_lg{padding-inline:var(--ikp-spacing-3\\.5);height:var(--ikp-sizes-11);min-width:var(--ikp-sizes-11);font-size:var(--ikp-font-sizes-md);gap:var(--ikp-spacing-2)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-select__trigger--size_lg :where(svg){width:var(--ikp-sizes-5);height:var(--ikp-sizes-5)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-select__item--size_lg{font-size:1rem;line-height:1.5rem;padding-inline:var(--ikp-spacing-2);height:var(--ikp-sizes-11)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-select__itemIndicator--size_lg :where(svg){width:var(--ikp-sizes-5);height:var(--ikp-sizes-5)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-select__itemGroupLabel--size_lg{padding-inline:var(--ikp-spacing-2);padding-block:var(--ikp-spacing-1\\.5)}.\\32xl\\:ikp-select__content--size_lg{padding:var(--ikp-spacing-1\\.5);gap:var(--ikp-spacing-1)}.\\32xl\\:ikp-select__trigger--variant_outline{background:var(--ikp-colors-white);border-width:1px}.dark .\\32xl\\:ikp-select__trigger--variant_outline,[data-theme=dark] .\\32xl\\:ikp-select__trigger--variant_outline{background:var(--ikp-colors-color-palette-800)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-select__trigger--variant_outline:is(:focus,[data-focus]){border-color:var(--ikp-colors-color-palette-200)}.dark .\\32xl\\:ikp-select__trigger--variant_outline:is(:focus,[data-focus]),[data-theme=dark] .\\32xl\\:ikp-select__trigger--variant_outline:is(:focus,[data-focus]){border-color:var(--ikp-colors-color-palette-800)}.\\32xl\\:ikp-select__trigger--variant_outline:is(:focus,[data-focus]){box-shadow:var(--ikp-shadows-accent)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-select__trigger--variant_ghost:is(:focus,[data-focus]){background:var(--ikp-colors-color-palette-100)}.dark .\\32xl\\:ikp-select__trigger--variant_ghost:is(:focus,[data-focus]),[data-theme=dark] .\\32xl\\:ikp-select__trigger--variant_ghost:is(:focus,[data-focus]){background:var(--ikp-colors-color-palette-900)}.\\32xl\\:ikp-select__trigger--variant_ghost:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-100)}.dark .\\32xl\\:ikp-select__trigger--variant_ghost:is(:hover,[data-hover]),[data-theme=dark] .\\32xl\\:ikp-select__trigger--variant_ghost:is(:hover,[data-hover]){background:var(--ikp-colors-color-palette-900)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-select__trigger--variant_ikpOutline{background:var(--ikp-colors-white);border-width:1px}.dark .\\32xl\\:ikp-select__trigger--variant_ikpOutline,[data-theme=dark] .\\32xl\\:ikp-select__trigger--variant_ikpOutline{background:var(--ikp-colors-color-palette-900)}.\\32xl\\:ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]){border-color:var(--ikp-colors-color-palette-200)}.dark .\\32xl\\:ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]),[data-theme=dark] .\\32xl\\:ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]){border-color:var(--ikp-colors-white-alpha-300)}.\\32xl\\:ikp-select__trigger--variant_ikpOutline:is(:focus,[data-focus]){box-shadow:var(--ikp-shadows-accent)}.\\32xl\\:ikp-select__trigger--variant_ikpOutline:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-300)}.dark .\\32xl\\:ikp-select__trigger--variant_ikpOutline:is(:hover,[data-hover]),[data-theme=dark] .\\32xl\\:ikp-select__trigger--variant_ikpOutline:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-switch__root--size_sm{--switch-track-width:1.375rem;--switch-track-height:var(--ikp-sizes-3)}.\\32xl\\:ikp-switch__root--size_md{--switch-track-width:1.875rem;--switch-track-height:var(--ikp-sizes-4)}.\\32xl\\:ikp-switch__root--size_lg{--switch-track-width:2.875rem;--switch-track-height:var(--ikp-sizes-6)}.\\32xl\\:ikp-switch__control--size_xss{width:24px;height:12px}.\\32xl\\:ikp-switch__thumb--size_xss{width:12px;height:12px}.\\32xl\\:ikp-tabs__trigger--size_sm{padding-block:var(--ikp-spacing-1);padding-inline:var(--ikp-spacing-4);font-size:var(--ikp-font-sizes-sm)}.\\32xl\\:ikp-tabs__trigger--size_md{font-size:var(--ikp-font-sizes-md);padding-block:var(--ikp-spacing-2);padding-inline:var(--ikp-spacing-4)}.\\32xl\\:ikp-tabs__trigger--size_lg{font-size:var(--ikp-font-sizes-lg);padding-block:var(--ikp-spacing-3);padding-inline:var(--ikp-spacing-4)}.\\32xl\\:ikp-tabs__list--variant_line{--tabs-border-color:2px solid;border-color:inherit}.\\32xl\\:ikp-tabs__trigger--variant_line{--tabs-border-color:2px solid;border-color:var(--ikp-colors-transparent);--tabs-margin-prop:-2px;color:var(--tabs-color);background:var(--tabs-bg)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-600) }.dark .\\32xl\\:ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]),[data-theme=dark] .\\32xl\\:ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-300) }.\\32xl\\:ikp-tabs__trigger--variant_line:is([aria-selected=true],[data-selected]){border-color:currentColor}.\\32xl\\:ikp-tabs__trigger--variant_line:is(:active,[data-active]){--tabs-bg:var(--ikp-colors-gray-200) }.dark .\\32xl\\:ikp-tabs__trigger--variant_line:is(:active,[data-active]),[data-theme=dark] .\\32xl\\:ikp-tabs__trigger--variant_line:is(:active,[data-active]){--tabs-bg:var(--ikp-colors-white-alpha-300) }.\\32xl\\:ikp-tabs__trigger--variant_line:is(:disabled,[disabled],[data-disabled]):is(:active,[data-active]){background:none}}@media screen and (min-width: 96em){.\\32xl\\:ikp-tabs__list--variant_enclosed{margin-bottom:-1px;border-bottom:1px solid;border-color:inherit}.\\32xl\\:ikp-tabs__trigger--variant_enclosed{border-top-left-radius:var(--ikp-radii-md);border-top-right-radius:var(--ikp-radii-md);border:1px solid;border-color:var(--ikp-colors-transparent);margin-bottom:-1px;--tabs-border-color:transparent;color:var(--tabs-color)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-600) ;--tabs-border-color:var(--ikp-colors-white) }.dark .\\32xl\\:ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]),[data-theme=dark] .\\32xl\\:ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-color-palette-300) ;--tabs-border-color:var(--ikp-colors-gray-800) }.\\32xl\\:ikp-tabs__trigger--variant_enclosed:is([aria-selected=true],[data-selected]){border-color:inherit;border-bottom-color:var(--tabs-border-color)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-tabs__list--variant_enclosed-colored{margin-bottom:-1px;border-bottom:1px solid;border-color:inherit}.\\32xl\\:ikp-tabs__trigger--variant_enclosed-colored{border:1px solid;border-color:inherit;--tabs-bg:var(--ikp-colors-gray-50);margin-bottom:-1px;color:var(--tabs-color);background:var(--tabs-bg)}.dark .\\32xl\\:ikp-tabs__trigger--variant_enclosed-colored,[data-theme=dark] .\\32xl\\:ikp-tabs__trigger--variant_enclosed-colored{--tabs-bg:var(--ikp-colors-white-alpha-50) }}@media screen and (min-width: 96em){.\\32xl\\:ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]){--tabs-bg:var(--ikp-colors-white) ;--tabs-color:var(--ikp-colors-color-palette-600) }.dark .\\32xl\\:ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]),[data-theme=dark] .\\32xl\\:ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]){--tabs-bg:var(--ikp-colors-gray-800) ;--tabs-color:var(--ikp-colors-color-palette-300) }.\\32xl\\:ikp-tabs__trigger--variant_enclosed-colored:is([aria-selected=true],[data-selected]){border-color:inherit;border-top-color:currentColor;border-bottom-color:var(--ikp-colors-transparent)}.\\32xl\\:ikp-tabs__trigger--variant_enclosed-colored _notLast{margin-inline-end:-1px}.\\32xl\\:ikp-tabs__trigger--variant_soft-rounded{border-radius:var(--ikp-radii-full);font-weight:var(--ikp-font-weights-semibold);color:var(--ikp-colors-gray-600)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-tabs__trigger--variant_soft-rounded:is([aria-selected=true],[data-selected]){color:var(--ikp-colors-color-palette-700);background:var(--ikp-colors-color-palette-100)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-tabs__trigger--variant_solid-rounded{border-radius:var(--ikp-radii-full);font-weight:var(--ikp-font-weights-semibold);--tabs-color:var(--ikp-colors-gray-600);color:var(--tabs-color);background:var(--tabs-bg)}.dark .\\32xl\\:ikp-tabs__trigger--variant_solid-rounded,[data-theme=dark] .\\32xl\\:ikp-tabs__trigger--variant_solid-rounded{--tabs-color:inherit }.\\32xl\\:ikp-tabs__trigger--variant_solid-rounded:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-white) ;--tabs-bg:var(--ikp-colors-color-palette-600) }.dark .\\32xl\\:ikp-tabs__trigger--variant_solid-rounded:is([aria-selected=true],[data-selected]),[data-theme=dark] .\\32xl\\:ikp-tabs__trigger--variant_solid-rounded:is([aria-selected=true],[data-selected]){--tabs-color:var(--ikp-colors-gray-800) ;--tabs-bg:var(--ikp-colors-color-palette-300) }}@media screen and (min-width: 96em){.\\32xl\\:ikp-tabs__trigger--isFitted_true{flex:1 1 0%}.\\32xl\\:ikp-table__caption--variant_simple{color:var(--ikp-colors-gray-600)}.dark .\\32xl\\:ikp-table__caption--variant_simple,[data-theme=dark] .\\32xl\\:ikp-table__caption--variant_simple{color:var(--ikp-colors-gray-100)}.\\32xl\\:ikp-table__td--variant_simple{border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .\\32xl\\:ikp-table__td--variant_simple,[data-theme=dark] .\\32xl\\:ikp-table__td--variant_simple{border-color:var(--ikp-colors-color-palette-700)}.\\32xl\\:ikp-table__td--variant_simple[data-is-numeric=true]{text-align:end}.\\32xl\\:ikp-table__th--variant_simple{color:var(--ikp-colors-gray-600);border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .\\32xl\\:ikp-table__th--variant_simple,[data-theme=dark] .\\32xl\\:ikp-table__th--variant_simple{color:var(--ikp-colors-gray-400);border-color:var(--ikp-colors-color-palette-700)}.\\32xl\\:ikp-table__th--variant_simple[data-is-numeric=true]{text-align:end}.\\32xl\\:ikp-table__tr--variant_tfoot th:last-of-type{border-bottom-width:0}.\\32xl\\:ikp-table__caption--variant_striped{color:var(--ikp-colors-gray-600)}.dark .\\32xl\\:ikp-table__caption--variant_striped,[data-theme=dark] .\\32xl\\:ikp-table__caption--variant_striped{color:var(--ikp-colors-gray-100)}.\\32xl\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,.\\32xl\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) th{border-bottom-width:1px;border-color:var(--ikp-colors-color-palette-100)}.dark .\\32xl\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,.dark .\\32xl\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) th,[data-theme=dark] .\\32xl\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,[data-theme=dark] .\\32xl\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) th{border-color:var(--ikp-colors-color-palette-700)}.\\32xl\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td{background:var(--ikp-colors-color-palette-100)}.dark .\\32xl\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td,[data-theme=dark] .\\32xl\\:ikp-table__tbody--variant_striped tr:nth-of-type(odd) td{background:var(--ikp-colors-color-palette-700)}.\\32xl\\:ikp-table__td--variant_striped{border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .\\32xl\\:ikp-table__td--variant_striped,[data-theme=dark] .\\32xl\\:ikp-table__td--variant_striped{border-color:var(--ikp-colors-color-palette-700)}.\\32xl\\:ikp-table__td--variant_striped[data-is-numeric=true]{text-align:end}.\\32xl\\:ikp-table__tfoot--variant_striped th tr:last-of-type{border-bottom-width:0}.\\32xl\\:ikp-table__th--variant_striped{color:var(--ikp-colors-gray-600);border-bottom:var(--ikp-borders-1px);border-color:var(--ikp-colors-color-palette-100)}.dark .\\32xl\\:ikp-table__th--variant_striped,[data-theme=dark] .\\32xl\\:ikp-table__th--variant_striped{color:var(--ikp-colors-gray-400);border-color:var(--ikp-colors-color-palette-700)}.\\32xl\\:ikp-table__th--variant_striped[data-is-numeric=true]{text-align:end}.\\32xl\\:ikp-table__caption--size_sm{font-size:var(--ikp-font-sizes-xs)}.\\32xl\\:ikp-table__caption--size_sm,.\\32xl\\:ikp-table__td--size_sm{padding-inline:var(--ikp-spacing-4);padding-block:var(--ikp-spacing-2)}.\\32xl\\:ikp-table__td--size_sm{font-size:var(--ikp-font-sizes-sm);line-height:var(--ikp-line-heights-4)}.\\32xl\\:ikp-table__th--size_sm{padding-inline:var(--ikp-spacing-4);padding-block:var(--ikp-spacing-1);line-height:var(--ikp-line-heights-4);font-size:var(--ikp-font-sizes-xs)}.\\32xl\\:ikp-table__caption--size_md{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-2);font-size:var(--ikp-font-sizes-sm)}.\\32xl\\:ikp-table__td--size_md{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-4);line-height:var(--ikp-line-heights-5)}.\\32xl\\:ikp-table__th--size_md{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-3);line-height:var(--ikp-line-heights-4);font-size:var(--ikp-font-sizes-xs)}.\\32xl\\:ikp-table__caption--size_lg{padding-inline:var(--ikp-spacing-6);padding-block:var(--ikp-spacing-2);font-size:var(--ikp-font-sizes-md)}.\\32xl\\:ikp-table__td--size_lg{padding-inline:var(--ikp-spacing-8);padding-block:var(--ikp-spacing-5);line-height:var(--ikp-line-heights-6)}.\\32xl\\:ikp-table__th--size_lg{padding-inline:var(--ikp-spacing-8);padding-block:var(--ikp-spacing-4);line-height:var(--ikp-line-heights-5);font-size:var(--ikp-font-sizes-sm)}.\\32xl\\:ikp-tooltip__content--variant_default{font-weight:var(--ikp-font-weights-normal)}.light .\\32xl\\:ikp-tooltip__content--variant_default,[data-theme=light] .\\32xl\\:ikp-tooltip__content--variant_default{background:var(--ikp-colors-white);box-shadow:0 8px 30px #0000001f;color:var(--ikp-colors-gray-800);--tooltip-arrow-bg:white }.dark .\\32xl\\:ikp-tooltip__content--variant_default,[data-theme=dark] .\\32xl\\:ikp-tooltip__content--variant_default{background:var(--ikp-colors-gray-dark-800);color:var(--ikp-colors-white-alpha-800);--tooltip-arrow-bg:var(--ikp-colors-gray-dark-800) }.\\32xl\\:ikp-search-bar-trigger__container--size_expand{height:100%!important}.\\32xl\\:ikp-search-bar-trigger__wrapper--size_expand{width:100%;height:100%}}@media screen and (min-width: 96em){@media screen and (min-width: 48em){.\\32xl\\:ikp-search-bar-trigger__wrapper--size_compact{width:min(340px,100%);height:min(40px,100%)}}}@media screen and (min-width: 96em){.\\32xl\\:ikp-search-bar-trigger__container--size_shrink{padding-inline:var(--ikp-spacing-2)!important;height:var(--ikp-sizes-9)!important}@media screen and (min-width: 48em){.\\32xl\\:ikp-search-bar-trigger__container--size_shrink{padding-inline:var(--ikp-spacing-3)!important}.\\32xl\\:ikp-search-bar-trigger__wrapper--size_shrink{width:min(340px,100%);height:min(36px,100%)}}}@media screen and (min-width: 96em){.\\32xl\\:ikp-search-bar-trigger__text--size_shrink{display:none}@media screen and (min-width: 33em){.\\32xl\\:ikp-search-bar-trigger__text--size_shrink{display:inline-block}}}@media screen and (min-width: 96em){.\\32xl\\:ikp-search-bar-trigger__kbd--size_shrink{display:none}@media screen and (min-width: 33em){.\\32xl\\:ikp-search-bar-trigger__kbd--size_shrink{display:flex}}}@media screen and (min-width: 96em){.\\32xl\\:ikp-search-bar-trigger__icon--size_shrink{width:var(--ikp-sizes-5)!important;margin-right:var(--ikp-spacing-0)!important}@media screen and (min-width: 33em){.\\32xl\\:ikp-search-bar-trigger__icon--size_shrink{width:var(--ikp-sizes-5)!important;margin-right:var(--ikp-spacing-2)!important}}}@media screen and (min-width: 96em){.\\32xl\\:ikp-search-bar-trigger__container--size_medium{height:100%!important}}@media screen and (min-width: 96em){@media screen and (min-width: 48em){.\\32xl\\:ikp-search-bar-trigger__wrapper--size_medium{width:min(500px,100%);height:min(3rem,100%)}}}@media screen and (min-width: 96em){.light .\\32xl\\:ikp-search-bar-trigger__container--variant_emphasized,[data-theme=light] .\\32xl\\:ikp-search-bar-trigger__container--variant_emphasized{border-color:var(--ikp-colors-gray-100);box-shadow:var(--ikp-shadows-sm)}.light .\\32xl\\:ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]),[data-theme=light] .\\32xl\\:ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]){box-shadow:var(--ikp-shadows-md);background:none!important}.dark .\\32xl\\:ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]),[data-theme=dark] .\\32xl\\:ikp-search-bar-trigger__container--variant_emphasized:is(:hover,[data-hover]){background:none!important}}@media screen and (min-width: 96em){.\\32xl\\:ikp-search-bar-trigger__container--variant_subtle{border-color:var(--ikp-colors-gray-300);color:var(--ikp-colors-gray-500)!important}.dark .\\32xl\\:ikp-search-bar-trigger__container--variant_subtle,[data-theme=dark] .\\32xl\\:ikp-search-bar-trigger__container--variant_subtle{color:var(--ikp-colors-white-alpha-500)!important;border-color:var(--ikp-colors-white-alpha-300)}.\\32xl\\:ikp-search-bar-trigger__container--variant_subtle:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-400);background:none!important}.dark .\\32xl\\:ikp-search-bar-trigger__container--variant_subtle:is(:hover,[data-hover]),[data-theme=dark] .\\32xl\\:ikp-search-bar-trigger__container--variant_subtle:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-400)}}@media screen and (min-width: 96em){.\\32xl\\:ikp-search-bar-trigger__kbd--variant_subtle{border:var(--ikp-borders-none);padding-inline:var(--ikp-spacing-0);color:var(--ikp-colors-gray-500)}.dark .\\32xl\\:ikp-search-bar-trigger__kbd--variant_subtle,[data-theme=dark] .\\32xl\\:ikp-search-bar-trigger__kbd--variant_subtle{color:var(--ikp-colors-white-alpha-500)}.\\32xl\\:ikp-search-bar-trigger__icon--variant_subtle{width:18px}}}@layer utilities{.ikp-justify_start{justify-content:start}.ikp-h_min\\(calc\\(_85vh_-_72px_\\)\\,_calc\\(_850px_-_72px_-_275px_\\)\\){height:min(calc(85vh - 72px),503px)}.ikp-h_0px{height:0px}.ikp-pt_1{padding-top:var(--ikp-spacing-1)}.ikp-h_10px{height:10px}.ikp-w_10px{width:10px}.ikp-border-l_1px_solid_transparent{border-left:1px solid transparent}.ikp-border-l_none{border-left:var(--ikp-borders-none)}.ikp-border-t_1px_solid_transparent{border-top:1px solid transparent}.ikp-border-t_none{border-top:var(--ikp-borders-none)}.ikp-touch_none{touch-action:none}.ikp-p_1px{padding:1px}.ikp-text_gray\\.500{color:var(--ikp-colors-gray-500)}.ikp-text_inkeepPrimary\\.textSubtle{color:var(--ikp-colors-inkeep-primary-text-subtle)}.dark .dark\\:ikp-text_grayDark\\.50,[data-theme=dark] .dark\\:ikp-text_grayDark\\.50{color:var(--ikp-colors-gray-dark-50)}.light .light\\:ikp-bg_inkeepPrimary\\.medium,[data-theme=light] .light\\:ikp-bg_inkeepPrimary\\.medium{background:var(--ikp-colors-inkeep-primary-medium)}.ikp-bg_inherit{background:inherit}.ikp-text_red\\.500{color:var(--ikp-colors-red-500)}.dark .dark\\:ikp-text_red\\.300,[data-theme=dark] .dark\\:ikp-text_red\\.300{color:var(--ikp-colors-red-300)}.\\[\\&_div\\]\\:ikp-d_contents div,.ikp-d_contents{display:contents}.ikp-w_1em{width:1em}.ikp-min-h_1em{min-height:1em}.ikp-mx_5px{margin-inline:5px}.ikp-fs_\\.45rem{font-size:.45rem}.ikp-transform_translateY\\(-1px\\){transform:translateY(-1px)}.light .light\\:ikp-text_inkeepPrimary\\.textBold,[data-theme=light] .light\\:ikp-text_inkeepPrimary\\.textBold{color:var(--ikp-colors-inkeep-primary-text-bold)}.dark .dark\\:ikp-text_white,[data-theme=dark] .dark\\:ikp-text_white{color:var(--ikp-colors-white)}.ikp-mr_0\\.5{margin-right:var(--ikp-spacing-0\\.5)}.ikp-backdrop_blur\\(3px\\){backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px)}.ikp-max-h_unset{max-height:unset}.ikp-fs_16px{font-size:16px}.ikp-rounded_inherit{border-radius:inherit}.\\[\\&\\:\\:after\\]\\:ikp-pos_absolute:after{position:absolute}.\\[\\&\\:\\:after\\]\\:ikp-content_\\"\\":after{content:""}.\\[\\&\\:\\:after\\]\\:ikp-left_0px:after{left:0}.\\[\\&\\:\\:after\\]\\:ikp-top_100\\%:after{top:100%}.\\[\\&\\:\\:after\\]\\:ikp-h_1rem:after{height:1rem}.\\[\\&\\:\\:after\\]\\:ikp-w_100\\%:after{width:100%}.\\[\\&\\:\\:after\\]\\:ikp-text_white:after{color:var(--ikp-colors-white)}.dark .\\[\\&\\:\\:after\\]\\:dark\\:ikp-text_grayDark\\.900:after,[data-theme=dark] .\\[\\&\\:\\:after\\]\\:dark\\:ikp-text_grayDark\\.900:after{color:var(--ikp-colors-gray-dark-900)}.\\[\\&\\:\\:after\\]\\:ikp-bg_linear-gradient\\(currentColor\\,_transparent\\):after{background:linear-gradient(currentColor,transparent)}.\\[\\&\\:\\:after\\]\\:ikp-z_1:after{z-index:1}.dark .dark\\:ikp-bg_grayDark\\.900,[data-theme=dark] .dark\\:ikp-bg_grayDark\\.900{background:var(--ikp-colors-gray-dark-900)}.ikp-white-space_pre-wrap{white-space:pre-wrap}.ikp-max-h_200px{max-height:200px}.ikp-overflow-y_auto\\!{overflow-y:auto!important}.ikp-text_inherit{color:inherit}.ikp-transform_rotate\\(-30deg\\){transform:rotate(-30deg)}.ikp-transform_translateY\\(1px\\)_translateX\\(-4px\\){transform:translateY(1px) translate(-4px)}.ikp-w_1{width:var(--ikp-sizes-1)}.ikp-h_1{height:var(--ikp-sizes-1)}.ikp-bg_var\\(--loading-bg-color\\){background-color:var(--loading-bg-color)}.ikp-w_32px{width:32px}.ikp-h_32px{height:32px}.ikp-right_auto{right:auto}.ikp-top_auto{top:auto}.ikp-px_18px{padding-inline:18px}.ikp-w_24px{width:24px}.ikp-h_20px{height:20px}.ikp-w_5{width:var(--ikp-sizes-5)}.ikp-h_5{height:var(--ikp-sizes-5)}.ikp-fs_xl{font-size:var(--ikp-font-sizes-xl)}.ikp-fill_none{fill:none}.ikp-border_none\\!{border:var(--ikp-borders-none)!important}.ikp-shadow_none\\!{box-shadow:var(--ikp-shadows-none)!important}.ikp-max-h_10vh{max-height:10vh}.ikp-min-h_38px{min-height:38px}.ikp-ring_none\\!{outline:var(--ikp-borders-none)!important}.ikp-fs_20px{font-size:20px}.ikp-mr_0\\.5em{margin-right:.5em}.ikp-text_ellipsis{text-overflow:ellipsis}.ikp-w_4{width:var(--ikp-sizes-4)}.ikp-leading_normal{line-height:var(--ikp-line-heights-normal)}.ikp-cursor_pointer{cursor:pointer}.ikp-transform_translateY\\(1px\\){transform:translateY(1px)}.ikp-ml_1{margin-left:var(--ikp-spacing-1)}.ikp-fs_lg{font-size:var(--ikp-font-sizes-lg)}.ikp-mr_8{margin-right:var(--ikp-spacing-8)}.ikp-pt_0{padding-top:var(--ikp-spacing-0)}.ikp-text_inkeepPrimary\\.medium{color:var(--ikp-colors-inkeep-primary-medium)}.ikp-fs_2xs{font-size:var(--ikp-font-sizes-2xs)}.ikp-text_uppercase{text-transform:uppercase}.ikp-tracking_widest{letter-spacing:var(--ikp-letter-spacings-widest)}.dark .dark\\:ikp-text_whiteAlpha\\.500,[data-theme=dark] .dark\\:ikp-text_whiteAlpha\\.500{color:var(--ikp-colors-white-alpha-500)}.ikp-h_30px{height:30px}.ikp-shadow_sm{box-shadow:var(--ikp-shadows-sm)}.ikp-shadow_none{box-shadow:var(--ikp-shadows-none)}.ikp-rounded_4px{border-radius:4px}.ikp-w_40px{width:40px}.ikp-h_40px{height:40px}.ikp-transition-prop_all{--transition-prop:all;transition-property:all}.ikp-transition_linear{transition:linear}.disabled\\:ikp-cursor_not-allowed:is(:disabled,[disabled],[data-disabled]){cursor:not-allowed}.light .light\\:ikp-text_inkeepPrimary\\.medium,[data-theme=light] .light\\:ikp-text_inkeepPrimary\\.medium{color:var(--ikp-colors-inkeep-primary-medium)}.light .light\\:disabled\\:ikp-text_gray\\.500:is(:disabled,[disabled],[data-disabled]),[data-theme=light] .light\\:disabled\\:ikp-text_gray\\.500:is(:disabled,[disabled],[data-disabled]){color:var(--ikp-colors-gray-500)}.dark .dark\\:ikp-text_inkeepExpandedPrimary\\.100,[data-theme=dark] .dark\\:ikp-text_inkeepExpandedPrimary\\.100{color:var(--ikp-colors-inkeep-expanded-primary-100)}.dark .dark\\:disabled\\:ikp-text_whiteAlpha\\.300:is(:disabled,[disabled],[data-disabled]),[data-theme=dark] .dark\\:disabled\\:ikp-text_whiteAlpha\\.300:is(:disabled,[disabled],[data-disabled]){color:var(--ikp-colors-white-alpha-300)}.ikp-mt_16{margin-top:var(--ikp-spacing-16)}.ikp-z_10{z-index:10}.ikp-mr_var\\(--scrollbar-width\\){margin-right:var(--scrollbar-width)}.ikp-py_3{padding-block:var(--ikp-spacing-3)}.ikp-transition-prop_transform\\,_box-shadow\\,_background-color\\,_color{--transition-prop:transform,box-shadow,background-color,color;transition-property:transform,box-shadow,background-color,color}.ikp-duration_0\\.15s{--transition-duration:.15s;transition-duration:.15s}.ikp-ease_ease-in-out{--transition-easing:ease-in-out;transition-timing-function:ease-in-out}.ikp-h_11{height:var(--ikp-sizes-11)}.ikp-max-w_180px{max-width:180px}.ikp-h_8{height:var(--ikp-sizes-8)}.ikp-min-w_8{min-width:var(--ikp-sizes-8)}.expanded\\:ikp-text_inkeepPrimary\\.stronger:is([aria-expanded=true],[data-expanded],[data-state=expanded]){color:var(--ikp-colors-inkeep-primary-stronger)}.dark .expanded\\:dark\\:ikp-text_inkeepExpandedPrimary\\.300:is([aria-expanded=true],[data-expanded],[data-state=expanded]),[data-theme=dark] .expanded\\:dark\\:ikp-text_inkeepExpandedPrimary\\.300:is([aria-expanded=true],[data-expanded],[data-state=expanded]){color:var(--ikp-colors-inkeep-expanded-primary-300)}.light .light\\:ikp-text_gray\\.800,[data-theme=light] .light\\:ikp-text_gray\\.800{color:var(--ikp-colors-gray-800)}.ikp-fs_inherit{font-size:inherit}.ikp-white-space_normal{white-space:normal}.ikp-text_center{text-align:center}.ikp-leading_unset{line-height:unset}.ikp-border_gray\\.200{border-color:var(--ikp-colors-gray-200)}.ikp-bg_gray\\.100{background:var(--ikp-colors-gray-100)}.dark .dark\\:ikp-bg_whiteAlpha\\.200,[data-theme=dark] .dark\\:ikp-bg_whiteAlpha\\.200{background:var(--ikp-colors-white-alpha-200)}.dark .dark\\:ikp-text_whiteAlpha\\.900,[data-theme=dark] .dark\\:ikp-text_whiteAlpha\\.900{color:var(--ikp-colors-white-alpha-900)}.light .light\\:ikp-text_inkeepPrimary\\.textColorOnPrimary,[data-theme=light] .light\\:ikp-text_inkeepPrimary\\.textColorOnPrimary{color:var(--ikp-colors-inkeep-primary-text-color-on-primary)}.ikp-w_6{width:var(--ikp-sizes-6)}.ikp-text_gray\\.600{color:var(--ikp-colors-gray-600)}.ikp-justify-self_center{justify-self:center}.ikp-max-w_200px{max-width:200px}.ikp-z_tooltip{z-index:var(--ikp-z-index-tooltip)}.ikp-bg_inkeepPrimary\\.medium{background:var(--ikp-colors-inkeep-primary-medium)}.ikp-text_inkeepPrimary\\.textColorOnPrimary{color:var(--ikp-colors-inkeep-primary-text-color-on-primary)}.ikp-font_bold{font-weight:var(--ikp-font-weights-bold)}.ikp-tracking_tight{letter-spacing:var(--ikp-letter-spacings-tight)}.ikp-mb_8{margin-bottom:var(--ikp-spacing-8)}.ikp-text_inkeepPrimary\\.strong{color:var(--ikp-colors-inkeep-primary-strong)}.ikp-text_inkeepPrimary\\.textBold{color:var(--ikp-colors-inkeep-primary-text-bold)}.ikp-bg_inkeepPrimary\\.lightSubtle{background-color:var(--ikp-colors-inkeep-primary-light-subtle)}.ikp-bg_white{background-color:var(--ikp-colors-white)}.ikp-border_inkeepPrimary\\.mediumSubtle{border-color:var(--ikp-colors-inkeep-primary-medium-subtle)}.ikp-border_gray\\.300{border-color:var(--ikp-colors-gray-300)}.dark .dark\\:ikp-bg_whiteAlpha\\.200,[data-theme=dark] .dark\\:ikp-bg_whiteAlpha\\.200{background-color:var(--ikp-colors-white-alpha-200)}.dark .dark\\:ikp-bg_transparent,[data-theme=dark] .dark\\:ikp-bg_transparent{background-color:var(--ikp-colors-transparent)}.dark .dark\\:ikp-border_inkeepExpandedPrimary\\.300,[data-theme=dark] .dark\\:ikp-border_inkeepExpandedPrimary\\.300{border-color:var(--ikp-colors-inkeep-expanded-primary-300)}.dark .dark\\:ikp-border_whiteAlpha\\.300,[data-theme=dark] .dark\\:ikp-border_whiteAlpha\\.300{border-color:var(--ikp-colors-white-alpha-300)}.ikp-border-w_1px{border-width:1px}.ikp-h_20{height:var(--ikp-sizes-20)}.ikp-mr_4{margin-right:var(--ikp-spacing-4)}.ikp-h_12{height:var(--ikp-sizes-12)}.ikp-w_12{width:var(--ikp-sizes-12)}.ikp-h_4{height:var(--ikp-sizes-4)}.ikp-w_200px{width:200px}.ikp-color-palette_purple{--ikp-colors-color-palette-50:var(--ikp-colors-purple-50);--ikp-colors-color-palette-100:var(--ikp-colors-purple-100);--ikp-colors-color-palette-200:var(--ikp-colors-purple-200);--ikp-colors-color-palette-300:var(--ikp-colors-purple-300);--ikp-colors-color-palette-400:var(--ikp-colors-purple-400);--ikp-colors-color-palette-500:var(--ikp-colors-purple-500);--ikp-colors-color-palette-600:var(--ikp-colors-purple-600);--ikp-colors-color-palette-700:var(--ikp-colors-purple-700);--ikp-colors-color-palette-800:var(--ikp-colors-purple-800);--ikp-colors-color-palette-900:var(--ikp-colors-purple-900);--ikp-colors-color-palette-950:var(--ikp-colors-purple-950)}.ikp-color-palette_green{--ikp-colors-color-palette-50:var(--ikp-colors-green-50);--ikp-colors-color-palette-100:var(--ikp-colors-green-100);--ikp-colors-color-palette-200:var(--ikp-colors-green-200);--ikp-colors-color-palette-300:var(--ikp-colors-green-300);--ikp-colors-color-palette-400:var(--ikp-colors-green-400);--ikp-colors-color-palette-500:var(--ikp-colors-green-500);--ikp-colors-color-palette-600:var(--ikp-colors-green-600);--ikp-colors-color-palette-700:var(--ikp-colors-green-700);--ikp-colors-color-palette-800:var(--ikp-colors-green-800);--ikp-colors-color-palette-900:var(--ikp-colors-green-900);--ikp-colors-color-palette-950:var(--ikp-colors-green-950)}.ikp-border_1px_solid_gray{border:1px solid gray}.light .light\\:ikp-border_gray\\.300,[data-theme=light] .light\\:ikp-border_gray\\.300{border-color:var(--ikp-colors-gray-300)}.dark .dark\\:ikp-border_grayDark\\.500,[data-theme=dark] .dark\\:ikp-border_grayDark\\.500{border-color:var(--ikp-colors-gray-dark-500)}.ikp-fs_13px{font-size:13px}.ikp-transition_all_0\\.2s{transition:all .2s}.selected\\:ikp-bg_inkeepPrimary\\.lightSubtle:is([aria-selected=true],[data-selected]){background:var(--ikp-colors-inkeep-primary-light-subtle)}.selected\\:ikp-border_inkeepPrimary\\.mediumSubtle:is([aria-selected=true],[data-selected]){border-color:var(--ikp-colors-inkeep-primary-medium-subtle)}.selected\\:ikp-text_inkeepExpandedPrimary\\.900:is([aria-selected=true],[data-selected]){color:var(--ikp-colors-inkeep-expanded-primary-900)}.dark .selected\\:dark\\:ikp-text_inkeepExpandedPrimary\\.300:is([aria-selected=true],[data-selected]),[data-theme=dark] .selected\\:dark\\:ikp-text_inkeepExpandedPrimary\\.300:is([aria-selected=true],[data-selected]){color:var(--ikp-colors-inkeep-expanded-primary-300)}.dark .selected\\:dark\\:ikp-bg_whiteAlpha\\.200:is([aria-selected=true],[data-selected]),[data-theme=dark] .selected\\:dark\\:ikp-bg_whiteAlpha\\.200:is([aria-selected=true],[data-selected]){background:var(--ikp-colors-white-alpha-200)}.dark .selected\\:dark\\:ikp-border_inkeepExpandedPrimary\\.300:is([aria-selected=true],[data-selected]),[data-theme=dark] .selected\\:dark\\:ikp-border_inkeepExpandedPrimary\\.300:is([aria-selected=true],[data-selected]){border-color:var(--ikp-colors-inkeep-expanded-primary-300)}.ikp-py_0{padding-block:var(--ikp-spacing-0)}.ikp-px_0{padding-inline:var(--ikp-spacing-0)}.ikp-fs_md{font-size:var(--ikp-font-sizes-md)}.ikp-grow_1{flex-grow:1}.ikp-pb_2{padding-bottom:var(--ikp-spacing-2)}.ikp-bg_transparent{background:var(--ikp-colors-transparent)}.ikp-border_none{border:var(--ikp-borders-none)}.ikp-pt_1px{padding-top:1px}.ikp-max-h_calc\\(100\\%_-_33px\\){max-height:calc(100% - 33px)}.ikp-rounded_none{border-radius:var(--ikp-radii-none)}.ikp-left_auto{left:auto}.ikp-left_0px{left:0}.ikp-right_0px{right:0}.ikp-right_6{right:var(--ikp-spacing-6)}.ikp-top_0px{top:0}.dark .dark\\:ikp-bg_grayDark\\.900,[data-theme=dark] .dark\\:ikp-bg_grayDark\\.900{background-color:var(--ikp-colors-gray-dark-900)}.light .light\\:ikp-bg_white,[data-theme=light] .light\\:ikp-bg_white{background-color:var(--ikp-colors-white)}.ikp-m_0{margin:var(--ikp-spacing-0)}.ikp-text_left{text-align:left}.ikp-transition_width\\,_min-width_\\.3s_ease-in-out{transition:width,min-width .3s ease-in-out}.ikp-max-w_480px{max-width:480px}.ikp-top_5\\%{top:5%}.file\\:ikp-h_100\\%::file-selector-button{height:100%}.file\\:ikp-cursor_pointer::file-selector-button{cursor:pointer}.file\\:ikp-bg_transparent::file-selector-button{background:var(--ikp-colors-transparent)}.file\\:ikp-border_none::file-selector-button{border:var(--ikp-borders-none)}.file\\:ikp-fs_sm::file-selector-button{font-size:var(--ikp-font-sizes-sm)}.file\\:ikp-font_medium::file-selector-button{font-weight:var(--ikp-font-weights-medium)}.file\\:ikp-text_gray\\.700::file-selector-button{color:var(--ikp-colors-gray-700)}.dark .file\\:dark\\:ikp-text_whiteAlpha\\.700::file-selector-button,[data-theme=dark] .file\\:dark\\:ikp-text_whiteAlpha\\.700::file-selector-button{color:var(--ikp-colors-white-alpha-700)}.ikp-ml_auto{margin-left:auto}.ikp-min-h_unset{min-height:unset}.ikp-resize_none{resize:none}.light .light\\:\\[\\&\\:\\:placeholder\\]\\:ikp-text_gray\\.600::placeholder,[data-theme=light] .light\\:\\[\\&\\:\\:placeholder\\]\\:ikp-text_gray\\.600::placeholder{color:var(--ikp-colors-gray-600)}.dark .dark\\:\\[\\&\\:\\:placeholder\\]\\:ikp-text_grayDark\\.200::placeholder,[data-theme=dark] .dark\\:\\[\\&\\:\\:placeholder\\]\\:ikp-text_grayDark\\.200::placeholder{color:var(--ikp-colors-gray-dark-200)}.ikp-w_250px{width:250px}.ikp-bg_white{background:var(--ikp-colors-white)}.ikp-shadow_lg{box-shadow:var(--ikp-shadows-lg)}.ikp-text_gray\\.800{color:var(--ikp-colors-gray-800)}.dark .dark\\:ikp-text_whiteAlpha\\.800,[data-theme=dark] .dark\\:ikp-text_whiteAlpha\\.800{color:var(--ikp-colors-white-alpha-800)}.ikp-w_2xs{width:var(--ikp-sizes-2xs)}.dark .dark\\:ikp-bg_grayDark\\.800,[data-theme=dark] .dark\\:ikp-bg_grayDark\\.800{background:var(--ikp-colors-gray-dark-800)}.dark .dark\\:ikp-text_whiteAlpha\\.300\\!,[data-theme=dark] .dark\\:ikp-text_whiteAlpha\\.300\\!{color:var(--ikp-colors-white-alpha-300)!important}.light .light\\:ikp-shadow_lg,[data-theme=light] .light\\:ikp-shadow_lg{box-shadow:var(--ikp-shadows-lg)}.ikp-bg_none{background:none}.ikp-d_none\\!{display:none!important}.dark .dark\\:ikp-bg_inkeepExpandedPrimary\\.300,[data-theme=dark] .dark\\:ikp-bg_inkeepExpandedPrimary\\.300{background:var(--ikp-colors-inkeep-expanded-primary-300)}.dark .dark\\:ikp-bg_none,[data-theme=dark] .dark\\:ikp-bg_none{background:none}.ikp-font_semibold{font-weight:var(--ikp-font-weights-semibold)}.ikp-ml_0\\.5rem{margin-left:.5rem}.ikp-py_8px{padding-block:8px}.ikp-px_16px{padding-inline:16px}.ikp-color-palette_inkeepExpandedPrimary{--ikp-colors-color-palette-50:var(--ikp-colors-inkeep-expanded-primary-50);--ikp-colors-color-palette-100:var(--ikp-colors-inkeep-expanded-primary-100);--ikp-colors-color-palette-200:var(--ikp-colors-inkeep-expanded-primary-200);--ikp-colors-color-palette-300:var(--ikp-colors-inkeep-expanded-primary-300);--ikp-colors-color-palette-400:var(--ikp-colors-inkeep-expanded-primary-400);--ikp-colors-color-palette-500:var(--ikp-colors-inkeep-expanded-primary-500);--ikp-colors-color-palette-600:var(--ikp-colors-inkeep-expanded-primary-600);--ikp-colors-color-palette-700:var(--ikp-colors-inkeep-expanded-primary-700);--ikp-colors-color-palette-800:var(--ikp-colors-inkeep-expanded-primary-800);--ikp-colors-color-palette-900:var(--ikp-colors-inkeep-expanded-primary-900)}.ikp-transition_all_\\.3s_ease-in-out{transition:all .3s ease-in-out}.dark .dark\\:ikp-bg_transparent,[data-theme=dark] .dark\\:ikp-bg_transparent{background:var(--ikp-colors-transparent)}.dark .dark\\:ikp-border_grayDark\\.700,[data-theme=dark] .dark\\:ikp-border_grayDark\\.700{border-color:var(--ikp-colors-gray-dark-700)}.ikp-p_0\\.5{padding:var(--ikp-spacing-0\\.5)}.ikp-border_1px_solid_transparent{border:1px solid transparent}.light .light\\:ikp-bg_gray\\.100,[data-theme=light] .light\\:ikp-bg_gray\\.100{background:var(--ikp-colors-gray-100)}.ikp-mb_0{margin-bottom:var(--ikp-spacing-0)}.ikp-leading_shorter{line-height:var(--ikp-line-heights-shorter)}.ikp-transform_all_0\\.2s_ease-in-out{transform:all .2s ease-in-out}.ikp-rounded_6px_6px_0_0{border-radius:6px 6px 0 0}.ikp-rounded_8{border-radius:8px}.dark .dark\\:ikp-text_gray\\.400,[data-theme=dark] .dark\\:ikp-text_gray\\.400{color:var(--ikp-colors-gray-400)}.ikp-gap_8{gap:var(--ikp-spacing-8)}.ikp-px_14{padding-inline:var(--ikp-spacing-14)}.ikp-pb_14{padding-bottom:var(--ikp-spacing-14)}.ikp-min-h_0px{min-height:0px}.ikp-pt_4{padding-top:var(--ikp-spacing-4)}.ikp-content_stretch{align-content:stretch}.ikp-pb_2\\.5{padding-bottom:var(--ikp-spacing-2\\.5)}.light .light\\:ikp-text_inkeepPrimary\\.textSubtle,[data-theme=light] .light\\:ikp-text_inkeepPrimary\\.textSubtle{color:var(--ikp-colors-inkeep-primary-text-subtle)}.dark .dark\\:ikp-text_grayDark\\.300,[data-theme=dark] .dark\\:ikp-text_grayDark\\.300{color:var(--ikp-colors-gray-dark-300)}.ikp-leading_short{line-height:var(--ikp-line-heights-short)}.ikp-leading_base{line-height:var(--ikp-line-heights-base)}.dark .dark\\:ikp-text_grayDark\\.400,[data-theme=dark] .dark\\:ikp-text_grayDark\\.400{color:var(--ikp-colors-gray-dark-400)}.ikp-mt_8{margin-top:var(--ikp-spacing-8)}.ikp-overflow_visible{overflow:visible}.dark .dark\\:ikp-text_grayDark\\.100,[data-theme=dark] .dark\\:ikp-text_grayDark\\.100{color:var(--ikp-colors-gray-dark-100)}.ikp-grow_4{flex-grow:4}.ikp-overflow-y_hidden{overflow-y:hidden}.ikp-from_rgba\\(255\\,_255\\,_255\\,_0\\){--gradient-from:rgba(255,255,255,0)}.ikp-to_white{--gradient-to:var(--ikp-colors-white)}.dark .dark\\:ikp-to_grayDark\\.900,[data-theme=dark] .dark\\:ikp-to_grayDark\\.900{--gradient-to:var(--ikp-colors-gray-dark-900)}.ikp-pt_6{padding-top:var(--ikp-spacing-6)}.ikp-pb_4{padding-bottom:var(--ikp-spacing-4)}.\\[\\&\\:\\:before\\]\\:ikp-bg-gradient_to-b:before{--gradient-stops:var(--gradient-from),var(--gradient-to);--gradient:var(--gradient-via-stops,var(--gradient-stops));background-image:linear-gradient(to bottom,var(--gradient))}.\\[\\&\\:\\:before\\]\\:ikp-from_rgba\\(255\\,_255\\,_255\\,_0\\):before{--gradient-from:rgba(255,255,255,0)}.\\[\\&\\:\\:before\\]\\:ikp-to_white:before{--gradient-to:var(--ikp-colors-white)}.dark .\\[\\&\\:\\:before\\]\\:dark\\:ikp-to_grayDark\\.900:before,[data-theme=dark] .\\[\\&\\:\\:before\\]\\:dark\\:ikp-to_grayDark\\.900:before{--gradient-to:var(--ikp-colors-gray-dark-900)}.\\[\\&\\:\\:before\\]\\:ikp-content_\\"\\":before{content:""}.\\[\\&\\:\\:before\\]\\:ikp-d_block:before{display:block}.\\[\\&\\:\\:before\\]\\:ikp-h_3:before{height:var(--ikp-sizes-3)}.\\[\\&\\:\\:before\\]\\:ikp-left_0:before{left:var(--ikp-spacing-0)}.\\[\\&\\:\\:before\\]\\:ikp-top_0:before{top:var(--ikp-spacing-0)}.\\[\\&\\:\\:before\\]\\:ikp-transform_translateY\\(-100\\%\\):before{transform:translateY(-100%)}.\\[\\&\\:\\:before\\]\\:ikp-pointer-events_none:before{pointer-events:none}.\\[\\&\\:\\:before\\]\\:ikp-pos_absolute:before{position:absolute}.\\[\\&\\:\\:before\\]\\:ikp-w_100\\%:before{width:100%}.ikp-vis_visible{visibility:visible}.ikp-mt_2{margin-top:var(--ikp-spacing-2)}.ikp-mb_3{margin-bottom:var(--ikp-spacing-3)}.ikp-py_8{padding-block:var(--ikp-spacing-8)}.ikp-shrink_2{flex-shrink:2}.ikp-pr_3{padding-right:var(--ikp-spacing-3)}.ikp-flex-wrap_wrap-reverse{flex-wrap:wrap-reverse}.ikp-items_stretch{align-items:stretch}.light .light\\:ikp-bg_gray\\.50,[data-theme=light] .light\\:ikp-bg_gray\\.50{background:var(--ikp-colors-gray-50)}.dark .dark\\:ikp-bg_whiteAlpha\\.50,[data-theme=dark] .dark\\:ikp-bg_whiteAlpha\\.50{background:var(--ikp-colors-white-alpha-50)}.dark .dark\\:ikp-shadow_none,[data-theme=dark] .dark\\:ikp-shadow_none{box-shadow:var(--ikp-shadows-none)}.ikp-rounded_lg{border-radius:var(--ikp-radii-lg)}.ikp-shadow_md{box-shadow:var(--ikp-shadows-md)}.ikp-justify_flex-end{justify-content:flex-end}.ikp-flex_row-reverse{flex-direction:row-reverse}.ikp-pr_6{padding-right:var(--ikp-spacing-6)}.ikp-mb_6{margin-bottom:var(--ikp-spacing-6)}.ikp-justify_flex-start{justify-content:flex-start}.ikp-select_none{-webkit-user-select:none;user-select:none}.light .light\\:ikp-text_gray\\.700,[data-theme=light] .light\\:ikp-text_gray\\.700{color:var(--ikp-colors-gray-700)}.ikp-gap_6{gap:var(--ikp-spacing-6)}.ikp-grow_5{flex-grow:5}.ikp-p_0{padding:var(--ikp-spacing-0)}.ikp-pl_3{padding-left:var(--ikp-spacing-3)}.ikp-pt_3{padding-top:var(--ikp-spacing-3)}.ikp-rounded_2xl{border-radius:var(--ikp-radii-2xl)}.ikp-top_0\\!{top:var(--ikp-spacing-0)!important}.ikp-pr_2{padding-right:var(--ikp-spacing-2)}.ikp-pl_2{padding-left:var(--ikp-spacing-2)}.ikp-h_6{height:var(--ikp-sizes-6)}.ikp-bg_gray\\.300{background:var(--ikp-colors-gray-300)}.dark .dark\\:ikp-bg_whiteAlpha\\.300,[data-theme=dark] .dark\\:ikp-bg_whiteAlpha\\.300{background:var(--ikp-colors-white-alpha-300)}.ikp-mb_4{margin-bottom:var(--ikp-spacing-4)}.dark .dark\\:ikp-text_whiteAlpha\\.600,[data-theme=dark] .dark\\:ikp-text_whiteAlpha\\.600{color:var(--ikp-colors-white-alpha-600)}.light .light\\:ikp-text_gray\\.600,[data-theme=light] .light\\:ikp-text_gray\\.600{color:var(--ikp-colors-gray-600)}.ikp-fs_xs{font-size:var(--ikp-font-sizes-xs)}.ikp-mr_1{margin-right:var(--ikp-spacing-1)}.ikp-w_18px{width:18px}.ikp-top_0{top:var(--ikp-spacing-0)}.ikp-bg-gradient_to-b{--gradient-stops:var(--gradient-from),var(--gradient-to);--gradient:var(--gradient-via-stops,var(--gradient-stops));background-image:linear-gradient(to bottom,var(--gradient))}.ikp-opacity_0\\!{opacity:0!important}.ikp-opacity_1{opacity:1}.ikp-bottom_0{bottom:var(--ikp-spacing-0)}.ikp-left_0{left:var(--ikp-spacing-0)}.ikp-right_0{right:var(--ikp-spacing-0)}.ikp-h_10{height:var(--ikp-sizes-10)}.ikp-bg-gradient_to-t{--gradient-stops:var(--gradient-from),var(--gradient-to);--gradient:var(--gradient-via-stops,var(--gradient-stops));background-image:linear-gradient(to top,var(--gradient))}.ikp-from_white{--gradient-from:var(--ikp-colors-white)}.dark .dark\\:ikp-from_grayDark\\.900,[data-theme=dark] .dark\\:ikp-from_grayDark\\.900{--gradient-from:var(--ikp-colors-gray-dark-900)}.ikp-to_transparent{--gradient-to:var(--ikp-colors-transparent)}.ikp-z_1{z-index:1}.ikp-self_flex-end{align-self:flex-end}.ikp-max-h_125px{max-height:125px}.ikp-overflow-y_auto{overflow-y:auto}.ikp-mb_12px{margin-bottom:12px}.ikp-w_16px{width:16px}.ikp-min-h_16px{min-height:16px}.ikp-d_inline{display:inline}.ikp-items_baseline{align-items:baseline}.ikp-overflow-x_auto{overflow-x:auto}.ikp-scrollbar-width_thin{scrollbar-width:thin}.ikp-scrollbar-color_var\\(--ikp-colors-gray-300\\)_transparent{scrollbar-color:var(--ikp-colors-gray-300) transparent}.dark .dark\\:ikp-scrollbar-color_var\\(--ikp-colors-gray-dark-600\\)_transparent,[data-theme=dark] .dark\\:ikp-scrollbar-color_var\\(--ikp-colors-gray-dark-600\\)_transparent{scrollbar-color:var(--ikp-colors-gray-dark-600) transparent}.ikp-h_var\\(--chakra-vh\\){height:var(--chakra-vh)}.ikp-pb_8{padding-bottom:var(--ikp-spacing-8)}.ikp-grow_2{flex-grow:2}.ikp-overflow-wrap_break-word{overflow-wrap:break-word}.ikp-shrink_1{flex-shrink:1}.ikp-d_inline-block{display:inline-block}.ikp-d_none{display:none}.ikp-d_grid{display:grid}.ikp-grid-cols_repeat\\(2\\,_1fr\\){grid-template-columns:repeat(2,1fr)}.ikp-gap-y_1{column-gap:var(--ikp-spacing-1)}.ikp-gap-x_1{row-gap:var(--ikp-spacing-1)}.ikp-sr_true{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.ikp-ml_4{margin-left:var(--ikp-spacing-4)}.ikp-bg_gray\\.50{background:var(--ikp-colors-gray-50)}.ikp-bg_inkeepPrimary\\.lighter{background:var(--ikp-colors-inkeep-primary-lighter)}.ikp-text_gray\\.700{color:var(--ikp-colors-gray-700)}.ikp-text_inkeepPrimary\\.stronger{color:var(--ikp-colors-inkeep-primary-stronger)}.dark .dark\\:ikp-text_whiteAlpha\\.700,[data-theme=dark] .dark\\:ikp-text_whiteAlpha\\.700{color:var(--ikp-colors-white-alpha-700)}.dark .dark\\:ikp-text_inkeepExpandedPrimary\\.300,[data-theme=dark] .dark\\:ikp-text_inkeepExpandedPrimary\\.300{color:var(--ikp-colors-inkeep-expanded-primary-300)}.ikp-py_1{padding-block:var(--ikp-spacing-1)}.dark .dark\\:ikp-bg_grayDark\\.700,[data-theme=dark] .dark\\:ikp-bg_grayDark\\.700{background:var(--ikp-colors-gray-dark-700)}.ikp-min-h_0{min-height:var(--ikp-sizes-0)}.ikp-fs_15px{font-size:15px}.ikp-max-h_100\\%{max-height:100%}.ikp-justify-self_flex-end{justify-self:flex-end}.ikp-pos_fixed{position:fixed}.ikp-transition_all_0\\.25s_linear{transition:all .25s linear}.ikp-vis_hidden{visibility:hidden}.ikp-w_auto{width:var(--ikp-sizes-auto)}.ikp-pointer-events_none{pointer-events:none}.ikp-z_-1{z-index:-1}.ikp-pb_3{padding-bottom:var(--ikp-spacing-3)}.ikp-w_full{width:var(--ikp-sizes-full)}.ikp-font_medium{font-weight:var(--ikp-font-weights-medium)}.ikp-ml_2{margin-left:var(--ikp-spacing-2)}.ikp-font_normal{font-weight:var(--ikp-font-weights-normal)}.ikp-n-lines_1{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:var(--chakra-line-clamp);--chakra-line-clamp:1}.ikp-min-w_20px{min-width:20px}.ikp-w_20px{width:20px}.ikp-w_28px{width:28px}.ikp-h_28px{height:28px}.ikp-d_inline-flex{display:inline-flex}.ikp-z_popover{z-index:var(--ikp-z-index-popover)}.ikp-py_4{padding-block:var(--ikp-spacing-4)}.ikp-z_0{z-index:0}.ikp-min-h_9{min-height:var(--ikp-sizes-9)}.ikp-rounded_md{border-radius:var(--ikp-radii-md)}.after\\:ikp-content_\\"\\":after{content:""}.after\\:ikp-pos_absolute:after{position:absolute}.after\\:ikp-z_-1:after{z-index:-1}.after\\:ikp-left_1px:after{left:1px}.after\\:ikp-top_1px:after{top:1px}.after\\:ikp-w_calc\\(100\\%_-_2px\\):after{width:calc(100% - 2px)}.after\\:ikp-h_calc\\(100\\%_-_2px\\):after{height:calc(100% - 2px)}.after\\:ikp-rounded_5px:after{border-radius:5px}.after\\:ikp-bg_white:after{background-color:var(--ikp-colors-white)}.dark .dark\\:after\\:ikp-bg_grayDark\\.900:after,[data-theme=dark] .dark\\:after\\:ikp-bg_grayDark\\.900:after{background-color:var(--ikp-colors-gray-dark-900)}.ikp-bg-img_conic-gradient\\(transparent\\,_token\\(colors\\.inkeepExpandedPrimary\\.600\\)\\,_transparent_30\\%\\){background-image:conic-gradient(transparent,var(--ikp-colors-inkeep-expanded-primary-600),transparent 30%)}.ikp-bg-img_none{background-image:none}.ikp-animation_4s_spin_linear_infinite{animation:4s spin linear infinite}.ikp-animation_none{animation:none}.dark .dark\\:ikp-bg-img_conic-gradient\\(transparent\\,_token\\(colors\\.inkeepExpandedPrimary\\.300\\)\\,_transparent_30\\%\\)\\!,[data-theme=dark] .dark\\:ikp-bg-img_conic-gradient\\(transparent\\,_token\\(colors\\.inkeepExpandedPrimary\\.300\\)\\,_transparent_30\\%\\)\\!{background-image:conic-gradient(transparent,var(--ikp-colors-inkeep-expanded-primary-300),transparent 30%)!important}.dark .dark\\:ikp-bg-img_none,[data-theme=dark] .dark\\:ikp-bg-img_none{background-image:none}.ikp-pos_absolute{position:absolute}.ikp-z_-2{z-index:-2}.ikp-bg_gray\\.300{background-color:var(--ikp-colors-gray-300)}.ikp-bg-repeat_no-repeat{background-repeat:no-repeat}.ikp-bg_0_0{background-position:0 0}.ikp-bg_cover{background-size:cover}.dark .dark\\:ikp-bg_whiteAlpha\\.300,[data-theme=dark] .dark\\:ikp-bg_whiteAlpha\\.300{background-color:var(--ikp-colors-white-alpha-300)}.ikp-mt_4{margin-top:var(--ikp-spacing-4)}.ikp-mr_2{margin-right:var(--ikp-spacing-2)}.ikp-max-w_100\\%{max-width:100%}.ikp-self_center{align-self:center}.ikp-h_auto{height:var(--ikp-sizes-auto)}.ikp-rounded_full{border-radius:var(--ikp-radii-full)}.ikp-d_block{display:block}.ikp-gap_0\\.5{gap:var(--ikp-spacing-0\\.5)}.ikp-py_0\\.5{padding-block:var(--ikp-spacing-0\\.5)}.\\[\\&\\[data-reversed\\]\\]\\:ikp-flex_column-reverse[data-reversed]{flex-direction:column-reverse}.ikp-gap_12{gap:var(--ikp-spacing-12)}.ikp-flex_1{flex:1 1 0%}.ikp-p_8{padding:var(--ikp-spacing-8)}.ikp-px_2{padding-inline:var(--ikp-spacing-2)}.ikp-px_4px{padding-inline:4px}.ikp-pt_2{padding-top:var(--ikp-spacing-2)}.ikp-pb_1{padding-bottom:var(--ikp-spacing-1)}.ikp-min-w_0px{min-width:0px}.ikp-justify_space-between{justify-content:space-between}.ikp-px_3{padding-inline:var(--ikp-spacing-3)}.ikp-ml_3{margin-left:var(--ikp-spacing-3)}.ikp-grow_0{flex-grow:0}.ikp-mr_3{margin-right:var(--ikp-spacing-3)}.ikp-overflow_hidden{overflow:hidden}.ikp-px_4{padding-inline:var(--ikp-spacing-4)}.ikp-py_2{padding-block:var(--ikp-spacing-2)}.ikp-px_8{padding-inline:var(--ikp-spacing-8)}.ikp-px_6{padding-inline:var(--ikp-spacing-6)}.ikp-items_start{align-items:start}.ikp-justify_center{justify-content:center}.ikp-gap_0{gap:var(--ikp-spacing-0)}.ikp-flex-wrap_wrap{flex-wrap:wrap}.ikp-h_48px{height:48px}.ikp-white-space_nowrap{white-space:nowrap}.ikp-gap_1{gap:var(--ikp-spacing-1)}.ikp-h_24px{height:24px}.ikp-ml_0{margin-left:var(--ikp-spacing-0)}.ikp-flex_row{flex-direction:row}.ikp-mb_2{margin-bottom:var(--ikp-spacing-2)}.ikp-px_5{padding-inline:var(--ikp-spacing-5)}.ikp-content_center{align-content:center}.ikp-pos_relative{position:relative}.ikp-shrink_0{flex-shrink:0}.ikp-h_100\\%{height:100%}.ikp-py_1px{padding-block:1px}.ikp-my_-1px{margin-block:-1px}.ikp-min-w_0{min-width:var(--ikp-sizes-0)}.ikp-items_flex-start{align-items:flex-start}.ikp-items_flex-end{align-items:flex-end}.ikp-gap_2{gap:var(--ikp-spacing-2)}.ikp-pl_4{padding-left:var(--ikp-spacing-4)}.ikp-gap_10px{gap:10px}.ikp-items_center{align-items:center}.ikp-gap_3{gap:var(--ikp-spacing-3)}.ikp-flex_column{flex-direction:column}.ikp-fs_sm{font-size:var(--ikp-font-sizes-sm)}.ikp-d_flex{display:flex}.ikp-m_auto{margin:auto}.ikp---thickness_1px{--thickness:1px}.ikp-w_100\\%{width:100%}.ikp-border-block-end-width_var\\(--thickness\\){border-block-end-width:var(--thickness)}.focusVisible\\:ikp-shadow_outline:is(:focus-visible,[data-focus-visible]){box-shadow:var(--ikp-shadows-outline)}.focus\\:ikp-bg_grayAlpha\\.50:is(:focus,[data-focus]){background-color:var(--ikp-colors-gray-alpha-50)}.focus\\:ikp-border_grayAlpha\\.50:is(:focus,[data-focus]){border-color:var(--ikp-colors-gray-alpha-50)}.group:is(:focus,[data-focus]) .groupFocus\\:ikp-border_inkeepPrimary\\.mediumSubtle{border-color:var(--ikp-colors-inkeep-primary-medium-subtle)}.group:is(:focus,[data-focus]) .groupFocus\\:ikp-bg_inkeepPrimary\\.lightSubtle{background-color:var(--ikp-colors-inkeep-primary-light-subtle)}.group:is(:focus,[data-focus]) .groupFocus\\:ikp-text_inkeepPrimary\\.strong{color:var(--ikp-colors-inkeep-primary-strong)}.dark .group:is(:focus,[data-focus]) .groupFocus\\:dark\\:ikp-border_inkeepExpandedPrimary\\.300,[data-theme=dark] .group:is(:focus,[data-focus]) .groupFocus\\:dark\\:ikp-border_inkeepExpandedPrimary\\.300{border-color:var(--ikp-colors-inkeep-expanded-primary-300)}.dark .group:is(:focus,[data-focus]) .groupFocus\\:dark\\:ikp-bg_whiteAlpha\\.200,[data-theme=dark] .group:is(:focus,[data-focus]) .groupFocus\\:dark\\:ikp-bg_whiteAlpha\\.200{background-color:var(--ikp-colors-white-alpha-200)}.dark .group:is(:focus,[data-focus]) .groupFocus\\:dark\\:ikp-text_inkeepExpandedPrimary\\.300,[data-theme=dark] .group:is(:focus,[data-focus]) .groupFocus\\:dark\\:ikp-text_inkeepExpandedPrimary\\.300{color:var(--ikp-colors-inkeep-expanded-primary-300)}.light .light\\:focus\\:ikp-bg_inkeepPrimary\\.lightSubtle:is(:focus,[data-focus]),[data-theme=light] .light\\:focus\\:ikp-bg_inkeepPrimary\\.lightSubtle:is(:focus,[data-focus]){background:var(--ikp-colors-inkeep-primary-light-subtle)}.light .light\\:focus\\:ikp-border_inkeepPrimary\\.mediumSubtle:is(:focus,[data-focus]),[data-theme=light] .light\\:focus\\:ikp-border_inkeepPrimary\\.mediumSubtle:is(:focus,[data-focus]){border-color:var(--ikp-colors-inkeep-primary-medium-subtle)}.light .light\\:focus\\:ikp-text_inkeepPrimary\\.textBold:is(:focus,[data-focus]),[data-theme=light] .light\\:focus\\:ikp-text_inkeepPrimary\\.textBold:is(:focus,[data-focus]){color:var(--ikp-colors-inkeep-primary-text-bold)}.dark .dark\\:focus\\:ikp-border_inkeepExpandedPrimary\\.300:is(:focus,[data-focus]),[data-theme=dark] .dark\\:focus\\:ikp-border_inkeepExpandedPrimary\\.300:is(:focus,[data-focus]){border-color:var(--ikp-colors-inkeep-expanded-primary-300)}.dark .dark\\:focus\\:ikp-bg_whiteAlpha\\.200:is(:focus,[data-focus]),[data-theme=dark] .dark\\:focus\\:ikp-bg_whiteAlpha\\.200:is(:focus,[data-focus]){background-color:var(--ikp-colors-white-alpha-200)}.dark .dark\\:focus\\:ikp-border_whiteAlpha\\.300:is(:focus,[data-focus]),[data-theme=dark] .dark\\:focus\\:ikp-border_whiteAlpha\\.300:is(:focus,[data-focus]){border-color:var(--ikp-colors-white-alpha-300)}.group:is(:hover,[data-hover]) .groupHover\\:ikp-text_gray\\.600{color:var(--ikp-colors-gray-600)}.dark .group:is(:hover,[data-hover]) .groupHover\\:dark\\:ikp-text_whiteAlpha\\.600,[data-theme=dark] .group:is(:hover,[data-hover]) .groupHover\\:dark\\:ikp-text_whiteAlpha\\.600{color:var(--ikp-colors-white-alpha-600)}.hover\\:ikp-bg_transparent\\!:is(:hover,[data-hover]){background-color:var(--ikp-colors-transparent)!important}.group:is(:hover,[data-hover]) .groupHover\\:ikp-text_inkeepPrimary\\.textBold{color:var(--ikp-colors-inkeep-primary-text-bold)}.dark .group:is(:hover,[data-hover]) .groupHover\\:dark\\:ikp-text_whiteAlpha\\.900,[data-theme=dark] .group:is(:hover,[data-hover]) .groupHover\\:dark\\:ikp-text_whiteAlpha\\.900{color:var(--ikp-colors-white-alpha-900)}.hover\\:ikp-transform_none:is(:hover,[data-hover]){transform:none}.group:is(:hover,[data-hover]) .groupHover\\:ikp-vis_visible{visibility:visible}.hover\\:ikp-text_gray\\.800:is(:hover,[data-hover]){color:var(--ikp-colors-gray-800)}.dark .hover\\:dark\\:ikp-text_whiteAlpha\\.800:is(:hover,[data-hover]),[data-theme=dark] .hover\\:dark\\:ikp-text_whiteAlpha\\.800:is(:hover,[data-hover]){color:var(--ikp-colors-white-alpha-800)}.hover\\:ikp-transform_scale\\(1\\.1\\):is(:hover,[data-hover]){transform:scale(1.1)}.hover\\:ikp-bg_transparent:is(:hover,[data-hover]){background:var(--ikp-colors-transparent)}.hover\\:ikp-text_gray\\.700:is(:hover,[data-hover]){color:var(--ikp-colors-gray-700)}.dark .hover\\:dark\\:ikp-text_whiteAlpha\\.500:is(:hover,[data-hover]),[data-theme=dark] .hover\\:dark\\:ikp-text_whiteAlpha\\.500:is(:hover,[data-hover]){color:var(--ikp-colors-white-alpha-500)}.hover\\:ikp-bg_grayAlpha\\.50\\!:is(:hover,[data-hover]){background-color:var(--ikp-colors-gray-alpha-50)!important}.hover\\:ikp-border_grayAlpha\\.50:is(:hover,[data-hover]){border-color:var(--ikp-colors-gray-alpha-50)}.hover\\:ikp-bg_gray\\.100:is(:hover,[data-hover]){background:var(--ikp-colors-gray-100)}.dark .hover\\:dark\\:ikp-bg_whiteAlpha\\.200:is(:hover,[data-hover]),[data-theme=dark] .hover\\:dark\\:ikp-bg_whiteAlpha\\.200:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-200)}.hover\\:ikp-bg_gray\\.200:is(:hover,[data-hover]){background:var(--ikp-colors-gray-200)}.dark .hover\\:dark\\:ikp-bg_whiteAlpha\\.300:is(:hover,[data-hover]),[data-theme=dark] .hover\\:dark\\:ikp-bg_whiteAlpha\\.300:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-300)}.hover\\:disabled\\:ikp-bg_gray\\.100:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){background:var(--ikp-colors-gray-100)}.dark .hover\\:disabled\\:dark\\:ikp-bg_whiteAlpha\\.200:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]),[data-theme=dark] .hover\\:disabled\\:dark\\:ikp-bg_whiteAlpha\\.200:is(:hover,[data-hover]):is(:disabled,[disabled],[data-disabled]){background:var(--ikp-colors-white-alpha-200)}.hover\\:ikp-cursor_pointer:is(:hover,[data-hover]){cursor:pointer}.hover\\:ikp-text-decor_none:is(:hover,[data-hover]){text-decoration:none}.hover\\:ikp-bg_gray\\.50:is(:hover,[data-hover]){background:var(--ikp-colors-gray-50)}.dark .hover\\:dark\\:ikp-bg_whiteAlpha\\.50:is(:hover,[data-hover]),[data-theme=dark] .hover\\:dark\\:ikp-bg_whiteAlpha\\.50:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-50)}.group:is(:hover,[data-hover]) .groupHover\\:ikp-text_inkeepPrimary\\.textSubtle{color:var(--ikp-colors-inkeep-primary-text-subtle)}.dark .group:is(:hover,[data-hover]) .groupHover\\:dark\\:ikp-text_grayDark\\.100,[data-theme=dark] .group:is(:hover,[data-hover]) .groupHover\\:dark\\:ikp-text_grayDark\\.100{color:var(--ikp-colors-gray-dark-100)}.light .light\\:hover\\:ikp-bg_gray\\.200:is(:hover,[data-hover]),[data-theme=light] .light\\:hover\\:ikp-bg_gray\\.200:is(:hover,[data-hover]){background:var(--ikp-colors-gray-200)}.light .light\\:hover\\:ikp-text_inkeepPrimary\\.strong:is(:hover,[data-hover]),[data-theme=light] .light\\:hover\\:ikp-text_inkeepPrimary\\.strong:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-primary-strong)}.dark .dark\\:hover\\:ikp-bg_whiteAlpha\\.100:is(:hover,[data-hover]),[data-theme=dark] .dark\\:hover\\:ikp-bg_whiteAlpha\\.100:is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-100)}.dark .dark\\:hover\\:ikp-text_inkeepExpandedPrimary\\.300:is(:hover,[data-hover]),[data-theme=dark] .dark\\:hover\\:ikp-text_inkeepExpandedPrimary\\.300:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-expanded-primary-300)}.disabled\\:hover\\:ikp-bg_none\\!:is(:disabled,[disabled],[data-disabled]):is(:hover,[data-hover]){background:none!important}.light .light\\:hover\\:ikp-bg_inkeepPrimary\\.lightSubtle:is(:hover,[data-hover]),[data-theme=light] .light\\:hover\\:ikp-bg_inkeepPrimary\\.lightSubtle:is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-light-subtle)}.light .light\\:hover\\:ikp-border_inkeepPrimary\\.mediumSubtle:is(:hover,[data-hover]),[data-theme=light] .light\\:hover\\:ikp-border_inkeepPrimary\\.mediumSubtle:is(:hover,[data-hover]){border-color:var(--ikp-colors-inkeep-primary-medium-subtle)}.light .light\\:hover\\:ikp-text_inkeepPrimary\\.textBold:is(:hover,[data-hover]),[data-theme=light] .light\\:hover\\:ikp-text_inkeepPrimary\\.textBold:is(:hover,[data-hover]){color:var(--ikp-colors-inkeep-primary-text-bold)}.dark .dark\\:hover\\:ikp-border_inkeepExpandedPrimary\\.300:is(:hover,[data-hover]),[data-theme=dark] .dark\\:hover\\:ikp-border_inkeepExpandedPrimary\\.300:is(:hover,[data-hover]){border-color:var(--ikp-colors-inkeep-expanded-primary-300)}.dark .dark\\:hover\\:ikp-bg_whiteAlpha\\.200\\!:is(:hover,[data-hover]),[data-theme=dark] .dark\\:hover\\:ikp-bg_whiteAlpha\\.200\\!:is(:hover,[data-hover]){background-color:var(--ikp-colors-white-alpha-200)!important}.dark .dark\\:hover\\:ikp-border_whiteAlpha\\.300:is(:hover,[data-hover]),[data-theme=dark] .dark\\:hover\\:ikp-border_whiteAlpha\\.300:is(:hover,[data-hover]){border-color:var(--ikp-colors-white-alpha-300)}.selected\\:hover\\:ikp-bg_inkeepPrimary\\.lightSubtle:is([aria-selected=true],[data-selected]):is(:hover,[data-hover]){background:var(--ikp-colors-inkeep-primary-light-subtle)}.dark .selected\\:dark\\:hover\\:ikp-bg_whiteAlpha\\.200:is([aria-selected=true],[data-selected]):is(:hover,[data-hover]),[data-theme=dark] .selected\\:dark\\:hover\\:ikp-bg_whiteAlpha\\.200:is([aria-selected=true],[data-selected]):is(:hover,[data-hover]){background:var(--ikp-colors-white-alpha-200)}.dark .dark\\:hover\\:ikp-text_white:is(:hover,[data-hover]),[data-theme=dark] .dark\\:hover\\:ikp-text_white:is(:hover,[data-hover]){color:var(--ikp-colors-white)}.light .light\\:hover\\:ikp-text_gray\\.700:is(:hover,[data-hover]),[data-theme=light] .light\\:hover\\:ikp-text_gray\\.700:is(:hover,[data-hover]){color:var(--ikp-colors-gray-700)}.active\\:ikp-transform_scale\\(\\.85\\):is(:active,[data-active]){transform:scale(.85)}.active\\:ikp-bg_gray\\.200:is(:active,[data-active]){background:var(--ikp-colors-gray-200)}.dark .active\\:dark\\:ikp-bg_whiteAlpha\\.300:is(:active,[data-active]),[data-theme=dark] .active\\:dark\\:ikp-bg_whiteAlpha\\.300:is(:active,[data-active]){background:var(--ikp-colors-white-alpha-300)}.active\\:ikp-bg_gray\\.300:is(:active,[data-active]){background:var(--ikp-colors-gray-300)}.dark .active\\:dark\\:ikp-bg_whiteAlpha\\.400:is(:active,[data-active]),[data-theme=dark] .active\\:dark\\:ikp-bg_whiteAlpha\\.400:is(:active,[data-active]){background:var(--ikp-colors-white-alpha-400)}.disabled\\:active\\:ikp-bg_none\\!:is(:disabled,[disabled],[data-disabled]):is(:active,[data-active]){background:none!important}.light .light\\:active\\:ikp-bg_gray\\.300:is(:active,[data-active]),[data-theme=light] .light\\:active\\:ikp-bg_gray\\.300:is(:active,[data-active]){background:var(--ikp-colors-gray-300)}.dark .dark\\:active\\:ikp-bg_whiteAlpha\\.200:is(:active,[data-active]),[data-theme=dark] .dark\\:active\\:ikp-bg_whiteAlpha\\.200:is(:active,[data-active]){background:var(--ikp-colors-white-alpha-200)}@media screen and (min-width: 33em){.sm\\:ikp-fs_24px{font-size:24px}.sm\\:ikp-w_420px{width:420px}.sm\\:ikp-w_24px{width:24px}}@media screen and (min-width: 48em){.md\\:ikp-leading_24px{line-height:24px}.md\\:ikp-right_6{right:var(--ikp-spacing-6)}.md\\:ikp-px_10{padding-inline:var(--ikp-spacing-10)}.md\\:ikp-py_10{padding-block:var(--ikp-spacing-10)}.md\\:ikp-fs_sm{font-size:var(--ikp-font-sizes-sm)}.md\\:ikp-gap_2{gap:var(--ikp-spacing-2)}}}
`;
function u1(e) {
  return typeof e == "object" && e != null && !Array.isArray(e);
}
function Y_(e) {
  return Object.fromEntries(Object.entries(e ?? {}).filter(([t, r]) => r !== void 0));
}
var cS = (e) => e === "base";
function dS(e) {
  return e.slice().filter((t) => !cS(t));
}
var n8 = /!(important)?/;
function pS(e) {
  return typeof e == "string" ? n8.test(e) : !1;
}
function hS(e) {
  return typeof e == "string" ? e.replace(n8, "").trim() : e;
}
function q_(e) {
  return typeof e == "string" ? e.replaceAll(" ", "_") : e;
}
function v5(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
}
function fS(e) {
  let t = "", r;
  for (r = Math.abs(e); r > 52; r = r / 52 | 0)
    t = v5(r % 52) + t;
  return v5(r % 52) + t;
}
function gS(e, t) {
  let r = t.length;
  for (; r; )
    e = e * 33 ^ t.charCodeAt(--r);
  return e;
}
function mS(e) {
  return fS(gS(5381, e) >>> 0);
}
function Q_(...e) {
  return e.filter(Boolean).reduce((r, i) => (Object.keys(i).forEach((n) => {
    const a = r[n], o = i[n];
    u1(a) && u1(o) ? r[n] = Q_(a, o) : r[n] = o;
  }), r), {});
}
var vS = (e) => e != null;
function im(e, t, r = {}) {
  const { stop: i, getKey: n } = r;
  function a(o, s = []) {
    if (u1(o) || Array.isArray(o)) {
      const l = {};
      for (const [u, d] of Object.entries(o)) {
        const c = (n == null ? void 0 : n(u)) ?? u, p = [...s, c];
        if (i != null && i(o, p))
          return t(o, s);
        const f = a(d, p);
        vS(f) && (l[c] = f);
      }
      return l;
    }
    return t(o, s);
  }
  return a(e);
}
function uc(e, t) {
  return Array.isArray(e) ? e.map((r) => t(r)) : u1(e) ? im(e, (r) => t(r)) : t(e);
}
function kS(e, t) {
  return e.reduce((r, i, n) => {
    const a = t[n];
    return i != null && (r[a] = i), r;
  }, {});
}
function bS(e, t) {
  const { hasShorthand: r, resolveShorthand: i } = t.utility;
  return im(e, (n) => n, {
    getKey: (n) => r ? i(n) : n
  });
}
function _S(e, t, r = !0) {
  const { utility: i, conditions: n } = t, { hasShorthand: a, resolveShorthand: o } = i;
  return im(
    e,
    (s) => Array.isArray(s) ? kS(s, n.breakpoints.keys) : s,
    {
      stop: (s) => Array.isArray(s),
      getKey: r ? (s) => a ? o(s) : s : void 0
    }
  );
}
var DS = {
  shift: (e) => e,
  finalize: (e) => e,
  breakpoints: { keys: [] }
}, yS = (e) => typeof e == "string" ? e.replaceAll(/[\n\s]+/g, " ") : e;
function a8(e) {
  const { utility: t, hash: r, conditions: i = DS } = e, n = (o) => [t.prefix, o].filter(Boolean).join("-"), a = (o, s) => {
    let l;
    if (r) {
      const u = [...i.finalize(o), s];
      l = n(mS(u.join(":")));
    } else
      l = [...i.finalize(o), n(s)].join(":");
    return l;
  };
  return (o = {}) => {
    const s = _S(o, e), l = /* @__PURE__ */ new Set();
    return im(s, (u, d) => {
      const c = pS(u);
      if (u == null)
        return;
      const [p, ...f] = i.shift(d), g = dS(f), k = t.transform(p, hS(yS(u)));
      let y = a(g, k.className);
      c && (y = `${y}!`), l.add(y);
    }), Array.from(l).join(" ");
  };
}
function ES(...e) {
  return e.filter((t) => u1(t) && Object.keys(Y_(t)).length > 0);
}
function CS(e) {
  function t(n) {
    const a = ES(...n);
    return a.length === 1 ? a : a.map((o) => bS(o, e));
  }
  function r(...n) {
    return Q_(...t(n));
  }
  function i(...n) {
    return Object.assign({}, ...t(n));
  }
  return { mergeCss: r, assignCss: i };
}
var o8 = (e) => {
  const t = /* @__PURE__ */ new Map();
  return (...i) => {
    const n = JSON.stringify(i);
    if (t.has(n))
      return t.get(n);
    const a = e(...i);
    return t.set(n, a), a;
  };
}, xS = /([A-Z])/g, AS = /^ms-/, wS = o8((e) => e.startsWith("--") ? e : e.replace(xS, "-$1").replace(AS, "-ms-").toLowerCase()), FS = (e = {}) => {
  const t = (n) => {
    var a;
    return {
      className: [e.className, n].filter(Boolean).join("__"),
      base: ((a = e.base) == null ? void 0 : a[n]) ?? {},
      variants: {},
      defaultVariants: e.defaultVariants ?? {},
      compoundVariants: e.compoundVariants ? bn(e.compoundVariants, n) : []
    };
  }, i = (e.slots ?? []).map((n) => [n, t(n)]);
  for (const [n, a] of Object.entries(e.variants ?? {}))
    for (const [o, s] of Object.entries(a))
      i.forEach(([l, u]) => {
        var d;
        (d = u.variants)[n] ?? (d[n] = {}), u.variants[n][o] = s[l] ?? {};
      });
  return Object.fromEntries(i);
}, bn = (e, t) => e.filter((r) => r.css[t]).map((r) => ({ ...r, css: r.css[t] }));
function Rr(e, ...t) {
  const r = Object.getOwnPropertyDescriptors(e), i = Object.keys(r), n = (o) => {
    const s = {};
    for (let l = 0; l < o.length; l++) {
      const u = o[l];
      r[u] && (Object.defineProperty(s, u, r[u]), delete r[u]);
    }
    return s;
  }, a = (o) => n(Array.isArray(o) ? o : i.filter(o));
  return t.map(a).concat(n(i));
}
var xb = (...e) => e.filter(Boolean).reduce((t, r) => Array.from(/* @__PURE__ */ new Set([...t, ...r])), []), s8 = ["htmlSize", "htmlTranslate", "htmlWidth", "htmlHeight"];
function TS(e) {
  return s8.includes(e) ? e.replace("html", "").toLowerCase() : e;
}
function Ab(e) {
  return Object.fromEntries(Object.entries(e).map(([t, r]) => [TS(t), r]));
}
Ab.keys = s8;
const SS = "_invalid,_hover,_focus,_focusWithin,_focusVisible,_disabled,_active,_visited,_target,_readOnly,_readWrite,_empty,_checked,_enabled,_expanded,_highlighted,_before,_after,_firstLetter,_firstLine,_marker,_selection,_file,_backdrop,_first,_last,_only,_even,_odd,_firstOfType,_lastOfType,_onlyOfType,_peerFocus,_peerHover,_peerActive,_peerFocusWithin,_peerFocusVisible,_peerDisabled,_peerChecked,_peerInvalid,_peerExpanded,_peerPlaceholderShown,_groupFocus,_groupHover,_groupActive,_groupFocusWithin,_groupFocusVisible,_groupDisabled,_groupChecked,_groupExpanded,_groupInvalid,_indeterminate,_required,_valid,_autofill,_inRange,_outOfRange,_placeholder,_placeholderShown,_pressed,_selected,_default,_optional,_open,_closed,_fullscreen,_loading,_currentPage,_currentStep,_motionReduce,_motionSafe,_print,_landscape,_portrait,_dark,_light,_osDark,_osLight,_highContrast,_lessContrast,_moreContrast,_ltr,_rtl,_scrollbar,_scrollbarThumb,_scrollbarTrack,_horizontal,_vertical,_hidden,sm,smOnly,smDown,md,mdOnly,mdDown,lg,lgOnly,lgDown,xl,xlOnly,xlDown,2xl,2xlOnly,2xlDown,smToMd,smToLg,smToXl,smTo2xl,mdToLg,mdToXl,mdTo2xl,lgToXl,lgTo2xl,xlTo2xl,base", l8 = new Set(SS.split(","));
function k5(e) {
  return l8.has(e) || /^@|&|&$/.test(e);
}
const IS = /^_/, BS = /&|@/;
function u8(e) {
  return e.map((t) => l8.has(t) ? t.replace(IS, "") : BS.test(t) ? `[${q_(t.trim())}]` : t);
}
function c8(e) {
  return e.sort((t, r) => {
    const i = k5(t), n = k5(r);
    return i && !n ? 1 : !i && n ? -1 : 0;
  });
}
const RS = "aspectRatio:aspect,boxDecorationBreak:decoration,zIndex:z,boxSizing:box,objectPosition:object,objectFit:object,overscrollBehavior:overscroll,overscrollBehaviorX:overscroll-x,overscrollBehaviorY:overscroll-y,position:pos/1,top:top,left:left,insetInline:inset-x,insetBlock:inset-y,inset:inset,insetBlockEnd:inset-b,insetBlockStart:inset-t,insetInlineEnd:end/insetEnd/1,insetInlineStart:start/insetStart/1,right:right,bottom:bottom,insetX:inset-x,insetY:inset-y,float:float,visibility:vis,display:d,hideFrom:hide,hideBelow:show,flexBasis:basis,flex:flex,flexDirection:flex/flexDir,flexGrow:grow,flexShrink:shrink,gridTemplateColumns:grid-cols,gridTemplateRows:grid-rows,gridColumn:col-span,gridRow:row-span,gridColumnStart:col-start,gridColumnEnd:col-end,gridAutoFlow:grid-flow,gridAutoColumns:auto-cols,gridAutoRows:auto-rows,gap:gap,gridGap:gap,gridRowGap:gap-x,gridColumnGap:gap-y,rowGap:gap-x,columnGap:gap-y,justifyContent:justify,alignContent:content,alignItems:items,alignSelf:self,padding:p/1,paddingLeft:pl/1,paddingRight:pr/1,paddingTop:pt/1,paddingBottom:pb/1,paddingBlock:py/1/paddingY,paddingBlockEnd:pb,paddingBlockStart:pt,paddingInline:px/paddingX/1,paddingInlineEnd:pe/1/paddingEnd,paddingInlineStart:ps/1/paddingStart,marginLeft:ml/1,marginRight:mr/1,marginTop:mt/1,marginBottom:mb/1,margin:m/1,marginBlock:my/1/marginY,marginBlockEnd:mb,marginBlockStart:mt,marginInline:mx/1/marginX,marginInlineEnd:me/1/marginEnd,marginInlineStart:ms/1/marginStart,outlineWidth:ring/ringWidth,outlineColor:ring/ringColor,outline:ring/1,outlineOffset:ring/ringOffset,divideX:divide-x,divideY:divide-y,divideColor:divide,divideStyle:divide,width:w/1,inlineSize:w,minWidth:min-w/minW,minInlineSize:min-w,maxWidth:max-w/maxW,maxInlineSize:max-w,height:h/1,blockSize:h,minHeight:min-h/minH,minBlockSize:min-h,maxHeight:max-h/maxH,maxBlockSize:max-b,color:text,fontFamily:font,fontSize:fs,fontWeight:font,fontSmoothing:smoothing,fontVariantNumeric:numeric,letterSpacing:tracking,lineHeight:leading,textAlign:text,textDecoration:text-decor,textDecorationColor:text-decor,textEmphasisColor:text-emphasis,textDecorationStyle:decoration,textDecorationThickness:decoration,textUnderlineOffset:underline-offset,textTransform:text,textIndent:indent,textShadow:text-shadow,textOverflow:text,verticalAlign:align,wordBreak:break,textWrap:text,truncate:truncate,lineClamp:clamp,listStyleType:list,listStylePosition:list,listStyleImage:list-img,backgroundPosition:bg/bgPosition,backgroundPositionX:bg-x/bgPositionX,backgroundPositionY:bg-y/bgPositionY,backgroundAttachment:bg/bgAttachment,backgroundClip:bg-clip/bgClip,background:bg/1,backgroundColor:bg/bgColor,backgroundOrigin:bg-origin/bgOrigin,backgroundImage:bg-img/bgImage,backgroundRepeat:bg-repeat/bgRepeat,backgroundBlendMode:bg-blend/bgBlendMode,backgroundSize:bg/bgSize,backgroundGradient:bg-gradient/bgGradient,textGradient:text-gradient,gradientFrom:from,gradientTo:to,gradientVia:via,borderRadius:rounded/1,borderTopLeftRadius:rounded-tl/roundedTopLeft,borderTopRightRadius:rounded-tr/roundedTopRight,borderBottomRightRadius:rounded-br/roundedBottomRight,borderBottomLeftRadius:rounded-bl/roundedBottomLeft,borderTopRadius:rounded-t/roundedTop,borderRightRadius:rounded-r/roundedRight,borderBottomRadius:rounded-b/roundedBottom,borderLeftRadius:rounded-l/roundedLeft,borderStartStartRadius:rounded-ss/roundedStartStart,borderStartEndRadius:rounded-se/roundedStartEnd,borderStartRadius:rounded-s/roundedStart,borderEndStartRadius:rounded-es/roundedEndStart,borderEndEndRadius:rounded-ee/roundedEndEnd,borderEndRadius:rounded-e/roundedEnd,border:border,borderWidth:border-w,borderTopWidth:border-tw,borderLeftWidth:border-lw,borderRightWidth:border-rw,borderBottomWidth:border-bw,borderColor:border,borderInline:border-x/borderX,borderInlineWidth:border-x/borderXWidth,borderInlineColor:border-x/borderXColor,borderBlock:border-y/borderY,borderBlockWidth:border-y/borderYWidth,borderBlockColor:border-y/borderYColor,borderLeft:border-l,borderLeftColor:border-l,borderInlineStart:border-s/borderStart,borderInlineStartWidth:border-s/borderStartWidth,borderInlineStartColor:border-s/borderStartColor,borderRight:border-r,borderRightColor:border-r,borderInlineEnd:border-e/borderEnd,borderInlineEndWidth:border-e/borderEndWidth,borderInlineEndColor:border-e/borderEndColor,borderTop:border-t,borderTopColor:border-t,borderBottom:border-b,borderBottomColor:border-b,borderBlockEnd:border-be,borderBlockEndColor:border-be,borderBlockStart:border-bs,borderBlockStartColor:border-bs,boxShadow:shadow/1,boxShadowColor:shadow/shadowColor,mixBlendMode:mix-blend,filter:filter,brightness:brightness,contrast:contrast,grayscale:grayscale,hueRotate:hue-rotate,invert:invert,saturate:saturate,sepia:sepia,dropShadow:drop-shadow,blur:blur,backdropFilter:backdrop,backdropBlur:backdrop-blur,backdropBrightness:backdrop-brightness,backdropContrast:backdrop-contrast,backdropGrayscale:backdrop-grayscale,backdropHueRotate:backdrop-hue-rotate,backdropInvert:backdrop-invert,backdropOpacity:backdrop-opacity,backdropSaturate:backdrop-saturate,backdropSepia:backdrop-sepia,borderCollapse:border,borderSpacing:border-spacing,borderSpacingX:border-spacing-x,borderSpacingY:border-spacing-y,tableLayout:table,transitionTimingFunction:ease,transitionDelay:delay,transitionDuration:duration,transitionProperty:transition-prop,transition:transition,animation:animation,animationName:animation-name,animationDelay:animation-delay,transformOrigin:origin,scale:scale,scaleX:scale-x,scaleY:scale-y,translate:translate,translateX:translate-x/x,translateY:translate-y/y,accentColor:accent,caretColor:caret,scrollBehavior:scroll,scrollbar:scrollbar,scrollMargin:scroll-m,scrollMarginX:scroll-mx,scrollMarginY:scroll-my,scrollMarginLeft:scroll-ml,scrollMarginRight:scroll-mr,scrollMarginTop:scroll-mt,scrollMarginBottom:scroll-mb,scrollMarginBlock:scroll-my,scrollMarginBlockEnd:scroll-mb,scrollMarginBlockStart:scroll-mt,scrollMarginInline:scroll-mx,scrollMarginInlineEnd:scroll-me,scrollMarginInlineStart:scroll-ms,scrollPadding:scroll-p,scrollPaddingBlock:scroll-pb,scrollPaddingBlockStart:scroll-pt,scrollPaddingBlockEnd:scroll-pb,scrollPaddingInline:scroll-px,scrollPaddingInlineEnd:scroll-pe,scrollPaddingInlineStart:scroll-ps,scrollPaddingX:scroll-px,scrollPaddingY:scroll-py,scrollPaddingLeft:scroll-pl,scrollPaddingRight:scroll-pr,scrollPaddingTop:scroll-pt,scrollPaddingBottom:scroll-pb,scrollSnapAlign:snap,scrollSnapStop:snap,scrollSnapType:snap,scrollSnapStrictness:strictness,scrollSnapMargin:snap-m,scrollSnapMarginTop:snap-mt,scrollSnapMarginBottom:snap-mb,scrollSnapMarginLeft:snap-ml,scrollSnapMarginRight:snap-mr,touchAction:touch,userSelect:select,fill:fill,stroke:stroke,strokeWidth:stroke-w,srOnly:sr,debug:debug,appearance:appearance,backfaceVisibility:backface,clipPath:clip-path,hyphens:hyphens,mask:mask,maskImage:mask-image,maskSize:mask-size,textSizeAdjust:text-size-adjust,noOfLines:n-lines,backgroundAlpha:bg-alpha/bga,colorAlpha:text-alpha,textStyle:textStyle", d8 = /* @__PURE__ */ new Map(), p8 = /* @__PURE__ */ new Map();
RS.split(",").forEach((e) => {
  const [t, r] = e.split(":"), [i, ...n] = r.split("/");
  d8.set(t, i), n.length && n.forEach((a) => {
    p8.set(a === "1" ? i : a, t);
  });
});
const b5 = (e) => p8.get(e) || e, h8 = {
  conditions: {
    shift: c8,
    finalize: u8,
    breakpoints: { keys: ["base", "sm", "md", "lg", "xl", "2xl"] }
  },
  utility: {
    prefix: "ikp",
    transform: (e, t) => {
      const r = b5(e);
      return { className: `${d8.get(r) || wS(r)}_${q_(t)}` };
    },
    hasShorthand: !0,
    resolveShorthand: b5
  }
}, OS = a8(h8), yo = (...e) => OS(Uu(...e));
yo.raw = (...e) => Uu(...e);
const { mergeCss: Uu, assignCss: mue } = CS(h8);
function Eo() {
  let e = "", t = 0, r;
  for (; t < arguments.length; )
    (r = arguments[t++]) && typeof r == "string" && (e && (e += " "), e += r);
  return e;
}
const _5 = (e) => ({
  base: {},
  variants: {},
  defaultVariants: {},
  compoundVariants: [],
  ...e
});
function T1(e) {
  const { base: t, variants: r, defaultVariants: i, compoundVariants: n } = _5(e);
  function a(c = {}) {
    var k;
    const p = { ...i, ...Y_(c) };
    let f = { ...t };
    for (const [y, _] of Object.entries(p))
      (k = r[y]) != null && k[_] && (f = Uu(f, r[y][_]));
    const g = wb(n, p);
    return Uu(f, g);
  }
  function o(c) {
    const p = _5(c.config), f = xb(c.variantKeys, Object.keys(r));
    return T1({
      base: Uu(t, p.base),
      variants: Object.fromEntries(
        f.map((g) => [g, Uu(r[g], p.variants[g])])
      ),
      defaultVariants: Q_(i, p.defaultVariants),
      compoundVariants: [...n, ...p.compoundVariants]
    });
  }
  function s(c) {
    return yo(a(c));
  }
  const l = Object.keys(r);
  function u(c) {
    return Rr(c, l);
  }
  const d = Object.fromEntries(Object.entries(r).map(([c, p]) => [c, Object.keys(p)]));
  return Object.assign(s, {
    __cva__: !0,
    variantMap: d,
    variantKeys: l,
    raw: a,
    config: e,
    merge: o,
    splitVariantProps: u
  });
}
function wb(e, t) {
  let r = {};
  return e.forEach((i) => {
    Object.entries(i).every(([a, o]) => a === "css" ? !0 : (Array.isArray(o) ? o : [o]).some((l) => t[a] === l)) && (r = Uu(r, i.css));
  }), r;
}
function PS(e, t, r, i) {
  if (t.length > 0 && typeof (r == null ? void 0 : r[i]) == "object")
    throw new Error(`[recipe:${e}:${i}] Conditions are not supported when using compound variants.`);
}
function NS(e) {
  const t = Object.entries(FS(e)).map(([l, u]) => [l, T1(u)]);
  function r(l) {
    const u = t.map(([d, c]) => [d, c(l)]);
    return Object.fromEntries(u);
  }
  function i(l) {
    const u = t.map(([d, c]) => [d, c.raw(l)]);
    return Object.fromEntries(u);
  }
  const n = e.variants ?? {}, a = Object.keys(n);
  function o(l) {
    return Rr(l, a);
  }
  const s = Object.fromEntries(
    Object.entries(n).map(([l, u]) => [l, Object.keys(u)])
  );
  return Object.assign(r, {
    __cva__: !1,
    raw: i,
    variantMap: s,
    variantKeys: a,
    splitVariantProps: o
  });
}
var zS = "css,pos,insetEnd,end,insetStart,start,flexDir,p,pl,pr,pt,pb,py,paddingY,paddingX,px,pe,paddingEnd,ps,paddingStart,ml,mr,mt,mb,m,my,marginY,mx,marginX,me,marginEnd,ms,marginStart,ringWidth,ringColor,ring,ringOffset,w,minW,maxW,h,minH,maxH,bgPosition,bgPositionX,bgPositionY,bgAttachment,bgClip,bg,bgColor,bgOrigin,bgImage,bgRepeat,bgBlendMode,bgSize,bgGradient,rounded,roundedTopLeft,roundedTopRight,roundedBottomRight,roundedBottomLeft,roundedTop,roundedRight,roundedBottom,roundedLeft,roundedStartStart,roundedStartEnd,roundedStart,roundedEndStart,roundedEndEnd,roundedEnd,borderX,borderXWidth,borderXColor,borderY,borderYWidth,borderYColor,borderStart,borderStartWidth,borderStartColor,borderEnd,borderEndWidth,borderEndColor,shadow,shadowColor,x,y,bga,aspectRatio,boxDecorationBreak,zIndex,boxSizing,objectPosition,objectFit,overscrollBehavior,overscrollBehaviorX,overscrollBehaviorY,position,top,left,insetInline,insetBlock,inset,insetBlockEnd,insetBlockStart,insetInlineEnd,insetInlineStart,right,bottom,insetX,insetY,float,visibility,display,hideFrom,hideBelow,flexBasis,flex,flexDirection,flexGrow,flexShrink,gridTemplateColumns,gridTemplateRows,gridColumn,gridRow,gridColumnStart,gridColumnEnd,gridAutoFlow,gridAutoColumns,gridAutoRows,gap,gridGap,gridRowGap,gridColumnGap,rowGap,columnGap,justifyContent,alignContent,alignItems,alignSelf,padding,paddingLeft,paddingRight,paddingTop,paddingBottom,paddingBlock,paddingBlockEnd,paddingBlockStart,paddingInline,paddingInlineEnd,paddingInlineStart,marginLeft,marginRight,marginTop,marginBottom,margin,marginBlock,marginBlockEnd,marginBlockStart,marginInline,marginInlineEnd,marginInlineStart,outlineWidth,outlineColor,outline,outlineOffset,divideX,divideY,divideColor,divideStyle,width,inlineSize,minWidth,minInlineSize,maxWidth,maxInlineSize,height,blockSize,minHeight,minBlockSize,maxHeight,maxBlockSize,color,fontFamily,fontSize,fontWeight,fontSmoothing,fontVariantNumeric,letterSpacing,lineHeight,textAlign,textDecoration,textDecorationColor,textEmphasisColor,textDecorationStyle,textDecorationThickness,textUnderlineOffset,textTransform,textIndent,textShadow,textOverflow,verticalAlign,wordBreak,textWrap,truncate,lineClamp,listStyleType,listStylePosition,listStyleImage,backgroundPosition,backgroundPositionX,backgroundPositionY,backgroundAttachment,backgroundClip,background,backgroundColor,backgroundOrigin,backgroundImage,backgroundRepeat,backgroundBlendMode,backgroundSize,backgroundGradient,textGradient,gradientFrom,gradientTo,gradientVia,borderRadius,borderTopLeftRadius,borderTopRightRadius,borderBottomRightRadius,borderBottomLeftRadius,borderTopRadius,borderRightRadius,borderBottomRadius,borderLeftRadius,borderStartStartRadius,borderStartEndRadius,borderStartRadius,borderEndStartRadius,borderEndEndRadius,borderEndRadius,border,borderWidth,borderTopWidth,borderLeftWidth,borderRightWidth,borderBottomWidth,borderColor,borderInline,borderInlineWidth,borderInlineColor,borderBlock,borderBlockWidth,borderBlockColor,borderLeft,borderLeftColor,borderInlineStart,borderInlineStartWidth,borderInlineStartColor,borderRight,borderRightColor,borderInlineEnd,borderInlineEndWidth,borderInlineEndColor,borderTop,borderTopColor,borderBottom,borderBottomColor,borderBlockEnd,borderBlockEndColor,borderBlockStart,borderBlockStartColor,opacity,boxShadow,boxShadowColor,mixBlendMode,filter,brightness,contrast,grayscale,hueRotate,invert,saturate,sepia,dropShadow,blur,backdropFilter,backdropBlur,backdropBrightness,backdropContrast,backdropGrayscale,backdropHueRotate,backdropInvert,backdropOpacity,backdropSaturate,backdropSepia,borderCollapse,borderSpacing,borderSpacingX,borderSpacingY,tableLayout,transitionTimingFunction,transitionDelay,transitionDuration,transitionProperty,transition,animation,animationName,animationDelay,transformOrigin,scale,scaleX,scaleY,translate,translateX,translateY,accentColor,caretColor,scrollBehavior,scrollbar,scrollMargin,scrollMarginX,scrollMarginY,scrollMarginLeft,scrollMarginRight,scrollMarginTop,scrollMarginBottom,scrollMarginBlock,scrollMarginBlockEnd,scrollMarginBlockStart,scrollMarginInline,scrollMarginInlineEnd,scrollMarginInlineStart,scrollPadding,scrollPaddingBlock,scrollPaddingBlockStart,scrollPaddingBlockEnd,scrollPaddingInline,scrollPaddingInlineEnd,scrollPaddingInlineStart,scrollPaddingX,scrollPaddingY,scrollPaddingLeft,scrollPaddingRight,scrollPaddingTop,scrollPaddingBottom,scrollSnapAlign,scrollSnapStop,scrollSnapType,scrollSnapStrictness,scrollSnapMargin,scrollSnapMarginTop,scrollSnapMarginBottom,scrollSnapMarginLeft,scrollSnapMarginRight,touchAction,userSelect,fill,stroke,strokeWidth,srOnly,debug,appearance,backfaceVisibility,clipPath,hyphens,mask,maskImage,maskSize,textSizeAdjust,noOfLines,backgroundAlpha,colorAlpha,colorPalette,textStyle,_invalid,_hover,_focus,_focusWithin,_focusVisible,_disabled,_active,_visited,_target,_readOnly,_readWrite,_empty,_checked,_enabled,_expanded,_highlighted,_before,_after,_firstLetter,_firstLine,_marker,_selection,_file,_backdrop,_first,_last,_only,_even,_odd,_firstOfType,_lastOfType,_onlyOfType,_peerFocus,_peerHover,_peerActive,_peerFocusWithin,_peerFocusVisible,_peerDisabled,_peerChecked,_peerInvalid,_peerExpanded,_peerPlaceholderShown,_groupFocus,_groupHover,_groupActive,_groupFocusWithin,_groupFocusVisible,_groupDisabled,_groupChecked,_groupExpanded,_groupInvalid,_indeterminate,_required,_valid,_autofill,_inRange,_outOfRange,_placeholder,_placeholderShown,_pressed,_selected,_default,_optional,_open,_closed,_fullscreen,_loading,_currentPage,_currentStep,_motionReduce,_motionSafe,_print,_landscape,_portrait,_dark,_light,_osDark,_osLight,_highContrast,_lessContrast,_moreContrast,_ltr,_rtl,_scrollbar,_scrollbarThumb,_scrollbarTrack,_horizontal,_vertical,_hidden,sm,smOnly,smDown,md,mdOnly,mdDown,lg,lgOnly,lgDown,xl,xlOnly,xlDown,2xl,2xlOnly,2xlDown,smToMd,smToLg,smToXl,smTo2xl,mdToLg,mdToXl,mdTo2xl,lgToXl,lgTo2xl,xlTo2xl", LS = zS.split(","), MS = "WebkitAppearance,WebkitBorderBefore,WebkitBorderBeforeColor,WebkitBorderBeforeStyle,WebkitBorderBeforeWidth,WebkitBoxReflect,WebkitLineClamp,WebkitMask,WebkitMaskAttachment,WebkitMaskClip,WebkitMaskComposite,WebkitMaskImage,WebkitMaskOrigin,WebkitMaskPosition,WebkitMaskPositionX,WebkitMaskPositionY,WebkitMaskRepeat,WebkitMaskRepeatX,WebkitMaskRepeatY,WebkitMaskSize,WebkitOverflowScrolling,WebkitTapHighlightColor,WebkitTextFillColor,WebkitTextStroke,WebkitTextStrokeColor,WebkitTextStrokeWidth,WebkitTouchCallout,WebkitUserModify,accentColor,alignContent,alignItems,alignSelf,alignTracks,all,animation,animationComposition,animationDelay,animationDirection,animationDuration,animationFillMode,animationIterationCount,animationName,animationPlayState,animationTimingFunction,animationTimeline,appearance,aspectRatio,azimuth,backdropFilter,backfaceVisibility,background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundPositionX,backgroundPositionY,backgroundRepeat,backgroundSize,blockOverflow,blockSize,border,borderBlock,borderBlockColor,borderBlockStyle,borderBlockWidth,borderBlockEnd,borderBlockEndColor,borderBlockEndStyle,borderBlockEndWidth,borderBlockStart,borderBlockStartColor,borderBlockStartStyle,borderBlockStartWidth,borderBottom,borderBottomColor,borderBottomLeftRadius,borderBottomRightRadius,borderBottomStyle,borderBottomWidth,borderCollapse,borderColor,borderEndEndRadius,borderEndStartRadius,borderImage,borderImageOutset,borderImageRepeat,borderImageSlice,borderImageSource,borderImageWidth,borderInline,borderInlineEnd,borderInlineColor,borderInlineStyle,borderInlineWidth,borderInlineEndColor,borderInlineEndStyle,borderInlineEndWidth,borderInlineStart,borderInlineStartColor,borderInlineStartStyle,borderInlineStartWidth,borderLeft,borderLeftColor,borderLeftStyle,borderLeftWidth,borderRadius,borderRight,borderRightColor,borderRightStyle,borderRightWidth,borderSpacing,borderStartEndRadius,borderStartStartRadius,borderStyle,borderTop,borderTopColor,borderTopLeftRadius,borderTopRightRadius,borderTopStyle,borderTopWidth,borderWidth,bottom,boxAlign,boxDecorationBreak,boxDirection,boxFlex,boxFlexGroup,boxLines,boxOrdinalGroup,boxOrient,boxPack,boxShadow,boxSizing,breakAfter,breakBefore,breakInside,captionSide,caret,caretColor,caretShape,clear,clip,clipPath,color,colorScheme,columnCount,columnFill,columnGap,columnRule,columnRuleColor,columnRuleStyle,columnRuleWidth,columnSpan,columnWidth,columns,contain,containIntrinsicSize,containIntrinsicBlockSize,containIntrinsicHeight,containIntrinsicInlineSize,containIntrinsicWidth,container,containerName,containerType,content,contentVisibility,counterIncrement,counterReset,counterSet,cursor,direction,display,emptyCells,filter,flex,flexBasis,flexDirection,flexFlow,flexGrow,flexShrink,flexWrap,float,font,fontFamily,fontFeatureSettings,fontKerning,fontLanguageOverride,fontOpticalSizing,fontPalette,fontVariationSettings,fontSize,fontSizeAdjust,fontSmooth,fontStretch,fontStyle,fontSynthesis,fontVariant,fontVariantAlternates,fontVariantCaps,fontVariantEastAsian,fontVariantEmoji,fontVariantLigatures,fontVariantNumeric,fontVariantPosition,fontWeight,forcedColorAdjust,gap,grid,gridArea,gridAutoColumns,gridAutoFlow,gridAutoRows,gridColumn,gridColumnEnd,gridColumnGap,gridColumnStart,gridGap,gridRow,gridRowEnd,gridRowGap,gridRowStart,gridTemplate,gridTemplateAreas,gridTemplateColumns,gridTemplateRows,hangingPunctuation,height,hyphenateCharacter,hyphenateLimitChars,hyphens,imageOrientation,imageRendering,imageResolution,imeMode,initialLetter,initialLetterAlign,inlineSize,inputSecurity,inset,insetBlock,insetBlockEnd,insetBlockStart,insetInline,insetInlineEnd,insetInlineStart,isolation,justifyContent,justifyItems,justifySelf,justifyTracks,left,letterSpacing,lineBreak,lineClamp,lineHeight,lineHeightStep,listStyle,listStyleImage,listStylePosition,listStyleType,margin,marginBlock,marginBlockEnd,marginBlockStart,marginBottom,marginInline,marginInlineEnd,marginInlineStart,marginLeft,marginRight,marginTop,marginTrim,mask,maskBorder,maskBorderMode,maskBorderOutset,maskBorderRepeat,maskBorderSlice,maskBorderSource,maskBorderWidth,maskClip,maskComposite,maskImage,maskMode,maskOrigin,maskPosition,maskRepeat,maskSize,maskType,masonryAutoFlow,mathDepth,mathShift,mathStyle,maxBlockSize,maxHeight,maxInlineSize,maxLines,maxWidth,minBlockSize,minHeight,minInlineSize,minWidth,mixBlendMode,objectFit,objectPosition,offset,offsetAnchor,offsetDistance,offsetPath,offsetPosition,offsetRotate,opacity,order,orphans,outline,outlineColor,outlineOffset,outlineStyle,outlineWidth,overflow,overflowAnchor,overflowBlock,overflowClipBox,overflowClipMargin,overflowInline,overflowWrap,overflowX,overflowY,overscrollBehavior,overscrollBehaviorBlock,overscrollBehaviorInline,overscrollBehaviorX,overscrollBehaviorY,padding,paddingBlock,paddingBlockEnd,paddingBlockStart,paddingBottom,paddingInline,paddingInlineEnd,paddingInlineStart,paddingLeft,paddingRight,paddingTop,page,pageBreakAfter,pageBreakBefore,pageBreakInside,paintOrder,perspective,perspectiveOrigin,placeContent,placeItems,placeSelf,pointerEvents,position,printColorAdjust,quotes,resize,right,rotate,rowGap,rubyAlign,rubyMerge,rubyPosition,scale,scrollbarColor,scrollbarGutter,scrollbarWidth,scrollBehavior,scrollMargin,scrollMarginBlock,scrollMarginBlockStart,scrollMarginBlockEnd,scrollMarginBottom,scrollMarginInline,scrollMarginInlineStart,scrollMarginInlineEnd,scrollMarginLeft,scrollMarginRight,scrollMarginTop,scrollPadding,scrollPaddingBlock,scrollPaddingBlockStart,scrollPaddingBlockEnd,scrollPaddingBottom,scrollPaddingInline,scrollPaddingInlineStart,scrollPaddingInlineEnd,scrollPaddingLeft,scrollPaddingRight,scrollPaddingTop,scrollSnapAlign,scrollSnapCoordinate,scrollSnapDestination,scrollSnapPointsX,scrollSnapPointsY,scrollSnapStop,scrollSnapType,scrollSnapTypeX,scrollSnapTypeY,scrollTimeline,scrollTimelineAxis,scrollTimelineName,shapeImageThreshold,shapeMargin,shapeOutside,tabSize,tableLayout,textAlign,textAlignLast,textCombineUpright,textDecoration,textDecorationColor,textDecorationLine,textDecorationSkip,textDecorationSkipInk,textDecorationStyle,textDecorationThickness,textEmphasis,textEmphasisColor,textEmphasisPosition,textEmphasisStyle,textIndent,textJustify,textOrientation,textOverflow,textRendering,textShadow,textSizeAdjust,textTransform,textUnderlineOffset,textUnderlinePosition,top,touchAction,transform,transformBox,transformOrigin,transformStyle,transition,transitionDelay,transitionDuration,transitionProperty,transitionTimingFunction,translate,unicodeBidi,userSelect,verticalAlign,viewTransitionName,visibility,whiteSpace,widows,width,willChange,wordBreak,wordSpacing,wordWrap,writingMode,zIndex,zoom,alignmentBaseline,baselineShift,clipRule,colorInterpolation,colorRendering,dominantBaseline,fill,fillOpacity,fillRule,floodColor,floodOpacity,glyphOrientationVertical,lightingColor,marker,markerEnd,markerMid,markerStart,shapeRendering,stopColor,stopOpacity,stroke,strokeDasharray,strokeDashoffset,strokeLinecap,strokeLinejoin,strokeMiterlimit,strokeOpacity,strokeWidth,textAnchor,vectorEffect", jS = MS.split(",").concat(LS), HS = new Map(jS.map((e) => [e, !0])), $S = /&|@/, f8 = /* @__PURE__ */ o8((e) => HS.has(e) || e.startsWith("--") || $S.test(e));
const US = (e, t) => !t.includes(e) && !f8(e), VS = (e, t) => e.__shouldForwardProps__ && t ? (r) => e.__shouldForwardProps__(r) && t(r) : t, WS = (e, t) => {
  var i;
  if (e && !t)
    return e;
  if (!e && t)
    return t;
  if (e.__cva__ && t.__cva__ || e.__recipe__ && t.__recipe__)
    return e.merge(t);
  const r = new TypeError("Cannot merge cva with recipe. Please use either cva or recipe.");
  throw (i = TypeError.captureStackTrace) == null || i.call(TypeError, r), r;
}, GS = (e) => typeof e == "string" ? e : (e == null ? void 0 : e.displayName) || (e == null ? void 0 : e.name) || "Component";
function qv(e, t = {}, r = {}) {
  const i = t.__cva__ || t.__recipe__ ? t : T1(t), n = r.shouldForwardProp || US, a = (u) => n(u, i.variantKeys), o = Object.assign(
    r.dataAttr && t.__name__ ? { "data-recipe": t.__name__ } : {},
    r.defaultProps
  ), s = /* @__PURE__ */ Je(function(d, c) {
    const { as: p = e.__base__ || e, children: f, ...g } = d, k = WS(e.__cva__, i), y = VS(e, a), _ = Jt(() => Object.assign({}, o, g), [g]), [A, T, N, P, B] = Jt(() => Rr(_, Ab.keys, y, k.variantKeys, f8), [_]);
    function M() {
      var J;
      const { css: K, ...z } = P, j = (J = k.__getCompoundVariantCss__) == null ? void 0 : J.call(k, N);
      return Eo(k(N, !1), yo(j, z, K), _.className);
    }
    function X() {
      const { css: K, ...z } = P, j = k.raw(N);
      return Eo(yo(j, z, K), _.className);
    }
    const U = t.__recipe__ ? M : X;
    return xa(p, {
      ref: c,
      ...T,
      ...B,
      ...Ab(A),
      className: U()
    }, _.children ?? f);
  }), l = GS(e);
  return s.displayName = `styled.${l}`, s.__cva__ = i, s.__base__ = e, s.__shouldForwardProps__ = a, s;
}
function KS() {
  const e = /* @__PURE__ */ new Map();
  return new Proxy(qv, {
    apply(t, r, i) {
      return qv(...i);
    },
    get(t, r) {
      return e.has(r) || e.set(r, qv(r)), e.get(r);
    }
  });
}
const Te = /* @__PURE__ */ KS(), YS = {
  transform(e) {
    return e;
  }
}, qS = (e = {}) => YS.transform(e, { map: uc }), Ct = /* @__PURE__ */ Je(function(t, r) {
  const i = qS();
  return xa(Te.div, { ref: r, ...i, ...t });
}), QS = {
  transform(e) {
    const { direction: t, align: r, justify: i, wrap: n, basis: a, grow: o, shrink: s, ...l } = e;
    return {
      display: "flex",
      flexDirection: t,
      alignItems: r,
      justifyContent: i,
      flexWrap: n,
      flexBasis: a,
      flexGrow: o,
      flexShrink: s,
      ...l
    };
  }
}, X_ = (e = {}) => QS.transform(e, { map: uc }), g8 = (e) => yo(X_(e));
g8.raw = X_;
const mt = /* @__PURE__ */ Je(function(t, r) {
  const { align: i, justify: n, direction: a, wrap: o, basis: s, grow: l, shrink: u, ...d } = t, c = X_({ align: i, justify: n, direction: a, wrap: o, basis: s, grow: l, shrink: u });
  return xa(Te.div, { ref: r, ...c, ...d });
}), XS = {
  transform(e) {
    const { align: t, justify: r, direction: i = "column", gap: n = "10px", ...a } = e;
    return {
      display: "flex",
      flexDirection: i,
      alignItems: t,
      justifyContent: r,
      gap: n,
      ...a
    };
  }
}, ZS = (e = {}) => XS.transform(e, { map: uc }), bo = /* @__PURE__ */ Je(function(t, r) {
  const { align: i, justify: n, direction: a, gap: o, ...s } = t, l = ZS({ align: i, justify: n, direction: a, gap: o });
  return xa(Te.div, { ref: r, ...l, ...s });
}), JS = {
  transform(e) {
    const { justify: t, gap: r = "10px", ...i } = e;
    return {
      display: "flex",
      alignItems: "center",
      justifyContent: t,
      gap: r,
      flexDirection: "column",
      ...i
    };
  }
}, eI = (e = {}) => JS.transform(e, { map: uc }), S1 = /* @__PURE__ */ Je(function(t, r) {
  const { justify: i, gap: n, ...a } = t, o = eI({ justify: i, gap: n });
  return xa(Te.div, { ref: r, ...o, ...a });
}), tI = {
  transform(e) {
    const { justify: t, gap: r = "10px", ...i } = e;
    return {
      display: "flex",
      alignItems: "center",
      justifyContent: t,
      gap: r,
      flexDirection: "row",
      ...i
    };
  }
}, rI = (e = {}) => tI.transform(e, { map: uc }), Tl = /* @__PURE__ */ Je(function(t, r) {
  const { justify: i, gap: n, ...a } = t, o = rI({ justify: i, gap: n });
  return xa(Te.div, { ref: r, ...o, ...a });
}), iI = {
  transform(e) {
    const { inline: t, ...r } = e;
    return {
      display: t ? "inline-flex" : "flex",
      alignItems: "center",
      justifyContent: "center",
      ...r
    };
  }
}, nI = (e = {}) => iI.transform(e, { map: uc }), m8 = /* @__PURE__ */ Je(function(t, r) {
  const { inline: i, ...n } = t, a = nI({ inline: i });
  return xa(Te.div, { ref: r, ...a, ...n });
}), aI = {
  transform(e, { map: t }) {
    const { orientation: r = "horizontal", thickness: i = "1px", color: n, ...a } = e;
    return {
      "--thickness": i,
      width: t(r, (o) => o === "vertical" ? void 0 : "100%"),
      height: t(r, (o) => o === "horizontal" ? void 0 : "100%"),
      borderBlockEndWidth: t(r, (o) => o === "horizontal" ? "var(--thickness)" : void 0),
      borderInlineEndWidth: t(r, (o) => o === "vertical" ? "var(--thickness)" : void 0),
      borderColor: n,
      ...a
    };
  }
}, oI = (e = {}) => aI.transform(e, { map: uc }), sg = /* @__PURE__ */ Je(function(t, r) {
  const { orientation: i, thickness: n, color: a, ...o } = t, s = oI({ orientation: i, thickness: n, color: a });
  return xa(Te.div, { ref: r, ...s, ...o });
}), ni = (e, t, r) => {
  const i = (a) => ({
    [e]: "__ignore__",
    ...t,
    ...Y_(a)
  });
  return Object.assign((a, o = !0) => {
    const l = a8({
      conditions: {
        shift: c8,
        finalize: u8,
        breakpoints: { keys: ["base", "sm", "md", "lg", "xl", "2xl"] }
      },
      utility: {
        prefix: "ikp",
        transform: (d, c) => (PS(e, r, a, d), c === "__ignore__" ? { className: e } : (c = q_(c), { className: `${e}--${d}_${c}` }))
      }
    }), u = i(a);
    if (o) {
      const d = wb(r, u);
      return Eo(l(u), yo(d));
    }
    return l(u);
  }, {
    __getCompoundVariantCss__: (a) => wb(r, i(a))
  });
}, xo = (e, t) => {
  if (e && !t)
    return e;
  if (!e && t)
    return t;
  const r = (...a) => Eo(e(...a), t(...a)), i = xb(e.variantKeys, t.variantKeys), n = i.reduce((a, o) => (a[o] = xb(e.variantMap[o], t.variantMap[o]), a), {});
  return Object.assign(r, {
    __recipe__: !0,
    __name__: `${e.__name__} ${t.__name__}`,
    raw: (a) => a,
    variantKeys: i,
    variantMap: n,
    splitVariantProps(a) {
      return Rr(a, i);
    }
  });
}, sI = {
  variant: "subtle"
}, lI = [], uI = [
  [
    "container",
    "alert__container"
  ],
  [
    "icon",
    "alert__icon"
  ],
  [
    "spinner",
    "alert__spinner"
  ],
  [
    "title",
    "alert__title"
  ],
  [
    "description",
    "alert__description"
  ]
], cI = /* @__PURE__ */ uI.map(([e, t]) => [e, ni(t, sI, bn(lI, e))]), dI = (e = {}) => Object.fromEntries(cI.map(([t, r]) => [t, r(e)])), D5 = [
  "variant"
], pI = /* @__PURE__ */ Object.assign(dI, {
  __recipe__: !1,
  __name__: "alert",
  raw: (e) => e,
  variantKeys: D5,
  variantMap: {
    variant: [
      "subtle",
      "left-accent",
      "top-accent",
      "solid"
    ]
  },
  splitVariantProps(e) {
    return Rr(e, D5);
  }
}), hI = {
  size: "md"
}, fI = [], gI = [
  [
    "root",
    "avatar__root"
  ],
  [
    "fallback",
    "avatar__fallback"
  ],
  [
    "image",
    "avatar__image"
  ]
], mI = /* @__PURE__ */ gI.map(([e, t]) => [e, ni(t, hI, bn(fI, e))]), vI = (e = {}) => Object.fromEntries(mI.map(([t, r]) => [t, r(e)])), y5 = [
  "size"
], kI = /* @__PURE__ */ Object.assign(vI, {
  __recipe__: !1,
  __name__: "avatar",
  raw: (e) => e,
  variantKeys: y5,
  variantMap: {
    size: [
      "2xs",
      "xs",
      "sm",
      "md",
      "lg",
      "xl",
      "2xl"
    ]
  },
  splitVariantProps(e) {
    return Rr(e, y5);
  }
}), bI = {
  variant: "elevated",
  size: "md"
}, _I = [], DI = [
  [
    "container",
    "card__container"
  ],
  [
    "body",
    "card__body"
  ],
  [
    "header",
    "card__header"
  ],
  [
    "footer",
    "card__footer"
  ]
], yI = /* @__PURE__ */ DI.map(([e, t]) => [e, ni(t, bI, bn(_I, e))]), EI = (e = {}) => Object.fromEntries(yI.map(([t, r]) => [t, r(e)])), E5 = [
  "variant",
  "size"
], CI = /* @__PURE__ */ Object.assign(EI, {
  __recipe__: !1,
  __name__: "card",
  raw: (e) => e,
  variantKeys: E5,
  variantMap: {
    variant: [
      "elevated",
      "outline",
      "filled",
      "unstyled"
    ],
    size: [
      "sm",
      "md",
      "lg"
    ]
  },
  splitVariantProps(e) {
    return Rr(e, E5);
  }
}), xI = {
  size: "md"
}, AI = [], wI = [
  [
    "container",
    "checkbox__container"
  ],
  [
    "control",
    "checkbox__control"
  ],
  [
    "label",
    "checkbox__label"
  ],
  [
    "icon",
    "checkbox__icon"
  ]
], FI = /* @__PURE__ */ wI.map(([e, t]) => [e, ni(t, xI, bn(AI, e))]), TI = (e = {}) => Object.fromEntries(FI.map(([t, r]) => [t, r(e)])), C5 = [
  "size",
  "shape",
  "variant"
], SI = /* @__PURE__ */ Object.assign(TI, {
  __recipe__: !1,
  __name__: "checkbox",
  raw: (e) => e,
  variantKeys: C5,
  variantMap: {
    size: [
      "sm",
      "md",
      "lg"
    ],
    shape: [
      "circular"
    ],
    variant: [
      "neutral"
    ]
  },
  splitVariantProps(e) {
    return Rr(e, C5);
  }
}), II = /* @__PURE__ */ ni("close-btn", {
  size: "md"
}, []), v8 = {
  size: [
    "lg",
    "md",
    "sm"
  ]
}, x5 = Object.keys(v8), Z_ = /* @__PURE__ */ Object.assign(II, {
  __recipe__: !0,
  __name__: "closeButton",
  raw: (e) => e,
  variantKeys: x5,
  variantMap: v8,
  merge(e) {
    return xo(this, e);
  },
  splitVariantProps(e) {
    return Rr(e, x5);
  }
}), BI = /* @__PURE__ */ ni("code", {
  variant: "subtle"
}, []), k8 = {
  variant: [
    "solid",
    "subtle",
    "outline"
  ]
}, A5 = Object.keys(k8), RI = /* @__PURE__ */ Object.assign(BI, {
  __recipe__: !0,
  __name__: "code",
  raw: (e) => e,
  variantKeys: A5,
  variantMap: k8,
  merge(e) {
    return xo(this, e);
  },
  splitVariantProps(e) {
    return Rr(e, A5);
  }
}), OI = /* @__PURE__ */ ni("badge", {
  variant: "subtle"
}, []), b8 = {
  variant: [
    "solid",
    "subtle",
    "outline"
  ]
}, w5 = Object.keys(b8), PI = /* @__PURE__ */ Object.assign(OI, {
  __recipe__: !0,
  __name__: "badge",
  raw: (e) => e,
  variantKeys: w5,
  variantMap: b8,
  merge(e) {
    return xo(this, e);
  },
  splitVariantProps(e) {
    return Rr(e, w5);
  }
}), NI = {}, zI = [], LI = [
  [
    "container",
    "form-control__container"
  ],
  [
    "required-indicator",
    "form-control__required-indicator"
  ],
  [
    "helper",
    "form-control__helper"
  ],
  [
    "label",
    "form-control__label"
  ],
  [
    "error",
    "form-control__error"
  ],
  [
    "error-icon",
    "form-control__error-icon"
  ]
], MI = /* @__PURE__ */ LI.map(([e, t]) => [e, ni(t, NI, bn(zI, e))]), jI = (e = {}) => Object.fromEntries(MI.map(([t, r]) => [t, r(e)])), F5 = [], HI = /* @__PURE__ */ Object.assign(jI, {
  __recipe__: !1,
  __name__: "formControl",
  raw: (e) => e,
  variantKeys: F5,
  variantMap: {},
  splitVariantProps(e) {
    return Rr(e, F5);
  }
}), $I = {
  size: "md",
  variant: "outline"
}, UI = [], VI = [
  [
    "group",
    "input__group"
  ],
  [
    "field",
    "input__field"
  ],
  [
    "addon",
    "input__addon"
  ]
], WI = /* @__PURE__ */ VI.map(([e, t]) => [e, ni(t, $I, bn(UI, e))]), GI = (e = {}) => Object.fromEntries(WI.map(([t, r]) => [t, r(e)])), T5 = [
  "size",
  "variant"
], KI = /* @__PURE__ */ Object.assign(GI, {
  __recipe__: !1,
  __name__: "input",
  raw: (e) => e,
  variantKeys: T5,
  variantMap: {
    size: [
      "lg",
      "md",
      "sm",
      "xs"
    ],
    variant: [
      "outline",
      "filled",
      "flushed",
      "unstyled"
    ]
  },
  splitVariantProps(e) {
    return Rr(e, T5);
  }
}), YI = /* @__PURE__ */ ni("link", {}, []), _8 = {}, S5 = Object.keys(_8), qI = /* @__PURE__ */ Object.assign(YI, {
  __recipe__: !0,
  __name__: "link",
  raw: (e) => e,
  variantKeys: S5,
  variantMap: _8,
  merge(e) {
    return xo(this, e);
  },
  splitVariantProps(e) {
    return Rr(e, S5);
  }
}), QI = {}, XI = [], ZI = [
  [
    "arrow",
    "popover__arrow"
  ],
  [
    "arrowTip",
    "popover__arrowTip"
  ],
  [
    "anchor",
    "popover__anchor"
  ],
  [
    "trigger",
    "popover__trigger"
  ],
  [
    "positioner",
    "popover__positioner"
  ],
  [
    "content",
    "popover__content"
  ],
  [
    "title",
    "popover__title"
  ],
  [
    "description",
    "popover__description"
  ],
  [
    "closeTrigger",
    "popover__closeTrigger"
  ],
  [
    "footer",
    "popover__footer"
  ]
], JI = /* @__PURE__ */ ZI.map(([e, t]) => [e, ni(t, QI, bn(XI, e))]), eB = (e = {}) => Object.fromEntries(JI.map(([t, r]) => [t, r(e)])), I5 = [], tB = /* @__PURE__ */ Object.assign(eB, {
  __recipe__: !1,
  __name__: "popover",
  raw: (e) => e,
  variantKeys: I5,
  variantMap: {},
  splitVariantProps(e) {
    return Rr(e, I5);
  }
}), rB = /* @__PURE__ */ ni("skeleton", {}, []), D8 = {}, B5 = Object.keys(D8), iB = /* @__PURE__ */ Object.assign(rB, {
  __recipe__: !0,
  __name__: "skeleton",
  raw: (e) => e,
  variantKeys: B5,
  variantMap: D8,
  merge(e) {
    return xo(this, e);
  },
  splitVariantProps(e) {
    return Rr(e, B5);
  }
}), nB = {
  variant: "simple",
  size: "md"
}, aB = [], oB = [
  [
    "container",
    "table__container"
  ],
  [
    "table",
    "table__table"
  ],
  [
    "caption",
    "table__caption"
  ],
  [
    "tbody",
    "table__tbody"
  ],
  [
    "td",
    "table__td"
  ],
  [
    "tfoot",
    "table__tfoot"
  ],
  [
    "th",
    "table__th"
  ],
  [
    "thead",
    "table__thead"
  ],
  [
    "tr",
    "table__tr"
  ]
], sB = /* @__PURE__ */ oB.map(([e, t]) => [e, ni(t, nB, bn(aB, e))]), lB = (e = {}) => Object.fromEntries(sB.map(([t, r]) => [t, r(e)])), R5 = [
  "variant",
  "size"
], uB = /* @__PURE__ */ Object.assign(lB, {
  __recipe__: !1,
  __name__: "table",
  raw: (e) => e,
  variantKeys: R5,
  variantMap: {
    variant: [
      "simple",
      "tfoot",
      "striped",
      "unstyled"
    ],
    size: [
      "sm",
      "md",
      "lg"
    ]
  },
  splitVariantProps(e) {
    return Rr(e, R5);
  }
}), cB = /* @__PURE__ */ ni("textarea", {
  size: "md",
  variant: "outline"
}, []), y8 = {
  variant: [
    "outline",
    "flushed",
    "filled",
    "unstyled"
  ],
  size: [
    "xs",
    "sm",
    "md",
    "lg"
  ]
}, O5 = Object.keys(y8), dB = /* @__PURE__ */ Object.assign(cB, {
  __recipe__: !0,
  __name__: "textarea",
  raw: (e) => e,
  variantKeys: O5,
  variantMap: y8,
  merge(e) {
    return xo(this, e);
  },
  splitVariantProps(e) {
    return Rr(e, O5);
  }
}), pB = /* @__PURE__ */ ni("ai-chat-page-wrapper", {
  size: "default",
  variant: "container-with-shadow"
}, []), E8 = {
  size: [
    "expand",
    "default",
    "shrink-vertically",
    "full-viewport"
  ],
  variant: [
    "no-shadow",
    "container-with-shadow"
  ]
}, P5 = Object.keys(E8), hB = /* @__PURE__ */ Object.assign(pB, {
  __recipe__: !0,
  __name__: "aiChatPageWrapper",
  raw: (e) => e,
  variantKeys: P5,
  variantMap: E8,
  merge(e) {
    return xo(this, e);
  },
  splitVariantProps(e) {
    return Rr(e, P5);
  }
}), fB = /* @__PURE__ */ ni("btn", {
  colorPalette: "gray",
  variant: "solid",
  size: "md"
}, [
  {
    variant: "ghost",
    colorPalette: "gray",
    css: {
      color: {
        base: "gray.800",
        _dark: "whiteAlpha.900"
      },
      _hover: {
        bg: {
          base: "gray.100",
          _dark: "whiteAlpha.200"
        }
      },
      _active: {
        bg: {
          base: "gray.200",
          _dark: "whiteAlpha.300"
        }
      }
    }
  },
  {
    variant: "outline",
    colorPalette: "gray",
    css: {
      borderColor: {
        base: "gray.200",
        _dark: "whiteAlpha.300"
      }
    }
  },
  {
    variant: "solid",
    colorPalette: "gray",
    css: {
      bg: {
        base: "gray.100",
        _dark: "whiteAlpha.200"
      },
      color: {
        base: "gray.800",
        _dark: "whiteAlpha.900"
      },
      _hover: {
        bg: {
          base: "gray.200",
          _dark: "whiteAlpha.300"
        },
        _disabled: {
          bg: {
            base: "gray.100",
            _dark: "whiteAlpha.200"
          }
        }
      },
      _active: {
        bg: {
          base: "gray.300",
          _dark: "whiteAlpha.400"
        }
      }
    }
  }
]), C8 = {
  colorPalette: [
    "gray",
    "blue",
    "teal",
    "inkeepPrimary"
  ],
  variant: [
    "ghost",
    "solid",
    "link",
    "unstyled",
    "outlinePrimary",
    "none",
    "outlineFilled",
    "outlineFilledActive",
    "chatButton",
    "filledCTA",
    "primaryFilled",
    "neutralFilled",
    "outline",
    "iconButton"
  ],
  size: [
    "lg",
    "md",
    "sm",
    "xs",
    "none"
  ]
}, N5 = Object.keys(C8), x8 = /* @__PURE__ */ Object.assign(fB, {
  __recipe__: !0,
  __name__: "button",
  raw: (e) => e,
  variantKeys: N5,
  variantMap: C8,
  merge(e) {
    return xo(this, e);
  },
  splitVariantProps(e) {
    return Rr(e, N5);
  }
}), gB = {}, mB = [], vB = [
  [
    "span",
    "content-parser__span"
  ],
  [
    "sup",
    "content-parser__sup"
  ],
  [
    "text",
    "content-parser__text"
  ],
  [
    "ol",
    "content-parser__ol"
  ],
  [
    "ul",
    "content-parser__ul"
  ],
  [
    "li",
    "content-parser__li"
  ],
  [
    "image",
    "content-parser__image"
  ],
  [
    "link",
    "content-parser__link"
  ],
  [
    "table",
    "content-parser__table"
  ],
  [
    "thead",
    "content-parser__thead"
  ],
  [
    "tbody",
    "content-parser__tbody"
  ],
  [
    "tr",
    "content-parser__tr"
  ],
  [
    "th",
    "content-parser__th"
  ],
  [
    "td",
    "content-parser__td"
  ],
  [
    "code",
    "content-parser__code"
  ],
  [
    "heading",
    "content-parser__heading"
  ]
], kB = /* @__PURE__ */ vB.map(([e, t]) => [e, ni(t, gB, bn(mB, e))]), bB = (e = {}) => Object.fromEntries(kB.map(([t, r]) => [t, r(e)])), z5 = [], _B = /* @__PURE__ */ Object.assign(bB, {
  __recipe__: !1,
  __name__: "contentParser",
  raw: (e) => e,
  variantKeys: z5,
  variantMap: {},
  splitVariantProps(e) {
    return Rr(e, z5);
  }
}), DB = /* @__PURE__ */ ni("heading", {
  size: "xl"
}, []), A8 = {
  size: [
    "4xl",
    "3xl",
    "2xl",
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
  ],
  uppercase: [
    "true"
  ]
}, L5 = Object.keys(A8), yB = /* @__PURE__ */ Object.assign(DB, {
  __recipe__: !0,
  __name__: "heading",
  raw: (e) => e,
  variantKeys: L5,
  variantMap: A8,
  merge(e) {
    return xo(this, e);
  },
  splitVariantProps(e) {
    return Rr(e, L5);
  }
}), EB = /* @__PURE__ */ ni("icon", {}, []), w8 = {
  variant: [
    "dark",
    "lightPrimary",
    "light"
  ]
}, M5 = Object.keys(w8), CB = /* @__PURE__ */ Object.assign(EB, {
  __recipe__: !0,
  __name__: "icon",
  raw: (e) => e,
  variantKeys: M5,
  variantMap: w8,
  merge(e) {
    return xo(this, e);
  },
  splitVariantProps(e) {
    return Rr(e, M5);
  }
}), xB = /* @__PURE__ */ ni("kbd", {}, []), F8 = {
  variant: [
    "dark",
    "darkOutline",
    "light",
    "grayLight",
    "outline"
  ]
}, j5 = Object.keys(F8), AB = /* @__PURE__ */ Object.assign(xB, {
  __recipe__: !0,
  __name__: "kbd",
  raw: (e) => e,
  variantKeys: j5,
  variantMap: F8,
  merge(e) {
    return xo(this, e);
  },
  splitVariantProps(e) {
    return Rr(e, j5);
  }
}), wB = {
  size: "md",
  scrollOverflowBehavior: "outside",
  isCentered: !0
}, FB = [], TB = [
  [
    "trigger",
    "modal__trigger"
  ],
  [
    "backdrop",
    "modal__backdrop"
  ],
  [
    "container",
    "modal__container"
  ],
  [
    "content",
    "modal__content"
  ],
  [
    "title",
    "modal__title"
  ],
  [
    "description",
    "modal__description"
  ],
  [
    "closeTrigger",
    "modal__closeTrigger"
  ],
  [
    "root",
    "modal__root"
  ],
  [
    "footer",
    "modal__footer"
  ],
  [
    "trigger",
    "modal__trigger"
  ],
  [
    "backdrop",
    "modal__backdrop"
  ],
  [
    "container",
    "modal__container"
  ],
  [
    "content",
    "modal__content"
  ],
  [
    "title",
    "modal__title"
  ],
  [
    "description",
    "modal__description"
  ],
  [
    "closeTrigger",
    "modal__closeTrigger"
  ],
  [
    "root",
    "modal__root"
  ],
  [
    "footer",
    "modal__footer"
  ]
], SB = /* @__PURE__ */ TB.map(([e, t]) => [e, ni(t, wB, bn(FB, e))]), IB = (e = {}) => Object.fromEntries(SB.map(([t, r]) => [t, r(e)])), H5 = [
  "size",
  "scrollOverflowBehavior",
  "isCentered",
  "variant"
], BB = /* @__PURE__ */ Object.assign(IB, {
  __recipe__: !1,
  __name__: "modal",
  raw: (e) => e,
  variantKeys: H5,
  variantMap: {
    size: [
      "xs",
      "sm",
      "md",
      "lg",
      "xl",
      "2xl",
      "3xl",
      "4xl",
      "5xl",
      "6xl",
      "full"
    ],
    scrollOverflowBehavior: [
      "inside",
      "outside"
    ],
    isCentered: [
      "false",
      "true"
    ],
    variant: [
      "clickThrough"
    ]
  },
  splitVariantProps(e) {
    return Rr(e, H5);
  }
}), RB = {
  size: "compact",
  variant: "subtle"
}, OB = [], PB = [
  [
    "container",
    "search-bar-trigger__container"
  ],
  [
    "wrapper",
    "search-bar-trigger__wrapper"
  ],
  [
    "text",
    "search-bar-trigger__text"
  ],
  [
    "kbd",
    "search-bar-trigger__kbd"
  ],
  [
    "icon",
    "search-bar-trigger__icon"
  ]
], NB = /* @__PURE__ */ PB.map(([e, t]) => [e, ni(t, RB, bn(OB, e))]), zB = (e = {}) => Object.fromEntries(NB.map(([t, r]) => [t, r(e)])), $5 = [
  "size",
  "variant"
], LB = /* @__PURE__ */ Object.assign(zB, {
  __recipe__: !1,
  __name__: "searchBarTrigger",
  raw: (e) => e,
  variantKeys: $5,
  variantMap: {
    size: [
      "expand",
      "compact",
      "shrink",
      "medium"
    ],
    variant: [
      "emphasized",
      "subtle"
    ]
  },
  splitVariantProps(e) {
    return Rr(e, $5);
  }
}), MB = {
  size: "md",
  variant: "outline"
}, jB = [], HB = [
  [
    "label",
    "select__label"
  ],
  [
    "positioner",
    "select__positioner"
  ],
  [
    "trigger",
    "select__trigger"
  ],
  [
    "clearTrigger",
    "select__clearTrigger"
  ],
  [
    "item",
    "select__item"
  ],
  [
    "itemText",
    "select__itemText"
  ],
  [
    "itemIndicator",
    "select__itemIndicator"
  ],
  [
    "itemGroup",
    "select__itemGroup"
  ],
  [
    "itemGroupLabel",
    "select__itemGroupLabel"
  ],
  [
    "content",
    "select__content"
  ],
  [
    "root",
    "select__root"
  ],
  [
    "control",
    "select__control"
  ],
  [
    "value",
    "select__value"
  ],
  [
    "label",
    "select__label"
  ],
  [
    "positioner",
    "select__positioner"
  ],
  [
    "trigger",
    "select__trigger"
  ],
  [
    "clearTrigger",
    "select__clearTrigger"
  ],
  [
    "item",
    "select__item"
  ],
  [
    "itemText",
    "select__itemText"
  ],
  [
    "itemIndicator",
    "select__itemIndicator"
  ],
  [
    "itemGroup",
    "select__itemGroup"
  ],
  [
    "itemGroupLabel",
    "select__itemGroupLabel"
  ],
  [
    "content",
    "select__content"
  ],
  [
    "root",
    "select__root"
  ],
  [
    "control",
    "select__control"
  ],
  [
    "value",
    "select__value"
  ]
], $B = /* @__PURE__ */ HB.map(([e, t]) => [e, ni(t, MB, bn(jB, e))]), UB = (e = {}) => Object.fromEntries($B.map(([t, r]) => [t, r(e)])), U5 = [
  "size",
  "variant"
], VB = /* @__PURE__ */ Object.assign(UB, {
  __recipe__: !1,
  __name__: "select",
  raw: (e) => e,
  variantKeys: U5,
  variantMap: {
    size: [
      "sm",
      "md",
      "lg"
    ],
    variant: [
      "outline",
      "ghost",
      "ikpOutline"
    ]
  },
  splitVariantProps(e) {
    return Rr(e, U5);
  }
}), WB = {
  size: "md"
}, GB = [], KB = [
  [
    "root",
    "switch__root"
  ],
  [
    "label",
    "switch__label"
  ],
  [
    "control",
    "switch__control"
  ],
  [
    "thumb",
    "switch__thumb"
  ],
  [
    "root",
    "switch__root"
  ],
  [
    "label",
    "switch__label"
  ],
  [
    "control",
    "switch__control"
  ],
  [
    "thumb",
    "switch__thumb"
  ]
], YB = /* @__PURE__ */ KB.map(([e, t]) => [e, ni(t, WB, bn(GB, e))]), qB = (e = {}) => Object.fromEntries(YB.map(([t, r]) => [t, r(e)])), V5 = [
  "size"
], QB = /* @__PURE__ */ Object.assign(qB, {
  __recipe__: !1,
  __name__: "switchRecipe",
  raw: (e) => e,
  variantKeys: V5,
  variantMap: {
    size: [
      "sm",
      "md",
      "lg",
      "xss"
    ]
  },
  splitVariantProps(e) {
    return Rr(e, V5);
  }
}), XB = {
  size: "md",
  variant: "line"
}, ZB = [], JB = [
  [
    "root",
    "tabs__root"
  ],
  [
    "list",
    "tabs__list"
  ],
  [
    "trigger",
    "tabs__trigger"
  ],
  [
    "content",
    "tabs__content"
  ],
  [
    "indicator",
    "tabs__indicator"
  ],
  [
    "panels",
    "tabs__panels"
  ],
  [
    "root",
    "tabs__root"
  ],
  [
    "list",
    "tabs__list"
  ],
  [
    "trigger",
    "tabs__trigger"
  ],
  [
    "content",
    "tabs__content"
  ],
  [
    "indicator",
    "tabs__indicator"
  ],
  [
    "panels",
    "tabs__panels"
  ]
], eR = /* @__PURE__ */ JB.map(([e, t]) => [e, ni(t, XB, bn(ZB, e))]), tR = (e = {}) => Object.fromEntries(eR.map(([t, r]) => [t, r(e)])), W5 = [
  "size",
  "variant",
  "isFitted"
], rR = /* @__PURE__ */ Object.assign(tR, {
  __recipe__: !1,
  __name__: "tabs",
  raw: (e) => e,
  variantKeys: W5,
  variantMap: {
    size: [
      "sm",
      "md",
      "lg"
    ],
    variant: [
      "line",
      "enclosed",
      "enclosed-colored",
      "soft-rounded",
      "solid-rounded",
      "unstyled"
    ],
    isFitted: [
      "true"
    ]
  },
  splitVariantProps(e) {
    return Rr(e, W5);
  }
}), iR = {
  variant: "default"
}, nR = [], aR = [
  [
    "trigger",
    "tooltip__trigger"
  ],
  [
    "arrow",
    "tooltip__arrow"
  ],
  [
    "arrowTip",
    "tooltip__arrowTip"
  ],
  [
    "positioner",
    "tooltip__positioner"
  ],
  [
    "content",
    "tooltip__content"
  ],
  [
    "trigger",
    "tooltip__trigger"
  ],
  [
    "arrow",
    "tooltip__arrow"
  ],
  [
    "arrowTip",
    "tooltip__arrowTip"
  ],
  [
    "positioner",
    "tooltip__positioner"
  ],
  [
    "content",
    "tooltip__content"
  ]
], oR = /* @__PURE__ */ aR.map(([e, t]) => [e, ni(t, iR, bn(nR, e))]), sR = (e = {}) => Object.fromEntries(oR.map(([t, r]) => [t, r(e)])), G5 = [
  "variant"
], lR = /* @__PURE__ */ Object.assign(sR, {
  __recipe__: !1,
  __name__: "tooltip",
  raw: (e) => e,
  variantKeys: G5,
  variantMap: {
    variant: [
      "default"
    ]
  },
  splitVariantProps(e) {
    return Rr(e, G5);
  }
}), T8 = {
  "blurs.sm": {
    value: "4px",
    variable: "var(--ikp-blurs-sm)"
  },
  "blurs.base": {
    value: "8px",
    variable: "var(--ikp-blurs-base)"
  },
  "blurs.md": {
    value: "12px",
    variable: "var(--ikp-blurs-md)"
  },
  "blurs.lg": {
    value: "16px",
    variable: "var(--ikp-blurs-lg)"
  },
  "blurs.xl": {
    value: "24px",
    variable: "var(--ikp-blurs-xl)"
  },
  "blurs.2xl": {
    value: "40px",
    variable: "var(--ikp-blurs-2xl)"
  },
  "blurs.3xl": {
    value: "64px",
    variable: "var(--ikp-blurs-3xl)"
  },
  "spacing.0": {
    value: "0rem",
    variable: "var(--ikp-spacing-0)"
  },
  "spacing.1": {
    value: "0.25rem",
    variable: "var(--ikp-spacing-1)"
  },
  "spacing.2": {
    value: "0.5rem",
    variable: "var(--ikp-spacing-2)"
  },
  "spacing.3": {
    value: "0.75rem",
    variable: "var(--ikp-spacing-3)"
  },
  "spacing.4": {
    value: "1rem",
    variable: "var(--ikp-spacing-4)"
  },
  "spacing.5": {
    value: "1.25rem",
    variable: "var(--ikp-spacing-5)"
  },
  "spacing.6": {
    value: "1.5rem",
    variable: "var(--ikp-spacing-6)"
  },
  "spacing.7": {
    value: "1.75rem",
    variable: "var(--ikp-spacing-7)"
  },
  "spacing.8": {
    value: "2rem",
    variable: "var(--ikp-spacing-8)"
  },
  "spacing.9": {
    value: "2.25rem",
    variable: "var(--ikp-spacing-9)"
  },
  "spacing.10": {
    value: "2.5rem",
    variable: "var(--ikp-spacing-10)"
  },
  "spacing.11": {
    value: "2.75rem",
    variable: "var(--ikp-spacing-11)"
  },
  "spacing.12": {
    value: "3rem",
    variable: "var(--ikp-spacing-12)"
  },
  "spacing.14": {
    value: "3.5rem",
    variable: "var(--ikp-spacing-14)"
  },
  "spacing.16": {
    value: "4rem",
    variable: "var(--ikp-spacing-16)"
  },
  "spacing.20": {
    value: "5rem",
    variable: "var(--ikp-spacing-20)"
  },
  "spacing.24": {
    value: "6rem",
    variable: "var(--ikp-spacing-24)"
  },
  "spacing.28": {
    value: "7rem",
    variable: "var(--ikp-spacing-28)"
  },
  "spacing.32": {
    value: "8rem",
    variable: "var(--ikp-spacing-32)"
  },
  "spacing.36": {
    value: "9rem",
    variable: "var(--ikp-spacing-36)"
  },
  "spacing.40": {
    value: "10rem",
    variable: "var(--ikp-spacing-40)"
  },
  "spacing.44": {
    value: "11rem",
    variable: "var(--ikp-spacing-44)"
  },
  "spacing.48": {
    value: "12rem",
    variable: "var(--ikp-spacing-48)"
  },
  "spacing.52": {
    value: "13rem",
    variable: "var(--ikp-spacing-52)"
  },
  "spacing.56": {
    value: "14rem",
    variable: "var(--ikp-spacing-56)"
  },
  "spacing.60": {
    value: "15rem",
    variable: "var(--ikp-spacing-60)"
  },
  "spacing.64": {
    value: "16rem",
    variable: "var(--ikp-spacing-64)"
  },
  "spacing.72": {
    value: "18rem",
    variable: "var(--ikp-spacing-72)"
  },
  "spacing.80": {
    value: "20rem",
    variable: "var(--ikp-spacing-80)"
  },
  "spacing.96": {
    value: "24rem",
    variable: "var(--ikp-spacing-96)"
  },
  "spacing.0.5": {
    value: "0.125rem",
    variable: "var(--ikp-spacing-0\\.5)"
  },
  "spacing.1.5": {
    value: "0.375rem",
    variable: "var(--ikp-spacing-1\\.5)"
  },
  "spacing.2.5": {
    value: "0.625rem",
    variable: "var(--ikp-spacing-2\\.5)"
  },
  "spacing.3.5": {
    value: "0.875rem",
    variable: "var(--ikp-spacing-3\\.5)"
  },
  "borders.none": {
    value: 0,
    variable: "var(--ikp-borders-none)"
  },
  "borders.1px": {
    value: "1px solid",
    variable: "var(--ikp-borders-1px)"
  },
  "borders.2px": {
    value: "2px solid",
    variable: "var(--ikp-borders-2px)"
  },
  "borders.4px": {
    value: "4px solid",
    variable: "var(--ikp-borders-4px)"
  },
  "borders.8px": {
    value: "8px solid",
    variable: "var(--ikp-borders-8px)"
  },
  "fontSizes.3xs": {
    value: "0.45rem",
    variable: "var(--ikp-font-sizes-3xs)"
  },
  "fontSizes.2xs": {
    value: "0.625rem",
    variable: "var(--ikp-font-sizes-2xs)"
  },
  "fontSizes.xs": {
    value: "0.75rem",
    variable: "var(--ikp-font-sizes-xs)"
  },
  "fontSizes.sm": {
    value: "0.875rem",
    variable: "var(--ikp-font-sizes-sm)"
  },
  "fontSizes.md": {
    value: "1rem",
    variable: "var(--ikp-font-sizes-md)"
  },
  "fontSizes.lg": {
    value: "1.125rem",
    variable: "var(--ikp-font-sizes-lg)"
  },
  "fontSizes.xl": {
    value: "1.25rem",
    variable: "var(--ikp-font-sizes-xl)"
  },
  "fontSizes.2xl": {
    value: "1.5rem",
    variable: "var(--ikp-font-sizes-2xl)"
  },
  "fontSizes.3xl": {
    value: "1.875rem",
    variable: "var(--ikp-font-sizes-3xl)"
  },
  "fontSizes.4xl": {
    value: "2.25rem",
    variable: "var(--ikp-font-sizes-4xl)"
  },
  "fontSizes.5xl": {
    value: "3rem",
    variable: "var(--ikp-font-sizes-5xl)"
  },
  "fontSizes.6xl": {
    value: "3.75rem",
    variable: "var(--ikp-font-sizes-6xl)"
  },
  "fontSizes.7xl": {
    value: "4.5rem",
    variable: "var(--ikp-font-sizes-7xl)"
  },
  "fontSizes.8xl": {
    value: "6rem",
    variable: "var(--ikp-font-sizes-8xl)"
  },
  "fontSizes.9xl": {
    value: "8rem",
    variable: "var(--ikp-font-sizes-9xl)"
  },
  "fontWeights.extralight": {
    value: "200",
    variable: "var(--ikp-font-weights-extralight)"
  },
  "fontWeights.hairline": {
    value: 100,
    variable: "var(--ikp-font-weights-hairline)"
  },
  "fontWeights.thin": {
    value: 200,
    variable: "var(--ikp-font-weights-thin)"
  },
  "fontWeights.light": {
    value: 300,
    variable: "var(--ikp-font-weights-light)"
  },
  "fontWeights.normal": {
    value: 400,
    variable: "var(--ikp-font-weights-normal)"
  },
  "fontWeights.medium": {
    value: 500,
    variable: "var(--ikp-font-weights-medium)"
  },
  "fontWeights.semibold": {
    value: 600,
    variable: "var(--ikp-font-weights-semibold)"
  },
  "fontWeights.bold": {
    value: 700,
    variable: "var(--ikp-font-weights-bold)"
  },
  "fontWeights.extrabold": {
    value: 800,
    variable: "var(--ikp-font-weights-extrabold)"
  },
  "fontWeights.black": {
    value: 900,
    variable: "var(--ikp-font-weights-black)"
  },
  "letterSpacings.tighter": {
    value: "-0.05em",
    variable: "var(--ikp-letter-spacings-tighter)"
  },
  "letterSpacings.tight": {
    value: "-0.025em",
    variable: "var(--ikp-letter-spacings-tight)"
  },
  "letterSpacings.normal": {
    value: "0",
    variable: "var(--ikp-letter-spacings-normal)"
  },
  "letterSpacings.wide": {
    value: "0.025em",
    variable: "var(--ikp-letter-spacings-wide)"
  },
  "letterSpacings.wider": {
    value: "0.05em",
    variable: "var(--ikp-letter-spacings-wider)"
  },
  "letterSpacings.widest": {
    value: "0.1em",
    variable: "var(--ikp-letter-spacings-widest)"
  },
  "lineHeights.3": {
    value: ".75rem",
    variable: "var(--ikp-line-heights-3)"
  },
  "lineHeights.4": {
    value: "1rem",
    variable: "var(--ikp-line-heights-4)"
  },
  "lineHeights.5": {
    value: "1.25rem",
    variable: "var(--ikp-line-heights-5)"
  },
  "lineHeights.6": {
    value: "1.5rem",
    variable: "var(--ikp-line-heights-6)"
  },
  "lineHeights.7": {
    value: "1.75rem",
    variable: "var(--ikp-line-heights-7)"
  },
  "lineHeights.8": {
    value: "2rem",
    variable: "var(--ikp-line-heights-8)"
  },
  "lineHeights.9": {
    value: "2.25rem",
    variable: "var(--ikp-line-heights-9)"
  },
  "lineHeights.10": {
    value: "2.5rem",
    variable: "var(--ikp-line-heights-10)"
  },
  "lineHeights.tight": {
    value: "1.25",
    variable: "var(--ikp-line-heights-tight)"
  },
  "lineHeights.snug": {
    value: "1.375",
    variable: "var(--ikp-line-heights-snug)"
  },
  "lineHeights.relaxed": {
    value: "1.625",
    variable: "var(--ikp-line-heights-relaxed)"
  },
  "lineHeights.loose": {
    value: "2",
    variable: "var(--ikp-line-heights-loose)"
  },
  "lineHeights.normal": {
    value: "normal",
    variable: "var(--ikp-line-heights-normal)"
  },
  "lineHeights.none": {
    value: 1,
    variable: "var(--ikp-line-heights-none)"
  },
  "lineHeights.shorter": {
    value: 1.25,
    variable: "var(--ikp-line-heights-shorter)"
  },
  "lineHeights.short": {
    value: 1.375,
    variable: "var(--ikp-line-heights-short)"
  },
  "lineHeights.base": {
    value: 1.5,
    variable: "var(--ikp-line-heights-base)"
  },
  "lineHeights.tall": {
    value: 1.625,
    variable: "var(--ikp-line-heights-tall)"
  },
  "lineHeights.taller": {
    value: "2",
    variable: "var(--ikp-line-heights-taller)"
  },
  "radii.xs": {
    value: "0.125rem",
    variable: "var(--ikp-radii-xs)"
  },
  "radii.none": {
    value: "0",
    variable: "var(--ikp-radii-none)"
  },
  "radii.sm": {
    value: "0.125rem",
    variable: "var(--ikp-radii-sm)"
  },
  "radii.base": {
    value: "0.25rem",
    variable: "var(--ikp-radii-base)"
  },
  "radii.md": {
    value: "0.375rem",
    variable: "var(--ikp-radii-md)"
  },
  "radii.lg": {
    value: "0.5rem",
    variable: "var(--ikp-radii-lg)"
  },
  "radii.xl": {
    value: "0.75rem",
    variable: "var(--ikp-radii-xl)"
  },
  "radii.2xl": {
    value: "1rem",
    variable: "var(--ikp-radii-2xl)"
  },
  "radii.3xl": {
    value: "1.5rem",
    variable: "var(--ikp-radii-3xl)"
  },
  "radii.full": {
    value: "9999px",
    variable: "var(--ikp-radii-full)"
  },
  "sizes.0": {
    value: "0",
    variable: "var(--ikp-sizes-0)"
  },
  "sizes.1": {
    value: "0.25rem",
    variable: "var(--ikp-sizes-1)"
  },
  "sizes.2": {
    value: "0.5rem",
    variable: "var(--ikp-sizes-2)"
  },
  "sizes.3": {
    value: "0.75rem",
    variable: "var(--ikp-sizes-3)"
  },
  "sizes.4": {
    value: "1rem",
    variable: "var(--ikp-sizes-4)"
  },
  "sizes.5": {
    value: "1.25rem",
    variable: "var(--ikp-sizes-5)"
  },
  "sizes.6": {
    value: "1.5rem",
    variable: "var(--ikp-sizes-6)"
  },
  "sizes.7": {
    value: "1.75rem",
    variable: "var(--ikp-sizes-7)"
  },
  "sizes.8": {
    value: "2rem",
    variable: "var(--ikp-sizes-8)"
  },
  "sizes.9": {
    value: "2.25rem",
    variable: "var(--ikp-sizes-9)"
  },
  "sizes.10": {
    value: "2.5rem",
    variable: "var(--ikp-sizes-10)"
  },
  "sizes.11": {
    value: "2.75rem",
    variable: "var(--ikp-sizes-11)"
  },
  "sizes.12": {
    value: "3rem",
    variable: "var(--ikp-sizes-12)"
  },
  "sizes.14": {
    value: "3.5rem",
    variable: "var(--ikp-sizes-14)"
  },
  "sizes.16": {
    value: "4rem",
    variable: "var(--ikp-sizes-16)"
  },
  "sizes.20": {
    value: "5rem",
    variable: "var(--ikp-sizes-20)"
  },
  "sizes.24": {
    value: "6rem",
    variable: "var(--ikp-sizes-24)"
  },
  "sizes.28": {
    value: "7rem",
    variable: "var(--ikp-sizes-28)"
  },
  "sizes.32": {
    value: "8rem",
    variable: "var(--ikp-sizes-32)"
  },
  "sizes.36": {
    value: "9rem",
    variable: "var(--ikp-sizes-36)"
  },
  "sizes.40": {
    value: "10rem",
    variable: "var(--ikp-sizes-40)"
  },
  "sizes.44": {
    value: "11rem",
    variable: "var(--ikp-sizes-44)"
  },
  "sizes.48": {
    value: "12rem",
    variable: "var(--ikp-sizes-48)"
  },
  "sizes.52": {
    value: "13rem",
    variable: "var(--ikp-sizes-52)"
  },
  "sizes.56": {
    value: "14rem",
    variable: "var(--ikp-sizes-56)"
  },
  "sizes.60": {
    value: "15rem",
    variable: "var(--ikp-sizes-60)"
  },
  "sizes.64": {
    value: "16rem",
    variable: "var(--ikp-sizes-64)"
  },
  "sizes.72": {
    value: "18rem",
    variable: "var(--ikp-sizes-72)"
  },
  "sizes.80": {
    value: "20rem",
    variable: "var(--ikp-sizes-80)"
  },
  "sizes.96": {
    value: "24rem",
    variable: "var(--ikp-sizes-96)"
  },
  "sizes.fit": {
    value: "fit-content",
    variable: "var(--ikp-sizes-fit)"
  },
  "sizes.auto": {
    value: "auto",
    variable: "var(--ikp-sizes-auto)"
  },
  "sizes.none": {
    value: "none",
    variable: "var(--ikp-sizes-none)"
  },
  "sizes.px": {
    value: "1px",
    variable: "var(--ikp-sizes-px)"
  },
  "sizes.0.5": {
    value: "0.125rem",
    variable: "var(--ikp-sizes-0\\.5)"
  },
  "sizes.1.5": {
    value: "0.375rem",
    variable: "var(--ikp-sizes-1\\.5)"
  },
  "sizes.2.5": {
    value: "0.625rem",
    variable: "var(--ikp-sizes-2\\.5)"
  },
  "sizes.3.5": {
    value: "0.875rem",
    variable: "var(--ikp-sizes-3\\.5)"
  },
  "sizes.max": {
    value: "max-content",
    variable: "var(--ikp-sizes-max)"
  },
  "sizes.min": {
    value: "min-content",
    variable: "var(--ikp-sizes-min)"
  },
  "sizes.full": {
    value: "100%",
    variable: "var(--ikp-sizes-full)"
  },
  "sizes.3xs": {
    value: "14rem",
    variable: "var(--ikp-sizes-3xs)"
  },
  "sizes.2xs": {
    value: "16rem",
    variable: "var(--ikp-sizes-2xs)"
  },
  "sizes.xs": {
    value: "20rem",
    variable: "var(--ikp-sizes-xs)"
  },
  "sizes.sm": {
    value: "24rem",
    variable: "var(--ikp-sizes-sm)"
  },
  "sizes.md": {
    value: "28rem",
    variable: "var(--ikp-sizes-md)"
  },
  "sizes.lg": {
    value: "32rem",
    variable: "var(--ikp-sizes-lg)"
  },
  "sizes.xl": {
    value: "36rem",
    variable: "var(--ikp-sizes-xl)"
  },
  "sizes.2xl": {
    value: "42rem",
    variable: "var(--ikp-sizes-2xl)"
  },
  "sizes.3xl": {
    value: "48rem",
    variable: "var(--ikp-sizes-3xl)"
  },
  "sizes.4xl": {
    value: "56rem",
    variable: "var(--ikp-sizes-4xl)"
  },
  "sizes.5xl": {
    value: "64rem",
    variable: "var(--ikp-sizes-5xl)"
  },
  "sizes.6xl": {
    value: "72rem",
    variable: "var(--ikp-sizes-6xl)"
  },
  "sizes.7xl": {
    value: "80rem",
    variable: "var(--ikp-sizes-7xl)"
  },
  "sizes.8xl": {
    value: "90rem",
    variable: "var(--ikp-sizes-8xl)"
  },
  "sizes.prose": {
    value: "60ch",
    variable: "var(--ikp-sizes-prose)"
  },
  "sizes.container.sm": {
    value: "640px",
    variable: "var(--ikp-sizes-container-sm)"
  },
  "sizes.container.md": {
    value: "768px",
    variable: "var(--ikp-sizes-container-md)"
  },
  "sizes.container.lg": {
    value: "1024px",
    variable: "var(--ikp-sizes-container-lg)"
  },
  "sizes.container.xl": {
    value: "1280px",
    variable: "var(--ikp-sizes-container-xl)"
  },
  "sizes.breakpoint-md": {
    value: "768px",
    variable: "var(--ikp-sizes-breakpoint-md)"
  },
  "sizes.breakpoint-lg": {
    value: "1024px",
    variable: "var(--ikp-sizes-breakpoint-lg)"
  },
  "sizes.breakpoint-xl": {
    value: "1280px",
    variable: "var(--ikp-sizes-breakpoint-xl)"
  },
  "sizes.breakpoint-2xl": {
    value: "1536px",
    variable: "var(--ikp-sizes-breakpoint-2xl)"
  },
  "sizes.breakpoint-sm": {
    value: "33em",
    variable: "var(--ikp-sizes-breakpoint-sm)"
  },
  "space.0": {
    value: "0",
    variable: "var(--ikp-space-0)"
  },
  "space.1": {
    value: "0.25rem",
    variable: "var(--ikp-space-1)"
  },
  "space.2": {
    value: "0.5rem",
    variable: "var(--ikp-space-2)"
  },
  "space.3": {
    value: "0.75rem",
    variable: "var(--ikp-space-3)"
  },
  "space.4": {
    value: "1rem",
    variable: "var(--ikp-space-4)"
  },
  "space.5": {
    value: "1.25rem",
    variable: "var(--ikp-space-5)"
  },
  "space.6": {
    value: "1.5rem",
    variable: "var(--ikp-space-6)"
  },
  "space.7": {
    value: "1.75rem",
    variable: "var(--ikp-space-7)"
  },
  "space.8": {
    value: "2rem",
    variable: "var(--ikp-space-8)"
  },
  "space.9": {
    value: "2.25rem",
    variable: "var(--ikp-space-9)"
  },
  "space.10": {
    value: "2.5rem",
    variable: "var(--ikp-space-10)"
  },
  "space.12": {
    value: "3rem",
    variable: "var(--ikp-space-12)"
  },
  "space.14": {
    value: "3.5rem",
    variable: "var(--ikp-space-14)"
  },
  "space.16": {
    value: "4rem",
    variable: "var(--ikp-space-16)"
  },
  "space.20": {
    value: "5rem",
    variable: "var(--ikp-space-20)"
  },
  "space.24": {
    value: "6rem",
    variable: "var(--ikp-space-24)"
  },
  "space.28": {
    value: "7rem",
    variable: "var(--ikp-space-28)"
  },
  "space.32": {
    value: "8rem",
    variable: "var(--ikp-space-32)"
  },
  "space.36": {
    value: "9rem",
    variable: "var(--ikp-space-36)"
  },
  "space.40": {
    value: "10rem",
    variable: "var(--ikp-space-40)"
  },
  "space.44": {
    value: "11rem",
    variable: "var(--ikp-space-44)"
  },
  "space.48": {
    value: "12rem",
    variable: "var(--ikp-space-48)"
  },
  "space.52": {
    value: "13rem",
    variable: "var(--ikp-space-52)"
  },
  "space.56": {
    value: "14rem",
    variable: "var(--ikp-space-56)"
  },
  "space.60": {
    value: "15rem",
    variable: "var(--ikp-space-60)"
  },
  "space.64": {
    value: "16rem",
    variable: "var(--ikp-space-64)"
  },
  "space.72": {
    value: "18rem",
    variable: "var(--ikp-space-72)"
  },
  "space.80": {
    value: "20rem",
    variable: "var(--ikp-space-80)"
  },
  "space.96": {
    value: "24rem",
    variable: "var(--ikp-space-96)"
  },
  "space.auto": {
    value: "auto",
    variable: "var(--ikp-space-auto)"
  },
  "space.none": {
    value: "none",
    variable: "var(--ikp-space-none)"
  },
  "space.px": {
    value: "1px",
    variable: "var(--ikp-space-px)"
  },
  "space.0.5": {
    value: "0.125rem",
    variable: "var(--ikp-space-0\\.5)"
  },
  "space.1.5": {
    value: "0.375rem",
    variable: "var(--ikp-space-1\\.5)"
  },
  "space.2.5": {
    value: "0.625rem",
    variable: "var(--ikp-space-2\\.5)"
  },
  "space.3.5": {
    value: "0.875rem",
    variable: "var(--ikp-space-3\\.5)"
  },
  "zIndex.hide": {
    value: -1,
    variable: "var(--ikp-z-index-hide)"
  },
  "zIndex.auto": {
    value: "auto",
    variable: "var(--ikp-z-index-auto)"
  },
  "zIndex.base": {
    value: 0,
    variable: "var(--ikp-z-index-base)"
  },
  "zIndex.docked": {
    value: 10,
    variable: "var(--ikp-z-index-docked)"
  },
  "zIndex.dropdown": {
    value: 1e3,
    variable: "var(--ikp-z-index-dropdown)"
  },
  "zIndex.sticky": {
    value: 1100,
    variable: "var(--ikp-z-index-sticky)"
  },
  "zIndex.banner": {
    value: 1200,
    variable: "var(--ikp-z-index-banner)"
  },
  "zIndex.overlay": {
    value: 1300,
    variable: "var(--ikp-z-index-overlay)"
  },
  "zIndex.modal": {
    value: 1400,
    variable: "var(--ikp-z-index-modal)"
  },
  "zIndex.popover": {
    value: 1500,
    variable: "var(--ikp-z-index-popover)"
  },
  "zIndex.skipLink": {
    value: 1600,
    variable: "var(--ikp-z-index-skip-link)"
  },
  "zIndex.toast": {
    value: 1700,
    variable: "var(--ikp-z-index-toast)"
  },
  "zIndex.tooltip": {
    value: 1800,
    variable: "var(--ikp-z-index-tooltip)"
  },
  "colors.rose.50": {
    value: "#fff1f2",
    variable: "var(--ikp-colors-rose-50)"
  },
  "colors.rose.100": {
    value: "#ffe4e6",
    variable: "var(--ikp-colors-rose-100)"
  },
  "colors.rose.200": {
    value: "#fecdd3",
    variable: "var(--ikp-colors-rose-200)"
  },
  "colors.rose.300": {
    value: "#fda4af",
    variable: "var(--ikp-colors-rose-300)"
  },
  "colors.rose.400": {
    value: "#fb7185",
    variable: "var(--ikp-colors-rose-400)"
  },
  "colors.rose.500": {
    value: "#f43f5e",
    variable: "var(--ikp-colors-rose-500)"
  },
  "colors.rose.600": {
    value: "#e11d48",
    variable: "var(--ikp-colors-rose-600)"
  },
  "colors.rose.700": {
    value: "#be123c",
    variable: "var(--ikp-colors-rose-700)"
  },
  "colors.rose.800": {
    value: "#9f1239",
    variable: "var(--ikp-colors-rose-800)"
  },
  "colors.rose.900": {
    value: "#881337",
    variable: "var(--ikp-colors-rose-900)"
  },
  "colors.rose.950": {
    value: "#4c0519",
    variable: "var(--ikp-colors-rose-950)"
  },
  "colors.fuchsia.50": {
    value: "#fdf4ff",
    variable: "var(--ikp-colors-fuchsia-50)"
  },
  "colors.fuchsia.100": {
    value: "#fae8ff",
    variable: "var(--ikp-colors-fuchsia-100)"
  },
  "colors.fuchsia.200": {
    value: "#f5d0fe",
    variable: "var(--ikp-colors-fuchsia-200)"
  },
  "colors.fuchsia.300": {
    value: "#f0abfc",
    variable: "var(--ikp-colors-fuchsia-300)"
  },
  "colors.fuchsia.400": {
    value: "#e879f9",
    variable: "var(--ikp-colors-fuchsia-400)"
  },
  "colors.fuchsia.500": {
    value: "#d946ef",
    variable: "var(--ikp-colors-fuchsia-500)"
  },
  "colors.fuchsia.600": {
    value: "#c026d3",
    variable: "var(--ikp-colors-fuchsia-600)"
  },
  "colors.fuchsia.700": {
    value: "#a21caf",
    variable: "var(--ikp-colors-fuchsia-700)"
  },
  "colors.fuchsia.800": {
    value: "#86198f",
    variable: "var(--ikp-colors-fuchsia-800)"
  },
  "colors.fuchsia.900": {
    value: "#701a75",
    variable: "var(--ikp-colors-fuchsia-900)"
  },
  "colors.fuchsia.950": {
    value: "#4a044e",
    variable: "var(--ikp-colors-fuchsia-950)"
  },
  "colors.violet.50": {
    value: "#f5f3ff",
    variable: "var(--ikp-colors-violet-50)"
  },
  "colors.violet.100": {
    value: "#ede9fe",
    variable: "var(--ikp-colors-violet-100)"
  },
  "colors.violet.200": {
    value: "#ddd6fe",
    variable: "var(--ikp-colors-violet-200)"
  },
  "colors.violet.300": {
    value: "#c4b5fd",
    variable: "var(--ikp-colors-violet-300)"
  },
  "colors.violet.400": {
    value: "#a78bfa",
    variable: "var(--ikp-colors-violet-400)"
  },
  "colors.violet.500": {
    value: "#8b5cf6",
    variable: "var(--ikp-colors-violet-500)"
  },
  "colors.violet.600": {
    value: "#7c3aed",
    variable: "var(--ikp-colors-violet-600)"
  },
  "colors.violet.700": {
    value: "#6d28d9",
    variable: "var(--ikp-colors-violet-700)"
  },
  "colors.violet.800": {
    value: "#5b21b6",
    variable: "var(--ikp-colors-violet-800)"
  },
  "colors.violet.900": {
    value: "#4c1d95",
    variable: "var(--ikp-colors-violet-900)"
  },
  "colors.violet.950": {
    value: "#2e1065",
    variable: "var(--ikp-colors-violet-950)"
  },
  "colors.indigo.50": {
    value: "#eef2ff",
    variable: "var(--ikp-colors-indigo-50)"
  },
  "colors.indigo.100": {
    value: "#e0e7ff",
    variable: "var(--ikp-colors-indigo-100)"
  },
  "colors.indigo.200": {
    value: "#c7d2fe",
    variable: "var(--ikp-colors-indigo-200)"
  },
  "colors.indigo.300": {
    value: "#a5b4fc",
    variable: "var(--ikp-colors-indigo-300)"
  },
  "colors.indigo.400": {
    value: "#818cf8",
    variable: "var(--ikp-colors-indigo-400)"
  },
  "colors.indigo.500": {
    value: "#6366f1",
    variable: "var(--ikp-colors-indigo-500)"
  },
  "colors.indigo.600": {
    value: "#4f46e5",
    variable: "var(--ikp-colors-indigo-600)"
  },
  "colors.indigo.700": {
    value: "#4338ca",
    variable: "var(--ikp-colors-indigo-700)"
  },
  "colors.indigo.800": {
    value: "#3730a3",
    variable: "var(--ikp-colors-indigo-800)"
  },
  "colors.indigo.900": {
    value: "#312e81",
    variable: "var(--ikp-colors-indigo-900)"
  },
  "colors.indigo.950": {
    value: "#1e1b4b",
    variable: "var(--ikp-colors-indigo-950)"
  },
  "colors.sky.50": {
    value: "#f0f9ff",
    variable: "var(--ikp-colors-sky-50)"
  },
  "colors.sky.100": {
    value: "#e0f2fe",
    variable: "var(--ikp-colors-sky-100)"
  },
  "colors.sky.200": {
    value: "#bae6fd",
    variable: "var(--ikp-colors-sky-200)"
  },
  "colors.sky.300": {
    value: "#7dd3fc",
    variable: "var(--ikp-colors-sky-300)"
  },
  "colors.sky.400": {
    value: "#38bdf8",
    variable: "var(--ikp-colors-sky-400)"
  },
  "colors.sky.500": {
    value: "#0ea5e9",
    variable: "var(--ikp-colors-sky-500)"
  },
  "colors.sky.600": {
    value: "#0284c7",
    variable: "var(--ikp-colors-sky-600)"
  },
  "colors.sky.700": {
    value: "#0369a1",
    variable: "var(--ikp-colors-sky-700)"
  },
  "colors.sky.800": {
    value: "#075985",
    variable: "var(--ikp-colors-sky-800)"
  },
  "colors.sky.900": {
    value: "#0c4a6e",
    variable: "var(--ikp-colors-sky-900)"
  },
  "colors.sky.950": {
    value: "#082f49",
    variable: "var(--ikp-colors-sky-950)"
  },
  "colors.emerald.50": {
    value: "#ecfdf5",
    variable: "var(--ikp-colors-emerald-50)"
  },
  "colors.emerald.100": {
    value: "#d1fae5",
    variable: "var(--ikp-colors-emerald-100)"
  },
  "colors.emerald.200": {
    value: "#a7f3d0",
    variable: "var(--ikp-colors-emerald-200)"
  },
  "colors.emerald.300": {
    value: "#6ee7b7",
    variable: "var(--ikp-colors-emerald-300)"
  },
  "colors.emerald.400": {
    value: "#34d399",
    variable: "var(--ikp-colors-emerald-400)"
  },
  "colors.emerald.500": {
    value: "#10b981",
    variable: "var(--ikp-colors-emerald-500)"
  },
  "colors.emerald.600": {
    value: "#059669",
    variable: "var(--ikp-colors-emerald-600)"
  },
  "colors.emerald.700": {
    value: "#047857",
    variable: "var(--ikp-colors-emerald-700)"
  },
  "colors.emerald.800": {
    value: "#065f46",
    variable: "var(--ikp-colors-emerald-800)"
  },
  "colors.emerald.900": {
    value: "#064e3b",
    variable: "var(--ikp-colors-emerald-900)"
  },
  "colors.emerald.950": {
    value: "#022c22",
    variable: "var(--ikp-colors-emerald-950)"
  },
  "colors.lime.50": {
    value: "#f7fee7",
    variable: "var(--ikp-colors-lime-50)"
  },
  "colors.lime.100": {
    value: "#ecfccb",
    variable: "var(--ikp-colors-lime-100)"
  },
  "colors.lime.200": {
    value: "#d9f99d",
    variable: "var(--ikp-colors-lime-200)"
  },
  "colors.lime.300": {
    value: "#bef264",
    variable: "var(--ikp-colors-lime-300)"
  },
  "colors.lime.400": {
    value: "#a3e635",
    variable: "var(--ikp-colors-lime-400)"
  },
  "colors.lime.500": {
    value: "#84cc16",
    variable: "var(--ikp-colors-lime-500)"
  },
  "colors.lime.600": {
    value: "#65a30d",
    variable: "var(--ikp-colors-lime-600)"
  },
  "colors.lime.700": {
    value: "#4d7c0f",
    variable: "var(--ikp-colors-lime-700)"
  },
  "colors.lime.800": {
    value: "#3f6212",
    variable: "var(--ikp-colors-lime-800)"
  },
  "colors.lime.900": {
    value: "#365314",
    variable: "var(--ikp-colors-lime-900)"
  },
  "colors.lime.950": {
    value: "#1a2e05",
    variable: "var(--ikp-colors-lime-950)"
  },
  "colors.amber.50": {
    value: "#fffbeb",
    variable: "var(--ikp-colors-amber-50)"
  },
  "colors.amber.100": {
    value: "#fef3c7",
    variable: "var(--ikp-colors-amber-100)"
  },
  "colors.amber.200": {
    value: "#fde68a",
    variable: "var(--ikp-colors-amber-200)"
  },
  "colors.amber.300": {
    value: "#fcd34d",
    variable: "var(--ikp-colors-amber-300)"
  },
  "colors.amber.400": {
    value: "#fbbf24",
    variable: "var(--ikp-colors-amber-400)"
  },
  "colors.amber.500": {
    value: "#f59e0b",
    variable: "var(--ikp-colors-amber-500)"
  },
  "colors.amber.600": {
    value: "#d97706",
    variable: "var(--ikp-colors-amber-600)"
  },
  "colors.amber.700": {
    value: "#b45309",
    variable: "var(--ikp-colors-amber-700)"
  },
  "colors.amber.800": {
    value: "#92400e",
    variable: "var(--ikp-colors-amber-800)"
  },
  "colors.amber.900": {
    value: "#78350f",
    variable: "var(--ikp-colors-amber-900)"
  },
  "colors.amber.950": {
    value: "#451a03",
    variable: "var(--ikp-colors-amber-950)"
  },
  "colors.neutral.50": {
    value: "#fafafa",
    variable: "var(--ikp-colors-neutral-50)"
  },
  "colors.neutral.100": {
    value: "#f5f5f5",
    variable: "var(--ikp-colors-neutral-100)"
  },
  "colors.neutral.200": {
    value: "#e5e5e5",
    variable: "var(--ikp-colors-neutral-200)"
  },
  "colors.neutral.300": {
    value: "#d4d4d4",
    variable: "var(--ikp-colors-neutral-300)"
  },
  "colors.neutral.400": {
    value: "#a3a3a3",
    variable: "var(--ikp-colors-neutral-400)"
  },
  "colors.neutral.500": {
    value: "#737373",
    variable: "var(--ikp-colors-neutral-500)"
  },
  "colors.neutral.600": {
    value: "#525252",
    variable: "var(--ikp-colors-neutral-600)"
  },
  "colors.neutral.700": {
    value: "#404040",
    variable: "var(--ikp-colors-neutral-700)"
  },
  "colors.neutral.800": {
    value: "#262626",
    variable: "var(--ikp-colors-neutral-800)"
  },
  "colors.neutral.900": {
    value: "#171717",
    variable: "var(--ikp-colors-neutral-900)"
  },
  "colors.neutral.950": {
    value: "#0a0a0a",
    variable: "var(--ikp-colors-neutral-950)"
  },
  "colors.stone.50": {
    value: "#fafaf9",
    variable: "var(--ikp-colors-stone-50)"
  },
  "colors.stone.100": {
    value: "#f5f5f4",
    variable: "var(--ikp-colors-stone-100)"
  },
  "colors.stone.200": {
    value: "#e7e5e4",
    variable: "var(--ikp-colors-stone-200)"
  },
  "colors.stone.300": {
    value: "#d6d3d1",
    variable: "var(--ikp-colors-stone-300)"
  },
  "colors.stone.400": {
    value: "#a8a29e",
    variable: "var(--ikp-colors-stone-400)"
  },
  "colors.stone.500": {
    value: "#78716c",
    variable: "var(--ikp-colors-stone-500)"
  },
  "colors.stone.600": {
    value: "#57534e",
    variable: "var(--ikp-colors-stone-600)"
  },
  "colors.stone.700": {
    value: "#44403c",
    variable: "var(--ikp-colors-stone-700)"
  },
  "colors.stone.800": {
    value: "#292524",
    variable: "var(--ikp-colors-stone-800)"
  },
  "colors.stone.900": {
    value: "#1c1917",
    variable: "var(--ikp-colors-stone-900)"
  },
  "colors.stone.950": {
    value: "#0c0a09",
    variable: "var(--ikp-colors-stone-950)"
  },
  "colors.zinc.50": {
    value: "#fafafa",
    variable: "var(--ikp-colors-zinc-50)"
  },
  "colors.zinc.100": {
    value: "#f4f4f5",
    variable: "var(--ikp-colors-zinc-100)"
  },
  "colors.zinc.200": {
    value: "#e4e4e7",
    variable: "var(--ikp-colors-zinc-200)"
  },
  "colors.zinc.300": {
    value: "#d4d4d8",
    variable: "var(--ikp-colors-zinc-300)"
  },
  "colors.zinc.400": {
    value: "#a1a1aa",
    variable: "var(--ikp-colors-zinc-400)"
  },
  "colors.zinc.500": {
    value: "#71717a",
    variable: "var(--ikp-colors-zinc-500)"
  },
  "colors.zinc.600": {
    value: "#52525b",
    variable: "var(--ikp-colors-zinc-600)"
  },
  "colors.zinc.700": {
    value: "#3f3f46",
    variable: "var(--ikp-colors-zinc-700)"
  },
  "colors.zinc.800": {
    value: "#27272a",
    variable: "var(--ikp-colors-zinc-800)"
  },
  "colors.zinc.900": {
    value: "#18181b",
    variable: "var(--ikp-colors-zinc-900)"
  },
  "colors.zinc.950": {
    value: "#09090b",
    variable: "var(--ikp-colors-zinc-950)"
  },
  "colors.slate.50": {
    value: "#f8fafc",
    variable: "var(--ikp-colors-slate-50)"
  },
  "colors.slate.100": {
    value: "#f1f5f9",
    variable: "var(--ikp-colors-slate-100)"
  },
  "colors.slate.200": {
    value: "#e2e8f0",
    variable: "var(--ikp-colors-slate-200)"
  },
  "colors.slate.300": {
    value: "#cbd5e1",
    variable: "var(--ikp-colors-slate-300)"
  },
  "colors.slate.400": {
    value: "#94a3b8",
    variable: "var(--ikp-colors-slate-400)"
  },
  "colors.slate.500": {
    value: "#64748b",
    variable: "var(--ikp-colors-slate-500)"
  },
  "colors.slate.600": {
    value: "#475569",
    variable: "var(--ikp-colors-slate-600)"
  },
  "colors.slate.700": {
    value: "#334155",
    variable: "var(--ikp-colors-slate-700)"
  },
  "colors.slate.800": {
    value: "#1e293b",
    variable: "var(--ikp-colors-slate-800)"
  },
  "colors.slate.900": {
    value: "#0f172a",
    variable: "var(--ikp-colors-slate-900)"
  },
  "colors.slate.950": {
    value: "#020617",
    variable: "var(--ikp-colors-slate-950)"
  },
  "colors.transparent": {
    value: "transparent",
    variable: "var(--ikp-colors-transparent)"
  },
  "colors.current": {
    value: "currentColor",
    variable: "var(--ikp-colors-current)"
  },
  "colors.black": {
    value: "#000000",
    variable: "var(--ikp-colors-black)"
  },
  "colors.white": {
    value: "#FFFFFF",
    variable: "var(--ikp-colors-white)"
  },
  "colors.whiteAlpha.50": {
    value: "rgba(255, 255, 255, 0.04)",
    variable: "var(--ikp-colors-white-alpha-50)"
  },
  "colors.whiteAlpha.100": {
    value: "rgba(255, 255, 255, 0.06)",
    variable: "var(--ikp-colors-white-alpha-100)"
  },
  "colors.whiteAlpha.200": {
    value: "rgba(255, 255, 255, 0.08)",
    variable: "var(--ikp-colors-white-alpha-200)"
  },
  "colors.whiteAlpha.300": {
    value: "rgba(255, 255, 255, 0.16)",
    variable: "var(--ikp-colors-white-alpha-300)"
  },
  "colors.whiteAlpha.400": {
    value: "rgba(255, 255, 255, 0.24)",
    variable: "var(--ikp-colors-white-alpha-400)"
  },
  "colors.whiteAlpha.500": {
    value: "rgba(255, 255, 255, 0.36)",
    variable: "var(--ikp-colors-white-alpha-500)"
  },
  "colors.whiteAlpha.600": {
    value: "rgba(255, 255, 255, 0.48)",
    variable: "var(--ikp-colors-white-alpha-600)"
  },
  "colors.whiteAlpha.700": {
    value: "rgba(255, 255, 255, 0.64)",
    variable: "var(--ikp-colors-white-alpha-700)"
  },
  "colors.whiteAlpha.800": {
    value: "rgba(255, 255, 255, 0.80)",
    variable: "var(--ikp-colors-white-alpha-800)"
  },
  "colors.whiteAlpha.900": {
    value: "rgba(255, 255, 255, 0.92)",
    variable: "var(--ikp-colors-white-alpha-900)"
  },
  "colors.blackAlpha.50": {
    value: "rgba(0, 0, 0, 0.04)",
    variable: "var(--ikp-colors-black-alpha-50)"
  },
  "colors.blackAlpha.100": {
    value: "rgba(0, 0, 0, 0.06)",
    variable: "var(--ikp-colors-black-alpha-100)"
  },
  "colors.blackAlpha.200": {
    value: "rgba(0, 0, 0, 0.08)",
    variable: "var(--ikp-colors-black-alpha-200)"
  },
  "colors.blackAlpha.300": {
    value: "rgba(0, 0, 0, 0.16)",
    variable: "var(--ikp-colors-black-alpha-300)"
  },
  "colors.blackAlpha.400": {
    value: "rgba(0, 0, 0, 0.24)",
    variable: "var(--ikp-colors-black-alpha-400)"
  },
  "colors.blackAlpha.500": {
    value: "rgba(0, 0, 0, 0.36)",
    variable: "var(--ikp-colors-black-alpha-500)"
  },
  "colors.blackAlpha.600": {
    value: "rgba(0, 0, 0, 0.48)",
    variable: "var(--ikp-colors-black-alpha-600)"
  },
  "colors.blackAlpha.700": {
    value: "rgba(0, 0, 0, 0.64)",
    variable: "var(--ikp-colors-black-alpha-700)"
  },
  "colors.blackAlpha.800": {
    value: "rgba(0, 0, 0, 0.80)",
    variable: "var(--ikp-colors-black-alpha-800)"
  },
  "colors.blackAlpha.900": {
    value: "rgba(0, 0, 0, 0.92)",
    variable: "var(--ikp-colors-black-alpha-900)"
  },
  "colors.red.50": {
    value: "#FFF5F5",
    variable: "var(--ikp-colors-red-50)"
  },
  "colors.red.100": {
    value: "#FED7D7",
    variable: "var(--ikp-colors-red-100)"
  },
  "colors.red.200": {
    value: "#FEB2B2",
    variable: "var(--ikp-colors-red-200)"
  },
  "colors.red.300": {
    value: "#FC8181",
    variable: "var(--ikp-colors-red-300)"
  },
  "colors.red.400": {
    value: "#F56565",
    variable: "var(--ikp-colors-red-400)"
  },
  "colors.red.500": {
    value: "#E53E3E",
    variable: "var(--ikp-colors-red-500)"
  },
  "colors.red.600": {
    value: "#C53030",
    variable: "var(--ikp-colors-red-600)"
  },
  "colors.red.700": {
    value: "#9B2C2C",
    variable: "var(--ikp-colors-red-700)"
  },
  "colors.red.800": {
    value: "#822727",
    variable: "var(--ikp-colors-red-800)"
  },
  "colors.red.900": {
    value: "#63171B",
    variable: "var(--ikp-colors-red-900)"
  },
  "colors.red.950": {
    value: "#450a0a",
    variable: "var(--ikp-colors-red-950)"
  },
  "colors.orange.50": {
    value: "#FFFAF0",
    variable: "var(--ikp-colors-orange-50)"
  },
  "colors.orange.100": {
    value: "#FEEBC8",
    variable: "var(--ikp-colors-orange-100)"
  },
  "colors.orange.200": {
    value: "#FBD38D",
    variable: "var(--ikp-colors-orange-200)"
  },
  "colors.orange.300": {
    value: "#F6AD55",
    variable: "var(--ikp-colors-orange-300)"
  },
  "colors.orange.400": {
    value: "#ED8936",
    variable: "var(--ikp-colors-orange-400)"
  },
  "colors.orange.500": {
    value: "#DD6B20",
    variable: "var(--ikp-colors-orange-500)"
  },
  "colors.orange.600": {
    value: "#C05621",
    variable: "var(--ikp-colors-orange-600)"
  },
  "colors.orange.700": {
    value: "#9C4221",
    variable: "var(--ikp-colors-orange-700)"
  },
  "colors.orange.800": {
    value: "#7B341E",
    variable: "var(--ikp-colors-orange-800)"
  },
  "colors.orange.900": {
    value: "#652B19",
    variable: "var(--ikp-colors-orange-900)"
  },
  "colors.orange.950": {
    value: "#431407",
    variable: "var(--ikp-colors-orange-950)"
  },
  "colors.yellow.50": {
    value: "#FFFFF0",
    variable: "var(--ikp-colors-yellow-50)"
  },
  "colors.yellow.100": {
    value: "#FEFCBF",
    variable: "var(--ikp-colors-yellow-100)"
  },
  "colors.yellow.200": {
    value: "#FAF089",
    variable: "var(--ikp-colors-yellow-200)"
  },
  "colors.yellow.300": {
    value: "#F6E05E",
    variable: "var(--ikp-colors-yellow-300)"
  },
  "colors.yellow.400": {
    value: "#ECC94B",
    variable: "var(--ikp-colors-yellow-400)"
  },
  "colors.yellow.500": {
    value: "#D69E2E",
    variable: "var(--ikp-colors-yellow-500)"
  },
  "colors.yellow.600": {
    value: "#B7791F",
    variable: "var(--ikp-colors-yellow-600)"
  },
  "colors.yellow.700": {
    value: "#975A16",
    variable: "var(--ikp-colors-yellow-700)"
  },
  "colors.yellow.800": {
    value: "#744210",
    variable: "var(--ikp-colors-yellow-800)"
  },
  "colors.yellow.900": {
    value: "#5F370E",
    variable: "var(--ikp-colors-yellow-900)"
  },
  "colors.yellow.950": {
    value: "#422006",
    variable: "var(--ikp-colors-yellow-950)"
  },
  "colors.green.50": {
    value: "#F0FFF4",
    variable: "var(--ikp-colors-green-50)"
  },
  "colors.green.100": {
    value: "#C6F6D5",
    variable: "var(--ikp-colors-green-100)"
  },
  "colors.green.200": {
    value: "#9AE6B4",
    variable: "var(--ikp-colors-green-200)"
  },
  "colors.green.300": {
    value: "#68D391",
    variable: "var(--ikp-colors-green-300)"
  },
  "colors.green.400": {
    value: "#48BB78",
    variable: "var(--ikp-colors-green-400)"
  },
  "colors.green.500": {
    value: "#38A169",
    variable: "var(--ikp-colors-green-500)"
  },
  "colors.green.600": {
    value: "#2F855A",
    variable: "var(--ikp-colors-green-600)"
  },
  "colors.green.700": {
    value: "#276749",
    variable: "var(--ikp-colors-green-700)"
  },
  "colors.green.800": {
    value: "#22543D",
    variable: "var(--ikp-colors-green-800)"
  },
  "colors.green.900": {
    value: "#1C4532",
    variable: "var(--ikp-colors-green-900)"
  },
  "colors.green.950": {
    value: "#052e16",
    variable: "var(--ikp-colors-green-950)"
  },
  "colors.teal.50": {
    value: "#E6FFFA",
    variable: "var(--ikp-colors-teal-50)"
  },
  "colors.teal.100": {
    value: "#B2F5EA",
    variable: "var(--ikp-colors-teal-100)"
  },
  "colors.teal.200": {
    value: "#81E6D9",
    variable: "var(--ikp-colors-teal-200)"
  },
  "colors.teal.300": {
    value: "#4FD1C5",
    variable: "var(--ikp-colors-teal-300)"
  },
  "colors.teal.400": {
    value: "#38B2AC",
    variable: "var(--ikp-colors-teal-400)"
  },
  "colors.teal.500": {
    value: "#319795",
    variable: "var(--ikp-colors-teal-500)"
  },
  "colors.teal.600": {
    value: "#2C7A7B",
    variable: "var(--ikp-colors-teal-600)"
  },
  "colors.teal.700": {
    value: "#285E61",
    variable: "var(--ikp-colors-teal-700)"
  },
  "colors.teal.800": {
    value: "#234E52",
    variable: "var(--ikp-colors-teal-800)"
  },
  "colors.teal.900": {
    value: "#1D4044",
    variable: "var(--ikp-colors-teal-900)"
  },
  "colors.teal.950": {
    value: "#042f2e",
    variable: "var(--ikp-colors-teal-950)"
  },
  "colors.blue.50": {
    value: "#ebf8ff",
    variable: "var(--ikp-colors-blue-50)"
  },
  "colors.blue.100": {
    value: "#bee3f8",
    variable: "var(--ikp-colors-blue-100)"
  },
  "colors.blue.200": {
    value: "#90cdf4",
    variable: "var(--ikp-colors-blue-200)"
  },
  "colors.blue.300": {
    value: "#63b3ed",
    variable: "var(--ikp-colors-blue-300)"
  },
  "colors.blue.400": {
    value: "#4299e1",
    variable: "var(--ikp-colors-blue-400)"
  },
  "colors.blue.500": {
    value: "#3182ce",
    variable: "var(--ikp-colors-blue-500)"
  },
  "colors.blue.600": {
    value: "#2b6cb0",
    variable: "var(--ikp-colors-blue-600)"
  },
  "colors.blue.700": {
    value: "#2c5282",
    variable: "var(--ikp-colors-blue-700)"
  },
  "colors.blue.800": {
    value: "#2a4365",
    variable: "var(--ikp-colors-blue-800)"
  },
  "colors.blue.900": {
    value: "#1A365D",
    variable: "var(--ikp-colors-blue-900)"
  },
  "colors.blue.950": {
    value: "#172554",
    variable: "var(--ikp-colors-blue-950)"
  },
  "colors.cyan.50": {
    value: "#EDFDFD",
    variable: "var(--ikp-colors-cyan-50)"
  },
  "colors.cyan.100": {
    value: "#C4F1F9",
    variable: "var(--ikp-colors-cyan-100)"
  },
  "colors.cyan.200": {
    value: "#9DECF9",
    variable: "var(--ikp-colors-cyan-200)"
  },
  "colors.cyan.300": {
    value: "#76E4F7",
    variable: "var(--ikp-colors-cyan-300)"
  },
  "colors.cyan.400": {
    value: "#0BC5EA",
    variable: "var(--ikp-colors-cyan-400)"
  },
  "colors.cyan.500": {
    value: "#00B5D8",
    variable: "var(--ikp-colors-cyan-500)"
  },
  "colors.cyan.600": {
    value: "#00A3C4",
    variable: "var(--ikp-colors-cyan-600)"
  },
  "colors.cyan.700": {
    value: "#0987A0",
    variable: "var(--ikp-colors-cyan-700)"
  },
  "colors.cyan.800": {
    value: "#086F83",
    variable: "var(--ikp-colors-cyan-800)"
  },
  "colors.cyan.900": {
    value: "#065666",
    variable: "var(--ikp-colors-cyan-900)"
  },
  "colors.cyan.950": {
    value: "#083344",
    variable: "var(--ikp-colors-cyan-950)"
  },
  "colors.purple.50": {
    value: "#FAF5FF",
    variable: "var(--ikp-colors-purple-50)"
  },
  "colors.purple.100": {
    value: "#E9D8FD",
    variable: "var(--ikp-colors-purple-100)"
  },
  "colors.purple.200": {
    value: "#D6BCFA",
    variable: "var(--ikp-colors-purple-200)"
  },
  "colors.purple.300": {
    value: "#B794F4",
    variable: "var(--ikp-colors-purple-300)"
  },
  "colors.purple.400": {
    value: "#9F7AEA",
    variable: "var(--ikp-colors-purple-400)"
  },
  "colors.purple.500": {
    value: "#805AD5",
    variable: "var(--ikp-colors-purple-500)"
  },
  "colors.purple.600": {
    value: "#6B46C1",
    variable: "var(--ikp-colors-purple-600)"
  },
  "colors.purple.700": {
    value: "#553C9A",
    variable: "var(--ikp-colors-purple-700)"
  },
  "colors.purple.800": {
    value: "#44337A",
    variable: "var(--ikp-colors-purple-800)"
  },
  "colors.purple.900": {
    value: "#322659",
    variable: "var(--ikp-colors-purple-900)"
  },
  "colors.purple.950": {
    value: "#3b0764",
    variable: "var(--ikp-colors-purple-950)"
  },
  "colors.pink.50": {
    value: "#FFF5F7",
    variable: "var(--ikp-colors-pink-50)"
  },
  "colors.pink.100": {
    value: "#FED7E2",
    variable: "var(--ikp-colors-pink-100)"
  },
  "colors.pink.200": {
    value: "#FBB6CE",
    variable: "var(--ikp-colors-pink-200)"
  },
  "colors.pink.300": {
    value: "#F687B3",
    variable: "var(--ikp-colors-pink-300)"
  },
  "colors.pink.400": {
    value: "#ED64A6",
    variable: "var(--ikp-colors-pink-400)"
  },
  "colors.pink.500": {
    value: "#D53F8C",
    variable: "var(--ikp-colors-pink-500)"
  },
  "colors.pink.600": {
    value: "#B83280",
    variable: "var(--ikp-colors-pink-600)"
  },
  "colors.pink.700": {
    value: "#97266D",
    variable: "var(--ikp-colors-pink-700)"
  },
  "colors.pink.800": {
    value: "#702459",
    variable: "var(--ikp-colors-pink-800)"
  },
  "colors.pink.900": {
    value: "#521B41",
    variable: "var(--ikp-colors-pink-900)"
  },
  "colors.pink.950": {
    value: "#500724",
    variable: "var(--ikp-colors-pink-950)"
  },
  "colors.linkedin.50": {
    value: "#E8F4F9",
    variable: "var(--ikp-colors-linkedin-50)"
  },
  "colors.linkedin.100": {
    value: "#CFEDFB",
    variable: "var(--ikp-colors-linkedin-100)"
  },
  "colors.linkedin.200": {
    value: "#9BDAF3",
    variable: "var(--ikp-colors-linkedin-200)"
  },
  "colors.linkedin.300": {
    value: "#68C7EC",
    variable: "var(--ikp-colors-linkedin-300)"
  },
  "colors.linkedin.400": {
    value: "#34B3E4",
    variable: "var(--ikp-colors-linkedin-400)"
  },
  "colors.linkedin.500": {
    value: "#00A0DC",
    variable: "var(--ikp-colors-linkedin-500)"
  },
  "colors.linkedin.600": {
    value: "#008CC9",
    variable: "var(--ikp-colors-linkedin-600)"
  },
  "colors.linkedin.700": {
    value: "#0077B5",
    variable: "var(--ikp-colors-linkedin-700)"
  },
  "colors.linkedin.800": {
    value: "#005E93",
    variable: "var(--ikp-colors-linkedin-800)"
  },
  "colors.linkedin.900": {
    value: "#004471",
    variable: "var(--ikp-colors-linkedin-900)"
  },
  "colors.facebook.50": {
    value: "#E8F4F9",
    variable: "var(--ikp-colors-facebook-50)"
  },
  "colors.facebook.100": {
    value: "#D9DEE9",
    variable: "var(--ikp-colors-facebook-100)"
  },
  "colors.facebook.200": {
    value: "#B7C2DA",
    variable: "var(--ikp-colors-facebook-200)"
  },
  "colors.facebook.300": {
    value: "#6482C0",
    variable: "var(--ikp-colors-facebook-300)"
  },
  "colors.facebook.400": {
    value: "#4267B2",
    variable: "var(--ikp-colors-facebook-400)"
  },
  "colors.facebook.500": {
    value: "#385898",
    variable: "var(--ikp-colors-facebook-500)"
  },
  "colors.facebook.600": {
    value: "#314E89",
    variable: "var(--ikp-colors-facebook-600)"
  },
  "colors.facebook.700": {
    value: "#29487D",
    variable: "var(--ikp-colors-facebook-700)"
  },
  "colors.facebook.800": {
    value: "#223B67",
    variable: "var(--ikp-colors-facebook-800)"
  },
  "colors.facebook.900": {
    value: "#1E355B",
    variable: "var(--ikp-colors-facebook-900)"
  },
  "colors.messenger.50": {
    value: "#D0E6FF",
    variable: "var(--ikp-colors-messenger-50)"
  },
  "colors.messenger.100": {
    value: "#B9DAFF",
    variable: "var(--ikp-colors-messenger-100)"
  },
  "colors.messenger.200": {
    value: "#A2CDFF",
    variable: "var(--ikp-colors-messenger-200)"
  },
  "colors.messenger.300": {
    value: "#7AB8FF",
    variable: "var(--ikp-colors-messenger-300)"
  },
  "colors.messenger.400": {
    value: "#2E90FF",
    variable: "var(--ikp-colors-messenger-400)"
  },
  "colors.messenger.500": {
    value: "#0078FF",
    variable: "var(--ikp-colors-messenger-500)"
  },
  "colors.messenger.600": {
    value: "#0063D1",
    variable: "var(--ikp-colors-messenger-600)"
  },
  "colors.messenger.700": {
    value: "#0052AC",
    variable: "var(--ikp-colors-messenger-700)"
  },
  "colors.messenger.800": {
    value: "#003C7E",
    variable: "var(--ikp-colors-messenger-800)"
  },
  "colors.messenger.900": {
    value: "#002C5C",
    variable: "var(--ikp-colors-messenger-900)"
  },
  "colors.whatsapp.50": {
    value: "#dffeec",
    variable: "var(--ikp-colors-whatsapp-50)"
  },
  "colors.whatsapp.100": {
    value: "#b9f5d0",
    variable: "var(--ikp-colors-whatsapp-100)"
  },
  "colors.whatsapp.200": {
    value: "#90edb3",
    variable: "var(--ikp-colors-whatsapp-200)"
  },
  "colors.whatsapp.300": {
    value: "#65e495",
    variable: "var(--ikp-colors-whatsapp-300)"
  },
  "colors.whatsapp.400": {
    value: "#3cdd78",
    variable: "var(--ikp-colors-whatsapp-400)"
  },
  "colors.whatsapp.500": {
    value: "#22c35e",
    variable: "var(--ikp-colors-whatsapp-500)"
  },
  "colors.whatsapp.600": {
    value: "#179848",
    variable: "var(--ikp-colors-whatsapp-600)"
  },
  "colors.whatsapp.700": {
    value: "#0c6c33",
    variable: "var(--ikp-colors-whatsapp-700)"
  },
  "colors.whatsapp.800": {
    value: "#01421c",
    variable: "var(--ikp-colors-whatsapp-800)"
  },
  "colors.whatsapp.900": {
    value: "#001803",
    variable: "var(--ikp-colors-whatsapp-900)"
  },
  "colors.twitter.50": {
    value: "#E5F4FD",
    variable: "var(--ikp-colors-twitter-50)"
  },
  "colors.twitter.100": {
    value: "#C8E9FB",
    variable: "var(--ikp-colors-twitter-100)"
  },
  "colors.twitter.200": {
    value: "#A8DCFA",
    variable: "var(--ikp-colors-twitter-200)"
  },
  "colors.twitter.300": {
    value: "#83CDF7",
    variable: "var(--ikp-colors-twitter-300)"
  },
  "colors.twitter.400": {
    value: "#57BBF5",
    variable: "var(--ikp-colors-twitter-400)"
  },
  "colors.twitter.500": {
    value: "#1DA1F2",
    variable: "var(--ikp-colors-twitter-500)"
  },
  "colors.twitter.600": {
    value: "#1A94DA",
    variable: "var(--ikp-colors-twitter-600)"
  },
  "colors.twitter.700": {
    value: "#1681BF",
    variable: "var(--ikp-colors-twitter-700)"
  },
  "colors.twitter.800": {
    value: "#136B9E",
    variable: "var(--ikp-colors-twitter-800)"
  },
  "colors.twitter.900": {
    value: "#0D4D71",
    variable: "var(--ikp-colors-twitter-900)"
  },
  "colors.telegram.50": {
    value: "#E3F2F9",
    variable: "var(--ikp-colors-telegram-50)"
  },
  "colors.telegram.100": {
    value: "#C5E4F3",
    variable: "var(--ikp-colors-telegram-100)"
  },
  "colors.telegram.200": {
    value: "#A2D4EC",
    variable: "var(--ikp-colors-telegram-200)"
  },
  "colors.telegram.300": {
    value: "#7AC1E4",
    variable: "var(--ikp-colors-telegram-300)"
  },
  "colors.telegram.400": {
    value: "#47A9DA",
    variable: "var(--ikp-colors-telegram-400)"
  },
  "colors.telegram.500": {
    value: "#0088CC",
    variable: "var(--ikp-colors-telegram-500)"
  },
  "colors.telegram.600": {
    value: "#007AB8",
    variable: "var(--ikp-colors-telegram-600)"
  },
  "colors.telegram.700": {
    value: "#006BA1",
    variable: "var(--ikp-colors-telegram-700)"
  },
  "colors.telegram.800": {
    value: "#005885",
    variable: "var(--ikp-colors-telegram-800)"
  },
  "colors.telegram.900": {
    value: "#003F5E",
    variable: "var(--ikp-colors-telegram-900)"
  },
  "colors.gray.50": {
    value: "#f8f9fa",
    variable: "var(--ikp-colors-gray-50)"
  },
  "colors.gray.100": {
    value: "#f1f3f5",
    variable: "var(--ikp-colors-gray-100)"
  },
  "colors.gray.200": {
    value: "#eceef0",
    variable: "var(--ikp-colors-gray-200)"
  },
  "colors.gray.300": {
    value: "#e6e8eb",
    variable: "var(--ikp-colors-gray-300)"
  },
  "colors.gray.400": {
    value: "#dfe3e6",
    variable: "var(--ikp-colors-gray-400)"
  },
  "colors.gray.500": {
    value: "#BDC2C7",
    variable: "var(--ikp-colors-gray-500)"
  },
  "colors.gray.600": {
    value: "#889096",
    variable: "var(--ikp-colors-gray-600)"
  },
  "colors.gray.700": {
    value: "#687076",
    variable: "var(--ikp-colors-gray-700)"
  },
  "colors.gray.800": {
    value: "#36424A",
    variable: "var(--ikp-colors-gray-800)"
  },
  "colors.gray.900": {
    value: "#11181c",
    variable: "var(--ikp-colors-gray-900)"
  },
  "colors.gray.950": {
    value: "#030712",
    variable: "var(--ikp-colors-gray-950)"
  },
  "colors.grayAlpha.50": {
    value: "rgba(22, 56, 90, 0.03)",
    variable: "var(--ikp-colors-gray-alpha-50)"
  },
  "colors.grayAlpha.100": {
    value: "rgba(22, 56, 90, 0.06)",
    variable: "var(--ikp-colors-gray-alpha-100)"
  },
  "colors.grayAlpha.200": {
    value: "rgba(18, 43, 68, 0.08)",
    variable: "var(--ikp-colors-gray-alpha-200)"
  },
  "colors.grayAlpha.300": {
    value: "rgba(5, 26, 56, 0.1)",
    variable: "var(--ikp-colors-gray-alpha-300)"
  },
  "colors.grayAlpha.400": {
    value: "rgba(9, 39, 62, 0.13)",
    variable: "var(--ikp-colors-gray-alpha-400)"
  },
  "colors.grayAlpha.500": {
    value: "rgba(1, 20, 40, 0.26)",
    variable: "var(--ikp-colors-gray-alpha-500)"
  },
  "colors.grayAlpha.600": {
    value: "rgba(2, 20, 34, 0.47)",
    variable: "var(--ikp-colors-gray-alpha-600)"
  },
  "colors.grayAlpha.700": {
    value: "rgba(3, 17, 28, 0.6)",
    variable: "var(--ikp-colors-gray-alpha-700)"
  },
  "colors.grayAlpha.800": {
    value: "rgba(1, 15, 25, 0.79)",
    variable: "var(--ikp-colors-gray-alpha-800)"
  },
  "colors.grayAlpha.900": {
    value: "rgba(2, 9, 13, 0.94)",
    variable: "var(--ikp-colors-gray-alpha-900)"
  },
  "colors.grayDark.50": {
    value: "#ededed",
    variable: "var(--ikp-colors-gray-dark-50)"
  },
  "colors.grayDark.100": {
    value: "#a0a0a0",
    variable: "var(--ikp-colors-gray-dark-100)"
  },
  "colors.grayDark.200": {
    value: "#7e7e7e",
    variable: "var(--ikp-colors-gray-dark-200)"
  },
  "colors.grayDark.300": {
    value: "#707070",
    variable: "var(--ikp-colors-gray-dark-300)"
  },
  "colors.grayDark.400": {
    value: "#505050",
    variable: "var(--ikp-colors-gray-dark-400)"
  },
  "colors.grayDark.500": {
    value: "#3e3e3e",
    variable: "var(--ikp-colors-gray-dark-500)"
  },
  "colors.grayDark.600": {
    value: "#343434",
    variable: "var(--ikp-colors-gray-dark-600)"
  },
  "colors.grayDark.700": {
    value: "#2e2e2e",
    variable: "var(--ikp-colors-gray-dark-700)"
  },
  "colors.grayDark.800": {
    value: "#282828",
    variable: "var(--ikp-colors-gray-dark-800)"
  },
  "colors.grayDark.900": {
    value: "#1c1c1c",
    variable: "var(--ikp-colors-gray-dark-900)"
  },
  "fonts.sans": {
    value: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    variable: "var(--ikp-fonts-sans)"
  },
  "fonts.serif": {
    value: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
    variable: "var(--ikp-fonts-serif)"
  },
  "fonts.mono": {
    value: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace',
    variable: "var(--ikp-fonts-mono)"
  },
  "fonts.body": {
    value: "'Inter', sans-serif",
    variable: "var(--ikp-fonts-body)"
  },
  "fonts.heading": {
    value: "'Inter', sans-serif",
    variable: "var(--ikp-fonts-heading)"
  },
  "easings.linear": {
    value: "linear",
    variable: "var(--ikp-easings-linear)"
  },
  "easings.in": {
    value: "cubic-bezier(0.4, 0, 1, 1)",
    variable: "var(--ikp-easings-in)"
  },
  "easings.out": {
    value: "cubic-bezier(0, 0, 0.2, 1)",
    variable: "var(--ikp-easings-out)"
  },
  "easings.in-out": {
    value: "cubic-bezier(0.4, 0, 0.2, 1)",
    variable: "var(--ikp-easings-in-out)"
  },
  "easings.default": {
    value: "cubic-bezier(0.2, 0.0, 0, 1.0)",
    variable: "var(--ikp-easings-default)"
  },
  "easings.emphasized-in": {
    value: "cubic-bezier(0.05, 0.7, 0.1, 1.0)",
    variable: "var(--ikp-easings-emphasized-in)"
  },
  "easings.emphasized-out": {
    value: "cubic-bezier(0.3, 0.0, 0.8, 0.15)",
    variable: "var(--ikp-easings-emphasized-out)"
  },
  "animations.spin": {
    value: "spin 1s linear infinite",
    variable: "var(--ikp-animations-spin)"
  },
  "animations.ping": {
    value: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
    variable: "var(--ikp-animations-ping)"
  },
  "animations.pulse": {
    value: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
    variable: "var(--ikp-animations-pulse)"
  },
  "animations.bounce": {
    value: "bounce 1s infinite",
    variable: "var(--ikp-animations-bounce)"
  },
  "animations.backdrop-in": {
    value: "fade-in 250ms var(--ikp-easings-default)",
    variable: "var(--ikp-animations-backdrop-in)"
  },
  "animations.backdrop-out": {
    value: "fade-out 200ms var(--ikp-easings-default)",
    variable: "var(--ikp-animations-backdrop-out)"
  },
  "animations.dialog-in": {
    value: "slide-in 400ms var(--ikp-easings-emphasized-in)",
    variable: "var(--ikp-animations-dialog-in)"
  },
  "animations.dialog-out": {
    value: "slide-out 200ms var(--ikp-easings-emphasized-out)",
    variable: "var(--ikp-animations-dialog-out)"
  },
  "durations.fastest": {
    value: "50ms",
    variable: "var(--ikp-durations-fastest)"
  },
  "durations.normal": {
    value: "200ms",
    variable: "var(--ikp-durations-normal)"
  },
  "durations.slower": {
    value: "400ms",
    variable: "var(--ikp-durations-slower)"
  },
  "durations.slowest": {
    value: "500ms",
    variable: "var(--ikp-durations-slowest)"
  },
  "durations.faster": {
    value: "100ms",
    variable: "var(--ikp-durations-faster)"
  },
  "durations.fast": {
    value: "180ms",
    variable: "var(--ikp-durations-fast)"
  },
  "durations.medium": {
    value: "300ms",
    variable: "var(--ikp-durations-medium)"
  },
  "durations.slow": {
    value: "500ms",
    variable: "var(--ikp-durations-slow)"
  },
  "shadows.xs": {
    value: "var(--ikp-shadows-xs)",
    variable: "var(--ikp-shadows-xs)"
  },
  "shadows.sm": {
    value: "var(--ikp-shadows-sm)",
    variable: "var(--ikp-shadows-sm)"
  },
  "shadows.base": {
    value: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    variable: "var(--ikp-shadows-base)"
  },
  "shadows.md": {
    value: "var(--ikp-shadows-md)",
    variable: "var(--ikp-shadows-md)"
  },
  "shadows.lg": {
    value: "var(--ikp-shadows-lg)",
    variable: "var(--ikp-shadows-lg)"
  },
  "shadows.xl": {
    value: "var(--ikp-shadows-xl)",
    variable: "var(--ikp-shadows-xl)"
  },
  "shadows.2xl": {
    value: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    variable: "var(--ikp-shadows-2xl)"
  },
  "shadows.inner": {
    value: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
    variable: "var(--ikp-shadows-inner)"
  },
  "shadows.none": {
    value: "none",
    variable: "var(--ikp-shadows-none)"
  },
  "shadows.dark-lg": {
    value: "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px",
    variable: "var(--ikp-shadows-dark-lg)"
  },
  "shadows.outline": {
    value: "var(--ikp-shadows-outline)",
    variable: "var(--ikp-shadows-outline)"
  },
  "shadows.boxShadow": {
    value: "none",
    variable: "var(--ikp-shadows-box-shadow)"
  },
  "shadows.tooltipShadow": {
    value: "0 8px 30px rgba(0, 0, 0, 0.12)",
    variable: "var(--ikp-shadows-tooltip-shadow)"
  },
  "breakpoints.md": {
    value: "768px",
    variable: "var(--ikp-breakpoints-md)"
  },
  "breakpoints.lg": {
    value: "1024px",
    variable: "var(--ikp-breakpoints-lg)"
  },
  "breakpoints.xl": {
    value: "1280px",
    variable: "var(--ikp-breakpoints-xl)"
  },
  "breakpoints.2xl": {
    value: "1536px",
    variable: "var(--ikp-breakpoints-2xl)"
  },
  "breakpoints.sm": {
    value: "33em",
    variable: "var(--ikp-breakpoints-sm)"
  },
  "shadows.accent": {
    value: "var(--ikp-shadows-accent)",
    variable: "var(--ikp-shadows-accent)"
  },
  "colors.chakra-body-text": {
    value: "var(--ikp-colors-chakra-body-text)",
    variable: "var(--ikp-colors-chakra-body-text)"
  },
  "colors.chakra-body-bg": {
    value: "var(--ikp-colors-chakra-body-bg)",
    variable: "var(--ikp-colors-chakra-body-bg)"
  },
  "colors.chakra-border-color": {
    value: "var(--ikp-colors-chakra-border-color)",
    variable: "var(--ikp-colors-chakra-border-color)"
  },
  "colors.chakra-inverse-text": {
    value: "var(--ikp-colors-chakra-inverse-text)",
    variable: "var(--ikp-colors-chakra-inverse-text)"
  },
  "colors.chakra-subtle-bg": {
    value: "var(--ikp-colors-chakra-subtle-bg)",
    variable: "var(--ikp-colors-chakra-subtle-bg)"
  },
  "colors.chakra-subtle-text": {
    value: "var(--ikp-colors-chakra-subtle-text)",
    variable: "var(--ikp-colors-chakra-subtle-text)"
  },
  "colors.chakra-placeholder-color": {
    value: "var(--ikp-colors-chakra-placeholder-color)",
    variable: "var(--ikp-colors-chakra-placeholder-color)"
  },
  "colors.background": {
    value: "var(--ikp-colors-background)",
    variable: "var(--ikp-colors-background)"
  },
  "colors.foreground": {
    value: "var(--ikp-colors-foreground)",
    variable: "var(--ikp-colors-foreground)"
  },
  "colors.bg.canvas": {
    value: "var(--ikp-colors-bg-canvas)",
    variable: "var(--ikp-colors-bg-canvas)"
  },
  "colors.bg.default": {
    value: "var(--ikp-colors-bg-default)",
    variable: "var(--ikp-colors-bg-default)"
  },
  "colors.bg.subtle": {
    value: "var(--ikp-colors-bg-subtle)",
    variable: "var(--ikp-colors-bg-subtle)"
  },
  "colors.bg.muted": {
    value: "var(--ikp-colors-bg-muted)",
    variable: "var(--ikp-colors-bg-muted)"
  },
  "colors.bg.emphasized": {
    value: "var(--ikp-colors-bg-emphasized)",
    variable: "var(--ikp-colors-bg-emphasized)"
  },
  "colors.bg.disabled": {
    value: "var(--ikp-colors-bg-disabled)",
    variable: "var(--ikp-colors-bg-disabled)"
  },
  "colors.fg.default": {
    value: "var(--ikp-colors-fg-default)",
    variable: "var(--ikp-colors-fg-default)"
  },
  "colors.fg.emphasized": {
    value: "var(--ikp-colors-fg-emphasized)",
    variable: "var(--ikp-colors-fg-emphasized)"
  },
  "colors.fg.muted": {
    value: "var(--ikp-colors-fg-muted)",
    variable: "var(--ikp-colors-fg-muted)"
  },
  "colors.fg.subtle": {
    value: "var(--ikp-colors-fg-subtle)",
    variable: "var(--ikp-colors-fg-subtle)"
  },
  "colors.fg.disabled": {
    value: "var(--ikp-colors-fg-disabled)",
    variable: "var(--ikp-colors-fg-disabled)"
  },
  "colors.accent.default": {
    value: "var(--ikp-colors-accent-default)",
    variable: "var(--ikp-colors-accent-default)"
  },
  "colors.accent.emphasized": {
    value: "var(--ikp-colors-accent-emphasized)",
    variable: "var(--ikp-colors-accent-emphasized)"
  },
  "colors.accent.fg": {
    value: "var(--ikp-colors-accent-fg)",
    variable: "var(--ikp-colors-accent-fg)"
  },
  "colors.border.default": {
    value: "var(--ikp-colors-border-default)",
    variable: "var(--ikp-colors-border-default)"
  },
  "colors.border.emphasized": {
    value: "var(--ikp-colors-border-emphasized)",
    variable: "var(--ikp-colors-border-emphasized)"
  },
  "colors.border.outline": {
    value: "var(--ikp-colors-border-outline)",
    variable: "var(--ikp-colors-border-outline)"
  },
  "colors.border.accent": {
    value: "var(--ikp-colors-border-accent)",
    variable: "var(--ikp-colors-border-accent)"
  },
  "colors.border.disabled": {
    value: "var(--ikp-colors-border-disabled)",
    variable: "var(--ikp-colors-border-disabled)"
  },
  "colors.inkeepPrimary.hitContentPreview": {
    value: "var(--ikp-colors-inkeep-primary-hit-content-preview)",
    variable: "var(--ikp-colors-inkeep-primary-hit-content-preview)"
  },
  "colors.inkeepPrimary.hitContentPreviewHover": {
    value: "var(--ikp-colors-inkeep-primary-hit-content-preview-hover)",
    variable: "var(--ikp-colors-inkeep-primary-hit-content-preview-hover)"
  },
  "colors.inkeepPrimary.textBold": {
    value: "var(--ikp-colors-inkeep-primary-text-bold)",
    variable: "var(--ikp-colors-inkeep-primary-text-bold)"
  },
  "colors.inkeepPrimary.textSubtle": {
    value: "var(--ikp-colors-inkeep-primary-text-subtle)",
    variable: "var(--ikp-colors-inkeep-primary-text-subtle)"
  },
  "colors.inkeepPrimary.lighter": {
    value: "var(--ikp-colors-inkeep-primary-lighter)",
    variable: "var(--ikp-colors-inkeep-primary-lighter)"
  },
  "colors.inkeepPrimary.light": {
    value: "var(--ikp-colors-inkeep-primary-light)",
    variable: "var(--ikp-colors-inkeep-primary-light)"
  },
  "colors.inkeepPrimary.lightSubtle": {
    value: "var(--ikp-colors-inkeep-primary-light-subtle)",
    variable: "var(--ikp-colors-inkeep-primary-light-subtle)"
  },
  "colors.inkeepPrimary.medium": {
    value: "var(--ikp-colors-inkeep-primary-medium)",
    variable: "var(--ikp-colors-inkeep-primary-medium)"
  },
  "colors.inkeepPrimary.mediumSubtle": {
    value: "var(--ikp-colors-inkeep-primary-medium-subtle)",
    variable: "var(--ikp-colors-inkeep-primary-medium-subtle)"
  },
  "colors.inkeepPrimary.strong": {
    value: "var(--ikp-colors-inkeep-primary-strong)",
    variable: "var(--ikp-colors-inkeep-primary-strong)"
  },
  "colors.inkeepPrimary.stronger": {
    value: "var(--ikp-colors-inkeep-primary-stronger)",
    variable: "var(--ikp-colors-inkeep-primary-stronger)"
  },
  "colors.inkeepPrimary.textColorOnPrimary": {
    value: "var(--ikp-colors-inkeep-primary-text-color-on-primary)",
    variable: "var(--ikp-colors-inkeep-primary-text-color-on-primary)"
  },
  "colors.inkeepExpandedPrimary.50": {
    value: "var(--ikp-colors-inkeep-expanded-primary-50)",
    variable: "var(--ikp-colors-inkeep-expanded-primary-50)"
  },
  "colors.inkeepExpandedPrimary.100": {
    value: "var(--ikp-colors-inkeep-expanded-primary-100)",
    variable: "var(--ikp-colors-inkeep-expanded-primary-100)"
  },
  "colors.inkeepExpandedPrimary.200": {
    value: "var(--ikp-colors-inkeep-expanded-primary-200)",
    variable: "var(--ikp-colors-inkeep-expanded-primary-200)"
  },
  "colors.inkeepExpandedPrimary.300": {
    value: "var(--ikp-colors-inkeep-expanded-primary-300)",
    variable: "var(--ikp-colors-inkeep-expanded-primary-300)"
  },
  "colors.inkeepExpandedPrimary.400": {
    value: "var(--ikp-colors-inkeep-expanded-primary-400)",
    variable: "var(--ikp-colors-inkeep-expanded-primary-400)"
  },
  "colors.inkeepExpandedPrimary.500": {
    value: "var(--ikp-colors-inkeep-expanded-primary-500)",
    variable: "var(--ikp-colors-inkeep-expanded-primary-500)"
  },
  "colors.inkeepExpandedPrimary.600": {
    value: "var(--ikp-colors-inkeep-expanded-primary-600)",
    variable: "var(--ikp-colors-inkeep-expanded-primary-600)"
  },
  "colors.inkeepExpandedPrimary.700": {
    value: "var(--ikp-colors-inkeep-expanded-primary-700)",
    variable: "var(--ikp-colors-inkeep-expanded-primary-700)"
  },
  "colors.inkeepExpandedPrimary.800": {
    value: "var(--ikp-colors-inkeep-expanded-primary-800)",
    variable: "var(--ikp-colors-inkeep-expanded-primary-800)"
  },
  "colors.inkeepExpandedPrimary.900": {
    value: "var(--ikp-colors-inkeep-expanded-primary-900)",
    variable: "var(--ikp-colors-inkeep-expanded-primary-900)"
  },
  "spacing.-1": {
    value: "calc(var(--ikp-spacing-1) * -1)",
    variable: "var(--ikp-spacing-1)"
  },
  "spacing.-2": {
    value: "calc(var(--ikp-spacing-2) * -1)",
    variable: "var(--ikp-spacing-2)"
  },
  "spacing.-3": {
    value: "calc(var(--ikp-spacing-3) * -1)",
    variable: "var(--ikp-spacing-3)"
  },
  "spacing.-4": {
    value: "calc(var(--ikp-spacing-4) * -1)",
    variable: "var(--ikp-spacing-4)"
  },
  "spacing.-5": {
    value: "calc(var(--ikp-spacing-5) * -1)",
    variable: "var(--ikp-spacing-5)"
  },
  "spacing.-6": {
    value: "calc(var(--ikp-spacing-6) * -1)",
    variable: "var(--ikp-spacing-6)"
  },
  "spacing.-7": {
    value: "calc(var(--ikp-spacing-7) * -1)",
    variable: "var(--ikp-spacing-7)"
  },
  "spacing.-8": {
    value: "calc(var(--ikp-spacing-8) * -1)",
    variable: "var(--ikp-spacing-8)"
  },
  "spacing.-9": {
    value: "calc(var(--ikp-spacing-9) * -1)",
    variable: "var(--ikp-spacing-9)"
  },
  "spacing.-10": {
    value: "calc(var(--ikp-spacing-10) * -1)",
    variable: "var(--ikp-spacing-10)"
  },
  "spacing.-11": {
    value: "calc(var(--ikp-spacing-11) * -1)",
    variable: "var(--ikp-spacing-11)"
  },
  "spacing.-12": {
    value: "calc(var(--ikp-spacing-12) * -1)",
    variable: "var(--ikp-spacing-12)"
  },
  "spacing.-14": {
    value: "calc(var(--ikp-spacing-14) * -1)",
    variable: "var(--ikp-spacing-14)"
  },
  "spacing.-16": {
    value: "calc(var(--ikp-spacing-16) * -1)",
    variable: "var(--ikp-spacing-16)"
  },
  "spacing.-20": {
    value: "calc(var(--ikp-spacing-20) * -1)",
    variable: "var(--ikp-spacing-20)"
  },
  "spacing.-24": {
    value: "calc(var(--ikp-spacing-24) * -1)",
    variable: "var(--ikp-spacing-24)"
  },
  "spacing.-28": {
    value: "calc(var(--ikp-spacing-28) * -1)",
    variable: "var(--ikp-spacing-28)"
  },
  "spacing.-32": {
    value: "calc(var(--ikp-spacing-32) * -1)",
    variable: "var(--ikp-spacing-32)"
  },
  "spacing.-36": {
    value: "calc(var(--ikp-spacing-36) * -1)",
    variable: "var(--ikp-spacing-36)"
  },
  "spacing.-40": {
    value: "calc(var(--ikp-spacing-40) * -1)",
    variable: "var(--ikp-spacing-40)"
  },
  "spacing.-44": {
    value: "calc(var(--ikp-spacing-44) * -1)",
    variable: "var(--ikp-spacing-44)"
  },
  "spacing.-48": {
    value: "calc(var(--ikp-spacing-48) * -1)",
    variable: "var(--ikp-spacing-48)"
  },
  "spacing.-52": {
    value: "calc(var(--ikp-spacing-52) * -1)",
    variable: "var(--ikp-spacing-52)"
  },
  "spacing.-56": {
    value: "calc(var(--ikp-spacing-56) * -1)",
    variable: "var(--ikp-spacing-56)"
  },
  "spacing.-60": {
    value: "calc(var(--ikp-spacing-60) * -1)",
    variable: "var(--ikp-spacing-60)"
  },
  "spacing.-64": {
    value: "calc(var(--ikp-spacing-64) * -1)",
    variable: "var(--ikp-spacing-64)"
  },
  "spacing.-72": {
    value: "calc(var(--ikp-spacing-72) * -1)",
    variable: "var(--ikp-spacing-72)"
  },
  "spacing.-80": {
    value: "calc(var(--ikp-spacing-80) * -1)",
    variable: "var(--ikp-spacing-80)"
  },
  "spacing.-96": {
    value: "calc(var(--ikp-spacing-96) * -1)",
    variable: "var(--ikp-spacing-96)"
  },
  "spacing.-0.5": {
    value: "calc(var(--ikp-spacing-0\\.5) * -1)",
    variable: "var(--ikp-spacing-0\\.5)"
  },
  "spacing.-1.5": {
    value: "calc(var(--ikp-spacing-1\\.5) * -1)",
    variable: "var(--ikp-spacing-1\\.5)"
  },
  "spacing.-2.5": {
    value: "calc(var(--ikp-spacing-2\\.5) * -1)",
    variable: "var(--ikp-spacing-2\\.5)"
  },
  "spacing.-3.5": {
    value: "calc(var(--ikp-spacing-3\\.5) * -1)",
    variable: "var(--ikp-spacing-3\\.5)"
  },
  "colors.colorPalette.50": {
    value: "var(--ikp-colors-color-palette-50)",
    variable: "var(--ikp-colors-color-palette-50)"
  },
  "colors.colorPalette.100": {
    value: "var(--ikp-colors-color-palette-100)",
    variable: "var(--ikp-colors-color-palette-100)"
  },
  "colors.colorPalette.200": {
    value: "var(--ikp-colors-color-palette-200)",
    variable: "var(--ikp-colors-color-palette-200)"
  },
  "colors.colorPalette.300": {
    value: "var(--ikp-colors-color-palette-300)",
    variable: "var(--ikp-colors-color-palette-300)"
  },
  "colors.colorPalette.400": {
    value: "var(--ikp-colors-color-palette-400)",
    variable: "var(--ikp-colors-color-palette-400)"
  },
  "colors.colorPalette.500": {
    value: "var(--ikp-colors-color-palette-500)",
    variable: "var(--ikp-colors-color-palette-500)"
  },
  "colors.colorPalette.600": {
    value: "var(--ikp-colors-color-palette-600)",
    variable: "var(--ikp-colors-color-palette-600)"
  },
  "colors.colorPalette.700": {
    value: "var(--ikp-colors-color-palette-700)",
    variable: "var(--ikp-colors-color-palette-700)"
  },
  "colors.colorPalette.800": {
    value: "var(--ikp-colors-color-palette-800)",
    variable: "var(--ikp-colors-color-palette-800)"
  },
  "colors.colorPalette.900": {
    value: "var(--ikp-colors-color-palette-900)",
    variable: "var(--ikp-colors-color-palette-900)"
  },
  "colors.colorPalette.950": {
    value: "var(--ikp-colors-color-palette-950)",
    variable: "var(--ikp-colors-color-palette-950)"
  },
  "colors.colorPalette": {
    value: "var(--ikp-colors-color-palette)",
    variable: "var(--ikp-colors-color-palette)"
  },
  "colors.colorPalette.canvas": {
    value: "var(--ikp-colors-color-palette-canvas)",
    variable: "var(--ikp-colors-color-palette-canvas)"
  },
  "colors.colorPalette.default": {
    value: "var(--ikp-colors-color-palette-default)",
    variable: "var(--ikp-colors-color-palette-default)"
  },
  "colors.colorPalette.subtle": {
    value: "var(--ikp-colors-color-palette-subtle)",
    variable: "var(--ikp-colors-color-palette-subtle)"
  },
  "colors.colorPalette.muted": {
    value: "var(--ikp-colors-color-palette-muted)",
    variable: "var(--ikp-colors-color-palette-muted)"
  },
  "colors.colorPalette.emphasized": {
    value: "var(--ikp-colors-color-palette-emphasized)",
    variable: "var(--ikp-colors-color-palette-emphasized)"
  },
  "colors.colorPalette.disabled": {
    value: "var(--ikp-colors-color-palette-disabled)",
    variable: "var(--ikp-colors-color-palette-disabled)"
  },
  "colors.colorPalette.fg": {
    value: "var(--ikp-colors-color-palette-fg)",
    variable: "var(--ikp-colors-color-palette-fg)"
  },
  "colors.colorPalette.outline": {
    value: "var(--ikp-colors-color-palette-outline)",
    variable: "var(--ikp-colors-color-palette-outline)"
  },
  "colors.colorPalette.accent": {
    value: "var(--ikp-colors-color-palette-accent)",
    variable: "var(--ikp-colors-color-palette-accent)"
  },
  "colors.colorPalette.hitContentPreview": {
    value: "var(--ikp-colors-color-palette-hit-content-preview)",
    variable: "var(--ikp-colors-color-palette-hit-content-preview)"
  },
  "colors.colorPalette.hitContentPreviewHover": {
    value: "var(--ikp-colors-color-palette-hit-content-preview-hover)",
    variable: "var(--ikp-colors-color-palette-hit-content-preview-hover)"
  },
  "colors.colorPalette.textBold": {
    value: "var(--ikp-colors-color-palette-text-bold)",
    variable: "var(--ikp-colors-color-palette-text-bold)"
  },
  "colors.colorPalette.textSubtle": {
    value: "var(--ikp-colors-color-palette-text-subtle)",
    variable: "var(--ikp-colors-color-palette-text-subtle)"
  },
  "colors.colorPalette.lighter": {
    value: "var(--ikp-colors-color-palette-lighter)",
    variable: "var(--ikp-colors-color-palette-lighter)"
  },
  "colors.colorPalette.light": {
    value: "var(--ikp-colors-color-palette-light)",
    variable: "var(--ikp-colors-color-palette-light)"
  },
  "colors.colorPalette.lightSubtle": {
    value: "var(--ikp-colors-color-palette-light-subtle)",
    variable: "var(--ikp-colors-color-palette-light-subtle)"
  },
  "colors.colorPalette.medium": {
    value: "var(--ikp-colors-color-palette-medium)",
    variable: "var(--ikp-colors-color-palette-medium)"
  },
  "colors.colorPalette.mediumSubtle": {
    value: "var(--ikp-colors-color-palette-medium-subtle)",
    variable: "var(--ikp-colors-color-palette-medium-subtle)"
  },
  "colors.colorPalette.strong": {
    value: "var(--ikp-colors-color-palette-strong)",
    variable: "var(--ikp-colors-color-palette-strong)"
  },
  "colors.colorPalette.stronger": {
    value: "var(--ikp-colors-color-palette-stronger)",
    variable: "var(--ikp-colors-color-palette-stronger)"
  },
  "colors.colorPalette.textColorOnPrimary": {
    value: "var(--ikp-colors-color-palette-text-color-on-primary)",
    variable: "var(--ikp-colors-color-palette-text-color-on-primary)"
  }
};
function Nr(e, t) {
  var r;
  return ((r = T8[e]) == null ? void 0 : r.value) || t;
}
function uR(e, t) {
  var r;
  return ((r = T8[e]) == null ? void 0 : r.variable) || t;
}
Nr.var = uR;
const K5 = (...e) => e.filter(Boolean).join(" "), Nn = (e) => {
  const t = kn(null);
  return {
    withProvider: (n, a, o) => {
      const s = Je(
        (l, u) => {
          const [d, c] = e.splitVariantProps(
            l
          ), { className: p = "", ...f } = c, g = e(d), k = g == null ? void 0 : g[a ?? ""], y = K5(o == null ? void 0 : o.className, k, p);
          return /* @__PURE__ */ v.jsx(t.Provider, { value: g, children: /* @__PURE__ */ v.jsx(
            n,
            {
              ref: u,
              ...o,
              className: y,
              ...f
            }
          ) });
        }
      );
      return s.displayName = n.displayName || n.name, s;
    },
    withContext: (n, a, o) => {
      if (!a)
        return n;
      const s = Je(
        ({ className: l, ...u }, d) => {
          const c = Pn(t), p = c == null ? void 0 : c[a ?? ""], f = K5(o == null ? void 0 : o.className, p, l);
          return /* @__PURE__ */ v.jsx(
            n,
            {
              ref: d,
              ...o,
              className: f,
              ...u
            }
          );
        }
      );
      return s.displayName = n.displayName || n.name, s;
    }
  };
};
function cR(e, t) {
  return `${e} returned \`undefined\`. Seems you forgot to wrap component within ${t}`;
}
function nm(e = {}) {
  const {
    name: t,
    strict: r = !0,
    hookName: i = "useContext",
    providerName: n = "Provider",
    errorMessage: a,
    defaultValue: o
  } = e, s = kn(o);
  s.displayName = t;
  function l() {
    var d;
    const u = Pn(s);
    if (!u && r) {
      const c = new Error(
        a ?? cR(i, n)
      );
      throw c.name = "ContextError", (d = Error.captureStackTrace) == null || d.call(Error, c, l), c;
    }
    return u;
  }
  return [s.Provider, l, s];
}
const _i = (e, t) => Je((r, i) => {
  var s;
  const n = (s = pR()) == null ? void 0 : s[t], a = Eo(r == null ? void 0 : r.className, n == null ? void 0 : n.className), o = Object.assign({}, r == null ? void 0 : r.style, n == null ? void 0 : n.style);
  return xa(e, {
    ref: i,
    ...Object.assign({}, r, n == null ? void 0 : n.defaultProps),
    className: a,
    style: o
  });
}), [dR, pR] = nm({
  strict: !1,
  name: "ThemeProps"
}), { withProvider: hR, withContext: fR } = Nn(pI), Y5 = _i(
  hR(Te("div"), "container"),
  "Alert"
), J_ = fR(Te("div"), "icon");
function gR({ css: e, ...t }) {
  return /* @__PURE__ */ v.jsx(J_, { children: /* @__PURE__ */ v.jsx(
    "svg",
    {
      ...t,
      className: yo({ h: "100%", w: "100%" }, e),
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ v.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
        }
      )
    }
  ) });
}
function mR({ css: e, ...t }) {
  return /* @__PURE__ */ v.jsx(J_, { children: /* @__PURE__ */ v.jsx(
    "svg",
    {
      ...t,
      className: yo({ h: "100%", w: "100%" }, e),
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ v.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
        }
      )
    }
  ) });
}
function q5({ css: e, ...t }) {
  return /* @__PURE__ */ v.jsx(J_, { children: /* @__PURE__ */ v.jsx(
    "svg",
    {
      ...t,
      className: yo({ h: "100%", w: "100%" }, e),
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ v.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
        }
      )
    }
  ) });
}
const Q5 = Object.assign(Y5, {
  Root: Y5,
  // https://github.com/chakra-ui/chakra-ui/blob/f4b1ad66be1ada4b2728faef4c68a82a76f02532/packages/components/src/alert/alert-context.ts#L20
  InfoIcon: mR,
  WarningIcon: q5,
  SuccessIcon: gR,
  ErrorIcon: q5
}), vR = Symbol(), e2 = Symbol(), h0 = "a", Mf = "w";
let kR = (e, t) => new Proxy(e, t);
const Fb = Object.getPrototypeOf, Tb = /* @__PURE__ */ new WeakMap(), S8 = (e) => e && (Tb.has(e) ? Tb.get(e) : Fb(e) === Object.prototype || Fb(e) === Array.prototype), X5 = (e) => typeof e == "object" && e !== null, bR = (e) => {
  if (Array.isArray(e))
    return Array.from(e);
  const t = Object.getOwnPropertyDescriptors(e);
  return Object.values(t).forEach((r) => {
    r.configurable = !0;
  }), Object.create(Fb(e), t);
}, I8 = (e) => e[e2] || e, B8 = (e, t, r, i) => {
  if (!S8(e))
    return e;
  let n = i && i.get(e);
  if (!n) {
    const l = I8(e);
    n = ((u) => Object.values(Object.getOwnPropertyDescriptors(u)).some((d) => !d.configurable && !d.writable))(l) ? [l, bR(l)] : [l], i == null || i.set(e, n);
  }
  const [a, o] = n;
  let s = r && r.get(a);
  return s && s[1].f === !!o || (s = ((l, u) => {
    const d = { f: u };
    let c = !1;
    const p = (g, k) => {
      if (!c) {
        let y = d[h0].get(l);
        if (y || (y = {}, d[h0].set(l, y)), g === Mf)
          y[Mf] = !0;
        else {
          let _ = y[g];
          _ || (_ = /* @__PURE__ */ new Set(), y[g] = _), _.add(k);
        }
      }
    }, f = { get: (g, k) => k === e2 ? l : (p("k", k), B8(Reflect.get(g, k), d[h0], d.c, d.t)), has: (g, k) => k === vR ? (c = !0, d[h0].delete(l), !0) : (p("h", k), Reflect.has(g, k)), getOwnPropertyDescriptor: (g, k) => (p("o", k), Reflect.getOwnPropertyDescriptor(g, k)), ownKeys: (g) => (p(Mf), Reflect.ownKeys(g)) };
    return u && (f.set = f.deleteProperty = () => !1), [f, d];
  })(a, !!o), s[1].p = kR(o || a, s[0]), r && r.set(a, s)), s[1][h0] = t, s[1].c = r, s[1].t = i, s[1].p;
}, R8 = (e, t, r, i) => {
  if (Object.is(e, t))
    return !1;
  if (!X5(e) || !X5(t))
    return !0;
  const n = r.get(I8(e));
  if (!n)
    return !0;
  if (i) {
    const o = i.get(e);
    if (o && o.n === t)
      return o.g;
    i.set(e, { n: t, g: !1 });
  }
  let a = null;
  try {
    for (const o of n.h || [])
      if (a = Reflect.has(e, o) !== Reflect.has(t, o), a)
        return a;
    if (n[Mf] === !0) {
      if (a = ((o, s) => {
        const l = Reflect.ownKeys(o), u = Reflect.ownKeys(s);
        return l.length !== u.length || l.some((d, c) => d !== u[c]);
      })(e, t), a)
        return a;
    } else
      for (const o of n.o || [])
        if (a = !!Reflect.getOwnPropertyDescriptor(e, o) != !!Reflect.getOwnPropertyDescriptor(t, o), a)
          return a;
    for (const o of n.k || [])
      if (a = R8(e[o], t[o], r, i), a)
        return a;
    return a === null && (a = !0), a;
  } finally {
    i && i.set(e, { n: t, g: a });
  }
}, O8 = (e) => S8(e) && e[e2] || null, lg = (e, t = !0) => {
  Tb.set(e, t);
};
var ug = process.env.NODE_ENV !== "production", Qv = (e) => typeof e == "object" && e !== null, Lu = /* @__PURE__ */ new WeakMap(), M0 = /* @__PURE__ */ new WeakSet(), _R = (e = Object.is, t = (u, d) => new Proxy(u, d), r = (u) => Qv(u) && !M0.has(u) && (Array.isArray(u) || !(Symbol.iterator in u)) && !(u instanceof WeakMap) && !(u instanceof WeakSet) && !(u instanceof Error) && !(u instanceof Number) && !(u instanceof Date) && !(u instanceof String) && !(u instanceof RegExp) && !(u instanceof ArrayBuffer), i = (u) => {
  switch (u.status) {
    case "fulfilled":
      return u.value;
    case "rejected":
      throw u.reason;
    default:
      throw u;
  }
}, n = /* @__PURE__ */ new WeakMap(), a = (u, d, c = i) => {
  const p = n.get(u);
  if ((p == null ? void 0 : p[0]) === d)
    return p[1];
  const f = Array.isArray(u) ? [] : Object.create(Object.getPrototypeOf(u));
  return lg(f, !0), n.set(u, [d, f]), Reflect.ownKeys(u).forEach((g) => {
    const k = Reflect.get(u, g);
    M0.has(k) ? (lg(k, !1), f[g] = k) : k instanceof Promise ? Object.defineProperty(f, g, {
      get() {
        return c(k);
      }
    }) : Lu.has(k) ? f[g] = Sl(k, c) : f[g] = k;
  }), Object.freeze(f);
}, o = /* @__PURE__ */ new WeakMap(), s = [1, 1], l = (u) => {
  if (!Qv(u))
    throw new Error("object required");
  const d = o.get(u);
  if (d)
    return d;
  let c = s[0];
  const p = /* @__PURE__ */ new Set(), f = (U, K = ++s[0]) => {
    c !== K && (c = K, p.forEach((z) => z(U, K)));
  };
  let g = s[1];
  const k = (U = ++s[1]) => (g !== U && !p.size && (g = U, _.forEach(([K]) => {
    const z = K[1](U);
    z > c && (c = z);
  })), c), y = (U) => (K, z) => {
    const j = [...K];
    j[1] = [U, ...j[1]], f(j, z);
  }, _ = /* @__PURE__ */ new Map(), A = (U, K) => {
    if (ug && _.has(U))
      throw new Error("prop listener already exists");
    if (p.size) {
      const z = K[3](y(U));
      _.set(U, [K, z]);
    } else
      _.set(U, [K]);
  }, T = (U) => {
    var z;
    const K = _.get(U);
    K && (_.delete(U), (z = K[1]) == null || z.call(K));
  }, N = (U) => (p.add(U), p.size === 1 && _.forEach(([z, j], J) => {
    if (ug && j)
      throw new Error("remove already exists");
    const ie = z[3](y(J));
    _.set(J, [z, ie]);
  }), () => {
    p.delete(U), p.size === 0 && _.forEach(([z, j], J) => {
      j && (j(), _.set(J, [z]));
    });
  }), P = Array.isArray(u) ? [] : Object.create(Object.getPrototypeOf(u)), M = t(P, {
    deleteProperty(U, K) {
      const z = Reflect.get(U, K);
      T(K);
      const j = Reflect.deleteProperty(U, K);
      return j && f(["delete", [K], z]), j;
    },
    set(U, K, z, j) {
      var de;
      const J = Reflect.has(U, K), ie = Reflect.get(U, K, j);
      if (J && (e(ie, z) || o.has(z) && e(ie, o.get(z))))
        return !0;
      T(K), Qv(z) && (z = O8(z) || z);
      let ue = z;
      if (!((de = Object.getOwnPropertyDescriptor(U, K)) != null && de.set))
        if (z instanceof Promise)
          z.then((he) => {
            z.status = "fulfilled", z.value = he, f(["resolve", [K], he]);
          }).catch((he) => {
            z.status = "rejected", z.reason = he, f(["reject", [K], he]);
          });
        else {
          !Lu.has(z) && r(z) && (ue = am(z));
          const he = !M0.has(ue) && Lu.get(ue);
          he && A(K, he);
        }
      return Reflect.set(U, K, ue, j), f(["set", [K], z, ie]), !0;
    }
  });
  o.set(u, M);
  const X = [P, k, a, N];
  return Lu.set(M, X), Reflect.ownKeys(u).forEach((U) => {
    const K = Object.getOwnPropertyDescriptor(u, U);
    K.get || K.set ? Object.defineProperty(P, U, K) : M[U] = u[U];
  }), M;
}) => [
  // public functions
  l,
  // shared state
  Lu,
  M0,
  // internal things
  e,
  t,
  r,
  i,
  n,
  a,
  o,
  s
], [DR] = _R();
function am(e = {}) {
  return DR(e);
}
function c1(e, t, r) {
  const i = Lu.get(e);
  ug && !i && console.warn("Please use proxy object");
  let n;
  const a = [], o = i[3];
  let s = !1;
  const u = o((d) => {
    if (a.push(d), r) {
      t(a.splice(0));
      return;
    }
    n || (n = Promise.resolve().then(() => {
      n = void 0, s && t(a.splice(0));
    }));
  });
  return s = !0, () => {
    s = !1, u();
  };
}
function Sl(e, t) {
  const r = Lu.get(e);
  ug && !r && console.warn("Please use proxy object");
  const [i, n, a] = r;
  return a(i, n(), t);
}
function Kd(e) {
  return M0.add(e), e;
}
function yR(e, t) {
  Object.keys(t).forEach((n) => {
    if (Object.getOwnPropertyDescriptor(e, n))
      throw new Error("object property already defined");
    const a = t[n], { get: o, set: s } = typeof a == "function" ? { get: a } : a, l = {};
    l.get = () => o(Sl(i)), s && (l.set = (u) => s(i, u)), Object.defineProperty(e, n, l);
  });
  const i = am(e);
  return i;
}
var ER = (e, t) => Object.is(e, t);
function Z5(e, t, r, i, n) {
  let a = Reflect.get(Sl(e), t);
  const o = n || ER;
  function s() {
    const l = Sl(e);
    o(a, l[t]) || (r(l[t]), a = Reflect.get(l, t));
  }
  return c1(e, s, i);
}
function J5(e, t, r) {
  typeof r.value == "object" && (r.value = Sd(r.value)), !r.enumerable || r.get || r.set || !r.configurable || !r.writable || t === "__proto__" ? Object.defineProperty(e, t, r) : e[t] = r.value;
}
function Sd(e) {
  if (typeof e != "object")
    return e;
  var t = 0, r, i, n, a = Object.prototype.toString.call(e);
  if (a === "[object Object]" ? n = Object.create(e.__proto__ || null) : a === "[object Array]" ? n = Array(e.length) : a === "[object Set]" ? (n = /* @__PURE__ */ new Set(), e.forEach(function(o) {
    n.add(Sd(o));
  })) : a === "[object Map]" ? (n = /* @__PURE__ */ new Map(), e.forEach(function(o, s) {
    n.set(Sd(s), Sd(o));
  })) : a === "[object Date]" ? n = /* @__PURE__ */ new Date(+e) : a === "[object RegExp]" ? n = new RegExp(e.source, e.flags) : a === "[object DataView]" ? n = new e.constructor(Sd(e.buffer)) : a === "[object ArrayBuffer]" ? n = e.slice(0) : a.slice(-6) === "Array]" && (n = new e.constructor(e)), n) {
    for (i = Object.getOwnPropertySymbols(e); t < i.length; t++)
      J5(n, i[t], Object.getOwnPropertyDescriptor(e, i[t]));
    for (t = 0, i = Object.getOwnPropertyNames(e); t < i.length; t++)
      Object.hasOwnProperty.call(n, r = i[t]) && n[r] === e[r] || J5(n, r, Object.getOwnPropertyDescriptor(e, r));
  }
  return n || e;
}
var CR = Object.defineProperty, xR = (e, t, r) => t in e ? CR(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, pt = (e, t, r) => (xR(e, typeof t != "symbol" ? t + "" : t, r), r);
function AR(e) {
  for (; e.length > 0; )
    e.pop();
  return e;
}
var ey = (e, ...t) => (typeof e == "function" ? e(...t) : e) ?? void 0, Ns = (e) => e, Xv = () => {
}, wR = (...e) => (...t) => {
  e.forEach(function(r) {
    r == null || r(...t);
  });
}, ty = /* @__PURE__ */ (() => {
  let e = 0;
  return () => (e++, e.toString(36));
})(), FR = () => process.env.NODE_ENV !== "production", W0 = (e) => Array.isArray(e), G0 = (e) => !(e == null || typeof e != "object" || W0(e)), TR = (e) => typeof e == "number" && !Number.isNaN(e), fo = (e) => typeof e == "string", cg = (e) => typeof e == "function";
function dg(e) {
  if (!SR(e) || e === void 0)
    return e;
  const t = Reflect.ownKeys(e).filter((i) => typeof i == "string"), r = {};
  for (const i of t) {
    const n = e[i];
    n !== void 0 && (r[i] = dg(n));
  }
  return r;
}
var SR = (e) => e && typeof e == "object" && e.constructor === Object;
function Zv(...e) {
  const t = e.length === 1 ? e[0] : e[1];
  (e.length === 2 ? e[0] : !0) && process.env.NODE_ENV !== "production" && console.warn(t);
}
function jf(...e) {
  const t = e.length === 1 ? e[0] : e[1];
  if ((e.length === 2 ? e[0] : !0) && process.env.NODE_ENV !== "production")
    throw new Error(t);
}
function P8(e, ...t) {
  for (const r of t) {
    const i = dg(r);
    for (const n in i)
      G0(r[n]) ? (e[n] || (e[n] = {}), P8(e[n], r[n])) : e[n] = r[n];
  }
  return e;
}
function ry(e) {
  return Sd(e);
}
function qn(e) {
  return fo(e) ? { type: e } : e;
}
function fl(e) {
  return e ? W0(e) ? e.slice() : [e] : [];
}
function N8(e) {
  return G0(e) && e.predicate != null;
}
var IR = () => !0;
function t2(e, t, r, i) {
  return (n) => {
    var a;
    return fo(n) ? !!((a = e[n]) != null && a.call(e, t, r, i)) : cg(n) ? n(t, r, i) : n.predicate(e)(t, r, i);
  };
}
function BR(...e) {
  return {
    predicate: (t) => (r, i, n) => e.map(t2(t, r, i, n)).some(Boolean)
  };
}
function RR(...e) {
  return {
    predicate: (t) => (r, i, n) => e.map(t2(t, r, i, n)).every(Boolean)
  };
}
function OR(e) {
  return {
    predicate: (t) => (r, i, n) => !t2(t, r, i, n)(e)
  };
}
function PR(...e) {
  return (t, r, i) => i.state.matches(...e);
}
var rp = { or: BR, and: RR, not: OR, stateIn: PR };
function z8(e, t) {
  return e = e ?? IR, (r, i, n) => {
    if (fo(e)) {
      const a = t[e];
      return cg(a) ? a(r, i, n) : a;
    }
    return N8(e) ? e.predicate(t)(r, i, n) : e == null ? void 0 : e(r, i, n);
  };
}
function Jv(e, t) {
  return (r, i, n) => N8(e) ? e.predicate(t)(r, i, n) : e;
}
function NR(e) {
  const t = e.computed ?? Ns({}), r = e.context ?? Ns({}), i = am({
    value: e.initial ?? "",
    previousValue: "",
    event: Ns({}),
    previousEvent: Ns({}),
    context: yR(r, t),
    done: !1,
    tags: [],
    hasTag(n) {
      return this.tags.includes(n);
    },
    matches(...n) {
      return n.includes(this.value);
    },
    can(n) {
      return Ns(this).nextEvents.includes(n);
    },
    get nextEvents() {
      var o, s;
      const n = ((s = (o = e.states) == null ? void 0 : o[this.value]) == null ? void 0 : s.on) ?? {}, a = (e == null ? void 0 : e.on) ?? {};
      return Object.keys({ ...n, ...a });
    },
    get changed() {
      return this.event.value === "machine.init" || !this.previousValue ? !1 : this.value !== this.previousValue;
    }
  });
  return Ns(i);
}
function Kh(e, t) {
  return (r, i) => {
    if (TR(e))
      return e;
    if (cg(e))
      return e(r, i);
    if (fo(e)) {
      const n = Number.parseFloat(e);
      if (!Number.isNaN(n))
        return n;
      if (t) {
        const a = t == null ? void 0 : t[e];
        return jf(
          a == null,
          `[@zag-js/core > determine-delay] Cannot determine delay for \`${e}\`. It doesn't exist in \`options.delays\``
        ), cg(a) ? a(r, i) : a;
      }
    }
  };
}
function zR(e) {
  return fo(e) ? { target: e } : e;
}
function LR(e, t) {
  return (r, i, n) => fl(e).map(zR).find((a) => z8(a.guard, t)(r, i, n) ?? a.target ?? a.actions);
}
var MR = class L8 {
  // Let's get started!
  constructor(t, r) {
    var n, a, o, s, l, u;
    pt(
      this,
      "status",
      "Not Started"
      /* NotStarted */
    ), pt(this, "state"), pt(this, "initialState"), pt(this, "initialContext"), pt(this, "id"), pt(
      this,
      "type",
      "machine"
      /* Machine */
    ), pt(this, "activityEvents", /* @__PURE__ */ new Map()), pt(this, "delayedEvents", /* @__PURE__ */ new Map()), pt(this, "stateListeners", /* @__PURE__ */ new Set()), pt(this, "contextListeners", /* @__PURE__ */ new Set()), pt(this, "eventListeners", /* @__PURE__ */ new Set()), pt(this, "doneListeners", /* @__PURE__ */ new Set()), pt(this, "contextWatchers", /* @__PURE__ */ new Set()), pt(this, "removeStateListener", Xv), pt(this, "removeEventListener", Xv), pt(this, "removeContextListener", Xv), pt(this, "parent"), pt(this, "children", /* @__PURE__ */ new Map()), pt(this, "guardMap"), pt(this, "actionMap"), pt(this, "delayMap"), pt(this, "activityMap"), pt(this, "sync"), pt(this, "options"), pt(this, "config"), pt(this, "start", (d) => {
      if (this.state.value = "", this.status === "Running")
        return this;
      this.status = "Running", this.removeStateListener = c1(
        this.state,
        () => {
          this.stateListeners.forEach((y) => {
            y(this.stateSnapshot);
          });
        },
        this.sync
      ), this.removeEventListener = Z5(
        this.state,
        "event",
        (y) => {
          this.executeActions(this.config.onEvent, y), this.eventListeners.forEach((_) => {
            _(y);
          });
        },
        this.sync
      ), this.removeContextListener = c1(
        this.state.context,
        () => {
          this.log("Context:", this.contextSnapshot), this.contextListeners.forEach((y) => {
            y(this.contextSnapshot);
          });
        },
        this.sync || this.options.debug
      ), this.setupContextWatchers(), this.executeActivities(
        qn(
          "machine.start"
          /* Start */
        ),
        fl(this.config.activities),
        "machine.start"
        /* Start */
      ), this.executeActions(this.config.entry, qn(
        "machine.start"
        /* Start */
      ));
      const c = qn(
        "machine.init"
        /* Init */
      ), p = G0(d) ? d.value : d, f = G0(d) ? d.context : void 0;
      f && this.setContext(f);
      const g = {
        target: p ?? this.config.initial
      }, k = this.getNextStateInfo(g, c);
      return this.initialState = k, this.performStateChangeEffects(this.state.value, k, c), this;
    }), pt(this, "setupContextWatchers", () => {
      var d;
      for (const [c, p] of Object.entries(this.config.watch ?? {})) {
        const f = (d = this.options.compareFns) == null ? void 0 : d[c], g = Z5(
          this.state.context,
          c,
          () => {
            this.executeActions(p, this.state.event);
          },
          this.sync,
          f
        );
        this.contextWatchers.add(g);
      }
    }), pt(this, "stop", () => {
      if (this.status !== "Stopped")
        return this.performExitEffects(this.state.value, qn(
          "machine.stop"
          /* Stop */
        )), this.executeActions(this.config.exit, qn(
          "machine.stop"
          /* Stop */
        )), this.setState(""), this.setEvent(
          "machine.stop"
          /* Stop */
        ), this.stopStateListeners(), this.stopChildren(), this.stopActivities(), this.stopDelayedEvents(), this.stopContextWatchers(), this.stopEventListeners(), this.stopContextListeners(), this.status = "Stopped", this;
    }), pt(this, "stopEventListeners", () => {
      this.eventListeners.clear(), this.removeEventListener();
    }), pt(this, "stopContextListeners", () => {
      this.contextListeners.clear(), this.removeContextListener();
    }), pt(this, "stopStateListeners", () => {
      this.removeStateListener(), this.stateListeners.clear();
    }), pt(this, "stopContextWatchers", () => {
      this.contextWatchers.forEach((d) => d()), this.contextWatchers.clear();
    }), pt(this, "stopDelayedEvents", () => {
      this.delayedEvents.forEach((d) => {
        d.forEach((c) => c());
      }), this.delayedEvents.clear();
    }), pt(this, "stopActivities", (d) => {
      var c, p;
      d ? ((c = this.activityEvents.get(d)) == null || c.forEach((f) => f()), (p = this.activityEvents.get(d)) == null || p.clear(), this.activityEvents.delete(d)) : (this.activityEvents.forEach((f) => {
        f.forEach((g) => g()), f.clear();
      }), this.activityEvents.clear());
    }), pt(this, "sendChild", (d, c) => {
      const p = qn(d), f = ey(c, this.contextSnapshot), g = this.children.get(f);
      g || jf(`[@zag-js/core] Cannot send '${p.type}' event to unknown child`), g.send(p);
    }), pt(this, "stopChild", (d) => {
      this.children.has(d) || jf(`[@zag-js/core > stop-child] Cannot stop unknown child ${d}`), this.children.get(d).stop(), this.children.delete(d);
    }), pt(this, "removeChild", (d) => {
      this.children.delete(d);
    }), pt(this, "stopChildren", () => {
      this.children.forEach((d) => d.stop()), this.children.clear();
    }), pt(this, "setParent", (d) => {
      this.parent = d;
    }), pt(this, "spawn", (d, c) => {
      const p = ey(d);
      return c && (p.id = c), p.type = "machine.actor", p.setParent(this), this.children.set(p.id, Ns(p)), p.onDone(() => {
        this.removeChild(p.id);
      }).start(), Ns(Kd(p));
    }), pt(this, "stopActivity", (d) => {
      var p;
      if (!this.state.value)
        return;
      const c = this.activityEvents.get(this.state.value);
      (p = c == null ? void 0 : c.get(d)) == null || p(), c == null || c.delete(d);
    }), pt(this, "addActivityCleanup", (d, c, p) => {
      var f;
      d && (this.activityEvents.has(d) ? (f = this.activityEvents.get(d)) == null || f.set(c, p) : this.activityEvents.set(d, /* @__PURE__ */ new Map([[c, p]])));
    }), pt(this, "setState", (d) => {
      this.state.previousValue = this.state.value, this.state.value = d;
      const c = this.getStateNode(d);
      d == null ? AR(this.state.tags) : this.state.tags = fl(c == null ? void 0 : c.tags);
    }), pt(this, "transformContext", (d) => {
      var c, p;
      return (p = (c = this.options) == null ? void 0 : c.transformContext) == null || p.call(c, d), d;
    }), pt(this, "setContext", (d) => {
      d && P8(this.state.context, this.transformContext(d));
    }), pt(this, "withContext", (d) => {
      const c = this.transformContext(d), p = { ...this.config.context, ...dg(c) };
      return new L8({ ...this.config, context: p }, this.options);
    }), pt(this, "setOptions", (d) => {
      const c = dg(d);
      this.actionMap = { ...this.actionMap, ...c.actions }, this.delayMap = { ...this.delayMap, ...c.delays }, this.activityMap = { ...this.activityMap, ...c.activities }, this.guardMap = { ...this.guardMap, ...c.guards };
    }), pt(this, "getStateNode", (d) => {
      var c;
      if (d)
        return (c = this.config.states) == null ? void 0 : c[d];
    }), pt(this, "getNextStateInfo", (d, c) => {
      const p = this.determineTransition(d, c), f = !(p != null && p.target), g = (p == null ? void 0 : p.target) ?? this.state.value, k = this.state.value !== g, y = this.getStateNode(g), A = {
        reenter: !f && !k && !(p != null && p.internal),
        transition: p,
        stateNode: y,
        target: g,
        changed: k
      };
      return this.log("NextState:", `[${c.type}]`, this.state.value, "---->", A.target), A;
    }), pt(this, "getActionFromDelayedTransition", (d) => {
      const c = qn(
        "machine.after"
        /* After */
      ), f = Kh(d.delay, this.delayMap)(this.contextSnapshot, c);
      let g;
      return {
        entry: () => {
          g = globalThis.setTimeout(() => {
            const k = this.getNextStateInfo(d, c);
            this.performStateChangeEffects(this.state.value, k, c);
          }, f);
        },
        exit: () => {
          globalThis.clearTimeout(g);
        }
      };
    }), pt(this, "getDelayedEventActions", (d) => {
      const c = this.getStateNode(d), p = qn(
        "machine.after"
        /* After */
      );
      if (!c || !c.after)
        return;
      const f = [], g = [];
      if (W0(c.after)) {
        const k = this.determineTransition(c.after, p);
        if (!k)
          return;
        const y = this.getActionFromDelayedTransition(k);
        f.push(y.entry), g.push(y.exit);
      } else if (G0(c.after))
        for (const k in c.after) {
          const y = c.after[k];
          let _ = {};
          if (W0(y)) {
            const T = this.determineTransition(y, p);
            T && (_ = T);
          } else
            fo(y) ? _ = { target: y, delay: k } : _ = { ...y, delay: k };
          const A = this.getActionFromDelayedTransition(_);
          f.push(A.entry), g.push(A.exit);
        }
      return { entries: f, exits: g };
    }), pt(this, "executeActions", (d, c) => {
      var f;
      const p = Jv(d, this.guardMap)(this.contextSnapshot, c, this.guardMeta);
      for (const g of fl(p)) {
        const k = fo(g) ? (f = this.actionMap) == null ? void 0 : f[g] : g;
        Zv(
          fo(g) && !k,
          `[@zag-js/core > execute-actions] No implementation found for action: \`${g}\``
        ), k == null || k(this.state.context, c, this.meta);
      }
    }), pt(this, "executeActivities", (d, c, p) => {
      var f;
      for (const g of c) {
        const k = fo(g) ? (f = this.activityMap) == null ? void 0 : f[g] : g;
        if (!k) {
          Zv(`[@zag-js/core > execute-activity] No implementation found for activity: \`${g}\``);
          continue;
        }
        const y = k(this.state.context, d, this.meta);
        if (y) {
          const _ = fo(g) ? g : g.name || ty();
          this.addActivityCleanup(p ?? this.state.value, _, y);
        }
      }
    }), pt(this, "createEveryActivities", (d, c) => {
      if (!d)
        return;
      const p = qn(
        "machine.every"
        /* Every */
      );
      if (W0(d)) {
        const f = fl(d).find((_) => {
          const A = _.delay, N = Kh(A, this.delayMap)(this.contextSnapshot, p);
          return z8(_.guard, this.guardMap)(this.contextSnapshot, p, this.guardMeta) ?? N != null;
        });
        if (!f)
          return;
        const k = Kh(f.delay, this.delayMap)(this.contextSnapshot, p);
        c(() => {
          const _ = globalThis.setInterval(() => {
            this.executeActions(f.actions, p);
          }, k);
          return () => {
            globalThis.clearInterval(_);
          };
        });
      } else
        for (const f in d) {
          const g = d == null ? void 0 : d[f], y = Kh(f, this.delayMap)(this.contextSnapshot, p);
          c(() => {
            const A = globalThis.setInterval(() => {
              this.executeActions(g, p);
            }, y);
            return () => {
              globalThis.clearInterval(A);
            };
          });
        }
    }), pt(this, "setEvent", (d) => {
      this.state.previousEvent = this.state.event, this.state.event = Kd(qn(d));
    }), pt(this, "performExitEffects", (d, c) => {
      const p = this.state.value;
      if (p === "")
        return;
      const f = d ? this.getStateNode(d) : void 0;
      this.stopActivities(p);
      const g = Jv(f == null ? void 0 : f.exit, this.guardMap)(this.contextSnapshot, c, this.guardMeta), k = fl(g), y = this.delayedEvents.get(p);
      y && k.push(...y), this.executeActions(k, c), this.eventListeners.clear();
    }), pt(this, "performEntryEffects", (d, c) => {
      const p = this.getStateNode(d), f = fl(p == null ? void 0 : p.activities);
      this.createEveryActivities(p == null ? void 0 : p.every, (_) => {
        f.unshift(_);
      }), f.length > 0 && this.executeActivities(c, f);
      const g = Jv(p == null ? void 0 : p.entry, this.guardMap)(
        this.contextSnapshot,
        c,
        this.guardMeta
      ), k = fl(g), y = this.getDelayedEventActions(d);
      p != null && p.after && y && (this.delayedEvents.set(d, y == null ? void 0 : y.exits), k.push(...y.entries)), this.executeActions(k, c), (p == null ? void 0 : p.type) === "final" && (this.state.done = !0, this.doneListeners.forEach((_) => {
        _(this.stateSnapshot);
      }), this.stop());
    }), pt(this, "performTransitionEffects", (d, c) => {
      const p = this.determineTransition(d, c);
      this.executeActions(p == null ? void 0 : p.actions, c);
    }), pt(this, "performStateChangeEffects", (d, c, p) => {
      this.setEvent(p);
      const f = c.changed || c.reenter;
      f && this.performExitEffects(d, p), this.performTransitionEffects(c.transition, p), this.setState(c.target), f && this.performEntryEffects(c.target, p);
    }), pt(this, "determineTransition", (d, c) => {
      const p = LR(d, this.guardMap);
      return p == null ? void 0 : p(this.contextSnapshot, c, this.guardMeta);
    }), pt(this, "sendParent", (d) => {
      var p;
      this.parent || jf("[@zag-js/core > send-parent] Cannot send event to an unknown parent");
      const c = qn(d);
      (p = this.parent) == null || p.send(c);
    }), pt(this, "log", (...d) => {
      FR() && this.options.debug && console.log(...d);
    }), pt(this, "send", (d) => {
      const c = qn(d);
      this.transition(this.state.value, c);
    }), pt(this, "transition", (d, c) => {
      var y, _;
      const p = fo(d) ? this.getStateNode(d) : d == null ? void 0 : d.stateNode, f = qn(c);
      if (!p && !this.config.on) {
        const A = this.status === "Stopped" ? "[@zag-js/core > transition] Cannot transition a stopped machine" : `[@zag-js/core > transition] State does not have a definition for \`state\`: ${d}, \`event\`: ${f.type}`;
        Zv(A);
        return;
      }
      const g = ((y = p == null ? void 0 : p.on) == null ? void 0 : y[f.type]) ?? ((_ = this.config.on) == null ? void 0 : _[f.type]), k = this.getNextStateInfo(g, f);
      return this.performStateChangeEffects(this.state.value, k, f), k.stateNode;
    }), pt(this, "subscribe", (d) => (this.stateListeners.add(d), this.status === "Running" && d(this.stateSnapshot), () => {
      this.stateListeners.delete(d);
    })), pt(this, "onDone", (d) => (this.doneListeners.add(d), this)), pt(this, "onTransition", (d) => (this.stateListeners.add(d), this.status === "Running" && d(this.stateSnapshot), this)), pt(this, "onChange", (d) => (this.contextListeners.add(d), this)), pt(this, "onEvent", (d) => (this.eventListeners.add(d), this)), this.config = ry(t), this.options = ry(r ?? {}), this.id = this.config.id ?? `machine-${ty()}`, this.guardMap = ((n = this.options) == null ? void 0 : n.guards) ?? {}, this.actionMap = ((a = this.options) == null ? void 0 : a.actions) ?? {}, this.delayMap = ((o = this.options) == null ? void 0 : o.delays) ?? {}, this.activityMap = ((s = this.options) == null ? void 0 : s.activities) ?? {}, this.sync = ((l = this.options) == null ? void 0 : l.sync) ?? !1, this.state = NR(this.config), this.initialContext = Sl(this.state.context), this.transformContext(this.state.context);
    const i = qn(
      "machine.created"
      /* Created */
    );
    this.executeActions((u = this.config) == null ? void 0 : u.created, i);
  }
  // immutable state value
  get stateSnapshot() {
    return Ns(Sl(this.state));
  }
  getState() {
    return this.stateSnapshot;
  }
  // immutable context value
  get contextSnapshot() {
    return this.stateSnapshot.context;
  }
  /**
   * A reference to the instance methods of the machine.
   * Useful when spawning child machines and managing the communication between them.
   */
  get self() {
    const t = this;
    return {
      id: this.id,
      send: this.send.bind(this),
      sendParent: this.sendParent.bind(this),
      sendChild: this.sendChild.bind(this),
      stop: this.stop.bind(this),
      stopChild: this.stopChild.bind(this),
      spawn: this.spawn.bind(this),
      stopActivity: this.stopActivity.bind(this),
      get state() {
        return t.stateSnapshot;
      },
      get initialContext() {
        return t.initialContext;
      },
      get initialState() {
        var r;
        return ((r = t.initialState) == null ? void 0 : r.target) ?? "";
      }
    };
  }
  get meta() {
    var t;
    return {
      state: this.stateSnapshot,
      guards: this.guardMap,
      send: this.send.bind(this),
      self: this.self,
      initialContext: this.initialContext,
      initialState: ((t = this.initialState) == null ? void 0 : t.target) ?? "",
      getState: () => this.stateSnapshot,
      getAction: (r) => this.actionMap[r],
      getGuard: (r) => this.guardMap[r]
    };
  }
  get guardMeta() {
    return {
      state: this.stateSnapshot
    };
  }
  get [Symbol.toStringTag]() {
    return "Machine";
  }
}, $s = (e, t) => new MR(e, t), jR = (...e) => e.map((t) => t == null ? void 0 : t.trim()).filter(Boolean).join(" "), HR = /^on[A-Z]/;
function zt(...e) {
  let t = {};
  for (let r of e) {
    for (let i in t) {
      if (HR.test(i) && typeof t[i] == "function" && typeof r[i] == "function") {
        t[i] = wR(t[i], r[i]);
        continue;
      }
      if (i === "className" || i === "class") {
        t[i] = jR(t[i], r[i]);
        continue;
      }
      if (i === "style") {
        t[i] = Object.assign({}, t[i] ?? {}, r[i] ?? {});
        continue;
      }
      t[i] = r[i] !== void 0 ? r[i] : t[i];
    }
    for (let i in r)
      t[i] === void 0 && (t[i] = r[i]);
  }
  return t;
}
function $R(e) {
  return new Proxy({}, {
    get() {
      return e;
    }
  });
}
var $l = $R((e) => e), UR = typeof document < "u" ? Xu : gt, { use: iy } = ht, VR = /* @__PURE__ */ new WeakMap();
function WR(e, t) {
  const r = t == null ? void 0 : t.sync, i = qt(), n = qt(), a = $T(
    Nt(
      (l) => {
        const u = c1(e, l, r);
        return l(), u;
      },
      [e, r]
    ),
    () => {
      const l = Sl(e, iy);
      try {
        if (i.current && n.current && !R8(i.current, l, n.current, /* @__PURE__ */ new WeakMap()))
          return i.current;
      } catch {
      }
      return l;
    },
    () => Sl(e, iy)
  ), o = /* @__PURE__ */ new WeakMap();
  gt(() => {
    i.current = a, n.current = o;
  });
  const s = Jt(() => /* @__PURE__ */ new WeakMap(), []);
  return B8(a, o, s, VR);
}
function GR(e) {
  const t = qt();
  return t.current || (t.current = { v: e() }), t.current.v;
}
function KR(e, t) {
  const { actions: r, state: i, context: n } = t ?? {}, a = GR(() => {
    const o = typeof e == "function" ? e() : e;
    return n ? o.withContext(n) : o;
  });
  return UR(() => (a.start(i), a.state.can("SETUP") && a.send("SETUP"), () => {
    a.stop();
  }), []), a.setOptions({ actions: r }), a.setContext(n), a;
}
function Us(e, t) {
  const r = KR(e, t);
  return [WR(r.state), r.send, r];
}
const oa = () => (e, t) => t.reduce(
  (r, i) => {
    const [n, a] = r, o = i;
    return a[o] !== void 0 && (n[o] = a[o]), delete a[o], [n, a];
  },
  [{}, { ...e }]
);
function YR(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function M8(...e) {
  return (t) => e.forEach((r) => YR(r, t));
}
const ek = (e) => {
  const t = Je((r, i) => {
    const { asChild: n, children: a, ...o } = r;
    if (!n)
      return /* @__PURE__ */ v.jsx(e, { ...r, ref: i });
    const s = Qx.only(a);
    return Xx(s) ? Zx(s, {
      ...zt(o, s.props),
      ref: i ? M8(i, s.ref) : s.ref
    }) : null;
  });
  return t.displayName = e.displayName || e.name, t;
}, qR = () => {
  const e = /* @__PURE__ */ new Map();
  return new Proxy(ek, {
    apply(t, r, i) {
      return ek(i[0]);
    },
    get(t, r) {
      const i = r;
      return e.has(i) || e.set(i, ek(i)), e.get(i);
    }
  });
}, St = qR();
function QR(e, t) {
  return `${e} returned \`undefined\`. Seems you forgot to wrap component within ${t}`;
}
function ns(e = {}) {
  const {
    name: t,
    strict: r = !0,
    hookName: i = "useContext",
    providerName: n = "Provider",
    errorMessage: a
  } = e, o = kn(void 0);
  o.displayName = t;
  function s() {
    var u;
    const l = Pn(o);
    if (!l && r) {
      const d = new Error(a ?? QR(i, n));
      throw d.name = "ContextError", (u = Error.captureStackTrace) == null || u.call(Error, d, s), d;
    }
    return l;
  }
  return [o.Provider, s, o];
}
const [XR, j8] = ns({
  name: "AvatarContext",
  hookName: "useAvatarContext",
  providerName: "<AvatarProvider />"
});
var _o = (e, t = []) => ({
  parts: (...r) => {
    if (ZR(t))
      return _o(e, r);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...r) => _o(e, [...t, ...r]),
  rename: (r) => _o(r, t),
  keys: () => t,
  build: () => [...new Set(t)].reduce(
    (r, i) => Object.assign(r, {
      [i]: {
        selector: [
          `&[data-scope="${cd(e)}"][data-part="${cd(i)}"]`,
          `& [data-scope="${cd(e)}"][data-part="${cd(i)}"]`
        ].join(", "),
        attrs: { "data-scope": cd(e), "data-part": cd(i) }
      }
    }),
    {}
  )
}), cd = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), ZR = (e) => e.length === 0, pr = (e) => e ? "" : void 0, JR = (e) => e ? "true" : void 0;
function Ju(e) {
  return typeof e == "object" && (e == null ? void 0 : e.nodeType) === Node.ELEMENT_NODE && typeof (e == null ? void 0 : e.nodeName) == "string";
}
function d1(e, t) {
  return !e || !t || !Ju(e) || !Ju(t) ? !1 : e === t || e.contains(t);
}
var H8 = (e) => d1(e.currentTarget, e.target), eO = (e) => e.nodeType === Node.DOCUMENT_NODE ? e : e.ownerDocument ?? document;
function Ul(e) {
  const t = {
    getRootNode: (r) => {
      var i;
      return ((i = r.getRootNode) == null ? void 0 : i.call(r)) ?? document;
    },
    getDoc: (r) => eO(t.getRootNode(r)),
    getWin: (r) => t.getDoc(r).defaultView ?? window,
    getActiveElement: (r) => t.getDoc(r).activeElement,
    getById: (r, i) => t.getRootNode(r).getElementById(i),
    setValue: (r, i) => {
      r == null || i == null || (r.value = i.toString());
    }
  };
  return { ...t, ...e };
}
var tO = (e) => e.nodeType === Node.DOCUMENT_NODE;
function r2(e) {
  return tO(e) ? e : (e == null ? void 0 : e.ownerDocument) ?? document;
}
function rO(e) {
  return (e == null ? void 0 : e.ownerDocument.defaultView) ?? window;
}
function $8(e, t) {
  return e.find((r) => r.id === t);
}
function i2(e, t) {
  const r = $8(e, t);
  return r ? e.indexOf(r) : -1;
}
function iO(e, t, r = !0) {
  let i = i2(e, t);
  return i = r ? (i + 1) % e.length : Math.min(i + 1, e.length - 1), e[i];
}
function nO(e, t, r = !0) {
  let i = i2(e, t);
  return i === -1 ? r ? e[e.length - 1] : null : (i = r ? (i - 1 + e.length) % e.length : Math.max(0, i - 1), e[i]);
}
var aO = (e) => e.dataset.valuetext ?? e.textContent ?? "", oO = (e, t) => e.toLowerCase().startsWith(t.toLowerCase()), sO = (e, t) => e.map((r, i) => e[(Math.max(t, 0) + i) % e.length]);
function lO(e, t, r) {
  const i = r ? i2(e, r) : -1;
  let n = r ? sO(e, i) : e;
  return t.length === 1 && (n = n.filter((o) => o.id !== r)), n.find((o) => oO(aO(o), t));
}
function uO(e, t) {
  const { state: r, activeId: i, key: n, timeout: a = 350 } = t, o = r.keysSoFar + n, l = o.length > 1 && Array.from(o).every((f) => f === o[0]) ? o[0] : o;
  let u = e.slice();
  const d = lO(u, l, i);
  function c() {
    clearTimeout(r.timer), r.timer = -1;
  }
  function p(f) {
    r.keysSoFar = f, c(), f !== "" && (r.timer = +setTimeout(() => {
      p(""), c();
    }, a));
  }
  return p(o), d;
}
var Sb = /* @__PURE__ */ Object.assign(uO, {
  defaultOptions: { keysSoFar: "", timer: -1 },
  isValidEvent: cO
});
function cO(e) {
  return e.key.length === 1 && !e.ctrlKey && !e.metaKey;
}
function pg(e) {
  var t;
  return ((t = e.composedPath) == null ? void 0 : t.call(e)[0]) ?? e.target;
}
function U8(e) {
  const t = e.ownerDocument.defaultView || window, { overflow: r, overflowX: i, overflowY: n } = t.getComputedStyle(e);
  return /auto|scroll|overlay|hidden/.test(r + n + i);
}
function V8(e) {
  return e.localName === "html" ? e : e.assignedSlot || e.parentElement || e.ownerDocument.documentElement;
}
function n2(e) {
  return ["html", "body", "#document"].includes(e.localName) ? e.ownerDocument.body : Ju(e) && U8(e) ? e : n2(V8(e));
}
function W8(e, t = []) {
  const r = n2(e), i = r === e.ownerDocument.body, n = r.ownerDocument.defaultView || window, a = i ? [n].concat(n.visualViewport || [], U8(r) ? r : []) : r, o = t.concat(a);
  return i ? o : o.concat(W8(V8(a)));
}
function dO(e) {
  if (e == null || !Ju(e))
    return !1;
  try {
    const t = e.ownerDocument.defaultView || window;
    return e instanceof t.HTMLInputElement && e.selectionStart != null || /(textarea|select)/.test(e.localName) || e.isContentEditable;
  } catch {
    return !1;
  }
}
var a2 = () => typeof document < "u";
function pO() {
  const e = navigator.userAgentData;
  return (e == null ? void 0 : e.platform) ?? navigator.platform;
}
var G8 = (e) => a2() && e.test(pO()), hO = (e) => a2() && e.test(navigator.vendor), fO = () => a2() && !!navigator.maxTouchPoints, gO = () => G8(/^Mac/) && !fO(), K8 = () => Y8() && hO(/apple/i), Y8 = () => G8(/mac|iphone|ipad|ipod/i), mO = () => Y8() && !gO();
function vO(e, t) {
  return Array.from((e == null ? void 0 : e.querySelectorAll(t)) ?? []);
}
function hg(e) {
  const t = /* @__PURE__ */ new Set();
  function r(i) {
    const n = globalThis.requestAnimationFrame(i);
    t.add(() => globalThis.cancelAnimationFrame(n));
  }
  return r(() => r(e)), function() {
    t.forEach((n) => n());
  };
}
function Wi(e) {
  const t = globalThis.requestAnimationFrame(e);
  return () => {
    globalThis.cancelAnimationFrame(t);
  };
}
function o2(e, t, r) {
  if (!e)
    return;
  const i = e.ownerDocument.defaultView || window, n = new i.MutationObserver((a) => {
    for (const o of a)
      o.type === "attributes" && o.attributeName && t.includes(o.attributeName) && r(o);
  });
  return n.observe(e, { attributes: !0, attributeFilter: t }), () => n.disconnect();
}
function kO(e, t) {
  if (!e)
    return;
  const r = e.ownerDocument.defaultView || window, i = new r.MutationObserver(t);
  return i.observe(e, { childList: !0, subtree: !0 }), () => i.disconnect();
}
var bO = (e) => e[0], _O = (e) => e[e.length - 1], DO = (e, t) => e.indexOf(t) !== -1, yO = (e, ...t) => e.concat(t), EO = (e, t) => CO(e, e.indexOf(t)), CO = (e, t) => (t > -1 && e.splice(t, 1), e), xO = (e, t) => DO(e, t) ? EO(e, t) : yO(e, t), Ku = (e, t) => {
  if (Object.is(e, t))
    return !0;
  if (!(e instanceof Object) || !(t instanceof Object))
    return !1;
  const r = Object.keys(e), i = r.length;
  for (let n = 0; n < i; n++)
    if (!(r[n] in t))
      return !1;
  for (let n = 0; n < i; n++)
    if (e[r[n]] !== t[r[n]])
      return !1;
  return i === Object.keys(t).length;
}, fg = (e, ...t) => (typeof e == "function" ? e(...t) : e) ?? void 0, Ib = (...e) => (...t) => {
  e.forEach(function(r) {
    r == null || r(...t);
  });
};
function as(e) {
  if (!AO(e) || e === void 0)
    return e;
  const t = Reflect.ownKeys(e).filter((i) => typeof i == "string"), r = {};
  for (const i of t) {
    const n = e[i];
    n !== void 0 && (r[i] = as(n));
  }
  return r;
}
var AO = (e) => e && typeof e == "object" && e.constructor === Object;
function wO(...e) {
  const t = e.length === 1 ? e[0] : e[1];
  (e.length === 2 ? e[0] : !0) && process.env.NODE_ENV !== "production" && console.warn(t);
}
var FO = _o("avatar").parts("root", "image", "fallback"), tk = FO.build(), Wo = Ul({
  getRootId: (e) => `avatar:${e.id}`,
  getImageId: (e) => `avatar:${e.id}:image`,
  getFallbackId: (e) => `avatar:${e.id}:fallback`,
  getRootEl: (e) => Wo.getById(e, Wo.getRootId(e)),
  getImageEl: (e) => Wo.getById(e, Wo.getImageId(e))
});
function TO(e, t, r) {
  const i = e.matches("loaded"), n = !i;
  return {
    isLoaded: i,
    showFallback: n,
    setSrc(a) {
      t({ type: "SRC.SET", src: a });
    },
    setLoaded() {
      t({ type: "IMG.LOADED", src: "api" });
    },
    setError() {
      t({ type: "IMG.ERROR", src: "api" });
    },
    rootProps: r.element({
      ...tk.root.attrs,
      id: Wo.getRootId(e.context),
      style: {
        display: "grid",
        gridTemplateRows: "1fr 1fr",
        overflow: "hidden"
      }
    }),
    imageProps: r.img({
      ...tk.image.attrs,
      id: Wo.getImageId(e.context),
      "data-state": i ? "visible" : "hidden",
      onLoad() {
        t({ type: "IMG.LOADED", src: "element" });
      },
      onError() {
        t({ type: "IMG.ERROR", src: "element" });
      },
      style: {
        gridArea: "1 / 1 / 2 / 2",
        visibility: i ? void 0 : "hidden"
      }
    }),
    fallbackProps: r.element({
      ...tk.fallback.attrs,
      id: Wo.getFallbackId(e.context),
      hidden: !n,
      "data-state": i ? "hidden" : "visible",
      style: {
        gridArea: "1 / 1 / 2 / 2"
      }
    })
  };
}
function SO(e) {
  const t = as(e);
  return $s(
    {
      id: "avatar",
      initial: "loading",
      activities: ["trackImageRemoval"],
      context: t,
      on: {
        "SRC.CHANGE": {
          target: "loading"
        },
        "IMG.UNMOUNT": {
          target: "error"
        }
      },
      states: {
        loading: {
          activities: ["trackSrcChange"],
          entry: ["checkImgStatus"],
          on: {
            "IMG.LOADED": {
              target: "loaded",
              actions: ["invokeOnLoad"]
            },
            "IMG.ERROR": {
              target: "error",
              actions: ["invokeOnError"]
            }
          }
        },
        error: {
          activities: ["trackSrcChange"],
          on: {
            "IMG.LOADED": {
              target: "loaded",
              actions: ["invokeOnLoad"]
            }
          }
        },
        loaded: {
          activities: ["trackSrcChange"],
          on: {
            "IMG.ERROR": {
              target: "error",
              actions: ["invokeOnError"]
            }
          }
        }
      }
    },
    {
      activities: {
        trackSrcChange(r, i, { send: n }) {
          const a = Wo.getImageEl(r);
          return o2(a, ["src", "srcset"], () => {
            n({ type: "SRC.CHANGE" });
          });
        },
        trackImageRemoval(r, i, { send: n }) {
          const a = Wo.getRootEl(r);
          return kO(a, (o) => {
            Array.from(o[0].removedNodes).find((u) => u.matches("[data-scope=avatar][data-part=image]")) && n({ type: "IMG.UNMOUNT" });
          });
        }
      },
      actions: {
        invokeOnLoad(r) {
          var i;
          (i = r.onLoad) == null || i.call(r);
        },
        invokeOnError(r) {
          var i;
          (i = r.onError) == null || i.call(r);
        },
        checkImgStatus(r, i, { send: n }) {
          const a = Wo.getImageEl(r);
          if (a != null && a.complete) {
            const o = a.currentSrc ? "IMG.LOADED" : "IMG.ERROR";
            n({ type: o, src: "ssr" });
          }
        }
      }
    }
  );
}
const [IO, Vl] = ns({
  name: "EnvironmentContext",
  hookName: "useEnvironmentContext",
  providerName: "<EnvironmentProvider />",
  strict: !1
}), ny = (e) => {
  const { value: t, children: r } = e, i = qt(null), n = Jt(() => () => {
    var o;
    return t ?? ((o = i.current) == null ? void 0 : o.ownerDocument) ?? document;
  }, [t]), a = !t;
  return /* @__PURE__ */ v.jsxs(IO, { value: n, children: [
    r,
    a && /* @__PURE__ */ v.jsx("span", { hidden: !0, ref: i })
  ] });
}, BO = Object.assign(ny, {
  Root: ny
}), RO = (e) => {
  const t = Vl(), r = {
    id: Co(),
    getRootNode: t,
    ...e
  }, [i, n] = Us(SO(r), { context: r });
  return TO(i, n, $l);
}, Bb = Je((e, t) => {
  const [r, i] = oa()(e, [
    "getRootNode",
    "id",
    "onError",
    "onLoad"
  ]), n = RO(r), a = zt(n.rootProps, i);
  return /* @__PURE__ */ v.jsx(XR, { value: n, children: /* @__PURE__ */ v.jsx(St.div, { ...a, ref: t }) });
});
Bb.displayName = "Avatar";
const q8 = Je((e, t) => {
  const { fallbackProps: r } = j8(), i = zt(r, e);
  return /* @__PURE__ */ v.jsx(St.span, { ...i, ref: t });
});
q8.displayName = "AvatarFallback";
const Q8 = Je((e, t) => {
  const { imageProps: r } = j8(), i = zt(r, e);
  return /* @__PURE__ */ v.jsx(St.img, { ...i, ref: t });
});
Q8.displayName = "AvatarImage";
const s2 = Object.assign(Bb, {
  Root: Bb,
  Fallback: q8,
  Image: Q8
}), { withProvider: OO, withContext: X8 } = Nn(kI), ay = _i(
  OO(
    Te(
      s2.Root
    ),
    "root"
  ),
  "Avatar"
), PO = X8(Te(s2.Fallback), "fallback"), NO = X8(Te(s2.Image), "image"), oy = Object.assign(ay, {
  Root: ay,
  Fallback: PO,
  Image: NO
}), Z8 = _i(Te("span", PI), "Badge");
var Vu = (e, t, r, i) => {
  const n = typeof e == "function" ? e() : e;
  return n == null || n.addEventListener(t, r, i), () => {
    n == null || n.removeEventListener(t, r, i);
  };
}, zO = (e) => e.button === 2 || LO() && e.ctrlKey && e.button === 0, LO = () => /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
function sy(e, t, r) {
  if (!e)
    return;
  const i = e.ownerDocument.defaultView || window, n = new i.CustomEvent(t, r);
  return e.dispatchEvent(n);
}
var MO = {
  Up: "ArrowUp",
  Down: "ArrowDown",
  Esc: "Escape",
  " ": "Space",
  ",": "Comma",
  Left: "ArrowLeft",
  Right: "ArrowRight"
}, ly = {
  ArrowLeft: "ArrowRight",
  ArrowRight: "ArrowLeft"
};
function Rb(e, t = {}) {
  const { dir: r = "ltr", orientation: i = "horizontal" } = t;
  let { key: n } = e;
  return n = MO[n] ?? n, r === "rtl" && i === "horizontal" && n in ly && (n = ly[n]), n;
}
function jO(e, t, r) {
  return {
    isPresent: e.matches("mounted", "unmountSuspended"),
    setNode(i) {
      i && t({ type: "NODE.SET", node: i });
    }
  };
}
var { and: HO, or: $O } = rp;
function f0(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function UO(e) {
  const t = e.present ? "mounted" : "unmounted";
  return $s(
    {
      initial: t,
      watch: {
        present: ["raisePresenceChange", "setPrevPresent"]
      },
      on: {
        "NODE.SET": {
          actions: ["setNode", "setStyles"]
        },
        "PRESENCE.CHANGED": [
          {
            guard: "isPresent",
            target: "mounted",
            actions: ["setPrevAnimationName"]
          },
          {
            guard: $O("isAnimationNone", "isDisplayNone"),
            target: "unmounted"
          },
          {
            guard: HO("wasPresent", "isAnimating"),
            target: "unmountSuspended"
          },
          { target: "unmounted" }
        ]
      },
      states: {
        mounted: {
          on: {
            UNMOUNT: "unmounted",
            "ANIMATION.OUT": "unmountSuspended"
          }
        },
        unmountSuspended: {
          activities: ["trackAnimationEvents"],
          on: {
            MOUNT: {
              target: "mounted",
              actions: ["setPrevAnimationName"]
            },
            "ANIMATION.END": "unmounted"
          }
        },
        unmounted: {
          entry: ["clearPrevAnimationName"],
          on: {
            MOUNT: "mounted"
          }
        }
      }
    },
    {
      guards: {
        isPresent: (r) => !!r.present,
        isAnimationNone: (r) => f0(r.styles) === "none",
        isDisplayNone: (r) => {
          var i;
          return ((i = r.styles) == null ? void 0 : i.display) === "none";
        },
        wasPresent: (r) => !!r.prevPresent,
        isAnimating: (r) => r.prevAnimationName !== f0(r.styles)
      },
      actions: {
        invokeOnExitComplete(r) {
          var i;
          (i = r.onExitComplete) == null || i.call(r);
        },
        setNode(r, i) {
          r.node = Kd(i.node);
        },
        setStyles(r, i) {
          const n = i.node.ownerDocument.defaultView || window;
          r.styles = Kd(n.getComputedStyle(i.node));
        },
        raisePresenceChange(r, i, { send: n }) {
          n("PRESENCE.CHANGED");
        },
        setPrevPresent(r) {
          r.prevPresent = r.present;
        },
        setPrevAnimationName(r) {
          requestAnimationFrame(() => {
            r.prevAnimationName = f0(r.styles);
          });
        },
        clearPrevAnimationName(r) {
          r.prevAnimationName = "";
        }
      },
      activities: {
        trackAnimationEvents(r, i, { send: n }) {
          const a = r.node;
          if (!a)
            return;
          const o = (l) => {
            l.target === a && (r.prevAnimationName = f0(r.styles));
          }, s = (l) => {
            const d = f0(r.styles).includes(l.animationName);
            l.target === a && d && n("ANIMATION.END");
          };
          return a.addEventListener("animationstart", o), a.addEventListener("animationcancel", s), a.addEventListener("animationend", s), () => {
            a.removeEventListener("animationstart", o), a.removeEventListener("animationcancel", s), a.removeEventListener("animationend", s);
          };
        }
      }
    }
  );
}
const VO = (e) => {
  const [t, r] = Us(UO(e), {
    context: e
  });
  return jO(t, r);
}, uy = (e) => {
  const [t, { children: r, lazyMount: i, unmountOnExit: n }] = oa()(e, ["present", "onExitComplete"]), a = VO(t), o = qt(!1);
  if (a.isPresent && (o.current = !0), !a.isPresent && !o.current && i || n && !a.isPresent && o.current)
    return null;
  const s = Qx.only(r);
  return Zx(s, {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ref: M8(a.setNode, s.ref),
    hidden: !a.isPresent,
    "data-state": t.present ? "open" : "closed",
    ...s.props
  });
};
function ip(e) {
  return oa()(e, [
    "lazyMount",
    "onExitComplete",
    "present",
    "unmountOnExit"
  ]);
}
const np = Object.assign(uy, {
  Root: uy
}), WO = (e) => typeof e == "function", cc = (e, ...t) => WO(e) ? e(...t) : e, [GO, J8] = ns({
  name: "CheckboxContext",
  hookName: "useCheckboxContext",
  providerName: "<CheckboxProvider />"
});
var l2 = {
  border: "0",
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: "0",
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}, e3 = (e) => e.ownerDocument.defaultView || window;
function t3(e, t) {
  const { type: r = "HTMLInputElement", property: i = "value" } = t, n = e3(e)[r].prototype;
  return Object.getOwnPropertyDescriptor(n, i) ?? {};
}
function KO(e, t, r = {}) {
  var n;
  (n = t3(e, r).set) == null || n.call(e, t);
}
function YO(e, t) {
  var i;
  (i = t3(e, { type: "HTMLInputElement", property: "checked" }).set) == null || i.call(e, t);
}
function r3(e, t) {
  const { checked: r, bubbles: i = !0 } = t;
  if (!e)
    return;
  const n = e3(e);
  e instanceof n.HTMLInputElement && (YO(e, r), e.dispatchEvent(new n.Event("click", { bubbles: i })), e.dispatchEvent(new n.Event("change", { bubbles: i })));
}
function qO(e) {
  return QO(e) ? e.form : e.closest("form");
}
function QO(e) {
  return e.matches("textarea, input, select, button");
}
function XO(e, t) {
  if (!e)
    return;
  const r = qO(e);
  return r == null || r.addEventListener("reset", t, { passive: !0 }), () => {
    r == null || r.removeEventListener("reset", t);
  };
}
function ZO(e, t) {
  const r = e == null ? void 0 : e.closest("fieldset");
  if (r)
    return t(r.disabled), o2(r, ["disabled"], () => t(r.disabled));
}
function u2(e, t) {
  if (!e)
    return;
  const { onFieldsetDisabledChange: r, onFormReset: i } = t, n = [XO(e, i), ZO(e, r)];
  return () => {
    n.forEach((a) => a == null ? void 0 : a());
  };
}
var JO = _o("checkbox").parts("root", "label", "control"), rk = JO.build(), ra = Ul({
  getRootId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.root) ?? `checkbox:${e.id}`;
  },
  getLabelId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.label) ?? `checkbox:${e.id}:label`;
  },
  getControlId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.control) ?? `checkbox:${e.id}:control`;
  },
  getHiddenInputId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.hiddenInput) ?? `checkbox:${e.id}:hidden`;
  },
  getRootEl: (e) => ra.getById(e, ra.getRootId(e)),
  getHiddenInputEl: (e) => ra.getById(e, ra.getHiddenInputId(e))
});
function eP(e, t, r) {
  const i = e.context.isDisabled, n = !i && e.context.focused, a = e.context.isChecked, o = e.context.isIndeterminate, s = {
    "data-active": pr(e.context.active),
    "data-focus": pr(n),
    "data-hover": pr(e.context.hovered),
    "data-disabled": pr(i),
    "data-state": o ? "indeterminate" : e.context.checked ? "checked" : "unchecked",
    "data-invalid": pr(e.context.invalid)
  };
  return {
    isChecked: a,
    isDisabled: i,
    isIndeterminate: o,
    isFocused: n,
    checkedState: e.context.checked,
    setChecked(l) {
      t({ type: "CHECKED.SET", checked: l, isTrusted: !1 });
    },
    toggleChecked() {
      t({ type: "CHECKED.TOGGLE", checked: a, isTrusted: !1 });
    },
    rootProps: r.label({
      ...rk.root.attrs,
      ...s,
      id: ra.getRootId(e.context),
      htmlFor: ra.getHiddenInputId(e.context),
      onPointerMove() {
        i || t({ type: "CONTEXT.SET", context: { hovered: !0 } });
      },
      onPointerLeave() {
        i || t({ type: "CONTEXT.SET", context: { hovered: !1 } });
      },
      onPointerDown(l) {
        i || (n && l.pointerType === "mouse" && l.preventDefault(), t({ type: "CONTEXT.SET", context: { active: !0 } }));
      },
      onPointerUp() {
        i || t({ type: "CONTEXT.SET", context: { active: !1 } });
      },
      onClick(l) {
        l.target === ra.getHiddenInputEl(e.context) && l.stopPropagation();
      }
    }),
    labelProps: r.element({
      ...rk.label.attrs,
      ...s,
      id: ra.getLabelId(e.context)
    }),
    controlProps: r.element({
      ...rk.control.attrs,
      ...s,
      id: ra.getControlId(e.context),
      "aria-hidden": !0
    }),
    hiddenInputProps: r.input({
      id: ra.getHiddenInputId(e.context),
      type: "checkbox",
      required: e.context.required,
      defaultChecked: a,
      disabled: i,
      "data-disabled": pr(i),
      "aria-labelledby": ra.getLabelId(e.context),
      "aria-invalid": e.context.invalid,
      name: e.context.name,
      form: e.context.form,
      value: e.context.value,
      style: l2,
      onChange(l) {
        const u = l.currentTarget.checked;
        t({ type: "CHECKED.SET", checked: u, isTrusted: !0 });
      },
      onBlur() {
        t({ type: "CONTEXT.SET", context: { focused: !1 } });
      },
      onFocus() {
        t({ type: "CONTEXT.SET", context: { focused: !0 } });
      },
      onKeyDown(l) {
        l.key === " " && t({ type: "CONTEXT.SET", context: { active: !0 } });
      },
      onKeyUp(l) {
        l.key === " " && t({ type: "CONTEXT.SET", context: { active: !1 } });
      }
    })
  };
}
var { not: cy } = rp;
function tP(e) {
  const t = as(e);
  return $s(
    {
      id: "checkbox",
      initial: "ready",
      context: {
        checked: !1,
        value: "on",
        disabled: !1,
        ...t,
        fieldsetDisabled: !1
      },
      watch: {
        disabled: "removeFocusIfNeeded",
        checked: "syncInputElement"
      },
      activities: ["trackFormControlState"],
      on: {
        "CHECKED.TOGGLE": [
          {
            guard: cy("isTrusted"),
            actions: ["toggleChecked", "dispatchChangeEvent"]
          },
          {
            actions: ["toggleChecked"]
          }
        ],
        "CHECKED.SET": [
          {
            guard: cy("isTrusted"),
            actions: ["setChecked", "dispatchChangeEvent"]
          },
          {
            actions: ["setChecked"]
          }
        ],
        "CONTEXT.SET": {
          actions: ["setContext"]
        }
      },
      computed: {
        isIndeterminate: (r) => Ob(r.checked),
        isChecked: (r) => dy(r.checked),
        isDisabled: (r) => !!r.disabled || r.fieldsetDisabled
      },
      states: {
        ready: {}
      }
    },
    {
      guards: {
        isTrusted: (r, i) => !!i.isTrusted
      },
      activities: {
        trackFormControlState(r, i, { send: n, initialContext: a }) {
          return u2(ra.getHiddenInputEl(r), {
            onFieldsetDisabledChange(o) {
              r.fieldsetDisabled = o;
            },
            onFormReset() {
              n({ type: "CHECKED.SET", checked: !!a.checked });
            }
          });
        }
      },
      actions: {
        setContext(r, i) {
          Object.assign(r, i.context);
        },
        syncInputElement(r) {
          const i = ra.getHiddenInputEl(r);
          i && (i.checked = r.isChecked, i.indeterminate = r.isIndeterminate);
        },
        removeFocusIfNeeded(r) {
          r.disabled && r.focused && (r.focused = !1);
        },
        setChecked(r, i) {
          py.checked(r, i.checked);
        },
        toggleChecked(r) {
          const i = Ob(r.checked) ? !0 : !r.checked;
          py.checked(r, i);
        },
        dispatchChangeEvent(r) {
          const i = ra.getHiddenInputEl(r);
          r3(i, { checked: dy(r.checked) });
        }
      }
    }
  );
}
function Ob(e) {
  return e === "indeterminate";
}
function dy(e) {
  return Ob(e) ? !1 : !!e;
}
var rP = {
  change: (e) => {
    var t;
    (t = e.onChange) == null || t.call(e, { checked: e.checked });
  }
}, py = {
  checked: (e, t) => {
    Ku(e.checked, t) || (e.checked = t, rP.change(e));
  }
};
const iP = (e) => {
  const t = Vl(), r = {
    id: Co(),
    getRootNode: t,
    ...e,
    checked: e.defaultChecked
  }, i = {
    ...r,
    checked: e.checked
  }, [n, a] = Us(tP(r), { context: i });
  return eP(n, a, $l);
}, Pb = Je((e, t) => {
  const [r, { children: i, ...n }] = oa()(
    e,
    [
      "checked",
      "defaultChecked",
      "dir",
      "disabled",
      "form",
      "getRootNode",
      "id",
      "ids",
      "invalid",
      "name",
      "onChange",
      "required",
      "value"
    ]
  ), a = iP(r), o = zt(a.rootProps, n), s = cc(i, a);
  return /* @__PURE__ */ v.jsxs(GO, { value: a, children: [
    /* @__PURE__ */ v.jsx(St.label, { ...o, ref: t, children: s }),
    /* @__PURE__ */ v.jsx("input", { ...a.hiddenInputProps })
  ] });
});
Pb.displayName = "Checkbox";
const i3 = Je((e, t) => {
  const r = J8(), i = zt(r.controlProps, e);
  return /* @__PURE__ */ v.jsx(St.div, { ...i, ref: t });
});
i3.displayName = "CheckboxControl";
const n3 = Je((e, t) => {
  const { labelProps: r } = J8(), i = zt(r, e);
  return /* @__PURE__ */ v.jsx(St.span, { ...i, ref: t });
});
n3.displayName = "CheckboxLabel";
const c2 = Object.assign(Pb, {
  Root: Pb,
  Control: i3,
  Label: n3
}), ec = Math.min, ja = Math.max, gg = Math.round, Il = (e) => ({
  x: e,
  y: e
}), nP = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, aP = {
  start: "end",
  end: "start"
};
function Nb(e, t, r) {
  return ja(e, ec(t, r));
}
function ap(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Bl(e) {
  return e.split("-")[0];
}
function op(e) {
  return e.split("-")[1];
}
function a3(e) {
  return e === "x" ? "y" : "x";
}
function d2(e) {
  return e === "y" ? "height" : "width";
}
function I1(e) {
  return ["top", "bottom"].includes(Bl(e)) ? "y" : "x";
}
function p2(e) {
  return a3(I1(e));
}
function oP(e, t, r) {
  r === void 0 && (r = !1);
  const i = op(e), n = p2(e), a = d2(n);
  let o = n === "x" ? i === (r ? "end" : "start") ? "right" : "left" : i === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (o = mg(o)), [o, mg(o)];
}
function sP(e) {
  const t = mg(e);
  return [zb(e), t, zb(t)];
}
function zb(e) {
  return e.replace(/start|end/g, (t) => aP[t]);
}
function lP(e, t, r) {
  const i = ["left", "right"], n = ["right", "left"], a = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? n : i : t ? i : n;
    case "left":
    case "right":
      return t ? a : o;
    default:
      return [];
  }
}
function uP(e, t, r, i) {
  const n = op(e);
  let a = lP(Bl(e), r === "start", i);
  return n && (a = a.map((o) => o + "-" + n), t && (a = a.concat(a.map(zb)))), a;
}
function mg(e) {
  return e.replace(/left|right|bottom|top/g, (t) => nP[t]);
}
function cP(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function o3(e) {
  return typeof e != "number" ? cP(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function vg(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function hy(e, t, r) {
  let {
    reference: i,
    floating: n
  } = e;
  const a = I1(t), o = p2(t), s = d2(o), l = Bl(t), u = a === "y", d = i.x + i.width / 2 - n.width / 2, c = i.y + i.height / 2 - n.height / 2, p = i[s] / 2 - n[s] / 2;
  let f;
  switch (l) {
    case "top":
      f = {
        x: d,
        y: i.y - n.height
      };
      break;
    case "bottom":
      f = {
        x: d,
        y: i.y + i.height
      };
      break;
    case "right":
      f = {
        x: i.x + i.width,
        y: c
      };
      break;
    case "left":
      f = {
        x: i.x - n.width,
        y: c
      };
      break;
    default:
      f = {
        x: i.x,
        y: i.y
      };
  }
  switch (op(t)) {
    case "start":
      f[o] -= p * (r && u ? -1 : 1);
      break;
    case "end":
      f[o] += p * (r && u ? -1 : 1);
      break;
  }
  return f;
}
const dP = async (e, t, r) => {
  const {
    placement: i = "bottom",
    strategy: n = "absolute",
    middleware: a = [],
    platform: o
  } = r, s = a.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let u = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: n
  }), {
    x: d,
    y: c
  } = hy(u, i, l), p = i, f = {}, g = 0;
  for (let k = 0; k < s.length; k++) {
    const {
      name: y,
      fn: _
    } = s[k], {
      x: A,
      y: T,
      data: N,
      reset: P
    } = await _({
      x: d,
      y: c,
      initialPlacement: i,
      placement: p,
      strategy: n,
      middlewareData: f,
      rects: u,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (d = A ?? d, c = T ?? c, f = {
      ...f,
      [y]: {
        ...f[y],
        ...N
      }
    }, P && g <= 50) {
      g++, typeof P == "object" && (P.placement && (p = P.placement), P.rects && (u = P.rects === !0 ? await o.getElementRects({
        reference: e,
        floating: t,
        strategy: n
      }) : P.rects), {
        x: d,
        y: c
      } = hy(u, p, l)), k = -1;
      continue;
    }
  }
  return {
    x: d,
    y: c,
    placement: p,
    strategy: n,
    middlewareData: f
  };
};
async function h2(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: i,
    y: n,
    platform: a,
    rects: o,
    elements: s,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: c = "floating",
    altBoundary: p = !1,
    padding: f = 0
  } = ap(t, e), g = o3(f), y = s[p ? c === "floating" ? "reference" : "floating" : c], _ = vg(await a.getClippingRect({
    element: (r = await (a.isElement == null ? void 0 : a.isElement(y))) == null || r ? y : y.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: l
  })), A = c === "floating" ? {
    ...o.floating,
    x: i,
    y: n
  } : o.reference, T = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), N = await (a.isElement == null ? void 0 : a.isElement(T)) ? await (a.getScale == null ? void 0 : a.getScale(T)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, P = vg(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: A,
    offsetParent: T,
    strategy: l
  }) : A);
  return {
    top: (_.top - P.top + g.top) / N.y,
    bottom: (P.bottom - _.bottom + g.bottom) / N.y,
    left: (_.left - P.left + g.left) / N.x,
    right: (P.right - _.right + g.right) / N.x
  };
}
const pP = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: i,
      placement: n,
      rects: a,
      platform: o,
      elements: s,
      middlewareData: l
    } = t, {
      element: u,
      padding: d = 0
    } = ap(e, t) || {};
    if (u == null)
      return {};
    const c = o3(d), p = {
      x: r,
      y: i
    }, f = p2(n), g = d2(f), k = await o.getDimensions(u), y = f === "y", _ = y ? "top" : "left", A = y ? "bottom" : "right", T = y ? "clientHeight" : "clientWidth", N = a.reference[g] + a.reference[f] - p[f] - a.floating[g], P = p[f] - a.reference[f], B = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(u));
    let M = B ? B[T] : 0;
    (!M || !await (o.isElement == null ? void 0 : o.isElement(B))) && (M = s.floating[T] || a.floating[g]);
    const X = N / 2 - P / 2, U = M / 2 - k[g] / 2 - 1, K = ec(c[_], U), z = ec(c[A], U), j = K, J = M - k[g] - z, ie = M / 2 - k[g] / 2 + X, ue = Nb(j, ie, J), de = !l.arrow && op(n) != null && ie != ue && a.reference[g] / 2 - (ie < j ? K : z) - k[g] / 2 < 0, he = de ? ie < j ? ie - j : ie - J : 0;
    return {
      [f]: p[f] + he,
      data: {
        [f]: ue,
        centerOffset: ie - ue - he,
        ...de && {
          alignmentOffset: he
        }
      },
      reset: de
    };
  }
}), hP = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, i;
      const {
        placement: n,
        middlewareData: a,
        rects: o,
        initialPlacement: s,
        platform: l,
        elements: u
      } = t, {
        mainAxis: d = !0,
        crossAxis: c = !0,
        fallbackPlacements: p,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: k = !0,
        ...y
      } = ap(e, t);
      if ((r = a.arrow) != null && r.alignmentOffset)
        return {};
      const _ = Bl(n), A = Bl(s) === s, T = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), N = p || (A || !k ? [mg(s)] : sP(s));
      !p && g !== "none" && N.push(...uP(s, k, g, T));
      const P = [s, ...N], B = await h2(t, y), M = [];
      let X = ((i = a.flip) == null ? void 0 : i.overflows) || [];
      if (d && M.push(B[_]), c) {
        const j = oP(n, o, T);
        M.push(B[j[0]], B[j[1]]);
      }
      if (X = [...X, {
        placement: n,
        overflows: M
      }], !M.every((j) => j <= 0)) {
        var U, K;
        const j = (((U = a.flip) == null ? void 0 : U.index) || 0) + 1, J = P[j];
        if (J)
          return {
            data: {
              index: j,
              overflows: X
            },
            reset: {
              placement: J
            }
          };
        let ie = (K = X.filter((ue) => ue.overflows[0] <= 0).sort((ue, de) => ue.overflows[1] - de.overflows[1])[0]) == null ? void 0 : K.placement;
        if (!ie)
          switch (f) {
            case "bestFit": {
              var z;
              const ue = (z = X.map((de) => [de.placement, de.overflows.filter((he) => he > 0).reduce((he, Ee) => he + Ee, 0)]).sort((de, he) => de[1] - he[1])[0]) == null ? void 0 : z[0];
              ue && (ie = ue);
              break;
            }
            case "initialPlacement":
              ie = s;
              break;
          }
        if (n !== ie)
          return {
            reset: {
              placement: ie
            }
          };
      }
      return {};
    }
  };
};
async function fP(e, t) {
  const {
    placement: r,
    platform: i,
    elements: n
  } = e, a = await (i.isRTL == null ? void 0 : i.isRTL(n.floating)), o = Bl(r), s = op(r), l = I1(r) === "y", u = ["left", "top"].includes(o) ? -1 : 1, d = a && l ? -1 : 1, c = ap(t, e);
  let {
    mainAxis: p,
    crossAxis: f,
    alignmentAxis: g
  } = typeof c == "number" ? {
    mainAxis: c,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...c
  };
  return s && typeof g == "number" && (f = s === "end" ? g * -1 : g), l ? {
    x: f * d,
    y: p * u
  } : {
    x: p * u,
    y: f * d
  };
}
const gP = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, i;
      const {
        x: n,
        y: a,
        placement: o,
        middlewareData: s
      } = t, l = await fP(t, e);
      return o === ((r = s.offset) == null ? void 0 : r.placement) && (i = s.arrow) != null && i.alignmentOffset ? {} : {
        x: n + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
}, mP = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: i,
        placement: n
      } = t, {
        mainAxis: a = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (y) => {
            let {
              x: _,
              y: A
            } = y;
            return {
              x: _,
              y: A
            };
          }
        },
        ...l
      } = ap(e, t), u = {
        x: r,
        y: i
      }, d = await h2(t, l), c = I1(Bl(n)), p = a3(c);
      let f = u[p], g = u[c];
      if (a) {
        const y = p === "y" ? "top" : "left", _ = p === "y" ? "bottom" : "right", A = f + d[y], T = f - d[_];
        f = Nb(A, f, T);
      }
      if (o) {
        const y = c === "y" ? "top" : "left", _ = c === "y" ? "bottom" : "right", A = g + d[y], T = g - d[_];
        g = Nb(A, g, T);
      }
      const k = s.fn({
        ...t,
        [p]: f,
        [c]: g
      });
      return {
        ...k,
        data: {
          x: k.x - r,
          y: k.y - i
        }
      };
    }
  };
}, vP = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: r,
        rects: i,
        platform: n,
        elements: a
      } = t, {
        apply: o = () => {
        },
        ...s
      } = ap(e, t), l = await h2(t, s), u = Bl(r), d = op(r), c = I1(r) === "y", {
        width: p,
        height: f
      } = i.floating;
      let g, k;
      u === "top" || u === "bottom" ? (g = u, k = d === (await (n.isRTL == null ? void 0 : n.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (k = u, g = d === "end" ? "top" : "bottom");
      const y = f - l[g], _ = p - l[k], A = !t.middlewareData.shift;
      let T = y, N = _;
      if (c) {
        const B = p - l.left - l.right;
        N = d || A ? ec(_, B) : B;
      } else {
        const B = f - l.top - l.bottom;
        T = d || A ? ec(y, B) : B;
      }
      if (A && !d) {
        const B = ja(l.left, 0), M = ja(l.right, 0), X = ja(l.top, 0), U = ja(l.bottom, 0);
        c ? N = p - 2 * (B !== 0 || M !== 0 ? B + M : ja(l.left, l.right)) : T = f - 2 * (X !== 0 || U !== 0 ? X + U : ja(l.top, l.bottom));
      }
      await o({
        ...t,
        availableWidth: N,
        availableHeight: T
      });
      const P = await n.getDimensions(a.floating);
      return p !== P.width || f !== P.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Rl(e) {
  return s3(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Ca(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Wl(e) {
  var t;
  return (t = (s3(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function s3(e) {
  return e instanceof Node || e instanceof Ca(e).Node;
}
function Ls(e) {
  return e instanceof Element || e instanceof Ca(e).Element;
}
function Xo(e) {
  return e instanceof HTMLElement || e instanceof Ca(e).HTMLElement;
}
function fy(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Ca(e).ShadowRoot;
}
function B1(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: i,
    display: n
  } = Ga(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + i + r) && !["inline", "contents"].includes(n);
}
function kP(e) {
  return ["table", "td", "th"].includes(Rl(e));
}
function f2(e) {
  const t = g2(), r = Ga(e);
  return r.transform !== "none" || r.perspective !== "none" || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((i) => (r.willChange || "").includes(i)) || ["paint", "layout", "strict", "content"].some((i) => (r.contain || "").includes(i));
}
function bP(e) {
  let t = Yd(e);
  for (; Xo(t) && !om(t); ) {
    if (f2(t))
      return t;
    t = Yd(t);
  }
  return null;
}
function g2() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function om(e) {
  return ["html", "body", "#document"].includes(Rl(e));
}
function Ga(e) {
  return Ca(e).getComputedStyle(e);
}
function sm(e) {
  return Ls(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function Yd(e) {
  if (Rl(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    fy(e) && e.host || // Fallback.
    Wl(e)
  );
  return fy(t) ? t.host : t;
}
function l3(e) {
  const t = Yd(e);
  return om(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Xo(t) && B1(t) ? t : l3(t);
}
function kg(e, t, r) {
  var i;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const n = l3(e), a = n === ((i = e.ownerDocument) == null ? void 0 : i.body), o = Ca(n);
  return a ? t.concat(o, o.visualViewport || [], B1(n) ? n : [], o.frameElement && r ? kg(o.frameElement) : []) : t.concat(n, kg(n, [], r));
}
function u3(e) {
  const t = Ga(e);
  let r = parseFloat(t.width) || 0, i = parseFloat(t.height) || 0;
  const n = Xo(e), a = n ? e.offsetWidth : r, o = n ? e.offsetHeight : i, s = gg(r) !== a || gg(i) !== o;
  return s && (r = a, i = o), {
    width: r,
    height: i,
    $: s
  };
}
function c3(e) {
  return Ls(e) ? e : e.contextElement;
}
function zd(e) {
  const t = c3(e);
  if (!Xo(t))
    return Il(1);
  const r = t.getBoundingClientRect(), {
    width: i,
    height: n,
    $: a
  } = u3(t);
  let o = (a ? gg(r.width) : r.width) / i, s = (a ? gg(r.height) : r.height) / n;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const _P = /* @__PURE__ */ Il(0);
function d3(e) {
  const t = Ca(e);
  return !g2() || !t.visualViewport ? _P : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function DP(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== Ca(e) ? !1 : t;
}
function p1(e, t, r, i) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const n = e.getBoundingClientRect(), a = c3(e);
  let o = Il(1);
  t && (i ? Ls(i) && (o = zd(i)) : o = zd(e));
  const s = DP(a, r, i) ? d3(a) : Il(0);
  let l = (n.left + s.x) / o.x, u = (n.top + s.y) / o.y, d = n.width / o.x, c = n.height / o.y;
  if (a) {
    const p = Ca(a), f = i && Ls(i) ? Ca(i) : i;
    let g = p.frameElement;
    for (; g && i && f !== p; ) {
      const k = zd(g), y = g.getBoundingClientRect(), _ = Ga(g), A = y.left + (g.clientLeft + parseFloat(_.paddingLeft)) * k.x, T = y.top + (g.clientTop + parseFloat(_.paddingTop)) * k.y;
      l *= k.x, u *= k.y, d *= k.x, c *= k.y, l += A, u += T, g = Ca(g).frameElement;
    }
  }
  return vg({
    width: d,
    height: c,
    x: l,
    y: u
  });
}
function yP(e) {
  let {
    rect: t,
    offsetParent: r,
    strategy: i
  } = e;
  const n = Xo(r), a = Wl(r);
  if (r === a)
    return t;
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = Il(1);
  const l = Il(0);
  if ((n || !n && i !== "fixed") && ((Rl(r) !== "body" || B1(a)) && (o = sm(r)), Xo(r))) {
    const u = p1(r);
    s = zd(r), l.x = u.x + r.clientLeft, l.y = u.y + r.clientTop;
  }
  return {
    width: t.width * s.x,
    height: t.height * s.y,
    x: t.x * s.x - o.scrollLeft * s.x + l.x,
    y: t.y * s.y - o.scrollTop * s.y + l.y
  };
}
function EP(e) {
  return Array.from(e.getClientRects());
}
function p3(e) {
  return p1(Wl(e)).left + sm(e).scrollLeft;
}
function CP(e) {
  const t = Wl(e), r = sm(e), i = e.ownerDocument.body, n = ja(t.scrollWidth, t.clientWidth, i.scrollWidth, i.clientWidth), a = ja(t.scrollHeight, t.clientHeight, i.scrollHeight, i.clientHeight);
  let o = -r.scrollLeft + p3(e);
  const s = -r.scrollTop;
  return Ga(i).direction === "rtl" && (o += ja(t.clientWidth, i.clientWidth) - n), {
    width: n,
    height: a,
    x: o,
    y: s
  };
}
function xP(e, t) {
  const r = Ca(e), i = Wl(e), n = r.visualViewport;
  let a = i.clientWidth, o = i.clientHeight, s = 0, l = 0;
  if (n) {
    a = n.width, o = n.height;
    const u = g2();
    (!u || u && t === "fixed") && (s = n.offsetLeft, l = n.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: s,
    y: l
  };
}
function AP(e, t) {
  const r = p1(e, !0, t === "fixed"), i = r.top + e.clientTop, n = r.left + e.clientLeft, a = Xo(e) ? zd(e) : Il(1), o = e.clientWidth * a.x, s = e.clientHeight * a.y, l = n * a.x, u = i * a.y;
  return {
    width: o,
    height: s,
    x: l,
    y: u
  };
}
function gy(e, t, r) {
  let i;
  if (t === "viewport")
    i = xP(e, r);
  else if (t === "document")
    i = CP(Wl(e));
  else if (Ls(t))
    i = AP(t, r);
  else {
    const n = d3(e);
    i = {
      ...t,
      x: t.x - n.x,
      y: t.y - n.y
    };
  }
  return vg(i);
}
function h3(e, t) {
  const r = Yd(e);
  return r === t || !Ls(r) || om(r) ? !1 : Ga(r).position === "fixed" || h3(r, t);
}
function wP(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let i = kg(e).filter((s) => Ls(s) && Rl(s) !== "body"), n = null;
  const a = Ga(e).position === "fixed";
  let o = a ? Yd(e) : e;
  for (; Ls(o) && !om(o); ) {
    const s = Ga(o), l = f2(o);
    !l && s.position === "fixed" && (n = null), (a ? !l && !n : !l && s.position === "static" && !!n && ["absolute", "fixed"].includes(n.position) || B1(o) && !l && h3(e, o)) ? i = i.filter((d) => d !== o) : n = s, o = Yd(o);
  }
  return t.set(e, i), i;
}
function FP(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: i,
    strategy: n
  } = e;
  const o = [...r === "clippingAncestors" ? wP(t, this._c) : [].concat(r), i], s = o[0], l = o.reduce((u, d) => {
    const c = gy(t, d, n);
    return u.top = ja(c.top, u.top), u.right = ec(c.right, u.right), u.bottom = ec(c.bottom, u.bottom), u.left = ja(c.left, u.left), u;
  }, gy(t, s, n));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function TP(e) {
  return u3(e);
}
function SP(e, t, r) {
  const i = Xo(t), n = Wl(t), a = r === "fixed", o = p1(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Il(0);
  if (i || !i && !a)
    if ((Rl(t) !== "body" || B1(n)) && (s = sm(t)), i) {
      const u = p1(t, !0, a, t);
      l.x = u.x + t.clientLeft, l.y = u.y + t.clientTop;
    } else
      n && (l.x = p3(n));
  return {
    x: o.left + s.scrollLeft - l.x,
    y: o.top + s.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function my(e, t) {
  return !Xo(e) || Ga(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function f3(e, t) {
  const r = Ca(e);
  if (!Xo(e))
    return r;
  let i = my(e, t);
  for (; i && kP(i) && Ga(i).position === "static"; )
    i = my(i, t);
  return i && (Rl(i) === "html" || Rl(i) === "body" && Ga(i).position === "static" && !f2(i)) ? r : i || bP(e) || r;
}
const IP = async function(e) {
  let {
    reference: t,
    floating: r,
    strategy: i
  } = e;
  const n = this.getOffsetParent || f3, a = this.getDimensions;
  return {
    reference: SP(t, await n(r), i),
    floating: {
      x: 0,
      y: 0,
      ...await a(r)
    }
  };
};
function BP(e) {
  return Ga(e).direction === "rtl";
}
const RP = {
  convertOffsetParentRelativeRectToViewportRelativeRect: yP,
  getDocumentElement: Wl,
  getClippingRect: FP,
  getOffsetParent: f3,
  getElementRects: IP,
  getClientRects: EP,
  getDimensions: TP,
  getScale: zd,
  isElement: Ls,
  isRTL: BP
}, OP = (e, t, r) => {
  const i = /* @__PURE__ */ new Map(), n = {
    platform: RP,
    ...r
  }, a = {
    ...n.platform,
    _c: i
  };
  return dP(e, t, {
    ...n,
    platform: a
  });
};
var Lb, Pu = /* @__PURE__ */ new Map(), PP = (e) => e.getBoundingClientRect();
function Mb(e, t) {
  const { scope: r = "rect", getRect: i = PP, onChange: n } = t, a = NP({ scope: r, getRect: i }), o = Pu.get(e);
  return o ? (o.callbacks.push(n), n(i(e))) : (Pu.set(e, {
    rect: {},
    callbacks: [n]
  }), Pu.size === 1 && (Lb = requestAnimationFrame(a))), function() {
    const l = Pu.get(e);
    if (!l)
      return;
    const u = l.callbacks.indexOf(n);
    u > -1 && l.callbacks.splice(u, 1), l.callbacks.length === 0 && (Pu.delete(e), Pu.size === 0 && cancelAnimationFrame(Lb));
  };
}
function NP(e) {
  const { scope: t, getRect: r } = e, i = LP(t);
  return function n() {
    const a = [];
    Pu.forEach((o, s) => {
      const l = r(s);
      i(o.rect, l) || (o.rect = l, a.push(o));
    }), a.forEach((o) => {
      o.callbacks.forEach((s) => s(o.rect));
    }), Lb = requestAnimationFrame(n);
  };
}
var g3 = (e, t) => e.width === t.width && e.height === t.height, m3 = (e, t) => e.top === t.top && e.left === t.left, zP = (e, t) => g3(e, t) && m3(e, t);
function LP(e) {
  return e === "size" ? g3 : e === "position" ? m3 : zP;
}
var ik = (...e) => () => e.forEach((t) => t()), vy = (e) => typeof e == "object" && e !== null && e.nodeType === 1, ky = (e, t, r, i) => (e.addEventListener(t, r, i), () => e.removeEventListener(t, r, i));
function MP(e) {
  const t = typeof e == "boolean";
  return {
    ancestorResize: t ? e : e.ancestorResize ?? !0,
    ancestorScroll: t ? e : e.ancestorScroll ?? !0,
    referenceResize: t ? e : e.referenceResize ?? !0
  };
}
function jP(e, t, r, i = !1) {
  const { ancestorScroll: n, ancestorResize: a, referenceResize: o } = MP(i), s = n || a, l = [];
  s && vy(e) && l.push(...kg(e));
  function u() {
    let c = [Mb(t, { scope: "size", onChange: r })];
    return o && vy(e) && c.push(Mb(e, { onChange: r })), c.push(ik(...l.map((p) => ky(p, "resize", r)))), () => c.forEach((p) => p());
  }
  function d() {
    return ik(...l.map((c) => ky(c, "scroll", r, { passive: !0 })));
  }
  return ik(u(), d());
}
var g0 = (e) => ({ variable: e, reference: `var(${e})` }), Os = {
  arrowSize: g0("--arrow-size"),
  arrowSizeHalf: g0("--arrow-size-half"),
  arrowBg: g0("--arrow-background"),
  transformOrigin: g0("--transform-origin"),
  arrowOffset: g0("--arrow-offset")
}, HP = (e) => ({
  top: "bottom center",
  "top-start": e ? `${e.x}px bottom` : "left bottom",
  "top-end": e ? `${e.x}px bottom` : "right bottom",
  bottom: "top center",
  "bottom-start": e ? `${e.x}px top` : "top left",
  "bottom-end": e ? `${e.x}px top` : "top right",
  left: "right center",
  "left-start": e ? `right ${e.y}px` : "right top",
  "left-end": e ? `right ${e.y}px` : "right bottom",
  right: "left center",
  "right-start": e ? `left ${e.y}px` : "left top",
  "right-end": e ? `left ${e.y}px` : "left bottom"
}), $P = {
  name: "transformOrigin",
  fn({ placement: e, elements: t, middlewareData: r }) {
    const { arrow: i } = r, n = HP(i)[e], { floating: a } = t;
    return a.style.setProperty(Os.transformOrigin.variable, n), {
      data: { transformOrigin: n }
    };
  }
}, UP = (e) => ({
  name: "shiftArrow",
  fn({ placement: t, middlewareData: r }) {
    const { element: i } = e;
    if (r.arrow) {
      const { x: n, y: a } = r.arrow, o = t.split("-")[0];
      Object.assign(i.style, {
        left: n != null ? `${n}px` : "",
        top: a != null ? `${a}px` : "",
        [o]: `calc(100% + ${Os.arrowOffset.reference})`
      });
    }
    return {};
  }
}), VP = {
  strategy: "absolute",
  placement: "bottom",
  listeners: !0,
  gutter: 8,
  flip: !0,
  sameWidth: !1,
  overflowPadding: 8
};
function WP(e, t, r = {}) {
  var l, u;
  if (!t || !e)
    return;
  const i = Object.assign({}, VP, r), n = t.querySelector("[data-part=arrow]"), a = [], o = typeof i.boundary == "function" ? i.boundary() : i.boundary;
  if (i.flip && a.push(
    hP({
      boundary: o,
      padding: i.overflowPadding
    })
  ), i.gutter || i.offset) {
    const d = n ? n.offsetHeight / 2 : 0;
    let c = ((l = i.offset) == null ? void 0 : l.mainAxis) ?? i.gutter, p = (u = i.offset) == null ? void 0 : u.crossAxis;
    c != null && (c += d);
    const f = as({ mainAxis: c, crossAxis: p });
    a.push(gP(f));
  }
  a.push(
    mP({
      boundary: o,
      crossAxis: i.overlap,
      padding: i.overflowPadding
    })
  ), n && a.push(
    pP({ element: n, padding: 8 }),
    UP({ element: n })
  ), a.push($P), a.push(
    vP({
      padding: i.overflowPadding,
      apply({ rects: d, availableHeight: c, availableWidth: p }) {
        const f = Math.round(d.reference.width);
        t.style.setProperty("--reference-width", `${f}px`), t.style.setProperty("--available-width", `${p}px`), t.style.setProperty("--available-height", `${c}px`);
      }
    })
  );
  function s(d = {}) {
    if (!e || !t)
      return;
    const { placement: c, strategy: p, onComplete: f } = i;
    OP(e, t, {
      placement: c,
      middleware: a,
      strategy: p,
      ...d
    }).then((g) => {
      const k = Math.round(g.x);
      t.style.setProperty("--x", `${k}px`);
      const y = Math.round(g.y);
      t.style.setProperty("--y", `${y}px`), f == null || f(g);
    });
  }
  return s(), Ib(
    i.listeners ? jP(e, t, s, i.listeners) : void 0,
    i.onCleanup
  );
}
function h1(e, t, r = {}) {
  const { defer: i, ...n } = r, a = i ? Wi : (s) => s(), o = [];
  return o.push(
    a(() => {
      const s = typeof e == "function" ? e() : e, l = typeof t == "function" ? t() : t;
      o.push(WP(s, l, n));
    })
  ), () => {
    o.forEach((s) => s == null ? void 0 : s());
  };
}
var GP = {
  bottom: "rotate(45deg)",
  left: "rotate(135deg)",
  top: "rotate(225deg)",
  right: "rotate(315deg)"
};
function m2(e = {}) {
  const { placement: t = "bottom", sameWidth: r, fitViewport: i, strategy: n = "absolute" } = e;
  return {
    arrow: {
      position: "absolute",
      width: Os.arrowSize.reference,
      height: Os.arrowSize.reference,
      [Os.arrowSizeHalf.variable]: `calc(${Os.arrowSize.reference} / 2)`,
      [Os.arrowOffset.variable]: `calc(${Os.arrowSizeHalf.reference} * -1)`
    },
    arrowTip: {
      transform: GP[t.split("-")[0]],
      background: Os.arrowBg.reference,
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      position: "absolute",
      zIndex: "inherit"
    },
    floating: {
      position: n,
      minWidth: r ? void 0 : "max-content",
      width: r ? "var(--reference-width)" : void 0,
      maxWidth: i ? "var(--available-width)" : void 0,
      maxHeight: i ? "var(--available-height)" : void 0,
      top: "0px",
      left: "0px",
      transform: "translate3d(var(--x), var(--y), 0)"
    }
  };
}
var m0 = /* @__PURE__ */ new WeakMap(), Pa = [];
function KP(e, t = {}) {
  const { rootEl: r } = t, i = e.filter(Boolean);
  if (i.length === 0)
    return;
  const n = i[0].ownerDocument || document, a = n.defaultView ?? window, o = new Set(i), s = /* @__PURE__ */ new Set(), l = r ?? n.body;
  let u = (f) => {
    for (let _ of f.querySelectorAll("[data-live-announcer], [data-zag-top-layer]"))
      o.add(_);
    let g = (_) => {
      if (o.has(_) || s.has(_.parentElement) && _.parentElement.getAttribute("role") !== "row")
        return NodeFilter.FILTER_REJECT;
      for (let A of o)
        if (_.contains(A))
          return NodeFilter.FILTER_SKIP;
      return NodeFilter.FILTER_ACCEPT;
    }, k = n.createTreeWalker(f, NodeFilter.SHOW_ELEMENT, { acceptNode: g }), y = g(f);
    if (y === NodeFilter.FILTER_ACCEPT && d(f), y !== NodeFilter.FILTER_REJECT) {
      let _ = k.nextNode();
      for (; _ != null; )
        d(_), _ = k.nextNode();
    }
  }, d = (f) => {
    let g = m0.get(f) ?? 0;
    f.getAttribute("aria-hidden") === "true" && g === 0 || (g === 0 && f.setAttribute("aria-hidden", "true"), s.add(f), m0.set(f, g + 1));
  };
  Pa.length && Pa[Pa.length - 1].disconnect(), u(l);
  const c = new a.MutationObserver((f) => {
    for (let g of f)
      if (!(g.type !== "childList" || g.addedNodes.length === 0) && ![...o, ...s].some((k) => k.contains(g.target))) {
        for (let k of g.removedNodes)
          k instanceof a.Element && (o.delete(k), s.delete(k));
        for (let k of g.addedNodes)
          (k instanceof a.HTMLElement || k instanceof a.SVGElement) && (k.dataset.liveAnnouncer === "true" || k.dataset.zagTopLayer === "true") ? o.add(k) : k instanceof a.Element && u(k);
      }
  });
  c.observe(l, { childList: !0, subtree: !0 });
  let p = {
    observe() {
      c.observe(l, { childList: !0, subtree: !0 });
    },
    disconnect() {
      c.disconnect();
    }
  };
  return Pa.push(p), () => {
    c.disconnect();
    for (let f of s) {
      let g = m0.get(f);
      g === 1 ? (f.removeAttribute("aria-hidden"), m0.delete(f)) : m0.set(f, g - 1);
    }
    p === Pa[Pa.length - 1] ? (Pa.pop(), Pa.length && Pa[Pa.length - 1].observe()) : Pa.splice(Pa.indexOf(p), 1);
  };
}
function v3(e, t = {}) {
  const { defer: r } = t, i = r ? Wi : (a) => a(), n = [];
  return n.push(
    i(() => {
      const a = typeof e == "function" ? e() : e;
      n.push(KP(a, t));
    })
  ), () => {
    n.forEach((a) => a == null ? void 0 : a());
  };
}
var v2 = (e) => typeof e == "object" && e !== null && e.nodeType === 1, k3 = (e) => v2(e) && e.tagName === "IFRAME";
function YP(e) {
  return v2(e) ? e.offsetWidth > 0 || e.offsetHeight > 0 || e.getClientRects().length > 0 : !1;
}
function qP(e) {
  return parseInt(e.getAttribute("tabindex") || "0", 10) < 0;
}
var k2 = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false']), details > summary:first-of-type", b2 = (e, t = !1) => {
  if (!e)
    return [];
  const r = Array.from(e.querySelectorAll(k2));
  (t == !0 || t == "if-empty" && r.length === 0) && v2(e) && f1(e) && r.unshift(e);
  const n = r.filter(f1);
  return n.forEach((a, o) => {
    if (k3(a) && a.contentDocument) {
      const s = a.contentDocument.body;
      n.splice(o, 1, ...b2(s));
    }
  }), n;
};
function f1(e) {
  return !e || e.closest("[inert]") ? !1 : e.matches(k2) && YP(e);
}
function tc(e, t) {
  if (!e)
    return [];
  const r = Array.from(e.querySelectorAll(k2)), i = r.filter(by);
  return t && by(e) && i.unshift(e), i.forEach((n, a) => {
    if (k3(n) && n.contentDocument) {
      const o = n.contentDocument.body, s = tc(o);
      i.splice(a, 1, ...s);
    }
  }), !i.length && t ? r : i;
}
function by(e) {
  return e != null && e.tabIndex > 0 ? !0 : f1(e) && !qP(e);
}
function QP(e, t) {
  const [r] = tc(e, t);
  return r || null;
}
function XP(e, t) {
  const r = tc(e, t);
  return r[r.length - 1] || null;
}
function ZP(e, t) {
  const r = tc(e, t), i = r[0] || null, n = r[r.length - 1] || null;
  return [i, n];
}
function JP(e, t) {
  const r = tc(e), i = (e == null ? void 0 : e.ownerDocument) || document, n = t ?? i.activeElement;
  if (!n)
    return null;
  const a = r.indexOf(n);
  return r[a + 1] || null;
}
function eN(e, t = {}) {
  const { triggerElement: r, onFocus: i } = t, n = (e == null ? void 0 : e.ownerDocument) || document, a = n.body;
  function o(s) {
    if (s.key !== "Tab")
      return;
    let l = null;
    const [u, d] = ZP(e, !0), c = !u && !d;
    s.shiftKey && (n.activeElement === u || c) ? l = r : !s.shiftKey && n.activeElement === r ? l = u : !s.shiftKey && (n.activeElement === d || c) && (l = JP(a, r)), l && (s.preventDefault(), (i == null ? void 0 : i(l)) ?? l.focus());
  }
  return n == null || n.addEventListener("keydown", o, !0), () => {
    n == null || n.removeEventListener("keydown", o, !0);
  };
}
function b3(e, t) {
  const { defer: r, triggerElement: i, ...n } = t, a = r ? Wi : (s) => s(), o = [];
  return o.push(
    a(() => {
      const s = typeof e == "function" ? e() : e, l = typeof i == "function" ? i() : i;
      o.push(eN(s, { triggerElement: l, ...n }));
    })
  ), () => {
    o.forEach((s) => s == null ? void 0 : s());
  };
}
function tN(e) {
  const t = {
    each(r) {
      var i;
      for (let n = 0; n < ((i = e.frames) == null ? void 0 : i.length); n += 1) {
        const a = e.frames[n];
        a && r(a);
      }
    },
    addEventListener(r, i, n) {
      return t.each((a) => {
        try {
          a.document.addEventListener(r, i, n);
        } catch (o) {
          console.warn(o);
        }
      }), () => {
        try {
          t.removeEventListener(r, i, n);
        } catch (a) {
          console.warn(a);
        }
      };
    },
    removeEventListener(r, i, n) {
      t.each((a) => {
        try {
          a.document.removeEventListener(r, i, n);
        } catch (o) {
          console.warn(o);
        }
      });
    }
  };
  return t;
}
var _y = "pointerdown.outside", Dy = "focus.outside";
function rN(e) {
  const t = e.composedPath() ?? [e.target];
  for (const r of t)
    if (Ju(r) && f1(r))
      return !0;
  return !1;
}
var iN = (e) => "clientY" in e;
function nN(e, t) {
  if (!iN(t) || !e)
    return !1;
  const r = e.getBoundingClientRect();
  return r.width === 0 || r.height === 0 ? !1 : r.top <= t.clientY && t.clientY <= r.top + r.height && r.left <= t.clientX && t.clientX <= r.left + r.width;
}
function aN(e, t) {
  const { exclude: r, onFocusOutside: i, onPointerDownOutside: n, onInteractOutside: a } = t;
  if (!e)
    return;
  const o = r2(e), s = rO(e), l = tN(s);
  function u(k) {
    const y = pg(k);
    return !Ju(y) || d1(e, y) || nN(e, k) ? !1 : !(r != null && r(y));
  }
  let d;
  function c(k) {
    function y() {
      if (!(!e || !u(k))) {
        if (n || a) {
          const _ = Ib(n, a);
          e.addEventListener(_y, _, { once: !0 });
        }
        sy(e, _y, {
          bubbles: !1,
          cancelable: !0,
          detail: {
            originalEvent: k,
            contextmenu: zO(k),
            focusable: rN(k)
          }
        });
      }
    }
    k.pointerType === "touch" ? (l.removeEventListener("click", y), o.removeEventListener("click", y), d = y, o.addEventListener("click", y, { once: !0 }), l.addEventListener("click", y, { once: !0 })) : y();
  }
  const p = /* @__PURE__ */ new Set(), f = setTimeout(() => {
    p.add(l.addEventListener("pointerdown", c, !0)), p.add(Vu(o, "pointerdown", c, !0));
  }, 0);
  function g(k) {
    if (!(!e || !u(k))) {
      if (i || a) {
        const y = Ib(i, a);
        e.addEventListener(Dy, y, { once: !0 });
      }
      sy(e, Dy, {
        bubbles: !1,
        cancelable: !0,
        detail: {
          originalEvent: k,
          contextmenu: !1,
          focusable: f1(pg(k))
        }
      });
    }
  }
  return p.add(Vu(o, "focusin", g, !0)), p.add(l.addEventListener("focusin", g, !0)), () => {
    clearTimeout(f), d && (l.removeEventListener("click", d), o.removeEventListener("click", d)), p.forEach((k) => k());
  };
}
function oN(e, t) {
  const { defer: r } = t, i = r ? Wi : (a) => a(), n = [];
  return n.push(
    i(() => {
      const a = typeof e == "function" ? e() : e;
      n.push(aN(a, t));
    })
  ), () => {
    n.forEach((a) => a == null ? void 0 : a());
  };
}
function sN(e, t) {
  const r = (i) => {
    i.key === "Escape" && (t == null || t(i));
  };
  return Vu(r2(e), "keydown", r);
}
var ho = {
  layers: [],
  branches: [],
  count() {
    return this.layers.length;
  },
  pointerBlockingLayers() {
    return this.layers.filter((e) => e.pointerBlocking);
  },
  topMostPointerBlockingLayer() {
    return [...this.pointerBlockingLayers()].slice(-1)[0];
  },
  hasPointerBlockingLayer() {
    return this.pointerBlockingLayers().length > 0;
  },
  isBelowPointerBlockingLayer(e) {
    var i;
    const t = this.indexOf(e), r = this.topMostPointerBlockingLayer() ? this.indexOf((i = this.topMostPointerBlockingLayer()) == null ? void 0 : i.node) : -1;
    return t < r;
  },
  isTopMost(e) {
    const t = this.layers[this.count() - 1];
    return (t == null ? void 0 : t.node) === e;
  },
  getNestedLayers(e) {
    return Array.from(this.layers).slice(this.indexOf(e) + 1);
  },
  isInNestedLayer(e, t) {
    return this.getNestedLayers(e).some((r) => d1(r.node, t));
  },
  isInBranch(e) {
    return Array.from(this.branches).some((t) => d1(t, e));
  },
  add(e) {
    this.layers.push(e);
  },
  addBranch(e) {
    this.branches.push(e);
  },
  remove(e) {
    const t = this.indexOf(e);
    t < 0 || (t < this.count() - 1 && this.getNestedLayers(e).forEach((i) => i.dismiss()), this.layers.splice(t, 1));
  },
  removeBranch(e) {
    const t = this.branches.indexOf(e);
    t >= 0 && this.branches.splice(t, 1);
  },
  indexOf(e) {
    return this.layers.findIndex((t) => t.node === e);
  },
  dismiss(e) {
    var t;
    (t = this.layers[this.indexOf(e)]) == null || t.dismiss();
  },
  clear() {
    this.remove(this.layers[0].node);
  }
}, yy;
function Ey() {
  ho.layers.forEach(({ node: e }) => {
    e.style.pointerEvents = ho.isBelowPointerBlockingLayer(e) ? "none" : "auto";
  });
}
function lN(e) {
  e.style.pointerEvents = "";
}
var nk = "data-inert";
function uN(e) {
  const t = r2(e);
  return ho.hasPointerBlockingLayer() && !t.body.hasAttribute(nk) && (yy = document.body.style.pointerEvents, t.body.style.pointerEvents = "none", t.body.setAttribute(nk, "")), () => {
    ho.hasPointerBlockingLayer() || (t.body.style.pointerEvents = yy, t.body.removeAttribute(nk), t.body.style.length === 0 && t.body.removeAttribute("style"));
  };
}
function cN(e, t) {
  if (!e) {
    wO("[@zag-js/dismissable] node is `null` or `undefined`");
    return;
  }
  const { onDismiss: r, pointerBlocking: i, exclude: n, debug: a } = t, o = { dismiss: r, node: e, pointerBlocking: i };
  ho.add(o), Ey();
  function s(p) {
    var g, k;
    const f = pg(p.detail.originalEvent);
    ho.isBelowPointerBlockingLayer(e) || ho.isInBranch(f) || ((g = t.onPointerDownOutside) == null || g.call(t, p), (k = t.onInteractOutside) == null || k.call(t, p), !p.defaultPrevented && (a && console.log("onPointerDownOutside:", p.detail.originalEvent), r == null || r()));
  }
  function l(p) {
    var g, k;
    const f = pg(p.detail.originalEvent);
    ho.isInBranch(f) || ((g = t.onFocusOutside) == null || g.call(t, p), (k = t.onInteractOutside) == null || k.call(t, p), !p.defaultPrevented && (a && console.log("onFocusOutside:", p.detail.originalEvent), r == null || r()));
  }
  function u(p) {
    var f;
    ho.isTopMost(e) && ((f = t.onEscapeKeyDown) == null || f.call(t, p), !p.defaultPrevented && r && (p.preventDefault(), r()));
  }
  function d(p) {
    if (!e)
      return !1;
    const f = typeof n == "function" ? n() : n;
    return (Array.isArray(f) ? f : [f]).some((k) => d1(k, p)) || ho.isInNestedLayer(e, p);
  }
  const c = [
    i ? uN(e) : void 0,
    sN(e, u),
    oN(e, { exclude: d, onFocusOutside: l, onPointerDownOutside: s })
  ];
  return () => {
    ho.remove(e), Ey(), lN(e), c.forEach((p) => p == null ? void 0 : p());
  };
}
function _2(e, t) {
  const { defer: r } = t, i = r ? Wi : (a) => a(), n = [];
  return n.push(
    i(() => {
      const a = typeof e == "function" ? e() : e;
      n.push(cN(a, t));
    })
  ), () => {
    n.forEach((a) => a == null ? void 0 : a());
  };
}
var dN = Object.defineProperty, pN = (e, t, r) => t in e ? dN(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, $r = (e, t, r) => (pN(e, typeof t != "symbol" ? t + "" : t, r), r), ak = (e) => typeof e == "object" && e !== null && !Array.isArray(e), ok = (e, t) => Object.prototype.hasOwnProperty.call(e, t), Hf = {
  itemToValue(e) {
    return typeof e == "string" ? e : ak(e) && ok(e, "value") ? e.value : "";
  },
  itemToString(e) {
    return typeof e == "string" ? e : ak(e) && ok(e, "label") ? e.label : Hf.itemToValue(e);
  },
  itemToDisabled(e) {
    return ak(e) && ok(e, "disabled") ? !!e.disabled : !1;
  }
}, _3 = class {
  constructor(e) {
    this.options = e, $r(this, "nodes", /* @__PURE__ */ new Map()), $r(this, "disabledValues", /* @__PURE__ */ new Set()), $r(this, "_firstValue", null), $r(this, "_lastValue", null), $r(this, "iterate", () => {
      const { items: t } = this.options;
      for (let r = 0; r < t.length; r++) {
        const i = t[r], n = this.itemToValue(i), a = this.itemToString(i), o = this.itemToDisabled(i), s = {
          // freeze item to prevent mutation by frameworks like Solid.js
          item: Object.freeze(i),
          index: r,
          label: a,
          value: n,
          previousValue: this.itemToValue(t[r - 1]) ?? null,
          nextValue: this.itemToValue(t[r + 1]) ?? null
        };
        this.nodes.set(n, s), o && this.disabledValues.add(n), r === 0 && (this._firstValue = n), r === t.length - 1 && (this._lastValue = n);
      }
      return this;
    }), $r(this, "setItems", (t) => (this.options.items = t, this.iterate())), $r(this, "item", (t) => {
      var r;
      return t === null ? null : ((r = this.nodes.get(t)) == null ? void 0 : r.item) ?? null;
    }), $r(this, "items", (t) => t.map((r) => this.item(r)).filter(Boolean)), $r(this, "at", (t) => {
      for (const r of this.nodes.values())
        if (r.index === t)
          return r.item;
      return null;
    }), $r(this, "sortFn", (t, r) => {
      const i = this.nodes.get(t), n = this.nodes.get(r);
      return ((i == null ? void 0 : i.index) ?? 0) - ((n == null ? void 0 : n.index) ?? 0);
    }), $r(this, "sort", (t) => t.sort(this.sortFn)), $r(this, "itemToValue", (t) => {
      var r, i;
      return t ? ((i = (r = this.options).itemToValue) == null ? void 0 : i.call(r, t)) ?? Hf.itemToValue(t) : "";
    }), $r(this, "itemToString", (t) => {
      var r, i;
      return t ? ((i = (r = this.options).itemToString) == null ? void 0 : i.call(r, t)) ?? Hf.itemToString(t) : "";
    }), $r(this, "itemToDisabled", (t) => {
      var r, i;
      return t ? ((i = (r = this.options).isItemDisabled) == null ? void 0 : i.call(r, t)) ?? Hf.itemToDisabled(t) : !1;
    }), $r(this, "valueToString", (t) => {
      var r;
      return t == null ? "" : ((r = this.nodes.get(t)) == null ? void 0 : r.label) ?? "";
    }), $r(this, "itemsToString", (t, r = ", ") => t.map((i) => this.itemToString(i)).filter(Boolean).join(r)), $r(this, "has", (t) => t == null ? !1 : this.nodes.has(t)), $r(this, "count", () => this.nodes.size), $r(this, "first", () => {
      let t = this._firstValue;
      for (; t != null; ) {
        let r = this.nodes.get(t);
        if (r != null && !this.disabledValues.has(r.value))
          return t;
        t = (r == null ? void 0 : r.nextValue) ?? null;
      }
      return null;
    }), $r(this, "last", () => {
      let t = this._lastValue;
      for (; t != null; ) {
        let r = this.nodes.get(t);
        if (r != null && !this.disabledValues.has(r.value))
          return t;
        t = (r == null ? void 0 : r.previousValue) ?? null;
      }
      return null;
    }), $r(this, "next", (t) => {
      if (t == null)
        return null;
      const r = this.nodes.get(t);
      let i = (r == null ? void 0 : r.nextValue) ?? null;
      for (; i != null; ) {
        let n = this.nodes.get(i);
        if (n != null && !this.disabledValues.has(n.value))
          return i;
        i = (n == null ? void 0 : n.nextValue) ?? null;
      }
      return null;
    }), $r(this, "prev", (t) => {
      if (t == null)
        return null;
      const r = this.nodes.get(t);
      let i = (r == null ? void 0 : r.previousValue) ?? null;
      for (; i != null; ) {
        let n = this.nodes.get(i);
        if (n != null && !this.disabledValues.has(n.value))
          return i;
        i = (n == null ? void 0 : n.previousValue) ?? null;
      }
      return null;
    }), $r(this, "isItemDisabled", (t) => this.disabledValues.has(this.itemToValue(t))), $r(this, "toArray", () => Array.from(this.nodes.values())), $r(this, "indexOf", (t) => {
      var r;
      return t == null ? -1 : ((r = this.nodes.get(t)) == null ? void 0 : r.index) ?? -1;
    }), $r(this, "getByText", (t, r) => {
      const i = this.indexOf(r);
      let n = r != null ? fN(this.toArray(), i) : this.toArray();
      return t.length === 1 && (n = n.filter((o) => o.value !== r)), n.find((o) => hN(o.label, t));
    }), $r(this, "search", (t, r) => {
      var p;
      const { state: i, currentValue: n, timeout: a = 350 } = r, o = i.keysSoFar + t, l = o.length > 1 && Array.from(o).every((f) => f === o[0]) ? o[0] : o, u = ((p = this.getByText(l, n)) == null ? void 0 : p.value) ?? null;
      function d() {
        clearTimeout(i.timer), i.timer = -1;
      }
      function c(f) {
        i.keysSoFar = f, d(), f !== "" && (i.timer = +setTimeout(() => {
          c(""), d();
        }, a));
      }
      return c(o), u;
    }), $r(this, "toJSON", () => ({
      size: this.count(),
      first: this.first(),
      last: this.last()
    })), this.iterate();
  }
}, hN = (e, t) => e.toLowerCase().startsWith(t.toLowerCase()), fN = (e, t) => e.map((r, i) => e[(Math.max(t, 0) + i) % e.length]);
const [gN, Vs] = ns({
  name: "DialogContext",
  hookName: "useDialogContext",
  providerName: "<DialogProvider />"
});
var sk = "data-zag-scroll-lock";
function Cy(e, t) {
  if (!e)
    return;
  const r = e.style.cssText;
  return Object.assign(e.style, t), () => {
    e.style.cssText = r;
  };
}
function mN(e, t, r) {
  if (!e)
    return;
  const i = e.style.getPropertyValue(t);
  return e.style.setProperty(t, r), () => {
    i ? e.style.setProperty(t, i) : e.style.removeProperty(t);
  };
}
function vN(e) {
  const t = e.getBoundingClientRect().left;
  return Math.round(t) + e.scrollLeft ? "paddingLeft" : "paddingRight";
}
function D3(e) {
  const t = e ?? document, r = t.defaultView ?? window, { documentElement: i, body: n } = t;
  if (n.hasAttribute(sk))
    return;
  n.setAttribute(sk, "");
  const o = r.innerWidth - i.clientWidth, s = () => mN(i, "--scrollbar-width", `${o}px`), l = vN(i), u = () => Cy(n, {
    overflow: "hidden",
    [l]: `${o}px`
  }), d = () => {
    const { scrollX: p, scrollY: f, visualViewport: g } = r, k = (g == null ? void 0 : g.offsetLeft) ?? 0, y = (g == null ? void 0 : g.offsetTop) ?? 0, _ = Cy(n, {
      position: "fixed",
      overflow: "hidden",
      top: `${-(f - Math.floor(y))}px`,
      left: `${-(p - Math.floor(k))}px`,
      right: "0",
      [l]: `${o}px`
    });
    return () => {
      _ == null || _(), r.scrollTo(p, f);
    };
  }, c = [s(), mO() ? d() : u()];
  return () => {
    c.forEach((p) => p == null ? void 0 : p()), n.removeAttribute(sk);
  };
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var y3 = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], bg = /* @__PURE__ */ y3.join(","), E3 = typeof Element > "u", rc = E3 ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, _g = !E3 && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, Dg = function e(t, r) {
  var i;
  r === void 0 && (r = !0);
  var n = t == null || (i = t.getAttribute) === null || i === void 0 ? void 0 : i.call(t, "inert"), a = n === "" || n === "true", o = a || r && t && e(t.parentNode);
  return o;
}, kN = function(t) {
  var r, i = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "contenteditable");
  return i === "" || i === "true";
}, C3 = function(t, r, i) {
  if (Dg(t))
    return [];
  var n = Array.prototype.slice.apply(t.querySelectorAll(bg));
  return r && rc.call(t, bg) && n.unshift(t), n = n.filter(i), n;
}, x3 = function e(t, r, i) {
  for (var n = [], a = Array.from(t); a.length; ) {
    var o = a.shift();
    if (!Dg(o, !1))
      if (o.tagName === "SLOT") {
        var s = o.assignedElements(), l = s.length ? s : o.children, u = e(l, !0, i);
        i.flatten ? n.push.apply(n, u) : n.push({
          scopeParent: o,
          candidates: u
        });
      } else {
        var d = rc.call(o, bg);
        d && i.filter(o) && (r || !t.includes(o)) && n.push(o);
        var c = o.shadowRoot || // check for an undisclosed shadow
        typeof i.getShadowRoot == "function" && i.getShadowRoot(o), p = !Dg(c, !1) && (!i.shadowRootFilter || i.shadowRootFilter(o));
        if (c && p) {
          var f = e(c === !0 ? o.children : c.children, !0, i);
          i.flatten ? n.push.apply(n, f) : n.push({
            scopeParent: o,
            candidates: f
          });
        } else
          a.unshift.apply(a, o.children);
      }
  }
  return n;
}, A3 = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, Mu = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || kN(t)) && !A3(t) ? 0 : t.tabIndex;
}, bN = function(t, r) {
  var i = Mu(t);
  return i < 0 && r && !A3(t) ? 0 : i;
}, _N = function(t, r) {
  return t.tabIndex === r.tabIndex ? t.documentOrder - r.documentOrder : t.tabIndex - r.tabIndex;
}, w3 = function(t) {
  return t.tagName === "INPUT";
}, DN = function(t) {
  return w3(t) && t.type === "hidden";
}, yN = function(t) {
  var r = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(i) {
    return i.tagName === "SUMMARY";
  });
  return r;
}, EN = function(t, r) {
  for (var i = 0; i < t.length; i++)
    if (t[i].checked && t[i].form === r)
      return t[i];
}, CN = function(t) {
  if (!t.name)
    return !0;
  var r = t.form || _g(t), i = function(s) {
    return r.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, n;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    n = i(window.CSS.escape(t.name));
  else
    try {
      n = i(t.name);
    } catch (o) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", o.message), !1;
    }
  var a = EN(n, t.form);
  return !a || a === t;
}, xN = function(t) {
  return w3(t) && t.type === "radio";
}, AN = function(t) {
  return xN(t) && !CN(t);
}, wN = function(t) {
  var r, i = t && _g(t), n = (r = i) === null || r === void 0 ? void 0 : r.host, a = !1;
  if (i && i !== t) {
    var o, s, l;
    for (a = !!((o = n) !== null && o !== void 0 && (s = o.ownerDocument) !== null && s !== void 0 && s.contains(n) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !a && n; ) {
      var u, d, c;
      i = _g(n), n = (u = i) === null || u === void 0 ? void 0 : u.host, a = !!((d = n) !== null && d !== void 0 && (c = d.ownerDocument) !== null && c !== void 0 && c.contains(n));
    }
  }
  return a;
}, xy = function(t) {
  var r = t.getBoundingClientRect(), i = r.width, n = r.height;
  return i === 0 && n === 0;
}, FN = function(t, r) {
  var i = r.displayCheck, n = r.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var a = rc.call(t, "details>summary:first-of-type"), o = a ? t.parentElement : t;
  if (rc.call(o, "details:not([open]) *"))
    return !0;
  if (!i || i === "full" || i === "legacy-full") {
    if (typeof n == "function") {
      for (var s = t; t; ) {
        var l = t.parentElement, u = _g(t);
        if (l && !l.shadowRoot && n(l) === !0)
          return xy(t);
        t.assignedSlot ? t = t.assignedSlot : !l && u !== t.ownerDocument ? t = u.host : t = l;
      }
      t = s;
    }
    if (wN(t))
      return !t.getClientRects().length;
    if (i !== "legacy-full")
      return !0;
  } else if (i === "non-zero-area")
    return xy(t);
  return !1;
}, TN = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var r = t.parentElement; r; ) {
      if (r.tagName === "FIELDSET" && r.disabled) {
        for (var i = 0; i < r.children.length; i++) {
          var n = r.children.item(i);
          if (n.tagName === "LEGEND")
            return rc.call(r, "fieldset[disabled] *") ? !0 : !n.contains(t);
        }
        return !0;
      }
      r = r.parentElement;
    }
  return !1;
}, yg = function(t, r) {
  return !(r.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Dg(r) || DN(r) || FN(r, t) || // For a details element with a summary, the summary element gets the focus
  yN(r) || TN(r));
}, jb = function(t, r) {
  return !(AN(r) || Mu(r) < 0 || !yg(t, r));
}, SN = function(t) {
  var r = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(r) || r >= 0);
}, IN = function e(t) {
  var r = [], i = [];
  return t.forEach(function(n, a) {
    var o = !!n.scopeParent, s = o ? n.scopeParent : n, l = bN(s, o), u = o ? e(n.candidates) : s;
    l === 0 ? o ? r.push.apply(r, u) : r.push(s) : i.push({
      documentOrder: a,
      tabIndex: l,
      item: n,
      isScope: o,
      content: u
    });
  }), i.sort(_N).reduce(function(n, a) {
    return a.isScope ? n.push.apply(n, a.content) : n.push(a.content), n;
  }, []).concat(r);
}, BN = function(t, r) {
  r = r || {};
  var i;
  return r.getShadowRoot ? i = x3([t], r.includeContainer, {
    filter: jb.bind(null, r),
    flatten: !1,
    getShadowRoot: r.getShadowRoot,
    shadowRootFilter: SN
  }) : i = C3(t, r.includeContainer, jb.bind(null, r)), IN(i);
}, RN = function(t, r) {
  r = r || {};
  var i;
  return r.getShadowRoot ? i = x3([t], r.includeContainer, {
    filter: yg.bind(null, r),
    flatten: !0,
    getShadowRoot: r.getShadowRoot
  }) : i = C3(t, r.includeContainer, yg.bind(null, r)), i;
}, dd = function(t, r) {
  if (r = r || {}, !t)
    throw new Error("No node provided");
  return rc.call(t, bg) === !1 ? !1 : jb(r, t);
}, ON = /* @__PURE__ */ y3.concat("iframe").join(","), lk = function(t, r) {
  if (r = r || {}, !t)
    throw new Error("No node provided");
  return rc.call(t, ON) === !1 ? !1 : yg(r, t);
};
/*!
* focus-trap 7.5.2
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function Ay(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function wy(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ay(Object(r), !0).forEach(function(i) {
      PN(e, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ay(Object(r)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return e;
}
function PN(e, t, r) {
  return t = zN(t), t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function NN(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var i = r.call(e, t || "default");
    if (typeof i != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function zN(e) {
  var t = NN(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var Fy = {
  activateTrap: function(t, r) {
    if (t.length > 0) {
      var i = t[t.length - 1];
      i !== r && i.pause();
    }
    var n = t.indexOf(r);
    n === -1 || t.splice(n, 1), t.push(r);
  },
  deactivateTrap: function(t, r) {
    var i = t.indexOf(r);
    i !== -1 && t.splice(i, 1), t.length > 0 && t[t.length - 1].unpause();
  }
}, LN = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, MN = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, K0 = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, jN = function(t) {
  return K0(t) && !t.shiftKey;
}, HN = function(t) {
  return K0(t) && t.shiftKey;
}, Ty = function(t) {
  return setTimeout(t, 0);
}, Sy = function(t, r) {
  var i = -1;
  return t.every(function(n, a) {
    return r(n) ? (i = a, !1) : !0;
  }), i;
}, v0 = function(t) {
  for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
    i[n - 1] = arguments[n];
  return typeof t == "function" ? t.apply(void 0, i) : t;
}, Yh = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, $N = [], F3 = function(t, r) {
  var i = (r == null ? void 0 : r.document) || document, n = (r == null ? void 0 : r.trapStack) || $N, a = wy({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: jN,
    isKeyBackward: HN
  }, r), o = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, s, l = function(z, j, J) {
    return z && z[j] !== void 0 ? z[j] : a[J || j];
  }, u = function(z, j) {
    var J = typeof (j == null ? void 0 : j.composedPath) == "function" ? j.composedPath() : void 0;
    return o.containerGroups.findIndex(function(ie) {
      var ue = ie.container, de = ie.tabbableNodes;
      return ue.contains(z) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (J == null ? void 0 : J.includes(ue)) || de.find(function(he) {
        return he === z;
      });
    });
  }, d = function(z) {
    var j = a[z];
    if (typeof j == "function") {
      for (var J = arguments.length, ie = new Array(J > 1 ? J - 1 : 0), ue = 1; ue < J; ue++)
        ie[ue - 1] = arguments[ue];
      j = j.apply(void 0, ie);
    }
    if (j === !0 && (j = void 0), !j) {
      if (j === void 0 || j === !1)
        return j;
      throw new Error("`".concat(z, "` was specified but was not a node, or did not return a node"));
    }
    var de = j;
    if (typeof j == "string" && (de = i.querySelector(j), !de))
      throw new Error("`".concat(z, "` as selector refers to no known node"));
    return de;
  }, c = function() {
    var z = d("initialFocus");
    if (z === !1)
      return !1;
    if (z === void 0 || !lk(z, a.tabbableOptions))
      if (u(i.activeElement) >= 0)
        z = i.activeElement;
      else {
        var j = o.tabbableGroups[0], J = j && j.firstTabbableNode;
        z = J || d("fallbackFocus");
      }
    if (!z)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return z;
  }, p = function() {
    if (o.containerGroups = o.containers.map(function(z) {
      var j = BN(z, a.tabbableOptions), J = RN(z, a.tabbableOptions), ie = j.length > 0 ? j[0] : void 0, ue = j.length > 0 ? j[j.length - 1] : void 0, de = J.find(function(Le) {
        return dd(Le);
      }), he = J.slice().reverse().find(function(Le) {
        return dd(Le);
      }), Ee = !!j.find(function(Le) {
        return Mu(Le) > 0;
      });
      return {
        container: z,
        tabbableNodes: j,
        focusableNodes: J,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: Ee,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: ie,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: ue,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: de,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: he,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(L) {
          var me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, Se = j.indexOf(L);
          return Se < 0 ? me ? J.slice(J.indexOf(L) + 1).find(function(G) {
            return dd(G);
          }) : J.slice(0, J.indexOf(L)).reverse().find(function(G) {
            return dd(G);
          }) : j[Se + (me ? 1 : -1)];
        }
      };
    }), o.tabbableGroups = o.containerGroups.filter(function(z) {
      return z.tabbableNodes.length > 0;
    }), o.tabbableGroups.length <= 0 && !d("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (o.containerGroups.find(function(z) {
      return z.posTabIndexesFound;
    }) && o.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, f = function K(z) {
    if (z !== !1 && z !== i.activeElement) {
      if (!z || !z.focus) {
        K(c());
        return;
      }
      z.focus({
        preventScroll: !!a.preventScroll
      }), o.mostRecentlyFocusedNode = z, LN(z) && z.select();
    }
  }, g = function(z) {
    var j = d("setReturnFocus", z);
    return j || (j === !1 ? !1 : z);
  }, k = function(z) {
    var j = z.target, J = z.event, ie = z.isBackward, ue = ie === void 0 ? !1 : ie;
    j = j || Yh(J), p();
    var de = null;
    if (o.tabbableGroups.length > 0) {
      var he = u(j, J), Ee = he >= 0 ? o.containerGroups[he] : void 0;
      if (he < 0)
        ue ? de = o.tabbableGroups[o.tabbableGroups.length - 1].lastTabbableNode : de = o.tabbableGroups[0].firstTabbableNode;
      else if (ue) {
        var Le = Sy(o.tabbableGroups, function(xe) {
          var _e = xe.firstTabbableNode;
          return j === _e;
        });
        if (Le < 0 && (Ee.container === j || lk(j, a.tabbableOptions) && !dd(j, a.tabbableOptions) && !Ee.nextTabbableNode(j, !1)) && (Le = he), Le >= 0) {
          var L = Le === 0 ? o.tabbableGroups.length - 1 : Le - 1, me = o.tabbableGroups[L];
          de = Mu(j) >= 0 ? me.lastTabbableNode : me.lastDomTabbableNode;
        } else
          K0(J) || (de = Ee.nextTabbableNode(j, !1));
      } else {
        var Se = Sy(o.tabbableGroups, function(xe) {
          var _e = xe.lastTabbableNode;
          return j === _e;
        });
        if (Se < 0 && (Ee.container === j || lk(j, a.tabbableOptions) && !dd(j, a.tabbableOptions) && !Ee.nextTabbableNode(j)) && (Se = he), Se >= 0) {
          var G = Se === o.tabbableGroups.length - 1 ? 0 : Se + 1, He = o.tabbableGroups[G];
          de = Mu(j) >= 0 ? He.firstTabbableNode : He.firstDomTabbableNode;
        } else
          K0(J) || (de = Ee.nextTabbableNode(j));
      }
    } else
      de = d("fallbackFocus");
    return de;
  }, y = function(z) {
    var j = Yh(z);
    if (!(u(j, z) >= 0)) {
      if (v0(a.clickOutsideDeactivates, z)) {
        s.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: a.returnFocusOnDeactivate
        });
        return;
      }
      v0(a.allowOutsideClick, z) || z.preventDefault();
    }
  }, _ = function(z) {
    var j = Yh(z), J = u(j, z) >= 0;
    if (J || j instanceof Document)
      J && (o.mostRecentlyFocusedNode = j);
    else {
      z.stopImmediatePropagation();
      var ie, ue = !0;
      if (o.mostRecentlyFocusedNode)
        if (Mu(o.mostRecentlyFocusedNode) > 0) {
          var de = u(o.mostRecentlyFocusedNode), he = o.containerGroups[de].tabbableNodes;
          if (he.length > 0) {
            var Ee = he.findIndex(function(Le) {
              return Le === o.mostRecentlyFocusedNode;
            });
            Ee >= 0 && (a.isKeyForward(o.recentNavEvent) ? Ee + 1 < he.length && (ie = he[Ee + 1], ue = !1) : Ee - 1 >= 0 && (ie = he[Ee - 1], ue = !1));
          }
        } else
          o.containerGroups.some(function(Le) {
            return Le.tabbableNodes.some(function(L) {
              return Mu(L) > 0;
            });
          }) || (ue = !1);
      else
        ue = !1;
      ue && (ie = k({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: o.mostRecentlyFocusedNode,
        isBackward: a.isKeyBackward(o.recentNavEvent)
      })), f(ie || o.mostRecentlyFocusedNode || c());
    }
    o.recentNavEvent = void 0;
  }, A = function(z) {
    var j = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    o.recentNavEvent = z;
    var J = k({
      event: z,
      isBackward: j
    });
    J && (K0(z) && z.preventDefault(), f(J));
  }, T = function(z) {
    if (MN(z) && v0(a.escapeDeactivates, z) !== !1) {
      z.preventDefault(), s.deactivate();
      return;
    }
    (a.isKeyForward(z) || a.isKeyBackward(z)) && A(z, a.isKeyBackward(z));
  }, N = function(z) {
    var j = Yh(z);
    u(j, z) >= 0 || v0(a.clickOutsideDeactivates, z) || v0(a.allowOutsideClick, z) || (z.preventDefault(), z.stopImmediatePropagation());
  }, P = function() {
    if (o.active)
      return Fy.activateTrap(n, s), o.delayInitialFocusTimer = a.delayInitialFocus ? Ty(function() {
        f(c());
      }) : f(c()), i.addEventListener("focusin", _, !0), i.addEventListener("mousedown", y, {
        capture: !0,
        passive: !1
      }), i.addEventListener("touchstart", y, {
        capture: !0,
        passive: !1
      }), i.addEventListener("click", N, {
        capture: !0,
        passive: !1
      }), i.addEventListener("keydown", T, {
        capture: !0,
        passive: !1
      }), s;
  }, B = function() {
    if (o.active)
      return i.removeEventListener("focusin", _, !0), i.removeEventListener("mousedown", y, !0), i.removeEventListener("touchstart", y, !0), i.removeEventListener("click", N, !0), i.removeEventListener("keydown", T, !0), s;
  }, M = function(z) {
    var j = z.some(function(J) {
      var ie = Array.from(J.removedNodes);
      return ie.some(function(ue) {
        return ue === o.mostRecentlyFocusedNode;
      });
    });
    j && f(c());
  }, X = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(M) : void 0, U = function() {
    X && (X.disconnect(), o.active && !o.paused && o.containers.map(function(z) {
      X.observe(z, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return s = {
    get active() {
      return o.active;
    },
    get paused() {
      return o.paused;
    },
    activate: function(z) {
      if (o.active)
        return this;
      var j = l(z, "onActivate"), J = l(z, "onPostActivate"), ie = l(z, "checkCanFocusTrap");
      ie || p(), o.active = !0, o.paused = !1, o.nodeFocusedBeforeActivation = i.activeElement, j == null || j();
      var ue = function() {
        ie && p(), P(), U(), J == null || J();
      };
      return ie ? (ie(o.containers.concat()).then(ue, ue), this) : (ue(), this);
    },
    deactivate: function(z) {
      if (!o.active)
        return this;
      var j = wy({
        onDeactivate: a.onDeactivate,
        onPostDeactivate: a.onPostDeactivate,
        checkCanReturnFocus: a.checkCanReturnFocus
      }, z);
      clearTimeout(o.delayInitialFocusTimer), o.delayInitialFocusTimer = void 0, B(), o.active = !1, o.paused = !1, U(), Fy.deactivateTrap(n, s);
      var J = l(j, "onDeactivate"), ie = l(j, "onPostDeactivate"), ue = l(j, "checkCanReturnFocus"), de = l(j, "returnFocus", "returnFocusOnDeactivate");
      J == null || J();
      var he = function() {
        Ty(function() {
          de && f(g(o.nodeFocusedBeforeActivation)), ie == null || ie();
        });
      };
      return de && ue ? (ue(g(o.nodeFocusedBeforeActivation)).then(he, he), this) : (he(), this);
    },
    pause: function(z) {
      if (o.paused || !o.active)
        return this;
      var j = l(z, "onPause"), J = l(z, "onPostPause");
      return o.paused = !0, j == null || j(), B(), U(), J == null || J(), this;
    },
    unpause: function(z) {
      if (!o.paused || !o.active)
        return this;
      var j = l(z, "onUnpause"), J = l(z, "onPostUnpause");
      return o.paused = !1, j == null || j(), p(), P(), U(), J == null || J(), this;
    },
    updateContainerElements: function(z) {
      var j = [].concat(z).filter(Boolean);
      return o.containers = j.map(function(J) {
        return typeof J == "string" ? i.querySelector(J) : J;
      }), o.active && p(), U(), this;
    }
  }, s.updateContainerElements(t), s;
}, UN = _o("dialog").parts(
  "trigger",
  "backdrop",
  "container",
  "content",
  "title",
  "description",
  "closeTrigger"
), Su = UN.build(), Pr = Ul({
  getContainerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.container) ?? `dialog:${e.id}:container`;
  },
  getBackdropId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.backdrop) ?? `dialog:${e.id}:backdrop`;
  },
  getContentId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.content) ?? `dialog:${e.id}:content`;
  },
  getTriggerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.trigger) ?? `dialog:${e.id}:trigger`;
  },
  getTitleId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.title) ?? `dialog:${e.id}:title`;
  },
  getDescriptionId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.description) ?? `dialog:${e.id}:description`;
  },
  getCloseTriggerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.closeTrigger) ?? `dialog:${e.id}:close`;
  },
  getContentEl: (e) => Pr.getById(e, Pr.getContentId(e)),
  getTriggerEl: (e) => Pr.getById(e, Pr.getTriggerId(e)),
  getContainerEl: (e) => Pr.getById(e, Pr.getContainerId(e)),
  getTitleEl: (e) => Pr.getById(e, Pr.getTitleId(e)),
  getDescriptionEl: (e) => Pr.getById(e, Pr.getDescriptionId(e))
});
function VN(e, t, r) {
  const i = e.context["aria-label"], n = e.matches("open"), a = e.context.renderedElements;
  return {
    isOpen: n,
    open() {
      t("OPEN");
    },
    close() {
      t("CLOSE");
    },
    triggerProps: r.button({
      ...Su.trigger.attrs,
      id: Pr.getTriggerId(e.context),
      "aria-haspopup": "dialog",
      type: "button",
      "aria-expanded": n,
      "data-state": n ? "open" : "closed",
      "aria-controls": Pr.getContentId(e.context),
      onClick() {
        t("TOGGLE");
      }
    }),
    backdropProps: r.element({
      ...Su.backdrop.attrs,
      hidden: !n,
      id: Pr.getBackdropId(e.context),
      "data-state": n ? "open" : "closed"
    }),
    containerProps: r.element({
      ...Su.container.attrs,
      hidden: !n,
      id: Pr.getContainerId(e.context),
      "data-state": n ? "open" : "closed",
      style: {
        pointerEvents: n ? void 0 : "none"
      }
    }),
    contentProps: r.element({
      ...Su.content.attrs,
      role: e.context.role,
      hidden: !n,
      id: Pr.getContentId(e.context),
      tabIndex: -1,
      "data-state": n ? "open" : "closed",
      "aria-modal": !0,
      "aria-label": i || void 0,
      "aria-labelledby": i || !a.title ? void 0 : Pr.getTitleId(e.context),
      "aria-describedby": a.description ? Pr.getDescriptionId(e.context) : void 0
    }),
    titleProps: r.element({
      ...Su.title.attrs,
      id: Pr.getTitleId(e.context)
    }),
    descriptionProps: r.element({
      ...Su.description.attrs,
      id: Pr.getDescriptionId(e.context)
    }),
    closeTriggerProps: r.button({
      ...Su.closeTrigger.attrs,
      id: Pr.getCloseTriggerId(e.context),
      type: "button",
      onClick(o) {
        o.stopPropagation(), t("CLOSE");
      }
    })
  };
}
function WN(e) {
  const t = as(e);
  return $s(
    {
      id: "dialog",
      initial: t.open ? "open" : "closed",
      context: {
        role: "dialog",
        renderedElements: {
          title: !0,
          description: !0
        },
        modal: !0,
        trapFocus: !0,
        preventScroll: !0,
        closeOnOutsideClick: !0,
        closeOnEsc: !0,
        restoreFocus: !0,
        ...t
      },
      watch: {
        open: ["toggleVisibility"]
      },
      states: {
        open: {
          entry: ["checkRenderedElements"],
          activities: ["trackDismissableElement", "trapFocus", "preventScroll", "hideContentBelow"],
          on: {
            CLOSE: {
              target: "closed",
              actions: ["invokeOnClose", "restoreFocus"]
            },
            TOGGLE: {
              target: "closed",
              actions: ["invokeOnClose", "restoreFocus"]
            }
          }
        },
        closed: {
          on: {
            OPEN: {
              target: "open",
              actions: ["invokeOnOpen"]
            },
            TOGGLE: {
              target: "open",
              actions: ["invokeOnOpen"]
            }
          }
        }
      }
    },
    {
      activities: {
        trackDismissableElement(r, i, { send: n }) {
          return _2(() => Pr.getContentEl(r), {
            defer: !0,
            pointerBlocking: r.modal,
            exclude: [Pr.getTriggerEl(r)],
            onDismiss() {
              n({ type: "CLOSE", src: "interact-outside" });
            },
            onEscapeKeyDown(o) {
              var s;
              r.closeOnEsc ? n({ type: "CLOSE", src: "escape-key" }) : o.preventDefault(), (s = r.onEsc) == null || s.call(r);
            },
            onPointerDownOutside(o) {
              var s;
              r.closeOnOutsideClick || o.preventDefault(), (s = r.onOutsideClick) == null || s.call(r);
            }
          });
        },
        preventScroll(r) {
          if (r.preventScroll)
            return D3(Pr.getDoc(r));
        },
        trapFocus(r) {
          if (!r.trapFocus)
            return;
          let i;
          return hg(() => {
            const n = Pr.getContentEl(r);
            if (n) {
              i = F3(n, {
                document: Pr.getDoc(r),
                escapeDeactivates: !1,
                preventScroll: !0,
                returnFocusOnDeactivate: !1,
                fallbackFocus: n,
                allowOutsideClick: !0,
                initialFocus: fg(r.initialFocusEl)
              });
              try {
                i.activate();
              } catch {
              }
            }
          }), () => i == null ? void 0 : i.deactivate();
        },
        hideContentBelow(r) {
          return r.modal ? v3(() => [Pr.getContainerEl(r)], { defer: !0 }) : void 0;
        }
      },
      actions: {
        checkRenderedElements(r) {
          Wi(() => {
            r.renderedElements.title = !!Pr.getTitleEl(r), r.renderedElements.description = !!Pr.getDescriptionEl(r);
          });
        },
        invokeOnClose(r) {
          var i;
          (i = r.onClose) == null || i.call(r);
        },
        invokeOnOpen(r) {
          var i;
          (i = r.onOpen) == null || i.call(r);
        },
        toggleVisibility(r, i, { send: n }) {
          n({ type: r.open ? "OPEN" : "CLOSE", src: "controlled" });
        },
        restoreFocus(r) {
          r.restoreFocus && Wi(() => {
            const i = fg(r.finalFocusEl) ?? Pr.getTriggerEl(r);
            i == null || i.focus({ preventScroll: !0 });
          });
        }
      }
    }
  );
}
const GN = (e) => {
  const t = Vl(), r = {
    id: Co(),
    getRootNode: t,
    ...e
  }, [i, n] = Us(WN(r), { context: r });
  return VN(i, n, $l);
}, Iy = (e) => {
  const { children: t, ...r } = e, i = GN(r), n = cc(t, i);
  return /* @__PURE__ */ v.jsx(gN, { value: i, children: n });
}, T3 = Je((e, t) => {
  const [r, i] = ip(e), n = Vs();
  return /* @__PURE__ */ v.jsx(np, { present: n.isOpen, ...r, children: /* @__PURE__ */ v.jsx(KN, { ref: t, ...i }) });
});
T3.displayName = "DialogBackdrop";
const KN = Je(
  function(t, r) {
    const i = Vs(), n = zt(i.backdropProps, t);
    return /* @__PURE__ */ v.jsx(St.div, { ...n, ref: r });
  }
), S3 = Je(
  (e, t) => {
    const { closeTriggerProps: r } = Vs(), i = zt(r, e);
    return /* @__PURE__ */ v.jsx(St.button, { ...i, ref: t });
  }
);
S3.displayName = "DialogCloseTrigger";
const I3 = Je((e, t) => {
  const { containerProps: r } = Vs(), i = zt(r, e);
  return /* @__PURE__ */ v.jsx(St.div, { ...i, ref: t });
});
I3.displayName = "DialogContainer";
const B3 = Je((e, t) => {
  const [r, i] = ip(e), n = Vs();
  return /* @__PURE__ */ v.jsx(np, { present: n.isOpen, ...r, children: /* @__PURE__ */ v.jsx(YN, { ref: t, ...i }) });
});
B3.displayName = "DialogContent";
const YN = Je(
  function(t, r) {
    const i = Vs(), n = zt(i.contentProps, t);
    return /* @__PURE__ */ v.jsx(St.div, { ...n, ref: r });
  }
), R3 = Je(
  (e, t) => {
    const { descriptionProps: r } = Vs(), i = zt(r, e);
    return /* @__PURE__ */ v.jsx(St.p, { ...i, ref: t });
  }
);
R3.displayName = "DialogDescription";
const O3 = Je((e, t) => {
  const { titleProps: r } = Vs(), i = zt(r, e);
  return /* @__PURE__ */ v.jsx(St.h2, { ...i, ref: t });
});
O3.displayName = "DialogTitle";
const P3 = Je((e, t) => {
  const { triggerProps: r } = Vs(), i = zt(r, e);
  return /* @__PURE__ */ v.jsx(St.button, { ...i, ref: t });
});
P3.displayName = "DialogTrigger";
const Gl = Object.assign(Iy, {
  Root: Iy,
  Backdrop: T3,
  CloseTrigger: S3,
  Container: I3,
  Content: B3,
  Description: R3,
  Title: O3,
  Trigger: P3
}), [qN, os] = ns({
  name: "PopoverContext",
  hookName: "usePopoverContext",
  providerName: "<PopoverProvider />"
});
var QN = _o("popover").parts(
  "arrow",
  "arrowTip",
  "anchor",
  "trigger",
  "positioner",
  "content",
  "title",
  "description",
  "closeTrigger"
), Cs = QN.build(), It = Ul({
  getActiveEl: (e) => It.getDoc(e).activeElement,
  getAnchorId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.anchor) ?? `popover:${e.id}:anchor`;
  },
  getTriggerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.trigger) ?? `popover:${e.id}:trigger`;
  },
  getContentId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.content) ?? `popover:${e.id}:content`;
  },
  getPositionerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.positioner) ?? `popover:${e.id}:popper`;
  },
  getArrowId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.arrow) ?? `popover:${e.id}:arrow`;
  },
  getTitleId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.title) ?? `popover:${e.id}:title`;
  },
  getDescriptionId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.description) ?? `popover:${e.id}:desc`;
  },
  getCloseTriggerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.closeTrigger) ?? `popover:${e.id}:close`;
  },
  getAnchorEl: (e) => It.getById(e, It.getAnchorId(e)),
  getTriggerEl: (e) => It.getById(e, It.getTriggerId(e)),
  getContentEl: (e) => It.getById(e, It.getContentId(e)),
  getPositionerEl: (e) => It.getById(e, It.getPositionerId(e)),
  getTitleEl: (e) => It.getById(e, It.getTitleId(e)),
  getDescriptionEl: (e) => It.getById(e, It.getDescriptionId(e)),
  getFocusableEls: (e) => b2(It.getContentEl(e)),
  getFirstFocusableEl: (e) => It.getFocusableEls(e)[0],
  getDocTabbableEls: (e) => tc(It.getDoc(e).body),
  getTabbableEls: (e) => tc(It.getContentEl(e), "if-empty"),
  getFirstTabbableEl: (e) => QP(It.getContentEl(e), "if-empty"),
  getLastTabbableEl: (e) => XP(It.getContentEl(e), "if-empty"),
  getInitialFocusEl: (e) => {
    let t = fg(e.initialFocusEl);
    return !t && e.autoFocus && (t = It.getFirstFocusableEl(e)), t || (t = It.getContentEl(e)), t;
  }
});
function XN(e, t, r) {
  const i = e.matches("open"), n = e.context.currentPlacement, a = e.context.currentPortalled, o = e.context.renderedElements, s = m2({
    ...e.context.positioning,
    placement: n
  });
  return {
    portalled: a,
    isOpen: i,
    open() {
      t("OPEN");
    },
    close() {
      t("CLOSE");
    },
    setPositioning(l = {}) {
      t({ type: "SET_POSITIONING", options: l });
    },
    arrowProps: r.element({
      id: It.getArrowId(e.context),
      ...Cs.arrow.attrs,
      style: s.arrow
    }),
    arrowTipProps: r.element({
      ...Cs.arrowTip.attrs,
      style: s.arrowTip
    }),
    anchorProps: r.element({
      ...Cs.anchor.attrs,
      id: It.getAnchorId(e.context)
    }),
    triggerProps: r.button({
      ...Cs.trigger.attrs,
      type: "button",
      "data-placement": n,
      id: It.getTriggerId(e.context),
      "aria-haspopup": "dialog",
      "aria-expanded": i,
      "data-state": i ? "open" : "closed",
      "aria-controls": It.getContentId(e.context),
      onClick() {
        t("TOGGLE");
      },
      onBlur(l) {
        t({ type: "TRIGGER_BLUR", target: l.relatedTarget });
      }
    }),
    positionerProps: r.element({
      id: It.getPositionerId(e.context),
      ...Cs.positioner.attrs,
      style: s.floating
    }),
    contentProps: r.element({
      ...Cs.content.attrs,
      id: It.getContentId(e.context),
      tabIndex: -1,
      role: "dialog",
      hidden: !i,
      "data-state": i ? "open" : "closed",
      "data-expanded": pr(i),
      "aria-labelledby": o.title ? It.getTitleId(e.context) : void 0,
      "aria-describedby": o.description ? It.getDescriptionId(e.context) : void 0,
      "data-placement": n
    }),
    titleProps: r.element({
      ...Cs.title.attrs,
      id: It.getTitleId(e.context)
    }),
    descriptionProps: r.element({
      ...Cs.description.attrs,
      id: It.getDescriptionId(e.context)
    }),
    closeTriggerProps: r.button({
      ...Cs.closeTrigger.attrs,
      id: It.getCloseTriggerId(e.context),
      type: "button",
      "aria-label": "close",
      onClick() {
        t("REQUEST_CLOSE");
      }
    })
  };
}
function ZN(e) {
  const t = as(e);
  return $s(
    {
      id: "popover",
      initial: t.open ? "open" : "closed",
      context: {
        closeOnInteractOutside: !0,
        closeOnEsc: !0,
        autoFocus: !0,
        modal: !1,
        portalled: !0,
        positioning: {
          placement: "bottom",
          ...t.positioning
        },
        currentPlacement: void 0,
        ...t,
        renderedElements: {
          title: !0,
          description: !0
        }
      },
      computed: {
        currentPortalled: (r) => !!r.modal || !!r.portalled
      },
      watch: {
        open: ["toggleVisibility"]
      },
      entry: ["checkRenderedElements"],
      states: {
        closed: {
          on: {
            TOGGLE: {
              target: "open",
              actions: ["invokeOnOpen"]
            },
            OPEN: {
              target: "open",
              actions: ["invokeOnOpen"]
            }
          }
        },
        open: {
          activities: [
            "trapFocus",
            "preventScroll",
            "hideContentBelow",
            "trackPositioning",
            "trackDismissableElement",
            "proxyTabFocus"
          ],
          entry: ["setInitialFocus"],
          on: {
            CLOSE: {
              target: "closed",
              actions: ["invokeOnClose"]
            },
            REQUEST_CLOSE: {
              target: "closed",
              actions: ["restoreFocusIfNeeded", "invokeOnClose"]
            },
            TOGGLE: {
              target: "closed",
              actions: ["invokeOnClose"]
            },
            SET_POSITIONING: {
              actions: "setPositioning"
            }
          }
        }
      }
    },
    {
      activities: {
        trackPositioning(r) {
          r.currentPlacement = r.positioning.placement;
          const i = It.getAnchorEl(r) ?? It.getTriggerEl(r);
          return h1(i, () => It.getPositionerEl(r), {
            ...r.positioning,
            defer: !0,
            onComplete(a) {
              r.currentPlacement = a.placement;
            },
            onCleanup() {
              r.currentPlacement = void 0;
            }
          });
        },
        trackDismissableElement(r, i, { send: n }) {
          const a = () => It.getContentEl(r);
          let o = !0;
          return _2(a, {
            pointerBlocking: r.modal,
            exclude: It.getTriggerEl(r),
            defer: !0,
            onEscapeKeyDown(s) {
              var l;
              (l = r.onEscapeKeyDown) == null || l.call(r, s), !r.closeOnEsc && s.preventDefault();
            },
            onInteractOutside(s) {
              var l;
              (l = r.onInteractOutside) == null || l.call(r, s), !s.defaultPrevented && (o = !(s.detail.focusable || s.detail.contextmenu), r.closeOnInteractOutside || s.preventDefault());
            },
            onPointerDownOutside: r.onPointerDownOutside,
            onFocusOutside: r.onFocusOutside,
            onDismiss() {
              n({ type: "REQUEST_CLOSE", src: "interact-outside", restoreFocus: o });
            }
          });
        },
        proxyTabFocus(r) {
          return r.modal || !r.portalled ? void 0 : b3(() => It.getContentEl(r), {
            triggerElement: It.getTriggerEl(r),
            defer: !0,
            onFocus(n) {
              n.focus({ preventScroll: !0 });
            }
          });
        },
        hideContentBelow(r) {
          return r.modal ? v3(() => [It.getContentEl(r), It.getTriggerEl(r)], { defer: !0 }) : void 0;
        },
        preventScroll(r) {
          if (r.modal)
            return D3(It.getDoc(r));
        },
        trapFocus(r) {
          if (!r.modal)
            return;
          let i;
          return hg(() => {
            const n = It.getContentEl(r);
            if (n) {
              i = F3(n, {
                escapeDeactivates: !1,
                allowOutsideClick: !0,
                preventScroll: !0,
                returnFocusOnDeactivate: !0,
                document: It.getDoc(r),
                fallbackFocus: n,
                initialFocus: fg(r.initialFocusEl)
              });
              try {
                i.activate();
              } catch {
              }
            }
          }), () => i == null ? void 0 : i.deactivate();
        }
      },
      actions: {
        setPositioning(r, i) {
          const n = It.getAnchorEl(r) ?? It.getTriggerEl(r);
          h1(n, () => It.getPositionerEl(r), {
            ...r.positioning,
            ...i.options,
            defer: !0,
            listeners: !1
          });
        },
        checkRenderedElements(r) {
          Wi(() => {
            Object.assign(r.renderedElements, {
              title: !!It.getTitleEl(r),
              description: !!It.getDescriptionEl(r)
            });
          });
        },
        setInitialFocus(r) {
          Wi(() => {
            var i;
            (i = It.getInitialFocusEl(r)) == null || i.focus({ preventScroll: !0 });
          });
        },
        restoreFocusIfNeeded(r, i) {
          i.restoreFocus && Wi(() => {
            var n;
            (n = It.getTriggerEl(r)) == null || n.focus({ preventScroll: !0 });
          });
        },
        invokeOnOpen(r) {
          var i;
          (i = r.onOpen) == null || i.call(r);
        },
        invokeOnClose(r) {
          var i;
          (i = r.onClose) == null || i.call(r);
        },
        toggleVisibility(r, i, { send: n }) {
          n({ type: r.open ? "OPEN" : "CLOSE", src: "controlled" });
        }
      }
    }
  );
}
const JN = (e) => {
  const t = Vl(), r = {
    id: Co(),
    getRootNode: t,
    ...e
  }, [i, n] = Us(ZN(r), { context: r });
  return XN(i, n, $l);
}, By = (e) => {
  const { children: t, ...r } = e, i = JN(r), n = cc(t, i);
  return /* @__PURE__ */ v.jsx(qN, { value: i, children: n });
}, N3 = Je((e, t) => {
  const { anchorProps: r } = os(), i = zt(r, e);
  return /* @__PURE__ */ v.jsx(St.div, { ...i, ref: t });
});
N3.displayName = "PopoverAnchor";
const z3 = Je((e, t) => {
  const { arrowProps: r } = os(), i = zt(r, e);
  return /* @__PURE__ */ v.jsx(St.div, { ...i, ref: t });
});
z3.displayName = "PopoverArrow";
const L3 = Je((e, t) => {
  const { arrowTipProps: r } = os(), i = zt(r, e);
  return /* @__PURE__ */ v.jsx(St.div, { ...i, ref: t });
});
L3.displayName = "PopoverArrowTip";
const M3 = Je(
  (e, t) => {
    const { closeTriggerProps: r } = os(), i = zt(r, e);
    return /* @__PURE__ */ v.jsx(St.button, { ...i, ref: t });
  }
);
M3.displayName = "PopoverCloseTrigger";
const j3 = Je((e, t) => {
  const [r, i] = ip(e), n = os();
  return /* @__PURE__ */ v.jsx(np, { present: n.isOpen, ...r, children: /* @__PURE__ */ v.jsx(ez, { ref: t, ...i }) });
});
j3.displayName = "PopoverContent";
const ez = Je(
  function(t, r) {
    const i = os(), n = zt(i.contentProps, t);
    return /* @__PURE__ */ v.jsx(St.div, { ...n, ref: r });
  }
), H3 = Je(
  (e, t) => {
    const { descriptionProps: r } = os(), i = zt(r, e);
    return /* @__PURE__ */ v.jsx(St.p, { ...i, ref: t });
  }
);
H3.displayName = "PopoverDescription";
const $3 = Je(
  (e, t) => {
    const { positionerProps: r } = os(), i = zt(r, e);
    return /* @__PURE__ */ v.jsx(St.div, { ...i, ref: t });
  }
);
$3.displayName = "PopoverPositioner";
const U3 = Je((e, t) => {
  const { titleProps: r } = os(), i = zt(r, e);
  return /* @__PURE__ */ v.jsx(St.div, { ...i, ref: t });
});
U3.displayName = "PopoverTitle";
const V3 = Je((e, t) => {
  const { triggerProps: r } = os(), i = zt(r, e);
  return /* @__PURE__ */ v.jsx(St.button, { ...i, ref: t });
});
V3.displayName = "PopoverTrigger";
const ss = Object.assign(By, {
  Root: By,
  Anchor: N3,
  Arrow: z3,
  ArrowTip: L3,
  CloseTrigger: M3,
  Content: j3,
  Description: H3,
  Positioner: $3,
  Title: U3,
  Trigger: V3
}), [tz, Aa] = ns({
  name: "SelectContext",
  hookName: "useSelectContext",
  providerName: "<SelectProvider />"
});
var W3 = _o("select").parts(
  "label",
  "positioner",
  "trigger",
  "clearTrigger",
  "item",
  "itemText",
  "itemIndicator",
  "itemGroup",
  "itemGroupLabel",
  "content",
  "root",
  "control"
), Na = W3.build(), Ot = Ul({
  getRootId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.root) ?? `select:${e.id}`;
  },
  getContentId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.content) ?? `select:${e.id}:content`;
  },
  getTriggerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.trigger) ?? `select:${e.id}:trigger`;
  },
  getClearTriggerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.clearTrigger) ?? `select:${e.id}:clear-trigger`;
  },
  getLabelId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.label) ?? `select:${e.id}:label`;
  },
  getControlId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.control) ?? `select:${e.id}:control`;
  },
  getItemId: (e, t) => {
    var r, i;
    return ((i = (r = e.ids) == null ? void 0 : r.item) == null ? void 0 : i.call(r, t)) ?? `select:${e.id}:option:${t}`;
  },
  getHiddenSelectId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.hiddenSelect) ?? `select:${e.id}:select`;
  },
  getPositionerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.positioner) ?? `select:${e.id}:positioner`;
  },
  getItemGroupId: (e, t) => {
    var r, i;
    return ((i = (r = e.ids) == null ? void 0 : r.itemGroup) == null ? void 0 : i.call(r, t)) ?? `select:${e.id}:optgroup:${t}`;
  },
  getItemGroupLabelId: (e, t) => {
    var r, i;
    return ((i = (r = e.ids) == null ? void 0 : r.itemGroupLabel) == null ? void 0 : i.call(r, t)) ?? `select:${e.id}:optgroup-label:${t}`;
  },
  getHiddenSelectEl: (e) => Ot.getById(e, Ot.getHiddenSelectId(e)),
  getContentEl: (e) => Ot.getById(e, Ot.getContentId(e)),
  getControlEl: (e) => Ot.getById(e, Ot.getControlId(e)),
  getTriggerEl: (e) => Ot.getById(e, Ot.getTriggerId(e)),
  getClearTriggerEl: (e) => Ot.getById(e, Ot.getClearTriggerId(e)),
  getPositionerEl: (e) => Ot.getById(e, Ot.getPositionerId(e)),
  getHighlightedOptionEl(e) {
    return e.highlightedValue ? Ot.getById(e, Ot.getItemId(e, e.highlightedValue)) : null;
  }
});
function rz(e, t, r) {
  const i = e.context.isDisabled, n = e.context.invalid, a = e.context.readOnly, o = e.context.isInteractive, s = e.hasTag("open"), l = e.matches("focused"), u = e.context.highlightedItem, d = e.context.selectedItems, c = e.context.isTypingAhead;
  function p(g) {
    const { item: k } = g, y = e.context.collection.isItemDisabled(k), _ = e.context.collection.itemToValue(k);
    return {
      value: _,
      isDisabled: !!(y || i),
      isHighlighted: e.context.highlightedValue === _,
      isSelected: e.context.value.includes(_)
    };
  }
  const f = m2({
    ...e.context.positioning,
    placement: e.context.currentPlacement
  });
  return {
    isOpen: s,
    isFocused: l,
    highlightedItem: u,
    highlightedValue: e.context.highlightedValue,
    selectedItems: d,
    hasSelectedItems: e.context.hasSelectedItems,
    value: e.context.value,
    valueAsString: e.context.valueAsString,
    setCollection(g) {
      t({ type: "COLLECTION.SET", value: g });
    },
    focus() {
      var g;
      (g = Ot.getTriggerEl(e.context)) == null || g.focus({ preventScroll: !0 });
    },
    open() {
      t("OPEN");
    },
    close() {
      t("CLOSE");
    },
    selectValue(g) {
      t({ type: "ITEM.SELECT", value: g });
    },
    setValue(g) {
      t({ type: "VALUE.SET", value: g });
    },
    highlightValue(g) {
      t({ type: "HIGHLIGHTED_VALUE.SET", value: g });
    },
    clearValue(g) {
      t(g ? { type: "ITEM.CLEAR", value: g } : { type: "VALUE.CLEAR" });
    },
    getItemState: p,
    rootProps: r.element({
      ...Na.root.attrs,
      dir: e.context.dir,
      id: Ot.getRootId(e.context),
      "data-invalid": pr(n),
      "data-readonly": pr(a)
    }),
    labelProps: r.label({
      dir: e.context.dir,
      id: Ot.getLabelId(e.context),
      ...Na.label.attrs,
      "data-disabled": pr(i),
      "data-invalid": pr(n),
      "data-readonly": pr(a),
      htmlFor: Ot.getHiddenSelectId(e.context),
      onClick() {
        var g;
        i || (g = Ot.getTriggerEl(e.context)) == null || g.focus({ preventScroll: !0 });
      }
    }),
    controlProps: r.element({
      ...Na.control.attrs,
      dir: e.context.dir,
      id: Ot.getControlId(e.context),
      "data-state": s ? "open" : "closed",
      "data-focus": pr(l),
      "data-disabled": pr(i),
      "data-invalid": pr(n)
    }),
    triggerProps: r.button({
      id: Ot.getTriggerId(e.context),
      disabled: i,
      dir: e.context.dir,
      type: "button",
      "aria-controls": Ot.getContentId(e.context),
      "aria-expanded": s,
      "data-state": s ? "open" : "closed",
      "aria-haspopup": "listbox",
      "aria-labelledby": Ot.getLabelId(e.context),
      ...Na.trigger.attrs,
      "data-disabled": pr(i),
      "data-invalid": pr(n),
      "aria-invalid": n,
      "data-readonly": pr(a),
      "data-placement": e.context.currentPlacement,
      "data-placeholder-shown": pr(!e.context.hasSelectedItems),
      onPointerDown(g) {
        g.button || g.ctrlKey || !o || (g.currentTarget.dataset.pointerType = g.pointerType, !(i || g.pointerType === "touch") && t({ type: "TRIGGER.CLICK" }));
      },
      onClick(g) {
        !o || g.button || g.currentTarget.dataset.pointerType === "touch" && t({ type: "TRIGGER.CLICK" });
      },
      onFocus() {
        t("TRIGGER.FOCUS");
      },
      onBlur() {
        t("TRIGGER.BLUR");
      },
      onKeyDown(g) {
        if (!o)
          return;
        const y = {
          ArrowUp() {
            t({ type: "TRIGGER.ARROW_UP" });
          },
          ArrowDown(_) {
            t({ type: _.altKey ? "OPEN" : "TRIGGER.ARROW_DOWN" });
          },
          ArrowLeft() {
            t({ type: "TRIGGER.ARROW_LEFT" });
          },
          ArrowRight() {
            t({ type: "TRIGGER.ARROW_RIGHT" });
          },
          Home() {
            t({ type: "TRIGGER.HOME" });
          },
          End() {
            t({ type: "TRIGGER.END" });
          },
          Enter() {
            t({ type: "TRIGGER.ENTER" });
          },
          Space(_) {
            t(c ? { type: "TRIGGER.TYPEAHEAD", key: _.key } : { type: "TRIGGER.ENTER" });
          }
        }[Rb(g, e.context)];
        if (y) {
          y(g), g.preventDefault();
          return;
        }
        Sb.isValidEvent(g) && (t({ type: "TRIGGER.TYPEAHEAD", key: g.key }), g.preventDefault());
      }
    }),
    getItemProps(g) {
      const k = p(g);
      return r.element({
        id: Ot.getItemId(e.context, k.value),
        role: "option",
        ...Na.item.attrs,
        dir: e.context.dir,
        "data-value": k.value,
        "aria-selected": k.isSelected,
        "data-state": k.isSelected ? "checked" : "unchecked",
        "data-highlighted": pr(k.isHighlighted),
        "data-disabled": pr(k.isDisabled),
        "aria-disabled": JR(k.isDisabled),
        onPointerMove(y) {
          k.isDisabled || y.pointerType !== "mouse" || k.value !== e.context.highlightedValue && t({ type: "ITEM.POINTER_MOVE", value: k.value });
        },
        onPointerUp() {
          k.isDisabled || t({ type: "ITEM.CLICK", src: "pointerup", value: k.value });
        },
        onPointerLeave(y) {
          k.isDisabled || y.pointerType !== "mouse" || t({ type: "ITEM.POINTER_LEAVE" });
        }
      });
    },
    getItemTextProps(g) {
      const k = p(g);
      return r.element({
        ...Na.itemText.attrs,
        dir: e.context.dir,
        "data-disabled": pr(k.isDisabled),
        "data-highlighted": pr(k.isHighlighted)
      });
    },
    getItemIndicatorProps(g) {
      const k = p(g);
      return r.element({
        "aria-hidden": !0,
        ...Na.itemIndicator.attrs,
        dir: e.context.dir,
        "data-state": k.isSelected ? "checked" : "unchecked",
        hidden: !k.isSelected
      });
    },
    getItemGroupLabelProps(g) {
      const { htmlFor: k } = g;
      return r.element({
        ...Na.itemGroupLabel.attrs,
        id: Ot.getItemGroupId(e.context, k),
        role: "group",
        dir: e.context.dir
      });
    },
    getItemGroupProps(g) {
      const { id: k } = g;
      return r.element({
        ...Na.itemGroup.attrs,
        "data-disabled": pr(i),
        id: Ot.getItemGroupId(e.context, k),
        "aria-labelledby": Ot.getItemGroupLabelId(e.context, k),
        dir: e.context.dir
      });
    },
    clearTriggerProps: r.button({
      ...Na.clearTrigger.attrs,
      id: Ot.getClearTriggerId(e.context),
      type: "button",
      "aria-label": "Clear value",
      hidden: !e.context.hasSelectedItems,
      dir: e.context.dir,
      onClick() {
        t("VALUE.CLEAR");
      }
    }),
    hiddenSelectProps: r.select({
      name: e.context.name,
      form: e.context.form,
      disabled: !o,
      multiple: e.context.multiple,
      "aria-hidden": !0,
      id: Ot.getHiddenSelectId(e.context),
      // defaultValue: state.context.selectedOption?.value,
      style: l2,
      tabIndex: -1,
      // Some browser extensions will focus the hidden select.
      // Let's forward the focus to the trigger.
      onFocus() {
        var g;
        (g = Ot.getTriggerEl(e.context)) == null || g.focus({ preventScroll: !0 });
      },
      "aria-labelledby": Ot.getLabelId(e.context)
    }),
    positionerProps: r.element({
      ...Na.positioner.attrs,
      id: Ot.getPositionerId(e.context),
      style: f.floating
    }),
    contentProps: r.element({
      hidden: !s,
      dir: e.context.dir,
      id: Ot.getContentId(e.context),
      role: "listbox",
      ...Na.content.attrs,
      "data-state": s ? "open" : "closed",
      "aria-activedescendant": e.context.highlightedValue || "",
      "aria-multiselectable": e.context.multiple ? "true" : void 0,
      "aria-labelledby": Ot.getLabelId(e.context),
      tabIndex: 0,
      onKeyDown(g) {
        if (!o || !H8(g))
          return;
        const k = {
          ArrowUp() {
            t({ type: "CONTENT.ARROW_UP" });
          },
          ArrowDown() {
            t({ type: "CONTENT.ARROW_DOWN" });
          },
          Home() {
            t({ type: "CONTENT.HOME" });
          },
          End() {
            t({ type: "CONTENT.END" });
          },
          Enter() {
            t({ type: "CONTENT.ENTER" });
          },
          Space(_) {
            var A;
            c ? t({ type: "CONTENT.TYPEAHEAD", key: _.key }) : (A = k.Enter) == null || A.call(k, _);
          }
        }, y = k[Rb(g)];
        if (y) {
          y(g), g.preventDefault();
          return;
        }
        dO(g.target) || Sb.isValidEvent(g) && (t({ type: "CONTENT.TYPEAHEAD", key: g.key }), g.preventDefault());
      }
    })
  };
}
var D2 = (e) => Kd(new _3(e));
D2.empty = () => Kd(new _3({ items: [] }));
var { and: uk, not: Iu } = rp;
function iz(e) {
  const t = as(e);
  return $s(
    {
      id: "select",
      context: {
        value: [],
        highlightedValue: null,
        selectOnBlur: !1,
        loop: !1,
        closeOnSelect: !0,
        disabled: !1,
        ...t,
        collection: t.collection ?? D2.empty(),
        typeahead: Sb.defaultOptions,
        fieldsetDisabled: !1,
        positioning: {
          placement: "bottom-start",
          gutter: 8,
          ...t.positioning
        }
      },
      computed: {
        hasSelectedItems: (r) => r.value.length > 0,
        isTypingAhead: (r) => r.typeahead.keysSoFar !== "",
        isDisabled: (r) => !!r.disabled || r.fieldsetDisabled,
        isInteractive: (r) => !(r.isDisabled || r.readOnly),
        selectedItems: (r) => r.collection.items(r.value),
        highlightedItem: (r) => r.collection.item(r.highlightedValue),
        valueAsString: (r) => r.collection.itemsToString(r.selectedItems)
      },
      initial: "idle",
      watch: {
        open: ["toggleVisibility"],
        value: ["syncSelectElement"]
      },
      on: {
        "HIGHLIGHTED_VALUE.SET": {
          actions: ["setHighlightedItem"]
        },
        "ITEM.SELECT": {
          actions: ["selectItem"]
        },
        "ITEM.CLEAR": {
          actions: ["clearItem"]
        },
        "VALUE.SET": {
          actions: ["setSelectedItems"]
        },
        "VALUE.CLEAR": {
          actions: ["clearSelectedItems"]
        },
        "COLLECTION.SET": {
          actions: ["setCollection"]
        }
      },
      activities: ["trackFormControlState"],
      states: {
        idle: {
          tags: ["closed"],
          on: {
            "TRIGGER.CLICK": {
              target: "open",
              actions: ["invokeOnOpen", "highlightFirstSelectedItem"]
            },
            "TRIGGER.FOCUS": {
              target: "focused"
            },
            OPEN: {
              target: "open",
              actions: ["invokeOnOpen"]
            }
          }
        },
        focused: {
          tags: ["closed"],
          entry: ["focusTriggerEl"],
          on: {
            OPEN: {
              target: "open",
              actions: ["invokeOnOpen"]
            },
            "TRIGGER.BLUR": {
              target: "idle"
            },
            "TRIGGER.CLICK": {
              target: "open",
              actions: ["invokeOnOpen", "highlightFirstSelectedItem"]
            },
            "TRIGGER.ENTER": [
              {
                guard: "hasSelectedItems",
                target: "open",
                actions: ["highlightFirstSelectedItem", "invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["highlightFirstItem", "invokeOnOpen"]
              }
            ],
            "TRIGGER.ARROW_UP": [
              {
                guard: "hasSelectedItems",
                target: "open",
                actions: ["highlightFirstSelectedItem", "invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["highlightLastItem", "invokeOnOpen"]
              }
            ],
            "TRIGGER.ARROW_DOWN": [
              {
                guard: "hasSelectedItems",
                target: "open",
                actions: ["highlightFirstSelectedItem", "invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["highlightFirstItem", "invokeOnOpen"]
              }
            ],
            "TRIGGER.ARROW_LEFT": [
              {
                guard: uk(Iu("multiple"), "hasSelectedItems"),
                actions: ["selectPreviousItem"]
              },
              {
                guard: Iu("multiple"),
                actions: ["selectLastItem"]
              }
            ],
            "TRIGGER.ARROW_RIGHT": [
              {
                guard: uk(Iu("multiple"), "hasSelectedItems"),
                actions: ["selectNextItem"]
              },
              {
                guard: Iu("multiple"),
                actions: ["selectFirstItem"]
              }
            ],
            "TRIGGER.HOME": {
              guard: Iu("multiple"),
              actions: ["selectFirstItem"]
            },
            "TRIGGER.END": {
              guard: Iu("multiple"),
              actions: ["selectLastItem"]
            },
            "TRIGGER.TYPEAHEAD": {
              guard: Iu("multiple"),
              actions: ["selectMatchingItem"]
            }
          }
        },
        open: {
          tags: ["open"],
          entry: ["focusContentEl"],
          exit: ["scrollContentToTop"],
          activities: ["trackDismissableElement", "computePlacement", "scrollToHighlightedItem", "proxyTabFocus"],
          on: {
            CLOSE: {
              target: "focused",
              actions: ["clearHighlightedItem", "invokeOnClose"]
            },
            "TRIGGER.CLICK": {
              target: "focused",
              actions: ["clearHighlightedItem", "invokeOnClose"]
            },
            "ITEM.CLICK": [
              {
                guard: "closeOnSelect",
                target: "focused",
                actions: ["selectHighlightedItem", "clearHighlightedItem", "invokeOnClose"]
              },
              {
                guard: "multiple",
                actions: ["selectHighlightedItem"]
              },
              {
                actions: ["selectHighlightedItem", "clearHighlightedItem"]
              }
            ],
            "CONTENT.ENTER": [
              {
                guard: "closeOnSelect",
                target: "focused",
                actions: ["selectHighlightedItem", "clearHighlightedItem", "invokeOnClose"]
              },
              {
                guard: "multiple",
                actions: ["selectHighlightedItem"]
              },
              {
                actions: ["selectHighlightedItem", "clearHighlightedItem"]
              }
            ],
            "CONTENT.INTERACT_OUTSIDE": [
              {
                guard: uk("selectOnBlur", "hasHighlightedItem"),
                target: "idle",
                actions: ["selectHighlightedItem", "invokeOnClose", "clearHighlightedItem"]
              },
              {
                guard: "isTargetFocusable",
                target: "idle",
                actions: ["clearHighlightedItem", "invokeOnClose"]
              },
              {
                target: "focused",
                actions: ["clearHighlightedItem", "invokeOnClose"]
              }
            ],
            "CONTENT.HOME": {
              actions: ["highlightFirstItem"]
            },
            "CONTENT.END": {
              actions: ["highlightLastItem"]
            },
            "CONTENT.ARROW_DOWN": [
              {
                guard: "hasHighlightedItem",
                actions: ["highlightNextItem"]
              },
              {
                actions: ["highlightFirstItem"]
              }
            ],
            "CONTENT.ARROW_UP": [
              {
                guard: "hasHighlightedItem",
                actions: ["highlightPreviousItem"]
              },
              {
                actions: ["highlightLastItem"]
              }
            ],
            "CONTENT.TYPEAHEAD": {
              actions: ["highlightMatchingItem"]
            },
            "ITEM.POINTER_MOVE": {
              actions: ["highlightItem"]
            },
            "ITEM.POINTER_LEAVE": {
              actions: ["clearHighlightedItem"]
            }
          }
        }
      }
    },
    {
      guards: {
        multiple: (r) => !!r.multiple,
        hasSelectedItems: (r) => r.hasSelectedItems,
        hasHighlightedItem: (r) => r.highlightedValue != null,
        selectOnBlur: (r) => !!r.selectOnBlur,
        closeOnSelect: (r, i) => r.multiple ? !1 : !!(i.closeOnSelect ?? r.closeOnSelect),
        isTargetFocusable: (r, i) => !!i.focusable
      },
      activities: {
        proxyTabFocus(r) {
          return b3(() => Ot.getContentEl(r), {
            defer: !0,
            triggerElement: Ot.getTriggerEl(r),
            onFocus(n) {
              Wi(() => n.focus({ preventScroll: !0 }));
            }
          });
        },
        trackFormControlState(r, i, { initialContext: n }) {
          return u2(Ot.getHiddenSelectEl(r), {
            onFieldsetDisabledChange(a) {
              r.fieldsetDisabled = a;
            },
            onFormReset() {
              Oi.selectedItems(r, n.value);
            }
          });
        },
        trackDismissableElement(r, i, { send: n }) {
          let a = !1;
          return _2(() => Ot.getContentEl(r), {
            defer: !0,
            exclude: [Ot.getTriggerEl(r), Ot.getClearTriggerEl(r)],
            onFocusOutside: r.onFocusOutside,
            onPointerDownOutside: r.onPointerDownOutside,
            onInteractOutside(s) {
              var l;
              a = s.detail.focusable, (l = r.onInteractOutside) == null || l.call(r, s);
            },
            onDismiss() {
              n({ type: "CONTENT.INTERACT_OUTSIDE", focusable: a });
            }
          });
        },
        computePlacement(r) {
          return r.currentPlacement = r.positioning.placement, h1(() => Ot.getTriggerEl(r), () => Ot.getPositionerEl(r), {
            defer: !0,
            ...r.positioning,
            onComplete(a) {
              r.currentPlacement = a.placement;
            }
          });
        },
        scrollToHighlightedItem(r, i, { getState: n }) {
          const a = () => {
            if (n().event.type.startsWith("ITEM.POINTER"))
              return;
            const s = Ot.getHighlightedOptionEl(r);
            s == null || s.scrollIntoView({ block: "nearest" });
          };
          return Wi(() => {
            a();
          }), o2(Ot.getContentEl(r), ["aria-activedescendant"], a);
        }
      },
      actions: {
        toggleVisibility(r, i, { send: n }) {
          n({ type: r.open ? "OPEN" : "CLOSE", src: "controlled" });
        },
        highlightPreviousItem(r) {
          if (r.highlightedValue == null)
            return;
          const i = r.collection.prev(r.highlightedValue);
          Oi.highlightedItem(r, i);
        },
        highlightNextItem(r) {
          if (r.highlightedValue == null)
            return;
          const i = r.collection.next(r.highlightedValue);
          Oi.highlightedItem(r, i);
        },
        highlightFirstItem(r) {
          const i = r.collection.first();
          Oi.highlightedItem(r, i);
        },
        highlightLastItem(r) {
          const i = r.collection.last();
          Oi.highlightedItem(r, i);
        },
        focusContentEl(r) {
          Wi(() => {
            var i;
            (i = Ot.getContentEl(r)) == null || i.focus({ preventScroll: !0 });
          });
        },
        focusTriggerEl(r) {
          Wi(() => {
            var i;
            (i = Ot.getTriggerEl(r)) == null || i.focus({ preventScroll: !0 });
          });
        },
        selectHighlightedItem(r, i) {
          const n = i.value ?? r.highlightedValue;
          n != null && Oi.selectedItem(r, n);
        },
        highlightFirstSelectedItem(r) {
          if (!r.hasSelectedItems)
            return;
          const [i] = r.collection.sort(r.value);
          Oi.highlightedItem(r, i);
        },
        highlightItem(r, i) {
          Oi.highlightedItem(r, i.value);
        },
        highlightMatchingItem(r, i) {
          const n = r.collection.search(i.key, {
            state: r.typeahead,
            currentValue: r.highlightedValue
          });
          n != null && Oi.highlightedItem(r, n);
        },
        setHighlightedItem(r, i) {
          Oi.highlightedItem(r, i.value);
        },
        clearHighlightedItem(r) {
          Oi.highlightedItem(r, null, !0);
        },
        selectItem(r, i) {
          Oi.selectedItem(r, i.value);
        },
        clearItem(r, i) {
          const n = r.value.filter((a) => a !== i.value);
          Oi.selectedItems(r, n);
        },
        setSelectedItems(r, i) {
          Oi.selectedItems(r, i.value);
        },
        clearSelectedItems(r) {
          Oi.selectedItems(r, []);
        },
        selectPreviousItem(r) {
          const i = r.collection.prev(r.value[0]);
          Oi.selectedItem(r, i);
        },
        selectNextItem(r) {
          const i = r.collection.next(r.value[0]);
          Oi.selectedItem(r, i);
        },
        selectFirstItem(r) {
          const i = r.collection.first();
          Oi.selectedItem(r, i);
        },
        selectLastItem(r) {
          const i = r.collection.last();
          Oi.selectedItem(r, i);
        },
        selectMatchingItem(r, i) {
          const n = r.collection.search(i.key, {
            state: r.typeahead,
            currentValue: r.value[0]
          });
          n != null && Oi.selectedItem(r, n);
        },
        scrollContentToTop(r) {
          var i;
          (i = Ot.getContentEl(r)) == null || i.scrollTo(0, 0);
        },
        invokeOnOpen(r) {
          var i;
          (i = r.onOpen) == null || i.call(r);
        },
        invokeOnClose(r) {
          var i;
          (i = r.onClose) == null || i.call(r);
        },
        syncSelectElement(r) {
          const i = Ot.getHiddenSelectEl(r);
          i && KO(i, r.value.join(","), { type: "HTMLSelectElement" });
        },
        setCollection(r, i) {
          r.collection = i.value;
        }
      }
    }
  );
}
function nz(e) {
  const t = Ot.getHiddenSelectEl(e);
  if (!t)
    return;
  const r = Ot.getWin(e), i = new r.Event("change", { bubbles: !0 });
  t.dispatchEvent(i);
}
var qh = {
  change: (e) => {
    var t;
    (t = e.onChange) == null || t.call(e, { value: Array.from(e.value), items: e.selectedItems }), nz(e);
  },
  highlightChange: (e) => {
    var t;
    (t = e.onHighlight) == null || t.call(e, { value: e.highlightedValue, item: e.highlightedItem });
  }
}, Oi = {
  selectedItem: (e, t, r = !1) => {
    if (Ku(e.value, t) || t == null && !r)
      return;
    if (t == null && r) {
      e.value = [], qh.change(e);
      return;
    }
    const i = e.multiple ? xO(e.value, t) : [t];
    e.value = i, qh.change(e);
  },
  selectedItems: (e, t) => {
    Ku(e.value, t) || (e.value = t, qh.change(e));
  },
  highlightedItem: (e, t, r = !1) => {
    Ku(e.highlightedValue, t) || t == null && !r || (e.highlightedValue = t ?? null, qh.highlightChange(e));
  }
};
const az = (e) => {
  const [t, r] = oa()(e, [
    "isItemDisabled",
    "itemToValue",
    "itemToString",
    "items"
  ]), i = D2(t), n = Vl(), a = {
    id: Co(),
    getRootNode: n,
    collection: i,
    ...r,
    value: e.defaultValue
  }, o = {
    ...a,
    collection: i,
    value: e.value
  }, [s, l] = Us(iz(a), {
    context: o
  });
  return rz(s, l, $l);
}, oz = (e, t) => {
  const [r, { children: i, ...n }] = oa()(
    e,
    [
      "closeOnSelect",
      "defaultValue",
      "dir",
      "disabled",
      "form",
      "getRootNode",
      "highlightedValue",
      "id",
      "ids",
      "invalid",
      "isItemDisabled",
      "items",
      "itemToString",
      "itemToValue",
      "loop",
      "multiple",
      "name",
      "onChange",
      "onClose",
      "onFocusOutside",
      "onHighlight",
      "onInteractOutside",
      "onOpen",
      "onPointerDownOutside",
      "open",
      "positioning",
      "readOnly",
      "selectOnBlur",
      "value"
    ]
  ), a = az(r), o = cc(i, a), s = zt(a.rootProps, n);
  return /* @__PURE__ */ v.jsx(tz, { value: a, children: /* @__PURE__ */ v.jsx(St.div, { ...s, ref: t, children: o }) });
}, Ry = Je(oz), G3 = Je(
  (e, t) => {
    const r = Aa(), i = zt(r.clearTriggerProps, e);
    return /* @__PURE__ */ v.jsx(St.button, { ...i, ref: t });
  }
);
G3.displayName = "SelectClearTrigger";
const K3 = Je((e, t) => {
  const [r, i] = ip(e), n = Aa();
  return /* @__PURE__ */ v.jsx(np, { present: n.isOpen, ...r, children: /* @__PURE__ */ v.jsx(sz, { ref: t, ...i }) });
});
K3.displayName = "SelectContent";
const sz = Je(
  function(t, r) {
    const i = Aa(), n = zt(i.contentProps, t);
    return /* @__PURE__ */ v.jsx(St.div, { ...n, ref: r });
  }
), Y3 = Je((e, t) => {
  const r = Aa(), i = zt(r.controlProps, e);
  return /* @__PURE__ */ v.jsx(St.div, { ...i, ref: t });
});
Y3.displayName = "SelectControl";
const [lz, q3] = ns({
  name: "SelectItemContext",
  hookName: "useSelectItemContext",
  providerName: "<SelectItemProvider />"
}), Q3 = Je((e, t) => {
  const [r, { children: i, ...n }] = oa()(e, ["item"]), a = Aa(), o = zt(a.getItemProps(r), n), s = a.getItemState(r), l = cc(i, s);
  return /* @__PURE__ */ v.jsx(lz, { value: r, children: /* @__PURE__ */ v.jsx(St.div, { ...o, ref: t, children: l }) });
});
Q3.displayName = "SelectItem";
const X3 = Je((e, t) => {
  const [r, i] = oa()(e, ["id"]), n = Aa(), a = zt(n.getItemGroupProps(r), i);
  return /* @__PURE__ */ v.jsx(St.div, { ...a, ref: t });
});
X3.displayName = "SelectItemGroup";
const Z3 = Je(
  (e, t) => {
    const [r, i] = oa()(e, [
      "htmlFor"
    ]), n = Aa(), a = zt(n.getItemGroupLabelProps(r), i);
    return /* @__PURE__ */ v.jsx(St.div, { ...a, ref: t });
  }
);
Z3.displayName = "SelectItemGroupLabel";
const J3 = Je(
  (e, t) => {
    const r = Aa(), i = q3(), n = zt(r.getItemIndicatorProps(i), e);
    return /* @__PURE__ */ v.jsx(St.div, { ...n, ref: t });
  }
);
J3.displayName = "SelectItemIndicator";
const e6 = Je((e, t) => {
  const r = Aa(), i = q3(), n = zt(r.getItemTextProps(i), e);
  return /* @__PURE__ */ v.jsx(St.span, { ...n, ref: t });
});
e6.displayName = "SelectItemText";
const t6 = Je((e, t) => {
  const r = Aa(), i = zt(r.labelProps, e);
  return /* @__PURE__ */ v.jsx(St.label, { ...i, ref: t });
});
t6.displayName = "SelectLabel";
const r6 = Je((e, t) => {
  const r = Aa(), i = zt(r.positionerProps, e);
  return /* @__PURE__ */ v.jsx(St.div, { ...i, ref: t });
});
r6.displayName = "SelectPositioner";
const i6 = Je((e, t) => {
  const r = Aa(), i = zt(r.triggerProps, e);
  return /* @__PURE__ */ v.jsx(St.button, { ...i, ref: t });
});
i6.displayName = "SelectTrigger";
const uz = W3.extendWith("value"), cz = uz.build(), n6 = Je((e, t) => {
  const { children: r, placeholder: i, ...n } = e, a = Aa();
  return /* @__PURE__ */ v.jsx(St.span, { ...cz.value.attrs, ...n, ref: t, children: r || a.valueAsString || i });
});
n6.displayName = "SelectValue";
const wa = Object.assign(Ry, {
  Root: Ry,
  ClearTrigger: G3,
  Content: K3,
  Control: Y3,
  Item: Q3,
  ItemGroup: X3,
  ItemGroupLabel: Z3,
  ItemIndicator: J3,
  ItemText: e6,
  Label: t6,
  Positioner: r6,
  Trigger: i6,
  Value: n6
}), [dz, y2] = ns({
  name: "SwitchContext",
  hookName: "useSwitchContext",
  providerName: "<SwitchProvider />"
});
var pz = _o("switch").parts("root", "label", "control", "thumb"), Qh = pz.build(), _a = Ul({
  getRootId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.root) ?? `switch:${e.id}`;
  },
  getLabelId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.label) ?? `switch:${e.id}:label`;
  },
  getThumbId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.thumb) ?? `switch:${e.id}:thumb`;
  },
  getControlId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.control) ?? `switch:${e.id}:control`;
  },
  getHiddenInputId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.input) ?? `switch:${e.id}:input`;
  },
  getHiddenInputEl: (e) => _a.getById(e, _a.getHiddenInputId(e))
});
function hz(e, t, r) {
  const i = e.context.isDisabled, n = !i && e.context.focused, a = e.context.checked, o = {
    "data-active": pr(e.context.active),
    "data-focus": pr(n),
    "data-hover": pr(e.context.hovered),
    "data-disabled": pr(i),
    "data-state": e.context.checked ? "checked" : "unchecked",
    "data-invalid": pr(e.context.invalid)
  };
  return {
    isChecked: a,
    isDisabled: i,
    isFocused: n,
    setChecked(s) {
      t({ type: "CHECKED.SET", checked: s, isTrusted: !1 });
    },
    toggleChecked() {
      t({ type: "CHECKED.TOGGLE", checked: a, isTrusted: !1 });
    },
    rootProps: r.label({
      ...Qh.root.attrs,
      ...o,
      id: _a.getRootId(e.context),
      htmlFor: _a.getHiddenInputId(e.context),
      onPointerMove() {
        i || t({ type: "CONTEXT.SET", context: { hovered: !0 } });
      },
      onPointerLeave() {
        i || t({ type: "CONTEXT.SET", context: { hovered: !1 } });
      },
      onPointerDown(s) {
        i || (n && s.preventDefault(), t({ type: "CONTEXT.SET", context: { active: !0 } }));
      },
      onPointerUp() {
        i || t({ type: "CONTEXT.SET", context: { active: !1 } });
      },
      onClick(s) {
        s.target === _a.getHiddenInputEl(e.context) && s.stopPropagation();
      }
    }),
    labelProps: r.element({
      ...Qh.label.attrs,
      ...o,
      id: _a.getLabelId(e.context)
    }),
    thumbProps: r.element({
      ...Qh.thumb.attrs,
      ...o,
      id: _a.getThumbId(e.context),
      "aria-hidden": !0
    }),
    controlProps: r.element({
      ...Qh.control.attrs,
      ...o,
      id: _a.getControlId(e.context),
      "aria-hidden": !0
    }),
    hiddenInputProps: r.input({
      id: _a.getHiddenInputId(e.context),
      type: "checkbox",
      required: e.context.required,
      defaultChecked: a,
      disabled: i,
      "aria-labelledby": _a.getLabelId(e.context),
      "aria-invalid": e.context.invalid,
      name: e.context.name,
      form: e.context.form,
      value: e.context.value,
      style: l2,
      onChange(s) {
        const l = s.currentTarget.checked;
        t({ type: "CHECKED.SET", checked: l, isTrusted: !0 });
      },
      onBlur() {
        t({ type: "CONTEXT.SET", context: { focused: !1 } });
      },
      onFocus() {
        t({ type: "CONTEXT.SET", context: { focused: !0 } });
      },
      onKeyDown(s) {
        s.key === " " && t({ type: "CONTEXT.SET", context: { active: !0 } });
      },
      onKeyUp(s) {
        s.key === " " && t({ type: "CONTEXT.SET", context: { active: !1 } });
      }
    })
  };
}
var { not: Oy } = rp;
function fz(e) {
  const t = as(e);
  return $s(
    {
      id: "switch",
      initial: "ready",
      context: {
        checked: !1,
        label: "switch",
        value: "on",
        disabled: !1,
        ...t,
        fieldsetDisabled: !1
      },
      computed: {
        isDisabled: (r) => r.disabled || r.fieldsetDisabled
      },
      watch: {
        disabled: "removeFocusIfNeeded",
        checked: "syncInputElement"
      },
      activities: ["trackFormControlState"],
      on: {
        "CHECKED.TOGGLE": [
          {
            guard: Oy("isTrusted"),
            actions: ["toggleChecked", "dispatchChangeEvent"]
          },
          {
            actions: ["toggleChecked"]
          }
        ],
        "CHECKED.SET": [
          {
            guard: Oy("isTrusted"),
            actions: ["setChecked", "dispatchChangeEvent"]
          },
          {
            actions: ["setChecked"]
          }
        ],
        "CONTEXT.SET": {
          actions: ["setContext"]
        }
      },
      states: {
        ready: {}
      }
    },
    {
      guards: {
        isTrusted: (r, i) => !!i.isTrusted
      },
      activities: {
        trackFormControlState(r, i, { send: n, initialContext: a }) {
          return u2(_a.getHiddenInputEl(r), {
            onFieldsetDisabledChange(o) {
              r.fieldsetDisabled = o;
            },
            onFormReset() {
              n({ type: "CHECKED.SET", checked: !!a.checked, src: "form-reset" });
            }
          });
        }
      },
      actions: {
        setContext(r, i) {
          Object.assign(r, i.context);
        },
        syncInputElement(r) {
          const i = _a.getHiddenInputEl(r);
          i && (i.checked = !!r.checked);
        },
        removeFocusIfNeeded(r) {
          r.disabled && r.focused && (r.focused = !1);
        },
        setChecked(r, i) {
          Py.checked(r, i.checked);
        },
        toggleChecked(r, i) {
          Py.checked(r, !r.checked);
        },
        dispatchChangeEvent(r) {
          const i = _a.getHiddenInputEl(r);
          r3(i, { checked: r.checked });
        }
      }
    }
  );
}
var gz = {
  change: (e) => {
    var t;
    (t = e.onChange) == null || t.call(e, { checked: e.checked });
  }
}, Py = {
  checked: (e, t) => {
    Ku(e.checked, t) || (e.checked = t, gz.change(e));
  }
};
const mz = (e) => {
  const t = Vl(), r = {
    id: Co(),
    getRootNode: t,
    ...e,
    checked: e.defaultChecked
  }, i = {
    ...r,
    checked: e.checked
  }, [n, a] = Us(fz(r), { context: i });
  return hz(n, a, $l);
}, Hb = Je((e, t) => {
  const [r, { children: i, ...n }] = oa()(e, [
    "checked",
    "defaultChecked",
    "dir",
    "disabled",
    "form",
    "getRootNode",
    "id",
    "ids",
    "invalid",
    "label",
    "name",
    "onChange",
    "readOnly",
    "required",
    "value"
  ]), a = mz(r), o = cc(i, a), s = zt(a.rootProps, n);
  return /* @__PURE__ */ v.jsxs(dz, { value: a, children: [
    /* @__PURE__ */ v.jsx(St.label, { ...s, ref: t, children: o }),
    /* @__PURE__ */ v.jsx("input", { ...a.hiddenInputProps })
  ] });
});
Hb.displayName = "Switch";
const a6 = Je((e, t) => {
  const r = y2(), i = zt(r.controlProps, e);
  return /* @__PURE__ */ v.jsx(St.span, { ...i, ref: t });
});
a6.displayName = "SwitchControl";
const o6 = Je((e, t) => {
  const { labelProps: r } = y2(), i = zt(r, e);
  return /* @__PURE__ */ v.jsx(St.span, { ...i, ref: t });
});
o6.displayName = "SwitchLabel";
const s6 = Je((e, t) => {
  const { thumbProps: r } = y2(), i = zt(r, e);
  return /* @__PURE__ */ v.jsx(St.span, { ...i, ref: t });
});
s6.displayName = "SwitchThumb";
const lm = Object.assign(Hb, {
  Root: Hb,
  Control: a6,
  Label: o6,
  Thumb: s6
});
var vz = _o("tabs").parts("root", "list", "trigger", "content", "indicator"), k0 = vz.build(), Xt = Ul({
  getRootId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.root) ?? `tabs:${e.id}`;
  },
  getTablistId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.tablist) ?? `tabs:${e.id}:list`;
  },
  getContentId: (e, t) => {
    var r;
    return ((r = e.ids) == null ? void 0 : r.content) ?? `tabs:${e.id}:content-${t}`;
  },
  getTriggerId: (e, t) => {
    var r;
    return ((r = e.ids) == null ? void 0 : r.trigger) ?? `tabs:${e.id}:trigger-${t}`;
  },
  getIndicatorId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.indicator) ?? `tabs:${e.id}:indicator`;
  },
  getTablistEl: (e) => Xt.getById(e, Xt.getTablistId(e)),
  getContentEl: (e, t) => Xt.getById(e, Xt.getContentId(e, t)),
  getTriggerEl: (e, t) => Xt.getById(e, Xt.getTriggerId(e, t)),
  getIndicatorEl: (e) => Xt.getById(e, Xt.getIndicatorId(e)),
  getElements: (e) => {
    const r = `[role=tab][data-ownedby='${CSS.escape(Xt.getTablistId(e))}']:not([disabled])`;
    return vO(Xt.getTablistEl(e), r);
  },
  getFirstEl: (e) => bO(Xt.getElements(e)),
  getLastEl: (e) => _O(Xt.getElements(e)),
  getNextEl: (e, t) => iO(Xt.getElements(e), Xt.getTriggerId(e, t), e.loop),
  getPrevEl: (e, t) => nO(Xt.getElements(e), Xt.getTriggerId(e, t), e.loop),
  getActiveContentEl: (e) => {
    if (e.value)
      return Xt.getContentEl(e, e.value);
  },
  getActiveTabEl: (e) => {
    if (e.value)
      return Xt.getTriggerEl(e, e.value);
  },
  getOffsetRect: (e) => ({
    left: (e == null ? void 0 : e.offsetLeft) ?? 0,
    top: (e == null ? void 0 : e.offsetTop) ?? 0,
    width: (e == null ? void 0 : e.offsetWidth) ?? 0,
    height: (e == null ? void 0 : e.offsetHeight) ?? 0
  }),
  getRectById: (e, t) => {
    const r = $8(Xt.getElements(e), Xt.getTriggerId(e, t));
    return Xt.resolveRect(Xt.getOffsetRect(r), e.orientation);
  },
  resolveRect(e, t) {
    const r = t === "vertical" ? "height" : "width", i = t === "vertical" ? "top" : "left";
    return {
      [i]: `${e[i]}px`,
      [r]: `${e[r]}px`
    };
  }
});
function kz(e, t, r) {
  const i = e.context.translations, n = e.matches("focused");
  return {
    value: e.context.value,
    focusedValue: e.context.focusedValue,
    previousValues: Array.from(e.context.previousValues),
    setValue(a) {
      t({ type: "SET_VALUE", value: a });
    },
    clearValue() {
      t({ type: "CLEAR_VALUE" });
    },
    setIndicatorRect(a) {
      t({ type: "SET_INDICATOR_RECT", id: a });
    },
    rootProps: r.element({
      ...k0.root.attrs,
      id: Xt.getRootId(e.context),
      "data-orientation": e.context.orientation,
      "data-focus": pr(n),
      dir: e.context.dir
    }),
    tablistProps: r.element({
      ...k0.list.attrs,
      id: Xt.getTablistId(e.context),
      role: "tablist",
      "data-focus": pr(n),
      "aria-orientation": e.context.orientation,
      "data-orientation": e.context.orientation,
      "aria-label": i.tablistLabel,
      onKeyDown(a) {
        if (!H8(a))
          return;
        const o = {
          ArrowDown() {
            t("ARROW_DOWN");
          },
          ArrowUp() {
            t("ARROW_UP");
          },
          ArrowLeft() {
            t("ARROW_LEFT");
          },
          ArrowRight() {
            t("ARROW_RIGHT");
          },
          Home() {
            t("HOME");
          },
          End() {
            t("END");
          },
          Enter() {
            t({ type: "ENTER", value: e.context.focusedValue });
          }
        };
        let s = Rb(a, e.context);
        const l = o[s];
        l && (a.preventDefault(), l(a));
      }
    }),
    getTriggerProps(a) {
      const { value: o, disabled: s } = a, l = e.context.value === o;
      return r.button({
        ...k0.trigger.attrs,
        role: "tab",
        type: "button",
        disabled: s,
        "data-orientation": e.context.orientation,
        "data-disabled": pr(s),
        "aria-disabled": s,
        "data-value": o,
        "aria-selected": l,
        "data-selected": pr(l),
        "aria-controls": Xt.getContentId(e.context, o),
        "data-ownedby": Xt.getTablistId(e.context),
        id: Xt.getTriggerId(e.context, o),
        tabIndex: l ? 0 : -1,
        onFocus() {
          t({ type: "TAB_FOCUS", value: o });
        },
        onBlur(u) {
          const d = u.relatedTarget;
          (d == null ? void 0 : d.getAttribute("role")) !== "tab" && t({ type: "TAB_BLUR" });
        },
        onClick(u) {
          s || (K8() && u.currentTarget.focus(), t({ type: "TAB_CLICK", value: o }));
        }
      });
    },
    getContentProps({ value: a }) {
      const o = e.context.value === a;
      return r.element({
        ...k0.content.attrs,
        id: Xt.getContentId(e.context, a),
        tabIndex: 0,
        "aria-labelledby": Xt.getTriggerId(e.context, a),
        role: "tabpanel",
        "data-ownedby": Xt.getTablistId(e.context),
        "data-selected": pr(o),
        hidden: !o
      });
    },
    indicatorProps: r.element({
      id: Xt.getIndicatorId(e.context),
      ...k0.indicator.attrs,
      "data-orientation": e.context.orientation,
      style: {
        "--transition-duration": "150ms",
        "--transition-property": "left, right, top, bottom, width, height",
        position: "absolute",
        willChange: "var(--transition-property)",
        transitionProperty: "var(--transition-property)",
        transitionDuration: e.context.canIndicatorTransition ? "var(--transition-duration)" : "0ms",
        transitionTimingFunction: "var(--transition-timing-function)",
        ...e.context.indicatorRect
      }
    })
  };
}
var { not: bz } = rp;
function _z(e) {
  const t = as(e);
  return $s(
    {
      initial: "idle",
      context: {
        dir: "ltr",
        orientation: "horizontal",
        activationMode: "automatic",
        value: null,
        focusedValue: null,
        previousValues: [],
        indicatorRect: {
          left: "0px",
          top: "0px",
          width: "0px",
          height: "0px"
        },
        canIndicatorTransition: !1,
        isIndicatorRendered: !1,
        loop: !0,
        translations: {},
        ...t
      },
      computed: {
        isHorizontal: (r) => r.orientation === "horizontal",
        isVertical: (r) => r.orientation === "vertical"
      },
      created: ["setPrevSelectedTabs"],
      entry: ["checkRenderedElements", "syncIndicatorRect", "setContentTabIndex"],
      exit: ["cleanupObserver"],
      watch: {
        value: ["enableIndicatorTransition", "setPrevSelectedTabs", "syncIndicatorRect", "setContentTabIndex"],
        dir: ["syncIndicatorRect"],
        orientation: ["syncIndicatorRect"]
      },
      on: {
        SET_VALUE: {
          actions: "setValue"
        },
        CLEAR_VALUE: {
          actions: "clearValue"
        },
        SET_INDICATOR_RECT: {
          actions: "setIndicatorRect"
        }
      },
      states: {
        idle: {
          on: {
            TAB_FOCUS: [
              {
                guard: "selectOnFocus",
                target: "focused",
                actions: ["setFocusedValue", "setValue"]
              },
              {
                target: "focused",
                actions: "setFocusedValue"
              }
            ],
            TAB_CLICK: {
              target: "focused",
              actions: ["setFocusedValue", "setValue"]
            }
          }
        },
        focused: {
          on: {
            TAB_CLICK: {
              target: "focused",
              actions: ["setFocusedValue", "setValue"]
            },
            ARROW_LEFT: {
              guard: "isHorizontal",
              actions: "focusPrevTab"
            },
            ARROW_RIGHT: {
              guard: "isHorizontal",
              actions: "focusNextTab"
            },
            ARROW_UP: {
              guard: "isVertical",
              actions: "focusPrevTab"
            },
            ARROW_DOWN: {
              guard: "isVertical",
              actions: "focusNextTab"
            },
            HOME: {
              actions: "focusFirstTab"
            },
            END: {
              actions: "focusLastTab"
            },
            ENTER: {
              guard: bz("selectOnFocus"),
              actions: "setValue"
            },
            TAB_FOCUS: [
              {
                guard: "selectOnFocus",
                actions: ["setFocusedValue", "setValue"]
              },
              { actions: "setFocusedValue" }
            ],
            TAB_BLUR: {
              target: "idle",
              actions: "clearFocusedValue"
            }
          }
        }
      }
    },
    {
      guards: {
        isVertical: (r) => r.isVertical,
        isHorizontal: (r) => r.isHorizontal,
        selectOnFocus: (r) => r.activationMode === "automatic"
      },
      actions: {
        setFocusedValue(r, i) {
          Xh.focusedValue(r, i.value);
        },
        clearFocusedValue(r) {
          Xh.focusedValue(r, null);
        },
        setValue(r, i) {
          Xh.value(r, i.value);
        },
        clearValue(r) {
          Xh.value(r, null);
        },
        focusFirstTab(r) {
          Wi(() => {
            var i;
            return (i = Xt.getFirstEl(r)) == null ? void 0 : i.focus();
          });
        },
        focusLastTab(r) {
          Wi(() => {
            var i;
            return (i = Xt.getLastEl(r)) == null ? void 0 : i.focus();
          });
        },
        focusNextTab(r) {
          if (!r.focusedValue)
            return;
          const i = Xt.getNextEl(r, r.focusedValue);
          Wi(() => i == null ? void 0 : i.focus());
        },
        focusPrevTab(r) {
          if (!r.focusedValue)
            return;
          const i = Xt.getPrevEl(r, r.focusedValue);
          Wi(() => i == null ? void 0 : i.focus());
        },
        checkRenderedElements(r) {
          r.isIndicatorRendered = !!Xt.getIndicatorEl(r);
        },
        setPrevSelectedTabs(r) {
          r.value != null && (r.previousValues = Dz(r.previousValues, r.value));
        },
        // if tab panel contains focusable elements, remove the tabindex attribute
        setContentTabIndex(r) {
          Wi(() => {
            const i = Xt.getActiveContentEl(r);
            if (!i)
              return;
            b2(i).length > 0 ? i.removeAttribute("tabindex") : i.setAttribute("tabindex", "0");
          });
        },
        cleanupObserver(r) {
          var i;
          (i = r.indicatorCleanup) == null || i.call(r);
        },
        enableIndicatorTransition(r) {
          r.canIndicatorTransition = !0;
        },
        setIndicatorRect(r, i) {
          const n = i.id ?? r.value;
          !r.isIndicatorRendered || !n || !Xt.getTriggerEl(r, n) || (r.indicatorRect = Xt.getRectById(r, n), hg(() => {
            r.canIndicatorTransition = !1;
          }));
        },
        syncIndicatorRect(r) {
          var a;
          (a = r.indicatorCleanup) == null || a.call(r);
          const i = r.value;
          if (!r.isIndicatorRendered || !i)
            return;
          const n = Xt.getActiveTabEl(r);
          n && (r.indicatorCleanup = Mb(n, {
            getRect(o) {
              return Xt.getOffsetRect(o);
            },
            onChange(o) {
              r.indicatorRect = Xt.resolveRect(o, r.orientation), hg(() => {
                r.canIndicatorTransition = !1;
              });
            }
          }));
        }
      }
    }
  );
}
function Dz(e, t) {
  const r = Array.from(e).slice(), i = r.indexOf(t);
  return i > -1 && r.splice(i, 1), r.push(t), r;
}
var Ny = {
  change: (e) => {
    var t;
    e.value != null && ((t = e.onChange) == null || t.call(e, { value: e.value }));
  },
  focusChange: (e) => {
    var t;
    e.focusedValue != null && ((t = e.onFocus) == null || t.call(e, { value: e.focusedValue }));
  }
}, Xh = {
  value: (e, t) => {
    Ku(t, e.value) || (e.value = t, Ny.change(e));
  },
  focusedValue: (e, t) => {
    Ku(t, e.focusedValue) || (e.focusedValue = t, Ny.focusChange(e));
  }
};
const [yz, R1] = ns({
  name: "TabsContext",
  hookName: "useTabsContext",
  providerName: "<TabsProvider />"
}), Ez = (e) => {
  const { present: t, ...r } = e, { value: i } = R1();
  return /* @__PURE__ */ v.jsx(np, { present: t !== void 0 ? t : i === e.value, ...r });
}, l6 = Je((e, t) => {
  const [r, i] = ip(e), [n, a] = oa()(i, ["value"]);
  return /* @__PURE__ */ v.jsx(Ez, { ...r, ...n, children: /* @__PURE__ */ v.jsx(u6, { ref: t, ...n, ...a }) });
});
l6.displayName = "TabContent";
const u6 = Je((e, t) => {
  const [r, i] = oa()(e, ["value"]), { getContentProps: n } = R1(), a = zt(n(r), i);
  return /* @__PURE__ */ v.jsx(St.div, { ...a, ref: t });
});
u6.displayName = "InnerTabContent";
const c6 = Je((e, t) => {
  const { indicatorProps: r } = R1(), i = zt(r, e);
  return /* @__PURE__ */ v.jsx(St.div, { ...i, ref: t });
});
c6.displayName = "TabIndicator";
const d6 = Je((e, t) => {
  const { tablistProps: r } = R1(), i = zt(r, e);
  return /* @__PURE__ */ v.jsx(St.div, { ...i, ref: t });
});
d6.displayName = "TabList";
const p6 = Je((e, t) => {
  const [r, i] = oa()(e, ["disabled", "value"]), { getTriggerProps: n } = R1(), a = zt(n(r), i);
  return /* @__PURE__ */ v.jsx(St.button, { ...a, ref: t });
});
p6.displayName = "TabTrigger";
const Cz = (e) => {
  const t = Vl(), r = {
    id: Co(),
    getRootNode: t,
    ...e,
    value: e.defaultValue
  }, i = {
    ...r,
    value: e.value
  }, [n, a] = Us(_z(r), { context: i });
  return kz(n, a, $l);
}, $b = Je((e, t) => {
  const [r, i] = oa()(e, [
    "activationMode",
    "defaultValue",
    "dir",
    "getRootNode",
    "id",
    "ids",
    "loop",
    "onChange",
    "onFocus",
    "orientation",
    "translations",
    "value"
  ]), n = Cz(r), a = zt(n.rootProps, i);
  return /* @__PURE__ */ v.jsx(yz, { value: n, children: /* @__PURE__ */ v.jsx(St.div, { ...a, ref: t }) });
});
$b.displayName = "Tabs";
const O1 = Object.assign($b, {
  Root: $b,
  Content: l6,
  Indicator: c6,
  List: d6,
  Trigger: p6
}), [xz, sp] = ns({
  name: "TooltipContext",
  hookName: "useTooltipContext",
  providerName: "<TooltipProvider />"
});
var Az = _o("tooltip").parts("trigger", "arrow", "arrowTip", "positioner", "content"), b0 = Az.build(), Fi = Ul({
  getTriggerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.trigger) ?? `tooltip:${e.id}:trigger`;
  },
  getContentId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.content) ?? `tooltip:${e.id}:content`;
  },
  getArrowId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.arrow) ?? `tooltip:${e.id}:arrow`;
  },
  getPositionerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.positioner) ?? `tooltip:${e.id}:popper`;
  },
  getTriggerEl: (e) => Fi.getById(e, Fi.getTriggerId(e)),
  getContentEl: (e) => Fi.getById(e, Fi.getContentId(e)),
  getPositionerEl: (e) => Fi.getById(e, Fi.getPositionerId(e)),
  getArrowEl: (e) => Fi.getById(e, Fi.getArrowId(e)),
  getScrollParent: (e) => n2(Fi.getTriggerEl(e))
}), Ps = am({
  id: null,
  prevId: null,
  setId(e) {
    this.prevId = this.id, this.id = e;
  }
});
function wz(e, t, r) {
  const i = e.context.id, n = e.context.hasAriaLabel, a = e.hasTag("open"), o = Fi.getTriggerId(e.context), s = Fi.getContentId(e.context), l = e.context.disabled, u = m2({
    ...e.context.positioning,
    placement: e.context.currentPlacement
  });
  return {
    isOpen: a,
    open() {
      t("OPEN");
    },
    close() {
      t("CLOSE");
    },
    setPositioning(d = {}) {
      t({ type: "SET_POSITIONING", options: d });
    },
    triggerProps: r.button({
      ...b0.trigger.attrs,
      id: o,
      "data-expanded": pr(a),
      "data-state": a ? "open" : "closed",
      "aria-describedby": a ? s : void 0,
      onClick() {
        t("CLICK");
      },
      onFocus() {
        e.event.type !== "POINTER_DOWN" && t("FOCUS");
      },
      onBlur() {
        i === Ps.id && t("BLUR");
      },
      onPointerDown() {
        l || i === Ps.id && t("POINTER_DOWN");
      },
      onPointerMove(d) {
        l || d.pointerType === "touch" || t("POINTER_MOVE");
      },
      onPointerLeave() {
        l || t("POINTER_LEAVE");
      },
      onPointerCancel() {
        l || t("POINTER_LEAVE");
      }
    }),
    arrowProps: r.element({
      id: Fi.getArrowId(e.context),
      ...b0.arrow.attrs,
      style: u.arrow
    }),
    arrowTipProps: r.element({
      ...b0.arrowTip.attrs,
      style: u.arrowTip
    }),
    positionerProps: r.element({
      id: Fi.getPositionerId(e.context),
      ...b0.positioner.attrs,
      style: u.floating
    }),
    contentProps: r.element({
      ...b0.content.attrs,
      hidden: !a,
      "data-state": a ? "open" : "closed",
      role: n ? void 0 : "tooltip",
      id: n ? void 0 : s,
      "data-placement": e.context.currentPlacement,
      onPointerEnter() {
        t("CONTENT.POINTER_MOVE");
      },
      onPointerLeave() {
        t("CONTENT.POINTER_LEAVE");
      },
      style: {
        pointerEvents: e.context.interactive ? "auto" : "none"
      }
    })
  };
}
var { and: Fz, not: zy } = rp;
function Tz(e) {
  const t = as(e);
  return $s(
    {
      id: "tooltip",
      initial: "closed",
      context: {
        openDelay: 1e3,
        closeDelay: 500,
        closeOnPointerDown: !0,
        closeOnEsc: !0,
        interactive: !0,
        currentPlacement: void 0,
        ...t,
        hasPointerMoveOpened: !1,
        positioning: {
          placement: "bottom",
          ...t.positioning
        }
      },
      computed: {
        hasAriaLabel: (r) => !!r["aria-label"]
      },
      watch: {
        disabled: ["closeIfDisabled"],
        open: ["toggleVisibility"]
      },
      on: {
        OPEN: "open",
        CLOSE: "closed"
      },
      states: {
        closed: {
          tags: ["closed"],
          entry: ["clearGlobalId", "invokeOnClose"],
          on: {
            FOCUS: "open",
            POINTER_LEAVE: {
              actions: ["clearPointerMoveOpened"]
            },
            POINTER_MOVE: [
              {
                guard: Fz("noVisibleTooltip", zy("hasPointerMoveOpened")),
                target: "opening"
              },
              {
                guard: zy("hasPointerMoveOpened"),
                target: "open",
                actions: ["setPointerMoveOpened"]
              }
            ]
          }
        },
        opening: {
          tags: ["closed"],
          activities: ["trackScroll", "trackPointerlockChange"],
          after: {
            OPEN_DELAY: {
              target: "open",
              actions: ["setPointerMoveOpened"]
            }
          },
          on: {
            POINTER_LEAVE: {
              target: "closed",
              actions: ["clearPointerMoveOpened"]
            },
            BLUR: "closed",
            SCROLL: "closed",
            POINTER_LOCK_CHANGE: "closed",
            POINTER_DOWN: {
              guard: "closeOnPointerDown",
              target: "closed"
            }
          }
        },
        open: {
          tags: ["open"],
          activities: [
            "trackEscapeKey",
            "trackDisabledTriggerOnSafari",
            "trackScroll",
            "trackPointerlockChange",
            "trackPositioning"
          ],
          entry: ["setGlobalId", "invokeOnOpen"],
          on: {
            POINTER_LEAVE: [
              {
                guard: "isVisible",
                target: "closing",
                actions: ["clearPointerMoveOpened"]
              },
              {
                target: "closed",
                actions: ["clearPointerMoveOpened"]
              }
            ],
            BLUR: "closed",
            ESCAPE: "closed",
            SCROLL: "closed",
            POINTER_LOCK_CHANGE: "closed",
            "CONTENT.POINTER_LEAVE": {
              guard: "isInteractive",
              target: "closing"
            },
            POINTER_DOWN: {
              guard: "closeOnPointerDown",
              target: "closed"
            },
            CLICK: "closed",
            SET_POSITIONING: {
              actions: "setPositioning"
            }
          }
        },
        closing: {
          tags: ["open"],
          activities: ["trackStore", "trackPositioning"],
          after: {
            CLOSE_DELAY: "closed"
          },
          on: {
            FORCE_CLOSE: "closed",
            POINTER_MOVE: {
              target: "open",
              actions: ["setPointerMoveOpened"]
            },
            "CONTENT.POINTER_MOVE": {
              guard: "isInteractive",
              target: "open"
            }
          }
        }
      }
    },
    {
      activities: {
        trackPositioning(r) {
          r.currentPlacement = r.positioning.placement;
          const i = () => Fi.getPositionerEl(r);
          return h1(Fi.getTriggerEl(r), i, {
            ...r.positioning,
            defer: !0,
            onComplete(n) {
              r.currentPlacement = n.placement;
            },
            onCleanup() {
              r.currentPlacement = void 0;
            }
          });
        },
        trackPointerlockChange(r, i, { send: n }) {
          const a = () => n("POINTER_LOCK_CHANGE");
          return Vu(Fi.getDoc(r), "pointerlockchange", a, !1);
        },
        trackScroll(r, i, { send: n }) {
          const a = Fi.getTriggerEl(r);
          if (!a)
            return;
          const o = W8(a).map((s) => Vu(s, "scroll", () => n("SCROLL"), { passive: !0, capture: !0 }));
          return () => {
            o.forEach((s) => s == null ? void 0 : s());
          };
        },
        trackStore(r, i, { send: n }) {
          return c1(Ps, () => {
            Ps.id !== r.id && n("FORCE_CLOSE");
          });
        },
        trackDisabledTriggerOnSafari(r, i, { send: n }) {
          if (!K8())
            return;
          const a = Fi.getDoc(r);
          return Vu(a, "pointermove", (o) => {
            const s = "[data-part=trigger][data-expanded]";
            Ju(o.target) && o.target.closest(s) || n("POINTER_LEAVE");
          });
        },
        trackEscapeKey(r, i, { send: n }) {
          if (!r.closeOnEsc)
            return;
          const a = Fi.getDoc(r);
          return Vu(a, "keydown", (o) => {
            o.key === "Escape" && n("ESCAPE");
          });
        }
      },
      actions: {
        setGlobalId(r) {
          Ps.setId(r.id);
        },
        clearGlobalId(r) {
          r.id === Ps.id && Ps.setId(null);
        },
        invokeOnOpen(r, i) {
          var a;
          ["CONTENT.POINTER_MOVE", "POINTER_MOVE"].includes(i.type) || (a = r.onOpen) == null || a.call(r);
        },
        invokeOnClose(r) {
          var i;
          (i = r.onClose) == null || i.call(r);
        },
        closeIfDisabled(r, i, { send: n }) {
          r.disabled && n("CLOSE");
        },
        setPositioning(r, i) {
          const n = () => Fi.getPositionerEl(r);
          h1(Fi.getTriggerEl(r), n, {
            ...r.positioning,
            ...i.options,
            defer: !0,
            listeners: !1
          });
        },
        toggleVisibility(r, i, { send: n }) {
          n({ type: r.open ? "OPEN" : "CLOSE", src: "controlled" });
        },
        setPointerMoveOpened(r) {
          r.hasPointerMoveOpened = !0;
        },
        clearPointerMoveOpened(r) {
          r.hasPointerMoveOpened = !1;
        }
      },
      guards: {
        closeOnPointerDown: (r) => r.closeOnPointerDown,
        noVisibleTooltip: () => Ps.id === null,
        isVisible: (r) => r.id === Ps.id,
        isInteractive: (r) => r.interactive,
        hasPointerMoveOpened: (r) => !!r.hasPointerMoveOpened
      },
      delays: {
        OPEN_DELAY: (r) => r.openDelay,
        CLOSE_DELAY: (r) => r.closeDelay
      }
    }
  );
}
const Sz = (e) => {
  const t = Vl(), r = {
    id: Co(),
    getRootNode: t,
    ...e
  }, [i, n] = Us(Tz(r), { context: r });
  return wz(i, n, $l);
}, Ly = (e) => {
  const { children: t, ...r } = e, i = Sz(r), n = cc(t, i);
  return /* @__PURE__ */ v.jsx(xz, { value: i, children: n });
}, h6 = Je((e, t) => {
  const { arrowProps: r } = sp(), i = zt(r, e);
  return /* @__PURE__ */ v.jsx(St.div, { ...i, ref: t });
});
h6.displayName = "TooltipArrow";
const f6 = Je((e, t) => {
  const { arrowTipProps: r } = sp(), i = zt(r, e);
  return /* @__PURE__ */ v.jsx(St.div, { ...i, ref: t });
});
f6.displayName = "TooltipArrowTip";
const g6 = Je((e, t) => {
  const [r, i] = ip(e), n = sp();
  return /* @__PURE__ */ v.jsx(np, { present: n.isOpen, ...r, children: /* @__PURE__ */ v.jsx(Iz, { ref: t, ...i }) });
});
g6.displayName = "TooltipContent";
const Iz = Je(
  function(t, r) {
    const { contentProps: i } = sp(), n = zt(i, t);
    return /* @__PURE__ */ v.jsx(St.div, { ...n, ref: r });
  }
), m6 = Je(
  (e, t) => {
    const { positionerProps: r } = sp(), i = zt(r, e);
    return /* @__PURE__ */ v.jsx(St.div, { ...i, ref: t });
  }
);
m6.displayName = "TooltipPositioner";
const v6 = Je((e, t) => {
  const { triggerProps: r } = sp(), i = zt(r, e);
  return /* @__PURE__ */ v.jsx(St.button, { ...i, ref: t });
});
v6.displayName = "TooltipTrigger";
const lp = Object.assign(Ly, {
  Root: Ly,
  Arrow: h6,
  ArrowTip: f6,
  Content: g6,
  Positioner: m6,
  Trigger: v6
}), Bz = Te(Te.span, {
  base: {
    display: "inline-flex",
    alignSelf: "center",
    flexShrink: 0
  }
}), Rz = _i(Te(St.button, x8), "Button");
function Oz(e) {
  const { leftIcon: t, children: r } = e;
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    t && /* @__PURE__ */ v.jsx(Bz, { marginRight: 2, children: t }),
    r
  ] });
}
const di = Je(
  ({ children: e, leftIcon: t, ...r }, i) => /* @__PURE__ */ v.jsx(
    Rz,
    {
      ...r,
      ref: i,
      children: /* @__PURE__ */ v.jsx(Oz, { leftIcon: t, children: e })
    }
  )
);
di.displayName = "Button";
const { withProvider: Pz, withContext: E2 } = Nn(CI), My = _i(
  Pz(Te("div"), "container"),
  "Card"
), Nz = E2(Te("div"), "body"), zz = E2(Te("div"), "header"), Lz = E2(Te("div"), "footer"), jy = Object.assign(My, {
  Root: My,
  Body: Nz,
  Header: zz,
  Footer: Lz
});
function Mz(e) {
  return /* @__PURE__ */ v.jsx(
    Te.svg,
    {
      viewBox: "0 0 12 10",
      style: {
        width: "1.2em",
        fill: "none",
        strokeWidth: 2,
        stroke: "currentColor",
        strokeDasharray: 16
      },
      ...e,
      children: /* @__PURE__ */ v.jsx("polyline", { points: "1.5 6 4.5 9 10.5 1" })
    }
  );
}
function jz(e) {
  return /* @__PURE__ */ v.jsx(
    Te.svg,
    {
      viewBox: "0 0 24 24",
      style: { width: "1.2em", stroke: "currentColor", strokeWidth: 4 },
      ...e,
      children: /* @__PURE__ */ v.jsx("line", { x1: "21", x2: "3", y1: "12", y2: "12" })
    }
  );
}
function Hz(e) {
  const { className: t, isIndeterminate: r, isChecked: i, ...n } = e;
  if (!i && !r)
    return null;
  const a = r ? jz : Mz;
  return /* @__PURE__ */ v.jsx(
    Te.div,
    {
      "data-scope": "checkbox",
      "data-part": "icon",
      className: t,
      css: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%"
      },
      children: /* @__PURE__ */ v.jsx(a, { ...n })
    }
  );
}
const { withProvider: $z, withContext: C2 } = Nn(SI), Hy = _i(
  $z(
    Te(
      c2.Root
    ),
    "container"
  ),
  "Checkbox"
), Uz = C2(Te(c2.Control), "control"), Vz = C2(Te(c2.Label), "label"), El = Object.assign(Hy, {
  Root: Hy,
  Control: Uz,
  Label: Vz,
  Icon: C2(Hz, "icon")
}), Wz = _i(Te("code", RI), "Code");
function Gz(e, t) {
  if (e != null) {
    if (typeof e == "function") {
      e(t);
      return;
    }
    try {
      e.current = t;
    } catch {
      throw new Error(`Cannot assign value '${t}' to ref '${e}'`);
    }
  }
}
function $y(...e) {
  return (t) => {
    e.forEach((r) => {
      Gz(r, t);
    });
  };
}
const k6 = (e, t) => `var(--${e}${t ? ", " + t : ""})`, b6 = (e) => `--${e}`, Kz = (e, t) => ({
  name: b6(e),
  ref: k6(e, t)
});
function Yz(e, t) {
  const r = {};
  for (const i of t) {
    if (Array.isArray(i)) {
      const [n, a] = i;
      r[n] = qd.create(`${e}-${n}`, a);
      continue;
    }
    r[i] = qd.create(`${e}-${i}`);
  }
  return r;
}
const qd = {
  ref: k6,
  name: b6,
  create: Kz,
  scope: Yz
}, qz = /[A-Z]/g;
function Ub(e) {
  return e.replace(qz, (t) => `-${t.toLowerCase()}`);
}
const ck = (e) => e ? !0 : void 0, Zh = (e) => e ? "" : void 0;
function Uy(...e) {
  return function(r) {
    e.some((i) => (i == null || i(r), r == null ? void 0 : r.defaultPrevented));
  };
}
function Qz(e) {
  const t = e.split(" "), r = t[0] ?? "", i = t.length > 1 ? t[t.length - 1] : "";
  return r && i ? `${r.charAt(0)}${i.charAt(0)}` : r.charAt(0);
}
const Xz = {
  recipes: {
    alert: ["*"],
    avatar: ["*"],
    button: ["*"],
    card: ["*"],
    checkbox: ["*"],
    closeButton: ["*"],
    code: ["*"],
    badge: ["*"],
    formControl: ["*"],
    heading: ["*"],
    icon: ["*"],
    input: ["*"],
    kbd: ["*"],
    link: ["*"],
    modal: ["*"],
    popover: ["*"],
    select: ["*"],
    skeleton: ["*"],
    switchRecipe: ["*"],
    tabs: ["*"],
    table: ["*"],
    tag: ["*"],
    textarea: ["*"],
    tooltip: ["*"],
    //
    aiChatPageWrapper: ["*"],
    contentParser: ["*"],
    previewContentHeader: ["*"],
    searchBarTrigger: ["*"]
  }
}, _6 = "inkeep-widget-vars", Vy = `:where(.${_6})`, ye = "ikp", Jh = {
  themeVarsClass: _6,
  prefix: ye,
  cssVarRoot: Vy,
  extendCssVarRoot: (e) => Vy.replace(")", `, ${e})`),
  staticCss: Xz,
  presets: [
    "@pandacss/preset-panda",
    "@inkeep/preset-chakra",
    "@inkeep/preset"
  ]
}, Zz = (e) => typeof e == "object" && e !== null, Wy = { separator: "." };
function x2(e, t, r = Wy, i = "") {
  const n = r.separator ?? Wy.separator;
  if (e === null || typeof e != "object")
    return;
  const a = Object.keys(e);
  for (let o = 0, s = a.length; o < s; o++) {
    const l = a[o], u = e[l], d = Zz(u), c = i ? `${i}${n}${l}` : l;
    t(l, u, c), d && x2(u, t, r, c);
  }
}
const [Jz, A2] = nm({
  strict: !1,
  name: "FormControlContext"
});
function eL(e) {
  const {
    id: t,
    isRequired: r,
    isInvalid: i,
    isDisabled: n,
    isReadOnly: a,
    ...o
  } = e, s = Co(), l = t || `field-${s}`, u = `${l}-label`, d = `${l}-feedback`, c = `${l}-helptext`, [p, f] = rt(!1), [g, k] = rt(!1), [y, _] = rt(!1), A = Nt(
    (M = {}, X = null) => ({
      id: c,
      ...M,
      /**
       * Notify the field context when the help text is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: $y(X, (U) => {
        U && k(!0);
      })
    }),
    [c]
  ), T = Nt(
    (M = {}, X = null) => ({
      ...M,
      ref: X,
      "data-focus": Zh(y),
      "data-disabled": Zh(n),
      "data-invalid": Zh(i),
      "data-readonly": Zh(a),
      id: M.id !== void 0 ? M.id : u,
      htmlFor: M.htmlFor !== void 0 ? M.htmlFor : l
    }),
    [l, n, y, i, a, u]
  ), N = Nt(
    (M = {}, X = null) => ({
      id: d,
      ...M,
      /**
       * Notify the field context when the error message is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: $y(X, (U) => {
        U && f(!0);
      }),
      "aria-live": "polite"
    }),
    [d]
  ), P = Nt(
    (M = {}, X = null) => ({
      ...M,
      ...o,
      ref: X,
      role: "group"
    }),
    [o]
  ), B = Nt(
    (M = {}, X = null) => ({
      ...M,
      ref: X,
      role: "presentation",
      "aria-hidden": !0,
      children: M.children || "*"
    }),
    []
  );
  return {
    isRequired: !!r,
    isInvalid: !!i,
    isReadOnly: !!a,
    isDisabled: !!n,
    isFocused: !!y,
    onFocus: () => _(!0),
    onBlur: () => _(!1),
    hasFeedbackText: p,
    setHasFeedbackText: f,
    hasHelpText: g,
    setHasHelpText: k,
    id: l,
    labelId: u,
    feedbackId: d,
    helpTextId: c,
    htmlProps: o,
    getHelpTextProps: A,
    getErrorMessageProps: N,
    getRootProps: P,
    getLabelProps: T,
    getRequiredIndicatorProps: B
  };
}
const um = (e, t, r, i) => {
  const n = Je((a, o) => {
    const s = A2();
    if (i && !i(s))
      return null;
    const l = s == null ? void 0 : s[r](a, o);
    return /* @__PURE__ */ v.jsx(e, { ...l });
  });
  return n.displayName = t, n;
}, cm = _i(
  Te(St.svg, CB, {
    defaultProps: {
      // TODO this one seems to cause issues for some icons
      // viewBox: '0 0 24 24',
      role: "presentation",
      "aria-hidden": !0,
      focusable: !1
    }
  }),
  "Icon"
), tL = Je(
  (e, t) => /* @__PURE__ */ v.jsx(di, { padding: "0", ...e, ref: t })
), { withProvider: rL, withContext: P1 } = Nn(HI), iL = rL(Te("div"), "container"), Vb = Je(
  function(t, r) {
    const {
      getRootProps: i,
      htmlProps: n,
      ...a
    } = eL(t);
    return /* @__PURE__ */ v.jsx(Jz, { value: a, children: /* @__PURE__ */ v.jsx(iL, { ...i({}, r) }) });
  }
);
Vb.displayName = "FormControl";
const D6 = P1(Te("label"), "label"), Wb = Te(D6, {
  base: {
    display: "block",
    textAlign: "start",
    //
    fontSize: "md",
    marginEnd: "3",
    mb: "2",
    fontWeight: "medium",
    transitionProperty: "common",
    transitionDuration: "normal",
    opacity: 1,
    _disabled: {
      opacity: 0.4
    }
  }
}), nL = um(
  D6,
  "FormLabel",
  "getLabelProps"
), aL = P1(
  Te("span"),
  "required-indicator"
), oL = um(
  aL,
  "FormRequiredIndicator",
  "getRequiredIndicatorProps",
  (e) => e == null ? void 0 : e.isRequired
), sL = P1(Te("div"), "helper"), lL = um(
  sL,
  "FormHelperText",
  "getHelpTextProps"
), uL = P1(Te("div"), "error"), cL = um(
  uL,
  "FormError",
  "getErrorMessageProps",
  (e) => e == null ? void 0 : e.isInvalid
), dL = () => /* @__PURE__ */ v.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
  }
), pL = P1(cm, "error-icon"), y6 = Je(
  function(t, r) {
    const i = A2();
    return i != null && i.isInvalid ? /* @__PURE__ */ v.jsx(pL, { ref: r, ...t, children: /* @__PURE__ */ v.jsx(dL, {}) }) : null;
  }
);
y6.displayName = "FormErrorIcon";
const Go = Object.assign(Vb, {
  Container: Vb,
  Label: nL,
  Helper: lL,
  RequiredIndicator: oL,
  Error: cL,
  ErrorIcon: y6
}), Eg = _i(Te("h2", yB), "Heading"), w2 = Te.img, hL = T1({
  base: {
    flex: "0 0 auto",
    width: "auto",
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap"
  },
  variants: {
    placement: {
      left: {
        marginEnd: "-1px",
        borderEndRadius: 0,
        borderEndColor: "transparent"
      },
      right: {
        marginStart: "-1px",
        borderStartRadius: 0,
        borderStartColor: "transparent"
      }
    }
  }
}), E6 = Je(
  function(t, r) {
    const { placement: i = "left", className: n, ...a } = t;
    return /* @__PURE__ */ v.jsx(
      Te.div,
      {
        "data-placement": i,
        ...a,
        className: Eo(hL({ placement: i }), n),
        ref: r
      }
    );
  }
);
E6.displayName = "InputAddon";
function C6(e) {
  const { isDisabled: t, isInvalid: r, isReadOnly: i, isRequired: n, ...a } = fL(e);
  return {
    ...a,
    disabled: t,
    readOnly: i,
    required: n,
    "aria-invalid": ck(r),
    "aria-required": ck(n),
    "aria-readonly": ck(i)
  };
}
function fL(e) {
  const t = A2(), {
    id: r,
    disabled: i,
    readOnly: n,
    required: a,
    isRequired: o,
    isInvalid: s,
    isReadOnly: l,
    isDisabled: u,
    onFocus: d,
    onBlur: c,
    ...p
  } = e, f = e["aria-describedby"] ? [e["aria-describedby"]] : [];
  return t != null && t.hasFeedbackText && (t != null && t.isInvalid) && f.push(t.feedbackId), t != null && t.hasHelpText && f.push(t.helpTextId), {
    ...p,
    "aria-describedby": f.join(" ") || void 0,
    id: r ?? (t == null ? void 0 : t.id),
    isDisabled: i ?? u ?? (t == null ? void 0 : t.isDisabled),
    isReadOnly: n ?? l ?? (t == null ? void 0 : t.isReadOnly),
    isRequired: a ?? o ?? (t == null ? void 0 : t.isRequired),
    isInvalid: s ?? (t == null ? void 0 : t.isInvalid),
    onFocus: Uy(t == null ? void 0 : t.onFocus, d),
    onBlur: Uy(t == null ? void 0 : t.onBlur, c)
  };
}
const { withProvider: x6, withContext: Gy } = Nn(KI), gL = x6(Te("input"), "field"), Gb = Je(function(t, r) {
  const i = C6(t);
  return /* @__PURE__ */ v.jsx(gL, { ref: r, ...i });
});
Gb.displayName = "Input";
const mL = x6(Te("div"), "group"), N1 = Object.assign(Gb, {
  Root: Gb,
  Group: mL,
  Field: Gy(Te("input"), "field"),
  Addon: Gy(E6, "addon")
}), vL = _i(Te("a", qI), "Link"), dm = Je(function({ isExternal: t, ...r }, i) {
  return /* @__PURE__ */ v.jsx(
    vL,
    {
      target: t ? "_blank" : void 0,
      rel: t ? "noopener" : void 0,
      ...r,
      ref: i
    }
  );
});
dm.displayName = "Link";
const kL = NS({
  slots: ["ul", "ol", "icon", "item"],
  base: {
    ul: {
      listStyleType: "initial",
      marginStart: "1em"
    },
    ol: {
      listStyleType: "decimal",
      marginStart: "1em"
    },
    icon: {
      marginEnd: "2",
      display: "inline",
      verticalAlign: "text-bottom"
    }
  }
}), { withProvider: A6, withContext: w6 } = Nn(kL), Ky = A6(Te.ul, "ul"), bL = A6(
  Te(
    "ol",
    {},
    {
      shouldForwardProp(e, t) {
        return e === "start";
      }
    }
  ),
  "ol"
), _L = w6(Te.li, "item"), DL = w6(Te.li, "icon"), ef = Object.assign(Ky, {
  Unordered: Ky,
  Ordered: bL,
  Item: _L,
  Icon: DL
}), { withProvider: yL, withContext: Kl } = Nn(BB), Yy = _i(
  yL(Te(Gl.Root), "root"),
  "Modal"
), EL = Kl(Te(Gl.Backdrop), "backdrop"), CL = Kl(
  // TODO recipe extension
  Te(Gl.CloseTrigger, Z_),
  "closeTrigger"
), xL = Kl(Te(Gl.Container), "container"), AL = Kl(Te(Gl.Content), "content"), wL = Je((e, t) => /* @__PURE__ */ v.jsx(Gl.Description, { as: "div", ...e, ref: t })), FL = Kl(
  Te(wL),
  "description"
), TL = Kl(Te(Gl.Title), "title"), SL = Kl(Te(Gl.Trigger), "trigger"), IL = Kl(Te("div"), "footer"), ri = Object.assign(Yy, {
  Root: Yy,
  Overlay: EL,
  Close: CL,
  Container: xL,
  Content: AL,
  Body: FL,
  Header: TL,
  Trigger: SL,
  Footer: IL
});
Te("button", Z_);
const { withProvider: BL, withContext: ls } = Nn(tB), qy = _i(
  BL(Te(ss.Root)),
  "Popover"
), RL = ls(Te(ss.Anchor), "anchor"), OL = ls(Te(ss.Arrow), "arrow"), PL = ls(Te(ss.ArrowTip), "arrowTip"), NL = ls(
  Te(ss.CloseTrigger),
  "closeTrigger"
), zL = ls(Te(ss.Content), "content"), LL = ls(
  Te(ss.Description),
  "description"
), ML = ls(Te("div"), "footer"), jL = ls(
  Te(ss.Positioner),
  "positioner"
), HL = ls(Te(ss.Title), "title"), $L = ls(Te(ss.Trigger), "trigger"), Da = Object.assign(qy, {
  Root: qy,
  Anchor: RL,
  Arrow: OL,
  ArrowTip: PL,
  CloseTrigger: NL,
  Content: zL,
  Description: LL,
  Footer: ML,
  Positioner: jL,
  Title: HL,
  Trigger: $L
}), UL = typeof document < "u" ? Xu : gt;
function F6(e) {
  const { children: t, target: r, tag: i, host: n } = e, a = qt(null), o = qt(null), [, s] = Jx((u) => u + 1, 0);
  UL(() => {
    if (!a.current)
      return;
    const u = a.current.ownerDocument, d = n ?? u.body;
    return o.current = u.createElement(i ?? "inkeep-portal"), d.appendChild(o.current), s(), () => {
      o.current && d.removeChild(o.current);
    };
  }, []);
  const l = (r == null ? void 0 : r.current) ?? o.current;
  return l ? t8(t, l) : xa("span", { ref: a });
}
const { withProvider: VL, withContext: qa } = Nn(VB), Qy = _i(
  VL(
    Te(
      wa.Root
    ),
    "root"
  ),
  "Select"
), WL = qa(
  Te(wa.ClearTrigger),
  "clearTrigger"
), GL = qa(Te(wa.Content), "content"), KL = qa(Te(wa.Control), "control"), YL = qa(
  Te(
    wa.Item
  ),
  "item"
), qL = qa(
  Te(wa.ItemGroup),
  "itemGroup"
), QL = qa(
  Te(wa.ItemGroupLabel),
  "itemGroupLabel"
), XL = qa(
  Te(wa.ItemIndicator),
  "itemIndicator"
), ZL = qa(Te(wa.ItemText), "itemText"), JL = qa(Te(wa.Label), "label"), eM = qa(
  Te(wa.Positioner),
  "positioner"
), tM = qa(Te(wa.Trigger), "trigger"), rM = qa(Te(wa.Value), "value"), Po = Object.assign(Qy, {
  Root: Qy,
  ClearTrigger: WL,
  Content: GL,
  Control: KL,
  Item: YL,
  ItemGroup: qL,
  ItemGroupLabel: QL,
  ItemIndicator: XL,
  ItemText: ZL,
  Label: JL,
  Positioner: eM,
  Trigger: tM,
  Value: rM
});
var $f = (e, t = []) => ({
  parts: (...r) => {
    if (iM(t))
      return $f(e, r);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...r) => $f(e, [...t, ...r]),
  rename: (r) => $f(r, t),
  keys: () => t,
  build: () => [...new Set(t)].reduce(
    (r, i) => Object.assign(r, {
      [i]: {
        selector: [
          `&[data-scope="${pd(e)}"][data-part="${pd(i)}"]`,
          `& [data-scope="${pd(e)}"][data-part="${pd(i)}"]`
        ].join(", "),
        attrs: { "data-scope": pd(e), "data-part": pd(i) }
      }
    }),
    {}
  )
}), pd = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), iM = (e) => e.length === 0;
function nM(e) {
  return typeof e == "object" && (e == null ? void 0 : e.nodeType) === Node.ELEMENT_NODE && typeof (e == null ? void 0 : e.nodeName) == "string";
}
var aM = (e) => e.nodeType === Node.DOCUMENT_NODE ? e : e.ownerDocument ?? document;
function oM(e) {
  const t = {
    getRootNode: (r) => {
      var i;
      return ((i = r.getRootNode) == null ? void 0 : i.call(r)) ?? document;
    },
    getDoc: (r) => aM(t.getRootNode(r)),
    getWin: (r) => t.getDoc(r).defaultView ?? window,
    getActiveElement: (r) => t.getDoc(r).activeElement,
    getById: (r, i) => t.getRootNode(r).getElementById(i),
    setValue: (r, i) => {
      r == null || i == null || (r.value = i.toString());
    }
  };
  return { ...t, ...e };
}
function sM(e) {
  const t = e.ownerDocument.defaultView || window, { overflow: r, overflowX: i, overflowY: n } = t.getComputedStyle(e);
  return /auto|scroll|overlay|hidden/.test(r + n + i);
}
function lM(e) {
  return e.localName === "html" ? e : e.assignedSlot || e.parentElement || e.ownerDocument.documentElement;
}
function T6(e) {
  return ["html", "body", "#document"].includes(e.localName) ? e.ownerDocument.body : nM(e) && sM(e) ? e : T6(lM(e));
}
var Kb = process.env.NODE_ENV !== "production", dk = (e) => typeof e == "object" && e !== null, yd = /* @__PURE__ */ new WeakMap(), tf = /* @__PURE__ */ new WeakSet(), uM = (e = Object.is, t = (u, d) => new Proxy(u, d), r = (u) => dk(u) && !tf.has(u) && (Array.isArray(u) || !(Symbol.iterator in u)) && !(u instanceof WeakMap) && !(u instanceof WeakSet) && !(u instanceof Error) && !(u instanceof Number) && !(u instanceof Date) && !(u instanceof String) && !(u instanceof RegExp) && !(u instanceof ArrayBuffer), i = (u) => {
  switch (u.status) {
    case "fulfilled":
      return u.value;
    case "rejected":
      throw u.reason;
    default:
      throw u;
  }
}, n = /* @__PURE__ */ new WeakMap(), a = (u, d, c = i) => {
  const p = n.get(u);
  if ((p == null ? void 0 : p[0]) === d)
    return p[1];
  const f = Array.isArray(u) ? [] : Object.create(Object.getPrototypeOf(u));
  return lg(f, !0), n.set(u, [d, f]), Reflect.ownKeys(u).forEach((g) => {
    const k = Reflect.get(u, g);
    tf.has(k) ? (lg(k, !1), f[g] = k) : k instanceof Promise ? Object.defineProperty(f, g, {
      get() {
        return c(k);
      }
    }) : yd.has(k) ? f[g] = dM(k, c) : f[g] = k;
  }), Object.freeze(f);
}, o = /* @__PURE__ */ new WeakMap(), s = [1, 1], l = (u) => {
  if (!dk(u))
    throw new Error("object required");
  const d = o.get(u);
  if (d)
    return d;
  let c = s[0];
  const p = /* @__PURE__ */ new Set(), f = (U, K = ++s[0]) => {
    c !== K && (c = K, p.forEach((z) => z(U, K)));
  };
  let g = s[1];
  const k = (U = ++s[1]) => (g !== U && !p.size && (g = U, _.forEach(([K]) => {
    const z = K[1](U);
    z > c && (c = z);
  })), c), y = (U) => (K, z) => {
    const j = [...K];
    j[1] = [U, ...j[1]], f(j, z);
  }, _ = /* @__PURE__ */ new Map(), A = (U, K) => {
    if (Kb && _.has(U))
      throw new Error("prop listener already exists");
    if (p.size) {
      const z = K[3](y(U));
      _.set(U, [K, z]);
    } else
      _.set(U, [K]);
  }, T = (U) => {
    var z;
    const K = _.get(U);
    K && (_.delete(U), (z = K[1]) == null || z.call(K));
  }, N = (U) => (p.add(U), p.size === 1 && _.forEach(([z, j], J) => {
    if (Kb && j)
      throw new Error("remove already exists");
    const ie = z[3](y(J));
    _.set(J, [z, ie]);
  }), () => {
    p.delete(U), p.size === 0 && _.forEach(([z, j], J) => {
      j && (j(), _.set(J, [z]));
    });
  }), P = Array.isArray(u) ? [] : Object.create(Object.getPrototypeOf(u)), M = t(P, {
    deleteProperty(U, K) {
      const z = Reflect.get(U, K);
      T(K);
      const j = Reflect.deleteProperty(U, K);
      return j && f(["delete", [K], z]), j;
    },
    set(U, K, z, j) {
      var de;
      const J = Reflect.has(U, K), ie = Reflect.get(U, K, j);
      if (J && (e(ie, z) || o.has(z) && e(ie, o.get(z))))
        return !0;
      T(K), dk(z) && (z = O8(z) || z);
      let ue = z;
      if (!((de = Object.getOwnPropertyDescriptor(U, K)) != null && de.set))
        if (z instanceof Promise)
          z.then((he) => {
            z.status = "fulfilled", z.value = he, f(["resolve", [K], he]);
          }).catch((he) => {
            z.status = "rejected", z.reason = he, f(["reject", [K], he]);
          });
        else {
          !yd.has(z) && r(z) && (ue = S6(z));
          const he = !tf.has(ue) && yd.get(ue);
          he && A(K, he);
        }
      return Reflect.set(U, K, ue, j), f(["set", [K], z, ie]), !0;
    }
  });
  o.set(u, M);
  const X = [P, k, a, N];
  return yd.set(M, X), Reflect.ownKeys(u).forEach((U) => {
    const K = Object.getOwnPropertyDescriptor(u, U);
    K.get || K.set ? Object.defineProperty(P, U, K) : M[U] = u[U];
  }), M;
}) => [
  // public functions
  l,
  // shared state
  yd,
  tf,
  // internal things
  e,
  t,
  r,
  i,
  n,
  a,
  o,
  s
], [cM] = uM();
function S6(e = {}) {
  return cM(e);
}
function dM(e, t) {
  const r = yd.get(e);
  Kb && !r && console.warn("Please use proxy object");
  const [i, n, a] = r;
  return a(i, n(), t);
}
var I6 = $f("tooltip").parts("trigger", "arrow", "arrowTip", "positioner", "content");
I6.build();
var xs = oM({
  getTriggerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.trigger) ?? `tooltip:${e.id}:trigger`;
  },
  getContentId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.content) ?? `tooltip:${e.id}:content`;
  },
  getArrowId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.arrow) ?? `tooltip:${e.id}:arrow`;
  },
  getPositionerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.positioner) ?? `tooltip:${e.id}:popper`;
  },
  getTriggerEl: (e) => xs.getById(e, xs.getTriggerId(e)),
  getContentEl: (e) => xs.getById(e, xs.getContentId(e)),
  getPositionerEl: (e) => xs.getById(e, xs.getPositionerId(e)),
  getArrowEl: (e) => xs.getById(e, xs.getArrowId(e)),
  getScrollParent: (e) => T6(xs.getTriggerEl(e))
});
S6({
  id: null,
  prevId: null,
  setId(e) {
    this.prevId = this.id, this.id = e;
  }
});
function pM() {
  const e = (t) => t;
  return new Proxy(e, {
    get() {
      return e;
    }
  });
}
var B6 = /* @__PURE__ */ pM();
const jo = qd.scope("tooltip", ["bg", "fg", "arrow-bg"]), Xy = qd.scope("arrow", [
  "size",
  "size-half",
  "background",
  "offset"
]);
I6.keys(), jo["arrow-bg"].name + "", jo.bg.ref, jo.bg.name + "", jo.fg.name + "", jo.bg.name + "", jo.fg.name + "", jo.bg.ref, jo.fg.ref, Xy.size.name + "", Xy.background.name + "", jo["arrow-bg"].ref;
const Zy = {
  skeleton: qd.scope("skeleton", ["start-color", "end-color"]),
  tooltip: jo
}, hM = Te("div", iB), Uf = _i(
  Je(
    ({ children: e, startColor: t, endColor: r, style: i, ...n }, a) => /* @__PURE__ */ v.jsx(
      hM,
      {
        ...n,
        style: {
          // @ts-ignore
          [Zy.skeleton["start-color"].name]: t,
          // @ts-ignore
          [Zy.skeleton["end-color"].name]: r,
          ...i
        },
        ref: a,
        children: e
      }
    )
  ),
  "Skeleton"
), { withProvider: fM, withContext: F2 } = Nn(QB), Jy = _i(
  fM(
    Te(
      lm.Root
    ),
    "root"
  ),
  "Switch"
), gM = F2(Te(lm.Control), "control"), mM = F2(Te(lm.Label), "label"), vM = F2(Te(lm.Thumb), "thumb"), rf = Object.assign(Jy, {
  Root: Jy,
  Control: gM,
  Label: mM,
  Thumb: vM
}), { withProvider: R6, withContext: Yl } = Nn(uB), kM = _i(
  R6(Te("div"), "container"),
  "Table"
), eE = _i(
  R6(Te("table"), "table"),
  "Table"
), bM = Yl(Te("tbody"), "tbody"), _M = Yl(Te("caption"), "caption"), DM = Yl(Te("td"), "td"), yM = Yl(Te("tfoot"), "tfoot"), EM = Yl(Te("th"), "th"), CM = Yl(Te("thead"), "thead"), xM = Yl(Te("tr"), "tr"), hd = Object.assign(eE, {
  Container: kM,
  Table: eE,
  Root: Yl(Te("table"), "table"),
  Body: bM,
  Caption: _M,
  Cell: DM,
  Footer: yM,
  Head: EM,
  Header: CM,
  Row: xM
}), { withProvider: AM, withContext: z1 } = Nn(rR), tE = _i(
  AM(
    Te(
      O1.Root
    ),
    "root"
  ),
  "Tabs"
), wM = z1(
  Te(
    O1.Content
  ),
  "content"
), FM = z1(Te("div"), "panels"), TM = z1(Te(O1.Indicator), "indicator"), SM = z1(Te(O1.List), "list"), IM = z1(
  Te(
    O1.Trigger
  ),
  "trigger"
), _0 = Object.assign(tE, {
  Root: tE,
  Panels: FM,
  Content: wM,
  Indicator: TM,
  List: SM,
  Trigger: IM
}), cn = Te.span, BM = _i(
  Te(St.textarea, dB),
  "Textarea"
), zs = Je(
  function(t, r) {
    const i = C6(t);
    return /* @__PURE__ */ v.jsx(BM, { ref: r, ...i });
  }
);
zs.displayName = "Textarea";
const { withProvider: RM, withContext: L1 } = Nn(lR), rE = _i(
  RM(Te(lp.Root)),
  "Tooltip"
), OM = L1(Te(lp.Arrow), "arrow"), PM = L1(Te(lp.ArrowTip), "arrowTip"), NM = L1(Te(lp.Content), "content"), zM = L1(
  Te(lp.Positioner),
  "positioner"
), LM = L1(Te(lp.Trigger), "trigger"), Ir = Object.assign(rE, {
  Root: rE,
  Arrow: OM,
  ArrowTip: PM,
  Content: NM,
  Positioner: zM,
  Trigger: LM
});
function iE(e, t = []) {
  const r = qt(e);
  return gt(() => {
    r.current = e;
  }), Nt((...i) => {
    var n;
    return (n = r.current) == null ? void 0 : n.call(r, ...i);
  }, t);
}
function pm(e = {}) {
  const {
    onClose: t,
    onOpen: r,
    isOpen: i,
    id: n
  } = e, a = iE(r), o = iE(t), [s, l] = rt(e.defaultIsOpen || !1), u = i !== void 0 ? i : s, d = i !== void 0, c = Co(), p = n ?? `disclosure-${c}`, f = Nt(() => {
    d || l(!1), o == null || o();
  }, [d, o]), g = Nt(() => {
    d || l(!0), a == null || a();
  }, [d, a]), k = Nt(() => {
    u ? f() : g();
  }, [u, g, f]);
  function y(A = {}) {
    return {
      ...A,
      "aria-expanded": u,
      "aria-controls": p,
      onClick(T) {
        var N;
        (N = A.onClick) == null || N.call(A, T), k();
      }
    };
  }
  function _(A = {}) {
    return {
      ...A,
      hidden: !u,
      id: p
    };
  }
  return {
    isOpen: u,
    onOpen: g,
    onClose: f,
    onToggle: k,
    isControlled: d,
    getButtonProps: y,
    getDisclosureProps: _
  };
}
function MM(e, t = {}) {
  const { ssr: r = !0, fallback: i } = t, n = Nt(() => window, []), a = Array.isArray(e) ? e : [e];
  let o = Array.isArray(i) ? i : [i];
  o = o.filter((u) => u != null);
  const [s, l] = rt(() => a.map((u, d) => ({
    media: u,
    matches: r ? !!o[d] : n().matchMedia(u).matches
  })));
  return gt(() => {
    const u = n();
    l(
      a.map((p) => ({
        media: p,
        matches: u.matchMedia(p).matches
      }))
    );
    const d = a.map((p) => u.matchMedia(p)), c = (p) => {
      l((f) => f.slice().map((g) => g.media === p.media ? { ...g, matches: p.matches } : g));
    };
    return d.forEach((p) => {
      typeof p.addListener == "function" ? p.addListener(c) : p.addEventListener("change", c);
    }), () => {
      d.forEach((p) => {
        typeof p.removeListener == "function" ? p.removeListener(c) : p.removeEventListener("change", c);
      });
    };
  }, [n]), s.map((u) => u.matches);
}
const [jM, O6] = nm({
  strict: !1,
  name: "ShadowContext"
}), HM = `@layer reset,base,tokens,recipes,recipes._base,recipes.slots,utilities;@layer reset{html{line-height:1.5;-webkit-text-size-adjust:100%;font-family:system-ui,sans-serif;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;touch-action:manipulation}body{position:relative;min-height:100%;margin:0;font-feature-settings:"kern"}:where(.inkeep-widget-vars) :where(*,*:before,*:after){border-width:0;border-style:solid;box-sizing:border-box;word-wrap:break-word}main{display:block}:where(.inkeep-widget-vars) hr{border-top-width:1px;box-sizing:content-box;height:0;overflow:visible}:where(.inkeep-widget-vars) :where(pre,code,kbd,samp){font-family:SFMono-Regular,Menlo,Monaco,Consolas,monospace;font-size:1em}:where(.inkeep-widget-vars) a{background-color:transparent;color:inherit;text-decoration:inherit}:where(.inkeep-widget-vars) abbr[title]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted}:where(.inkeep-widget-vars) :where(b,strong){font-weight:700}:where(.inkeep-widget-vars) small{font-size:80%}:where(.inkeep-widget-vars) :where(sub,sup){font-size:75%;line-height:0;position:relative;vertical-align:baseline}:where(.inkeep-widget-vars) sub{bottom:-.25em}:where(.inkeep-widget-vars) sup{top:-.5em}:where(.inkeep-widget-vars) img{border-style:none}:where(.inkeep-widget-vars) :where(button,input,optgroup,select,textarea){font-family:inherit;font-size:100%;line-height:1.15;margin:0}:where(.inkeep-widget-vars) :where(button,input){overflow:visible}:where(.inkeep-widget-vars) :where(button,select){text-transform:none}:where(.inkeep-widget-vars) :where(button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner){border-style:none;padding:0}:where(.inkeep-widget-vars) fieldset{padding:.35em .75em .625em}:where(.inkeep-widget-vars) legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}:where(.inkeep-widget-vars) progress{vertical-align:baseline}:where(.inkeep-widget-vars) textarea{overflow:auto}:where(.inkeep-widget-vars) :where([type=checkbox],[type=radio]){box-sizing:border-box;padding:0}:where(.inkeep-widget-vars) input[type=number]::-webkit-inner-spin-button,:where(.inkeep-widget-vars) input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none!important}:where(.inkeep-widget-vars) input[type=number]{-moz-appearance:textfield}:where(.inkeep-widget-vars) input[type=search]{-webkit-appearance:textfield;outline-offset:-2px}:where(.inkeep-widget-vars) input[type=search]::-webkit-search-decoration{-webkit-appearance:none!important}:where(.inkeep-widget-vars) ::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}:where(.inkeep-widget-vars) details{display:block}:where(.inkeep-widget-vars) summary{display:list-item}template{display:none}[hidden]{display:none!important}:where(.inkeep-widget-vars) :where(blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre){margin:0}:where(.inkeep-widget-vars) button{background:transparent;padding:0}:where(.inkeep-widget-vars) fieldset{margin:0;padding:0}:where(.inkeep-widget-vars) :where(ol,ul){margin:0;padding:0}:where(.inkeep-widget-vars) textarea{resize:vertical}:where(.inkeep-widget-vars) :where(button,[role=button]){cursor:pointer}:where(.inkeep-widget-vars) button::-moz-focus-inner{border:0!important}:where(.inkeep-widget-vars) table{border-collapse:collapse}:where(.inkeep-widget-vars) :where(h1,h2,h3,h4,h5,h6){font-size:inherit;font-weight:inherit}:where(.inkeep-widget-vars) :where(button,input,optgroup,select,textarea){padding:0;line-height:inherit;color:inherit}:where(.inkeep-widget-vars) :where(img,svg,video,canvas,audio,iframe,embed,object){display:block}:where(.inkeep-widget-vars) :where(img,video){max-width:100%;height:auto}[data-js-focus-visible] :focus:not([data-focus-visible-added]):not([data-focus-visible-disabled]){outline:none;box-shadow:none}:where(.inkeep-widget-vars) select::-ms-expand{display:none}:root,:host{--chakra-vh: 100vh}@supports (height: -webkit-fill-available){:root,:host{--chakra-vh: -webkit-fill-available}}@supports (height: -moz-fill-available){:root,:host{--chakra-vh: -moz-fill-available}}@supports (height: 100dvh){:root,:host{--chakra-vh: 100dvh}}}
`, $M = ({
  withCss: e = !0,
  wrapperStyles: t = {},
  children: r,
  customStyles: i
}) => {
  const [n, a] = rt(null), [o, s] = rt(null), l = Jt(
    () => ({ shadowHost: n, rootElement: o }),
    [n, o]
  ), u = Co();
  return /* @__PURE__ */ v.jsxs(
    lS.div,
    {
      id: `inkeep-shadow${u}`,
      ref: (d) => {
        d && a(d);
      },
      style: t,
      children: [
        e && /* @__PURE__ */ v.jsxs("style", { type: "text/css", children: [
          `@import
          url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;900&display=swap');`,
          HM,
          uS
        ] }),
        i,
        /* @__PURE__ */ v.jsx(
          "div",
          {
            id: "inkeep-widget-root",
            ref: (d) => {
              d && s(d);
            },
            style: t,
            children: /* @__PURE__ */ v.jsx(jM, { value: l, children: n && o && r })
          }
        )
      ]
    }
  );
}, P6 = (e) => O6() ? e.children : /* @__PURE__ */ v.jsx($M, { ...e });
var Cg = { exports: {} };
Cg.exports;
(function(e, t) {
  var r = 200, i = "__lodash_hash_undefined__", n = 1, a = 2, o = 9007199254740991, s = "[object Arguments]", l = "[object Array]", u = "[object AsyncFunction]", d = "[object Boolean]", c = "[object Date]", p = "[object Error]", f = "[object Function]", g = "[object GeneratorFunction]", k = "[object Map]", y = "[object Number]", _ = "[object Null]", A = "[object Object]", T = "[object Promise]", N = "[object Proxy]", P = "[object RegExp]", B = "[object Set]", M = "[object String]", X = "[object Symbol]", U = "[object Undefined]", K = "[object WeakMap]", z = "[object ArrayBuffer]", j = "[object DataView]", J = "[object Float32Array]", ie = "[object Float64Array]", ue = "[object Int8Array]", de = "[object Int16Array]", he = "[object Int32Array]", Ee = "[object Uint8Array]", Le = "[object Uint8ClampedArray]", L = "[object Uint16Array]", me = "[object Uint32Array]", Se = /[\\^$.*+?()[\]{}|]/g, G = /^\[object .+?Constructor\]$/, He = /^(?:0|[1-9]\d*)$/, xe = {};
  xe[J] = xe[ie] = xe[ue] = xe[de] = xe[he] = xe[Ee] = xe[Le] = xe[L] = xe[me] = !0, xe[s] = xe[l] = xe[z] = xe[d] = xe[j] = xe[c] = xe[p] = xe[f] = xe[k] = xe[y] = xe[A] = xe[P] = xe[B] = xe[M] = xe[K] = !1;
  var _e = typeof L0 == "object" && L0 && L0.Object === Object && L0, Ze = typeof self == "object" && self && self.Object === Object && self, qe = _e || Ze || Function("return this")(), nt = t && !t.nodeType && t, at = nt && !0 && e && !e.nodeType && e, At = at && at.exports === nt, Oe = At && _e.process, wt = function() {
    try {
      return Oe && Oe.binding && Oe.binding("util");
    } catch {
    }
  }(), Ge = wt && wt.isTypedArray;
  function nr(Y, le) {
    for (var Pe = -1, it = Y == null ? 0 : Y.length, Zt = 0, Pt = []; ++Pe < it; ) {
      var xr = Y[Pe];
      le(xr, Pe, Y) && (Pt[Zt++] = xr);
    }
    return Pt;
  }
  function vr(Y, le) {
    for (var Pe = -1, it = le.length, Zt = Y.length; ++Pe < it; )
      Y[Zt + Pe] = le[Pe];
    return Y;
  }
  function zr(Y, le) {
    for (var Pe = -1, it = Y == null ? 0 : Y.length; ++Pe < it; )
      if (le(Y[Pe], Pe, Y))
        return !0;
    return !1;
  }
  function Wr(Y, le) {
    for (var Pe = -1, it = Array(Y); ++Pe < Y; )
      it[Pe] = le(Pe);
    return it;
  }
  function ne(Y) {
    return function(le) {
      return Y(le);
    };
  }
  function pe(Y, le) {
    return Y.has(le);
  }
  function Fe(Y, le) {
    return Y == null ? void 0 : Y[le];
  }
  function Ye(Y) {
    var le = -1, Pe = Array(Y.size);
    return Y.forEach(function(it, Zt) {
      Pe[++le] = [Zt, it];
    }), Pe;
  }
  function Ue(Y, le) {
    return function(Pe) {
      return Y(le(Pe));
    };
  }
  function Re(Y) {
    var le = -1, Pe = Array(Y.size);
    return Y.forEach(function(it) {
      Pe[++le] = it;
    }), Pe;
  }
  var ot = Array.prototype, Ut = Function.prototype, ge = Object.prototype, Ie = qe["__core-js_shared__"], ut = Ut.toString, xt = ge.hasOwnProperty, Bt = function() {
    var Y = /[^.]+$/.exec(Ie && Ie.keys && Ie.keys.IE_PROTO || "");
    return Y ? "Symbol(src)_1." + Y : "";
  }(), gr = ge.toString, Gr = RegExp(
    "^" + ut.call(xt).replace(Se, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), kr = At ? qe.Buffer : void 0, Xr = qe.Symbol, Er = qe.Uint8Array, tr = ge.propertyIsEnumerable, Ti = ot.splice, lt = Xr ? Xr.toStringTag : void 0, _r = Object.getOwnPropertySymbols, hr = kr ? kr.isBuffer : void 0, $t = Ue(Object.keys, Object), pi = yt(qe, "DataView"), Di = yt(qe, "Map"), Zi = yt(qe, "Promise"), yi = yt(qe, "Set"), pn = yt(qe, "WeakMap"), vi = yt(Object, "create"), Cr = Ri(pi), ca = Ri(Di), da = Ri(Zi), pa = Ri(yi), Lr = Ri(pn), Ln = Xr ? Xr.prototype : void 0, ha = Ln ? Ln.valueOf : void 0;
  function Ji(Y) {
    var le = -1, Pe = Y == null ? 0 : Y.length;
    for (this.clear(); ++le < Pe; ) {
      var it = Y[le];
      this.set(it[0], it[1]);
    }
  }
  function te() {
    this.__data__ = vi ? vi(null) : {}, this.size = 0;
  }
  function $e(Y) {
    var le = this.has(Y) && delete this.__data__[Y];
    return this.size -= le ? 1 : 0, le;
  }
  function tt(Y) {
    var le = this.__data__;
    if (vi) {
      var Pe = le[Y];
      return Pe === i ? void 0 : Pe;
    }
    return xt.call(le, Y) ? le[Y] : void 0;
  }
  function Et(Y) {
    var le = this.__data__;
    return vi ? le[Y] !== void 0 : xt.call(le, Y);
  }
  function Vt(Y, le) {
    var Pe = this.__data__;
    return this.size += this.has(Y) ? 0 : 1, Pe[Y] = vi && le === void 0 ? i : le, this;
  }
  Ji.prototype.clear = te, Ji.prototype.delete = $e, Ji.prototype.get = tt, Ji.prototype.has = Et, Ji.prototype.set = Vt;
  function Rt(Y) {
    var le = -1, Pe = Y == null ? 0 : Y.length;
    for (this.clear(); ++le < Pe; ) {
      var it = Y[le];
      this.set(it[0], it[1]);
    }
  }
  function Gt() {
    this.__data__ = [], this.size = 0;
  }
  function Lt(Y) {
    var le = this.__data__, Pe = Dn(le, Y);
    if (Pe < 0)
      return !1;
    var it = le.length - 1;
    return Pe == it ? le.pop() : Ti.call(le, Pe, 1), --this.size, !0;
  }
  function Mr(Y) {
    var le = this.__data__, Pe = Dn(le, Y);
    return Pe < 0 ? void 0 : le[Pe][1];
  }
  function ar(Y) {
    return Dn(this.__data__, Y) > -1;
  }
  function or(Y, le) {
    var Pe = this.__data__, it = Dn(Pe, Y);
    return it < 0 ? (++this.size, Pe.push([Y, le])) : Pe[it][1] = le, this;
  }
  Rt.prototype.clear = Gt, Rt.prototype.delete = Lt, Rt.prototype.get = Mr, Rt.prototype.has = ar, Rt.prototype.set = or;
  function dr(Y) {
    var le = -1, Pe = Y == null ? 0 : Y.length;
    for (this.clear(); ++le < Pe; ) {
      var it = Y[le];
      this.set(it[0], it[1]);
    }
  }
  function Si() {
    this.size = 0, this.__data__ = {
      hash: new Ji(),
      map: new (Di || Rt)(),
      string: new Ji()
    };
  }
  function hn(Y) {
    var le = dt(this, Y).delete(Y);
    return this.size -= le ? 1 : 0, le;
  }
  function jr(Y) {
    return dt(this, Y).get(Y);
  }
  function Hr(Y) {
    return dt(this, Y).has(Y);
  }
  function fn(Y, le) {
    var Pe = dt(this, Y), it = Pe.size;
    return Pe.set(Y, le), this.size += Pe.size == it ? 0 : 1, this;
  }
  dr.prototype.clear = Si, dr.prototype.delete = hn, dr.prototype.get = jr, dr.prototype.has = Hr, dr.prototype.set = fn;
  function Ii(Y) {
    var le = -1, Pe = Y == null ? 0 : Y.length;
    for (this.__data__ = new dr(); ++le < Pe; )
      this.add(Y[le]);
  }
  function fi(Y) {
    return this.__data__.set(Y, i), this;
  }
  function Fa(Y) {
    return this.__data__.has(Y);
  }
  Ii.prototype.add = Ii.prototype.push = fi, Ii.prototype.has = Fa;
  function gi(Y) {
    var le = this.__data__ = new Rt(Y);
    this.size = le.size;
  }
  function gn() {
    this.__data__ = new Rt(), this.size = 0;
  }
  function Bi(Y) {
    var le = this.__data__, Pe = le.delete(Y);
    return this.size = le.size, Pe;
  }
  function _n(Y) {
    return this.__data__.get(Y);
  }
  function Mn(Y) {
    return this.__data__.has(Y);
  }
  function to(Y, le) {
    var Pe = this.__data__;
    if (Pe instanceof Rt) {
      var it = Pe.__data__;
      if (!Di || it.length < r - 1)
        return it.push([Y, le]), this.size = ++Pe.size, this;
      Pe = this.__data__ = new dr(it);
    }
    return Pe.set(Y, le), this.size = Pe.size, this;
  }
  gi.prototype.clear = gn, gi.prototype.delete = Bi, gi.prototype.get = _n, gi.prototype.has = Mn, gi.prototype.set = to;
  function ro(Y, le) {
    var Pe = $n(Y), it = !Pe && Cn(Y), Zt = !Pe && !it && ps(Y), Pt = !Pe && !it && !Zt && io(Y), xr = Pe || it || Zt || Pt, ai = xr ? Wr(Y.length, String) : [], hi = ai.length;
    for (var Ar in Y)
      (le || xt.call(Y, Ar)) && !(xr && // Safari 9 has enumerable `arguments.length` in strict mode.
      (Ar == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      Zt && (Ar == "offset" || Ar == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      Pt && (Ar == "buffer" || Ar == "byteLength" || Ar == "byteOffset") || // Skip index properties.
      Ei(Ar, hi))) && ai.push(Ar);
    return ai;
  }
  function Dn(Y, le) {
    for (var Pe = Y.length; Pe--; )
      if (Hn(Y[Pe][0], le))
        return Pe;
    return -1;
  }
  function jn(Y, le, Pe) {
    var it = le(Y);
    return $n(Y) ? it : vr(it, Pe(Y));
  }
  function yn(Y) {
    return Y == null ? Y === void 0 ? U : _ : lt && lt in Object(Y) ? Dt(Y) : Ta(Y);
  }
  function fa(Y) {
    return xn(Y) && yn(Y) == s;
  }
  function ga(Y, le, Pe, it, Zt) {
    return Y === le ? !0 : Y == null || le == null || !xn(Y) && !xn(le) ? Y !== Y && le !== le : E(Y, le, Pe, it, ga, Zt);
  }
  function E(Y, le, Pe, it, Zt, Pt) {
    var xr = $n(Y), ai = $n(le), hi = xr ? l : Zr(Y), Ar = ai ? l : Zr(le);
    hi = hi == s ? A : hi, Ar = Ar == s ? A : Ar;
    var Hi = hi == A, tn = Ar == A, oi = hi == Ar;
    if (oi && ps(Y)) {
      if (!ps(le))
        return !1;
      xr = !0, Hi = !1;
    }
    if (oi && !Hi)
      return Pt || (Pt = new gi()), xr || io(Y) ? ve(Y, le, Pe, it, Zt, Pt) : ce(Y, le, hi, Pe, it, Zt, Pt);
    if (!(Pe & n)) {
      var xi = Hi && xt.call(Y, "__wrapped__"), Ai = tn && xt.call(le, "__wrapped__");
      if (xi || Ai) {
        var Ki = xi ? Y.value() : Y, An = Ai ? le.value() : le;
        return Pt || (Pt = new gi()), Zt(Ki, An, Pe, it, Pt);
      }
    }
    return oi ? (Pt || (Pt = new gi()), Ae(Y, le, Pe, it, Zt, Pt)) : !1;
  }
  function I(Y) {
    if (!mn(Y) || En(Y))
      return !1;
    var le = Ks(Y) ? Gr : G;
    return le.test(Ri(Y));
  }
  function V(Y) {
    return xn(Y) && Fo(Y.length) && !!xe[yn(Y)];
  }
  function q(Y) {
    if (!en(Y))
      return $t(Y);
    var le = [];
    for (var Pe in Object(Y))
      xt.call(Y, Pe) && Pe != "constructor" && le.push(Pe);
    return le;
  }
  function ve(Y, le, Pe, it, Zt, Pt) {
    var xr = Pe & n, ai = Y.length, hi = le.length;
    if (ai != hi && !(xr && hi > ai))
      return !1;
    var Ar = Pt.get(Y);
    if (Ar && Pt.get(le))
      return Ar == le;
    var Hi = -1, tn = !0, oi = Pe & a ? new Ii() : void 0;
    for (Pt.set(Y, le), Pt.set(le, Y); ++Hi < ai; ) {
      var xi = Y[Hi], Ai = le[Hi];
      if (it)
        var Ki = xr ? it(Ai, xi, Hi, le, Y, Pt) : it(xi, Ai, Hi, Y, le, Pt);
      if (Ki !== void 0) {
        if (Ki)
          continue;
        tn = !1;
        break;
      }
      if (oi) {
        if (!zr(le, function(An, rn) {
          if (!pe(oi, rn) && (xi === An || Zt(xi, An, Pe, it, Pt)))
            return oi.push(rn);
        })) {
          tn = !1;
          break;
        }
      } else if (!(xi === Ai || Zt(xi, Ai, Pe, it, Pt))) {
        tn = !1;
        break;
      }
    }
    return Pt.delete(Y), Pt.delete(le), tn;
  }
  function ce(Y, le, Pe, it, Zt, Pt, xr) {
    switch (Pe) {
      case j:
        if (Y.byteLength != le.byteLength || Y.byteOffset != le.byteOffset)
          return !1;
        Y = Y.buffer, le = le.buffer;
      case z:
        return !(Y.byteLength != le.byteLength || !Pt(new Er(Y), new Er(le)));
      case d:
      case c:
      case y:
        return Hn(+Y, +le);
      case p:
        return Y.name == le.name && Y.message == le.message;
      case P:
      case M:
        return Y == le + "";
      case k:
        var ai = Ye;
      case B:
        var hi = it & n;
        if (ai || (ai = Re), Y.size != le.size && !hi)
          return !1;
        var Ar = xr.get(Y);
        if (Ar)
          return Ar == le;
        it |= a, xr.set(Y, le);
        var Hi = ve(ai(Y), ai(le), it, Zt, Pt, xr);
        return xr.delete(Y), Hi;
      case X:
        if (ha)
          return ha.call(Y) == ha.call(le);
    }
    return !1;
  }
  function Ae(Y, le, Pe, it, Zt, Pt) {
    var xr = Pe & n, ai = Ve(Y), hi = ai.length, Ar = Ve(le), Hi = Ar.length;
    if (hi != Hi && !xr)
      return !1;
    for (var tn = hi; tn--; ) {
      var oi = ai[tn];
      if (!(xr ? oi in le : xt.call(le, oi)))
        return !1;
    }
    var xi = Pt.get(Y);
    if (xi && Pt.get(le))
      return xi == le;
    var Ai = !0;
    Pt.set(Y, le), Pt.set(le, Y);
    for (var Ki = xr; ++tn < hi; ) {
      oi = ai[tn];
      var An = Y[oi], rn = le[oi];
      if (it)
        var To = xr ? it(rn, An, oi, le, Y, Pt) : it(An, rn, oi, Y, le, Pt);
      if (!(To === void 0 ? An === rn || Zt(An, rn, Pe, it, Pt) : To)) {
        Ai = !1;
        break;
      }
      Ki || (Ki = oi == "constructor");
    }
    if (Ai && !Ki) {
      var Sa = Y.constructor, wn = le.constructor;
      Sa != wn && "constructor" in Y && "constructor" in le && !(typeof Sa == "function" && Sa instanceof Sa && typeof wn == "function" && wn instanceof wn) && (Ai = !1);
    }
    return Pt.delete(Y), Pt.delete(le), Ai;
  }
  function Ve(Y) {
    return jn(Y, br, rr);
  }
  function dt(Y, le) {
    var Pe = Y.__data__;
    return Ci(le) ? Pe[typeof le == "string" ? "string" : "hash"] : Pe.map;
  }
  function yt(Y, le) {
    var Pe = Fe(Y, le);
    return I(Pe) ? Pe : void 0;
  }
  function Dt(Y) {
    var le = xt.call(Y, lt), Pe = Y[lt];
    try {
      Y[lt] = void 0;
      var it = !0;
    } catch {
    }
    var Zt = gr.call(Y);
    return it && (le ? Y[lt] = Pe : delete Y[lt]), Zt;
  }
  var rr = _r ? function(Y) {
    return Y == null ? [] : (Y = Object(Y), nr(_r(Y), function(le) {
      return tr.call(Y, le);
    }));
  } : Un, Zr = yn;
  (pi && Zr(new pi(new ArrayBuffer(1))) != j || Di && Zr(new Di()) != k || Zi && Zr(Zi.resolve()) != T || yi && Zr(new yi()) != B || pn && Zr(new pn()) != K) && (Zr = function(Y) {
    var le = yn(Y), Pe = le == A ? Y.constructor : void 0, it = Pe ? Ri(Pe) : "";
    if (it)
      switch (it) {
        case Cr:
          return j;
        case ca:
          return k;
        case da:
          return T;
        case pa:
          return B;
        case Lr:
          return K;
      }
    return le;
  });
  function Ei(Y, le) {
    return le = le ?? o, !!le && (typeof Y == "number" || He.test(Y)) && Y > -1 && Y % 1 == 0 && Y < le;
  }
  function Ci(Y) {
    var le = typeof Y;
    return le == "string" || le == "number" || le == "symbol" || le == "boolean" ? Y !== "__proto__" : Y === null;
  }
  function En(Y) {
    return !!Bt && Bt in Y;
  }
  function en(Y) {
    var le = Y && Y.constructor, Pe = typeof le == "function" && le.prototype || ge;
    return Y === Pe;
  }
  function Ta(Y) {
    return gr.call(Y);
  }
  function Ri(Y) {
    if (Y != null) {
      try {
        return ut.call(Y);
      } catch {
      }
      try {
        return Y + "";
      } catch {
      }
    }
    return "";
  }
  function Hn(Y, le) {
    return Y === le || Y !== Y && le !== le;
  }
  var Cn = fa(function() {
    return arguments;
  }()) ? fa : function(Y) {
    return xn(Y) && xt.call(Y, "callee") && !tr.call(Y, "callee");
  }, $n = Array.isArray;
  function Jl(Y) {
    return Y != null && Fo(Y.length) && !Ks(Y);
  }
  var ps = hr || ji;
  function hs(Y, le) {
    return ga(Y, le);
  }
  function Ks(Y) {
    if (!mn(Y))
      return !1;
    var le = yn(Y);
    return le == f || le == g || le == u || le == N;
  }
  function Fo(Y) {
    return typeof Y == "number" && Y > -1 && Y % 1 == 0 && Y <= o;
  }
  function mn(Y) {
    var le = typeof Y;
    return Y != null && (le == "object" || le == "function");
  }
  function xn(Y) {
    return Y != null && typeof Y == "object";
  }
  var io = Ge ? ne(Ge) : V;
  function br(Y) {
    return Jl(Y) ? ro(Y) : q(Y);
  }
  function Un() {
    return [];
  }
  function ji() {
    return !1;
  }
  e.exports = hs;
})(Cg, Cg.exports);
var UM = Cg.exports;
const ql = /* @__PURE__ */ is(UM);
var xg = /* @__PURE__ */ ((e) => (e.Auto = "AUTO", e.Turbo = "TURBO", e))(xg || {}), N6 = /* @__PURE__ */ ((e) => (e.Closed = "CLOSED", e.Open = "OPEN", e))(N6 || {}), z6 = /* @__PURE__ */ ((e) => (e.Auto = "AUTO", e.Intelligent = "INTELLIGENT", e.Keyword = "KEYWORD", e))(z6 || {}), hm = /* @__PURE__ */ ((e) => (e.ChatButton = "CHAT_BUTTON", e.CustomTrigger = "CUSTOM_TRIGGER", e.EmbeddedChat = "EMBEDDED_CHAT", e.SearchBar = "SEARCH_BAR", e))(hm || {});
const VM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "GetSearchRootRecords" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "ids" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getSearchRootRecords" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "ids" }, value: { kind: "Variable", name: { kind: "Name", value: "ids" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "preview" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DocumentationRecord" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pathBreadcrumbs" } }, { kind: "Field", name: { kind: "Name", value: "contentType" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHubIssueRecord" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DiscourseRecord" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "categoryBreadcrumbs" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StackOverflowRecord" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }] } }] } }] } }] }, L6 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "subscription", name: { kind: "Name", value: "OnNewSessionChatResult" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageInput" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageContext" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "integrationId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "chatMode" } }, type: { kind: "NamedType", name: { kind: "Name", value: "ChatMode" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "filters" } }, type: { kind: "NamedType", name: { kind: "Name", value: "ChatFiltersInput" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageAttributes" } }, type: { kind: "NamedType", name: { kind: "Name", value: "JSON" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "tags" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "workflowId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "context" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "guidance" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "includeAIAnnotations" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "environment" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "newSessionChatResult" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "messageInput" }, value: { kind: "Variable", name: { kind: "Name", value: "messageInput" } } }, { kind: "ObjectField", name: { kind: "Name", value: "messageContext" }, value: { kind: "Variable", name: { kind: "Name", value: "messageContext" } } }, { kind: "ObjectField", name: { kind: "Name", value: "organizationId" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "integrationId" }, value: { kind: "Variable", name: { kind: "Name", value: "integrationId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "chatMode" }, value: { kind: "Variable", name: { kind: "Name", value: "chatMode" } } }, { kind: "ObjectField", name: { kind: "Name", value: "filters" }, value: { kind: "Variable", name: { kind: "Name", value: "filters" } } }, { kind: "ObjectField", name: { kind: "Name", value: "messageAttributes" }, value: { kind: "Variable", name: { kind: "Name", value: "messageAttributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "tags" }, value: { kind: "Variable", name: { kind: "Name", value: "tags" } } }, { kind: "ObjectField", name: { kind: "Name", value: "workflowId" }, value: { kind: "Variable", name: { kind: "Name", value: "workflowId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "context" }, value: { kind: "Variable", name: { kind: "Name", value: "context" } } }, { kind: "ObjectField", name: { kind: "Name", value: "guidance" }, value: { kind: "Variable", name: { kind: "Name", value: "guidance" } } }, { kind: "ObjectField", name: { kind: "Name", value: "environment" }, value: { kind: "Variable", name: { kind: "Name", value: "environment" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isEnd" } }, { kind: "Field", name: { kind: "Name", value: "sessionId" } }, { kind: "Field", name: { kind: "Name", value: "message" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "BotMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "citations" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "citationNumber" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "rootRecordId" } }, { kind: "Field", name: { kind: "Name", value: "rootRecordType" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "aiAnnotations" }, directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "includeAIAnnotations" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shouldEscalateToSupport" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "strict" } }, { kind: "Field", name: { kind: "Name", value: "standard" } }] } }] } }] } }] } }] }, M6 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "subscription", name: { kind: "Name", value: "OnContinueChatResult" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageInput" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "sessionId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageContext" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageAttributes" } }, type: { kind: "NamedType", name: { kind: "Name", value: "JSON" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "includeAIAnnotations" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "continueChatResult" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "messageInput" }, value: { kind: "Variable", name: { kind: "Name", value: "messageInput" } } }, { kind: "ObjectField", name: { kind: "Name", value: "sessionId" }, value: { kind: "Variable", name: { kind: "Name", value: "sessionId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "messageContext" }, value: { kind: "Variable", name: { kind: "Name", value: "messageContext" } } }, { kind: "ObjectField", name: { kind: "Name", value: "messageAttributes" }, value: { kind: "Variable", name: { kind: "Name", value: "messageAttributes" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isEnd" } }, { kind: "Field", name: { kind: "Name", value: "sessionId" } }, { kind: "Field", name: { kind: "Name", value: "message" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "BotMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "citations" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "citationNumber" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "rootRecordId" } }, { kind: "Field", name: { kind: "Name", value: "rootRecordType" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "aiAnnotations" }, directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "includeAIAnnotations" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shouldEscalateToSupport" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "strict" } }, { kind: "Field", name: { kind: "Name", value: "standard" } }] } }] } }] } }] } }] }, WM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "LogUsageEvent" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LogUsageEventInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "logUsageEvent" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }] } }] } }] }, GM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "GetSearchResults" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "searchInput" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "SearchInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "searchInput" }, value: { kind: "Variable", name: { kind: "Name", value: "searchInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchHits" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hitOnRoot" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "preview" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DocumentationHit" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rootRecord" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "preview" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DocumentationRecord" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pathBreadcrumbs" } }, { kind: "Field", name: { kind: "Name", value: "contentType" } }, { kind: "Field", name: { kind: "Name", value: "topLevelHeadings" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "anchor" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "htmlTag" } }, { kind: "Field", name: { kind: "Name", value: "content" } }] } }, { kind: "Field", name: { kind: "Name", value: "firstContentPath" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "anchor" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "htmlTag" } }, { kind: "Field", name: { kind: "Name", value: "content" } }] } }, { kind: "Field", name: { kind: "Name", value: "firstContent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pathHeadings" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "anchor" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "htmlTag" } }, { kind: "Field", name: { kind: "Name", value: "content" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "anchor" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "htmlTag" } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "contentHtml" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StackOverflowHit" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rootRecord" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "preview" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StackOverflowRecord" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "score" } }, { kind: "Field", name: { kind: "Name", value: "topVotedAnswer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "score" } }, { kind: "Field", name: { kind: "Name", value: "content" } }] } }, { kind: "Field", name: { kind: "Name", value: "markedAsCorrectAnswer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "score" } }, { kind: "Field", name: { kind: "Name", value: "content" } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHubIssueHit" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rootRecord" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "preview" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHubIssueRecord" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "reactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reactionType" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "commentsWithMostPositiveReactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "commentDate" } }, { kind: "Field", name: { kind: "Name", value: "reactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reactionType" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DiscourseHit" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rootRecord" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "preview" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DiscourseRecord" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyHtml" } }, { kind: "Field", name: { kind: "Name", value: "categoryBreadcrumbs" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "searchQuery" } }] } }] } }] }, KM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "GetChatSession" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getChatSession" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "organizationId" } }, { kind: "Field", name: { kind: "Name", value: "chatMode" } }, { kind: "Field", name: { kind: "Name", value: "workflowId" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "UserMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "context" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "BotMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "citations" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "citationNumber" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "rootRecordId" } }, { kind: "Field", name: { kind: "Name", value: "rootRecordType" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "filters" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "product" } }, { kind: "Field", name: { kind: "Name", value: "productVersion" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }] } }] } }] } }] }, YM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "CopyChatSession" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "sessionId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "isSharedSession" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "copyChatSession" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "sessionId" }, value: { kind: "Variable", name: { kind: "Name", value: "sessionId" } } }, { kind: "Argument", name: { kind: "Name", value: "isSharedSession" }, value: { kind: "Variable", name: { kind: "Name", value: "isSharedSession" } } }] }] } }] };
function j6(e) {
  const t = qt(void 0);
  return Jt(() => (ql(e, t.current) || (t.current = e), t.current), [e]);
}
function H6(e = 21) {
  const t = new Uint8Array(e);
  return crypto.getRandomValues(t), Array.from(t, (r) => r.toString(36)).join("").slice(0, e);
}
const nE = /* @__PURE__ */ new Map();
function kl(e = "id") {
  const r = (nE.get(e) || 0) + 1;
  return nE.set(e, r), `${e}${r}`;
}
function $6(e = []) {
  const [t, r] = rt([]), i = t.length >= e.length, n = Jt(
    () => (o) => {
      r((s) => [.../* @__PURE__ */ new Set([...s, o])]);
    },
    []
  );
  return [Jt(
    () => e.map((o) => {
      const s = kl("stylesheet_");
      return /* @__PURE__ */ v.jsx(
        "link",
        {
          id: s,
          rel: "stylesheet",
          type: "text/css",
          href: o,
          onLoad: () => {
            n(o);
          }
        },
        s
      );
    }),
    [e, n]
  ), i];
}
const T2 = (e) => ({
  customStyles: t,
  shouldRender: r,
  inkeepShadowProps: i,
  ...n
}) => /* @__PURE__ */ v.jsxs(P6, { ...i, children: [
  t,
  /* @__PURE__ */ v.jsx(
    "div",
    {
      style: {
        visibility: r ? "visible" : "hidden",
        ...i == null ? void 0 : i.wrapperStyles
      },
      children: /* @__PURE__ */ v.jsx(e, { ...n })
    }
  )
] }), S2 = (e) => ({ ...t }) => {
  var u;
  const r = (u = t.baseSettings) == null ? void 0 : u.theme, i = (r == null ? void 0 : r.stylesheetUrls) || [], n = r == null ? void 0 : r.stylesheets, a = j6(i), [o, s] = $6(a), l = Jt(
    () => /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      n,
      o
    ] }),
    // technically we should do a deep compare of stylesheets here but was causing extra rerenders so leaving as is for now
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [a, n == null ? void 0 : n.length]
  );
  return /* @__PURE__ */ v.jsx(
    e,
    {
      ...t,
      shouldRender: s,
      customStyles: l
    }
  );
}, qM = (e) => (t) => /* @__PURE__ */ v.jsx(F6, { children: /* @__PURE__ */ v.jsx(e, { ...t }) });
function U6(e) {
  var t, r, i = "";
  if (typeof e == "string" || typeof e == "number")
    i += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (r = U6(e[t])) && (i && (i += " "), i += r);
    else
      for (t in e)
        e[t] && (i && (i += " "), i += t);
  return i;
}
function V6() {
  for (var e, t, r = 0, i = ""; r < arguments.length; )
    (e = arguments[r++]) && (t = U6(e)) && (i && (i += " "), i += t);
  return i;
}
var QM = Object.create, fm = Object.defineProperty, XM = Object.defineProperties, ZM = Object.getOwnPropertyDescriptor, JM = Object.getOwnPropertyDescriptors, W6 = Object.getOwnPropertyNames, Ag = Object.getOwnPropertySymbols, ej = Object.getPrototypeOf, I2 = Object.prototype.hasOwnProperty, G6 = Object.prototype.propertyIsEnumerable, aE = (e, t, r) => t in e ? fm(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Yo = (e, t) => {
  for (var r in t || (t = {}))
    I2.call(t, r) && aE(e, r, t[r]);
  if (Ag)
    for (var r of Ag(t))
      G6.call(t, r) && aE(e, r, t[r]);
  return e;
}, gm = (e, t) => XM(e, JM(t)), K6 = (e, t) => {
  var r = {};
  for (var i in e)
    I2.call(e, i) && t.indexOf(i) < 0 && (r[i] = e[i]);
  if (e != null && Ag)
    for (var i of Ag(e))
      t.indexOf(i) < 0 && G6.call(e, i) && (r[i] = e[i]);
  return r;
}, tj = (e, t) => function() {
  return t || (0, e[W6(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, rj = (e, t) => {
  for (var r in t)
    fm(e, r, { get: t[r], enumerable: !0 });
}, ij = (e, t, r, i) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let n of W6(t))
      !I2.call(e, n) && n !== r && fm(e, n, { get: () => t[n], enumerable: !(i = ZM(t, n)) || i.enumerable });
  return e;
}, nj = (e, t, r) => (r = e != null ? QM(ej(e)) : {}, ij(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  t || !e || !e.__esModule ? fm(r, "default", { value: e, enumerable: !0 }) : r,
  e
)), aj = tj({
  "../../node_modules/.pnpm/prismjs@1.29.0_patch_hash=vrxx3pzkik6jpmgpayxfjunetu/node_modules/prismjs/prism.js"(e, t) {
    var r = function() {
      var i = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, n = 0, a = {}, o = {
        /**
         * A namespace for utility methods.
         *
         * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
         * change or disappear at any time.
         *
         * @namespace
         * @memberof Prism
         */
        util: {
          encode: function g(k) {
            return k instanceof s ? new s(k.type, g(k.content), k.alias) : Array.isArray(k) ? k.map(g) : k.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
          },
          /**
           * Returns the name of the type of the given value.
           *
           * @param {any} o
           * @returns {string}
           * @example
           * type(null)      === 'Null'
           * type(undefined) === 'Undefined'
           * type(123)       === 'Number'
           * type('foo')     === 'String'
           * type(true)      === 'Boolean'
           * type([1, 2])    === 'Array'
           * type({})        === 'Object'
           * type(String)    === 'Function'
           * type(/abc+/)    === 'RegExp'
           */
          type: function(g) {
            return Object.prototype.toString.call(g).slice(8, -1);
          },
          /**
           * Returns a unique number for the given object. Later calls will still return the same number.
           *
           * @param {Object} obj
           * @returns {number}
           */
          objId: function(g) {
            return g.__id || Object.defineProperty(g, "__id", { value: ++n }), g.__id;
          },
          /**
           * Creates a deep clone of the given object.
           *
           * The main intended use of this function is to clone language definitions.
           *
           * @param {T} o
           * @param {Record<number, any>} [visited]
           * @returns {T}
           * @template T
           */
          clone: function g(k, y) {
            y = y || {};
            var _, A;
            switch (o.util.type(k)) {
              case "Object":
                if (A = o.util.objId(k), y[A])
                  return y[A];
                _ = /** @type {Record<string, any>} */
                {}, y[A] = _;
                for (var T in k)
                  k.hasOwnProperty(T) && (_[T] = g(k[T], y));
                return (
                  /** @type {any} */
                  _
                );
              case "Array":
                return A = o.util.objId(k), y[A] ? y[A] : (_ = [], y[A] = _, k.forEach(function(N, P) {
                  _[P] = g(N, y);
                }), /** @type {any} */
                _);
              default:
                return k;
            }
          },
          /**
           * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
           *
           * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
           *
           * @param {Element} element
           * @returns {string}
           */
          getLanguage: function(g) {
            for (; g; ) {
              var k = i.exec(g.className);
              if (k)
                return k[1].toLowerCase();
              g = g.parentElement;
            }
            return "none";
          },
          /**
           * Sets the Prism `language-xxxx` class of the given element.
           *
           * @param {Element} element
           * @param {string} language
           * @returns {void}
           */
          setLanguage: function(g, k) {
            g.className = g.className.replace(RegExp(i, "gi"), ""), g.classList.add("language-" + k);
          },
          /**
           * Returns whether a given class is active for `element`.
           *
           * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
           * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
           * given class is just the given class with a `no-` prefix.
           *
           * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
           * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
           * ancestors have the given class or the negated version of it, then the default activation will be returned.
           *
           * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
           * version of it, the class is considered active.
           *
           * @param {Element} element
           * @param {string} className
           * @param {boolean} [defaultActivation=false]
           * @returns {boolean}
           */
          isActive: function(g, k, y) {
            for (var _ = "no-" + k; g; ) {
              var A = g.classList;
              if (A.contains(k))
                return !0;
              if (A.contains(_))
                return !1;
              g = g.parentElement;
            }
            return !!y;
          }
        },
        /**
         * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
         *
         * @namespace
         * @memberof Prism
         * @public
         */
        languages: {
          /**
           * The grammar for plain, unformatted text.
           */
          plain: a,
          plaintext: a,
          text: a,
          txt: a,
          /**
           * Creates a deep copy of the language with the given id and appends the given tokens.
           *
           * If a token in `redef` also appears in the copied language, then the existing token in the copied language
           * will be overwritten at its original position.
           *
           * ## Best practices
           *
           * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
           * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
           * understand the language definition because, normally, the order of tokens matters in Prism grammars.
           *
           * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
           * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
           *
           * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
           * @param {Grammar} redef The new tokens to append.
           * @returns {Grammar} The new language created.
           * @public
           * @example
           * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
           *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
           *     // at its original position
           *     'comment': { ... },
           *     // CSS doesn't have a 'color' token, so this token will be appended
           *     'color': /\b(?:red|green|blue)\b/
           * });
           */
          extend: function(g, k) {
            var y = o.util.clone(o.languages[g]);
            for (var _ in k)
              y[_] = k[_];
            return y;
          },
          /**
           * Inserts tokens _before_ another token in a language definition or any other grammar.
           *
           * ## Usage
           *
           * This helper method makes it easy to modify existing languages. For example, the CSS language definition
           * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
           * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
           * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
           * this:
           *
           * ```js
           * Prism.languages.markup.style = {
           *     // token
           * };
           * ```
           *
           * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
           * before existing tokens. For the CSS example above, you would use it like this:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'cdata', {
           *     'style': {
           *         // token
           *     }
           * });
           * ```
           *
           * ## Special cases
           *
           * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
           * will be ignored.
           *
           * This behavior can be used to insert tokens after `before`:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'comment', {
           *     'comment': Prism.languages.markup.comment,
           *     // tokens after 'comment'
           * });
           * ```
           *
           * ## Limitations
           *
           * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
           * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
           * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
           * deleting properties which is necessary to insert at arbitrary positions.
           *
           * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
           * Instead, it will create a new object and replace all references to the target object with the new one. This
           * can be done without temporarily deleting properties, so the iteration order is well-defined.
           *
           * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
           * you hold the target object in a variable, then the value of the variable will not change.
           *
           * ```js
           * var oldMarkup = Prism.languages.markup;
           * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
           *
           * assert(oldMarkup !== Prism.languages.markup);
           * assert(newMarkup === Prism.languages.markup);
           * ```
           *
           * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
           * object to be modified.
           * @param {string} before The key to insert before.
           * @param {Grammar} insert An object containing the key-value pairs to be inserted.
           * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
           * object to be modified.
           *
           * Defaults to `Prism.languages`.
           * @returns {Grammar} The new grammar object.
           * @public
           */
          insertBefore: function(g, k, y, _) {
            _ = _ || /** @type {any} */
            o.languages;
            var A = _[g], T = {};
            for (var N in A)
              if (A.hasOwnProperty(N)) {
                if (N == k)
                  for (var P in y)
                    y.hasOwnProperty(P) && (T[P] = y[P]);
                y.hasOwnProperty(N) || (T[N] = A[N]);
              }
            var B = _[g];
            return _[g] = T, o.languages.DFS(o.languages, function(M, X) {
              X === B && M != g && (this[M] = T);
            }), T;
          },
          // Traverse a language definition with Depth First Search
          DFS: function g(k, y, _, A) {
            A = A || {};
            var T = o.util.objId;
            for (var N in k)
              if (k.hasOwnProperty(N)) {
                y.call(k, N, k[N], _ || N);
                var P = k[N], B = o.util.type(P);
                B === "Object" && !A[T(P)] ? (A[T(P)] = !0, g(P, y, null, A)) : B === "Array" && !A[T(P)] && (A[T(P)] = !0, g(P, y, N, A));
              }
          }
        },
        plugins: {},
        /**
         * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
         * and the language definitions to use, and returns a string with the HTML produced.
         *
         * The following hooks will be run:
         * 1. `before-tokenize`
         * 2. `after-tokenize`
         * 3. `wrap`: On each {@link Token}.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @param {string} language The name of the language definition passed to `grammar`.
         * @returns {string} The highlighted HTML.
         * @memberof Prism
         * @public
         * @example
         * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
         */
        highlight: function(g, k, y) {
          var _ = {
            code: g,
            grammar: k,
            language: y
          };
          if (o.hooks.run("before-tokenize", _), !_.grammar)
            throw new Error('The language "' + _.language + '" has no grammar.');
          return _.tokens = o.tokenize(_.code, _.grammar), o.hooks.run("after-tokenize", _), s.stringify(o.util.encode(_.tokens), _.language);
        },
        /**
         * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
         * and the language definitions to use, and returns an array with the tokenized code.
         *
         * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
         *
         * This method could be useful in other contexts as well, as a very crude parser.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @returns {TokenStream} An array of strings and tokens, a token stream.
         * @memberof Prism
         * @public
         * @example
         * let code = `var foo = 0;`;
         * let tokens = Prism.tokenize(code, Prism.languages.javascript);
         * tokens.forEach(token => {
         *     if (token instanceof Prism.Token && token.type === 'number') {
         *         console.log(`Found numeric literal: ${token.content}`);
         *     }
         * });
         */
        tokenize: function(g, k) {
          var y = k.rest;
          if (y) {
            for (var _ in y)
              k[_] = y[_];
            delete k.rest;
          }
          var A = new d();
          return c(A, A.head, g), u(g, A, k, A.head, 0), f(A);
        },
        /**
         * @namespace
         * @memberof Prism
         * @public
         */
        hooks: {
          all: {},
          /**
           * Adds the given callback to the list of callbacks for the given hook.
           *
           * The callback will be invoked when the hook it is registered for is run.
           * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
           *
           * One callback function can be registered to multiple hooks and the same hook multiple times.
           *
           * @param {string} name The name of the hook.
           * @param {HookCallback} callback The callback function which is given environment variables.
           * @public
           */
          add: function(g, k) {
            var y = o.hooks.all;
            y[g] = y[g] || [], y[g].push(k);
          },
          /**
           * Runs a hook invoking all registered callbacks with the given environment variables.
           *
           * Callbacks will be invoked synchronously and in the order in which they were registered.
           *
           * @param {string} name The name of the hook.
           * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
           * @public
           */
          run: function(g, k) {
            var y = o.hooks.all[g];
            if (!(!y || !y.length))
              for (var _ = 0, A; A = y[_++]; )
                A(k);
          }
        },
        Token: s
      };
      function s(g, k, y, _) {
        this.type = g, this.content = k, this.alias = y, this.length = (_ || "").length | 0;
      }
      s.stringify = function g(k, y) {
        if (typeof k == "string")
          return k;
        if (Array.isArray(k)) {
          var _ = "";
          return k.forEach(function(B) {
            _ += g(B, y);
          }), _;
        }
        var A = {
          type: k.type,
          content: g(k.content, y),
          tag: "span",
          classes: ["token", k.type],
          attributes: {},
          language: y
        }, T = k.alias;
        T && (Array.isArray(T) ? Array.prototype.push.apply(A.classes, T) : A.classes.push(T)), o.hooks.run("wrap", A);
        var N = "";
        for (var P in A.attributes)
          N += " " + P + '="' + (A.attributes[P] || "").replace(/"/g, "&quot;") + '"';
        return "<" + A.tag + ' class="' + A.classes.join(" ") + '"' + N + ">" + A.content + "</" + A.tag + ">";
      };
      function l(g, k, y, _) {
        g.lastIndex = k;
        var A = g.exec(y);
        if (A && _ && A[1]) {
          var T = A[1].length;
          A.index += T, A[0] = A[0].slice(T);
        }
        return A;
      }
      function u(g, k, y, _, A, T) {
        for (var N in y)
          if (!(!y.hasOwnProperty(N) || !y[N])) {
            var P = y[N];
            P = Array.isArray(P) ? P : [P];
            for (var B = 0; B < P.length; ++B) {
              if (T && T.cause == N + "," + B)
                return;
              var M = P[B], X = M.inside, U = !!M.lookbehind, K = !!M.greedy, z = M.alias;
              if (K && !M.pattern.global) {
                var j = M.pattern.toString().match(/[imsuy]*$/)[0];
                M.pattern = RegExp(M.pattern.source, j + "g");
              }
              for (var J = M.pattern || M, ie = _.next, ue = A; ie !== k.tail && !(T && ue >= T.reach); ue += ie.value.length, ie = ie.next) {
                var de = ie.value;
                if (k.length > g.length)
                  return;
                if (!(de instanceof s)) {
                  var he = 1, Ee;
                  if (K) {
                    if (Ee = l(J, ue, g, U), !Ee || Ee.index >= g.length)
                      break;
                    var Se = Ee.index, Le = Ee.index + Ee[0].length, L = ue;
                    for (L += ie.value.length; Se >= L; )
                      ie = ie.next, L += ie.value.length;
                    if (L -= ie.value.length, ue = L, ie.value instanceof s)
                      continue;
                    for (var me = ie; me !== k.tail && (L < Le || typeof me.value == "string"); me = me.next)
                      he++, L += me.value.length;
                    he--, de = g.slice(ue, L), Ee.index -= ue;
                  } else if (Ee = l(J, 0, de, U), !Ee)
                    continue;
                  var Se = Ee.index, G = Ee[0], He = de.slice(0, Se), xe = de.slice(Se + G.length), _e = ue + de.length;
                  T && _e > T.reach && (T.reach = _e);
                  var Ze = ie.prev;
                  He && (Ze = c(k, Ze, He), ue += He.length), p(k, Ze, he);
                  var qe = new s(N, X ? o.tokenize(G, X) : G, z, G);
                  if (ie = c(k, Ze, qe), xe && c(k, ie, xe), he > 1) {
                    var nt = {
                      cause: N + "," + B,
                      reach: _e
                    };
                    u(g, k, y, ie.prev, ue, nt), T && nt.reach > T.reach && (T.reach = nt.reach);
                  }
                }
              }
            }
          }
      }
      function d() {
        var g = { value: null, prev: null, next: null }, k = { value: null, prev: g, next: null };
        g.next = k, this.head = g, this.tail = k, this.length = 0;
      }
      function c(g, k, y) {
        var _ = k.next, A = { value: y, prev: k, next: _ };
        return k.next = A, _.prev = A, g.length++, A;
      }
      function p(g, k, y) {
        for (var _ = k.next, A = 0; A < y && _ !== g.tail; A++)
          _ = _.next;
        k.next = _, _.prev = k, g.length -= A;
      }
      function f(g) {
        for (var k = [], y = g.head.next; y !== g.tail; )
          k.push(y.value), y = y.next;
        return k;
      }
      return o;
    }();
    t.exports = r, r.default = r;
  }
}), ze = nj(aj());
ze.languages.markup = { comment: { pattern: /<!--(?:(?!<!--)[\s\S])*?-->/, greedy: !0 }, prolog: { pattern: /<\?[\s\S]+?\?>/, greedy: !0 }, doctype: { pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i, greedy: !0, inside: { "internal-subset": { pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/, lookbehind: !0, greedy: !0, inside: null }, string: { pattern: /"[^"]*"|'[^']*'/, greedy: !0 }, punctuation: /^<!|>$|[[\]]/, "doctype-tag": /^DOCTYPE/i, name: /[^\s<>'"]+/ } }, cdata: { pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i, greedy: !0 }, tag: { pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/, greedy: !0, inside: { tag: { pattern: /^<\/?[^\s>\/]+/, inside: { punctuation: /^<\/?/, namespace: /^[^\s>\/:]+:/ } }, "special-attr": [], "attr-value": { pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/, inside: { punctuation: [{ pattern: /^=/, alias: "attr-equals" }, { pattern: /^(\s*)["']|["']$/, lookbehind: !0 }] } }, punctuation: /\/?>/, "attr-name": { pattern: /[^\s>\/]+/, inside: { namespace: /^[^\s>\/:]+:/ } } } }, entity: [{ pattern: /&[\da-z]{1,8};/i, alias: "named-entity" }, /&#x?[\da-f]{1,8};/i] }, ze.languages.markup.tag.inside["attr-value"].inside.entity = ze.languages.markup.entity, ze.languages.markup.doctype.inside["internal-subset"].inside = ze.languages.markup, ze.hooks.add("wrap", function(e) {
  e.type === "entity" && (e.attributes.title = e.content.replace(/&amp;/, "&"));
}), Object.defineProperty(ze.languages.markup.tag, "addInlined", { value: function(e, i) {
  var r = {}, r = (r["language-" + i] = { pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i, lookbehind: !0, inside: ze.languages[i] }, r.cdata = /^<!\[CDATA\[|\]\]>$/i, { "included-cdata": { pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i, inside: r } }), i = (r["language-" + i] = { pattern: /[\s\S]+/, inside: ze.languages[i] }, {});
  i[e] = { pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
    return e;
  }), "i"), lookbehind: !0, greedy: !0, inside: r }, ze.languages.insertBefore("markup", "cdata", i);
} }), Object.defineProperty(ze.languages.markup.tag, "addAttribute", { value: function(e, t) {
  ze.languages.markup.tag.inside["special-attr"].push({ pattern: RegExp(/(^|["'\s])/.source + "(?:" + e + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"), lookbehind: !0, inside: { "attr-name": /^[^\s=]+/, "attr-value": { pattern: /=[\s\S]+/, inside: { value: { pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/, lookbehind: !0, alias: [t, "language-" + t], inside: ze.languages[t] }, punctuation: [{ pattern: /^=/, alias: "attr-equals" }, /"|'/] } } } });
} }), ze.languages.html = ze.languages.markup, ze.languages.mathml = ze.languages.markup, ze.languages.svg = ze.languages.markup, ze.languages.xml = ze.languages.extend("markup", {}), ze.languages.ssml = ze.languages.xml, ze.languages.atom = ze.languages.xml, ze.languages.rss = ze.languages.xml, function(e) {
  var t = { pattern: /\\[\\(){}[\]^$+*?|.]/, alias: "escape" }, r = /\\(?:x[\da-fA-F]{2}|u[\da-fA-F]{4}|u\{[\da-fA-F]+\}|0[0-7]{0,2}|[123][0-7]{2}|c[a-zA-Z]|.)/, i = "(?:[^\\\\-]|" + r.source + ")", i = RegExp(i + "-" + i), n = { pattern: /(<|')[^<>']+(?=[>']$)/, lookbehind: !0, alias: "variable" };
  e.languages.regex = { "char-class": { pattern: /((?:^|[^\\])(?:\\\\)*)\[(?:[^\\\]]|\\[\s\S])*\]/, lookbehind: !0, inside: { "char-class-negation": { pattern: /(^\[)\^/, lookbehind: !0, alias: "operator" }, "char-class-punctuation": { pattern: /^\[|\]$/, alias: "punctuation" }, range: { pattern: i, inside: { escape: r, "range-punctuation": { pattern: /-/, alias: "operator" } } }, "special-escape": t, "char-set": { pattern: /\\[wsd]|\\p\{[^{}]+\}/i, alias: "class-name" }, escape: r } }, "special-escape": t, "char-set": { pattern: /\.|\\[wsd]|\\p\{[^{}]+\}/i, alias: "class-name" }, backreference: [{ pattern: /\\(?![123][0-7]{2})[1-9]/, alias: "keyword" }, { pattern: /\\k<[^<>']+>/, alias: "keyword", inside: { "group-name": n } }], anchor: { pattern: /[$^]|\\[ABbGZz]/, alias: "function" }, escape: r, group: [{ pattern: /\((?:\?(?:<[^<>']+>|'[^<>']+'|[>:]|<?[=!]|[idmnsuxU]+(?:-[idmnsuxU]+)?:?))?/, alias: "punctuation", inside: { "group-name": n } }, { pattern: /\)/, alias: "punctuation" }], quantifier: { pattern: /(?:[+*?]|\{\d+(?:,\d*)?\})[?+]?/, alias: "number" }, alternation: { pattern: /\|/, alias: "keyword" } };
}(ze), ze.languages.clike = { comment: [{ pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/, lookbehind: !0, greedy: !0 }, { pattern: /(^|[^\\:])\/\/.*/, lookbehind: !0, greedy: !0 }], string: { pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, greedy: !0 }, "class-name": { pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i, lookbehind: !0, inside: { punctuation: /[.\\]/ } }, keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/, boolean: /\b(?:false|true)\b/, function: /\b\w+(?=\()/, number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i, operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/, punctuation: /[{}[\];(),.:]/ }, ze.languages.javascript = ze.languages.extend("clike", { "class-name": [ze.languages.clike["class-name"], { pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/, lookbehind: !0 }], keyword: [{ pattern: /((?:^|\})\s*)catch\b/, lookbehind: !0 }, { pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/, lookbehind: !0 }], function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/, number: { pattern: RegExp(/(^|[^\w$])/.source + "(?:" + /NaN|Infinity/.source + "|" + /0[bB][01]+(?:_[01]+)*n?/.source + "|" + /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + /\d+(?:_\d+)*n/.source + "|" + /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source + ")" + /(?![\w$])/.source), lookbehind: !0 }, operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/ }), ze.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, ze.languages.insertBefore("javascript", "keyword", { regex: { pattern: RegExp(/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source), lookbehind: !0, greedy: !0, inside: { "regex-source": { pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/, lookbehind: !0, alias: "language-regex", inside: ze.languages.regex }, "regex-delimiter": /^\/|\/$/, "regex-flags": /^[a-z]+$/ } }, "function-variable": { pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/, alias: "function" }, parameter: [{ pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/, lookbehind: !0, inside: ze.languages.javascript }, { pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i, lookbehind: !0, inside: ze.languages.javascript }, { pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/, lookbehind: !0, inside: ze.languages.javascript }, { pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/, lookbehind: !0, inside: ze.languages.javascript }], constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/ }), ze.languages.insertBefore("javascript", "string", { hashbang: { pattern: /^#!.*/, greedy: !0, alias: "comment" }, "template-string": { pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/, greedy: !0, inside: { "template-punctuation": { pattern: /^`|`$/, alias: "string" }, interpolation: { pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/, lookbehind: !0, inside: { "interpolation-punctuation": { pattern: /^\$\{|\}$/, alias: "punctuation" }, rest: ze.languages.javascript } }, string: /[\s\S]+/ } }, "string-property": { pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m, lookbehind: !0, greedy: !0, alias: "property" } }), ze.languages.insertBefore("javascript", "operator", { "literal-property": { pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m, lookbehind: !0, alias: "property" } }), ze.languages.markup && (ze.languages.markup.tag.addInlined("script", "javascript"), ze.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript")), ze.languages.js = ze.languages.javascript, ze.languages.actionscript = ze.languages.extend("javascript", { keyword: /\b(?:as|break|case|catch|class|const|default|delete|do|dynamic|each|else|extends|final|finally|for|function|get|if|implements|import|in|include|instanceof|interface|internal|is|namespace|native|new|null|override|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|use|var|void|while|with)\b/, operator: /\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/ }), ze.languages.actionscript["class-name"].alias = "function", delete ze.languages.actionscript.parameter, delete ze.languages.actionscript["literal-property"], ze.languages.markup && ze.languages.insertBefore("actionscript", "string", { xml: { pattern: /(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/, lookbehind: !0, inside: ze.languages.markup } }), function(e) {
  var t = /#(?!\{).+/, r = { pattern: /#\{[^}]+\}/, alias: "variable" };
  e.languages.coffeescript = e.languages.extend("javascript", { comment: t, string: [{ pattern: /'(?:\\[\s\S]|[^\\'])*'/, greedy: !0 }, { pattern: /"(?:\\[\s\S]|[^\\"])*"/, greedy: !0, inside: { interpolation: r } }], keyword: /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/, "class-member": { pattern: /@(?!\d)\w+/, alias: "variable" } }), e.languages.insertBefore("coffeescript", "comment", { "multiline-comment": { pattern: /###[\s\S]+?###/, alias: "comment" }, "block-regex": { pattern: /\/{3}[\s\S]*?\/{3}/, alias: "regex", inside: { comment: t, interpolation: r } } }), e.languages.insertBefore("coffeescript", "string", { "inline-javascript": { pattern: /`(?:\\[\s\S]|[^\\`])*`/, inside: { delimiter: { pattern: /^`|`$/, alias: "punctuation" }, script: { pattern: /[\s\S]+/, alias: "language-javascript", inside: e.languages.javascript } } }, "multiline-string": [{ pattern: /'''[\s\S]*?'''/, greedy: !0, alias: "string" }, { pattern: /"""[\s\S]*?"""/, greedy: !0, alias: "string", inside: { interpolation: r } }] }), e.languages.insertBefore("coffeescript", "keyword", { property: /(?!\d)\w+(?=\s*:(?!:))/ }), delete e.languages.coffeescript["template-string"], e.languages.coffee = e.languages.coffeescript;
}(ze), function(e) {
  var t = e.languages.javadoclike = { parameter: { pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*@(?:arg|arguments|param)\s+)\w+/m, lookbehind: !0 }, keyword: { pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*|\{)@[a-z][a-zA-Z-]+\b/m, lookbehind: !0 }, punctuation: /[{}]/ };
  Object.defineProperty(t, "addSupport", { value: function(r, i) {
    (r = typeof r == "string" ? [r] : r).forEach(function(n) {
      var a = function(c) {
        c.inside || (c.inside = {}), c.inside.rest = i;
      }, o = "doc-comment";
      if (s = e.languages[n]) {
        var s, l = s[o];
        if ((l = l || (s = e.languages.insertBefore(n, "comment", { "doc-comment": { pattern: /(^|[^\\])\/\*\*[^/][\s\S]*?(?:\*\/|$)/, lookbehind: !0, alias: "comment" } }))[o]) instanceof RegExp && (l = s[o] = { pattern: l }), Array.isArray(l))
          for (var u = 0, d = l.length; u < d; u++)
            l[u] instanceof RegExp && (l[u] = { pattern: l[u] }), a(l[u]);
        else
          a(l);
      }
    });
  } }), t.addSupport(["java", "javascript", "php"], t);
}(ze), function(e) {
  var t = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/, t = (e.languages.css = { comment: /\/\*[\s\S]*?\*\//, atrule: { pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + t.source + ")*?" + /(?:;|(?=\s*\{))/.source), inside: { rule: /^@[\w-]+/, "selector-function-argument": { pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/, lookbehind: !0, alias: "selector" }, keyword: { pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/, lookbehind: !0 } } }, url: { pattern: RegExp("\\burl\\((?:" + t.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"), greedy: !0, inside: { function: /^url/i, punctuation: /^\(|\)$/, string: { pattern: RegExp("^" + t.source + "$"), alias: "url" } } }, selector: { pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + t.source + ")*(?=\\s*\\{)"), lookbehind: !0 }, string: { pattern: t, greedy: !0 }, property: { pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i, lookbehind: !0 }, important: /!important\b/i, function: { pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i, lookbehind: !0 }, punctuation: /[(){};:,]/ }, e.languages.css.atrule.inside.rest = e.languages.css, e.languages.markup);
  t && (t.tag.addInlined("style", "css"), t.tag.addAttribute("style", "css"));
}(ze), function(e) {
  var t = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, t = (e.languages.css.selector = { pattern: e.languages.css.selector.pattern, lookbehind: !0, inside: t = { "pseudo-element": /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/, "pseudo-class": /:[-\w]+/, class: /\.[-\w]+/, id: /#[-\w]+/, attribute: { pattern: RegExp(`\\[(?:[^[\\]"']|` + t.source + ")*\\]"), greedy: !0, inside: { punctuation: /^\[|\]$/, "case-sensitivity": { pattern: /(\s)[si]$/i, lookbehind: !0, alias: "keyword" }, namespace: { pattern: /^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/, lookbehind: !0, inside: { punctuation: /\|$/ } }, "attr-name": { pattern: /^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/, lookbehind: !0 }, "attr-value": [t, { pattern: /(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/, lookbehind: !0 }], operator: /[|~*^$]?=/ } }, "n-th": [{ pattern: /(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/, lookbehind: !0, inside: { number: /[\dn]+/, operator: /[+-]/ } }, { pattern: /(\(\s*)(?:even|odd)(?=\s*\))/i, lookbehind: !0 }], combinator: />|\+|~|\|\|/, punctuation: /[(),]/ } }, e.languages.css.atrule.inside["selector-function-argument"].inside = t, e.languages.insertBefore("css", "property", { variable: { pattern: /(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i, lookbehind: !0 } }), { pattern: /(\b\d+)(?:%|[a-z]+(?![\w-]))/, lookbehind: !0 }), r = { pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/, lookbehind: !0 };
  e.languages.insertBefore("css", "function", { operator: { pattern: /(\s)[+\-*\/](?=\s)/, lookbehind: !0 }, hexcode: { pattern: /\B#[\da-f]{3,8}\b/i, alias: "color" }, color: [{ pattern: /(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|RebeccaPurple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i, lookbehind: !0 }, { pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i, inside: { unit: t, number: r, function: /[\w-]+(?=\()/, punctuation: /[(),]/ } }], entity: /\\[\da-f]{1,8}/i, unit: t, number: r });
}(ze), function(e) {
  var t = /[*&][^\s[\]{},]+/, r = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/, i = "(?:" + r.source + "(?:[ 	]+" + t.source + ")?|" + t.source + "(?:[ 	]+" + r.source + ")?)", n = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function() {
    return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
  }), a = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
  function o(s, l) {
    l = (l || "").replace(/m/g, "") + "m";
    var u = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
      return i;
    }).replace(/<<value>>/g, function() {
      return s;
    });
    return RegExp(u, l);
  }
  e.languages.yaml = { scalar: { pattern: RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function() {
    return i;
  })), lookbehind: !0, alias: "string" }, comment: /#.*/, key: { pattern: RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
    return i;
  }).replace(/<<key>>/g, function() {
    return "(?:" + n + "|" + a + ")";
  })), lookbehind: !0, greedy: !0, alias: "atrule" }, directive: { pattern: /(^[ \t]*)%.+/m, lookbehind: !0, alias: "important" }, datetime: { pattern: o(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source), lookbehind: !0, alias: "number" }, boolean: { pattern: o(/false|true/.source, "i"), lookbehind: !0, alias: "important" }, null: { pattern: o(/null|~/.source, "i"), lookbehind: !0, alias: "important" }, string: { pattern: o(a), lookbehind: !0, greedy: !0 }, number: { pattern: o(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, "i"), lookbehind: !0 }, tag: r, important: t, punctuation: /---|[:[\]{}\-,|>?]|\.\.\./ }, e.languages.yml = e.languages.yaml;
}(ze), function(e) {
  var t = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
  function r(u) {
    return u = u.replace(/<inner>/g, function() {
      return t;
    }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + u + ")");
  }
  var i = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, n = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
    return i;
  }), a = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source, o = (e.languages.markdown = e.languages.extend("markup", {}), e.languages.insertBefore("markdown", "prolog", { "front-matter-block": { pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/, lookbehind: !0, greedy: !0, inside: { punctuation: /^---|---$/, "front-matter": { pattern: /\S+(?:\s+\S+)*/, alias: ["yaml", "language-yaml"], inside: e.languages.yaml } } }, blockquote: { pattern: /^>(?:[\t ]*>)*/m, alias: "punctuation" }, table: { pattern: RegExp("^" + n + a + "(?:" + n + ")*", "m"), inside: { "table-data-rows": { pattern: RegExp("^(" + n + a + ")(?:" + n + ")*$"), lookbehind: !0, inside: { "table-data": { pattern: RegExp(i), inside: e.languages.markdown }, punctuation: /\|/ } }, "table-line": { pattern: RegExp("^(" + n + ")" + a + "$"), lookbehind: !0, inside: { punctuation: /\||:?-{3,}:?/ } }, "table-header-row": { pattern: RegExp("^" + n + "$"), inside: { "table-header": { pattern: RegExp(i), alias: "important", inside: e.languages.markdown }, punctuation: /\|/ } } } }, code: [{ pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/, lookbehind: !0, alias: "keyword" }, { pattern: /^```[\s\S]*?^```$/m, greedy: !0, inside: { "code-block": { pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m, lookbehind: !0 }, "code-language": { pattern: /^(```).+/, lookbehind: !0 }, punctuation: /```/ } }], title: [{ pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m, alias: "important", inside: { punctuation: /==+$|--+$/ } }, { pattern: /(^\s*)#.+/m, lookbehind: !0, alias: "important", inside: { punctuation: /^#+|#+$/ } }], hr: { pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m, lookbehind: !0, alias: "punctuation" }, list: { pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m, lookbehind: !0, alias: "punctuation" }, "url-reference": { pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/, inside: { variable: { pattern: /^(!?\[)[^\]]+/, lookbehind: !0 }, string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/, punctuation: /^[\[\]!:]|[<>]/ }, alias: "url" }, bold: { pattern: r(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source), lookbehind: !0, greedy: !0, inside: { content: { pattern: /(^..)[\s\S]+(?=..$)/, lookbehind: !0, inside: {} }, punctuation: /\*\*|__/ } }, italic: { pattern: r(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source), lookbehind: !0, greedy: !0, inside: { content: { pattern: /(^.)[\s\S]+(?=.$)/, lookbehind: !0, inside: {} }, punctuation: /[*_]/ } }, strike: { pattern: r(/(~~?)(?:(?!~)<inner>)+\2/.source), lookbehind: !0, greedy: !0, inside: { content: { pattern: /(^~~?)[\s\S]+(?=\1$)/, lookbehind: !0, inside: {} }, punctuation: /~~?/ } }, "code-snippet": { pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/, lookbehind: !0, greedy: !0, alias: ["code", "keyword"] }, url: { pattern: r(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source), lookbehind: !0, greedy: !0, inside: { operator: /^!/, content: { pattern: /(^\[)[^\]]+(?=\])/, lookbehind: !0, inside: {} }, variable: { pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/, lookbehind: !0 }, url: { pattern: /(^\]\()[^\s)]+/, lookbehind: !0 }, string: { pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/, lookbehind: !0 } } } }), ["url", "bold", "italic", "strike"].forEach(function(u) {
    ["url", "bold", "italic", "strike", "code-snippet"].forEach(function(d) {
      u !== d && (e.languages.markdown[u].inside.content.inside[d] = e.languages.markdown[d]);
    });
  }), e.hooks.add("after-tokenize", function(u) {
    u.language !== "markdown" && u.language !== "md" || function d(c) {
      if (c && typeof c != "string")
        for (var p = 0, f = c.length; p < f; p++) {
          var g, k = c[p];
          k.type !== "code" ? d(k.content) : (g = k.content[1], k = k.content[3], g && k && g.type === "code-language" && k.type === "code-block" && typeof g.content == "string" && (g = g.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp"), g = "language-" + (g = (/[a-z][\w-]*/i.exec(g) || [""])[0].toLowerCase()), k.alias ? typeof k.alias == "string" ? k.alias = [k.alias, g] : k.alias.push(g) : k.alias = [g]));
        }
    }(u.tokens);
  }), e.hooks.add("wrap", function(u) {
    if (u.type === "code-block") {
      for (var d = "", c = 0, p = u.classes.length; c < p; c++) {
        var f = u.classes[c], f = /language-(.+)/.exec(f);
        if (f) {
          d = f[1];
          break;
        }
      }
      var g, k = e.languages[d];
      k ? u.content = e.highlight(function(y) {
        return y = y.replace(o, ""), y = y.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(_, A) {
          var T;
          return (A = A.toLowerCase())[0] === "#" ? (T = A[1] === "x" ? parseInt(A.slice(2), 16) : Number(A.slice(1)), l(T)) : s[A] || _;
        });
      }(u.content), k, d) : d && d !== "none" && e.plugins.autoloader && (g = "md-" + (/* @__PURE__ */ new Date()).valueOf() + "-" + Math.floor(1e16 * Math.random()), u.attributes.id = g, e.plugins.autoloader.loadLanguages(d, function() {
        var y = document.getElementById(g);
        y && (y.innerHTML = e.highlight(y.textContent, e.languages[d], d));
      }));
    }
  }), RegExp(e.languages.markup.tag.pattern.source, "gi")), s = { amp: "&", lt: "<", gt: ">", quot: '"' }, l = String.fromCodePoint || String.fromCharCode;
  e.languages.md = e.languages.markdown;
}(ze), ze.languages.graphql = { comment: /#.*/, description: { pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i, greedy: !0, alias: "string", inside: { "language-markdown": { pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/, lookbehind: !0, inside: ze.languages.markdown } } }, string: { pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/, greedy: !0 }, number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i, boolean: /\b(?:false|true)\b/, variable: /\$[a-z_]\w*/i, directive: { pattern: /@[a-z_]\w*/i, alias: "function" }, "attr-name": { pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i, greedy: !0 }, "atom-input": { pattern: /\b[A-Z]\w*Input\b/, alias: "class-name" }, scalar: /\b(?:Boolean|Float|ID|Int|String)\b/, constant: /\b[A-Z][A-Z_\d]*\b/, "class-name": { pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/, lookbehind: !0 }, fragment: { pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/, lookbehind: !0, alias: "function" }, "definition-mutation": { pattern: /(\bmutation\s+)[a-zA-Z_]\w*/, lookbehind: !0, alias: "function" }, "definition-query": { pattern: /(\bquery\s+)[a-zA-Z_]\w*/, lookbehind: !0, alias: "function" }, keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/, operator: /[!=|&]|\.{3}/, "property-query": /\w+(?=\s*\()/, object: /\w+(?=\s*\{)/, punctuation: /[!(){}\[\]:=,]/, property: /\w+/ }, ze.hooks.add("after-tokenize", function(e) {
  if (e.language === "graphql")
    for (var t = e.tokens.filter(function(g) {
      return typeof g != "string" && g.type !== "comment" && g.type !== "scalar";
    }), r = 0; r < t.length; ) {
      var i = t[r++];
      if (i.type === "keyword" && i.content === "mutation") {
        var n = [];
        if (c(["definition-mutation", "punctuation"]) && d(1).content === "(") {
          r += 2;
          var a = p(/^\($/, /^\)$/);
          if (a === -1)
            continue;
          for (; r < a; r++) {
            var o = d(0);
            o.type === "variable" && (f(o, "variable-input"), n.push(o.content));
          }
          r = a + 1;
        }
        if (c(["punctuation", "property-query"]) && d(0).content === "{" && (r++, f(d(0), "property-mutation"), 0 < n.length)) {
          var s = p(/^\{$/, /^\}$/);
          if (s !== -1)
            for (var l = r; l < s; l++) {
              var u = t[l];
              u.type === "variable" && 0 <= n.indexOf(u.content) && f(u, "variable-input");
            }
        }
      }
    }
  function d(g) {
    return t[r + g];
  }
  function c(g, k) {
    k = k || 0;
    for (var y = 0; y < g.length; y++) {
      var _ = d(y + k);
      if (!_ || _.type !== g[y])
        return;
    }
    return 1;
  }
  function p(g, k) {
    for (var y = 1, _ = r; _ < t.length; _++) {
      var A = t[_], T = A.content;
      if (A.type === "punctuation" && typeof T == "string") {
        if (g.test(T))
          y++;
        else if (k.test(T) && --y === 0)
          return _;
      }
    }
    return -1;
  }
  function f(g, k) {
    var y = g.alias;
    y ? Array.isArray(y) || (g.alias = y = [y]) : g.alias = y = [], y.push(k);
  }
}), ze.languages.sql = { comment: { pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/, lookbehind: !0 }, variable: [{ pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/, greedy: !0 }, /@[\w.$]+/], string: { pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/, greedy: !0, lookbehind: !0 }, identifier: { pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/, greedy: !0, lookbehind: !0, inside: { punctuation: /^`|`$/ } }, function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i, keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i, boolean: /\b(?:FALSE|NULL|TRUE)\b/i, number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i, operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i, punctuation: /[;[\]()`,.]/ }, function(e) {
  var t = e.languages.javascript["template-string"], r = t.pattern.source, i = t.inside.interpolation, n = i.inside["interpolation-punctuation"], a = i.pattern.source;
  function o(c, p) {
    if (e.languages[c])
      return { pattern: RegExp("((?:" + p + ")\\s*)" + r), lookbehind: !0, greedy: !0, inside: { "template-punctuation": { pattern: /^`|`$/, alias: "string" }, "embedded-code": { pattern: /[\s\S]+/, alias: c } } };
  }
  function s(c, p, f) {
    return c = { code: c, grammar: p, language: f }, e.hooks.run("before-tokenize", c), c.tokens = e.tokenize(c.code, c.grammar), e.hooks.run("after-tokenize", c), c.tokens;
  }
  function l(c, p, f) {
    var y = e.tokenize(c, { interpolation: { pattern: RegExp(a), lookbehind: !0 } }), g = 0, k = {}, y = s(y.map(function(A) {
      if (typeof A == "string")
        return A;
      for (var T, N, A = A.content; c.indexOf((N = g++, T = "___" + f.toUpperCase() + "_" + N + "___")) !== -1; )
        ;
      return k[T] = A, T;
    }).join(""), p, f), _ = Object.keys(k);
    return g = 0, function A(T) {
      for (var N = 0; N < T.length; N++) {
        if (g >= _.length)
          return;
        var P, B, M, X, U, K, z, j = T[N];
        typeof j == "string" || typeof j.content == "string" ? (P = _[g], (z = (K = typeof j == "string" ? j : j.content).indexOf(P)) !== -1 && (++g, B = K.substring(0, z), U = k[P], M = void 0, (X = {})["interpolation-punctuation"] = n, (X = e.tokenize(U, X)).length === 3 && ((M = [1, 1]).push.apply(M, s(X[1], e.languages.javascript, "javascript")), X.splice.apply(X, M)), M = new e.Token("interpolation", X, i.alias, U), X = K.substring(z + P.length), U = [], B && U.push(B), U.push(M), X && (A(K = [X]), U.push.apply(U, K)), typeof j == "string" ? (T.splice.apply(T, [N, 1].concat(U)), N += U.length - 1) : j.content = U)) : (z = j.content, Array.isArray(z) ? A(z) : A([z]));
      }
    }(y), new e.Token(f, y, "language-" + f, c);
  }
  e.languages.javascript["template-string"] = [o("css", /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source), o("html", /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source), o("svg", /\bsvg/.source), o("markdown", /\b(?:markdown|md)/.source), o("graphql", /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source), o("sql", /\bsql/.source), t].filter(Boolean);
  var u = { javascript: !0, js: !0, typescript: !0, ts: !0, jsx: !0, tsx: !0 };
  function d(c) {
    return typeof c == "string" ? c : Array.isArray(c) ? c.map(d).join("") : d(c.content);
  }
  e.hooks.add("after-tokenize", function(c) {
    c.language in u && function p(f) {
      for (var g = 0, k = f.length; g < k; g++) {
        var y, _, A, T = f[g];
        typeof T != "string" && (y = T.content, Array.isArray(y) ? T.type === "template-string" ? (T = y[1], y.length === 3 && typeof T != "string" && T.type === "embedded-code" && (_ = d(T), T = T.alias, T = Array.isArray(T) ? T[0] : T, A = e.languages[T]) && (y[1] = l(_, A, T))) : p(y) : typeof y != "string" && p([y]));
      }
    }(c.tokens);
  });
}(ze), function(e) {
  e.languages.typescript = e.languages.extend("javascript", { "class-name": { pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/, lookbehind: !0, greedy: !0, inside: null }, builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/ }), e.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, /\btype\b(?=\s*(?:[\{*]|$))/), delete e.languages.typescript.parameter, delete e.languages.typescript["literal-property"];
  var t = e.languages.extend("typescript", {});
  delete t["class-name"], e.languages.typescript["class-name"].inside = t, e.languages.insertBefore("typescript", "function", { decorator: { pattern: /@[$\w\xA0-\uFFFF]+/, inside: { at: { pattern: /^@/, alias: "operator" }, function: /^[\s\S]+/ } }, "generic-function": { pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/, greedy: !0, inside: { function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/, generic: { pattern: /<[\s\S]+/, alias: "class-name", inside: t } } } }), e.languages.ts = e.languages.typescript;
}(ze), function(e) {
  var t = e.languages.javascript, r = /\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})+\}/.source, i = "(@(?:arg|argument|param|property)\\s+(?:" + r + "\\s+)?)";
  e.languages.jsdoc = e.languages.extend("javadoclike", { parameter: { pattern: RegExp(i + /(?:(?!\s)[$\w\xA0-\uFFFF.])+(?=\s|$)/.source), lookbehind: !0, inside: { punctuation: /\./ } } }), e.languages.insertBefore("jsdoc", "keyword", { "optional-parameter": { pattern: RegExp(i + /\[(?:(?!\s)[$\w\xA0-\uFFFF.])+(?:=[^[\]]+)?\](?=\s|$)/.source), lookbehind: !0, inside: { parameter: { pattern: /(^\[)[$\w\xA0-\uFFFF\.]+/, lookbehind: !0, inside: { punctuation: /\./ } }, code: { pattern: /(=)[\s\S]*(?=\]$)/, lookbehind: !0, inside: t, alias: "language-javascript" }, punctuation: /[=[\]]/ } }, "class-name": [{ pattern: RegExp(/(@(?:augments|class|extends|interface|memberof!?|template|this|typedef)\s+(?:<TYPE>\s+)?)[A-Z]\w*(?:\.[A-Z]\w*)*/.source.replace(/<TYPE>/g, function() {
    return r;
  })), lookbehind: !0, inside: { punctuation: /\./ } }, { pattern: RegExp("(@[a-z]+\\s+)" + r), lookbehind: !0, inside: { string: t.string, number: t.number, boolean: t.boolean, keyword: e.languages.typescript.keyword, operator: /=>|\.\.\.|[&|?:*]/, punctuation: /[.,;=<>{}()[\]]/ } }], example: { pattern: /(@example\s+(?!\s))(?:[^@\s]|\s+(?!\s))+?(?=\s*(?:\*\s*)?(?:@\w|\*\/))/, lookbehind: !0, inside: { code: { pattern: /^([\t ]*(?:\*\s*)?)\S.*$/m, lookbehind: !0, inside: t, alias: "language-javascript" } } } }), e.languages.javadoclike.addSupport("javascript", e.languages.jsdoc);
}(ze), function(e) {
  e.languages.flow = e.languages.extend("javascript", {}), e.languages.insertBefore("flow", "keyword", { type: [{ pattern: /\b(?:[Bb]oolean|Function|[Nn]umber|[Ss]tring|[Ss]ymbol|any|mixed|null|void)\b/, alias: "class-name" }] }), e.languages.flow["function-variable"].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i, delete e.languages.flow.parameter, e.languages.insertBefore("flow", "operator", { "flow-punctuation": { pattern: /\{\||\|\}/, alias: "punctuation" } }), Array.isArray(e.languages.flow.keyword) || (e.languages.flow.keyword = [e.languages.flow.keyword]), e.languages.flow.keyword.unshift({ pattern: /(^|[^$]\b)(?:Class|declare|opaque|type)\b(?!\$)/, lookbehind: !0 }, { pattern: /(^|[^$]\B)\$(?:Diff|Enum|Exact|Keys|ObjMap|PropertyType|Record|Shape|Subtype|Supertype|await)\b(?!\$)/, lookbehind: !0 });
}(ze), ze.languages.n4js = ze.languages.extend("javascript", { keyword: /\b(?:Array|any|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/ }), ze.languages.insertBefore("n4js", "constant", { annotation: { pattern: /@+\w+/, alias: "operator" } }), ze.languages.n4jsd = ze.languages.n4js, function(e) {
  function t(o, s) {
    return RegExp(o.replace(/<ID>/g, function() {
      return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
    }), s);
  }
  e.languages.insertBefore("javascript", "function-variable", { "method-variable": { pattern: RegExp("(\\.\\s*)" + e.languages.javascript["function-variable"].pattern.source), lookbehind: !0, alias: ["function-variable", "method", "function", "property-access"] } }), e.languages.insertBefore("javascript", "function", { method: { pattern: RegExp("(\\.\\s*)" + e.languages.javascript.function.source), lookbehind: !0, alias: ["function", "property-access"] } }), e.languages.insertBefore("javascript", "constant", { "known-class-name": [{ pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/, alias: "class-name" }, { pattern: /\b(?:[A-Z]\w*)Error\b/, alias: "class-name" }] }), e.languages.insertBefore("javascript", "keyword", { imports: { pattern: t(/(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source), lookbehind: !0, inside: e.languages.javascript }, exports: { pattern: t(/(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source), lookbehind: !0, inside: e.languages.javascript } }), e.languages.javascript.keyword.unshift({ pattern: /\b(?:as|default|export|from|import)\b/, alias: "module" }, { pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/, alias: "control-flow" }, { pattern: /\bnull\b/, alias: ["null", "nil"] }, { pattern: /\bundefined\b/, alias: "nil" }), e.languages.insertBefore("javascript", "operator", { spread: { pattern: /\.{3}/, alias: "operator" }, arrow: { pattern: /=>/, alias: "operator" } }), e.languages.insertBefore("javascript", "punctuation", { "property-access": { pattern: t(/(\.\s*)#?<ID>/.source), lookbehind: !0 }, "maybe-class-name": { pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/, lookbehind: !0 }, dom: { pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/, alias: "variable" }, console: { pattern: /\bconsole(?=\s*\.)/, alias: "class-name" } });
  for (var r = ["function", "function-variable", "method", "method-variable", "property-access"], i = 0; i < r.length; i++) {
    var a = r[i], n = e.languages.javascript[a], a = (n = e.util.type(n) === "RegExp" ? e.languages.javascript[a] = { pattern: n } : n).inside || {};
    (n.inside = a)["maybe-class-name"] = /^[A-Z][\s\S]*/;
  }
}(ze), function(e) {
  var t = e.util.clone(e.languages.javascript), r = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, i = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, n = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
  function a(l, u) {
    return l = l.replace(/<S>/g, function() {
      return r;
    }).replace(/<BRACES>/g, function() {
      return i;
    }).replace(/<SPREAD>/g, function() {
      return n;
    }), RegExp(l, u);
  }
  n = a(n).source, e.languages.jsx = e.languages.extend("markup", t), e.languages.jsx.tag.pattern = a(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source), e.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, e.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, e.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, e.languages.jsx.tag.inside.comment = t.comment, e.languages.insertBefore("inside", "attr-name", { spread: { pattern: a(/<SPREAD>/.source), inside: e.languages.jsx } }, e.languages.jsx.tag), e.languages.insertBefore("inside", "special-attr", { script: { pattern: a(/=<BRACES>/.source), alias: "language-javascript", inside: { "script-punctuation": { pattern: /^=(?=\{)/, alias: "punctuation" }, rest: e.languages.jsx } } }, e.languages.jsx.tag);
  function o(l) {
    for (var u = [], d = 0; d < l.length; d++) {
      var c = l[d], p = !1;
      typeof c != "string" && (c.type === "tag" && c.content[0] && c.content[0].type === "tag" ? c.content[0].content[0].content === "</" ? 0 < u.length && u[u.length - 1].tagName === s(c.content[0].content[1]) && u.pop() : c.content[c.content.length - 1].content !== "/>" && u.push({ tagName: s(c.content[0].content[1]), openedBraces: 0 }) : 0 < u.length && c.type === "punctuation" && c.content === "{" ? u[u.length - 1].openedBraces++ : 0 < u.length && 0 < u[u.length - 1].openedBraces && c.type === "punctuation" && c.content === "}" ? u[u.length - 1].openedBraces-- : p = !0), (p || typeof c == "string") && 0 < u.length && u[u.length - 1].openedBraces === 0 && (p = s(c), d < l.length - 1 && (typeof l[d + 1] == "string" || l[d + 1].type === "plain-text") && (p += s(l[d + 1]), l.splice(d + 1, 1)), 0 < d && (typeof l[d - 1] == "string" || l[d - 1].type === "plain-text") && (p = s(l[d - 1]) + p, l.splice(d - 1, 1), d--), l[d] = new e.Token("plain-text", p, null, p)), c.content && typeof c.content != "string" && o(c.content);
    }
  }
  var s = function(l) {
    return l ? typeof l == "string" ? l : typeof l.content == "string" ? l.content : l.content.map(s).join("") : "";
  };
  e.hooks.add("after-tokenize", function(l) {
    l.language !== "jsx" && l.language !== "tsx" || o(l.tokens);
  });
}(ze), function(e) {
  var t = e.util.clone(e.languages.typescript), t = (e.languages.tsx = e.languages.extend("jsx", t), delete e.languages.tsx.parameter, delete e.languages.tsx["literal-property"], e.languages.tsx.tag);
  t.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + "(?:" + t.pattern.source + ")", t.pattern.flags), t.lookbehind = !0;
}(ze), ze.languages.swift = { comment: { pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/, lookbehind: !0, greedy: !0 }, "string-literal": [{ pattern: RegExp(/(^|[^"#])/.source + "(?:" + /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source), lookbehind: !0, greedy: !0, inside: { interpolation: { pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/, lookbehind: !0, inside: null }, "interpolation-punctuation": { pattern: /^\)|\\\($/, alias: "punctuation" }, punctuation: /\\(?=[\r\n])/, string: /[\s\S]+/ } }, { pattern: RegExp(/(^|[^"#])(#+)/.source + "(?:" + /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")\\2"), lookbehind: !0, greedy: !0, inside: { interpolation: { pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/, lookbehind: !0, inside: null }, "interpolation-punctuation": { pattern: /^\)|\\#+\($/, alias: "punctuation" }, string: /[\s\S]+/ } }], directive: { pattern: RegExp(/#/.source + "(?:" + /(?:elseif|if)\b/.source + "(?:[ 	]*" + /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+|" + /(?:else|endif)\b/.source + ")"), alias: "property", inside: { "directive-name": /^#\w+/, boolean: /\b(?:false|true)\b/, number: /\b\d+(?:\.\d+)*\b/, operator: /!|&&|\|\||[<>]=?/, punctuation: /[(),]/ } }, literal: { pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/, alias: "constant" }, "other-directive": { pattern: /#\w+\b/, alias: "property" }, attribute: { pattern: /@\w+/, alias: "atrule" }, "function-definition": { pattern: /(\bfunc\s+)\w+/, lookbehind: !0, alias: "function" }, label: { pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/, lookbehind: !0, alias: "important" }, keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/, boolean: /\b(?:false|true)\b/, nil: { pattern: /\bnil\b/, alias: "constant" }, "short-argument": /\$\d+\b/, omit: { pattern: /\b_\b/, alias: "keyword" }, number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i, "class-name": /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/, function: /\b[a-z_]\w*(?=\s*\()/i, constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/, operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/, punctuation: /[{}[\]();,.:\\]/ }, ze.languages.swift["string-literal"].forEach(function(e) {
  e.inside.interpolation.inside = ze.languages.swift;
}), function(e) {
  e.languages.kotlin = e.languages.extend("clike", { keyword: { pattern: /(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/, lookbehind: !0 }, function: [{ pattern: /(?:`[^\r\n`]+`|\b\w+)(?=\s*\()/, greedy: !0 }, { pattern: /(\.)(?:`[^\r\n`]+`|\w+)(?=\s*\{)/, lookbehind: !0, greedy: !0 }], number: /\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/, operator: /\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/ }), delete e.languages.kotlin["class-name"];
  var t = { "interpolation-punctuation": { pattern: /^\$\{?|\}$/, alias: "punctuation" }, expression: { pattern: /[\s\S]+/, inside: e.languages.kotlin } };
  e.languages.insertBefore("kotlin", "string", { "string-literal": [{ pattern: /"""(?:[^$]|\$(?:(?!\{)|\{[^{}]*\}))*?"""/, alias: "multiline", inside: { interpolation: { pattern: /\$(?:[a-z_]\w*|\{[^{}]*\})/i, inside: t }, string: /[\s\S]+/ } }, { pattern: /"(?:[^"\\\r\n$]|\\.|\$(?:(?!\{)|\{[^{}]*\}))*"/, alias: "singleline", inside: { interpolation: { pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:[a-z_]\w*|\{[^{}]*\})/i, lookbehind: !0, inside: t }, string: /[\s\S]+/ } }], char: { pattern: /'(?:[^'\\\r\n]|\\(?:.|u[a-fA-F0-9]{0,4}))'/, greedy: !0 } }), delete e.languages.kotlin.string, e.languages.insertBefore("kotlin", "keyword", { annotation: { pattern: /\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/, alias: "builtin" } }), e.languages.insertBefore("kotlin", "function", { label: { pattern: /\b\w+@|@\w+\b/, alias: "symbol" } }), e.languages.kt = e.languages.kotlin, e.languages.kts = e.languages.kotlin;
}(ze), ze.languages.c = ze.languages.extend("clike", { comment: { pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/, greedy: !0 }, string: { pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/, greedy: !0 }, "class-name": { pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/, lookbehind: !0 }, keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/, function: /\b[a-z_]\w*(?=\s*\()/i, number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i, operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/ }), ze.languages.insertBefore("c", "string", { char: { pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/, greedy: !0 } }), ze.languages.insertBefore("c", "string", { macro: { pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im, lookbehind: !0, greedy: !0, alias: "property", inside: { string: [{ pattern: /^(#\s*include\s*)<[^>]+>/, lookbehind: !0 }, ze.languages.c.string], char: ze.languages.c.char, comment: ze.languages.c.comment, "macro-name": [{ pattern: /(^#\s*define\s+)\w+\b(?!\()/i, lookbehind: !0 }, { pattern: /(^#\s*define\s+)\w+\b(?=\()/i, lookbehind: !0, alias: "function" }], directive: { pattern: /^(#\s*)[a-z]+/, lookbehind: !0, alias: "keyword" }, "directive-hash": /^#/, punctuation: /##|\\(?=[\r\n])/, expression: { pattern: /\S[\s\S]*/, inside: ze.languages.c } } } }), ze.languages.insertBefore("c", "function", { constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/ }), delete ze.languages.c.boolean, ze.languages.objectivec = ze.languages.extend("c", { string: { pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/, greedy: !0 }, keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/, operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/ }), delete ze.languages.objectivec["class-name"], ze.languages.objc = ze.languages.objectivec, ze.languages.reason = ze.languages.extend("clike", { string: { pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/, greedy: !0 }, "class-name": /\b[A-Z]\w*/, keyword: /\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/, operator: /\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/ }), ze.languages.insertBefore("reason", "class-name", { char: { pattern: /'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/, greedy: !0 }, constructor: /\b[A-Z]\w*\b(?!\s*\.)/, label: { pattern: /\b[a-z]\w*(?=::)/, alias: "symbol" } }), delete ze.languages.reason.function, function(e) {
  for (var t = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source, r = 0; r < 2; r++)
    t = t.replace(/<self>/g, function() {
      return t;
    });
  t = t.replace(/<self>/g, function() {
    return /[^\s\S]/.source;
  }), e.languages.rust = { comment: [{ pattern: RegExp(/(^|[^\\])/.source + t), lookbehind: !0, greedy: !0 }, { pattern: /(^|[^\\:])\/\/.*/, lookbehind: !0, greedy: !0 }], string: { pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/, greedy: !0 }, char: { pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/, greedy: !0 }, attribute: { pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/, greedy: !0, alias: "attr-name", inside: { string: null } }, "closure-params": { pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/, lookbehind: !0, greedy: !0, inside: { "closure-punctuation": { pattern: /^\||\|$/, alias: "punctuation" }, rest: null } }, "lifetime-annotation": { pattern: /'\w+/, alias: "symbol" }, "fragment-specifier": { pattern: /(\$\w+:)[a-z]+/, lookbehind: !0, alias: "punctuation" }, variable: /\$\w+/, "function-definition": { pattern: /(\bfn\s+)\w+/, lookbehind: !0, alias: "function" }, "type-definition": { pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/, lookbehind: !0, alias: "class-name" }, "module-declaration": [{ pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/, lookbehind: !0, alias: "namespace" }, { pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/, lookbehind: !0, alias: "namespace", inside: { punctuation: /::/ } }], keyword: [/\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/, /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/], function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/, macro: { pattern: /\b\w+!/, alias: "property" }, constant: /\b[A-Z_][A-Z_\d]+\b/, "class-name": /\b[A-Z]\w*\b/, namespace: { pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/, inside: { punctuation: /::/ } }, number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/, boolean: /\b(?:false|true)\b/, punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/, operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/ }, e.languages.rust["closure-params"].inside.rest = e.languages.rust, e.languages.rust.attribute.inside.string = e.languages.rust.string;
}(ze), ze.languages.go = ze.languages.extend("clike", { string: { pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/, lookbehind: !0, greedy: !0 }, keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/, boolean: /\b(?:_|false|iota|nil|true)\b/, number: [/\b0(?:b[01_]+|o[0-7_]+)i?\b/i, /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i, /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i], operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./, builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/ }), ze.languages.insertBefore("go", "string", { char: { pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/, greedy: !0 } }), delete ze.languages.go["class-name"], function(e) {
  var t = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/, r = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
    return t.source;
  });
  e.languages.cpp = e.languages.extend("c", { "class-name": [{ pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
    return t.source;
  })), lookbehind: !0 }, /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/, /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i, /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/], keyword: t, number: { pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i, greedy: !0 }, operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/, boolean: /\b(?:false|true)\b/ }), e.languages.insertBefore("cpp", "string", { module: { pattern: RegExp(/(\b(?:import|module)\s+)/.source + "(?:" + /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
    return r;
  }) + ")"), lookbehind: !0, greedy: !0, inside: { string: /^[<"][\s\S]+/, operator: /:/, punctuation: /\./ } }, "raw-string": { pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/, alias: "string", greedy: !0 } }), e.languages.insertBefore("cpp", "keyword", { "generic-function": { pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i, inside: { function: /^\w+/, generic: { pattern: /<[\s\S]+/, alias: "class-name", inside: e.languages.cpp } } } }), e.languages.insertBefore("cpp", "operator", { "double-colon": { pattern: /::/, alias: "punctuation" } }), e.languages.insertBefore("cpp", "class-name", { "base-clause": { pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/, lookbehind: !0, greedy: !0, inside: e.languages.extend("cpp", {}) } }), e.languages.insertBefore("inside", "double-colon", { "class-name": /\b[a-z_]\w*\b(?!\s*::)/i }, e.languages.cpp["base-clause"]);
}(ze), ze.languages.python = { comment: { pattern: /(^|[^\\])#.*/, lookbehind: !0, greedy: !0 }, "string-interpolation": { pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i, greedy: !0, inside: { interpolation: { pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/, lookbehind: !0, inside: { "format-spec": { pattern: /(:)[^:(){}]+(?=\}$)/, lookbehind: !0 }, "conversion-option": { pattern: /![sra](?=[:}]$)/, alias: "punctuation" }, rest: null } }, string: /[\s\S]+/ } }, "triple-quoted-string": { pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i, greedy: !0, alias: "string" }, string: { pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i, greedy: !0 }, function: { pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g, lookbehind: !0 }, "class-name": { pattern: /(\bclass\s+)\w+/i, lookbehind: !0 }, decorator: { pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m, lookbehind: !0, alias: ["annotation", "punctuation"], inside: { punctuation: /\./ } }, keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/, builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/, boolean: /\b(?:False|None|True)\b/, number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i, operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/, punctuation: /[{}[\];(),.:]/ }, ze.languages.python["string-interpolation"].inside.interpolation.inside.rest = ze.languages.python, ze.languages.py = ze.languages.python;
var B2 = {};
rj(B2, {
  dracula: () => sj,
  duotoneDark: () => uj,
  duotoneLight: () => dj,
  github: () => hj,
  jettwaveDark: () => Oj,
  jettwaveLight: () => Nj,
  nightOwl: () => gj,
  nightOwlLight: () => vj,
  oceanicNext: () => bj,
  okaidia: () => Dj,
  oneDark: () => Lj,
  oneLight: () => jj,
  palenight: () => Ej,
  shadesOfPurple: () => xj,
  synthwave84: () => wj,
  ultramin: () => Tj,
  vsDark: () => Y6,
  vsLight: () => Bj
});
var oj = {
  plain: {
    color: "#F8F8F2",
    backgroundColor: "#282A36"
  },
  styles: [
    {
      types: ["prolog", "constant", "builtin"],
      style: {
        color: "rgb(189, 147, 249)"
      }
    },
    {
      types: ["inserted", "function"],
      style: {
        color: "rgb(80, 250, 123)"
      }
    },
    {
      types: ["deleted"],
      style: {
        color: "rgb(255, 85, 85)"
      }
    },
    {
      types: ["changed"],
      style: {
        color: "rgb(255, 184, 108)"
      }
    },
    {
      types: ["punctuation", "symbol"],
      style: {
        color: "rgb(248, 248, 242)"
      }
    },
    {
      types: ["string", "char", "tag", "selector"],
      style: {
        color: "rgb(255, 121, 198)"
      }
    },
    {
      types: ["keyword", "variable"],
      style: {
        color: "rgb(189, 147, 249)",
        fontStyle: "italic"
      }
    },
    {
      types: ["comment"],
      style: {
        color: "rgb(98, 114, 164)"
      }
    },
    {
      types: ["attr-name"],
      style: {
        color: "rgb(241, 250, 140)"
      }
    }
  ]
}, sj = oj, lj = {
  plain: {
    backgroundColor: "#2a2734",
    color: "#9a86fd"
  },
  styles: [
    {
      types: ["comment", "prolog", "doctype", "cdata", "punctuation"],
      style: {
        color: "#6c6783"
      }
    },
    {
      types: ["namespace"],
      style: {
        opacity: 0.7
      }
    },
    {
      types: ["tag", "operator", "number"],
      style: {
        color: "#e09142"
      }
    },
    {
      types: ["property", "function"],
      style: {
        color: "#9a86fd"
      }
    },
    {
      types: ["tag-id", "selector", "atrule-id"],
      style: {
        color: "#eeebff"
      }
    },
    {
      types: ["attr-name"],
      style: {
        color: "#c4b9fe"
      }
    },
    {
      types: [
        "boolean",
        "string",
        "entity",
        "url",
        "attr-value",
        "keyword",
        "control",
        "directive",
        "unit",
        "statement",
        "regex",
        "atrule",
        "placeholder",
        "variable"
      ],
      style: {
        color: "#ffcc99"
      }
    },
    {
      types: ["deleted"],
      style: {
        textDecorationLine: "line-through"
      }
    },
    {
      types: ["inserted"],
      style: {
        textDecorationLine: "underline"
      }
    },
    {
      types: ["italic"],
      style: {
        fontStyle: "italic"
      }
    },
    {
      types: ["important", "bold"],
      style: {
        fontWeight: "bold"
      }
    },
    {
      types: ["important"],
      style: {
        color: "#c4b9fe"
      }
    }
  ]
}, uj = lj, cj = {
  plain: {
    backgroundColor: "#faf8f5",
    color: "#728fcb"
  },
  styles: [
    {
      types: ["comment", "prolog", "doctype", "cdata", "punctuation"],
      style: {
        color: "#b6ad9a"
      }
    },
    {
      types: ["namespace"],
      style: {
        opacity: 0.7
      }
    },
    {
      types: ["tag", "operator", "number"],
      style: {
        color: "#063289"
      }
    },
    {
      types: ["property", "function"],
      style: {
        color: "#b29762"
      }
    },
    {
      types: ["tag-id", "selector", "atrule-id"],
      style: {
        color: "#2d2006"
      }
    },
    {
      types: ["attr-name"],
      style: {
        color: "#896724"
      }
    },
    {
      types: [
        "boolean",
        "string",
        "entity",
        "url",
        "attr-value",
        "keyword",
        "control",
        "directive",
        "unit",
        "statement",
        "regex",
        "atrule"
      ],
      style: {
        color: "#728fcb"
      }
    },
    {
      types: ["placeholder", "variable"],
      style: {
        color: "#93abdc"
      }
    },
    {
      types: ["deleted"],
      style: {
        textDecorationLine: "line-through"
      }
    },
    {
      types: ["inserted"],
      style: {
        textDecorationLine: "underline"
      }
    },
    {
      types: ["italic"],
      style: {
        fontStyle: "italic"
      }
    },
    {
      types: ["important", "bold"],
      style: {
        fontWeight: "bold"
      }
    },
    {
      types: ["important"],
      style: {
        color: "#896724"
      }
    }
  ]
}, dj = cj, pj = {
  plain: {
    color: "#393A34",
    backgroundColor: "#f6f8fa"
  },
  styles: [
    {
      types: ["comment", "prolog", "doctype", "cdata"],
      style: {
        color: "#999988",
        fontStyle: "italic"
      }
    },
    {
      types: ["namespace"],
      style: {
        opacity: 0.7
      }
    },
    {
      types: ["string", "attr-value"],
      style: {
        color: "#e3116c"
      }
    },
    {
      types: ["punctuation", "operator"],
      style: {
        color: "#393A34"
      }
    },
    {
      types: [
        "entity",
        "url",
        "symbol",
        "number",
        "boolean",
        "variable",
        "constant",
        "property",
        "regex",
        "inserted"
      ],
      style: {
        color: "#36acaa"
      }
    },
    {
      types: ["atrule", "keyword", "attr-name", "selector"],
      style: {
        color: "#00a4db"
      }
    },
    {
      types: ["function", "deleted", "tag"],
      style: {
        color: "#d73a49"
      }
    },
    {
      types: ["function-variable"],
      style: {
        color: "#6f42c1"
      }
    },
    {
      types: ["tag", "selector", "keyword"],
      style: {
        color: "#00009f"
      }
    }
  ]
}, hj = pj, fj = {
  plain: {
    color: "#d6deeb",
    backgroundColor: "#011627"
  },
  styles: [
    {
      types: ["changed"],
      style: {
        color: "rgb(162, 191, 252)",
        fontStyle: "italic"
      }
    },
    {
      types: ["deleted"],
      style: {
        color: "rgba(239, 83, 80, 0.56)",
        fontStyle: "italic"
      }
    },
    {
      types: ["inserted", "attr-name"],
      style: {
        color: "rgb(173, 219, 103)",
        fontStyle: "italic"
      }
    },
    {
      types: ["comment"],
      style: {
        color: "rgb(99, 119, 119)",
        fontStyle: "italic"
      }
    },
    {
      types: ["string", "url"],
      style: {
        color: "rgb(173, 219, 103)"
      }
    },
    {
      types: ["variable"],
      style: {
        color: "rgb(214, 222, 235)"
      }
    },
    {
      types: ["number"],
      style: {
        color: "rgb(247, 140, 108)"
      }
    },
    {
      types: ["builtin", "char", "constant", "function"],
      style: {
        color: "rgb(130, 170, 255)"
      }
    },
    {
      // This was manually added after the auto-generation
      // so that punctuations are not italicised
      types: ["punctuation"],
      style: {
        color: "rgb(199, 146, 234)"
      }
    },
    {
      types: ["selector", "doctype"],
      style: {
        color: "rgb(199, 146, 234)",
        fontStyle: "italic"
      }
    },
    {
      types: ["class-name"],
      style: {
        color: "rgb(255, 203, 139)"
      }
    },
    {
      types: ["tag", "operator", "keyword"],
      style: {
        color: "rgb(127, 219, 202)"
      }
    },
    {
      types: ["boolean"],
      style: {
        color: "rgb(255, 88, 116)"
      }
    },
    {
      types: ["property"],
      style: {
        color: "rgb(128, 203, 196)"
      }
    },
    {
      types: ["namespace"],
      style: {
        color: "rgb(178, 204, 214)"
      }
    }
  ]
}, gj = fj, mj = {
  plain: {
    color: "#403f53",
    backgroundColor: "#FBFBFB"
  },
  styles: [
    {
      types: ["changed"],
      style: {
        color: "rgb(162, 191, 252)",
        fontStyle: "italic"
      }
    },
    {
      types: ["deleted"],
      style: {
        color: "rgba(239, 83, 80, 0.56)",
        fontStyle: "italic"
      }
    },
    {
      types: ["inserted", "attr-name"],
      style: {
        color: "rgb(72, 118, 214)",
        fontStyle: "italic"
      }
    },
    {
      types: ["comment"],
      style: {
        color: "rgb(152, 159, 177)",
        fontStyle: "italic"
      }
    },
    {
      types: ["string", "builtin", "char", "constant", "url"],
      style: {
        color: "rgb(72, 118, 214)"
      }
    },
    {
      types: ["variable"],
      style: {
        color: "rgb(201, 103, 101)"
      }
    },
    {
      types: ["number"],
      style: {
        color: "rgb(170, 9, 130)"
      }
    },
    {
      // This was manually added after the auto-generation
      // so that punctuations are not italicised
      types: ["punctuation"],
      style: {
        color: "rgb(153, 76, 195)"
      }
    },
    {
      types: ["function", "selector", "doctype"],
      style: {
        color: "rgb(153, 76, 195)",
        fontStyle: "italic"
      }
    },
    {
      types: ["class-name"],
      style: {
        color: "rgb(17, 17, 17)"
      }
    },
    {
      types: ["tag"],
      style: {
        color: "rgb(153, 76, 195)"
      }
    },
    {
      types: ["operator", "property", "keyword", "namespace"],
      style: {
        color: "rgb(12, 150, 155)"
      }
    },
    {
      types: ["boolean"],
      style: {
        color: "rgb(188, 84, 84)"
      }
    }
  ]
}, vj = mj, ma = {
  char: "#D8DEE9",
  comment: "#999999",
  keyword: "#c5a5c5",
  primitive: "#5a9bcf",
  string: "#8dc891",
  variable: "#d7deea",
  boolean: "#ff8b50",
  punctuation: "#5FB3B3",
  tag: "#fc929e",
  function: "#79b6f2",
  className: "#FAC863",
  method: "#6699CC",
  operator: "#fc929e"
}, kj = {
  plain: {
    backgroundColor: "#282c34",
    color: "#ffffff"
  },
  styles: [
    {
      types: ["attr-name"],
      style: {
        color: ma.keyword
      }
    },
    {
      types: ["attr-value"],
      style: {
        color: ma.string
      }
    },
    {
      types: [
        "comment",
        "block-comment",
        "prolog",
        "doctype",
        "cdata",
        "shebang"
      ],
      style: {
        color: ma.comment
      }
    },
    {
      types: [
        "property",
        "number",
        "function-name",
        "constant",
        "symbol",
        "deleted"
      ],
      style: {
        color: ma.primitive
      }
    },
    {
      types: ["boolean"],
      style: {
        color: ma.boolean
      }
    },
    {
      types: ["tag"],
      style: {
        color: ma.tag
      }
    },
    {
      types: ["string"],
      style: {
        color: ma.string
      }
    },
    {
      types: ["punctuation"],
      style: {
        color: ma.string
      }
    },
    {
      types: ["selector", "char", "builtin", "inserted"],
      style: {
        color: ma.char
      }
    },
    {
      types: ["function"],
      style: {
        color: ma.function
      }
    },
    {
      types: ["operator", "entity", "url", "variable"],
      style: {
        color: ma.variable
      }
    },
    {
      types: ["keyword"],
      style: {
        color: ma.keyword
      }
    },
    {
      types: ["atrule", "class-name"],
      style: {
        color: ma.className
      }
    },
    {
      types: ["important"],
      style: {
        fontWeight: "400"
      }
    },
    {
      types: ["bold"],
      style: {
        fontWeight: "bold"
      }
    },
    {
      types: ["italic"],
      style: {
        fontStyle: "italic"
      }
    },
    {
      types: ["namespace"],
      style: {
        opacity: 0.7
      }
    }
  ]
}, bj = kj, _j = {
  plain: {
    color: "#f8f8f2",
    backgroundColor: "#272822"
  },
  styles: [
    {
      types: ["changed"],
      style: {
        color: "rgb(162, 191, 252)",
        fontStyle: "italic"
      }
    },
    {
      types: ["deleted"],
      style: {
        color: "#f92672",
        fontStyle: "italic"
      }
    },
    {
      types: ["inserted"],
      style: {
        color: "rgb(173, 219, 103)",
        fontStyle: "italic"
      }
    },
    {
      types: ["comment"],
      style: {
        color: "#8292a2",
        fontStyle: "italic"
      }
    },
    {
      types: ["string", "url"],
      style: {
        color: "#a6e22e"
      }
    },
    {
      types: ["variable"],
      style: {
        color: "#f8f8f2"
      }
    },
    {
      types: ["number"],
      style: {
        color: "#ae81ff"
      }
    },
    {
      types: ["builtin", "char", "constant", "function", "class-name"],
      style: {
        color: "#e6db74"
      }
    },
    {
      types: ["punctuation"],
      style: {
        color: "#f8f8f2"
      }
    },
    {
      types: ["selector", "doctype"],
      style: {
        color: "#a6e22e",
        fontStyle: "italic"
      }
    },
    {
      types: ["tag", "operator", "keyword"],
      style: {
        color: "#66d9ef"
      }
    },
    {
      types: ["boolean"],
      style: {
        color: "#ae81ff"
      }
    },
    {
      types: ["namespace"],
      style: {
        color: "rgb(178, 204, 214)",
        opacity: 0.7
      }
    },
    {
      types: ["tag", "property"],
      style: {
        color: "#f92672"
      }
    },
    {
      types: ["attr-name"],
      style: {
        color: "#a6e22e !important"
      }
    },
    {
      types: ["doctype"],
      style: {
        color: "#8292a2"
      }
    },
    {
      types: ["rule"],
      style: {
        color: "#e6db74"
      }
    }
  ]
}, Dj = _j, yj = {
  plain: {
    color: "#bfc7d5",
    backgroundColor: "#292d3e"
  },
  styles: [
    {
      types: ["comment"],
      style: {
        color: "rgb(105, 112, 152)",
        fontStyle: "italic"
      }
    },
    {
      types: ["string", "inserted"],
      style: {
        color: "rgb(195, 232, 141)"
      }
    },
    {
      types: ["number"],
      style: {
        color: "rgb(247, 140, 108)"
      }
    },
    {
      types: ["builtin", "char", "constant", "function"],
      style: {
        color: "rgb(130, 170, 255)"
      }
    },
    {
      types: ["punctuation", "selector"],
      style: {
        color: "rgb(199, 146, 234)"
      }
    },
    {
      types: ["variable"],
      style: {
        color: "rgb(191, 199, 213)"
      }
    },
    {
      types: ["class-name", "attr-name"],
      style: {
        color: "rgb(255, 203, 107)"
      }
    },
    {
      types: ["tag", "deleted"],
      style: {
        color: "rgb(255, 85, 114)"
      }
    },
    {
      types: ["operator"],
      style: {
        color: "rgb(137, 221, 255)"
      }
    },
    {
      types: ["boolean"],
      style: {
        color: "rgb(255, 88, 116)"
      }
    },
    {
      types: ["keyword"],
      style: {
        fontStyle: "italic"
      }
    },
    {
      types: ["doctype"],
      style: {
        color: "rgb(199, 146, 234)",
        fontStyle: "italic"
      }
    },
    {
      types: ["namespace"],
      style: {
        color: "rgb(178, 204, 214)"
      }
    },
    {
      types: ["url"],
      style: {
        color: "rgb(221, 221, 221)"
      }
    }
  ]
}, Ej = yj, Cj = {
  plain: {
    color: "#9EFEFF",
    backgroundColor: "#2D2A55"
  },
  styles: [
    {
      types: ["changed"],
      style: {
        color: "rgb(255, 238, 128)"
      }
    },
    {
      types: ["deleted"],
      style: {
        color: "rgba(239, 83, 80, 0.56)"
      }
    },
    {
      types: ["inserted"],
      style: {
        color: "rgb(173, 219, 103)"
      }
    },
    {
      types: ["comment"],
      style: {
        color: "rgb(179, 98, 255)",
        fontStyle: "italic"
      }
    },
    {
      types: ["punctuation"],
      style: {
        color: "rgb(255, 255, 255)"
      }
    },
    {
      types: ["constant"],
      style: {
        color: "rgb(255, 98, 140)"
      }
    },
    {
      types: ["string", "url"],
      style: {
        color: "rgb(165, 255, 144)"
      }
    },
    {
      types: ["variable"],
      style: {
        color: "rgb(255, 238, 128)"
      }
    },
    {
      types: ["number", "boolean"],
      style: {
        color: "rgb(255, 98, 140)"
      }
    },
    {
      types: ["attr-name"],
      style: {
        color: "rgb(255, 180, 84)"
      }
    },
    {
      types: [
        "keyword",
        "operator",
        "property",
        "namespace",
        "tag",
        "selector",
        "doctype"
      ],
      style: {
        color: "rgb(255, 157, 0)"
      }
    },
    {
      types: ["builtin", "char", "constant", "function", "class-name"],
      style: {
        color: "rgb(250, 208, 0)"
      }
    }
  ]
}, xj = Cj, Aj = {
  plain: {
    backgroundColor: "linear-gradient(to bottom, #2a2139 75%, #34294f)",
    backgroundImage: "#34294f",
    color: "#f92aad",
    textShadow: "0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"
  },
  styles: [
    {
      types: ["comment", "block-comment", "prolog", "doctype", "cdata"],
      style: {
        color: "#495495",
        fontStyle: "italic"
      }
    },
    {
      types: ["punctuation"],
      style: {
        color: "#ccc"
      }
    },
    {
      types: [
        "tag",
        "attr-name",
        "namespace",
        "number",
        "unit",
        "hexcode",
        "deleted"
      ],
      style: {
        color: "#e2777a"
      }
    },
    {
      types: ["property", "selector"],
      style: {
        color: "#72f1b8",
        textShadow: "0 0 2px #100c0f, 0 0 10px #257c5575, 0 0 35px #21272475"
      }
    },
    {
      types: ["function-name"],
      style: {
        color: "#6196cc"
      }
    },
    {
      types: ["boolean", "selector-id", "function"],
      style: {
        color: "#fdfdfd",
        textShadow: "0 0 2px #001716, 0 0 3px #03edf975, 0 0 5px #03edf975, 0 0 8px #03edf975"
      }
    },
    {
      types: ["class-name", "maybe-class-name", "builtin"],
      style: {
        color: "#fff5f6",
        textShadow: "0 0 2px #000, 0 0 10px #fc1f2c75, 0 0 5px #fc1f2c75, 0 0 25px #fc1f2c75"
      }
    },
    {
      types: ["constant", "symbol"],
      style: {
        color: "#f92aad",
        textShadow: "0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"
      }
    },
    {
      types: ["important", "atrule", "keyword", "selector-class"],
      style: {
        color: "#f4eee4",
        textShadow: "0 0 2px #393a33, 0 0 8px #f39f0575, 0 0 2px #f39f0575"
      }
    },
    {
      types: ["string", "char", "attr-value", "regex", "variable"],
      style: {
        color: "#f87c32"
      }
    },
    {
      types: ["parameter"],
      style: {
        fontStyle: "italic"
      }
    },
    {
      types: ["entity", "url"],
      style: {
        color: "#67cdcc"
      }
    },
    {
      types: ["operator"],
      style: {
        color: "ffffffee"
      }
    },
    {
      types: ["important", "bold"],
      style: {
        fontWeight: "bold"
      }
    },
    {
      types: ["italic"],
      style: {
        fontStyle: "italic"
      }
    },
    {
      types: ["entity"],
      style: {
        cursor: "help"
      }
    },
    {
      types: ["inserted"],
      style: {
        color: "green"
      }
    }
  ]
}, wj = Aj, Fj = {
  plain: {
    color: "#282a2e",
    backgroundColor: "#ffffff"
  },
  styles: [
    {
      types: ["comment"],
      style: {
        color: "rgb(197, 200, 198)"
      }
    },
    {
      types: ["string", "number", "builtin", "variable"],
      style: {
        color: "rgb(150, 152, 150)"
      }
    },
    {
      types: ["class-name", "function", "tag", "attr-name"],
      style: {
        color: "rgb(40, 42, 46)"
      }
    }
  ]
}, Tj = Fj, Sj = {
  plain: {
    color: "#9CDCFE",
    backgroundColor: "#1E1E1E"
  },
  styles: [
    {
      types: ["prolog"],
      style: {
        color: "rgb(0, 0, 128)"
      }
    },
    {
      types: ["comment"],
      style: {
        color: "rgb(106, 153, 85)"
      }
    },
    {
      types: ["builtin", "changed", "keyword", "interpolation-punctuation"],
      style: {
        color: "rgb(86, 156, 214)"
      }
    },
    {
      types: ["number", "inserted"],
      style: {
        color: "rgb(181, 206, 168)"
      }
    },
    {
      types: ["constant"],
      style: {
        color: "rgb(100, 102, 149)"
      }
    },
    {
      types: ["attr-name", "variable"],
      style: {
        color: "rgb(156, 220, 254)"
      }
    },
    {
      types: ["deleted", "string", "attr-value", "template-punctuation"],
      style: {
        color: "rgb(206, 145, 120)"
      }
    },
    {
      types: ["selector"],
      style: {
        color: "rgb(215, 186, 125)"
      }
    },
    {
      // Fix tag color
      types: ["tag"],
      style: {
        color: "rgb(78, 201, 176)"
      }
    },
    {
      // Fix tag color for HTML
      types: ["tag"],
      languages: ["markup"],
      style: {
        color: "rgb(86, 156, 214)"
      }
    },
    {
      types: ["punctuation", "operator"],
      style: {
        color: "rgb(212, 212, 212)"
      }
    },
    {
      // Fix punctuation color for HTML
      types: ["punctuation"],
      languages: ["markup"],
      style: {
        color: "#808080"
      }
    },
    {
      types: ["function"],
      style: {
        color: "rgb(220, 220, 170)"
      }
    },
    {
      types: ["class-name"],
      style: {
        color: "rgb(78, 201, 176)"
      }
    },
    {
      types: ["char"],
      style: {
        color: "rgb(209, 105, 105)"
      }
    }
  ]
}, Y6 = Sj, Ij = {
  plain: {
    color: "#000000",
    backgroundColor: "#ffffff"
  },
  styles: [
    {
      types: ["comment"],
      style: {
        color: "rgb(0, 128, 0)"
      }
    },
    {
      types: ["builtin"],
      style: {
        color: "rgb(0, 112, 193)"
      }
    },
    {
      types: ["number", "variable", "inserted"],
      style: {
        color: "rgb(9, 134, 88)"
      }
    },
    {
      types: ["operator"],
      style: {
        color: "rgb(0, 0, 0)"
      }
    },
    {
      types: ["constant", "char"],
      style: {
        color: "rgb(129, 31, 63)"
      }
    },
    {
      types: ["tag"],
      style: {
        color: "rgb(128, 0, 0)"
      }
    },
    {
      types: ["attr-name"],
      style: {
        color: "rgb(255, 0, 0)"
      }
    },
    {
      types: ["deleted", "string"],
      style: {
        color: "rgb(163, 21, 21)"
      }
    },
    {
      types: ["changed", "punctuation"],
      style: {
        color: "rgb(4, 81, 165)"
      }
    },
    {
      types: ["function", "keyword"],
      style: {
        color: "rgb(0, 0, 255)"
      }
    },
    {
      types: ["class-name"],
      style: {
        color: "rgb(38, 127, 153)"
      }
    }
  ]
}, Bj = Ij, Rj = {
  plain: {
    color: "#f8fafc",
    backgroundColor: "#011627"
  },
  styles: [
    {
      types: ["prolog"],
      style: {
        color: "#000080"
      }
    },
    {
      types: ["comment"],
      style: {
        color: "#6A9955"
      }
    },
    {
      types: ["builtin", "changed", "keyword", "interpolation-punctuation"],
      style: {
        color: "#569CD6"
      }
    },
    {
      types: ["number", "inserted"],
      style: {
        color: "#B5CEA8"
      }
    },
    {
      types: ["constant"],
      style: {
        color: "#f8fafc"
      }
    },
    {
      types: ["attr-name", "variable"],
      style: {
        color: "#9CDCFE"
      }
    },
    {
      types: ["deleted", "string", "attr-value", "template-punctuation"],
      style: {
        color: "#cbd5e1"
      }
    },
    {
      types: ["selector"],
      style: {
        color: "#D7BA7D"
      }
    },
    {
      types: ["tag"],
      style: {
        color: "#0ea5e9"
      }
    },
    {
      types: ["tag"],
      languages: ["markup"],
      style: {
        color: "#0ea5e9"
      }
    },
    {
      types: ["punctuation", "operator"],
      style: {
        color: "#D4D4D4"
      }
    },
    {
      types: ["punctuation"],
      languages: ["markup"],
      style: {
        color: "#808080"
      }
    },
    {
      types: ["function"],
      style: {
        color: "#7dd3fc"
      }
    },
    {
      types: ["class-name"],
      style: {
        color: "#0ea5e9"
      }
    },
    {
      types: ["char"],
      style: {
        color: "#D16969"
      }
    }
  ]
}, Oj = Rj, Pj = {
  plain: {
    color: "#0f172a",
    backgroundColor: "#f1f5f9"
  },
  styles: [
    {
      types: ["prolog"],
      style: {
        color: "#000080"
      }
    },
    {
      types: ["comment"],
      style: {
        color: "#6A9955"
      }
    },
    {
      types: ["builtin", "changed", "keyword", "interpolation-punctuation"],
      style: {
        color: "#0c4a6e"
      }
    },
    {
      types: ["number", "inserted"],
      style: {
        color: "#B5CEA8"
      }
    },
    {
      types: ["constant"],
      style: {
        color: "#0f172a"
      }
    },
    {
      types: ["attr-name", "variable"],
      style: {
        color: "#0c4a6e"
      }
    },
    {
      types: ["deleted", "string", "attr-value", "template-punctuation"],
      style: {
        color: "#64748b"
      }
    },
    {
      types: ["selector"],
      style: {
        color: "#D7BA7D"
      }
    },
    {
      types: ["tag"],
      style: {
        color: "#0ea5e9"
      }
    },
    {
      types: ["tag"],
      languages: ["markup"],
      style: {
        color: "#0ea5e9"
      }
    },
    {
      types: ["punctuation", "operator"],
      style: {
        color: "#475569"
      }
    },
    {
      types: ["punctuation"],
      languages: ["markup"],
      style: {
        color: "#808080"
      }
    },
    {
      types: ["function"],
      style: {
        color: "#0e7490"
      }
    },
    {
      types: ["class-name"],
      style: {
        color: "#0ea5e9"
      }
    },
    {
      types: ["char"],
      style: {
        color: "#D16969"
      }
    }
  ]
}, Nj = Pj, zj = {
  plain: {
    backgroundColor: "hsl(220, 13%, 18%)",
    color: "hsl(220, 14%, 71%)",
    textShadow: "0 1px rgba(0, 0, 0, 0.3)"
  },
  styles: [
    {
      types: ["comment", "prolog", "cdata"],
      style: {
        color: "hsl(220, 10%, 40%)"
      }
    },
    {
      types: ["doctype", "punctuation", "entity"],
      style: {
        color: "hsl(220, 14%, 71%)"
      }
    },
    {
      types: [
        "attr-name",
        "class-name",
        "maybe-class-name",
        "boolean",
        "constant",
        "number",
        "atrule"
      ],
      style: { color: "hsl(29, 54%, 61%)" }
    },
    {
      types: ["keyword"],
      style: { color: "hsl(286, 60%, 67%)" }
    },
    {
      types: ["property", "tag", "symbol", "deleted", "important"],
      style: {
        color: "hsl(355, 65%, 65%)"
      }
    },
    {
      types: [
        "selector",
        "string",
        "char",
        "builtin",
        "inserted",
        "regex",
        "attr-value"
      ],
      style: {
        color: "hsl(95, 38%, 62%)"
      }
    },
    {
      types: ["variable", "operator", "function"],
      style: {
        color: "hsl(207, 82%, 66%)"
      }
    },
    {
      types: ["url"],
      style: {
        color: "hsl(187, 47%, 55%)"
      }
    },
    {
      types: ["deleted"],
      style: {
        textDecorationLine: "line-through"
      }
    },
    {
      types: ["inserted"],
      style: {
        textDecorationLine: "underline"
      }
    },
    {
      types: ["italic"],
      style: {
        fontStyle: "italic"
      }
    },
    {
      types: ["important", "bold"],
      style: {
        fontWeight: "bold"
      }
    },
    {
      types: ["important"],
      style: {
        color: "hsl(220, 14%, 71%)"
      }
    }
  ]
}, Lj = zj, Mj = {
  plain: {
    backgroundColor: "hsl(230, 1%, 98%)",
    color: "hsl(230, 8%, 24%)"
  },
  styles: [
    {
      types: ["comment", "prolog", "cdata"],
      style: {
        color: "hsl(230, 4%, 64%)"
      }
    },
    {
      types: ["doctype", "punctuation", "entity"],
      style: {
        color: "hsl(230, 8%, 24%)"
      }
    },
    {
      types: [
        "attr-name",
        "class-name",
        "boolean",
        "constant",
        "number",
        "atrule"
      ],
      style: {
        color: "hsl(35, 99%, 36%)"
      }
    },
    {
      types: ["keyword"],
      style: {
        color: "hsl(301, 63%, 40%)"
      }
    },
    {
      types: ["property", "tag", "symbol", "deleted", "important"],
      style: {
        color: "hsl(5, 74%, 59%)"
      }
    },
    {
      types: [
        "selector",
        "string",
        "char",
        "builtin",
        "inserted",
        "regex",
        "attr-value",
        "punctuation"
      ],
      style: {
        color: "hsl(119, 34%, 47%)"
      }
    },
    {
      types: ["variable", "operator", "function"],
      style: {
        color: "hsl(221, 87%, 60%)"
      }
    },
    {
      types: ["url"],
      style: {
        color: "hsl(198, 99%, 37%)"
      }
    },
    {
      types: ["deleted"],
      style: {
        textDecorationLine: "line-through"
      }
    },
    {
      types: ["inserted"],
      style: {
        textDecorationLine: "underline"
      }
    },
    {
      types: ["italic"],
      style: {
        fontStyle: "italic"
      }
    },
    {
      types: ["important", "bold"],
      style: {
        fontWeight: "bold"
      }
    },
    {
      types: ["important"],
      style: {
        color: "hsl(230, 8%, 24%)"
      }
    }
  ]
}, jj = Mj, Hj = (e, t) => {
  const { plain: r } = e, i = e.styles.reduce((n, a) => {
    const { languages: o, style: s } = a;
    return o && !o.includes(t) || a.types.forEach((l) => {
      const u = Yo(Yo({}, n[l]), s);
      n[l] = u;
    }), n;
  }, {});
  return i.root = r, i.plain = gm(Yo({}, r), { backgroundColor: void 0 }), i;
}, oE = Hj, $j = (e, t) => {
  const [r, i] = rt(
    oE(t, e)
  ), n = qt(), a = qt();
  return gt(() => {
    (t !== n.current || e !== a.current) && (n.current = t, a.current = e, i(oE(t, e)));
  }, [e, t]), r;
}, Uj = (e) => Nt(
  (t) => {
    var r = t, { className: i, style: n, line: a } = r, o = K6(r, ["className", "style", "line"]);
    const s = gm(Yo({}, o), {
      className: V6("token-line", i)
    });
    return typeof e == "object" && "plain" in e && (s.style = e.plain), typeof n == "object" && (s.style = Yo(Yo({}, s.style || {}), n)), s;
  },
  [e]
), Vj = (e) => {
  const t = Nt(
    ({ types: r, empty: i }) => {
      if (e != null) {
        {
          if (r.length === 1 && r[0] === "plain")
            return i != null ? { display: "inline-block" } : void 0;
          if (r.length === 1 && i != null)
            return e[r[0]];
        }
        return Object.assign(
          i != null ? { display: "inline-block" } : {},
          ...r.map((n) => e[n])
        );
      }
    },
    [e]
  );
  return Nt(
    (r) => {
      var i = r, { token: n, className: a, style: o } = i, s = K6(i, ["token", "className", "style"]);
      const l = gm(Yo({}, s), {
        className: V6("token", ...n.types, a),
        children: n.content,
        style: t(n)
      });
      return o != null && (l.style = Yo(Yo({}, l.style || {}), o)), l;
    },
    [t]
  );
}, Wj = /\r\n|\r|\n/, sE = (e) => {
  e.length === 0 ? e.push({
    types: ["plain"],
    content: `
`,
    empty: !0
  }) : e.length === 1 && e[0].content === "" && (e[0].content = `
`, e[0].empty = !0);
}, lE = (e, t) => {
  const r = e.length;
  return r > 0 && e[r - 1] === t ? e : e.concat(t);
}, Gj = (e) => {
  const t = [[]], r = [e], i = [0], n = [e.length];
  let a = 0, o = 0, s = [];
  const l = [s];
  for (; o > -1; ) {
    for (; (a = i[o]++) < n[o]; ) {
      let u, d = t[o];
      const p = r[o][a];
      if (typeof p == "string" ? (d = o > 0 ? d : ["plain"], u = p) : (d = lE(d, p.type), p.alias && (d = lE(d, p.alias)), u = p.content), typeof u != "string") {
        o++, t.push(d), r.push(u), i.push(0), n.push(u.length);
        continue;
      }
      const f = u.split(Wj), g = f.length;
      s.push({
        types: d,
        content: f[0]
      });
      for (let k = 1; k < g; k++)
        sE(s), l.push(s = []), s.push({
          types: d,
          content: f[k]
        });
    }
    o--, t.pop(), r.pop(), i.pop(), n.pop();
  }
  return sE(s), l;
}, uE = Gj, Kj = ({ prism: e, code: t, grammar: r, language: i }) => {
  const n = qt(e);
  return Jt(() => {
    if (r == null)
      return uE([t]);
    const a = {
      code: t,
      grammar: r,
      language: i,
      tokens: []
    };
    return n.current.hooks.run("before-tokenize", a), a.tokens = n.current.tokenize(t, r), n.current.hooks.run("after-tokenize", a), uE(a.tokens);
  }, [t, r, i]);
}, Yj = ({
  children: e,
  language: t,
  code: r,
  theme: i,
  prism: n
}) => {
  const a = t.toLowerCase(), o = $j(a, i), s = Uj(o), l = Vj(o), u = n.languages[a], d = Kj({ prism: n, language: a, code: r, grammar: u });
  return e({
    tokens: d,
    className: `prism-code language-${a}`,
    style: o != null ? o.root : {},
    getLineProps: s,
    getTokenProps: l
  });
}, qj = (e) => xa(Yj, gm(Yo({}, e), {
  prism: e.prism || ze,
  theme: e.theme || Y6,
  code: e.code,
  language: e.language
}));
/*! Bundled license information:

prismjs/prism.js:
  (**
   * Prism: Lightweight, robust, elegant syntax highlighting
   *
   * @license MIT <https://opensource.org/licenses/MIT>
   * @author Lea Verou <https://lea.verou.me>
   * @namespace
   * @public
   *)
*/
async function Qj(e) {
  globalThis.Prism = e, await import("./prism-python-47c53c27.mjs"), await import("./prism-bash-9cd46793.mjs"), await import("./prism-sql-4fd3a13d.mjs"), await import("./prism-json-a7824359.mjs"), await import("./prism-css-db2d0e53.mjs"), await import("./prism-javascript-8d001e70.mjs"), delete globalThis.Prism;
}
const Xj = (e) => (gt(() => {
  e || Qj(ze);
}, [e]), null), mm = Xj;
var q6 = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, cE = ht.createContext && ht.createContext(q6), wl = globalThis && globalThis.__assign || function() {
  return wl = Object.assign || function(e) {
    for (var t, r = 1, i = arguments.length; r < i; r++) {
      t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, wl.apply(this, arguments);
}, Zj = globalThis && globalThis.__rest || function(e, t) {
  var r = {};
  for (var i in e)
    Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (r[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, i = Object.getOwnPropertySymbols(e); n < i.length; n++)
      t.indexOf(i[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[n]) && (r[i[n]] = e[i[n]]);
  return r;
};
function Q6(e) {
  return e && e.map(function(t, r) {
    return ht.createElement(t.tag, wl({
      key: r
    }, t.attr), Q6(t.child));
  });
}
function ft(e) {
  return function(t) {
    return ht.createElement(Jj, wl({
      attr: wl({}, e.attr)
    }, t), Q6(e.child));
  };
}
function Jj(e) {
  var t = function(r) {
    var i = e.attr, n = e.size, a = e.title, o = Zj(e, ["attr", "size", "title"]), s = n || r.size || "1em", l;
    return r.className && (l = r.className), e.className && (l = (l ? l + " " : "") + e.className), ht.createElement("svg", wl({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, r.attr, i, o, {
      className: l,
      style: wl(wl({
        color: e.color || r.color
      }, r.style), e.style),
      height: s,
      width: s,
      xmlns: "http://www.w3.org/2000/svg"
    }), a && ht.createElement("title", null, a), e.children);
  };
  return cE !== void 0 ? ht.createElement(cE.Consumer, null, function(r) {
    return t(r);
  }) : t(q6);
}
function eH(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" } }] })(e);
}
const tH = () => {
  const [e, t] = rt();
  return gt(() => {
    const i = new URLSearchParams(window.location.search).get("tags");
    i && t(i.split(","));
  }, []), e;
};
/*!
 * XRegExp 5.1.1
 * <xregexp.com>
 * Steven Levithan (c) 2007-present MIT License
 */
const ci = "xregexp", ic = {
  astral: !1,
  namespacing: !0
}, Zo = {};
let j0 = {}, Ed = {};
const Yb = [], Ld = "default", dE = "class", rH = {
  // Any native multicharacter token in default scope, or any single character
  default: /\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9]\d*|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|\(\?(?:[:=!]|<[=!])|[?*+]\?|{\d+(?:,\d*)?}\??|[\s\S]/,
  // Any native multicharacter token in character class scope, or any single character
  class: /\\(?:[0-3][0-7]{0,2}|[4-7][0-7]?|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|[\s\S]/
}, iH = /\$(?:\{([^\}]+)\}|<([^>]+)>|(\d\d?|[\s\S]?))/g, nH = /()??/.exec("")[1] === void 0, aH = /x/.flags !== void 0;
function M1(e) {
  let t = !0;
  try {
    if (new RegExp("", e), e === "y") {
      const r = (() => "gy")();
      ".a".replace(new RegExp("a", r), ".") === ".." && (t = !1);
    }
  } catch {
    t = !1;
  }
  return t;
}
const oH = M1("d"), R2 = M1("s"), X6 = M1("u"), O2 = M1("y"), Z6 = {
  d: oH,
  g: !0,
  i: !0,
  m: !0,
  s: R2,
  u: X6,
  y: O2
}, sH = R2 ? /[^dgimsuy]+/g : /[^dgimuy]+/g;
function J6(e, t, r, i, n) {
  if (e[ci] = {
    captureNames: t
  }, n)
    return e;
  if (e.__proto__)
    e.__proto__ = We.prototype;
  else
    for (const a in We.prototype)
      e[a] = We.prototype[a];
  return e[ci].source = r, e[ci].flags = i && i.split("").sort().join(""), e;
}
function g1(e) {
  return e.replace(/([\s\S])(?=[\s\S]*\1)/g, "");
}
function dc(e, t) {
  if (!We.isRegExp(e))
    throw new TypeError("Type RegExp expected");
  const r = e[ci] || {};
  let i = lH(e), n = "", a = "", o = null, s = null;
  return t = t || {}, t.removeG && (a += "g"), t.removeY && (a += "y"), a && (i = i.replace(new RegExp(`[${a}]+`, "g"), "")), t.addG && (n += "g"), t.addY && (n += "y"), n && (i = g1(i + n)), t.isInternalOnly || (r.source !== void 0 && (o = r.source), r.flags != null && (s = n ? g1(r.flags + n) : r.flags)), e = J6(
    new RegExp(t.source || e.source, i),
    uH(e) ? r.captureNames.slice(0) : null,
    o,
    s,
    t.isInternalOnly
  ), e;
}
function eA(e) {
  return parseInt(e, 16);
}
function tA(e, t, r) {
  const i = e.index + e[0].length, n = e.input[e.index - 1], a = e.input[i];
  return (
    // No need to separate tokens if at the beginning or end of a group, before or after a
    // group, or before or after a `|`
    /^[()|]$/.test(n) || /^[()|]$/.test(a) || // No need to separate tokens if at the beginning or end of the pattern
    e.index === 0 || i === e.input.length || // No need to separate tokens if at the beginning of a noncapturing group or lookaround.
    // Looks only at the last 4 chars (at most) for perf when constructing long regexes.
    /\(\?(?:[:=!]|<[=!])$/.test(e.input.substring(e.index - 4, e.index)) || // Avoid separating tokens when the following token is a quantifier
    cH(e.input, i, r) ? "" : "(?:)"
  );
}
function lH(e) {
  return aH ? e.flags : (
    // Explicitly using `RegExp.prototype.toString` (rather than e.g. `String` or concatenation
    // with an empty string) allows this to continue working predictably when
    // `XRegExp.proptotype.toString` is overridden
    /\/([a-z]*)$/i.exec(RegExp.prototype.toString.call(e))[1]
  );
}
function uH(e) {
  return !!(e[ci] && e[ci].captureNames);
}
function P2(e) {
  return parseInt(e, 10).toString(16);
}
function cH(e, t, r) {
  const i = "\\(\\?#[^)]*\\)", n = "#[^#\\n]*", a = "[?*+]|{\\d+(?:,\\d*)?}";
  return (r.includes("x") ? (
    // Ignore any leading whitespace, line comments, and inline comments
    new RegExp(`^(?:\\s|${n}|${i})*(?:${a})`)
  ) : (
    // Ignore any leading inline comments
    new RegExp(`^(?:${i})*(?:${a})`)
  )).test(e.slice(t));
}
function wg(e, t) {
  return Object.prototype.toString.call(e) === `[object ${t}]`;
}
function up(e) {
  if (e == null)
    throw new TypeError("Cannot convert null or undefined to object");
  return e;
}
function N2(e) {
  for (; e.length < 4; )
    e = `0${e}`;
  return e;
}
function dH(e, t) {
  if (g1(t) !== t)
    throw new SyntaxError(`Invalid duplicate regex flag ${t}`);
  e = e.replace(/^\(\?([\w$]+)\)/, (r, i) => {
    if (/[dgy]/.test(i))
      throw new SyntaxError(`Cannot use flags dgy in mode modifier ${r}`);
    return t = g1(t + i), "";
  });
  for (const r of t)
    if (!Z6[r])
      throw new SyntaxError(`Unknown regex flag ${r}`);
  return {
    pattern: e,
    flags: t
  };
}
function rA(e) {
  const t = {};
  return wg(e, "String") ? (We.forEach(e, /[^\s,]+/, (r) => {
    t[r] = !0;
  }), t) : e;
}
function pE(e) {
  if (!/^[\w$]$/.test(e))
    throw new Error("Flag must be a single character A-Za-z0-9_$");
  Z6[e] = !0;
}
function pH(e, t, r, i, n) {
  let a = Yb.length;
  const o = e[r];
  let s = null, l, u;
  for (; a--; )
    if (u = Yb[a], !(u.leadChar && u.leadChar !== o || u.scope !== i && u.scope !== "all" || u.flag && !t.includes(u.flag)) && (l = We.exec(e, u.regex, r, "sticky"), l)) {
      s = {
        matchLength: l[0].length,
        output: u.handler.call(n, l, i, t),
        reparse: u.reparse
      };
      break;
    }
  return s;
}
function iA(e) {
  ic.astral = e;
}
function nA(e) {
  ic.namespacing = e;
}
function We(e, t) {
  if (We.isRegExp(e)) {
    if (t !== void 0)
      throw new TypeError("Cannot supply flags when copying a RegExp");
    return dc(e);
  }
  if (e = e === void 0 ? "" : String(e), t = t === void 0 ? "" : String(t), We.isInstalled("astral") && !t.includes("A") && (t += "A"), Ed[e] || (Ed[e] = {}), !Ed[e][t]) {
    const i = {
      hasNamedCapture: !1,
      captureNames: []
    };
    let n = Ld, a = "", o = 0, s;
    const l = dH(e, t);
    let u = l.pattern;
    const d = l.flags;
    for (; o < u.length; ) {
      do
        s = pH(u, d, o, n, i), s && s.reparse && (u = u.slice(0, o) + s.output + u.slice(o + s.matchLength));
      while (s && s.reparse);
      if (s)
        a += s.output, o += s.matchLength || 1;
      else {
        const [c] = We.exec(u, rH[n], o, "sticky");
        a += c, o += c.length, c === "[" && n === Ld ? n = dE : c === "]" && n === dE && (n = Ld);
      }
    }
    Ed[e][t] = {
      // Use basic cleanup to collapse repeated empty groups like `(?:)(?:)` to `(?:)`. Empty
      // groups are sometimes inserted during regex transpilation in order to keep tokens
      // separated. However, more than one empty group in a row is never needed.
      pattern: a.replace(/(?:\(\?:\))+/g, "(?:)"),
      // Strip all but native flags
      flags: d.replace(sH, ""),
      // `context.captureNames` has an item for each capturing group, even if unnamed
      captures: i.hasNamedCapture ? i.captureNames : null
    };
  }
  const r = Ed[e][t];
  return J6(
    new RegExp(r.pattern, r.flags),
    r.captures,
    e,
    t
  );
}
We.prototype = new RegExp();
We.version = "5.1.1";
We._clipDuplicates = g1;
We._hasNativeFlag = M1;
We._dec = eA;
We._hex = P2;
We._pad4 = N2;
We.addToken = (e, t, r) => {
  r = r || {};
  let { optionalFlags: i } = r;
  if (r.flag && pE(r.flag), i) {
    i = i.split("");
    for (const n of i)
      pE(n);
  }
  Yb.push({
    regex: dc(e, {
      addG: !0,
      addY: O2,
      isInternalOnly: !0
    }),
    handler: t,
    scope: r.scope || Ld,
    flag: r.flag,
    reparse: r.reparse,
    leadChar: r.leadChar
  }), We.cache.flush("patterns");
};
We.cache = (e, t) => (j0[e] || (j0[e] = {}), j0[e][t] || (j0[e][t] = We(e, t)));
We.cache.flush = (e) => {
  e === "patterns" ? Ed = {} : j0 = {};
};
We.escape = (e) => String(up(e)).replace(/[\\\[\]{}()*+?.^$|]/g, "\\$&").replace(/[\s#\-,]/g, (t) => `\\u${N2(P2(t.charCodeAt(0)))}`);
We.exec = (e, t, r, i) => {
  let n = "g", a = !1, o = !1, s;
  a = O2 && !!(i || t.sticky && i !== !1), a ? n += "y" : i && (o = !0, n += "FakeY"), t[ci] = t[ci] || {};
  const l = t[ci][n] || (t[ci][n] = dc(t, {
    addG: !0,
    addY: a,
    source: o ? `${t.source}|()` : void 0,
    removeY: i === !1,
    isInternalOnly: !0
  }));
  return r = r || 0, l.lastIndex = r, s = Zo.exec.call(l, e), o && s && s.pop() === "" && (s = null), t.global && (t.lastIndex = s ? l.lastIndex : 0), s;
};
We.forEach = (e, t, r) => {
  let i = 0, n = -1, a;
  for (; a = We.exec(e, t, i); )
    r(a, ++n, e, t), i = a.index + (a[0].length || 1);
};
We.globalize = (e) => dc(e, { addG: !0 });
We.install = (e) => {
  e = rA(e), !ic.astral && e.astral && iA(!0), !ic.namespacing && e.namespacing && nA(!0);
};
We.isInstalled = (e) => !!ic[e];
We.isRegExp = (e) => Object.prototype.toString.call(e) === "[object RegExp]";
We.match = (e, t, r) => {
  const i = t.global && r !== "one" || r === "all", n = (i ? "g" : "") + (t.sticky ? "y" : "") || "noGY";
  t[ci] = t[ci] || {};
  const a = t[ci][n] || (t[ci][n] = dc(t, {
    addG: !!i,
    removeG: r === "one",
    isInternalOnly: !0
  })), o = String(up(e)).match(a);
  return t.global && (t.lastIndex = r === "one" && o ? (
    // Can't use `r2.lastIndex` since `r2` is nonglobal in this case
    o.index + o[0].length
  ) : 0), i ? o || [] : o && o[0];
};
We.matchChain = (e, t) => function r(i, n) {
  const a = t[n].regex ? t[n] : { regex: t[n] }, o = [];
  function s(l) {
    if (a.backref) {
      const u = `Backreference to undefined group: ${a.backref}`, d = isNaN(a.backref);
      if (d && We.isInstalled("namespacing")) {
        if (!(l.groups && a.backref in l.groups))
          throw new ReferenceError(u);
      } else if (!l.hasOwnProperty(a.backref))
        throw new ReferenceError(u);
      const c = d && We.isInstalled("namespacing") ? l.groups[a.backref] : l[a.backref];
      o.push(c || "");
    } else
      o.push(l[0]);
  }
  for (const l of i)
    We.forEach(l, a.regex, s);
  return n === t.length - 1 || !o.length ? o : r(o, n + 1);
}([e], 0);
We.replace = (e, t, r, i) => {
  const n = We.isRegExp(t), a = t.global && i !== "one" || i === "all", o = (a ? "g" : "") + (t.sticky ? "y" : "") || "noGY";
  let s = t;
  n ? (t[ci] = t[ci] || {}, s = t[ci][o] || (t[ci][o] = dc(t, {
    addG: !!a,
    removeG: i === "one",
    isInternalOnly: !0
  }))) : a && (s = new RegExp(We.escape(String(t)), "g"));
  const l = Zo.replace.call(up(e), s, r);
  return n && t.global && (t.lastIndex = 0), l;
};
We.replaceEach = (e, t) => {
  for (const r of t)
    e = We.replace(e, r[0], r[1], r[2]);
  return e;
};
We.split = (e, t, r) => Zo.split.call(up(e), t, r);
We.test = (e, t, r, i) => !!We.exec(e, t, r, i);
We.uninstall = (e) => {
  e = rA(e), ic.astral && e.astral && iA(!1), ic.namespacing && e.namespacing && nA(!1);
};
We.union = (e, t, r) => {
  r = r || {};
  const i = r.conjunction || "or";
  let n = 0, a, o;
  function s(c, p, f) {
    const g = o[n - a];
    if (p) {
      if (++n, g)
        return `(?<${g}>`;
    } else if (f)
      return `\\${+f + a}`;
    return c;
  }
  if (!(wg(e, "Array") && e.length))
    throw new TypeError("Must provide a nonempty array of patterns to merge");
  const l = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g, u = [];
  for (const c of e)
    We.isRegExp(c) ? (a = n, o = c[ci] && c[ci].captureNames || [], u.push(We(c.source).source.replace(l, s))) : u.push(We.escape(c));
  const d = i === "none" ? "" : "|";
  return We(u.join(d), t);
};
Zo.exec = function(e) {
  const t = this.lastIndex, r = RegExp.prototype.exec.apply(this, arguments);
  if (r) {
    if (!nH && r.length > 1 && r.includes("")) {
      const i = dc(this, {
        removeG: !0,
        isInternalOnly: !0
      });
      String(e).slice(r.index).replace(i, (...n) => {
        const a = n.length;
        for (let o = 1; o < a - 2; ++o)
          n[o] === void 0 && (r[o] = void 0);
      });
    }
    if (this[ci] && this[ci].captureNames) {
      let i = r;
      We.isInstalled("namespacing") && (r.groups = /* @__PURE__ */ Object.create(null), i = r.groups);
      for (let n = 1; n < r.length; ++n) {
        const a = this[ci].captureNames[n - 1];
        a && (i[a] = r[n]);
      }
    } else
      !r.groups && We.isInstalled("namespacing") && (r.groups = void 0);
    this.global && !r[0].length && this.lastIndex > r.index && (this.lastIndex = r.index);
  }
  return this.global || (this.lastIndex = t), r;
};
Zo.test = function(e) {
  return !!Zo.exec.call(this, e);
};
Zo.match = function(e) {
  if (!We.isRegExp(e))
    e = new RegExp(e);
  else if (e.global) {
    const t = String.prototype.match.apply(this, arguments);
    return e.lastIndex = 0, t;
  }
  return Zo.exec.call(e, up(this));
};
Zo.replace = function(e, t) {
  const r = We.isRegExp(e);
  let i, n, a;
  return r ? (e[ci] && ({ captureNames: n } = e[ci]), i = e.lastIndex) : e += "", wg(t, "Function") ? a = String(this).replace(e, (...o) => {
    if (n) {
      let s;
      We.isInstalled("namespacing") ? (s = /* @__PURE__ */ Object.create(null), o.push(s)) : (o[0] = new String(o[0]), [s] = o);
      for (let l = 0; l < n.length; ++l)
        n[l] && (s[n[l]] = o[l + 1]);
    }
    return t(...o);
  }) : a = String(up(this)).replace(e, (...o) => {
    return String(t).replace(iH, s);
    function s(l, u, d, c) {
      u = u || d;
      const p = wg(o[o.length - 1], "Object") ? 4 : 3, f = o.length - p;
      if (u) {
        if (/^\d+$/.test(u)) {
          const k = +u;
          if (k <= f)
            return o[k] || "";
        }
        const g = n ? n.indexOf(u) : -1;
        if (g < 0)
          throw new SyntaxError(`Backreference to undefined group ${l}`);
        return o[g + 1] || "";
      }
      if (c === "" || c === " ")
        throw new SyntaxError(`Invalid token ${l}`);
      if (c === "&" || +c == 0)
        return o[0];
      if (c === "$")
        return "$";
      if (c === "`")
        return o[o.length - 1].slice(0, o[o.length - 2]);
      if (c === "'")
        return o[o.length - 1].slice(o[o.length - 2] + o[0].length);
      if (c = +c, !isNaN(c)) {
        if (c > f)
          throw new SyntaxError(`Backreference to undefined group ${l}`);
        return o[c] || "";
      }
      throw new SyntaxError(`Invalid token ${l}`);
    }
  }), r && (e.global ? e.lastIndex = 0 : e.lastIndex = i), a;
};
Zo.split = function(e, t) {
  if (!We.isRegExp(e))
    return String.prototype.split.apply(this, arguments);
  const r = String(this), i = [], n = e.lastIndex;
  let a = 0, o;
  return t = (t === void 0 ? -1 : t) >>> 0, We.forEach(r, e, (s) => {
    s.index + s[0].length > a && (i.push(r.slice(a, s.index)), s.length > 1 && s.index < r.length && Array.prototype.push.apply(i, s.slice(1)), o = s[0].length, a = s.index + o);
  }), a === r.length ? (!e.test("") || o) && i.push("") : i.push(r.slice(a)), e.lastIndex = n, i.length > t ? i.slice(0, t) : i;
};
We.addToken(
  /\\([ABCE-RTUVXYZaeg-mopqyz]|c(?![A-Za-z])|u(?![\dA-Fa-f]{4}|{[\dA-Fa-f]+})|x(?![\dA-Fa-f]{2}))/,
  (e, t) => {
    if (e[1] === "B" && t === Ld)
      return e[0];
    throw new SyntaxError(`Invalid escape ${e[0]}`);
  },
  {
    scope: "all",
    leadChar: "\\"
  }
);
We.addToken(
  /\\u{([\dA-Fa-f]+)}/,
  (e, t, r) => {
    const i = eA(e[1]);
    if (i > 1114111)
      throw new SyntaxError(`Invalid Unicode code point ${e[0]}`);
    if (i <= 65535)
      return `\\u${N2(P2(i))}`;
    if (X6 && r.includes("u"))
      return e[0];
    throw new SyntaxError("Cannot use Unicode code point above \\u{FFFF} without flag u");
  },
  {
    scope: "all",
    leadChar: "\\"
  }
);
We.addToken(
  /\(\?#[^)]*\)/,
  tA,
  { leadChar: "(" }
);
We.addToken(
  /\s+|#[^\n]*\n?/,
  tA,
  { flag: "x" }
);
R2 || We.addToken(
  /\./,
  () => "[\\s\\S]",
  {
    flag: "s",
    leadChar: "."
  }
);
We.addToken(
  /\\k<([^>]+)>/,
  function(e) {
    const t = isNaN(e[1]) ? this.captureNames.indexOf(e[1]) + 1 : +e[1], r = e.index + e[0].length;
    if (!t || t > this.captureNames.length)
      throw new SyntaxError(`Backreference to undefined group ${e[0]}`);
    return `\\${t}${r === e.input.length || isNaN(e.input[r]) ? "" : "(?:)"}`;
  },
  { leadChar: "\\" }
);
We.addToken(
  /\\(\d+)/,
  function(e, t) {
    if (!(t === Ld && /^[1-9]/.test(e[1]) && +e[1] <= this.captureNames.length) && e[1] !== "0")
      throw new SyntaxError(`Cannot use octal escape or backreference to undefined group ${e[0]}`);
    return e[0];
  },
  {
    scope: "all",
    leadChar: "\\"
  }
);
We.addToken(
  /\(\?P?<([\p{ID_Start}$_][\p{ID_Continue}$_\u200C\u200D]*)>/u,
  function(e) {
    if (!We.isInstalled("namespacing") && (e[1] === "length" || e[1] === "__proto__"))
      throw new SyntaxError(`Cannot use reserved word as capture name ${e[0]}`);
    if (this.captureNames.includes(e[1]))
      throw new SyntaxError(`Cannot use same name for multiple groups ${e[0]}`);
    return this.captureNames.push(e[1]), this.hasNamedCapture = !0, "(";
  },
  { leadChar: "(" }
);
We.addToken(
  /\((?!\?)/,
  function(e, t, r) {
    return r.includes("n") ? "(?:" : (this.captureNames.push(null), "(");
  },
  {
    optionalFlags: "n",
    leadChar: "("
  }
);
/*!
 * XRegExp.build 5.1.1
 * <xregexp.com>
 * Steven Levithan (c) 2012-present MIT License
 */
const hH = (e) => {
  const t = "xregexp", r = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g, i = e.union([/\({{([\w$]+)}}\)|{{([\w$]+)}}/, r], "g", {
    conjunction: "or"
  });
  function n(u) {
    const d = /^(?:\(\?:\))*\^/, c = /\$(?:\(\?:\))*$/;
    return d.test(u) && c.test(u) && // Ensure that the trailing `$` isn't escaped
    c.test(u.replace(/\\[\s\S]/g, "")) ? u.replace(d, "").replace(c, "") : u;
  }
  function a(u, d) {
    const c = d ? "x" : "";
    return e.isRegExp(u) ? u[t] && u[t].captureNames ? (
      // Don't recompile, to preserve capture names
      u
    ) : (
      // Recompile as XRegExp
      e(u.source, c)
    ) : (
      // Compile string as XRegExp
      e(u, c)
    );
  }
  function o(u) {
    return u instanceof RegExp ? u : e.escape(u);
  }
  function s(u, d, c) {
    return u[`subpattern${c}`] = d, u;
  }
  function l(u, d, c) {
    const p = d < c.length - 1;
    return u + (p ? `{{subpattern${d}}}` : "");
  }
  e.tag = (u) => (d, ...c) => {
    const p = c.map(o).reduce(s, {}), f = d.raw.map(l).join("");
    return e.build(f, p, u);
  }, e.build = (u, d, c) => {
    c = c || "";
    const p = c.includes("x"), f = /^\(\?([\w$]+)\)/.exec(u);
    f && (c = e._clipDuplicates(c + f[1]));
    const g = {};
    for (const B in d)
      if (d.hasOwnProperty(B)) {
        const M = a(d[B], p);
        g[B] = {
          // Deanchoring allows embedding independently useful anchored regexes. If you
          // really need to keep your anchors, double them (i.e., `^^...$$`).
          pattern: n(M.source),
          names: M[t].captureNames || []
        };
      }
    const k = a(u, p);
    let y = 0, _, A = 0;
    const T = [0], N = k[t].captureNames || [], P = k.source.replace(i, (B, M, X, U, K) => {
      const z = M || X;
      let j, J, ie;
      if (z) {
        if (!g.hasOwnProperty(z))
          throw new ReferenceError(`Undefined property ${B}`);
        M ? (j = N[A], T[++A] = ++y, J = `(?<${j || z}>`) : J = "(?:", _ = y;
        const ue = g[z].pattern.replace(r, (de, he, Ee) => {
          if (he) {
            if (j = g[z].names[y - _], ++y, j)
              return `(?<${j}>`;
          } else if (Ee)
            return ie = +Ee - 1, g[z].names[ie] ? (
              // Need to preserve the backreference name in case using flag `n`
              `\\k<${g[z].names[ie]}>`
            ) : `\\${+Ee + _}`;
          return de;
        });
        return `${J}${ue})`;
      }
      if (U) {
        if (j = N[A], T[++A] = ++y, j)
          return `(?<${j}>`;
      } else if (K)
        return ie = +K - 1, N[ie] ? (
          // Need to preserve the backreference name in case using flag `n`
          `\\k<${N[ie]}>`
        ) : `\\${T[+K]}`;
      return B;
    });
    return e(P, c);
  };
};
/*!
 * XRegExp.matchRecursive 5.1.1
 * <xregexp.com>
 * Steven Levithan (c) 2009-present MIT License
 */
const fH = (e) => {
  function t(r, i, n, a) {
    return {
      name: r,
      value: i,
      start: n,
      end: a
    };
  }
  e.matchRecursive = (r, i, n, a, o) => {
    a = a || "", o = o || {};
    const s = a.includes("g"), l = a.includes("y"), u = a.replace(/y/g, "");
    i = e(i, u), n = e(n, u);
    let d, { escapeChar: c } = o;
    if (c) {
      if (c.length > 1)
        throw new Error("Cannot use more than one escape character");
      c = e.escape(c), d = new RegExp(
        `(?:${c}[\\S\\s]|(?:(?!${// Using `XRegExp.union` safely rewrites backreferences in `left` and `right`.
        // Intentionally not passing `basicFlags` to `XRegExp.union` since any syntax
        // transformation resulting from those flags was already applied to `left` and
        // `right` when they were passed through the XRegExp constructor above.
        e.union([i, n], "", { conjunction: "or" }).source})[^${c}])+)+`,
        // Flags `dgy` not needed here
        a.replace(e._hasNativeFlag("s") ? /[^imsu]/g : /[^imu]/g, "")
      );
    }
    let p = 0, f = 0, g = 0, k = 0, y, _, A, T;
    const N = o.valueNames, P = [];
    for (; ; ) {
      if (c && (g += (e.exec(r, d, g, "sticky") || [""])[0].length), A = e.exec(r, i, g), T = e.exec(r, n, g), A && T && (A.index <= T.index ? T = null : A = null), A || T)
        f = (A || T).index, g = f + (A || T)[0].length;
      else if (!p)
        break;
      if (l && !p && f > k)
        break;
      if (A)
        p || (y = f, _ = g), p += 1;
      else if (T && p) {
        if (p -= 1, !p && (N ? (N[0] && y > k && P.push(t(N[0], r.slice(k, y), k, y)), N[1] && P.push(t(N[1], r.slice(y, _), y, _)), N[2] && P.push(t(N[2], r.slice(_, f), _, f)), N[3] && P.push(t(N[3], r.slice(f, g), f, g))) : P.push(r.slice(_, f)), k = g, !s))
          break;
      } else {
        const B = o.unbalanced || "error";
        if (B === "skip" || B === "skip-lazy")
          if (T)
            T = null;
          else {
            if (B === "skip") {
              const M = e.exec(r, i, y, "sticky")[0].length;
              g = y + (M || 1);
            } else
              g = y + 1;
            p = 0;
          }
        else if (B === "error") {
          const M = T ? "right" : "left", X = T ? f : y;
          throw new Error(`Unbalanced ${M} delimiter found in string at position ${X}`);
        } else
          throw new Error(`Unsupported value for unbalanced: ${B}`);
      }
      f === g && (g += 1);
    }
    return s && P.length > 0 && !l && N && N[0] && r.length > k && P.push(t(N[0], r.slice(k), k, r.length)), P;
  };
};
/*!
 * XRegExp Unicode Base 5.1.1
 * <xregexp.com>
 * Steven Levithan (c) 2008-present MIT License
 */
const gH = (e) => {
  const t = {}, r = {}, i = e._dec, n = e._hex, a = e._pad4;
  function o(p) {
    return p.replace(/[- _]+/g, "").toLowerCase();
  }
  function s(p) {
    const f = /^\\[xu](.+)/.exec(p);
    return f ? i(f[1]) : p.charCodeAt(p[0] === "\\" ? 1 : 0);
  }
  function l(p) {
    let f = "", g = -1;
    return e.forEach(
      p,
      /(\\x..|\\u....|\\?[\s\S])(?:-(\\x..|\\u....|\\?[\s\S]))?/,
      (k) => {
        const y = s(k[1]);
        y > g + 1 && (f += `\\u${a(n(g + 1))}`, y > g + 2 && (f += `-\\u${a(n(y - 1))}`)), g = s(k[2] || k[1]);
      }
    ), g < 65535 && (f += `\\u${a(n(g + 1))}`, g < 65534 && (f += "-\\uFFFF")), f;
  }
  function u(p) {
    const f = "b!";
    return t[p][f] || (t[p][f] = l(t[p].bmp));
  }
  function d(p, f) {
    const g = t[p];
    let k = "";
    return g.bmp && !g.isBmpLast && (k = `[${g.bmp}]${g.astral ? "|" : ""}`), g.astral && (k += g.astral), g.isBmpLast && g.bmp && (k += `${g.astral ? "|" : ""}[${g.bmp}]`), f ? `(?:(?!${k})(?:[\uD800-\uDBFF][\uDC00-\uDFFF]|[\0-￿]))` : `(?:${k})`;
  }
  function c(p, f) {
    const g = f ? "a!" : "a=";
    return t[p][g] || (t[p][g] = d(p, f));
  }
  e.addToken(
    // Use `*` instead of `+` to avoid capturing `^` as the token name in `\p{^}`
    /\\([pP])(?:{(\^?)(?:(\w+)=)?([^}]*)}|([A-Za-z]))/,
    (p, f, g) => {
      const k = "Invalid double negation ", y = "Unknown Unicode token ", _ = "Unicode token missing data ", A = "Astral mode required for Unicode token ", T = "Astral mode does not support Unicode tokens within character classes", [
        N,
        P,
        B,
        M,
        X,
        U
      ] = p;
      let K = P === "P" || !!B;
      const z = g.includes("A");
      let j = o(U || X), J = t[j];
      if (P === "P" && B)
        throw new SyntaxError(k + N);
      if (!t.hasOwnProperty(j))
        throw new SyntaxError(y + N);
      if (M && !(r[M] && r[M][j]))
        throw new SyntaxError(y + N);
      if (J.inverseOf) {
        if (j = o(J.inverseOf), !t.hasOwnProperty(j))
          throw new ReferenceError(`${_ + N} -> ${J.inverseOf}`);
        J = t[j], K = !K;
      }
      if (!(J.bmp || z))
        throw new SyntaxError(A + N);
      if (z) {
        if (f === "class")
          throw new SyntaxError(T);
        return c(j, K);
      }
      return f === "class" ? K ? u(j) : J.bmp : `${(K ? "[^" : "[") + J.bmp}]`;
    },
    {
      scope: "all",
      optionalFlags: "A",
      leadChar: "\\"
    }
  ), e.addUnicodeData = (p, f) => {
    const g = "Unicode token requires name", k = "Unicode token has no character data ";
    f && (r[f] = {});
    for (const y of p) {
      if (!y.name)
        throw new Error(g);
      if (!(y.inverseOf || y.bmp || y.astral))
        throw new Error(k + y.name);
      const _ = o(y.name);
      if (t[_] = y, f && (r[f][_] = !0), y.alias) {
        const A = o(y.alias);
        t[A] = y, f && (r[f][A] = !0);
      }
    }
    e.cache.flush("patterns");
  }, e._getUnicodeProperty = (p) => {
    const f = o(p);
    return t[f];
  };
};
var mH = [
  {
    name: "C",
    alias: "Other",
    isBmpLast: !0,
    bmp: "\0--­͸͹΀-΃΋΍΢԰՗՘֋֌֐׈-׏׫-׮׵-؅؜۝܎܏݋݌޲-޿߻߼࠮࠯࠿࡜࡝࡟࡫-࡯࢏-ࢗ࣢঄঍঎঑঒঩঱঳-঵঺঻৅৆৉৊৏-৖৘-৛৞৤৥৿਀਄਋-਎਑਒਩਱਴਷਺਻਽੃-੆੉੊੎-੐੒-੘੝੟-੥੷-઀઄઎઒઩઱઴઺઻૆૊૎૏૑-૟૤૥૲-૸଀଄଍଎଑଒଩଱଴଺଻୅୆୉୊୎-୔୘-୛୞୤୥୸-஁஄஋-஍஑஖-஘஛஝஠-஢஥-஧஫-஭஺-஽௃-௅௉௎௏௑-௖௘-௥௻-௿఍఑఩఺఻౅౉౎-౔౗౛౜౞౟౤౥౰-౶಍಑಩಴಺಻೅೉೎-೔೗-೜೟೤೥೰ೳ-೿഍഑൅൉൐-൓൤൥඀඄඗-඙඲඼඾඿෇-෉෋-෎෕෗෠-෥෰෱෵-฀฻-฾๜-຀຃຅຋຤຦຾຿໅໇໎໏໚໛໠-໿཈཭-཰྘྽࿍࿛-࿿჆჈-჌჎჏቉቎቏቗቙቞቟኉኎኏኱኶኷኿዁዆዇዗጑጖጗፛፜፽-፿᎚-᎟᏶᏷᏾᏿᚝-᚟᛹-᛿᜖-᜞᜷-᜿᝔-᝟᝭᝱᝴-᝿៞៟៪-៯៺-៿᠎᠚-᠟᡹-᡿᢫-᢯᣶-᣿᤟᤬-᤯᤼-᤿᥁-᥃᥮᥯᥵-᥿᦬-᦯᧊-᧏᧛-᧝᨜᨝᩟᩽᩾᪊-᪏᪚-᪟᪮᪯᫏-᫿᭍-᭏᭿᯴-᯻᰸-᰺᱊-᱌Ᲊ-᲏᲻᲼᳈-᳏᳻-᳿἖἗἞἟὆὇὎὏὘὚὜὞὾὿᾵῅῔῕῜῰῱῵῿​-‏‪-‮⁠-⁯⁲⁳₏₝-₟⃁-⃏⃱-⃿↌-↏␧-␿⑋-⑟⭴⭵⮖⳴-⳸⴦⴨-⴬⴮⴯⵨-⵮⵱-⵾⶗-⶟⶧⶯⶷⶿⷇⷏⷗⷟⹞-⹿⺚⻴-⻿⿖-⿯⿼-⿿぀゗゘㄀-㄄㄰㆏㇤-㇯㈟꒍-꒏꓇-꓏꘬-꘿꛸-꛿Ɤ-꟏꟒꟔Ꟛ-꟱꠭-꠯꠺-꠿꡸-꡿꣆-꣍꣚-꣟꥔-꥞꥽-꥿꧎꧚-꧝꧿꨷-꨿꩎꩏꩚꩛꫃-꫚꫷-꬀꬇꬈꬏꬐꬗-꬟꬧꬯꭬-꭯꯮꯯꯺-꯿힤-힯퟇-퟊퟼-﩮﩯﫚-﫿﬇-﬒﬘-﬜﬷﬽﬿﭂﭅﯃-﯒﶐﶑﷈-﷎﷐-﷯︚-︟﹓﹧﹬-﹯﹵﻽-＀﾿-￁￈￉￐￑￘￙￝-￟￧￯-￻￾￿",
    astral: "\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8F\uDD9D-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2C\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD7B\uDD8B\uDD93\uDD96\uDDA2\uDDB2\uDDBA\uDDBD-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDF7F\uDF86\uDFB1\uDFBB-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE36\uDE37\uDE3B-\uDE3E\uDE49-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD28-\uDD2F\uDD3A-\uDE5F\uDE7F\uDEAA\uDEAE\uDEAF\uDEB2-\uDEFF\uDF28-\uDF2F\uDF5A-\uDF6F\uDF8A-\uDFAF\uDFCC-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC76-\uDC7E\uDCBD\uDCC3-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD48-\uDD4F\uDD77-\uDD7F\uDDE0\uDDF5-\uDDFF\uDE12\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC5C\uDC62-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE5F\uDE6D-\uDE7F\uDEBA-\uDEBF\uDECA-\uDEFF\uDF1B\uDF1C\uDF2C-\uDF2F\uDF47-\uDFFF]|\uD806[\uDC3C-\uDC9F\uDCF3-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD36\uDD39\uDD3A\uDD47-\uDD4F\uDD5A-\uDD9F\uDDA8\uDDA9\uDDD8\uDDD9\uDDE5-\uDDFF\uDE48-\uDE4F\uDEA3-\uDEAF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC46-\uDC4F\uDC6D-\uDC6F\uDC90\uDC91\uDCA8\uDCB7-\uDCFF\uDD07\uDD0A\uDD37-\uDD39\uDD3B\uDD3E\uDD48-\uDD4F\uDD5A-\uDD5F\uDD66\uDD69\uDD8F\uDD92\uDD99-\uDD9F\uDDAA-\uDEDF\uDEF9-\uDFAF\uDFB1-\uDFBF\uDFF2-\uDFFE]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80E-\uD810\uD812-\uD819\uD824-\uD82A\uD82D\uD82E\uD830-\uD832\uD83F\uD87B-\uD87D\uD87F\uD885-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD80B[\uDC00-\uDF8F\uDFF3-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDEBF\uDECA-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDE3F\uDE9B-\uDEFF\uDF4B-\uDF4E\uDF88-\uDF8E\uDFA0-\uDFDF\uDFE5-\uDFEF\uDFF2-\uDFFF]|\uD821[\uDFF8-\uDFFF]|\uD823[\uDCD6-\uDCFF\uDD09-\uDFFF]|\uD82B[\uDC00-\uDFEF\uDFF4\uDFFC\uDFFF]|\uD82C[\uDD23-\uDD4F\uDD53-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA0-\uDFFF]|\uD833[\uDC00-\uDEFF\uDF2E\uDF2F\uDF47-\uDF4F\uDFC4-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDD73-\uDD7A\uDDEB-\uDDFF\uDE46-\uDEDF\uDEF4-\uDEFF\uDF57-\uDF5F\uDF79-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD837[\uDC00-\uDEFF\uDF1F-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDCFF\uDD2D-\uDD2F\uDD3E\uDD3F\uDD4A-\uDD4D\uDD50-\uDE8F\uDEAF-\uDEBF\uDEFA-\uDEFE\uDF00-\uDFFF]|\uD839[\uDC00-\uDFDF\uDFE7\uDFEC\uDFEF\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDCFF\uDD4C-\uDD4F\uDD5A-\uDD5D\uDD60-\uDFFF]|\uD83B[\uDC00-\uDC70\uDCB5-\uDD00\uDD3E-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDDAE-\uDDE5\uDE03-\uDE0F\uDE3C-\uDE3F\uDE49-\uDE4F\uDE52-\uDE5F\uDE66-\uDEFF]|\uD83D[\uDED8-\uDEDC\uDEED-\uDEEF\uDEFD-\uDEFF\uDF74-\uDF7F\uDFD9-\uDFDF\uDFEC-\uDFEF\uDFF1-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE\uDCAF\uDCB2-\uDCFF\uDE54-\uDE5F\uDE6E\uDE6F\uDE75-\uDE77\uDE7D-\uDE7F\uDE87-\uDE8F\uDEAD-\uDEAF\uDEBB-\uDEBF\uDEC6-\uDECF\uDEDA-\uDEDF\uDEE8-\uDEEF\uDEF7-\uDEFF\uDF93\uDFCB-\uDFEF\uDFFA-\uDFFF]|\uD869[\uDEE0-\uDEFF]|\uD86D[\uDF39-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]"
  },
  {
    name: "Cc",
    alias: "Control",
    bmp: "\0--"
  },
  {
    name: "Cf",
    alias: "Format",
    bmp: "­؀-؅؜۝܏࢐࢑࣢᠎​-‏‪-‮⁠-⁤⁦-⁯\uFEFF￹-￻",
    astral: "\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC38]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]"
  },
  {
    name: "Cn",
    alias: "Unassigned",
    bmp: "͸͹΀-΃΋΍΢԰՗՘֋֌֐׈-׏׫-׮׵-׿܎݋݌޲-޿߻߼࠮࠯࠿࡜࡝࡟࡫-࡯࢏࢒-ࢗ঄঍঎঑঒঩঱঳-঵঺঻৅৆৉৊৏-৖৘-৛৞৤৥৿਀਄਋-਎਑਒਩਱਴਷਺਻਽੃-੆੉੊੎-੐੒-੘੝੟-੥੷-઀઄઎઒઩઱઴઺઻૆૊૎૏૑-૟૤૥૲-૸଀଄଍଎଑଒଩଱଴଺଻୅୆୉୊୎-୔୘-୛୞୤୥୸-஁஄஋-஍஑஖-஘஛஝஠-஢஥-஧஫-஭஺-஽௃-௅௉௎௏௑-௖௘-௥௻-௿఍఑఩఺఻౅౉౎-౔౗౛౜౞౟౤౥౰-౶಍಑಩಴಺಻೅೉೎-೔೗-೜೟೤೥೰ೳ-೿഍഑൅൉൐-൓൤൥඀඄඗-඙඲඼඾඿෇-෉෋-෎෕෗෠-෥෰෱෵-฀฻-฾๜-຀຃຅຋຤຦຾຿໅໇໎໏໚໛໠-໿཈཭-཰྘྽࿍࿛-࿿჆჈-჌჎჏቉቎቏቗቙቞቟኉኎኏኱኶኷኿዁዆዇዗጑጖጗፛፜፽-፿᎚-᎟᏶᏷᏾᏿᚝-᚟᛹-᛿᜖-᜞᜷-᜿᝔-᝟᝭᝱᝴-᝿៞៟៪-៯៺-៿᠚-᠟᡹-᡿᢫-᢯᣶-᣿᤟᤬-᤯᤼-᤿᥁-᥃᥮᥯᥵-᥿᦬-᦯᧊-᧏᧛-᧝᨜᨝᩟᩽᩾᪊-᪏᪚-᪟᪮᪯᫏-᫿᭍-᭏᭿᯴-᯻᰸-᰺᱊-᱌Ᲊ-᲏᲻᲼᳈-᳏᳻-᳿἖἗἞἟὆὇὎὏὘὚὜὞὾὿᾵῅῔῕῜῰῱῵῿⁥⁲⁳₏₝-₟⃁-⃏⃱-⃿↌-↏␧-␿⑋-⑟⭴⭵⮖⳴-⳸⴦⴨-⴬⴮⴯⵨-⵮⵱-⵾⶗-⶟⶧⶯⶷⶿⷇⷏⷗⷟⹞-⹿⺚⻴-⻿⿖-⿯⿼-⿿぀゗゘㄀-㄄㄰㆏㇤-㇯㈟꒍-꒏꓇-꓏꘬-꘿꛸-꛿Ɤ-꟏꟒꟔Ꟛ-꟱꠭-꠯꠺-꠿꡸-꡿꣆-꣍꣚-꣟꥔-꥞꥽-꥿꧎꧚-꧝꧿꨷-꨿꩎꩏꩚꩛꫃-꫚꫷-꬀꬇꬈꬏꬐꬗-꬟꬧꬯꭬-꭯꯮꯯꯺-꯿힤-힯퟇-퟊퟼-퟿﩮﩯﫚-﫿﬇-﬒﬘-﬜﬷﬽﬿﭂﭅﯃-﯒﶐﶑﷈-﷎﷐-﷯︚-︟﹓﹧﹬-﹯﹵﻽﻾＀﾿-￁￈￉￐￑￘￙￝-￟￧￯-￸￾￿",
    astral: "\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8F\uDD9D-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2C\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD7B\uDD8B\uDD93\uDD96\uDDA2\uDDB2\uDDBA\uDDBD-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDF7F\uDF86\uDFB1\uDFBB-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE36\uDE37\uDE3B-\uDE3E\uDE49-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD28-\uDD2F\uDD3A-\uDE5F\uDE7F\uDEAA\uDEAE\uDEAF\uDEB2-\uDEFF\uDF28-\uDF2F\uDF5A-\uDF6F\uDF8A-\uDFAF\uDFCC-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC76-\uDC7E\uDCC3-\uDCCC\uDCCE\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD48-\uDD4F\uDD77-\uDD7F\uDDE0\uDDF5-\uDDFF\uDE12\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC5C\uDC62-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE5F\uDE6D-\uDE7F\uDEBA-\uDEBF\uDECA-\uDEFF\uDF1B\uDF1C\uDF2C-\uDF2F\uDF47-\uDFFF]|\uD806[\uDC3C-\uDC9F\uDCF3-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD36\uDD39\uDD3A\uDD47-\uDD4F\uDD5A-\uDD9F\uDDA8\uDDA9\uDDD8\uDDD9\uDDE5-\uDDFF\uDE48-\uDE4F\uDEA3-\uDEAF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC46-\uDC4F\uDC6D-\uDC6F\uDC90\uDC91\uDCA8\uDCB7-\uDCFF\uDD07\uDD0A\uDD37-\uDD39\uDD3B\uDD3E\uDD48-\uDD4F\uDD5A-\uDD5F\uDD66\uDD69\uDD8F\uDD92\uDD99-\uDD9F\uDDAA-\uDEDF\uDEF9-\uDFAF\uDFB1-\uDFBF\uDFF2-\uDFFE]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80E-\uD810\uD812-\uD819\uD824-\uD82A\uD82D\uD82E\uD830-\uD832\uD83F\uD87B-\uD87D\uD87F\uD885-\uDB3F\uDB41-\uDB7F][\uDC00-\uDFFF]|\uD80B[\uDC00-\uDF8F\uDFF3-\uDFFF]|\uD80D[\uDC2F\uDC39-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDEBF\uDECA-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDE3F\uDE9B-\uDEFF\uDF4B-\uDF4E\uDF88-\uDF8E\uDFA0-\uDFDF\uDFE5-\uDFEF\uDFF2-\uDFFF]|\uD821[\uDFF8-\uDFFF]|\uD823[\uDCD6-\uDCFF\uDD09-\uDFFF]|\uD82B[\uDC00-\uDFEF\uDFF4\uDFFC\uDFFF]|\uD82C[\uDD23-\uDD4F\uDD53-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA4-\uDFFF]|\uD833[\uDC00-\uDEFF\uDF2E\uDF2F\uDF47-\uDF4F\uDFC4-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDDEB-\uDDFF\uDE46-\uDEDF\uDEF4-\uDEFF\uDF57-\uDF5F\uDF79-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD837[\uDC00-\uDEFF\uDF1F-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDCFF\uDD2D-\uDD2F\uDD3E\uDD3F\uDD4A-\uDD4D\uDD50-\uDE8F\uDEAF-\uDEBF\uDEFA-\uDEFE\uDF00-\uDFFF]|\uD839[\uDC00-\uDFDF\uDFE7\uDFEC\uDFEF\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDCFF\uDD4C-\uDD4F\uDD5A-\uDD5D\uDD60-\uDFFF]|\uD83B[\uDC00-\uDC70\uDCB5-\uDD00\uDD3E-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDDAE-\uDDE5\uDE03-\uDE0F\uDE3C-\uDE3F\uDE49-\uDE4F\uDE52-\uDE5F\uDE66-\uDEFF]|\uD83D[\uDED8-\uDEDC\uDEED-\uDEEF\uDEFD-\uDEFF\uDF74-\uDF7F\uDFD9-\uDFDF\uDFEC-\uDFEF\uDFF1-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE\uDCAF\uDCB2-\uDCFF\uDE54-\uDE5F\uDE6E\uDE6F\uDE75-\uDE77\uDE7D-\uDE7F\uDE87-\uDE8F\uDEAD-\uDEAF\uDEBB-\uDEBF\uDEC6-\uDECF\uDEDA-\uDEDF\uDEE8-\uDEEF\uDEF7-\uDEFF\uDF93\uDFCB-\uDFEF\uDFFA-\uDFFF]|\uD869[\uDEE0-\uDEFF]|\uD86D[\uDF39-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDFFF]|\uDB40[\uDC00\uDC02-\uDC1F\uDC80-\uDCFF\uDDF0-\uDFFF]|[\uDBBF\uDBFF][\uDFFE\uDFFF]"
  },
  {
    name: "Co",
    alias: "Private_Use",
    bmp: "-",
    astral: "[\uDB80-\uDBBE\uDBC0-\uDBFE][\uDC00-\uDFFF]|[\uDBBF\uDBFF][\uDC00-\uDFFD]"
  },
  {
    name: "Cs",
    alias: "Surrogate",
    bmp: "\uD800-\uDFFF"
  },
  {
    name: "L",
    alias: "Letter",
    bmp: "A-Za-zªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛱ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢄᢇ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎↃↄⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々〆〱-〵〻〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛥꜗ-ꜟꜢ-ꞈꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
    astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]"
  },
  {
    name: "LC",
    alias: "Cased_Letter",
    bmp: "A-Za-zµÀ-ÖØ-öø-ƺƼ-ƿǄ-ʓʕ-ʯͰ-ͳͶͷͻ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՠ-ֈႠ-ჅჇჍა-ჺჽ-ჿᎠ-Ᏽᏸ-ᏽᲀ-ᲈᲐ-ᲺᲽ-Ჿᴀ-ᴫᵫ-ᵷᵹ-ᶚḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℴℹℼ-ℿⅅ-ⅉⅎↃↄⰀ-ⱻⱾ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭꙀ-ꙭꚀ-ꚛꜢ-ꝯꝱ-ꞇꞋ-ꞎꞐ-ꟊꟐꟑꟓꟕ-ꟙꟵꟶꟺꬰ-ꭚꭠ-ꭨꭰ-ꮿﬀ-ﬆﬓ-ﬗＡ-Ｚａ-ｚ",
    astral: "\uD801[\uDC00-\uDC4F\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC]|\uD803[\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD806[\uDCA0-\uDCDF]|\uD81B[\uDE40-\uDE7F]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF09\uDF0B-\uDF1E]|\uD83A[\uDD00-\uDD43]"
  },
  {
    name: "Ll",
    alias: "Lowercase_Letter",
    bmp: "a-zµß-öø-ÿāăąćĉċčďđēĕėęěĝğġģĥħĩīĭįıĳĵķĸĺļľŀłńņňŉŋōŏőœŕŗřśŝşšţťŧũūŭůűųŵŷźżž-ƀƃƅƈƌƍƒƕƙ-ƛƞơƣƥƨƪƫƭưƴƶƹƺƽ-ƿǆǉǌǎǐǒǔǖǘǚǜǝǟǡǣǥǧǩǫǭǯǰǳǵǹǻǽǿȁȃȅȇȉȋȍȏȑȓȕȗșțȝȟȡȣȥȧȩȫȭȯȱȳ-ȹȼȿɀɂɇɉɋɍɏ-ʓʕ-ʯͱͳͷͻ-ͽΐά-ώϐϑϕ-ϗϙϛϝϟϡϣϥϧϩϫϭϯ-ϳϵϸϻϼа-џѡѣѥѧѩѫѭѯѱѳѵѷѹѻѽѿҁҋҍҏґғҕҗҙқҝҟҡңҥҧҩҫҭүұҳҵҷҹһҽҿӂӄӆӈӊӌӎӏӑӓӕӗәӛӝӟӡӣӥӧөӫӭӯӱӳӵӷӹӻӽӿԁԃԅԇԉԋԍԏԑԓԕԗԙԛԝԟԡԣԥԧԩԫԭԯՠ-ֈა-ჺჽ-ჿᏸ-ᏽᲀ-ᲈᴀ-ᴫᵫ-ᵷᵹ-ᶚḁḃḅḇḉḋḍḏḑḓḕḗḙḛḝḟḡḣḥḧḩḫḭḯḱḳḵḷḹḻḽḿṁṃṅṇṉṋṍṏṑṓṕṗṙṛṝṟṡṣṥṧṩṫṭṯṱṳṵṷṹṻṽṿẁẃẅẇẉẋẍẏẑẓẕ-ẝẟạảấầẩẫậắằẳẵặẹẻẽếềểễệỉịọỏốồổỗộớờởỡợụủứừửữựỳỵỷỹỻỽỿ-ἇἐ-ἕἠ-ἧἰ-ἷὀ-ὅὐ-ὗὠ-ὧὰ-ώᾀ-ᾇᾐ-ᾗᾠ-ᾧᾰ-ᾴᾶᾷιῂ-ῄῆῇῐ-ΐῖῗῠ-ῧῲ-ῴῶῷℊℎℏℓℯℴℹℼℽⅆ-ⅉⅎↄⰰ-ⱟⱡⱥⱦⱨⱪⱬⱱⱳⱴⱶ-ⱻⲁⲃⲅⲇⲉⲋⲍⲏⲑⲓⲕⲗⲙⲛⲝⲟⲡⲣⲥⲧⲩⲫⲭⲯⲱⲳⲵⲷⲹⲻⲽⲿⳁⳃⳅⳇⳉⳋⳍⳏⳑⳓⳕⳗⳙⳛⳝⳟⳡⳣⳤⳬⳮⳳⴀ-ⴥⴧⴭꙁꙃꙅꙇꙉꙋꙍꙏꙑꙓꙕꙗꙙꙛꙝꙟꙡꙣꙥꙧꙩꙫꙭꚁꚃꚅꚇꚉꚋꚍꚏꚑꚓꚕꚗꚙꚛꜣꜥꜧꜩꜫꜭꜯ-ꜱꜳꜵꜷꜹꜻꜽꜿꝁꝃꝅꝇꝉꝋꝍꝏꝑꝓꝕꝗꝙꝛꝝꝟꝡꝣꝥꝧꝩꝫꝭꝯꝱ-ꝸꝺꝼꝿꞁꞃꞅꞇꞌꞎꞑꞓ-ꞕꞗꞙꞛꞝꞟꞡꞣꞥꞧꞩꞯꞵꞷꞹꞻꞽꞿꟁꟃꟈꟊꟑꟓꟕꟗꟙꟶꟺꬰ-ꭚꭠ-ꭨꭰ-ꮿﬀ-ﬆﬓ-ﬗａ-ｚ",
    astral: "\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC]|\uD803[\uDCC0-\uDCF2]|\uD806[\uDCC0-\uDCDF]|\uD81B[\uDE60-\uDE7F]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD837[\uDF00-\uDF09\uDF0B-\uDF1E]|\uD83A[\uDD22-\uDD43]"
  },
  {
    name: "Lm",
    alias: "Modifier_Letter",
    bmp: "ʰ-ˁˆ-ˑˠ-ˤˬˮʹͺՙـۥۦߴߵߺࠚࠤࠨࣉॱๆໆჼៗᡃᪧᱸ-ᱽᴬ-ᵪᵸᶛ-ᶿⁱⁿₐ-ₜⱼⱽⵯⸯ々〱-〵〻ゝゞー-ヾꀕꓸ-ꓽꘌꙿꚜꚝꜗ-ꜟꝰꞈꟲ-ꟴꟸꟹꧏꧦꩰꫝꫳꫴꭜ-ꭟꭩｰﾞﾟ",
    astral: "\uD801[\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD81A[\uDF40-\uDF43]|\uD81B[\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD838[\uDD37-\uDD3D]|𞥋"
  },
  {
    name: "Lo",
    alias: "Other_Letter",
    bmp: "ªºƻǀ-ǃʔא-תׯ-ײؠ-ؿف-يٮٯٱ-ۓەۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪࠀ-ࠕࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣈऄ-हऽॐक़-ॡॲ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๅກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎᄀ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛱ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៜᠠ-ᡂᡄ-ᡸᢀ-ᢄᢇ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱷᳩ-ᳬᳮ-ᳳᳵᳶᳺℵ-ℸⴰ-ⵧⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ〆〼ぁ-ゖゟァ-ヺヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꀔꀖ-ꒌꓐ-ꓷꔀ-ꘋꘐ-ꘟꘪꘫꙮꚠ-ꛥꞏꟷꟻ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧠ-ꧤꧧ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩯꩱ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛꫜꫠ-ꫪꫲꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎יִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼｦ-ｯｱ-ﾝﾠ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
    astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC50-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF4A\uDF50]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|𝼊|\uD838[\uDD00-\uDD2C\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]"
  },
  {
    name: "Lt",
    alias: "Titlecase_Letter",
    bmp: "ǅǈǋǲᾈ-ᾏᾘ-ᾟᾨ-ᾯᾼῌῼ"
  },
  {
    name: "Lu",
    alias: "Uppercase_Letter",
    bmp: "A-ZÀ-ÖØ-ÞĀĂĄĆĈĊČĎĐĒĔĖĘĚĜĞĠĢĤĦĨĪĬĮİĲĴĶĹĻĽĿŁŃŅŇŊŌŎŐŒŔŖŘŚŜŞŠŢŤŦŨŪŬŮŰŲŴŶŸŹŻŽƁƂƄƆƇƉ-ƋƎ-ƑƓƔƖ-ƘƜƝƟƠƢƤƦƧƩƬƮƯƱ-ƳƵƷƸƼǄǇǊǍǏǑǓǕǗǙǛǞǠǢǤǦǨǪǬǮǱǴǶ-ǸǺǼǾȀȂȄȆȈȊȌȎȐȒȔȖȘȚȜȞȠȢȤȦȨȪȬȮȰȲȺȻȽȾɁɃ-ɆɈɊɌɎͰͲͶͿΆΈ-ΊΌΎΏΑ-ΡΣ-ΫϏϒ-ϔϘϚϜϞϠϢϤϦϨϪϬϮϴϷϹϺϽ-ЯѠѢѤѦѨѪѬѮѰѲѴѶѸѺѼѾҀҊҌҎҐҒҔҖҘҚҜҞҠҢҤҦҨҪҬҮҰҲҴҶҸҺҼҾӀӁӃӅӇӉӋӍӐӒӔӖӘӚӜӞӠӢӤӦӨӪӬӮӰӲӴӶӸӺӼӾԀԂԄԆԈԊԌԎԐԒԔԖԘԚԜԞԠԢԤԦԨԪԬԮԱ-ՖႠ-ჅჇჍᎠ-ᏵᲐ-ᲺᲽ-ᲿḀḂḄḆḈḊḌḎḐḒḔḖḘḚḜḞḠḢḤḦḨḪḬḮḰḲḴḶḸḺḼḾṀṂṄṆṈṊṌṎṐṒṔṖṘṚṜṞṠṢṤṦṨṪṬṮṰṲṴṶṸṺṼṾẀẂẄẆẈẊẌẎẐẒẔẞẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼẾỀỂỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪỬỮỰỲỴỶỸỺỼỾἈ-ἏἘ-ἝἨ-ἯἸ-ἿὈ-ὍὙὛὝὟὨ-ὯᾸ-ΆῈ-ΉῘ-ΊῨ-ῬῸ-Ώℂℇℋ-ℍℐ-ℒℕℙ-ℝℤΩℨK-ℭℰ-ℳℾℿⅅↃⰀ-ⰯⱠⱢ-ⱤⱧⱩⱫⱭ-ⱰⱲⱵⱾ-ⲀⲂⲄⲆⲈⲊⲌⲎⲐⲒⲔⲖⲘⲚⲜⲞⲠⲢⲤⲦⲨⲪⲬⲮⲰⲲⲴⲶⲸⲺⲼⲾⳀⳂⳄⳆⳈⳊⳌⳎⳐⳒⳔⳖⳘⳚⳜⳞⳠⳢⳫⳭⳲꙀꙂꙄꙆꙈꙊꙌꙎꙐꙒꙔꙖꙘꙚꙜꙞꙠꙢꙤꙦꙨꙪꙬꚀꚂꚄꚆꚈꚊꚌꚎꚐꚒꚔꚖꚘꚚꜢꜤꜦꜨꜪꜬꜮꜲꜴꜶꜸꜺꜼꜾꝀꝂꝄꝆꝈꝊꝌꝎꝐꝒꝔꝖꝘꝚꝜꝞꝠꝢꝤꝦꝨꝪꝬꝮꝹꝻꝽꝾꞀꞂꞄꞆꞋꞍꞐꞒꞖꞘꞚꞜꞞꞠꞢꞤꞦꞨꞪ-ꞮꞰ-ꞴꞶꞸꞺꞼꞾꟀꟂꟄ-ꟇꟉꟐꟖꟘꟵＡ-Ｚ",
    astral: "\uD801[\uDC00-\uDC27\uDCB0-\uDCD3\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD81B[\uDE40-\uDE5F]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21]"
  },
  {
    name: "M",
    alias: "Mark",
    bmp: "̀-ͯ҃-҉֑-ׇֽֿׁׂׅׄؐ-ًؚ-ٰٟۖ-ۜ۟-۪ۤۧۨ-ܑۭܰ-݊ަ-ް߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࢘-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣঁ-ঃ়া-ৄেৈো-্ৗৢৣ৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑੰੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣஂா-ூெ-ைொ-்ௗఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣඁ-ඃ්ා-ුූෘ-ෟෲෳัิ-ฺ็-๎ັິ-ຼ່-ໍ༹༘༙༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏႚ-ႝ፝-፟ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝᠋-᠍᠏ᢅᢆᢩᤠ-ᤫᤰ-᤻ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼᪰-ᫎᬀ-ᬄ᬴-᭄᭫-᭳ᮀ-ᮂᮡ-ᮭ᯦-᯳ᰤ-᰷᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿⃐-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯꙯-꙲ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣠-꣱ꣿꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀ꧥꨩ-ꨶꩃꩌꩍꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭ﬞ︀-️︠-︯",
    astral: "\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC82\uDCB0-\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD34\uDD45\uDD46\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDC9-\uDDCC\uDDCE\uDDCF\uDE2C-\uDE37\uDE3E\uDEDF-\uDEEA\uDF00-\uDF03\uDF3B\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC35-\uDC46\uDC5E\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD806[\uDC2C-\uDC3A\uDD30-\uDD35\uDD37\uDD38\uDD3B-\uDD3E\uDD40\uDD42\uDD43\uDDD1-\uDDD7\uDDDA-\uDDE0\uDDE4\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE3E\uDE47\uDE51-\uDE5B\uDE8A-\uDE99]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD8A-\uDD8E\uDD90\uDD91\uDD93-\uDD97\uDEF3-\uDEF6]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF51-\uDF87\uDF8F-\uDF92\uDFE4\uDFF0\uDFF1]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]"
  },
  {
    name: "Mc",
    alias: "Spacing_Mark",
    bmp: "ःऻा-ीॉ-ौॎॏংঃা-ীেৈোৌৗਃਾ-ੀઃા-ીૉોૌଂଃାୀେୈୋୌୗாிுூெ-ைொ-ௌௗఁ-ఃు-ౄಂಃಾೀ-ೄೇೈೊೋೕೖംഃാ-ീെ-ൈൊ-ൌൗංඃා-ෑෘ-ෟෲෳ༾༿ཿါာေးျြၖၗၢ-ၤၧ-ၭႃႄႇ-ႌႏႚ-ႜ᜕᜴ាើ-ៅះៈᤣ-ᤦᤩ-ᤫᤰᤱᤳ-ᤸᨙᨚᩕᩗᩡᩣᩤᩭ-ᩲᬄᬵᬻᬽ-ᭁᭃ᭄ᮂᮡᮦᮧ᮪ᯧᯪ-ᯬᯮ᯲᯳ᰤ-ᰫᰴᰵ᳡᳷〮〯ꠣꠤꠧꢀꢁꢴ-ꣃꥒ꥓ꦃꦴꦵꦺꦻꦾ-꧀ꨯꨰꨳꨴꩍꩻꩽꫫꫮꫯꫵꯣꯤꯦꯧꯩꯪ꯬",
    astral: "\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3E\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB0-\uDCB2\uDCB9\uDCBB-\uDCBE\uDCC1\uDDAF-\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF20\uDF21\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD30-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD65\uDD66\uDD6D-\uDD72]"
  },
  {
    name: "Me",
    alias: "Enclosing_Mark",
    bmp: "҈҉᪾⃝-⃠⃢-⃤꙰-꙲"
  },
  {
    name: "Mn",
    alias: "Nonspacing_Mark",
    bmp: "̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-ٰٟۖ-ۜ۟-۪ۤۧۨ-ܑۭܰ-݊ަ-ް߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࢘-࢟࣊-ࣣ࣡-ंऺ़ु-ै्॑-ॗॢॣঁ়ু-ৄ্ৢৣ৾ਁਂ਼ੁੂੇੈੋ-੍ੑੰੱੵઁં઼ુ-ૅેૈ્ૢૣૺ-૿ଁ଼ିୁ-ୄ୍୕ୖୢୣஂீ்ఀఄ఼ా-ీె-ైొ-్ౕౖౢౣಁ಼ಿೆೌ್ೢೣഀഁ഻഼ു-ൄ്ൢൣඁ්ි-ුූัิ-ฺ็-๎ັິ-ຼ່-ໍཱ༹༘༙༵༷-ཾྀ-྄྆྇ྍ-ྗྙ-ྼ࿆ိ-ူဲ-့္်ွှၘၙၞ-ၠၱ-ၴႂႅႆႍႝ፝-፟ᜒ-᜔ᜲᜳᝒᝓᝲᝳ឴឵ិ-ួំ៉-៓៝᠋-᠍᠏ᢅᢆᢩᤠ-ᤢᤧᤨᤲ᤹-᤻ᨘᨗᨛᩖᩘ-ᩞ᩠ᩢᩥ-ᩬᩳ-᩿᩼᪰-᪽ᪿ-ᫎᬀ-ᬃ᬴ᬶ-ᬺᬼᭂ᭫-᭳ᮀᮁᮢ-ᮥᮨᮩ᮫-ᮭ᯦ᯨᯩᯭᯯ-ᯱᰬ-ᰳᰶ᰷᳐-᳔᳒-᳢᳠-᳨᳭᳴᳸᳹᷀-᷿⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〭꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠥꠦ꠬꣄ꣅ꣠-꣱ꣿꤦ-꤭ꥇ-ꥑꦀ-ꦂ꦳ꦶ-ꦹꦼꦽꧥꨩ-ꨮꨱꨲꨵꨶꩃꩌꩼꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫬꫭ꫶ꯥꯨ꯭ﬞ︀-️︠-︯",
    astral: "\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC01\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF40\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB3-\uDCB8\uDCBA\uDCBF\uDCC0\uDCC2\uDCC3\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]"
  },
  {
    name: "N",
    alias: "Number",
    bmp: "0-9²³¹¼-¾٠-٩۰-۹߀-߉०-९০-৯৴-৹੦-੯૦-૯୦-୯୲-୷௦-௲౦-౯౸-౾೦-೯൘-൞൦-൸෦-෯๐-๙໐-໙༠-༳၀-၉႐-႙፩-፼ᛮ-ᛰ០-៩៰-៹᠐-᠙᥆-᥏᧐-᧚᪀-᪉᪐-᪙᭐-᭙᮰-᮹᱀-᱉᱐-᱙⁰⁴-⁹₀-₉⅐-ↂↅ-↉①-⒛⓪-⓿❶-➓⳽〇〡-〩〸-〺㆒-㆕㈠-㈩㉈-㉏㉑-㉟㊀-㊉㊱-㊿꘠-꘩ꛦ-ꛯ꠰-꠵꣐-꣙꤀-꤉꧐-꧙꧰-꧹꩐-꩙꯰-꯹０-９",
    astral: "\uD800[\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23\uDF41\uDF4A\uDFD1-\uDFD5]|\uD801[\uDCA0-\uDCA9]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE48\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDD30-\uDD39\uDE60-\uDE7E\uDF1D-\uDF26\uDF51-\uDF54\uDFC5-\uDFCB]|\uD804[\uDC52-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDDE1-\uDDF4\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF3B]|\uD806[\uDCE0-\uDCF2\uDD50-\uDD59]|\uD807[\uDC50-\uDC6C\uDD50-\uDD59\uDDA0-\uDDA9\uDFC0-\uDFD4]|\uD809[\uDC00-\uDC6E]|\uD81A[\uDE60-\uDE69\uDEC0-\uDEC9\uDF50-\uDF59\uDF5B-\uDF61]|\uD81B[\uDE80-\uDE96]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDFCE-\uDFFF]|\uD838[\uDD40-\uDD49\uDEF0-\uDEF9]|\uD83A[\uDCC7-\uDCCF\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]"
  },
  {
    name: "Nd",
    alias: "Decimal_Number",
    bmp: "0-9٠-٩۰-۹߀-߉०-९০-৯੦-੯૦-૯୦-୯௦-௯౦-౯೦-೯൦-൯෦-෯๐-๙໐-໙༠-༩၀-၉႐-႙០-៩᠐-᠙᥆-᥏᧐-᧙᪀-᪉᪐-᪙᭐-᭙᮰-᮹᱀-᱉᱐-᱙꘠-꘩꣐-꣙꤀-꤉꧐-꧙꧰-꧹꩐-꩙꯰-꯹０-９",
    astral: "\uD801[\uDCA0-\uDCA9]|\uD803[\uDD30-\uDD39]|\uD804[\uDC66-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF39]|\uD806[\uDCE0-\uDCE9\uDD50-\uDD59]|\uD807[\uDC50-\uDC59\uDD50-\uDD59\uDDA0-\uDDA9]|\uD81A[\uDE60-\uDE69\uDEC0-\uDEC9\uDF50-\uDF59]|\uD835[\uDFCE-\uDFFF]|\uD838[\uDD40-\uDD49\uDEF0-\uDEF9]|\uD83A[\uDD50-\uDD59]|\uD83E[\uDFF0-\uDFF9]"
  },
  {
    name: "Nl",
    alias: "Letter_Number",
    bmp: "ᛮ-ᛰⅠ-ↂↅ-ↈ〇〡-〩〸-〺ꛦ-ꛯ",
    astral: "\uD800[\uDD40-\uDD74\uDF41\uDF4A\uDFD1-\uDFD5]|\uD809[\uDC00-\uDC6E]"
  },
  {
    name: "No",
    alias: "Other_Number",
    bmp: "²³¹¼-¾৴-৹୲-୷௰-௲౸-౾൘-൞൰-൸༪-༳፩-፼៰-៹᧚⁰⁴-⁹₀-₉⅐-⅟↉①-⒛⓪-⓿❶-➓⳽㆒-㆕㈠-㈩㉈-㉏㉑-㉟㊀-㊉㊱-㊿꠰-꠵",
    astral: "\uD800[\uDD07-\uDD33\uDD75-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE48\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDE60-\uDE7E\uDF1D-\uDF26\uDF51-\uDF54\uDFC5-\uDFCB]|\uD804[\uDC52-\uDC65\uDDE1-\uDDF4]|\uD805[\uDF3A\uDF3B]|\uD806[\uDCEA-\uDCF2]|\uD807[\uDC5A-\uDC6C\uDFC0-\uDFD4]|\uD81A[\uDF5B-\uDF61]|\uD81B[\uDE80-\uDE96]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD83A[\uDCC7-\uDCCF]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D]|\uD83C[\uDD00-\uDD0C]"
  },
  {
    name: "P",
    alias: "Punctuation",
    bmp: "!-#%-\\*,-\\/:;\\?@\\[-\\]_\\{\\}¡§«¶·»¿;·՚-՟։֊־׀׃׆׳״؉؊،؍؛؝-؟٪-٭۔܀-܍߷-߹࠰-࠾࡞।॥॰৽੶૰౷಄෴๏๚๛༄-༒༔༺-༽྅࿐-࿔࿙࿚၊-၏჻፠-፨᐀᙮᚛᚜᛫-᛭᜵᜶។-៖៘-៚᠀-᠊᥄᥅᨞᨟᪠-᪦᪨-᪭᭚-᭠᭽᭾᯼-᯿᰻-᰿᱾᱿᳀-᳇᳓‐-‧‰-⁃⁅-⁑⁓-⁞⁽⁾₍₎⌈-⌋〈〉❨-❵⟅⟆⟦-⟯⦃-⦘⧘-⧛⧼⧽⳹-⳼⳾⳿⵰⸀-⸮⸰-⹏⹒-⹝、-〃〈-】〔-〟〰〽゠・꓾꓿꘍-꘏꙳꙾꛲-꛷꡴-꡷꣎꣏꣸-꣺꣼꤮꤯꥟꧁-꧍꧞꧟꩜-꩟꫞꫟꫰꫱꯫﴾﴿︐-︙︰-﹒﹔-﹡﹣﹨﹪﹫！-＃％-＊，-／：；？＠［-］＿｛｝｟-･",
    astral: "\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|𐕯|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|𛲟|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]"
  },
  {
    name: "Pc",
    alias: "Connector_Punctuation",
    bmp: "_‿⁀⁔︳︴﹍-﹏＿"
  },
  {
    name: "Pd",
    alias: "Dash_Punctuation",
    bmp: "\\-֊־᐀᠆‐-―⸗⸚⸺⸻⹀⹝〜〰゠︱︲﹘﹣－",
    astral: "𐺭"
  },
  {
    name: "Pe",
    alias: "Close_Punctuation",
    bmp: "\\)\\]\\}༻༽᚜⁆⁾₎⌉⌋〉❩❫❭❯❱❳❵⟆⟧⟩⟫⟭⟯⦄⦆⦈⦊⦌⦎⦐⦒⦔⦖⦘⧙⧛⧽⸣⸥⸧⸩⹖⹘⹚⹜〉》」』】〕〗〙〛〞〟﴾︘︶︸︺︼︾﹀﹂﹄﹈﹚﹜﹞）］｝｠｣"
  },
  {
    name: "Pf",
    alias: "Final_Punctuation",
    bmp: "»’”›⸃⸅⸊⸍⸝⸡"
  },
  {
    name: "Pi",
    alias: "Initial_Punctuation",
    bmp: "«‘‛“‟‹⸂⸄⸉⸌⸜⸠"
  },
  {
    name: "Po",
    alias: "Other_Punctuation",
    bmp: "!-#%-'\\*,\\.\\/:;\\?@\\¡§¶·¿;·՚-՟։׀׃׆׳״؉؊،؍؛؝-؟٪-٭۔܀-܍߷-߹࠰-࠾࡞।॥॰৽੶૰౷಄෴๏๚๛༄-༒༔྅࿐-࿔࿙࿚၊-၏჻፠-፨᙮᛫-᛭᜵᜶។-៖៘-៚᠀-᠅᠇-᠊᥄᥅᨞᨟᪠-᪦᪨-᪭᭚-᭠᭽᭾᯼-᯿᰻-᰿᱾᱿᳀-᳇᳓‖‗†-‧‰-‸※-‾⁁-⁃⁇-⁑⁓⁕-⁞⳹-⳼⳾⳿⵰⸀⸁⸆-⸈⸋⸎-⸖⸘⸙⸛⸞⸟⸪-⸮⸰-⸹⸼-⸿⹁⹃-⹏⹒-⹔、-〃〽・꓾꓿꘍-꘏꙳꙾꛲-꛷꡴-꡷꣎꣏꣸-꣺꣼꤮꤯꥟꧁-꧍꧞꧟꩜-꩟꫞꫟꫰꫱꯫︐-︖︙︰﹅﹆﹉-﹌﹐-﹒﹔-﹗﹟-﹡﹨﹪﹫！-＃％-＇＊，．／：；？＠＼｡､･",
    astral: "\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|𐕯|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|𛲟|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]"
  },
  {
    name: "Ps",
    alias: "Open_Punctuation",
    bmp: "\\(\\[\\{༺༼᚛‚„⁅⁽₍⌈⌊〈❨❪❬❮❰❲❴⟅⟦⟨⟪⟬⟮⦃⦅⦇⦉⦋⦍⦏⦑⦓⦕⦗⧘⧚⧼⸢⸤⸦⸨⹂⹕⹗⹙⹛〈《「『【〔〖〘〚〝﴿︗︵︷︹︻︽︿﹁﹃﹇﹙﹛﹝（［｛｟｢"
  },
  {
    name: "S",
    alias: "Symbol",
    bmp: "\\$\\+<->\\^`\\|~¢-¦¨©¬®-±´¸×÷˂-˅˒-˟˥-˫˭˯-˿͵΄΅϶҂֍-֏؆-؈؋؎؏۞۩۽۾߶߾߿࢈৲৳৺৻૱୰௳-௺౿൏൹฿༁-༃༓༕-༗༚-༟༴༶༸྾-࿅࿇-࿌࿎࿏࿕-࿘႞႟᎐-᎙᙭៛᥀᧞-᧿᭡-᭪᭴-᭼᾽᾿-῁῍-῏῝-῟῭-`´῾⁄⁒⁺-⁼₊-₌₠-⃀℀℁℃-℆℈℉℔№-℘℞-℣℥℧℩℮℺℻⅀-⅄⅊-⅍⅏↊↋←-⌇⌌-⌨⌫-␦⑀-⑊⒜-ⓩ─-❧➔-⟄⟇-⟥⟰-⦂⦙-⧗⧜-⧻⧾-⭳⭶-⮕⮗-⯿⳥-⳪⹐⹑⺀-⺙⺛-⻳⼀-⿕⿰-⿻〄〒〓〠〶〷〾〿゛゜㆐㆑㆖-㆟㇀-㇣㈀-㈞㈪-㉇㉐㉠-㉿㊊-㊰㋀-㏿䷀-䷿꒐-꓆꜀-꜖꜠꜡꞉꞊꠨-꠫꠶-꠹꩷-꩹꭛꭪꭫﬩﮲-﯂﵀-﵏﷏﷼-﷿﹢﹤-﹦﹩＄＋＜-＞＾｀｜～￠-￦￨-￮￼�",
    astral: "\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|𑜿|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|𛲜|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDD-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC5\uDED0-\uDED9\uDEE0-\uDEE7\uDEF0-\uDEF6\uDF00-\uDF92\uDF94-\uDFCA]"
  },
  {
    name: "Sc",
    alias: "Currency_Symbol",
    bmp: "\\$¢-¥֏؋߾߿৲৳৻૱௹฿៛₠-⃀꠸﷼﹩＄￠￡￥￦",
    astral: "\uD807[\uDFDD-\uDFE0]|𞋿|𞲰"
  },
  {
    name: "Sk",
    alias: "Modifier_Symbol",
    bmp: "\\^`¨¯´¸˂-˅˒-˟˥-˫˭˯-˿͵΄΅࢈᾽᾿-῁῍-῏῝-῟῭-`´῾゛゜꜀-꜖꜠꜡꞉꞊꭛꭪꭫﮲-﯂＾｀￣",
    astral: "\uD83C[\uDFFB-\uDFFF]"
  },
  {
    name: "Sm",
    alias: "Math_Symbol",
    bmp: "\\+<->\\|~¬±×÷϶؆-؈⁄⁒⁺-⁼₊-₌℘⅀-⅄⅋←-↔↚↛↠↣↦↮⇎⇏⇒⇔⇴-⋿⌠⌡⍼⎛-⎳⏜-⏡▷◁◸-◿♯⟀-⟄⟇-⟥⟰-⟿⤀-⦂⦙-⧗⧜-⧻⧾-⫿⬰-⭄⭇-⭌﬩﹢﹤-﹦＋＜-＞｜～￢￩-￬",
    astral: "\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD83B[\uDEF0\uDEF1]"
  },
  {
    name: "So",
    alias: "Other_Symbol",
    bmp: "¦©®°҂֍֎؎؏۞۩۽۾߶৺୰௳-௸௺౿൏൹༁-༃༓༕-༗༚-༟༴༶༸྾-࿅࿇-࿌࿎࿏࿕-࿘႞႟᎐-᎙᙭᥀᧞-᧿᭡-᭪᭴-᭼℀℁℃-℆℈℉℔№℗℞-℣℥℧℩℮℺℻⅊⅌⅍⅏↊↋↕-↙↜-↟↡↢↤↥↧-↭↯-⇍⇐⇑⇓⇕-⇳⌀-⌇⌌-⌟⌢-⌨⌫-⍻⍽-⎚⎴-⏛⏢-␦⑀-⑊⒜-ⓩ─-▶▸-◀◂-◷☀-♮♰-❧➔-➿⠀-⣿⬀-⬯⭅⭆⭍-⭳⭶-⮕⮗-⯿⳥-⳪⹐⹑⺀-⺙⺛-⻳⼀-⿕⿰-⿻〄〒〓〠〶〷〾〿㆐㆑㆖-㆟㇀-㇣㈀-㈞㈪-㉇㉐㉠-㉿㊊-㊰㋀-㏿䷀-䷿꒐-꓆꠨-꠫꠶꠷꠹꩷-꩹﵀-﵏﷏﷽-﷿￤￨￭￮￼�",
    astral: "\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|𑜿|\uD807[\uDFD5-\uDFDC\uDFE1-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|𛲜|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|𞅏|\uD83B[\uDCAC\uDD2E]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFA]|\uD83D[\uDC00-\uDED7\uDEDD-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC5\uDED0-\uDED9\uDEE0-\uDEE7\uDEF0-\uDEF6\uDF00-\uDF92\uDF94-\uDFCA]"
  },
  {
    name: "Z",
    alias: "Separator",
    bmp: "    - \u2028\u2029  　"
  },
  {
    name: "Zl",
    alias: "Line_Separator",
    bmp: "\u2028"
  },
  {
    name: "Zp",
    alias: "Paragraph_Separator",
    bmp: "\u2029"
  },
  {
    name: "Zs",
    alias: "Space_Separator",
    bmp: "    -   　"
  }
];
const vH = /* @__PURE__ */ is(mH);
/*!
 * XRegExp Unicode Categories 5.1.1
 * <xregexp.com>
 * Steven Levithan (c) 2010-present MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */
const kH = (e) => {
  if (!e.addUnicodeData)
    throw new ReferenceError("Unicode Base must be loaded before Unicode Categories");
  e.addUnicodeData(vH);
};
var bH = [
  {
    name: "ASCII",
    bmp: "\0-"
  },
  {
    name: "Alphabetic",
    bmp: "A-Za-zªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͅͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈְ-ׇֽֿׁׂׅׄא-תׯ-ײؐ-ؚؠ-ٗٙ-ٟٮ-ۓە-ۜۡ-ۭۨ-ۯۺ-ۼۿܐ-ܿݍ-ޱߊ-ߪߴߵߺࠀ-ࠗࠚ-ࠬࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉࣔ-ࣣࣟ-ࣰࣩ-ऻऽ-ौॎ-ॐॕ-ॣॱ-ঃঅ-ঌএঐও-নপ-রলশ-হঽ-ৄেৈোৌৎৗড়ঢ়য়-ৣৰৱৼਁ-ਃਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਾ-ੂੇੈੋੌੑਖ਼-ੜਫ਼ੰ-ੵઁ-ઃઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽ-ૅે-ૉોૌૐૠ-ૣૹ-ૼଁ-ଃଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽ-ୄେୈୋୌୖୗଡ଼ଢ଼ୟ-ୣୱஂஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹா-ூெ-ைொ-ௌௐௗఀ-ఃఅ-ఌఎ-ఐఒ-నప-హఽ-ౄె-ైొ-ౌౕౖౘ-ౚౝౠ-ౣಀ-ಃಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽ-ೄೆ-ೈೊ-ೌೕೖೝೞೠ-ೣೱೲഀ-ഌഎ-ഐഒ-ഺഽ-ൄെ-ൈൊ-ൌൎൔ-ൗൟ-ൣൺ-ൿඁ-ඃඅ-ඖක-නඳ-රලව-ෆා-ුූෘ-ෟෲෳก-ฺเ-ๆํກຂຄຆ-ຊຌ-ຣລວ-ູົ-ຽເ-ໄໆໍໜ-ໟༀཀ-ཇཉ-ཬཱ-ཱྀྈ-ྗྙ-ྼက-ံးျ-ဿၐ-ႏႚ-ႝႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜓᜟ-ᜳᝀ-ᝓᝠ-ᝬᝮ-ᝰᝲᝳក-ឳា-ៈៗៜᠠ-ᡸᢀ-ᢪᢰ-ᣵᤀ-ᤞᤠ-ᤫᤰ-ᤸᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨛᨠ-ᩞᩡ-ᩴᪧᪿᫀᫌ-ᫎᬀ-ᬳᬵ-ᭃᭅ-ᭌᮀ-ᮩᮬ-ᮯᮺ-ᯥᯧ-ᯱᰀ-ᰶᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿᷧ-ᷴḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⒶ-ⓩⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⷠ-ⷿⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙴ-ꙻꙿ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꠅꠇ-ꠧꡀ-ꡳꢀ-ꣃꣅꣲ-ꣷꣻꣽ-ꣿꤊ-ꤪꤰ-ꥒꥠ-ꥼꦀ-ꦲꦴ-ꦿꧏꧠ-ꧯꧺ-ꧾꨀ-ꨶꩀ-ꩍꩠ-ꩶꩺ-ꪾꫀꫂꫛ-ꫝꫠ-ꫯꫲ-ꫵꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯪ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
    astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD27\uDE80-\uDEA9\uDEAB\uDEAC\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC00-\uDC45\uDC71-\uDC75\uDC82-\uDCB8\uDCC2\uDCD0-\uDCE8\uDD00-\uDD32\uDD44-\uDD47\uDD50-\uDD72\uDD76\uDD80-\uDDBF\uDDC1-\uDDC4\uDDCE\uDDCF\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE34\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEE8\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D-\uDF44\uDF47\uDF48\uDF4B\uDF4C\uDF50\uDF57\uDF5D-\uDF63]|\uD805[\uDC00-\uDC41\uDC43-\uDC45\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCC1\uDCC4\uDCC5\uDCC7\uDD80-\uDDB5\uDDB8-\uDDBE\uDDD8-\uDDDD\uDE00-\uDE3E\uDE40\uDE44\uDE80-\uDEB5\uDEB8\uDF00-\uDF1A\uDF1D-\uDF2A\uDF40-\uDF46]|\uD806[\uDC00-\uDC38\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD35\uDD37\uDD38\uDD3B\uDD3C\uDD3F-\uDD42\uDDA0-\uDDA7\uDDAA-\uDDD7\uDDDA-\uDDDF\uDDE1\uDDE3\uDDE4\uDE00-\uDE32\uDE35-\uDE3E\uDE50-\uDE97\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC3E\uDC40\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD41\uDD43\uDD46\uDD47\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD8E\uDD90\uDD91\uDD93-\uDD96\uDD98\uDEE0-\uDEF6\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF4F-\uDF87\uDF8F-\uDF9F\uDFE0\uDFE1\uDFE3\uDFF0\uDFF1]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9E]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD47\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]"
  },
  {
    name: "Any",
    isBmpLast: !0,
    bmp: "\0-￿",
    astral: "[\uD800-\uDBFF][\uDC00-\uDFFF]"
  },
  {
    name: "Default_Ignorable_Code_Point",
    bmp: "­͏؜ᅟᅠ឴឵᠋-᠏​-‏‪-‮⁠-⁯ㅤ︀-️\uFEFFﾠ￰-￸",
    astral: "\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|[\uDB40-\uDB43][\uDC00-\uDFFF]"
  },
  {
    name: "Lowercase",
    bmp: "a-zªµºß-öø-ÿāăąćĉċčďđēĕėęěĝğġģĥħĩīĭįıĳĵķĸĺļľŀłńņňŉŋōŏőœŕŗřśŝşšţťŧũūŭůűųŵŷźżž-ƀƃƅƈƌƍƒƕƙ-ƛƞơƣƥƨƪƫƭưƴƶƹƺƽ-ƿǆǉǌǎǐǒǔǖǘǚǜǝǟǡǣǥǧǩǫǭǯǰǳǵǹǻǽǿȁȃȅȇȉȋȍȏȑȓȕȗșțȝȟȡȣȥȧȩȫȭȯȱȳ-ȹȼȿɀɂɇɉɋɍɏ-ʓʕ-ʸˀˁˠ-ˤͅͱͳͷͺ-ͽΐά-ώϐϑϕ-ϗϙϛϝϟϡϣϥϧϩϫϭϯ-ϳϵϸϻϼа-џѡѣѥѧѩѫѭѯѱѳѵѷѹѻѽѿҁҋҍҏґғҕҗҙқҝҟҡңҥҧҩҫҭүұҳҵҷҹһҽҿӂӄӆӈӊӌӎӏӑӓӕӗәӛӝӟӡӣӥӧөӫӭӯӱӳӵӷӹӻӽӿԁԃԅԇԉԋԍԏԑԓԕԗԙԛԝԟԡԣԥԧԩԫԭԯՠ-ֈა-ჺჽ-ჿᏸ-ᏽᲀ-ᲈᴀ-ᶿḁḃḅḇḉḋḍḏḑḓḕḗḙḛḝḟḡḣḥḧḩḫḭḯḱḳḵḷḹḻḽḿṁṃṅṇṉṋṍṏṑṓṕṗṙṛṝṟṡṣṥṧṩṫṭṯṱṳṵṷṹṻṽṿẁẃẅẇẉẋẍẏẑẓẕ-ẝẟạảấầẩẫậắằẳẵặẹẻẽếềểễệỉịọỏốồổỗộớờởỡợụủứừửữựỳỵỷỹỻỽỿ-ἇἐ-ἕἠ-ἧἰ-ἷὀ-ὅὐ-ὗὠ-ὧὰ-ώᾀ-ᾇᾐ-ᾗᾠ-ᾧᾰ-ᾴᾶᾷιῂ-ῄῆῇῐ-ΐῖῗῠ-ῧῲ-ῴῶῷⁱⁿₐ-ₜℊℎℏℓℯℴℹℼℽⅆ-ⅉⅎⅰ-ⅿↄⓐ-ⓩⰰ-ⱟⱡⱥⱦⱨⱪⱬⱱⱳⱴⱶ-ⱽⲁⲃⲅⲇⲉⲋⲍⲏⲑⲓⲕⲗⲙⲛⲝⲟⲡⲣⲥⲧⲩⲫⲭⲯⲱⲳⲵⲷⲹⲻⲽⲿⳁⳃⳅⳇⳉⳋⳍⳏⳑⳓⳕⳗⳙⳛⳝⳟⳡⳣⳤⳬⳮⳳⴀ-ⴥⴧⴭꙁꙃꙅꙇꙉꙋꙍꙏꙑꙓꙕꙗꙙꙛꙝꙟꙡꙣꙥꙧꙩꙫꙭꚁꚃꚅꚇꚉꚋꚍꚏꚑꚓꚕꚗꚙꚛ-ꚝꜣꜥꜧꜩꜫꜭꜯ-ꜱꜳꜵꜷꜹꜻꜽꜿꝁꝃꝅꝇꝉꝋꝍꝏꝑꝓꝕꝗꝙꝛꝝꝟꝡꝣꝥꝧꝩꝫꝭꝯ-ꝸꝺꝼꝿꞁꞃꞅꞇꞌꞎꞑꞓ-ꞕꞗꞙꞛꞝꞟꞡꞣꞥꞧꞩꞯꞵꞷꞹꞻꞽꞿꟁꟃꟈꟊꟑꟓꟕꟗꟙꟶꟸ-ꟺꬰ-ꭚꭜ-ꭨꭰ-ꮿﬀ-ﬆﬓ-ﬗａ-ｚ",
    astral: "\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDF80\uDF83-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD803[\uDCC0-\uDCF2]|\uD806[\uDCC0-\uDCDF]|\uD81B[\uDE60-\uDE7F]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD837[\uDF00-\uDF09\uDF0B-\uDF1E]|\uD83A[\uDD22-\uDD43]"
  },
  {
    name: "Noncharacter_Code_Point",
    bmp: "﷐-﷯￾￿",
    astral: "[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]"
  },
  {
    name: "Uppercase",
    bmp: "A-ZÀ-ÖØ-ÞĀĂĄĆĈĊČĎĐĒĔĖĘĚĜĞĠĢĤĦĨĪĬĮİĲĴĶĹĻĽĿŁŃŅŇŊŌŎŐŒŔŖŘŚŜŞŠŢŤŦŨŪŬŮŰŲŴŶŸŹŻŽƁƂƄƆƇƉ-ƋƎ-ƑƓƔƖ-ƘƜƝƟƠƢƤƦƧƩƬƮƯƱ-ƳƵƷƸƼǄǇǊǍǏǑǓǕǗǙǛǞǠǢǤǦǨǪǬǮǱǴǶ-ǸǺǼǾȀȂȄȆȈȊȌȎȐȒȔȖȘȚȜȞȠȢȤȦȨȪȬȮȰȲȺȻȽȾɁɃ-ɆɈɊɌɎͰͲͶͿΆΈ-ΊΌΎΏΑ-ΡΣ-ΫϏϒ-ϔϘϚϜϞϠϢϤϦϨϪϬϮϴϷϹϺϽ-ЯѠѢѤѦѨѪѬѮѰѲѴѶѸѺѼѾҀҊҌҎҐҒҔҖҘҚҜҞҠҢҤҦҨҪҬҮҰҲҴҶҸҺҼҾӀӁӃӅӇӉӋӍӐӒӔӖӘӚӜӞӠӢӤӦӨӪӬӮӰӲӴӶӸӺӼӾԀԂԄԆԈԊԌԎԐԒԔԖԘԚԜԞԠԢԤԦԨԪԬԮԱ-ՖႠ-ჅჇჍᎠ-ᏵᲐ-ᲺᲽ-ᲿḀḂḄḆḈḊḌḎḐḒḔḖḘḚḜḞḠḢḤḦḨḪḬḮḰḲḴḶḸḺḼḾṀṂṄṆṈṊṌṎṐṒṔṖṘṚṜṞṠṢṤṦṨṪṬṮṰṲṴṶṸṺṼṾẀẂẄẆẈẊẌẎẐẒẔẞẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼẾỀỂỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪỬỮỰỲỴỶỸỺỼỾἈ-ἏἘ-ἝἨ-ἯἸ-ἿὈ-ὍὙὛὝὟὨ-ὯᾸ-ΆῈ-ΉῘ-ΊῨ-ῬῸ-Ώℂℇℋ-ℍℐ-ℒℕℙ-ℝℤΩℨK-ℭℰ-ℳℾℿⅅⅠ-ⅯↃⒶ-ⓏⰀ-ⰯⱠⱢ-ⱤⱧⱩⱫⱭ-ⱰⱲⱵⱾ-ⲀⲂⲄⲆⲈⲊⲌⲎⲐⲒⲔⲖⲘⲚⲜⲞⲠⲢⲤⲦⲨⲪⲬⲮⲰⲲⲴⲶⲸⲺⲼⲾⳀⳂⳄⳆⳈⳊⳌⳎⳐⳒⳔⳖⳘⳚⳜⳞⳠⳢⳫⳭⳲꙀꙂꙄꙆꙈꙊꙌꙎꙐꙒꙔꙖꙘꙚꙜꙞꙠꙢꙤꙦꙨꙪꙬꚀꚂꚄꚆꚈꚊꚌꚎꚐꚒꚔꚖꚘꚚꜢꜤꜦꜨꜪꜬꜮꜲꜴꜶꜸꜺꜼꜾꝀꝂꝄꝆꝈꝊꝌꝎꝐꝒꝔꝖꝘꝚꝜꝞꝠꝢꝤꝦꝨꝪꝬꝮꝹꝻꝽꝾꞀꞂꞄꞆꞋꞍꞐꞒꞖꞘꞚꞜꞞꞠꞢꞤꞦꞨꞪ-ꞮꞰ-ꞴꞶꞸꞺꞼꞾꟀꟂꟄ-ꟇꟉꟐꟖꟘꟵＡ-Ｚ",
    astral: "\uD801[\uDC00-\uDC27\uDCB0-\uDCD3\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD81B[\uDE40-\uDE5F]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]"
  },
  {
    name: "White_Space",
    bmp: "	-\r    - \u2028\u2029  　"
  }
];
const _H = /* @__PURE__ */ is(bH);
/*!
 * XRegExp Unicode Properties 5.1.1
 * <xregexp.com>
 * Steven Levithan (c) 2012-present MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */
const DH = (e) => {
  if (!e.addUnicodeData)
    throw new ReferenceError("Unicode Base must be loaded before Unicode Properties");
  const t = _H;
  t.push({
    name: "Assigned",
    // Since this is defined as the inverse of Unicode category Cn (Unassigned), the Unicode
    // Categories addon is required to use this property
    inverseOf: "Cn"
  }), e.addUnicodeData(t);
};
var yH = [
  {
    name: "Adlam",
    astral: "\uD83A[\uDD00-\uDD4B\uDD50-\uDD59\uDD5E\uDD5F]"
  },
  {
    name: "Ahom",
    astral: "\uD805[\uDF00-\uDF1A\uDF1D-\uDF2B\uDF30-\uDF46]"
  },
  {
    name: "Anatolian_Hieroglyphs",
    astral: "\uD811[\uDC00-\uDE46]"
  },
  {
    name: "Arabic",
    bmp: "؀-؄؆-؋؍-ؚ؜-؞ؠ-ؿف-يٖ-ٯٱ-ۜ۞-ۿݐ-ݿࡰ-ࢎ࢐࢑࢘-ࣣ࣡-ࣿﭐ-﯂ﯓ-ﴽ﵀-ﶏﶒ-ﷇ﷏ﷰ-﷿ﹰ-ﹴﹶ-ﻼ",
    astral: "\uD803[\uDE60-\uDE7E]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB\uDEF0\uDEF1]"
  },
  {
    name: "Armenian",
    bmp: "Ա-Ֆՙ-֊֍-֏ﬓ-ﬗ"
  },
  {
    name: "Avestan",
    astral: "\uD802[\uDF00-\uDF35\uDF39-\uDF3F]"
  },
  {
    name: "Balinese",
    bmp: "ᬀ-ᭌ᭐-᭾"
  },
  {
    name: "Bamum",
    bmp: "ꚠ-꛷",
    astral: "\uD81A[\uDC00-\uDE38]"
  },
  {
    name: "Bassa_Vah",
    astral: "\uD81A[\uDED0-\uDEED\uDEF0-\uDEF5]"
  },
  {
    name: "Batak",
    bmp: "ᯀ-᯳᯼-᯿"
  },
  {
    name: "Bengali",
    bmp: "ঀ-ঃঅ-ঌএঐও-নপ-রলশ-হ়-ৄেৈো-ৎৗড়ঢ়য়-ৣ০-৾"
  },
  {
    name: "Bhaiksuki",
    astral: "\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC45\uDC50-\uDC6C]"
  },
  {
    name: "Bopomofo",
    bmp: "˪˫ㄅ-ㄯㆠ-ㆿ"
  },
  {
    name: "Brahmi",
    astral: "\uD804[\uDC00-\uDC4D\uDC52-\uDC75\uDC7F]"
  },
  {
    name: "Braille",
    bmp: "⠀-⣿"
  },
  {
    name: "Buginese",
    bmp: "ᨀ-ᨛ᨞᨟"
  },
  {
    name: "Buhid",
    bmp: "ᝀ-ᝓ"
  },
  {
    name: "Canadian_Aboriginal",
    bmp: "᐀-ᙿᢰ-ᣵ",
    astral: "\uD806[\uDEB0-\uDEBF]"
  },
  {
    name: "Carian",
    astral: "\uD800[\uDEA0-\uDED0]"
  },
  {
    name: "Caucasian_Albanian",
    astral: "\uD801[\uDD30-\uDD63\uDD6F]"
  },
  {
    name: "Chakma",
    astral: "\uD804[\uDD00-\uDD34\uDD36-\uDD47]"
  },
  {
    name: "Cham",
    bmp: "ꨀ-ꨶꩀ-ꩍ꩐-꩙꩜-꩟"
  },
  {
    name: "Cherokee",
    bmp: "Ꭰ-Ᏽᏸ-ᏽꭰ-ꮿ"
  },
  {
    name: "Chorasmian",
    astral: "\uD803[\uDFB0-\uDFCB]"
  },
  {
    name: "Common",
    bmp: "\0-@\\[-`\\{-©«-¹»-¿×÷ʹ-˟˥-˩ˬ-˿ʹ;΅·؅،؛؟ـ۝࣢।॥฿࿕-࿘჻᛫-᛭᜵᜶᠂᠃᠅᳓᳡ᳩ-ᳬᳮ-ᳳᳵ-᳷ᳺ -​‎-⁤⁦-⁰⁴-⁾₀-₎₠-⃀℀-℥℧-℩ℬ-ℱℳ-⅍⅏-⅟↉-↋←-␦⑀-⑊①-⟿⤀-⭳⭶-⮕⮗-⯿⸀-⹝⿰-⿻　-〄〆〈-〠〰-〷〼-〿゛゜゠・ー㆐-㆟㇀-㇣㈠-㉟㉿-㋏㋿㍘-㏿䷀-䷿꜀-꜡ꞈ-꞊꠰-꠹꤮ꧏ꭛꭪꭫﴾﴿︐-︙︰-﹒﹔-﹦﹨-﹫\uFEFF！-＠［-｀｛-･ｰﾞﾟ￠-￦￨-￮￹-�",
    astral: "\uD800[\uDD00-\uDD02\uDD07-\uDD33\uDD37-\uDD3F\uDD90-\uDD9C\uDDD0-\uDDFC\uDEE1-\uDEFB]|\uD82F[\uDCA0-\uDCA3]|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD66\uDD6A-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDEE0-\uDEF3\uDF00-\uDF56\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDFCB\uDFCE-\uDFFF]|\uD83B[\uDC71-\uDCB4\uDD01-\uDD3D]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD00-\uDDAD\uDDE6-\uDDFF\uDE01\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDD-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC5\uDED0-\uDED9\uDEE0-\uDEE7\uDEF0-\uDEF6\uDF00-\uDF92\uDF94-\uDFCA\uDFF0-\uDFF9]|\uDB40[\uDC01\uDC20-\uDC7F]"
  },
  {
    name: "Coptic",
    bmp: "Ϣ-ϯⲀ-ⳳ⳹-⳿"
  },
  {
    name: "Cuneiform",
    astral: "\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC70-\uDC74\uDC80-\uDD43]"
  },
  {
    name: "Cypriot",
    astral: "\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F]"
  },
  {
    name: "Cypro_Minoan",
    astral: "\uD80B[\uDF90-\uDFF2]"
  },
  {
    name: "Cyrillic",
    bmp: "Ѐ-҄҇-ԯᲀ-ᲈᴫᵸⷠ-ⷿꙀ-ꚟ︮︯"
  },
  {
    name: "Deseret",
    astral: "\uD801[\uDC00-\uDC4F]"
  },
  {
    name: "Devanagari",
    bmp: "ऀ-ॐॕ-ॣ०-ॿ꣠-ꣿ"
  },
  {
    name: "Dives_Akuru",
    astral: "\uD806[\uDD00-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD35\uDD37\uDD38\uDD3B-\uDD46\uDD50-\uDD59]"
  },
  {
    name: "Dogra",
    astral: "\uD806[\uDC00-\uDC3B]"
  },
  {
    name: "Duployan",
    astral: "\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9C-\uDC9F]"
  },
  {
    name: "Egyptian_Hieroglyphs",
    astral: "\uD80C[\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E\uDC30-\uDC38]"
  },
  {
    name: "Elbasan",
    astral: "\uD801[\uDD00-\uDD27]"
  },
  {
    name: "Elymaic",
    astral: "\uD803[\uDFE0-\uDFF6]"
  },
  {
    name: "Ethiopic",
    bmp: "ሀ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚ፝-፼ᎀ-᎙ⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮ",
    astral: "\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]"
  },
  {
    name: "Georgian",
    bmp: "Ⴀ-ჅჇჍა-ჺჼ-ჿᲐ-ᲺᲽ-Ჿⴀ-ⴥⴧⴭ"
  },
  {
    name: "Glagolitic",
    bmp: "Ⰰ-ⱟ",
    astral: "\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]"
  },
  {
    name: "Gothic",
    astral: "\uD800[\uDF30-\uDF4A]"
  },
  {
    name: "Grantha",
    astral: "\uD804[\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]"
  },
  {
    name: "Greek",
    bmp: "Ͱ-ͳ͵-ͷͺ-ͽͿ΄ΆΈ-ΊΌΎ-ΡΣ-ϡϰ-Ͽᴦ-ᴪᵝ-ᵡᵦ-ᵪᶿἀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ῄῆ-ΐῖ-Ί῝-`ῲ-ῴῶ-῾Ωꭥ",
    astral: "\uD800[\uDD40-\uDD8E\uDDA0]|\uD834[\uDE00-\uDE45]"
  },
  {
    name: "Gujarati",
    bmp: "ઁ-ઃઅ-ઍએ-ઑઓ-નપ-રલળવ-હ઼-ૅે-ૉો-્ૐૠ-ૣ૦-૱ૹ-૿"
  },
  {
    name: "Gunjala_Gondi",
    astral: "\uD807[\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD8E\uDD90\uDD91\uDD93-\uDD98\uDDA0-\uDDA9]"
  },
  {
    name: "Gurmukhi",
    bmp: "ਁ-ਃਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹ਼ਾ-ੂੇੈੋ-੍ੑਖ਼-ੜਫ਼੦-੶"
  },
  {
    name: "Han",
    bmp: "⺀-⺙⺛-⻳⼀-⿕々〇〡-〩〸-〻㐀-䶿一-鿿豈-舘並-龎",
    astral: "\uD81B[\uDFE2\uDFE3\uDFF0\uDFF1]|[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]"
  },
  {
    name: "Hangul",
    bmp: "ᄀ-ᇿ〮〯ㄱ-ㆎ㈀-㈞㉠-㉾ꥠ-ꥼ가-힣ힰ-ퟆퟋ-ퟻﾠ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ"
  },
  {
    name: "Hanifi_Rohingya",
    astral: "\uD803[\uDD00-\uDD27\uDD30-\uDD39]"
  },
  {
    name: "Hanunoo",
    bmp: "ᜠ-᜴"
  },
  {
    name: "Hatran",
    astral: "\uD802[\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDCFF]"
  },
  {
    name: "Hebrew",
    bmp: "֑-ׇא-תׯ-״יִ-זּטּ-לּמּנּסּףּפּצּ-ﭏ"
  },
  {
    name: "Hiragana",
    bmp: "ぁ-ゖゝ-ゟ",
    astral: "\uD82C[\uDC01-\uDD1F\uDD50-\uDD52]|🈀"
  },
  {
    name: "Imperial_Aramaic",
    astral: "\uD802[\uDC40-\uDC55\uDC57-\uDC5F]"
  },
  {
    name: "Inherited",
    bmp: "̀-ًͯ҅҆-ٰٕ॑-॔᪰-ᫎ᳐-᳔᳒-᳢᳠-᳨᳭᳴᳸᳹᷀-᷿‌‍⃐-〪⃰-゙゚〭︀-️︠-︭",
    astral: "\uD800[\uDDFD\uDEE0]|𑌻|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD]|\uDB40[\uDD00-\uDDEF]"
  },
  {
    name: "Inscriptional_Pahlavi",
    astral: "\uD802[\uDF60-\uDF72\uDF78-\uDF7F]"
  },
  {
    name: "Inscriptional_Parthian",
    astral: "\uD802[\uDF40-\uDF55\uDF58-\uDF5F]"
  },
  {
    name: "Javanese",
    bmp: "ꦀ-꧍꧐-꧙꧞꧟"
  },
  {
    name: "Kaithi",
    astral: "\uD804[\uDC80-\uDCC2\uDCCD]"
  },
  {
    name: "Kannada",
    bmp: "ಀ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹ಼-ೄೆ-ೈೊ-್ೕೖೝೞೠ-ೣ೦-೯ೱೲ"
  },
  {
    name: "Katakana",
    bmp: "ァ-ヺヽ-ヿㇰ-ㇿ㋐-㋾㌀-㍗ｦ-ｯｱ-ﾝ",
    astral: "\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00\uDD20-\uDD22\uDD64-\uDD67]"
  },
  {
    name: "Kayah_Li",
    bmp: "꤀-꤭꤯"
  },
  {
    name: "Kharoshthi",
    astral: "\uD802[\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE38-\uDE3A\uDE3F-\uDE48\uDE50-\uDE58]"
  },
  {
    name: "Khitan_Small_Script",
    astral: "𖿤|\uD822[\uDF00-\uDFFF]|\uD823[\uDC00-\uDCD5]"
  },
  {
    name: "Khmer",
    bmp: "ក-៝០-៩៰-៹᧠-᧿"
  },
  {
    name: "Khojki",
    astral: "\uD804[\uDE00-\uDE11\uDE13-\uDE3E]"
  },
  {
    name: "Khudawadi",
    astral: "\uD804[\uDEB0-\uDEEA\uDEF0-\uDEF9]"
  },
  {
    name: "Lao",
    bmp: "ກຂຄຆ-ຊຌ-ຣລວ-ຽເ-ໄໆ່-ໍ໐-໙ໜ-ໟ"
  },
  {
    name: "Latin",
    bmp: "A-Za-zªºÀ-ÖØ-öø-ʸˠ-ˤᴀ-ᴥᴬ-ᵜᵢ-ᵥᵫ-ᵷᵹ-ᶾḀ-ỿⁱⁿₐ-ₜKÅℲⅎⅠ-ↈⱠ-ⱿꜢ-ꞇꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꟿꬰ-ꭚꭜ-ꭤꭦ-ꭩﬀ-ﬆＡ-Ｚａ-ｚ",
    astral: "\uD801[\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD837[\uDF00-\uDF1E]"
  },
  {
    name: "Lepcha",
    bmp: "ᰀ-᰷᰻-᱉ᱍ-ᱏ"
  },
  {
    name: "Limbu",
    bmp: "ᤀ-ᤞᤠ-ᤫᤰ-᤻᥀᥄-᥏"
  },
  {
    name: "Linear_A",
    astral: "\uD801[\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]"
  },
  {
    name: "Linear_B",
    astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA]"
  },
  {
    name: "Lisu",
    bmp: "ꓐ-꓿",
    astral: "𑾰"
  },
  {
    name: "Lycian",
    astral: "\uD800[\uDE80-\uDE9C]"
  },
  {
    name: "Lydian",
    astral: "\uD802[\uDD20-\uDD39\uDD3F]"
  },
  {
    name: "Mahajani",
    astral: "\uD804[\uDD50-\uDD76]"
  },
  {
    name: "Makasar",
    astral: "\uD807[\uDEE0-\uDEF8]"
  },
  {
    name: "Malayalam",
    bmp: "ഀ-ഌഎ-ഐഒ-ൄെ-ൈൊ-൏ൔ-ൣ൦-ൿ"
  },
  {
    name: "Mandaic",
    bmp: "ࡀ-࡛࡞"
  },
  {
    name: "Manichaean",
    astral: "\uD802[\uDEC0-\uDEE6\uDEEB-\uDEF6]"
  },
  {
    name: "Marchen",
    astral: "\uD807[\uDC70-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]"
  },
  {
    name: "Masaram_Gondi",
    astral: "\uD807[\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD50-\uDD59]"
  },
  {
    name: "Medefaidrin",
    astral: "\uD81B[\uDE40-\uDE9A]"
  },
  {
    name: "Meetei_Mayek",
    bmp: "ꫠ-꫶ꯀ-꯭꯰-꯹"
  },
  {
    name: "Mende_Kikakui",
    astral: "\uD83A[\uDC00-\uDCC4\uDCC7-\uDCD6]"
  },
  {
    name: "Meroitic_Cursive",
    astral: "\uD802[\uDDA0-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDDFF]"
  },
  {
    name: "Meroitic_Hieroglyphs",
    astral: "\uD802[\uDD80-\uDD9F]"
  },
  {
    name: "Miao",
    astral: "\uD81B[\uDF00-\uDF4A\uDF4F-\uDF87\uDF8F-\uDF9F]"
  },
  {
    name: "Modi",
    astral: "\uD805[\uDE00-\uDE44\uDE50-\uDE59]"
  },
  {
    name: "Mongolian",
    bmp: "᠀᠁᠄᠆-᠙ᠠ-ᡸᢀ-ᢪ",
    astral: "\uD805[\uDE60-\uDE6C]"
  },
  {
    name: "Mro",
    astral: "\uD81A[\uDE40-\uDE5E\uDE60-\uDE69\uDE6E\uDE6F]"
  },
  {
    name: "Multani",
    astral: "\uD804[\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA9]"
  },
  {
    name: "Myanmar",
    bmp: "က-႟ꧠ-ꧾꩠ-ꩿ"
  },
  {
    name: "Nabataean",
    astral: "\uD802[\uDC80-\uDC9E\uDCA7-\uDCAF]"
  },
  {
    name: "Nandinagari",
    astral: "\uD806[\uDDA0-\uDDA7\uDDAA-\uDDD7\uDDDA-\uDDE4]"
  },
  {
    name: "New_Tai_Lue",
    bmp: "ᦀ-ᦫᦰ-ᧉ᧐-᧚᧞᧟"
  },
  {
    name: "Newa",
    astral: "\uD805[\uDC00-\uDC5B\uDC5D-\uDC61]"
  },
  {
    name: "Nko",
    bmp: "߀-ߺ߽-߿"
  },
  {
    name: "Nushu",
    astral: "𖿡|\uD82C[\uDD70-\uDEFB]"
  },
  {
    name: "Nyiakeng_Puachue_Hmong",
    astral: "\uD838[\uDD00-\uDD2C\uDD30-\uDD3D\uDD40-\uDD49\uDD4E\uDD4F]"
  },
  {
    name: "Ogham",
    bmp: " -᚜"
  },
  {
    name: "Ol_Chiki",
    bmp: "᱐-᱿"
  },
  {
    name: "Old_Hungarian",
    astral: "\uD803[\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDCFF]"
  },
  {
    name: "Old_Italic",
    astral: "\uD800[\uDF00-\uDF23\uDF2D-\uDF2F]"
  },
  {
    name: "Old_North_Arabian",
    astral: "\uD802[\uDE80-\uDE9F]"
  },
  {
    name: "Old_Permic",
    astral: "\uD800[\uDF50-\uDF7A]"
  },
  {
    name: "Old_Persian",
    astral: "\uD800[\uDFA0-\uDFC3\uDFC8-\uDFD5]"
  },
  {
    name: "Old_Sogdian",
    astral: "\uD803[\uDF00-\uDF27]"
  },
  {
    name: "Old_South_Arabian",
    astral: "\uD802[\uDE60-\uDE7F]"
  },
  {
    name: "Old_Turkic",
    astral: "\uD803[\uDC00-\uDC48]"
  },
  {
    name: "Old_Uyghur",
    astral: "\uD803[\uDF70-\uDF89]"
  },
  {
    name: "Oriya",
    bmp: "ଁ-ଃଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହ଼-ୄେୈୋ-୍୕-ୗଡ଼ଢ଼ୟ-ୣ୦-୷"
  },
  {
    name: "Osage",
    astral: "\uD801[\uDCB0-\uDCD3\uDCD8-\uDCFB]"
  },
  {
    name: "Osmanya",
    astral: "\uD801[\uDC80-\uDC9D\uDCA0-\uDCA9]"
  },
  {
    name: "Pahawh_Hmong",
    astral: "\uD81A[\uDF00-\uDF45\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]"
  },
  {
    name: "Palmyrene",
    astral: "\uD802[\uDC60-\uDC7F]"
  },
  {
    name: "Pau_Cin_Hau",
    astral: "\uD806[\uDEC0-\uDEF8]"
  },
  {
    name: "Phags_Pa",
    bmp: "ꡀ-꡷"
  },
  {
    name: "Phoenician",
    astral: "\uD802[\uDD00-\uDD1B\uDD1F]"
  },
  {
    name: "Psalter_Pahlavi",
    astral: "\uD802[\uDF80-\uDF91\uDF99-\uDF9C\uDFA9-\uDFAF]"
  },
  {
    name: "Rejang",
    bmp: "ꤰ-꥓꥟"
  },
  {
    name: "Runic",
    bmp: "ᚠ-ᛪᛮ-ᛸ"
  },
  {
    name: "Samaritan",
    bmp: "ࠀ-࠭࠰-࠾"
  },
  {
    name: "Saurashtra",
    bmp: "ꢀ-ꣅ꣎-꣙"
  },
  {
    name: "Sharada",
    astral: "\uD804[\uDD80-\uDDDF]"
  },
  {
    name: "Shavian",
    astral: "\uD801[\uDC50-\uDC7F]"
  },
  {
    name: "Siddham",
    astral: "\uD805[\uDD80-\uDDB5\uDDB8-\uDDDD]"
  },
  {
    name: "SignWriting",
    astral: "\uD836[\uDC00-\uDE8B\uDE9B-\uDE9F\uDEA1-\uDEAF]"
  },
  {
    name: "Sinhala",
    bmp: "ඁ-ඃඅ-ඖක-නඳ-රලව-ෆ්ා-ුූෘ-ෟ෦-෯ෲ-෴",
    astral: "\uD804[\uDDE1-\uDDF4]"
  },
  {
    name: "Sogdian",
    astral: "\uD803[\uDF30-\uDF59]"
  },
  {
    name: "Sora_Sompeng",
    astral: "\uD804[\uDCD0-\uDCE8\uDCF0-\uDCF9]"
  },
  {
    name: "Soyombo",
    astral: "\uD806[\uDE50-\uDEA2]"
  },
  {
    name: "Sundanese",
    bmp: "ᮀ-ᮿ᳀-᳇"
  },
  {
    name: "Syloti_Nagri",
    bmp: "ꠀ-꠬"
  },
  {
    name: "Syriac",
    bmp: "܀-܍܏-݊ݍ-ݏࡠ-ࡪ"
  },
  {
    name: "Tagalog",
    bmp: "ᜀ-᜕ᜟ"
  },
  {
    name: "Tagbanwa",
    bmp: "ᝠ-ᝬᝮ-ᝰᝲᝳ"
  },
  {
    name: "Tai_Le",
    bmp: "ᥐ-ᥭᥰ-ᥴ"
  },
  {
    name: "Tai_Tham",
    bmp: "ᨠ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪠-᪭"
  },
  {
    name: "Tai_Viet",
    bmp: "ꪀ-ꫂꫛ-꫟"
  },
  {
    name: "Takri",
    astral: "\uD805[\uDE80-\uDEB9\uDEC0-\uDEC9]"
  },
  {
    name: "Tamil",
    bmp: "ஂஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹா-ூெ-ைொ-்ௐௗ௦-௺",
    astral: "\uD807[\uDFC0-\uDFF1\uDFFF]"
  },
  {
    name: "Tangsa",
    astral: "\uD81A[\uDE70-\uDEBE\uDEC0-\uDEC9]"
  },
  {
    name: "Tangut",
    astral: "𖿠|[\uD81C-\uD820][\uDC00-\uDFFF]|\uD821[\uDC00-\uDFF7]|\uD822[\uDC00-\uDEFF]|\uD823[\uDD00-\uDD08]"
  },
  {
    name: "Telugu",
    bmp: "ఀ-ఌఎ-ఐఒ-నప-హ఼-ౄె-ైొ-్ౕౖౘ-ౚౝౠ-ౣ౦-౯౷-౿"
  },
  {
    name: "Thaana",
    bmp: "ހ-ޱ"
  },
  {
    name: "Thai",
    bmp: "ก-ฺเ-๛"
  },
  {
    name: "Tibetan",
    bmp: "ༀ-ཇཉ-ཬཱ-ྗྙ-ྼ྾-࿌࿎-࿔࿙࿚"
  },
  {
    name: "Tifinagh",
    bmp: "ⴰ-ⵧⵯ⵰⵿"
  },
  {
    name: "Tirhuta",
    astral: "\uD805[\uDC80-\uDCC7\uDCD0-\uDCD9]"
  },
  {
    name: "Toto",
    astral: "\uD838[\uDE90-\uDEAE]"
  },
  {
    name: "Ugaritic",
    astral: "\uD800[\uDF80-\uDF9D\uDF9F]"
  },
  {
    name: "Vai",
    bmp: "ꔀ-ꘫ"
  },
  {
    name: "Vithkuqi",
    astral: "\uD801[\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC]"
  },
  {
    name: "Wancho",
    astral: "\uD838[\uDEC0-\uDEF9\uDEFF]"
  },
  {
    name: "Warang_Citi",
    astral: "\uD806[\uDCA0-\uDCF2\uDCFF]"
  },
  {
    name: "Yezidi",
    astral: "\uD803[\uDE80-\uDEA9\uDEAB-\uDEAD\uDEB0\uDEB1]"
  },
  {
    name: "Yi",
    bmp: "ꀀ-ꒌ꒐-꓆"
  },
  {
    name: "Zanabazar_Square",
    astral: "\uD806[\uDE00-\uDE47]"
  }
];
const EH = /* @__PURE__ */ is(yH);
/*!
 * XRegExp Unicode Scripts 5.1.1
 * <xregexp.com>
 * Steven Levithan (c) 2010-present MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */
const CH = (e) => {
  if (!e.addUnicodeData)
    throw new ReferenceError("Unicode Base must be loaded before Unicode Scripts");
  e.addUnicodeData(EH, "Script");
};
hH(We);
fH(We);
gH(We);
kH(We);
DH(We);
CH(We);
const hE = /* @__PURE__ */ new WeakMap();
function xH(e, t) {
  if (!t || e === t.replaceWith)
    return e;
  const r = t.replaceIfFirstWord !== !1, i = t.isCaseSensitive ? "g" : "gi";
  if (t.matchingRule.ruleType === "Regex") {
    let n = hE.get(t.matchingRule);
    return n || (n = We(t.matchingRule.pattern, i), hE.set(t.matchingRule, n)), We.replace(e, n, t.replaceWith);
  }
  if (t.matchingRule.ruleType === "Substring") {
    const n = t.matchingRule, a = We.escape(n.string), o = n.useExactWordMatch === !1 ? a : `\\b${a}\\b`;
    return !r && new RegExp(`^${o}\\b`, "i").test(e) ? e : e.replace(new RegExp(o, i), t.replaceWith);
  }
  return e;
}
function aA({
  input: e,
  stringReplacementRules: t,
  applyRulePredicate: r
}) {
  if (!e)
    return e;
  for (const i of t)
    r(i) && (e = xH(e, i));
  return e.trim();
}
function AH(e) {
  const t = [], r = ["API", "Docs", "Documentation", "Blogs"];
  e && r.push(e);
  const i = "gi", n = ["\\|", "-", ":"];
  for (const a of r) {
    const o = `^\\s*${a}(\\.\\w+)?\\s*(${n.join(
      "|"
    )})\\s*`, s = `\\s*(${n.join(
      "|"
    )})\\s*${a}.*$`, l = {
      matchingRule: {
        ruleType: "Regex",
        pattern: o,
        flags: i
      },
      replaceWith: ""
    }, u = {
      matchingRule: {
        ruleType: "Regex",
        pattern: s,
        flags: i
      },
      replaceWith: "",
      replaceInTitles: !0
    };
    t.push(l, u);
  }
  return t;
}
function fE({
  title: e,
  stringReplacementRules: t
}) {
  return aA({
    input: e,
    stringReplacementRules: t,
    applyRulePredicate: (r) => r.replaceInTitles !== !1
  });
}
const gE = {
  js: ".js",
  db: "DB",
  sql: "SQL"
}, wH = (e) => e === "js" ? `(^|[^.]|\\s)${e}$` : `\\b${e}$`, FH = (e) => ({
  ruleType: "Regex",
  pattern: e
}), TH = () => Object.keys(gE).map((t) => {
  const r = wH(t);
  return {
    matchingRule: FH(r),
    replaceWith: gE[t],
    replaceInBreadCrumbs: !0
  };
}), SH = TH(), oA = [
  "a",
  "an",
  "the",
  "and",
  "as",
  "but",
  "or",
  "nor",
  "at",
  "by",
  "in",
  "of",
  "on",
  "per",
  "to",
  "up",
  "via",
  "vs",
  "with",
  "is",
  "it",
  "for",
  "are",
  "not",
  "out",
  "off",
  "yet",
  "so",
  "be",
  "if",
  "has",
  "its",
  "we",
  "our",
  "any",
  "all",
  "how",
  "her",
  "his",
  "their",
  "was",
  "were"
], IH = [
  "BaaS",
  "SaaS",
  "PaaS",
  "IaaS",
  "HTML",
  "JSON",
  "HTTPS",
  "HTTP",
  "SMTP",
  "DBMS",
  "RDBMS",
  "REST",
  "SOAP",
  "MVVM",
  "VoIP",
  "RFID",
  "WYSIWYG",
  "WLAN",
  "OIDC",
  "SAML",
  "LDAP",
  "IPSec",
  "OAuth",
  "OpenID",
  "SFTP",
  "IMAP",
  "RTSP",
  "DHCP",
  "XMPP",
  "SNMP",
  "ICMP",
  "IGMP",
  "RARP",
  "PPTP",
  "L2TP",
  "IPv4",
  "IPv6",
  "TOTP",
  "HMAC",
  "TFTP",
  "CORS",
  "CSRF",
  "DDOS",
  "YAML",
  "MQTT",
  "AMQP",
  "HDLC",
  "EDIFACT",
  "DICOM",
  "MATLAB",
  "UNIX",
  "HDMI",
  "WiFi",
  "WPA2",
  "DDoS",
  "ipadOS",
  "watchOS",
  "macOS",
  "JavaScript",
  "TypeScript",
  "SSO",
  "IDP",
  "RBAC"
], BH = [
  "API",
  "AWS",
  "GCP",
  "SQL",
  "CSS",
  "JS",
  "JDK",
  "SDK",
  "JRE",
  "IDE",
  "XML",
  "GUI",
  "CLI",
  "AI",
  "ML",
  "DL",
  "IoT",
  "TCP",
  "UDP",
  "IP",
  "FTP",
  "RAM",
  "ROM",
  "SSD",
  "HDD",
  "VPS",
  "VPN",
  "OS",
  "UI",
  "UX",
  "DB",
  "OOP",
  "CRM",
  "ERP",
  "POS",
  "CAD",
  "BI",
  "CMS",
  "SEO",
  "SEM",
  "PPC",
  "B2B",
  "B2C",
  "SMB",
  "ROI",
  "KPI",
  "CTA",
  "CPC",
  "CPM",
  "CDN",
  "MVC",
  "FAQ",
  "LMS",
  "RPA",
  "QA",
  "QC",
  "CRO",
  "SVN",
  "GIT",
  "DOM",
  "DNS",
  "ISP",
  "URL",
  "URN",
  "URI",
  "SIP",
  "NFC",
  "LTE",
  "OSI",
  "RAS",
  "DRM",
  "DOS",
  "WWW",
  "LAN",
  "WAN",
  "SAN",
  "NAS",
  "NLP",
  "OCR",
  "IBM",
  "HP",
  "SAP",
  "JWT",
  "SSH",
  "SSL",
  "TLS",
  "POP",
  "NTP",
  "BGP",
  "ARP",
  "2FA",
  "MFA",
  "RDP",
  "VNC",
  "SCP",
  "PKI",
  "XSS",
  "DoS",
  "CSV",
  "HL7",
  "SOP",
  "PHP",
  "JSP",
  "NET",
  "VBA",
  "iOS",
  "GNU",
  "CPU",
  "GPU",
  "NIC",
  "USB",
  "VGA",
  "AES",
  "RSA",
  "DES",
  "ECC",
  "WEP",
  "WPA",
  "IDS",
  "IPS",
  "PM",
  "HR",
  "TCO",
  "BPM",
  "SLA",
  "SOW",
  "AR",
  "VR",
  "XR",
  "3D",
  "2D",
  "4D",
  "iOS",
  "OpenAPI",
  "SSO"
];
function pk({ word: e, overrides: t = {} }) {
  return {
    matchingRule: {
      ruleType: "Substring",
      string: e,
      useExactWordMatch: !0
    },
    replaceWith: e,
    isCaseSensitive: !1,
    replaceInBreadCrumbs: !0,
    replaceInTitles: !1,
    ...t
    // Apply any overrides provided
  };
}
const RH = [
  ...oA.map((e) => pk({ word: e, overrides: { replaceIfFirstWord: !1 } })),
  ...IH.map((e) => pk({ word: e })),
  ...BH.map((e) => pk({ word: e }))
], OH = RH, PH = [
  ...OH,
  ...SH
];
function NH(e) {
  const t = e.split(" ");
  for (const r of t)
    if (r[0] !== r[0].toUpperCase() || r.slice(1) !== r.slice(1).toLowerCase())
      return !1;
  return !0;
}
function zH(e) {
  return NH(e) ? null : {
    matchingRule: {
      ruleType: "Substring",
      string: e,
      useExactWordMatch: !0
    },
    replaceWith: e,
    isCaseSensitive: !1,
    replaceInBreadCrumbs: !0,
    replaceInTitles: !1
  };
}
const [LH, MH] = nm({
  strict: !1,
  name: "PortalContext"
}), sA = kn(
  void 0
), Xi = () => {
  const e = Pn(sA);
  if (e === void 0)
    throw new Error(
      "useInkeepBaseContext must be used within a Inkeep Widget provider"
    );
  return e;
}, vm = ({
  children: e,
  interactionType: t,
  ...r
}) => {
  const { organizationDisplayName: i } = r, n = i ? zH(i) : null, a = tH(), o = r.tags ?? a, s = [
    ...n ? [n] : [],
    ...PH,
    ...r.stringReplacementRules ?? [],
    ...i ? AH(i) : []
  ], l = r.theme ?? {}, u = O6(), d = r.shadowHost ?? (u == null ? void 0 : u.shadowHost), c = r.rootElement ?? (u == null ? void 0 : u.rootElement);
  return /* @__PURE__ */ v.jsx(
    sA.Provider,
    {
      value: {
        ...r,
        shadowHost: d,
        rootElement: c,
        interactionType: t,
        stringReplacementRules: s,
        tags: o
      },
      children: /* @__PURE__ */ v.jsx(BO, { value: d == null ? void 0 : d.shadowRoot, children: /* @__PURE__ */ v.jsx(LH, { value: { host: c }, children: /* @__PURE__ */ v.jsx(dR, { value: (l == null ? void 0 : l.components) ?? {}, children: e }) }) })
    }
  );
}, jH = () => {
  try {
    if (typeof localStorage > "u")
      return !1;
    const e = "__df709c5b-6651-43dc-94e7-d8dc899bf4e8__";
    return localStorage.setItem(e, "test_value"), localStorage.removeItem(e), !0;
  } catch {
    return !1;
  }
}, HH = () => {
  if (typeof document > "u")
    return !1;
  document.cookie = "testcookie=true; Path=/; Max-Age=1000";
  const e = document.cookie.includes("testcookie=true");
  return document.cookie = "testcookie=; Path=/; Max-Age=-1000", e;
}, qb = () => {
  const e = jH(), t = HH();
  return e && t;
}, m1 = "inkeepUsagePreferences", $H = {
  chatMode: "AUTO",
  hasSwitchModeButtonJiggled: !1,
  userId: null
  // widgetColorMode: null,
}, lA = {
  defaultView: null,
  inkeepChatSessionId: null
}, hk = {
  ...$H,
  ...lA
};
function uA(e, t, r = 365) {
  try {
    if (typeof document > "u")
      return t;
    const i = /* @__PURE__ */ new Date();
    t === void 0 ? (console.log("clearing cookie"), i.setTime(i.getTime() - 1), r = -1, t = "") : i.setTime(i.getTime() + r * 24 * 60 * 60 * 1e3);
    const n = `; expires=${i.toUTCString()}`, a = `; domain=${document.location.hostname}`, o = "; path=/";
    return document.cookie = `${m1}_${e}=${t}${n}${a}${o}`, t;
  } catch {
    return t;
  }
}
function UH(e) {
  if (typeof document > "u")
    return null;
  const t = `${m1}_${e}=`, r = document.cookie.split(";");
  for (let i = 0; i < r.length; i++) {
    let n = r[i];
    for (; n.startsWith(" "); )
      n = n.substring(1, n.length);
    if (n.startsWith(t))
      return n.substring(t.length, n.length);
  }
  return null;
}
function VH(e, t) {
  try {
    return typeof sessionStorage < "u" && (t === void 0 ? sessionStorage.removeItem(`${m1}_${e}`) : sessionStorage.setItem(
      `${m1}_${e}`,
      JSON.stringify(t)
    )), t;
  } catch {
    return t;
  }
}
function WH(e) {
  let t = null;
  try {
    return typeof sessionStorage < "u" && (t = sessionStorage.getItem(`${m1}_${e}`)), t != null && t !== "undefined" ? JSON.parse(t) : null;
  } catch {
    return null;
  }
}
const GH = (e) => e === "cookie" ? uA : VH, KH = (e) => e === "cookie" ? UH : WH, Ql = () => {
  const {
    optOutAllAnalytics: e,
    optOutFunctionalCookies: t,
    integrationId: r,
    interactionType: i
  } = Xi(), a = !e && !t && qb() ? "cookie" : "sessionStorage", o = `${r}-${i}`, s = (p) => Object.keys(lA).includes(p) ? `${p}-${o}` : p, l = Object.keys(
    hk
  ).reduce((p, f) => {
    const g = s(f), k = KH(a)(g);
    return {
      ...p,
      [f]: k
    };
  }, hk), [u, d] = rt(
    l
  ), c = (p, f, g = 365) => {
    const k = s(p);
    GH(a)(k, f, g), d((y) => ({
      ...y,
      [p]: f
    }));
  };
  return gt(() => {
    t && Object.keys(hk).forEach((p) => {
      const f = s(p);
      uA(f, null, -1);
    });
  }, [t]), [u, c];
}, cA = kn(
  void 0
), Qr = () => {
  const e = Pn(cA);
  if (e === void 0)
    throw new Error(
      "useInkeepAIChatContext must be used within a InkeepAIChat provider"
    );
  return e;
}, z2 = ({
  children: e,
  ...t
}) => {
  const [r] = Ql(), [i, n] = rt(
    r.chatMode || t.defaultChatMode || "AUTO"
  ), a = qt(void 0);
  gt(() => {
    r.chatMode && a.current === null && n(r.chatMode), a.current = r.chatMode;
  }, [r.chatMode]);
  const o = Jt(
    () => ({
      ...t,
      chatMode: i,
      setChatMode: n
    }),
    [t, i, n]
  );
  return /* @__PURE__ */ v.jsx(cA.Provider, { value: o, children: e });
}, dA = kn(
  void 0
), Ka = () => {
  const e = Pn(dA);
  if (e === void 0)
    throw new Error(
      "useInkeepModalContext must be used within a InkeepCustomTrigger provider"
    );
  return e;
}, L2 = ({
  children: e,
  ...t
}) => /* @__PURE__ */ v.jsx(dA.Provider, { value: t, children: e }), pA = kn(
  void 0
), nc = () => {
  const e = Pn(pA);
  if (e === void 0)
    throw new Error(
      "useInkeepSearchContext must be used within a InkeepSearch provider"
    );
  return e;
}, M2 = ({
  children: e,
  ...t
}) => /* @__PURE__ */ v.jsx(pA.Provider, { value: { ...t }, children: e }), Fg = ["light", "dark"], j2 = "(prefers-color-scheme: dark)", YH = typeof window > "u", km = kn(
  void 0
), qH = {
  setColorMode: (e) => {
  },
  colorModes: []
}, QH = () => Pn(km) ?? qH;
function ia(e, t) {
  const r = QH();
  return (r.forcedColorMode ?? r.resolvedColorMode) === "dark" ? t : e;
}
const XH = (e) => Pn(km) ? /* @__PURE__ */ v.jsx(UT, { children: e.children }) : /* @__PURE__ */ v.jsx(r$, { ...e }), ZH = () => {
}, JH = {
  setColorMode: ZH,
  colorModes: ["dark"],
  colorMode: "dark",
  forcedColorMode: "dark",
  resolvedColorMode: "dark",
  systemColorMode: "dark"
}, e$ = ({
  children: e
}) => /* @__PURE__ */ v.jsx(km.Provider, { value: JH, children: /* @__PURE__ */ v.jsx("div", { "data-theme": "dark", children: e }) }), t$ = ["light", "dark"], r$ = ({
  forcedColorMode: e,
  disableTransitionOnChange: t = !1,
  enableSystem: r = !1,
  enableColorScheme: i = !0,
  storageKey: n = "inkeep-colorMode",
  colorModes: a = t$,
  defaultColorMode: o = r ? "system" : "light",
  attribute: s = "data-theme",
  value: l,
  children: u,
  nonce: d,
  shadowHostId: c,
  rootId: p
}) => {
  const [f, g] = rt(
    () => mE(n, o)
  ), [k, y] = rt(
    () => mE(n)
  ), _ = l ? Object.values(l) : a, A = Nt((B) => {
    var j;
    let M = B;
    if (!M)
      return;
    B === "system" && r && (M = vE());
    const X = l ? l[M] : M, U = t ? n$() : null, K = c && p && ((j = document.getElementById(c)) == null ? void 0 : j.shadowRoot), z = K ? K.getElementById(p) ?? document.documentElement : document.documentElement;
    if (s === "class" ? (z.classList.remove(..._), X && z.classList.add(X)) : X ? z.setAttribute(s, X) : z.removeAttribute(s), i) {
      const J = Fg.includes(o) ? o : null, ie = Fg.includes(M) ? M : J;
      z.style.colorScheme = ie;
    }
    U == null || U();
  }, []), T = Nt(
    (B) => {
      g(B);
      try {
        localStorage.setItem(n, B);
      } catch {
      }
    },
    [e]
  ), N = Nt(
    (B) => {
      const M = vE(B);
      y(M), f === "system" && r && !e && A("system");
    },
    [f, e]
  );
  gt(() => {
    const B = window.matchMedia(j2);
    return B.addListener(N), N(B), () => B.removeListener(N);
  }, [N]), gt(() => {
    const B = (M) => {
      if (M.key !== n)
        return;
      const X = M.newValue || o;
      T(X);
    };
    return window.addEventListener("storage", B), () => window.removeEventListener("storage", B);
  }, [T]), gt(() => {
    A(e ?? f);
  }, [e, f]);
  const P = Jt(
    () => ({
      colorMode: f,
      setColorMode: T,
      forcedColorMode: e,
      resolvedColorMode: f === "system" ? k : f,
      colorModes: r ? [...a, "system"] : a,
      systemColorMode: r ? k : void 0
    }),
    [
      f,
      T,
      e,
      k,
      r,
      a
    ]
  );
  return /* @__PURE__ */ v.jsxs(km.Provider, { value: P, children: [
    /* @__PURE__ */ v.jsx(
      i$,
      {
        forcedColorMode: e,
        disableTransitionOnChange: t,
        enableSystem: r,
        enableColorScheme: i,
        storageKey: n,
        colorModes: a,
        defaultColorMode: o,
        attribute: s,
        value: l,
        children: u,
        attrs: _,
        nonce: d,
        shadowHostId: c,
        rootId: p
      }
    ),
    u
  ] });
}, i$ = VT(
  ({
    forcedColorMode: e,
    storageKey: t,
    attribute: r,
    enableSystem: i,
    enableColorScheme: n,
    defaultColorMode: a,
    value: o,
    attrs: s,
    nonce: l,
    shadowHostId: u,
    rootId: d
  }) => {
    const c = a === "system", p = (() => {
      const y = u && d ? `document.getElementById('${u}').shadowRoot.getElementById('${d}')` : "document.documentElement";
      if (r === "class") {
        const _ = `c.remove(${s.map((A) => `'${A}'`).join(",")})`;
        return `var d=${y},c=d.classList;${_};`;
      } else
        return `var d=${y},n='${r}',s='setAttribute';`;
    })(), f = (() => n ? (Fg.includes(a) ? a : null) ? `if(e==='light'||e==='dark'||!e)d.style.colorScheme=e||'${a}'` : "if(e==='light'||e==='dark')d.style.colorScheme=e" : "")(), g = (y, _ = !1, A = !0) => {
      const T = o ? o[y] : y, N = _ ? y + "|| ''" : `'${T}'`;
      let P = "";
      return n && A && !_ && Fg.includes(y) && (P += `d.style.colorScheme = '${y}';`), r === "class" ? _ || T ? P += `c.add(${N})` : P += "null" : T && (P += `d[s](n,${N})`), P;
    }, k = (() => e ? `!function(){${p}${g(e)}}()` : i ? `!function(){try{${p}var e=localStorage.getItem('${t}');if('system'===e||(!e&&${c})){var t='${j2}',m=window.matchMedia(t);if(m.media!==t||m.matches){${g(
      "dark"
    )}}else{${g("light")}}}else if(e){${o ? `var x=${JSON.stringify(o)};` : ""}${g(o ? "x[e]" : "e", !0)}}${c ? "" : "else{" + g(a, !1, !1) + "}"}${f}}catch(e){}}()` : `!function(){try{${p}var e=localStorage.getItem('${t}');if(e){${o ? `var x=${JSON.stringify(o)};` : ""}${g(o ? "x[e]" : "e", !0)}}else{${g(
      a,
      !1,
      !1
    )};}${f}}catch(t){}}();`)();
    return /* @__PURE__ */ v.jsx("script", { nonce: l, dangerouslySetInnerHTML: { __html: k } });
  },
  // Never re-render this component
  () => !0
), mE = (e, t) => {
  if (YH)
    return;
  let r;
  try {
    r = localStorage.getItem(e) || void 0;
  } catch {
  }
  return r || t;
}, n$ = () => {
  const e = document.createElement("style");
  return e.appendChild(
    document.createTextNode(
      "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}"
    )
  ), document.head.appendChild(e), () => {
    window.getComputedStyle(document.body), setTimeout(() => {
      document.head.removeChild(e);
    }, 1);
  };
}, vE = (e) => (e || (e = window.matchMedia(j2)), e.matches ? "dark" : "light");
function Li(e, t) {
  let r = e.length;
  Array.isArray(e[0]) || (e = [e]), Array.isArray(t[0]) || (t = t.map((o) => [o]));
  let i = t[0].length, n = t[0].map((o, s) => t.map((l) => l[s])), a = e.map((o) => n.map((s) => {
    let l = 0;
    if (!Array.isArray(o)) {
      for (let u of s)
        l += o * u;
      return l;
    }
    for (let u = 0; u < o.length; u++)
      l += o[u] * (s[u] || 0);
    return l;
  }));
  return r === 1 && (a = a[0]), i === 1 ? a.map((o) => o[0]) : a;
}
function j1(e) {
  return Fl(e) === "string";
}
function Fl(e) {
  return (Object.prototype.toString.call(e).match(/^\[object\s+(.*?)\]$/)[1] || "").toLowerCase();
}
function Tg(e, t) {
  e = +e, t = +t;
  let r = (Math.floor(e) + "").length;
  if (t > r)
    return +e.toFixed(t - r);
  {
    let i = 10 ** (r - t);
    return Math.round(e / i) * i;
  }
}
function hA(e) {
  if (!e)
    return;
  e = e.trim();
  const t = /^([a-z]+)\((.+?)\)$/i, r = /^-?[\d.]+$/;
  let i = e.match(t);
  if (i) {
    let n = [];
    return i[2].replace(/\/?\s*([-\w.]+(?:%|deg)?)/g, (a, o) => {
      /%$/.test(o) ? (o = new Number(o.slice(0, -1) / 100), o.type = "<percentage>") : /deg$/.test(o) ? (o = new Number(+o.slice(0, -3)), o.type = "<angle>", o.unit = "deg") : r.test(o) && (o = new Number(o), o.type = "<number>"), a.startsWith("/") && (o = o instanceof Number ? o : new Number(o), o.alpha = !0), n.push(o);
    }), {
      name: i[1].toLowerCase(),
      rawName: i[1],
      rawArgs: i[2],
      // An argument could be (as of css-color-4):
      // a number, percentage, degrees (hue), ident (in color())
      args: n
    };
  }
}
function fA(e) {
  return e[e.length - 1];
}
function Sg(e, t, r) {
  return isNaN(e) ? t : isNaN(t) ? e : e + (t - e) * r;
}
function gA(e, t, r) {
  return (r - e) / (t - e);
}
function H2(e, t, r) {
  return Sg(t[0], t[1], gA(e[0], e[1], r));
}
function mA(e) {
  return e.map((t) => t.split("|").map((r) => {
    r = r.trim();
    let i = r.match(/^(<[a-z]+>)\[(-?[.\d]+),\s*(-?[.\d]+)\]?$/);
    if (i) {
      let n = new String(i[1]);
      return n.range = [+i[2], +i[3]], n;
    }
    return r;
  }));
}
var a$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  interpolate: Sg,
  interpolateInv: gA,
  isString: j1,
  last: fA,
  mapRange: H2,
  multiplyMatrices: Li,
  parseCoordGrammar: mA,
  parseFunction: hA,
  toPrecision: Tg,
  type: Fl
});
class o$ {
  add(t, r, i) {
    if (typeof arguments[0] != "string") {
      for (var t in arguments[0])
        this.add(t, arguments[0][t], arguments[1]);
      return;
    }
    (Array.isArray(t) ? t : [t]).forEach(function(n) {
      this[n] = this[n] || [], r && this[n][i ? "unshift" : "push"](r);
    }, this);
  }
  run(t, r) {
    this[t] = this[t] || [], this[t].forEach(function(i) {
      i.call(r && r.context ? r.context : r, r);
    });
  }
}
const Ol = new o$();
var Jo = {
  gamut_mapping: "lch.c",
  precision: 5,
  deltaE: "76"
  // Default deltaE method
};
const ko = {
  // for compatibility, the four-digit chromaticity-derived ones everyone else uses
  D50: [0.3457 / 0.3585, 1, (1 - 0.3457 - 0.3585) / 0.3585],
  D65: [0.3127 / 0.329, 1, (1 - 0.3127 - 0.329) / 0.329]
};
function Qb(e) {
  return Array.isArray(e) ? e : ko[e];
}
function Ig(e, t, r, i = {}) {
  if (e = Qb(e), t = Qb(t), !e || !t)
    throw new TypeError(`Missing white point to convert ${e ? "" : "from"}${!e && !t ? "/" : ""}${t ? "" : "to"}`);
  if (e === t)
    return r;
  let n = { W1: e, W2: t, XYZ: r, options: i };
  if (Ol.run("chromatic-adaptation-start", n), n.M || (n.W1 === ko.D65 && n.W2 === ko.D50 ? n.M = [
    [1.0479298208405488, 0.022946793341019088, -0.05019222954313557],
    [0.029627815688159344, 0.990434484573249, -0.01707382502938514],
    [-0.009243058152591178, 0.015055144896577895, 0.7518742899580008]
  ] : n.W1 === ko.D50 && n.W2 === ko.D65 && (n.M = [
    [0.9554734527042182, -0.023098536874261423, 0.0632593086610217],
    [-0.028369706963208136, 1.0099954580058226, 0.021041398966943008],
    [0.012314001688319899, -0.020507696433477912, 1.3303659366080753]
  ])), Ol.run("chromatic-adaptation-end", n), n.M)
    return Li(n.M, n.XYZ);
  throw new TypeError("Only Bradford CAT with white points D50 and D65 supported for now.");
}
const s$ = 75e-6, ba = class ba {
  constructor(t) {
    var n, a, o;
    this.id = t.id, this.name = t.name, this.base = t.base ? ba.get(t.base) : null, this.aliases = t.aliases, this.base && (this.fromBase = t.fromBase, this.toBase = t.toBase);
    let r = t.coords ?? this.base.coords;
    for (let s in r)
      "name" in r[s] || (r[s].name = s);
    this.coords = r;
    let i = t.white ?? this.base.white ?? "D65";
    this.white = Qb(i), this.formats = t.formats ?? {};
    for (let s in this.formats) {
      let l = this.formats[s];
      l.type || (l.type = "function"), l.name || (l.name = s);
    }
    t.cssId && !((n = this.formats.functions) != null && n.color) ? (this.formats.color = { id: t.cssId }, Object.defineProperty(this, "cssId", { value: t.cssId })) : (a = this.formats) != null && a.color && !((o = this.formats) != null && o.color.id) && (this.formats.color.id = this.id), this.referred = t.referred, Object.defineProperty(this, "path", {
      value: l$(this).reverse(),
      writable: !1,
      enumerable: !0,
      configurable: !0
    }), Ol.run("colorspace-init-end", this);
  }
  inGamut(t, { epsilon: r = s$ } = {}) {
    if (this.isPolar)
      return t = this.toBase(t), this.base.inGamut(t, { epsilon: r });
    let i = Object.values(this.coords);
    return t.every((n, a) => {
      let o = i[a];
      if (o.type !== "angle" && o.range) {
        if (Number.isNaN(n))
          return !0;
        let [s, l] = o.range;
        return (s === void 0 || n >= s - r) && (l === void 0 || n <= l + r);
      }
      return !0;
    });
  }
  get cssId() {
    var t, r;
    return ((r = (t = this.formats.functions) == null ? void 0 : t.color) == null ? void 0 : r.id) || this.id;
  }
  get isPolar() {
    for (let t in this.coords)
      if (this.coords[t].type === "angle")
        return !0;
    return !1;
  }
  getFormat(t) {
    if (typeof t == "object")
      return t = kE(t, this), t;
    let r;
    return t === "default" ? r = Object.values(this.formats)[0] : r = this.formats[t], r ? (r = kE(r, this), r) : null;
  }
  // We cannot rely on simple === because then ColorSpace objects cannot be proxied
  equals(t) {
    return t ? this === t || this.id === t.id : !1;
  }
  to(t, r) {
    if (arguments.length === 1 && ([t, r] = [t.space, t.coords]), t = ba.get(t), this.equals(t))
      return r;
    r = r.map((s) => Number.isNaN(s) ? 0 : s);
    let i = this.path, n = t.path, a, o;
    for (let s = 0; s < i.length && i[s].equals(n[s]); s++)
      a = i[s], o = s;
    if (!a)
      throw new Error(`Cannot convert between color spaces ${this} and ${t}: no connection space was found`);
    for (let s = i.length - 1; s > o; s--)
      r = i[s].toBase(r);
    for (let s = o + 1; s < n.length; s++)
      r = n[s].fromBase(r);
    return r;
  }
  from(t, r) {
    return arguments.length === 1 && ([t, r] = [t.space, t.coords]), t = ba.get(t), t.to(this, r);
  }
  toString() {
    return `${this.name} (${this.id})`;
  }
  getMinCoords() {
    let t = [];
    for (let r in this.coords) {
      let i = this.coords[r], n = i.range || i.refRange;
      t.push((n == null ? void 0 : n.min) ?? 0);
    }
    return t;
  }
  // Returns array of unique color spaces
  static get all() {
    return [...new Set(Object.values(ba.registry))];
  }
  static register(t, r) {
    if (arguments.length === 1 && (r = arguments[0], t = r.id), r = this.get(r), this.registry[t] && this.registry[t] !== r)
      throw new Error(`Duplicate color space registration: '${t}'`);
    if (this.registry[t] = r, arguments.length === 1 && r.aliases)
      for (let i of r.aliases)
        this.register(i, r);
    return r;
  }
  /**
   * Lookup ColorSpace object by name
   * @param {ColorSpace | string} name
   */
  static get(t, ...r) {
    if (!t || t instanceof ba)
      return t;
    if (Fl(t) === "string") {
      let n = ba.registry[t.toLowerCase()];
      if (!n)
        throw new TypeError(`No color space found with id = "${t}"`);
      return n;
    }
    if (r.length)
      return ba.get(...r);
    throw new TypeError(`${t} is not a valid color space`);
  }
  /**
   * Get metadata about a coordinate of a color space
   *
   * @static
   * @param {Array | string} ref
   * @param {ColorSpace | string} [workingSpace]
   * @return {Object}
   */
  static resolveCoord(t, r) {
    var l;
    let i = Fl(t), n, a;
    if (i === "string" ? t.includes(".") ? [n, a] = t.split(".") : [n, a] = [, t] : Array.isArray(t) ? [n, a] = t : (n = t.space, a = t.coordId), n = ba.get(n), n || (n = r), !n)
      throw new TypeError(`Cannot resolve coordinate reference ${t}: No color space specified and relative references are not allowed here`);
    if (i = Fl(a), i === "number" || i === "string" && a >= 0) {
      let u = Object.entries(n.coords)[a];
      if (u)
        return { space: n, id: u[0], index: a, ...u[1] };
    }
    n = ba.get(n);
    let o = a.toLowerCase(), s = 0;
    for (let u in n.coords) {
      let d = n.coords[u];
      if (u.toLowerCase() === o || ((l = d.name) == null ? void 0 : l.toLowerCase()) === o)
        return { space: n, id: u, index: s, ...d };
      s++;
    }
    throw new TypeError(`No "${a}" coordinate found in ${n.name}. Its coordinates are: ${Object.keys(n.coords).join(", ")}`);
  }
};
c0(ba, "registry", {}), c0(ba, "DEFAULT_FORMAT", {
  type: "functions",
  name: "color"
});
let jt = ba;
function l$(e) {
  let t = [e];
  for (let r = e; r = r.base; )
    t.push(r);
  return t;
}
function kE(e, { coords: t } = {}) {
  if (e.coords && !e.coordGrammar) {
    e.type || (e.type = "function"), e.name || (e.name = "color"), e.coordGrammar = mA(e.coords);
    let r = Object.entries(t).map(([i, n], a) => {
      let o = e.coordGrammar[a][0], s = n.range || n.refRange, l = o.range, u = "";
      return o == "<percentage>" ? (l = [0, 100], u = "%") : o == "<angle>" && (u = "deg"), { fromRange: s, toRange: l, suffix: u };
    });
    e.serializeCoords = (i, n) => i.map((a, o) => {
      let { fromRange: s, toRange: l, suffix: u } = r[o];
      return s && l && (a = H2(s, l, a)), a = Tg(a, n), u && (a += u), a;
    });
  }
  return e;
}
var Ua = new jt({
  id: "xyz-d65",
  name: "XYZ D65",
  coords: {
    x: { name: "X" },
    y: { name: "Y" },
    z: { name: "Z" }
  },
  white: "D65",
  formats: {
    color: {
      ids: ["xyz-d65", "xyz"]
    }
  },
  aliases: ["xyz"]
});
class sa extends jt {
  /**
   * Creates a new RGB ColorSpace.
   * If coords are not specified, they will use the default RGB coords.
   * Instead of `fromBase()` and `toBase()` functions,
   * you can specify to/from XYZ matrices and have `toBase()` and `fromBase()` automatically generated.
   * @param {*} options - Same options as {@link ColorSpace} plus:
   * @param {number[][]} options.toXYZ_M - Matrix to convert to XYZ
   * @param {number[][]} options.fromXYZ_M - Matrix to convert from XYZ
   */
  constructor(t) {
    t.coords || (t.coords = {
      r: {
        range: [0, 1],
        name: "Red"
      },
      g: {
        range: [0, 1],
        name: "Green"
      },
      b: {
        range: [0, 1],
        name: "Blue"
      }
    }), t.base || (t.base = Ua), t.toXYZ_M && t.fromXYZ_M && (t.toBase ?? (t.toBase = (r) => {
      let i = Li(t.toXYZ_M, r);
      return this.white !== this.base.white && (i = Ig(this.white, this.base.white, i)), i;
    }), t.fromBase ?? (t.fromBase = (r) => (r = Ig(this.base.white, this.white, r), Li(t.fromXYZ_M, r)))), t.referred ?? (t.referred = "display"), super(t);
  }
}
function vA(e, { meta: t } = {}) {
  var i, n, a, o, s;
  let r = { str: (i = String(e)) == null ? void 0 : i.trim() };
  if (Ol.run("parse-start", r), r.color)
    return r.color;
  if (r.parsed = hA(r.str), r.parsed) {
    let l = r.parsed.name;
    if (l === "color") {
      let u = r.parsed.args.shift(), d = r.parsed.rawArgs.indexOf("/") > 0 ? r.parsed.args.pop() : 1;
      for (let p of jt.all) {
        let f = p.getFormat("color");
        if (f && (u === f.id || (n = f.ids) != null && n.includes(u))) {
          const g = Object.keys(p.coords).map((k, y) => r.parsed.args[y] || 0);
          return t && (t.formatId = "color"), { spaceId: p.id, coords: g, alpha: d };
        }
      }
      let c = "";
      if (u in jt.registry) {
        let p = (s = (o = (a = jt.registry[u].formats) == null ? void 0 : a.functions) == null ? void 0 : o.color) == null ? void 0 : s.id;
        p && (c = `Did you mean color(${p})?`);
      }
      throw new TypeError(`Cannot parse color(${u}). ` + (c || "Missing a plugin?"));
    } else
      for (let u of jt.all) {
        let d = u.getFormat(l);
        if (d && d.type === "function") {
          let c = 1;
          (d.lastAlpha || fA(r.parsed.args).alpha) && (c = r.parsed.args.pop());
          let p = r.parsed.args, f;
          return d.coordGrammar && (f = Object.entries(u.coords).map(([g, k], y) => {
            var B;
            let _ = d.coordGrammar[y], A = (B = p[y]) == null ? void 0 : B.type, T = _.find((M) => M == A);
            if (!T) {
              let M = k.name || g;
              throw new TypeError(`${A} not allowed for ${M} in ${l}()`);
            }
            let N = T.range;
            A === "<percentage>" && (N || (N = [0, 1]));
            let P = k.range || k.refRange;
            return N && P && (p[y] = H2(N, P, p[y])), T;
          })), t && Object.assign(t, { formatId: d.name, types: f }), {
            spaceId: u.id,
            coords: p,
            alpha: c
          };
        }
      }
  } else
    for (let l of jt.all)
      for (let u in l.formats) {
        let d = l.formats[u];
        if (d.type !== "custom" || d.test && !d.test(r.str))
          continue;
        let c = d.parse(r.str);
        if (c)
          return c.alpha ?? (c.alpha = 1), t && (t.formatId = u), c;
      }
  throw new TypeError(`Could not parse ${e} as a color. Missing a plugin?`);
}
function Br(e) {
  if (!e)
    throw new TypeError("Empty color reference");
  j1(e) && (e = vA(e));
  let t = e.space || e.spaceId;
  return t instanceof jt || (e.space = jt.get(t)), e.alpha === void 0 && (e.alpha = 1), e;
}
function H1(e, t) {
  return t = jt.get(t), t.from(e);
}
function Va(e, t) {
  let { space: r, index: i } = jt.resolveCoord(t, e.space);
  return H1(e, r)[i];
}
function kA(e, t, r) {
  return t = jt.get(t), e.coords = t.to(e.space, r), e;
}
function Pl(e, t, r) {
  if (e = Br(e), arguments.length === 2 && Fl(arguments[1]) === "object") {
    let i = arguments[1];
    for (let n in i)
      Pl(e, n, i[n]);
  } else {
    typeof r == "function" && (r = r(Va(e, t)));
    let { space: i, index: n } = jt.resolveCoord(t, e.space), a = H1(e, i);
    a[n] = r, kA(e, i, a);
  }
  return e;
}
var $2 = new jt({
  id: "xyz-d50",
  name: "XYZ D50",
  white: "D50",
  base: Ua,
  fromBase: (e) => Ig(Ua.white, "D50", e),
  toBase: (e) => Ig("D50", Ua.white, e),
  formats: {
    color: {}
  }
});
const u$ = 216 / 24389, bE = 24 / 116, nf = 24389 / 27;
let fk = ko.D50;
var ya = new jt({
  id: "lab",
  name: "Lab",
  coords: {
    l: {
      refRange: [0, 100],
      name: "L"
    },
    a: {
      refRange: [-125, 125]
    },
    b: {
      refRange: [-125, 125]
    }
  },
  // Assuming XYZ is relative to D50, convert to CIE Lab
  // from CIE standard, which now defines these as a rational fraction
  white: fk,
  base: $2,
  // Convert D50-adapted XYX to Lab
  //  CIE 15.3:2004 section 8.2.1.1
  fromBase(e) {
    let r = e.map((i, n) => i / fk[n]).map((i) => i > u$ ? Math.cbrt(i) : (nf * i + 16) / 116);
    return [
      116 * r[1] - 16,
      // L
      500 * (r[0] - r[1]),
      // a
      200 * (r[1] - r[2])
      // b
    ];
  },
  // Convert Lab to D50-adapted XYZ
  // Same result as CIE 15.3:2004 Appendix D although the derivation is different
  // http://www.brucelindbloom.com/index.html?Eqn_RGB_XYZ_Matrix.html
  toBase(e) {
    let t = [];
    return t[1] = (e[0] + 16) / 116, t[0] = e[1] / 500 + t[1], t[2] = t[1] - e[2] / 200, [
      t[0] > bE ? Math.pow(t[0], 3) : (116 * t[0] - 16) / nf,
      e[0] > 8 ? Math.pow((e[0] + 16) / 116, 3) : e[0] / nf,
      t[2] > bE ? Math.pow(t[2], 3) : (116 * t[2] - 16) / nf
    ].map((i, n) => i * fk[n]);
  },
  formats: {
    lab: {
      coords: ["<number> | <percentage>", "<number> | <percentage>[-1,1]", "<number> | <percentage>[-1,1]"]
    }
  }
});
function bm(e) {
  return (e % 360 + 360) % 360;
}
function c$(e, t) {
  if (e === "raw")
    return t;
  let [r, i] = t.map(bm), n = i - r;
  return e === "increasing" ? n < 0 && (i += 360) : e === "decreasing" ? n > 0 && (r += 360) : e === "longer" ? -180 < n && n < 180 && (n > 0 ? r += 360 : i += 360) : e === "shorter" && (n > 180 ? r += 360 : n < -180 && (i += 360)), [r, i];
}
var v1 = new jt({
  id: "lch",
  name: "LCH",
  coords: {
    l: {
      refRange: [0, 100],
      name: "Lightness"
    },
    c: {
      refRange: [0, 150],
      name: "Chroma"
    },
    h: {
      refRange: [0, 360],
      type: "angle",
      name: "Hue"
    }
  },
  base: ya,
  fromBase(e) {
    let [t, r, i] = e, n;
    const a = 0.02;
    return Math.abs(r) < a && Math.abs(i) < a ? n = NaN : n = Math.atan2(i, r) * 180 / Math.PI, [
      t,
      // L is still L
      Math.sqrt(r ** 2 + i ** 2),
      // Chroma
      bm(n)
      // Hue, in degrees [0 to 360)
    ];
  },
  toBase(e) {
    let [t, r, i] = e;
    return r < 0 && (r = 0), isNaN(i) && (i = 0), [
      t,
      // L is still L
      r * Math.cos(i * Math.PI / 180),
      // a
      r * Math.sin(i * Math.PI / 180)
      // b
    ];
  },
  formats: {
    lch: {
      coords: ["<number> | <percentage>", "<number> | <percentage>", "<number> | <angle>"]
    }
  }
});
const _E = 25 ** 7, Bg = Math.PI, DE = 180 / Bg, fd = Bg / 180;
function Xb(e, t, { kL: r = 1, kC: i = 1, kH: n = 1 } = {}) {
  let [a, o, s] = ya.from(e), l = v1.from(ya, [a, o, s])[1], [u, d, c] = ya.from(t), p = v1.from(ya, [u, d, c])[1];
  l < 0 && (l = 0), p < 0 && (p = 0);
  let g = ((l + p) / 2) ** 7, k = 0.5 * (1 - Math.sqrt(g / (g + _E))), y = (1 + k) * o, _ = (1 + k) * d, A = Math.sqrt(y ** 2 + s ** 2), T = Math.sqrt(_ ** 2 + c ** 2), N = y === 0 && s === 0 ? 0 : Math.atan2(s, y), P = _ === 0 && c === 0 ? 0 : Math.atan2(c, _);
  N < 0 && (N += 2 * Bg), P < 0 && (P += 2 * Bg), N *= DE, P *= DE;
  let B = u - a, M = T - A, X = P - N, U = N + P, K = Math.abs(X), z;
  A * T === 0 ? z = 0 : K <= 180 ? z = X : X > 180 ? z = X - 360 : X < -180 ? z = X + 360 : console.log("the unthinkable has happened");
  let j = 2 * Math.sqrt(T * A) * Math.sin(z * fd / 2), J = (a + u) / 2, ie = (A + T) / 2, ue = Math.pow(ie, 7), de;
  A * T === 0 ? de = U : K <= 180 ? de = U / 2 : U < 360 ? de = (U + 360) / 2 : de = (U - 360) / 2;
  let he = (J - 50) ** 2, Ee = 1 + 0.015 * he / Math.sqrt(20 + he), Le = 1 + 0.045 * ie, L = 1;
  L -= 0.17 * Math.cos((de - 30) * fd), L += 0.24 * Math.cos(2 * de * fd), L += 0.32 * Math.cos((3 * de + 6) * fd), L -= 0.2 * Math.cos((4 * de - 63) * fd);
  let me = 1 + 0.015 * ie * L, Se = 30 * Math.exp(-1 * ((de - 275) / 25) ** 2), G = 2 * Math.sqrt(ue / (ue + _E)), He = -1 * Math.sin(2 * Se * fd) * G, xe = (B / (r * Ee)) ** 2;
  return xe += (M / (i * Le)) ** 2, xe += (j / (n * me)) ** 2, xe += He * (M / (i * Le)) * (j / (n * me)), Math.sqrt(xe);
}
const d$ = 75e-6;
function Y0(e, t = e.space, { epsilon: r = d$ } = {}) {
  e = Br(e), t = jt.get(t);
  let i = e.coords;
  return t !== e.space && (i = t.from(e)), t.inGamut(i, { epsilon: r });
}
function k1(e) {
  return {
    space: e.space,
    coords: e.coords.slice(),
    alpha: e.alpha
  };
}
function Nl(e, { method: t = Jo.gamut_mapping, space: r = e.space } = {}) {
  if (j1(arguments[1]) && (r = arguments[1]), r = jt.get(r), Y0(e, r, { epsilon: 0 }))
    return Br(e);
  let i = $a(e, r);
  if (t !== "clip" && !Y0(e, r)) {
    let n = Nl(k1(i), { method: "clip", space: r });
    if (Xb(e, n) > 2) {
      let a = jt.resolveCoord(t), o = a.space, s = a.id, l = $a(i, o), d = (a.range || a.refRange)[0], c = 0.01, p = d, f = Va(l, s);
      for (; f - p > c; ) {
        let g = k1(l);
        g = Nl(g, { space: r, method: "clip" }), Xb(l, g) - 2 < c ? p = Va(l, s) : f = Va(l, s), Pl(l, s, (p + f) / 2);
      }
      i = $a(l, r);
    } else
      i = n;
  }
  if (t === "clip" || !Y0(i, r, { epsilon: 0 })) {
    let n = Object.values(r.coords).map((a) => a.range || []);
    i.coords = i.coords.map((a, o) => {
      let [s, l] = n[o];
      return s !== void 0 && (a = Math.max(s, a)), l !== void 0 && (a = Math.min(a, l)), a;
    });
  }
  return r !== e.space && (i = $a(i, e.space)), e.coords = i.coords, e;
}
Nl.returns = "color";
function $a(e, t, { inGamut: r } = {}) {
  e = Br(e), t = jt.get(t);
  let i = t.from(e), n = { space: t, coords: i, alpha: e.alpha };
  return r && (n = Nl(n)), n;
}
$a.returns = "color";
function Rg(e, {
  precision: t = Jo.precision,
  format: r = "default",
  inGamut: i = !0,
  ...n
} = {}) {
  var l;
  let a;
  e = Br(e);
  let o = r;
  r = e.space.getFormat(r) ?? e.space.getFormat("default") ?? jt.DEFAULT_FORMAT, i || (i = r.toGamut);
  let s = e.coords;
  if (s = s.map((u) => u || 0), i && !Y0(e) && (s = Nl(k1(e), i === !0 ? void 0 : i).coords), r.type === "custom")
    if (n.precision = t, r.serialize)
      a = r.serialize(s, e.alpha, n);
    else
      throw new TypeError(`format ${o} can only be used to parse colors, not for serialization`);
  else {
    let u = r.name || "color";
    r.serializeCoords ? s = r.serializeCoords(s, t) : t !== null && (s = s.map((f) => Tg(f, t)));
    let d = [...s];
    if (u === "color") {
      let f = r.id || ((l = r.ids) == null ? void 0 : l[0]) || e.space.id;
      d.unshift(f);
    }
    let c = e.alpha;
    t !== null && (c = Tg(c, t));
    let p = e.alpha < 1 && !r.noAlpha ? `${r.commas ? "," : " /"} ${c}` : "";
    a = `${u}(${d.join(r.commas ? ", " : " ")}${p})`;
  }
  return a;
}
const p$ = [
  [0.6369580483012914, 0.14461690358620832, 0.1688809751641721],
  [0.2627002120112671, 0.6779980715188708, 0.05930171646986196],
  [0, 0.028072693049087428, 1.060985057710791]
], h$ = [
  [1.716651187971268, -0.355670783776392, -0.25336628137366],
  [-0.666684351832489, 1.616481236634939, 0.0157685458139111],
  [0.017639857445311, -0.042770613257809, 0.942103121235474]
];
var _m = new sa({
  id: "rec2020-linear",
  name: "Linear REC.2020",
  white: "D65",
  toXYZ_M: p$,
  fromXYZ_M: h$,
  formats: {
    color: {}
  }
});
const af = 1.09929682680944, yE = 0.018053968510807;
var bA = new sa({
  id: "rec2020",
  name: "REC.2020",
  base: _m,
  // Non-linear transfer function from Rec. ITU-R BT.2020-2 table 4
  toBase(e) {
    return e.map(function(t) {
      return t < yE * 4.5 ? t / 4.5 : Math.pow((t + af - 1) / af, 1 / 0.45);
    });
  },
  fromBase(e) {
    return e.map(function(t) {
      return t >= yE ? af * Math.pow(t, 0.45) - (af - 1) : 4.5 * t;
    });
  },
  formats: {
    color: {}
  }
});
const f$ = [
  [0.4865709486482162, 0.26566769316909306, 0.1982172852343625],
  [0.2289745640697488, 0.6917385218365064, 0.079286914093745],
  [0, 0.04511338185890264, 1.043944368900976]
], g$ = [
  [2.493496911941425, -0.9313836179191239, -0.40271078445071684],
  [-0.8294889695615747, 1.7626640603183463, 0.023624685841943577],
  [0.03584583024378447, -0.07617238926804182, 0.9568845240076872]
];
var _A = new sa({
  id: "p3-linear",
  name: "Linear P3",
  white: "D65",
  toXYZ_M: f$,
  fromXYZ_M: g$
});
const m$ = [
  [0.41239079926595934, 0.357584339383878, 0.1804807884018343],
  [0.21263900587151027, 0.715168678767756, 0.07219231536073371],
  [0.01933081871559182, 0.11919477979462598, 0.9505321522496607]
], v$ = [
  [3.2409699419045226, -1.537383177570094, -0.4986107602930034],
  [-0.9692436362808796, 1.8759675015077202, 0.04155505740717559],
  [0.05563007969699366, -0.20397695888897652, 1.0569715142428786]
];
var DA = new sa({
  id: "srgb-linear",
  name: "Linear sRGB",
  white: "D65",
  toXYZ_M: m$,
  fromXYZ_M: v$,
  formats: {
    color: {}
  }
}), EE = {
  aliceblue: [240 / 255, 248 / 255, 1],
  antiquewhite: [250 / 255, 235 / 255, 215 / 255],
  aqua: [0, 1, 1],
  aquamarine: [127 / 255, 1, 212 / 255],
  azure: [240 / 255, 1, 1],
  beige: [245 / 255, 245 / 255, 220 / 255],
  bisque: [1, 228 / 255, 196 / 255],
  black: [0, 0, 0],
  blanchedalmond: [1, 235 / 255, 205 / 255],
  blue: [0, 0, 1],
  blueviolet: [138 / 255, 43 / 255, 226 / 255],
  brown: [165 / 255, 42 / 255, 42 / 255],
  burlywood: [222 / 255, 184 / 255, 135 / 255],
  cadetblue: [95 / 255, 158 / 255, 160 / 255],
  chartreuse: [127 / 255, 1, 0],
  chocolate: [210 / 255, 105 / 255, 30 / 255],
  coral: [1, 127 / 255, 80 / 255],
  cornflowerblue: [100 / 255, 149 / 255, 237 / 255],
  cornsilk: [1, 248 / 255, 220 / 255],
  crimson: [220 / 255, 20 / 255, 60 / 255],
  cyan: [0, 1, 1],
  darkblue: [0, 0, 139 / 255],
  darkcyan: [0, 139 / 255, 139 / 255],
  darkgoldenrod: [184 / 255, 134 / 255, 11 / 255],
  darkgray: [169 / 255, 169 / 255, 169 / 255],
  darkgreen: [0, 100 / 255, 0],
  darkgrey: [169 / 255, 169 / 255, 169 / 255],
  darkkhaki: [189 / 255, 183 / 255, 107 / 255],
  darkmagenta: [139 / 255, 0, 139 / 255],
  darkolivegreen: [85 / 255, 107 / 255, 47 / 255],
  darkorange: [1, 140 / 255, 0],
  darkorchid: [153 / 255, 50 / 255, 204 / 255],
  darkred: [139 / 255, 0, 0],
  darksalmon: [233 / 255, 150 / 255, 122 / 255],
  darkseagreen: [143 / 255, 188 / 255, 143 / 255],
  darkslateblue: [72 / 255, 61 / 255, 139 / 255],
  darkslategray: [47 / 255, 79 / 255, 79 / 255],
  darkslategrey: [47 / 255, 79 / 255, 79 / 255],
  darkturquoise: [0, 206 / 255, 209 / 255],
  darkviolet: [148 / 255, 0, 211 / 255],
  deeppink: [1, 20 / 255, 147 / 255],
  deepskyblue: [0, 191 / 255, 1],
  dimgray: [105 / 255, 105 / 255, 105 / 255],
  dimgrey: [105 / 255, 105 / 255, 105 / 255],
  dodgerblue: [30 / 255, 144 / 255, 1],
  firebrick: [178 / 255, 34 / 255, 34 / 255],
  floralwhite: [1, 250 / 255, 240 / 255],
  forestgreen: [34 / 255, 139 / 255, 34 / 255],
  fuchsia: [1, 0, 1],
  gainsboro: [220 / 255, 220 / 255, 220 / 255],
  ghostwhite: [248 / 255, 248 / 255, 1],
  gold: [1, 215 / 255, 0],
  goldenrod: [218 / 255, 165 / 255, 32 / 255],
  gray: [128 / 255, 128 / 255, 128 / 255],
  green: [0, 128 / 255, 0],
  greenyellow: [173 / 255, 1, 47 / 255],
  grey: [128 / 255, 128 / 255, 128 / 255],
  honeydew: [240 / 255, 1, 240 / 255],
  hotpink: [1, 105 / 255, 180 / 255],
  indianred: [205 / 255, 92 / 255, 92 / 255],
  indigo: [75 / 255, 0, 130 / 255],
  ivory: [1, 1, 240 / 255],
  khaki: [240 / 255, 230 / 255, 140 / 255],
  lavender: [230 / 255, 230 / 255, 250 / 255],
  lavenderblush: [1, 240 / 255, 245 / 255],
  lawngreen: [124 / 255, 252 / 255, 0],
  lemonchiffon: [1, 250 / 255, 205 / 255],
  lightblue: [173 / 255, 216 / 255, 230 / 255],
  lightcoral: [240 / 255, 128 / 255, 128 / 255],
  lightcyan: [224 / 255, 1, 1],
  lightgoldenrodyellow: [250 / 255, 250 / 255, 210 / 255],
  lightgray: [211 / 255, 211 / 255, 211 / 255],
  lightgreen: [144 / 255, 238 / 255, 144 / 255],
  lightgrey: [211 / 255, 211 / 255, 211 / 255],
  lightpink: [1, 182 / 255, 193 / 255],
  lightsalmon: [1, 160 / 255, 122 / 255],
  lightseagreen: [32 / 255, 178 / 255, 170 / 255],
  lightskyblue: [135 / 255, 206 / 255, 250 / 255],
  lightslategray: [119 / 255, 136 / 255, 153 / 255],
  lightslategrey: [119 / 255, 136 / 255, 153 / 255],
  lightsteelblue: [176 / 255, 196 / 255, 222 / 255],
  lightyellow: [1, 1, 224 / 255],
  lime: [0, 1, 0],
  limegreen: [50 / 255, 205 / 255, 50 / 255],
  linen: [250 / 255, 240 / 255, 230 / 255],
  magenta: [1, 0, 1],
  maroon: [128 / 255, 0, 0],
  mediumaquamarine: [102 / 255, 205 / 255, 170 / 255],
  mediumblue: [0, 0, 205 / 255],
  mediumorchid: [186 / 255, 85 / 255, 211 / 255],
  mediumpurple: [147 / 255, 112 / 255, 219 / 255],
  mediumseagreen: [60 / 255, 179 / 255, 113 / 255],
  mediumslateblue: [123 / 255, 104 / 255, 238 / 255],
  mediumspringgreen: [0, 250 / 255, 154 / 255],
  mediumturquoise: [72 / 255, 209 / 255, 204 / 255],
  mediumvioletred: [199 / 255, 21 / 255, 133 / 255],
  midnightblue: [25 / 255, 25 / 255, 112 / 255],
  mintcream: [245 / 255, 1, 250 / 255],
  mistyrose: [1, 228 / 255, 225 / 255],
  moccasin: [1, 228 / 255, 181 / 255],
  navajowhite: [1, 222 / 255, 173 / 255],
  navy: [0, 0, 128 / 255],
  oldlace: [253 / 255, 245 / 255, 230 / 255],
  olive: [128 / 255, 128 / 255, 0],
  olivedrab: [107 / 255, 142 / 255, 35 / 255],
  orange: [1, 165 / 255, 0],
  orangered: [1, 69 / 255, 0],
  orchid: [218 / 255, 112 / 255, 214 / 255],
  palegoldenrod: [238 / 255, 232 / 255, 170 / 255],
  palegreen: [152 / 255, 251 / 255, 152 / 255],
  paleturquoise: [175 / 255, 238 / 255, 238 / 255],
  palevioletred: [219 / 255, 112 / 255, 147 / 255],
  papayawhip: [1, 239 / 255, 213 / 255],
  peachpuff: [1, 218 / 255, 185 / 255],
  peru: [205 / 255, 133 / 255, 63 / 255],
  pink: [1, 192 / 255, 203 / 255],
  plum: [221 / 255, 160 / 255, 221 / 255],
  powderblue: [176 / 255, 224 / 255, 230 / 255],
  purple: [128 / 255, 0, 128 / 255],
  rebeccapurple: [102 / 255, 51 / 255, 153 / 255],
  red: [1, 0, 0],
  rosybrown: [188 / 255, 143 / 255, 143 / 255],
  royalblue: [65 / 255, 105 / 255, 225 / 255],
  saddlebrown: [139 / 255, 69 / 255, 19 / 255],
  salmon: [250 / 255, 128 / 255, 114 / 255],
  sandybrown: [244 / 255, 164 / 255, 96 / 255],
  seagreen: [46 / 255, 139 / 255, 87 / 255],
  seashell: [1, 245 / 255, 238 / 255],
  sienna: [160 / 255, 82 / 255, 45 / 255],
  silver: [192 / 255, 192 / 255, 192 / 255],
  skyblue: [135 / 255, 206 / 255, 235 / 255],
  slateblue: [106 / 255, 90 / 255, 205 / 255],
  slategray: [112 / 255, 128 / 255, 144 / 255],
  slategrey: [112 / 255, 128 / 255, 144 / 255],
  snow: [1, 250 / 255, 250 / 255],
  springgreen: [0, 1, 127 / 255],
  steelblue: [70 / 255, 130 / 255, 180 / 255],
  tan: [210 / 255, 180 / 255, 140 / 255],
  teal: [0, 128 / 255, 128 / 255],
  thistle: [216 / 255, 191 / 255, 216 / 255],
  tomato: [1, 99 / 255, 71 / 255],
  turquoise: [64 / 255, 224 / 255, 208 / 255],
  violet: [238 / 255, 130 / 255, 238 / 255],
  wheat: [245 / 255, 222 / 255, 179 / 255],
  white: [1, 1, 1],
  whitesmoke: [245 / 255, 245 / 255, 245 / 255],
  yellow: [1, 1, 0],
  yellowgreen: [154 / 255, 205 / 255, 50 / 255]
};
let CE = Array(3).fill("<percentage> | <number>[0, 255]"), xE = Array(3).fill("<number>[0, 255]");
var b1 = new sa({
  id: "srgb",
  name: "sRGB",
  base: DA,
  fromBase: (e) => e.map((t) => {
    let r = t < 0 ? -1 : 1, i = t * r;
    return i > 31308e-7 ? r * (1.055 * i ** (1 / 2.4) - 0.055) : 12.92 * t;
  }),
  toBase: (e) => e.map((t) => {
    let r = t < 0 ? -1 : 1, i = t * r;
    return i < 0.04045 ? t / 12.92 : r * ((i + 0.055) / 1.055) ** 2.4;
  }),
  formats: {
    rgb: {
      coords: CE
    },
    rgb_number: {
      name: "rgb",
      commas: !0,
      coords: xE,
      noAlpha: !0
    },
    color: {
      /* use defaults */
    },
    rgba: {
      coords: CE,
      commas: !0,
      lastAlpha: !0
    },
    rgba_number: {
      name: "rgba",
      commas: !0,
      coords: xE
    },
    hex: {
      type: "custom",
      toGamut: !0,
      test: (e) => /^#([a-f0-9]{3,4}){1,2}$/i.test(e),
      parse(e) {
        e.length <= 5 && (e = e.replace(/[a-f0-9]/gi, "$&$&"));
        let t = [];
        return e.replace(/[a-f0-9]{2}/gi, (r) => {
          t.push(parseInt(r, 16) / 255);
        }), {
          spaceId: "srgb",
          coords: t.slice(0, 3),
          alpha: t.slice(3)[0]
        };
      },
      serialize: (e, t, {
        collapse: r = !0
        // collapse to 3-4 digit hex when possible?
      } = {}) => {
        t < 1 && e.push(t), e = e.map((a) => Math.round(a * 255));
        let i = r && e.every((a) => a % 17 === 0);
        return "#" + e.map((a) => i ? (a / 17).toString(16) : a.toString(16).padStart(2, "0")).join("");
      }
    },
    keyword: {
      type: "custom",
      test: (e) => /^[a-z]+$/i.test(e),
      parse(e) {
        e = e.toLowerCase();
        let t = { spaceId: "srgb", coords: null, alpha: 1 };
        if (e === "transparent" ? (t.coords = EE.black, t.alpha = 0) : t.coords = EE[e], t.coords)
          return t;
      }
    }
  }
}), yA = new sa({
  id: "p3",
  name: "P3",
  base: _A,
  // Gamma encoding/decoding is the same as sRGB
  fromBase: b1.fromBase,
  toBase: b1.toBase,
  formats: {
    color: {
      id: "display-p3"
    }
  }
});
Jo.display_space = b1;
if (typeof CSS < "u" && CSS.supports)
  for (let e of [ya, bA, yA]) {
    let t = e.getMinCoords(), i = Rg({ space: e, coords: t, alpha: 1 });
    if (CSS.supports("color", i)) {
      Jo.display_space = e;
      break;
    }
  }
function k$(e, { space: t = Jo.display_space, ...r } = {}) {
  let i = Rg(e, r);
  if (typeof CSS > "u" || CSS.supports("color", i) || !Jo.display_space)
    i = new String(i), i.color = e;
  else {
    let n = $a(e, t);
    i = new String(Rg(n, r)), i.color = n;
  }
  return i;
}
function EA(e, t, r = "lab") {
  r = jt.get(r);
  let i = r.from(e), n = r.from(t);
  return Math.sqrt(i.reduce((a, o, s) => {
    let l = n[s];
    return isNaN(o) || isNaN(l) ? a : a + (l - o) ** 2;
  }, 0));
}
function b$(e, t) {
  return e = Br(e), t = Br(t), e.space === t.space && e.alpha === t.alpha && e.coords.every((r, i) => r === t.coords[i]);
}
function zl(e) {
  return Va(e, [Ua, "y"]);
}
function CA(e, t) {
  Pl(e, [Ua, "y"], t);
}
function _$(e) {
  Object.defineProperty(e.prototype, "luminance", {
    get() {
      return zl(this);
    },
    set(t) {
      CA(this, t);
    }
  });
}
var D$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  getLuminance: zl,
  register: _$,
  setLuminance: CA
});
function y$(e, t) {
  e = Br(e), t = Br(t);
  let r = Math.max(zl(e), 0), i = Math.max(zl(t), 0);
  return i > r && ([r, i] = [i, r]), (r + 0.05) / (i + 0.05);
}
const E$ = 0.56, C$ = 0.57, x$ = 0.62, A$ = 0.65, AE = 0.022, w$ = 1.414, F$ = 0.1, T$ = 5e-4, S$ = 1.14, wE = 0.027, I$ = 1.14;
function FE(e) {
  return e >= AE ? e : e + (AE - e) ** w$;
}
function gd(e) {
  let t = e < 0 ? -1 : 1, r = Math.abs(e);
  return t * Math.pow(r, 2.4);
}
function B$(e, t) {
  t = Br(t), e = Br(e);
  let r, i, n, a, o, s;
  t = $a(t, "srgb"), [a, o, s] = t.coords;
  let l = gd(a) * 0.2126729 + gd(o) * 0.7151522 + gd(s) * 0.072175;
  e = $a(e, "srgb"), [a, o, s] = e.coords;
  let u = gd(a) * 0.2126729 + gd(o) * 0.7151522 + gd(s) * 0.072175, d = FE(l), c = FE(u), p = c > d;
  return Math.abs(c - d) < T$ ? i = 0 : p ? (r = c ** E$ - d ** C$, i = r * S$) : (r = c ** A$ - d ** x$, i = r * I$), Math.abs(i) < F$ ? n = 0 : i > 0 ? n = i - wE : n = i + wE, n * 100;
}
function R$(e, t) {
  e = Br(e), t = Br(t);
  let r = Math.max(zl(e), 0), i = Math.max(zl(t), 0);
  i > r && ([r, i] = [i, r]);
  let n = r + i;
  return n === 0 ? 0 : (r - i) / n;
}
const O$ = 5e4;
function P$(e, t) {
  e = Br(e), t = Br(t);
  let r = Math.max(zl(e), 0), i = Math.max(zl(t), 0);
  return i > r && ([r, i] = [i, r]), i === 0 ? O$ : (r - i) / i;
}
function N$(e, t) {
  e = Br(e), t = Br(t);
  let r = Va(e, [ya, "l"]), i = Va(t, [ya, "l"]);
  return Math.abs(r - i);
}
const z$ = 216 / 24389, TE = 24 / 116, of = 24389 / 27;
let gk = ko.D65;
var Zb = new jt({
  id: "lab-d65",
  name: "Lab D65",
  coords: {
    l: {
      refRange: [0, 100],
      name: "L"
    },
    a: {
      refRange: [-125, 125]
    },
    b: {
      refRange: [-125, 125]
    }
  },
  // Assuming XYZ is relative to D65, convert to CIE Lab
  // from CIE standard, which now defines these as a rational fraction
  white: gk,
  base: Ua,
  // Convert D65-adapted XYZ to Lab
  //  CIE 15.3:2004 section 8.2.1.1
  fromBase(e) {
    let r = e.map((i, n) => i / gk[n]).map((i) => i > z$ ? Math.cbrt(i) : (of * i + 16) / 116);
    return [
      116 * r[1] - 16,
      // L
      500 * (r[0] - r[1]),
      // a
      200 * (r[1] - r[2])
      // b
    ];
  },
  // Convert Lab to D65-adapted XYZ
  // Same result as CIE 15.3:2004 Appendix D although the derivation is different
  // http://www.brucelindbloom.com/index.html?Eqn_RGB_XYZ_Matrix.html
  toBase(e) {
    let t = [];
    return t[1] = (e[0] + 16) / 116, t[0] = e[1] / 500 + t[1], t[2] = t[1] - e[2] / 200, [
      t[0] > TE ? Math.pow(t[0], 3) : (116 * t[0] - 16) / of,
      e[0] > 8 ? Math.pow((e[0] + 16) / 116, 3) : e[0] / of,
      t[2] > TE ? Math.pow(t[2], 3) : (116 * t[2] - 16) / of
    ].map((i, n) => i * gk[n]);
  },
  formats: {
    "lab-d65": {
      coords: ["<number> | <percentage>", "<number> | <percentage>[-1,1]", "<number> | <percentage>[-1,1]"]
    }
  }
});
const mk = Math.pow(5, 0.5) * 0.5 + 0.5;
function L$(e, t) {
  e = Br(e), t = Br(t);
  let r = Va(e, [Zb, "l"]), i = Va(t, [Zb, "l"]), n = Math.abs(Math.pow(r, mk) - Math.pow(i, mk)), a = Math.pow(n, 1 / mk) * Math.SQRT2 - 40;
  return a < 7.5 ? 0 : a;
}
var Vf = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  contrastAPCA: B$,
  contrastDeltaPhi: L$,
  contrastLstar: N$,
  contrastMichelson: R$,
  contrastWCAG21: y$,
  contrastWeber: P$
});
function M$(e, t, r = {}) {
  j1(r) && (r = { algorithm: r });
  let { algorithm: i, ...n } = r;
  if (!i) {
    let a = Object.keys(Vf).map((o) => o.replace(/^contrast/, "")).join(", ");
    throw new TypeError(`contrast() function needs a contrast algorithm. Please specify one of: ${a}`);
  }
  e = Br(e), t = Br(t);
  for (let a in Vf)
    if ("contrast" + i.toLowerCase() === a.toLowerCase())
      return Vf[a](e, t, n);
  throw new TypeError(`Unknown contrast algorithm: ${i}`);
}
function xA(e) {
  let [t, r, i] = H1(e, Ua), n = t + 15 * r + 3 * i;
  return [4 * t / n, 9 * r / n];
}
function AA(e) {
  let [t, r, i] = H1(e, Ua), n = t + r + i;
  return [t / n, r / n];
}
function j$(e) {
  Object.defineProperty(e.prototype, "uv", {
    get() {
      return xA(this);
    }
  }), Object.defineProperty(e.prototype, "xy", {
    get() {
      return AA(this);
    }
  });
}
var H$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  register: j$,
  uv: xA,
  xy: AA
});
function $$(e, t) {
  return EA(e, t, "lab");
}
const U$ = Math.PI, SE = U$ / 180;
function V$(e, t, { l: r = 2, c: i = 1 } = {}) {
  let [n, a, o] = ya.from(e), [, s, l] = v1.from(ya, [n, a, o]), [u, d, c] = ya.from(t), p = v1.from(ya, [u, d, c])[1];
  s < 0 && (s = 0), p < 0 && (p = 0);
  let f = n - u, g = s - p, k = a - d, y = o - c, _ = k ** 2 + y ** 2 - g ** 2, A = 0.511;
  n >= 16 && (A = 0.040975 * n / (1 + 0.01765 * n));
  let T = 0.0638 * s / (1 + 0.0131 * s) + 0.638, N;
  Number.isNaN(l) && (l = 0), l >= 164 && l <= 345 ? N = 0.56 + Math.abs(0.2 * Math.cos((l + 168) * SE)) : N = 0.36 + Math.abs(0.4 * Math.cos((l + 35) * SE));
  let P = Math.pow(s, 4), B = Math.sqrt(P / (P + 1900)), M = T * (B * N + 1 - B), X = (f / (r * A)) ** 2;
  return X += (g / (i * T)) ** 2, X += _ / M ** 2, Math.sqrt(X);
}
const IE = 203;
var U2 = new jt({
  // Absolute CIE XYZ, with a D65 whitepoint,
  // as used in most HDR colorspaces as a starting point.
  // SDR spaces are converted per BT.2048
  // so that diffuse, media white is 203 cd/m²
  id: "xyz-abs-d65",
  name: "Absolute XYZ D65",
  coords: {
    x: {
      refRange: [0, 9504.7],
      name: "Xa"
    },
    y: {
      refRange: [0, 1e4],
      name: "Ya"
    },
    z: {
      refRange: [0, 10888.3],
      name: "Za"
    }
  },
  base: Ua,
  fromBase(e) {
    return e.map((t) => Math.max(t * IE, 0));
  },
  toBase(e) {
    return e.map((t) => Math.max(t / IE, 0));
  }
});
const sf = 1.15, lf = 0.66, BE = 2610 / 2 ** 14, W$ = 2 ** 14 / 2610, RE = 3424 / 2 ** 12, OE = 2413 / 2 ** 7, PE = 2392 / 2 ** 7, G$ = 1.7 * 2523 / 2 ** 5, NE = 2 ** 5 / (1.7 * 2523), uf = -0.56, vk = 16295499532821565e-27, K$ = [
  [0.41478972, 0.579999, 0.014648],
  [-0.20151, 1.120649, 0.0531008],
  [-0.0166008, 0.2648, 0.6684799]
], Y$ = [
  [1.9242264357876067, -1.0047923125953657, 0.037651404030618],
  [0.35031676209499907, 0.7264811939316552, -0.06538442294808501],
  [-0.09098281098284752, -0.3127282905230739, 1.5227665613052603]
], q$ = [
  [0.5, 0.5, 0],
  [3.524, -4.066708, 0.542708],
  [0.199076, 1.096799, -1.295875]
], Q$ = [
  [1, 0.1386050432715393, 0.05804731615611886],
  [0.9999999999999999, -0.1386050432715393, -0.05804731615611886],
  [0.9999999999999998, -0.09601924202631895, -0.8118918960560388]
];
var wA = new jt({
  id: "jzazbz",
  name: "Jzazbz",
  coords: {
    jz: {
      refRange: [0, 1],
      name: "Jz"
    },
    az: {
      refRange: [-0.5, 0.5]
    },
    bz: {
      refRange: [-0.5, 0.5]
    }
  },
  base: U2,
  fromBase(e) {
    let [t, r, i] = e, n = sf * t - (sf - 1) * i, a = lf * r - (lf - 1) * t, s = Li(K$, [n, a, i]).map(function(p) {
      let f = RE + OE * (p / 1e4) ** BE, g = 1 + PE * (p / 1e4) ** BE;
      return (f / g) ** G$;
    }), [l, u, d] = Li(q$, s);
    return [(1 + uf) * l / (1 + uf * l) - vk, u, d];
  },
  toBase(e) {
    let [t, r, i] = e, n = (t + vk) / (1 + uf - uf * (t + vk)), o = Li(Q$, [n, r, i]).map(function(p) {
      let f = RE - p ** NE, g = PE * p ** NE - OE;
      return 1e4 * (f / g) ** W$;
    }), [s, l, u] = Li(Y$, o), d = (s + (sf - 1) * u) / sf, c = (l + (lf - 1) * d) / lf;
    return [d, c, u];
  },
  formats: {
    // https://drafts.csswg.org/css-color-hdr/#Jzazbz
    color: {}
  }
}), Jb = new jt({
  id: "jzczhz",
  name: "JzCzHz",
  coords: {
    jz: {
      refRange: [0, 1],
      name: "Jz"
    },
    cz: {
      refRange: [0, 1],
      name: "Chroma"
    },
    hz: {
      refRange: [0, 360],
      type: "angle",
      name: "Hue"
    }
  },
  base: wA,
  fromBase(e) {
    let [t, r, i] = e, n;
    const a = 2e-4;
    return Math.abs(r) < a && Math.abs(i) < a ? n = NaN : n = Math.atan2(i, r) * 180 / Math.PI, [
      t,
      // Jz is still Jz
      Math.sqrt(r ** 2 + i ** 2),
      // Chroma
      bm(n)
      // Hue, in degrees [0 to 360)
    ];
  },
  toBase(e) {
    return [
      e[0],
      // Jz is still Jz
      e[1] * Math.cos(e[2] * Math.PI / 180),
      // az
      e[1] * Math.sin(e[2] * Math.PI / 180)
      // bz
    ];
  },
  formats: {
    color: {}
  }
});
function X$(e, t) {
  let [r, i, n] = Jb.from(e), [a, o, s] = Jb.from(t), l = r - a, u = i - o;
  Number.isNaN(n) && Number.isNaN(s) ? (n = 0, s = 0) : Number.isNaN(n) ? n = s : Number.isNaN(s) && (s = n);
  let d = n - s, c = 2 * Math.sqrt(i * o) * Math.sin(d / 2 * (Math.PI / 180));
  return Math.sqrt(l ** 2 + u ** 2 + c ** 2);
}
const FA = 3424 / 4096, TA = 2413 / 128, SA = 2392 / 128, zE = 2610 / 16384, Z$ = 2523 / 32, J$ = 16384 / 2610, LE = 32 / 2523, eU = [
  [0.3592, 0.6976, -0.0358],
  [-0.1922, 1.1004, 0.0755],
  [7e-3, 0.0749, 0.8434]
], tU = [
  [2048 / 4096, 2048 / 4096, 0],
  [6610 / 4096, -13613 / 4096, 7003 / 4096],
  [17933 / 4096, -17390 / 4096, -543 / 4096]
], rU = [
  [0.9999888965628402, 0.008605050147287059, 0.11103437159861648],
  [1.00001110343716, -0.008605050147287059, -0.11103437159861648],
  [1.0000320633910054, 0.56004913547279, -0.3206339100541203]
], iU = [
  [2.0701800566956137, -1.326456876103021, 0.20661600684785517],
  [0.3649882500326575, 0.6804673628522352, -0.04542175307585323],
  [-0.04959554223893211, -0.04942116118675749, 1.1879959417328034]
];
var e_ = new jt({
  id: "ictcp",
  name: "ICTCP",
  // From BT.2100-2 page 7:
  // During production, signal values are expected to exceed the
  // range E′ = [0.0 : 1.0]. This provides processing headroom and avoids
  // signal degradation during cascaded processing. Such values of E′,
  // below 0.0 or exceeding 1.0, should not be clipped during production
  // and exchange.
  // Values below 0.0 should not be clipped in reference displays (even
  // though they represent “negative” light) to allow the black level of
  // the signal (LB) to be properly set using test signals known as “PLUGE”
  coords: {
    i: {
      refRange: [0, 1],
      // Constant luminance,
      name: "I"
    },
    ct: {
      refRange: [-0.5, 0.5],
      // Full BT.2020 gamut in range [-0.5, 0.5]
      name: "CT"
    },
    cp: {
      refRange: [-0.5, 0.5],
      name: "CP"
    }
  },
  base: U2,
  fromBase(e) {
    let t = Li(eU, e);
    return nU(t);
  },
  toBase(e) {
    let t = aU(e);
    return Li(iU, t);
  },
  formats: {
    color: {}
  }
});
function nU(e) {
  let t = e.map(function(r) {
    let i = FA + TA * (r / 1e4) ** zE, n = 1 + SA * (r / 1e4) ** zE;
    return (i / n) ** Z$;
  });
  return Li(tU, t);
}
function aU(e) {
  return Li(rU, e).map(function(i) {
    let n = Math.max(i ** LE - FA, 0), a = TA - SA * i ** LE;
    return 1e4 * (n / a) ** J$;
  });
}
function oU(e, t) {
  let [r, i, n] = e_.from(e), [a, o, s] = e_.from(t);
  return 720 * Math.sqrt((r - a) ** 2 + 0.25 * (i - o) ** 2 + (n - s) ** 2);
}
const sU = [
  [0.8190224432164319, 0.3619062562801221, -0.12887378261216414],
  [0.0329836671980271, 0.9292868468965546, 0.03614466816999844],
  [0.048177199566046255, 0.26423952494422764, 0.6335478258136937]
], lU = [
  [1.2268798733741557, -0.5578149965554813, 0.28139105017721583],
  [-0.04057576262431372, 1.1122868293970594, -0.07171106666151701],
  [-0.07637294974672142, -0.4214933239627914, 1.5869240244272418]
], uU = [
  [0.2104542553, 0.793617785, -0.0040720468],
  [1.9779984951, -2.428592205, 0.4505937099],
  [0.0259040371, 0.7827717662, -0.808675766]
], cU = [
  [0.9999999984505198, 0.39633779217376786, 0.2158037580607588],
  [1.0000000088817609, -0.10556134232365635, -0.06385417477170591],
  [1.0000000546724108, -0.08948418209496575, -1.2914855378640917]
];
var Og = new jt({
  id: "oklab",
  name: "Oklab",
  coords: {
    l: {
      refRange: [0, 1],
      name: "L"
    },
    a: {
      refRange: [-0.4, 0.4]
    },
    b: {
      refRange: [-0.4, 0.4]
    }
  },
  // Note that XYZ is relative to D65
  white: "D65",
  base: Ua,
  fromBase(e) {
    let r = Li(sU, e).map((i) => Math.cbrt(i));
    return Li(uU, r);
  },
  toBase(e) {
    let r = Li(cU, e).map((i) => i ** 3);
    return Li(lU, r);
  },
  formats: {
    oklab: {
      coords: ["<percentage> | <number>", "<number> | <percentage>[-1,1]", "<number> | <percentage>[-1,1]"]
    }
  }
});
function dU(e, t) {
  let [r, i, n] = Og.from(e), [a, o, s] = Og.from(t), l = r - a, u = i - o, d = n - s;
  return Math.sqrt(l ** 2 + u ** 2 + d ** 2);
}
var Pg = {
  deltaE76: $$,
  deltaECMC: V$,
  deltaE2000: Xb,
  deltaEJz: X$,
  deltaEITP: oU,
  deltaEOK: dU
};
function H0(e, t, r = {}) {
  j1(r) && (r = { method: r });
  let { method: i = Jo.deltaE, ...n } = r;
  e = Br(e), t = Br(t);
  for (let a in Pg)
    if ("deltae" + i.toLowerCase() === a.toLowerCase())
      return Pg[a](e, t, n);
  throw new TypeError(`Unknown deltaE method: ${i}`);
}
function pU(e, t = 0.25) {
  let i = [jt.get("oklch", "lch"), "l"];
  return Pl(e, i, (n) => n * (1 + t));
}
function hU(e, t = 0.25) {
  let i = [jt.get("oklch", "lch"), "l"];
  return Pl(e, i, (n) => n * (1 - t));
}
var fU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  darken: hU,
  lighten: pU
});
function IA(e, t, r = 0.5, i = {}) {
  [e, t] = [Br(e), Br(t)], Fl(r) === "object" && ([r, i] = [0.5, r]);
  let { space: n, outputSpace: a, premultiplied: o } = i;
  return $1(e, t, { space: n, outputSpace: a, premultiplied: o })(r);
}
function BA(e, t, r = {}) {
  let i;
  V2(e) && ([i, r] = [e, t], [e, t] = i.rangeArgs.colors);
  let {
    maxDeltaE: n,
    deltaEMethod: a,
    steps: o = 2,
    maxSteps: s = 1e3,
    ...l
  } = r;
  i || ([e, t] = [Br(e), Br(t)], i = $1(e, t, l));
  let u = H0(e, t), d = n > 0 ? Math.max(o, Math.ceil(u / n) + 1) : o, c = [];
  if (s !== void 0 && (d = Math.min(d, s)), d === 1)
    c = [{ p: 0.5, color: i(0.5) }];
  else {
    let p = 1 / (d - 1);
    c = Array.from({ length: d }, (f, g) => {
      let k = g * p;
      return { p: k, color: i(k) };
    });
  }
  if (n > 0) {
    let p = c.reduce((f, g, k) => {
      if (k === 0)
        return 0;
      let y = H0(g.color, c[k - 1].color, a);
      return Math.max(f, y);
    }, 0);
    for (; p > n; ) {
      p = 0;
      for (let f = 1; f < c.length && c.length < s; f++) {
        let g = c[f - 1], k = c[f], y = (k.p + g.p) / 2, _ = i(y);
        p = Math.max(p, H0(_, g.color), H0(_, k.color)), c.splice(f, 0, { p: y, color: i(y) }), f++;
      }
    }
  }
  return c = c.map((p) => p.color), c;
}
function $1(e, t, r = {}) {
  if (V2(e)) {
    let [l, u] = [e, t];
    return $1(...l.rangeArgs.colors, { ...l.rangeArgs.options, ...u });
  }
  let { space: i, outputSpace: n, progression: a, premultiplied: o } = r;
  e = Br(e), t = Br(t), e = k1(e), t = k1(t);
  let s = { colors: [e, t], options: r };
  if (i ? i = jt.get(i) : i = jt.registry[Jo.interpolationSpace] || e.space, n = n ? jt.get(n) : i, e = $a(e, i), t = $a(t, i), e = Nl(e), t = Nl(t), i.coords.h && i.coords.h.type === "angle") {
    let l = r.hue = r.hue || "shorter", u = [i, "h"], [d, c] = [Va(e, u), Va(t, u)];
    [d, c] = c$(l, [d, c]), Pl(e, u, d), Pl(t, u, c);
  }
  return o && (e.coords = e.coords.map((l) => l * e.alpha), t.coords = t.coords.map((l) => l * t.alpha)), Object.assign((l) => {
    l = a ? a(l) : l;
    let u = e.coords.map((p, f) => {
      let g = t.coords[f];
      return Sg(p, g, l);
    }), d = Sg(e.alpha, t.alpha, l), c = { space: i, coords: u, alpha: d };
    return o && (c.coords = c.coords.map((p) => p / d)), n !== i && (c = $a(c, n)), c;
  }, {
    rangeArgs: s
  });
}
function V2(e) {
  return Fl(e) === "function" && !!e.rangeArgs;
}
Jo.interpolationSpace = "lab";
function gU(e) {
  e.defineFunction("mix", IA, { returns: "color" }), e.defineFunction("range", $1, { returns: "function<color>" }), e.defineFunction("steps", BA, { returns: "array<color>" });
}
var mU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  isRange: V2,
  mix: IA,
  range: $1,
  register: gU,
  steps: BA
}), RA = new jt({
  id: "hsl",
  name: "HSL",
  coords: {
    h: {
      refRange: [0, 360],
      type: "angle",
      name: "Hue"
    },
    s: {
      range: [0, 100],
      name: "Saturation"
    },
    l: {
      range: [0, 100],
      name: "Lightness"
    }
  },
  base: b1,
  // Adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB
  fromBase: (e) => {
    let t = Math.max(...e), r = Math.min(...e), [i, n, a] = e, [o, s, l] = [NaN, 0, (r + t) / 2], u = t - r;
    if (u !== 0) {
      switch (s = l === 0 || l === 1 ? 0 : (t - l) / Math.min(l, 1 - l), t) {
        case i:
          o = (n - a) / u + (n < a ? 6 : 0);
          break;
        case n:
          o = (a - i) / u + 2;
          break;
        case a:
          o = (i - n) / u + 4;
      }
      o = o * 60;
    }
    return [o, s * 100, l * 100];
  },
  // Adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_RGB_alternative
  toBase: (e) => {
    let [t, r, i] = e;
    t = t % 360, t < 0 && (t += 360), r /= 100, i /= 100;
    function n(a) {
      let o = (a + t / 30) % 12, s = r * Math.min(i, 1 - i);
      return i - s * Math.max(-1, Math.min(o - 3, 9 - o, 1));
    }
    return [n(0), n(8), n(4)];
  },
  formats: {
    hsl: {
      toGamut: !0,
      coords: ["<number> | <angle>", "<percentage>", "<percentage>"]
    },
    hsla: {
      coords: ["<number> | <angle>", "<percentage>", "<percentage>"],
      commas: !0,
      lastAlpha: !0
    }
  }
}), OA = new jt({
  id: "hsv",
  name: "HSV",
  coords: {
    h: {
      refRange: [0, 360],
      type: "angle",
      name: "Hue"
    },
    s: {
      range: [0, 100],
      name: "Saturation"
    },
    v: {
      range: [0, 100],
      name: "Value"
    }
  },
  base: RA,
  // https://en.wikipedia.org/wiki/HSL_and_HSV#Interconversion
  fromBase(e) {
    let [t, r, i] = e;
    r /= 100, i /= 100;
    let n = i + r * Math.min(i, 1 - i);
    return [
      t,
      // h is the same
      n === 0 ? 0 : 200 * (1 - i / n),
      // s
      100 * n
    ];
  },
  // https://en.wikipedia.org/wiki/HSL_and_HSV#Interconversion
  toBase(e) {
    let [t, r, i] = e;
    r /= 100, i /= 100;
    let n = i * (1 - r / 2);
    return [
      t,
      // h is the same
      n === 0 || n === 1 ? 0 : (i - n) / Math.min(n, 1 - n) * 100,
      n * 100
    ];
  },
  formats: {
    color: {
      toGamut: !0
    }
  }
}), vU = new jt({
  id: "hwb",
  name: "HWB",
  coords: {
    h: {
      refRange: [0, 360],
      type: "angle",
      name: "Hue"
    },
    w: {
      range: [0, 100],
      name: "Whiteness"
    },
    b: {
      range: [0, 100],
      name: "Blackness"
    }
  },
  base: OA,
  fromBase(e) {
    let [t, r, i] = e;
    return [t, i * (100 - r) / 100, 100 - i];
  },
  toBase(e) {
    let [t, r, i] = e;
    r /= 100, i /= 100;
    let n = r + i;
    if (n >= 1) {
      let s = r / n;
      return [t, 0, s * 100];
    }
    let a = 1 - i, o = a === 0 ? 0 : 1 - r / a;
    return [t, o * 100, a * 100];
  },
  formats: {
    hwb: {
      toGamut: !0,
      coords: ["<number> | <angle>", "<percentage>", "<percentage>"]
    }
  }
});
const kU = [
  [0.5766690429101305, 0.1855582379065463, 0.1882286462349947],
  [0.29734497525053605, 0.6273635662554661, 0.07529145849399788],
  [0.02703136138641234, 0.07068885253582723, 0.9913375368376388]
], bU = [
  [2.0415879038107465, -0.5650069742788596, -0.34473135077832956],
  [-0.9692436362808795, 1.8759675015077202, 0.04155505740717557],
  [0.013444280632031142, -0.11836239223101838, 1.0151749943912054]
];
var PA = new sa({
  id: "a98rgb-linear",
  name: "Linear Adobe® 98 RGB compatible",
  white: "D65",
  toXYZ_M: kU,
  fromXYZ_M: bU
}), _U = new sa({
  id: "a98rgb",
  name: "Adobe® 98 RGB compatible",
  base: PA,
  toBase: (e) => e.map((t) => Math.pow(Math.abs(t), 563 / 256) * Math.sign(t)),
  fromBase: (e) => e.map((t) => Math.pow(Math.abs(t), 256 / 563) * Math.sign(t)),
  formats: {
    color: {
      id: "a98-rgb"
    }
  }
});
const DU = [
  [0.7977604896723027, 0.13518583717574031, 0.0313493495815248],
  [0.2880711282292934, 0.7118432178101014, 8565396060525902e-20],
  [0, 0, 0.8251046025104601]
], yU = [
  [1.3457989731028281, -0.25558010007997534, -0.05110628506753401],
  [-0.5446224939028347, 1.5082327413132781, 0.02053603239147973],
  [0, 0, 1.2119675456389454]
];
var NA = new sa({
  id: "prophoto-linear",
  name: "Linear ProPhoto",
  white: "D50",
  base: $2,
  toXYZ_M: DU,
  fromXYZ_M: yU
});
const EU = 1 / 512, CU = 16 / 512;
var xU = new sa({
  id: "prophoto",
  name: "ProPhoto",
  base: NA,
  toBase(e) {
    return e.map((t) => t < CU ? t / 16 : t ** 1.8);
  },
  fromBase(e) {
    return e.map((t) => t >= EU ? t ** (1 / 1.8) : 16 * t);
  },
  formats: {
    color: {
      id: "prophoto-rgb"
    }
  }
}), AU = new jt({
  id: "oklch",
  name: "Oklch",
  coords: {
    l: {
      refRange: [0, 1],
      name: "Lightness"
    },
    c: {
      refRange: [0, 0.4],
      name: "Chroma"
    },
    h: {
      refRange: [0, 360],
      type: "angle",
      name: "Hue"
    }
  },
  white: "D65",
  base: Og,
  fromBase(e) {
    let [t, r, i] = e, n;
    const a = 2e-4;
    return Math.abs(r) < a && Math.abs(i) < a ? n = NaN : n = Math.atan2(i, r) * 180 / Math.PI, [
      t,
      // OKLab L is still L
      Math.sqrt(r ** 2 + i ** 2),
      // Chroma
      bm(n)
      // Hue, in degrees [0 to 360)
    ];
  },
  // Convert from polar form
  toBase(e) {
    let [t, r, i] = e, n, a;
    return isNaN(i) ? (n = 0, a = 0) : (n = r * Math.cos(i * Math.PI / 180), a = r * Math.sin(i * Math.PI / 180)), [t, n, a];
  },
  formats: {
    oklch: {
      coords: ["<number> | <percentage>", "<number> | <percentage>[0,1]", "<number> | <angle>"]
    }
  }
});
const ME = 203, jE = 2610 / 2 ** 14, wU = 2 ** 14 / 2610, FU = 2523 / 2 ** 5, HE = 2 ** 5 / 2523, $E = 3424 / 2 ** 12, UE = 2413 / 2 ** 7, VE = 2392 / 2 ** 7;
var TU = new sa({
  id: "rec2100pq",
  name: "REC.2100-PQ",
  base: _m,
  toBase(e) {
    return e.map(function(t) {
      return (Math.max(t ** HE - $E, 0) / (UE - VE * t ** HE)) ** wU * 1e4 / ME;
    });
  },
  fromBase(e) {
    return e.map(function(t) {
      let r = Math.max(t * ME / 1e4, 0), i = $E + UE * r ** jE, n = 1 + VE * r ** jE;
      return (i / n) ** FU;
    });
  },
  formats: {
    color: {
      id: "rec2100-pq"
    }
  }
});
const WE = 0.17883277, GE = 0.28466892, KE = 0.55991073, kk = 3.7743;
var SU = new sa({
  id: "rec2100hlg",
  cssid: "rec2100-hlg",
  name: "REC.2100-HLG",
  referred: "scene",
  base: _m,
  toBase(e) {
    return e.map(function(t) {
      return t <= 0.5 ? t ** 2 / 3 * kk : (Math.exp((t - KE) / WE) + GE) / 12 * kk;
    });
  },
  fromBase(e) {
    return e.map(function(t) {
      return t /= kk, t <= 1 / 12 ? Math.sqrt(3 * t) : WE * Math.log(12 * t - GE) + KE;
    });
  },
  formats: {
    color: {
      id: "rec2100-hlg"
    }
  }
});
const zA = {};
Ol.add("chromatic-adaptation-start", (e) => {
  e.options.method && (e.M = LA(e.W1, e.W2, e.options.method));
});
Ol.add("chromatic-adaptation-end", (e) => {
  e.M || (e.M = LA(e.W1, e.W2, e.options.method));
});
function Dm({ id: e, toCone_M: t, fromCone_M: r }) {
  zA[e] = arguments[0];
}
function LA(e, t, r = "Bradford") {
  let i = zA[r], [n, a, o] = Li(i.toCone_M, e), [s, l, u] = Li(i.toCone_M, t), d = [
    [s / n, 0, 0],
    [0, l / a, 0],
    [0, 0, u / o]
  ], c = Li(d, i.toCone_M);
  return Li(i.fromCone_M, c);
}
Dm({
  id: "von Kries",
  toCone_M: [
    [0.40024, 0.7076, -0.08081],
    [-0.2263, 1.16532, 0.0457],
    [0, 0, 0.91822]
  ],
  fromCone_M: [
    [1.8599364, -1.1293816, 0.2198974],
    [0.3611914, 0.6388125, -64e-7],
    [0, 0, 1.0890636]
  ]
});
Dm({
  id: "Bradford",
  // Convert an array of XYZ values in the range 0.0 - 1.0
  // to cone fundamentals
  toCone_M: [
    [0.8951, 0.2664, -0.1614],
    [-0.7502, 1.7135, 0.0367],
    [0.0389, -0.0685, 1.0296]
  ],
  // and back
  fromCone_M: [
    [0.9869929, -0.1470543, 0.1599627],
    [0.4323053, 0.5183603, 0.0492912],
    [-85287e-7, 0.0400428, 0.9684867]
  ]
});
Dm({
  id: "CAT02",
  // with complete chromatic adaptation to W2, so D = 1.0
  toCone_M: [
    [0.7328, 0.4296, -0.1624],
    [-0.7036, 1.6975, 61e-4],
    [3e-3, 0.0136, 0.9834]
  ],
  fromCone_M: [
    [1.0961238, -0.278869, 0.1827452],
    [0.454369, 0.4735332, 0.0720978],
    [-96276e-7, -5698e-6, 1.0153256]
  ]
});
Dm({
  id: "CAT16",
  toCone_M: [
    [0.401288, 0.650173, -0.051461],
    [-0.250268, 1.204414, 0.045854],
    [-2079e-6, 0.048952, 0.953127]
  ],
  // the extra precision is needed to avoid roundtripping errors
  fromCone_M: [
    [1.862067855087233, -1.011254630531685, 0.1491867754444518],
    [0.3875265432361372, 0.6214474419314753, -0.008973985167612518],
    [-0.01584149884933386, -0.03412293802851557, 1.04996443687785]
  ]
});
Object.assign(ko, {
  // whitepoint values from ASTM E308-01 with 10nm spacing, 1931 2 degree observer
  // all normalized to Y (luminance) = 1.00000
  // Illuminant A is a tungsten electric light, giving a very warm, orange light.
  A: [1.0985, 1, 0.35585],
  // Illuminant C was an early approximation to daylight: illuminant A with a blue filter.
  C: [0.98074, 1, 1.18232],
  // The daylight series of illuminants simulate natural daylight.
  // The color temperature (in degrees Kelvin/100) ranges from
  // cool, overcast daylight (D50) to bright, direct sunlight (D65).
  D55: [0.95682, 1, 0.92149],
  D75: [0.94972, 1, 1.22638],
  // Equal-energy illuminant, used in two-stage CAT16
  E: [1, 1, 1],
  // The F series of illuminants represent fluorescent lights
  F2: [0.99186, 1, 0.67393],
  F7: [0.95041, 1, 1.08747],
  F11: [1.00962, 1, 0.6435]
});
ko.ACES = [0.32168 / 0.33767, 1, (1 - 0.32168 - 0.33767) / 0.33767];
const IU = [
  [0.6624541811085053, 0.13400420645643313, 0.1561876870049078],
  [0.27222871678091454, 0.6740817658111484, 0.05368951740793705],
  [-0.005574649490394108, 0.004060733528982826, 1.0103391003129971]
], BU = [
  [1.6410233796943257, -0.32480329418479, -0.23642469523761225],
  [-0.6636628587229829, 1.6153315916573379, 0.016756347685530137],
  [0.011721894328375376, -0.008284441996237409, 0.9883948585390215]
];
var MA = new sa({
  id: "acescg",
  name: "ACEScg",
  // ACEScg – A scene-referred, linear-light encoding of ACES Data
  // https://docs.acescentral.com/specifications/acescg/
  // uses the AP1 primaries, see section 4.3.1 Color primaries
  coords: {
    r: {
      range: [0, 65504],
      name: "Red"
    },
    g: {
      range: [0, 65504],
      name: "Green"
    },
    b: {
      range: [0, 65504],
      name: "Blue"
    }
  },
  referred: "scene",
  white: ko.ACES,
  toXYZ_M: IU,
  fromXYZ_M: BU,
  formats: {
    color: {}
  }
});
const cf = 2 ** -16, bk = -0.35828683, df = (Math.log2(65504) + 9.72) / 17.52;
var RU = new sa({
  id: "acescc",
  name: "ACEScc",
  // see S-2014-003 ACEScc – A Logarithmic Encoding of ACES Data
  // https://docs.acescentral.com/specifications/acescc/
  // uses the AP1 primaries, see section 4.3.1 Color primaries
  // Appendix A: "Very small ACES scene referred values below 7 1/4 stops
  // below 18% middle gray are encoded as negative ACEScc values.
  // These values should be preserved per the encoding in Section 4.4
  // so that all positive ACES values are maintained."
  coords: {
    r: {
      range: [bk, df],
      name: "Red"
    },
    g: {
      range: [bk, df],
      name: "Green"
    },
    b: {
      range: [bk, df],
      name: "Blue"
    }
  },
  referred: "scene",
  base: MA,
  // from section 4.4.2 Decoding Function
  toBase(e) {
    const t = -0.3013698630136986;
    return e.map(function(r) {
      return r <= t ? (2 ** (r * 17.52 - 9.72) - cf) * 2 : r < df ? 2 ** (r * 17.52 - 9.72) : 65504;
    });
  },
  // Non-linear encoding function from S-2014-003, section 4.4.1 Encoding Function
  fromBase(e) {
    return e.map(function(t) {
      return t <= 0 ? (Math.log2(cf) + 9.72) / 17.52 : t < cf ? (Math.log2(cf + t * 0.5) + 9.72) / 17.52 : (Math.log2(t) + 9.72) / 17.52;
    });
  },
  // encoded media white (rgb 1,1,1) => linear  [ 222.861, 222.861, 222.861 ]
  // encoded media black (rgb 0,0,0) => linear [ 0.0011857, 0.0011857, 0.0011857]
  formats: {
    color: {}
  }
}), YE = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  A98RGB: _U,
  A98RGB_Linear: PA,
  ACEScc: RU,
  ACEScg: MA,
  HSL: RA,
  HSV: OA,
  HWB: vU,
  ICTCP: e_,
  JzCzHz: Jb,
  Jzazbz: wA,
  LCH: v1,
  Lab: ya,
  Lab_D65: Zb,
  OKLCH: AU,
  OKLab: Og,
  P3: yA,
  P3_Linear: _A,
  ProPhoto: xU,
  ProPhoto_Linear: NA,
  REC_2020: bA,
  REC_2020_Linear: _m,
  REC_2100_HLG: SU,
  REC_2100_PQ: TU,
  XYZ_ABS_D65: U2,
  XYZ_D50: $2,
  XYZ_D65: Ua,
  sRGB: b1,
  sRGB_Linear: DA
});
class er {
  /**
   * Creates an instance of Color.
   * Signatures:
   * - `new Color(stringToParse)`
   * - `new Color(otherColor)`
   * - `new Color({space, coords, alpha})`
   * - `new Color(space, coords, alpha)`
   * - `new Color(spaceId, coords, alpha)`
   */
  constructor(...t) {
    let r;
    t.length === 1 && (r = Br(t[0]));
    let i, n, a;
    r ? (i = r.space || r.spaceId, n = r.coords, a = r.alpha) : [i, n, a] = t, Object.defineProperty(this, "space", {
      value: jt.get(i),
      writable: !1,
      enumerable: !0,
      configurable: !0
      // see note in https://262.ecma-international.org/8.0/#sec-proxy-object-internal-methods-and-internal-slots-get-p-receiver
    }), this.coords = n ? n.slice() : [0, 0, 0], this.alpha = a < 1 ? a : 1;
    for (let o = 0; o < this.coords.length; o++)
      this.coords[o] === "NaN" && (this.coords[o] = NaN);
    for (let o in this.space.coords)
      Object.defineProperty(this, o, {
        get: () => this.get(o),
        set: (s) => this.set(o, s)
      });
  }
  get spaceId() {
    return this.space.id;
  }
  clone() {
    return new er(this.space, this.coords, this.alpha);
  }
  toJSON() {
    return {
      spaceId: this.spaceId,
      coords: this.coords,
      alpha: this.alpha
    };
  }
  display(...t) {
    let r = k$(this, ...t);
    return r.color = new er(r.color), r;
  }
  /**
   * Get a color from the argument passed
   * Basically gets us the same result as new Color(color) but doesn't clone an existing color object
   */
  static get(t, ...r) {
    return t instanceof er ? t : new er(t, ...r);
  }
  static defineFunction(t, r, i = r) {
    let { instance: n = !0, returns: a } = i, o = function(...s) {
      let l = r(...s);
      if (a === "color")
        l = er.get(l);
      else if (a === "function<color>") {
        let u = l;
        l = function(...d) {
          let c = u(...d);
          return er.get(c);
        }, Object.assign(l, u);
      } else
        a === "array<color>" && (l = l.map((u) => er.get(u)));
      return l;
    };
    t in er || (er[t] = o), n && (er.prototype[t] = function(...s) {
      return o(this, ...s);
    });
  }
  static defineFunctions(t) {
    for (let r in t)
      er.defineFunction(r, t[r], t[r]);
  }
  static extend(t) {
    if (t.register)
      t.register(er);
    else
      for (let r in t)
        er.defineFunction(r, t[r]);
  }
}
er.defineFunctions({
  get: Va,
  getAll: H1,
  set: Pl,
  setAll: kA,
  to: $a,
  equals: b$,
  inGamut: Y0,
  toGamut: Nl,
  distance: EA,
  toString: Rg
});
Object.assign(er, {
  util: a$,
  hooks: Ol,
  WHITES: ko,
  Space: jt,
  spaces: jt.registry,
  parse: vA,
  // Global defaults one may want to configure
  defaults: Jo
});
for (let e of Object.keys(YE))
  jt.register(YE[e]);
for (let e in jt.registry)
  t_(e, jt.registry[e]);
Ol.add("colorspace-init-end", (e) => {
  var t;
  t_(e.id, e), (t = e.aliases) == null || t.forEach((r) => {
    t_(r, e);
  });
});
function t_(e, t) {
  Object.keys(t.coords), Object.values(t.coords).map((i) => i.name);
  let r = e.replace(/-/g, "_");
  Object.defineProperty(er.prototype, r, {
    // Convert coords to coords in another colorspace and return them
    // Source colorspace: this.spaceId
    // Target colorspace: id
    get() {
      let i = this.getAll(e);
      return typeof Proxy > "u" ? i : new Proxy(i, {
        has: (n, a) => {
          try {
            return jt.resolveCoord([t, a]), !0;
          } catch {
          }
          return Reflect.has(n, a);
        },
        get: (n, a, o) => {
          if (a && typeof a != "symbol" && !(a in n)) {
            let { index: s } = jt.resolveCoord([t, a]);
            if (s >= 0)
              return n[s];
          }
          return Reflect.get(n, a, o);
        },
        set: (n, a, o, s) => {
          if (a && typeof a != "symbol" && !(a in n) || a >= 0) {
            let { index: l } = jt.resolveCoord([t, a]);
            if (l >= 0)
              return n[l] = o, this.setAll(e, n), !0;
          }
          return Reflect.set(n, a, o, s);
        }
      });
    },
    // Convert coords in another colorspace to internal coords and set them
    // Target colorspace: this.spaceId
    // Source colorspace: id
    set(i) {
      this.setAll(e, i);
    },
    configurable: !0,
    enumerable: !0
  });
}
er.extend(Pg);
er.extend({ deltaE: H0 });
Object.assign(er, { deltaEMethods: Pg });
er.extend(fU);
er.extend({ contrast: M$ });
er.extend(H$);
er.extend(D$);
er.extend(mU);
er.extend(Vf);
function _k(e) {
  return Number.parseInt(e, 16) || 0;
}
function Dk(e) {
  return _k(e) / 255 <= 0.03928 ? _k(e) / 255 / 12.92 : ((_k(e) / 255 + 0.055) / 1.055) ** 2.4;
}
function qE(e) {
  return 0.2126 * Dk(e.slice(1, 3)) + 0.7152 * Dk(e.slice(3, 5)) + 0.0722 * Dk(e.slice(-2));
}
function QE(e, t) {
  const r = qE(e), i = qE(t);
  return (Math.max(r, i) + 0.05) / (Math.min(r, i) + 0.05);
}
function OU(e, t, r) {
  const i = QE(e, t), n = QE(e, r);
  return i > n ? t : r;
}
B6.animations({
  "backdrop-in": {
    value: "fade-in 250ms {easings.default}"
  },
  "backdrop-out": {
    value: "fade-out 200ms {easings.default}"
  },
  "dialog-in": {
    value: "slide-in 400ms {easings.emphasized-in}"
  },
  "dialog-out": {
    value: "slide-out 200ms {easings.emphasized-out}"
  }
});
const PU = B6({
  colors: {
    gray: {
      // CURRENT, LOOSELY BASED OFF RADIX SLATE GRAY
      50: { value: "#f8f9fa" },
      // slate }2
      100: { value: "#f1f3f5" },
      // slate }3
      200: { value: "#eceef0" },
      // slate }4
      300: { value: "#e6e8eb" },
      // slate }5
      400: { value: "#dfe3e6" },
      // slate }6
      500: { value: "#BDC2C7" },
      // did not match the slate gra }y
      600: { value: "#889096" },
      // slate }9
      700: { value: "#687076" },
      // slate1 }1
      800: { value: "#36424A" },
      // did not match the slate gra }y
      900: { value: "#11181c" }
      // slate1 }2
    },
    // alphas based off of grays
    grayAlpha: {
      50: { value: "rgba(22, 56, 90, 0.03)" },
      100: { value: "rgba(22, 56, 90, 0.06)" },
      200: { value: "rgba(18, 43, 68, 0.08)" },
      300: { value: "rgba(5, 26, 56, 0.1)" },
      400: { value: "rgba(9, 39, 62, 0.13)" },
      500: { value: "rgba(1, 20, 40, 0.26)" },
      600: { value: "rgba(2, 20, 34, 0.47)" },
      700: { value: "rgba(3, 17, 28, 0.6)" },
      800: { value: "rgba(1, 15, 25, 0.79)" },
      900: { value: "rgba(2, 9, 13, 0.94)" }
    },
    // radix neutral gray for dark mode ('grayDark')
    grayDark: {
      // '900': { value: '#161616' },
      900: { value: "#1c1c1c" },
      // '800': { value: '#0b0a0a' },
      800: { value: "#282828" },
      700: { value: "#2e2e2e" },
      600: { value: "#343434" },
      500: { value: "#3e3e3e" },
      400: { value: "#505050" },
      300: { value: "#707070" },
      200: { value: "#7e7e7e" },
      100: { value: "#a0a0a0" },
      50: { value: "#ededed" }
    }
  },
  fonts: {
    body: {
      value: "'Inter', sans-serif"
    },
    heading: {
      value: "'Inter', sans-serif"
    }
  },
  // https://github.com/cschroeter/park-ui/blob/ff729b25267137a6e5a87a375fe8b647e148dd2b/packages/presets/src/theme/tokens/animations.ts
  easings: {
    default: { value: "cubic-bezier(0.2, 0.0, 0, 1.0)" },
    "emphasized-in": { value: "cubic-bezier(0.05, 0.7, 0.1, 1.0)" },
    "emphasized-out": { value: "cubic-bezier(0.3, 0.0, 0.8, 0.15)" }
  },
  animations: {
    "backdrop-in": {
      value: "fade-in 250ms {easings.default}"
    },
    "backdrop-out": {
      value: "fade-out 200ms {easings.default}"
    },
    "dialog-in": {
      value: "slide-in 400ms {easings.emphasized-in}"
    },
    "dialog-out": {
      value: "slide-out 200ms {easings.emphasized-out}"
    }
  },
  // packages/widgets/src/themes/index.ts
  durations: {
    faster: { value: "100ms" },
    fast: { value: "180ms" },
    medium: { value: "300ms" },
    slow: { value: "500ms" }
  },
  shadows: {
    outline: { value: "none" },
    boxShadow: { value: "none" },
    tooltipShadow: { value: "0 8px 30px rgba(0, 0, 0, 0.12)" }
  }
}), NU = (e, t) => {
  const r = W2(e), i = {};
  return x2(
    r,
    (n, a, o) => {
      if (typeof a == "string") {
        const s = `--${t ? t + "-" : ""}colors-` + Ub(o);
        i[s] = a;
      }
    },
    { separator: "-" }
  ), i;
}, zU = "#000000";
function No(e) {
  return e.to("srgb").toString({ format: "hex" });
}
function D0(e, t, r) {
  const i = e.lch, n = t.lch, a = i.l + (n.l - i.l) * r, o = i.c + (n.c - i.c) * r, s = i.h + (n.h - i.h) * r;
  return new er("lch", [a, o, s]);
}
function zo(e) {
  return e.to("srgb");
}
const LU = new er(zU), jA = (e) => {
  const t = e instanceof er ? e : new er(e), r = t.lch.c < 3 ? t.lch.c : 3, i = t.lch.c < 10 ? t.lch.c : 10, n = t.lch.c < 5 ? t.lch.c : 5;
  return {
    textBold: new er("lch", [10, n, t.lch.h]),
    textSubtle: new er("lch", [30, i, t.lch.h]),
    lighter: new er("lch", [98, t.lch.c * 1.2, t.lch.h * 0.96]),
    light: new er("lch", [89, t.lch.c * 1.2, t.lch.h * 0.96]),
    lightSubtle: new er("lch", [
      98,
      r,
      t.lch.h * 0.98
    ]),
    medium: t,
    mediumSubtle: new er("lch", [
      t.lch.l * 0.5,
      t.lch.c,
      t.lch.h
    ], 0.3),
    strong: new er("lch", [
      t.lch.l * 0.85,
      t.lch.c,
      t.lch.h
    ]),
    stronger: new er("lch", [
      t.lch.l * 0.5,
      t.lch.c,
      t.lch.h
    ])
  };
}, HA = jA(LU), W2 = (e, t) => {
  const r = Object.assign(
    {},
    t ? jA(t) : HA,
    e
  );
  Object.keys(r).forEach((l) => {
    r[l] instanceof er || (r[l] = new er(r[l]));
  });
  const i = Object.assign(
    {
      hitContentPreview: r.strong,
      hitContentPreviewHover: r.stronger
    },
    r
  ), n = Object.keys(i).reduce((l, u) => (l[u] = i[u].to("srgb").toString({ format: "hex" }), l), {}), a = {
    50: No(zo(i.lighter)),
    100: No(
      zo(D0(i.lighter, i.light, 0.5))
    ),
    200: No(zo(i.light)),
    300: No(
      zo(D0(i.light, i.medium, 0.5))
    ),
    400: No(
      zo(D0(i.light, i.medium, 0.75))
    ),
    500: No(zo(i.medium)),
    600: No(
      zo(D0(i.medium, i.strong, 0.75))
    ),
    700: No(zo(i.strong)),
    800: No(
      zo(D0(i.strong, i.stronger, 0.5))
    ),
    900: No(zo(i.stronger))
  }, o = n.textColorOnPrimary || OU(
    n.medium,
    "#ffffff",
    PU.colors.gray[900].value
  );
  return {
    inkeepPrimary: {
      ...n,
      textColorOnPrimary: o
    },
    inkeepExpandedPrimary: a
  };
};
W2(HA);
const U1 = ({ children: e }) => {
  var l, u;
  const t = Xi(), r = t.theme ?? {}, i = t == null ? void 0 : t.colorMode, n = r.primaryColors ?? {}, a = t.primaryBrandColor || "#000000", o = W2(n, a), s = Object.assign(
    XE(r.tokens ?? {}, Jh.prefix),
    NU(o.inkeepPrimary, Jh.prefix),
    XE(
      {
        colors: {
          "inkeepExpandedPrimary.100": o.inkeepExpandedPrimary[100],
          "inkeepExpandedPrimary.200": o.inkeepExpandedPrimary[200],
          "inkeepExpandedPrimary.300": o.inkeepExpandedPrimary[300],
          "inkeepExpandedPrimary.400": o.inkeepExpandedPrimary[400],
          "inkeepExpandedPrimary.500": o.inkeepExpandedPrimary[500],
          "inkeepExpandedPrimary.600": o.inkeepExpandedPrimary[600],
          "inkeepExpandedPrimary.700": o.inkeepExpandedPrimary[700],
          "inkeepExpandedPrimary.800": o.inkeepExpandedPrimary[800],
          "inkeepExpandedPrimary.900": o.inkeepExpandedPrimary[900]
        }
      },
      Jh.prefix
    )
  );
  return /* @__PURE__ */ v.jsx(
    XH,
    {
      ...i,
      shadowHostId: (l = t.shadowHost) == null ? void 0 : l.id,
      rootId: (u = t.rootElement) == null ? void 0 : u.id,
      children: /* @__PURE__ */ v.jsx(
        "div",
        {
          className: Eo(
            Jh.themeVarsClass,
            yo({ display: "contents" })
          ),
          style: s,
          children: e
        }
      )
    }
  );
}, XE = (e, t) => {
  const r = {};
  for (const [i, n] of Object.entries(e ?? {}))
    x2(
      n,
      (a, o, s) => {
        if (typeof o == "string" || typeof o == "number") {
          const l = `--${t ? `${t}-` : ""}${Ub(
            i
          )}-${Ub(s.replace(".", "-"))}`;
          r[l] = o;
        }
      },
      { separator: "-" }
    );
  return r;
}, $A = kn({
  log: () => {
  },
  logBuffer: []
}), dn = () => Pn($A), ZE = (e) => {
  if (typeof e == "object" && e !== null)
    try {
      return JSON.stringify(e, null, 2);
    } catch {
      return e;
    }
  else
    return e;
};
function MU(e) {
  const t = e.split(`
`);
  if (t.length >= 3) {
    const r = t[2].trim(), i = r.match(/at\s+(.*?)\s\(/), n = r.match(/\(([^()]+)\)/), a = i ? i[1] : null, o = n ? n[1] : null;
    return { componentName: a, sourceFile: o };
  }
  return { componentName: null, sourceFile: null };
}
const jU = ({ children: e }) => {
  const { consoleDebugLevel: t, remoteErrorLogsLevel: r } = Xi(), i = qt([]), n = (o) => {
    if (!r || r < r8.IdentifiableErrors)
      return;
    const s = o.slice(0, 500);
    i.current = [...i.current, s], i.current.length > 20 && i.current.shift();
  }, a = Jt(
    () => (o, ...s) => {
      const l = ZE(o), u = s.map((k, y) => {
        const _ = ZE(k);
        return typeof k == "object" && k !== null ? `${_}` : _;
      }), d = `${l}
${u.join(
        `
`
      )}`, c = new Error().stack || "", { componentName: p, sourceFile: f } = MU(c), g = `${d}${p ? `
| Logged from: ${p}` : ""}`;
      t && t >= s1.Messages && console.log(g), t && t >= s1.Verbose && console.log(c), n(g);
    },
    [t]
  );
  return /* @__PURE__ */ v.jsx($A.Provider, { value: { log: a, logBuffer: i.current }, children: e });
}, ym = jU, HU = kn(null), yk = {
  didCatch: !1,
  error: null
};
class UA extends WT {
  constructor(t) {
    super(t), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = yk;
  }
  static getDerivedStateFromError(t) {
    return {
      didCatch: !0,
      error: t
    };
  }
  resetErrorBoundary() {
    const {
      error: t
    } = this.state;
    if (t !== null) {
      for (var r, i, n = arguments.length, a = new Array(n), o = 0; o < n; o++)
        a[o] = arguments[o];
      (r = (i = this.props).onReset) === null || r === void 0 || r.call(i, {
        args: a,
        reason: "imperative-api"
      }), this.setState(yk);
    }
  }
  componentDidCatch(t, r) {
    var i, n;
    (i = (n = this.props).onError) === null || i === void 0 || i.call(n, t, r);
  }
  componentDidUpdate(t, r) {
    const {
      didCatch: i
    } = this.state, {
      resetKeys: n
    } = this.props;
    if (i && r.error !== null && $U(t.resetKeys, n)) {
      var a, o;
      (a = (o = this.props).onReset) === null || a === void 0 || a.call(o, {
        next: n,
        prev: t.resetKeys,
        reason: "keys"
      }), this.setState(yk);
    }
  }
  render() {
    const {
      children: t,
      fallbackRender: r,
      FallbackComponent: i,
      fallback: n
    } = this.props, {
      didCatch: a,
      error: o
    } = this.state;
    let s = t;
    if (a) {
      const l = {
        error: o,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof r == "function")
        s = r(l);
      else if (i)
        s = xa(i, l);
      else if (n === null || Xx(n))
        s = n;
      else
        throw o;
    }
    return xa(HU.Provider, {
      value: {
        didCatch: a,
        error: o,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, s);
  }
}
function $U() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return e.length !== t.length || e.some((r, i) => !Object.is(r, t[i]));
}
const UU = () => null, VU = ({
  children: e
}) => {
  const t = (r, i) => {
    console.log(r), console.log(i);
  };
  return /* @__PURE__ */ v.jsx(UA, { FallbackComponent: UU, onError: t, children: e });
}, Em = VU, WU = ({ children: e, ...t }) => {
  const {
    isPositionFixed: r,
    fixedPositionXOffset: i,
    fixedPositionYOffset: n,
    chatButtonBgColor: a,
    chatButtonBgColorDarkMode: o
  } = Ka(), l = ia(a, o ?? a);
  return /* @__PURE__ */ v.jsx(
    di,
    {
      variant: "chatButton",
      _active: {
        transform: "scale(.85)"
      },
      _hover: {
        transform: "scale(1.1)"
      },
      alignItems: "center",
      position: r ? "fixed" : "relative",
      marginRight: "var(--scrollbar-width)",
      height: "auto",
      justifyContent: "center",
      px: 3,
      py: 3,
      transitionProperty: "transform, box-shadow, background-color, color",
      transitionDuration: "0.15s",
      transitionTimingFunction: "ease-in-out",
      userSelect: "none",
      className: `${ye}-floating-button`,
      zIndex: r ? 10 : void 0,
      style: {
        bottom: `${r ? n : void 0}`,
        right: `${r ? i : void 0}`,
        background: l
      },
      ...t,
      children: e
    }
  );
}, Cm = WU;
function GU(e) {
  const t = Nr("colors.inkeepExpandedPrimary.300"), r = Nr("colors.inkeepExpandedPrimary.700"), i = Nr("colors.inkeepExpandedPrimary.50"), n = Nr("colors.inkeepExpandedPrimary.300"), a = ia(t, i), o = ia(r, n), s = kl("gradient_"), l = kl("gradient_"), u = kl("gradient_"), d = kl("gradient_"), c = kl("gradient_"), p = kl("gradient_");
  return /* @__PURE__ */ v.jsxs(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ v.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.99958 4.49988C9.16254 4.49991 9.32106 4.55302 9.45115 4.65118C9.58124 4.74933 9.67582 4.88718 9.72058 5.04388L10.5336 7.88988C10.7086 8.5028 11.037 9.06098 11.4878 9.5117C11.9385 9.96243 12.4967 10.2908 13.1096 10.4659L15.9556 11.2789C16.1122 11.3237 16.2499 11.4184 16.348 11.5484C16.446 11.6785 16.499 11.837 16.499 11.9999C16.499 12.1628 16.446 12.3212 16.348 12.4513C16.2499 12.5814 16.1122 12.676 15.9556 12.7209L13.1096 13.5339C12.4967 13.7089 11.9385 14.0373 11.4878 14.4881C11.037 14.9388 10.7086 15.497 10.5336 16.1099L9.72058 18.9559C9.67572 19.1125 9.5811 19.2502 9.45102 19.3483C9.32094 19.4463 9.16248 19.4993 8.99958 19.4993C8.83669 19.4993 8.67822 19.4463 8.54814 19.3483C8.41806 19.2502 8.32344 19.1125 8.27858 18.9559L7.46558 16.1099C7.29053 15.497 6.96214 14.9388 6.51141 14.4881C6.06068 14.0373 5.5025 13.7089 4.88958 13.5339L2.04358 12.7209C1.88699 12.676 1.74925 12.5814 1.6512 12.4513C1.55316 12.3212 1.50012 12.1628 1.50012 11.9999C1.50012 11.837 1.55316 11.6785 1.6512 11.5484C1.74925 11.4184 1.88699 11.3237 2.04358 11.2789L4.88958 10.4659C5.5025 10.2908 6.06068 9.96243 6.51141 9.5117C6.96214 9.06098 7.29053 8.5028 7.46558 7.88988L8.27858 5.04388C8.32334 4.88718 8.41792 4.74933 8.54801 4.65118C8.6781 4.55302 8.83662 4.49991 8.99958 4.49988Z",
            fill: `url(#${s})`,
            stroke: `url(#${l})`,
            strokeWidth: "0.4"
          }
        ),
        /* @__PURE__ */ v.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.4983 15C16.6558 14.9999 16.8094 15.0494 16.9372 15.1415C17.065 15.2336 17.1605 15.3636 17.2103 15.513L17.6043 16.696C17.7543 17.143 18.1043 17.495 18.5523 17.644L19.7353 18.039C19.8843 18.089 20.0138 18.1845 20.1055 18.3121C20.1972 18.4397 20.2466 18.5929 20.2466 18.75C20.2466 18.9071 20.1972 19.0603 20.1055 19.1879C20.0138 19.3155 19.8843 19.411 19.7353 19.461L18.5523 19.856C18.1053 20.006 17.7533 20.356 17.6043 20.804L17.2093 21.987C17.1593 22.136 17.0637 22.2655 16.9362 22.3572C16.8086 22.4489 16.6554 22.4983 16.4983 22.4983C16.3412 22.4983 16.188 22.4489 16.0604 22.3572C15.9328 22.2655 15.8373 22.136 15.7873 21.987L15.3923 20.804C15.3186 20.5833 15.1946 20.3827 15.0301 20.2182C14.8656 20.0537 14.665 19.9297 14.4443 19.856L13.2613 19.461C13.1123 19.411 12.9828 19.3155 12.8911 19.1879C12.7994 19.0603 12.75 18.9071 12.75 18.75C12.75 18.5929 12.7994 18.4397 12.8911 18.3121C12.9828 18.1845 13.1123 18.089 13.2613 18.039L14.4443 17.644C14.8913 17.494 15.2433 17.144 15.3923 16.696L15.7873 15.513C15.837 15.3637 15.9324 15.2339 16.06 15.1418C16.1876 15.0497 16.341 15.0001 16.4983 15Z",
            fill: `url(#${u})`,
            stroke: `url(#${d})`,
            strokeWidth: "0.4"
          }
        ),
        /* @__PURE__ */ v.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.0018 1.49988C18.1691 1.49978 18.3317 1.55564 18.4636 1.65856C18.5955 1.76149 18.6892 1.90556 18.7298 2.06788L18.9878 3.10388C19.2238 4.04388 19.9578 4.77788 20.8978 5.01388L21.9338 5.27188C22.0964 5.31216 22.2409 5.40573 22.3441 5.53768C22.4474 5.66962 22.5035 5.83234 22.5035 5.99988C22.5035 6.16742 22.4474 6.33013 22.3441 6.46208C22.2409 6.59402 22.0964 6.6876 21.9338 6.72788L20.8978 6.98588C19.9578 7.22188 19.2238 7.95588 18.9878 8.89588L18.7298 9.93188C18.6895 10.0945 18.5959 10.239 18.464 10.3422C18.3321 10.4455 18.1693 10.5016 18.0018 10.5016C17.8343 10.5016 17.6715 10.4455 17.5396 10.3422C17.4077 10.239 17.3141 10.0945 17.2738 9.93188L17.0158 8.89588C16.9004 8.43431 16.6617 8.01278 16.3253 7.67635C15.9889 7.33993 15.5674 7.10127 15.1058 6.98588L14.0698 6.72788C13.9072 6.6876 13.7627 6.59402 13.6595 6.46208C13.5562 6.33013 13.5001 6.16742 13.5001 5.99988C13.5001 5.83234 13.5562 5.66962 13.6595 5.53768C13.7627 5.40573 13.9072 5.31216 14.0698 5.27188L15.1058 5.01388C15.5674 4.89849 15.9889 4.65983 16.3253 4.3234C16.6617 3.98698 16.9004 3.56545 17.0158 3.10388L17.2738 2.06788C17.3144 1.90556 17.4081 1.76149 17.54 1.65856C17.6719 1.55564 17.8345 1.49978 18.0018 1.49988Z",
            fill: `url(#${c})`,
            stroke: `url(#${p})`,
            strokeWidth: "0.4"
          }
        ),
        /* @__PURE__ */ v.jsxs("defs", { children: [
          /* @__PURE__ */ v.jsxs(
            "linearGradient",
            {
              id: `${s}`,
              x1: "1",
              y1: "4",
              x2: "17",
              y2: "20",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ v.jsx("stop", { offset: "0.257014", stopColor: a }),
                /* @__PURE__ */ v.jsx("stop", { offset: "1", stopColor: o })
              ]
            }
          ),
          /* @__PURE__ */ v.jsxs(
            "linearGradient",
            {
              id: `${l}`,
              x1: "1",
              y1: "4",
              x2: "17",
              y2: "20",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ v.jsx("stop", { stopColor: o }),
                /* @__PURE__ */ v.jsx("stop", { offset: "1", stopColor: a })
              ]
            }
          ),
          /* @__PURE__ */ v.jsxs(
            "linearGradient",
            {
              id: `${u}`,
              x1: "12.5",
              y1: "14.7501",
              x2: "20.4985",
              y2: "22.7471",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ v.jsx("stop", { offset: "0.257014", stopColor: a }),
                /* @__PURE__ */ v.jsx("stop", { offset: "1", stopColor: o })
              ]
            }
          ),
          /* @__PURE__ */ v.jsxs(
            "linearGradient",
            {
              id: `${d}`,
              x1: "12.5",
              y1: "14.7501",
              x2: "20.4985",
              y2: "22.7471",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ v.jsx("stop", { stopColor: o }),
                /* @__PURE__ */ v.jsx("stop", { offset: "1", stopColor: a })
              ]
            }
          ),
          /* @__PURE__ */ v.jsxs(
            "linearGradient",
            {
              id: `${c}`,
              x1: "13.1999",
              y1: "1.19988",
              x2: "22.8021",
              y2: "10.8042",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ v.jsx("stop", { offset: "0.257014", stopColor: a }),
                /* @__PURE__ */ v.jsx("stop", { offset: "1", stopColor: o })
              ]
            }
          ),
          /* @__PURE__ */ v.jsxs(
            "linearGradient",
            {
              id: `${p}`,
              x1: "13.1999",
              y1: "1.19988",
              x2: "22.8021",
              y2: "10.8042",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ v.jsx("stop", { stopColor: o }),
                /* @__PURE__ */ v.jsx("stop", { offset: "1", stopColor: a })
              ]
            }
          )
        ] })
      ]
    }
  );
}
const KU = ({ isFilled: e = !1, ...t }) => {
  const { botAvatarSrcUrl: r, botAvatarDarkSrcUrl: i } = Qr(), a = ia(r, i ?? r), [o, s] = rt(a);
  gt(() => {
    s(a);
  }, [a]);
  const l = () => {
    s(null);
  };
  return o ? /* @__PURE__ */ v.jsx(
    Ct,
    {
      width: "28px",
      height: "28px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      className: `${ye}-bot-avatar__box`,
      ...t,
      children: /* @__PURE__ */ v.jsx(
        w2,
        {
          src: o,
          maxH: "100%",
          maxW: "100%",
          alt: "AI chat avatar",
          onError: l
        }
      )
    }
  ) : /* @__PURE__ */ v.jsx(
    Ct,
    {
      width: "28px",
      height: "28px",
      ...t,
      className: `${ye}-bot-avatar__box`,
      children: /* @__PURE__ */ v.jsx(GU, {})
    }
  );
}, G2 = KU;
function K2() {
  return /* @__PURE__ */ v.jsx(e$, { children: /* @__PURE__ */ v.jsx(G2, { height: "24px", width: "24px", zIndex: 1 }) });
}
function YU() {
  const { chatButtonText: e = "Ask AI" } = Ka(), [t, r] = rt(!1), { isPositionFixed: i, fixedPositionYOffset: n, fixedPositionXOffset: a } = Ka(), o = qt(null), s = qt(null), [l, u] = rt(0);
  return gt(() => {
    if (s.current) {
      const { offsetWidth: d } = s.current;
      typeof d == "number" && d !== l && u(d);
    }
  }, [e, t, l]), /* @__PURE__ */ v.jsx(
    Ct,
    {
      onMouseOver: () => void r(!0),
      onMouseOut: () => void r(!1),
      position: i ? "fixed" : "relative",
      style: {
        bottom: `${i ? n : void 0}`,
        right: `${i ? a : void 0}`
      },
      children: /* @__PURE__ */ v.jsx(
        Cm,
        {
          borderRadius: "full",
          _hover: {
            transform: "none"
          },
          children: /* @__PURE__ */ v.jsxs(mt, { alignItems: "center", justifyContent: "center", children: [
            /* @__PURE__ */ v.jsx(
              Ct,
              {
                ref: o,
                mr: t ? 2 : 0,
                className: `${ye}-chat-button__text`,
                transition: "all 0.25s linear",
                pointerEvents: "none",
                style: {
                  width: t ? `${l}px` : "0px",
                  opacity: t ? 1 : 0
                },
                children: e
              }
            ),
            /* @__PURE__ */ v.jsx(
              Ct,
              {
                ref: s,
                className: `${ye}-chat-button__text__hidden`,
                position: "absolute",
                visibility: "hidden",
                height: "auto",
                width: "auto",
                whiteSpace: "nowrap",
                pointerEvents: "none",
                zIndex: -1,
                children: e
              }
            ),
            /* @__PURE__ */ v.jsx(K2, {})
          ] })
        }
      )
    }
  );
}
function qU(e, t) {
  if (e == null)
    return {};
  var r = {}, i = Object.keys(e), n, a;
  for (a = 0; a < i.length; a++)
    n = i[a], !(t.indexOf(n) >= 0) && (r[n] = e[n]);
  return r;
}
function Ng() {
  return Ng = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, Ng.apply(this, arguments);
}
function r_(e, t) {
  return r_ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, r_(e, t);
}
function QU(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, r_(e, t);
}
var i_ = function(e, t) {
  return i_ = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
    r.__proto__ = i;
  } || function(r, i) {
    for (var n in i)
      Object.prototype.hasOwnProperty.call(i, n) && (r[n] = i[n]);
  }, i_(e, t);
};
function Qa(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  i_(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var ke = function() {
  return ke = Object.assign || function(t) {
    for (var r, i = 1, n = arguments.length; i < n; i++) {
      r = arguments[i];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, ke.apply(this, arguments);
};
function es(e, t) {
  var r = {};
  for (var i in e)
    Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (r[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, i = Object.getOwnPropertySymbols(e); n < i.length; n++)
      t.indexOf(i[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[n]) && (r[i[n]] = e[i[n]]);
  return r;
}
function bl(e, t, r, i) {
  function n(a) {
    return a instanceof r ? a : new r(function(o) {
      o(a);
    });
  }
  return new (r || (r = Promise))(function(a, o) {
    function s(d) {
      try {
        u(i.next(d));
      } catch (c) {
        o(c);
      }
    }
    function l(d) {
      try {
        u(i.throw(d));
      } catch (c) {
        o(c);
      }
    }
    function u(d) {
      d.done ? a(d.value) : n(d.value).then(s, l);
    }
    u((i = i.apply(e, t || [])).next());
  });
}
function _l(e, t) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, i, n, a, o;
  return o = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(u) {
    return function(d) {
      return l([u, d]);
    };
  }
  function l(u) {
    if (i)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, u[0] && (r = 0)), r; )
      try {
        if (i = 1, n && (a = u[0] & 2 ? n.return : u[0] ? n.throw || ((a = n.return) && a.call(n), 0) : n.next) && !(a = a.call(n, u[1])).done)
          return a;
        switch (n = 0, a && (u = [u[0] & 2, a.value]), u[0]) {
          case 0:
          case 1:
            a = u;
            break;
          case 4:
            return r.label++, { value: u[1], done: !1 };
          case 5:
            r.label++, n = u[1], u = [0];
            continue;
          case 7:
            u = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              r = 0;
              continue;
            }
            if (u[0] === 3 && (!a || u[1] > a[0] && u[1] < a[3])) {
              r.label = u[1];
              break;
            }
            if (u[0] === 6 && r.label < a[1]) {
              r.label = a[1], a = u;
              break;
            }
            if (a && r.label < a[2]) {
              r.label = a[2], r.ops.push(u);
              break;
            }
            a[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        u = t.call(e, r);
      } catch (d) {
        u = [6, d], n = 0;
      } finally {
        i = a = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function qo(e, t, r) {
  if (r || arguments.length === 2)
    for (var i = 0, n = t.length, a; i < n; i++)
      (a || !(i in t)) && (a || (a = Array.prototype.slice.call(t, 0, i)), a[i] = t[i]);
  return e.concat(a || Array.prototype.slice.call(t));
}
/*!
 * content-type
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var JE = /; *([!#$%&'*+.^_`|~0-9A-Za-z-]+) *= *("(?:[\u000b\u0020\u0021\u0023-\u005b\u005d-\u007e\u0080-\u00ff]|\\[\u000b\u0020-\u00ff])*"|[!#$%&'*+.^_`|~0-9A-Za-z-]+) */g, XU = /\\([\u000b\u0020-\u00ff])/g, ZU = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+\/[!#$%&'*+.^_`|~0-9A-Za-z-]+$/, JU = eV;
function eV(e) {
  if (!e)
    throw new TypeError("argument string is required");
  var t = typeof e == "object" ? tV(e) : e;
  if (typeof t != "string")
    throw new TypeError("argument string is required to be a string");
  var r = t.indexOf(";"), i = r !== -1 ? t.slice(0, r).trim() : t.trim();
  if (!ZU.test(i))
    throw new TypeError("invalid media type");
  var n = new rV(i.toLowerCase());
  if (r !== -1) {
    var a, o, s;
    for (JE.lastIndex = r; o = JE.exec(t); ) {
      if (o.index !== r)
        throw new TypeError("invalid parameter format");
      r += o[0].length, a = o[1].toLowerCase(), s = o[2], s.charCodeAt(0) === 34 && (s = s.slice(1, -1), s.indexOf("\\") !== -1 && (s = s.replace(XU, "$1"))), n.parameters[a] = s;
    }
    if (r !== t.length)
      throw new TypeError("invalid parameter format");
  }
  return n;
}
function tV(e) {
  var t;
  if (typeof e.getHeader == "function" ? t = e.getHeader("content-type") : typeof e.headers == "object" && (t = e.headers && e.headers["content-type"]), typeof t != "string")
    throw new TypeError("content-type header is missing from object");
  return t;
}
function rV(e) {
  this.parameters = /* @__PURE__ */ Object.create(null), this.type = e;
}
var Cd = /* @__PURE__ */ new Map(), VA = function(t) {
  return t.cloneNode(!0);
}, e9 = function() {
  return window.location.protocol === "file:";
}, WA = function(t, r, i) {
  var n = new XMLHttpRequest();
  n.onreadystatechange = function() {
    try {
      if (!/\.svg/i.test(t) && n.readyState === 2) {
        var a = n.getResponseHeader("Content-Type");
        if (!a)
          throw new Error("Content type not found");
        var o = JU(a).type;
        if (!(o === "image/svg+xml" || o === "text/plain"))
          throw new Error("Invalid content type: ".concat(o));
      }
      if (n.readyState === 4) {
        if (n.status === 404 || n.responseXML === null)
          throw new Error(e9() ? "Note: SVG injection ajax calls do not work locally without adjusting security settings in your browser. Or consider using a local webserver." : "Unable to load SVG file: " + t);
        if (n.status === 200 || e9() && n.status === 0)
          i(null, n);
        else
          throw new Error("There was a problem injecting the SVG: " + n.status + " " + n.statusText);
      }
    } catch (s) {
      if (n.abort(), s instanceof Error)
        i(s, n);
      else
        throw s;
    }
  }, n.open("GET", t), n.withCredentials = r, n.overrideMimeType && n.overrideMimeType("text/xml"), n.send();
}, yl = {}, t9 = function(t, r) {
  yl[t] = yl[t] || [], yl[t].push(r);
}, iV = function(t) {
  for (var r = function(o, s) {
    setTimeout(function() {
      if (Array.isArray(yl[t])) {
        var l = Cd.get(t), u = yl[t][o];
        l instanceof SVGSVGElement && u(null, VA(l)), l instanceof Error && u(l), o === yl[t].length - 1 && delete yl[t];
      }
    }, 0);
  }, i = 0, n = yl[t].length; i < n; i++)
    r(i);
}, nV = function(t, r, i) {
  if (Cd.has(t)) {
    var n = Cd.get(t);
    if (n === void 0) {
      t9(t, i);
      return;
    }
    if (n instanceof SVGSVGElement) {
      i(null, VA(n));
      return;
    }
  }
  Cd.set(t, void 0), t9(t, i), WA(t, r, function(a, o) {
    var s;
    a ? Cd.set(t, a) : ((s = o.responseXML) === null || s === void 0 ? void 0 : s.documentElement) instanceof SVGSVGElement && Cd.set(t, o.responseXML.documentElement), iV(t);
  });
}, aV = function(t, r, i) {
  WA(t, r, function(n, a) {
    var o;
    n ? i(n) : ((o = a.responseXML) === null || o === void 0 ? void 0 : o.documentElement) instanceof SVGSVGElement && i(null, a.responseXML.documentElement);
  });
}, oV = 0, sV = function() {
  return ++oV;
}, Lo = [], r9 = {}, lV = "http://www.w3.org/2000/svg", Ek = "http://www.w3.org/1999/xlink", i9 = function(t, r, i, n, a, o, s) {
  var l = t.getAttribute("data-src") || t.getAttribute("src");
  if (!l) {
    s(new Error("Invalid data-src or src attribute"));
    return;
  }
  if (Lo.indexOf(t) !== -1) {
    Lo.splice(Lo.indexOf(t), 1), t = null;
    return;
  }
  Lo.push(t), t.setAttribute("src", "");
  var u = n ? nV : aV;
  u(l, a, function(d, c) {
    if (!c) {
      Lo.splice(Lo.indexOf(t), 1), t = null, s(d);
      return;
    }
    var p = t.getAttribute("id");
    p && c.setAttribute("id", p);
    var f = t.getAttribute("title");
    f && c.setAttribute("title", f);
    var g = t.getAttribute("width");
    g && c.setAttribute("width", g);
    var k = t.getAttribute("height");
    k && c.setAttribute("height", k);
    var y = Array.from(new Set(qo(qo(qo([], (c.getAttribute("class") || "").split(" "), !0), ["injected-svg"], !1), (t.getAttribute("class") || "").split(" "), !0))).join(" ").trim();
    c.setAttribute("class", y);
    var _ = t.getAttribute("style");
    _ && c.setAttribute("style", _), c.setAttribute("data-src", l);
    var A = [].filter.call(t.attributes, function(Ee) {
      return /^data-\w[\w-]*$/.test(Ee.name);
    });
    if (Array.prototype.forEach.call(A, function(Ee) {
      Ee.name && Ee.value && c.setAttribute(Ee.name, Ee.value);
    }), i) {
      var T = {
        clipPath: ["clip-path"],
        "color-profile": ["color-profile"],
        cursor: ["cursor"],
        filter: ["filter"],
        linearGradient: ["fill", "stroke"],
        marker: ["marker", "marker-start", "marker-mid", "marker-end"],
        mask: ["mask"],
        path: [],
        pattern: ["fill", "stroke"],
        radialGradient: ["fill", "stroke"]
      }, N, P, B, M, X;
      Object.keys(T).forEach(function(Ee) {
        N = Ee, B = T[Ee], P = c.querySelectorAll(N + "[id]");
        for (var Le = function(G, He) {
          M = P[G].id, X = M + "-" + sV();
          var xe;
          Array.prototype.forEach.call(B, function(wt) {
            xe = c.querySelectorAll("[" + wt + '*="' + M + '"]');
            for (var Ge = 0, nr = xe.length; Ge < nr; Ge++) {
              var vr = xe[Ge].getAttribute(wt);
              vr && !vr.match(new RegExp('url\\("?#' + M + '"?\\)')) || xe[Ge].setAttribute(wt, "url(#" + X + ")");
            }
          });
          for (var _e = c.querySelectorAll("[*|href]"), Ze = [], qe = 0, nt = _e.length; qe < nt; qe++) {
            var at = _e[qe].getAttributeNS(Ek, "href");
            at && at.toString() === "#" + P[G].id && Ze.push(_e[qe]);
          }
          for (var At = 0, Oe = Ze.length; At < Oe; At++)
            Ze[At].setAttributeNS(Ek, "href", "#" + X);
          P[G].id = X;
        }, L = 0, me = P.length; L < me; L++)
          Le(L);
      });
    }
    c.removeAttribute("xmlns:a");
    for (var U = c.querySelectorAll("script"), K = [], z, j, J = 0, ie = U.length; J < ie; J++)
      j = U[J].getAttribute("type"), (!j || j === "application/ecmascript" || j === "application/javascript" || j === "text/javascript") && (z = U[J].innerText || U[J].textContent, z && K.push(z), c.removeChild(U[J]));
    if (K.length > 0 && (r === "always" || r === "once" && !r9[l])) {
      for (var ue = 0, de = K.length; ue < de; ue++)
        new Function(K[ue])(window);
      r9[l] = !0;
    }
    var he = c.querySelectorAll("style");
    if (Array.prototype.forEach.call(he, function(Ee) {
      Ee.textContent += "";
    }), c.setAttribute("xmlns", lV), c.setAttribute("xmlns:xlink", Ek), o(c), !t.parentNode) {
      Lo.splice(Lo.indexOf(t), 1), t = null, s(new Error("Parent node is null"));
      return;
    }
    t.parentNode.replaceChild(c, t), Lo.splice(Lo.indexOf(t), 1), t = null, s(null, c);
  });
}, uV = function(t, r) {
  var i = r === void 0 ? {} : r, n = i.afterAll, a = n === void 0 ? function() {
  } : n, o = i.afterEach, s = o === void 0 ? function() {
  } : o, l = i.beforeEach, u = l === void 0 ? function() {
  } : l, d = i.cacheRequests, c = d === void 0 ? !0 : d, p = i.evalScripts, f = p === void 0 ? "never" : p, g = i.httpRequestWithCredentials, k = g === void 0 ? !1 : g, y = i.renumerateIRIElements, _ = y === void 0 ? !0 : y;
  if (t && "length" in t)
    for (var A = 0, T = 0, N = t.length; T < N; T++)
      i9(t[T], f, _, c, k, u, function(P, B) {
        s(P, B), t && "length" in t && t.length === ++A && a(A);
      });
  else
    t ? i9(t, f, _, c, k, u, function(P, B) {
      s(P, B), a(1), t = null;
    }) : a(0);
}, n_ = { exports: {} }, pf = { exports: {} }, wr = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var n9;
function cV() {
  if (n9)
    return wr;
  n9 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, c = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, f = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, k = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, A = e ? Symbol.for("react.scope") : 60119;
  function T(P) {
    if (typeof P == "object" && P !== null) {
      var B = P.$$typeof;
      switch (B) {
        case t:
          switch (P = P.type, P) {
            case l:
            case u:
            case i:
            case a:
            case n:
            case c:
              return P;
            default:
              switch (P = P && P.$$typeof, P) {
                case s:
                case d:
                case g:
                case f:
                case o:
                  return P;
                default:
                  return B;
              }
          }
        case r:
          return B;
      }
    }
  }
  function N(P) {
    return T(P) === u;
  }
  return wr.AsyncMode = l, wr.ConcurrentMode = u, wr.ContextConsumer = s, wr.ContextProvider = o, wr.Element = t, wr.ForwardRef = d, wr.Fragment = i, wr.Lazy = g, wr.Memo = f, wr.Portal = r, wr.Profiler = a, wr.StrictMode = n, wr.Suspense = c, wr.isAsyncMode = function(P) {
    return N(P) || T(P) === l;
  }, wr.isConcurrentMode = N, wr.isContextConsumer = function(P) {
    return T(P) === s;
  }, wr.isContextProvider = function(P) {
    return T(P) === o;
  }, wr.isElement = function(P) {
    return typeof P == "object" && P !== null && P.$$typeof === t;
  }, wr.isForwardRef = function(P) {
    return T(P) === d;
  }, wr.isFragment = function(P) {
    return T(P) === i;
  }, wr.isLazy = function(P) {
    return T(P) === g;
  }, wr.isMemo = function(P) {
    return T(P) === f;
  }, wr.isPortal = function(P) {
    return T(P) === r;
  }, wr.isProfiler = function(P) {
    return T(P) === a;
  }, wr.isStrictMode = function(P) {
    return T(P) === n;
  }, wr.isSuspense = function(P) {
    return T(P) === c;
  }, wr.isValidElementType = function(P) {
    return typeof P == "string" || typeof P == "function" || P === i || P === u || P === a || P === n || P === c || P === p || typeof P == "object" && P !== null && (P.$$typeof === g || P.$$typeof === f || P.$$typeof === o || P.$$typeof === s || P.$$typeof === d || P.$$typeof === y || P.$$typeof === _ || P.$$typeof === A || P.$$typeof === k);
  }, wr.typeOf = T, wr;
}
var Fr = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var a9;
function dV() {
  return a9 || (a9 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, c = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, f = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, k = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, A = e ? Symbol.for("react.scope") : 60119;
    function T(Oe) {
      return typeof Oe == "string" || typeof Oe == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Oe === i || Oe === u || Oe === a || Oe === n || Oe === c || Oe === p || typeof Oe == "object" && Oe !== null && (Oe.$$typeof === g || Oe.$$typeof === f || Oe.$$typeof === o || Oe.$$typeof === s || Oe.$$typeof === d || Oe.$$typeof === y || Oe.$$typeof === _ || Oe.$$typeof === A || Oe.$$typeof === k);
    }
    function N(Oe) {
      if (typeof Oe == "object" && Oe !== null) {
        var wt = Oe.$$typeof;
        switch (wt) {
          case t:
            var Ge = Oe.type;
            switch (Ge) {
              case l:
              case u:
              case i:
              case a:
              case n:
              case c:
                return Ge;
              default:
                var nr = Ge && Ge.$$typeof;
                switch (nr) {
                  case s:
                  case d:
                  case g:
                  case f:
                  case o:
                    return nr;
                  default:
                    return wt;
                }
            }
          case r:
            return wt;
        }
      }
    }
    var P = l, B = u, M = s, X = o, U = t, K = d, z = i, j = g, J = f, ie = r, ue = a, de = n, he = c, Ee = !1;
    function Le(Oe) {
      return Ee || (Ee = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), L(Oe) || N(Oe) === l;
    }
    function L(Oe) {
      return N(Oe) === u;
    }
    function me(Oe) {
      return N(Oe) === s;
    }
    function Se(Oe) {
      return N(Oe) === o;
    }
    function G(Oe) {
      return typeof Oe == "object" && Oe !== null && Oe.$$typeof === t;
    }
    function He(Oe) {
      return N(Oe) === d;
    }
    function xe(Oe) {
      return N(Oe) === i;
    }
    function _e(Oe) {
      return N(Oe) === g;
    }
    function Ze(Oe) {
      return N(Oe) === f;
    }
    function qe(Oe) {
      return N(Oe) === r;
    }
    function nt(Oe) {
      return N(Oe) === a;
    }
    function at(Oe) {
      return N(Oe) === n;
    }
    function At(Oe) {
      return N(Oe) === c;
    }
    Fr.AsyncMode = P, Fr.ConcurrentMode = B, Fr.ContextConsumer = M, Fr.ContextProvider = X, Fr.Element = U, Fr.ForwardRef = K, Fr.Fragment = z, Fr.Lazy = j, Fr.Memo = J, Fr.Portal = ie, Fr.Profiler = ue, Fr.StrictMode = de, Fr.Suspense = he, Fr.isAsyncMode = Le, Fr.isConcurrentMode = L, Fr.isContextConsumer = me, Fr.isContextProvider = Se, Fr.isElement = G, Fr.isForwardRef = He, Fr.isFragment = xe, Fr.isLazy = _e, Fr.isMemo = Ze, Fr.isPortal = qe, Fr.isProfiler = nt, Fr.isStrictMode = at, Fr.isSuspense = At, Fr.isValidElementType = T, Fr.typeOf = N;
  }()), Fr;
}
var o9;
function GA() {
  return o9 || (o9 = 1, process.env.NODE_ENV === "production" ? pf.exports = cV() : pf.exports = dV()), pf.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ck, s9;
function pV() {
  if (s9)
    return Ck;
  s9 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function i(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function n() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(o).map(function(d) {
        return o[d];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        u[d] = d;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Ck = n() ? Object.assign : function(a, o) {
    for (var s, l = i(a), u, d = 1; d < arguments.length; d++) {
      s = Object(arguments[d]);
      for (var c in s)
        t.call(s, c) && (l[c] = s[c]);
      if (e) {
        u = e(s);
        for (var p = 0; p < u.length; p++)
          r.call(s, u[p]) && (l[u[p]] = s[u[p]]);
      }
    }
    return l;
  }, Ck;
}
var xk, l9;
function Y2() {
  if (l9)
    return xk;
  l9 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return xk = e, xk;
}
var Ak, u9;
function KA() {
  return u9 || (u9 = 1, Ak = Function.call.bind(Object.prototype.hasOwnProperty)), Ak;
}
var wk, c9;
function hV() {
  if (c9)
    return wk;
  c9 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Y2(), r = {}, i = KA();
    e = function(a) {
      var o = "Warning: " + a;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function n(a, o, s, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in a)
        if (i(a, d)) {
          var c;
          try {
            if (typeof a[d] != "function") {
              var p = Error(
                (l || "React class") + ": " + s + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            c = a[d](o, d, l, s, null, t);
          } catch (g) {
            c = g;
          }
          if (c && !(c instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof c + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), c instanceof Error && !(c.message in r)) {
            r[c.message] = !0;
            var f = u ? u() : "";
            e(
              "Failed " + s + " type: " + c.message + (f ?? "")
            );
          }
        }
    }
  }
  return n.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, wk = n, wk;
}
var Fk, d9;
function fV() {
  if (d9)
    return Fk;
  d9 = 1;
  var e = GA(), t = pV(), r = Y2(), i = KA(), n = hV(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Fk = function(s, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function c(L) {
      var me = L && (u && L[u] || L[d]);
      if (typeof me == "function")
        return me;
    }
    var p = "<<anonymous>>", f = {
      array: _("array"),
      bigint: _("bigint"),
      bool: _("boolean"),
      func: _("function"),
      number: _("number"),
      object: _("object"),
      string: _("string"),
      symbol: _("symbol"),
      any: A(),
      arrayOf: T,
      element: N(),
      elementType: P(),
      instanceOf: B,
      node: K(),
      objectOf: X,
      oneOf: M,
      oneOfType: U,
      shape: j,
      exact: J
    };
    function g(L, me) {
      return L === me ? L !== 0 || 1 / L === 1 / me : L !== L && me !== me;
    }
    function k(L, me) {
      this.message = L, this.data = me && typeof me == "object" ? me : {}, this.stack = "";
    }
    k.prototype = Error.prototype;
    function y(L) {
      if (process.env.NODE_ENV !== "production")
        var me = {}, Se = 0;
      function G(xe, _e, Ze, qe, nt, at, At) {
        if (qe = qe || p, at = at || Ze, At !== r) {
          if (l) {
            var Oe = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Oe.name = "Invariant Violation", Oe;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var wt = qe + ":" + Ze;
            !me[wt] && // Avoid spamming the console because they are often not actionable except for lib authors
            Se < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + at + "` prop on `" + qe + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), me[wt] = !0, Se++);
          }
        }
        return _e[Ze] == null ? xe ? _e[Ze] === null ? new k("The " + nt + " `" + at + "` is marked as required " + ("in `" + qe + "`, but its value is `null`.")) : new k("The " + nt + " `" + at + "` is marked as required in " + ("`" + qe + "`, but its value is `undefined`.")) : null : L(_e, Ze, qe, nt, at);
      }
      var He = G.bind(null, !1);
      return He.isRequired = G.bind(null, !0), He;
    }
    function _(L) {
      function me(Se, G, He, xe, _e, Ze) {
        var qe = Se[G], nt = de(qe);
        if (nt !== L) {
          var at = he(qe);
          return new k(
            "Invalid " + xe + " `" + _e + "` of type " + ("`" + at + "` supplied to `" + He + "`, expected ") + ("`" + L + "`."),
            { expectedType: L }
          );
        }
        return null;
      }
      return y(me);
    }
    function A() {
      return y(o);
    }
    function T(L) {
      function me(Se, G, He, xe, _e) {
        if (typeof L != "function")
          return new k("Property `" + _e + "` of component `" + He + "` has invalid PropType notation inside arrayOf.");
        var Ze = Se[G];
        if (!Array.isArray(Ze)) {
          var qe = de(Ze);
          return new k("Invalid " + xe + " `" + _e + "` of type " + ("`" + qe + "` supplied to `" + He + "`, expected an array."));
        }
        for (var nt = 0; nt < Ze.length; nt++) {
          var at = L(Ze, nt, He, xe, _e + "[" + nt + "]", r);
          if (at instanceof Error)
            return at;
        }
        return null;
      }
      return y(me);
    }
    function N() {
      function L(me, Se, G, He, xe) {
        var _e = me[Se];
        if (!s(_e)) {
          var Ze = de(_e);
          return new k("Invalid " + He + " `" + xe + "` of type " + ("`" + Ze + "` supplied to `" + G + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(L);
    }
    function P() {
      function L(me, Se, G, He, xe) {
        var _e = me[Se];
        if (!e.isValidElementType(_e)) {
          var Ze = de(_e);
          return new k("Invalid " + He + " `" + xe + "` of type " + ("`" + Ze + "` supplied to `" + G + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(L);
    }
    function B(L) {
      function me(Se, G, He, xe, _e) {
        if (!(Se[G] instanceof L)) {
          var Ze = L.name || p, qe = Le(Se[G]);
          return new k("Invalid " + xe + " `" + _e + "` of type " + ("`" + qe + "` supplied to `" + He + "`, expected ") + ("instance of `" + Ze + "`."));
        }
        return null;
      }
      return y(me);
    }
    function M(L) {
      if (!Array.isArray(L))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), o;
      function me(Se, G, He, xe, _e) {
        for (var Ze = Se[G], qe = 0; qe < L.length; qe++)
          if (g(Ze, L[qe]))
            return null;
        var nt = JSON.stringify(L, function(At, Oe) {
          var wt = he(Oe);
          return wt === "symbol" ? String(Oe) : Oe;
        });
        return new k("Invalid " + xe + " `" + _e + "` of value `" + String(Ze) + "` " + ("supplied to `" + He + "`, expected one of " + nt + "."));
      }
      return y(me);
    }
    function X(L) {
      function me(Se, G, He, xe, _e) {
        if (typeof L != "function")
          return new k("Property `" + _e + "` of component `" + He + "` has invalid PropType notation inside objectOf.");
        var Ze = Se[G], qe = de(Ze);
        if (qe !== "object")
          return new k("Invalid " + xe + " `" + _e + "` of type " + ("`" + qe + "` supplied to `" + He + "`, expected an object."));
        for (var nt in Ze)
          if (i(Ze, nt)) {
            var at = L(Ze, nt, He, xe, _e + "." + nt, r);
            if (at instanceof Error)
              return at;
          }
        return null;
      }
      return y(me);
    }
    function U(L) {
      if (!Array.isArray(L))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var me = 0; me < L.length; me++) {
        var Se = L[me];
        if (typeof Se != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Ee(Se) + " at index " + me + "."
          ), o;
      }
      function G(He, xe, _e, Ze, qe) {
        for (var nt = [], at = 0; at < L.length; at++) {
          var At = L[at], Oe = At(He, xe, _e, Ze, qe, r);
          if (Oe == null)
            return null;
          Oe.data && i(Oe.data, "expectedType") && nt.push(Oe.data.expectedType);
        }
        var wt = nt.length > 0 ? ", expected one of type [" + nt.join(", ") + "]" : "";
        return new k("Invalid " + Ze + " `" + qe + "` supplied to " + ("`" + _e + "`" + wt + "."));
      }
      return y(G);
    }
    function K() {
      function L(me, Se, G, He, xe) {
        return ie(me[Se]) ? null : new k("Invalid " + He + " `" + xe + "` supplied to " + ("`" + G + "`, expected a ReactNode."));
      }
      return y(L);
    }
    function z(L, me, Se, G, He) {
      return new k(
        (L || "React class") + ": " + me + " type `" + Se + "." + G + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + He + "`."
      );
    }
    function j(L) {
      function me(Se, G, He, xe, _e) {
        var Ze = Se[G], qe = de(Ze);
        if (qe !== "object")
          return new k("Invalid " + xe + " `" + _e + "` of type `" + qe + "` " + ("supplied to `" + He + "`, expected `object`."));
        for (var nt in L) {
          var at = L[nt];
          if (typeof at != "function")
            return z(He, xe, _e, nt, he(at));
          var At = at(Ze, nt, He, xe, _e + "." + nt, r);
          if (At)
            return At;
        }
        return null;
      }
      return y(me);
    }
    function J(L) {
      function me(Se, G, He, xe, _e) {
        var Ze = Se[G], qe = de(Ze);
        if (qe !== "object")
          return new k("Invalid " + xe + " `" + _e + "` of type `" + qe + "` " + ("supplied to `" + He + "`, expected `object`."));
        var nt = t({}, Se[G], L);
        for (var at in nt) {
          var At = L[at];
          if (i(L, at) && typeof At != "function")
            return z(He, xe, _e, at, he(At));
          if (!At)
            return new k(
              "Invalid " + xe + " `" + _e + "` key `" + at + "` supplied to `" + He + "`.\nBad object: " + JSON.stringify(Se[G], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(L), null, "  ")
            );
          var Oe = At(Ze, at, He, xe, _e + "." + at, r);
          if (Oe)
            return Oe;
        }
        return null;
      }
      return y(me);
    }
    function ie(L) {
      switch (typeof L) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !L;
        case "object":
          if (Array.isArray(L))
            return L.every(ie);
          if (L === null || s(L))
            return !0;
          var me = c(L);
          if (me) {
            var Se = me.call(L), G;
            if (me !== L.entries) {
              for (; !(G = Se.next()).done; )
                if (!ie(G.value))
                  return !1;
            } else
              for (; !(G = Se.next()).done; ) {
                var He = G.value;
                if (He && !ie(He[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ue(L, me) {
      return L === "symbol" ? !0 : me ? me["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && me instanceof Symbol : !1;
    }
    function de(L) {
      var me = typeof L;
      return Array.isArray(L) ? "array" : L instanceof RegExp ? "object" : ue(me, L) ? "symbol" : me;
    }
    function he(L) {
      if (typeof L > "u" || L === null)
        return "" + L;
      var me = de(L);
      if (me === "object") {
        if (L instanceof Date)
          return "date";
        if (L instanceof RegExp)
          return "regexp";
      }
      return me;
    }
    function Ee(L) {
      var me = he(L);
      switch (me) {
        case "array":
        case "object":
          return "an " + me;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + me;
        default:
          return me;
      }
    }
    function Le(L) {
      return !L.constructor || !L.constructor.name ? p : L.constructor.name;
    }
    return f.checkPropTypes = n, f.resetWarningCache = n.resetWarningCache, f.PropTypes = f, f;
  }, Fk;
}
var Tk, p9;
function gV() {
  if (p9)
    return Tk;
  p9 = 1;
  var e = Y2();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, Tk = function() {
    function i(o, s, l, u, d, c) {
      if (c !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    i.isRequired = i;
    function n() {
      return i;
    }
    var a = {
      array: i,
      bigint: i,
      bool: i,
      func: i,
      number: i,
      object: i,
      string: i,
      symbol: i,
      any: i,
      arrayOf: n,
      element: i,
      elementType: i,
      instanceOf: n,
      node: i,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, Tk;
}
if (process.env.NODE_ENV !== "production") {
  var mV = GA(), vV = !0;
  n_.exports = fV()(mV.isElement, vV);
} else
  n_.exports = gV()();
var Pi = n_.exports;
const Kt = /* @__PURE__ */ is(Pi);
var kV = function(t) {
  var r = (t == null ? void 0 : t.ownerDocument) || document;
  return r.defaultView || window;
}, bV = function(t, r) {
  for (var i in t)
    if (!(i in r))
      return !0;
  for (var n in r)
    if (t[n] !== r[n])
      return !0;
  return !1;
}, _V = ["afterInjection", "beforeInjection", "desc", "evalScripts", "fallback", "httpRequestWithCredentials", "loading", "renumerateIRIElements", "src", "title", "useRequestCache", "wrapper"], hf = "http://www.w3.org/2000/svg", h9 = "http://www.w3.org/1999/xlink", q2 = /* @__PURE__ */ function(e) {
  QU(t, e);
  function t() {
    for (var i, n = arguments.length, a = new Array(n), o = 0; o < n; o++)
      a[o] = arguments[o];
    return i = e.call.apply(e, [this].concat(a)) || this, i.initialState = {
      hasError: !1,
      isLoading: !0
    }, i.state = i.initialState, i._isMounted = !1, i.reactWrapper = void 0, i.nonReactWrapper = void 0, i.refCallback = function(s) {
      i.reactWrapper = s;
    }, i;
  }
  var r = t.prototype;
  return r.renderSVG = function() {
    var n = this;
    if (this.reactWrapper instanceof kV(this.reactWrapper).Node) {
      var a = this.props, o = a.desc, s = a.evalScripts, l = a.httpRequestWithCredentials, u = a.renumerateIRIElements, d = a.src, c = a.title, p = a.useRequestCache, f = this.props.onError, g = this.props.beforeInjection, k = this.props.afterInjection, y = this.props.wrapper, _, A;
      y === "svg" ? (_ = document.createElementNS(hf, y), _.setAttribute("xmlns", hf), _.setAttribute("xmlns:xlink", h9), A = document.createElementNS(hf, y)) : (_ = document.createElement(y), A = document.createElement(y)), _.appendChild(A), A.dataset.src = d, this.nonReactWrapper = this.reactWrapper.appendChild(_);
      var T = function(M) {
        if (n.removeSVG(), !n._isMounted) {
          f(M);
          return;
        }
        n.setState(function() {
          return {
            hasError: !0,
            isLoading: !1
          };
        }, function() {
          f(M);
        });
      }, N = function(M, X) {
        if (M) {
          T(M);
          return;
        }
        n._isMounted && n.setState(function() {
          return {
            isLoading: !1
          };
        }, function() {
          try {
            k(X);
          } catch (U) {
            T(U);
          }
        });
      }, P = function(M) {
        if (M.setAttribute("role", "img"), o) {
          var X = M.querySelector(":scope > desc");
          X && M.removeChild(X);
          var U = document.createElement("desc");
          U.innerHTML = o, M.prepend(U);
        }
        if (c) {
          var K = M.querySelector(":scope > title");
          K && M.removeChild(K);
          var z = document.createElement("title");
          z.innerHTML = c, M.prepend(z);
        }
        try {
          g(M);
        } catch (j) {
          T(j);
        }
      };
      uV(A, {
        afterEach: N,
        beforeEach: P,
        cacheRequests: p,
        evalScripts: s,
        httpRequestWithCredentials: l,
        renumerateIRIElements: u
      });
    }
  }, r.removeSVG = function() {
    var n;
    (n = this.nonReactWrapper) != null && n.parentNode && (this.nonReactWrapper.parentNode.removeChild(this.nonReactWrapper), this.nonReactWrapper = null);
  }, r.componentDidMount = function() {
    this._isMounted = !0, this.renderSVG();
  }, r.componentDidUpdate = function(n) {
    var a = this;
    bV(Ng({}, n), this.props) && this.setState(function() {
      return a.initialState;
    }, function() {
      a.removeSVG(), a.renderSVG();
    });
  }, r.componentWillUnmount = function() {
    this._isMounted = !1, this.removeSVG();
  }, r.render = function() {
    var n = this.props;
    n.afterInjection, n.beforeInjection, n.desc, n.evalScripts;
    var a = n.fallback;
    n.httpRequestWithCredentials;
    var o = n.loading;
    n.renumerateIRIElements, n.src, n.title, n.useRequestCache;
    var s = n.wrapper, l = qU(n, _V), u = s;
    return /* @__PURE__ */ we.createElement(u, Ng({}, l, {
      ref: this.refCallback
    }, s === "svg" ? {
      xmlns: hf,
      xmlnsXlink: h9
    } : {}), this.state.isLoading && o && /* @__PURE__ */ we.createElement(o, null), this.state.hasError && a && /* @__PURE__ */ we.createElement(a, null));
  }, t;
}(we.Component);
q2.defaultProps = {
  afterInjection: function() {
  },
  beforeInjection: function() {
  },
  desc: "",
  evalScripts: "never",
  fallback: null,
  httpRequestWithCredentials: !1,
  loading: null,
  onError: function() {
  },
  renumerateIRIElements: !0,
  title: "",
  useRequestCache: !0,
  wrapper: "div"
};
q2.propTypes = {
  afterInjection: Pi.func,
  beforeInjection: Pi.func,
  desc: Pi.string,
  evalScripts: Pi.oneOf(["always", "once", "never"]),
  fallback: Pi.oneOfType([Pi.func, Pi.object, Pi.string]),
  httpRequestWithCredentials: Pi.bool,
  loading: Pi.oneOfType([Pi.func, Pi.object, Pi.string]),
  onError: Pi.func,
  renumerateIRIElements: Pi.bool,
  src: Pi.string.isRequired,
  title: Pi.string,
  useRequestCache: Pi.bool,
  wrapper: Pi.oneOf(["div", "span", "svg"])
};
function DV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M0 256C0 209.4 12.47 165.6 34.27 127.1L144.1 318.3C166 357.5 207.9 384 256 384C270.3 384 283.1 381.7 296.8 377.4L220.5 509.6C95.9 492.3 0 385.3 0 256zM365.1 321.6C377.4 302.4 384 279.1 384 256C384 217.8 367.2 183.5 340.7 160H493.4C505.4 189.6 512 222.1 512 256C512 397.4 397.4 511.1 256 512L365.1 321.6zM477.8 128H256C193.1 128 142.3 172.1 130.5 230.7L54.19 98.47C101 38.53 174 0 256 0C350.8 0 433.5 51.48 477.8 128V128zM168 256C168 207.4 207.4 168 256 168C304.6 168 344 207.4 344 256C344 304.6 304.6 344 256 344C207.4 344 168 304.6 168 256z" } }] })(e);
}
function yV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 640 512" }, child: [{ tag: "path", attr: { d: "M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z" } }] })(e);
}
function EV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M225.9 32C103.3 32 0 130.5 0 252.1 0 256 .1 480 .1 480l225.8-.2c122.7 0 222.1-102.3 222.1-223.9C448 134.3 348.6 32 225.9 32zM224 384c-19.4 0-37.9-4.3-54.4-12.1L88.5 392l22.9-75c-9.8-18.1-15.4-38.9-15.4-61 0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128z" } }] })(e);
}
function CV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 496 512" }, child: [{ tag: "path", attr: { d: "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z" } }] })(e);
}
function xV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M94.12 315.1c0 25.9-21.16 47.06-47.06 47.06S0 341 0 315.1c0-25.9 21.16-47.06 47.06-47.06h47.06v47.06zm23.72 0c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.84c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06V315.1zm47.06-188.98c-25.9 0-47.06-21.16-47.06-47.06S139 32 164.9 32s47.06 21.16 47.06 47.06v47.06H164.9zm0 23.72c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H47.06C21.16 243.96 0 222.8 0 196.9s21.16-47.06 47.06-47.06H164.9zm188.98 47.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06h-47.06V196.9zm-23.72 0c0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06V79.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06V196.9zM283.1 385.88c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06v-47.06h47.06zm0-23.72c-25.9 0-47.06-21.16-47.06-47.06 0-25.9 21.16-47.06 47.06-47.06h117.84c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06H283.1z" } }] })(e);
}
function AV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 384 512" }, child: [{ tag: "path", attr: { d: "M290.7 311L95 269.7 86.8 309l195.7 41zm51-87L188.2 95.7l-25.5 30.8 153.5 128.3zm-31.2 39.7L129.2 179l-16.7 36.5L293.7 300zM262 32l-32 24 119.3 160.3 32-24zm20.5 328h-200v39.7h200zm39.7 80H42.7V320h-40v160h359.5V320h-40z" } }] })(e);
}
function wV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 496 512" }, child: [{ tag: "path", attr: { d: "M248,8C111.033,8,0,119.033,0,256S111.033,504,248,504,496,392.967,496,256,384.967,8,248,8ZM362.952,176.66c-3.732,39.215-19.881,134.378-28.1,178.3-3.476,18.584-10.322,24.816-16.948,25.425-14.4,1.326-25.338-9.517-39.287-18.661-21.827-14.308-34.158-23.215-55.346-37.177-24.485-16.135-8.612-25,5.342-39.5,3.652-3.793,67.107-61.51,68.335-66.746.153-.655.3-3.1-1.154-4.384s-3.59-.849-5.135-.5q-3.283.746-104.608,69.142-14.845,10.194-26.894,9.934c-8.855-.191-25.888-5.006-38.551-9.123-15.531-5.048-27.875-7.717-26.8-16.291q.84-6.7,18.45-13.7,108.446-47.248,144.628-62.3c68.872-28.647,83.183-33.623,92.511-33.789,2.052-.034,6.639.474,9.61,2.885a10.452,10.452,0,0,1,3.53,6.716A43.765,43.765,0,0,1,362.952,176.66Z" } }] })(e);
}
function FV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M192 32c0 17.7 14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192c-17.7 0-32 14.3-32 32zM96 144c0-26.5-21.5-48-48-48S0 117.5 0 144V368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144H128v96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48V144z" } }] })(e);
}
function TV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm16 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z" } }] })(e);
}
function SV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z" } }] })(e);
}
function IV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 320 512" }, child: [{ tag: "path", attr: { d: "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" } }] })(e);
}
function BV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z" } }] })(e);
}
function RV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M448 80v48c0 44.2-100.3 80-224 80S0 172.2 0 128V80C0 35.8 100.3 0 224 0S448 35.8 448 80zM393.2 214.7c20.8-7.4 39.9-16.9 54.8-28.6V288c0 44.2-100.3 80-224 80S0 332.2 0 288V186.1c14.9 11.8 34 21.2 54.8 28.6C99.7 230.7 159.5 240 224 240s124.3-9.3 169.2-25.3zM0 346.1c14.9 11.8 34 21.2 54.8 28.6C99.7 390.7 159.5 400 224 400s124.3-9.3 169.2-25.3c20.8-7.4 39.9-16.9 54.8-28.6V432c0 44.2-100.3 80-224 80S0 476.2 0 432V346.1z" } }] })(e);
}
function OV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" } }] })(e);
}
function PV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z" } }] })(e);
}
function NV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" } }] })(e);
}
function zV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z" } }] })(e);
}
function LV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z" } }] })(e);
}
function MV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z" } }] })(e);
}
function jV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 320 512" }, child: [{ tag: "path", attr: { d: "M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z" } }] })(e);
}
function HV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M64 256V160H224v96H64zm0 64H224v96H64V320zm224 96V320H448v96H288zM448 256H288V160H448v96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z" } }] })(e);
}
function $V(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M64 464H96v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288H336V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z" } }] })(e);
}
function UV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M9 4.5a.75.75 0 01.721.544l.813 2.846a3.75 3.75 0 002.576 2.576l2.846.813a.75.75 0 010 1.442l-2.846.813a3.75 3.75 0 00-2.576 2.576l-.813 2.846a.75.75 0 01-1.442 0l-.813-2.846a3.75 3.75 0 00-2.576-2.576l-2.846-.813a.75.75 0 010-1.442l2.846-.813A3.75 3.75 0 007.466 7.89l.813-2.846A.75.75 0 019 4.5zM18 1.5a.75.75 0 01.728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 010 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 01-1.456 0l-.258-1.036a2.625 2.625 0 00-1.91-1.91l-1.036-.258a.75.75 0 010-1.456l1.036-.258a2.625 2.625 0 001.91-1.91l.258-1.036A.75.75 0 0118 1.5zM16.5 15a.75.75 0 01.712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 010 1.422l-1.183.395c-.447.15-.799.5-.948.948l-.395 1.183a.75.75 0 01-1.422 0l-.395-1.183a1.5 1.5 0 00-.948-.948l-1.183-.395a.75.75 0 010-1.422l1.183-.395c.447-.15.799-.5.948-.948l.395-1.183A.75.75 0 0116.5 15z", clipRule: "evenodd" } }] })(e);
}
function VV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { d: "M11.983 1.907a.75.75 0 00-1.292-.657l-8.5 9.5A.75.75 0 002.75 12h6.572l-1.305 6.093a.75.75 0 001.292.657l8.5-9.5A.75.75 0 0017.25 8h-6.572l1.305-6.093z" } }] })(e);
}
function WV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M256 112v288m144-144H112" } }] })(e);
}
function GV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M256 160c16-63.16 76.43-95.41 208-96a15.94 15.94 0 0116 16v288a16 16 0 01-16 16c-128 0-177.45 25.81-208 64-30.37-38-80-64-208-64-9.88 0-16-8.05-16-17.93V80a15.94 15.94 0 0116-16c131.57.59 192 32.84 208 96zm0 0v288" } }] })(e);
}
function KV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeMiterlimit: "10", strokeWidth: "32", d: "M431 320.6c-1-3.6 1.2-8.6 3.3-12.2a33.68 33.68 0 012.1-3.1A162 162 0 00464 215c.3-92.2-77.5-167-173.7-167-83.9 0-153.9 57.1-170.3 132.9a160.7 160.7 0 00-3.7 34.2c0 92.3 74.8 169.1 171 169.1 15.3 0 35.9-4.6 47.2-7.7s22.5-7.2 25.4-8.3a26.44 26.44 0 019.3-1.7 26 26 0 0110.1 2l56.7 20.1a13.52 13.52 0 003.9 1 8 8 0 008-8 12.85 12.85 0 00-.5-2.7z" } }, { tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeMiterlimit: "10", strokeWidth: "32", d: "M66.46 232a146.23 146.23 0 006.39 152.67c2.31 3.49 3.61 6.19 3.21 8s-11.93 61.87-11.93 61.87a8 8 0 002.71 7.68A8.17 8.17 0 0072 464a7.26 7.26 0 002.91-.6l56.21-22a15.7 15.7 0 0112 .2c18.94 7.38 39.88 12 60.83 12A159.21 159.21 0 00284 432.11" } }] })(e);
}
function YV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M464 128L240 384l-96-96m0 96l-96-96m320-160L232 284" } }] })(e);
}
function qV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M416 128L192 384l-96-96" } }] })(e);
}
function QV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "48", d: "M184 112l144 144-144 144" } }] })(e);
}
function XV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M368 368L144 144m224 0L144 368" } }] })(e);
}
function ZV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "rect", attr: { width: "336", height: "336", x: "128", y: "128", fill: "none", strokeLinejoin: "round", strokeWidth: "32", rx: "57", ry: "57" } }, { tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M383.5 128l.5-24a56.16 56.16 0 00-56-56H112a64.19 64.19 0 00-64 64v216a56.16 56.16 0 0056 56h24" } }] })(e);
}
function JV(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M408 480H184a72 72 0 01-72-72V184a72 72 0 0172-72h224a72 72 0 0172 72v224a72 72 0 01-72 72z" } }, { tag: "path", attr: { d: "M160 80h235.88A72.12 72.12 0 00328 32H104a72 72 0 00-72 72v224a72.12 72.12 0 0048 67.88V160a80 80 0 0180-80z" } }] })(e);
}
function eW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M240 216V32H92a12 12 0 00-12 12v424a12 12 0 0012 12h328a12 12 0 0012-12V224H248a8 8 0 01-8-8z" } }, { tag: "path", attr: { d: "M272 41.69V188a4 4 0 004 4h146.31a2 2 0 001.42-3.41L275.41 40.27a2 2 0 00-3.41 1.42z" } }] })(e);
}
function tW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinejoin: "round", strokeWidth: "32", d: "M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z" } }, { tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M256 56v120a32 32 0 0032 32h120m-232 80h160m-160 80h160" } }] })(e);
}
function rW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M272 41.69V188a4 4 0 004 4h146.31a2 2 0 001.42-3.41L275.41 40.27a2 2 0 00-3.41 1.42z" } }, { tag: "path", attr: { d: "M248 224a8 8 0 01-8-8V32H92a12 12 0 00-12 12v424a12 12 0 0012 12h328a12 12 0 0012-12V224zm104 160H160v-32h192zm0-80H160v-32h192z" } }] })(e);
}
function iW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "circle", attr: { cx: "256", cy: "256", r: "208", fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32" } }, { tag: "circle", attr: { cx: "256", cy: "256", r: "80", fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32" } }, { tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M208 54l8 132m80 0l8-132m-96 404l8-132m80 0l8 132m154-250l-132 8m0 80l132 8M54 208l132 8m0 80l-132 8" } }] })(e);
}
function nW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M80 212v236a16 16 0 0016 16h96V328a24 24 0 0124-24h80a24 24 0 0124 24v136h96a16 16 0 0016-16V212" } }, { tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M480 256L266.89 52c-5-5.28-16.69-5.34-21.78 0L32 256m368-77V64h-48v69" } }] })(e);
}
function aW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeMiterlimit: "10", strokeWidth: "32", d: "M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184 184-82.39 184-184S349.61 64 248 64z" } }, { tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M220 220h32v116" } }, { tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeMiterlimit: "10", strokeWidth: "32", d: "M208 340h88" } }, { tag: "path", attr: { d: "M248 130a26 26 0 1026 26 26 26 0 00-26-26z" } }] })(e);
}
function oW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "36", d: "M208 352h-64a96 96 0 010-192h64m96 0h64a96 96 0 010 192h-64m-140.71-96h187.42" } }] })(e);
}
function sW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M464 66.52A50 50 0 00414.12 17L97.64 16A49.65 49.65 0 0048 65.52V392c0 27.3 22.28 48 49.64 48H368l-13-44 109 100zM324.65 329.81s-8.72-10.39-16-19.32C340.39 301.55 352.5 282 352.5 282a139 139 0 01-27.85 14.25 173.31 173.31 0 01-35.11 10.39 170.05 170.05 0 01-62.72-.24 184.45 184.45 0 01-35.59-10.4 141.46 141.46 0 01-17.68-8.21c-.73-.48-1.45-.72-2.18-1.21-.49-.24-.73-.48-1-.48-4.36-2.42-6.78-4.11-6.78-4.11s11.62 19.09 42.38 28.26c-7.27 9.18-16.23 19.81-16.23 19.81-53.51-1.69-73.85-36.47-73.85-36.47 0-77.06 34.87-139.62 34.87-139.62 34.87-25.85 67.8-25.12 67.8-25.12l2.42 2.9c-43.59 12.32-63.44 31.4-63.44 31.4s5.32-2.9 14.28-6.77c25.91-11.35 46.5-14.25 55-15.21a24 24 0 014.12-.49 205.62 205.62 0 0148.91-.48 201.62 201.62 0 0172.89 22.95s-19.13-18.15-60.3-30.45l3.39-3.86s33.17-.73 67.81 25.16c0 0 34.87 62.56 34.87 139.62 0-.28-20.35 34.5-73.86 36.19z" } }, { tag: "path", attr: { d: "M212.05 218c-13.8 0-24.7 11.84-24.7 26.57s11.14 26.57 24.7 26.57c13.8 0 24.7-11.83 24.7-26.57.25-14.76-10.9-26.57-24.7-26.57zm88.38 0c-13.8 0-24.7 11.84-24.7 26.57s11.14 26.57 24.7 26.57c13.81 0 24.7-11.83 24.7-26.57S314 218 300.43 218z" } }] })(e);
}
function lW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M256 32C132.3 32 32 134.9 32 261.7c0 101.5 64.2 187.5 153.2 217.9a17.56 17.56 0 003.8.4c8.3 0 11.5-6.1 11.5-11.4 0-5.5-.2-19.9-.3-39.1a102.4 102.4 0 01-22.6 2.7c-43.1 0-52.9-33.5-52.9-33.5-10.2-26.5-24.9-33.6-24.9-33.6-19.5-13.7-.1-14.1 1.4-14.1h.1c22.5 2 34.3 23.8 34.3 23.8 11.2 19.6 26.2 25.1 39.6 25.1a63 63 0 0025.6-6c2-14.8 7.8-24.9 14.2-30.7-49.7-5.8-102-25.5-102-113.5 0-25.1 8.7-45.6 23-61.6-2.3-5.8-10-29.2 2.2-60.8a18.64 18.64 0 015-.5c8.1 0 26.4 3.1 56.6 24.1a208.21 208.21 0 01112.2 0c30.2-21 48.5-24.1 56.6-24.1a18.64 18.64 0 015 .5c12.2 31.6 4.5 55 2.2 60.8 14.3 16.1 23 36.6 23 61.6 0 88.2-52.4 107.6-102.3 113.3 8 7.1 15.2 21.1 15.2 42.5 0 30.7-.3 55.5-.3 63 0 5.4 3.1 11.5 11.4 11.5a19.35 19.35 0 004-.4C415.9 449.2 480 363.1 480 261.7 480 134.9 379.7 32 256 32z" } }] })(e);
}
function uW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M424 80H88a56.06 56.06 0 00-56 56v240a56.06 56.06 0 0056 56h336a56.06 56.06 0 0056-56V136a56.06 56.06 0 00-56-56zm-14.18 92.63l-144 112a16 16 0 01-19.64 0l-144-112a16 16 0 1119.64-25.26L256 251.73l134.18-104.36a16 16 0 0119.64 25.26z" } }] })(e);
}
function cW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M384 224v184a40 40 0 01-40 40H104a40 40 0 01-40-40V168a40 40 0 0140-40h167.48M336 64h112v112M224 288L440 72" } }] })(e);
}
function dW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M364.13 125.25L87 403l-23 45 44.99-23 277.76-277.13-22.62-22.62zm56.56-56.56l-22.62 22.62 22.62 22.63 22.62-22.63a16 16 0 000-22.62h0a16 16 0 00-22.62 0z" } }] })(e);
}
function pW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M402 168c-2.93 40.67-33.1 72-66 72s-63.12-31.32-66-72c-3-42.31 26.37-72 66-72s69 30.46 66 72z" } }, { tag: "path", attr: { fill: "none", strokeMiterlimit: "10", strokeWidth: "32", d: "M336 304c-65.17 0-127.84 32.37-143.54 95.41-2.08 8.34 3.15 16.59 11.72 16.59h263.65c8.57 0 13.77-8.25 11.72-16.59C463.85 335.36 401.18 304 336 304z" } }, { tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M200 185.94c-2.34 32.48-26.72 58.06-53 58.06s-50.7-25.57-53-58.06C91.61 152.15 115.34 128 147 128s55.39 24.77 53 57.94z" } }, { tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeMiterlimit: "10", strokeWidth: "32", d: "M206 306c-18.05-8.27-37.93-11.45-59-11.45-52 0-102.1 25.85-114.65 76.2-1.65 6.66 2.53 13.25 9.37 13.25H154" } }] })(e);
}
function hW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeMiterlimit: "10", strokeWidth: "32", d: "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z" } }, { tag: "path", attr: { d: "M216.32 334.44l114.45-69.14a10.89 10.89 0 000-18.6l-114.45-69.14a10.78 10.78 0 00-16.32 9.31v138.26a10.78 10.78 0 0016.32 9.31z" } }] })(e);
}
function fW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "rect", attr: { width: "320", height: "416", x: "96", y: "48", fill: "none", strokeLinejoin: "round", strokeWidth: "32", rx: "48", ry: "48" } }, { tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M176 128h160m-160 80h160m-160 80h80" } }] })(e);
}
function gW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M112 352l-64-64 64-64" } }, { tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M64 288h294c58.76 0 106-49.33 106-108v-20" } }] })(e);
}
function mW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M400 352l64-64-64-64" } }, { tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M448 288H154c-58.76 0-106-49.33-106-108v-20" } }] })(e);
}
function vW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M456.69 421.39L362.6 327.3a173.81 173.81 0 0034.84-104.58C397.44 126.38 319.06 48 222.72 48S48 126.38 48 222.72s78.38 174.72 174.72 174.72A173.81 173.81 0 00327.3 362.6l94.09 94.09a25 25 0 0035.3-35.3zM97.92 222.72a124.8 124.8 0 11124.8 124.8 124.95 124.95 0 01-124.8-124.8z" } }] })(e);
}
function kW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M476.59 227.05l-.16-.07L49.35 49.84A23.56 23.56 0 0027.14 52 24.65 24.65 0 0016 72.59v113.29a24 24 0 0019.52 23.57l232.93 43.07a4 4 0 010 7.86L35.53 303.45A24 24 0 0016 327v113.31A23.57 23.57 0 0026.59 460a23.94 23.94 0 0013.22 4 24.55 24.55 0 009.52-1.93L476.4 285.94l.19-.09a32 32 0 000-58.8z" } }] })(e);
}
function bW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M432 32H80a64.07 64.07 0 00-64 64v320a64.07 64.07 0 0064 64h352a64.07 64.07 0 0064-64V96a64.07 64.07 0 00-64-64zM96 256a16 16 0 01-10-28.49L150.39 176 86 124.49a16 16 0 1120-25l80 64a16 16 0 010 25l-80 64A16 16 0 0196 256zm160 0h-64a16 16 0 010-32h64a16 16 0 010 32z" } }] })(e);
}
function _W(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M56 320l156.05 12-23 89.4c-6.08 26.6.7 41.87 22.39 48.62l34.69 9.85a4 4 0 004.4-1.72l129-202.34a8 8 0 016.81-3.81H496V64H378.39a48 48 0 01-15.18-2.46l-76.3-25.43a80 80 0 00-25.3-4.11H83.68c-19 0-31.5 13.52-35.23 32.16L16 206.42V280c0 22.06 18 38 40 40z" } }, { tag: "path", attr: { fill: "none", d: "M378.45 273.93A15.84 15.84 0 01386 272a15.93 15.93 0 00-7.51 1.91zm-40.59 69.29l-.13.22a2.53 2.53 0 01.13-.22c20.5-35.51 30.36-55 33.82-62-3.47 7.06-13.34 26.51-33.82 62z" } }, { tag: "path", attr: { d: "M372.66 279.16l-1 2a16.29 16.29 0 016.77-7.26 16.48 16.48 0 00-5.77 5.26z" } }] })(e);
}
function DW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M456 192l-156-12 23-89.4c6-26.6-.78-41.87-22.47-48.6l-34.69-9.85a4 4 0 00-4.4 1.72l-129 202.34a8 8 0 01-6.81 3.81H16V448h117.61a48 48 0 0115.18 2.46l76.3 25.43a80 80 0 0025.3 4.11h177.93c19 0 31.5-13.52 35.23-32.16L496 305.58V232c0-22.06-18-38-40-40z" } }] })(e);
}
function yW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "m12 19-7-7 7-7" } }, { tag: "path", attr: { d: "M19 12H5" } }] })(e);
}
function EW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M7 7h10v10" } }, { tag: "path", attr: { d: "M7 17 17 7" } }] })(e);
}
function CW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" } }, { tag: "path", attr: { d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" } }] })(e);
}
function xW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "polyline", attr: { points: "20 6 9 17 4 12" } }] })(e);
}
function AW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "m6 9 6 6 6-6" } }] })(e);
}
function wW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3" } }] })(e);
}
function FW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "rect", attr: { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" } }, { tag: "path", attr: { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" } }] })(e);
}
function TW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "polyline", attr: { points: "9 10 4 15 9 20" } }, { tag: "path", attr: { d: "M20 4v7a4 4 0 0 1-4 4H4" } }] })(e);
}
function SW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "m17 2 4 4-4 4" } }, { tag: "path", attr: { d: "M3 11v-1a4 4 0 0 1 4-4h14" } }, { tag: "path", attr: { d: "m7 22-4-4 4-4" } }, { tag: "path", attr: { d: "M21 13v1a4 4 0 0 1-4 4H3" } }] })(e);
}
function IW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M17 14V2" } }, { tag: "path", attr: { d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22h0a3.13 3.13 0 0 1-3-3.88Z" } }] })(e);
}
function BW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M7 10v12" } }, { tag: "path", attr: { d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z" } }] })(e);
}
function RW(e) {
  return ft({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" } }, { tag: "circle", attr: { cx: "9", cy: "7", r: "4" } }, { tag: "path", attr: { d: "M22 21v-2a4 4 0 0 0-3-3.87" } }, { tag: "path", attr: { d: "M16 3.13a4 4 0 0 1 0 7.75" } }] })(e);
}
const OW = {
  FaBook: TV,
  FaGithub: CV,
  FaDatabase: RV,
  FaStackOverflow: AV,
  FaChrome: DV,
  FaPhone: MV,
  FaEnvelope: OV,
  FaPencil: LV,
  FaBlog: FV,
  FaSort: jV,
  FaPenSquare: zV,
  FaChevronRight: IV,
  FaChevronUp: BV,
  FaFilePdf: PV,
  FaDiscourse: EV,
  FaDiscord: yV,
  FaSlack: xV,
  IoDocumentTextSharp: rW,
  IoDocumentSharp: eW,
  IoSend: kW,
  IoInformationCircleOutline: aW,
  IoLinkOutline: oW,
  IoThumbsUpSharp: DW,
  IoThumbsDownSharp: _W,
  IoSearch: vW,
  IoCopyOutline: ZV,
  IoCopy: JV,
  IoReturnDownBackOutline: gW,
  IoChevronForwardOutline: QV,
  IoReturnDownForward: mW,
  IoCloseOutline: XV,
  IoCheckmarkOutline: qV,
  IoBookOutline: GV,
  IoReaderOutline: fW,
  IoHelpBuoyOutline: iW,
  IoPeopleOutline: pW,
  IoDocumentTextOutline: tW,
  IoChatbubblesOutline: KV,
  FaRegFilePdf: $V,
  IoLogoDiscord: sW,
  IoLogoGithub: lW,
  IoTerminal: bW,
  FaBriefcase: SV,
  IoPlayCircleOutline: hW,
  IoPencilOutline: dW,
  IoCheckmarkDoneOutline: YV,
  IoHomeOutline: nW,
  IoMail: uW,
  IoOpenOutline: cW,
  FaTelegram: wV,
  FaTable: HV,
  FaMagnifyingGlass: NV,
  LuArrowLeft: yW,
  LuCommand: wW,
  LuCopy: FW,
  LuCornerDownLeft: TW,
  LuRepeat: SW,
  LuThumbsDown: IW,
  LuThumbsUp: BW,
  LuUsers: RW,
  LuArrowUpRight: EW,
  LuBookOpen: CW,
  HiSparkles: UV
}, PW = Te(q2);
function NW({
  iconSettings: e,
  ...t
}) {
  if (!e)
    return /* @__PURE__ */ v.jsx(Ct, { width: "16px", minH: "16px" });
  if ("builtIn" in e) {
    const r = OW[e.builtIn];
    return r ? /* @__PURE__ */ v.jsx(cm, { ...t, asChild: !0, children: /* @__PURE__ */ v.jsx(r, {}) }) : null;
  }
  if ("custom" in e) {
    const r = e.custom;
    if (r.toLowerCase().endsWith(".svg")) {
      const n = Eo(`${ye}-icon`, t.className).split(" ");
      return /* @__PURE__ */ v.jsx(
        PW,
        {
          src: r,
          beforeInjection: (a) => {
            a.classList.add(...n);
          },
          wrapper: "div",
          display: "contents",
          css: {
            "& div": {
              display: "contents"
            }
          }
        }
      );
    }
    return /* @__PURE__ */ v.jsx(
      w2,
      {
        src: e.custom,
        display: "inline-block",
        alt: "custom icon",
        w: "1em",
        minH: "1em",
        ...t
      }
    );
  }
  return null;
}
const cp = Te(NW), zW = {
  search: "IoSearch",
  thumbsUp: "LuThumbsUp",
  thumbsDown: "LuThumbsDown",
  messageCopy: "LuCopy",
  codeCopy: "LuCopy",
  openLinkInNewTab: "LuArrowUpRight",
  openLinkInSameTab: "LuCornerDownLeft",
  breadcrumbSeparator: "FaChevronRight",
  switchToSearch: "IoSearch",
  switchToChat: "HiSparkles",
  chatSubmit: "IoSend",
  close: "IoCloseOutline",
  info: "IoInformationCircleOutline",
  command: "LuCommand"
};
function LW({ iconKey: e, ...t }) {
  var a;
  const r = zW[e], i = r ? { builtIn: r } : { custom: "" }, n = ((a = Xi().customIcons) == null ? void 0 : a[e]) || i;
  return /* @__PURE__ */ v.jsx(cp, { iconSettings: n, ...t });
}
const zn = Te(LW), MW = () => {
  var t, r;
  if (typeof window > "u")
    return !1;
  const e = (r = (t = window.navigator) == null ? void 0 : t.userAgent) == null ? void 0 : r.toLowerCase();
  return e.includes("macintosh") || e.includes("mac os x");
}, jW = () => /* @__PURE__ */ v.jsx(
  zn,
  {
    iconKey: "command",
    mr: 0.5,
    color: "inherit",
    className: `${ye}-kbd-shortcut-icon`
  }
), HW = () => /* @__PURE__ */ v.jsx(cn, { mr: 0.5, className: `${ye}-kbd-shortcut-icon`, children: "Ctrl" }), $W = ({ openShortcutKey: e }) => {
  const t = MW() ? jW : HW;
  return /* @__PURE__ */ v.jsxs(
    Ct,
    {
      className: `${ye}-kbd-shortcut`,
      display: "flex",
      alignItems: "center",
      children: [
        /* @__PURE__ */ v.jsx(t, {}),
        e.toUpperCase()
      ]
    }
  );
}, YA = $W, UW = () => {
  const {
    openShortcutKey: e,
    isShortcutKeyEnabled: t,
    chatButtonText: r = "Ask anything"
  } = Ka();
  return /* @__PURE__ */ v.jsx(Cm, { px: 4, children: /* @__PURE__ */ v.jsxs(mt, { alignItems: "center", direction: "column", justifyContent: "center", children: [
    /* @__PURE__ */ v.jsxs(mt, { alignItems: "center", justifyContent: "space-between", w: "100%", children: [
      /* @__PURE__ */ v.jsx(K2, {}),
      e && t && /* @__PURE__ */ v.jsx(mt, { alignItems: "center", pl: 3, children: /* @__PURE__ */ v.jsx(YA, { openShortcutKey: e }) })
    ] }),
    /* @__PURE__ */ v.jsx(
      cn,
      {
        mt: 2,
        display: "inline-flex",
        alignItems: "center",
        className: `${ye}-chat-button__text`,
        children: r
      }
    )
  ] }) });
}, VW = UW, WW = () => {
  const { chatButtonText: e = "Ask AI" } = Ka();
  return /* @__PURE__ */ v.jsx(Cm, { borderRadius: "full", px: "18px", children: /* @__PURE__ */ v.jsxs(mt, { alignItems: "center", justifyContent: "center", children: [
    /* @__PURE__ */ v.jsx(
      cn,
      {
        display: "inline-flex",
        alignItems: "center",
        mr: 2,
        className: `${ye}-chat-button__text`,
        children: e
      }
    ),
    /* @__PURE__ */ v.jsx(K2, {})
  ] }) });
}, f9 = WW, GW = Je((e, t) => /* @__PURE__ */ v.jsx(Ct, { ref: t, ...e, className: `${ye}-floating-button-box`, children: e.children })), KW = GW, YW = () => {
  const { chatButtonType: e, isOpen: t, onClose: r, onOpen: i, closeOnBlur: n } = Ka();
  let a;
  switch (e) {
    case "ICON":
      a = YU;
      break;
    case "PILL":
      a = f9;
      break;
    case "RECTANGLE_SHORTCUT":
      a = VW;
      break;
    default:
      a = f9;
  }
  return /* @__PURE__ */ v.jsx(KW, { onClick: t ? r : i, children: t && !n ? /* @__PURE__ */ v.jsx(
    Cm,
    {
      _light: {
        bg: "inkeepPrimary.medium"
      },
      borderRadius: "full",
      px: 3,
      py: 3,
      children: /* @__PURE__ */ v.jsx(
        cm,
        {
          _light: {
            color: "inkeepPrimary.textColorOnPrimary"
          },
          height: 6,
          width: 6,
          asChild: !0,
          children: /* @__PURE__ */ v.jsx(eH, {})
        }
      )
    }
  ) : /* @__PURE__ */ v.jsx(a, {}) });
}, qW = T2(({ baseProps: e, modalProps: t, searchProps: r, aiChatProps: i }) => /* @__PURE__ */ v.jsx(Em, { children: /* @__PURE__ */ v.jsx(
  vm,
  {
    ...e,
    children: /* @__PURE__ */ v.jsx(ym, { children: /* @__PURE__ */ v.jsx(U1, { children: /* @__PURE__ */ v.jsx(L2, { ...t, children: /* @__PURE__ */ v.jsx(z2, { ...i, children: /* @__PURE__ */ v.jsx(M2, { ...r, children: /* @__PURE__ */ v.jsx(YW, {}) }) }) }) }) })
  }
) }));
function a_() {
  return a_ = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, a_.apply(this, arguments);
}
var qA = ["shift", "alt", "meta", "mod", "ctrl"], QW = {
  esc: "escape",
  return: "enter",
  ".": "period",
  ",": "comma",
  "-": "slash",
  " ": "space",
  "`": "backquote",
  "#": "backslash",
  "+": "bracketright",
  ShiftLeft: "shift",
  ShiftRight: "shift",
  AltLeft: "alt",
  AltRight: "alt",
  MetaLeft: "meta",
  MetaRight: "meta",
  OSLeft: "meta",
  OSRight: "meta",
  ControlLeft: "ctrl",
  ControlRight: "ctrl"
};
function Cl(e) {
  return (QW[e] || e).trim().toLowerCase().replace(/key|digit|numpad|arrow/, "");
}
function XW(e) {
  return qA.includes(e);
}
function Sk(e, t) {
  return t === void 0 && (t = ","), e.split(t);
}
function Ik(e, t, r) {
  t === void 0 && (t = "+");
  var i = e.toLocaleLowerCase().split(t).map(function(o) {
    return Cl(o);
  }), n = {
    alt: i.includes("alt"),
    ctrl: i.includes("ctrl") || i.includes("control"),
    shift: i.includes("shift"),
    meta: i.includes("meta"),
    mod: i.includes("mod")
  }, a = i.filter(function(o) {
    return !qA.includes(o);
  });
  return a_({}, n, {
    keys: a,
    description: r
  });
}
(function() {
  typeof document < "u" && (document.addEventListener("keydown", function(e) {
    e.key !== void 0 && QA([Cl(e.key), Cl(e.code)]);
  }), document.addEventListener("keyup", function(e) {
    e.key !== void 0 && XA([Cl(e.key), Cl(e.code)]);
  })), typeof window < "u" && window.addEventListener("blur", function() {
    xl.clear();
  });
})();
var xl = /* @__PURE__ */ new Set();
function Q2(e) {
  return Array.isArray(e);
}
function ZW(e, t) {
  t === void 0 && (t = ",");
  var r = Q2(e) ? e : e.split(t);
  return r.every(function(i) {
    return xl.has(i.trim().toLowerCase());
  });
}
function QA(e) {
  var t = Array.isArray(e) ? e : [e];
  xl.has("meta") && xl.forEach(function(r) {
    return !XW(r) && xl.delete(r.toLowerCase());
  }), t.forEach(function(r) {
    return xl.add(r.toLowerCase());
  });
}
function XA(e) {
  var t = Array.isArray(e) ? e : [e];
  e === "meta" ? xl.clear() : t.forEach(function(r) {
    return xl.delete(r.toLowerCase());
  });
}
function JW(e, t, r) {
  (typeof r == "function" && r(e, t) || r === !0) && e.preventDefault();
}
function eG(e, t, r) {
  return typeof r == "function" ? r(e, t) : r === !0 || r === void 0;
}
function tG(e) {
  return ZA(e, ["input", "textarea", "select"]);
}
function ZA(e, t) {
  var r = e.target;
  t === void 0 && (t = !1);
  var i = r && r.tagName;
  return Q2(t) ? !!(i && t && t.some(function(n) {
    return n.toLowerCase() === i.toLowerCase();
  })) : !!(i && t && t === !0);
}
function rG(e, t) {
  return e.length === 0 && t ? (console.warn('A hotkey has the "scopes" option set, however no active scopes were found. If you want to use the global scopes feature, you need to wrap your app in a <HotkeysProvider>'), !0) : t ? e.some(function(r) {
    return t.includes(r);
  }) || e.includes("*") : !0;
}
var iG = function(t, r, i) {
  i === void 0 && (i = !1);
  var n = r.alt, a = r.meta, o = r.mod, s = r.shift, l = r.ctrl, u = r.keys, d = t.key, c = t.code, p = t.ctrlKey, f = t.metaKey, g = t.shiftKey, k = t.altKey, y = Cl(c), _ = d.toLowerCase();
  if (!i) {
    if (n === !k && _ !== "alt" || s === !g && _ !== "shift")
      return !1;
    if (o) {
      if (!f && !p)
        return !1;
    } else if (a === !f && _ !== "meta" && _ !== "os" || l === !p && _ !== "ctrl" && _ !== "control")
      return !1;
  }
  return u && u.length === 1 && (u.includes(_) || u.includes(y)) ? !0 : u ? ZW(u) : !u;
}, JA = /* @__PURE__ */ kn(void 0), nG = function() {
  return Pn(JA);
};
function aG(e) {
  var t = e.addHotkey, r = e.removeHotkey, i = e.children;
  return /* @__PURE__ */ v.jsx(JA.Provider, {
    value: {
      addHotkey: t,
      removeHotkey: r
    },
    children: i
  });
}
function X2(e, t) {
  return e && t && typeof e == "object" && typeof t == "object" ? Object.keys(e).length === Object.keys(t).length && //@ts-ignore
  Object.keys(e).reduce(function(r, i) {
    return r && X2(e[i], t[i]);
  }, !0) : e === t;
}
var ew = /* @__PURE__ */ kn({
  hotkeys: [],
  enabledScopes: [],
  toggleScope: function() {
  },
  enableScope: function() {
  },
  disableScope: function() {
  }
}), oG = function() {
  return Pn(ew);
}, tw = function(t) {
  var r = t.initiallyActiveScopes, i = r === void 0 ? ["*"] : r, n = t.children, a = rt((i == null ? void 0 : i.length) > 0 ? i : ["*"]), o = a[0], s = a[1], l = rt([]), u = l[0], d = l[1], c = Nt(function(y) {
    s(function(_) {
      return _.includes("*") ? [y] : Array.from(new Set([].concat(_, [y])));
    });
  }, []), p = Nt(function(y) {
    s(function(_) {
      return _.filter(function(A) {
        return A !== y;
      }).length === 0 ? ["*"] : _.filter(function(A) {
        return A !== y;
      });
    });
  }, []), f = Nt(function(y) {
    s(function(_) {
      return _.includes(y) ? _.filter(function(A) {
        return A !== y;
      }).length === 0 ? ["*"] : _.filter(function(A) {
        return A !== y;
      }) : _.includes("*") ? [y] : Array.from(new Set([].concat(_, [y])));
    });
  }, []), g = Nt(function(y) {
    d(function(_) {
      return [].concat(_, [y]);
    });
  }, []), k = Nt(function(y) {
    d(function(_) {
      return _.filter(function(A) {
        return !X2(A, y);
      });
    });
  }, []);
  return /* @__PURE__ */ v.jsx(ew.Provider, {
    value: {
      enabledScopes: o,
      hotkeys: u,
      enableScope: c,
      disableScope: p,
      toggleScope: f
    },
    children: /* @__PURE__ */ v.jsx(aG, {
      addHotkey: g,
      removeHotkey: k,
      children: n
    })
  });
};
function sG(e) {
  var t = qt(void 0);
  return X2(t.current, e) || (t.current = e), t.current;
}
var g9 = function(t) {
  t.stopPropagation(), t.preventDefault(), t.stopImmediatePropagation();
}, lG = typeof window < "u" ? Xu : gt;
function rw(e, t, r, i) {
  var n = qt(null), a = qt(!1), o = r instanceof Array ? i instanceof Array ? void 0 : i : r, s = Q2(e) ? e.join(o == null ? void 0 : o.splitKey) : e, l = r instanceof Array ? r : i instanceof Array ? i : void 0, u = Nt(t, l ?? []), d = qt(u);
  l ? d.current = u : d.current = t;
  var c = sG(o), p = oG(), f = p.enabledScopes, g = nG();
  return lG(function() {
    if (!((c == null ? void 0 : c.enabled) === !1 || !rG(f, c == null ? void 0 : c.scopes))) {
      var k = function(N, P) {
        var B;
        if (P === void 0 && (P = !1), !(tG(N) && !ZA(N, c == null ? void 0 : c.enableOnFormTags)) && !(c != null && c.ignoreEventWhen != null && c.ignoreEventWhen(N))) {
          if (n.current !== null && document.activeElement !== n.current && !n.current.contains(document.activeElement)) {
            g9(N);
            return;
          }
          (B = N.target) != null && B.isContentEditable && !(c != null && c.enableOnContentEditable) || Sk(s, c == null ? void 0 : c.splitKey).forEach(function(M) {
            var X, U = Ik(M, c == null ? void 0 : c.combinationKey);
            if (iG(N, U, c == null ? void 0 : c.ignoreModifiers) || (X = U.keys) != null && X.includes("*")) {
              if (P && a.current)
                return;
              if (JW(N, U, c == null ? void 0 : c.preventDefault), !eG(N, U, c == null ? void 0 : c.enabled)) {
                g9(N);
                return;
              }
              d.current(N, U), P || (a.current = !0);
            }
          });
        }
      }, y = function(N) {
        N.key !== void 0 && (QA(Cl(N.code)), ((c == null ? void 0 : c.keydown) === void 0 && (c == null ? void 0 : c.keyup) !== !0 || c != null && c.keydown) && k(N));
      }, _ = function(N) {
        N.key !== void 0 && (XA(Cl(N.code)), a.current = !1, c != null && c.keyup && k(N, !0));
      }, A = n.current || (o == null ? void 0 : o.document) || document;
      return A.addEventListener("keyup", _), A.addEventListener("keydown", y), g && Sk(s, c == null ? void 0 : c.splitKey).forEach(function(T) {
        return g.addHotkey(Ik(T, c == null ? void 0 : c.combinationKey, c == null ? void 0 : c.description));
      }), function() {
        A.removeEventListener("keyup", _), A.removeEventListener("keydown", y), g && Sk(s, c == null ? void 0 : c.splitKey).forEach(function(T) {
          return g.removeHotkey(Ik(T, c == null ? void 0 : c.combinationKey, c == null ? void 0 : c.description));
        });
      };
    }
  }, [s, c, f]), n;
}
function Xn(e) {
  return e === null ? "null" : Array.isArray(e) ? "array" : typeof e;
}
function Nu(e) {
  return Xn(e) === "object";
}
function uG(e) {
  return Array.isArray(e) && // must be at least one error
  e.length > 0 && // error has at least a message
  e.every((t) => "message" in t);
}
function m9(e, t) {
  return e.length < 124 ? e : t;
}
const cG = "graphql-transport-ws";
var ka;
(function(e) {
  e[e.InternalServerError = 4500] = "InternalServerError", e[e.InternalClientError = 4005] = "InternalClientError", e[e.BadRequest = 4400] = "BadRequest", e[e.BadResponse = 4004] = "BadResponse", e[e.Unauthorized = 4401] = "Unauthorized", e[e.Forbidden = 4403] = "Forbidden", e[e.SubprotocolNotAcceptable = 4406] = "SubprotocolNotAcceptable", e[e.ConnectionInitialisationTimeout = 4408] = "ConnectionInitialisationTimeout", e[e.ConnectionAcknowledgementTimeout = 4504] = "ConnectionAcknowledgementTimeout", e[e.SubscriberAlreadyExists = 4409] = "SubscriberAlreadyExists", e[e.TooManyInitialisationRequests = 4429] = "TooManyInitialisationRequests";
})(ka || (ka = {}));
var wi;
(function(e) {
  e.ConnectionInit = "connection_init", e.ConnectionAck = "connection_ack", e.Ping = "ping", e.Pong = "pong", e.Subscribe = "subscribe", e.Next = "next", e.Error = "error", e.Complete = "complete";
})(wi || (wi = {}));
function iw(e) {
  if (!Nu(e))
    throw new Error(`Message is expected to be an object, but got ${Xn(e)}`);
  if (!e.type)
    throw new Error("Message is missing the 'type' property");
  if (typeof e.type != "string")
    throw new Error(`Message is expects the 'type' property to be a string, but got ${Xn(e.type)}`);
  switch (e.type) {
    case wi.ConnectionInit:
    case wi.ConnectionAck:
    case wi.Ping:
    case wi.Pong: {
      if (e.payload != null && !Nu(e.payload))
        throw new Error(`"${e.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${e.payload}"`);
      break;
    }
    case wi.Subscribe: {
      if (typeof e.id != "string")
        throw new Error(`"${e.type}" message expects the 'id' property to be a string, but got ${Xn(e.id)}`);
      if (!e.id)
        throw new Error(`"${e.type}" message requires a non-empty 'id' property`);
      if (!Nu(e.payload))
        throw new Error(`"${e.type}" message expects the 'payload' property to be an object, but got ${Xn(e.payload)}`);
      if (typeof e.payload.query != "string")
        throw new Error(`"${e.type}" message payload expects the 'query' property to be a string, but got ${Xn(e.payload.query)}`);
      if (e.payload.variables != null && !Nu(e.payload.variables))
        throw new Error(`"${e.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${Xn(e.payload.variables)}`);
      if (e.payload.operationName != null && Xn(e.payload.operationName) !== "string")
        throw new Error(`"${e.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${Xn(e.payload.operationName)}`);
      if (e.payload.extensions != null && !Nu(e.payload.extensions))
        throw new Error(`"${e.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${Xn(e.payload.extensions)}`);
      break;
    }
    case wi.Next: {
      if (typeof e.id != "string")
        throw new Error(`"${e.type}" message expects the 'id' property to be a string, but got ${Xn(e.id)}`);
      if (!e.id)
        throw new Error(`"${e.type}" message requires a non-empty 'id' property`);
      if (!Nu(e.payload))
        throw new Error(`"${e.type}" message expects the 'payload' property to be an object, but got ${Xn(e.payload)}`);
      break;
    }
    case wi.Error: {
      if (typeof e.id != "string")
        throw new Error(`"${e.type}" message expects the 'id' property to be a string, but got ${Xn(e.id)}`);
      if (!e.id)
        throw new Error(`"${e.type}" message requires a non-empty 'id' property`);
      if (!uG(e.payload))
        throw new Error(`"${e.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(e.payload)}`);
      break;
    }
    case wi.Complete: {
      if (typeof e.id != "string")
        throw new Error(`"${e.type}" message expects the 'id' property to be a string, but got ${Xn(e.id)}`);
      if (!e.id)
        throw new Error(`"${e.type}" message requires a non-empty 'id' property`);
      break;
    }
    default:
      throw new Error(`Invalid message 'type' property "${e.type}"`);
  }
  return e;
}
function dG(e, t) {
  return iw(typeof e == "string" ? JSON.parse(e, t) : e);
}
function y0(e, t) {
  return iw(e), JSON.stringify(e, t);
}
var Md = globalThis && globalThis.__await || function(e) {
  return this instanceof Md ? (this.v = e, this) : new Md(e);
}, pG = globalThis && globalThis.__asyncGenerator || function(e, t, r) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var i = r.apply(e, t || []), n, a = [];
  return n = {}, o("next"), o("throw"), o("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n;
  function o(p) {
    i[p] && (n[p] = function(f) {
      return new Promise(function(g, k) {
        a.push([p, f, g, k]) > 1 || s(p, f);
      });
    });
  }
  function s(p, f) {
    try {
      l(i[p](f));
    } catch (g) {
      c(a[0][3], g);
    }
  }
  function l(p) {
    p.value instanceof Md ? Promise.resolve(p.value.v).then(u, d) : c(a[0][2], p);
  }
  function u(p) {
    s("next", p);
  }
  function d(p) {
    s("throw", p);
  }
  function c(p, f) {
    p(f), a.shift(), a.length && s(a[0][0], a[0][1]);
  }
};
function hG(e) {
  const {
    url: t,
    connectionParams: r,
    lazy: i = !0,
    onNonLazyError: n = console.error,
    lazyCloseTimeout: a = 0,
    keepAlive: o = 0,
    disablePong: s,
    connectionAckWaitTimeout: l = 0,
    retryAttempts: u = 5,
    retryWait: d = async function(ue) {
      let de = 1e3;
      for (let he = 0; he < ue; he++)
        de *= 2;
      await new Promise((he) => setTimeout(he, de + // add random timeout from 300ms to 3s
      Math.floor(Math.random() * (3e3 - 300) + 300)));
    },
    shouldRetry: c = ff,
    isFatalConnectionProblem: p,
    on: f,
    webSocketImpl: g,
    /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */
    generateID: k = function() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (ue) => {
        const de = Math.random() * 16 | 0;
        return (ue == "x" ? de : de & 3 | 8).toString(16);
      });
    },
    jsonMessageReplacer: y,
    jsonMessageReviver: _
  } = e;
  let A;
  if (g) {
    if (!gG(g))
      throw new Error("Invalid WebSocket implementation provided");
    A = g;
  } else
    typeof WebSocket < "u" ? A = WebSocket : typeof global < "u" ? A = global.WebSocket || // @ts-expect-error: Support more browsers
    global.MozWebSocket : typeof window < "u" && (A = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket);
  if (!A)
    throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
  const T = A, N = (() => {
    const ie = (() => {
      const de = {};
      return {
        on(he, Ee) {
          return de[he] = Ee, () => {
            delete de[he];
          };
        },
        emit(he) {
          var Ee;
          "id" in he && ((Ee = de[he.id]) === null || Ee === void 0 || Ee.call(de, he));
        }
      };
    })(), ue = {
      connecting: f != null && f.connecting ? [f.connecting] : [],
      opened: f != null && f.opened ? [f.opened] : [],
      connected: f != null && f.connected ? [f.connected] : [],
      ping: f != null && f.ping ? [f.ping] : [],
      pong: f != null && f.pong ? [f.pong] : [],
      message: f != null && f.message ? [ie.emit, f.message] : [ie.emit],
      closed: f != null && f.closed ? [f.closed] : [],
      error: f != null && f.error ? [f.error] : []
    };
    return {
      onMessage: ie.on,
      on(de, he) {
        const Ee = ue[de];
        return Ee.push(he), () => {
          Ee.splice(Ee.indexOf(he), 1);
        };
      },
      emit(de, ...he) {
        for (const Ee of [...ue[de]])
          Ee(...he);
      }
    };
  })();
  function P(ie) {
    const ue = [
      // errors are fatal and more critical than close events, throw them first
      N.on("error", (de) => {
        ue.forEach((he) => he()), ie(de);
      }),
      // closes can be graceful and not fatal, throw them second (if error didnt throw)
      N.on("closed", (de) => {
        ue.forEach((he) => he()), ie(de);
      })
    ];
  }
  let B, M = 0, X, U = !1, K = 0, z = !1;
  async function j() {
    clearTimeout(X);
    const [ie, ue] = await (B ?? (B = new Promise((Ee, Le) => (async () => {
      if (U) {
        if (await d(K), !M)
          return B = void 0, Le({ code: 1e3, reason: "All Subscriptions Gone" });
        K++;
      }
      N.emit("connecting");
      const L = new T(typeof t == "function" ? await t() : t, cG);
      let me, Se;
      function G() {
        isFinite(o) && o > 0 && (clearTimeout(Se), Se = setTimeout(() => {
          L.readyState === T.OPEN && (L.send(y0({ type: wi.Ping })), N.emit("ping", !1, void 0));
        }, o));
      }
      P((xe) => {
        B = void 0, clearTimeout(me), clearTimeout(Se), Le(xe), ff(xe) && xe.code === 4499 && (L.close(4499, "Terminated"), L.onerror = null, L.onclose = null);
      }), L.onerror = (xe) => N.emit("error", xe), L.onclose = (xe) => N.emit("closed", xe), L.onopen = async () => {
        try {
          N.emit("opened", L);
          const xe = typeof r == "function" ? await r() : r;
          if (L.readyState !== T.OPEN)
            return;
          L.send(y0(xe ? {
            type: wi.ConnectionInit,
            payload: xe
          } : {
            type: wi.ConnectionInit
            // payload is completely absent if not provided
          }, y)), isFinite(l) && l > 0 && (me = setTimeout(() => {
            L.close(ka.ConnectionAcknowledgementTimeout, "Connection acknowledgement timeout");
          }, l)), G();
        } catch (xe) {
          N.emit("error", xe), L.close(ka.InternalClientError, m9(xe instanceof Error ? xe.message : new Error(xe).message, "Internal client error"));
        }
      };
      let He = !1;
      L.onmessage = ({ data: xe }) => {
        try {
          const _e = dG(xe, _);
          if (N.emit("message", _e), _e.type === "ping" || _e.type === "pong") {
            N.emit(_e.type, !0, _e.payload), _e.type === "pong" ? G() : s || (L.send(y0(_e.payload ? {
              type: wi.Pong,
              payload: _e.payload
            } : {
              type: wi.Pong
              // payload is completely absent if not provided
            })), N.emit("pong", !1, _e.payload));
            return;
          }
          if (He)
            return;
          if (_e.type !== wi.ConnectionAck)
            throw new Error(`First message cannot be of type ${_e.type}`);
          clearTimeout(me), He = !0, N.emit("connected", L, _e.payload), U = !1, K = 0, Ee([
            L,
            new Promise((Ze, qe) => P(qe))
          ]);
        } catch (_e) {
          L.onmessage = null, N.emit("error", _e), L.close(ka.BadResponse, m9(_e instanceof Error ? _e.message : new Error(_e).message, "Bad response"));
        }
      };
    })())));
    ie.readyState === T.CLOSING && await ue;
    let de = () => {
    };
    const he = new Promise((Ee) => de = Ee);
    return [
      ie,
      de,
      Promise.race([
        // wait for
        he.then(() => {
          if (!M) {
            const Ee = () => ie.close(1e3, "Normal Closure");
            isFinite(a) && a > 0 ? X = setTimeout(() => {
              ie.readyState === T.OPEN && Ee();
            }, a) : Ee();
          }
        }),
        // or
        ue
      ])
    ];
  }
  function J(ie) {
    if (ff(ie) && (fG(ie.code) || [
      ka.InternalServerError,
      ka.InternalClientError,
      ka.BadRequest,
      ka.BadResponse,
      ka.Unauthorized,
      // CloseCode.Forbidden, might grant access out after retry
      ka.SubprotocolNotAcceptable,
      // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
      // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
      ka.SubscriberAlreadyExists,
      ka.TooManyInitialisationRequests
      // 4499, // Terminated, probably because the socket froze, we want to retry
    ].includes(ie.code)))
      throw ie;
    if (z)
      return !1;
    if (ff(ie) && ie.code === 1e3)
      return M > 0;
    if (!u || K >= u || !c(ie) || p != null && p(ie))
      throw ie;
    return U = !0;
  }
  return i || (async () => {
    for (M++; ; )
      try {
        const [, , ie] = await j();
        await ie;
      } catch (ie) {
        try {
          if (!J(ie))
            return;
        } catch (ue) {
          return n == null ? void 0 : n(ue);
        }
      }
  })(), {
    on: N.on,
    subscribe(ie, ue) {
      const de = k(ie);
      let he = !1, Ee = !1, Le = () => {
        M--, he = !0;
      };
      return (async () => {
        for (M++; ; )
          try {
            const [L, me, Se] = await j();
            if (he)
              return me();
            const G = N.onMessage(de, (He) => {
              switch (He.type) {
                case wi.Next: {
                  ue.next(He.payload);
                  return;
                }
                case wi.Error: {
                  Ee = !0, he = !0, ue.error(He.payload), Le();
                  return;
                }
                case wi.Complete: {
                  he = !0, Le();
                  return;
                }
              }
            });
            L.send(y0({
              id: de,
              type: wi.Subscribe,
              payload: ie
            }, y)), Le = () => {
              !he && L.readyState === T.OPEN && L.send(y0({
                id: de,
                type: wi.Complete
              }, y)), M--, he = !0, me();
            }, await Se.finally(G);
            return;
          } catch (L) {
            if (!J(L))
              return;
          }
      })().then(() => {
        Ee || ue.complete();
      }).catch((L) => {
        ue.error(L);
      }), () => {
        he || Le();
      };
    },
    iterate(ie) {
      const ue = [], de = {
        done: !1,
        error: null,
        resolve: () => {
        }
      }, he = this.subscribe(ie, {
        next(Le) {
          ue.push(Le), de.resolve();
        },
        error(Le) {
          de.done = !0, de.error = Le, de.resolve();
        },
        complete() {
          de.done = !0, de.resolve();
        }
      }), Ee = function() {
        return pG(this, arguments, function* () {
          for (; ; ) {
            for (ue.length || (yield Md(new Promise((me) => de.resolve = me))); ue.length; )
              yield yield Md(ue.shift());
            if (de.error)
              throw de.error;
            if (de.done)
              return yield Md(void 0);
          }
        });
      }();
      return Ee.throw = async (Le) => (de.done || (de.done = !0, de.error = Le, de.resolve()), { done: !0, value: void 0 }), Ee.return = async () => (he(), { done: !0, value: void 0 }), Ee;
    },
    async dispose() {
      if (z = !0, B) {
        const [ie] = await B;
        ie.close(1e3, "Normal Closure");
      }
    },
    terminate() {
      B && N.emit("closed", {
        code: 4499,
        reason: "Terminated",
        wasClean: !1
      });
    }
  };
}
function ff(e) {
  return Nu(e) && "code" in e && "reason" in e;
}
function fG(e) {
  return [
    1e3,
    1001,
    1006,
    1005,
    1012,
    1013,
    1014
    // Bad Gateway
  ].includes(e) ? !1 : e >= 1e3 && e <= 1999;
}
function gG(e) {
  return typeof e == "function" && "constructor" in e && "CLOSED" in e && "CLOSING" in e && "CONNECTING" in e && "OPEN" in e;
}
function Wf(e, t) {
  if (!!!e)
    throw new Error(t);
}
function mG(e) {
  return typeof e == "object" && e !== null;
}
function vG(e, t) {
  if (!!!e)
    throw new Error(
      t ?? "Unexpected invariant triggered."
    );
}
const kG = /\r\n|[\n\r]/g;
function o_(e, t) {
  let r = 0, i = 1;
  for (const n of e.body.matchAll(kG)) {
    if (typeof n.index == "number" || vG(!1), n.index >= t)
      break;
    r = n.index + n[0].length, i += 1;
  }
  return {
    line: i,
    column: t + 1 - r
  };
}
function bG(e) {
  return nw(
    e.source,
    o_(e.source, e.start)
  );
}
function nw(e, t) {
  const r = e.locationOffset.column - 1, i = "".padStart(r) + e.body, n = t.line - 1, a = e.locationOffset.line - 1, o = t.line + a, s = t.line === 1 ? r : 0, l = t.column + s, u = `${e.name}:${o}:${l}
`, d = i.split(/\r\n|[\n\r]/g), c = d[n];
  if (c.length > 120) {
    const p = Math.floor(l / 80), f = l % 80, g = [];
    for (let k = 0; k < c.length; k += 80)
      g.push(c.slice(k, k + 80));
    return u + v9([
      [`${o} |`, g[0]],
      ...g.slice(1, p + 1).map((k) => ["|", k]),
      ["|", "^".padStart(f)],
      ["|", g[p + 1]]
    ]);
  }
  return u + v9([
    // Lines specified like this: ["prefix", "string"],
    [`${o - 1} |`, d[n - 1]],
    [`${o} |`, c],
    ["|", "^".padStart(l)],
    [`${o + 1} |`, d[n + 1]]
  ]);
}
function v9(e) {
  const t = e.filter(([i, n]) => n !== void 0), r = Math.max(...t.map(([i]) => i.length));
  return t.map(([i, n]) => i.padStart(r) + (n ? " " + n : "")).join(`
`);
}
function _G(e) {
  const t = e[0];
  return t == null || "kind" in t || "length" in t ? {
    nodes: t,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : t;
}
class Z2 extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(t, ...r) {
    var i, n, a;
    const { nodes: o, source: s, positions: l, path: u, originalError: d, extensions: c } = _G(r);
    super(t), this.name = "GraphQLError", this.path = u ?? void 0, this.originalError = d ?? void 0, this.nodes = k9(
      Array.isArray(o) ? o : o ? [o] : void 0
    );
    const p = k9(
      (i = this.nodes) === null || i === void 0 ? void 0 : i.map((g) => g.loc).filter((g) => g != null)
    );
    this.source = s ?? (p == null || (n = p[0]) === null || n === void 0 ? void 0 : n.source), this.positions = l ?? (p == null ? void 0 : p.map((g) => g.start)), this.locations = l && s ? l.map((g) => o_(s, g)) : p == null ? void 0 : p.map((g) => o_(g.source, g.start));
    const f = mG(
      d == null ? void 0 : d.extensions
    ) ? d == null ? void 0 : d.extensions : void 0;
    this.extensions = (a = c ?? f) !== null && a !== void 0 ? a : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), d != null && d.stack ? Object.defineProperty(this, "stack", {
      value: d.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, Z2) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let t = this.message;
    if (this.nodes)
      for (const r of this.nodes)
        r.loc && (t += `

` + bG(r.loc));
    else if (this.source && this.locations)
      for (const r of this.locations)
        t += `

` + nw(this.source, r);
    return t;
  }
  toJSON() {
    const t = {
      message: this.message
    };
    return this.locations != null && (t.locations = this.locations), this.path != null && (t.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (t.extensions = this.extensions), t;
  }
}
function k9(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function qi(e, t, r) {
  return new Z2(`Syntax Error: ${r}`, {
    source: e,
    positions: [t]
  });
}
class DG {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(t, r, i) {
    this.start = t.start, this.end = r.end, this.startToken = t, this.endToken = r, this.source = i;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class aw {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(t, r, i, n, a, o) {
    this.kind = t, this.start = r, this.end = i, this.line = n, this.column = a, this.value = o, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const ow = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, yG = new Set(Object.keys(ow));
function b9(e) {
  const t = e == null ? void 0 : e.kind;
  return typeof t == "string" && yG.has(t);
}
var Id;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(Id || (Id = {}));
var s_;
(function(e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(s_ || (s_ = {}));
var bt;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(bt || (bt = {}));
function l_(e) {
  return e === 9 || e === 32;
}
function _1(e) {
  return e >= 48 && e <= 57;
}
function sw(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function lw(e) {
  return sw(e) || e === 95;
}
function EG(e) {
  return sw(e) || _1(e) || e === 95;
}
function CG(e) {
  var t;
  let r = Number.MAX_SAFE_INTEGER, i = null, n = -1;
  for (let o = 0; o < e.length; ++o) {
    var a;
    const s = e[o], l = xG(s);
    l !== s.length && (i = (a = i) !== null && a !== void 0 ? a : o, n = o, o !== 0 && l < r && (r = l));
  }
  return e.map((o, s) => s === 0 ? o : o.slice(r)).slice(
    (t = i) !== null && t !== void 0 ? t : 0,
    n + 1
  );
}
function xG(e) {
  let t = 0;
  for (; t < e.length && l_(e.charCodeAt(t)); )
    ++t;
  return t;
}
function AG(e, t) {
  const r = e.replace(/"""/g, '\\"""'), i = r.split(/\r\n|[\n\r]/g), n = i.length === 1, a = i.length > 1 && i.slice(1).every((f) => f.length === 0 || l_(f.charCodeAt(0))), o = r.endsWith('\\"""'), s = e.endsWith('"') && !o, l = e.endsWith("\\"), u = s || l, d = !(t != null && t.minimize) && // add leading and trailing new lines only if it improves readability
  (!n || e.length > 70 || u || a || o);
  let c = "";
  const p = n && l_(e.charCodeAt(0));
  return (d && !p || a) && (c += `
`), c += r, (d || u) && (c += `
`), '"""' + c + '"""';
}
var Me;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(Me || (Me = {}));
class wG {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(t) {
    const r = new aw(Me.SOF, 0, 0, 0, 0);
    this.source = t, this.lastToken = r, this.token = r, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let t = this.token;
    if (t.kind !== Me.EOF)
      do
        if (t.next)
          t = t.next;
        else {
          const r = TG(this, t.end);
          t.next = r, r.prev = t, t = r;
        }
      while (t.kind === Me.COMMENT);
    return t;
  }
}
function FG(e) {
  return e === Me.BANG || e === Me.DOLLAR || e === Me.AMP || e === Me.PAREN_L || e === Me.PAREN_R || e === Me.SPREAD || e === Me.COLON || e === Me.EQUALS || e === Me.AT || e === Me.BRACKET_L || e === Me.BRACKET_R || e === Me.BRACE_L || e === Me.PIPE || e === Me.BRACE_R;
}
function dp(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function xm(e, t) {
  return uw(e.charCodeAt(t)) && cw(e.charCodeAt(t + 1));
}
function uw(e) {
  return e >= 55296 && e <= 56319;
}
function cw(e) {
  return e >= 56320 && e <= 57343;
}
function ac(e, t) {
  const r = e.source.body.codePointAt(t);
  if (r === void 0)
    return Me.EOF;
  if (r >= 32 && r <= 126) {
    const i = String.fromCodePoint(r);
    return i === '"' ? `'"'` : `"${i}"`;
  }
  return "U+" + r.toString(16).toUpperCase().padStart(4, "0");
}
function Ni(e, t, r, i, n) {
  const a = e.line, o = 1 + r - e.lineStart;
  return new aw(t, r, i, a, o, n);
}
function TG(e, t) {
  const r = e.source.body, i = r.length;
  let n = t;
  for (; n < i; ) {
    const a = r.charCodeAt(n);
    switch (a) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++n;
        continue;
      case 10:
        ++n, ++e.line, e.lineStart = n;
        continue;
      case 13:
        r.charCodeAt(n + 1) === 10 ? n += 2 : ++n, ++e.line, e.lineStart = n;
        continue;
      case 35:
        return SG(e, n);
      case 33:
        return Ni(e, Me.BANG, n, n + 1);
      case 36:
        return Ni(e, Me.DOLLAR, n, n + 1);
      case 38:
        return Ni(e, Me.AMP, n, n + 1);
      case 40:
        return Ni(e, Me.PAREN_L, n, n + 1);
      case 41:
        return Ni(e, Me.PAREN_R, n, n + 1);
      case 46:
        if (r.charCodeAt(n + 1) === 46 && r.charCodeAt(n + 2) === 46)
          return Ni(e, Me.SPREAD, n, n + 3);
        break;
      case 58:
        return Ni(e, Me.COLON, n, n + 1);
      case 61:
        return Ni(e, Me.EQUALS, n, n + 1);
      case 64:
        return Ni(e, Me.AT, n, n + 1);
      case 91:
        return Ni(e, Me.BRACKET_L, n, n + 1);
      case 93:
        return Ni(e, Me.BRACKET_R, n, n + 1);
      case 123:
        return Ni(e, Me.BRACE_L, n, n + 1);
      case 124:
        return Ni(e, Me.PIPE, n, n + 1);
      case 125:
        return Ni(e, Me.BRACE_R, n, n + 1);
      case 34:
        return r.charCodeAt(n + 1) === 34 && r.charCodeAt(n + 2) === 34 ? NG(e, n) : BG(e, n);
    }
    if (_1(a) || a === 45)
      return IG(e, n, a);
    if (lw(a))
      return zG(e, n);
    throw qi(
      e.source,
      n,
      a === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : dp(a) || xm(r, n) ? `Unexpected character: ${ac(e, n)}.` : `Invalid character: ${ac(e, n)}.`
    );
  }
  return Ni(e, Me.EOF, i, i);
}
function SG(e, t) {
  const r = e.source.body, i = r.length;
  let n = t + 1;
  for (; n < i; ) {
    const a = r.charCodeAt(n);
    if (a === 10 || a === 13)
      break;
    if (dp(a))
      ++n;
    else if (xm(r, n))
      n += 2;
    else
      break;
  }
  return Ni(
    e,
    Me.COMMENT,
    t,
    n,
    r.slice(t + 1, n)
  );
}
function IG(e, t, r) {
  const i = e.source.body;
  let n = t, a = r, o = !1;
  if (a === 45 && (a = i.charCodeAt(++n)), a === 48) {
    if (a = i.charCodeAt(++n), _1(a))
      throw qi(
        e.source,
        n,
        `Invalid number, unexpected digit after 0: ${ac(
          e,
          n
        )}.`
      );
  } else
    n = Bk(e, n, a), a = i.charCodeAt(n);
  if (a === 46 && (o = !0, a = i.charCodeAt(++n), n = Bk(e, n, a), a = i.charCodeAt(n)), (a === 69 || a === 101) && (o = !0, a = i.charCodeAt(++n), (a === 43 || a === 45) && (a = i.charCodeAt(++n)), n = Bk(e, n, a), a = i.charCodeAt(n)), a === 46 || lw(a))
    throw qi(
      e.source,
      n,
      `Invalid number, expected digit but got: ${ac(
        e,
        n
      )}.`
    );
  return Ni(
    e,
    o ? Me.FLOAT : Me.INT,
    t,
    n,
    i.slice(t, n)
  );
}
function Bk(e, t, r) {
  if (!_1(r))
    throw qi(
      e.source,
      t,
      `Invalid number, expected digit but got: ${ac(
        e,
        t
      )}.`
    );
  const i = e.source.body;
  let n = t + 1;
  for (; _1(i.charCodeAt(n)); )
    ++n;
  return n;
}
function BG(e, t) {
  const r = e.source.body, i = r.length;
  let n = t + 1, a = n, o = "";
  for (; n < i; ) {
    const s = r.charCodeAt(n);
    if (s === 34)
      return o += r.slice(a, n), Ni(e, Me.STRING, t, n + 1, o);
    if (s === 92) {
      o += r.slice(a, n);
      const l = r.charCodeAt(n + 1) === 117 ? r.charCodeAt(n + 2) === 123 ? RG(e, n) : OG(e, n) : PG(e, n);
      o += l.value, n += l.size, a = n;
      continue;
    }
    if (s === 10 || s === 13)
      break;
    if (dp(s))
      ++n;
    else if (xm(r, n))
      n += 2;
    else
      throw qi(
        e.source,
        n,
        `Invalid character within String: ${ac(
          e,
          n
        )}.`
      );
  }
  throw qi(e.source, n, "Unterminated string.");
}
function RG(e, t) {
  const r = e.source.body;
  let i = 0, n = 3;
  for (; n < 12; ) {
    const a = r.charCodeAt(t + n++);
    if (a === 125) {
      if (n < 5 || !dp(i))
        break;
      return {
        value: String.fromCodePoint(i),
        size: n
      };
    }
    if (i = i << 4 | $0(a), i < 0)
      break;
  }
  throw qi(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${r.slice(
      t,
      t + n
    )}".`
  );
}
function OG(e, t) {
  const r = e.source.body, i = _9(r, t + 2);
  if (dp(i))
    return {
      value: String.fromCodePoint(i),
      size: 6
    };
  if (uw(i) && r.charCodeAt(t + 6) === 92 && r.charCodeAt(t + 7) === 117) {
    const n = _9(r, t + 8);
    if (cw(n))
      return {
        value: String.fromCodePoint(i, n),
        size: 12
      };
  }
  throw qi(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${r.slice(t, t + 6)}".`
  );
}
function _9(e, t) {
  return $0(e.charCodeAt(t)) << 12 | $0(e.charCodeAt(t + 1)) << 8 | $0(e.charCodeAt(t + 2)) << 4 | $0(e.charCodeAt(t + 3));
}
function $0(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function PG(e, t) {
  const r = e.source.body;
  switch (r.charCodeAt(t + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw qi(
    e.source,
    t,
    `Invalid character escape sequence: "${r.slice(
      t,
      t + 2
    )}".`
  );
}
function NG(e, t) {
  const r = e.source.body, i = r.length;
  let n = e.lineStart, a = t + 3, o = a, s = "";
  const l = [];
  for (; a < i; ) {
    const u = r.charCodeAt(a);
    if (u === 34 && r.charCodeAt(a + 1) === 34 && r.charCodeAt(a + 2) === 34) {
      s += r.slice(o, a), l.push(s);
      const d = Ni(
        e,
        Me.BLOCK_STRING,
        t,
        a + 3,
        // Return a string of the lines joined with U+000A.
        CG(l).join(`
`)
      );
      return e.line += l.length - 1, e.lineStart = n, d;
    }
    if (u === 92 && r.charCodeAt(a + 1) === 34 && r.charCodeAt(a + 2) === 34 && r.charCodeAt(a + 3) === 34) {
      s += r.slice(o, a), o = a + 1, a += 4;
      continue;
    }
    if (u === 10 || u === 13) {
      s += r.slice(o, a), l.push(s), u === 13 && r.charCodeAt(a + 1) === 10 ? a += 2 : ++a, s = "", o = a, n = a;
      continue;
    }
    if (dp(u))
      ++a;
    else if (xm(r, a))
      a += 2;
    else
      throw qi(
        e.source,
        a,
        `Invalid character within String: ${ac(
          e,
          a
        )}.`
      );
  }
  throw qi(e.source, a, "Unterminated string.");
}
function zG(e, t) {
  const r = e.source.body, i = r.length;
  let n = t + 1;
  for (; n < i; ) {
    const a = r.charCodeAt(n);
    if (EG(a))
      ++n;
    else
      break;
  }
  return Ni(
    e,
    Me.NAME,
    t,
    n,
    r.slice(t, n)
  );
}
const LG = 10, dw = 2;
function J2(e) {
  return Am(e, []);
}
function Am(e, t) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return MG(e, t);
    default:
      return String(e);
  }
}
function MG(e, t) {
  if (e === null)
    return "null";
  if (t.includes(e))
    return "[Circular]";
  const r = [...t, e];
  if (jG(e)) {
    const i = e.toJSON();
    if (i !== e)
      return typeof i == "string" ? i : Am(i, r);
  } else if (Array.isArray(e))
    return $G(e, r);
  return HG(e, r);
}
function jG(e) {
  return typeof e.toJSON == "function";
}
function HG(e, t) {
  const r = Object.entries(e);
  return r.length === 0 ? "{}" : t.length > dw ? "[" + UG(e) + "]" : "{ " + r.map(
    ([n, a]) => n + ": " + Am(a, t)
  ).join(", ") + " }";
}
function $G(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > dw)
    return "[Array]";
  const r = Math.min(LG, e.length), i = e.length - r, n = [];
  for (let a = 0; a < r; ++a)
    n.push(Am(e[a], t));
  return i === 1 ? n.push("... 1 more item") : i > 1 && n.push(`... ${i} more items`), "[" + n.join(", ") + "]";
}
function UG(e) {
  const t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    const r = e.constructor.name;
    if (typeof r == "string" && r !== "")
      return r;
  }
  return t;
}
const VG = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function(t, r) {
    return t instanceof r;
  } : function(t, r) {
    if (t instanceof r)
      return !0;
    if (typeof t == "object" && t !== null) {
      var i;
      const n = r.prototype[Symbol.toStringTag], a = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in t ? t[Symbol.toStringTag] : (i = t.constructor) === null || i === void 0 ? void 0 : i.name
      );
      if (n === a) {
        const o = J2(t);
        throw new Error(`Cannot use ${n} "${o}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class pw {
  constructor(t, r = "GraphQL request", i = {
    line: 1,
    column: 1
  }) {
    typeof t == "string" || Wf(!1, `Body must be a string. Received: ${J2(t)}.`), this.body = t, this.name = r, this.locationOffset = i, this.locationOffset.line > 0 || Wf(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || Wf(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function WG(e) {
  return VG(e, pw);
}
function GG(e, t) {
  return new KG(e, t).parseDocument();
}
let KG = class {
  constructor(t, r = {}) {
    const i = WG(t) ? t : new pw(t);
    this._lexer = new wG(i), this._options = r, this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const t = this.expectToken(Me.NAME);
    return this.node(t, {
      kind: bt.NAME,
      value: t.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: bt.DOCUMENT,
      definitions: this.many(
        Me.SOF,
        this.parseDefinition,
        Me.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(Me.BRACE_L))
      return this.parseOperationDefinition();
    const t = this.peekDescription(), r = t ? this._lexer.lookahead() : this._lexer.token;
    if (r.kind === Me.NAME) {
      switch (r.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (t)
        throw qi(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (r.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(r);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const t = this._lexer.token;
    if (this.peek(Me.BRACE_L))
      return this.node(t, {
        kind: bt.OPERATION_DEFINITION,
        operation: Id.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const r = this.parseOperationType();
    let i;
    return this.peek(Me.NAME) && (i = this.parseName()), this.node(t, {
      kind: bt.OPERATION_DEFINITION,
      operation: r,
      name: i,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const t = this.expectToken(Me.NAME);
    switch (t.value) {
      case "query":
        return Id.QUERY;
      case "mutation":
        return Id.MUTATION;
      case "subscription":
        return Id.SUBSCRIPTION;
    }
    throw this.unexpected(t);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      Me.PAREN_L,
      this.parseVariableDefinition,
      Me.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: bt.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(Me.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(Me.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const t = this._lexer.token;
    return this.expectToken(Me.DOLLAR), this.node(t, {
      kind: bt.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: bt.SELECTION_SET,
      selections: this.many(
        Me.BRACE_L,
        this.parseSelection,
        Me.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(Me.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const t = this._lexer.token, r = this.parseName();
    let i, n;
    return this.expectOptionalToken(Me.COLON) ? (i = r, n = this.parseName()) : n = r, this.node(t, {
      kind: bt.FIELD,
      alias: i,
      name: n,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(Me.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(t) {
    const r = t ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(Me.PAREN_L, r, Me.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(t = !1) {
    const r = this._lexer.token, i = this.parseName();
    return this.expectToken(Me.COLON), this.node(r, {
      kind: bt.ARGUMENT,
      name: i,
      value: this.parseValueLiteral(t)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const t = this._lexer.token;
    this.expectToken(Me.SPREAD);
    const r = this.expectOptionalKeyword("on");
    return !r && this.peek(Me.NAME) ? this.node(t, {
      kind: bt.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(t, {
      kind: bt.INLINE_FRAGMENT,
      typeCondition: r ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const t = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(t, {
      kind: bt.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(t, {
      kind: bt.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(t) {
    const r = this._lexer.token;
    switch (r.kind) {
      case Me.BRACKET_L:
        return this.parseList(t);
      case Me.BRACE_L:
        return this.parseObject(t);
      case Me.INT:
        return this.advanceLexer(), this.node(r, {
          kind: bt.INT,
          value: r.value
        });
      case Me.FLOAT:
        return this.advanceLexer(), this.node(r, {
          kind: bt.FLOAT,
          value: r.value
        });
      case Me.STRING:
      case Me.BLOCK_STRING:
        return this.parseStringLiteral();
      case Me.NAME:
        switch (this.advanceLexer(), r.value) {
          case "true":
            return this.node(r, {
              kind: bt.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(r, {
              kind: bt.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(r, {
              kind: bt.NULL
            });
          default:
            return this.node(r, {
              kind: bt.ENUM,
              value: r.value
            });
        }
      case Me.DOLLAR:
        if (t)
          if (this.expectToken(Me.DOLLAR), this._lexer.token.kind === Me.NAME) {
            const i = this._lexer.token.value;
            throw qi(
              this._lexer.source,
              r.start,
              `Unexpected variable "$${i}" in constant value.`
            );
          } else
            throw this.unexpected(r);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const t = this._lexer.token;
    return this.advanceLexer(), this.node(t, {
      kind: bt.STRING,
      value: t.value,
      block: t.kind === Me.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(t) {
    const r = () => this.parseValueLiteral(t);
    return this.node(this._lexer.token, {
      kind: bt.LIST,
      values: this.any(Me.BRACKET_L, r, Me.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(t) {
    const r = () => this.parseObjectField(t);
    return this.node(this._lexer.token, {
      kind: bt.OBJECT,
      fields: this.any(Me.BRACE_L, r, Me.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(t) {
    const r = this._lexer.token, i = this.parseName();
    return this.expectToken(Me.COLON), this.node(r, {
      kind: bt.OBJECT_FIELD,
      name: i,
      value: this.parseValueLiteral(t)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(t) {
    const r = [];
    for (; this.peek(Me.AT); )
      r.push(this.parseDirective(t));
    return r;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(t) {
    const r = this._lexer.token;
    return this.expectToken(Me.AT), this.node(r, {
      kind: bt.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(t)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const t = this._lexer.token;
    let r;
    if (this.expectOptionalToken(Me.BRACKET_L)) {
      const i = this.parseTypeReference();
      this.expectToken(Me.BRACKET_R), r = this.node(t, {
        kind: bt.LIST_TYPE,
        type: i
      });
    } else
      r = this.parseNamedType();
    return this.expectOptionalToken(Me.BANG) ? this.node(t, {
      kind: bt.NON_NULL_TYPE,
      type: r
    }) : r;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: bt.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(Me.STRING) || this.peek(Me.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("schema");
    const i = this.parseConstDirectives(), n = this.many(
      Me.BRACE_L,
      this.parseOperationTypeDefinition,
      Me.BRACE_R
    );
    return this.node(t, {
      kind: bt.SCHEMA_DEFINITION,
      description: r,
      directives: i,
      operationTypes: n
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const t = this._lexer.token, r = this.parseOperationType();
    this.expectToken(Me.COLON);
    const i = this.parseNamedType();
    return this.node(t, {
      kind: bt.OPERATION_TYPE_DEFINITION,
      operation: r,
      type: i
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("scalar");
    const i = this.parseName(), n = this.parseConstDirectives();
    return this.node(t, {
      kind: bt.SCALAR_TYPE_DEFINITION,
      description: r,
      name: i,
      directives: n
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("type");
    const i = this.parseName(), n = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    return this.node(t, {
      kind: bt.OBJECT_TYPE_DEFINITION,
      description: r,
      name: i,
      interfaces: n,
      directives: a,
      fields: o
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(Me.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      Me.BRACE_L,
      this.parseFieldDefinition,
      Me.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const t = this._lexer.token, r = this.parseDescription(), i = this.parseName(), n = this.parseArgumentDefs();
    this.expectToken(Me.COLON);
    const a = this.parseTypeReference(), o = this.parseConstDirectives();
    return this.node(t, {
      kind: bt.FIELD_DEFINITION,
      description: r,
      name: i,
      arguments: n,
      type: a,
      directives: o
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      Me.PAREN_L,
      this.parseInputValueDef,
      Me.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const t = this._lexer.token, r = this.parseDescription(), i = this.parseName();
    this.expectToken(Me.COLON);
    const n = this.parseTypeReference();
    let a;
    this.expectOptionalToken(Me.EQUALS) && (a = this.parseConstValueLiteral());
    const o = this.parseConstDirectives();
    return this.node(t, {
      kind: bt.INPUT_VALUE_DEFINITION,
      description: r,
      name: i,
      type: n,
      defaultValue: a,
      directives: o
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("interface");
    const i = this.parseName(), n = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    return this.node(t, {
      kind: bt.INTERFACE_TYPE_DEFINITION,
      description: r,
      name: i,
      interfaces: n,
      directives: a,
      fields: o
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("union");
    const i = this.parseName(), n = this.parseConstDirectives(), a = this.parseUnionMemberTypes();
    return this.node(t, {
      kind: bt.UNION_TYPE_DEFINITION,
      description: r,
      name: i,
      directives: n,
      types: a
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(Me.EQUALS) ? this.delimitedMany(Me.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("enum");
    const i = this.parseName(), n = this.parseConstDirectives(), a = this.parseEnumValuesDefinition();
    return this.node(t, {
      kind: bt.ENUM_TYPE_DEFINITION,
      description: r,
      name: i,
      directives: n,
      values: a
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      Me.BRACE_L,
      this.parseEnumValueDefinition,
      Me.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const t = this._lexer.token, r = this.parseDescription(), i = this.parseEnumValueName(), n = this.parseConstDirectives();
    return this.node(t, {
      kind: bt.ENUM_VALUE_DEFINITION,
      description: r,
      name: i,
      directives: n
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw qi(
        this._lexer.source,
        this._lexer.token.start,
        `${gf(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("input");
    const i = this.parseName(), n = this.parseConstDirectives(), a = this.parseInputFieldsDefinition();
    return this.node(t, {
      kind: bt.INPUT_OBJECT_TYPE_DEFINITION,
      description: r,
      name: i,
      directives: n,
      fields: a
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      Me.BRACE_L,
      this.parseInputValueDef,
      Me.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const t = this._lexer.lookahead();
    if (t.kind === Me.NAME)
      switch (t.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(t);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const r = this.parseConstDirectives(), i = this.optionalMany(
      Me.BRACE_L,
      this.parseOperationTypeDefinition,
      Me.BRACE_R
    );
    if (r.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: bt.SCHEMA_EXTENSION,
      directives: r,
      operationTypes: i
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const r = this.parseName(), i = this.parseConstDirectives();
    if (i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: bt.SCALAR_TYPE_EXTENSION,
      name: r,
      directives: i
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const r = this.parseName(), i = this.parseImplementsInterfaces(), n = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (i.length === 0 && n.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: bt.OBJECT_TYPE_EXTENSION,
      name: r,
      interfaces: i,
      directives: n,
      fields: a
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const r = this.parseName(), i = this.parseImplementsInterfaces(), n = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (i.length === 0 && n.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: bt.INTERFACE_TYPE_EXTENSION,
      name: r,
      interfaces: i,
      directives: n,
      fields: a
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const r = this.parseName(), i = this.parseConstDirectives(), n = this.parseUnionMemberTypes();
    if (i.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: bt.UNION_TYPE_EXTENSION,
      name: r,
      directives: i,
      types: n
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const r = this.parseName(), i = this.parseConstDirectives(), n = this.parseEnumValuesDefinition();
    if (i.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: bt.ENUM_TYPE_EXTENSION,
      name: r,
      directives: i,
      values: n
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const r = this.parseName(), i = this.parseConstDirectives(), n = this.parseInputFieldsDefinition();
    if (i.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: bt.INPUT_OBJECT_TYPE_EXTENSION,
      name: r,
      directives: i,
      fields: n
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(Me.AT);
    const i = this.parseName(), n = this.parseArgumentDefs(), a = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const o = this.parseDirectiveLocations();
    return this.node(t, {
      kind: bt.DIRECTIVE_DEFINITION,
      description: r,
      name: i,
      arguments: n,
      repeatable: a,
      locations: o
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(Me.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const t = this._lexer.token, r = this.parseName();
    if (Object.prototype.hasOwnProperty.call(s_, r.value))
      return r;
    throw this.unexpected(t);
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(t, r) {
    return this._options.noLocation !== !0 && (r.loc = new DG(
      t,
      this._lexer.lastToken,
      this._lexer.source
    )), r;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(t) {
    return this._lexer.token.kind === t;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(t) {
    const r = this._lexer.token;
    if (r.kind === t)
      return this.advanceLexer(), r;
    throw qi(
      this._lexer.source,
      r.start,
      `Expected ${hw(t)}, found ${gf(r)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(t) {
    return this._lexer.token.kind === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(t) {
    const r = this._lexer.token;
    if (r.kind === Me.NAME && r.value === t)
      this.advanceLexer();
    else
      throw qi(
        this._lexer.source,
        r.start,
        `Expected "${t}", found ${gf(r)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(t) {
    const r = this._lexer.token;
    return r.kind === Me.NAME && r.value === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(t) {
    const r = t ?? this._lexer.token;
    return qi(
      this._lexer.source,
      r.start,
      `Unexpected ${gf(r)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(t, r, i) {
    this.expectToken(t);
    const n = [];
    for (; !this.expectOptionalToken(i); )
      n.push(r.call(this));
    return n;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(t, r, i) {
    if (this.expectOptionalToken(t)) {
      const n = [];
      do
        n.push(r.call(this));
      while (!this.expectOptionalToken(i));
      return n;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(t, r, i) {
    this.expectToken(t);
    const n = [];
    do
      n.push(r.call(this));
    while (!this.expectOptionalToken(i));
    return n;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(t, r) {
    this.expectOptionalToken(t);
    const i = [];
    do
      i.push(r.call(this));
    while (this.expectOptionalToken(t));
    return i;
  }
  advanceLexer() {
    const { maxTokens: t } = this._options, r = this._lexer.advance();
    if (t !== void 0 && r.kind !== Me.EOF && (++this._tokenCounter, this._tokenCounter > t))
      throw qi(
        this._lexer.source,
        r.start,
        `Document contains more that ${t} tokens. Parsing aborted.`
      );
  }
};
function gf(e) {
  const t = e.value;
  return hw(e.kind) + (t != null ? ` "${t}"` : "");
}
function hw(e) {
  return FG(e) ? `"${e}"` : e;
}
function YG(e) {
  return `"${e.replace(qG, QG)}"`;
}
const qG = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function QG(e) {
  return XG[e.charCodeAt(0)];
}
const XG = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], eD = Object.freeze({});
function Ms(e, t, r = ow) {
  const i = /* @__PURE__ */ new Map();
  for (const _ of Object.values(bt))
    i.set(_, ZG(t, _));
  let n, a = Array.isArray(e), o = [e], s = -1, l = [], u = e, d, c;
  const p = [], f = [];
  do {
    s++;
    const _ = s === o.length, A = _ && l.length !== 0;
    if (_) {
      if (d = f.length === 0 ? void 0 : p[p.length - 1], u = c, c = f.pop(), A)
        if (a) {
          u = u.slice();
          let N = 0;
          for (const [P, B] of l) {
            const M = P - N;
            B === null ? (u.splice(M, 1), N++) : u[M] = B;
          }
        } else {
          u = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(u)
          );
          for (const [N, P] of l)
            u[N] = P;
        }
      s = n.index, o = n.keys, l = n.edits, a = n.inArray, n = n.prev;
    } else if (c) {
      if (d = a ? s : o[s], u = c[d], u == null)
        continue;
      p.push(d);
    }
    let T;
    if (!Array.isArray(u)) {
      var g, k;
      b9(u) || Wf(!1, `Invalid AST Node: ${J2(u)}.`);
      const N = _ ? (g = i.get(u.kind)) === null || g === void 0 ? void 0 : g.leave : (k = i.get(u.kind)) === null || k === void 0 ? void 0 : k.enter;
      if (T = N == null ? void 0 : N.call(t, u, d, c, p, f), T === eD)
        break;
      if (T === !1) {
        if (!_) {
          p.pop();
          continue;
        }
      } else if (T !== void 0 && (l.push([d, T]), !_))
        if (b9(T))
          u = T;
        else {
          p.pop();
          continue;
        }
    }
    if (T === void 0 && A && l.push([d, u]), _)
      p.pop();
    else {
      var y;
      n = {
        inArray: a,
        index: s,
        keys: o,
        edits: l,
        prev: n
      }, a = Array.isArray(u), o = a ? u : (y = r[u.kind]) !== null && y !== void 0 ? y : [], s = -1, l = [], c && f.push(c), c = u;
    }
  } while (n !== void 0);
  return l.length !== 0 ? l[l.length - 1][1] : e;
}
function ZG(e, t) {
  const r = e[t];
  return typeof r == "object" ? r : typeof r == "function" ? {
    enter: r,
    leave: void 0
  } : {
    enter: e.enter,
    leave: e.leave
  };
}
function JG(e) {
  return Ms(e, tK);
}
const eK = 80, tK = {
  Name: {
    leave: (e) => e.value
  },
  Variable: {
    leave: (e) => "$" + e.name
  },
  // Document
  Document: {
    leave: (e) => _t(e.definitions, `

`)
  },
  OperationDefinition: {
    leave(e) {
      const t = ur("(", _t(e.variableDefinitions, ", "), ")"), r = _t(
        [
          e.operation,
          _t([e.name, t]),
          _t(e.directives, " ")
        ],
        " "
      );
      return (r === "query" ? "" : r + " ") + e.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: e, type: t, defaultValue: r, directives: i }) => e + ": " + t + ur(" = ", r) + ur(" ", _t(i, " "))
  },
  SelectionSet: {
    leave: ({ selections: e }) => lo(e)
  },
  Field: {
    leave({ alias: e, name: t, arguments: r, directives: i, selectionSet: n }) {
      const a = ur("", e, ": ") + t;
      let o = a + ur("(", _t(r, ", "), ")");
      return o.length > eK && (o = a + ur(`(
`, Gf(_t(r, `
`)), `
)`)), _t([o, _t(i, " "), n], " ");
    }
  },
  Argument: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: e, directives: t }) => "..." + e + ur(" ", _t(t, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: e, directives: t, selectionSet: r }) => _t(
      [
        "...",
        ur("on ", e),
        _t(t, " "),
        r
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: e, typeCondition: t, variableDefinitions: r, directives: i, selectionSet: n }) => (
      // or removed in the future.
      `fragment ${e}${ur("(", _t(r, ", "), ")")} on ${t} ${ur("", _t(i, " "), " ")}` + n
    )
  },
  // Value
  IntValue: {
    leave: ({ value: e }) => e
  },
  FloatValue: {
    leave: ({ value: e }) => e
  },
  StringValue: {
    leave: ({ value: e, block: t }) => t ? AG(e) : YG(e)
  },
  BooleanValue: {
    leave: ({ value: e }) => e ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: e }) => e
  },
  ListValue: {
    leave: ({ values: e }) => "[" + _t(e, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: e }) => "{" + _t(e, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Directive
  Directive: {
    leave: ({ name: e, arguments: t }) => "@" + e + ur("(", _t(t, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: e }) => e
  },
  ListType: {
    leave: ({ type: e }) => "[" + e + "]"
  },
  NonNullType: {
    leave: ({ type: e }) => e + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: e, directives: t, operationTypes: r }) => ur("", e, `
`) + _t(["schema", _t(t, " "), lo(r)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: e, type: t }) => e + ": " + t
  },
  ScalarTypeDefinition: {
    leave: ({ description: e, name: t, directives: r }) => ur("", e, `
`) + _t(["scalar", t, _t(r, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: r, directives: i, fields: n }) => ur("", e, `
`) + _t(
      [
        "type",
        t,
        ur("implements ", _t(r, " & ")),
        _t(i, " "),
        lo(n)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: e, name: t, arguments: r, type: i, directives: n }) => ur("", e, `
`) + t + (D9(r) ? ur(`(
`, Gf(_t(r, `
`)), `
)`) : ur("(", _t(r, ", "), ")")) + ": " + i + ur(" ", _t(n, " "))
  },
  InputValueDefinition: {
    leave: ({ description: e, name: t, type: r, defaultValue: i, directives: n }) => ur("", e, `
`) + _t(
      [t + ": " + r, ur("= ", i), _t(n, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: r, directives: i, fields: n }) => ur("", e, `
`) + _t(
      [
        "interface",
        t,
        ur("implements ", _t(r, " & ")),
        _t(i, " "),
        lo(n)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, types: i }) => ur("", e, `
`) + _t(
      ["union", t, _t(r, " "), ur("= ", _t(i, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, values: i }) => ur("", e, `
`) + _t(["enum", t, _t(r, " "), lo(i)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: e, name: t, directives: r }) => ur("", e, `
`) + _t([t, _t(r, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, fields: i }) => ur("", e, `
`) + _t(["input", t, _t(r, " "), lo(i)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: e, name: t, arguments: r, repeatable: i, locations: n }) => ur("", e, `
`) + "directive @" + t + (D9(r) ? ur(`(
`, Gf(_t(r, `
`)), `
)`) : ur("(", _t(r, ", "), ")")) + (i ? " repeatable" : "") + " on " + _t(n, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: e, operationTypes: t }) => _t(
      ["extend schema", _t(e, " "), lo(t)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: e, directives: t }) => _t(["extend scalar", e, _t(t, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: r, fields: i }) => _t(
      [
        "extend type",
        e,
        ur("implements ", _t(t, " & ")),
        _t(r, " "),
        lo(i)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: r, fields: i }) => _t(
      [
        "extend interface",
        e,
        ur("implements ", _t(t, " & ")),
        _t(r, " "),
        lo(i)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: e, directives: t, types: r }) => _t(
      [
        "extend union",
        e,
        _t(t, " "),
        ur("= ", _t(r, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: e, directives: t, values: r }) => _t(["extend enum", e, _t(t, " "), lo(r)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: e, directives: t, fields: r }) => _t(["extend input", e, _t(t, " "), lo(r)], " ")
  }
};
function _t(e, t = "") {
  var r;
  return (r = e == null ? void 0 : e.filter((i) => i).join(t)) !== null && r !== void 0 ? r : "";
}
function lo(e) {
  return ur(`{
`, Gf(_t(e, `
`)), `
}`);
}
function ur(e, t, r = "") {
  return t != null && t !== "" ? e + t + r : "";
}
function Gf(e) {
  return ur("  ", e.replace(/\n/g, `
  `));
}
function D9(e) {
  var t;
  return (t = e == null ? void 0 : e.some((r) => r.includes(`
`))) !== null && t !== void 0 ? t : !1;
}
function y9(e) {
  return e.kind === bt.FIELD || e.kind === bt.FRAGMENT_SPREAD || e.kind === bt.INLINE_FRAGMENT;
}
var Rk = "Invariant Violation", E9 = Object.setPrototypeOf, rK = E9 === void 0 ? function(e, t) {
  return e.__proto__ = t, e;
} : E9, fw = (
  /** @class */
  function(e) {
    Qa(t, e);
    function t(r) {
      r === void 0 && (r = Rk);
      var i = e.call(this, typeof r == "number" ? Rk + ": " + r + " (see https://github.com/apollographql/invariant-packages)" : r) || this;
      return i.framesToPop = 1, i.name = Rk, rK(i, t.prototype), i;
    }
    return t;
  }(Error)
);
function ju(e, t) {
  if (!e)
    throw new fw(t);
}
var gw = ["debug", "log", "warn", "error", "silent"], iK = gw.indexOf("log");
function mf(e) {
  return function() {
    if (gw.indexOf(e) >= iK) {
      var t = console[e] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(e) {
  e.debug = mf("debug"), e.log = mf("log"), e.warn = mf("warn"), e.error = mf("error");
})(ju || (ju = {}));
var tD = "3.8.8";
function go(e) {
  try {
    return e();
  } catch {
  }
}
const C9 = go(function() {
  return globalThis;
}) || go(function() {
  return window;
}) || go(function() {
  return self;
}) || go(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
go(function() {
  return go.constructor("return this")();
});
var x9 = /* @__PURE__ */ new Map();
function u_(e) {
  var t = x9.get(e) || 1;
  return x9.set(e, t + 1), "".concat(e, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function nK(e, t) {
  t === void 0 && (t = 0);
  var r = u_("stringifyForDisplay");
  return JSON.stringify(e, function(i, n) {
    return n === void 0 ? r : n;
  }, t).split(JSON.stringify(r)).join("<undefined>");
}
function vf(e) {
  return function(t) {
    for (var r = [], i = 1; i < arguments.length; i++)
      r[i - 1] = arguments[i];
    if (typeof t == "number") {
      var n = t;
      t = rD(n), t || (t = iD(n, r), r = []);
    }
    e.apply(void 0, [t].concat(r));
  };
}
var cr = Object.assign(function(t, r) {
  for (var i = [], n = 2; n < arguments.length; n++)
    i[n - 2] = arguments[n];
  t || ju(t, rD(r, i) || iD(r, i));
}, {
  debug: vf(ju.debug),
  log: vf(ju.log),
  warn: vf(ju.warn),
  error: vf(ju.error)
});
function aa(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return new fw(rD(e, t) || iD(e, t));
}
var A9 = Symbol.for("ApolloErrorMessageHandler_" + tD);
function mw(e) {
  return typeof e == "string" ? e : nK(e, 2).slice(0, 1e3);
}
function rD(e, t) {
  if (t === void 0 && (t = []), !!e)
    return C9[A9] && C9[A9](e, t.map(mw));
}
function iD(e, t) {
  if (t === void 0 && (t = []), !!e)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: tD,
      message: e,
      args: t.map(mw)
    })));
}
function V1(e, t) {
  var r = e.directives;
  return !r || !r.length ? !0 : sK(r).every(function(i) {
    var n = i.directive, a = i.ifArgument, o = !1;
    return a.value.kind === "Variable" ? (o = t && t[a.value.name.value], cr(o !== void 0, 66, n.name.value)) : o = a.value.value, n.name.value === "skip" ? !o : o;
  });
}
function D1(e, t, r) {
  var i = new Set(e), n = i.size;
  return Ms(t, {
    Directive: function(a) {
      if (i.delete(a.name.value) && (!r || !i.size))
        return eD;
    }
  }), r ? !i.size : i.size < n;
}
function aK(e) {
  return e && D1(["client", "export"], e, !0);
}
function oK(e) {
  var t = e.name.value;
  return t === "skip" || t === "include";
}
function sK(e) {
  var t = [];
  return e && e.length && e.forEach(function(r) {
    if (oK(r)) {
      var i = r.arguments, n = r.name.value;
      cr(i && i.length === 1, 67, n);
      var a = i[0];
      cr(a.name && a.name.value === "if", 68, n);
      var o = a.value;
      cr(o && (o.kind === "Variable" || o.kind === "BooleanValue"), 69, n), t.push({ directive: r, ifArgument: a });
    }
  }), t;
}
const lK = () => /* @__PURE__ */ Object.create(null), { forEach: uK, slice: w9 } = Array.prototype, { hasOwnProperty: cK } = Object.prototype;
let W1 = class vw {
  constructor(t = !0, r = lK) {
    this.weakness = t, this.makeData = r;
  }
  lookup() {
    return this.lookupArray(arguments);
  }
  lookupArray(t) {
    let r = this;
    return uK.call(t, (i) => r = r.getChildTrie(i)), cK.call(r, "data") ? r.data : r.data = this.makeData(w9.call(t));
  }
  peek() {
    return this.peekArray(arguments);
  }
  peekArray(t) {
    let r = this;
    for (let i = 0, n = t.length; r && i < n; ++i) {
      const a = r.mapFor(t[i], !1);
      r = a && a.get(t[i]);
    }
    return r && r.data;
  }
  remove() {
    return this.removeArray(arguments);
  }
  removeArray(t) {
    let r;
    if (t.length) {
      const i = t[0], n = this.mapFor(i, !1), a = n && n.get(i);
      a && (r = a.removeArray(w9.call(t, 1)), !a.data && !a.weak && !(a.strong && a.strong.size) && n.delete(i));
    } else
      r = this.data, delete this.data;
    return r;
  }
  getChildTrie(t) {
    const r = this.mapFor(t, !0);
    let i = r.get(t);
    return i || r.set(t, i = new vw(this.weakness, this.makeData)), i;
  }
  mapFor(t, r) {
    return this.weakness && dK(t) ? this.weak || (r ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (r ? this.strong = /* @__PURE__ */ new Map() : void 0);
  }
};
function dK(e) {
  switch (typeof e) {
    case "object":
      if (e === null)
        break;
    case "function":
      return !0;
  }
  return !1;
}
var us = typeof WeakMap == "function" && go(function() {
  return navigator.product;
}) !== "ReactNative", kw = typeof WeakSet == "function", nD = typeof Symbol == "function" && typeof Symbol.for == "function", wm = nD && Symbol.asyncIterator, pK = typeof go(function() {
  return window.document.createElement;
}) == "function", hK = (
  // Following advice found in this comment from @domenic (maintainer of jsdom):
  // https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
  //
  // Since we control the version of Jest and jsdom used when running Apollo
  // Client tests, and that version is recent enought to include " jsdom/x.y.z"
  // at the end of the user agent string, I believe this case is all we need to
  // check. Testing for "Node.js" was recommended for backwards compatibility
  // with older version of jsdom, but we don't have that problem.
  go(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
  }) || !1
), fK = pK && !hK;
function mi(e) {
  return e !== null && typeof e == "object";
}
function gK(e, t) {
  var r = t, i = [];
  e.definitions.forEach(function(a) {
    if (a.kind === "OperationDefinition")
      throw aa(
        70,
        a.operation,
        a.name ? " named '".concat(a.name.value, "'") : ""
      );
    a.kind === "FragmentDefinition" && i.push(a);
  }), typeof r > "u" && (cr(i.length === 1, 71, i.length), r = i[0].name.value);
  var n = ke(ke({}, e), { definitions: qo([
    {
      kind: "OperationDefinition",
      // OperationTypeNode is an enum
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: r
            }
          }
        ]
      }
    }
  ], e.definitions, !0) });
  return n;
}
function Fm(e) {
  e === void 0 && (e = []);
  var t = {};
  return e.forEach(function(r) {
    t[r.name.value] = r;
  }), t;
}
function Tm(e, t) {
  switch (e.kind) {
    case "InlineFragment":
      return e;
    case "FragmentSpread": {
      var r = e.name.value;
      if (typeof t == "function")
        return t(r);
      var i = t && t[r];
      return cr(i, 72, r), i || null;
    }
    default:
      return null;
  }
}
function jd(e) {
  return { __ref: String(e) };
}
function ui(e) {
  return !!(e && typeof e == "object" && typeof e.__ref == "string");
}
function mK(e) {
  return mi(e) && e.kind === "Document" && Array.isArray(e.definitions);
}
function vK(e) {
  return e.kind === "StringValue";
}
function kK(e) {
  return e.kind === "BooleanValue";
}
function bK(e) {
  return e.kind === "IntValue";
}
function _K(e) {
  return e.kind === "FloatValue";
}
function DK(e) {
  return e.kind === "Variable";
}
function yK(e) {
  return e.kind === "ObjectValue";
}
function EK(e) {
  return e.kind === "ListValue";
}
function CK(e) {
  return e.kind === "EnumValue";
}
function xK(e) {
  return e.kind === "NullValue";
}
function Qd(e, t, r, i) {
  if (bK(r) || _K(r))
    e[t.value] = Number(r.value);
  else if (kK(r) || vK(r))
    e[t.value] = r.value;
  else if (yK(r)) {
    var n = {};
    r.fields.map(function(o) {
      return Qd(n, o.name, o.value, i);
    }), e[t.value] = n;
  } else if (DK(r)) {
    var a = (i || {})[r.name.value];
    e[t.value] = a;
  } else if (EK(r))
    e[t.value] = r.values.map(function(o) {
      var s = {};
      return Qd(s, t, o, i), s[t.value];
    });
  else if (CK(r))
    e[t.value] = r.value;
  else if (xK(r))
    e[t.value] = null;
  else
    throw aa(81, t.value, r.kind);
}
function AK(e, t) {
  var r = null;
  e.directives && (r = {}, e.directives.forEach(function(n) {
    r[n.name.value] = {}, n.arguments && n.arguments.forEach(function(a) {
      var o = a.name, s = a.value;
      return Qd(r[n.name.value], o, s, t);
    });
  }));
  var i = null;
  return e.arguments && e.arguments.length && (i = {}, e.arguments.forEach(function(n) {
    var a = n.name, o = n.value;
    return Qd(i, a, o, t);
  })), aD(e.name.value, i, r);
}
var wK = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], aD = Object.assign(function(e, t, r) {
  if (t && r && r.connection && r.connection.key)
    if (r.connection.filter && r.connection.filter.length > 0) {
      var i = r.connection.filter ? r.connection.filter : [];
      i.sort();
      var n = {};
      return i.forEach(function(s) {
        n[s] = t[s];
      }), "".concat(r.connection.key, "(").concat(E0(n), ")");
    } else
      return r.connection.key;
  var a = e;
  if (t) {
    var o = E0(t);
    a += "(".concat(o, ")");
  }
  return r && Object.keys(r).forEach(function(s) {
    wK.indexOf(s) === -1 && (r[s] && Object.keys(r[s]).length ? a += "@".concat(s, "(").concat(E0(r[s]), ")") : a += "@".concat(s));
  }), a;
}, {
  setStringify: function(e) {
    var t = E0;
    return E0 = e, t;
  }
}), E0 = function(t) {
  return JSON.stringify(t, FK);
};
function FK(e, t) {
  return mi(t) && !Array.isArray(t) && (t = Object.keys(t).sort().reduce(function(r, i) {
    return r[i] = t[i], r;
  }, {})), t;
}
function Sm(e, t) {
  if (e.arguments && e.arguments.length) {
    var r = {};
    return e.arguments.forEach(function(i) {
      var n = i.name, a = i.value;
      return Qd(r, n, a, t);
    }), r;
  }
  return null;
}
function oc(e) {
  return e.alias ? e.alias.value : e.name.value;
}
function c_(e, t, r) {
  for (var i, n = 0, a = t.selections; n < a.length; n++) {
    var o = a[n];
    if (Ll(o)) {
      if (o.name.value === "__typename")
        return e[oc(o)];
    } else
      i ? i.push(o) : i = [o];
  }
  if (typeof e.__typename == "string")
    return e.__typename;
  if (i)
    for (var s = 0, l = i; s < l.length; s++) {
      var o = l[s], u = c_(e, Tm(o, r).selectionSet, r);
      if (typeof u == "string")
        return u;
    }
}
function Ll(e) {
  return e.kind === "Field";
}
function TK(e) {
  return e.kind === "InlineFragment";
}
function G1(e) {
  cr(e && e.kind === "Document", 73);
  var t = e.definitions.filter(function(r) {
    return r.kind !== "FragmentDefinition";
  }).map(function(r) {
    if (r.kind !== "OperationDefinition")
      throw aa(74, r.kind);
    return r;
  });
  return cr(t.length <= 1, 75, t.length), e;
}
function K1(e) {
  return G1(e), e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition";
  })[0];
}
function d_(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && !!t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
function Im(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "FragmentDefinition";
  });
}
function SK(e) {
  var t = K1(e);
  return cr(t && t.operation === "query", 76), t;
}
function IK(e) {
  cr(e.kind === "Document", 77), cr(e.definitions.length <= 1, 78);
  var t = e.definitions[0];
  return cr(t.kind === "FragmentDefinition", 79), t;
}
function sc(e) {
  G1(e);
  for (var t, r = 0, i = e.definitions; r < i.length; r++) {
    var n = i[r];
    if (n.kind === "OperationDefinition") {
      var a = n.operation;
      if (a === "query" || a === "mutation" || a === "subscription")
        return n;
    }
    n.kind === "FragmentDefinition" && !t && (t = n);
  }
  if (t)
    return t;
  throw aa(80);
}
function oD(e) {
  var t = /* @__PURE__ */ Object.create(null), r = e && e.variableDefinitions;
  return r && r.length && r.forEach(function(i) {
    i.defaultValue && Qd(t, i.variable.name, i.defaultValue);
  }), t;
}
function BK(e) {
  return e;
}
var bw = (
  /** @class */
  function() {
    function e(t, r) {
      r === void 0 && (r = /* @__PURE__ */ Object.create(null)), this.resultCache = kw ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = t, r.getCacheKey && (this.getCacheKey = r.getCacheKey), r.cache !== !1 && (this.stableCacheKeys = new W1(us, function(i) {
        return { key: i };
      }));
    }
    return e.prototype.getCacheKey = function(t) {
      return [t];
    }, e.identity = function() {
      return new e(BK, { cache: !1 });
    }, e.split = function(t, r, i) {
      return i === void 0 && (i = e.identity()), new e(
        function(n) {
          var a = t(n) ? r : i;
          return a.transformDocument(n);
        },
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: !1 }
      );
    }, e.prototype.transformDocument = function(t) {
      if (this.resultCache.has(t))
        return t;
      var r = this.getStableCacheEntry(t);
      if (r && r.value)
        return r.value;
      G1(t);
      var i = this.transform(t);
      return this.resultCache.add(i), r && (r.value = i), i;
    }, e.prototype.concat = function(t) {
      var r = this;
      return new e(
        function(i) {
          return t.transformDocument(r.transformDocument(i));
        },
        // Reasonably assume both transforms handle their own caching
        { cache: !1 }
      );
    }, e.prototype.getStableCacheEntry = function(t) {
      if (this.stableCacheKeys) {
        var r = this.getCacheKey(t);
        if (r)
          return cr(Array.isArray(r), 65), this.stableCacheKeys.lookupArray(r);
      }
    }, e;
  }()
), md = us ? /* @__PURE__ */ new WeakMap() : void 0, sD = function(e) {
  var t;
  return t = md == null ? void 0 : md.get(e), t || (t = JG(e), md == null || md.set(e, t)), t;
}, Mi = Array.isArray;
function Ya(e) {
  return Array.isArray(e) && e.length > 0;
}
var F9 = {
  kind: bt.FIELD,
  name: {
    kind: bt.NAME,
    value: "__typename"
  }
};
function _w(e, t) {
  return !e || e.selectionSet.selections.every(function(r) {
    return r.kind === bt.FRAGMENT_SPREAD && _w(t[r.name.value], t);
  });
}
function RK(e) {
  return _w(K1(e) || IK(e), Fm(Im(e))) ? null : e;
}
function OK(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  return e.forEach(function(i) {
    i && (i.name ? t.set(i.name, i) : i.test && r.set(i.test, i));
  }), function(i) {
    var n = t.get(i.name.value);
    return !n && r.size && r.forEach(function(a, o) {
      o(i) && (n = a);
    }), n;
  };
}
function T9(e) {
  var t = /* @__PURE__ */ new Map();
  return function(i) {
    i === void 0 && (i = e);
    var n = t.get(i);
    return n || t.set(i, n = {
      // Variable and fragment spread names used directly within this
      // operation or fragment definition, as identified by key. These sets
      // will be populated during the first traversal of the document in
      // removeDirectivesFromDocument below.
      variables: /* @__PURE__ */ new Set(),
      fragmentSpreads: /* @__PURE__ */ new Set()
    }), n;
  };
}
function Dw(e, t) {
  G1(t);
  for (var r = T9(""), i = T9(""), n = function(_) {
    for (var A = 0, T = void 0; A < _.length && (T = _[A]); ++A)
      if (!Mi(T)) {
        if (T.kind === bt.OPERATION_DEFINITION)
          return r(T.name && T.name.value);
        if (T.kind === bt.FRAGMENT_DEFINITION)
          return i(T.name.value);
      }
    return null;
  }, a = 0, o = t.definitions.length - 1; o >= 0; --o)
    t.definitions[o].kind === bt.OPERATION_DEFINITION && ++a;
  var s = OK(e), l = function(_) {
    return Ya(_) && _.map(s).some(function(A) {
      return A && A.remove;
    });
  }, u = /* @__PURE__ */ new Map(), d = !1, c = {
    enter: function(_) {
      if (l(_.directives))
        return d = !0, null;
    }
  }, p = Ms(t, {
    // These two AST node types share the same implementation, defined above.
    Field: c,
    InlineFragment: c,
    VariableDefinition: {
      enter: function() {
        return !1;
      }
    },
    Variable: {
      enter: function(_, A, T, N, P) {
        var B = n(P);
        B && B.variables.add(_.name.value);
      }
    },
    FragmentSpread: {
      enter: function(_, A, T, N, P) {
        if (l(_.directives))
          return d = !0, null;
        var B = n(P);
        B && B.fragmentSpreads.add(_.name.value);
      }
    },
    FragmentDefinition: {
      enter: function(_, A, T, N) {
        u.set(JSON.stringify(N), _);
      },
      leave: function(_, A, T, N) {
        var P = u.get(JSON.stringify(N));
        if (_ === P)
          return _;
        if (
          // This logic applies only if the document contains one or more
          // operations, since removing all fragments from a document containing
          // only fragments makes the document useless.
          a > 0 && _.selectionSet.selections.every(function(B) {
            return B.kind === bt.FIELD && B.name.value === "__typename";
          })
        )
          return i(_.name.value).removed = !0, d = !0, null;
      }
    },
    Directive: {
      leave: function(_) {
        if (s(_))
          return d = !0, null;
      }
    }
  });
  if (!d)
    return t;
  var f = function(_) {
    return _.transitiveVars || (_.transitiveVars = new Set(_.variables), _.removed || _.fragmentSpreads.forEach(function(A) {
      f(i(A)).transitiveVars.forEach(function(T) {
        _.transitiveVars.add(T);
      });
    })), _;
  }, g = /* @__PURE__ */ new Set();
  p.definitions.forEach(function(_) {
    _.kind === bt.OPERATION_DEFINITION ? f(r(_.name && _.name.value)).fragmentSpreads.forEach(function(A) {
      g.add(A);
    }) : _.kind === bt.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
    // definitions count as usages of their own fragment names. This heuristic
    // prevents accidentally removing all fragment definitions from the
    // document just because it contains no operations that use the fragments.
    a === 0 && !i(_.name.value).removed && g.add(_.name.value);
  }), g.forEach(function(_) {
    f(i(_)).fragmentSpreads.forEach(function(A) {
      g.add(A);
    });
  });
  var k = function(_) {
    return !!// A fragment definition will be removed if there are no spreads that refer
    // to it, or the fragment was explicitly removed because it had no fields
    // other than __typename.
    (!g.has(_) || i(_).removed);
  }, y = {
    enter: function(_) {
      if (k(_.name.value))
        return null;
    }
  };
  return RK(Ms(p, {
    // If the fragment is going to be removed, then leaving any dangling
    // FragmentSpread nodes with the same name would be a mistake.
    FragmentSpread: y,
    // This is where the fragment definition is actually removed.
    FragmentDefinition: y,
    OperationDefinition: {
      leave: function(_) {
        if (_.variableDefinitions) {
          var A = f(
            // If an operation is anonymous, we use the empty string as its key.
            r(_.name && _.name.value)
          ).transitiveVars;
          if (A.size < _.variableDefinitions.length)
            return ke(ke({}, _), { variableDefinitions: _.variableDefinitions.filter(function(T) {
              return A.has(T.variable.name.value);
            }) });
        }
      }
    }
  }));
}
var yw = Object.assign(function(e) {
  return Ms(e, {
    SelectionSet: {
      enter: function(t, r, i) {
        if (!(i && i.kind === bt.OPERATION_DEFINITION)) {
          var n = t.selections;
          if (n) {
            var a = n.some(function(s) {
              return Ll(s) && (s.name.value === "__typename" || s.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!a) {
              var o = i;
              if (!(Ll(o) && o.directives && o.directives.some(function(s) {
                return s.name.value === "export";
              })))
                return ke(ke({}, t), { selections: qo(qo([], n, !0), [F9], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(e) {
    return e === F9;
  }
});
function PK(e) {
  var t = sc(e), r = t.operation;
  if (r === "query")
    return e;
  var i = Ms(e, {
    OperationDefinition: {
      enter: function(n) {
        return ke(ke({}, n), { operation: "query" });
      }
    }
  });
  return i;
}
function Ew(e) {
  G1(e);
  var t = Dw([
    {
      test: function(r) {
        return r.name.value === "client";
      },
      remove: !0
    }
  ], e);
  return t;
}
var NK = Object.prototype.hasOwnProperty;
function S9() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return lD(e);
}
function lD(e) {
  var t = e[0] || {}, r = e.length;
  if (r > 1)
    for (var i = new Ml(), n = 1; n < r; ++n)
      t = i.merge(t, e[n]);
  return t;
}
var zK = function(e, t, r) {
  return this.merge(e[r], t[r]);
}, Ml = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = zK), this.reconciler = t, this.isObject = mi, this.pastCopies = /* @__PURE__ */ new Set();
    }
    return e.prototype.merge = function(t, r) {
      for (var i = this, n = [], a = 2; a < arguments.length; a++)
        n[a - 2] = arguments[a];
      return mi(r) && mi(t) ? (Object.keys(r).forEach(function(o) {
        if (NK.call(t, o)) {
          var s = t[o];
          if (r[o] !== s) {
            var l = i.reconciler.apply(i, qo([
              t,
              r,
              o
            ], n, !1));
            l !== s && (t = i.shallowCopyForMerge(t), t[o] = l);
          }
        } else
          t = i.shallowCopyForMerge(t), t[o] = r[o];
      }), t) : r;
    }, e.prototype.shallowCopyForMerge = function(t) {
      return mi(t) && (this.pastCopies.has(t) || (Array.isArray(t) ? t = t.slice(0) : t = ke({ __proto__: Object.getPrototypeOf(t) }, t), this.pastCopies.add(t))), t;
    }, e;
  }()
);
function LK(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r)
    return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = MK(e)) || t && e && typeof e.length == "number") {
    r && (e = r);
    var i = 0;
    return function() {
      return i >= e.length ? { done: !0 } : { done: !1, value: e[i++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function MK(e, t) {
  if (e) {
    if (typeof e == "string")
      return I9(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return I9(e, t);
  }
}
function I9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, i = new Array(t); r < t; r++)
    i[r] = e[r];
  return i;
}
function B9(e, t) {
  for (var r = 0; r < t.length; r++) {
    var i = t[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function uD(e, t, r) {
  return t && B9(e.prototype, t), r && B9(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var cD = function() {
  return typeof Symbol == "function";
}, dD = function(e) {
  return cD() && !!Symbol[e];
}, pD = function(e) {
  return dD(e) ? Symbol[e] : "@@" + e;
};
cD() && !dD("observable") && (Symbol.observable = Symbol("observable"));
var jK = pD("iterator"), p_ = pD("observable"), Cw = pD("species");
function zg(e, t) {
  var r = e[t];
  if (r != null) {
    if (typeof r != "function")
      throw new TypeError(r + " is not a function");
    return r;
  }
}
function C0(e) {
  var t = e.constructor;
  return t !== void 0 && (t = t[Cw], t === null && (t = void 0)), t !== void 0 ? t : Yr;
}
function HK(e) {
  return e instanceof Yr;
}
function Xd(e) {
  Xd.log ? Xd.log(e) : setTimeout(function() {
    throw e;
  });
}
function Kf(e) {
  Promise.resolve().then(function() {
    try {
      e();
    } catch (t) {
      Xd(t);
    }
  });
}
function xw(e) {
  var t = e._cleanup;
  if (t !== void 0 && (e._cleanup = void 0, !!t))
    try {
      if (typeof t == "function")
        t();
      else {
        var r = zg(t, "unsubscribe");
        r && r.call(t);
      }
    } catch (i) {
      Xd(i);
    }
}
function h_(e) {
  e._observer = void 0, e._queue = void 0, e._state = "closed";
}
function $K(e) {
  var t = e._queue;
  if (t) {
    e._queue = void 0, e._state = "ready";
    for (var r = 0; r < t.length && (Aw(e, t[r].type, t[r].value), e._state !== "closed"); ++r)
      ;
  }
}
function Aw(e, t, r) {
  e._state = "running";
  var i = e._observer;
  try {
    var n = zg(i, t);
    switch (t) {
      case "next":
        n && n.call(i, r);
        break;
      case "error":
        if (h_(e), n)
          n.call(i, r);
        else
          throw r;
        break;
      case "complete":
        h_(e), n && n.call(i);
        break;
    }
  } catch (a) {
    Xd(a);
  }
  e._state === "closed" ? xw(e) : e._state === "running" && (e._state = "ready");
}
function Ok(e, t, r) {
  if (e._state !== "closed") {
    if (e._state === "buffering") {
      e._queue.push({
        type: t,
        value: r
      });
      return;
    }
    if (e._state !== "ready") {
      e._state = "buffering", e._queue = [{
        type: t,
        value: r
      }], Kf(function() {
        return $K(e);
      });
      return;
    }
    Aw(e, t, r);
  }
}
var UK = /* @__PURE__ */ function() {
  function e(r, i) {
    this._cleanup = void 0, this._observer = r, this._queue = void 0, this._state = "initializing";
    var n = new VK(this);
    try {
      this._cleanup = i.call(void 0, n);
    } catch (a) {
      n.error(a);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var t = e.prototype;
  return t.unsubscribe = function() {
    this._state !== "closed" && (h_(this), xw(this));
  }, uD(e, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), e;
}(), VK = /* @__PURE__ */ function() {
  function e(r) {
    this._subscription = r;
  }
  var t = e.prototype;
  return t.next = function(i) {
    Ok(this._subscription, "next", i);
  }, t.error = function(i) {
    Ok(this._subscription, "error", i);
  }, t.complete = function() {
    Ok(this._subscription, "complete");
  }, uD(e, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), e;
}(), Yr = /* @__PURE__ */ function() {
  function e(r) {
    if (!(this instanceof e))
      throw new TypeError("Observable cannot be called as a function");
    if (typeof r != "function")
      throw new TypeError("Observable initializer must be a function");
    this._subscriber = r;
  }
  var t = e.prototype;
  return t.subscribe = function(i) {
    return (typeof i != "object" || i === null) && (i = {
      next: i,
      error: arguments[1],
      complete: arguments[2]
    }), new UK(i, this._subscriber);
  }, t.forEach = function(i) {
    var n = this;
    return new Promise(function(a, o) {
      if (typeof i != "function") {
        o(new TypeError(i + " is not a function"));
        return;
      }
      function s() {
        l.unsubscribe(), a();
      }
      var l = n.subscribe({
        next: function(u) {
          try {
            i(u, s);
          } catch (d) {
            o(d), l.unsubscribe();
          }
        },
        error: o,
        complete: a
      });
    });
  }, t.map = function(i) {
    var n = this;
    if (typeof i != "function")
      throw new TypeError(i + " is not a function");
    var a = C0(this);
    return new a(function(o) {
      return n.subscribe({
        next: function(s) {
          try {
            s = i(s);
          } catch (l) {
            return o.error(l);
          }
          o.next(s);
        },
        error: function(s) {
          o.error(s);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, t.filter = function(i) {
    var n = this;
    if (typeof i != "function")
      throw new TypeError(i + " is not a function");
    var a = C0(this);
    return new a(function(o) {
      return n.subscribe({
        next: function(s) {
          try {
            if (!i(s))
              return;
          } catch (l) {
            return o.error(l);
          }
          o.next(s);
        },
        error: function(s) {
          o.error(s);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, t.reduce = function(i) {
    var n = this;
    if (typeof i != "function")
      throw new TypeError(i + " is not a function");
    var a = C0(this), o = arguments.length > 1, s = !1, l = arguments[1], u = l;
    return new a(function(d) {
      return n.subscribe({
        next: function(c) {
          var p = !s;
          if (s = !0, !p || o)
            try {
              u = i(u, c);
            } catch (f) {
              return d.error(f);
            }
          else
            u = c;
        },
        error: function(c) {
          d.error(c);
        },
        complete: function() {
          if (!s && !o)
            return d.error(new TypeError("Cannot reduce an empty sequence"));
          d.next(u), d.complete();
        }
      });
    });
  }, t.concat = function() {
    for (var i = this, n = arguments.length, a = new Array(n), o = 0; o < n; o++)
      a[o] = arguments[o];
    var s = C0(this);
    return new s(function(l) {
      var u, d = 0;
      function c(p) {
        u = p.subscribe({
          next: function(f) {
            l.next(f);
          },
          error: function(f) {
            l.error(f);
          },
          complete: function() {
            d === a.length ? (u = void 0, l.complete()) : c(s.from(a[d++]));
          }
        });
      }
      return c(i), function() {
        u && (u.unsubscribe(), u = void 0);
      };
    });
  }, t.flatMap = function(i) {
    var n = this;
    if (typeof i != "function")
      throw new TypeError(i + " is not a function");
    var a = C0(this);
    return new a(function(o) {
      var s = [], l = n.subscribe({
        next: function(d) {
          if (i)
            try {
              d = i(d);
            } catch (p) {
              return o.error(p);
            }
          var c = a.from(d).subscribe({
            next: function(p) {
              o.next(p);
            },
            error: function(p) {
              o.error(p);
            },
            complete: function() {
              var p = s.indexOf(c);
              p >= 0 && s.splice(p, 1), u();
            }
          });
          s.push(c);
        },
        error: function(d) {
          o.error(d);
        },
        complete: function() {
          u();
        }
      });
      function u() {
        l.closed && s.length === 0 && o.complete();
      }
      return function() {
        s.forEach(function(d) {
          return d.unsubscribe();
        }), l.unsubscribe();
      };
    });
  }, t[p_] = function() {
    return this;
  }, e.from = function(i) {
    var n = typeof this == "function" ? this : e;
    if (i == null)
      throw new TypeError(i + " is not an object");
    var a = zg(i, p_);
    if (a) {
      var o = a.call(i);
      if (Object(o) !== o)
        throw new TypeError(o + " is not an object");
      return HK(o) && o.constructor === n ? o : new n(function(s) {
        return o.subscribe(s);
      });
    }
    if (dD("iterator") && (a = zg(i, jK), a))
      return new n(function(s) {
        Kf(function() {
          if (!s.closed) {
            for (var l = LK(a.call(i)), u; !(u = l()).done; ) {
              var d = u.value;
              if (s.next(d), s.closed)
                return;
            }
            s.complete();
          }
        });
      });
    if (Array.isArray(i))
      return new n(function(s) {
        Kf(function() {
          if (!s.closed) {
            for (var l = 0; l < i.length; ++l)
              if (s.next(i[l]), s.closed)
                return;
            s.complete();
          }
        });
      });
    throw new TypeError(i + " is not observable");
  }, e.of = function() {
    for (var i = arguments.length, n = new Array(i), a = 0; a < i; a++)
      n[a] = arguments[a];
    var o = typeof this == "function" ? this : e;
    return new o(function(s) {
      Kf(function() {
        if (!s.closed) {
          for (var l = 0; l < n.length; ++l)
            if (s.next(n[l]), s.closed)
              return;
          s.complete();
        }
      });
    });
  }, uD(e, null, [{
    key: Cw,
    get: function() {
      return this;
    }
  }]), e;
}();
cD() && Object.defineProperty(Yr, Symbol("extensions"), {
  value: {
    symbol: p_,
    hostReportError: Xd
  },
  configurable: !0
});
function WK(e) {
  var t, r = e.Symbol;
  if (typeof r == "function")
    if (r.observable)
      t = r.observable;
    else {
      typeof r.for == "function" ? t = r.for("https://github.com/benlesh/symbol-observable") : t = r("https://github.com/benlesh/symbol-observable");
      try {
        r.observable = t;
      } catch {
      }
    }
  else
    t = "@@observable";
  return t;
}
var xd;
typeof self < "u" ? xd = self : typeof window < "u" ? xd = window : typeof global < "u" ? xd = global : typeof module < "u" ? xd = module : xd = Function("return this")();
WK(xd);
var R9 = Yr.prototype, O9 = "@@observable";
R9[O9] || (R9[O9] = function() {
  return this;
});
var GK = Object.prototype.toString;
function KK(e) {
  return f_(e);
}
function f_(e, t) {
  switch (GK.call(e)) {
    case "[object Array]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var r = e.slice(0);
      return t.set(e, r), r.forEach(function(n, a) {
        r[a] = f_(n, t);
      }), r;
    }
    case "[object Object]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var i = Object.create(Object.getPrototypeOf(e));
      return t.set(e, i), Object.keys(e).forEach(function(n) {
        i[n] = f_(e[n], t);
      }), i;
    }
    default:
      return e;
  }
}
function q0(e, t, r) {
  var i = [];
  e.forEach(function(n) {
    return n[t] && i.push(n);
  }), i.forEach(function(n) {
    return n[t](r);
  });
}
function Pk(e, t, r) {
  return new Yr(function(i) {
    var n = {
      // Normally we would initialize promiseQueue to Promise.resolve(), but
      // in this case, for backwards compatibility, we need to be careful to
      // invoke the first callback synchronously.
      then: function(l) {
        return new Promise(function(u) {
          return u(l());
        });
      }
    };
    function a(l, u) {
      return function(d) {
        if (l) {
          var c = function() {
            return i.closed ? (
              /* will be swallowed */
              0
            ) : l(d);
          };
          n = n.then(c, c).then(function(p) {
            return i.next(p);
          }, function(p) {
            return i.error(p);
          });
        } else
          i[u](d);
      };
    }
    var o = {
      next: a(t, "next"),
      error: a(r, "error"),
      complete: function() {
        n.then(function() {
          return i.complete();
        });
      }
    }, s = e.subscribe(o);
    return function() {
      return s.unsubscribe();
    };
  });
}
function ww(e) {
  function t(r) {
    Object.defineProperty(e, r, { value: Yr });
  }
  return nD && Symbol.species && t(Symbol.species), t("@@species"), e;
}
function P9(e) {
  return e && typeof e.then == "function";
}
var Ad = (
  /** @class */
  function(e) {
    Qa(t, e);
    function t(r) {
      var i = e.call(this, function(n) {
        return i.addObserver(n), function() {
          return i.removeObserver(n);
        };
      }) || this;
      return i.observers = /* @__PURE__ */ new Set(), i.promise = new Promise(function(n, a) {
        i.resolve = n, i.reject = a;
      }), i.handlers = {
        next: function(n) {
          i.sub !== null && (i.latest = ["next", n], i.notify("next", n), q0(i.observers, "next", n));
        },
        error: function(n) {
          var a = i.sub;
          a !== null && (a && setTimeout(function() {
            return a.unsubscribe();
          }), i.sub = null, i.latest = ["error", n], i.reject(n), i.notify("error", n), q0(i.observers, "error", n));
        },
        complete: function() {
          var n = i, a = n.sub, o = n.sources, s = o === void 0 ? [] : o;
          if (a !== null) {
            var l = s.shift();
            l ? P9(l) ? l.then(function(u) {
              return i.sub = u.subscribe(i.handlers);
            }) : i.sub = l.subscribe(i.handlers) : (a && setTimeout(function() {
              return a.unsubscribe();
            }), i.sub = null, i.latest && i.latest[0] === "next" ? i.resolve(i.latest[1]) : i.resolve(), i.notify("complete"), q0(i.observers, "complete"));
          }
        }
      }, i.nextResultListeners = /* @__PURE__ */ new Set(), i.cancel = function(n) {
        i.reject(n), i.sources = [], i.handlers.complete();
      }, i.promise.catch(function(n) {
      }), typeof r == "function" && (r = [new Yr(r)]), P9(r) ? r.then(function(n) {
        return i.start(n);
      }, i.handlers.error) : i.start(r), i;
    }
    return t.prototype.start = function(r) {
      this.sub === void 0 && (this.sources = Array.from(r), this.handlers.complete());
    }, t.prototype.deliverLastMessage = function(r) {
      if (this.latest) {
        var i = this.latest[0], n = r[i];
        n && n.call(r, this.latest[1]), this.sub === null && i === "next" && r.complete && r.complete();
      }
    }, t.prototype.addObserver = function(r) {
      this.observers.has(r) || (this.deliverLastMessage(r), this.observers.add(r));
    }, t.prototype.removeObserver = function(r) {
      this.observers.delete(r) && this.observers.size < 1 && this.handlers.complete();
    }, t.prototype.notify = function(r, i) {
      var n = this.nextResultListeners;
      n.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), n.forEach(function(a) {
        return a(r, i);
      }));
    }, t.prototype.beforeNext = function(r) {
      var i = !1;
      this.nextResultListeners.add(function(n, a) {
        i || (i = !0, r(n, a));
      });
    }, t;
  }(Yr)
);
ww(Ad);
function Hd(e) {
  return "incremental" in e;
}
function YK(e) {
  return "hasNext" in e && "data" in e;
}
function qK(e) {
  return Hd(e) || YK(e);
}
function QK(e) {
  return mi(e) && "payload" in e;
}
function Fw(e, t) {
  var r = e, i = new Ml();
  return Hd(t) && Ya(t.incremental) && t.incremental.forEach(function(n) {
    for (var a = n.data, o = n.path, s = o.length - 1; s >= 0; --s) {
      var l = o[s], u = !isNaN(+l), d = u ? [] : {};
      d[l] = a, a = d;
    }
    r = i.merge(r, a);
  }), r;
}
function Yf(e) {
  var t = g_(e);
  return Ya(t);
}
function g_(e) {
  var t = Ya(e.errors) ? e.errors.slice(0) : [];
  return Hd(e) && Ya(e.incremental) && e.incremental.forEach(function(r) {
    r.errors && t.push.apply(t, r.errors);
  }), t;
}
function lc() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = /* @__PURE__ */ Object.create(null);
  return e.forEach(function(i) {
    i && Object.keys(i).forEach(function(n) {
      var a = i[n];
      a !== void 0 && (r[n] = a);
    });
  }), r;
}
function Yu(e, t) {
  return lc(e, t, t.variables && {
    variables: lc(ke(ke({}, e && e.variables), t.variables))
  });
}
function Nk(e) {
  return new Yr(function(t) {
    t.error(e);
  });
}
var m_ = function(e, t, r) {
  var i = new Error(r);
  throw i.name = "ServerError", i.response = e, i.statusCode = e.status, i.result = t, i;
};
function XK(e) {
  for (var t = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], r = 0, i = Object.keys(e); r < i.length; r++) {
    var n = i[r];
    if (t.indexOf(n) < 0)
      throw aa(43, n);
  }
  return e;
}
function ZK(e, t) {
  var r = ke({}, e), i = function(a) {
    typeof a == "function" ? r = ke(ke({}, r), a(r)) : r = ke(ke({}, r), a);
  }, n = function() {
    return ke({}, r);
  };
  return Object.defineProperty(t, "setContext", {
    enumerable: !1,
    value: i
  }), Object.defineProperty(t, "getContext", {
    enumerable: !1,
    value: n
  }), t;
}
function JK(e) {
  var t = {
    variables: e.variables || {},
    extensions: e.extensions || {},
    operationName: e.operationName,
    query: e.query
  };
  return t.operationName || (t.operationName = typeof t.query != "string" ? d_(t.query) || void 0 : ""), t;
}
function eY(e, t) {
  var r = ke({}, e), i = new Set(Object.keys(e));
  return Ms(t, {
    Variable: function(n, a, o) {
      o && o.kind !== "VariableDefinition" && i.delete(n.name.value);
    }
  }), i.forEach(function(n) {
    delete r[n];
  }), r;
}
function N9(e, t) {
  return t ? t(e) : Yr.of();
}
function x0(e) {
  return typeof e == "function" ? new cs(e) : e;
}
function kf(e) {
  return e.request.length <= 1;
}
var cs = (
  /** @class */
  function() {
    function e(t) {
      t && (this.request = t);
    }
    return e.empty = function() {
      return new e(function() {
        return Yr.of();
      });
    }, e.from = function(t) {
      return t.length === 0 ? e.empty() : t.map(x0).reduce(function(r, i) {
        return r.concat(i);
      });
    }, e.split = function(t, r, i) {
      var n = x0(r), a = x0(i || new e(N9));
      return kf(n) && kf(a) ? new e(function(o) {
        return t(o) ? n.request(o) || Yr.of() : a.request(o) || Yr.of();
      }) : new e(function(o, s) {
        return t(o) ? n.request(o, s) || Yr.of() : a.request(o, s) || Yr.of();
      });
    }, e.execute = function(t, r) {
      return t.request(ZK(r.context, JK(XK(r)))) || Yr.of();
    }, e.concat = function(t, r) {
      var i = x0(t);
      if (kf(i))
        return i;
      var n = x0(r);
      return kf(n) ? new e(function(a) {
        return i.request(a, function(o) {
          return n.request(o) || Yr.of();
        }) || Yr.of();
      }) : new e(function(a, o) {
        return i.request(a, function(s) {
          return n.request(s, o) || Yr.of();
        }) || Yr.of();
      });
    }, e.prototype.split = function(t, r, i) {
      return this.concat(e.split(t, r, i || new e(N9)));
    }, e.prototype.concat = function(t) {
      return e.concat(this, t);
    }, e.prototype.request = function(t, r) {
      throw aa(36);
    }, e.prototype.onError = function(t, r) {
      if (r && r.error)
        return r.error(t), !1;
      throw t;
    }, e.prototype.setOnError = function(t) {
      return this.onError = t, this;
    }, e;
  }()
), z9 = cs.split, v_ = cs.execute;
function tY(e) {
  var t, r = e[Symbol.asyncIterator]();
  return t = {
    next: function() {
      return r.next();
    }
  }, t[Symbol.asyncIterator] = function() {
    return this;
  }, t;
}
function rY(e) {
  var t = null, r = null, i = !1, n = [], a = [];
  function o(c) {
    if (!r) {
      if (a.length) {
        var p = a.shift();
        if (Array.isArray(p) && p[0])
          return p[0]({ value: c, done: !1 });
      }
      n.push(c);
    }
  }
  function s(c) {
    r = c;
    var p = a.slice();
    p.forEach(function(f) {
      f[1](c);
    }), !t || t();
  }
  function l() {
    i = !0;
    var c = a.slice();
    c.forEach(function(p) {
      p[0]({ value: void 0, done: !0 });
    }), !t || t();
  }
  t = function() {
    t = null, e.removeListener("data", o), e.removeListener("error", s), e.removeListener("end", l), e.removeListener("finish", l), e.removeListener("close", l);
  }, e.on("data", o), e.on("error", s), e.on("end", l), e.on("finish", l), e.on("close", l);
  function u() {
    return new Promise(function(c, p) {
      if (r)
        return p(r);
      if (n.length)
        return c({ value: n.shift(), done: !1 });
      if (i)
        return c({ value: void 0, done: !0 });
      a.push([c, p]);
    });
  }
  var d = {
    next: function() {
      return u();
    }
  };
  return wm && (d[Symbol.asyncIterator] = function() {
    return this;
  }), d;
}
function iY(e) {
  var t = !1, r = {
    next: function() {
      return t ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (t = !0, new Promise(function(i, n) {
        e.then(function(a) {
          i({ value: a, done: !1 });
        }).catch(n);
      }));
    }
  };
  return wm && (r[Symbol.asyncIterator] = function() {
    return this;
  }), r;
}
function L9(e) {
  var t = {
    next: function() {
      return e.read();
    }
  };
  return wm && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function nY(e) {
  return !!e.body;
}
function aY(e) {
  return !!e.getReader;
}
function oY(e) {
  return !!(wm && e[Symbol.asyncIterator]);
}
function sY(e) {
  return !!e.stream;
}
function lY(e) {
  return !!e.arrayBuffer;
}
function uY(e) {
  return !!e.pipe;
}
function cY(e) {
  var t = e;
  if (nY(e) && (t = e.body), oY(t))
    return tY(t);
  if (aY(t))
    return L9(t.getReader());
  if (sY(t))
    return L9(t.stream().getReader());
  if (lY(t))
    return iY(t.arrayBuffer());
  if (uY(t))
    return rY(t);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var hD = Symbol();
function dY(e) {
  return e.extensions ? Array.isArray(e.extensions[hD]) : !1;
}
function pY(e) {
  return e.hasOwnProperty("graphQLErrors");
}
var hY = function(e) {
  var t = qo(qo(qo([], e.graphQLErrors, !0), e.clientErrors, !0), e.protocolErrors, !0);
  return e.networkError && t.push(e.networkError), t.map(function(r) {
    return mi(r) && r.message || "Error message not found.";
  }).join(`
`);
}, $o = (
  /** @class */
  function(e) {
    Qa(t, e);
    function t(r) {
      var i = r.graphQLErrors, n = r.protocolErrors, a = r.clientErrors, o = r.networkError, s = r.errorMessage, l = r.extraInfo, u = e.call(this, s) || this;
      return u.name = "ApolloError", u.graphQLErrors = i || [], u.protocolErrors = n || [], u.clientErrors = a || [], u.networkError = o || null, u.message = s || hY(u), u.extraInfo = l, u.__proto__ = t.prototype, u;
    }
    return t;
  }(Error)
), M9 = Object.prototype.hasOwnProperty;
function fY(e, t) {
  var r;
  return bl(this, void 0, void 0, function() {
    var i, n, a, o, s, l, u, d, c, p, f, g, k, y, _, A, T, N, P, B, M, X, U;
    return _l(this, function(K) {
      switch (K.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          i = new TextDecoder("utf-8"), n = (r = e.headers) === null || r === void 0 ? void 0 : r.get("content-type"), a = "boundary=", o = n != null && n.includes(a) ? n == null ? void 0 : n.substring((n == null ? void 0 : n.indexOf(a)) + a.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", s = `\r
--`.concat(o), l = "", u = cY(e), d = !0, K.label = 1;
        case 1:
          return d ? [4, u.next()] : [3, 3];
        case 2:
          for (c = K.sent(), p = c.value, f = c.done, g = typeof p == "string" ? p : i.decode(p), k = l.length - s.length + 1, d = !f, l += g, y = l.indexOf(s, k); y > -1; ) {
            if (_ = void 0, X = [
              l.slice(0, y),
              l.slice(y + s.length)
            ], _ = X[0], l = X[1], A = _.indexOf(`\r
\r
`), T = gY(_.slice(0, A)), N = T["content-type"], N && N.toLowerCase().indexOf("application/json") === -1)
              throw new Error("Unsupported patch content type: application/json is required.");
            if (P = _.slice(A), P) {
              if (B = Tw(e, P), Object.keys(B).length > 1 || "data" in B || "incremental" in B || "errors" in B || "payload" in B)
                QK(B) ? (M = {}, "payload" in B && (M = ke({}, B.payload)), "errors" in B && (M = ke(ke({}, M), { extensions: ke(ke({}, "extensions" in M ? M.extensions : null), (U = {}, U[hD] = B.errors, U)) })), t(M)) : t(B);
              else if (
                // If the chunk contains only a "hasNext: false", we can call
                // observer.complete() immediately.
                Object.keys(B).length === 1 && "hasNext" in B && !B.hasNext
              )
                return [
                  2
                  /*return*/
                ];
            }
            y = l.indexOf(s);
          }
          return [3, 1];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function gY(e) {
  var t = {};
  return e.split(`
`).forEach(function(r) {
    var i = r.indexOf(":");
    if (i > -1) {
      var n = r.slice(0, i).trim().toLowerCase(), a = r.slice(i + 1).trim();
      t[n] = a;
    }
  }), t;
}
function Tw(e, t) {
  if (e.status >= 300) {
    var r = function() {
      try {
        return JSON.parse(t);
      } catch {
        return t;
      }
    };
    m_(e, r(), "Response not successful: Received status code ".concat(e.status));
  }
  try {
    return JSON.parse(t);
  } catch (n) {
    var i = n;
    throw i.name = "ServerParseError", i.response = e, i.statusCode = e.status, i.bodyText = t, i;
  }
}
function mY(e, t) {
  e.result && e.result.errors && e.result.data && t.next(e.result), t.error(e);
}
function vY(e) {
  return function(t) {
    return t.text().then(function(r) {
      return Tw(t, r);
    }).then(function(r) {
      return t.status >= 300 && m_(t, r, "Response not successful: Received status code ".concat(t.status)), !Array.isArray(r) && !M9.call(r, "data") && !M9.call(r, "errors") && m_(t, r, "Server response was missing for query '".concat(Array.isArray(e) ? e.map(function(i) {
        return i.operationName;
      }) : e.operationName, "'.")), r;
    });
  };
}
var k_ = function(e, t) {
  var r;
  try {
    r = JSON.stringify(e);
  } catch (n) {
    var i = aa(39, t, n.message);
    throw i.parseError = n, i;
  }
  return r;
}, kY = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, bY = {
  // headers are case insensitive (https://stackoverflow.com/a/5259004)
  accept: "*/*",
  // The content-type header describes the type of the body of the request, and
  // so it typically only is sent with requests that actually have bodies. One
  // could imagine that Apollo Client would remove this header when constructing
  // a GET request (which has no body), but we historically have not done that.
  // This means that browsers will preflight all Apollo Client requests (even
  // GET requests). Apollo Server's CSRF prevention feature (introduced in
  // AS3.7) takes advantage of this fact and does not block requests with this
  // header. If you want to drop this header from GET requests, then you should
  // probably replace it with a `apollo-require-preflight` header, or servers
  // with CSRF prevention enabled might block your GET request. See
  // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
  // for more details.
  "content-type": "application/json"
}, _Y = {
  method: "POST"
}, DY = {
  http: kY,
  headers: bY,
  options: _Y
}, yY = function(e, t) {
  return t(e);
};
function EY(e, t) {
  for (var r = [], i = 2; i < arguments.length; i++)
    r[i - 2] = arguments[i];
  var n = {}, a = {};
  r.forEach(function(c) {
    n = ke(ke(ke({}, n), c.options), { headers: ke(ke({}, n.headers), c.headers) }), c.credentials && (n.credentials = c.credentials), a = ke(ke({}, a), c.http);
  }), n.headers && (n.headers = CY(n.headers, a.preserveHeaderCase));
  var o = e.operationName, s = e.extensions, l = e.variables, u = e.query, d = { operationName: o, variables: l };
  return a.includeExtensions && (d.extensions = s), a.includeQuery && (d.query = t(u, sD)), {
    options: n,
    body: d
  };
}
function CY(e, t) {
  if (!t) {
    var r = /* @__PURE__ */ Object.create(null);
    return Object.keys(Object(e)).forEach(function(a) {
      r[a.toLowerCase()] = e[a];
    }), r;
  }
  var i = /* @__PURE__ */ Object.create(null);
  Object.keys(Object(e)).forEach(function(a) {
    i[a.toLowerCase()] = {
      originalName: a,
      value: e[a]
    };
  });
  var n = /* @__PURE__ */ Object.create(null);
  return Object.keys(i).forEach(function(a) {
    n[i[a].originalName] = i[a].value;
  }), n;
}
var xY = function(e, t) {
  var r = e.getContext(), i = r.uri;
  return i || (typeof t == "function" ? t(e) : t || "/graphql");
};
function AY(e, t) {
  var r = [], i = function(c, p) {
    r.push("".concat(c, "=").concat(encodeURIComponent(p)));
  };
  if ("query" in t && i("query", t.query), t.operationName && i("operationName", t.operationName), t.variables) {
    var n = void 0;
    try {
      n = k_(t.variables, "Variables map");
    } catch (c) {
      return { parseError: c };
    }
    i("variables", n);
  }
  if (t.extensions) {
    var a = void 0;
    try {
      a = k_(t.extensions, "Extensions map");
    } catch (c) {
      return { parseError: c };
    }
    i("extensions", a);
  }
  var o = "", s = e, l = e.indexOf("#");
  l !== -1 && (o = e.substr(l), s = e.substr(0, l));
  var u = s.indexOf("?") === -1 ? "?" : "&", d = s + u + r.join("&") + o;
  return { newURI: d };
}
var wY = go(function() {
  return fetch;
}), FY = function(e) {
  e === void 0 && (e = {});
  var t = e.uri, r = t === void 0 ? "/graphql" : t, i = e.fetch, n = e.print, a = n === void 0 ? yY : n, o = e.includeExtensions, s = e.preserveHeaderCase, l = e.useGETForQueries, u = e.includeUnusedVariables, d = u === void 0 ? !1 : u, c = es(e, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]), p = {
    http: { includeExtensions: o, preserveHeaderCase: s },
    options: c.fetchOptions,
    credentials: c.credentials,
    headers: c.headers
  };
  return new cs(function(f) {
    var g = xY(f, r), k = f.getContext(), y = {};
    if (k.clientAwareness) {
      var _ = k.clientAwareness, A = _.name, T = _.version;
      A && (y["apollographql-client-name"] = A), T && (y["apollographql-client-version"] = T);
    }
    var N = ke(ke({}, y), k.headers), P = {
      http: k.http,
      options: k.fetchOptions,
      credentials: k.credentials,
      headers: N
    };
    if (D1(["client"], f.query)) {
      var B = Ew(f.query);
      if (!B)
        return Nk(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
      f.query = B;
    }
    var M = EY(f, a, DY, p, P), X = M.options, U = M.body;
    U.variables && !d && (U.variables = eY(U.variables, f.query));
    var K;
    !X.signal && typeof AbortController < "u" && (K = new AbortController(), X.signal = K.signal);
    var z = function(Le) {
      return Le.kind === "OperationDefinition" && Le.operation === "mutation";
    }, j = function(Le) {
      return Le.kind === "OperationDefinition" && Le.operation === "subscription";
    }, J = j(sc(f.query)), ie = D1(["defer"], f.query);
    if (l && !f.query.definitions.some(z) && (X.method = "GET"), ie || J) {
      X.headers = X.headers || {};
      var ue = "multipart/mixed;";
      J ? ue += "boundary=graphql;subscriptionSpec=1.0,application/json" : ie && (ue += "deferSpec=20220824,application/json"), X.headers.accept = ue;
    }
    if (X.method === "GET") {
      var de = AY(g, U), he = de.newURI, Ee = de.parseError;
      if (Ee)
        return Nk(Ee);
      g = he;
    } else
      try {
        X.body = k_(U, "Payload");
      } catch (Le) {
        return Nk(Le);
      }
    return new Yr(function(Le) {
      var L = i || go(function() {
        return fetch;
      }) || wY, me = Le.next.bind(Le);
      return L(g, X).then(function(Se) {
        var G;
        f.setContext({ response: Se });
        var He = (G = Se.headers) === null || G === void 0 ? void 0 : G.get("content-type");
        return He !== null && /^multipart\/mixed/i.test(He) ? fY(Se, me) : vY(f)(Se).then(me);
      }).then(function() {
        K = void 0, Le.complete();
      }).catch(function(Se) {
        K = void 0, mY(Se, Le);
      }), function() {
        K && K.abort();
      };
    });
  });
}, b_ = (
  /** @class */
  function(e) {
    Qa(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var i = e.call(this, FY(r).request) || this;
      return i.options = r, i;
    }
    return t;
  }(cs)
);
const { toString: j9, hasOwnProperty: TY } = Object.prototype, H9 = Function.prototype.toString, __ = /* @__PURE__ */ new Map();
function qr(e, t) {
  try {
    return D_(e, t);
  } finally {
    __.clear();
  }
}
function D_(e, t) {
  if (e === t)
    return !0;
  const r = j9.call(e), i = j9.call(t);
  if (r !== i)
    return !1;
  switch (r) {
    case "[object Array]":
      if (e.length !== t.length)
        return !1;
    case "[object Object]": {
      if (U9(e, t))
        return !0;
      const n = $9(e), a = $9(t), o = n.length;
      if (o !== a.length)
        return !1;
      for (let s = 0; s < o; ++s)
        if (!TY.call(t, n[s]))
          return !1;
      for (let s = 0; s < o; ++s) {
        const l = n[s];
        if (!D_(e[l], t[l]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return e.name === t.name && e.message === t.message;
    case "[object Number]":
      if (e !== e)
        return t !== t;
    case "[object Boolean]":
    case "[object Date]":
      return +e == +t;
    case "[object RegExp]":
    case "[object String]":
      return e == `${t}`;
    case "[object Map]":
    case "[object Set]": {
      if (e.size !== t.size)
        return !1;
      if (U9(e, t))
        return !0;
      const n = e.entries(), a = r === "[object Map]";
      for (; ; ) {
        const o = n.next();
        if (o.done)
          break;
        const [s, l] = o.value;
        if (!t.has(s) || a && !D_(l, t.get(s)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      e = new Uint8Array(e), t = new Uint8Array(t);
    case "[object DataView]": {
      let n = e.byteLength;
      if (n === t.byteLength)
        for (; n-- && e[n] === t[n]; )
          ;
      return n === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const n = H9.call(e);
      return n !== H9.call(t) ? !1 : !BY(n, IY);
    }
  }
  return !1;
}
function $9(e) {
  return Object.keys(e).filter(SY, e);
}
function SY(e) {
  return this[e] !== void 0;
}
const IY = "{ [native code] }";
function BY(e, t) {
  const r = e.length - t.length;
  return r >= 0 && e.indexOf(t, r) === r;
}
function U9(e, t) {
  let r = __.get(e);
  if (r) {
    if (r.has(t))
      return !0;
  } else
    __.set(e, r = /* @__PURE__ */ new Set());
  return r.add(t), !1;
}
const RY = () => /* @__PURE__ */ Object.create(null), { forEach: OY, slice: PY } = Array.prototype, { hasOwnProperty: NY } = Object.prototype;
class fD {
  constructor(t = !0, r = RY) {
    this.weakness = t, this.makeData = r;
  }
  lookup(...t) {
    return this.lookupArray(t);
  }
  lookupArray(t) {
    let r = this;
    return OY.call(t, (i) => r = r.getChildTrie(i)), NY.call(r, "data") ? r.data : r.data = this.makeData(PY.call(t));
  }
  peek(...t) {
    return this.peekArray(t);
  }
  peekArray(t) {
    let r = this;
    for (let i = 0, n = t.length; r && i < n; ++i) {
      const a = this.weakness && V9(t[i]) ? r.weak : r.strong;
      r = a && a.get(t[i]);
    }
    return r && r.data;
  }
  getChildTrie(t) {
    const r = this.weakness && V9(t) ? this.weak || (this.weak = /* @__PURE__ */ new WeakMap()) : this.strong || (this.strong = /* @__PURE__ */ new Map());
    let i = r.get(t);
    return i || r.set(t, i = new fD(this.weakness, this.makeData)), i;
  }
}
function V9(e) {
  switch (typeof e) {
    case "object":
      if (e === null)
        break;
    case "function":
      return !0;
  }
  return !1;
}
function zY() {
}
class LY {
  constructor(t = 1 / 0, r = zY) {
    this.max = t, this.dispose = r, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  get size() {
    return this.map.size;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: i, newer: n } = r;
      n && (n.older = i), i && (i.newer = n), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = n);
    }
    return r;
  }
  set(t, r) {
    let i = this.getNode(t);
    return i ? i.value = r : (i = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = i), this.newest = i, this.oldest = this.oldest || i, this.map.set(t, i), i.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (r === this.newest && (this.newest = r.older), r === this.oldest && (this.oldest = r.newer), r.newer && (r.newer.older = r.older), r.older && (r.older.newer = r.newer), this.map.delete(t), this.dispose(r.value, t), !0) : !1;
  }
}
let on = null;
const W9 = {};
let MY = 1;
const jY = () => class {
  constructor() {
    this.id = [
      "slot",
      MY++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let t = on; t; t = t.parent)
      if (this.id in t.slots) {
        const r = t.slots[this.id];
        if (r === W9)
          break;
        return t !== on && (on.slots[this.id] = r), !0;
      }
    return on && (on.slots[this.id] = W9), !1;
  }
  getValue() {
    if (this.hasValue())
      return on.slots[this.id];
  }
  withValue(t, r, i, n) {
    const a = {
      __proto__: null,
      [this.id]: t
    }, o = on;
    on = { parent: o, slots: a };
    try {
      return r.apply(n, i);
    } finally {
      on = o;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(t) {
    const r = on;
    return function() {
      const i = on;
      try {
        return on = r, t.apply(this, arguments);
      } finally {
        on = i;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(t, r, i) {
    if (on) {
      const n = on;
      try {
        return on = null, t.apply(i, r);
      } finally {
        on = n;
      }
    } else
      return t.apply(i, r);
  }
};
function G9(e) {
  try {
    return e();
  } catch {
  }
}
const zk = "@wry/context:Slot", HY = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  G9(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  G9(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), K9 = HY, Sw = K9[zk] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[zk] || function(e) {
  try {
    Object.defineProperty(K9, zk, {
      value: e,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return e;
  }
}(jY()), Bm = new Sw(), { hasOwnProperty: $Y } = Object.prototype, gD = Array.from || function(e) {
  const t = [];
  return e.forEach((r) => t.push(r)), t;
};
function Lg(e) {
  const { unsubscribe: t } = e;
  typeof t == "function" && (e.unsubscribe = void 0, t());
}
const y1 = [], UY = 100;
function Zd(e, t) {
  if (!e)
    throw new Error(t || "assertion failure");
}
function Iw(e, t) {
  const r = e.length;
  return (
    // Unknown values are not equal to each other.
    r > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    r === t.length && // The underlying value or exception must be the same.
    e[r - 1] === t[r - 1]
  );
}
function Bw(e) {
  switch (e.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return e[0];
    case 2:
      throw e[1];
  }
}
function Rw(e) {
  return e.slice(0);
}
class Rm {
  constructor(t) {
    this.fn = t, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++Rm.count;
  }
  peek() {
    if (this.value.length === 1 && !jl(this))
      return Y9(this), this.value[0];
  }
  // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.
  recompute(t) {
    return Zd(!this.recomputing, "already recomputing"), Y9(this), jl(this) ? VY(this, t) : Bw(this.value);
  }
  setDirty() {
    this.dirty || (this.dirty = !0, Ow(this), Lg(this));
  }
  dispose() {
    this.setDirty(), Mw(this), mD(this, (t, r) => {
      t.setDirty(), jw(t, this);
    });
  }
  forget() {
    this.dispose();
  }
  dependOn(t) {
    t.add(this), this.deps || (this.deps = y1.pop() || /* @__PURE__ */ new Set()), this.deps.add(t);
  }
  forgetDeps() {
    this.deps && (gD(this.deps).forEach((t) => t.delete(this)), this.deps.clear(), y1.push(this.deps), this.deps = null);
  }
}
Rm.count = 0;
function Y9(e) {
  const t = Bm.getValue();
  if (t)
    return e.parents.add(t), t.childValues.has(e) || t.childValues.set(e, []), jl(e) ? Nw(t, e) : zw(t, e), t;
}
function VY(e, t) {
  return Mw(e), Bm.withValue(e, WY, [e, t]), KY(e, t) && GY(e), Bw(e.value);
}
function WY(e, t) {
  e.recomputing = !0;
  const { normalizeResult: r } = e;
  let i;
  r && e.value.length === 1 && (i = Rw(e.value)), e.value.length = 0;
  try {
    if (e.value[0] = e.fn.apply(null, t), r && i && !Iw(i, e.value))
      try {
        e.value[0] = r(e.value[0], i[0]);
      } catch {
      }
  } catch (n) {
    e.value[1] = n;
  }
  e.recomputing = !1;
}
function jl(e) {
  return e.dirty || !!(e.dirtyChildren && e.dirtyChildren.size);
}
function GY(e) {
  e.dirty = !1, !jl(e) && Pw(e);
}
function Ow(e) {
  mD(e, Nw);
}
function Pw(e) {
  mD(e, zw);
}
function mD(e, t) {
  const r = e.parents.size;
  if (r) {
    const i = gD(e.parents);
    for (let n = 0; n < r; ++n)
      t(i[n], e);
  }
}
function Nw(e, t) {
  Zd(e.childValues.has(t)), Zd(jl(t));
  const r = !jl(e);
  if (!e.dirtyChildren)
    e.dirtyChildren = y1.pop() || /* @__PURE__ */ new Set();
  else if (e.dirtyChildren.has(t))
    return;
  e.dirtyChildren.add(t), r && Ow(e);
}
function zw(e, t) {
  Zd(e.childValues.has(t)), Zd(!jl(t));
  const r = e.childValues.get(t);
  r.length === 0 ? e.childValues.set(t, Rw(t.value)) : Iw(r, t.value) || e.setDirty(), Lw(e, t), !jl(e) && Pw(e);
}
function Lw(e, t) {
  const r = e.dirtyChildren;
  r && (r.delete(t), r.size === 0 && (y1.length < UY && y1.push(r), e.dirtyChildren = null));
}
function Mw(e) {
  e.childValues.size > 0 && e.childValues.forEach((t, r) => {
    jw(e, r);
  }), e.forgetDeps(), Zd(e.dirtyChildren === null);
}
function jw(e, t) {
  t.parents.delete(e), e.childValues.delete(t), Lw(e, t);
}
function KY(e, t) {
  if (typeof e.subscribe == "function")
    try {
      Lg(e), e.unsubscribe = e.subscribe.apply(null, t);
    } catch {
      return e.setDirty(), !1;
    }
  return !0;
}
const YY = {
  setDirty: !0,
  dispose: !0,
  forget: !0
  // Fully remove parent Entry from LRU cache and computation graph
};
function Hw(e) {
  const t = /* @__PURE__ */ new Map(), r = e && e.subscribe;
  function i(n) {
    const a = Bm.getValue();
    if (a) {
      let o = t.get(n);
      o || t.set(n, o = /* @__PURE__ */ new Set()), a.dependOn(o), typeof r == "function" && (Lg(o), o.unsubscribe = r(n));
    }
  }
  return i.dirty = function(a, o) {
    const s = t.get(a);
    if (s) {
      const l = o && $Y.call(YY, o) ? o : "setDirty";
      gD(s).forEach((u) => u[l]()), t.delete(a), Lg(s);
    }
  }, i;
}
let q9;
function qY(...e) {
  return (q9 || (q9 = new fD(typeof WeakMap == "function"))).lookupArray(e);
}
const Lk = /* @__PURE__ */ new Set();
function Mg(e, { max: t = Math.pow(2, 16), keyArgs: r, makeCacheKey: i = qY, normalizeResult: n, subscribe: a, cache: o = LY } = /* @__PURE__ */ Object.create(null)) {
  const s = typeof o == "function" ? new o(t, (p) => p.dispose()) : o, l = function() {
    const p = i.apply(null, r ? r.apply(null, arguments) : arguments);
    if (p === void 0)
      return e.apply(null, arguments);
    let f = s.get(p);
    f || (s.set(p, f = new Rm(e)), f.normalizeResult = n, f.subscribe = a, f.forget = () => s.delete(p));
    const g = f.recompute(Array.prototype.slice.call(arguments));
    return s.set(p, f), Lk.add(s), Bm.hasValue() || (Lk.forEach((k) => k.clean()), Lk.clear()), g;
  };
  Object.defineProperty(l, "size", {
    get: () => s.size,
    configurable: !1,
    enumerable: !1
  }), Object.freeze(l.options = {
    max: t,
    keyArgs: r,
    makeCacheKey: i,
    normalizeResult: n,
    subscribe: a,
    cache: s
  });
  function u(p) {
    const f = p && s.get(p);
    f && f.setDirty();
  }
  l.dirtyKey = u, l.dirty = function() {
    u(i.apply(null, arguments));
  };
  function d(p) {
    const f = p && s.get(p);
    if (f)
      return f.peek();
  }
  l.peekKey = d, l.peek = function() {
    return d(i.apply(null, arguments));
  };
  function c(p) {
    return p ? s.delete(p) : !1;
  }
  return l.forgetKey = c, l.forget = function() {
    return c(i.apply(null, arguments));
  }, l.makeCacheKey = i, l.getKey = r ? function() {
    return i.apply(null, r.apply(null, arguments));
  } : i, Object.freeze(l);
}
var QY = (
  /** @class */
  function() {
    function e() {
      this.assumeImmutableResults = !1, this.getFragmentDoc = Mg(gK);
    }
    return e.prototype.batch = function(t) {
      var r = this, i = typeof t.optimistic == "string" ? t.optimistic : t.optimistic === !1 ? null : void 0, n;
      return this.performTransaction(function() {
        return n = t.update(r);
      }, i), n;
    }, e.prototype.recordOptimisticTransaction = function(t, r) {
      this.performTransaction(t, r);
    }, e.prototype.transformDocument = function(t) {
      return t;
    }, e.prototype.transformForLink = function(t) {
      return t;
    }, e.prototype.identify = function(t) {
    }, e.prototype.gc = function() {
      return [];
    }, e.prototype.modify = function(t) {
      return !1;
    }, e.prototype.readQuery = function(t, r) {
      return r === void 0 && (r = !!t.optimistic), this.read(ke(ke({}, t), { rootId: t.id || "ROOT_QUERY", optimistic: r }));
    }, e.prototype.readFragment = function(t, r) {
      return r === void 0 && (r = !!t.optimistic), this.read(ke(ke({}, t), { query: this.getFragmentDoc(t.fragment, t.fragmentName), rootId: t.id, optimistic: r }));
    }, e.prototype.writeQuery = function(t) {
      var r = t.id, i = t.data, n = es(t, ["id", "data"]);
      return this.write(Object.assign(n, {
        dataId: r || "ROOT_QUERY",
        result: i
      }));
    }, e.prototype.writeFragment = function(t) {
      var r = t.id, i = t.data, n = t.fragment, a = t.fragmentName, o = es(t, ["id", "data", "fragment", "fragmentName"]);
      return this.write(Object.assign(o, {
        query: this.getFragmentDoc(n, a),
        dataId: r,
        result: i
      }));
    }, e.prototype.updateQuery = function(t, r) {
      return this.batch({
        update: function(i) {
          var n = i.readQuery(t), a = r(n);
          return a == null ? n : (i.writeQuery(ke(ke({}, t), { data: a })), a);
        }
      });
    }, e.prototype.updateFragment = function(t, r) {
      return this.batch({
        update: function(i) {
          var n = i.readFragment(t), a = r(n);
          return a == null ? n : (i.writeFragment(ke(ke({}, t), { data: a })), a);
        }
      });
    }, e;
  }()
), $w = (
  /** @class */
  function(e) {
    Qa(t, e);
    function t(r, i, n, a) {
      var o, s = e.call(this, r) || this;
      if (s.message = r, s.path = i, s.query = n, s.variables = a, Array.isArray(s.path)) {
        s.missing = s.message;
        for (var l = s.path.length - 1; l >= 0; --l)
          s.missing = (o = {}, o[s.path[l]] = s.missing, o);
      } else
        s.missing = s.path;
      return s.__proto__ = t.prototype, s;
    }
    return t;
  }(Error)
), Yi = Object.prototype.hasOwnProperty;
function A0(e) {
  return e == null;
}
function Uw(e, t) {
  var r = e.__typename, i = e.id, n = e._id;
  if (typeof r == "string" && (t && (t.keyObject = A0(i) ? A0(n) ? void 0 : { _id: n } : { id: i }), A0(i) && !A0(n) && (i = n), !A0(i)))
    return "".concat(r, ":").concat(typeof i == "number" || typeof i == "string" ? i : JSON.stringify(i));
}
var Vw = {
  dataIdFromObject: Uw,
  addTypename: !0,
  resultCaching: !0,
  // Thanks to the shouldCanonizeResults helper, this should be the only line
  // you have to change to reenable canonization by default in the future.
  canonizeResults: !1
};
function XY(e) {
  return lc(Vw, e);
}
function Ww(e) {
  var t = e.canonizeResults;
  return t === void 0 ? Vw.canonizeResults : t;
}
var Gw = /^[_a-z][_0-9a-z]*/i;
function Jd(e) {
  var t = e.match(Gw);
  return t ? t[0] : e;
}
function y_(e, t, r) {
  return mi(t) ? Mi(t) ? t.every(function(i) {
    return y_(e, i, r);
  }) : e.selections.every(function(i) {
    if (Ll(i) && V1(i, r)) {
      var n = oc(i);
      return Yi.call(t, n) && (!i.selectionSet || y_(i.selectionSet, t[n], r));
    }
    return !0;
  }) : !1;
}
function Bd(e) {
  return mi(e) && !ui(e) && !Mi(e);
}
function ZY() {
  return new Ml();
}
function Kw(e, t) {
  var r = Fm(Im(e));
  return {
    fragmentMap: r,
    lookupFragment: function(i) {
      var n = r[i];
      return !n && t && (n = t.lookup(i)), n || null;
    }
  };
}
var qf = /* @__PURE__ */ Object.create(null), Mk = function() {
  return qf;
}, Q9 = /* @__PURE__ */ Object.create(null), E1 = (
  /** @class */
  function() {
    function e(t, r) {
      var i = this;
      this.policies = t, this.group = r, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(n, a) {
        return ui(n) ? i.get(n.__ref, a) : n && n[a];
      }, this.canRead = function(n) {
        return ui(n) ? i.has(n.__ref) : typeof n == "object";
      }, this.toReference = function(n, a) {
        if (typeof n == "string")
          return jd(n);
        if (ui(n))
          return n;
        var o = i.policies.identify(n)[0];
        if (o) {
          var s = jd(o);
          return a && i.merge(o, n), s;
        }
      };
    }
    return e.prototype.toObject = function() {
      return ke({}, this.data);
    }, e.prototype.has = function(t) {
      return this.lookup(t, !0) !== void 0;
    }, e.prototype.get = function(t, r) {
      if (this.group.depend(t, r), Yi.call(this.data, t)) {
        var i = this.data[t];
        if (i && Yi.call(i, r))
          return i[r];
      }
      if (r === "__typename" && Yi.call(this.policies.rootTypenamesById, t))
        return this.policies.rootTypenamesById[t];
      if (this instanceof gl)
        return this.parent.get(t, r);
    }, e.prototype.lookup = function(t, r) {
      if (r && this.group.depend(t, "__exists"), Yi.call(this.data, t))
        return this.data[t];
      if (this instanceof gl)
        return this.parent.lookup(t, r);
      if (this.policies.rootTypenamesById[t])
        return /* @__PURE__ */ Object.create(null);
    }, e.prototype.merge = function(t, r) {
      var i = this, n;
      ui(t) && (t = t.__ref), ui(r) && (r = r.__ref);
      var a = typeof t == "string" ? this.lookup(n = t) : t, o = typeof r == "string" ? this.lookup(n = r) : r;
      if (o) {
        cr(typeof n == "string", 1);
        var s = new Ml(eq).merge(a, o);
        if (this.data[n] = s, s !== a && (delete this.refs[n], this.group.caching)) {
          var l = /* @__PURE__ */ Object.create(null);
          a || (l.__exists = 1), Object.keys(o).forEach(function(u) {
            if (!a || a[u] !== s[u]) {
              l[u] = 1;
              var d = Jd(u);
              d !== u && !i.policies.hasKeyArgs(s.__typename, d) && (l[d] = 1), s[u] === void 0 && !(i instanceof gl) && delete s[u];
            }
          }), l.__typename && !(a && a.__typename) && // Since we return default root __typename strings
          // automatically from store.get, we don't need to dirty the
          // ROOT_QUERY.__typename field if merged.__typename is equal
          // to the default string (usually "Query").
          this.policies.rootTypenamesById[n] === s.__typename && delete l.__typename, Object.keys(l).forEach(function(u) {
            return i.group.dirty(n, u);
          });
        }
      }
    }, e.prototype.modify = function(t, r) {
      var i = this, n = this.lookup(t);
      if (n) {
        var a = /* @__PURE__ */ Object.create(null), o = !1, s = !0, l = {
          DELETE: qf,
          INVALIDATE: Q9,
          isReference: ui,
          toReference: this.toReference,
          canRead: this.canRead,
          readField: function(u, d) {
            return i.policies.readField(typeof u == "string" ? {
              fieldName: u,
              from: d || jd(t)
            } : u, { store: i });
          }
        };
        if (Object.keys(n).forEach(function(u) {
          var d = Jd(u), c = n[u];
          if (c !== void 0) {
            var p = typeof r == "function" ? r : r[u] || r[d];
            if (p) {
              var f = p === Mk ? qf : p(c, ke(ke({}, l), { fieldName: d, storeFieldName: u, storage: i.getStorage(t, u) }));
              f === Q9 ? i.group.dirty(t, u) : (f === qf && (f = void 0), f !== c && (a[u] = f, o = !0, c = f));
            }
            c !== void 0 && (s = !1);
          }
        }), o)
          return this.merge(t, a), s && (this instanceof gl ? this.data[t] = void 0 : delete this.data[t], this.group.dirty(t, "__exists")), !0;
      }
      return !1;
    }, e.prototype.delete = function(t, r, i) {
      var n, a = this.lookup(t);
      if (a) {
        var o = this.getFieldValue(a, "__typename"), s = r && i ? this.policies.getStoreFieldName({ typename: o, fieldName: r, args: i }) : r;
        return this.modify(t, s ? (n = {}, n[s] = Mk, n) : Mk);
      }
      return !1;
    }, e.prototype.evict = function(t, r) {
      var i = !1;
      return t.id && (Yi.call(this.data, t.id) && (i = this.delete(t.id, t.fieldName, t.args)), this instanceof gl && this !== r && (i = this.parent.evict(t, r) || i), (t.fieldName || i) && this.group.dirty(t.id, t.fieldName || "__exists")), i;
    }, e.prototype.clear = function() {
      this.replace(null);
    }, e.prototype.extract = function() {
      var t = this, r = this.toObject(), i = [];
      return this.getRootIdSet().forEach(function(n) {
        Yi.call(t.policies.rootTypenamesById, n) || i.push(n);
      }), i.length && (r.__META = { extraRootIds: i.sort() }), r;
    }, e.prototype.replace = function(t) {
      var r = this;
      if (Object.keys(this.data).forEach(function(a) {
        t && Yi.call(t, a) || r.delete(a);
      }), t) {
        var i = t.__META, n = es(t, ["__META"]);
        Object.keys(n).forEach(function(a) {
          r.merge(a, n[a]);
        }), i && i.extraRootIds.forEach(this.retain, this);
      }
    }, e.prototype.retain = function(t) {
      return this.rootIds[t] = (this.rootIds[t] || 0) + 1;
    }, e.prototype.release = function(t) {
      if (this.rootIds[t] > 0) {
        var r = --this.rootIds[t];
        return r || delete this.rootIds[t], r;
      }
      return 0;
    }, e.prototype.getRootIdSet = function(t) {
      return t === void 0 && (t = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(t.add, t), this instanceof gl ? this.parent.getRootIdSet(t) : Object.keys(this.policies.rootTypenamesById).forEach(t.add, t), t;
    }, e.prototype.gc = function() {
      var t = this, r = this.getRootIdSet(), i = this.toObject();
      r.forEach(function(o) {
        Yi.call(i, o) && (Object.keys(t.findChildRefIds(o)).forEach(r.add, r), delete i[o]);
      });
      var n = Object.keys(i);
      if (n.length) {
        for (var a = this; a instanceof gl; )
          a = a.parent;
        n.forEach(function(o) {
          return a.delete(o);
        });
      }
      return n;
    }, e.prototype.findChildRefIds = function(t) {
      if (!Yi.call(this.refs, t)) {
        var r = this.refs[t] = /* @__PURE__ */ Object.create(null), i = this.data[t];
        if (!i)
          return r;
        var n = /* @__PURE__ */ new Set([i]);
        n.forEach(function(a) {
          ui(a) && (r[a.__ref] = !0), mi(a) && Object.keys(a).forEach(function(o) {
            var s = a[o];
            mi(s) && n.add(s);
          });
        });
      }
      return this.refs[t];
    }, e.prototype.makeCacheKey = function() {
      return this.group.keyMaker.lookupArray(arguments);
    }, e;
  }()
), Yw = (
  /** @class */
  function() {
    function e(t, r) {
      r === void 0 && (r = null), this.caching = t, this.parent = r, this.d = null, this.resetCaching();
    }
    return e.prototype.resetCaching = function() {
      this.d = this.caching ? Hw() : null, this.keyMaker = new W1(us);
    }, e.prototype.depend = function(t, r) {
      if (this.d) {
        this.d(jk(t, r));
        var i = Jd(r);
        i !== r && this.d(jk(t, i)), this.parent && this.parent.depend(t, r);
      }
    }, e.prototype.dirty = function(t, r) {
      this.d && this.d.dirty(
        jk(t, r),
        // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        r === "__exists" ? "forget" : "setDirty"
      );
    }, e;
  }()
);
function jk(e, t) {
  return t + "#" + e;
}
function X9(e, t) {
  Q0(e) && e.group.depend(t, "__exists");
}
(function(e) {
  var t = (
    /** @class */
    function(r) {
      Qa(i, r);
      function i(n) {
        var a = n.policies, o = n.resultCaching, s = o === void 0 ? !0 : o, l = n.seed, u = r.call(this, a, new Yw(s)) || this;
        return u.stump = new JY(u), u.storageTrie = new W1(us), l && u.replace(l), u;
      }
      return i.prototype.addLayer = function(n, a) {
        return this.stump.addLayer(n, a);
      }, i.prototype.removeLayer = function() {
        return this;
      }, i.prototype.getStorage = function() {
        return this.storageTrie.lookupArray(arguments);
      }, i;
    }(e)
  );
  e.Root = t;
})(E1 || (E1 = {}));
var gl = (
  /** @class */
  function(e) {
    Qa(t, e);
    function t(r, i, n, a) {
      var o = e.call(this, i.policies, a) || this;
      return o.id = r, o.parent = i, o.replay = n, o.group = a, n(o), o;
    }
    return t.prototype.addLayer = function(r, i) {
      return new t(r, this, i, this.group);
    }, t.prototype.removeLayer = function(r) {
      var i = this, n = this.parent.removeLayer(r);
      return r === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(a) {
        var o = i.data[a], s = n.lookup(a);
        s ? o ? o !== s && Object.keys(o).forEach(function(l) {
          qr(o[l], s[l]) || i.group.dirty(a, l);
        }) : (i.group.dirty(a, "__exists"), Object.keys(s).forEach(function(l) {
          i.group.dirty(a, l);
        })) : i.delete(a);
      }), n) : n === this.parent ? this : n.addLayer(this.id, this.replay);
    }, t.prototype.toObject = function() {
      return ke(ke({}, this.parent.toObject()), this.data);
    }, t.prototype.findChildRefIds = function(r) {
      var i = this.parent.findChildRefIds(r);
      return Yi.call(this.data, r) ? ke(ke({}, i), e.prototype.findChildRefIds.call(this, r)) : i;
    }, t.prototype.getStorage = function() {
      for (var r = this.parent; r.parent; )
        r = r.parent;
      return r.getStorage.apply(
        r,
        // @ts-expect-error
        arguments
      );
    }, t;
  }(E1)
), JY = (
  /** @class */
  function(e) {
    Qa(t, e);
    function t(r) {
      return e.call(this, "EntityStore.Stump", r, function() {
      }, new Yw(r.group.caching, r.group)) || this;
    }
    return t.prototype.removeLayer = function() {
      return this;
    }, t.prototype.merge = function(r, i) {
      return this.parent.merge(r, i);
    }, t;
  }(gl)
);
function eq(e, t, r) {
  var i = e[r], n = t[r];
  return qr(i, n) ? i : n;
}
function Q0(e) {
  return !!(e instanceof E1 && e.group.caching);
}
function tq(e) {
  return mi(e) ? Mi(e) ? e.slice(0) : ke({ __proto__: Object.getPrototypeOf(e) }, e) : e;
}
var E_ = (
  /** @class */
  function() {
    function e() {
      this.known = new (kw ? WeakSet : Set)(), this.pool = new W1(us), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
    }
    return e.prototype.isKnown = function(t) {
      return mi(t) && this.known.has(t);
    }, e.prototype.pass = function(t) {
      if (mi(t)) {
        var r = tq(t);
        return this.passes.set(r, t), r;
      }
      return t;
    }, e.prototype.admit = function(t) {
      var r = this;
      if (mi(t)) {
        var i = this.passes.get(t);
        if (i)
          return i;
        var n = Object.getPrototypeOf(t);
        switch (n) {
          case Array.prototype: {
            if (this.known.has(t))
              return t;
            var a = t.map(this.admit, this), o = this.pool.lookupArray(a);
            return o.array || this.known.add(o.array = a), o.array;
          }
          case null:
          case Object.prototype: {
            if (this.known.has(t))
              return t;
            var s = Object.getPrototypeOf(t), l = [s], u = this.sortedKeys(t);
            l.push(u.json);
            var d = l.length;
            u.sorted.forEach(function(f) {
              l.push(r.admit(t[f]));
            });
            var o = this.pool.lookupArray(l);
            if (!o.object) {
              var c = o.object = Object.create(s);
              this.known.add(c), u.sorted.forEach(function(f, g) {
                c[f] = l[d + g];
              });
            }
            return o.object;
          }
        }
      }
      return t;
    }, e.prototype.sortedKeys = function(t) {
      var r = Object.keys(t), i = this.pool.lookupArray(r);
      if (!i.keys) {
        r.sort();
        var n = JSON.stringify(r);
        (i.keys = this.keysByJSON.get(n)) || this.keysByJSON.set(n, i.keys = { sorted: r, json: n });
      }
      return i.keys;
    }, e;
  }()
), qu = Object.assign(function(e) {
  if (mi(e)) {
    C_ === void 0 && Z9();
    var t = C_.admit(e), r = x_.get(t);
    return r === void 0 && x_.set(t, r = JSON.stringify(t)), r;
  }
  return JSON.stringify(e);
}, {
  reset: Z9
}), C_, x_;
function Z9() {
  C_ = new E_(), x_ = new (us ? WeakMap : Map)();
}
function J9(e) {
  return [
    e.selectionSet,
    e.objectOrReference,
    e.context,
    // We split out this property so we can pass different values
    // independently without modifying options.context itself.
    e.context.canonizeResults
  ];
}
var rq = (
  /** @class */
  function() {
    function e(t) {
      var r = this;
      this.knownResults = new (us ? WeakMap : Map)(), this.config = lc(t, {
        addTypename: t.addTypename !== !1,
        canonizeResults: Ww(t)
      }), this.canon = t.canon || new E_(), this.executeSelectionSet = Mg(function(i) {
        var n, a = i.context.canonizeResults, o = J9(i);
        o[3] = !a;
        var s = (n = r.executeSelectionSet).peek.apply(n, o);
        return s ? a ? ke(ke({}, s), {
          // If we previously read this result without canonizing it, we can
          // reuse that result simply by canonizing it now.
          result: r.canon.admit(s.result)
        }) : s : (X9(i.context.store, i.enclosingRef.__ref), r.execSelectionSetImpl(i));
      }, {
        max: this.config.resultCacheMaxSize,
        keyArgs: J9,
        // Note that the parameters of makeCacheKey are determined by the
        // array returned by keyArgs.
        makeCacheKey: function(i, n, a, o) {
          if (Q0(a.store))
            return a.store.makeCacheKey(i, ui(n) ? n.__ref : n, a.varString, o);
        }
      }), this.executeSubSelectedArray = Mg(function(i) {
        return X9(i.context.store, i.enclosingRef.__ref), r.execSubSelectedArrayImpl(i);
      }, {
        max: this.config.resultCacheMaxSize,
        makeCacheKey: function(i) {
          var n = i.field, a = i.array, o = i.context;
          if (Q0(o.store))
            return o.store.makeCacheKey(n, a, o.varString);
        }
      });
    }
    return e.prototype.resetCanon = function() {
      this.canon = new E_();
    }, e.prototype.diffQueryAgainstStore = function(t) {
      var r = t.store, i = t.query, n = t.rootId, a = n === void 0 ? "ROOT_QUERY" : n, o = t.variables, s = t.returnPartialData, l = s === void 0 ? !0 : s, u = t.canonizeResults, d = u === void 0 ? this.config.canonizeResults : u, c = this.config.cache.policies;
      o = ke(ke({}, oD(SK(i))), o);
      var p = jd(a), f = this.executeSelectionSet({
        selectionSet: sc(i).selectionSet,
        objectOrReference: p,
        enclosingRef: p,
        context: ke({ store: r, query: i, policies: c, variables: o, varString: qu(o), canonizeResults: d }, Kw(i, this.config.fragments))
      }), g;
      if (f.missing && (g = [
        new $w(iq(f.missing), f.missing, i, o)
      ], !l))
        throw g[0];
      return {
        result: f.result,
        complete: !g,
        missing: g
      };
    }, e.prototype.isFresh = function(t, r, i, n) {
      if (Q0(n.store) && this.knownResults.get(t) === i) {
        var a = this.executeSelectionSet.peek(
          i,
          r,
          n,
          // If result is canonical, then it could only have been previously
          // cached by the canonizing version of executeSelectionSet, so we can
          // avoid checking both possibilities here.
          this.canon.isKnown(t)
        );
        if (a && t === a.result)
          return !0;
      }
      return !1;
    }, e.prototype.execSelectionSetImpl = function(t) {
      var r = this, i = t.selectionSet, n = t.objectOrReference, a = t.enclosingRef, o = t.context;
      if (ui(n) && !o.policies.rootTypenamesById[n.__ref] && !o.store.has(n.__ref))
        return {
          result: this.canon.empty,
          missing: "Dangling reference to missing ".concat(n.__ref, " object")
        };
      var s = o.variables, l = o.policies, u = o.store, d = u.getFieldValue(n, "__typename"), c = [], p, f = new Ml();
      this.config.addTypename && typeof d == "string" && !l.rootIdsByTypename[d] && c.push({ __typename: d });
      function g(T, N) {
        var P;
        return T.missing && (p = f.merge(p, (P = {}, P[N] = T.missing, P))), T.result;
      }
      var k = new Set(i.selections);
      k.forEach(function(T) {
        var N, P;
        if (V1(T, s))
          if (Ll(T)) {
            var B = l.readField({
              fieldName: T.name.value,
              field: T,
              variables: o.variables,
              from: n
            }, o), M = oc(T);
            B === void 0 ? yw.added(T) || (p = f.merge(p, (N = {}, N[M] = "Can't find field '".concat(T.name.value, "' on ").concat(ui(n) ? n.__ref + " object" : "object " + JSON.stringify(n, null, 2)), N))) : Mi(B) ? B = g(r.executeSubSelectedArray({
              field: T,
              array: B,
              enclosingRef: a,
              context: o
            }), M) : T.selectionSet ? B != null && (B = g(r.executeSelectionSet({
              selectionSet: T.selectionSet,
              objectOrReference: B,
              enclosingRef: ui(B) ? B : a,
              context: o
            }), M)) : o.canonizeResults && (B = r.canon.pass(B)), B !== void 0 && c.push((P = {}, P[M] = B, P));
          } else {
            var X = Tm(T, o.lookupFragment);
            if (!X && T.kind === bt.FRAGMENT_SPREAD)
              throw aa(9, T.name.value);
            X && l.fragmentMatches(X, d) && X.selectionSet.selections.forEach(k.add, k);
          }
      });
      var y = lD(c), _ = { result: y, missing: p }, A = o.canonizeResults ? this.canon.admit(_) : _;
      return A.result && this.knownResults.set(A.result, i), A;
    }, e.prototype.execSubSelectedArrayImpl = function(t) {
      var r = this, i = t.field, n = t.array, a = t.enclosingRef, o = t.context, s, l = new Ml();
      function u(d, c) {
        var p;
        return d.missing && (s = l.merge(s, (p = {}, p[c] = d.missing, p))), d.result;
      }
      return i.selectionSet && (n = n.filter(o.store.canRead)), n = n.map(function(d, c) {
        return d === null ? null : Mi(d) ? u(r.executeSubSelectedArray({
          field: i,
          array: d,
          enclosingRef: a,
          context: o
        }), c) : i.selectionSet ? u(r.executeSelectionSet({
          selectionSet: i.selectionSet,
          objectOrReference: d,
          enclosingRef: ui(d) ? d : a,
          context: o
        }), c) : d;
      }), {
        result: o.canonizeResults ? this.canon.admit(n) : n,
        missing: s
      };
    }, e;
  }()
);
function iq(e) {
  try {
    JSON.stringify(e, function(t, r) {
      if (typeof r == "string")
        throw r;
      return r;
    });
  } catch (t) {
    return t;
  }
}
var vD = new Sw(), e4 = /* @__PURE__ */ new WeakMap();
function X0(e) {
  var t = e4.get(e);
  return t || e4.set(e, t = {
    vars: /* @__PURE__ */ new Set(),
    dep: Hw()
  }), t;
}
function t4(e) {
  X0(e).vars.forEach(function(t) {
    return t.forgetCache(e);
  });
}
function nq(e) {
  X0(e).vars.forEach(function(t) {
    return t.attachCache(e);
  });
}
function Om(e) {
  var t = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), i = function(a) {
    if (arguments.length > 0) {
      if (e !== a) {
        e = a, t.forEach(function(l) {
          X0(l).dep.dirty(i), aq(l);
        });
        var o = Array.from(r);
        r.clear(), o.forEach(function(l) {
          return l(e);
        });
      }
    } else {
      var s = vD.getValue();
      s && (n(s), X0(s).dep(i));
    }
    return e;
  };
  i.onNextChange = function(a) {
    return r.add(a), function() {
      r.delete(a);
    };
  };
  var n = i.attachCache = function(a) {
    return t.add(a), X0(a).vars.add(i), i;
  };
  return i.forgetCache = function(a) {
    return t.delete(a);
  }, i;
}
function aq(e) {
  e.broadcastWatches && e.broadcastWatches();
}
var r4 = /* @__PURE__ */ Object.create(null);
function kD(e) {
  var t = JSON.stringify(e);
  return r4[t] || (r4[t] = /* @__PURE__ */ Object.create(null));
}
function i4(e) {
  var t = kD(e);
  return t.keyFieldsFn || (t.keyFieldsFn = function(r, i) {
    var n = function(o, s) {
      return i.readField(s, o);
    }, a = i.keyObject = bD(e, function(o) {
      var s = $d(
        i.storeObject,
        o,
        // Using context.readField to extract paths from context.storeObject
        // allows the extraction to see through Reference objects and respect
        // custom read functions.
        n
      );
      return s === void 0 && r !== i.storeObject && Yi.call(r, o[0]) && (s = $d(r, o, Qw)), cr(s !== void 0, 4, o.join("."), r), s;
    });
    return "".concat(i.typename, ":").concat(JSON.stringify(a));
  });
}
function n4(e) {
  var t = kD(e);
  return t.keyArgsFn || (t.keyArgsFn = function(r, i) {
    var n = i.field, a = i.variables, o = i.fieldName, s = bD(e, function(u) {
      var d = u[0], c = d.charAt(0);
      if (c === "@") {
        if (n && Ya(n.directives)) {
          var p = d.slice(1), f = n.directives.find(function(_) {
            return _.name.value === p;
          }), g = f && Sm(f, a);
          return g && $d(
            g,
            // If keyPath.length === 1, this code calls extractKeyPath with an
            // empty path, which works because it uses directiveArgs as the
            // extracted value.
            u.slice(1)
          );
        }
        return;
      }
      if (c === "$") {
        var k = d.slice(1);
        if (a && Yi.call(a, k)) {
          var y = u.slice(0);
          return y[0] = k, $d(a, y);
        }
        return;
      }
      if (r)
        return $d(r, u);
    }), l = JSON.stringify(s);
    return (r || l !== "{}") && (o += ":" + l), o;
  });
}
function bD(e, t) {
  var r = new Ml();
  return qw(e).reduce(function(i, n) {
    var a, o = t(n);
    if (o !== void 0) {
      for (var s = n.length - 1; s >= 0; --s)
        o = (a = {}, a[n[s]] = o, a);
      i = r.merge(i, o);
    }
    return i;
  }, /* @__PURE__ */ Object.create(null));
}
function qw(e) {
  var t = kD(e);
  if (!t.paths) {
    var r = t.paths = [], i = [];
    e.forEach(function(n, a) {
      Mi(n) ? (qw(n).forEach(function(o) {
        return r.push(i.concat(o));
      }), i.length = 0) : (i.push(n), Mi(e[a + 1]) || (r.push(i.slice(0)), i.length = 0));
    });
  }
  return t.paths;
}
function Qw(e, t) {
  return e[t];
}
function $d(e, t, r) {
  return r = r || Qw, Xw(t.reduce(function i(n, a) {
    return Mi(n) ? n.map(function(o) {
      return i(o, a);
    }) : n && r(n, a);
  }, e));
}
function Xw(e) {
  return mi(e) ? Mi(e) ? e.map(Xw) : bD(Object.keys(e).sort(), function(t) {
    return $d(e, t);
  }) : e;
}
aD.setStringify(qu);
function A_(e) {
  return e.args !== void 0 ? e.args : e.field ? Sm(e.field, e.variables) : null;
}
var oq = function() {
}, a4 = function(e, t) {
  return t.fieldName;
}, o4 = function(e, t, r) {
  var i = r.mergeObjects;
  return i(e, t);
}, s4 = function(e, t) {
  return t;
}, sq = (
  /** @class */
  function() {
    function e(t) {
      this.config = t, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = ke({ dataIdFromObject: Uw }, t), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), t.possibleTypes && this.addPossibleTypes(t.possibleTypes), t.typePolicies && this.addTypePolicies(t.typePolicies);
    }
    return e.prototype.identify = function(t, r) {
      var i, n = this, a = r && (r.typename || ((i = r.storeObject) === null || i === void 0 ? void 0 : i.__typename)) || t.__typename;
      if (a === this.rootTypenamesById.ROOT_QUERY)
        return ["ROOT_QUERY"];
      for (var o = r && r.storeObject || t, s = ke(ke({}, r), { typename: a, storeObject: o, readField: r && r.readField || function() {
        var p = _D(arguments, o);
        return n.readField(p, {
          store: n.cache.data,
          variables: p.variables
        });
      } }), l, u = a && this.getTypePolicy(a), d = u && u.keyFn || this.config.dataIdFromObject; d; ) {
        var c = d(ke(ke({}, t), o), s);
        if (Mi(c))
          d = i4(c);
        else {
          l = c;
          break;
        }
      }
      return l = l ? String(l) : void 0, s.keyObject ? [l, s.keyObject] : [l];
    }, e.prototype.addTypePolicies = function(t) {
      var r = this;
      Object.keys(t).forEach(function(i) {
        var n = t[i], a = n.queryType, o = n.mutationType, s = n.subscriptionType, l = es(n, ["queryType", "mutationType", "subscriptionType"]);
        a && r.setRootTypename("Query", i), o && r.setRootTypename("Mutation", i), s && r.setRootTypename("Subscription", i), Yi.call(r.toBeAdded, i) ? r.toBeAdded[i].push(l) : r.toBeAdded[i] = [l];
      });
    }, e.prototype.updateTypePolicy = function(t, r) {
      var i = this, n = this.getTypePolicy(t), a = r.keyFields, o = r.fields;
      function s(l, u) {
        l.merge = typeof u == "function" ? u : u === !0 ? o4 : u === !1 ? s4 : l.merge;
      }
      s(n, r.merge), n.keyFn = // Pass false to disable normalization for this typename.
      a === !1 ? oq : Mi(a) ? i4(a) : typeof a == "function" ? a : n.keyFn, o && Object.keys(o).forEach(function(l) {
        var u = i.getFieldPolicy(t, l, !0), d = o[l];
        if (typeof d == "function")
          u.read = d;
        else {
          var c = d.keyArgs, p = d.read, f = d.merge;
          u.keyFn = // Pass false to disable argument-based differentiation of
          // field identities.
          c === !1 ? a4 : Mi(c) ? n4(c) : typeof c == "function" ? c : u.keyFn, typeof p == "function" && (u.read = p), s(u, f);
        }
        u.read && u.merge && (u.keyFn = u.keyFn || a4);
      });
    }, e.prototype.setRootTypename = function(t, r) {
      r === void 0 && (r = t);
      var i = "ROOT_" + t.toUpperCase(), n = this.rootTypenamesById[i];
      r !== n && (cr(!n || n === t, 5, t), n && delete this.rootIdsByTypename[n], this.rootIdsByTypename[r] = i, this.rootTypenamesById[i] = r);
    }, e.prototype.addPossibleTypes = function(t) {
      var r = this;
      this.usingPossibleTypes = !0, Object.keys(t).forEach(function(i) {
        r.getSupertypeSet(i, !0), t[i].forEach(function(n) {
          r.getSupertypeSet(n, !0).add(i);
          var a = n.match(Gw);
          (!a || a[0] !== n) && r.fuzzySubtypes.set(n, new RegExp(n));
        });
      });
    }, e.prototype.getTypePolicy = function(t) {
      var r = this;
      if (!Yi.call(this.typePolicies, t)) {
        var i = this.typePolicies[t] = /* @__PURE__ */ Object.create(null);
        i.fields = /* @__PURE__ */ Object.create(null);
        var n = this.supertypeMap.get(t);
        !n && this.fuzzySubtypes.size && (n = this.getSupertypeSet(t, !0), this.fuzzySubtypes.forEach(function(o, s) {
          if (o.test(t)) {
            var l = r.supertypeMap.get(s);
            l && l.forEach(function(u) {
              return n.add(u);
            });
          }
        })), n && n.size && n.forEach(function(o) {
          var s = r.getTypePolicy(o), l = s.fields, u = es(s, ["fields"]);
          Object.assign(i, u), Object.assign(i.fields, l);
        });
      }
      var a = this.toBeAdded[t];
      return a && a.length && a.splice(0).forEach(function(o) {
        r.updateTypePolicy(t, o);
      }), this.typePolicies[t];
    }, e.prototype.getFieldPolicy = function(t, r, i) {
      if (t) {
        var n = this.getTypePolicy(t).fields;
        return n[r] || i && (n[r] = /* @__PURE__ */ Object.create(null));
      }
    }, e.prototype.getSupertypeSet = function(t, r) {
      var i = this.supertypeMap.get(t);
      return !i && r && this.supertypeMap.set(t, i = /* @__PURE__ */ new Set()), i;
    }, e.prototype.fragmentMatches = function(t, r, i, n) {
      var a = this;
      if (!t.typeCondition)
        return !0;
      if (!r)
        return !1;
      var o = t.typeCondition.name.value;
      if (r === o)
        return !0;
      if (this.usingPossibleTypes && this.supertypeMap.has(o))
        for (var s = this.getSupertypeSet(r, !0), l = [s], u = function(f) {
          var g = a.getSupertypeSet(f, !1);
          g && g.size && l.indexOf(g) < 0 && l.push(g);
        }, d = !!(i && this.fuzzySubtypes.size), c = 0; c < l.length; ++c) {
          var p = l[c];
          if (p.has(o))
            return s.has(o) || s.add(o), !0;
          p.forEach(u), d && // Start checking fuzzy subtypes only after exhausting all
          // non-fuzzy subtypes (after the final iteration of the loop).
          c === l.length - 1 && // We could wait to compare fragment.selectionSet to result
          // after we verify the supertype, but this check is often less
          // expensive than that search, and we will have to do the
          // comparison anyway whenever we find a potential match.
          y_(t.selectionSet, i, n) && (d = !1, this.fuzzySubtypes.forEach(function(f, g) {
            var k = r.match(f);
            k && k[0] === r && u(g);
          }));
        }
      return !1;
    }, e.prototype.hasKeyArgs = function(t, r) {
      var i = this.getFieldPolicy(t, r, !1);
      return !!(i && i.keyFn);
    }, e.prototype.getStoreFieldName = function(t) {
      var r = t.typename, i = t.fieldName, n = this.getFieldPolicy(r, i, !1), a, o = n && n.keyFn;
      if (o && r)
        for (var s = {
          typename: r,
          fieldName: i,
          field: t.field || null,
          variables: t.variables
        }, l = A_(t); o; ) {
          var u = o(l, s);
          if (Mi(u))
            o = n4(u);
          else {
            a = u || i;
            break;
          }
        }
      return a === void 0 && (a = t.field ? AK(t.field, t.variables) : aD(i, A_(t))), a === !1 ? i : i === Jd(a) ? a : i + ":" + a;
    }, e.prototype.readField = function(t, r) {
      var i = t.from;
      if (i) {
        var n = t.field || t.fieldName;
        if (n) {
          if (t.typename === void 0) {
            var a = r.store.getFieldValue(i, "__typename");
            a && (t.typename = a);
          }
          var o = this.getStoreFieldName(t), s = Jd(o), l = r.store.getFieldValue(i, o), u = this.getFieldPolicy(t.typename, s, !1), d = u && u.read;
          if (d) {
            var c = l4(this, i, t, r, r.store.getStorage(ui(i) ? i.__ref : i, o));
            return vD.withValue(this.cache, d, [
              l,
              c
            ]);
          }
          return l;
        }
      }
    }, e.prototype.getReadFunction = function(t, r) {
      var i = this.getFieldPolicy(t, r, !1);
      return i && i.read;
    }, e.prototype.getMergeFunction = function(t, r, i) {
      var n = this.getFieldPolicy(t, r, !1), a = n && n.merge;
      return !a && i && (n = this.getTypePolicy(i), a = n && n.merge), a;
    }, e.prototype.runMergeFunction = function(t, r, i, n, a) {
      var o = i.field, s = i.typename, l = i.merge;
      return l === o4 ? Zw(n.store)(t, r) : l === s4 ? r : (n.overwrite && (t = void 0), l(t, r, l4(
        this,
        // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0,
        {
          typename: s,
          fieldName: o.name.value,
          field: o,
          variables: n.variables
        },
        n,
        a || /* @__PURE__ */ Object.create(null)
      )));
    }, e;
  }()
);
function l4(e, t, r, i, n) {
  var a = e.getStoreFieldName(r), o = Jd(a), s = r.variables || i.variables, l = i.store, u = l.toReference, d = l.canRead;
  return {
    args: A_(r),
    field: r.field || null,
    fieldName: o,
    storeFieldName: a,
    variables: s,
    isReference: ui,
    toReference: u,
    storage: n,
    cache: e.cache,
    canRead: d,
    readField: function() {
      return e.readField(_D(arguments, t, s), i);
    },
    mergeObjects: Zw(i.store)
  };
}
function _D(e, t, r) {
  var i = e[0], n = e[1], a = e.length, o;
  return typeof i == "string" ? o = {
    fieldName: i,
    // Default to objectOrReference only when no second argument was
    // passed for the from parameter, not when undefined is explicitly
    // passed as the second argument.
    from: a > 1 ? n : t
  } : (o = ke({}, i), Yi.call(o, "from") || (o.from = t)), o.variables === void 0 && (o.variables = r), o;
}
function Zw(e) {
  return function(r, i) {
    if (Mi(r) || Mi(i))
      throw aa(8);
    if (mi(r) && mi(i)) {
      var n = e.getFieldValue(r, "__typename"), a = e.getFieldValue(i, "__typename"), o = n && a && n !== a;
      if (o)
        return i;
      if (ui(r) && Bd(i))
        return e.merge(r.__ref, i), r;
      if (Bd(r) && ui(i))
        return e.merge(r, i.__ref), i;
      if (Bd(r) && Bd(i))
        return ke(ke({}, r), i);
    }
    return i;
  };
}
function Hk(e, t, r) {
  var i = "".concat(t).concat(r), n = e.flavors.get(i);
  return n || e.flavors.set(i, n = e.clientOnly === t && e.deferred === r ? e : ke(ke({}, e), { clientOnly: t, deferred: r })), n;
}
var lq = (
  /** @class */
  function() {
    function e(t, r, i) {
      this.cache = t, this.reader = r, this.fragments = i;
    }
    return e.prototype.writeToStore = function(t, r) {
      var i = this, n = r.query, a = r.result, o = r.dataId, s = r.variables, l = r.overwrite, u = K1(n), d = ZY();
      s = ke(ke({}, oD(u)), s);
      var c = ke(ke({ store: t, written: /* @__PURE__ */ Object.create(null), merge: function(f, g) {
        return d.merge(f, g);
      }, variables: s, varString: qu(s) }, Kw(n, this.fragments)), { overwrite: !!l, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), p = this.processSelectionSet({
        result: a || /* @__PURE__ */ Object.create(null),
        dataId: o,
        selectionSet: u.selectionSet,
        mergeTree: { map: /* @__PURE__ */ new Map() },
        context: c
      });
      if (!ui(p))
        throw aa(11, a);
      return c.incomingById.forEach(function(f, g) {
        var k = f.storeObject, y = f.mergeTree;
        f.fieldNodeSet;
        var _ = jd(g);
        if (y && y.map.size) {
          var A = i.applyMerges(y, _, k, c);
          if (ui(A))
            return;
          k = A;
        }
        t.merge(g, k);
      }), t.retain(p.__ref), p;
    }, e.prototype.processSelectionSet = function(t) {
      var r = this, i = t.dataId, n = t.result, a = t.selectionSet, o = t.context, s = t.mergeTree, l = this.cache.policies, u = /* @__PURE__ */ Object.create(null), d = i && l.rootTypenamesById[i] || c_(n, a, o.fragmentMap) || i && o.store.get(i, "__typename");
      typeof d == "string" && (u.__typename = d);
      var c = function() {
        var T = _D(arguments, u, o.variables);
        if (ui(T.from)) {
          var N = o.incomingById.get(T.from.__ref);
          if (N) {
            var P = l.readField(ke(ke({}, T), { from: N.storeObject }), o);
            if (P !== void 0)
              return P;
          }
        }
        return l.readField(T, o);
      }, p = /* @__PURE__ */ new Set();
      this.flattenFields(
        a,
        n,
        // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        o,
        d
      ).forEach(function(T, N) {
        var P, B = oc(N), M = n[B];
        if (p.add(N), M !== void 0) {
          var X = l.getStoreFieldName({
            typename: d,
            fieldName: N.name.value,
            field: N,
            variables: T.variables
          }), U = u4(s, X), K = r.processFieldValue(
            M,
            N,
            // Reset context.clientOnly and context.deferred to their default
            // values before processing nested selection sets.
            N.selectionSet ? Hk(T, !1, !1) : T,
            U
          ), z = void 0;
          N.selectionSet && (ui(K) || Bd(K)) && (z = c("__typename", K));
          var j = l.getMergeFunction(d, N.name.value, z);
          j ? U.info = {
            // TODO Check compatibility against any existing childTree.field?
            field: N,
            typename: d,
            merge: j
          } : c4(s, X), u = T.merge(u, (P = {}, P[X] = K, P));
        }
      });
      try {
        var f = l.identify(n, {
          typename: d,
          selectionSet: a,
          fragmentMap: o.fragmentMap,
          storeObject: u,
          readField: c
        }), g = f[0], k = f[1];
        i = i || g, k && (u = o.merge(u, k));
      } catch (T) {
        if (!i)
          throw T;
      }
      if (typeof i == "string") {
        var y = jd(i), _ = o.written[i] || (o.written[i] = []);
        if (_.indexOf(a) >= 0 || (_.push(a), this.reader && this.reader.isFresh(n, y, a, o)))
          return y;
        var A = o.incomingById.get(i);
        return A ? (A.storeObject = o.merge(A.storeObject, u), A.mergeTree = w_(A.mergeTree, s), p.forEach(function(T) {
          return A.fieldNodeSet.add(T);
        })) : o.incomingById.set(i, {
          storeObject: u,
          // Save a reference to mergeTree only if it is not empty, because
          // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
          // reused for entirely different parts of the result tree.
          mergeTree: jg(s) ? void 0 : s,
          fieldNodeSet: p
        }), y;
      }
      return u;
    }, e.prototype.processFieldValue = function(t, r, i, n) {
      var a = this;
      return !r.selectionSet || t === null ? t : Mi(t) ? t.map(function(o, s) {
        var l = a.processFieldValue(o, r, i, u4(n, s));
        return c4(n, s), l;
      }) : this.processSelectionSet({
        result: t,
        selectionSet: r.selectionSet,
        context: i,
        mergeTree: n
      });
    }, e.prototype.flattenFields = function(t, r, i, n) {
      n === void 0 && (n = c_(r, t, i.fragmentMap));
      var a = /* @__PURE__ */ new Map(), o = this.cache.policies, s = new W1(!1);
      return function l(u, d) {
        var c = s.lookup(
          u,
          // Because we take inheritedClientOnly and inheritedDeferred into
          // consideration here (in addition to selectionSet), it's possible for
          // the same selection set to be flattened more than once, if it appears
          // in the query with different @client and/or @directive configurations.
          d.clientOnly,
          d.deferred
        );
        c.visited || (c.visited = !0, u.selections.forEach(function(p) {
          if (V1(p, i.variables)) {
            var f = d.clientOnly, g = d.deferred;
            if (
              // Since the presence of @client or @defer on this field can only
              // cause clientOnly or deferred to become true, we can skip the
              // forEach loop if both clientOnly and deferred are already true.
              !(f && g) && Ya(p.directives) && p.directives.forEach(function(_) {
                var A = _.name.value;
                if (A === "client" && (f = !0), A === "defer") {
                  var T = Sm(_, i.variables);
                  (!T || T.if !== !1) && (g = !0);
                }
              }), Ll(p)
            ) {
              var k = a.get(p);
              k && (f = f && k.clientOnly, g = g && k.deferred), a.set(p, Hk(i, f, g));
            } else {
              var y = Tm(p, i.lookupFragment);
              if (!y && p.kind === bt.FRAGMENT_SPREAD)
                throw aa(13, p.name.value);
              y && o.fragmentMatches(y, n, r, i.variables) && l(y.selectionSet, Hk(i, f, g));
            }
          }
        }));
      }(t, i), a;
    }, e.prototype.applyMerges = function(t, r, i, n, a) {
      var o, s = this;
      if (t.map.size && !ui(i)) {
        var l = (
          // Items in the same position in different arrays are not
          // necessarily related to each other, so when incoming is an array
          // we process its elements as if there was no existing data.
          !Mi(i) && // Likewise, existing must be either a Reference or a StoreObject
          // in order for its fields to be safe to merge with the fields of
          // the incoming object.
          (ui(r) || Bd(r)) ? r : void 0
        ), u = i;
        l && !a && (a = [ui(l) ? l.__ref : l]);
        var d, c = function(p, f) {
          return Mi(p) ? typeof f == "number" ? p[f] : void 0 : n.store.getFieldValue(p, String(f));
        };
        t.map.forEach(function(p, f) {
          var g = c(l, f), k = c(u, f);
          if (k !== void 0) {
            a && a.push(f);
            var y = s.applyMerges(p, g, k, n, a);
            y !== k && (d = d || /* @__PURE__ */ new Map(), d.set(f, y)), a && cr(a.pop() === f);
          }
        }), d && (i = Mi(u) ? u.slice(0) : ke({}, u), d.forEach(function(p, f) {
          i[f] = p;
        }));
      }
      return t.info ? this.cache.policies.runMergeFunction(r, i, t.info, n, a && (o = n.store).getStorage.apply(o, a)) : i;
    }, e;
  }()
), Jw = [];
function u4(e, t) {
  var r = e.map;
  return r.has(t) || r.set(t, Jw.pop() || { map: /* @__PURE__ */ new Map() }), r.get(t);
}
function w_(e, t) {
  if (e === t || !t || jg(t))
    return e;
  if (!e || jg(e))
    return t;
  var r = e.info && t.info ? ke(ke({}, e.info), t.info) : e.info || t.info, i = e.map.size && t.map.size, n = i ? /* @__PURE__ */ new Map() : e.map.size ? e.map : t.map, a = { info: r, map: n };
  if (i) {
    var o = new Set(t.map.keys());
    e.map.forEach(function(s, l) {
      a.map.set(l, w_(s, t.map.get(l))), o.delete(l);
    }), o.forEach(function(s) {
      a.map.set(s, w_(t.map.get(s), e.map.get(s)));
    });
  }
  return a;
}
function jg(e) {
  return !e || !(e.info || e.map.size);
}
function c4(e, t) {
  var r = e.map, i = r.get(t);
  i && jg(i) && (Jw.push(i), r.delete(t));
}
var uq = (
  /** @class */
  function(e) {
    Qa(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var i = e.call(this) || this;
      return i.watches = /* @__PURE__ */ new Set(), i.addTypenameTransform = new bw(yw), i.assumeImmutableResults = !0, i.makeVar = Om, i.txCount = 0, i.config = XY(r), i.addTypename = !!i.config.addTypename, i.policies = new sq({
        cache: i,
        dataIdFromObject: i.config.dataIdFromObject,
        possibleTypes: i.config.possibleTypes,
        typePolicies: i.config.typePolicies
      }), i.init(), i;
    }
    return t.prototype.init = function() {
      var r = this.data = new E1.Root({
        policies: this.policies,
        resultCaching: this.config.resultCaching
      });
      this.optimisticData = r.stump, this.resetResultCache();
    }, t.prototype.resetResultCache = function(r) {
      var i = this, n = this.storeReader, a = this.config.fragments;
      this.storeWriter = new lq(this, this.storeReader = new rq({
        cache: this,
        addTypename: this.addTypename,
        resultCacheMaxSize: this.config.resultCacheMaxSize,
        canonizeResults: Ww(this.config),
        canon: r ? void 0 : n && n.canon,
        fragments: a
      }), a), this.maybeBroadcastWatch = Mg(function(o, s) {
        return i.broadcastWatch(o, s);
      }, {
        max: this.config.resultCacheMaxSize,
        makeCacheKey: function(o) {
          var s = o.optimistic ? i.optimisticData : i.data;
          if (Q0(s)) {
            var l = o.optimistic, u = o.id, d = o.variables;
            return s.makeCacheKey(
              o.query,
              // Different watches can have the same query, optimistic
              // status, rootId, and variables, but if their callbacks are
              // different, the (identical) result needs to be delivered to
              // each distinct callback. The easiest way to achieve that
              // separation is to include c.callback in the cache key for
              // maybeBroadcastWatch calls. See issue #5733.
              o.callback,
              qu({ optimistic: l, id: u, variables: d })
            );
          }
        }
      }), (/* @__PURE__ */ new Set([this.data.group, this.optimisticData.group])).forEach(function(o) {
        return o.resetCaching();
      });
    }, t.prototype.restore = function(r) {
      return this.init(), r && this.data.replace(r), this;
    }, t.prototype.extract = function(r) {
      return r === void 0 && (r = !1), (r ? this.optimisticData : this.data).extract();
    }, t.prototype.read = function(r) {
      var i = r.returnPartialData, n = i === void 0 ? !1 : i;
      try {
        return this.storeReader.diffQueryAgainstStore(ke(ke({}, r), { store: r.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: n })).result || null;
      } catch (a) {
        if (a instanceof $w)
          return null;
        throw a;
      }
    }, t.prototype.write = function(r) {
      try {
        return ++this.txCount, this.storeWriter.writeToStore(this.data, r);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.modify = function(r) {
      if (Yi.call(r, "id") && !r.id)
        return !1;
      var i = r.optimistic ? this.optimisticData : this.data;
      try {
        return ++this.txCount, i.modify(r.id || "ROOT_QUERY", r.fields);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.diff = function(r) {
      return this.storeReader.diffQueryAgainstStore(ke(ke({}, r), { store: r.optimistic ? this.optimisticData : this.data, rootId: r.id || "ROOT_QUERY", config: this.config }));
    }, t.prototype.watch = function(r) {
      var i = this;
      return this.watches.size || nq(this), this.watches.add(r), r.immediate && this.maybeBroadcastWatch(r), function() {
        i.watches.delete(r) && !i.watches.size && t4(i), i.maybeBroadcastWatch.forget(r);
      };
    }, t.prototype.gc = function(r) {
      qu.reset();
      var i = this.optimisticData.gc();
      return r && !this.txCount && (r.resetResultCache ? this.resetResultCache(r.resetResultIdentities) : r.resetResultIdentities && this.storeReader.resetCanon()), i;
    }, t.prototype.retain = function(r, i) {
      return (i ? this.optimisticData : this.data).retain(r);
    }, t.prototype.release = function(r, i) {
      return (i ? this.optimisticData : this.data).release(r);
    }, t.prototype.identify = function(r) {
      if (ui(r))
        return r.__ref;
      try {
        return this.policies.identify(r)[0];
      } catch {
      }
    }, t.prototype.evict = function(r) {
      if (!r.id) {
        if (Yi.call(r, "id"))
          return !1;
        r = ke(ke({}, r), { id: "ROOT_QUERY" });
      }
      try {
        return ++this.txCount, this.optimisticData.evict(r, this.data);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.reset = function(r) {
      var i = this;
      return this.init(), qu.reset(), r && r.discardWatches ? (this.watches.forEach(function(n) {
        return i.maybeBroadcastWatch.forget(n);
      }), this.watches.clear(), t4(this)) : this.broadcastWatches(), Promise.resolve();
    }, t.prototype.removeOptimistic = function(r) {
      var i = this.optimisticData.removeLayer(r);
      i !== this.optimisticData && (this.optimisticData = i, this.broadcastWatches());
    }, t.prototype.batch = function(r) {
      var i = this, n = r.update, a = r.optimistic, o = a === void 0 ? !0 : a, s = r.removeOptimistic, l = r.onWatchUpdated, u, d = function(p) {
        var f = i, g = f.data, k = f.optimisticData;
        ++i.txCount, p && (i.data = i.optimisticData = p);
        try {
          return u = n(i);
        } finally {
          --i.txCount, i.data = g, i.optimisticData = k;
        }
      }, c = /* @__PURE__ */ new Set();
      return l && !this.txCount && this.broadcastWatches(ke(ke({}, r), { onWatchUpdated: function(p) {
        return c.add(p), !1;
      } })), typeof o == "string" ? this.optimisticData = this.optimisticData.addLayer(o, d) : o === !1 ? d(this.data) : d(), typeof s == "string" && (this.optimisticData = this.optimisticData.removeLayer(s)), l && c.size ? (this.broadcastWatches(ke(ke({}, r), { onWatchUpdated: function(p, f) {
        var g = l.call(this, p, f);
        return g !== !1 && c.delete(p), g;
      } })), c.size && c.forEach(function(p) {
        return i.maybeBroadcastWatch.dirty(p);
      })) : this.broadcastWatches(r), u;
    }, t.prototype.performTransaction = function(r, i) {
      return this.batch({
        update: r,
        optimistic: i || i !== null
      });
    }, t.prototype.transformDocument = function(r) {
      return this.addTypenameToDocument(this.addFragmentsToDocument(r));
    }, t.prototype.broadcastWatches = function(r) {
      var i = this;
      this.txCount || this.watches.forEach(function(n) {
        return i.maybeBroadcastWatch(n, r);
      });
    }, t.prototype.addFragmentsToDocument = function(r) {
      var i = this.config.fragments;
      return i ? i.transform(r) : r;
    }, t.prototype.addTypenameToDocument = function(r) {
      return this.addTypename ? this.addTypenameTransform.transformDocument(r) : r;
    }, t.prototype.broadcastWatch = function(r, i) {
      var n = r.lastDiff, a = this.diff(r);
      i && (r.optimistic && typeof i.optimistic == "string" && (a.fromOptimisticTransaction = !0), i.onWatchUpdated && i.onWatchUpdated.call(this, r, a, n) === !1) || (!n || !qr(n.result, a.result)) && r.callback(r.lastDiff = a, n);
    }, t;
  }(QY)
), mr;
(function(e) {
  e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
})(mr || (mr = {}));
function C1(e) {
  return e ? e < 7 : !1;
}
function cq(e, t, r, i) {
  var n = t.data, a = es(t, ["data"]), o = r.data, s = es(r, ["data"]);
  return qr(a, s) && Qf(sc(e).selectionSet, n, o, {
    fragmentMap: Fm(Im(e)),
    variables: i
  });
}
function Qf(e, t, r, i) {
  if (t === r)
    return !0;
  var n = /* @__PURE__ */ new Set();
  return e.selections.every(function(a) {
    if (n.has(a) || (n.add(a), !V1(a, i.variables)) || d4(a))
      return !0;
    if (Ll(a)) {
      var o = oc(a), s = t && t[o], l = r && r[o], u = a.selectionSet;
      if (!u)
        return qr(s, l);
      var d = Array.isArray(s), c = Array.isArray(l);
      if (d !== c)
        return !1;
      if (d && c) {
        var p = s.length;
        if (l.length !== p)
          return !1;
        for (var f = 0; f < p; ++f)
          if (!Qf(u, s[f], l[f], i))
            return !1;
        return !0;
      }
      return Qf(u, s, l, i);
    } else {
      var g = Tm(a, i.fragmentMap);
      if (g)
        return d4(g) ? !0 : Qf(
          g.selectionSet,
          // Notice that we reuse the same aResult and bResult values here,
          // since the fragment ...spread does not specify a field name, but
          // consists of multiple fields (within the fragment's selection set)
          // that should be applied to the current result value(s).
          t,
          r,
          i
        );
    }
  });
}
function d4(e) {
  return !!e.directives && e.directives.some(dq);
}
function dq(e) {
  return e.name.value === "nonreactive";
}
var p4 = Object.assign, F_ = (
  /** @class */
  function(e) {
    Qa(t, e);
    function t(r) {
      var i = r.queryManager, n = r.queryInfo, a = r.options, o = e.call(this, function(y) {
        try {
          var _ = y._subscription._observer;
          _ && !_.error && (_.error = pq);
        } catch {
        }
        var A = !o.observers.size;
        o.observers.add(y);
        var T = o.last;
        return T && T.error ? y.error && y.error(T.error) : T && T.result && y.next && y.next(T.result), A && o.reobserve().catch(function() {
        }), function() {
          o.observers.delete(y) && !o.observers.size && o.tearDownQuery();
        };
      }) || this;
      o.observers = /* @__PURE__ */ new Set(), o.subscriptions = /* @__PURE__ */ new Set(), o.queryInfo = n, o.queryManager = i, o.waitForOwnResult = $k(a.fetchPolicy), o.isTornDown = !1;
      var s = i.defaultOptions.watchQuery, l = s === void 0 ? {} : s, u = l.fetchPolicy, d = u === void 0 ? "cache-first" : u, c = a.fetchPolicy, p = c === void 0 ? d : c, f = a.initialFetchPolicy, g = f === void 0 ? p === "standby" ? d : p : f;
      o.options = ke(ke({}, a), {
        // Remember the initial options.fetchPolicy so we can revert back to this
        // policy when variables change. This information can also be specified
        // (or overridden) by providing options.initialFetchPolicy explicitly.
        initialFetchPolicy: g,
        // This ensures this.options.fetchPolicy always has a string value, in
        // case options.fetchPolicy was not provided.
        fetchPolicy: p
      }), o.queryId = n.queryId || i.generateQueryId();
      var k = K1(o.query);
      return o.queryName = k && k.name && k.name.value, o;
    }
    return Object.defineProperty(t.prototype, "query", {
      // The `query` computed property will always reflect the document transformed
      // by the last run query. `this.options.query` will always reflect the raw
      // untransformed query to ensure document transforms with runtime conditionals
      // are run on the original document.
      get: function() {
        return this.lastQuery || this.options.query;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "variables", {
      // Computed shorthand for this.options.variables, preserved for
      // backwards compatibility.
      get: function() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.result = function() {
      var r = this;
      return new Promise(function(i, n) {
        var a = {
          next: function(s) {
            i(s), r.observers.delete(a), r.observers.size || r.queryManager.removeQuery(r.queryId), setTimeout(function() {
              o.unsubscribe();
            }, 0);
          },
          error: n
        }, o = r.subscribe(a);
      });
    }, t.prototype.getCurrentResult = function(r) {
      r === void 0 && (r = !0);
      var i = this.getLastResult(!0), n = this.queryInfo.networkStatus || i && i.networkStatus || mr.ready, a = ke(ke({}, i), { loading: C1(n), networkStatus: n }), o = this.options.fetchPolicy, s = o === void 0 ? "cache-first" : o;
      if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        !($k(s) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
      )
        if (this.waitForOwnResult)
          this.queryInfo.updateWatch();
        else {
          var l = this.queryInfo.getDiff();
          (l.complete || this.options.returnPartialData) && (a.data = l.result), qr(a.data, {}) && (a.data = void 0), l.complete ? (delete a.partial, l.complete && a.networkStatus === mr.loading && (s === "cache-first" || s === "cache-only") && (a.networkStatus = mr.ready, a.loading = !1)) : a.partial = !0;
        }
      return r && this.updateLastResult(a), a;
    }, t.prototype.isDifferentFromLastResult = function(r, i) {
      if (!this.last)
        return !0;
      var n = this.queryManager.getDocumentInfo(this.query).hasNonreactiveDirective ? !cq(this.query, this.last.result, r, this.variables) : !qr(this.last.result, r);
      return n || i && !qr(this.last.variables, i);
    }, t.prototype.getLast = function(r, i) {
      var n = this.last;
      if (n && n[r] && (!i || qr(n.variables, this.variables)))
        return n[r];
    }, t.prototype.getLastResult = function(r) {
      return this.getLast("result", r);
    }, t.prototype.getLastError = function(r) {
      return this.getLast("error", r);
    }, t.prototype.resetLastResults = function() {
      delete this.last, this.isTornDown = !1;
    }, t.prototype.resetQueryStoreErrors = function() {
      this.queryManager.resetErrors(this.queryId);
    }, t.prototype.refetch = function(r) {
      var i = {
        // Always disable polling for refetches.
        pollInterval: 0
      }, n = this.options.fetchPolicy;
      return n === "cache-and-network" ? i.fetchPolicy = n : n === "no-cache" ? i.fetchPolicy = "no-cache" : i.fetchPolicy = "network-only", r && !qr(this.options.variables, r) && (i.variables = this.options.variables = ke(ke({}, this.options.variables), r)), this.queryInfo.resetLastWrite(), this.reobserve(i, mr.refetch);
    }, t.prototype.fetchMore = function(r) {
      var i = this, n = ke(ke({}, r.query ? r : ke(ke(ke(ke({}, this.options), { query: this.options.query }), r), { variables: ke(ke({}, this.options.variables), r.variables) })), {
        // The fetchMore request goes immediately to the network and does
        // not automatically write its result to the cache (hence no-cache
        // instead of network-only), because we allow the caller of
        // fetchMore to provide an updateQuery callback that determines how
        // the data gets written to the cache.
        fetchPolicy: "no-cache"
      });
      n.query = this.transformDocument(n.query);
      var a = this.queryManager.generateQueryId();
      this.lastQuery = r.query ? this.transformDocument(this.options.query) : n.query;
      var o = this.queryInfo, s = o.networkStatus;
      o.networkStatus = mr.fetchMore, n.notifyOnNetworkStatusChange && this.observe();
      var l = /* @__PURE__ */ new Set();
      return this.queryManager.fetchQuery(a, n, mr.fetchMore).then(function(u) {
        return i.queryManager.removeQuery(a), o.networkStatus === mr.fetchMore && (o.networkStatus = s), i.queryManager.cache.batch({
          update: function(d) {
            var c = r.updateQuery;
            c ? d.updateQuery({
              query: i.query,
              variables: i.variables,
              returnPartialData: !0,
              optimistic: !1
            }, function(p) {
              return c(p, {
                fetchMoreResult: u.data,
                variables: n.variables
              });
            }) : d.writeQuery({
              query: n.query,
              variables: n.variables,
              data: u.data
            });
          },
          onWatchUpdated: function(d) {
            l.add(d.query);
          }
        }), u;
      }).finally(function() {
        l.has(i.query) || eF(i);
      });
    }, t.prototype.subscribeToMore = function(r) {
      var i = this, n = this.queryManager.startGraphQLSubscription({
        query: r.document,
        variables: r.variables,
        context: r.context
      }).subscribe({
        next: function(a) {
          var o = r.updateQuery;
          o && i.updateQuery(function(s, l) {
            var u = l.variables;
            return o(s, {
              subscriptionData: a,
              variables: u
            });
          });
        },
        error: function(a) {
          if (r.onError) {
            r.onError(a);
            return;
          }
        }
      });
      return this.subscriptions.add(n), function() {
        i.subscriptions.delete(n) && n.unsubscribe();
      };
    }, t.prototype.setOptions = function(r) {
      return this.reobserve(r);
    }, t.prototype.silentSetOptions = function(r) {
      var i = lc(this.options, r || {});
      p4(this.options, i);
    }, t.prototype.setVariables = function(r) {
      return qr(this.variables, r) ? this.observers.size ? this.result() : Promise.resolve() : (this.options.variables = r, this.observers.size ? this.reobserve({
        // Reset options.fetchPolicy to its original value.
        fetchPolicy: this.options.initialFetchPolicy,
        variables: r
      }, mr.setVariables) : Promise.resolve());
    }, t.prototype.updateQuery = function(r) {
      var i = this.queryManager, n = i.cache.diff({
        query: this.options.query,
        variables: this.variables,
        returnPartialData: !0,
        optimistic: !1
      }).result, a = r(n, {
        variables: this.variables
      });
      a && (i.cache.writeQuery({
        query: this.options.query,
        data: a,
        variables: this.variables
      }), i.broadcastQueries());
    }, t.prototype.startPolling = function(r) {
      this.options.pollInterval = r, this.updatePolling();
    }, t.prototype.stopPolling = function() {
      this.options.pollInterval = 0, this.updatePolling();
    }, t.prototype.applyNextFetchPolicy = function(r, i) {
      if (i.nextFetchPolicy) {
        var n = i.fetchPolicy, a = n === void 0 ? "cache-first" : n, o = i.initialFetchPolicy, s = o === void 0 ? a : o;
        a === "standby" || (typeof i.nextFetchPolicy == "function" ? i.fetchPolicy = i.nextFetchPolicy(a, {
          reason: r,
          options: i,
          observable: this,
          initialFetchPolicy: s
        }) : r === "variables-changed" ? i.fetchPolicy = s : i.fetchPolicy = i.nextFetchPolicy);
      }
      return i.fetchPolicy;
    }, t.prototype.fetch = function(r, i, n) {
      return this.queryManager.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(this.queryId, r, i, n);
    }, t.prototype.updatePolling = function() {
      var r = this;
      if (!this.queryManager.ssrMode) {
        var i = this, n = i.pollingInfo, a = i.options.pollInterval;
        if (!a) {
          n && (clearTimeout(n.timeout), delete this.pollingInfo);
          return;
        }
        if (!(n && n.interval === a)) {
          cr(a, 22);
          var o = n || (this.pollingInfo = {});
          o.interval = a;
          var s = function() {
            r.pollingInfo && (C1(r.queryInfo.networkStatus) ? l() : r.reobserve({
              // Most fetchPolicy options don't make sense to use in a polling context, as
              // users wouldn't want to be polling the cache directly. However, network-only and
              // no-cache are both useful for when the user wants to control whether or not the
              // polled results are written to the cache.
              fetchPolicy: r.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
            }, mr.poll).then(l, l));
          }, l = function() {
            var u = r.pollingInfo;
            u && (clearTimeout(u.timeout), u.timeout = setTimeout(s, u.interval));
          };
          l();
        }
      }
    }, t.prototype.updateLastResult = function(r, i) {
      i === void 0 && (i = this.variables);
      var n = this.getLastError();
      return n && this.last && !qr(i, this.last.variables) && (n = void 0), this.last = ke({ result: this.queryManager.assumeImmutableResults ? r : KK(r), variables: i }, n ? { error: n } : null);
    }, t.prototype.reobserveAsConcast = function(r, i) {
      var n = this;
      this.isTornDown = !1;
      var a = (
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        i === mr.refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        i === mr.fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        i === mr.poll
      ), o = this.options.variables, s = this.options.fetchPolicy, l = lc(this.options, r || {}), u = a ? (
        // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        l
      ) : p4(this.options, l), d = this.transformDocument(u.query);
      this.lastQuery = d, a || (this.updatePolling(), r && r.variables && !qr(r.variables, o) && // Don't mess with the fetchPolicy if it's currently "standby".
      u.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
      // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
      u.fetchPolicy === s && (this.applyNextFetchPolicy("variables-changed", u), i === void 0 && (i = mr.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = $k(u.fetchPolicy));
      var c = function() {
        n.concast === g && (n.waitForOwnResult = !1);
      }, p = u.variables && ke({}, u.variables), f = this.fetch(u, i, d), g = f.concast, k = f.fromLink, y = {
        next: function(_) {
          c(), n.reportResult(_, p);
        },
        error: function(_) {
          c(), n.reportError(_, p);
        }
      };
      return !a && (k || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = g, this.observer = y), g.addObserver(y), g;
    }, t.prototype.reobserve = function(r, i) {
      return this.reobserveAsConcast(r, i).promise;
    }, t.prototype.resubscribeAfterError = function() {
      for (var r = [], i = 0; i < arguments.length; i++)
        r[i] = arguments[i];
      var n = this.last;
      this.resetLastResults();
      var a = this.subscribe.apply(this, r);
      return this.last = n, a;
    }, t.prototype.observe = function() {
      this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentResult(!1),
        this.variables
      );
    }, t.prototype.reportResult = function(r, i) {
      var n = this.getLastError(), a = this.isDifferentFromLastResult(r, i);
      (n || !r.partial || this.options.returnPartialData) && this.updateLastResult(r, i), (n || a) && q0(this.observers, "next", r);
    }, t.prototype.reportError = function(r, i) {
      var n = ke(ke({}, this.getLastResult()), { error: r, errors: r.graphQLErrors, networkStatus: mr.error, loading: !1 });
      this.updateLastResult(n, i), q0(this.observers, "error", this.last.error = r);
    }, t.prototype.hasObservers = function() {
      return this.observers.size > 0;
    }, t.prototype.tearDownQuery = function() {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(r) {
        return r.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, t.prototype.transformDocument = function(r) {
      return this.queryManager.transform(r);
    }, t;
  }(Yr)
);
ww(F_);
function eF(e) {
  var t = e.options, r = t.fetchPolicy, i = t.nextFetchPolicy;
  return r === "cache-and-network" || r === "network-only" ? e.reobserve({
    fetchPolicy: "cache-first",
    // Use a temporary nextFetchPolicy function that replaces itself with the
    // previous nextFetchPolicy value and returns the original fetchPolicy.
    nextFetchPolicy: function(n, a) {
      return this.nextFetchPolicy = i, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(n, a) : r;
    }
  }) : e.reobserve();
}
function pq(e) {
}
function $k(e) {
  return e === "network-only" || e === "no-cache" || e === "standby";
}
var tF = (
  /** @class */
  function() {
    function e(t) {
      var r = t.cache, i = t.client, n = t.resolvers, a = t.fragmentMatcher;
      this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = r, i && (this.client = i), n && this.addResolvers(n), a && this.setFragmentMatcher(a);
    }
    return e.prototype.addResolvers = function(t) {
      var r = this;
      this.resolvers = this.resolvers || {}, Array.isArray(t) ? t.forEach(function(i) {
        r.resolvers = S9(r.resolvers, i);
      }) : this.resolvers = S9(this.resolvers, t);
    }, e.prototype.setResolvers = function(t) {
      this.resolvers = {}, this.addResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.resolvers || {};
    }, e.prototype.runResolvers = function(t) {
      var r = t.document, i = t.remoteResult, n = t.context, a = t.variables, o = t.onlyRunForcedResolvers, s = o === void 0 ? !1 : o;
      return bl(this, void 0, void 0, function() {
        return _l(this, function(l) {
          return r ? [2, this.resolveDocument(r, i.data, n, a, this.fragmentMatcher, s).then(function(u) {
            return ke(ke({}, i), { data: u.result });
          })] : [2, i];
        });
      });
    }, e.prototype.setFragmentMatcher = function(t) {
      this.fragmentMatcher = t;
    }, e.prototype.getFragmentMatcher = function() {
      return this.fragmentMatcher;
    }, e.prototype.clientQuery = function(t) {
      return D1(["client"], t) && this.resolvers ? t : null;
    }, e.prototype.serverQuery = function(t) {
      return Ew(t);
    }, e.prototype.prepareContext = function(t) {
      var r = this.cache;
      return ke(ke({}, t), {
        cache: r,
        // Getting an entry's cache key is useful for local state resolvers.
        getCacheKey: function(i) {
          return r.identify(i);
        }
      });
    }, e.prototype.addExportedVariables = function(t, r, i) {
      return r === void 0 && (r = {}), i === void 0 && (i = {}), bl(this, void 0, void 0, function() {
        return _l(this, function(n) {
          return t ? [2, this.resolveDocument(t, this.buildRootValueFromCache(t, r) || {}, this.prepareContext(i), r).then(function(a) {
            return ke(ke({}, r), a.exportedVariables);
          })] : [2, ke({}, r)];
        });
      });
    }, e.prototype.shouldForceResolvers = function(t) {
      var r = !1;
      return Ms(t, {
        Directive: {
          enter: function(i) {
            if (i.name.value === "client" && i.arguments && (r = i.arguments.some(function(n) {
              return n.name.value === "always" && n.value.kind === "BooleanValue" && n.value.value === !0;
            }), r))
              return eD;
          }
        }
      }), r;
    }, e.prototype.buildRootValueFromCache = function(t, r) {
      return this.cache.diff({
        query: PK(t),
        variables: r,
        returnPartialData: !0,
        optimistic: !1
      }).result;
    }, e.prototype.resolveDocument = function(t, r, i, n, a, o) {
      return i === void 0 && (i = {}), n === void 0 && (n = {}), a === void 0 && (a = function() {
        return !0;
      }), o === void 0 && (o = !1), bl(this, void 0, void 0, function() {
        var s, l, u, d, c, p, f, g, k, y, _;
        return _l(this, function(A) {
          return s = sc(t), l = Im(t), u = Fm(l), d = this.collectSelectionsToResolve(s, u), c = s.operation, p = c ? c.charAt(0).toUpperCase() + c.slice(1) : "Query", f = this, g = f.cache, k = f.client, y = {
            fragmentMap: u,
            context: ke(ke({}, i), { cache: g, client: k }),
            variables: n,
            fragmentMatcher: a,
            defaultOperationType: p,
            exportedVariables: {},
            selectionsToResolve: d,
            onlyRunForcedResolvers: o
          }, _ = !1, [2, this.resolveSelectionSet(s.selectionSet, _, r, y).then(function(T) {
            return {
              result: T,
              exportedVariables: y.exportedVariables
            };
          })];
        });
      });
    }, e.prototype.resolveSelectionSet = function(t, r, i, n) {
      return bl(this, void 0, void 0, function() {
        var a, o, s, l, u, d = this;
        return _l(this, function(c) {
          return a = n.fragmentMap, o = n.context, s = n.variables, l = [i], u = function(p) {
            return bl(d, void 0, void 0, function() {
              var f, g;
              return _l(this, function(k) {
                return !r && !n.selectionsToResolve.has(p) ? [
                  2
                  /*return*/
                ] : V1(p, s) ? Ll(p) ? [2, this.resolveField(p, r, i, n).then(function(y) {
                  var _;
                  typeof y < "u" && l.push((_ = {}, _[oc(p)] = y, _));
                })] : (TK(p) ? f = p : (f = a[p.name.value], cr(f, 18, p.name.value)), f && f.typeCondition && (g = f.typeCondition.name.value, n.fragmentMatcher(i, g, o)) ? [2, this.resolveSelectionSet(f.selectionSet, r, i, n).then(function(y) {
                  l.push(y);
                })] : [
                  2
                  /*return*/
                ]) : [
                  2
                  /*return*/
                ];
              });
            });
          }, [2, Promise.all(t.selections.map(u)).then(function() {
            return lD(l);
          })];
        });
      });
    }, e.prototype.resolveField = function(t, r, i, n) {
      return bl(this, void 0, void 0, function() {
        var a, o, s, l, u, d, c, p, f, g = this;
        return _l(this, function(k) {
          return i ? (a = n.variables, o = t.name.value, s = oc(t), l = o !== s, u = i[s] || i[o], d = Promise.resolve(u), (!n.onlyRunForcedResolvers || this.shouldForceResolvers(t)) && (c = i.__typename || n.defaultOperationType, p = this.resolvers && this.resolvers[c], p && (f = p[l ? o : s], f && (d = Promise.resolve(
            // In case the resolve function accesses reactive variables,
            // set cacheSlot to the current cache instance.
            vD.withValue(this.cache, f, [
              i,
              Sm(t, a),
              n.context,
              { field: t, fragmentMap: n.fragmentMap }
            ])
          )))), [2, d.then(function(y) {
            var _, A;
            if (y === void 0 && (y = u), t.directives && t.directives.forEach(function(N) {
              N.name.value === "export" && N.arguments && N.arguments.forEach(function(P) {
                P.name.value === "as" && P.value.kind === "StringValue" && (n.exportedVariables[P.value.value] = y);
              });
            }), !t.selectionSet || y == null)
              return y;
            var T = (A = (_ = t.directives) === null || _ === void 0 ? void 0 : _.some(function(N) {
              return N.name.value === "client";
            })) !== null && A !== void 0 ? A : !1;
            if (Array.isArray(y))
              return g.resolveSubSelectedArray(t, r || T, y, n);
            if (t.selectionSet)
              return g.resolveSelectionSet(t.selectionSet, r || T, y, n);
          })]) : [2, null];
        });
      });
    }, e.prototype.resolveSubSelectedArray = function(t, r, i, n) {
      var a = this;
      return Promise.all(i.map(function(o) {
        if (o === null)
          return null;
        if (Array.isArray(o))
          return a.resolveSubSelectedArray(t, r, o, n);
        if (t.selectionSet)
          return a.resolveSelectionSet(t.selectionSet, r, o, n);
      }));
    }, e.prototype.collectSelectionsToResolve = function(t, r) {
      var i = function(o) {
        return !Array.isArray(o);
      }, n = this.selectionsToResolveCache;
      function a(o) {
        if (!n.has(o)) {
          var s = /* @__PURE__ */ new Set();
          n.set(o, s), Ms(o, {
            Directive: function(l, u, d, c, p) {
              l.name.value === "client" && p.forEach(function(f) {
                i(f) && y9(f) && s.add(f);
              });
            },
            FragmentSpread: function(l, u, d, c, p) {
              var f = r[l.name.value];
              cr(f, 19, l.name.value);
              var g = a(f);
              g.size > 0 && (p.forEach(function(k) {
                i(k) && y9(k) && s.add(k);
              }), s.add(l), g.forEach(function(k) {
                s.add(k);
              }));
            }
          });
        }
        return n.get(o);
      }
      return a(t);
    }, e;
  }()
), Rd = new (us ? WeakMap : Map)();
function Uk(e, t) {
  var r = e[t];
  typeof r == "function" && (e[t] = function() {
    return Rd.set(
      e,
      // The %1e15 allows the count to wrap around to 0 safely every
      // quadrillion evictions, so there's no risk of overflow. To be
      // clear, this is more of a pedantic principle than something
      // that matters in any conceivable practical scenario.
      (Rd.get(e) + 1) % 1e15
    ), r.apply(this, arguments);
  });
}
function h4(e) {
  e.notifyTimeout && (clearTimeout(e.notifyTimeout), e.notifyTimeout = void 0);
}
var Vk = (
  /** @class */
  function() {
    function e(t, r) {
      r === void 0 && (r = t.generateQueryId()), this.queryId = r, this.listeners = /* @__PURE__ */ new Set(), this.document = null, this.lastRequestId = 1, this.stopped = !1, this.dirty = !1, this.observableQuery = null;
      var i = this.cache = t.cache;
      Rd.has(i) || (Rd.set(i, 0), Uk(i, "evict"), Uk(i, "modify"), Uk(i, "reset"));
    }
    return e.prototype.init = function(t) {
      var r = t.networkStatus || mr.loading;
      return this.variables && this.networkStatus !== mr.loading && !qr(this.variables, t.variables) && (r = mr.setVariables), qr(t.variables, this.variables) || (this.lastDiff = void 0), Object.assign(this, {
        document: t.document,
        variables: t.variables,
        networkError: null,
        graphQLErrors: this.graphQLErrors || [],
        networkStatus: r
      }), t.observableQuery && this.setObservableQuery(t.observableQuery), t.lastRequestId && (this.lastRequestId = t.lastRequestId), this;
    }, e.prototype.reset = function() {
      h4(this), this.dirty = !1;
    }, e.prototype.getDiff = function() {
      var t = this.getDiffOptions();
      if (this.lastDiff && qr(t, this.lastDiff.options))
        return this.lastDiff.diff;
      this.updateWatch(this.variables);
      var r = this.observableQuery;
      if (r && r.options.fetchPolicy === "no-cache")
        return { complete: !1 };
      var i = this.cache.diff(t);
      return this.updateLastDiff(i, t), i;
    }, e.prototype.updateLastDiff = function(t, r) {
      this.lastDiff = t ? {
        diff: t,
        options: r || this.getDiffOptions()
      } : void 0;
    }, e.prototype.getDiffOptions = function(t) {
      var r;
      return t === void 0 && (t = this.variables), {
        query: this.document,
        variables: t,
        returnPartialData: !0,
        optimistic: !0,
        canonizeResults: (r = this.observableQuery) === null || r === void 0 ? void 0 : r.options.canonizeResults
      };
    }, e.prototype.setDiff = function(t) {
      var r = this, i = this.lastDiff && this.lastDiff.diff;
      this.updateLastDiff(t), !this.dirty && !qr(i && i.result, t && t.result) && (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
        return r.notify();
      }, 0)));
    }, e.prototype.setObservableQuery = function(t) {
      var r = this;
      t !== this.observableQuery && (this.oqListener && this.listeners.delete(this.oqListener), this.observableQuery = t, t ? (t.queryInfo = this, this.listeners.add(this.oqListener = function() {
        var i = r.getDiff();
        i.fromOptimisticTransaction ? t.observe() : eF(t);
      })) : delete this.oqListener);
    }, e.prototype.notify = function() {
      var t = this;
      h4(this), this.shouldNotify() && this.listeners.forEach(function(r) {
        return r(t);
      }), this.dirty = !1;
    }, e.prototype.shouldNotify = function() {
      if (!this.dirty || !this.listeners.size)
        return !1;
      if (C1(this.networkStatus) && this.observableQuery) {
        var t = this.observableQuery.options.fetchPolicy;
        if (t !== "cache-only" && t !== "cache-and-network")
          return !1;
      }
      return !0;
    }, e.prototype.stop = function() {
      if (!this.stopped) {
        this.stopped = !0, this.reset(), this.cancel(), this.cancel = e.prototype.cancel;
        var t = this.observableQuery;
        t && t.stopPolling();
      }
    }, e.prototype.cancel = function() {
    }, e.prototype.updateWatch = function(t) {
      var r = this;
      t === void 0 && (t = this.variables);
      var i = this.observableQuery;
      if (!(i && i.options.fetchPolicy === "no-cache")) {
        var n = ke(ke({}, this.getDiffOptions(t)), { watcher: this, callback: function(a) {
          return r.setDiff(a);
        } });
        (!this.lastWatch || !qr(n, this.lastWatch)) && (this.cancel(), this.cancel = this.cache.watch(this.lastWatch = n));
      }
    }, e.prototype.resetLastWrite = function() {
      this.lastWrite = void 0;
    }, e.prototype.shouldWrite = function(t, r) {
      var i = this.lastWrite;
      return !(i && // If cache.evict has been called since the last time we wrote this
      // data into the cache, there's a chance writing this result into
      // the cache will repair what was evicted.
      i.dmCount === Rd.get(this.cache) && qr(r, i.variables) && qr(t.data, i.result.data));
    }, e.prototype.markResult = function(t, r, i, n) {
      var a = this, o = new Ml(), s = Ya(t.errors) ? t.errors.slice(0) : [];
      if (this.reset(), "incremental" in t && Ya(t.incremental)) {
        var l = Fw(this.getDiff().result, t);
        t.data = l;
      } else if ("hasNext" in t && t.hasNext) {
        var u = this.getDiff();
        t.data = o.merge(u.result, t.data);
      }
      this.graphQLErrors = s, i.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: t.data, complete: !0 }, this.getDiffOptions(i.variables)) : n !== 0 && (T_(t, i.errorPolicy) ? this.cache.performTransaction(function(d) {
        if (a.shouldWrite(t, i.variables))
          d.writeQuery({
            query: r,
            data: t.data,
            variables: i.variables,
            overwrite: n === 1
          }), a.lastWrite = {
            result: t,
            variables: i.variables,
            dmCount: Rd.get(a.cache)
          };
        else if (a.lastDiff && a.lastDiff.diff.complete) {
          t.data = a.lastDiff.diff.result;
          return;
        }
        var c = a.getDiffOptions(i.variables), p = d.diff(c);
        !a.stopped && qr(a.variables, i.variables) && a.updateWatch(i.variables), a.updateLastDiff(p, c), p.complete && (t.data = p.result);
      }) : this.lastWrite = void 0);
    }, e.prototype.markReady = function() {
      return this.networkError = null, this.networkStatus = mr.ready;
    }, e.prototype.markError = function(t) {
      return this.networkStatus = mr.error, this.lastWrite = void 0, this.reset(), t.graphQLErrors && (this.graphQLErrors = t.graphQLErrors), t.networkError && (this.networkError = t.networkError), t;
    }, e;
  }()
);
function T_(e, t) {
  t === void 0 && (t = "none");
  var r = t === "ignore" || t === "all", i = !Yf(e);
  return !i && r && e.data && (i = !0), i;
}
var hq = Object.prototype.hasOwnProperty, fq = (
  /** @class */
  function() {
    function e(t) {
      var r = t.cache, i = t.link, n = t.defaultOptions, a = t.documentTransform, o = t.queryDeduplication, s = o === void 0 ? !1 : o, l = t.onBroadcast, u = t.ssrMode, d = u === void 0 ? !1 : u, c = t.clientAwareness, p = c === void 0 ? {} : c, f = t.localState, g = t.assumeImmutableResults, k = g === void 0 ? !!r.assumeImmutableResults : g, y = this;
      this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new (us ? WeakMap : Map)(), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = /* @__PURE__ */ new Map();
      var _ = new bw(
        function(A) {
          return y.cache.transformDocument(A);
        },
        // Allow the apollo cache to manage its own transform caches
        { cache: !1 }
      );
      this.cache = r, this.link = i, this.defaultOptions = n || /* @__PURE__ */ Object.create(null), this.queryDeduplication = s, this.clientAwareness = p, this.localState = f || new tF({ cache: r }), this.ssrMode = d, this.assumeImmutableResults = k, this.documentTransform = a ? _.concat(a).concat(_) : _, (this.onBroadcast = l) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
    }
    return e.prototype.stop = function() {
      var t = this;
      this.queries.forEach(function(r, i) {
        t.stopQueryNoBroadcast(i);
      }), this.cancelPendingFetches(aa(25));
    }, e.prototype.cancelPendingFetches = function(t) {
      this.fetchCancelFns.forEach(function(r) {
        return r(t);
      }), this.fetchCancelFns.clear();
    }, e.prototype.mutate = function(t) {
      var r, i, n = t.mutation, a = t.variables, o = t.optimisticResponse, s = t.updateQueries, l = t.refetchQueries, u = l === void 0 ? [] : l, d = t.awaitRefetchQueries, c = d === void 0 ? !1 : d, p = t.update, f = t.onQueryUpdated, g = t.fetchPolicy, k = g === void 0 ? ((r = this.defaultOptions.mutate) === null || r === void 0 ? void 0 : r.fetchPolicy) || "network-only" : g, y = t.errorPolicy, _ = y === void 0 ? ((i = this.defaultOptions.mutate) === null || i === void 0 ? void 0 : i.errorPolicy) || "none" : y, A = t.keepRootFields, T = t.context;
      return bl(this, void 0, void 0, function() {
        var N, P, B, M;
        return _l(this, function(X) {
          switch (X.label) {
            case 0:
              return cr(n, 26), cr(k === "network-only" || k === "no-cache", 27), N = this.generateMutationId(), n = this.cache.transformForLink(this.transform(n)), P = this.getDocumentInfo(n).hasClientExports, a = this.getVariables(n, a), P ? [4, this.localState.addExportedVariables(n, a, T)] : [3, 2];
            case 1:
              a = X.sent(), X.label = 2;
            case 2:
              return B = this.mutationStore && (this.mutationStore[N] = {
                mutation: n,
                variables: a,
                loading: !0,
                error: null
              }), o && this.markMutationOptimistic(o, {
                mutationId: N,
                document: n,
                variables: a,
                fetchPolicy: k,
                errorPolicy: _,
                context: T,
                updateQueries: s,
                update: p,
                keepRootFields: A
              }), this.broadcastQueries(), M = this, [2, new Promise(function(U, K) {
                return Pk(M.getObservableFromLink(n, ke(ke({}, T), { optimisticResponse: o }), a, !1), function(z) {
                  if (Yf(z) && _ === "none")
                    throw new $o({
                      graphQLErrors: g_(z)
                    });
                  B && (B.loading = !1, B.error = null);
                  var j = ke({}, z);
                  return typeof u == "function" && (u = u(j)), _ === "ignore" && Yf(j) && delete j.errors, M.markMutationResult({
                    mutationId: N,
                    result: j,
                    document: n,
                    variables: a,
                    fetchPolicy: k,
                    errorPolicy: _,
                    context: T,
                    update: p,
                    updateQueries: s,
                    awaitRefetchQueries: c,
                    refetchQueries: u,
                    removeOptimistic: o ? N : void 0,
                    onQueryUpdated: f,
                    keepRootFields: A
                  });
                }).subscribe({
                  next: function(z) {
                    M.broadcastQueries(), (!("hasNext" in z) || z.hasNext === !1) && U(z);
                  },
                  error: function(z) {
                    B && (B.loading = !1, B.error = z), o && M.cache.removeOptimistic(N), M.broadcastQueries(), K(z instanceof $o ? z : new $o({
                      networkError: z
                    }));
                  }
                });
              })];
          }
        });
      });
    }, e.prototype.markMutationResult = function(t, r) {
      var i = this;
      r === void 0 && (r = this.cache);
      var n = t.result, a = [], o = t.fetchPolicy === "no-cache";
      if (!o && T_(n, t.errorPolicy)) {
        if (Hd(n) || a.push({
          result: n.data,
          dataId: "ROOT_MUTATION",
          query: t.document,
          variables: t.variables
        }), Hd(n) && Ya(n.incremental)) {
          var s = r.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.getDocumentInfo(t.document).asQuery,
            variables: t.variables,
            optimistic: !1,
            returnPartialData: !0
          }), l = void 0;
          s.result && (l = Fw(s.result, n)), typeof l < "u" && (n.data = l, a.push({
            result: l,
            dataId: "ROOT_MUTATION",
            query: t.document,
            variables: t.variables
          }));
        }
        var u = t.updateQueries;
        u && this.queries.forEach(function(c, p) {
          var f = c.observableQuery, g = f && f.queryName;
          if (!(!g || !hq.call(u, g))) {
            var k = u[g], y = i.queries.get(p), _ = y.document, A = y.variables, T = r.diff({
              query: _,
              variables: A,
              returnPartialData: !0,
              optimistic: !1
            }), N = T.result, P = T.complete;
            if (P && N) {
              var B = k(N, {
                mutationResult: n,
                queryName: _ && d_(_) || void 0,
                queryVariables: A
              });
              B && a.push({
                result: B,
                dataId: "ROOT_QUERY",
                query: _,
                variables: A
              });
            }
          }
        });
      }
      if (a.length > 0 || t.refetchQueries || t.update || t.onQueryUpdated || t.removeOptimistic) {
        var d = [];
        if (this.refetchQueries({
          updateCache: function(c) {
            o || a.forEach(function(k) {
              return c.write(k);
            });
            var p = t.update, f = !qK(n) || Hd(n) && !n.hasNext;
            if (p) {
              if (!o) {
                var g = c.diff({
                  id: "ROOT_MUTATION",
                  // The cache complains if passed a mutation where it expects a
                  // query, so we transform mutations and subscriptions to queries
                  // (only once, thanks to this.transformCache).
                  query: i.getDocumentInfo(t.document).asQuery,
                  variables: t.variables,
                  optimistic: !1,
                  returnPartialData: !0
                });
                g.complete && (n = ke(ke({}, n), { data: g.result }), "incremental" in n && delete n.incremental, "hasNext" in n && delete n.hasNext);
              }
              f && p(c, n, {
                context: t.context,
                variables: t.variables
              });
            }
            !o && !t.keepRootFields && f && c.modify({
              id: "ROOT_MUTATION",
              fields: function(k, y) {
                var _ = y.fieldName, A = y.DELETE;
                return _ === "__typename" ? k : A;
              }
            });
          },
          include: t.refetchQueries,
          // Write the final mutation.result to the root layer of the cache.
          optimistic: !1,
          // Remove the corresponding optimistic layer at the same time as we
          // write the final non-optimistic result.
          removeOptimistic: t.removeOptimistic,
          // Let the caller of client.mutate optionally determine the refetching
          // behavior for watched queries after the mutation.update function runs.
          // If no onQueryUpdated function was provided for this mutation, pass
          // null instead of undefined to disable the default refetching behavior.
          onQueryUpdated: t.onQueryUpdated || null
        }).forEach(function(c) {
          return d.push(c);
        }), t.awaitRefetchQueries || t.onQueryUpdated)
          return Promise.all(d).then(function() {
            return n;
          });
      }
      return Promise.resolve(n);
    }, e.prototype.markMutationOptimistic = function(t, r) {
      var i = this, n = typeof t == "function" ? t(r.variables) : t;
      return this.cache.recordOptimisticTransaction(function(a) {
        try {
          i.markMutationResult(ke(ke({}, r), { result: { data: n } }), a);
        } catch {
        }
      }, r.mutationId);
    }, e.prototype.fetchQuery = function(t, r, i) {
      return this.fetchConcastWithInfo(t, r, i).concast.promise;
    }, e.prototype.getQueryStore = function() {
      var t = /* @__PURE__ */ Object.create(null);
      return this.queries.forEach(function(r, i) {
        t[i] = {
          variables: r.variables,
          networkStatus: r.networkStatus,
          networkError: r.networkError,
          graphQLErrors: r.graphQLErrors
        };
      }), t;
    }, e.prototype.resetErrors = function(t) {
      var r = this.queries.get(t);
      r && (r.networkError = void 0, r.graphQLErrors = []);
    }, e.prototype.transform = function(t) {
      return this.documentTransform.transformDocument(t);
    }, e.prototype.getDocumentInfo = function(t) {
      var r = this.transformCache;
      if (!r.has(t)) {
        var i = {
          // TODO These three calls (hasClientExports, shouldForceResolvers, and
          // usesNonreactiveDirective) are performing independent full traversals
          // of the transformed document. We should consider merging these
          // traversals into a single pass in the future, though the work is
          // cached after the first time.
          hasClientExports: aK(t),
          hasForcedResolvers: this.localState.shouldForceResolvers(t),
          hasNonreactiveDirective: D1(["nonreactive"], t),
          clientQuery: this.localState.clientQuery(t),
          serverQuery: Dw([
            { name: "client", remove: !0 },
            { name: "connection" },
            { name: "nonreactive" }
          ], t),
          defaultVars: oD(K1(t)),
          // Transform any mutation or subscription operations to query operations
          // so we can read/write them from/to the cache.
          asQuery: ke(ke({}, t), { definitions: t.definitions.map(function(n) {
            return n.kind === "OperationDefinition" && n.operation !== "query" ? ke(ke({}, n), { operation: "query" }) : n;
          }) })
        };
        r.set(t, i);
      }
      return r.get(t);
    }, e.prototype.getVariables = function(t, r) {
      return ke(ke({}, this.getDocumentInfo(t).defaultVars), r);
    }, e.prototype.watchQuery = function(t) {
      var r = this.transform(t.query);
      t = ke(ke({}, t), { variables: this.getVariables(r, t.variables) }), typeof t.notifyOnNetworkStatusChange > "u" && (t.notifyOnNetworkStatusChange = !1);
      var i = new Vk(this), n = new F_({
        queryManager: this,
        queryInfo: i,
        options: t
      });
      return n.lastQuery = r, this.queries.set(n.queryId, i), i.init({
        document: r,
        observableQuery: n,
        variables: n.variables
      }), n;
    }, e.prototype.query = function(t, r) {
      var i = this;
      return r === void 0 && (r = this.generateQueryId()), cr(t.query, 28), cr(t.query.kind === "Document", 29), cr(!t.returnPartialData, 30), cr(!t.pollInterval, 31), this.fetchQuery(r, ke(ke({}, t), { query: this.transform(t.query) })).finally(function() {
        return i.stopQuery(r);
      });
    }, e.prototype.generateQueryId = function() {
      return String(this.queryIdCounter++);
    }, e.prototype.generateRequestId = function() {
      return this.requestIdCounter++;
    }, e.prototype.generateMutationId = function() {
      return String(this.mutationIdCounter++);
    }, e.prototype.stopQueryInStore = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryInStoreNoBroadcast = function(t) {
      var r = this.queries.get(t);
      r && r.stop();
    }, e.prototype.clearStore = function(t) {
      return t === void 0 && (t = {
        discardWatches: !0
      }), this.cancelPendingFetches(aa(32)), this.queries.forEach(function(r) {
        r.observableQuery ? r.networkStatus = mr.loading : r.stop();
      }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(t);
    }, e.prototype.getObservableQueries = function(t) {
      var r = this;
      t === void 0 && (t = "active");
      var i = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set();
      return Array.isArray(t) && t.forEach(function(o) {
        typeof o == "string" ? n.set(o, !1) : mK(o) ? n.set(r.transform(o), !1) : mi(o) && o.query && a.add(o);
      }), this.queries.forEach(function(o, s) {
        var l = o.observableQuery, u = o.document;
        if (l) {
          if (t === "all") {
            i.set(s, l);
            return;
          }
          var d = l.queryName, c = l.options.fetchPolicy;
          if (c === "standby" || t === "active" && !l.hasObservers())
            return;
          (t === "active" || d && n.has(d) || u && n.has(u)) && (i.set(s, l), d && n.set(d, !0), u && n.set(u, !0));
        }
      }), a.size && a.forEach(function(o) {
        var s = u_("legacyOneTimeQuery"), l = r.getQuery(s).init({
          document: o.query,
          variables: o.variables
        }), u = new F_({
          queryManager: r,
          queryInfo: l,
          options: ke(ke({}, o), { fetchPolicy: "network-only" })
        });
        cr(u.queryId === s), l.setObservableQuery(u), i.set(s, u);
      }), i;
    }, e.prototype.reFetchObservableQueries = function(t) {
      var r = this;
      t === void 0 && (t = !1);
      var i = [];
      return this.getObservableQueries(t ? "all" : "active").forEach(function(n, a) {
        var o = n.options.fetchPolicy;
        n.resetLastResults(), (t || o !== "standby" && o !== "cache-only") && i.push(n.refetch()), r.getQuery(a).setDiff(null);
      }), this.broadcastQueries(), Promise.all(i);
    }, e.prototype.setObservableQuery = function(t) {
      this.getQuery(t.queryId).setObservableQuery(t);
    }, e.prototype.startGraphQLSubscription = function(t) {
      var r = this, i = t.query, n = t.fetchPolicy, a = t.errorPolicy, o = a === void 0 ? "none" : a, s = t.variables, l = t.context, u = l === void 0 ? {} : l;
      i = this.transform(i), s = this.getVariables(i, s);
      var d = function(p) {
        return r.getObservableFromLink(i, u, p).map(function(f) {
          n !== "no-cache" && (T_(f, o) && r.cache.write({
            query: i,
            result: f.data,
            dataId: "ROOT_SUBSCRIPTION",
            variables: p
          }), r.broadcastQueries());
          var g = Yf(f), k = dY(f);
          if (g || k) {
            var y = {};
            if (g && (y.graphQLErrors = f.errors), k && (y.protocolErrors = f.extensions[hD]), o === "none" || k)
              throw new $o(y);
          }
          return o === "ignore" && delete f.errors, f;
        });
      };
      if (this.getDocumentInfo(i).hasClientExports) {
        var c = this.localState.addExportedVariables(i, s, u).then(d);
        return new Yr(function(p) {
          var f = null;
          return c.then(function(g) {
            return f = g.subscribe(p);
          }, p.error), function() {
            return f && f.unsubscribe();
          };
        });
      }
      return d(s);
    }, e.prototype.stopQuery = function(t) {
      this.stopQueryNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryNoBroadcast = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.removeQuery(t);
    }, e.prototype.removeQuery = function(t) {
      this.fetchCancelFns.delete(t), this.queries.has(t) && (this.getQuery(t).stop(), this.queries.delete(t));
    }, e.prototype.broadcastQueries = function() {
      this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(t) {
        return t.notify();
      });
    }, e.prototype.getLocalState = function() {
      return this.localState;
    }, e.prototype.getObservableFromLink = function(t, r, i, n) {
      var a = this, o;
      n === void 0 && (n = (o = r == null ? void 0 : r.queryDeduplication) !== null && o !== void 0 ? o : this.queryDeduplication);
      var s, l = this.getDocumentInfo(t), u = l.serverQuery, d = l.clientQuery;
      if (u) {
        var c = this, p = c.inFlightLinkObservables, f = c.link, g = {
          query: u,
          variables: i,
          operationName: d_(u) || void 0,
          context: this.prepareContext(ke(ke({}, r), { forceFetch: !n }))
        };
        if (r = g.context, n) {
          var k = sD(u), y = p.get(k) || /* @__PURE__ */ new Map();
          p.set(k, y);
          var _ = qu(i);
          if (s = y.get(_), !s) {
            var A = new Ad([
              v_(f, g)
            ]);
            y.set(_, s = A), A.beforeNext(function() {
              y.delete(_) && y.size < 1 && p.delete(k);
            });
          }
        } else
          s = new Ad([
            v_(f, g)
          ]);
      } else
        s = new Ad([Yr.of({ data: {} })]), r = this.prepareContext(r);
      return d && (s = Pk(s, function(T) {
        return a.localState.runResolvers({
          document: d,
          remoteResult: T,
          context: r,
          variables: i
        });
      })), s;
    }, e.prototype.getResultsFromLink = function(t, r, i) {
      var n = t.lastRequestId = this.generateRequestId(), a = this.cache.transformForLink(i.query);
      return Pk(this.getObservableFromLink(a, i.context, i.variables), function(o) {
        var s = g_(o), l = s.length > 0;
        if (n >= t.lastRequestId) {
          if (l && i.errorPolicy === "none")
            throw t.markError(new $o({
              graphQLErrors: s
            }));
          t.markResult(o, a, i, r), t.markReady();
        }
        var u = {
          data: o.data,
          loading: !1,
          networkStatus: mr.ready
        };
        return l && i.errorPolicy !== "ignore" && (u.errors = s, u.networkStatus = mr.error), u;
      }, function(o) {
        var s = pY(o) ? o : new $o({ networkError: o });
        throw n >= t.lastRequestId && t.markError(s), s;
      });
    }, e.prototype.fetchConcastWithInfo = function(t, r, i, n) {
      var a = this;
      i === void 0 && (i = mr.loading), n === void 0 && (n = r.query);
      var o = this.getVariables(n, r.variables), s = this.getQuery(t), l = this.defaultOptions.watchQuery, u = r.fetchPolicy, d = u === void 0 ? l && l.fetchPolicy || "cache-first" : u, c = r.errorPolicy, p = c === void 0 ? l && l.errorPolicy || "none" : c, f = r.returnPartialData, g = f === void 0 ? !1 : f, k = r.notifyOnNetworkStatusChange, y = k === void 0 ? !1 : k, _ = r.context, A = _ === void 0 ? {} : _, T = Object.assign({}, r, {
        query: n,
        variables: o,
        fetchPolicy: d,
        errorPolicy: p,
        returnPartialData: g,
        notifyOnNetworkStatusChange: y,
        context: A
      }), N = function(U) {
        T.variables = U;
        var K = a.fetchQueryByPolicy(s, T, i);
        return (
          // If we're in standby, postpone advancing options.fetchPolicy using
          // applyNextFetchPolicy.
          T.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
          // this is another way to detect when nothing was done/fetched.
          K.sources.length > 0 && s.observableQuery && s.observableQuery.applyNextFetchPolicy("after-fetch", r), K
        );
      }, P = function() {
        return a.fetchCancelFns.delete(t);
      };
      this.fetchCancelFns.set(t, function(U) {
        P(), setTimeout(function() {
          return B.cancel(U);
        });
      });
      var B, M;
      if (this.getDocumentInfo(T.query).hasClientExports)
        B = new Ad(this.localState.addExportedVariables(T.query, T.variables, T.context).then(N).then(function(U) {
          return U.sources;
        })), M = !0;
      else {
        var X = N(T.variables);
        M = X.fromLink, B = new Ad(X.sources);
      }
      return B.promise.then(P, P), {
        concast: B,
        fromLink: M
      };
    }, e.prototype.refetchQueries = function(t) {
      var r = this, i = t.updateCache, n = t.include, a = t.optimistic, o = a === void 0 ? !1 : a, s = t.removeOptimistic, l = s === void 0 ? o ? u_("refetchQueries") : void 0 : s, u = t.onQueryUpdated, d = /* @__PURE__ */ new Map();
      n && this.getObservableQueries(n).forEach(function(p, f) {
        d.set(f, {
          oq: p,
          lastDiff: r.getQuery(f).getDiff()
        });
      });
      var c = /* @__PURE__ */ new Map();
      return i && this.cache.batch({
        update: i,
        // Since you can perform any combination of cache reads and/or writes in
        // the cache.batch update function, its optimistic option can be either
        // a boolean or a string, representing three distinct modes of
        // operation:
        //
        // * false: read/write only the root layer
        // * true: read/write the topmost layer
        // * string: read/write a fresh optimistic layer with that ID string
        //
        // When typeof optimistic === "string", a new optimistic layer will be
        // temporarily created within cache.batch with that string as its ID. If
        // we then pass that same string as the removeOptimistic option, we can
        // make cache.batch immediately remove the optimistic layer after
        // running the updateCache function, triggering only one broadcast.
        //
        // However, the refetchQueries method accepts only true or false for its
        // optimistic option (not string). We interpret true to mean a temporary
        // optimistic layer should be created, to allow efficiently rolling back
        // the effect of the updateCache function, which involves passing a
        // string instead of true as the optimistic option to cache.batch, when
        // refetchQueries receives optimistic: true.
        //
        // In other words, we are deliberately not supporting the use case of
        // writing to an *existing* optimistic layer (using the refetchQueries
        // updateCache function), since that would potentially interfere with
        // other optimistic updates in progress. Instead, you can read/write
        // only the root layer by passing optimistic: false to refetchQueries,
        // or you can read/write a brand new optimistic layer that will be
        // automatically removed by passing optimistic: true.
        optimistic: o && l || !1,
        // The removeOptimistic option can also be provided by itself, even if
        // optimistic === false, to remove some previously-added optimistic
        // layer safely and efficiently, like we do in markMutationResult.
        //
        // If an explicit removeOptimistic string is provided with optimistic:
        // true, the removeOptimistic string will determine the ID of the
        // temporary optimistic layer, in case that ever matters.
        removeOptimistic: l,
        onWatchUpdated: function(p, f, g) {
          var k = p.watcher instanceof Vk && p.watcher.observableQuery;
          if (k) {
            if (u) {
              d.delete(k.queryId);
              var y = u(k, f, g);
              return y === !0 && (y = k.refetch()), y !== !1 && c.set(k, y), y;
            }
            u !== null && d.set(k.queryId, { oq: k, lastDiff: g, diff: f });
          }
        }
      }), d.size && d.forEach(function(p, f) {
        var g = p.oq, k = p.lastDiff, y = p.diff, _;
        if (u) {
          if (!y) {
            var A = g.queryInfo;
            A.reset(), y = A.getDiff();
          }
          _ = u(g, y, k);
        }
        (!u || _ === !0) && (_ = g.refetch()), _ !== !1 && c.set(g, _), f.indexOf("legacyOneTimeQuery") >= 0 && r.stopQueryNoBroadcast(f);
      }), l && this.cache.removeOptimistic(l), c;
    }, e.prototype.fetchQueryByPolicy = function(t, r, i) {
      var n = this, a = r.query, o = r.variables, s = r.fetchPolicy, l = r.refetchWritePolicy, u = r.errorPolicy, d = r.returnPartialData, c = r.context, p = r.notifyOnNetworkStatusChange, f = t.networkStatus;
      t.init({
        document: a,
        variables: o,
        networkStatus: i
      });
      var g = function() {
        return t.getDiff();
      }, k = function(N, P) {
        P === void 0 && (P = t.networkStatus || mr.loading);
        var B = N.result, M = function(X) {
          return Yr.of(ke({ data: X, loading: C1(P), networkStatus: P }, N.complete ? null : { partial: !0 }));
        };
        return B && n.getDocumentInfo(a).hasForcedResolvers ? n.localState.runResolvers({
          document: a,
          remoteResult: { data: B },
          context: c,
          variables: o,
          onlyRunForcedResolvers: !0
        }).then(function(X) {
          return M(X.data || void 0);
        }) : u === "none" && P === mr.refetch && Array.isArray(N.missing) ? M(void 0) : M(B);
      }, y = s === "no-cache" ? 0 : i === mr.refetch && l !== "merge" ? 1 : 2, _ = function() {
        return n.getResultsFromLink(t, y, {
          query: a,
          variables: o,
          context: c,
          fetchPolicy: s,
          errorPolicy: u
        });
      }, A = p && typeof f == "number" && f !== i && C1(i);
      switch (s) {
        default:
        case "cache-first": {
          var T = g();
          return T.complete ? {
            fromLink: !1,
            sources: [k(T, t.markReady())]
          } : d || A ? {
            fromLink: !0,
            sources: [k(T), _()]
          } : { fromLink: !0, sources: [_()] };
        }
        case "cache-and-network": {
          var T = g();
          return T.complete || d || A ? {
            fromLink: !0,
            sources: [k(T), _()]
          } : { fromLink: !0, sources: [_()] };
        }
        case "cache-only":
          return {
            fromLink: !1,
            sources: [k(g(), t.markReady())]
          };
        case "network-only":
          return A ? {
            fromLink: !0,
            sources: [k(g()), _()]
          } : { fromLink: !0, sources: [_()] };
        case "no-cache":
          return A ? {
            fromLink: !0,
            // Note that queryInfo.getDiff() for no-cache queries does not call
            // cache.diff, but instead returns a { complete: false } stub result
            // when there is no queryInfo.diff already defined.
            sources: [k(t.getDiff()), _()]
          } : { fromLink: !0, sources: [_()] };
        case "standby":
          return { fromLink: !1, sources: [] };
      }
    }, e.prototype.getQuery = function(t) {
      return t && !this.queries.has(t) && this.queries.set(t, new Vk(this, t)), this.queries.get(t);
    }, e.prototype.prepareContext = function(t) {
      t === void 0 && (t = {});
      var r = this.localState.prepareContext(t);
      return ke(ke({}, r), { clientAwareness: this.clientAwareness });
    }, e;
  }()
), gq = (
  /** @class */
  function() {
    function e(t) {
      var r = this;
      if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !t.cache)
        throw aa(15);
      var i = t.uri, n = t.credentials, a = t.headers, o = t.cache, s = t.documentTransform, l = t.ssrMode, u = l === void 0 ? !1 : l, d = t.ssrForceFetchDelay, c = d === void 0 ? 0 : d, p = t.connectToDevTools, f = p === void 0 ? typeof window == "object" && !window.__APOLLO_CLIENT__ && !1 : p, g = t.queryDeduplication, k = g === void 0 ? !0 : g, y = t.defaultOptions, _ = t.assumeImmutableResults, A = _ === void 0 ? o.assumeImmutableResults : _, T = t.resolvers, N = t.typeDefs, P = t.fragmentMatcher, B = t.name, M = t.version, X = t.link;
      X || (X = i ? new b_({ uri: i, credentials: n, headers: a }) : cs.empty()), this.link = X, this.cache = o, this.disableNetworkFetches = u || c > 0, this.queryDeduplication = k, this.defaultOptions = y || /* @__PURE__ */ Object.create(null), this.typeDefs = N, c && setTimeout(function() {
        return r.disableNetworkFetches = !1;
      }, c), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = tD, this.localState = new tF({
        cache: o,
        client: this,
        resolvers: T,
        fragmentMatcher: P
      }), this.queryManager = new fq({
        cache: this.cache,
        link: this.link,
        defaultOptions: this.defaultOptions,
        documentTransform: s,
        queryDeduplication: k,
        ssrMode: u,
        clientAwareness: {
          name: B,
          version: M
        },
        localState: this.localState,
        assumeImmutableResults: A,
        onBroadcast: f ? function() {
          r.devToolsHookCb && r.devToolsHookCb({
            action: {},
            state: {
              queries: r.queryManager.getQueryStore(),
              mutations: r.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: r.cache.extract(!0)
          });
        } : void 0
      }), f && this.connectToDevTools();
    }
    return e.prototype.connectToDevTools = function() {
      if (typeof window == "object") {
        var t = window, r = Symbol.for("apollo.devtools");
        (t[r] = t[r] || []).push(this), t.__APOLLO_CLIENT__ = this;
      }
    }, Object.defineProperty(e.prototype, "documentTransform", {
      /**
       * The `DocumentTransform` used to modify GraphQL documents before a request
       * is made. If a custom `DocumentTransform` is not provided, this will be the
       * default document transform.
       */
      get: function() {
        return this.queryManager.documentTransform;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.stop = function() {
      this.queryManager.stop();
    }, e.prototype.watchQuery = function(t) {
      return this.defaultOptions.watchQuery && (t = Yu(this.defaultOptions.watchQuery, t)), this.disableNetworkFetches && (t.fetchPolicy === "network-only" || t.fetchPolicy === "cache-and-network") && (t = ke(ke({}, t), { fetchPolicy: "cache-first" })), this.queryManager.watchQuery(t);
    }, e.prototype.query = function(t) {
      return this.defaultOptions.query && (t = Yu(this.defaultOptions.query, t)), cr(t.fetchPolicy !== "cache-and-network", 16), this.disableNetworkFetches && t.fetchPolicy === "network-only" && (t = ke(ke({}, t), { fetchPolicy: "cache-first" })), this.queryManager.query(t);
    }, e.prototype.mutate = function(t) {
      return this.defaultOptions.mutate && (t = Yu(this.defaultOptions.mutate, t)), this.queryManager.mutate(t);
    }, e.prototype.subscribe = function(t) {
      return this.queryManager.startGraphQLSubscription(t);
    }, e.prototype.readQuery = function(t, r) {
      return r === void 0 && (r = !1), this.cache.readQuery(t, r);
    }, e.prototype.readFragment = function(t, r) {
      return r === void 0 && (r = !1), this.cache.readFragment(t, r);
    }, e.prototype.writeQuery = function(t) {
      var r = this.cache.writeQuery(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, e.prototype.writeFragment = function(t) {
      var r = this.cache.writeFragment(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, e.prototype.__actionHookForDevTools = function(t) {
      this.devToolsHookCb = t;
    }, e.prototype.__requestRaw = function(t) {
      return v_(this.link, t);
    }, e.prototype.resetStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !1
        });
      }).then(function() {
        return Promise.all(t.resetStoreCallbacks.map(function(r) {
          return r();
        }));
      }).then(function() {
        return t.reFetchObservableQueries();
      });
    }, e.prototype.clearStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !0
        });
      }).then(function() {
        return Promise.all(t.clearStoreCallbacks.map(function(r) {
          return r();
        }));
      });
    }, e.prototype.onResetStore = function(t) {
      var r = this;
      return this.resetStoreCallbacks.push(t), function() {
        r.resetStoreCallbacks = r.resetStoreCallbacks.filter(function(i) {
          return i !== t;
        });
      };
    }, e.prototype.onClearStore = function(t) {
      var r = this;
      return this.clearStoreCallbacks.push(t), function() {
        r.clearStoreCallbacks = r.clearStoreCallbacks.filter(function(i) {
          return i !== t;
        });
      };
    }, e.prototype.reFetchObservableQueries = function(t) {
      return this.queryManager.reFetchObservableQueries(t);
    }, e.prototype.refetchQueries = function(t) {
      var r = this.queryManager.refetchQueries(t), i = [], n = [];
      r.forEach(function(o, s) {
        i.push(s), n.push(o);
      });
      var a = Promise.all(n);
      return a.queries = i, a.results = n, a.catch(function(o) {
      }), a;
    }, e.prototype.getObservableQueries = function(t) {
      return t === void 0 && (t = "active"), this.queryManager.getObservableQueries(t);
    }, e.prototype.extract = function(t) {
      return this.cache.extract(t);
    }, e.prototype.restore = function(t) {
      return this.cache.restore(t);
    }, e.prototype.addResolvers = function(t) {
      this.localState.addResolvers(t);
    }, e.prototype.setResolvers = function(t) {
      this.localState.setResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.localState.getResolvers();
    }, e.prototype.setLocalStateFragmentMatcher = function(t) {
      this.localState.setFragmentMatcher(t);
    }, e.prototype.setLink = function(t) {
      this.link = this.queryManager.link = t;
    }, e;
  }()
), Xf = /* @__PURE__ */ new Map(), S_ = /* @__PURE__ */ new Map(), rF = !0, Hg = !1;
function iF(e) {
  return e.replace(/[\s,]+/g, " ").trim();
}
function mq(e) {
  return iF(e.source.body.substring(e.start, e.end));
}
function vq(e) {
  var t = /* @__PURE__ */ new Set(), r = [];
  return e.definitions.forEach(function(i) {
    if (i.kind === "FragmentDefinition") {
      var n = i.name.value, a = mq(i.loc), o = S_.get(n);
      o && !o.has(a) ? rF && console.warn("Warning: fragment with name " + n + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : o || S_.set(n, o = /* @__PURE__ */ new Set()), o.add(a), t.has(a) || (t.add(a), r.push(i));
    } else
      r.push(i);
  }), ke(ke({}, e), { definitions: r });
}
function kq(e) {
  var t = new Set(e.definitions);
  t.forEach(function(i) {
    i.loc && delete i.loc, Object.keys(i).forEach(function(n) {
      var a = i[n];
      a && typeof a == "object" && t.add(a);
    });
  });
  var r = e.loc;
  return r && (delete r.startToken, delete r.endToken), e;
}
function bq(e) {
  var t = iF(e);
  if (!Xf.has(t)) {
    var r = GG(e, {
      experimentalFragmentVariables: Hg,
      allowLegacyFragmentVariables: Hg
    });
    if (!r || r.kind !== "Document")
      throw new Error("Not a valid GraphQL document.");
    Xf.set(t, kq(vq(r)));
  }
  return Xf.get(t);
}
function ts(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  typeof e == "string" && (e = [e]);
  var i = e[0];
  return t.forEach(function(n, a) {
    n && n.kind === "Document" ? i += n.loc.source.body : i += n, i += e[a + 1];
  }), bq(i);
}
function _q() {
  Xf.clear(), S_.clear();
}
function Dq() {
  rF = !1;
}
function yq() {
  Hg = !0;
}
function Eq() {
  Hg = !1;
}
var w0 = {
  gql: ts,
  resetCaches: _q,
  disableFragmentWarnings: Dq,
  enableExperimentalFragmentVariables: yq,
  disableExperimentalFragmentVariables: Eq
};
(function(e) {
  e.gql = w0.gql, e.resetCaches = w0.resetCaches, e.disableFragmentWarnings = w0.disableFragmentWarnings, e.enableExperimentalFragmentVariables = w0.enableExperimentalFragmentVariables, e.disableExperimentalFragmentVariables = w0.disableExperimentalFragmentVariables;
})(ts || (ts = {}));
ts.default = ts;
var f4 = nD ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function DD() {
  cr("createContext" in we, 45);
  var e = we.createContext[f4];
  return e || (Object.defineProperty(we.createContext, f4, {
    value: e = we.createContext({}),
    enumerable: !1,
    writable: !1,
    configurable: !0
  }), e.displayName = "ApolloContext"), e;
}
var Cq = function(e) {
  var t = e.client, r = e.children, i = DD(), n = we.useContext(i), a = we.useMemo(function() {
    return ke(ke({}, n), { client: t || n.client });
  }, [n, t]);
  return cr(a.client, 46), we.createElement(i.Provider, { value: a }, r);
};
function Pm(e) {
  var t = we.useContext(DD()), r = e || t.client;
  return cr(!!r, 49), r;
}
var xq = "useSyncExternalStore", Aq = we[xq], nF = Aq || function(e, t, r) {
  var i = t(), n = we.useState({
    inst: { value: i, getSnapshot: t }
  }), a = n[0].inst, o = n[1];
  return fK ? we.useLayoutEffect(function() {
    Object.assign(a, { value: i, getSnapshot: t }), Wk(a) && o({ inst: a });
  }, [e, i, t]) : Object.assign(a, { value: i, getSnapshot: t }), we.useEffect(function() {
    return Wk(a) && o({ inst: a }), e(function() {
      Wk(a) && o({ inst: a });
    });
  }, [e]), i;
};
function Wk(e) {
  var t = e.value, r = e.getSnapshot;
  try {
    return t !== r();
  } catch {
    return !0;
  }
}
var Do;
(function(e) {
  e[e.Query = 0] = "Query", e[e.Mutation = 1] = "Mutation", e[e.Subscription = 2] = "Subscription";
})(Do || (Do = {}));
var g4 = /* @__PURE__ */ new Map();
function m4(e) {
  var t;
  switch (e) {
    case Do.Query:
      t = "Query";
      break;
    case Do.Mutation:
      t = "Mutation";
      break;
    case Do.Subscription:
      t = "Subscription";
      break;
  }
  return t;
}
function wq(e) {
  var t = g4.get(e);
  if (t)
    return t;
  var r, i, n;
  cr(!!e && !!e.kind, 59, e);
  for (var a = [], o = [], s = [], l = [], u = 0, d = e.definitions; u < d.length; u++) {
    var c = d[u];
    if (c.kind === "FragmentDefinition") {
      a.push(c);
      continue;
    }
    if (c.kind === "OperationDefinition")
      switch (c.operation) {
        case "query":
          o.push(c);
          break;
        case "mutation":
          s.push(c);
          break;
        case "subscription":
          l.push(c);
          break;
      }
  }
  cr(!a.length || o.length || s.length || l.length, 60), cr(
    o.length + s.length + l.length <= 1,
    61,
    e,
    o.length,
    l.length,
    s.length
  ), i = o.length ? Do.Query : Do.Mutation, !o.length && !s.length && (i = Do.Subscription);
  var p = o.length ? o : s.length ? s : l;
  cr(p.length === 1, 62, e, p.length);
  var f = p[0];
  r = f.variableDefinitions || [], f.name && f.name.kind === "Name" ? n = f.name.value : n = "data";
  var g = { name: n, type: i, variables: r };
  return g4.set(e, g), g;
}
function yD(e, t) {
  var r = wq(e), i = m4(t), n = m4(r.type);
  cr(
    r.type === t,
    63,
    i,
    i,
    n
  );
}
var Fq = Object.prototype.hasOwnProperty;
function aF(e, t) {
  return t === void 0 && (t = /* @__PURE__ */ Object.create(null)), oF(Pm(t.client), e).useQuery(t);
}
function oF(e, t) {
  var r = we.useRef();
  (!r.current || e !== r.current.client || t !== r.current.query) && (r.current = new Tq(e, t, r.current));
  var i = r.current;
  return i.forceUpdateState = we.useReducer(function(n) {
    return n + 1;
  }, 0)[1], i;
}
var Tq = (
  /** @class */
  function() {
    function e(t, r, i) {
      var n = this;
      this.client = t, this.query = r, this.forceUpdate = function() {
        return n.forceUpdateState();
      }, this.ssrDisabledResult = {
        loading: !0,
        data: void 0,
        error: void 0,
        networkStatus: mr.loading
      }, this.skipStandbyResult = {
        loading: !1,
        data: void 0,
        error: void 0,
        networkStatus: mr.ready
      }, this.toQueryResultCache = new (us ? WeakMap : Map)(), yD(r, Do.Query);
      var a = i && i.result, o = a && a.data;
      o && (this.previousData = o);
    }
    return e.prototype.forceUpdateState = function() {
    }, e.prototype.executeQuery = function(t) {
      var r = this, i;
      t.query && Object.assign(this, { query: t.query }), this.watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = t);
      var n = this.observable.reobserveAsConcast(this.getObsQueryOptions());
      return this.previousData = ((i = this.result) === null || i === void 0 ? void 0 : i.data) || this.previousData, this.result = void 0, this.forceUpdate(), new Promise(function(a) {
        var o;
        n.subscribe({
          next: function(s) {
            o = s;
          },
          error: function() {
            a(r.toQueryResult(r.observable.getCurrentResult()));
          },
          complete: function() {
            a(r.toQueryResult(o));
          }
        });
      });
    }, e.prototype.useQuery = function(t) {
      var r = this;
      this.renderPromises = we.useContext(DD()).renderPromises, this.useOptions(t);
      var i = this.useObservableQuery(), n = nF(we.useCallback(function(a) {
        if (r.renderPromises)
          return function() {
          };
        r.forceUpdate = a;
        var o = function() {
          var u = r.result, d = i.getCurrentResult();
          u && u.loading === d.loading && u.networkStatus === d.networkStatus && qr(u.data, d.data) || r.setResult(d);
        }, s = function(u) {
          if (l.unsubscribe(), l = i.resubscribeAfterError(o, s), !Fq.call(u, "graphQLErrors"))
            throw u;
          var d = r.result;
          (!d || d && d.loading || !qr(u, d.error)) && r.setResult({
            data: d && d.data,
            error: u,
            loading: !1,
            networkStatus: mr.error
          });
        }, l = i.subscribe(o, s);
        return function() {
          setTimeout(function() {
            return l.unsubscribe();
          }), r.forceUpdate = function() {
            return r.forceUpdateState();
          };
        };
      }, [
        // We memoize the subscribe function using useCallback and the following
        // dependency keys, because the subscribe function reference is all that
        // useSyncExternalStore uses internally as a dependency key for the
        // useEffect ultimately responsible for the subscription, so we are
        // effectively passing this dependency array to that useEffect buried
        // inside useSyncExternalStore, as desired.
        i,
        this.renderPromises,
        this.client.disableNetworkFetches
      ]), function() {
        return r.getCurrentResult();
      }, function() {
        return r.getCurrentResult();
      });
      return this.unsafeHandlePartialRefetch(n), this.toQueryResult(n);
    }, e.prototype.useOptions = function(t) {
      var r, i = this.createWatchQueryOptions(this.queryHookOptions = t), n = this.watchQueryOptions;
      qr(i, n) || (this.watchQueryOptions = i, n && this.observable && (this.observable.reobserve(this.getObsQueryOptions()), this.previousData = ((r = this.result) === null || r === void 0 ? void 0 : r.data) || this.previousData, this.result = void 0)), this.onCompleted = t.onCompleted || e.prototype.onCompleted, this.onError = t.onError || e.prototype.onError, (this.renderPromises || this.client.disableNetworkFetches) && this.queryHookOptions.ssr === !1 && !this.queryHookOptions.skip ? this.result = this.ssrDisabledResult : this.queryHookOptions.skip || this.watchQueryOptions.fetchPolicy === "standby" ? this.result = this.skipStandbyResult : (this.result === this.ssrDisabledResult || this.result === this.skipStandbyResult) && (this.result = void 0);
    }, e.prototype.getObsQueryOptions = function() {
      var t = [], r = this.client.defaultOptions.watchQuery;
      return r && t.push(r), this.queryHookOptions.defaultOptions && t.push(this.queryHookOptions.defaultOptions), t.push(lc(this.observable && this.observable.options, this.watchQueryOptions)), t.reduce(Yu);
    }, e.prototype.createWatchQueryOptions = function(t) {
      var r;
      t === void 0 && (t = {});
      var i = t.skip;
      t.ssr, t.onCompleted, t.onError, t.defaultOptions;
      var n = es(t, ["skip", "ssr", "onCompleted", "onError", "defaultOptions"]), a = Object.assign(n, { query: this.query });
      if (this.renderPromises && (a.fetchPolicy === "network-only" || a.fetchPolicy === "cache-and-network") && (a.fetchPolicy = "cache-first"), a.variables || (a.variables = {}), i) {
        var o = a.fetchPolicy, s = o === void 0 ? this.getDefaultFetchPolicy() : o, l = a.initialFetchPolicy, u = l === void 0 ? s : l;
        Object.assign(a, {
          initialFetchPolicy: u,
          fetchPolicy: "standby"
        });
      } else
        a.fetchPolicy || (a.fetchPolicy = ((r = this.observable) === null || r === void 0 ? void 0 : r.options.initialFetchPolicy) || this.getDefaultFetchPolicy());
      return a;
    }, e.prototype.getDefaultFetchPolicy = function() {
      var t, r;
      return ((t = this.queryHookOptions.defaultOptions) === null || t === void 0 ? void 0 : t.fetchPolicy) || ((r = this.client.defaultOptions.watchQuery) === null || r === void 0 ? void 0 : r.fetchPolicy) || "cache-first";
    }, e.prototype.onCompleted = function(t) {
    }, e.prototype.onError = function(t) {
    }, e.prototype.useObservableQuery = function() {
      var t = this.observable = this.renderPromises && this.renderPromises.getSSRObservable(this.watchQueryOptions) || this.observable || // Reuse this.observable if possible (and not SSR)
      this.client.watchQuery(this.getObsQueryOptions());
      this.obsQueryFields = we.useMemo(function() {
        return {
          refetch: t.refetch.bind(t),
          reobserve: t.reobserve.bind(t),
          fetchMore: t.fetchMore.bind(t),
          updateQuery: t.updateQuery.bind(t),
          startPolling: t.startPolling.bind(t),
          stopPolling: t.stopPolling.bind(t),
          subscribeToMore: t.subscribeToMore.bind(t)
        };
      }, [t]);
      var r = !(this.queryHookOptions.ssr === !1 || this.queryHookOptions.skip);
      return this.renderPromises && r && (this.renderPromises.registerSSRObservable(t), t.getCurrentResult().loading && this.renderPromises.addObservableQueryPromise(t)), t;
    }, e.prototype.setResult = function(t) {
      var r = this.result;
      r && r.data && (this.previousData = r.data), this.result = t, this.forceUpdate(), this.handleErrorOrCompleted(t, r);
    }, e.prototype.handleErrorOrCompleted = function(t, r) {
      var i = this;
      if (!t.loading) {
        var n = this.toApolloError(t);
        Promise.resolve().then(function() {
          n ? i.onError(n) : t.data && (r == null ? void 0 : r.networkStatus) !== t.networkStatus && t.networkStatus === mr.ready && i.onCompleted(t.data);
        }).catch(function(a) {
        });
      }
    }, e.prototype.toApolloError = function(t) {
      return Ya(t.errors) ? new $o({ graphQLErrors: t.errors }) : t.error;
    }, e.prototype.getCurrentResult = function() {
      return this.result || this.handleErrorOrCompleted(this.result = this.observable.getCurrentResult()), this.result;
    }, e.prototype.toQueryResult = function(t) {
      var r = this.toQueryResultCache.get(t);
      if (r)
        return r;
      var i = t.data;
      t.partial;
      var n = es(t, ["data", "partial"]);
      return this.toQueryResultCache.set(t, r = ke(ke(ke({ data: i }, n), this.obsQueryFields), { client: this.client, observable: this.observable, variables: this.observable.variables, called: !this.queryHookOptions.skip, previousData: this.previousData })), !r.error && Ya(t.errors) && (r.error = new $o({ graphQLErrors: t.errors })), r;
    }, e.prototype.unsafeHandlePartialRefetch = function(t) {
      t.partial && this.queryHookOptions.partialRefetch && !t.loading && (!t.data || Object.keys(t.data).length === 0) && this.observable.options.fetchPolicy !== "cache-only" && (Object.assign(t, {
        loading: !0,
        networkStatus: mr.refetch
      }), this.observable.refetch());
    }, e;
  }()
), Sq = [
  "refetch",
  "reobserve",
  "fetchMore",
  "updateQuery",
  "startPolling",
  "subscribeToMore"
];
function Iq(e, t) {
  var r, i = we.useRef(), n = we.useRef(), a = we.useRef(), o = Yu(t, i.current || {}), s = (r = o == null ? void 0 : o.query) !== null && r !== void 0 ? r : e;
  n.current = o, a.current = s;
  var l = oF(Pm(t && t.client), s), u = l.useQuery(ke(ke({}, o), { skip: !i.current })), d = u.observable.options.initialFetchPolicy || l.getDefaultFetchPolicy(), c = Object.assign(u, {
    called: !!i.current
  }), p = we.useMemo(function() {
    for (var g = {}, k = function(T) {
      var N = c[T];
      g[T] = function() {
        return i.current || (i.current = /* @__PURE__ */ Object.create(null), l.forceUpdateState()), N.apply(this, arguments);
      };
    }, y = 0, _ = Sq; y < _.length; y++) {
      var A = _[y];
      k(A);
    }
    return g;
  }, []);
  Object.assign(c, p);
  var f = we.useCallback(function(g) {
    i.current = g ? ke(ke({}, g), { fetchPolicy: g.fetchPolicy || d }) : {
      fetchPolicy: d
    };
    var k = Yu(n.current, ke({ query: a.current }, i.current)), y = l.executeQuery(ke(ke({}, k), { skip: !1 })).then(function(_) {
      return Object.assign(_, p);
    });
    return y.catch(function() {
    }), y;
  }, []);
  return [f, c];
}
function sF(e, t) {
  var r = Pm(t == null ? void 0 : t.client);
  yD(e, Do.Mutation);
  var i = we.useState({
    called: !1,
    loading: !1,
    client: r
  }), n = i[0], a = i[1], o = we.useRef({
    result: n,
    mutationId: 0,
    isMounted: !0,
    client: r,
    mutation: e,
    options: t
  });
  Object.assign(o.current, { client: r, options: t, mutation: e });
  var s = we.useCallback(function(u) {
    u === void 0 && (u = {});
    var d = o.current, c = d.options, p = d.mutation, f = ke(ke({}, c), { mutation: p }), g = u.client || o.current.client;
    !o.current.result.loading && !f.ignoreResults && o.current.isMounted && a(o.current.result = {
      loading: !0,
      error: void 0,
      data: void 0,
      called: !0,
      client: g
    });
    var k = ++o.current.mutationId, y = Yu(f, u);
    return g.mutate(y).then(function(_) {
      var A, T, N = _.data, P = _.errors, B = P && P.length > 0 ? new $o({ graphQLErrors: P }) : void 0, M = u.onError || ((A = o.current.options) === null || A === void 0 ? void 0 : A.onError);
      if (B && M && M(B, y), k === o.current.mutationId && !y.ignoreResults) {
        var X = {
          called: !0,
          loading: !1,
          data: N,
          error: B,
          client: g
        };
        o.current.isMounted && !qr(o.current.result, X) && a(o.current.result = X);
      }
      var U = u.onCompleted || ((T = o.current.options) === null || T === void 0 ? void 0 : T.onCompleted);
      return B || U == null || U(_.data, y), _;
    }).catch(function(_) {
      var A;
      if (k === o.current.mutationId && o.current.isMounted) {
        var T = {
          loading: !1,
          error: _,
          data: void 0,
          called: !0,
          client: g
        };
        qr(o.current.result, T) || a(o.current.result = T);
      }
      var N = u.onError || ((A = o.current.options) === null || A === void 0 ? void 0 : A.onError);
      if (N)
        return N(_, y), { data: void 0, errors: _ };
      throw _;
    });
  }, []), l = we.useCallback(function() {
    if (o.current.isMounted) {
      var u = { called: !1, loading: !1, client: r };
      Object.assign(o.current, { mutationId: 0, result: u }), a(u);
    }
  }, []);
  return we.useEffect(function() {
    return o.current.isMounted = !0, function() {
      o.current.isMounted = !1;
    };
  }, []), [s, ke({ reset: l }, n)];
}
function lF(e, t) {
  var r = we.useRef(!1), i = Pm(t == null ? void 0 : t.client);
  yD(e, Do.Subscription);
  var n = we.useState({
    loading: !(t != null && t.skip),
    error: void 0,
    data: void 0,
    variables: t == null ? void 0 : t.variables
  }), a = n[0], o = n[1];
  r.current || (r.current = !0, t != null && t.onSubscriptionData, t != null && t.onSubscriptionComplete);
  var s = we.useState(function() {
    return t != null && t.skip ? null : i.subscribe({
      query: e,
      variables: t == null ? void 0 : t.variables,
      fetchPolicy: t == null ? void 0 : t.fetchPolicy,
      context: t == null ? void 0 : t.context
    });
  }), l = s[0], u = s[1], d = we.useRef(!1);
  we.useEffect(function() {
    return function() {
      d.current = !0;
    };
  }, []);
  var c = we.useRef({ client: i, subscription: e, options: t });
  return we.useEffect(function() {
    var p, f, g, k, y = t == null ? void 0 : t.shouldResubscribe;
    typeof y == "function" && (y = !!y(t)), t != null && t.skip ? (!(t != null && t.skip) != !(!((p = c.current.options) === null || p === void 0) && p.skip) || d.current) && (o({
      loading: !1,
      data: void 0,
      error: void 0,
      variables: t == null ? void 0 : t.variables
    }), u(null), d.current = !1) : (y !== !1 && (i !== c.current.client || e !== c.current.subscription || (t == null ? void 0 : t.fetchPolicy) !== ((f = c.current.options) === null || f === void 0 ? void 0 : f.fetchPolicy) || !(t != null && t.skip) != !(!((g = c.current.options) === null || g === void 0) && g.skip) || !qr(t == null ? void 0 : t.variables, (k = c.current.options) === null || k === void 0 ? void 0 : k.variables)) || d.current) && (o({
      loading: !0,
      data: void 0,
      error: void 0,
      variables: t == null ? void 0 : t.variables
    }), u(i.subscribe({
      query: e,
      variables: t == null ? void 0 : t.variables,
      fetchPolicy: t == null ? void 0 : t.fetchPolicy,
      context: t == null ? void 0 : t.context
    })), d.current = !1), Object.assign(c.current, { client: i, subscription: e, options: t });
  }, [i, e, t, d.current]), we.useEffect(function() {
    if (l) {
      var p = !1, f = l.subscribe({
        next: function(g) {
          var k, y;
          if (!p) {
            var _ = {
              loading: !1,
              // TODO: fetchResult.data can be null but SubscriptionResult.data
              // expects TData | undefined only
              data: g.data,
              error: void 0,
              variables: t == null ? void 0 : t.variables
            };
            o(_), !((k = c.current.options) === null || k === void 0) && k.onData ? c.current.options.onData({
              client: i,
              data: _
            }) : !((y = c.current.options) === null || y === void 0) && y.onSubscriptionData && c.current.options.onSubscriptionData({
              client: i,
              subscriptionData: _
            });
          }
        },
        error: function(g) {
          var k, y;
          p || (o({
            loading: !1,
            data: void 0,
            error: g,
            variables: t == null ? void 0 : t.variables
          }), (y = (k = c.current.options) === null || k === void 0 ? void 0 : k.onError) === null || y === void 0 || y.call(k, g));
        },
        complete: function() {
          var g, k;
          p || (!((g = c.current.options) === null || g === void 0) && g.onComplete ? c.current.options.onComplete() : !((k = c.current.options) === null || k === void 0) && k.onSubscriptionComplete && c.current.options.onSubscriptionComplete());
        }
      });
      return function() {
        p = !0, setTimeout(function() {
          f.unsubscribe();
        });
      };
    }
  }, [l]), a;
}
function x1(e) {
  return nF(we.useCallback(function(t) {
    return e.onNextChange(function r() {
      t(), e.onNextChange(r);
    });
  }, [e]), e, e);
}
function uF(e) {
  return new cs(function(t, r) {
    return new Yr(function(i) {
      var n, a, o;
      try {
        n = r(t).subscribe({
          next: function(s) {
            if (s.errors && (o = e({
              graphQLErrors: s.errors,
              response: s,
              operation: t,
              forward: r
            }), o)) {
              a = o.subscribe({
                next: i.next.bind(i),
                error: i.error.bind(i),
                complete: i.complete.bind(i)
              });
              return;
            }
            i.next(s);
          },
          error: function(s) {
            if (o = e({
              operation: t,
              networkError: s,
              //Network errors can return GraphQL errors on for example a 403
              graphQLErrors: s && s.result && s.result.errors,
              forward: r
            }), o) {
              a = o.subscribe({
                next: i.next.bind(i),
                error: i.error.bind(i),
                complete: i.complete.bind(i)
              });
              return;
            }
            i.error(s);
          },
          complete: function() {
            o || i.complete.bind(i)();
          }
        });
      } catch (s) {
        e({ networkError: s, operation: t, forward: r }), i.error(s);
      }
      return function() {
        n && n.unsubscribe(), a && n.unsubscribe();
      };
    });
  });
}
(function(e) {
  Qa(t, e);
  function t(r) {
    var i = e.call(this) || this;
    return i.link = uF(r), i;
  }
  return t.prototype.request = function(r, i) {
    return this.link.request(r, i);
  }, t;
})(cs);
function Bq(e) {
  return mi(e) && "code" in e && "reason" in e;
}
function Rq(e) {
  var t;
  return mi(e) && ((t = e.target) === null || t === void 0 ? void 0 : t.readyState) === WebSocket.CLOSED;
}
var Oq = (
  /** @class */
  function(e) {
    Qa(t, e);
    function t(r) {
      var i = e.call(this) || this;
      return i.client = r, i;
    }
    return t.prototype.request = function(r) {
      var i = this;
      return new Yr(function(n) {
        return i.client.subscribe(ke(ke({}, r), { query: sD(r.query) }), {
          next: n.next.bind(n),
          complete: n.complete.bind(n),
          error: function(a) {
            if (a instanceof Error)
              return n.error(a);
            var o = Bq(a);
            return o || Rq(a) ? n.error(
              // reason will be available on clean closes
              new Error("Socket closed".concat(o ? " with event ".concat(a.code) : "").concat(o ? " ".concat(a.reason) : ""))
            ) : n.error(new $o({
              graphQLErrors: Array.isArray(a) ? a : [a]
            }));
          }
        });
      });
    }, t;
  }(cs)
);
const Pq = {
  AnalyticsEvent: [],
  ChatFeedback: [
    "ChatNegativeFeedback",
    "ChatPositiveFeedback"
  ],
  ChatMessage: [
    "BotMessage",
    "UserAnswer",
    "UserMessage"
  ],
  DiscordIntegrationNegativeFeedbackCallback: [
    "DiscordTagCallback"
  ],
  DocumentationGap: [
    "FirstPartyDocumentationGap",
    "FirstPartyFeatureGap",
    "ThirdPartyDocumentationGap",
    "ThirdPartyFeatureGap"
  ],
  IconType: [
    "BuiltInIcon",
    "CustomIcon"
  ],
  IntegrationConfiguration: [
    "DiscordIntegrationConfiguration",
    "MintlifyIntegrationConfiguration",
    "SlackIntegrationConfiguration",
    "WebIntegrationConfiguration"
  ],
  IntegrationRuntimeSettings: [
    "IntegrationRuntimeDiscordSettings",
    "IntegrationRuntimeSlackSettings",
    "SandboxPromotionRuntimeSettings",
    "SandboxWidgetSettings"
  ],
  ManagedQuestionAnswer: [
    "CustomQuestionAnswer",
    "RevisedAnswer"
  ],
  Report: [
    "DocumentationGapsReport"
  ],
  SearchHit: [
    "DiscourseHit",
    "DocumentationHit",
    "GitHubIssueHit",
    "StackOverflowHit"
  ],
  SearchRootRecord: [
    "DiscourseRecord",
    "DocumentationRecord",
    "GitHubIssueRecord",
    "StackOverflowRecord"
  ],
  SlackIntegrationNegativeFeedbackCallback: [
    "SlackTagCallback"
  ],
  Source: [
    "CustomIndexesSource",
    "CustomQuestionAnswersSource",
    "DiscordSource",
    "DiscourseSource",
    "DocusaurusSource",
    "GeneralWebSource",
    "GitHubSource",
    "GitbookSource",
    "ReadmeSource",
    "RedoclySource",
    "RevisedAnswersSource",
    "SlackSource",
    "StackOverflowSource",
    "ZendeskSource"
  ]
}, Nq = {
  possibleTypes: Pq
}, zq = new uq({
  possibleTypes: Nq.possibleTypes
}), cF = ({
  children: e
}) => {
  const {
    apiKey: t,
    chatApiProxyDomain: r,
    analyticsApiProxyDomain: i,
    consoleDebugLevel: n,
    env: a,
    userToken: o
  } = Xi(), s = r || "api.inkeep.com", l = i || "api.management.inkeep.com", u = Jt(() => {
    const d = a === "DEVELOPMENT" && s.includes("localhost") ? "ws" : "wss", c = a === "DEVELOPMENT" && s.includes("localhost") ? "http" : "https", p = a === "DEVELOPMENT" && l.includes("localhost") ? "http" : "https", f = {
      ...t ? { Authorization: `Bearer ${t}` } : {},
      ...o ? { "User-Token": o } : {}
    }, g = `${d}://${s}/graphql`, k = new Oq(
      hG({
        url: g,
        connectionParams: {
          headers: f
        }
      })
    ), y = `${c}://${s}/graphql`, _ = new b_({
      uri: y,
      headers: f
    }), A = `${p}://${l}/graphql`, T = new b_({
      uri: A,
      headers: f
    }), N = z9(
      ({ query: X }) => {
        const U = sc(X);
        if (U.kind === "OperationDefinition") {
          const {
            operation: K,
            selectionSet: { selections: z }
          } = U;
          if (K === "mutation") {
            const j = z[0];
            if (j && j.kind === "Field") {
              const J = j.name.value;
              return [
                "logUsageEvent",
                "logSearchEvent",
                "logPositiveFeedback",
                "logNegativeFeedback"
              ].includes(J);
            }
          }
        }
        return !1;
      },
      T,
      _
    ), P = z9(
      ({ query: X }) => {
        const U = sc(X);
        return U.kind === "OperationDefinition" && U.operation === "subscription";
      },
      k,
      N
    ), B = uF(
      ({ operation: X, graphQLErrors: U, networkError: K }) => {
        U && U.forEach(
          ({ message: z, locations: j, path: J }) => {
            n && n > s1.None && console.error(
              `[GraphQL error]: Message: ${z}, Location: ${JSON.stringify(
                j
              )}, Path: ${J}`
            );
          }
        ), K && n && n > s1.None && console.error(`[Network error]: ${K}`);
      }
    ), M = cs.from([B, P]);
    return new gq({
      link: M,
      cache: zq
    });
  }, [
    t,
    s,
    l,
    n,
    a,
    // hub,
    o
  ]);
  return /* @__PURE__ */ v.jsx(Cq, { client: u, children: e });
}, Lq = () => null, Mq = ({
  children: e,
  handleError: t
}) => /* @__PURE__ */ v.jsx(UA, { FallbackComponent: Lq, onError: t, children: e }), jq = Mq, dF = kn({}), Hq = () => {
  const {
    log: e
    // logBuffer,
  } = dn();
  return { handleError: (r, i) => {
    e(r), i && e(i);
  } };
}, pF = () => {
  const { log: e } = dn(), t = Pn(dF);
  if (t === void 0)
    throw e("errorLoggingContext is undefined"), new Error(
      "useErrorLoggingContext must be used within a InkeepErrorLoggingProvider"
    );
  return t;
}, hF = ({
  children: e
}) => {
  const { handleError: t } = Hq(), r = Jt(() => ({ handleError: t }), [t]);
  return /* @__PURE__ */ v.jsx(dF.Provider, { value: r, children: /* @__PURE__ */ v.jsx(jq, { handleError: t, children: e }) });
}, $q = () => {
  const { log: e } = dn(), [t, r] = rt(void 0), { shareChatUrlBasePath: i } = Qr();
  return gt(() => {
    if (i) {
      const n = () => {
        const { origin: o, pathname: s, search: l } = typeof window > "u" ? new URL("") : window.location, u = (f) => f.endsWith("/") ? f.slice(0, -1) : f, d = new URL(i), c = u(s), p = u(d.pathname);
        if (o === d.origin && c === p) {
          const g = new URLSearchParams(l).get("chatId");
          e("chatIdQueryParam: ", g), g && r(g);
        }
      }, a = () => {
        n();
      };
      return n(), typeof window < "u" && window.addEventListener("popstate", a), () => {
        typeof window < "u" && window.removeEventListener("popstate", a);
      };
    }
  }, [i]), t;
}, ED = $q, Uq = () => {
  const {
    userId: e,
    userEmail: t,
    userCohorts: r,
    userType: i,
    optOutAllAnalytics: n,
    optOutAnalyticalCookies: a
  } = Xi();
  dn();
  const [o, s] = rt({
    userType: i,
    userIdentificationType: "ANONYMOUS",
    userCohorts: r,
    userEmail: t,
    userId: e
  }), [l, u] = Ql(), d = qb();
  return gt(() => {
    let c = "ANONYMOUS", p = e, f = t, g = r;
    const k = !(n || a) && qb();
    n ? (c = "ANONYMOUS", p = void 0, f = void 0, g = void 0) : e ? (c = "ID_PROVIDED", p = e) : k && (c = "COOKIED", p = l.userId || H6()), k ? u("userId", p) : u("userId", void 0);
    const y = {
      ...o,
      userId: p,
      userIdentificationType: c,
      userEmail: f,
      userCohorts: g
    };
    s(y);
  }, [e, n, a, d, t, r]), o;
}, Vq = ts`
  mutation LogUsageEvent($input: LogUsageEventInput!) {
    logUsageEvent(input: $input) {
      success
    }
  }
`, Wq = "0.3.15", fF = kn(null), la = () => {
  const e = Pn(fF);
  if (!e)
    throw new Error(
      "useInkeepEvent must be used within an InkeepEventProvider"
    );
  return e;
}, Gq = ({
  children: e
}) => {
  dn();
  const [t, r] = Ql(), i = ED(), a = Qr().chatId || i, {
    organizationId: o,
    filters: s,
    integrationId: l,
    interactionType: u,
    logEventCallback: d
  } = Xi();
  let c, p = !1, { toggleButtonSettings: f } = Hl, g = !1, k = xg.Auto, y;
  const _ = !1;
  try {
    ({ defaultChatMode: c, chatMode: k, isChatSharingEnabled: p, toggleButtonSettings: f } = Qr()), { isChatModeToggleEnabled: g = !1 } = f ?? {};
  } catch {
  }
  const [A, T] = rt({
    widgetLibraryVersion: Wq,
    interactionType: u,
    chatModeComponentDefault: c || "AUTO",
    chatModeCurrentlySelected: k || null,
    isChatModeToggleEnabled: !!g,
    // isChatSharingEnabled: Boolean(isChatSharingEnabled),
    // searchModeComponentDefault: searchMode || SearchMode.Auto,
    // searchModeCurrentlySelected: browserStorage.searchMode || null,
    isModalModeSwitchingEnabled: !!_,
    modalViewComponentDefault: "SEARCH",
    modalViewCurrentlySelected: t.defaultView || null,
    sharedChatSessionId: a || null
  }), [N, P] = rt({
    filters: s,
    chatSessionId: a || null,
    chatMode: k
  }), [B, M] = rt({
    organization_id: o
  }), X = Uq();
  gt(() => {
    M((Ee) => ({
      ...Ee,
      organization_id: o
    }));
  }, [o]), gt(() => {
    T({
      ...A,
      interactionType: u
    });
  }, [u]), gt(() => {
    s && P((Ee) => ({ ...Ee, filters: s }));
  }, [s]), gt(() => {
    T((Ee) => ({
      ...Ee,
      chatModeComponentDefault: c || "AUTO",
      chatModeCurrentlySelected: t.chatMode || null,
      modalViewComponentDefault: "SEARCH",
      modalViewCurrentlySelected: t.defaultView || null,
      sharedChatSessionId: a || null
    }));
  }, [
    c,
    t.chatMode,
    // searchMode,
    // browserStorage.searchMode,
    y,
    t,
    a
  ]);
  const { env: U, optOutAllAnalytics: K, tags: z } = Xi(), [j, { data: J, loading: ie, error: ue }] = sF(Vq), de = Nt(
    (Ee) => {
      if (!K && U !== "DEVELOPMENT") {
        const Le = {
          eventName: Ee.eventName + "",
          metadata: {
            integrationId: l,
            user: {
              ...X,
              userIdentificationType: X.userIdentificationType,
              userType: X.userType
              // cast userType to the correct type
            },
            client: {
              inkeepWebWidget: {
                ...A,
                chatModeComponentDefault: c || xg.Auto,
                interactionType: u
              }
            },
            env: U
          },
          chatProperties: {
            ...N,
            chatMode: N.chatMode
          },
          eventProperties: { ...Ee.properties, tags: z }
        };
        j({
          variables: {
            input: Le
          }
        });
      }
      d && d({
        ...Ee,
        commonProperties: {
          ...B,
          ...A,
          ...N,
          ...X,
          tags: z
        }
      });
    },
    [
      K,
      U,
      d,
      l,
      X,
      A,
      c,
      u,
      N,
      z,
      j,
      B
    ]
  ), he = Jt(
    () => ({
      capture: de,
      webClientProps: A,
      chatSessionProperties: N,
      userProps: X
    }),
    [de, A, N, X]
  );
  return /* @__PURE__ */ v.jsx(fF.Provider, { value: he, children: e });
}, gF = Gq;
function mF() {
  const e = qt(null), [t, r] = rt({ width: 0, height: 0 });
  return gt(() => {
    if (!e.current)
      return;
    const i = new ResizeObserver(([n]) => {
      const { width: a, height: o } = n.contentRect;
      r({ width: a, height: o });
    });
    return i.observe(e.current), () => {
      i.disconnect();
    };
  }, [e]), [e, t];
}
const Kq = Te("button", Z_), pp = ({ ...e }) => /* @__PURE__ */ v.jsx(
  zn,
  {
    iconKey: "close",
    w: 5,
    h: 5,
    fontSize: "md",
    className: `${ye}-close-icon`,
    ...e
  }
);
function Yq(e) {
  return /* @__PURE__ */ v.jsx(
    Kq,
    {
      type: "button",
      _dark: { color: "whiteAlpha.500" },
      _light: { color: "gray.600" },
      ...e,
      children: /* @__PURE__ */ v.jsx(pp, {})
    }
  );
}
const $g = ({ children: e, ...t }) => /* @__PURE__ */ v.jsx(
  mt,
  {
    width: "100%",
    flexDirection: "column",
    flexGrow: 5,
    overflow: "hidden",
    justifyContent: "space-between",
    position: "relative",
    ...t,
    children: e
  }
), CD = ({ children: e, ...t }) => /* @__PURE__ */ v.jsx(Ct, { position: "relative", maxHeight: "100%", ...t, children: e }), xD = ({ children: e, ...t }) => /* @__PURE__ */ v.jsx(
  mt,
  {
    width: "100%",
    flexDirection: "column",
    overflow: "hidden",
    p: 0,
    position: "relative",
    flexGrow: 2,
    ...t,
    children: e
  }
), vF = ({ children: e, ...t }) => /* @__PURE__ */ v.jsx(Ct, { justifySelf: "flex-end", flexShrink: 0, position: "relative", ...t, children: e }), v4 = ["http", "https", "mailto", "tel"];
function qq(e) {
  const t = (e || "").trim(), r = t.charAt(0);
  if (r === "#" || r === "/")
    return t;
  const i = t.indexOf(":");
  if (i === -1)
    return t;
  let n = -1;
  for (; ++n < v4.length; ) {
    const a = v4[n];
    if (i === a.length && t.slice(0, a.length).toLowerCase() === a)
      return t;
  }
  return n = t.indexOf("?"), n !== -1 && i > n || (n = t.indexOf("#"), n !== -1 && i > n) ? t : "javascript:void(0)";
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var Qq = function(t) {
  return t != null && t.constructor != null && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
};
const kF = /* @__PURE__ */ is(Qq);
function Z0(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? k4(e.position) : "start" in e || "end" in e ? k4(e) : "line" in e || "column" in e ? I_(e) : "";
}
function I_(e) {
  return b4(e && e.line) + ":" + b4(e && e.column);
}
function k4(e) {
  return I_(e && e.start) + "-" + I_(e && e.end);
}
function b4(e) {
  return e && typeof e == "number" ? e : 1;
}
class Xa extends Error {
  /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // To do: next major: expose `undefined` everywhere instead of `null`.
  constructor(t, r, i) {
    const n = [null, null];
    let a = {
      // @ts-expect-error: we always follows the structure of `position`.
      start: { line: null, column: null },
      // @ts-expect-error: "
      end: { line: null, column: null }
    };
    if (super(), typeof r == "string" && (i = r, r = void 0), typeof i == "string") {
      const o = i.indexOf(":");
      o === -1 ? n[1] = i : (n[0] = i.slice(0, o), n[1] = i.slice(o + 1));
    }
    r && ("type" in r || "position" in r ? r.position && (a = r.position) : "start" in r || "end" in r ? a = r : ("line" in r || "column" in r) && (a.start = r)), this.name = Z0(r) || "1:1", this.message = typeof t == "object" ? t.message : t, this.stack = "", typeof t == "object" && t.stack && (this.stack = t.stack), this.reason = this.message, this.fatal, this.line = a.start.line, this.column = a.start.column, this.position = a, this.source = n[0], this.ruleId = n[1], this.file, this.actual, this.expected, this.url, this.note;
  }
}
Xa.prototype.file = "";
Xa.prototype.name = "";
Xa.prototype.reason = "";
Xa.prototype.message = "";
Xa.prototype.stack = "";
Xa.prototype.fatal = null;
Xa.prototype.column = null;
Xa.prototype.line = null;
Xa.prototype.source = null;
Xa.prototype.ruleId = null;
Xa.prototype.position = null;
const Ho = { basename: Xq, dirname: Zq, extname: Jq, join: eQ, sep: "/" };
function Xq(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  Y1(e);
  let r = 0, i = -1, n = e.length, a;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; n--; )
      if (e.charCodeAt(n) === 47) {
        if (a) {
          r = n + 1;
          break;
        }
      } else
        i < 0 && (a = !0, i = n + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (t === e)
    return "";
  let o = -1, s = t.length - 1;
  for (; n--; )
    if (e.charCodeAt(n) === 47) {
      if (a) {
        r = n + 1;
        break;
      }
    } else
      o < 0 && (a = !0, o = n + 1), s > -1 && (e.charCodeAt(n) === t.charCodeAt(s--) ? s < 0 && (i = n) : (s = -1, i = o));
  return r === i ? i = o : i < 0 && (i = e.length), e.slice(r, i);
}
function Zq(e) {
  if (Y1(e), e.length === 0)
    return ".";
  let t = -1, r = e.length, i;
  for (; --r; )
    if (e.charCodeAt(r) === 47) {
      if (i) {
        t = r;
        break;
      }
    } else
      i || (i = !0);
  return t < 0 ? e.charCodeAt(0) === 47 ? "/" : "." : t === 1 && e.charCodeAt(0) === 47 ? "//" : e.slice(0, t);
}
function Jq(e) {
  Y1(e);
  let t = e.length, r = -1, i = 0, n = -1, a = 0, o;
  for (; t--; ) {
    const s = e.charCodeAt(t);
    if (s === 47) {
      if (o) {
        i = t + 1;
        break;
      }
      continue;
    }
    r < 0 && (o = !0, r = t + 1), s === 46 ? n < 0 ? n = t : a !== 1 && (a = 1) : n > -1 && (a = -1);
  }
  return n < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  a === 0 || // The (right-most) trimmed path component is exactly `..`.
  a === 1 && n === r - 1 && n === i + 1 ? "" : e.slice(n, r);
}
function eQ(...e) {
  let t = -1, r;
  for (; ++t < e.length; )
    Y1(e[t]), e[t] && (r = r === void 0 ? e[t] : r + "/" + e[t]);
  return r === void 0 ? "." : tQ(r);
}
function tQ(e) {
  Y1(e);
  const t = e.charCodeAt(0) === 47;
  let r = rQ(e, !t);
  return r.length === 0 && !t && (r = "."), r.length > 0 && e.charCodeAt(e.length - 1) === 47 && (r += "/"), t ? "/" + r : r;
}
function rQ(e, t) {
  let r = "", i = 0, n = -1, a = 0, o = -1, s, l;
  for (; ++o <= e.length; ) {
    if (o < e.length)
      s = e.charCodeAt(o);
    else {
      if (s === 47)
        break;
      s = 47;
    }
    if (s === 47) {
      if (!(n === o - 1 || a === 1))
        if (n !== o - 1 && a === 2) {
          if (r.length < 2 || i !== 2 || r.charCodeAt(r.length - 1) !== 46 || r.charCodeAt(r.length - 2) !== 46) {
            if (r.length > 2) {
              if (l = r.lastIndexOf("/"), l !== r.length - 1) {
                l < 0 ? (r = "", i = 0) : (r = r.slice(0, l), i = r.length - 1 - r.lastIndexOf("/")), n = o, a = 0;
                continue;
              }
            } else if (r.length > 0) {
              r = "", i = 0, n = o, a = 0;
              continue;
            }
          }
          t && (r = r.length > 0 ? r + "/.." : "..", i = 2);
        } else
          r.length > 0 ? r += "/" + e.slice(n + 1, o) : r = e.slice(n + 1, o), i = o - n - 1;
      n = o, a = 0;
    } else
      s === 46 && a > -1 ? a++ : a = -1;
  }
  return r;
}
function Y1(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const iQ = { cwd: nQ };
function nQ() {
  return "/";
}
function B_(e) {
  return e !== null && typeof e == "object" && // @ts-expect-error: indexable.
  e.href && // @ts-expect-error: indexable.
  e.origin;
}
function aQ(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!B_(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return oQ(e);
}
function oQ(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const t = e.pathname;
  let r = -1;
  for (; ++r < t.length; )
    if (t.charCodeAt(r) === 37 && t.charCodeAt(r + 1) === 50) {
      const i = t.charCodeAt(r + 2);
      if (i === 70 || i === 102) {
        const n = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw n.code = "ERR_INVALID_FILE_URL_PATH", n;
      }
    }
  return decodeURIComponent(t);
}
const Gk = ["history", "path", "basename", "stem", "extname", "dirname"];
class bF {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let r;
    t ? typeof t == "string" || sQ(t) ? r = { value: t } : B_(t) ? r = { path: t } : r = t : r = {}, this.data = {}, this.messages = [], this.history = [], this.cwd = iQ.cwd(), this.value, this.stored, this.result, this.map;
    let i = -1;
    for (; ++i < Gk.length; ) {
      const a = Gk[i];
      a in r && r[a] !== void 0 && r[a] !== null && (this[a] = a === "history" ? [...r[a]] : r[a]);
    }
    let n;
    for (n in r)
      Gk.includes(n) || (this[n] = r[n]);
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */
  set path(t) {
    B_(t) && (t = aQ(t)), Yk(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the parent path (example: `'~'`).
   */
  get dirname() {
    return typeof this.path == "string" ? Ho.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */
  set dirname(t) {
    _4(this.basename, "dirname"), this.path = Ho.join(t || "", this.basename);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */
  get basename() {
    return typeof this.path == "string" ? Ho.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set basename(t) {
    Yk(t, "basename"), Kk(t, "basename"), this.path = Ho.join(this.dirname || "", t);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   */
  get extname() {
    return typeof this.path == "string" ? Ho.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */
  set extname(t) {
    if (Kk(t, "extname"), _4(this.dirname, "extname"), t) {
      if (t.charCodeAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Ho.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */
  get stem() {
    return typeof this.path == "string" ? Ho.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set stem(t) {
    Yk(t, "stem"), Kk(t, "stem"), this.path = Ho.join(this.dirname || "", t + (this.extname || ""));
  }
  /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return (this.value || "").toString(t || void 0);
  }
  /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, r, i) {
    const n = new Xa(t, r, i);
    return this.path && (n.name = this.path + ":" + n.name, n.file = this.path), n.fatal = !1, this.messages.push(n), n;
  }
  /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, r, i) {
    const n = this.message(t, r, i);
    return n.fatal = null, n;
  }
  /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, r, i) {
    const n = this.message(t, r, i);
    throw n.fatal = !0, n;
  }
}
function Kk(e, t) {
  if (e && e.includes(Ho.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + Ho.sep + "`"
    );
}
function Yk(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function _4(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function sQ(e) {
  return kF(e);
}
function D4(e) {
  if (e)
    throw e;
}
var Zf = Object.prototype.hasOwnProperty, _F = Object.prototype.toString, y4 = Object.defineProperty, E4 = Object.getOwnPropertyDescriptor, C4 = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : _F.call(t) === "[object Array]";
}, x4 = function(t) {
  if (!t || _F.call(t) !== "[object Object]")
    return !1;
  var r = Zf.call(t, "constructor"), i = t.constructor && t.constructor.prototype && Zf.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !r && !i)
    return !1;
  var n;
  for (n in t)
    ;
  return typeof n > "u" || Zf.call(t, n);
}, A4 = function(t, r) {
  y4 && r.name === "__proto__" ? y4(t, r.name, {
    enumerable: !0,
    configurable: !0,
    value: r.newValue,
    writable: !0
  }) : t[r.name] = r.newValue;
}, w4 = function(t, r) {
  if (r === "__proto__")
    if (Zf.call(t, r)) {
      if (E4)
        return E4(t, r).value;
    } else
      return;
  return t[r];
}, lQ = function e() {
  var t, r, i, n, a, o, s = arguments[0], l = 1, u = arguments.length, d = !1;
  for (typeof s == "boolean" && (d = s, s = arguments[1] || {}, l = 2), (s == null || typeof s != "object" && typeof s != "function") && (s = {}); l < u; ++l)
    if (t = arguments[l], t != null)
      for (r in t)
        i = w4(s, r), n = w4(t, r), s !== n && (d && n && (x4(n) || (a = C4(n))) ? (a ? (a = !1, o = i && C4(i) ? i : []) : o = i && x4(i) ? i : {}, A4(s, { name: r, newValue: e(d, o, n) })) : typeof n < "u" && A4(s, { name: r, newValue: n }));
  return s;
};
const F4 = /* @__PURE__ */ is(lQ);
function R_(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function uQ() {
  const e = [], t = { run: r, use: i };
  return t;
  function r(...n) {
    let a = -1;
    const o = n.pop();
    if (typeof o != "function")
      throw new TypeError("Expected function as last argument, not " + o);
    s(null, ...n);
    function s(l, ...u) {
      const d = e[++a];
      let c = -1;
      if (l) {
        o(l);
        return;
      }
      for (; ++c < n.length; )
        (u[c] === null || u[c] === void 0) && (u[c] = n[c]);
      n = u, d ? cQ(d, s)(...u) : o(null, ...u);
    }
  }
  function i(n) {
    if (typeof n != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + n
      );
    return e.push(n), t;
  }
}
function cQ(e, t) {
  let r;
  return i;
  function i(...o) {
    const s = e.length > o.length;
    let l;
    s && o.push(n);
    try {
      l = e.apply(this, o);
    } catch (u) {
      const d = (
        /** @type {Error} */
        u
      );
      if (s && r)
        throw d;
      return n(d);
    }
    s || (l instanceof Promise ? l.then(a, n) : l instanceof Error ? n(l) : a(l));
  }
  function n(o, ...s) {
    r || (r = !0, t(o, ...s));
  }
  function a(o) {
    n(null, o);
  }
}
const dQ = yF().freeze(), DF = {}.hasOwnProperty;
function yF() {
  const e = uQ(), t = [];
  let r = {}, i, n = -1;
  return a.data = o, a.Parser = void 0, a.Compiler = void 0, a.freeze = s, a.attachers = t, a.use = l, a.parse = u, a.stringify = d, a.run = c, a.runSync = p, a.process = f, a.processSync = g, a;
  function a() {
    const k = yF();
    let y = -1;
    for (; ++y < t.length; )
      k.use(...t[y]);
    return k.data(F4(!0, {}, r)), k;
  }
  function o(k, y) {
    return typeof k == "string" ? arguments.length === 2 ? (Xk("data", i), r[k] = y, a) : DF.call(r, k) && r[k] || null : k ? (Xk("data", i), r = k, a) : r;
  }
  function s() {
    if (i)
      return a;
    for (; ++n < t.length; ) {
      const [k, ...y] = t[n];
      if (y[0] === !1)
        continue;
      y[0] === !0 && (y[0] = void 0);
      const _ = k.call(a, ...y);
      typeof _ == "function" && e.use(_);
    }
    return i = !0, n = Number.POSITIVE_INFINITY, a;
  }
  function l(k, ...y) {
    let _;
    if (Xk("use", i), k != null)
      if (typeof k == "function")
        P(k, ...y);
      else if (typeof k == "object")
        Array.isArray(k) ? N(k) : T(k);
      else
        throw new TypeError("Expected usable value, not `" + k + "`");
    return _ && (r.settings = Object.assign(r.settings || {}, _)), a;
    function A(B) {
      if (typeof B == "function")
        P(B);
      else if (typeof B == "object")
        if (Array.isArray(B)) {
          const [M, ...X] = B;
          P(M, ...X);
        } else
          T(B);
      else
        throw new TypeError("Expected usable value, not `" + B + "`");
    }
    function T(B) {
      N(B.plugins), B.settings && (_ = Object.assign(_ || {}, B.settings));
    }
    function N(B) {
      let M = -1;
      if (B != null)
        if (Array.isArray(B))
          for (; ++M < B.length; ) {
            const X = B[M];
            A(X);
          }
        else
          throw new TypeError("Expected a list of plugins, not `" + B + "`");
    }
    function P(B, M) {
      let X = -1, U;
      for (; ++X < t.length; )
        if (t[X][0] === B) {
          U = t[X];
          break;
        }
      U ? (R_(U[1]) && R_(M) && (M = F4(!0, U[1], M)), U[1] = M) : t.push([...arguments]);
    }
  }
  function u(k) {
    a.freeze();
    const y = F0(k), _ = a.Parser;
    return qk("parse", _), T4(_, "parse") ? new _(String(y), y).parse() : _(String(y), y);
  }
  function d(k, y) {
    a.freeze();
    const _ = F0(y), A = a.Compiler;
    return Qk("stringify", A), S4(k), T4(A, "compile") ? new A(k, _).compile() : A(k, _);
  }
  function c(k, y, _) {
    if (S4(k), a.freeze(), !_ && typeof y == "function" && (_ = y, y = void 0), !_)
      return new Promise(A);
    A(null, _);
    function A(T, N) {
      e.run(k, F0(y), P);
      function P(B, M, X) {
        M = M || k, B ? N(B) : T ? T(M) : _(null, M, X);
      }
    }
  }
  function p(k, y) {
    let _, A;
    return a.run(k, y, T), I4("runSync", "run", A), _;
    function T(N, P) {
      D4(N), _ = P, A = !0;
    }
  }
  function f(k, y) {
    if (a.freeze(), qk("process", a.Parser), Qk("process", a.Compiler), !y)
      return new Promise(_);
    _(null, y);
    function _(A, T) {
      const N = F0(k);
      a.run(a.parse(N), N, (B, M, X) => {
        if (B || !M || !X)
          P(B);
        else {
          const U = a.stringify(M, X);
          U == null || (fQ(U) ? X.value = U : X.result = U), P(B, X);
        }
      });
      function P(B, M) {
        B || !M ? T(B) : A ? A(M) : y(null, M);
      }
    }
  }
  function g(k) {
    let y;
    a.freeze(), qk("processSync", a.Parser), Qk("processSync", a.Compiler);
    const _ = F0(k);
    return a.process(_, A), I4("processSync", "process", y), _;
    function A(T) {
      y = !0, D4(T);
    }
  }
}
function T4(e, t) {
  return typeof e == "function" && // Prototypes do exist.
  // type-coverage:ignore-next-line
  e.prototype && // A function with keys in its prototype is probably a constructor.
  // Classes’ prototype methods are not enumerable, so we check if some value
  // exists in the prototype.
  // type-coverage:ignore-next-line
  (pQ(e.prototype) || t in e.prototype);
}
function pQ(e) {
  let t;
  for (t in e)
    if (DF.call(e, t))
      return !0;
  return !1;
}
function qk(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Parser`");
}
function Qk(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Compiler`");
}
function Xk(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function S4(e) {
  if (!R_(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function I4(e, t, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function F0(e) {
  return hQ(e) ? e : new bF(e);
}
function hQ(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function fQ(e) {
  return typeof e == "string" || kF(e);
}
const gQ = {};
function mQ(e, t) {
  const r = t || gQ, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, n = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return EF(e, i, n);
}
function EF(e, t, r) {
  if (vQ(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return B4(e.children, t, r);
  }
  return Array.isArray(e) ? B4(e, t, r) : "";
}
function B4(e, t, r) {
  const i = [];
  let n = -1;
  for (; ++n < e.length; )
    i[n] = EF(e[n], t, r);
  return i.join("");
}
function vQ(e) {
  return !!(e && typeof e == "object");
}
function rs(e, t, r, i) {
  const n = e.length;
  let a = 0, o;
  if (t < 0 ? t = -t > n ? 0 : n + t : t = t > n ? n : t, r = r > 0 ? r : 0, i.length < 1e4)
    o = Array.from(i), o.unshift(t, r), e.splice(...o);
  else
    for (r && e.splice(t, r); a < i.length; )
      o = i.slice(a, a + 1e4), o.unshift(t, 0), e.splice(...o), a += 1e4, t += 1e4;
}
function Ha(e, t) {
  return e.length > 0 ? (rs(e, e.length, 0, t), e) : t;
}
const R4 = {}.hasOwnProperty;
function kQ(e) {
  const t = {};
  let r = -1;
  for (; ++r < e.length; )
    bQ(t, e[r]);
  return t;
}
function bQ(e, t) {
  let r;
  for (r in t) {
    const n = (R4.call(e, r) ? e[r] : void 0) || (e[r] = {}), a = t[r];
    let o;
    if (a)
      for (o in a) {
        R4.call(n, o) || (n[o] = []);
        const s = a[o];
        _Q(
          // @ts-expect-error Looks like a list.
          n[o],
          Array.isArray(s) ? s : s ? [s] : []
        );
      }
  }
}
function _Q(e, t) {
  let r = -1;
  const i = [];
  for (; ++r < t.length; )
    (t[r].add === "after" ? e : i).push(t[r]);
  rs(e, 0, 0, i);
}
const DQ = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, Uo = Xl(/[A-Za-z]/), Ea = Xl(/[\dA-Za-z]/), yQ = Xl(/[#-'*+\--9=?A-Z^-~]/);
function O_(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const P_ = Xl(/\d/), EQ = Xl(/[\dA-Fa-f]/), CQ = Xl(/[!-/:-@[-`{-~]/);
function Ht(e) {
  return e !== null && e < -2;
}
function na(e) {
  return e !== null && (e < 0 || e === 32);
}
function yr(e) {
  return e === -2 || e === -1 || e === 32;
}
const xQ = Xl(DQ), AQ = Xl(/\s/);
function Xl(e) {
  return t;
  function t(r) {
    return r !== null && e.test(String.fromCharCode(r));
  }
}
function ii(e, t, r, i) {
  const n = i ? i - 1 : Number.POSITIVE_INFINITY;
  let a = 0;
  return o;
  function o(l) {
    return yr(l) ? (e.enter(r), s(l)) : t(l);
  }
  function s(l) {
    return yr(l) && a++ < n ? (e.consume(l), s) : (e.exit(r), t(l));
  }
}
const wQ = {
  tokenize: FQ
};
function FQ(e) {
  const t = e.attempt(
    this.parser.constructs.contentInitial,
    i,
    n
  );
  let r;
  return t;
  function i(s) {
    if (s === null) {
      e.consume(s);
      return;
    }
    return e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), ii(e, t, "linePrefix");
  }
  function n(s) {
    return e.enter("paragraph"), a(s);
  }
  function a(s) {
    const l = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = l), r = l, o(s);
  }
  function o(s) {
    if (s === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(s);
      return;
    }
    return Ht(s) ? (e.consume(s), e.exit("chunkText"), a) : (e.consume(s), o);
  }
}
const TQ = {
  tokenize: SQ
}, O4 = {
  tokenize: IQ
};
function SQ(e) {
  const t = this, r = [];
  let i = 0, n, a, o;
  return s;
  function s(T) {
    if (i < r.length) {
      const N = r[i];
      return t.containerState = N[1], e.attempt(
        N[0].continuation,
        l,
        u
      )(T);
    }
    return u(T);
  }
  function l(T) {
    if (i++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, n && A();
      const N = t.events.length;
      let P = N, B;
      for (; P--; )
        if (t.events[P][0] === "exit" && t.events[P][1].type === "chunkFlow") {
          B = t.events[P][1].end;
          break;
        }
      _(i);
      let M = N;
      for (; M < t.events.length; )
        t.events[M][1].end = Object.assign({}, B), M++;
      return rs(
        t.events,
        P + 1,
        0,
        t.events.slice(N)
      ), t.events.length = M, u(T);
    }
    return s(T);
  }
  function u(T) {
    if (i === r.length) {
      if (!n)
        return p(T);
      if (n.currentConstruct && n.currentConstruct.concrete)
        return g(T);
      t.interrupt = !!(n.currentConstruct && !n._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(
      O4,
      d,
      c
    )(T);
  }
  function d(T) {
    return n && A(), _(i), p(T);
  }
  function c(T) {
    return t.parser.lazy[t.now().line] = i !== r.length, o = t.now().offset, g(T);
  }
  function p(T) {
    return t.containerState = {}, e.attempt(
      O4,
      f,
      g
    )(T);
  }
  function f(T) {
    return i++, r.push([t.currentConstruct, t.containerState]), p(T);
  }
  function g(T) {
    if (T === null) {
      n && A(), _(0), e.consume(T);
      return;
    }
    return n = n || t.parser.flow(t.now()), e.enter("chunkFlow", {
      contentType: "flow",
      previous: a,
      _tokenizer: n
    }), k(T);
  }
  function k(T) {
    if (T === null) {
      y(e.exit("chunkFlow"), !0), _(0), e.consume(T);
      return;
    }
    return Ht(T) ? (e.consume(T), y(e.exit("chunkFlow")), i = 0, t.interrupt = void 0, s) : (e.consume(T), k);
  }
  function y(T, N) {
    const P = t.sliceStream(T);
    if (N && P.push(null), T.previous = a, a && (a.next = T), a = T, n.defineSkip(T.start), n.write(P), t.parser.lazy[T.start.line]) {
      let B = n.events.length;
      for (; B--; )
        if (
          // The token starts before the line ending…
          n.events[B][1].start.offset < o && // …and either is not ended yet…
          (!n.events[B][1].end || // …or ends after it.
          n.events[B][1].end.offset > o)
        )
          return;
      const M = t.events.length;
      let X = M, U, K;
      for (; X--; )
        if (t.events[X][0] === "exit" && t.events[X][1].type === "chunkFlow") {
          if (U) {
            K = t.events[X][1].end;
            break;
          }
          U = !0;
        }
      for (_(i), B = M; B < t.events.length; )
        t.events[B][1].end = Object.assign({}, K), B++;
      rs(
        t.events,
        X + 1,
        0,
        t.events.slice(M)
      ), t.events.length = B;
    }
  }
  function _(T) {
    let N = r.length;
    for (; N-- > T; ) {
      const P = r[N];
      t.containerState = P[1], P[0].exit.call(t, e);
    }
    r.length = T;
  }
  function A() {
    n.write([null]), a = void 0, n = void 0, t.containerState._closeFlow = void 0;
  }
}
function IQ(e, t, r) {
  return ii(
    e,
    e.attempt(this.parser.constructs.document, t, r),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function P4(e) {
  if (e === null || na(e) || AQ(e))
    return 1;
  if (xQ(e))
    return 2;
}
function AD(e, t, r) {
  const i = [];
  let n = -1;
  for (; ++n < e.length; ) {
    const a = e[n].resolveAll;
    a && !i.includes(a) && (t = a(t, r), i.push(a));
  }
  return t;
}
const N_ = {
  name: "attention",
  tokenize: RQ,
  resolveAll: BQ
};
function BQ(e, t) {
  let r = -1, i, n, a, o, s, l, u, d;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        t.sliceSerialize(e[i][1]).charCodeAt(0) === t.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          l = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const c = Object.assign({}, e[i][1].end), p = Object.assign({}, e[r][1].start);
          N4(c, -l), N4(p, l), o = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: c,
            end: Object.assign({}, e[i][1].end)
          }, s = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, e[r][1].start),
            end: p
          }, a = {
            type: l > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, e[i][1].end),
            end: Object.assign({}, e[r][1].start)
          }, n = {
            type: l > 1 ? "strong" : "emphasis",
            start: Object.assign({}, o.start),
            end: Object.assign({}, s.end)
          }, e[i][1].end = Object.assign({}, o.start), e[r][1].start = Object.assign({}, s.end), u = [], e[i][1].end.offset - e[i][1].start.offset && (u = Ha(u, [
            ["enter", e[i][1], t],
            ["exit", e[i][1], t]
          ])), u = Ha(u, [
            ["enter", n, t],
            ["enter", o, t],
            ["exit", o, t],
            ["enter", a, t]
          ]), u = Ha(
            u,
            AD(
              t.parser.constructs.insideSpan.null,
              e.slice(i + 1, r),
              t
            )
          ), u = Ha(u, [
            ["exit", a, t],
            ["enter", s, t],
            ["exit", s, t],
            ["exit", n, t]
          ]), e[r][1].end.offset - e[r][1].start.offset ? (d = 2, u = Ha(u, [
            ["enter", e[r][1], t],
            ["exit", e[r][1], t]
          ])) : d = 0, rs(e, i - 1, r - i + 3, u), r = i + u.length - d - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function RQ(e, t) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, n = P4(i);
  let a;
  return o;
  function o(l) {
    return a = l, e.enter("attentionSequence"), s(l);
  }
  function s(l) {
    if (l === a)
      return e.consume(l), s;
    const u = e.exit("attentionSequence"), d = P4(l), c = !d || d === 2 && n || r.includes(l), p = !n || n === 2 && d || r.includes(i);
    return u._open = !!(a === 42 ? c : c && (n || !p)), u._close = !!(a === 42 ? p : p && (d || !c)), t(l);
  }
}
function N4(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const OQ = {
  name: "autolink",
  tokenize: PQ
};
function PQ(e, t, r) {
  let i = 0;
  return n;
  function n(f) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(f), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), a;
  }
  function a(f) {
    return Uo(f) ? (e.consume(f), o) : u(f);
  }
  function o(f) {
    return f === 43 || f === 45 || f === 46 || Ea(f) ? (i = 1, s(f)) : u(f);
  }
  function s(f) {
    return f === 58 ? (e.consume(f), i = 0, l) : (f === 43 || f === 45 || f === 46 || Ea(f)) && i++ < 32 ? (e.consume(f), s) : (i = 0, u(f));
  }
  function l(f) {
    return f === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(f), e.exit("autolinkMarker"), e.exit("autolink"), t) : f === null || f === 32 || f === 60 || O_(f) ? r(f) : (e.consume(f), l);
  }
  function u(f) {
    return f === 64 ? (e.consume(f), d) : yQ(f) ? (e.consume(f), u) : r(f);
  }
  function d(f) {
    return Ea(f) ? c(f) : r(f);
  }
  function c(f) {
    return f === 46 ? (e.consume(f), i = 0, d) : f === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(f), e.exit("autolinkMarker"), e.exit("autolink"), t) : p(f);
  }
  function p(f) {
    if ((f === 45 || Ea(f)) && i++ < 63) {
      const g = f === 45 ? p : c;
      return e.consume(f), g;
    }
    return r(f);
  }
}
const Nm = {
  tokenize: NQ,
  partial: !0
};
function NQ(e, t, r) {
  return i;
  function i(a) {
    return yr(a) ? ii(e, n, "linePrefix")(a) : n(a);
  }
  function n(a) {
    return a === null || Ht(a) ? t(a) : r(a);
  }
}
const CF = {
  name: "blockQuote",
  tokenize: zQ,
  continuation: {
    tokenize: LQ
  },
  exit: MQ
};
function zQ(e, t, r) {
  const i = this;
  return n;
  function n(o) {
    if (o === 62) {
      const s = i.containerState;
      return s.open || (e.enter("blockQuote", {
        _container: !0
      }), s.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(o), e.exit("blockQuoteMarker"), a;
    }
    return r(o);
  }
  function a(o) {
    return yr(o) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(o), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(o));
  }
}
function LQ(e, t, r) {
  const i = this;
  return n;
  function n(o) {
    return yr(o) ? ii(
      e,
      a,
      "linePrefix",
      i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(o) : a(o);
  }
  function a(o) {
    return e.attempt(CF, t, r)(o);
  }
}
function MQ(e) {
  e.exit("blockQuote");
}
const xF = {
  name: "characterEscape",
  tokenize: jQ
};
function jQ(e, t, r) {
  return i;
  function i(a) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(a), e.exit("escapeMarker"), n;
  }
  function n(a) {
    return CQ(a) ? (e.enter("characterEscapeValue"), e.consume(a), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : r(a);
  }
}
const z4 = document.createElement("i");
function wD(e) {
  const t = "&" + e + ";";
  z4.innerHTML = t;
  const r = z4.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === t ? !1 : r;
}
const AF = {
  name: "characterReference",
  tokenize: HQ
};
function HQ(e, t, r) {
  const i = this;
  let n = 0, a, o;
  return s;
  function s(c) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(c), e.exit("characterReferenceMarker"), l;
  }
  function l(c) {
    return c === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(c), e.exit("characterReferenceMarkerNumeric"), u) : (e.enter("characterReferenceValue"), a = 31, o = Ea, d(c));
  }
  function u(c) {
    return c === 88 || c === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(c), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), a = 6, o = EQ, d) : (e.enter("characterReferenceValue"), a = 7, o = P_, d(c));
  }
  function d(c) {
    if (c === 59 && n) {
      const p = e.exit("characterReferenceValue");
      return o === Ea && !wD(i.sliceSerialize(p)) ? r(c) : (e.enter("characterReferenceMarker"), e.consume(c), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return o(c) && n++ < a ? (e.consume(c), d) : r(c);
  }
}
const L4 = {
  tokenize: UQ,
  partial: !0
}, M4 = {
  name: "codeFenced",
  tokenize: $Q,
  concrete: !0
};
function $Q(e, t, r) {
  const i = this, n = {
    tokenize: P,
    partial: !0
  };
  let a = 0, o = 0, s;
  return l;
  function l(B) {
    return u(B);
  }
  function u(B) {
    const M = i.events[i.events.length - 1];
    return a = M && M[1].type === "linePrefix" ? M[2].sliceSerialize(M[1], !0).length : 0, s = B, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), d(B);
  }
  function d(B) {
    return B === s ? (o++, e.consume(B), d) : o < 3 ? r(B) : (e.exit("codeFencedFenceSequence"), yr(B) ? ii(e, c, "whitespace")(B) : c(B));
  }
  function c(B) {
    return B === null || Ht(B) ? (e.exit("codeFencedFence"), i.interrupt ? t(B) : e.check(L4, k, N)(B)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), p(B));
  }
  function p(B) {
    return B === null || Ht(B) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), c(B)) : yr(B) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), ii(e, f, "whitespace")(B)) : B === 96 && B === s ? r(B) : (e.consume(B), p);
  }
  function f(B) {
    return B === null || Ht(B) ? c(B) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), g(B));
  }
  function g(B) {
    return B === null || Ht(B) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), c(B)) : B === 96 && B === s ? r(B) : (e.consume(B), g);
  }
  function k(B) {
    return e.attempt(n, N, y)(B);
  }
  function y(B) {
    return e.enter("lineEnding"), e.consume(B), e.exit("lineEnding"), _;
  }
  function _(B) {
    return a > 0 && yr(B) ? ii(
      e,
      A,
      "linePrefix",
      a + 1
    )(B) : A(B);
  }
  function A(B) {
    return B === null || Ht(B) ? e.check(L4, k, N)(B) : (e.enter("codeFlowValue"), T(B));
  }
  function T(B) {
    return B === null || Ht(B) ? (e.exit("codeFlowValue"), A(B)) : (e.consume(B), T);
  }
  function N(B) {
    return e.exit("codeFenced"), t(B);
  }
  function P(B, M, X) {
    let U = 0;
    return K;
    function K(ue) {
      return B.enter("lineEnding"), B.consume(ue), B.exit("lineEnding"), z;
    }
    function z(ue) {
      return B.enter("codeFencedFence"), yr(ue) ? ii(
        B,
        j,
        "linePrefix",
        i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )(ue) : j(ue);
    }
    function j(ue) {
      return ue === s ? (B.enter("codeFencedFenceSequence"), J(ue)) : X(ue);
    }
    function J(ue) {
      return ue === s ? (U++, B.consume(ue), J) : U >= o ? (B.exit("codeFencedFenceSequence"), yr(ue) ? ii(B, ie, "whitespace")(ue) : ie(ue)) : X(ue);
    }
    function ie(ue) {
      return ue === null || Ht(ue) ? (B.exit("codeFencedFence"), M(ue)) : X(ue);
    }
  }
}
function UQ(e, t, r) {
  const i = this;
  return n;
  function n(o) {
    return o === null ? r(o) : (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), a);
  }
  function a(o) {
    return i.parser.lazy[i.now().line] ? r(o) : t(o);
  }
}
const Zk = {
  name: "codeIndented",
  tokenize: WQ
}, VQ = {
  tokenize: GQ,
  partial: !0
};
function WQ(e, t, r) {
  const i = this;
  return n;
  function n(u) {
    return e.enter("codeIndented"), ii(e, a, "linePrefix", 4 + 1)(u);
  }
  function a(u) {
    const d = i.events[i.events.length - 1];
    return d && d[1].type === "linePrefix" && d[2].sliceSerialize(d[1], !0).length >= 4 ? o(u) : r(u);
  }
  function o(u) {
    return u === null ? l(u) : Ht(u) ? e.attempt(VQ, o, l)(u) : (e.enter("codeFlowValue"), s(u));
  }
  function s(u) {
    return u === null || Ht(u) ? (e.exit("codeFlowValue"), o(u)) : (e.consume(u), s);
  }
  function l(u) {
    return e.exit("codeIndented"), t(u);
  }
}
function GQ(e, t, r) {
  const i = this;
  return n;
  function n(o) {
    return i.parser.lazy[i.now().line] ? r(o) : Ht(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n) : ii(e, a, "linePrefix", 4 + 1)(o);
  }
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(o) : Ht(o) ? n(o) : r(o);
  }
}
const KQ = {
  name: "codeText",
  tokenize: QQ,
  resolve: YQ,
  previous: qQ
};
function YQ(e) {
  let t = e.length - 4, r = 3, i, n;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (i = r; ++i < t; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", r += 2, t -= 2;
        break;
      }
  }
  for (i = r - 1, t++; ++i <= t; )
    n === void 0 ? i !== t && e[i][1].type !== "lineEnding" && (n = i) : (i === t || e[i][1].type === "lineEnding") && (e[n][1].type = "codeTextData", i !== n + 2 && (e[n][1].end = e[i - 1][1].end, e.splice(n + 2, i - n - 2), t -= i - n - 2, i = n + 2), n = void 0);
  return e;
}
function qQ(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function QQ(e, t, r) {
  let i = 0, n, a;
  return o;
  function o(c) {
    return e.enter("codeText"), e.enter("codeTextSequence"), s(c);
  }
  function s(c) {
    return c === 96 ? (e.consume(c), i++, s) : (e.exit("codeTextSequence"), l(c));
  }
  function l(c) {
    return c === null ? r(c) : c === 32 ? (e.enter("space"), e.consume(c), e.exit("space"), l) : c === 96 ? (a = e.enter("codeTextSequence"), n = 0, d(c)) : Ht(c) ? (e.enter("lineEnding"), e.consume(c), e.exit("lineEnding"), l) : (e.enter("codeTextData"), u(c));
  }
  function u(c) {
    return c === null || c === 32 || c === 96 || Ht(c) ? (e.exit("codeTextData"), l(c)) : (e.consume(c), u);
  }
  function d(c) {
    return c === 96 ? (e.consume(c), n++, d) : n === i ? (e.exit("codeTextSequence"), e.exit("codeText"), t(c)) : (a.type = "codeTextData", u(c));
  }
}
function wF(e) {
  const t = {};
  let r = -1, i, n, a, o, s, l, u;
  for (; ++r < e.length; ) {
    for (; r in t; )
      r = t[r];
    if (i = e[r], r && i[1].type === "chunkFlow" && e[r - 1][1].type === "listItemPrefix" && (l = i[1]._tokenizer.events, a = 0, a < l.length && l[a][1].type === "lineEndingBlank" && (a += 2), a < l.length && l[a][1].type === "content"))
      for (; ++a < l.length && l[a][1].type !== "content"; )
        l[a][1].type === "chunkText" && (l[a][1]._isInFirstContentOfListItem = !0, a++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(t, XQ(e, r)), r = t[r], u = !0);
    else if (i[1]._container) {
      for (a = r, n = void 0; a-- && (o = e[a], o[1].type === "lineEnding" || o[1].type === "lineEndingBlank"); )
        o[0] === "enter" && (n && (e[n][1].type = "lineEndingBlank"), o[1].type = "lineEnding", n = a);
      n && (i[1].end = Object.assign({}, e[n][1].start), s = e.slice(n, r), s.unshift(i), rs(e, n, r - n + 1, s));
    }
  }
  return !u;
}
function XQ(e, t) {
  const r = e[t][1], i = e[t][2];
  let n = t - 1;
  const a = [], o = r._tokenizer || i.parser[r.contentType](r.start), s = o.events, l = [], u = {};
  let d, c, p = -1, f = r, g = 0, k = 0;
  const y = [k];
  for (; f; ) {
    for (; e[++n][1] !== f; )
      ;
    a.push(n), f._tokenizer || (d = i.sliceStream(f), f.next || d.push(null), c && o.defineSkip(f.start), f._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(d), f._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), c = f, f = f.next;
  }
  for (f = r; ++p < s.length; )
    // Find a void token that includes a break.
    s[p][0] === "exit" && s[p - 1][0] === "enter" && s[p][1].type === s[p - 1][1].type && s[p][1].start.line !== s[p][1].end.line && (k = p + 1, y.push(k), f._tokenizer = void 0, f.previous = void 0, f = f.next);
  for (o.events = [], f ? (f._tokenizer = void 0, f.previous = void 0) : y.pop(), p = y.length; p--; ) {
    const _ = s.slice(y[p], y[p + 1]), A = a.pop();
    l.unshift([A, A + _.length - 1]), rs(e, A, 2, _);
  }
  for (p = -1; ++p < l.length; )
    u[g + l[p][0]] = g + l[p][1], g += l[p][1] - l[p][0] - 1;
  return u;
}
const ZQ = {
  tokenize: tX,
  resolve: eX
}, JQ = {
  tokenize: rX,
  partial: !0
};
function eX(e) {
  return wF(e), e;
}
function tX(e, t) {
  let r;
  return i;
  function i(s) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), n(s);
  }
  function n(s) {
    return s === null ? a(s) : Ht(s) ? e.check(
      JQ,
      o,
      a
    )(s) : (e.consume(s), n);
  }
  function a(s) {
    return e.exit("chunkContent"), e.exit("content"), t(s);
  }
  function o(s) {
    return e.consume(s), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, n;
  }
}
function rX(e, t, r) {
  const i = this;
  return n;
  function n(o) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), ii(e, a, "linePrefix");
  }
  function a(o) {
    if (o === null || Ht(o))
      return r(o);
    const s = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(o) : e.interrupt(i.parser.constructs.flow, r, t)(o);
  }
}
function FF(e, t, r, i, n, a, o, s, l) {
  const u = l || Number.POSITIVE_INFINITY;
  let d = 0;
  return c;
  function c(_) {
    return _ === 60 ? (e.enter(i), e.enter(n), e.enter(a), e.consume(_), e.exit(a), p) : _ === null || _ === 32 || _ === 41 || O_(_) ? r(_) : (e.enter(i), e.enter(o), e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), k(_));
  }
  function p(_) {
    return _ === 62 ? (e.enter(a), e.consume(_), e.exit(a), e.exit(n), e.exit(i), t) : (e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), f(_));
  }
  function f(_) {
    return _ === 62 ? (e.exit("chunkString"), e.exit(s), p(_)) : _ === null || _ === 60 || Ht(_) ? r(_) : (e.consume(_), _ === 92 ? g : f);
  }
  function g(_) {
    return _ === 60 || _ === 62 || _ === 92 ? (e.consume(_), f) : f(_);
  }
  function k(_) {
    return !d && (_ === null || _ === 41 || na(_)) ? (e.exit("chunkString"), e.exit(s), e.exit(o), e.exit(i), t(_)) : d < u && _ === 40 ? (e.consume(_), d++, k) : _ === 41 ? (e.consume(_), d--, k) : _ === null || _ === 32 || _ === 40 || O_(_) ? r(_) : (e.consume(_), _ === 92 ? y : k);
  }
  function y(_) {
    return _ === 40 || _ === 41 || _ === 92 ? (e.consume(_), k) : k(_);
  }
}
function TF(e, t, r, i, n, a) {
  const o = this;
  let s = 0, l;
  return u;
  function u(f) {
    return e.enter(i), e.enter(n), e.consume(f), e.exit(n), e.enter(a), d;
  }
  function d(f) {
    return s > 999 || f === null || f === 91 || f === 93 && !l || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    f === 94 && !s && "_hiddenFootnoteSupport" in o.parser.constructs ? r(f) : f === 93 ? (e.exit(a), e.enter(n), e.consume(f), e.exit(n), e.exit(i), t) : Ht(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), d) : (e.enter("chunkString", {
      contentType: "string"
    }), c(f));
  }
  function c(f) {
    return f === null || f === 91 || f === 93 || Ht(f) || s++ > 999 ? (e.exit("chunkString"), d(f)) : (e.consume(f), l || (l = !yr(f)), f === 92 ? p : c);
  }
  function p(f) {
    return f === 91 || f === 92 || f === 93 ? (e.consume(f), s++, c) : c(f);
  }
}
function SF(e, t, r, i, n, a) {
  let o;
  return s;
  function s(p) {
    return p === 34 || p === 39 || p === 40 ? (e.enter(i), e.enter(n), e.consume(p), e.exit(n), o = p === 40 ? 41 : p, l) : r(p);
  }
  function l(p) {
    return p === o ? (e.enter(n), e.consume(p), e.exit(n), e.exit(i), t) : (e.enter(a), u(p));
  }
  function u(p) {
    return p === o ? (e.exit(a), l(o)) : p === null ? r(p) : Ht(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), ii(e, u, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), d(p));
  }
  function d(p) {
    return p === o || p === null || Ht(p) ? (e.exit("chunkString"), u(p)) : (e.consume(p), p === 92 ? c : d);
  }
  function c(p) {
    return p === o || p === 92 ? (e.consume(p), d) : d(p);
  }
}
function J0(e, t) {
  let r;
  return i;
  function i(n) {
    return Ht(n) ? (e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), r = !0, i) : yr(n) ? ii(
      e,
      i,
      r ? "linePrefix" : "lineSuffix"
    )(n) : t(n);
  }
}
function Ud(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const iX = {
  name: "definition",
  tokenize: aX
}, nX = {
  tokenize: oX,
  partial: !0
};
function aX(e, t, r) {
  const i = this;
  let n;
  return a;
  function a(f) {
    return e.enter("definition"), o(f);
  }
  function o(f) {
    return TF.call(
      i,
      e,
      s,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(f);
  }
  function s(f) {
    return n = Ud(
      i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)
    ), f === 58 ? (e.enter("definitionMarker"), e.consume(f), e.exit("definitionMarker"), l) : r(f);
  }
  function l(f) {
    return na(f) ? J0(e, u)(f) : u(f);
  }
  function u(f) {
    return FF(
      e,
      d,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(f);
  }
  function d(f) {
    return e.attempt(nX, c, c)(f);
  }
  function c(f) {
    return yr(f) ? ii(e, p, "whitespace")(f) : p(f);
  }
  function p(f) {
    return f === null || Ht(f) ? (e.exit("definition"), i.parser.defined.push(n), t(f)) : r(f);
  }
}
function oX(e, t, r) {
  return i;
  function i(s) {
    return na(s) ? J0(e, n)(s) : r(s);
  }
  function n(s) {
    return SF(
      e,
      a,
      r,
      "definitionTitle",
      "definitionTitleMarker",
      "definitionTitleString"
    )(s);
  }
  function a(s) {
    return yr(s) ? ii(e, o, "whitespace")(s) : o(s);
  }
  function o(s) {
    return s === null || Ht(s) ? t(s) : r(s);
  }
}
const sX = {
  name: "hardBreakEscape",
  tokenize: lX
};
function lX(e, t, r) {
  return i;
  function i(a) {
    return e.enter("hardBreakEscape"), e.consume(a), n;
  }
  function n(a) {
    return Ht(a) ? (e.exit("hardBreakEscape"), t(a)) : r(a);
  }
}
const uX = {
  name: "headingAtx",
  tokenize: dX,
  resolve: cX
};
function cX(e, t) {
  let r = e.length - 2, i = 3, n, a;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (n = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, a = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, rs(e, i, r - i + 1, [
    ["enter", n, t],
    ["enter", a, t],
    ["exit", a, t],
    ["exit", n, t]
  ])), e;
}
function dX(e, t, r) {
  let i = 0;
  return n;
  function n(d) {
    return e.enter("atxHeading"), a(d);
  }
  function a(d) {
    return e.enter("atxHeadingSequence"), o(d);
  }
  function o(d) {
    return d === 35 && i++ < 6 ? (e.consume(d), o) : d === null || na(d) ? (e.exit("atxHeadingSequence"), s(d)) : r(d);
  }
  function s(d) {
    return d === 35 ? (e.enter("atxHeadingSequence"), l(d)) : d === null || Ht(d) ? (e.exit("atxHeading"), t(d)) : yr(d) ? ii(e, s, "whitespace")(d) : (e.enter("atxHeadingText"), u(d));
  }
  function l(d) {
    return d === 35 ? (e.consume(d), l) : (e.exit("atxHeadingSequence"), s(d));
  }
  function u(d) {
    return d === null || d === 35 || na(d) ? (e.exit("atxHeadingText"), s(d)) : (e.consume(d), u);
  }
}
const pX = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], j4 = ["pre", "script", "style", "textarea"], hX = {
  name: "htmlFlow",
  tokenize: vX,
  resolveTo: mX,
  concrete: !0
}, fX = {
  tokenize: bX,
  partial: !0
}, gX = {
  tokenize: kX,
  partial: !0
};
function mX(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function vX(e, t, r) {
  const i = this;
  let n, a, o, s, l;
  return u;
  function u(G) {
    return d(G);
  }
  function d(G) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(G), c;
  }
  function c(G) {
    return G === 33 ? (e.consume(G), p) : G === 47 ? (e.consume(G), a = !0, k) : G === 63 ? (e.consume(G), n = 3, i.interrupt ? t : L) : Uo(G) ? (e.consume(G), o = String.fromCharCode(G), y) : r(G);
  }
  function p(G) {
    return G === 45 ? (e.consume(G), n = 2, f) : G === 91 ? (e.consume(G), n = 5, s = 0, g) : Uo(G) ? (e.consume(G), n = 4, i.interrupt ? t : L) : r(G);
  }
  function f(G) {
    return G === 45 ? (e.consume(G), i.interrupt ? t : L) : r(G);
  }
  function g(G) {
    const He = "CDATA[";
    return G === He.charCodeAt(s++) ? (e.consume(G), s === He.length ? i.interrupt ? t : j : g) : r(G);
  }
  function k(G) {
    return Uo(G) ? (e.consume(G), o = String.fromCharCode(G), y) : r(G);
  }
  function y(G) {
    if (G === null || G === 47 || G === 62 || na(G)) {
      const He = G === 47, xe = o.toLowerCase();
      return !He && !a && j4.includes(xe) ? (n = 1, i.interrupt ? t(G) : j(G)) : pX.includes(o.toLowerCase()) ? (n = 6, He ? (e.consume(G), _) : i.interrupt ? t(G) : j(G)) : (n = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(G) : a ? A(G) : T(G));
    }
    return G === 45 || Ea(G) ? (e.consume(G), o += String.fromCharCode(G), y) : r(G);
  }
  function _(G) {
    return G === 62 ? (e.consume(G), i.interrupt ? t : j) : r(G);
  }
  function A(G) {
    return yr(G) ? (e.consume(G), A) : K(G);
  }
  function T(G) {
    return G === 47 ? (e.consume(G), K) : G === 58 || G === 95 || Uo(G) ? (e.consume(G), N) : yr(G) ? (e.consume(G), T) : K(G);
  }
  function N(G) {
    return G === 45 || G === 46 || G === 58 || G === 95 || Ea(G) ? (e.consume(G), N) : P(G);
  }
  function P(G) {
    return G === 61 ? (e.consume(G), B) : yr(G) ? (e.consume(G), P) : T(G);
  }
  function B(G) {
    return G === null || G === 60 || G === 61 || G === 62 || G === 96 ? r(G) : G === 34 || G === 39 ? (e.consume(G), l = G, M) : yr(G) ? (e.consume(G), B) : X(G);
  }
  function M(G) {
    return G === l ? (e.consume(G), l = null, U) : G === null || Ht(G) ? r(G) : (e.consume(G), M);
  }
  function X(G) {
    return G === null || G === 34 || G === 39 || G === 47 || G === 60 || G === 61 || G === 62 || G === 96 || na(G) ? P(G) : (e.consume(G), X);
  }
  function U(G) {
    return G === 47 || G === 62 || yr(G) ? T(G) : r(G);
  }
  function K(G) {
    return G === 62 ? (e.consume(G), z) : r(G);
  }
  function z(G) {
    return G === null || Ht(G) ? j(G) : yr(G) ? (e.consume(G), z) : r(G);
  }
  function j(G) {
    return G === 45 && n === 2 ? (e.consume(G), de) : G === 60 && n === 1 ? (e.consume(G), he) : G === 62 && n === 4 ? (e.consume(G), me) : G === 63 && n === 3 ? (e.consume(G), L) : G === 93 && n === 5 ? (e.consume(G), Le) : Ht(G) && (n === 6 || n === 7) ? (e.exit("htmlFlowData"), e.check(
      fX,
      Se,
      J
    )(G)) : G === null || Ht(G) ? (e.exit("htmlFlowData"), J(G)) : (e.consume(G), j);
  }
  function J(G) {
    return e.check(
      gX,
      ie,
      Se
    )(G);
  }
  function ie(G) {
    return e.enter("lineEnding"), e.consume(G), e.exit("lineEnding"), ue;
  }
  function ue(G) {
    return G === null || Ht(G) ? J(G) : (e.enter("htmlFlowData"), j(G));
  }
  function de(G) {
    return G === 45 ? (e.consume(G), L) : j(G);
  }
  function he(G) {
    return G === 47 ? (e.consume(G), o = "", Ee) : j(G);
  }
  function Ee(G) {
    if (G === 62) {
      const He = o.toLowerCase();
      return j4.includes(He) ? (e.consume(G), me) : j(G);
    }
    return Uo(G) && o.length < 8 ? (e.consume(G), o += String.fromCharCode(G), Ee) : j(G);
  }
  function Le(G) {
    return G === 93 ? (e.consume(G), L) : j(G);
  }
  function L(G) {
    return G === 62 ? (e.consume(G), me) : G === 45 && n === 2 ? (e.consume(G), L) : j(G);
  }
  function me(G) {
    return G === null || Ht(G) ? (e.exit("htmlFlowData"), Se(G)) : (e.consume(G), me);
  }
  function Se(G) {
    return e.exit("htmlFlow"), t(G);
  }
}
function kX(e, t, r) {
  const i = this;
  return n;
  function n(o) {
    return Ht(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), a) : r(o);
  }
  function a(o) {
    return i.parser.lazy[i.now().line] ? r(o) : t(o);
  }
}
function bX(e, t, r) {
  return i;
  function i(n) {
    return e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), e.attempt(Nm, t, r);
  }
}
const _X = {
  name: "htmlText",
  tokenize: DX
};
function DX(e, t, r) {
  const i = this;
  let n, a, o;
  return s;
  function s(L) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(L), l;
  }
  function l(L) {
    return L === 33 ? (e.consume(L), u) : L === 47 ? (e.consume(L), P) : L === 63 ? (e.consume(L), T) : Uo(L) ? (e.consume(L), X) : r(L);
  }
  function u(L) {
    return L === 45 ? (e.consume(L), d) : L === 91 ? (e.consume(L), a = 0, g) : Uo(L) ? (e.consume(L), A) : r(L);
  }
  function d(L) {
    return L === 45 ? (e.consume(L), f) : r(L);
  }
  function c(L) {
    return L === null ? r(L) : L === 45 ? (e.consume(L), p) : Ht(L) ? (o = c, he(L)) : (e.consume(L), c);
  }
  function p(L) {
    return L === 45 ? (e.consume(L), f) : c(L);
  }
  function f(L) {
    return L === 62 ? de(L) : L === 45 ? p(L) : c(L);
  }
  function g(L) {
    const me = "CDATA[";
    return L === me.charCodeAt(a++) ? (e.consume(L), a === me.length ? k : g) : r(L);
  }
  function k(L) {
    return L === null ? r(L) : L === 93 ? (e.consume(L), y) : Ht(L) ? (o = k, he(L)) : (e.consume(L), k);
  }
  function y(L) {
    return L === 93 ? (e.consume(L), _) : k(L);
  }
  function _(L) {
    return L === 62 ? de(L) : L === 93 ? (e.consume(L), _) : k(L);
  }
  function A(L) {
    return L === null || L === 62 ? de(L) : Ht(L) ? (o = A, he(L)) : (e.consume(L), A);
  }
  function T(L) {
    return L === null ? r(L) : L === 63 ? (e.consume(L), N) : Ht(L) ? (o = T, he(L)) : (e.consume(L), T);
  }
  function N(L) {
    return L === 62 ? de(L) : T(L);
  }
  function P(L) {
    return Uo(L) ? (e.consume(L), B) : r(L);
  }
  function B(L) {
    return L === 45 || Ea(L) ? (e.consume(L), B) : M(L);
  }
  function M(L) {
    return Ht(L) ? (o = M, he(L)) : yr(L) ? (e.consume(L), M) : de(L);
  }
  function X(L) {
    return L === 45 || Ea(L) ? (e.consume(L), X) : L === 47 || L === 62 || na(L) ? U(L) : r(L);
  }
  function U(L) {
    return L === 47 ? (e.consume(L), de) : L === 58 || L === 95 || Uo(L) ? (e.consume(L), K) : Ht(L) ? (o = U, he(L)) : yr(L) ? (e.consume(L), U) : de(L);
  }
  function K(L) {
    return L === 45 || L === 46 || L === 58 || L === 95 || Ea(L) ? (e.consume(L), K) : z(L);
  }
  function z(L) {
    return L === 61 ? (e.consume(L), j) : Ht(L) ? (o = z, he(L)) : yr(L) ? (e.consume(L), z) : U(L);
  }
  function j(L) {
    return L === null || L === 60 || L === 61 || L === 62 || L === 96 ? r(L) : L === 34 || L === 39 ? (e.consume(L), n = L, J) : Ht(L) ? (o = j, he(L)) : yr(L) ? (e.consume(L), j) : (e.consume(L), ie);
  }
  function J(L) {
    return L === n ? (e.consume(L), n = void 0, ue) : L === null ? r(L) : Ht(L) ? (o = J, he(L)) : (e.consume(L), J);
  }
  function ie(L) {
    return L === null || L === 34 || L === 39 || L === 60 || L === 61 || L === 96 ? r(L) : L === 47 || L === 62 || na(L) ? U(L) : (e.consume(L), ie);
  }
  function ue(L) {
    return L === 47 || L === 62 || na(L) ? U(L) : r(L);
  }
  function de(L) {
    return L === 62 ? (e.consume(L), e.exit("htmlTextData"), e.exit("htmlText"), t) : r(L);
  }
  function he(L) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(L), e.exit("lineEnding"), Ee;
  }
  function Ee(L) {
    return yr(L) ? ii(
      e,
      Le,
      "linePrefix",
      i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(L) : Le(L);
  }
  function Le(L) {
    return e.enter("htmlTextData"), o(L);
  }
}
const FD = {
  name: "labelEnd",
  tokenize: wX,
  resolveTo: AX,
  resolveAll: xX
}, yX = {
  tokenize: FX
}, EX = {
  tokenize: TX
}, CX = {
  tokenize: SX
};
function xX(e) {
  let t = -1;
  for (; ++t < e.length; ) {
    const r = e[t][1];
    (r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") && (e.splice(t + 1, r.type === "labelImage" ? 4 : 2), r.type = "data", t++);
  }
  return e;
}
function AX(e, t) {
  let r = e.length, i = 0, n, a, o, s;
  for (; r--; )
    if (n = e[r][1], a) {
      if (n.type === "link" || n.type === "labelLink" && n._inactive)
        break;
      e[r][0] === "enter" && n.type === "labelLink" && (n._inactive = !0);
    } else if (o) {
      if (e[r][0] === "enter" && (n.type === "labelImage" || n.type === "labelLink") && !n._balanced && (a = r, n.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else
      n.type === "labelEnd" && (o = r);
  const l = {
    type: e[a][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, e[a][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, u = {
    type: "label",
    start: Object.assign({}, e[a][1].start),
    end: Object.assign({}, e[o][1].end)
  }, d = {
    type: "labelText",
    start: Object.assign({}, e[a + i + 2][1].end),
    end: Object.assign({}, e[o - 2][1].start)
  };
  return s = [
    ["enter", l, t],
    ["enter", u, t]
  ], s = Ha(s, e.slice(a + 1, a + i + 3)), s = Ha(s, [["enter", d, t]]), s = Ha(
    s,
    AD(
      t.parser.constructs.insideSpan.null,
      e.slice(a + i + 4, o - 3),
      t
    )
  ), s = Ha(s, [
    ["exit", d, t],
    e[o - 2],
    e[o - 1],
    ["exit", u, t]
  ]), s = Ha(s, e.slice(o + 1)), s = Ha(s, [["exit", l, t]]), rs(e, a, e.length, s), e;
}
function wX(e, t, r) {
  const i = this;
  let n = i.events.length, a, o;
  for (; n--; )
    if ((i.events[n][1].type === "labelImage" || i.events[n][1].type === "labelLink") && !i.events[n][1]._balanced) {
      a = i.events[n][1];
      break;
    }
  return s;
  function s(p) {
    return a ? a._inactive ? c(p) : (o = i.parser.defined.includes(
      Ud(
        i.sliceSerialize({
          start: a.end,
          end: i.now()
        })
      )
    ), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(p), e.exit("labelMarker"), e.exit("labelEnd"), l) : r(p);
  }
  function l(p) {
    return p === 40 ? e.attempt(
      yX,
      d,
      o ? d : c
    )(p) : p === 91 ? e.attempt(
      EX,
      d,
      o ? u : c
    )(p) : o ? d(p) : c(p);
  }
  function u(p) {
    return e.attempt(
      CX,
      d,
      c
    )(p);
  }
  function d(p) {
    return t(p);
  }
  function c(p) {
    return a._balanced = !0, r(p);
  }
}
function FX(e, t, r) {
  return i;
  function i(c) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(c), e.exit("resourceMarker"), n;
  }
  function n(c) {
    return na(c) ? J0(e, a)(c) : a(c);
  }
  function a(c) {
    return c === 41 ? d(c) : FF(
      e,
      o,
      s,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      32
    )(c);
  }
  function o(c) {
    return na(c) ? J0(e, l)(c) : d(c);
  }
  function s(c) {
    return r(c);
  }
  function l(c) {
    return c === 34 || c === 39 || c === 40 ? SF(
      e,
      u,
      r,
      "resourceTitle",
      "resourceTitleMarker",
      "resourceTitleString"
    )(c) : d(c);
  }
  function u(c) {
    return na(c) ? J0(e, d)(c) : d(c);
  }
  function d(c) {
    return c === 41 ? (e.enter("resourceMarker"), e.consume(c), e.exit("resourceMarker"), e.exit("resource"), t) : r(c);
  }
}
function TX(e, t, r) {
  const i = this;
  return n;
  function n(s) {
    return TF.call(
      i,
      e,
      a,
      o,
      "reference",
      "referenceMarker",
      "referenceString"
    )(s);
  }
  function a(s) {
    return i.parser.defined.includes(
      Ud(
        i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)
      )
    ) ? t(s) : r(s);
  }
  function o(s) {
    return r(s);
  }
}
function SX(e, t, r) {
  return i;
  function i(a) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), n;
  }
  function n(a) {
    return a === 93 ? (e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), e.exit("reference"), t) : r(a);
  }
}
const IX = {
  name: "labelStartImage",
  tokenize: BX,
  resolveAll: FD.resolveAll
};
function BX(e, t, r) {
  const i = this;
  return n;
  function n(s) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(s), e.exit("labelImageMarker"), a;
  }
  function a(s) {
    return s === 91 ? (e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelImage"), o) : r(s);
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : t(s);
  }
}
const RX = {
  name: "labelStartLink",
  tokenize: OX,
  resolveAll: FD.resolveAll
};
function OX(e, t, r) {
  const i = this;
  return n;
  function n(o) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelLink"), a;
  }
  function a(o) {
    return o === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(o) : t(o);
  }
}
const Jk = {
  name: "lineEnding",
  tokenize: PX
};
function PX(e, t) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), ii(e, t, "linePrefix");
  }
}
const Jf = {
  name: "thematicBreak",
  tokenize: NX
};
function NX(e, t, r) {
  let i = 0, n;
  return a;
  function a(u) {
    return e.enter("thematicBreak"), o(u);
  }
  function o(u) {
    return n = u, s(u);
  }
  function s(u) {
    return u === n ? (e.enter("thematicBreakSequence"), l(u)) : i >= 3 && (u === null || Ht(u)) ? (e.exit("thematicBreak"), t(u)) : r(u);
  }
  function l(u) {
    return u === n ? (e.consume(u), i++, l) : (e.exit("thematicBreakSequence"), yr(u) ? ii(e, s, "whitespace")(u) : s(u));
  }
}
const Zn = {
  name: "list",
  tokenize: MX,
  continuation: {
    tokenize: jX
  },
  exit: $X
}, zX = {
  tokenize: UX,
  partial: !0
}, LX = {
  tokenize: HX,
  partial: !0
};
function MX(e, t, r) {
  const i = this, n = i.events[i.events.length - 1];
  let a = n && n[1].type === "linePrefix" ? n[2].sliceSerialize(n[1], !0).length : 0, o = 0;
  return s;
  function s(f) {
    const g = i.containerState.type || (f === 42 || f === 43 || f === 45 ? "listUnordered" : "listOrdered");
    if (g === "listUnordered" ? !i.containerState.marker || f === i.containerState.marker : P_(f)) {
      if (i.containerState.type || (i.containerState.type = g, e.enter(g, {
        _container: !0
      })), g === "listUnordered")
        return e.enter("listItemPrefix"), f === 42 || f === 45 ? e.check(Jf, r, u)(f) : u(f);
      if (!i.interrupt || f === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), l(f);
    }
    return r(f);
  }
  function l(f) {
    return P_(f) && ++o < 10 ? (e.consume(f), l) : (!i.interrupt || o < 2) && (i.containerState.marker ? f === i.containerState.marker : f === 41 || f === 46) ? (e.exit("listItemValue"), u(f)) : r(f);
  }
  function u(f) {
    return e.enter("listItemMarker"), e.consume(f), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || f, e.check(
      Nm,
      // Can’t be empty when interrupting.
      i.interrupt ? r : d,
      e.attempt(
        zX,
        p,
        c
      )
    );
  }
  function d(f) {
    return i.containerState.initialBlankLine = !0, a++, p(f);
  }
  function c(f) {
    return yr(f) ? (e.enter("listItemPrefixWhitespace"), e.consume(f), e.exit("listItemPrefixWhitespace"), p) : r(f);
  }
  function p(f) {
    return i.containerState.size = a + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(f);
  }
}
function jX(e, t, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(Nm, n, a);
  function n(s) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, ii(
      e,
      t,
      "listItemIndent",
      i.containerState.size + 1
    )(s);
  }
  function a(s) {
    return i.containerState.furtherBlankLines || !yr(s) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, o(s)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(LX, t, o)(s));
  }
  function o(s) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, ii(
      e,
      e.attempt(Zn, t, r),
      "linePrefix",
      i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(s);
  }
}
function HX(e, t, r) {
  const i = this;
  return ii(
    e,
    n,
    "listItemIndent",
    i.containerState.size + 1
  );
  function n(a) {
    const o = i.events[i.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === i.containerState.size ? t(a) : r(a);
  }
}
function $X(e) {
  e.exit(this.containerState.type);
}
function UX(e, t, r) {
  const i = this;
  return ii(
    e,
    n,
    "listItemPrefixWhitespace",
    i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4 + 1
  );
  function n(a) {
    const o = i.events[i.events.length - 1];
    return !yr(a) && o && o[1].type === "listItemPrefixWhitespace" ? t(a) : r(a);
  }
}
const H4 = {
  name: "setextUnderline",
  tokenize: WX,
  resolveTo: VX
};
function VX(e, t) {
  let r = e.length, i, n, a;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (n = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !a && e[r][1].type === "definition" && (a = r);
  const o = {
    type: "setextHeading",
    start: Object.assign({}, e[n][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  };
  return e[n][1].type = "setextHeadingText", a ? (e.splice(n, 0, ["enter", o, t]), e.splice(a + 1, 0, ["exit", e[i][1], t]), e[i][1].end = Object.assign({}, e[a][1].end)) : e[i][1] = o, e.push(["exit", o, t]), e;
}
function WX(e, t, r) {
  const i = this;
  let n;
  return a;
  function a(u) {
    let d = i.events.length, c;
    for (; d--; )
      if (i.events[d][1].type !== "lineEnding" && i.events[d][1].type !== "linePrefix" && i.events[d][1].type !== "content") {
        c = i.events[d][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || c) ? (e.enter("setextHeadingLine"), n = u, o(u)) : r(u);
  }
  function o(u) {
    return e.enter("setextHeadingLineSequence"), s(u);
  }
  function s(u) {
    return u === n ? (e.consume(u), s) : (e.exit("setextHeadingLineSequence"), yr(u) ? ii(e, l, "lineSuffix")(u) : l(u));
  }
  function l(u) {
    return u === null || Ht(u) ? (e.exit("setextHeadingLine"), t(u)) : r(u);
  }
}
const GX = {
  tokenize: KX
};
function KX(e) {
  const t = this, r = e.attempt(
    // Try to parse a blank line.
    Nm,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(
      this.parser.constructs.flowInitial,
      n,
      ii(
        e,
        e.attempt(
          this.parser.constructs.flow,
          n,
          e.attempt(ZQ, n)
        ),
        "linePrefix"
      )
    )
  );
  return r;
  function i(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(a), e.exit("lineEndingBlank"), t.currentConstruct = void 0, r;
  }
  function n(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), t.currentConstruct = void 0, r;
  }
}
const YX = {
  resolveAll: BF()
}, qX = IF("string"), QX = IF("text");
function IF(e) {
  return {
    tokenize: t,
    resolveAll: BF(
      e === "text" ? XX : void 0
    )
  };
  function t(r) {
    const i = this, n = this.parser.constructs[e], a = r.attempt(n, o, s);
    return o;
    function o(d) {
      return u(d) ? a(d) : s(d);
    }
    function s(d) {
      if (d === null) {
        r.consume(d);
        return;
      }
      return r.enter("data"), r.consume(d), l;
    }
    function l(d) {
      return u(d) ? (r.exit("data"), a(d)) : (r.consume(d), l);
    }
    function u(d) {
      if (d === null)
        return !0;
      const c = n[d];
      let p = -1;
      if (c)
        for (; ++p < c.length; ) {
          const f = c[p];
          if (!f.previous || f.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function BF(e) {
  return t;
  function t(r, i) {
    let n = -1, a;
    for (; ++n <= r.length; )
      a === void 0 ? r[n] && r[n][1].type === "data" && (a = n, n++) : (!r[n] || r[n][1].type !== "data") && (n !== a + 2 && (r[a][1].end = r[n - 1][1].end, r.splice(a + 2, n - a - 2), n = a + 2), a = void 0);
    return e ? e(r, i) : r;
  }
}
function XX(e, t) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], n = t.sliceStream(i);
      let a = n.length, o = -1, s = 0, l;
      for (; a--; ) {
        const u = n[a];
        if (typeof u == "string") {
          for (o = u.length; u.charCodeAt(o - 1) === 32; )
            s++, o--;
          if (o)
            break;
          o = -1;
        } else if (u === -2)
          l = !0, s++;
        else if (u !== -1) {
          a++;
          break;
        }
      }
      if (s) {
        const u = {
          type: r === e.length || l || s < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: i.end.line,
            column: i.end.column - s,
            offset: i.end.offset - s,
            _index: i.start._index + a,
            _bufferIndex: a ? o : i.start._bufferIndex + o
          },
          end: Object.assign({}, i.end)
        };
        i.end = Object.assign({}, u.start), i.start.offset === i.end.offset ? Object.assign(i, u) : (e.splice(
          r,
          0,
          ["enter", u, t],
          ["exit", u, t]
        ), r += 2);
      }
      r++;
    }
  return e;
}
function ZX(e, t, r) {
  let i = Object.assign(
    r ? Object.assign({}, r) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const n = {}, a = [];
  let o = [], s = [];
  const l = {
    consume: A,
    enter: T,
    exit: N,
    attempt: M(P),
    check: M(B),
    interrupt: M(B, {
      interrupt: !0
    })
  }, u = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: e,
    sliceStream: f,
    sliceSerialize: p,
    now: g,
    defineSkip: k,
    write: c
  };
  let d = t.tokenize.call(u, l);
  return t.resolveAll && a.push(t), u;
  function c(z) {
    return o = Ha(o, z), y(), o[o.length - 1] !== null ? [] : (X(t, 0), u.events = AD(a, u.events, u), u.events);
  }
  function p(z, j) {
    return eZ(f(z), j);
  }
  function f(z) {
    return JX(o, z);
  }
  function g() {
    const { line: z, column: j, offset: J, _index: ie, _bufferIndex: ue } = i;
    return {
      line: z,
      column: j,
      offset: J,
      _index: ie,
      _bufferIndex: ue
    };
  }
  function k(z) {
    n[z.line] = z.column, K();
  }
  function y() {
    let z;
    for (; i._index < o.length; ) {
      const j = o[i._index];
      if (typeof j == "string")
        for (z = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === z && i._bufferIndex < j.length; )
          _(j.charCodeAt(i._bufferIndex));
      else
        _(j);
    }
  }
  function _(z) {
    d = d(z);
  }
  function A(z) {
    Ht(z) ? (i.line++, i.column = 1, i.offset += z === -3 ? 2 : 1, K()) : z !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === o[i._index].length && (i._bufferIndex = -1, i._index++)), u.previous = z;
  }
  function T(z, j) {
    const J = j || {};
    return J.type = z, J.start = g(), u.events.push(["enter", J, u]), s.push(J), J;
  }
  function N(z) {
    const j = s.pop();
    return j.end = g(), u.events.push(["exit", j, u]), j;
  }
  function P(z, j) {
    X(z, j.from);
  }
  function B(z, j) {
    j.restore();
  }
  function M(z, j) {
    return J;
    function J(ie, ue, de) {
      let he, Ee, Le, L;
      return Array.isArray(ie) ? Se(ie) : "tokenize" in ie ? (
        // @ts-expect-error Looks like a construct.
        Se([ie])
      ) : me(ie);
      function me(_e) {
        return Ze;
        function Ze(qe) {
          const nt = qe !== null && _e[qe], at = qe !== null && _e.null, At = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(nt) ? nt : nt ? [nt] : [],
            ...Array.isArray(at) ? at : at ? [at] : []
          ];
          return Se(At)(qe);
        }
      }
      function Se(_e) {
        return he = _e, Ee = 0, _e.length === 0 ? de : G(_e[Ee]);
      }
      function G(_e) {
        return Ze;
        function Ze(qe) {
          return L = U(), Le = _e, _e.partial || (u.currentConstruct = _e), _e.name && u.parser.constructs.disable.null.includes(_e.name) ? xe() : _e.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            j ? Object.assign(Object.create(u), j) : u,
            l,
            He,
            xe
          )(qe);
        }
      }
      function He(_e) {
        return z(Le, L), ue;
      }
      function xe(_e) {
        return L.restore(), ++Ee < he.length ? G(he[Ee]) : de;
      }
    }
  }
  function X(z, j) {
    z.resolveAll && !a.includes(z) && a.push(z), z.resolve && rs(
      u.events,
      j,
      u.events.length - j,
      z.resolve(u.events.slice(j), u)
    ), z.resolveTo && (u.events = z.resolveTo(u.events, u));
  }
  function U() {
    const z = g(), j = u.previous, J = u.currentConstruct, ie = u.events.length, ue = Array.from(s);
    return {
      restore: de,
      from: ie
    };
    function de() {
      i = z, u.previous = j, u.currentConstruct = J, u.events.length = ie, s = ue, K();
    }
  }
  function K() {
    i.line in n && i.column < 2 && (i.column = n[i.line], i.offset += n[i.line] - 1);
  }
}
function JX(e, t) {
  const r = t.start._index, i = t.start._bufferIndex, n = t.end._index, a = t.end._bufferIndex;
  let o;
  if (r === n)
    o = [e[r].slice(i, a)];
  else {
    if (o = e.slice(r, n), i > -1) {
      const s = o[0];
      typeof s == "string" ? o[0] = s.slice(i) : o.shift();
    }
    a > 0 && o.push(e[n].slice(0, a));
  }
  return o;
}
function eZ(e, t) {
  let r = -1;
  const i = [];
  let n;
  for (; ++r < e.length; ) {
    const a = e[r];
    let o;
    if (typeof a == "string")
      o = a;
    else
      switch (a) {
        case -5: {
          o = "\r";
          break;
        }
        case -4: {
          o = `
`;
          break;
        }
        case -3: {
          o = `\r
`;
          break;
        }
        case -2: {
          o = t ? " " : "	";
          break;
        }
        case -1: {
          if (!t && n)
            continue;
          o = " ";
          break;
        }
        default:
          o = String.fromCharCode(a);
      }
    n = a === -2, i.push(o);
  }
  return i.join("");
}
const tZ = {
  42: Zn,
  43: Zn,
  45: Zn,
  48: Zn,
  49: Zn,
  50: Zn,
  51: Zn,
  52: Zn,
  53: Zn,
  54: Zn,
  55: Zn,
  56: Zn,
  57: Zn,
  62: CF
}, rZ = {
  91: iX
}, iZ = {
  [-2]: Zk,
  [-1]: Zk,
  32: Zk
}, nZ = {
  35: uX,
  42: Jf,
  45: [H4, Jf],
  60: hX,
  61: H4,
  95: Jf,
  96: M4,
  126: M4
}, aZ = {
  38: AF,
  92: xF
}, oZ = {
  [-5]: Jk,
  [-4]: Jk,
  [-3]: Jk,
  33: IX,
  38: AF,
  42: N_,
  60: [OQ, _X],
  91: RX,
  92: [sX, xF],
  93: FD,
  95: N_,
  96: KQ
}, sZ = {
  null: [N_, YX]
}, lZ = {
  null: [42, 95]
}, uZ = {
  null: []
}, cZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: lZ,
  contentInitial: rZ,
  disable: uZ,
  document: tZ,
  flow: nZ,
  flowInitial: iZ,
  insideSpan: sZ,
  string: aZ,
  text: oZ
}, Symbol.toStringTag, { value: "Module" }));
function dZ(e) {
  const r = (
    /** @type {FullNormalizedExtension} */
    kQ([cZ, ...(e || {}).extensions || []])
  ), i = {
    defined: [],
    lazy: {},
    constructs: r,
    content: n(wQ),
    document: n(TQ),
    flow: n(GX),
    string: n(qX),
    text: n(QX)
  };
  return i;
  function n(a) {
    return o;
    function o(s) {
      return ZX(i, a, s);
    }
  }
}
const $4 = /[\0\t\n\r]/g;
function pZ() {
  let e = 1, t = "", r = !0, i;
  return n;
  function n(a, o, s) {
    const l = [];
    let u, d, c, p, f;
    for (a = t + a.toString(o), c = 0, t = "", r && (a.charCodeAt(0) === 65279 && c++, r = void 0); c < a.length; ) {
      if ($4.lastIndex = c, u = $4.exec(a), p = u && u.index !== void 0 ? u.index : a.length, f = a.charCodeAt(p), !u) {
        t = a.slice(c);
        break;
      }
      if (f === 10 && c === p && i)
        l.push(-3), i = void 0;
      else
        switch (i && (l.push(-5), i = void 0), c < p && (l.push(a.slice(c, p)), e += p - c), f) {
          case 0: {
            l.push(65533), e++;
            break;
          }
          case 9: {
            for (d = Math.ceil(e / 4) * 4, l.push(-2); e++ < d; )
              l.push(-1);
            break;
          }
          case 10: {
            l.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      c = p + 1;
    }
    return s && (i && l.push(-5), t && l.push(t), l.push(null)), l;
  }
}
function hZ(e) {
  for (; !wF(e); )
    ;
  return e;
}
function RF(e, t) {
  const r = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || (r & 65535) === 65535 || (r & 65535) === 65534 || // Out of range
    r > 1114111 ? "�" : String.fromCharCode(r)
  );
}
const fZ = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function gZ(e) {
  return e.replace(fZ, mZ);
}
function mZ(e, t, r) {
  if (t)
    return t;
  if (r.charCodeAt(0) === 35) {
    const n = r.charCodeAt(1), a = n === 120 || n === 88;
    return RF(r.slice(a ? 2 : 1), a ? 16 : 10);
  }
  return wD(r) || e;
}
const OF = {}.hasOwnProperty, vZ = (
  /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */
  /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */
  function(e, t, r) {
    return typeof t != "string" && (r = t, t = void 0), kZ(r)(
      hZ(
        dZ(r).document().write(pZ()(e, t, !0))
      )
    );
  }
);
function kZ(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: s(pe),
      autolinkProtocol: z,
      autolinkEmail: z,
      atxHeading: s(vr),
      blockQuote: s(At),
      characterEscape: z,
      characterReference: z,
      codeFenced: s(Oe),
      codeFencedFenceInfo: l,
      codeFencedFenceMeta: l,
      codeIndented: s(Oe, l),
      codeText: s(wt, l),
      codeTextData: z,
      data: z,
      codeFlowValue: z,
      definition: s(Ge),
      definitionDestinationString: l,
      definitionLabelString: l,
      definitionTitleString: l,
      emphasis: s(nr),
      hardBreakEscape: s(zr),
      hardBreakTrailing: s(zr),
      htmlFlow: s(Wr, l),
      htmlFlowData: z,
      htmlText: s(Wr, l),
      htmlTextData: z,
      image: s(ne),
      label: l,
      link: s(pe),
      listItem: s(Ye),
      listItemValue: g,
      listOrdered: s(Fe, f),
      listUnordered: s(Fe),
      paragraph: s(Ue),
      reference: xe,
      referenceString: l,
      resourceDestinationString: l,
      resourceTitleString: l,
      setextHeading: s(vr),
      strong: s(Re),
      thematicBreak: s(Ut)
    },
    exit: {
      atxHeading: d(),
      atxHeadingSequence: M,
      autolink: d(),
      autolinkEmail: at,
      autolinkProtocol: nt,
      blockQuote: d(),
      characterEscapeValue: j,
      characterReferenceMarkerHexadecimal: Ze,
      characterReferenceMarkerNumeric: Ze,
      characterReferenceValue: qe,
      codeFenced: d(A),
      codeFencedFence: _,
      codeFencedFenceInfo: k,
      codeFencedFenceMeta: y,
      codeFlowValue: j,
      codeIndented: d(T),
      codeText: d(he),
      codeTextData: j,
      data: j,
      definition: d(),
      definitionDestinationString: B,
      definitionLabelString: N,
      definitionTitleString: P,
      emphasis: d(),
      hardBreakEscape: d(ie),
      hardBreakTrailing: d(ie),
      htmlFlow: d(ue),
      htmlFlowData: j,
      htmlText: d(de),
      htmlTextData: j,
      image: d(Le),
      label: me,
      labelText: L,
      lineEnding: J,
      link: d(Ee),
      listItem: d(),
      listOrdered: d(),
      listUnordered: d(),
      paragraph: d(),
      referenceString: _e,
      resourceDestinationString: Se,
      resourceTitleString: G,
      resource: He,
      setextHeading: d(K),
      setextHeadingLineSequence: U,
      setextHeadingText: X,
      strong: d(),
      thematicBreak: d()
    }
  };
  PF(t, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(ge) {
    let Ie = {
      type: "root",
      children: []
    };
    const ut = {
      stack: [Ie],
      tokenStack: [],
      config: t,
      enter: u,
      exit: c,
      buffer: l,
      resume: p,
      setData: a,
      getData: o
    }, xt = [];
    let Bt = -1;
    for (; ++Bt < ge.length; )
      if (ge[Bt][1].type === "listOrdered" || ge[Bt][1].type === "listUnordered")
        if (ge[Bt][0] === "enter")
          xt.push(Bt);
        else {
          const gr = xt.pop();
          Bt = n(ge, gr, Bt);
        }
    for (Bt = -1; ++Bt < ge.length; ) {
      const gr = t[ge[Bt][0]];
      OF.call(gr, ge[Bt][1].type) && gr[ge[Bt][1].type].call(
        Object.assign(
          {
            sliceSerialize: ge[Bt][2].sliceSerialize
          },
          ut
        ),
        ge[Bt][1]
      );
    }
    if (ut.tokenStack.length > 0) {
      const gr = ut.tokenStack[ut.tokenStack.length - 1];
      (gr[1] || U4).call(ut, void 0, gr[0]);
    }
    for (Ie.position = {
      start: ul(
        ge.length > 0 ? ge[0][1].start : {
          line: 1,
          column: 1,
          offset: 0
        }
      ),
      end: ul(
        ge.length > 0 ? ge[ge.length - 2][1].end : {
          line: 1,
          column: 1,
          offset: 0
        }
      )
    }, Bt = -1; ++Bt < t.transforms.length; )
      Ie = t.transforms[Bt](Ie) || Ie;
    return Ie;
  }
  function n(ge, Ie, ut) {
    let xt = Ie - 1, Bt = -1, gr = !1, Gr, kr, Xr, Er;
    for (; ++xt <= ut; ) {
      const tr = ge[xt];
      if (tr[1].type === "listUnordered" || tr[1].type === "listOrdered" || tr[1].type === "blockQuote" ? (tr[0] === "enter" ? Bt++ : Bt--, Er = void 0) : tr[1].type === "lineEndingBlank" ? tr[0] === "enter" && (Gr && !Er && !Bt && !Xr && (Xr = xt), Er = void 0) : tr[1].type === "linePrefix" || tr[1].type === "listItemValue" || tr[1].type === "listItemMarker" || tr[1].type === "listItemPrefix" || tr[1].type === "listItemPrefixWhitespace" || (Er = void 0), !Bt && tr[0] === "enter" && tr[1].type === "listItemPrefix" || Bt === -1 && tr[0] === "exit" && (tr[1].type === "listUnordered" || tr[1].type === "listOrdered")) {
        if (Gr) {
          let Ti = xt;
          for (kr = void 0; Ti--; ) {
            const lt = ge[Ti];
            if (lt[1].type === "lineEnding" || lt[1].type === "lineEndingBlank") {
              if (lt[0] === "exit")
                continue;
              kr && (ge[kr][1].type = "lineEndingBlank", gr = !0), lt[1].type = "lineEnding", kr = Ti;
            } else if (!(lt[1].type === "linePrefix" || lt[1].type === "blockQuotePrefix" || lt[1].type === "blockQuotePrefixWhitespace" || lt[1].type === "blockQuoteMarker" || lt[1].type === "listItemIndent"))
              break;
          }
          Xr && (!kr || Xr < kr) && (Gr._spread = !0), Gr.end = Object.assign(
            {},
            kr ? ge[kr][1].start : tr[1].end
          ), ge.splice(kr || xt, 0, ["exit", Gr, tr[2]]), xt++, ut++;
        }
        tr[1].type === "listItemPrefix" && (Gr = {
          type: "listItem",
          _spread: !1,
          start: Object.assign({}, tr[1].start),
          // @ts-expect-error: we’ll add `end` in a second.
          end: void 0
        }, ge.splice(xt, 0, ["enter", Gr, tr[2]]), xt++, ut++, Xr = void 0, Er = !0);
      }
    }
    return ge[Ie][1]._spread = gr, ut;
  }
  function a(ge, Ie) {
    r[ge] = Ie;
  }
  function o(ge) {
    return r[ge];
  }
  function s(ge, Ie) {
    return ut;
    function ut(xt) {
      u.call(this, ge(xt), xt), Ie && Ie.call(this, xt);
    }
  }
  function l() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function u(ge, Ie, ut) {
    return this.stack[this.stack.length - 1].children.push(ge), this.stack.push(ge), this.tokenStack.push([Ie, ut]), ge.position = {
      start: ul(Ie.start)
    }, ge;
  }
  function d(ge) {
    return Ie;
    function Ie(ut) {
      ge && ge.call(this, ut), c.call(this, ut);
    }
  }
  function c(ge, Ie) {
    const ut = this.stack.pop(), xt = this.tokenStack.pop();
    if (xt)
      xt[0].type !== ge.type && (Ie ? Ie.call(this, ge, xt[0]) : (xt[1] || U4).call(this, ge, xt[0]));
    else
      throw new Error(
        "Cannot close `" + ge.type + "` (" + Z0({
          start: ge.start,
          end: ge.end
        }) + "): it’s not open"
      );
    return ut.position.end = ul(ge.end), ut;
  }
  function p() {
    return mQ(this.stack.pop());
  }
  function f() {
    a("expectingFirstListItemValue", !0);
  }
  function g(ge) {
    if (o("expectingFirstListItemValue")) {
      const Ie = this.stack[this.stack.length - 2];
      Ie.start = Number.parseInt(this.sliceSerialize(ge), 10), a("expectingFirstListItemValue");
    }
  }
  function k() {
    const ge = this.resume(), Ie = this.stack[this.stack.length - 1];
    Ie.lang = ge;
  }
  function y() {
    const ge = this.resume(), Ie = this.stack[this.stack.length - 1];
    Ie.meta = ge;
  }
  function _() {
    o("flowCodeInside") || (this.buffer(), a("flowCodeInside", !0));
  }
  function A() {
    const ge = this.resume(), Ie = this.stack[this.stack.length - 1];
    Ie.value = ge.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), a("flowCodeInside");
  }
  function T() {
    const ge = this.resume(), Ie = this.stack[this.stack.length - 1];
    Ie.value = ge.replace(/(\r?\n|\r)$/g, "");
  }
  function N(ge) {
    const Ie = this.resume(), ut = this.stack[this.stack.length - 1];
    ut.label = Ie, ut.identifier = Ud(
      this.sliceSerialize(ge)
    ).toLowerCase();
  }
  function P() {
    const ge = this.resume(), Ie = this.stack[this.stack.length - 1];
    Ie.title = ge;
  }
  function B() {
    const ge = this.resume(), Ie = this.stack[this.stack.length - 1];
    Ie.url = ge;
  }
  function M(ge) {
    const Ie = this.stack[this.stack.length - 1];
    if (!Ie.depth) {
      const ut = this.sliceSerialize(ge).length;
      Ie.depth = ut;
    }
  }
  function X() {
    a("setextHeadingSlurpLineEnding", !0);
  }
  function U(ge) {
    const Ie = this.stack[this.stack.length - 1];
    Ie.depth = this.sliceSerialize(ge).charCodeAt(0) === 61 ? 1 : 2;
  }
  function K() {
    a("setextHeadingSlurpLineEnding");
  }
  function z(ge) {
    const Ie = this.stack[this.stack.length - 1];
    let ut = Ie.children[Ie.children.length - 1];
    (!ut || ut.type !== "text") && (ut = ot(), ut.position = {
      start: ul(ge.start)
    }, Ie.children.push(ut)), this.stack.push(ut);
  }
  function j(ge) {
    const Ie = this.stack.pop();
    Ie.value += this.sliceSerialize(ge), Ie.position.end = ul(ge.end);
  }
  function J(ge) {
    const Ie = this.stack[this.stack.length - 1];
    if (o("atHardBreak")) {
      const ut = Ie.children[Ie.children.length - 1];
      ut.position.end = ul(ge.end), a("atHardBreak");
      return;
    }
    !o("setextHeadingSlurpLineEnding") && t.canContainEols.includes(Ie.type) && (z.call(this, ge), j.call(this, ge));
  }
  function ie() {
    a("atHardBreak", !0);
  }
  function ue() {
    const ge = this.resume(), Ie = this.stack[this.stack.length - 1];
    Ie.value = ge;
  }
  function de() {
    const ge = this.resume(), Ie = this.stack[this.stack.length - 1];
    Ie.value = ge;
  }
  function he() {
    const ge = this.resume(), Ie = this.stack[this.stack.length - 1];
    Ie.value = ge;
  }
  function Ee() {
    const ge = this.stack[this.stack.length - 1];
    if (o("inReference")) {
      const Ie = o("referenceType") || "shortcut";
      ge.type += "Reference", ge.referenceType = Ie, delete ge.url, delete ge.title;
    } else
      delete ge.identifier, delete ge.label;
    a("referenceType");
  }
  function Le() {
    const ge = this.stack[this.stack.length - 1];
    if (o("inReference")) {
      const Ie = o("referenceType") || "shortcut";
      ge.type += "Reference", ge.referenceType = Ie, delete ge.url, delete ge.title;
    } else
      delete ge.identifier, delete ge.label;
    a("referenceType");
  }
  function L(ge) {
    const Ie = this.sliceSerialize(ge), ut = this.stack[this.stack.length - 2];
    ut.label = gZ(Ie), ut.identifier = Ud(Ie).toLowerCase();
  }
  function me() {
    const ge = this.stack[this.stack.length - 1], Ie = this.resume(), ut = this.stack[this.stack.length - 1];
    if (a("inReference", !0), ut.type === "link") {
      const xt = ge.children;
      ut.children = xt;
    } else
      ut.alt = Ie;
  }
  function Se() {
    const ge = this.resume(), Ie = this.stack[this.stack.length - 1];
    Ie.url = ge;
  }
  function G() {
    const ge = this.resume(), Ie = this.stack[this.stack.length - 1];
    Ie.title = ge;
  }
  function He() {
    a("inReference");
  }
  function xe() {
    a("referenceType", "collapsed");
  }
  function _e(ge) {
    const Ie = this.resume(), ut = this.stack[this.stack.length - 1];
    ut.label = Ie, ut.identifier = Ud(
      this.sliceSerialize(ge)
    ).toLowerCase(), a("referenceType", "full");
  }
  function Ze(ge) {
    a("characterReferenceType", ge.type);
  }
  function qe(ge) {
    const Ie = this.sliceSerialize(ge), ut = o("characterReferenceType");
    let xt;
    ut ? (xt = RF(
      Ie,
      ut === "characterReferenceMarkerNumeric" ? 10 : 16
    ), a("characterReferenceType")) : xt = wD(Ie);
    const Bt = this.stack.pop();
    Bt.value += xt, Bt.position.end = ul(ge.end);
  }
  function nt(ge) {
    j.call(this, ge);
    const Ie = this.stack[this.stack.length - 1];
    Ie.url = this.sliceSerialize(ge);
  }
  function at(ge) {
    j.call(this, ge);
    const Ie = this.stack[this.stack.length - 1];
    Ie.url = "mailto:" + this.sliceSerialize(ge);
  }
  function At() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Oe() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function wt() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Ge() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function nr() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function vr() {
    return {
      type: "heading",
      depth: void 0,
      children: []
    };
  }
  function zr() {
    return {
      type: "break"
    };
  }
  function Wr() {
    return {
      type: "html",
      value: ""
    };
  }
  function ne() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function pe() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Fe(ge) {
    return {
      type: "list",
      ordered: ge.type === "listOrdered",
      start: null,
      spread: ge._spread,
      children: []
    };
  }
  function Ye(ge) {
    return {
      type: "listItem",
      spread: ge._spread,
      checked: null,
      children: []
    };
  }
  function Ue() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function Re() {
    return {
      type: "strong",
      children: []
    };
  }
  function ot() {
    return {
      type: "text",
      value: ""
    };
  }
  function Ut() {
    return {
      type: "thematicBreak"
    };
  }
}
function ul(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function PF(e, t) {
  let r = -1;
  for (; ++r < t.length; ) {
    const i = t[r];
    Array.isArray(i) ? PF(e, i) : bZ(e, i);
  }
}
function bZ(e, t) {
  let r;
  for (r in t)
    if (OF.call(t, r)) {
      if (r === "canContainEols") {
        const i = t[r];
        i && e[r].push(...i);
      } else if (r === "transforms") {
        const i = t[r];
        i && e[r].push(...i);
      } else if (r === "enter" || r === "exit") {
        const i = t[r];
        i && Object.assign(e[r], i);
      }
    }
}
function U4(e, t) {
  throw e ? new Error(
    "Cannot close `" + e.type + "` (" + Z0({
      start: e.start,
      end: e.end
    }) + "): a different token (`" + t.type + "`, " + Z0({
      start: t.start,
      end: t.end
    }) + ") is open"
  ) : new Error(
    "Cannot close document, a token (`" + t.type + "`, " + Z0({
      start: t.start,
      end: t.end
    }) + ") is still open"
  );
}
function _Z(e) {
  Object.assign(this, { Parser: (r) => {
    const i = (
      /** @type {Options} */
      this.data("settings")
    );
    return vZ(
      r,
      Object.assign({}, i, e, {
        // Note: these options are not in the readme.
        // The goal is for them to be set by plugins on `data` instead of being
        // passed by users.
        extensions: this.data("micromarkExtensions") || [],
        mdastExtensions: this.data("fromMarkdownExtensions") || []
      })
    );
  } });
}
function DZ(e, t) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function yZ(e, t) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, r), [e.applyData(t, r), { type: "text", value: `
` }];
}
function EZ(e, t) {
  const r = t.value ? t.value + `
` : "", i = t.lang ? t.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null, n = {};
  i && (n.className = ["language-" + i]);
  let a = {
    type: "element",
    tagName: "code",
    properties: n,
    children: [{ type: "text", value: r }]
  };
  return t.meta && (a.data = { meta: t.meta }), e.patch(t, a), a = e.applyData(t, a), a = { type: "element", tagName: "pre", properties: {}, children: [a] }, e.patch(t, a), a;
}
function CZ(e, t) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function xZ(e, t) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function hp(e) {
  const t = [];
  let r = -1, i = 0, n = 0;
  for (; ++r < e.length; ) {
    const a = e.charCodeAt(r);
    let o = "";
    if (a === 37 && Ea(e.charCodeAt(r + 1)) && Ea(e.charCodeAt(r + 2)))
      n = 2;
    else if (a < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(a)) || (o = String.fromCharCode(a));
    else if (a > 55295 && a < 57344) {
      const s = e.charCodeAt(r + 1);
      a < 56320 && s > 56319 && s < 57344 ? (o = String.fromCharCode(a, s), n = 1) : o = "�";
    } else
      o = String.fromCharCode(a);
    o && (t.push(e.slice(i, r), encodeURIComponent(o)), i = r + n + 1, o = ""), n && (r += n, n = 0);
  }
  return t.join("") + e.slice(i);
}
function NF(e, t) {
  const r = String(t.identifier).toUpperCase(), i = hp(r.toLowerCase()), n = e.footnoteOrder.indexOf(r);
  let a;
  n === -1 ? (e.footnoteOrder.push(r), e.footnoteCounts[r] = 1, a = e.footnoteOrder.length) : (e.footnoteCounts[r]++, a = n + 1);
  const o = e.footnoteCounts[r], s = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + e.clobberPrefix + "fn-" + i,
      id: e.clobberPrefix + "fnref-" + i + (o > 1 ? "-" + o : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(a) }]
  };
  e.patch(t, s);
  const l = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [s]
  };
  return e.patch(t, l), e.applyData(t, l);
}
function AZ(e, t) {
  const r = e.footnoteById;
  let i = 1;
  for (; i in r; )
    i++;
  const n = String(i);
  return r[n] = {
    type: "footnoteDefinition",
    identifier: n,
    children: [{ type: "paragraph", children: t.children }],
    position: t.position
  }, NF(e, {
    type: "footnoteReference",
    identifier: n,
    position: t.position
  });
}
function wZ(e, t) {
  const r = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function FZ(e, t) {
  if (e.dangerous) {
    const r = { type: "raw", value: t.value };
    return e.patch(t, r), e.applyData(t, r);
  }
  return null;
}
function zF(e, t) {
  const r = t.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return { type: "text", value: "![" + t.alt + i };
  const n = e.all(t), a = n[0];
  a && a.type === "text" ? a.value = "[" + a.value : n.unshift({ type: "text", value: "[" });
  const o = n[n.length - 1];
  return o && o.type === "text" ? o.value += i : n.push({ type: "text", value: i }), n;
}
function TZ(e, t) {
  const r = e.definition(t.identifier);
  if (!r)
    return zF(e, t);
  const i = { src: hp(r.url || ""), alt: t.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const n = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(t, n), e.applyData(t, n);
}
function SZ(e, t) {
  const r = { src: hp(t.url) };
  t.alt !== null && t.alt !== void 0 && (r.alt = t.alt), t.title !== null && t.title !== void 0 && (r.title = t.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(t, i), e.applyData(t, i);
}
function IZ(e, t) {
  const r = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(t, i), e.applyData(t, i);
}
function BZ(e, t) {
  const r = e.definition(t.identifier);
  if (!r)
    return zF(e, t);
  const i = { href: hp(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const n = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function RZ(e, t) {
  const r = { href: hp(t.url) };
  t.title !== null && t.title !== void 0 && (r.title = t.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function OZ(e, t, r) {
  const i = e.all(t), n = r ? PZ(r) : LF(t), a = {}, o = [];
  if (typeof t.checked == "boolean") {
    const d = i[0];
    let c;
    d && d.type === "element" && d.tagName === "p" ? c = d : (c = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(c)), c.children.length > 0 && c.children.unshift({ type: "text", value: " " }), c.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), a.className = ["task-list-item"];
  }
  let s = -1;
  for (; ++s < i.length; ) {
    const d = i[s];
    (n || s !== 0 || d.type !== "element" || d.tagName !== "p") && o.push({ type: "text", value: `
` }), d.type === "element" && d.tagName === "p" && !n ? o.push(...d.children) : o.push(d);
  }
  const l = i[i.length - 1];
  l && (n || l.type !== "element" || l.tagName !== "p") && o.push({ type: "text", value: `
` });
  const u = { type: "element", tagName: "li", properties: a, children: o };
  return e.patch(t, u), e.applyData(t, u);
}
function PZ(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !t && ++i < r.length; )
      t = LF(r[i]);
  }
  return t;
}
function LF(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function NZ(e, t) {
  const r = {}, i = e.all(t);
  let n = -1;
  for (typeof t.start == "number" && t.start !== 1 && (r.start = t.start); ++n < i.length; ) {
    const o = i[n];
    if (o.type === "element" && o.tagName === "li" && o.properties && Array.isArray(o.properties.className) && o.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const a = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function zZ(e, t) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function LZ(e, t) {
  const r = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, r), e.applyData(t, r);
}
function MZ(e, t) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
const q1 = MF("start"), zm = MF("end");
function jZ(e) {
  return { start: q1(e), end: zm(e) };
}
function MF(e) {
  return t;
  function t(r) {
    const i = r && r.position && r.position[e] || {};
    return {
      // @ts-expect-error: in practice, null is allowed.
      line: i.line || null,
      // @ts-expect-error: in practice, null is allowed.
      column: i.column || null,
      // @ts-expect-error: in practice, null is allowed.
      offset: i.offset > -1 ? i.offset : null
    };
  }
}
function HZ(e, t) {
  const r = e.all(t), i = r.shift(), n = [];
  if (i) {
    const o = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(t.children[0], o), n.push(o);
  }
  if (r.length > 0) {
    const o = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, s = q1(t.children[1]), l = zm(t.children[t.children.length - 1]);
    s.line && l.line && (o.position = { start: s, end: l }), n.push(o);
  }
  const a = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(n, !0)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function $Z(e, t, r) {
  const i = r ? r.children : void 0, a = (i ? i.indexOf(t) : 1) === 0 ? "th" : "td", o = r && r.type === "table" ? r.align : void 0, s = o ? o.length : t.children.length;
  let l = -1;
  const u = [];
  for (; ++l < s; ) {
    const c = t.children[l], p = {}, f = o ? o[l] : void 0;
    f && (p.align = f);
    let g = { type: "element", tagName: a, properties: p, children: [] };
    c && (g.children = e.all(c), e.patch(c, g), g = e.applyData(t, g)), u.push(g);
  }
  const d = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(u, !0)
  };
  return e.patch(t, d), e.applyData(t, d);
}
function UZ(e, t) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
const V4 = 9, W4 = 32;
function VZ(e) {
  const t = String(e), r = /\r?\n|\r/g;
  let i = r.exec(t), n = 0;
  const a = [];
  for (; i; )
    a.push(
      G4(t.slice(n, i.index), n > 0, !0),
      i[0]
    ), n = i.index + i[0].length, i = r.exec(t);
  return a.push(G4(t.slice(n), n > 0, !1)), a.join("");
}
function G4(e, t, r) {
  let i = 0, n = e.length;
  if (t) {
    let a = e.codePointAt(i);
    for (; a === V4 || a === W4; )
      i++, a = e.codePointAt(i);
  }
  if (r) {
    let a = e.codePointAt(n - 1);
    for (; a === V4 || a === W4; )
      n--, a = e.codePointAt(n - 1);
  }
  return n > i ? e.slice(i, n) : "";
}
function WZ(e, t) {
  const r = { type: "text", value: VZ(String(t.value)) };
  return e.patch(t, r), e.applyData(t, r);
}
function GZ(e, t) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, r), e.applyData(t, r);
}
const KZ = {
  blockquote: DZ,
  break: yZ,
  code: EZ,
  delete: CZ,
  emphasis: xZ,
  footnoteReference: NF,
  footnote: AZ,
  heading: wZ,
  html: FZ,
  imageReference: TZ,
  image: SZ,
  inlineCode: IZ,
  linkReference: BZ,
  link: RZ,
  listItem: OZ,
  list: NZ,
  paragraph: zZ,
  root: LZ,
  strong: MZ,
  table: HZ,
  tableCell: UZ,
  tableRow: $Z,
  text: WZ,
  thematicBreak: GZ,
  toml: bf,
  yaml: bf,
  definition: bf,
  footnoteDefinition: bf
};
function bf() {
  return null;
}
const jF = (
  /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {AssertAnything}
   */
  function(e) {
    if (e == null)
      return XZ;
    if (typeof e == "string")
      return QZ(e);
    if (typeof e == "object")
      return Array.isArray(e) ? YZ(e) : qZ(e);
    if (typeof e == "function")
      return Lm(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function YZ(e) {
  const t = [];
  let r = -1;
  for (; ++r < e.length; )
    t[r] = jF(e[r]);
  return Lm(i);
  function i(...n) {
    let a = -1;
    for (; ++a < t.length; )
      if (t[a].call(this, ...n))
        return !0;
    return !1;
  }
}
function qZ(e) {
  return Lm(t);
  function t(r) {
    let i;
    for (i in e)
      if (r[i] !== e[i])
        return !1;
    return !0;
  }
}
function QZ(e) {
  return Lm(t);
  function t(r) {
    return r && r.type === e;
  }
}
function Lm(e) {
  return t;
  function t(r, ...i) {
    return !!(r && typeof r == "object" && "type" in r && e.call(this, r, ...i));
  }
}
function XZ() {
  return !0;
}
const ZZ = !0, K4 = !1, JZ = "skip", eJ = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor<Node>} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(e, t, r, i) {
    typeof t == "function" && typeof r != "function" && (i = r, r = t, t = null);
    const n = jF(t), a = i ? -1 : 1;
    o(e, void 0, [])();
    function o(s, l, u) {
      const d = s && typeof s == "object" ? s : {};
      if (typeof d.type == "string") {
        const p = (
          // `hast`
          typeof d.tagName == "string" ? d.tagName : (
            // `xast`
            typeof d.name == "string" ? d.name : void 0
          )
        );
        Object.defineProperty(c, "name", {
          value: "node (" + (s.type + (p ? "<" + p + ">" : "")) + ")"
        });
      }
      return c;
      function c() {
        let p = [], f, g, k;
        if ((!t || n(s, l, u[u.length - 1] || null)) && (p = tJ(r(s, u)), p[0] === K4))
          return p;
        if (s.children && p[0] !== JZ)
          for (g = (i ? s.children.length : -1) + a, k = u.concat(s); g > -1 && g < s.children.length; ) {
            if (f = o(s.children[g], g, k)(), f[0] === K4)
              return f;
            g = typeof f[1] == "number" ? f[1] : g + a;
          }
        return p;
      }
    }
  }
);
function tJ(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [ZZ, e] : [e];
}
const Mm = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(e, t, r, i) {
    typeof t == "function" && typeof r != "function" && (i = r, r = t, t = null), eJ(e, t, n, i);
    function n(a, o) {
      const s = o[o.length - 1];
      return r(
        a,
        s ? s.children.indexOf(a) : null,
        s
      );
    }
  }
);
function rJ(e) {
  return !e || !e.position || !e.position.start || !e.position.start.line || !e.position.start.column || !e.position.end || !e.position.end.line || !e.position.end.column;
}
const Y4 = {}.hasOwnProperty;
function iJ(e) {
  const t = /* @__PURE__ */ Object.create(null);
  if (!e || !e.type)
    throw new Error("mdast-util-definitions expected node");
  return Mm(e, "definition", (i) => {
    const n = q4(i.identifier);
    n && !Y4.call(t, n) && (t[n] = i);
  }), r;
  function r(i) {
    const n = q4(i);
    return n && Y4.call(t, n) ? t[n] : null;
  }
}
function q4(e) {
  return String(e || "").toUpperCase();
}
const Ug = {}.hasOwnProperty;
function nJ(e, t) {
  const r = t || {}, i = r.allowDangerousHtml || !1, n = {};
  return o.dangerous = i, o.clobberPrefix = r.clobberPrefix === void 0 || r.clobberPrefix === null ? "user-content-" : r.clobberPrefix, o.footnoteLabel = r.footnoteLabel || "Footnotes", o.footnoteLabelTagName = r.footnoteLabelTagName || "h2", o.footnoteLabelProperties = r.footnoteLabelProperties || {
    className: ["sr-only"]
  }, o.footnoteBackLabel = r.footnoteBackLabel || "Back to content", o.unknownHandler = r.unknownHandler, o.passThrough = r.passThrough, o.handlers = { ...KZ, ...r.handlers }, o.definition = iJ(e), o.footnoteById = n, o.footnoteOrder = [], o.footnoteCounts = {}, o.patch = aJ, o.applyData = oJ, o.one = s, o.all = l, o.wrap = lJ, o.augment = a, Mm(e, "footnoteDefinition", (u) => {
    const d = String(u.identifier).toUpperCase();
    Ug.call(n, d) || (n[d] = u);
  }), o;
  function a(u, d) {
    if (u && "data" in u && u.data) {
      const c = u.data;
      c.hName && (d.type !== "element" && (d = {
        type: "element",
        tagName: "",
        properties: {},
        children: []
      }), d.tagName = c.hName), d.type === "element" && c.hProperties && (d.properties = { ...d.properties, ...c.hProperties }), "children" in d && d.children && c.hChildren && (d.children = c.hChildren);
    }
    if (u) {
      const c = "type" in u ? u : { position: u };
      rJ(c) || (d.position = { start: q1(c), end: zm(c) });
    }
    return d;
  }
  function o(u, d, c, p) {
    return Array.isArray(c) && (p = c, c = {}), a(u, {
      type: "element",
      tagName: d,
      properties: c || {},
      children: p || []
    });
  }
  function s(u, d) {
    return HF(o, u, d);
  }
  function l(u) {
    return TD(o, u);
  }
}
function aJ(e, t) {
  e.position && (t.position = jZ(e));
}
function oJ(e, t) {
  let r = t;
  if (e && e.data) {
    const i = e.data.hName, n = e.data.hChildren, a = e.data.hProperties;
    typeof i == "string" && (r.type === "element" ? r.tagName = i : r = {
      type: "element",
      tagName: i,
      properties: {},
      children: []
    }), r.type === "element" && a && (r.properties = { ...r.properties, ...a }), "children" in r && r.children && n !== null && n !== void 0 && (r.children = n);
  }
  return r;
}
function HF(e, t, r) {
  const i = t && t.type;
  if (!i)
    throw new Error("Expected node, got `" + t + "`");
  return Ug.call(e.handlers, i) ? e.handlers[i](e, t, r) : e.passThrough && e.passThrough.includes(i) ? "children" in t ? { ...t, children: TD(e, t) } : t : e.unknownHandler ? e.unknownHandler(e, t, r) : sJ(e, t);
}
function TD(e, t) {
  const r = [];
  if ("children" in t) {
    const i = t.children;
    let n = -1;
    for (; ++n < i.length; ) {
      const a = HF(e, i[n], t);
      if (a) {
        if (n && i[n - 1].type === "break" && (!Array.isArray(a) && a.type === "text" && (a.value = a.value.replace(/^\s+/, "")), !Array.isArray(a) && a.type === "element")) {
          const o = a.children[0];
          o && o.type === "text" && (o.value = o.value.replace(/^\s+/, ""));
        }
        Array.isArray(a) ? r.push(...a) : r.push(a);
      }
    }
  }
  return r;
}
function sJ(e, t) {
  const r = t.data || {}, i = "value" in t && !(Ug.call(r, "hProperties") || Ug.call(r, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: TD(e, t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function lJ(e, t) {
  const r = [];
  let i = -1;
  for (t && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return t && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function uJ(e) {
  const t = [];
  let r = -1;
  for (; ++r < e.footnoteOrder.length; ) {
    const i = e.footnoteById[e.footnoteOrder[r]];
    if (!i)
      continue;
    const n = e.all(i), a = String(i.identifier).toUpperCase(), o = hp(a.toLowerCase());
    let s = 0;
    const l = [];
    for (; ++s <= e.footnoteCounts[a]; ) {
      const c = {
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + e.clobberPrefix + "fnref-" + o + (s > 1 ? "-" + s : ""),
          dataFootnoteBackref: !0,
          className: ["data-footnote-backref"],
          ariaLabel: e.footnoteBackLabel
        },
        children: [{ type: "text", value: "↩" }]
      };
      s > 1 && c.children.push({
        type: "element",
        tagName: "sup",
        children: [{ type: "text", value: String(s) }]
      }), l.length > 0 && l.push({ type: "text", value: " " }), l.push(c);
    }
    const u = n[n.length - 1];
    if (u && u.type === "element" && u.tagName === "p") {
      const c = u.children[u.children.length - 1];
      c && c.type === "text" ? c.value += " " : u.children.push({ type: "text", value: " " }), u.children.push(...l);
    } else
      n.push(...l);
    const d = {
      type: "element",
      tagName: "li",
      properties: { id: e.clobberPrefix + "fn-" + o },
      children: e.wrap(n, !0)
    };
    e.patch(i, d), t.push(d);
  }
  if (t.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: e.footnoteLabelTagName,
          properties: {
            // To do: use structured clone.
            ...JSON.parse(JSON.stringify(e.footnoteLabelProperties)),
            id: "footnote-label"
          },
          children: [{ type: "text", value: e.footnoteLabel }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(t, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
function $F(e, t) {
  const r = nJ(e, t), i = r.one(e, null), n = uJ(r);
  return n && i.children.push({ type: "text", value: `
` }, n), Array.isArray(i) ? { type: "root", children: i } : i;
}
const cJ = (
  /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */
  function(e, t) {
    return e && "run" in e ? pJ(e, t) : hJ(e || t);
  }
), dJ = cJ;
function pJ(e, t) {
  return (r, i, n) => {
    e.run($F(r, t), i, (a) => {
      n(a);
    });
  };
}
function hJ(e) {
  return (t) => $F(t, e);
}
class Q1 {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, r, i) {
    this.property = t, this.normal = r, i && (this.space = i);
  }
}
Q1.prototype.property = {};
Q1.prototype.normal = {};
Q1.prototype.space = null;
function UF(e, t) {
  const r = {}, i = {};
  let n = -1;
  for (; ++n < e.length; )
    Object.assign(r, e[n].property), Object.assign(i, e[n].normal);
  return new Q1(r, i, t);
}
function A1(e) {
  return e.toLowerCase();
}
class Za {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, r) {
    this.property = t, this.attribute = r;
  }
}
Za.prototype.space = null;
Za.prototype.boolean = !1;
Za.prototype.booleanish = !1;
Za.prototype.overloadedBoolean = !1;
Za.prototype.number = !1;
Za.prototype.commaSeparated = !1;
Za.prototype.spaceSeparated = !1;
Za.prototype.commaOrSpaceSeparated = !1;
Za.prototype.mustUseProperty = !1;
Za.prototype.defined = !1;
let fJ = 0;
const Qt = pc(), zi = pc(), VF = pc(), Qe = pc(), ti = pc(), Vd = pc(), va = pc();
function pc() {
  return 2 ** ++fJ;
}
const z_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Qt,
  booleanish: zi,
  commaOrSpaceSeparated: va,
  commaSeparated: Vd,
  number: Qe,
  overloadedBoolean: VF,
  spaceSeparated: ti
}, Symbol.toStringTag, { value: "Module" })), eb = Object.keys(z_);
class SD extends Za {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, r, i, n) {
    let a = -1;
    if (super(t, r), Q4(this, "space", n), typeof i == "number")
      for (; ++a < eb.length; ) {
        const o = eb[a];
        Q4(this, eb[a], (i & z_[o]) === z_[o]);
      }
  }
}
SD.prototype.defined = !0;
function Q4(e, t, r) {
  r && (e[t] = r);
}
const gJ = {}.hasOwnProperty;
function fp(e) {
  const t = {}, r = {};
  let i;
  for (i in e.properties)
    if (gJ.call(e.properties, i)) {
      const n = e.properties[i], a = new SD(
        i,
        e.transform(e.attributes || {}, i),
        n,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (a.mustUseProperty = !0), t[i] = a, r[A1(i)] = i, r[A1(a.attribute)] = i;
    }
  return new Q1(t, r, e.space);
}
const WF = fp({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), GF = fp({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function KF(e, t) {
  return t in e ? e[t] : t;
}
function YF(e, t) {
  return KF(e, t.toLowerCase());
}
const qF = fp({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: YF,
  properties: { xmlns: null, xmlnsXLink: null }
}), QF = fp({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: zi,
    ariaAutoComplete: null,
    ariaBusy: zi,
    ariaChecked: zi,
    ariaColCount: Qe,
    ariaColIndex: Qe,
    ariaColSpan: Qe,
    ariaControls: ti,
    ariaCurrent: null,
    ariaDescribedBy: ti,
    ariaDetails: null,
    ariaDisabled: zi,
    ariaDropEffect: ti,
    ariaErrorMessage: null,
    ariaExpanded: zi,
    ariaFlowTo: ti,
    ariaGrabbed: zi,
    ariaHasPopup: null,
    ariaHidden: zi,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: ti,
    ariaLevel: Qe,
    ariaLive: null,
    ariaModal: zi,
    ariaMultiLine: zi,
    ariaMultiSelectable: zi,
    ariaOrientation: null,
    ariaOwns: ti,
    ariaPlaceholder: null,
    ariaPosInSet: Qe,
    ariaPressed: zi,
    ariaReadOnly: zi,
    ariaRelevant: null,
    ariaRequired: zi,
    ariaRoleDescription: ti,
    ariaRowCount: Qe,
    ariaRowIndex: Qe,
    ariaRowSpan: Qe,
    ariaSelected: zi,
    ariaSetSize: Qe,
    ariaSort: null,
    ariaValueMax: Qe,
    ariaValueMin: Qe,
    ariaValueNow: Qe,
    ariaValueText: null,
    role: null
  }
}), mJ = fp({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: YF,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Vd,
    acceptCharset: ti,
    accessKey: ti,
    action: null,
    allow: null,
    allowFullScreen: Qt,
    allowPaymentRequest: Qt,
    allowUserMedia: Qt,
    alt: null,
    as: null,
    async: Qt,
    autoCapitalize: null,
    autoComplete: ti,
    autoFocus: Qt,
    autoPlay: Qt,
    blocking: ti,
    capture: Qt,
    charSet: null,
    checked: Qt,
    cite: null,
    className: ti,
    cols: Qe,
    colSpan: null,
    content: null,
    contentEditable: zi,
    controls: Qt,
    controlsList: ti,
    coords: Qe | Vd,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Qt,
    defer: Qt,
    dir: null,
    dirName: null,
    disabled: Qt,
    download: VF,
    draggable: zi,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Qt,
    formTarget: null,
    headers: ti,
    height: Qe,
    hidden: Qt,
    high: Qe,
    href: null,
    hrefLang: null,
    htmlFor: ti,
    httpEquiv: ti,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Qt,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Qt,
    itemId: null,
    itemProp: ti,
    itemRef: ti,
    itemScope: Qt,
    itemType: ti,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Qt,
    low: Qe,
    manifest: null,
    max: null,
    maxLength: Qe,
    media: null,
    method: null,
    min: null,
    minLength: Qe,
    multiple: Qt,
    muted: Qt,
    name: null,
    nonce: null,
    noModule: Qt,
    noValidate: Qt,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Qt,
    optimum: Qe,
    pattern: null,
    ping: ti,
    placeholder: null,
    playsInline: Qt,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Qt,
    referrerPolicy: null,
    rel: ti,
    required: Qt,
    reversed: Qt,
    rows: Qe,
    rowSpan: Qe,
    sandbox: ti,
    scope: null,
    scoped: Qt,
    seamless: Qt,
    selected: Qt,
    shadowRootDelegatesFocus: Qt,
    shadowRootMode: null,
    shape: null,
    size: Qe,
    sizes: null,
    slot: null,
    span: Qe,
    spellCheck: zi,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Qe,
    step: null,
    style: null,
    tabIndex: Qe,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Qt,
    useMap: null,
    value: zi,
    width: Qe,
    wrap: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: ti,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Qe,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Qe,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Qt,
    // Lists. Use CSS to reduce space between items instead
    declare: Qt,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Qe,
    // `<img>` and `<object>`
    leftMargin: Qe,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Qe,
    // `<body>`
    marginWidth: Qe,
    // `<body>`
    noResize: Qt,
    // `<frame>`
    noHref: Qt,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Qt,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Qt,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Qe,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: zi,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Qe,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Qe,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Qt,
    disableRemotePlayback: Qt,
    prefix: null,
    property: null,
    results: Qe,
    security: null,
    unselectable: null
  }
}), vJ = fp({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: KF,
  properties: {
    about: va,
    accentHeight: Qe,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Qe,
    amplitude: Qe,
    arabicForm: null,
    ascent: Qe,
    attributeName: null,
    attributeType: null,
    azimuth: Qe,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Qe,
    by: null,
    calcMode: null,
    capHeight: Qe,
    className: ti,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Qe,
    diffuseConstant: Qe,
    direction: null,
    display: null,
    dur: null,
    divisor: Qe,
    dominantBaseline: null,
    download: Qt,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Qe,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Qe,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Qe,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Vd,
    g2: Vd,
    glyphName: Vd,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Qe,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Qe,
    horizOriginX: Qe,
    horizOriginY: Qe,
    id: null,
    ideographic: Qe,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Qe,
    k: Qe,
    k1: Qe,
    k2: Qe,
    k3: Qe,
    k4: Qe,
    kernelMatrix: va,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Qe,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Qe,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Qe,
    overlineThickness: Qe,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Qe,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: ti,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Qe,
    pointsAtY: Qe,
    pointsAtZ: Qe,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: va,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: va,
    rev: va,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: va,
    requiredFeatures: va,
    requiredFonts: va,
    requiredFormats: va,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Qe,
    specularExponent: Qe,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Qe,
    strikethroughThickness: Qe,
    string: null,
    stroke: null,
    strokeDashArray: va,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Qe,
    strokeOpacity: Qe,
    strokeWidth: null,
    style: null,
    surfaceScale: Qe,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: va,
    tabIndex: Qe,
    tableValues: null,
    target: null,
    targetX: Qe,
    targetY: Qe,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: va,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Qe,
    underlineThickness: Qe,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Qe,
    values: null,
    vAlphabetic: Qe,
    vMathematical: Qe,
    vectorEffect: null,
    vHanging: Qe,
    vIdeographic: Qe,
    version: null,
    vertAdvY: Qe,
    vertOriginX: Qe,
    vertOriginY: Qe,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Qe,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), kJ = /^data[-\w.:]+$/i, X4 = /-[a-z]/g, bJ = /[A-Z]/g;
function jm(e, t) {
  const r = A1(t);
  let i = t, n = Za;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && kJ.test(t)) {
    if (t.charAt(4) === "-") {
      const a = t.slice(5).replace(X4, DJ);
      i = "data" + a.charAt(0).toUpperCase() + a.slice(1);
    } else {
      const a = t.slice(4);
      if (!X4.test(a)) {
        let o = a.replace(bJ, _J);
        o.charAt(0) !== "-" && (o = "-" + o), t = "data" + o;
      }
    }
    n = SD;
  }
  return new n(i, t);
}
function _J(e) {
  return "-" + e.toLowerCase();
}
function DJ(e) {
  return e.charAt(1).toUpperCase();
}
const Z4 = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, X1 = UF([GF, WF, qF, QF, mJ], "html"), gp = UF([GF, WF, qF, QF, vJ], "svg");
function yJ(e) {
  if (e.allowedElements && e.disallowedElements)
    throw new TypeError(
      "Only one of `allowedElements` and `disallowedElements` should be defined"
    );
  if (e.allowedElements || e.disallowedElements || e.allowElement)
    return (t) => {
      Mm(t, "element", (r, i, n) => {
        const a = (
          /** @type {Element|Root} */
          n
        );
        let o;
        if (e.allowedElements ? o = !e.allowedElements.includes(r.tagName) : e.disallowedElements && (o = e.disallowedElements.includes(r.tagName)), !o && e.allowElement && typeof i == "number" && (o = !e.allowElement(r, i, a)), o && typeof i == "number")
          return e.unwrapDisallowed && r.children ? a.children.splice(i, 1, ...r.children) : a.children.splice(i, 1), i;
      });
    };
}
var L_ = { exports: {} }, Tr = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var J4;
function EJ() {
  if (J4)
    return Tr;
  J4 = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), n = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), c = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), g;
  g = Symbol.for("react.module.reference");
  function k(y) {
    if (typeof y == "object" && y !== null) {
      var _ = y.$$typeof;
      switch (_) {
        case e:
          switch (y = y.type, y) {
            case r:
            case n:
            case i:
            case u:
            case d:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case o:
                case l:
                case p:
                case c:
                case a:
                  return y;
                default:
                  return _;
              }
          }
        case t:
          return _;
      }
    }
  }
  return Tr.ContextConsumer = o, Tr.ContextProvider = a, Tr.Element = e, Tr.ForwardRef = l, Tr.Fragment = r, Tr.Lazy = p, Tr.Memo = c, Tr.Portal = t, Tr.Profiler = n, Tr.StrictMode = i, Tr.Suspense = u, Tr.SuspenseList = d, Tr.isAsyncMode = function() {
    return !1;
  }, Tr.isConcurrentMode = function() {
    return !1;
  }, Tr.isContextConsumer = function(y) {
    return k(y) === o;
  }, Tr.isContextProvider = function(y) {
    return k(y) === a;
  }, Tr.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, Tr.isForwardRef = function(y) {
    return k(y) === l;
  }, Tr.isFragment = function(y) {
    return k(y) === r;
  }, Tr.isLazy = function(y) {
    return k(y) === p;
  }, Tr.isMemo = function(y) {
    return k(y) === c;
  }, Tr.isPortal = function(y) {
    return k(y) === t;
  }, Tr.isProfiler = function(y) {
    return k(y) === n;
  }, Tr.isStrictMode = function(y) {
    return k(y) === i;
  }, Tr.isSuspense = function(y) {
    return k(y) === u;
  }, Tr.isSuspenseList = function(y) {
    return k(y) === d;
  }, Tr.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === r || y === n || y === i || y === u || y === d || y === f || typeof y == "object" && y !== null && (y.$$typeof === p || y.$$typeof === c || y.$$typeof === a || y.$$typeof === o || y.$$typeof === l || y.$$typeof === g || y.getModuleId !== void 0);
  }, Tr.typeOf = k, Tr;
}
var Sr = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var eC;
function CJ() {
  return eC || (eC = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), n = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), c = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), g = !1, k = !1, y = !1, _ = !1, A = !1, T;
    T = Symbol.for("react.module.reference");
    function N(Ge) {
      return !!(typeof Ge == "string" || typeof Ge == "function" || Ge === r || Ge === n || A || Ge === i || Ge === u || Ge === d || _ || Ge === f || g || k || y || typeof Ge == "object" && Ge !== null && (Ge.$$typeof === p || Ge.$$typeof === c || Ge.$$typeof === a || Ge.$$typeof === o || Ge.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Ge.$$typeof === T || Ge.getModuleId !== void 0));
    }
    function P(Ge) {
      if (typeof Ge == "object" && Ge !== null) {
        var nr = Ge.$$typeof;
        switch (nr) {
          case e:
            var vr = Ge.type;
            switch (vr) {
              case r:
              case n:
              case i:
              case u:
              case d:
                return vr;
              default:
                var zr = vr && vr.$$typeof;
                switch (zr) {
                  case s:
                  case o:
                  case l:
                  case p:
                  case c:
                  case a:
                    return zr;
                  default:
                    return nr;
                }
            }
          case t:
            return nr;
        }
      }
    }
    var B = o, M = a, X = e, U = l, K = r, z = p, j = c, J = t, ie = n, ue = i, de = u, he = d, Ee = !1, Le = !1;
    function L(Ge) {
      return Ee || (Ee = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function me(Ge) {
      return Le || (Le = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Se(Ge) {
      return P(Ge) === o;
    }
    function G(Ge) {
      return P(Ge) === a;
    }
    function He(Ge) {
      return typeof Ge == "object" && Ge !== null && Ge.$$typeof === e;
    }
    function xe(Ge) {
      return P(Ge) === l;
    }
    function _e(Ge) {
      return P(Ge) === r;
    }
    function Ze(Ge) {
      return P(Ge) === p;
    }
    function qe(Ge) {
      return P(Ge) === c;
    }
    function nt(Ge) {
      return P(Ge) === t;
    }
    function at(Ge) {
      return P(Ge) === n;
    }
    function At(Ge) {
      return P(Ge) === i;
    }
    function Oe(Ge) {
      return P(Ge) === u;
    }
    function wt(Ge) {
      return P(Ge) === d;
    }
    Sr.ContextConsumer = B, Sr.ContextProvider = M, Sr.Element = X, Sr.ForwardRef = U, Sr.Fragment = K, Sr.Lazy = z, Sr.Memo = j, Sr.Portal = J, Sr.Profiler = ie, Sr.StrictMode = ue, Sr.Suspense = de, Sr.SuspenseList = he, Sr.isAsyncMode = L, Sr.isConcurrentMode = me, Sr.isContextConsumer = Se, Sr.isContextProvider = G, Sr.isElement = He, Sr.isForwardRef = xe, Sr.isFragment = _e, Sr.isLazy = Ze, Sr.isMemo = qe, Sr.isPortal = nt, Sr.isProfiler = at, Sr.isStrictMode = At, Sr.isSuspense = Oe, Sr.isSuspenseList = wt, Sr.isValidElementType = N, Sr.typeOf = P;
  }()), Sr;
}
process.env.NODE_ENV === "production" ? L_.exports = EJ() : L_.exports = CJ();
var xJ = L_.exports;
const AJ = /* @__PURE__ */ is(xJ);
function wJ(e) {
  const t = (
    // @ts-expect-error looks like a node.
    e && typeof e == "object" && e.type === "text" ? (
      // @ts-expect-error looks like a text.
      e.value || ""
    ) : e
  );
  return typeof t == "string" && t.replace(/[ \t\n\f\r]/g, "") === "";
}
function tC(e) {
  const t = String(e || "").trim();
  return t ? t.split(/[ \t\n\r\f]+/g) : [];
}
function XF(e) {
  return e.join(" ").trim();
}
function rC(e) {
  const t = [], r = String(e || "");
  let i = r.indexOf(","), n = 0, a = !1;
  for (; !a; ) {
    i === -1 && (i = r.length, a = !0);
    const o = r.slice(n, i).trim();
    (o || !a) && t.push(o), n = i + 1, i = r.indexOf(",", n);
  }
  return t;
}
function ZF(e, t) {
  const r = t || {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
var ID = { exports: {} }, iC = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, FJ = /\n/g, TJ = /^\s*/, SJ = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, IJ = /^:\s*/, BJ = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, RJ = /^[;\s]*/, OJ = /^\s+|\s+$/g, PJ = `
`, nC = "/", aC = "*", Hu = "", NJ = "comment", zJ = "declaration", LJ = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e)
    return [];
  t = t || {};
  var r = 1, i = 1;
  function n(g) {
    var k = g.match(FJ);
    k && (r += k.length);
    var y = g.lastIndexOf(PJ);
    i = ~y ? g.length - y : i + g.length;
  }
  function a() {
    var g = { line: r, column: i };
    return function(k) {
      return k.position = new o(g), u(), k;
    };
  }
  function o(g) {
    this.start = g, this.end = { line: r, column: i }, this.source = t.source;
  }
  o.prototype.content = e;
  function s(g) {
    var k = new Error(
      t.source + ":" + r + ":" + i + ": " + g
    );
    if (k.reason = g, k.filename = t.source, k.line = r, k.column = i, k.source = e, !t.silent)
      throw k;
  }
  function l(g) {
    var k = g.exec(e);
    if (k) {
      var y = k[0];
      return n(y), e = e.slice(y.length), k;
    }
  }
  function u() {
    l(TJ);
  }
  function d(g) {
    var k;
    for (g = g || []; k = c(); )
      k !== !1 && g.push(k);
    return g;
  }
  function c() {
    var g = a();
    if (!(nC != e.charAt(0) || aC != e.charAt(1))) {
      for (var k = 2; Hu != e.charAt(k) && (aC != e.charAt(k) || nC != e.charAt(k + 1)); )
        ++k;
      if (k += 2, Hu === e.charAt(k - 1))
        return s("End of comment missing");
      var y = e.slice(2, k - 2);
      return i += 2, n(y), e = e.slice(k), i += 2, g({
        type: NJ,
        comment: y
      });
    }
  }
  function p() {
    var g = a(), k = l(SJ);
    if (k) {
      if (c(), !l(IJ))
        return s("property missing ':'");
      var y = l(BJ), _ = g({
        type: zJ,
        property: oC(k[0].replace(iC, Hu)),
        value: y ? oC(y[0].replace(iC, Hu)) : Hu
      });
      return l(RJ), _;
    }
  }
  function f() {
    var g = [];
    d(g);
    for (var k; k = p(); )
      k !== !1 && (g.push(k), d(g));
    return g;
  }
  return u(), f();
};
function oC(e) {
  return e ? e.replace(OJ, Hu) : Hu;
}
var MJ = LJ;
function JF(e, t) {
  var r = null;
  if (!e || typeof e != "string")
    return r;
  for (var i, n = MJ(e), a = typeof t == "function", o, s, l = 0, u = n.length; l < u; l++)
    i = n[l], o = i.property, s = i.value, a ? t(o, s, i) : s && (r || (r = {}), r[o] = s);
  return r;
}
ID.exports = JF;
ID.exports.default = JF;
var jJ = ID.exports;
const HJ = /* @__PURE__ */ is(jJ), M_ = {}.hasOwnProperty, $J = /* @__PURE__ */ new Set(["table", "thead", "tbody", "tfoot", "tr"]);
function e7(e, t) {
  const r = [];
  let i = -1, n;
  for (; ++i < t.children.length; )
    n = t.children[i], n.type === "element" ? r.push(UJ(e, n, i, t)) : n.type === "text" ? (t.type !== "element" || !$J.has(t.tagName) || !wJ(n)) && r.push(n.value) : n.type === "raw" && !e.options.skipHtml && r.push(n.value);
  return r;
}
function UJ(e, t, r, i) {
  const n = e.options, a = n.transformLinkUri === void 0 ? qq : n.transformLinkUri, o = e.schema, s = t.tagName, l = {};
  let u = o, d;
  if (o.space === "html" && s === "svg" && (u = gp, e.schema = u), t.properties)
    for (d in t.properties)
      M_.call(t.properties, d) && WJ(l, d, t.properties[d], e);
  (s === "ol" || s === "ul") && e.listDepth++;
  const c = e7(e, t);
  (s === "ol" || s === "ul") && e.listDepth--, e.schema = o;
  const p = t.position || {
    start: { line: null, column: null, offset: null },
    end: { line: null, column: null, offset: null }
  }, f = n.components && M_.call(n.components, s) ? n.components[s] : s, g = typeof f == "string" || f === ht.Fragment;
  if (!AJ.isValidElementType(f))
    throw new TypeError(
      `Component for name \`${s}\` not defined or is not renderable`
    );
  if (l.key = r, s === "a" && n.linkTarget && (l.target = typeof n.linkTarget == "function" ? n.linkTarget(
    String(l.href || ""),
    t.children,
    typeof l.title == "string" ? l.title : null
  ) : n.linkTarget), s === "a" && a && (l.href = a(
    String(l.href || ""),
    t.children,
    typeof l.title == "string" ? l.title : null
  )), !g && s === "code" && i.type === "element" && i.tagName !== "pre" && (l.inline = !0), !g && (s === "h1" || s === "h2" || s === "h3" || s === "h4" || s === "h5" || s === "h6") && (l.level = Number.parseInt(s.charAt(1), 10)), s === "img" && n.transformImageUri && (l.src = n.transformImageUri(
    String(l.src || ""),
    String(l.alt || ""),
    typeof l.title == "string" ? l.title : null
  )), !g && s === "li" && i.type === "element") {
    const k = VJ(t);
    l.checked = k && k.properties ? !!k.properties.checked : null, l.index = tb(i, t), l.ordered = i.tagName === "ol";
  }
  return !g && (s === "ol" || s === "ul") && (l.ordered = s === "ol", l.depth = e.listDepth), (s === "td" || s === "th") && (l.align && (l.style || (l.style = {}), l.style.textAlign = l.align, delete l.align), g || (l.isHeader = s === "th")), !g && s === "tr" && i.type === "element" && (l.isHeader = i.tagName === "thead"), n.sourcePos && (l["data-sourcepos"] = YJ(p)), !g && n.rawSourcePos && (l.sourcePosition = t.position), !g && n.includeElementIndex && (l.index = tb(i, t), l.siblingCount = tb(i)), g || (l.node = t), c.length > 0 ? ht.createElement(f, l, c) : ht.createElement(f, l);
}
function VJ(e) {
  let t = -1;
  for (; ++t < e.children.length; ) {
    const r = e.children[t];
    if (r.type === "element" && r.tagName === "input")
      return r;
  }
  return null;
}
function tb(e, t) {
  let r = -1, i = 0;
  for (; ++r < e.children.length && e.children[r] !== t; )
    e.children[r].type === "element" && i++;
  return i;
}
function WJ(e, t, r, i) {
  const n = jm(i.schema, t);
  let a = r;
  a == null || a !== a || (Array.isArray(a) && (a = n.commaSeparated ? ZF(a) : XF(a)), n.property === "style" && typeof a == "string" && (a = GJ(a)), n.space && n.property ? e[M_.call(Z4, n.property) ? Z4[n.property] : n.property] = a : n.attribute && (e[n.attribute] = a));
}
function GJ(e) {
  const t = {};
  try {
    HJ(e, r);
  } catch {
  }
  return t;
  function r(i, n) {
    const a = i.slice(0, 4) === "-ms-" ? `ms-${i.slice(4)}` : i;
    t[a.replace(/-([a-z])/g, KJ)] = n;
  }
}
function KJ(e, t) {
  return t.toUpperCase();
}
function YJ(e) {
  return [
    e.start.line,
    ":",
    e.start.column,
    "-",
    e.end.line,
    ":",
    e.end.column
  ].map(String).join("");
}
const sC = {}.hasOwnProperty, qJ = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", _f = {
  plugins: { to: "remarkPlugins", id: "change-plugins-to-remarkplugins" },
  renderers: { to: "components", id: "change-renderers-to-components" },
  astPlugins: { id: "remove-buggy-html-in-markdown-parser" },
  allowDangerousHtml: { id: "remove-buggy-html-in-markdown-parser" },
  escapeHtml: { id: "remove-buggy-html-in-markdown-parser" },
  source: { to: "children", id: "change-source-to-children" },
  allowNode: {
    to: "allowElement",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  allowedTypes: {
    to: "allowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  disallowedTypes: {
    to: "disallowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  includeNodeIndex: {
    to: "includeElementIndex",
    id: "change-includenodeindex-to-includeelementindex"
  }
};
function t7(e) {
  for (const a in _f)
    if (sC.call(_f, a) && sC.call(e, a)) {
      const o = _f[a];
      console.warn(
        `[react-markdown] Warning: please ${o.to ? `use \`${o.to}\` instead of` : "remove"} \`${a}\` (see <${qJ}#${o.id}> for more info)`
      ), delete _f[a];
    }
  const t = dQ().use(_Z).use(e.remarkPlugins || []).use(dJ, {
    ...e.remarkRehypeOptions,
    allowDangerousHtml: !0
  }).use(e.rehypePlugins || []).use(yJ, e), r = new bF();
  typeof e.children == "string" ? r.value = e.children : e.children !== void 0 && e.children !== null && console.warn(
    `[react-markdown] Warning: please pass a string as \`children\` (not: \`${e.children}\`)`
  );
  const i = t.runSync(t.parse(r), r);
  if (i.type !== "root")
    throw new TypeError("Expected a `root` node");
  let n = ht.createElement(
    ht.Fragment,
    {},
    e7({ options: e, schema: X1, listDepth: 0 }, i)
  );
  return e.className && (n = ht.createElement("div", { className: e.className }, n)), n;
}
t7.propTypes = {
  // Core options:
  children: Kt.string,
  // Layout options:
  className: Kt.string,
  // Filter options:
  allowElement: Kt.func,
  allowedElements: Kt.arrayOf(Kt.string),
  disallowedElements: Kt.arrayOf(Kt.string),
  unwrapDisallowed: Kt.bool,
  // Plugin options:
  remarkPlugins: Kt.arrayOf(
    Kt.oneOfType([
      Kt.object,
      Kt.func,
      Kt.arrayOf(
        Kt.oneOfType([
          Kt.bool,
          Kt.string,
          Kt.object,
          Kt.func,
          Kt.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            Kt.any
          )
        ])
      )
    ])
  ),
  rehypePlugins: Kt.arrayOf(
    Kt.oneOfType([
      Kt.object,
      Kt.func,
      Kt.arrayOf(
        Kt.oneOfType([
          Kt.bool,
          Kt.string,
          Kt.object,
          Kt.func,
          Kt.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            Kt.any
          )
        ])
      )
    ])
  ),
  // Transform options:
  sourcePos: Kt.bool,
  rawSourcePos: Kt.bool,
  skipHtml: Kt.bool,
  includeElementIndex: Kt.bool,
  transformLinkUri: Kt.oneOfType([Kt.func, Kt.bool]),
  linkTarget: Kt.oneOfType([Kt.func, Kt.string]),
  transformImageUri: Kt.func,
  components: Kt.object
};
var Ao = {};
const QJ = [
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
];
Ao.REPLACEMENT_CHARACTER = "�";
Ao.CODE_POINTS = {
  EOF: -1,
  NULL: 0,
  TABULATION: 9,
  CARRIAGE_RETURN: 13,
  LINE_FEED: 10,
  FORM_FEED: 12,
  SPACE: 32,
  EXCLAMATION_MARK: 33,
  QUOTATION_MARK: 34,
  NUMBER_SIGN: 35,
  AMPERSAND: 38,
  APOSTROPHE: 39,
  HYPHEN_MINUS: 45,
  SOLIDUS: 47,
  DIGIT_0: 48,
  DIGIT_9: 57,
  SEMICOLON: 59,
  LESS_THAN_SIGN: 60,
  EQUALS_SIGN: 61,
  GREATER_THAN_SIGN: 62,
  QUESTION_MARK: 63,
  LATIN_CAPITAL_A: 65,
  LATIN_CAPITAL_F: 70,
  LATIN_CAPITAL_X: 88,
  LATIN_CAPITAL_Z: 90,
  RIGHT_SQUARE_BRACKET: 93,
  GRAVE_ACCENT: 96,
  LATIN_SMALL_A: 97,
  LATIN_SMALL_F: 102,
  LATIN_SMALL_X: 120,
  LATIN_SMALL_Z: 122,
  REPLACEMENT_CHARACTER: 65533
};
Ao.CODE_POINT_SEQUENCES = {
  DASH_DASH_STRING: [45, 45],
  //--
  DOCTYPE_STRING: [68, 79, 67, 84, 89, 80, 69],
  //DOCTYPE
  CDATA_START_STRING: [91, 67, 68, 65, 84, 65, 91],
  //[CDATA[
  SCRIPT_STRING: [115, 99, 114, 105, 112, 116],
  //script
  PUBLIC_STRING: [80, 85, 66, 76, 73, 67],
  //PUBLIC
  SYSTEM_STRING: [83, 89, 83, 84, 69, 77]
  //SYSTEM
};
Ao.isSurrogate = function(e) {
  return e >= 55296 && e <= 57343;
};
Ao.isSurrogatePair = function(e) {
  return e >= 56320 && e <= 57343;
};
Ao.getSurrogatePairCodePoint = function(e, t) {
  return (e - 55296) * 1024 + 9216 + t;
};
Ao.isControlCodePoint = function(e) {
  return e !== 32 && e !== 10 && e !== 13 && e !== 9 && e !== 12 && e >= 1 && e <= 31 || e >= 127 && e <= 159;
};
Ao.isUndefinedCodePoint = function(e) {
  return e >= 64976 && e <= 65007 || QJ.indexOf(e) > -1;
};
var BD = {
  controlCharacterInInputStream: "control-character-in-input-stream",
  noncharacterInInputStream: "noncharacter-in-input-stream",
  surrogateInInputStream: "surrogate-in-input-stream",
  nonVoidHtmlElementStartTagWithTrailingSolidus: "non-void-html-element-start-tag-with-trailing-solidus",
  endTagWithAttributes: "end-tag-with-attributes",
  endTagWithTrailingSolidus: "end-tag-with-trailing-solidus",
  unexpectedSolidusInTag: "unexpected-solidus-in-tag",
  unexpectedNullCharacter: "unexpected-null-character",
  unexpectedQuestionMarkInsteadOfTagName: "unexpected-question-mark-instead-of-tag-name",
  invalidFirstCharacterOfTagName: "invalid-first-character-of-tag-name",
  unexpectedEqualsSignBeforeAttributeName: "unexpected-equals-sign-before-attribute-name",
  missingEndTagName: "missing-end-tag-name",
  unexpectedCharacterInAttributeName: "unexpected-character-in-attribute-name",
  unknownNamedCharacterReference: "unknown-named-character-reference",
  missingSemicolonAfterCharacterReference: "missing-semicolon-after-character-reference",
  unexpectedCharacterAfterDoctypeSystemIdentifier: "unexpected-character-after-doctype-system-identifier",
  unexpectedCharacterInUnquotedAttributeValue: "unexpected-character-in-unquoted-attribute-value",
  eofBeforeTagName: "eof-before-tag-name",
  eofInTag: "eof-in-tag",
  missingAttributeValue: "missing-attribute-value",
  missingWhitespaceBetweenAttributes: "missing-whitespace-between-attributes",
  missingWhitespaceAfterDoctypePublicKeyword: "missing-whitespace-after-doctype-public-keyword",
  missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: "missing-whitespace-between-doctype-public-and-system-identifiers",
  missingWhitespaceAfterDoctypeSystemKeyword: "missing-whitespace-after-doctype-system-keyword",
  missingQuoteBeforeDoctypePublicIdentifier: "missing-quote-before-doctype-public-identifier",
  missingQuoteBeforeDoctypeSystemIdentifier: "missing-quote-before-doctype-system-identifier",
  missingDoctypePublicIdentifier: "missing-doctype-public-identifier",
  missingDoctypeSystemIdentifier: "missing-doctype-system-identifier",
  abruptDoctypePublicIdentifier: "abrupt-doctype-public-identifier",
  abruptDoctypeSystemIdentifier: "abrupt-doctype-system-identifier",
  cdataInHtmlContent: "cdata-in-html-content",
  incorrectlyOpenedComment: "incorrectly-opened-comment",
  eofInScriptHtmlCommentLikeText: "eof-in-script-html-comment-like-text",
  eofInDoctype: "eof-in-doctype",
  nestedComment: "nested-comment",
  abruptClosingOfEmptyComment: "abrupt-closing-of-empty-comment",
  eofInComment: "eof-in-comment",
  incorrectlyClosedComment: "incorrectly-closed-comment",
  eofInCdata: "eof-in-cdata",
  absenceOfDigitsInNumericCharacterReference: "absence-of-digits-in-numeric-character-reference",
  nullCharacterReference: "null-character-reference",
  surrogateCharacterReference: "surrogate-character-reference",
  characterReferenceOutsideUnicodeRange: "character-reference-outside-unicode-range",
  controlCharacterReference: "control-character-reference",
  noncharacterCharacterReference: "noncharacter-character-reference",
  missingWhitespaceBeforeDoctypeName: "missing-whitespace-before-doctype-name",
  missingDoctypeName: "missing-doctype-name",
  invalidCharacterSequenceAfterDoctypeName: "invalid-character-sequence-after-doctype-name",
  duplicateAttribute: "duplicate-attribute",
  nonConformingDoctype: "non-conforming-doctype",
  missingDoctype: "missing-doctype",
  misplacedDoctype: "misplaced-doctype",
  endTagWithoutMatchingOpenElement: "end-tag-without-matching-open-element",
  closingOfElementWithOpenChildElements: "closing-of-element-with-open-child-elements",
  disallowedContentInNoscriptInHead: "disallowed-content-in-noscript-in-head",
  openElementsLeftAfterEof: "open-elements-left-after-eof",
  abandonedHeadElementChild: "abandoned-head-element-child",
  misplacedStartTagForHeadElement: "misplaced-start-tag-for-head-element",
  nestedNoscriptInHead: "nested-noscript-in-head",
  eofInElementThatCanContainOnlyText: "eof-in-element-that-can-contain-only-text"
};
const wd = Ao, rb = BD, Bu = wd.CODE_POINTS, XJ = 65536;
let ZJ = class {
  constructor() {
    this.html = null, this.pos = -1, this.lastGapPos = -1, this.lastCharPos = -1, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = XJ;
  }
  _err() {
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(t) {
    if (this.pos !== this.lastCharPos) {
      const r = this.html.charCodeAt(this.pos + 1);
      if (wd.isSurrogatePair(r))
        return this.pos++, this._addGap(), wd.getSurrogatePairCodePoint(t, r);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, Bu.EOF;
    return this._err(rb.surrogateInInputStream), t;
  }
  dropParsedChunk() {
    this.pos > this.bufferWaterline && (this.lastCharPos -= this.pos, this.html = this.html.substring(this.pos), this.pos = 0, this.lastGapPos = -1, this.gapStack = []);
  }
  write(t, r) {
    this.html ? this.html += t : this.html = t, this.lastCharPos = this.html.length - 1, this.endOfChunkHit = !1, this.lastChunkWritten = r;
  }
  insertHtmlAtCurrentPos(t) {
    this.html = this.html.substring(0, this.pos + 1) + t + this.html.substring(this.pos + 1, this.html.length), this.lastCharPos = this.html.length - 1, this.endOfChunkHit = !1;
  }
  advance() {
    if (this.pos++, this.pos > this.lastCharPos)
      return this.endOfChunkHit = !this.lastChunkWritten, Bu.EOF;
    let t = this.html.charCodeAt(this.pos);
    return this.skipNextNewLine && t === Bu.LINE_FEED ? (this.skipNextNewLine = !1, this._addGap(), this.advance()) : t === Bu.CARRIAGE_RETURN ? (this.skipNextNewLine = !0, Bu.LINE_FEED) : (this.skipNextNewLine = !1, wd.isSurrogate(t) && (t = this._processSurrogate(t)), t > 31 && t < 127 || t === Bu.LINE_FEED || t === Bu.CARRIAGE_RETURN || t > 159 && t < 64976 || this._checkForProblematicCharacters(t), t);
  }
  _checkForProblematicCharacters(t) {
    wd.isControlCodePoint(t) ? this._err(rb.controlCharacterInInputStream) : wd.isUndefinedCodePoint(t) && this._err(rb.noncharacterInInputStream);
  }
  retreat() {
    this.pos === this.lastGapPos && (this.lastGapPos = this.gapStack.pop(), this.pos--), this.pos--;
  }
};
var JJ = ZJ, eee = new Uint16Array([4, 52, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 106, 303, 412, 810, 1432, 1701, 1796, 1987, 2114, 2360, 2420, 2484, 3170, 3251, 4140, 4393, 4575, 4610, 5106, 5512, 5728, 6117, 6274, 6315, 6345, 6427, 6516, 7002, 7910, 8733, 9323, 9870, 10170, 10631, 10893, 11318, 11386, 11467, 12773, 13092, 14474, 14922, 15448, 15542, 16419, 17666, 18166, 18611, 19004, 19095, 19298, 19397, 4, 16, 69, 77, 97, 98, 99, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 140, 150, 158, 169, 176, 194, 199, 210, 216, 222, 226, 242, 256, 266, 283, 294, 108, 105, 103, 5, 198, 1, 59, 148, 1, 198, 80, 5, 38, 1, 59, 156, 1, 38, 99, 117, 116, 101, 5, 193, 1, 59, 167, 1, 193, 114, 101, 118, 101, 59, 1, 258, 4, 2, 105, 121, 182, 191, 114, 99, 5, 194, 1, 59, 189, 1, 194, 59, 1, 1040, 114, 59, 3, 55349, 56580, 114, 97, 118, 101, 5, 192, 1, 59, 208, 1, 192, 112, 104, 97, 59, 1, 913, 97, 99, 114, 59, 1, 256, 100, 59, 1, 10835, 4, 2, 103, 112, 232, 237, 111, 110, 59, 1, 260, 102, 59, 3, 55349, 56632, 112, 108, 121, 70, 117, 110, 99, 116, 105, 111, 110, 59, 1, 8289, 105, 110, 103, 5, 197, 1, 59, 264, 1, 197, 4, 2, 99, 115, 272, 277, 114, 59, 3, 55349, 56476, 105, 103, 110, 59, 1, 8788, 105, 108, 100, 101, 5, 195, 1, 59, 292, 1, 195, 109, 108, 5, 196, 1, 59, 301, 1, 196, 4, 8, 97, 99, 101, 102, 111, 114, 115, 117, 321, 350, 354, 383, 388, 394, 400, 405, 4, 2, 99, 114, 327, 336, 107, 115, 108, 97, 115, 104, 59, 1, 8726, 4, 2, 118, 119, 342, 345, 59, 1, 10983, 101, 100, 59, 1, 8966, 121, 59, 1, 1041, 4, 3, 99, 114, 116, 362, 369, 379, 97, 117, 115, 101, 59, 1, 8757, 110, 111, 117, 108, 108, 105, 115, 59, 1, 8492, 97, 59, 1, 914, 114, 59, 3, 55349, 56581, 112, 102, 59, 3, 55349, 56633, 101, 118, 101, 59, 1, 728, 99, 114, 59, 1, 8492, 109, 112, 101, 113, 59, 1, 8782, 4, 14, 72, 79, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 117, 442, 447, 456, 504, 542, 547, 569, 573, 577, 616, 678, 784, 790, 796, 99, 121, 59, 1, 1063, 80, 89, 5, 169, 1, 59, 454, 1, 169, 4, 3, 99, 112, 121, 464, 470, 497, 117, 116, 101, 59, 1, 262, 4, 2, 59, 105, 476, 478, 1, 8914, 116, 97, 108, 68, 105, 102, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8517, 108, 101, 121, 115, 59, 1, 8493, 4, 4, 97, 101, 105, 111, 514, 520, 530, 535, 114, 111, 110, 59, 1, 268, 100, 105, 108, 5, 199, 1, 59, 528, 1, 199, 114, 99, 59, 1, 264, 110, 105, 110, 116, 59, 1, 8752, 111, 116, 59, 1, 266, 4, 2, 100, 110, 553, 560, 105, 108, 108, 97, 59, 1, 184, 116, 101, 114, 68, 111, 116, 59, 1, 183, 114, 59, 1, 8493, 105, 59, 1, 935, 114, 99, 108, 101, 4, 4, 68, 77, 80, 84, 591, 596, 603, 609, 111, 116, 59, 1, 8857, 105, 110, 117, 115, 59, 1, 8854, 108, 117, 115, 59, 1, 8853, 105, 109, 101, 115, 59, 1, 8855, 111, 4, 2, 99, 115, 623, 646, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8754, 101, 67, 117, 114, 108, 121, 4, 2, 68, 81, 658, 671, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8221, 117, 111, 116, 101, 59, 1, 8217, 4, 4, 108, 110, 112, 117, 688, 701, 736, 753, 111, 110, 4, 2, 59, 101, 696, 698, 1, 8759, 59, 1, 10868, 4, 3, 103, 105, 116, 709, 717, 722, 114, 117, 101, 110, 116, 59, 1, 8801, 110, 116, 59, 1, 8751, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8750, 4, 2, 102, 114, 742, 745, 59, 1, 8450, 111, 100, 117, 99, 116, 59, 1, 8720, 110, 116, 101, 114, 67, 108, 111, 99, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8755, 111, 115, 115, 59, 1, 10799, 99, 114, 59, 3, 55349, 56478, 112, 4, 2, 59, 67, 803, 805, 1, 8915, 97, 112, 59, 1, 8781, 4, 11, 68, 74, 83, 90, 97, 99, 101, 102, 105, 111, 115, 834, 850, 855, 860, 865, 888, 903, 916, 921, 1011, 1415, 4, 2, 59, 111, 840, 842, 1, 8517, 116, 114, 97, 104, 100, 59, 1, 10513, 99, 121, 59, 1, 1026, 99, 121, 59, 1, 1029, 99, 121, 59, 1, 1039, 4, 3, 103, 114, 115, 873, 879, 883, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8609, 104, 118, 59, 1, 10980, 4, 2, 97, 121, 894, 900, 114, 111, 110, 59, 1, 270, 59, 1, 1044, 108, 4, 2, 59, 116, 910, 912, 1, 8711, 97, 59, 1, 916, 114, 59, 3, 55349, 56583, 4, 2, 97, 102, 927, 998, 4, 2, 99, 109, 933, 992, 114, 105, 116, 105, 99, 97, 108, 4, 4, 65, 68, 71, 84, 950, 957, 978, 985, 99, 117, 116, 101, 59, 1, 180, 111, 4, 2, 116, 117, 964, 967, 59, 1, 729, 98, 108, 101, 65, 99, 117, 116, 101, 59, 1, 733, 114, 97, 118, 101, 59, 1, 96, 105, 108, 100, 101, 59, 1, 732, 111, 110, 100, 59, 1, 8900, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8518, 4, 4, 112, 116, 117, 119, 1021, 1026, 1048, 1249, 102, 59, 3, 55349, 56635, 4, 3, 59, 68, 69, 1034, 1036, 1041, 1, 168, 111, 116, 59, 1, 8412, 113, 117, 97, 108, 59, 1, 8784, 98, 108, 101, 4, 6, 67, 68, 76, 82, 85, 86, 1065, 1082, 1101, 1189, 1211, 1236, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8751, 111, 4, 2, 116, 119, 1089, 1092, 59, 1, 168, 110, 65, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 101, 111, 1107, 1141, 102, 116, 4, 3, 65, 82, 84, 1117, 1124, 1136, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8660, 101, 101, 59, 1, 10980, 110, 103, 4, 2, 76, 82, 1149, 1177, 101, 102, 116, 4, 2, 65, 82, 1158, 1165, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10233, 105, 103, 104, 116, 4, 2, 65, 84, 1199, 1206, 114, 114, 111, 119, 59, 1, 8658, 101, 101, 59, 1, 8872, 112, 4, 2, 65, 68, 1218, 1225, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8741, 110, 4, 6, 65, 66, 76, 82, 84, 97, 1264, 1292, 1299, 1352, 1391, 1408, 114, 114, 111, 119, 4, 3, 59, 66, 85, 1276, 1278, 1283, 1, 8595, 97, 114, 59, 1, 10515, 112, 65, 114, 114, 111, 119, 59, 1, 8693, 114, 101, 118, 101, 59, 1, 785, 101, 102, 116, 4, 3, 82, 84, 86, 1310, 1323, 1334, 105, 103, 104, 116, 86, 101, 99, 116, 111, 114, 59, 1, 10576, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10590, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1345, 1347, 1, 8637, 97, 114, 59, 1, 10582, 105, 103, 104, 116, 4, 2, 84, 86, 1362, 1373, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10591, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1384, 1386, 1, 8641, 97, 114, 59, 1, 10583, 101, 101, 4, 2, 59, 65, 1399, 1401, 1, 8868, 114, 114, 111, 119, 59, 1, 8615, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 99, 116, 1421, 1426, 114, 59, 3, 55349, 56479, 114, 111, 107, 59, 1, 272, 4, 16, 78, 84, 97, 99, 100, 102, 103, 108, 109, 111, 112, 113, 115, 116, 117, 120, 1466, 1470, 1478, 1489, 1515, 1520, 1525, 1536, 1544, 1593, 1609, 1617, 1650, 1664, 1668, 1677, 71, 59, 1, 330, 72, 5, 208, 1, 59, 1476, 1, 208, 99, 117, 116, 101, 5, 201, 1, 59, 1487, 1, 201, 4, 3, 97, 105, 121, 1497, 1503, 1512, 114, 111, 110, 59, 1, 282, 114, 99, 5, 202, 1, 59, 1510, 1, 202, 59, 1, 1069, 111, 116, 59, 1, 278, 114, 59, 3, 55349, 56584, 114, 97, 118, 101, 5, 200, 1, 59, 1534, 1, 200, 101, 109, 101, 110, 116, 59, 1, 8712, 4, 2, 97, 112, 1550, 1555, 99, 114, 59, 1, 274, 116, 121, 4, 2, 83, 86, 1563, 1576, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9723, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9643, 4, 2, 103, 112, 1599, 1604, 111, 110, 59, 1, 280, 102, 59, 3, 55349, 56636, 115, 105, 108, 111, 110, 59, 1, 917, 117, 4, 2, 97, 105, 1624, 1640, 108, 4, 2, 59, 84, 1631, 1633, 1, 10869, 105, 108, 100, 101, 59, 1, 8770, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8652, 4, 2, 99, 105, 1656, 1660, 114, 59, 1, 8496, 109, 59, 1, 10867, 97, 59, 1, 919, 109, 108, 5, 203, 1, 59, 1675, 1, 203, 4, 2, 105, 112, 1683, 1689, 115, 116, 115, 59, 1, 8707, 111, 110, 101, 110, 116, 105, 97, 108, 69, 59, 1, 8519, 4, 5, 99, 102, 105, 111, 115, 1713, 1717, 1722, 1762, 1791, 121, 59, 1, 1060, 114, 59, 3, 55349, 56585, 108, 108, 101, 100, 4, 2, 83, 86, 1732, 1745, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9724, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9642, 4, 3, 112, 114, 117, 1770, 1775, 1781, 102, 59, 3, 55349, 56637, 65, 108, 108, 59, 1, 8704, 114, 105, 101, 114, 116, 114, 102, 59, 1, 8497, 99, 114, 59, 1, 8497, 4, 12, 74, 84, 97, 98, 99, 100, 102, 103, 111, 114, 115, 116, 1822, 1827, 1834, 1848, 1855, 1877, 1882, 1887, 1890, 1896, 1978, 1984, 99, 121, 59, 1, 1027, 5, 62, 1, 59, 1832, 1, 62, 109, 109, 97, 4, 2, 59, 100, 1843, 1845, 1, 915, 59, 1, 988, 114, 101, 118, 101, 59, 1, 286, 4, 3, 101, 105, 121, 1863, 1869, 1874, 100, 105, 108, 59, 1, 290, 114, 99, 59, 1, 284, 59, 1, 1043, 111, 116, 59, 1, 288, 114, 59, 3, 55349, 56586, 59, 1, 8921, 112, 102, 59, 3, 55349, 56638, 101, 97, 116, 101, 114, 4, 6, 69, 70, 71, 76, 83, 84, 1915, 1933, 1944, 1953, 1959, 1971, 113, 117, 97, 108, 4, 2, 59, 76, 1925, 1927, 1, 8805, 101, 115, 115, 59, 1, 8923, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8807, 114, 101, 97, 116, 101, 114, 59, 1, 10914, 101, 115, 115, 59, 1, 8823, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10878, 105, 108, 100, 101, 59, 1, 8819, 99, 114, 59, 3, 55349, 56482, 59, 1, 8811, 4, 8, 65, 97, 99, 102, 105, 111, 115, 117, 2005, 2012, 2026, 2032, 2036, 2049, 2073, 2089, 82, 68, 99, 121, 59, 1, 1066, 4, 2, 99, 116, 2018, 2023, 101, 107, 59, 1, 711, 59, 1, 94, 105, 114, 99, 59, 1, 292, 114, 59, 1, 8460, 108, 98, 101, 114, 116, 83, 112, 97, 99, 101, 59, 1, 8459, 4, 2, 112, 114, 2055, 2059, 102, 59, 1, 8461, 105, 122, 111, 110, 116, 97, 108, 76, 105, 110, 101, 59, 1, 9472, 4, 2, 99, 116, 2079, 2083, 114, 59, 1, 8459, 114, 111, 107, 59, 1, 294, 109, 112, 4, 2, 68, 69, 2097, 2107, 111, 119, 110, 72, 117, 109, 112, 59, 1, 8782, 113, 117, 97, 108, 59, 1, 8783, 4, 14, 69, 74, 79, 97, 99, 100, 102, 103, 109, 110, 111, 115, 116, 117, 2144, 2149, 2155, 2160, 2171, 2189, 2194, 2198, 2209, 2245, 2307, 2329, 2334, 2341, 99, 121, 59, 1, 1045, 108, 105, 103, 59, 1, 306, 99, 121, 59, 1, 1025, 99, 117, 116, 101, 5, 205, 1, 59, 2169, 1, 205, 4, 2, 105, 121, 2177, 2186, 114, 99, 5, 206, 1, 59, 2184, 1, 206, 59, 1, 1048, 111, 116, 59, 1, 304, 114, 59, 1, 8465, 114, 97, 118, 101, 5, 204, 1, 59, 2207, 1, 204, 4, 3, 59, 97, 112, 2217, 2219, 2238, 1, 8465, 4, 2, 99, 103, 2225, 2229, 114, 59, 1, 298, 105, 110, 97, 114, 121, 73, 59, 1, 8520, 108, 105, 101, 115, 59, 1, 8658, 4, 2, 116, 118, 2251, 2281, 4, 2, 59, 101, 2257, 2259, 1, 8748, 4, 2, 103, 114, 2265, 2271, 114, 97, 108, 59, 1, 8747, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8898, 105, 115, 105, 98, 108, 101, 4, 2, 67, 84, 2293, 2300, 111, 109, 109, 97, 59, 1, 8291, 105, 109, 101, 115, 59, 1, 8290, 4, 3, 103, 112, 116, 2315, 2320, 2325, 111, 110, 59, 1, 302, 102, 59, 3, 55349, 56640, 97, 59, 1, 921, 99, 114, 59, 1, 8464, 105, 108, 100, 101, 59, 1, 296, 4, 2, 107, 109, 2347, 2352, 99, 121, 59, 1, 1030, 108, 5, 207, 1, 59, 2358, 1, 207, 4, 5, 99, 102, 111, 115, 117, 2372, 2386, 2391, 2397, 2414, 4, 2, 105, 121, 2378, 2383, 114, 99, 59, 1, 308, 59, 1, 1049, 114, 59, 3, 55349, 56589, 112, 102, 59, 3, 55349, 56641, 4, 2, 99, 101, 2403, 2408, 114, 59, 3, 55349, 56485, 114, 99, 121, 59, 1, 1032, 107, 99, 121, 59, 1, 1028, 4, 7, 72, 74, 97, 99, 102, 111, 115, 2436, 2441, 2446, 2452, 2467, 2472, 2478, 99, 121, 59, 1, 1061, 99, 121, 59, 1, 1036, 112, 112, 97, 59, 1, 922, 4, 2, 101, 121, 2458, 2464, 100, 105, 108, 59, 1, 310, 59, 1, 1050, 114, 59, 3, 55349, 56590, 112, 102, 59, 3, 55349, 56642, 99, 114, 59, 3, 55349, 56486, 4, 11, 74, 84, 97, 99, 101, 102, 108, 109, 111, 115, 116, 2508, 2513, 2520, 2562, 2585, 2981, 2986, 3004, 3011, 3146, 3167, 99, 121, 59, 1, 1033, 5, 60, 1, 59, 2518, 1, 60, 4, 5, 99, 109, 110, 112, 114, 2532, 2538, 2544, 2548, 2558, 117, 116, 101, 59, 1, 313, 98, 100, 97, 59, 1, 923, 103, 59, 1, 10218, 108, 97, 99, 101, 116, 114, 102, 59, 1, 8466, 114, 59, 1, 8606, 4, 3, 97, 101, 121, 2570, 2576, 2582, 114, 111, 110, 59, 1, 317, 100, 105, 108, 59, 1, 315, 59, 1, 1051, 4, 2, 102, 115, 2591, 2907, 116, 4, 10, 65, 67, 68, 70, 82, 84, 85, 86, 97, 114, 2614, 2663, 2672, 2728, 2735, 2760, 2820, 2870, 2888, 2895, 4, 2, 110, 114, 2620, 2633, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10216, 114, 111, 119, 4, 3, 59, 66, 82, 2644, 2646, 2651, 1, 8592, 97, 114, 59, 1, 8676, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8646, 101, 105, 108, 105, 110, 103, 59, 1, 8968, 111, 4, 2, 117, 119, 2679, 2692, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10214, 110, 4, 2, 84, 86, 2699, 2710, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10593, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2721, 2723, 1, 8643, 97, 114, 59, 1, 10585, 108, 111, 111, 114, 59, 1, 8970, 105, 103, 104, 116, 4, 2, 65, 86, 2745, 2752, 114, 114, 111, 119, 59, 1, 8596, 101, 99, 116, 111, 114, 59, 1, 10574, 4, 2, 101, 114, 2766, 2792, 101, 4, 3, 59, 65, 86, 2775, 2777, 2784, 1, 8867, 114, 114, 111, 119, 59, 1, 8612, 101, 99, 116, 111, 114, 59, 1, 10586, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 2806, 2808, 2813, 1, 8882, 97, 114, 59, 1, 10703, 113, 117, 97, 108, 59, 1, 8884, 112, 4, 3, 68, 84, 86, 2829, 2841, 2852, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10577, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10592, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2863, 2865, 1, 8639, 97, 114, 59, 1, 10584, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2881, 2883, 1, 8636, 97, 114, 59, 1, 10578, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8660, 115, 4, 6, 69, 70, 71, 76, 83, 84, 2922, 2936, 2947, 2956, 2962, 2974, 113, 117, 97, 108, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8922, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8806, 114, 101, 97, 116, 101, 114, 59, 1, 8822, 101, 115, 115, 59, 1, 10913, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10877, 105, 108, 100, 101, 59, 1, 8818, 114, 59, 3, 55349, 56591, 4, 2, 59, 101, 2992, 2994, 1, 8920, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8666, 105, 100, 111, 116, 59, 1, 319, 4, 3, 110, 112, 119, 3019, 3110, 3115, 103, 4, 4, 76, 82, 108, 114, 3030, 3058, 3070, 3098, 101, 102, 116, 4, 2, 65, 82, 3039, 3046, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10231, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10230, 101, 102, 116, 4, 2, 97, 114, 3079, 3086, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10233, 102, 59, 3, 55349, 56643, 101, 114, 4, 2, 76, 82, 3123, 3134, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8601, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8600, 4, 3, 99, 104, 116, 3154, 3158, 3161, 114, 59, 1, 8466, 59, 1, 8624, 114, 111, 107, 59, 1, 321, 59, 1, 8810, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 3188, 3192, 3196, 3222, 3227, 3237, 3243, 3248, 112, 59, 1, 10501, 121, 59, 1, 1052, 4, 2, 100, 108, 3202, 3213, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8287, 108, 105, 110, 116, 114, 102, 59, 1, 8499, 114, 59, 3, 55349, 56592, 110, 117, 115, 80, 108, 117, 115, 59, 1, 8723, 112, 102, 59, 3, 55349, 56644, 99, 114, 59, 1, 8499, 59, 1, 924, 4, 9, 74, 97, 99, 101, 102, 111, 115, 116, 117, 3271, 3276, 3283, 3306, 3422, 3427, 4120, 4126, 4137, 99, 121, 59, 1, 1034, 99, 117, 116, 101, 59, 1, 323, 4, 3, 97, 101, 121, 3291, 3297, 3303, 114, 111, 110, 59, 1, 327, 100, 105, 108, 59, 1, 325, 59, 1, 1053, 4, 3, 103, 115, 119, 3314, 3380, 3415, 97, 116, 105, 118, 101, 4, 3, 77, 84, 86, 3327, 3340, 3365, 101, 100, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8203, 104, 105, 4, 2, 99, 110, 3348, 3357, 107, 83, 112, 97, 99, 101, 59, 1, 8203, 83, 112, 97, 99, 101, 59, 1, 8203, 101, 114, 121, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8203, 116, 101, 100, 4, 2, 71, 76, 3389, 3405, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8811, 101, 115, 115, 76, 101, 115, 115, 59, 1, 8810, 76, 105, 110, 101, 59, 1, 10, 114, 59, 3, 55349, 56593, 4, 4, 66, 110, 112, 116, 3437, 3444, 3460, 3464, 114, 101, 97, 107, 59, 1, 8288, 66, 114, 101, 97, 107, 105, 110, 103, 83, 112, 97, 99, 101, 59, 1, 160, 102, 59, 1, 8469, 4, 13, 59, 67, 68, 69, 71, 72, 76, 78, 80, 82, 83, 84, 86, 3492, 3494, 3517, 3536, 3578, 3657, 3685, 3784, 3823, 3860, 3915, 4066, 4107, 1, 10988, 4, 2, 111, 117, 3500, 3510, 110, 103, 114, 117, 101, 110, 116, 59, 1, 8802, 112, 67, 97, 112, 59, 1, 8813, 111, 117, 98, 108, 101, 86, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8742, 4, 3, 108, 113, 120, 3544, 3552, 3571, 101, 109, 101, 110, 116, 59, 1, 8713, 117, 97, 108, 4, 2, 59, 84, 3561, 3563, 1, 8800, 105, 108, 100, 101, 59, 3, 8770, 824, 105, 115, 116, 115, 59, 1, 8708, 114, 101, 97, 116, 101, 114, 4, 7, 59, 69, 70, 71, 76, 83, 84, 3600, 3602, 3609, 3621, 3631, 3637, 3650, 1, 8815, 113, 117, 97, 108, 59, 1, 8817, 117, 108, 108, 69, 113, 117, 97, 108, 59, 3, 8807, 824, 114, 101, 97, 116, 101, 114, 59, 3, 8811, 824, 101, 115, 115, 59, 1, 8825, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10878, 824, 105, 108, 100, 101, 59, 1, 8821, 117, 109, 112, 4, 2, 68, 69, 3666, 3677, 111, 119, 110, 72, 117, 109, 112, 59, 3, 8782, 824, 113, 117, 97, 108, 59, 3, 8783, 824, 101, 4, 2, 102, 115, 3692, 3724, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3709, 3711, 3717, 1, 8938, 97, 114, 59, 3, 10703, 824, 113, 117, 97, 108, 59, 1, 8940, 115, 4, 6, 59, 69, 71, 76, 83, 84, 3739, 3741, 3748, 3757, 3764, 3777, 1, 8814, 113, 117, 97, 108, 59, 1, 8816, 114, 101, 97, 116, 101, 114, 59, 1, 8824, 101, 115, 115, 59, 3, 8810, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10877, 824, 105, 108, 100, 101, 59, 1, 8820, 101, 115, 116, 101, 100, 4, 2, 71, 76, 3795, 3812, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 3, 10914, 824, 101, 115, 115, 76, 101, 115, 115, 59, 3, 10913, 824, 114, 101, 99, 101, 100, 101, 115, 4, 3, 59, 69, 83, 3838, 3840, 3848, 1, 8832, 113, 117, 97, 108, 59, 3, 10927, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8928, 4, 2, 101, 105, 3866, 3881, 118, 101, 114, 115, 101, 69, 108, 101, 109, 101, 110, 116, 59, 1, 8716, 103, 104, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3900, 3902, 3908, 1, 8939, 97, 114, 59, 3, 10704, 824, 113, 117, 97, 108, 59, 1, 8941, 4, 2, 113, 117, 3921, 3973, 117, 97, 114, 101, 83, 117, 4, 2, 98, 112, 3933, 3952, 115, 101, 116, 4, 2, 59, 69, 3942, 3945, 3, 8847, 824, 113, 117, 97, 108, 59, 1, 8930, 101, 114, 115, 101, 116, 4, 2, 59, 69, 3963, 3966, 3, 8848, 824, 113, 117, 97, 108, 59, 1, 8931, 4, 3, 98, 99, 112, 3981, 4e3, 4045, 115, 101, 116, 4, 2, 59, 69, 3990, 3993, 3, 8834, 8402, 113, 117, 97, 108, 59, 1, 8840, 99, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 4015, 4017, 4025, 4037, 1, 8833, 113, 117, 97, 108, 59, 3, 10928, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8929, 105, 108, 100, 101, 59, 3, 8831, 824, 101, 114, 115, 101, 116, 4, 2, 59, 69, 4056, 4059, 3, 8835, 8402, 113, 117, 97, 108, 59, 1, 8841, 105, 108, 100, 101, 4, 4, 59, 69, 70, 84, 4080, 4082, 4089, 4100, 1, 8769, 113, 117, 97, 108, 59, 1, 8772, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8775, 105, 108, 100, 101, 59, 1, 8777, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8740, 99, 114, 59, 3, 55349, 56489, 105, 108, 100, 101, 5, 209, 1, 59, 4135, 1, 209, 59, 1, 925, 4, 14, 69, 97, 99, 100, 102, 103, 109, 111, 112, 114, 115, 116, 117, 118, 4170, 4176, 4187, 4205, 4212, 4217, 4228, 4253, 4259, 4292, 4295, 4316, 4337, 4346, 108, 105, 103, 59, 1, 338, 99, 117, 116, 101, 5, 211, 1, 59, 4185, 1, 211, 4, 2, 105, 121, 4193, 4202, 114, 99, 5, 212, 1, 59, 4200, 1, 212, 59, 1, 1054, 98, 108, 97, 99, 59, 1, 336, 114, 59, 3, 55349, 56594, 114, 97, 118, 101, 5, 210, 1, 59, 4226, 1, 210, 4, 3, 97, 101, 105, 4236, 4241, 4246, 99, 114, 59, 1, 332, 103, 97, 59, 1, 937, 99, 114, 111, 110, 59, 1, 927, 112, 102, 59, 3, 55349, 56646, 101, 110, 67, 117, 114, 108, 121, 4, 2, 68, 81, 4272, 4285, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8220, 117, 111, 116, 101, 59, 1, 8216, 59, 1, 10836, 4, 2, 99, 108, 4301, 4306, 114, 59, 3, 55349, 56490, 97, 115, 104, 5, 216, 1, 59, 4314, 1, 216, 105, 4, 2, 108, 109, 4323, 4332, 100, 101, 5, 213, 1, 59, 4330, 1, 213, 101, 115, 59, 1, 10807, 109, 108, 5, 214, 1, 59, 4344, 1, 214, 101, 114, 4, 2, 66, 80, 4354, 4380, 4, 2, 97, 114, 4360, 4364, 114, 59, 1, 8254, 97, 99, 4, 2, 101, 107, 4372, 4375, 59, 1, 9182, 101, 116, 59, 1, 9140, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9180, 4, 9, 97, 99, 102, 104, 105, 108, 111, 114, 115, 4413, 4422, 4426, 4431, 4435, 4438, 4448, 4471, 4561, 114, 116, 105, 97, 108, 68, 59, 1, 8706, 121, 59, 1, 1055, 114, 59, 3, 55349, 56595, 105, 59, 1, 934, 59, 1, 928, 117, 115, 77, 105, 110, 117, 115, 59, 1, 177, 4, 2, 105, 112, 4454, 4467, 110, 99, 97, 114, 101, 112, 108, 97, 110, 101, 59, 1, 8460, 102, 59, 1, 8473, 4, 4, 59, 101, 105, 111, 4481, 4483, 4526, 4531, 1, 10939, 99, 101, 100, 101, 115, 4, 4, 59, 69, 83, 84, 4498, 4500, 4507, 4519, 1, 8826, 113, 117, 97, 108, 59, 1, 10927, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8828, 105, 108, 100, 101, 59, 1, 8830, 109, 101, 59, 1, 8243, 4, 2, 100, 112, 4537, 4543, 117, 99, 116, 59, 1, 8719, 111, 114, 116, 105, 111, 110, 4, 2, 59, 97, 4555, 4557, 1, 8759, 108, 59, 1, 8733, 4, 2, 99, 105, 4567, 4572, 114, 59, 3, 55349, 56491, 59, 1, 936, 4, 4, 85, 102, 111, 115, 4585, 4594, 4599, 4604, 79, 84, 5, 34, 1, 59, 4592, 1, 34, 114, 59, 3, 55349, 56596, 112, 102, 59, 1, 8474, 99, 114, 59, 3, 55349, 56492, 4, 12, 66, 69, 97, 99, 101, 102, 104, 105, 111, 114, 115, 117, 4636, 4642, 4650, 4681, 4704, 4763, 4767, 4771, 5047, 5069, 5081, 5094, 97, 114, 114, 59, 1, 10512, 71, 5, 174, 1, 59, 4648, 1, 174, 4, 3, 99, 110, 114, 4658, 4664, 4668, 117, 116, 101, 59, 1, 340, 103, 59, 1, 10219, 114, 4, 2, 59, 116, 4675, 4677, 1, 8608, 108, 59, 1, 10518, 4, 3, 97, 101, 121, 4689, 4695, 4701, 114, 111, 110, 59, 1, 344, 100, 105, 108, 59, 1, 342, 59, 1, 1056, 4, 2, 59, 118, 4710, 4712, 1, 8476, 101, 114, 115, 101, 4, 2, 69, 85, 4722, 4748, 4, 2, 108, 113, 4728, 4736, 101, 109, 101, 110, 116, 59, 1, 8715, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8651, 112, 69, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10607, 114, 59, 1, 8476, 111, 59, 1, 929, 103, 104, 116, 4, 8, 65, 67, 68, 70, 84, 85, 86, 97, 4792, 4840, 4849, 4905, 4912, 4972, 5022, 5040, 4, 2, 110, 114, 4798, 4811, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10217, 114, 111, 119, 4, 3, 59, 66, 76, 4822, 4824, 4829, 1, 8594, 97, 114, 59, 1, 8677, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8644, 101, 105, 108, 105, 110, 103, 59, 1, 8969, 111, 4, 2, 117, 119, 4856, 4869, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10215, 110, 4, 2, 84, 86, 4876, 4887, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10589, 101, 99, 116, 111, 114, 4, 2, 59, 66, 4898, 4900, 1, 8642, 97, 114, 59, 1, 10581, 108, 111, 111, 114, 59, 1, 8971, 4, 2, 101, 114, 4918, 4944, 101, 4, 3, 59, 65, 86, 4927, 4929, 4936, 1, 8866, 114, 114, 111, 119, 59, 1, 8614, 101, 99, 116, 111, 114, 59, 1, 10587, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 4958, 4960, 4965, 1, 8883, 97, 114, 59, 1, 10704, 113, 117, 97, 108, 59, 1, 8885, 112, 4, 3, 68, 84, 86, 4981, 4993, 5004, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10575, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10588, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5015, 5017, 1, 8638, 97, 114, 59, 1, 10580, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5033, 5035, 1, 8640, 97, 114, 59, 1, 10579, 114, 114, 111, 119, 59, 1, 8658, 4, 2, 112, 117, 5053, 5057, 102, 59, 1, 8477, 110, 100, 73, 109, 112, 108, 105, 101, 115, 59, 1, 10608, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8667, 4, 2, 99, 104, 5087, 5091, 114, 59, 1, 8475, 59, 1, 8625, 108, 101, 68, 101, 108, 97, 121, 101, 100, 59, 1, 10740, 4, 13, 72, 79, 97, 99, 102, 104, 105, 109, 111, 113, 115, 116, 117, 5134, 5150, 5157, 5164, 5198, 5203, 5259, 5265, 5277, 5283, 5374, 5380, 5385, 4, 2, 67, 99, 5140, 5146, 72, 99, 121, 59, 1, 1065, 121, 59, 1, 1064, 70, 84, 99, 121, 59, 1, 1068, 99, 117, 116, 101, 59, 1, 346, 4, 5, 59, 97, 101, 105, 121, 5176, 5178, 5184, 5190, 5195, 1, 10940, 114, 111, 110, 59, 1, 352, 100, 105, 108, 59, 1, 350, 114, 99, 59, 1, 348, 59, 1, 1057, 114, 59, 3, 55349, 56598, 111, 114, 116, 4, 4, 68, 76, 82, 85, 5216, 5227, 5238, 5250, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8595, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8592, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8594, 112, 65, 114, 114, 111, 119, 59, 1, 8593, 103, 109, 97, 59, 1, 931, 97, 108, 108, 67, 105, 114, 99, 108, 101, 59, 1, 8728, 112, 102, 59, 3, 55349, 56650, 4, 2, 114, 117, 5289, 5293, 116, 59, 1, 8730, 97, 114, 101, 4, 4, 59, 73, 83, 85, 5306, 5308, 5322, 5367, 1, 9633, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8851, 117, 4, 2, 98, 112, 5329, 5347, 115, 101, 116, 4, 2, 59, 69, 5338, 5340, 1, 8847, 113, 117, 97, 108, 59, 1, 8849, 101, 114, 115, 101, 116, 4, 2, 59, 69, 5358, 5360, 1, 8848, 113, 117, 97, 108, 59, 1, 8850, 110, 105, 111, 110, 59, 1, 8852, 99, 114, 59, 3, 55349, 56494, 97, 114, 59, 1, 8902, 4, 4, 98, 99, 109, 112, 5395, 5420, 5475, 5478, 4, 2, 59, 115, 5401, 5403, 1, 8912, 101, 116, 4, 2, 59, 69, 5411, 5413, 1, 8912, 113, 117, 97, 108, 59, 1, 8838, 4, 2, 99, 104, 5426, 5468, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 5440, 5442, 5449, 5461, 1, 8827, 113, 117, 97, 108, 59, 1, 10928, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8829, 105, 108, 100, 101, 59, 1, 8831, 84, 104, 97, 116, 59, 1, 8715, 59, 1, 8721, 4, 3, 59, 101, 115, 5486, 5488, 5507, 1, 8913, 114, 115, 101, 116, 4, 2, 59, 69, 5498, 5500, 1, 8835, 113, 117, 97, 108, 59, 1, 8839, 101, 116, 59, 1, 8913, 4, 11, 72, 82, 83, 97, 99, 102, 104, 105, 111, 114, 115, 5536, 5546, 5552, 5567, 5579, 5602, 5607, 5655, 5695, 5701, 5711, 79, 82, 78, 5, 222, 1, 59, 5544, 1, 222, 65, 68, 69, 59, 1, 8482, 4, 2, 72, 99, 5558, 5563, 99, 121, 59, 1, 1035, 121, 59, 1, 1062, 4, 2, 98, 117, 5573, 5576, 59, 1, 9, 59, 1, 932, 4, 3, 97, 101, 121, 5587, 5593, 5599, 114, 111, 110, 59, 1, 356, 100, 105, 108, 59, 1, 354, 59, 1, 1058, 114, 59, 3, 55349, 56599, 4, 2, 101, 105, 5613, 5631, 4, 2, 114, 116, 5619, 5627, 101, 102, 111, 114, 101, 59, 1, 8756, 97, 59, 1, 920, 4, 2, 99, 110, 5637, 5647, 107, 83, 112, 97, 99, 101, 59, 3, 8287, 8202, 83, 112, 97, 99, 101, 59, 1, 8201, 108, 100, 101, 4, 4, 59, 69, 70, 84, 5668, 5670, 5677, 5688, 1, 8764, 113, 117, 97, 108, 59, 1, 8771, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8773, 105, 108, 100, 101, 59, 1, 8776, 112, 102, 59, 3, 55349, 56651, 105, 112, 108, 101, 68, 111, 116, 59, 1, 8411, 4, 2, 99, 116, 5717, 5722, 114, 59, 3, 55349, 56495, 114, 111, 107, 59, 1, 358, 4, 14, 97, 98, 99, 100, 102, 103, 109, 110, 111, 112, 114, 115, 116, 117, 5758, 5789, 5805, 5823, 5830, 5835, 5846, 5852, 5921, 5937, 6089, 6095, 6101, 6108, 4, 2, 99, 114, 5764, 5774, 117, 116, 101, 5, 218, 1, 59, 5772, 1, 218, 114, 4, 2, 59, 111, 5781, 5783, 1, 8607, 99, 105, 114, 59, 1, 10569, 114, 4, 2, 99, 101, 5796, 5800, 121, 59, 1, 1038, 118, 101, 59, 1, 364, 4, 2, 105, 121, 5811, 5820, 114, 99, 5, 219, 1, 59, 5818, 1, 219, 59, 1, 1059, 98, 108, 97, 99, 59, 1, 368, 114, 59, 3, 55349, 56600, 114, 97, 118, 101, 5, 217, 1, 59, 5844, 1, 217, 97, 99, 114, 59, 1, 362, 4, 2, 100, 105, 5858, 5905, 101, 114, 4, 2, 66, 80, 5866, 5892, 4, 2, 97, 114, 5872, 5876, 114, 59, 1, 95, 97, 99, 4, 2, 101, 107, 5884, 5887, 59, 1, 9183, 101, 116, 59, 1, 9141, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9181, 111, 110, 4, 2, 59, 80, 5913, 5915, 1, 8899, 108, 117, 115, 59, 1, 8846, 4, 2, 103, 112, 5927, 5932, 111, 110, 59, 1, 370, 102, 59, 3, 55349, 56652, 4, 8, 65, 68, 69, 84, 97, 100, 112, 115, 5955, 5985, 5996, 6009, 6026, 6033, 6044, 6075, 114, 114, 111, 119, 4, 3, 59, 66, 68, 5967, 5969, 5974, 1, 8593, 97, 114, 59, 1, 10514, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8645, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8597, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10606, 101, 101, 4, 2, 59, 65, 6017, 6019, 1, 8869, 114, 114, 111, 119, 59, 1, 8613, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 4, 2, 76, 82, 6052, 6063, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8598, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8599, 105, 4, 2, 59, 108, 6082, 6084, 1, 978, 111, 110, 59, 1, 933, 105, 110, 103, 59, 1, 366, 99, 114, 59, 3, 55349, 56496, 105, 108, 100, 101, 59, 1, 360, 109, 108, 5, 220, 1, 59, 6115, 1, 220, 4, 9, 68, 98, 99, 100, 101, 102, 111, 115, 118, 6137, 6143, 6148, 6152, 6166, 6250, 6255, 6261, 6267, 97, 115, 104, 59, 1, 8875, 97, 114, 59, 1, 10987, 121, 59, 1, 1042, 97, 115, 104, 4, 2, 59, 108, 6161, 6163, 1, 8873, 59, 1, 10982, 4, 2, 101, 114, 6172, 6175, 59, 1, 8897, 4, 3, 98, 116, 121, 6183, 6188, 6238, 97, 114, 59, 1, 8214, 4, 2, 59, 105, 6194, 6196, 1, 8214, 99, 97, 108, 4, 4, 66, 76, 83, 84, 6209, 6214, 6220, 6231, 97, 114, 59, 1, 8739, 105, 110, 101, 59, 1, 124, 101, 112, 97, 114, 97, 116, 111, 114, 59, 1, 10072, 105, 108, 100, 101, 59, 1, 8768, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8202, 114, 59, 3, 55349, 56601, 112, 102, 59, 3, 55349, 56653, 99, 114, 59, 3, 55349, 56497, 100, 97, 115, 104, 59, 1, 8874, 4, 5, 99, 101, 102, 111, 115, 6286, 6292, 6298, 6303, 6309, 105, 114, 99, 59, 1, 372, 100, 103, 101, 59, 1, 8896, 114, 59, 3, 55349, 56602, 112, 102, 59, 3, 55349, 56654, 99, 114, 59, 3, 55349, 56498, 4, 4, 102, 105, 111, 115, 6325, 6330, 6333, 6339, 114, 59, 3, 55349, 56603, 59, 1, 926, 112, 102, 59, 3, 55349, 56655, 99, 114, 59, 3, 55349, 56499, 4, 9, 65, 73, 85, 97, 99, 102, 111, 115, 117, 6365, 6370, 6375, 6380, 6391, 6405, 6410, 6416, 6422, 99, 121, 59, 1, 1071, 99, 121, 59, 1, 1031, 99, 121, 59, 1, 1070, 99, 117, 116, 101, 5, 221, 1, 59, 6389, 1, 221, 4, 2, 105, 121, 6397, 6402, 114, 99, 59, 1, 374, 59, 1, 1067, 114, 59, 3, 55349, 56604, 112, 102, 59, 3, 55349, 56656, 99, 114, 59, 3, 55349, 56500, 109, 108, 59, 1, 376, 4, 8, 72, 97, 99, 100, 101, 102, 111, 115, 6445, 6450, 6457, 6472, 6477, 6501, 6505, 6510, 99, 121, 59, 1, 1046, 99, 117, 116, 101, 59, 1, 377, 4, 2, 97, 121, 6463, 6469, 114, 111, 110, 59, 1, 381, 59, 1, 1047, 111, 116, 59, 1, 379, 4, 2, 114, 116, 6483, 6497, 111, 87, 105, 100, 116, 104, 83, 112, 97, 99, 101, 59, 1, 8203, 97, 59, 1, 918, 114, 59, 1, 8488, 112, 102, 59, 1, 8484, 99, 114, 59, 3, 55349, 56501, 4, 16, 97, 98, 99, 101, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 119, 6550, 6561, 6568, 6612, 6622, 6634, 6645, 6672, 6699, 6854, 6870, 6923, 6933, 6963, 6974, 6983, 99, 117, 116, 101, 5, 225, 1, 59, 6559, 1, 225, 114, 101, 118, 101, 59, 1, 259, 4, 6, 59, 69, 100, 105, 117, 121, 6582, 6584, 6588, 6591, 6600, 6609, 1, 8766, 59, 3, 8766, 819, 59, 1, 8767, 114, 99, 5, 226, 1, 59, 6598, 1, 226, 116, 101, 5, 180, 1, 59, 6607, 1, 180, 59, 1, 1072, 108, 105, 103, 5, 230, 1, 59, 6620, 1, 230, 4, 2, 59, 114, 6628, 6630, 1, 8289, 59, 3, 55349, 56606, 114, 97, 118, 101, 5, 224, 1, 59, 6643, 1, 224, 4, 2, 101, 112, 6651, 6667, 4, 2, 102, 112, 6657, 6663, 115, 121, 109, 59, 1, 8501, 104, 59, 1, 8501, 104, 97, 59, 1, 945, 4, 2, 97, 112, 6678, 6692, 4, 2, 99, 108, 6684, 6688, 114, 59, 1, 257, 103, 59, 1, 10815, 5, 38, 1, 59, 6697, 1, 38, 4, 2, 100, 103, 6705, 6737, 4, 5, 59, 97, 100, 115, 118, 6717, 6719, 6724, 6727, 6734, 1, 8743, 110, 100, 59, 1, 10837, 59, 1, 10844, 108, 111, 112, 101, 59, 1, 10840, 59, 1, 10842, 4, 7, 59, 101, 108, 109, 114, 115, 122, 6753, 6755, 6758, 6762, 6814, 6835, 6848, 1, 8736, 59, 1, 10660, 101, 59, 1, 8736, 115, 100, 4, 2, 59, 97, 6770, 6772, 1, 8737, 4, 8, 97, 98, 99, 100, 101, 102, 103, 104, 6790, 6793, 6796, 6799, 6802, 6805, 6808, 6811, 59, 1, 10664, 59, 1, 10665, 59, 1, 10666, 59, 1, 10667, 59, 1, 10668, 59, 1, 10669, 59, 1, 10670, 59, 1, 10671, 116, 4, 2, 59, 118, 6821, 6823, 1, 8735, 98, 4, 2, 59, 100, 6830, 6832, 1, 8894, 59, 1, 10653, 4, 2, 112, 116, 6841, 6845, 104, 59, 1, 8738, 59, 1, 197, 97, 114, 114, 59, 1, 9084, 4, 2, 103, 112, 6860, 6865, 111, 110, 59, 1, 261, 102, 59, 3, 55349, 56658, 4, 7, 59, 69, 97, 101, 105, 111, 112, 6886, 6888, 6891, 6897, 6900, 6904, 6908, 1, 8776, 59, 1, 10864, 99, 105, 114, 59, 1, 10863, 59, 1, 8778, 100, 59, 1, 8779, 115, 59, 1, 39, 114, 111, 120, 4, 2, 59, 101, 6917, 6919, 1, 8776, 113, 59, 1, 8778, 105, 110, 103, 5, 229, 1, 59, 6931, 1, 229, 4, 3, 99, 116, 121, 6941, 6946, 6949, 114, 59, 3, 55349, 56502, 59, 1, 42, 109, 112, 4, 2, 59, 101, 6957, 6959, 1, 8776, 113, 59, 1, 8781, 105, 108, 100, 101, 5, 227, 1, 59, 6972, 1, 227, 109, 108, 5, 228, 1, 59, 6981, 1, 228, 4, 2, 99, 105, 6989, 6997, 111, 110, 105, 110, 116, 59, 1, 8755, 110, 116, 59, 1, 10769, 4, 16, 78, 97, 98, 99, 100, 101, 102, 105, 107, 108, 110, 111, 112, 114, 115, 117, 7036, 7041, 7119, 7135, 7149, 7155, 7219, 7224, 7347, 7354, 7463, 7489, 7786, 7793, 7814, 7866, 111, 116, 59, 1, 10989, 4, 2, 99, 114, 7047, 7094, 107, 4, 4, 99, 101, 112, 115, 7058, 7064, 7073, 7080, 111, 110, 103, 59, 1, 8780, 112, 115, 105, 108, 111, 110, 59, 1, 1014, 114, 105, 109, 101, 59, 1, 8245, 105, 109, 4, 2, 59, 101, 7088, 7090, 1, 8765, 113, 59, 1, 8909, 4, 2, 118, 119, 7100, 7105, 101, 101, 59, 1, 8893, 101, 100, 4, 2, 59, 103, 7113, 7115, 1, 8965, 101, 59, 1, 8965, 114, 107, 4, 2, 59, 116, 7127, 7129, 1, 9141, 98, 114, 107, 59, 1, 9142, 4, 2, 111, 121, 7141, 7146, 110, 103, 59, 1, 8780, 59, 1, 1073, 113, 117, 111, 59, 1, 8222, 4, 5, 99, 109, 112, 114, 116, 7167, 7181, 7188, 7193, 7199, 97, 117, 115, 4, 2, 59, 101, 7176, 7178, 1, 8757, 59, 1, 8757, 112, 116, 121, 118, 59, 1, 10672, 115, 105, 59, 1, 1014, 110, 111, 117, 59, 1, 8492, 4, 3, 97, 104, 119, 7207, 7210, 7213, 59, 1, 946, 59, 1, 8502, 101, 101, 110, 59, 1, 8812, 114, 59, 3, 55349, 56607, 103, 4, 7, 99, 111, 115, 116, 117, 118, 119, 7241, 7262, 7288, 7305, 7328, 7335, 7340, 4, 3, 97, 105, 117, 7249, 7253, 7258, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 4, 3, 100, 112, 116, 7270, 7275, 7281, 111, 116, 59, 1, 10752, 108, 117, 115, 59, 1, 10753, 105, 109, 101, 115, 59, 1, 10754, 4, 2, 113, 116, 7294, 7300, 99, 117, 112, 59, 1, 10758, 97, 114, 59, 1, 9733, 114, 105, 97, 110, 103, 108, 101, 4, 2, 100, 117, 7318, 7324, 111, 119, 110, 59, 1, 9661, 112, 59, 1, 9651, 112, 108, 117, 115, 59, 1, 10756, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 97, 114, 111, 119, 59, 1, 10509, 4, 3, 97, 107, 111, 7362, 7436, 7458, 4, 2, 99, 110, 7368, 7432, 107, 4, 3, 108, 115, 116, 7377, 7386, 7394, 111, 122, 101, 110, 103, 101, 59, 1, 10731, 113, 117, 97, 114, 101, 59, 1, 9642, 114, 105, 97, 110, 103, 108, 101, 4, 4, 59, 100, 108, 114, 7411, 7413, 7419, 7425, 1, 9652, 111, 119, 110, 59, 1, 9662, 101, 102, 116, 59, 1, 9666, 105, 103, 104, 116, 59, 1, 9656, 107, 59, 1, 9251, 4, 2, 49, 51, 7442, 7454, 4, 2, 50, 52, 7448, 7451, 59, 1, 9618, 59, 1, 9617, 52, 59, 1, 9619, 99, 107, 59, 1, 9608, 4, 2, 101, 111, 7469, 7485, 4, 2, 59, 113, 7475, 7478, 3, 61, 8421, 117, 105, 118, 59, 3, 8801, 8421, 116, 59, 1, 8976, 4, 4, 112, 116, 119, 120, 7499, 7504, 7517, 7523, 102, 59, 3, 55349, 56659, 4, 2, 59, 116, 7510, 7512, 1, 8869, 111, 109, 59, 1, 8869, 116, 105, 101, 59, 1, 8904, 4, 12, 68, 72, 85, 86, 98, 100, 104, 109, 112, 116, 117, 118, 7549, 7571, 7597, 7619, 7655, 7660, 7682, 7708, 7715, 7721, 7728, 7750, 4, 4, 76, 82, 108, 114, 7559, 7562, 7565, 7568, 59, 1, 9559, 59, 1, 9556, 59, 1, 9558, 59, 1, 9555, 4, 5, 59, 68, 85, 100, 117, 7583, 7585, 7588, 7591, 7594, 1, 9552, 59, 1, 9574, 59, 1, 9577, 59, 1, 9572, 59, 1, 9575, 4, 4, 76, 82, 108, 114, 7607, 7610, 7613, 7616, 59, 1, 9565, 59, 1, 9562, 59, 1, 9564, 59, 1, 9561, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7635, 7637, 7640, 7643, 7646, 7649, 7652, 1, 9553, 59, 1, 9580, 59, 1, 9571, 59, 1, 9568, 59, 1, 9579, 59, 1, 9570, 59, 1, 9567, 111, 120, 59, 1, 10697, 4, 4, 76, 82, 108, 114, 7670, 7673, 7676, 7679, 59, 1, 9557, 59, 1, 9554, 59, 1, 9488, 59, 1, 9484, 4, 5, 59, 68, 85, 100, 117, 7694, 7696, 7699, 7702, 7705, 1, 9472, 59, 1, 9573, 59, 1, 9576, 59, 1, 9516, 59, 1, 9524, 105, 110, 117, 115, 59, 1, 8863, 108, 117, 115, 59, 1, 8862, 105, 109, 101, 115, 59, 1, 8864, 4, 4, 76, 82, 108, 114, 7738, 7741, 7744, 7747, 59, 1, 9563, 59, 1, 9560, 59, 1, 9496, 59, 1, 9492, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7766, 7768, 7771, 7774, 7777, 7780, 7783, 1, 9474, 59, 1, 9578, 59, 1, 9569, 59, 1, 9566, 59, 1, 9532, 59, 1, 9508, 59, 1, 9500, 114, 105, 109, 101, 59, 1, 8245, 4, 2, 101, 118, 7799, 7804, 118, 101, 59, 1, 728, 98, 97, 114, 5, 166, 1, 59, 7812, 1, 166, 4, 4, 99, 101, 105, 111, 7824, 7829, 7834, 7846, 114, 59, 3, 55349, 56503, 109, 105, 59, 1, 8271, 109, 4, 2, 59, 101, 7841, 7843, 1, 8765, 59, 1, 8909, 108, 4, 3, 59, 98, 104, 7855, 7857, 7860, 1, 92, 59, 1, 10693, 115, 117, 98, 59, 1, 10184, 4, 2, 108, 109, 7872, 7885, 108, 4, 2, 59, 101, 7879, 7881, 1, 8226, 116, 59, 1, 8226, 112, 4, 3, 59, 69, 101, 7894, 7896, 7899, 1, 8782, 59, 1, 10926, 4, 2, 59, 113, 7905, 7907, 1, 8783, 59, 1, 8783, 4, 15, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 116, 117, 119, 121, 7942, 8021, 8075, 8080, 8121, 8126, 8157, 8279, 8295, 8430, 8446, 8485, 8491, 8707, 8726, 4, 3, 99, 112, 114, 7950, 7956, 8007, 117, 116, 101, 59, 1, 263, 4, 6, 59, 97, 98, 99, 100, 115, 7970, 7972, 7977, 7984, 7998, 8003, 1, 8745, 110, 100, 59, 1, 10820, 114, 99, 117, 112, 59, 1, 10825, 4, 2, 97, 117, 7990, 7994, 112, 59, 1, 10827, 112, 59, 1, 10823, 111, 116, 59, 1, 10816, 59, 3, 8745, 65024, 4, 2, 101, 111, 8013, 8017, 116, 59, 1, 8257, 110, 59, 1, 711, 4, 4, 97, 101, 105, 117, 8031, 8046, 8056, 8061, 4, 2, 112, 114, 8037, 8041, 115, 59, 1, 10829, 111, 110, 59, 1, 269, 100, 105, 108, 5, 231, 1, 59, 8054, 1, 231, 114, 99, 59, 1, 265, 112, 115, 4, 2, 59, 115, 8069, 8071, 1, 10828, 109, 59, 1, 10832, 111, 116, 59, 1, 267, 4, 3, 100, 109, 110, 8088, 8097, 8104, 105, 108, 5, 184, 1, 59, 8095, 1, 184, 112, 116, 121, 118, 59, 1, 10674, 116, 5, 162, 2, 59, 101, 8112, 8114, 1, 162, 114, 100, 111, 116, 59, 1, 183, 114, 59, 3, 55349, 56608, 4, 3, 99, 101, 105, 8134, 8138, 8154, 121, 59, 1, 1095, 99, 107, 4, 2, 59, 109, 8146, 8148, 1, 10003, 97, 114, 107, 59, 1, 10003, 59, 1, 967, 114, 4, 7, 59, 69, 99, 101, 102, 109, 115, 8174, 8176, 8179, 8258, 8261, 8268, 8273, 1, 9675, 59, 1, 10691, 4, 3, 59, 101, 108, 8187, 8189, 8193, 1, 710, 113, 59, 1, 8791, 101, 4, 2, 97, 100, 8200, 8223, 114, 114, 111, 119, 4, 2, 108, 114, 8210, 8216, 101, 102, 116, 59, 1, 8634, 105, 103, 104, 116, 59, 1, 8635, 4, 5, 82, 83, 97, 99, 100, 8235, 8238, 8241, 8246, 8252, 59, 1, 174, 59, 1, 9416, 115, 116, 59, 1, 8859, 105, 114, 99, 59, 1, 8858, 97, 115, 104, 59, 1, 8861, 59, 1, 8791, 110, 105, 110, 116, 59, 1, 10768, 105, 100, 59, 1, 10991, 99, 105, 114, 59, 1, 10690, 117, 98, 115, 4, 2, 59, 117, 8288, 8290, 1, 9827, 105, 116, 59, 1, 9827, 4, 4, 108, 109, 110, 112, 8305, 8326, 8376, 8400, 111, 110, 4, 2, 59, 101, 8313, 8315, 1, 58, 4, 2, 59, 113, 8321, 8323, 1, 8788, 59, 1, 8788, 4, 2, 109, 112, 8332, 8344, 97, 4, 2, 59, 116, 8339, 8341, 1, 44, 59, 1, 64, 4, 3, 59, 102, 108, 8352, 8354, 8358, 1, 8705, 110, 59, 1, 8728, 101, 4, 2, 109, 120, 8365, 8371, 101, 110, 116, 59, 1, 8705, 101, 115, 59, 1, 8450, 4, 2, 103, 105, 8382, 8395, 4, 2, 59, 100, 8388, 8390, 1, 8773, 111, 116, 59, 1, 10861, 110, 116, 59, 1, 8750, 4, 3, 102, 114, 121, 8408, 8412, 8417, 59, 3, 55349, 56660, 111, 100, 59, 1, 8720, 5, 169, 2, 59, 115, 8424, 8426, 1, 169, 114, 59, 1, 8471, 4, 2, 97, 111, 8436, 8441, 114, 114, 59, 1, 8629, 115, 115, 59, 1, 10007, 4, 2, 99, 117, 8452, 8457, 114, 59, 3, 55349, 56504, 4, 2, 98, 112, 8463, 8474, 4, 2, 59, 101, 8469, 8471, 1, 10959, 59, 1, 10961, 4, 2, 59, 101, 8480, 8482, 1, 10960, 59, 1, 10962, 100, 111, 116, 59, 1, 8943, 4, 7, 100, 101, 108, 112, 114, 118, 119, 8507, 8522, 8536, 8550, 8600, 8697, 8702, 97, 114, 114, 4, 2, 108, 114, 8516, 8519, 59, 1, 10552, 59, 1, 10549, 4, 2, 112, 115, 8528, 8532, 114, 59, 1, 8926, 99, 59, 1, 8927, 97, 114, 114, 4, 2, 59, 112, 8545, 8547, 1, 8630, 59, 1, 10557, 4, 6, 59, 98, 99, 100, 111, 115, 8564, 8566, 8573, 8587, 8592, 8596, 1, 8746, 114, 99, 97, 112, 59, 1, 10824, 4, 2, 97, 117, 8579, 8583, 112, 59, 1, 10822, 112, 59, 1, 10826, 111, 116, 59, 1, 8845, 114, 59, 1, 10821, 59, 3, 8746, 65024, 4, 4, 97, 108, 114, 118, 8610, 8623, 8663, 8672, 114, 114, 4, 2, 59, 109, 8618, 8620, 1, 8631, 59, 1, 10556, 121, 4, 3, 101, 118, 119, 8632, 8651, 8656, 113, 4, 2, 112, 115, 8639, 8645, 114, 101, 99, 59, 1, 8926, 117, 99, 99, 59, 1, 8927, 101, 101, 59, 1, 8910, 101, 100, 103, 101, 59, 1, 8911, 101, 110, 5, 164, 1, 59, 8670, 1, 164, 101, 97, 114, 114, 111, 119, 4, 2, 108, 114, 8684, 8690, 101, 102, 116, 59, 1, 8630, 105, 103, 104, 116, 59, 1, 8631, 101, 101, 59, 1, 8910, 101, 100, 59, 1, 8911, 4, 2, 99, 105, 8713, 8721, 111, 110, 105, 110, 116, 59, 1, 8754, 110, 116, 59, 1, 8753, 108, 99, 116, 121, 59, 1, 9005, 4, 19, 65, 72, 97, 98, 99, 100, 101, 102, 104, 105, 106, 108, 111, 114, 115, 116, 117, 119, 122, 8773, 8778, 8783, 8821, 8839, 8854, 8887, 8914, 8930, 8944, 9036, 9041, 9058, 9197, 9227, 9258, 9281, 9297, 9305, 114, 114, 59, 1, 8659, 97, 114, 59, 1, 10597, 4, 4, 103, 108, 114, 115, 8793, 8799, 8805, 8809, 103, 101, 114, 59, 1, 8224, 101, 116, 104, 59, 1, 8504, 114, 59, 1, 8595, 104, 4, 2, 59, 118, 8816, 8818, 1, 8208, 59, 1, 8867, 4, 2, 107, 108, 8827, 8834, 97, 114, 111, 119, 59, 1, 10511, 97, 99, 59, 1, 733, 4, 2, 97, 121, 8845, 8851, 114, 111, 110, 59, 1, 271, 59, 1, 1076, 4, 3, 59, 97, 111, 8862, 8864, 8880, 1, 8518, 4, 2, 103, 114, 8870, 8876, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8650, 116, 115, 101, 113, 59, 1, 10871, 4, 3, 103, 108, 109, 8895, 8902, 8907, 5, 176, 1, 59, 8900, 1, 176, 116, 97, 59, 1, 948, 112, 116, 121, 118, 59, 1, 10673, 4, 2, 105, 114, 8920, 8926, 115, 104, 116, 59, 1, 10623, 59, 3, 55349, 56609, 97, 114, 4, 2, 108, 114, 8938, 8941, 59, 1, 8643, 59, 1, 8642, 4, 5, 97, 101, 103, 115, 118, 8956, 8986, 8989, 8996, 9001, 109, 4, 3, 59, 111, 115, 8965, 8967, 8983, 1, 8900, 110, 100, 4, 2, 59, 115, 8975, 8977, 1, 8900, 117, 105, 116, 59, 1, 9830, 59, 1, 9830, 59, 1, 168, 97, 109, 109, 97, 59, 1, 989, 105, 110, 59, 1, 8946, 4, 3, 59, 105, 111, 9009, 9011, 9031, 1, 247, 100, 101, 5, 247, 2, 59, 111, 9020, 9022, 1, 247, 110, 116, 105, 109, 101, 115, 59, 1, 8903, 110, 120, 59, 1, 8903, 99, 121, 59, 1, 1106, 99, 4, 2, 111, 114, 9048, 9053, 114, 110, 59, 1, 8990, 111, 112, 59, 1, 8973, 4, 5, 108, 112, 116, 117, 119, 9070, 9076, 9081, 9130, 9144, 108, 97, 114, 59, 1, 36, 102, 59, 3, 55349, 56661, 4, 5, 59, 101, 109, 112, 115, 9093, 9095, 9109, 9116, 9122, 1, 729, 113, 4, 2, 59, 100, 9102, 9104, 1, 8784, 111, 116, 59, 1, 8785, 105, 110, 117, 115, 59, 1, 8760, 108, 117, 115, 59, 1, 8724, 113, 117, 97, 114, 101, 59, 1, 8865, 98, 108, 101, 98, 97, 114, 119, 101, 100, 103, 101, 59, 1, 8966, 110, 4, 3, 97, 100, 104, 9153, 9160, 9172, 114, 114, 111, 119, 59, 1, 8595, 111, 119, 110, 97, 114, 114, 111, 119, 115, 59, 1, 8650, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 9184, 9190, 101, 102, 116, 59, 1, 8643, 105, 103, 104, 116, 59, 1, 8642, 4, 2, 98, 99, 9203, 9211, 107, 97, 114, 111, 119, 59, 1, 10512, 4, 2, 111, 114, 9217, 9222, 114, 110, 59, 1, 8991, 111, 112, 59, 1, 8972, 4, 3, 99, 111, 116, 9235, 9248, 9252, 4, 2, 114, 121, 9241, 9245, 59, 3, 55349, 56505, 59, 1, 1109, 108, 59, 1, 10742, 114, 111, 107, 59, 1, 273, 4, 2, 100, 114, 9264, 9269, 111, 116, 59, 1, 8945, 105, 4, 2, 59, 102, 9276, 9278, 1, 9663, 59, 1, 9662, 4, 2, 97, 104, 9287, 9292, 114, 114, 59, 1, 8693, 97, 114, 59, 1, 10607, 97, 110, 103, 108, 101, 59, 1, 10662, 4, 2, 99, 105, 9311, 9315, 121, 59, 1, 1119, 103, 114, 97, 114, 114, 59, 1, 10239, 4, 18, 68, 97, 99, 100, 101, 102, 103, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 120, 9361, 9376, 9398, 9439, 9444, 9447, 9462, 9495, 9531, 9585, 9598, 9614, 9659, 9755, 9771, 9792, 9808, 9826, 4, 2, 68, 111, 9367, 9372, 111, 116, 59, 1, 10871, 116, 59, 1, 8785, 4, 2, 99, 115, 9382, 9392, 117, 116, 101, 5, 233, 1, 59, 9390, 1, 233, 116, 101, 114, 59, 1, 10862, 4, 4, 97, 105, 111, 121, 9408, 9414, 9430, 9436, 114, 111, 110, 59, 1, 283, 114, 4, 2, 59, 99, 9421, 9423, 1, 8790, 5, 234, 1, 59, 9428, 1, 234, 108, 111, 110, 59, 1, 8789, 59, 1, 1101, 111, 116, 59, 1, 279, 59, 1, 8519, 4, 2, 68, 114, 9453, 9458, 111, 116, 59, 1, 8786, 59, 3, 55349, 56610, 4, 3, 59, 114, 115, 9470, 9472, 9482, 1, 10906, 97, 118, 101, 5, 232, 1, 59, 9480, 1, 232, 4, 2, 59, 100, 9488, 9490, 1, 10902, 111, 116, 59, 1, 10904, 4, 4, 59, 105, 108, 115, 9505, 9507, 9515, 9518, 1, 10905, 110, 116, 101, 114, 115, 59, 1, 9191, 59, 1, 8467, 4, 2, 59, 100, 9524, 9526, 1, 10901, 111, 116, 59, 1, 10903, 4, 3, 97, 112, 115, 9539, 9544, 9564, 99, 114, 59, 1, 275, 116, 121, 4, 3, 59, 115, 118, 9554, 9556, 9561, 1, 8709, 101, 116, 59, 1, 8709, 59, 1, 8709, 112, 4, 2, 49, 59, 9571, 9583, 4, 2, 51, 52, 9577, 9580, 59, 1, 8196, 59, 1, 8197, 1, 8195, 4, 2, 103, 115, 9591, 9594, 59, 1, 331, 112, 59, 1, 8194, 4, 2, 103, 112, 9604, 9609, 111, 110, 59, 1, 281, 102, 59, 3, 55349, 56662, 4, 3, 97, 108, 115, 9622, 9635, 9640, 114, 4, 2, 59, 115, 9629, 9631, 1, 8917, 108, 59, 1, 10723, 117, 115, 59, 1, 10865, 105, 4, 3, 59, 108, 118, 9649, 9651, 9656, 1, 949, 111, 110, 59, 1, 949, 59, 1, 1013, 4, 4, 99, 115, 117, 118, 9669, 9686, 9716, 9747, 4, 2, 105, 111, 9675, 9680, 114, 99, 59, 1, 8790, 108, 111, 110, 59, 1, 8789, 4, 2, 105, 108, 9692, 9696, 109, 59, 1, 8770, 97, 110, 116, 4, 2, 103, 108, 9705, 9710, 116, 114, 59, 1, 10902, 101, 115, 115, 59, 1, 10901, 4, 3, 97, 101, 105, 9724, 9729, 9734, 108, 115, 59, 1, 61, 115, 116, 59, 1, 8799, 118, 4, 2, 59, 68, 9741, 9743, 1, 8801, 68, 59, 1, 10872, 112, 97, 114, 115, 108, 59, 1, 10725, 4, 2, 68, 97, 9761, 9766, 111, 116, 59, 1, 8787, 114, 114, 59, 1, 10609, 4, 3, 99, 100, 105, 9779, 9783, 9788, 114, 59, 1, 8495, 111, 116, 59, 1, 8784, 109, 59, 1, 8770, 4, 2, 97, 104, 9798, 9801, 59, 1, 951, 5, 240, 1, 59, 9806, 1, 240, 4, 2, 109, 114, 9814, 9822, 108, 5, 235, 1, 59, 9820, 1, 235, 111, 59, 1, 8364, 4, 3, 99, 105, 112, 9834, 9838, 9843, 108, 59, 1, 33, 115, 116, 59, 1, 8707, 4, 2, 101, 111, 9849, 9859, 99, 116, 97, 116, 105, 111, 110, 59, 1, 8496, 110, 101, 110, 116, 105, 97, 108, 101, 59, 1, 8519, 4, 12, 97, 99, 101, 102, 105, 106, 108, 110, 111, 112, 114, 115, 9896, 9910, 9914, 9921, 9954, 9960, 9967, 9989, 9994, 10027, 10036, 10164, 108, 108, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8786, 121, 59, 1, 1092, 109, 97, 108, 101, 59, 1, 9792, 4, 3, 105, 108, 114, 9929, 9935, 9950, 108, 105, 103, 59, 1, 64259, 4, 2, 105, 108, 9941, 9945, 103, 59, 1, 64256, 105, 103, 59, 1, 64260, 59, 3, 55349, 56611, 108, 105, 103, 59, 1, 64257, 108, 105, 103, 59, 3, 102, 106, 4, 3, 97, 108, 116, 9975, 9979, 9984, 116, 59, 1, 9837, 105, 103, 59, 1, 64258, 110, 115, 59, 1, 9649, 111, 102, 59, 1, 402, 4, 2, 112, 114, 1e4, 10005, 102, 59, 3, 55349, 56663, 4, 2, 97, 107, 10011, 10016, 108, 108, 59, 1, 8704, 4, 2, 59, 118, 10022, 10024, 1, 8916, 59, 1, 10969, 97, 114, 116, 105, 110, 116, 59, 1, 10765, 4, 2, 97, 111, 10042, 10159, 4, 2, 99, 115, 10048, 10155, 4, 6, 49, 50, 51, 52, 53, 55, 10062, 10102, 10114, 10135, 10139, 10151, 4, 6, 50, 51, 52, 53, 54, 56, 10076, 10083, 10086, 10093, 10096, 10099, 5, 189, 1, 59, 10081, 1, 189, 59, 1, 8531, 5, 188, 1, 59, 10091, 1, 188, 59, 1, 8533, 59, 1, 8537, 59, 1, 8539, 4, 2, 51, 53, 10108, 10111, 59, 1, 8532, 59, 1, 8534, 4, 3, 52, 53, 56, 10122, 10129, 10132, 5, 190, 1, 59, 10127, 1, 190, 59, 1, 8535, 59, 1, 8540, 53, 59, 1, 8536, 4, 2, 54, 56, 10145, 10148, 59, 1, 8538, 59, 1, 8541, 56, 59, 1, 8542, 108, 59, 1, 8260, 119, 110, 59, 1, 8994, 99, 114, 59, 3, 55349, 56507, 4, 17, 69, 97, 98, 99, 100, 101, 102, 103, 105, 106, 108, 110, 111, 114, 115, 116, 118, 10206, 10217, 10247, 10254, 10268, 10273, 10358, 10363, 10374, 10380, 10385, 10406, 10458, 10464, 10470, 10497, 10610, 4, 2, 59, 108, 10212, 10214, 1, 8807, 59, 1, 10892, 4, 3, 99, 109, 112, 10225, 10231, 10244, 117, 116, 101, 59, 1, 501, 109, 97, 4, 2, 59, 100, 10239, 10241, 1, 947, 59, 1, 989, 59, 1, 10886, 114, 101, 118, 101, 59, 1, 287, 4, 2, 105, 121, 10260, 10265, 114, 99, 59, 1, 285, 59, 1, 1075, 111, 116, 59, 1, 289, 4, 4, 59, 108, 113, 115, 10283, 10285, 10288, 10308, 1, 8805, 59, 1, 8923, 4, 3, 59, 113, 115, 10296, 10298, 10301, 1, 8805, 59, 1, 8807, 108, 97, 110, 116, 59, 1, 10878, 4, 4, 59, 99, 100, 108, 10318, 10320, 10324, 10345, 1, 10878, 99, 59, 1, 10921, 111, 116, 4, 2, 59, 111, 10332, 10334, 1, 10880, 4, 2, 59, 108, 10340, 10342, 1, 10882, 59, 1, 10884, 4, 2, 59, 101, 10351, 10354, 3, 8923, 65024, 115, 59, 1, 10900, 114, 59, 3, 55349, 56612, 4, 2, 59, 103, 10369, 10371, 1, 8811, 59, 1, 8921, 109, 101, 108, 59, 1, 8503, 99, 121, 59, 1, 1107, 4, 4, 59, 69, 97, 106, 10395, 10397, 10400, 10403, 1, 8823, 59, 1, 10898, 59, 1, 10917, 59, 1, 10916, 4, 4, 69, 97, 101, 115, 10416, 10419, 10434, 10453, 59, 1, 8809, 112, 4, 2, 59, 112, 10426, 10428, 1, 10890, 114, 111, 120, 59, 1, 10890, 4, 2, 59, 113, 10440, 10442, 1, 10888, 4, 2, 59, 113, 10448, 10450, 1, 10888, 59, 1, 8809, 105, 109, 59, 1, 8935, 112, 102, 59, 3, 55349, 56664, 97, 118, 101, 59, 1, 96, 4, 2, 99, 105, 10476, 10480, 114, 59, 1, 8458, 109, 4, 3, 59, 101, 108, 10489, 10491, 10494, 1, 8819, 59, 1, 10894, 59, 1, 10896, 5, 62, 6, 59, 99, 100, 108, 113, 114, 10512, 10514, 10527, 10532, 10538, 10545, 1, 62, 4, 2, 99, 105, 10520, 10523, 59, 1, 10919, 114, 59, 1, 10874, 111, 116, 59, 1, 8919, 80, 97, 114, 59, 1, 10645, 117, 101, 115, 116, 59, 1, 10876, 4, 5, 97, 100, 101, 108, 115, 10557, 10574, 10579, 10599, 10605, 4, 2, 112, 114, 10563, 10570, 112, 114, 111, 120, 59, 1, 10886, 114, 59, 1, 10616, 111, 116, 59, 1, 8919, 113, 4, 2, 108, 113, 10586, 10592, 101, 115, 115, 59, 1, 8923, 108, 101, 115, 115, 59, 1, 10892, 101, 115, 115, 59, 1, 8823, 105, 109, 59, 1, 8819, 4, 2, 101, 110, 10616, 10626, 114, 116, 110, 101, 113, 113, 59, 3, 8809, 65024, 69, 59, 3, 8809, 65024, 4, 10, 65, 97, 98, 99, 101, 102, 107, 111, 115, 121, 10653, 10658, 10713, 10718, 10724, 10760, 10765, 10786, 10850, 10875, 114, 114, 59, 1, 8660, 4, 4, 105, 108, 109, 114, 10668, 10674, 10678, 10684, 114, 115, 112, 59, 1, 8202, 102, 59, 1, 189, 105, 108, 116, 59, 1, 8459, 4, 2, 100, 114, 10690, 10695, 99, 121, 59, 1, 1098, 4, 3, 59, 99, 119, 10703, 10705, 10710, 1, 8596, 105, 114, 59, 1, 10568, 59, 1, 8621, 97, 114, 59, 1, 8463, 105, 114, 99, 59, 1, 293, 4, 3, 97, 108, 114, 10732, 10748, 10754, 114, 116, 115, 4, 2, 59, 117, 10741, 10743, 1, 9829, 105, 116, 59, 1, 9829, 108, 105, 112, 59, 1, 8230, 99, 111, 110, 59, 1, 8889, 114, 59, 3, 55349, 56613, 115, 4, 2, 101, 119, 10772, 10779, 97, 114, 111, 119, 59, 1, 10533, 97, 114, 111, 119, 59, 1, 10534, 4, 5, 97, 109, 111, 112, 114, 10798, 10803, 10809, 10839, 10844, 114, 114, 59, 1, 8703, 116, 104, 116, 59, 1, 8763, 107, 4, 2, 108, 114, 10816, 10827, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8617, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8618, 102, 59, 3, 55349, 56665, 98, 97, 114, 59, 1, 8213, 4, 3, 99, 108, 116, 10858, 10863, 10869, 114, 59, 3, 55349, 56509, 97, 115, 104, 59, 1, 8463, 114, 111, 107, 59, 1, 295, 4, 2, 98, 112, 10881, 10887, 117, 108, 108, 59, 1, 8259, 104, 101, 110, 59, 1, 8208, 4, 15, 97, 99, 101, 102, 103, 105, 106, 109, 110, 111, 112, 113, 115, 116, 117, 10925, 10936, 10958, 10977, 10990, 11001, 11039, 11045, 11101, 11192, 11220, 11226, 11237, 11285, 11299, 99, 117, 116, 101, 5, 237, 1, 59, 10934, 1, 237, 4, 3, 59, 105, 121, 10944, 10946, 10955, 1, 8291, 114, 99, 5, 238, 1, 59, 10953, 1, 238, 59, 1, 1080, 4, 2, 99, 120, 10964, 10968, 121, 59, 1, 1077, 99, 108, 5, 161, 1, 59, 10975, 1, 161, 4, 2, 102, 114, 10983, 10986, 59, 1, 8660, 59, 3, 55349, 56614, 114, 97, 118, 101, 5, 236, 1, 59, 10999, 1, 236, 4, 4, 59, 105, 110, 111, 11011, 11013, 11028, 11034, 1, 8520, 4, 2, 105, 110, 11019, 11024, 110, 116, 59, 1, 10764, 116, 59, 1, 8749, 102, 105, 110, 59, 1, 10716, 116, 97, 59, 1, 8489, 108, 105, 103, 59, 1, 307, 4, 3, 97, 111, 112, 11053, 11092, 11096, 4, 3, 99, 103, 116, 11061, 11065, 11088, 114, 59, 1, 299, 4, 3, 101, 108, 112, 11073, 11076, 11082, 59, 1, 8465, 105, 110, 101, 59, 1, 8464, 97, 114, 116, 59, 1, 8465, 104, 59, 1, 305, 102, 59, 1, 8887, 101, 100, 59, 1, 437, 4, 5, 59, 99, 102, 111, 116, 11113, 11115, 11121, 11136, 11142, 1, 8712, 97, 114, 101, 59, 1, 8453, 105, 110, 4, 2, 59, 116, 11129, 11131, 1, 8734, 105, 101, 59, 1, 10717, 100, 111, 116, 59, 1, 305, 4, 5, 59, 99, 101, 108, 112, 11154, 11156, 11161, 11179, 11186, 1, 8747, 97, 108, 59, 1, 8890, 4, 2, 103, 114, 11167, 11173, 101, 114, 115, 59, 1, 8484, 99, 97, 108, 59, 1, 8890, 97, 114, 104, 107, 59, 1, 10775, 114, 111, 100, 59, 1, 10812, 4, 4, 99, 103, 112, 116, 11202, 11206, 11211, 11216, 121, 59, 1, 1105, 111, 110, 59, 1, 303, 102, 59, 3, 55349, 56666, 97, 59, 1, 953, 114, 111, 100, 59, 1, 10812, 117, 101, 115, 116, 5, 191, 1, 59, 11235, 1, 191, 4, 2, 99, 105, 11243, 11248, 114, 59, 3, 55349, 56510, 110, 4, 5, 59, 69, 100, 115, 118, 11261, 11263, 11266, 11271, 11282, 1, 8712, 59, 1, 8953, 111, 116, 59, 1, 8949, 4, 2, 59, 118, 11277, 11279, 1, 8948, 59, 1, 8947, 59, 1, 8712, 4, 2, 59, 105, 11291, 11293, 1, 8290, 108, 100, 101, 59, 1, 297, 4, 2, 107, 109, 11305, 11310, 99, 121, 59, 1, 1110, 108, 5, 239, 1, 59, 11316, 1, 239, 4, 6, 99, 102, 109, 111, 115, 117, 11332, 11346, 11351, 11357, 11363, 11380, 4, 2, 105, 121, 11338, 11343, 114, 99, 59, 1, 309, 59, 1, 1081, 114, 59, 3, 55349, 56615, 97, 116, 104, 59, 1, 567, 112, 102, 59, 3, 55349, 56667, 4, 2, 99, 101, 11369, 11374, 114, 59, 3, 55349, 56511, 114, 99, 121, 59, 1, 1112, 107, 99, 121, 59, 1, 1108, 4, 8, 97, 99, 102, 103, 104, 106, 111, 115, 11404, 11418, 11433, 11438, 11445, 11450, 11455, 11461, 112, 112, 97, 4, 2, 59, 118, 11413, 11415, 1, 954, 59, 1, 1008, 4, 2, 101, 121, 11424, 11430, 100, 105, 108, 59, 1, 311, 59, 1, 1082, 114, 59, 3, 55349, 56616, 114, 101, 101, 110, 59, 1, 312, 99, 121, 59, 1, 1093, 99, 121, 59, 1, 1116, 112, 102, 59, 3, 55349, 56668, 99, 114, 59, 3, 55349, 56512, 4, 23, 65, 66, 69, 72, 97, 98, 99, 100, 101, 102, 103, 104, 106, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 11515, 11538, 11544, 11555, 11560, 11721, 11780, 11818, 11868, 12136, 12160, 12171, 12203, 12208, 12246, 12275, 12327, 12509, 12523, 12569, 12641, 12732, 12752, 4, 3, 97, 114, 116, 11523, 11528, 11532, 114, 114, 59, 1, 8666, 114, 59, 1, 8656, 97, 105, 108, 59, 1, 10523, 97, 114, 114, 59, 1, 10510, 4, 2, 59, 103, 11550, 11552, 1, 8806, 59, 1, 10891, 97, 114, 59, 1, 10594, 4, 9, 99, 101, 103, 109, 110, 112, 113, 114, 116, 11580, 11586, 11594, 11600, 11606, 11624, 11627, 11636, 11694, 117, 116, 101, 59, 1, 314, 109, 112, 116, 121, 118, 59, 1, 10676, 114, 97, 110, 59, 1, 8466, 98, 100, 97, 59, 1, 955, 103, 4, 3, 59, 100, 108, 11615, 11617, 11620, 1, 10216, 59, 1, 10641, 101, 59, 1, 10216, 59, 1, 10885, 117, 111, 5, 171, 1, 59, 11634, 1, 171, 114, 4, 8, 59, 98, 102, 104, 108, 112, 115, 116, 11655, 11657, 11669, 11673, 11677, 11681, 11685, 11690, 1, 8592, 4, 2, 59, 102, 11663, 11665, 1, 8676, 115, 59, 1, 10527, 115, 59, 1, 10525, 107, 59, 1, 8617, 112, 59, 1, 8619, 108, 59, 1, 10553, 105, 109, 59, 1, 10611, 108, 59, 1, 8610, 4, 3, 59, 97, 101, 11702, 11704, 11709, 1, 10923, 105, 108, 59, 1, 10521, 4, 2, 59, 115, 11715, 11717, 1, 10925, 59, 3, 10925, 65024, 4, 3, 97, 98, 114, 11729, 11734, 11739, 114, 114, 59, 1, 10508, 114, 107, 59, 1, 10098, 4, 2, 97, 107, 11745, 11758, 99, 4, 2, 101, 107, 11752, 11755, 59, 1, 123, 59, 1, 91, 4, 2, 101, 115, 11764, 11767, 59, 1, 10635, 108, 4, 2, 100, 117, 11774, 11777, 59, 1, 10639, 59, 1, 10637, 4, 4, 97, 101, 117, 121, 11790, 11796, 11811, 11815, 114, 111, 110, 59, 1, 318, 4, 2, 100, 105, 11802, 11807, 105, 108, 59, 1, 316, 108, 59, 1, 8968, 98, 59, 1, 123, 59, 1, 1083, 4, 4, 99, 113, 114, 115, 11828, 11832, 11845, 11864, 97, 59, 1, 10550, 117, 111, 4, 2, 59, 114, 11840, 11842, 1, 8220, 59, 1, 8222, 4, 2, 100, 117, 11851, 11857, 104, 97, 114, 59, 1, 10599, 115, 104, 97, 114, 59, 1, 10571, 104, 59, 1, 8626, 4, 5, 59, 102, 103, 113, 115, 11880, 11882, 12008, 12011, 12031, 1, 8804, 116, 4, 5, 97, 104, 108, 114, 116, 11895, 11913, 11935, 11947, 11996, 114, 114, 111, 119, 4, 2, 59, 116, 11905, 11907, 1, 8592, 97, 105, 108, 59, 1, 8610, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 11925, 11931, 111, 119, 110, 59, 1, 8637, 112, 59, 1, 8636, 101, 102, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8647, 105, 103, 104, 116, 4, 3, 97, 104, 115, 11959, 11974, 11984, 114, 114, 111, 119, 4, 2, 59, 115, 11969, 11971, 1, 8596, 59, 1, 8646, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8651, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8621, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8907, 59, 1, 8922, 4, 3, 59, 113, 115, 12019, 12021, 12024, 1, 8804, 59, 1, 8806, 108, 97, 110, 116, 59, 1, 10877, 4, 5, 59, 99, 100, 103, 115, 12043, 12045, 12049, 12070, 12083, 1, 10877, 99, 59, 1, 10920, 111, 116, 4, 2, 59, 111, 12057, 12059, 1, 10879, 4, 2, 59, 114, 12065, 12067, 1, 10881, 59, 1, 10883, 4, 2, 59, 101, 12076, 12079, 3, 8922, 65024, 115, 59, 1, 10899, 4, 5, 97, 100, 101, 103, 115, 12095, 12103, 12108, 12126, 12131, 112, 112, 114, 111, 120, 59, 1, 10885, 111, 116, 59, 1, 8918, 113, 4, 2, 103, 113, 12115, 12120, 116, 114, 59, 1, 8922, 103, 116, 114, 59, 1, 10891, 116, 114, 59, 1, 8822, 105, 109, 59, 1, 8818, 4, 3, 105, 108, 114, 12144, 12150, 12156, 115, 104, 116, 59, 1, 10620, 111, 111, 114, 59, 1, 8970, 59, 3, 55349, 56617, 4, 2, 59, 69, 12166, 12168, 1, 8822, 59, 1, 10897, 4, 2, 97, 98, 12177, 12198, 114, 4, 2, 100, 117, 12184, 12187, 59, 1, 8637, 4, 2, 59, 108, 12193, 12195, 1, 8636, 59, 1, 10602, 108, 107, 59, 1, 9604, 99, 121, 59, 1, 1113, 4, 5, 59, 97, 99, 104, 116, 12220, 12222, 12227, 12235, 12241, 1, 8810, 114, 114, 59, 1, 8647, 111, 114, 110, 101, 114, 59, 1, 8990, 97, 114, 100, 59, 1, 10603, 114, 105, 59, 1, 9722, 4, 2, 105, 111, 12252, 12258, 100, 111, 116, 59, 1, 320, 117, 115, 116, 4, 2, 59, 97, 12267, 12269, 1, 9136, 99, 104, 101, 59, 1, 9136, 4, 4, 69, 97, 101, 115, 12285, 12288, 12303, 12322, 59, 1, 8808, 112, 4, 2, 59, 112, 12295, 12297, 1, 10889, 114, 111, 120, 59, 1, 10889, 4, 2, 59, 113, 12309, 12311, 1, 10887, 4, 2, 59, 113, 12317, 12319, 1, 10887, 59, 1, 8808, 105, 109, 59, 1, 8934, 4, 8, 97, 98, 110, 111, 112, 116, 119, 122, 12345, 12359, 12364, 12421, 12446, 12467, 12474, 12490, 4, 2, 110, 114, 12351, 12355, 103, 59, 1, 10220, 114, 59, 1, 8701, 114, 107, 59, 1, 10214, 103, 4, 3, 108, 109, 114, 12373, 12401, 12409, 101, 102, 116, 4, 2, 97, 114, 12382, 12389, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10231, 97, 112, 115, 116, 111, 59, 1, 10236, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10230, 112, 97, 114, 114, 111, 119, 4, 2, 108, 114, 12433, 12439, 101, 102, 116, 59, 1, 8619, 105, 103, 104, 116, 59, 1, 8620, 4, 3, 97, 102, 108, 12454, 12458, 12462, 114, 59, 1, 10629, 59, 3, 55349, 56669, 117, 115, 59, 1, 10797, 105, 109, 101, 115, 59, 1, 10804, 4, 2, 97, 98, 12480, 12485, 115, 116, 59, 1, 8727, 97, 114, 59, 1, 95, 4, 3, 59, 101, 102, 12498, 12500, 12506, 1, 9674, 110, 103, 101, 59, 1, 9674, 59, 1, 10731, 97, 114, 4, 2, 59, 108, 12517, 12519, 1, 40, 116, 59, 1, 10643, 4, 5, 97, 99, 104, 109, 116, 12535, 12540, 12548, 12561, 12564, 114, 114, 59, 1, 8646, 111, 114, 110, 101, 114, 59, 1, 8991, 97, 114, 4, 2, 59, 100, 12556, 12558, 1, 8651, 59, 1, 10605, 59, 1, 8206, 114, 105, 59, 1, 8895, 4, 6, 97, 99, 104, 105, 113, 116, 12583, 12589, 12594, 12597, 12614, 12635, 113, 117, 111, 59, 1, 8249, 114, 59, 3, 55349, 56513, 59, 1, 8624, 109, 4, 3, 59, 101, 103, 12606, 12608, 12611, 1, 8818, 59, 1, 10893, 59, 1, 10895, 4, 2, 98, 117, 12620, 12623, 59, 1, 91, 111, 4, 2, 59, 114, 12630, 12632, 1, 8216, 59, 1, 8218, 114, 111, 107, 59, 1, 322, 5, 60, 8, 59, 99, 100, 104, 105, 108, 113, 114, 12660, 12662, 12675, 12680, 12686, 12692, 12698, 12705, 1, 60, 4, 2, 99, 105, 12668, 12671, 59, 1, 10918, 114, 59, 1, 10873, 111, 116, 59, 1, 8918, 114, 101, 101, 59, 1, 8907, 109, 101, 115, 59, 1, 8905, 97, 114, 114, 59, 1, 10614, 117, 101, 115, 116, 59, 1, 10875, 4, 2, 80, 105, 12711, 12716, 97, 114, 59, 1, 10646, 4, 3, 59, 101, 102, 12724, 12726, 12729, 1, 9667, 59, 1, 8884, 59, 1, 9666, 114, 4, 2, 100, 117, 12739, 12746, 115, 104, 97, 114, 59, 1, 10570, 104, 97, 114, 59, 1, 10598, 4, 2, 101, 110, 12758, 12768, 114, 116, 110, 101, 113, 113, 59, 3, 8808, 65024, 69, 59, 3, 8808, 65024, 4, 14, 68, 97, 99, 100, 101, 102, 104, 105, 108, 110, 111, 112, 115, 117, 12803, 12809, 12893, 12908, 12914, 12928, 12933, 12937, 13011, 13025, 13032, 13049, 13052, 13069, 68, 111, 116, 59, 1, 8762, 4, 4, 99, 108, 112, 114, 12819, 12827, 12849, 12887, 114, 5, 175, 1, 59, 12825, 1, 175, 4, 2, 101, 116, 12833, 12836, 59, 1, 9794, 4, 2, 59, 101, 12842, 12844, 1, 10016, 115, 101, 59, 1, 10016, 4, 2, 59, 115, 12855, 12857, 1, 8614, 116, 111, 4, 4, 59, 100, 108, 117, 12869, 12871, 12877, 12883, 1, 8614, 111, 119, 110, 59, 1, 8615, 101, 102, 116, 59, 1, 8612, 112, 59, 1, 8613, 107, 101, 114, 59, 1, 9646, 4, 2, 111, 121, 12899, 12905, 109, 109, 97, 59, 1, 10793, 59, 1, 1084, 97, 115, 104, 59, 1, 8212, 97, 115, 117, 114, 101, 100, 97, 110, 103, 108, 101, 59, 1, 8737, 114, 59, 3, 55349, 56618, 111, 59, 1, 8487, 4, 3, 99, 100, 110, 12945, 12954, 12985, 114, 111, 5, 181, 1, 59, 12952, 1, 181, 4, 4, 59, 97, 99, 100, 12964, 12966, 12971, 12976, 1, 8739, 115, 116, 59, 1, 42, 105, 114, 59, 1, 10992, 111, 116, 5, 183, 1, 59, 12983, 1, 183, 117, 115, 4, 3, 59, 98, 100, 12995, 12997, 13e3, 1, 8722, 59, 1, 8863, 4, 2, 59, 117, 13006, 13008, 1, 8760, 59, 1, 10794, 4, 2, 99, 100, 13017, 13021, 112, 59, 1, 10971, 114, 59, 1, 8230, 112, 108, 117, 115, 59, 1, 8723, 4, 2, 100, 112, 13038, 13044, 101, 108, 115, 59, 1, 8871, 102, 59, 3, 55349, 56670, 59, 1, 8723, 4, 2, 99, 116, 13058, 13063, 114, 59, 3, 55349, 56514, 112, 111, 115, 59, 1, 8766, 4, 3, 59, 108, 109, 13077, 13079, 13087, 1, 956, 116, 105, 109, 97, 112, 59, 1, 8888, 97, 112, 59, 1, 8888, 4, 24, 71, 76, 82, 86, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 108, 109, 111, 112, 114, 115, 116, 117, 118, 119, 13142, 13165, 13217, 13229, 13247, 13330, 13359, 13414, 13420, 13508, 13513, 13579, 13602, 13626, 13631, 13762, 13767, 13855, 13936, 13995, 14214, 14285, 14312, 14432, 4, 2, 103, 116, 13148, 13152, 59, 3, 8921, 824, 4, 2, 59, 118, 13158, 13161, 3, 8811, 8402, 59, 3, 8811, 824, 4, 3, 101, 108, 116, 13173, 13200, 13204, 102, 116, 4, 2, 97, 114, 13181, 13188, 114, 114, 111, 119, 59, 1, 8653, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8654, 59, 3, 8920, 824, 4, 2, 59, 118, 13210, 13213, 3, 8810, 8402, 59, 3, 8810, 824, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8655, 4, 2, 68, 100, 13235, 13241, 97, 115, 104, 59, 1, 8879, 97, 115, 104, 59, 1, 8878, 4, 5, 98, 99, 110, 112, 116, 13259, 13264, 13270, 13275, 13308, 108, 97, 59, 1, 8711, 117, 116, 101, 59, 1, 324, 103, 59, 3, 8736, 8402, 4, 5, 59, 69, 105, 111, 112, 13287, 13289, 13293, 13298, 13302, 1, 8777, 59, 3, 10864, 824, 100, 59, 3, 8779, 824, 115, 59, 1, 329, 114, 111, 120, 59, 1, 8777, 117, 114, 4, 2, 59, 97, 13316, 13318, 1, 9838, 108, 4, 2, 59, 115, 13325, 13327, 1, 9838, 59, 1, 8469, 4, 2, 115, 117, 13336, 13344, 112, 5, 160, 1, 59, 13342, 1, 160, 109, 112, 4, 2, 59, 101, 13352, 13355, 3, 8782, 824, 59, 3, 8783, 824, 4, 5, 97, 101, 111, 117, 121, 13371, 13385, 13391, 13407, 13411, 4, 2, 112, 114, 13377, 13380, 59, 1, 10819, 111, 110, 59, 1, 328, 100, 105, 108, 59, 1, 326, 110, 103, 4, 2, 59, 100, 13399, 13401, 1, 8775, 111, 116, 59, 3, 10861, 824, 112, 59, 1, 10818, 59, 1, 1085, 97, 115, 104, 59, 1, 8211, 4, 7, 59, 65, 97, 100, 113, 115, 120, 13436, 13438, 13443, 13466, 13472, 13478, 13494, 1, 8800, 114, 114, 59, 1, 8663, 114, 4, 2, 104, 114, 13450, 13454, 107, 59, 1, 10532, 4, 2, 59, 111, 13460, 13462, 1, 8599, 119, 59, 1, 8599, 111, 116, 59, 3, 8784, 824, 117, 105, 118, 59, 1, 8802, 4, 2, 101, 105, 13484, 13489, 97, 114, 59, 1, 10536, 109, 59, 3, 8770, 824, 105, 115, 116, 4, 2, 59, 115, 13503, 13505, 1, 8708, 59, 1, 8708, 114, 59, 3, 55349, 56619, 4, 4, 69, 101, 115, 116, 13523, 13527, 13563, 13568, 59, 3, 8807, 824, 4, 3, 59, 113, 115, 13535, 13537, 13559, 1, 8817, 4, 3, 59, 113, 115, 13545, 13547, 13551, 1, 8817, 59, 3, 8807, 824, 108, 97, 110, 116, 59, 3, 10878, 824, 59, 3, 10878, 824, 105, 109, 59, 1, 8821, 4, 2, 59, 114, 13574, 13576, 1, 8815, 59, 1, 8815, 4, 3, 65, 97, 112, 13587, 13592, 13597, 114, 114, 59, 1, 8654, 114, 114, 59, 1, 8622, 97, 114, 59, 1, 10994, 4, 3, 59, 115, 118, 13610, 13612, 13623, 1, 8715, 4, 2, 59, 100, 13618, 13620, 1, 8956, 59, 1, 8954, 59, 1, 8715, 99, 121, 59, 1, 1114, 4, 7, 65, 69, 97, 100, 101, 115, 116, 13647, 13652, 13656, 13661, 13665, 13737, 13742, 114, 114, 59, 1, 8653, 59, 3, 8806, 824, 114, 114, 59, 1, 8602, 114, 59, 1, 8229, 4, 4, 59, 102, 113, 115, 13675, 13677, 13703, 13725, 1, 8816, 116, 4, 2, 97, 114, 13684, 13691, 114, 114, 111, 119, 59, 1, 8602, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8622, 4, 3, 59, 113, 115, 13711, 13713, 13717, 1, 8816, 59, 3, 8806, 824, 108, 97, 110, 116, 59, 3, 10877, 824, 4, 2, 59, 115, 13731, 13734, 3, 10877, 824, 59, 1, 8814, 105, 109, 59, 1, 8820, 4, 2, 59, 114, 13748, 13750, 1, 8814, 105, 4, 2, 59, 101, 13757, 13759, 1, 8938, 59, 1, 8940, 105, 100, 59, 1, 8740, 4, 2, 112, 116, 13773, 13778, 102, 59, 3, 55349, 56671, 5, 172, 3, 59, 105, 110, 13787, 13789, 13829, 1, 172, 110, 4, 4, 59, 69, 100, 118, 13800, 13802, 13806, 13812, 1, 8713, 59, 3, 8953, 824, 111, 116, 59, 3, 8949, 824, 4, 3, 97, 98, 99, 13820, 13823, 13826, 59, 1, 8713, 59, 1, 8951, 59, 1, 8950, 105, 4, 2, 59, 118, 13836, 13838, 1, 8716, 4, 3, 97, 98, 99, 13846, 13849, 13852, 59, 1, 8716, 59, 1, 8958, 59, 1, 8957, 4, 3, 97, 111, 114, 13863, 13892, 13899, 114, 4, 4, 59, 97, 115, 116, 13874, 13876, 13883, 13888, 1, 8742, 108, 108, 101, 108, 59, 1, 8742, 108, 59, 3, 11005, 8421, 59, 3, 8706, 824, 108, 105, 110, 116, 59, 1, 10772, 4, 3, 59, 99, 101, 13907, 13909, 13914, 1, 8832, 117, 101, 59, 1, 8928, 4, 2, 59, 99, 13920, 13923, 3, 10927, 824, 4, 2, 59, 101, 13929, 13931, 1, 8832, 113, 59, 3, 10927, 824, 4, 4, 65, 97, 105, 116, 13946, 13951, 13971, 13982, 114, 114, 59, 1, 8655, 114, 114, 4, 3, 59, 99, 119, 13961, 13963, 13967, 1, 8603, 59, 3, 10547, 824, 59, 3, 8605, 824, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8603, 114, 105, 4, 2, 59, 101, 13990, 13992, 1, 8939, 59, 1, 8941, 4, 7, 99, 104, 105, 109, 112, 113, 117, 14011, 14036, 14060, 14080, 14085, 14090, 14106, 4, 4, 59, 99, 101, 114, 14021, 14023, 14028, 14032, 1, 8833, 117, 101, 59, 1, 8929, 59, 3, 10928, 824, 59, 3, 55349, 56515, 111, 114, 116, 4, 2, 109, 112, 14045, 14050, 105, 100, 59, 1, 8740, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8742, 109, 4, 2, 59, 101, 14067, 14069, 1, 8769, 4, 2, 59, 113, 14075, 14077, 1, 8772, 59, 1, 8772, 105, 100, 59, 1, 8740, 97, 114, 59, 1, 8742, 115, 117, 4, 2, 98, 112, 14098, 14102, 101, 59, 1, 8930, 101, 59, 1, 8931, 4, 3, 98, 99, 112, 14114, 14157, 14171, 4, 4, 59, 69, 101, 115, 14124, 14126, 14130, 14133, 1, 8836, 59, 3, 10949, 824, 59, 1, 8840, 101, 116, 4, 2, 59, 101, 14141, 14144, 3, 8834, 8402, 113, 4, 2, 59, 113, 14151, 14153, 1, 8840, 59, 3, 10949, 824, 99, 4, 2, 59, 101, 14164, 14166, 1, 8833, 113, 59, 3, 10928, 824, 4, 4, 59, 69, 101, 115, 14181, 14183, 14187, 14190, 1, 8837, 59, 3, 10950, 824, 59, 1, 8841, 101, 116, 4, 2, 59, 101, 14198, 14201, 3, 8835, 8402, 113, 4, 2, 59, 113, 14208, 14210, 1, 8841, 59, 3, 10950, 824, 4, 4, 103, 105, 108, 114, 14224, 14228, 14238, 14242, 108, 59, 1, 8825, 108, 100, 101, 5, 241, 1, 59, 14236, 1, 241, 103, 59, 1, 8824, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 14254, 14269, 101, 102, 116, 4, 2, 59, 101, 14263, 14265, 1, 8938, 113, 59, 1, 8940, 105, 103, 104, 116, 4, 2, 59, 101, 14279, 14281, 1, 8939, 113, 59, 1, 8941, 4, 2, 59, 109, 14291, 14293, 1, 957, 4, 3, 59, 101, 115, 14301, 14303, 14308, 1, 35, 114, 111, 59, 1, 8470, 112, 59, 1, 8199, 4, 9, 68, 72, 97, 100, 103, 105, 108, 114, 115, 14332, 14338, 14344, 14349, 14355, 14369, 14376, 14408, 14426, 97, 115, 104, 59, 1, 8877, 97, 114, 114, 59, 1, 10500, 112, 59, 3, 8781, 8402, 97, 115, 104, 59, 1, 8876, 4, 2, 101, 116, 14361, 14365, 59, 3, 8805, 8402, 59, 3, 62, 8402, 110, 102, 105, 110, 59, 1, 10718, 4, 3, 65, 101, 116, 14384, 14389, 14393, 114, 114, 59, 1, 10498, 59, 3, 8804, 8402, 4, 2, 59, 114, 14399, 14402, 3, 60, 8402, 105, 101, 59, 3, 8884, 8402, 4, 2, 65, 116, 14414, 14419, 114, 114, 59, 1, 10499, 114, 105, 101, 59, 3, 8885, 8402, 105, 109, 59, 3, 8764, 8402, 4, 3, 65, 97, 110, 14440, 14445, 14468, 114, 114, 59, 1, 8662, 114, 4, 2, 104, 114, 14452, 14456, 107, 59, 1, 10531, 4, 2, 59, 111, 14462, 14464, 1, 8598, 119, 59, 1, 8598, 101, 97, 114, 59, 1, 10535, 4, 18, 83, 97, 99, 100, 101, 102, 103, 104, 105, 108, 109, 111, 112, 114, 115, 116, 117, 118, 14512, 14515, 14535, 14560, 14597, 14603, 14618, 14643, 14657, 14662, 14701, 14741, 14747, 14769, 14851, 14877, 14907, 14916, 59, 1, 9416, 4, 2, 99, 115, 14521, 14531, 117, 116, 101, 5, 243, 1, 59, 14529, 1, 243, 116, 59, 1, 8859, 4, 2, 105, 121, 14541, 14557, 114, 4, 2, 59, 99, 14548, 14550, 1, 8858, 5, 244, 1, 59, 14555, 1, 244, 59, 1, 1086, 4, 5, 97, 98, 105, 111, 115, 14572, 14577, 14583, 14587, 14591, 115, 104, 59, 1, 8861, 108, 97, 99, 59, 1, 337, 118, 59, 1, 10808, 116, 59, 1, 8857, 111, 108, 100, 59, 1, 10684, 108, 105, 103, 59, 1, 339, 4, 2, 99, 114, 14609, 14614, 105, 114, 59, 1, 10687, 59, 3, 55349, 56620, 4, 3, 111, 114, 116, 14626, 14630, 14640, 110, 59, 1, 731, 97, 118, 101, 5, 242, 1, 59, 14638, 1, 242, 59, 1, 10689, 4, 2, 98, 109, 14649, 14654, 97, 114, 59, 1, 10677, 59, 1, 937, 110, 116, 59, 1, 8750, 4, 4, 97, 99, 105, 116, 14672, 14677, 14693, 14698, 114, 114, 59, 1, 8634, 4, 2, 105, 114, 14683, 14687, 114, 59, 1, 10686, 111, 115, 115, 59, 1, 10683, 110, 101, 59, 1, 8254, 59, 1, 10688, 4, 3, 97, 101, 105, 14709, 14714, 14719, 99, 114, 59, 1, 333, 103, 97, 59, 1, 969, 4, 3, 99, 100, 110, 14727, 14733, 14736, 114, 111, 110, 59, 1, 959, 59, 1, 10678, 117, 115, 59, 1, 8854, 112, 102, 59, 3, 55349, 56672, 4, 3, 97, 101, 108, 14755, 14759, 14764, 114, 59, 1, 10679, 114, 112, 59, 1, 10681, 117, 115, 59, 1, 8853, 4, 7, 59, 97, 100, 105, 111, 115, 118, 14785, 14787, 14792, 14831, 14837, 14841, 14848, 1, 8744, 114, 114, 59, 1, 8635, 4, 4, 59, 101, 102, 109, 14802, 14804, 14817, 14824, 1, 10845, 114, 4, 2, 59, 111, 14811, 14813, 1, 8500, 102, 59, 1, 8500, 5, 170, 1, 59, 14822, 1, 170, 5, 186, 1, 59, 14829, 1, 186, 103, 111, 102, 59, 1, 8886, 114, 59, 1, 10838, 108, 111, 112, 101, 59, 1, 10839, 59, 1, 10843, 4, 3, 99, 108, 111, 14859, 14863, 14873, 114, 59, 1, 8500, 97, 115, 104, 5, 248, 1, 59, 14871, 1, 248, 108, 59, 1, 8856, 105, 4, 2, 108, 109, 14884, 14893, 100, 101, 5, 245, 1, 59, 14891, 1, 245, 101, 115, 4, 2, 59, 97, 14901, 14903, 1, 8855, 115, 59, 1, 10806, 109, 108, 5, 246, 1, 59, 14914, 1, 246, 98, 97, 114, 59, 1, 9021, 4, 12, 97, 99, 101, 102, 104, 105, 108, 109, 111, 114, 115, 117, 14948, 14992, 14996, 15033, 15038, 15068, 15090, 15189, 15192, 15222, 15427, 15441, 114, 4, 4, 59, 97, 115, 116, 14959, 14961, 14976, 14989, 1, 8741, 5, 182, 2, 59, 108, 14968, 14970, 1, 182, 108, 101, 108, 59, 1, 8741, 4, 2, 105, 108, 14982, 14986, 109, 59, 1, 10995, 59, 1, 11005, 59, 1, 8706, 121, 59, 1, 1087, 114, 4, 5, 99, 105, 109, 112, 116, 15009, 15014, 15019, 15024, 15027, 110, 116, 59, 1, 37, 111, 100, 59, 1, 46, 105, 108, 59, 1, 8240, 59, 1, 8869, 101, 110, 107, 59, 1, 8241, 114, 59, 3, 55349, 56621, 4, 3, 105, 109, 111, 15046, 15057, 15063, 4, 2, 59, 118, 15052, 15054, 1, 966, 59, 1, 981, 109, 97, 116, 59, 1, 8499, 110, 101, 59, 1, 9742, 4, 3, 59, 116, 118, 15076, 15078, 15087, 1, 960, 99, 104, 102, 111, 114, 107, 59, 1, 8916, 59, 1, 982, 4, 2, 97, 117, 15096, 15119, 110, 4, 2, 99, 107, 15103, 15115, 107, 4, 2, 59, 104, 15110, 15112, 1, 8463, 59, 1, 8462, 118, 59, 1, 8463, 115, 4, 9, 59, 97, 98, 99, 100, 101, 109, 115, 116, 15140, 15142, 15148, 15151, 15156, 15168, 15171, 15179, 15184, 1, 43, 99, 105, 114, 59, 1, 10787, 59, 1, 8862, 105, 114, 59, 1, 10786, 4, 2, 111, 117, 15162, 15165, 59, 1, 8724, 59, 1, 10789, 59, 1, 10866, 110, 5, 177, 1, 59, 15177, 1, 177, 105, 109, 59, 1, 10790, 119, 111, 59, 1, 10791, 59, 1, 177, 4, 3, 105, 112, 117, 15200, 15208, 15213, 110, 116, 105, 110, 116, 59, 1, 10773, 102, 59, 3, 55349, 56673, 110, 100, 5, 163, 1, 59, 15220, 1, 163, 4, 10, 59, 69, 97, 99, 101, 105, 110, 111, 115, 117, 15244, 15246, 15249, 15253, 15258, 15334, 15347, 15367, 15416, 15421, 1, 8826, 59, 1, 10931, 112, 59, 1, 10935, 117, 101, 59, 1, 8828, 4, 2, 59, 99, 15264, 15266, 1, 10927, 4, 6, 59, 97, 99, 101, 110, 115, 15280, 15282, 15290, 15299, 15303, 15329, 1, 8826, 112, 112, 114, 111, 120, 59, 1, 10935, 117, 114, 108, 121, 101, 113, 59, 1, 8828, 113, 59, 1, 10927, 4, 3, 97, 101, 115, 15311, 15319, 15324, 112, 112, 114, 111, 120, 59, 1, 10937, 113, 113, 59, 1, 10933, 105, 109, 59, 1, 8936, 105, 109, 59, 1, 8830, 109, 101, 4, 2, 59, 115, 15342, 15344, 1, 8242, 59, 1, 8473, 4, 3, 69, 97, 115, 15355, 15358, 15362, 59, 1, 10933, 112, 59, 1, 10937, 105, 109, 59, 1, 8936, 4, 3, 100, 102, 112, 15375, 15378, 15404, 59, 1, 8719, 4, 3, 97, 108, 115, 15386, 15392, 15398, 108, 97, 114, 59, 1, 9006, 105, 110, 101, 59, 1, 8978, 117, 114, 102, 59, 1, 8979, 4, 2, 59, 116, 15410, 15412, 1, 8733, 111, 59, 1, 8733, 105, 109, 59, 1, 8830, 114, 101, 108, 59, 1, 8880, 4, 2, 99, 105, 15433, 15438, 114, 59, 3, 55349, 56517, 59, 1, 968, 110, 99, 115, 112, 59, 1, 8200, 4, 6, 102, 105, 111, 112, 115, 117, 15462, 15467, 15472, 15478, 15485, 15491, 114, 59, 3, 55349, 56622, 110, 116, 59, 1, 10764, 112, 102, 59, 3, 55349, 56674, 114, 105, 109, 101, 59, 1, 8279, 99, 114, 59, 3, 55349, 56518, 4, 3, 97, 101, 111, 15499, 15520, 15534, 116, 4, 2, 101, 105, 15506, 15515, 114, 110, 105, 111, 110, 115, 59, 1, 8461, 110, 116, 59, 1, 10774, 115, 116, 4, 2, 59, 101, 15528, 15530, 1, 63, 113, 59, 1, 8799, 116, 5, 34, 1, 59, 15540, 1, 34, 4, 21, 65, 66, 72, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 110, 111, 112, 114, 115, 116, 117, 120, 15586, 15609, 15615, 15620, 15796, 15855, 15893, 15931, 15977, 16001, 16039, 16183, 16204, 16222, 16228, 16285, 16312, 16318, 16363, 16408, 16416, 4, 3, 97, 114, 116, 15594, 15599, 15603, 114, 114, 59, 1, 8667, 114, 59, 1, 8658, 97, 105, 108, 59, 1, 10524, 97, 114, 114, 59, 1, 10511, 97, 114, 59, 1, 10596, 4, 7, 99, 100, 101, 110, 113, 114, 116, 15636, 15651, 15656, 15664, 15687, 15696, 15770, 4, 2, 101, 117, 15642, 15646, 59, 3, 8765, 817, 116, 101, 59, 1, 341, 105, 99, 59, 1, 8730, 109, 112, 116, 121, 118, 59, 1, 10675, 103, 4, 4, 59, 100, 101, 108, 15675, 15677, 15680, 15683, 1, 10217, 59, 1, 10642, 59, 1, 10661, 101, 59, 1, 10217, 117, 111, 5, 187, 1, 59, 15694, 1, 187, 114, 4, 11, 59, 97, 98, 99, 102, 104, 108, 112, 115, 116, 119, 15721, 15723, 15727, 15739, 15742, 15746, 15750, 15754, 15758, 15763, 15767, 1, 8594, 112, 59, 1, 10613, 4, 2, 59, 102, 15733, 15735, 1, 8677, 115, 59, 1, 10528, 59, 1, 10547, 115, 59, 1, 10526, 107, 59, 1, 8618, 112, 59, 1, 8620, 108, 59, 1, 10565, 105, 109, 59, 1, 10612, 108, 59, 1, 8611, 59, 1, 8605, 4, 2, 97, 105, 15776, 15781, 105, 108, 59, 1, 10522, 111, 4, 2, 59, 110, 15788, 15790, 1, 8758, 97, 108, 115, 59, 1, 8474, 4, 3, 97, 98, 114, 15804, 15809, 15814, 114, 114, 59, 1, 10509, 114, 107, 59, 1, 10099, 4, 2, 97, 107, 15820, 15833, 99, 4, 2, 101, 107, 15827, 15830, 59, 1, 125, 59, 1, 93, 4, 2, 101, 115, 15839, 15842, 59, 1, 10636, 108, 4, 2, 100, 117, 15849, 15852, 59, 1, 10638, 59, 1, 10640, 4, 4, 97, 101, 117, 121, 15865, 15871, 15886, 15890, 114, 111, 110, 59, 1, 345, 4, 2, 100, 105, 15877, 15882, 105, 108, 59, 1, 343, 108, 59, 1, 8969, 98, 59, 1, 125, 59, 1, 1088, 4, 4, 99, 108, 113, 115, 15903, 15907, 15914, 15927, 97, 59, 1, 10551, 100, 104, 97, 114, 59, 1, 10601, 117, 111, 4, 2, 59, 114, 15922, 15924, 1, 8221, 59, 1, 8221, 104, 59, 1, 8627, 4, 3, 97, 99, 103, 15939, 15966, 15970, 108, 4, 4, 59, 105, 112, 115, 15950, 15952, 15957, 15963, 1, 8476, 110, 101, 59, 1, 8475, 97, 114, 116, 59, 1, 8476, 59, 1, 8477, 116, 59, 1, 9645, 5, 174, 1, 59, 15975, 1, 174, 4, 3, 105, 108, 114, 15985, 15991, 15997, 115, 104, 116, 59, 1, 10621, 111, 111, 114, 59, 1, 8971, 59, 3, 55349, 56623, 4, 2, 97, 111, 16007, 16028, 114, 4, 2, 100, 117, 16014, 16017, 59, 1, 8641, 4, 2, 59, 108, 16023, 16025, 1, 8640, 59, 1, 10604, 4, 2, 59, 118, 16034, 16036, 1, 961, 59, 1, 1009, 4, 3, 103, 110, 115, 16047, 16167, 16171, 104, 116, 4, 6, 97, 104, 108, 114, 115, 116, 16063, 16081, 16103, 16130, 16143, 16155, 114, 114, 111, 119, 4, 2, 59, 116, 16073, 16075, 1, 8594, 97, 105, 108, 59, 1, 8611, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 16093, 16099, 111, 119, 110, 59, 1, 8641, 112, 59, 1, 8640, 101, 102, 116, 4, 2, 97, 104, 16112, 16120, 114, 114, 111, 119, 115, 59, 1, 8644, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8652, 105, 103, 104, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8649, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8605, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8908, 103, 59, 1, 730, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8787, 4, 3, 97, 104, 109, 16191, 16196, 16201, 114, 114, 59, 1, 8644, 97, 114, 59, 1, 8652, 59, 1, 8207, 111, 117, 115, 116, 4, 2, 59, 97, 16214, 16216, 1, 9137, 99, 104, 101, 59, 1, 9137, 109, 105, 100, 59, 1, 10990, 4, 4, 97, 98, 112, 116, 16238, 16252, 16257, 16278, 4, 2, 110, 114, 16244, 16248, 103, 59, 1, 10221, 114, 59, 1, 8702, 114, 107, 59, 1, 10215, 4, 3, 97, 102, 108, 16265, 16269, 16273, 114, 59, 1, 10630, 59, 3, 55349, 56675, 117, 115, 59, 1, 10798, 105, 109, 101, 115, 59, 1, 10805, 4, 2, 97, 112, 16291, 16304, 114, 4, 2, 59, 103, 16298, 16300, 1, 41, 116, 59, 1, 10644, 111, 108, 105, 110, 116, 59, 1, 10770, 97, 114, 114, 59, 1, 8649, 4, 4, 97, 99, 104, 113, 16328, 16334, 16339, 16342, 113, 117, 111, 59, 1, 8250, 114, 59, 3, 55349, 56519, 59, 1, 8625, 4, 2, 98, 117, 16348, 16351, 59, 1, 93, 111, 4, 2, 59, 114, 16358, 16360, 1, 8217, 59, 1, 8217, 4, 3, 104, 105, 114, 16371, 16377, 16383, 114, 101, 101, 59, 1, 8908, 109, 101, 115, 59, 1, 8906, 105, 4, 4, 59, 101, 102, 108, 16394, 16396, 16399, 16402, 1, 9657, 59, 1, 8885, 59, 1, 9656, 116, 114, 105, 59, 1, 10702, 108, 117, 104, 97, 114, 59, 1, 10600, 59, 1, 8478, 4, 19, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 111, 112, 113, 114, 115, 116, 117, 119, 122, 16459, 16466, 16472, 16572, 16590, 16672, 16687, 16746, 16844, 16850, 16924, 16963, 16988, 17115, 17121, 17154, 17206, 17614, 17656, 99, 117, 116, 101, 59, 1, 347, 113, 117, 111, 59, 1, 8218, 4, 10, 59, 69, 97, 99, 101, 105, 110, 112, 115, 121, 16494, 16496, 16499, 16513, 16518, 16531, 16536, 16556, 16564, 16569, 1, 8827, 59, 1, 10932, 4, 2, 112, 114, 16505, 16508, 59, 1, 10936, 111, 110, 59, 1, 353, 117, 101, 59, 1, 8829, 4, 2, 59, 100, 16524, 16526, 1, 10928, 105, 108, 59, 1, 351, 114, 99, 59, 1, 349, 4, 3, 69, 97, 115, 16544, 16547, 16551, 59, 1, 10934, 112, 59, 1, 10938, 105, 109, 59, 1, 8937, 111, 108, 105, 110, 116, 59, 1, 10771, 105, 109, 59, 1, 8831, 59, 1, 1089, 111, 116, 4, 3, 59, 98, 101, 16582, 16584, 16587, 1, 8901, 59, 1, 8865, 59, 1, 10854, 4, 7, 65, 97, 99, 109, 115, 116, 120, 16606, 16611, 16634, 16642, 16646, 16652, 16668, 114, 114, 59, 1, 8664, 114, 4, 2, 104, 114, 16618, 16622, 107, 59, 1, 10533, 4, 2, 59, 111, 16628, 16630, 1, 8600, 119, 59, 1, 8600, 116, 5, 167, 1, 59, 16640, 1, 167, 105, 59, 1, 59, 119, 97, 114, 59, 1, 10537, 109, 4, 2, 105, 110, 16659, 16665, 110, 117, 115, 59, 1, 8726, 59, 1, 8726, 116, 59, 1, 10038, 114, 4, 2, 59, 111, 16679, 16682, 3, 55349, 56624, 119, 110, 59, 1, 8994, 4, 4, 97, 99, 111, 121, 16697, 16702, 16716, 16739, 114, 112, 59, 1, 9839, 4, 2, 104, 121, 16708, 16713, 99, 121, 59, 1, 1097, 59, 1, 1096, 114, 116, 4, 2, 109, 112, 16724, 16729, 105, 100, 59, 1, 8739, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8741, 5, 173, 1, 59, 16744, 1, 173, 4, 2, 103, 109, 16752, 16770, 109, 97, 4, 3, 59, 102, 118, 16762, 16764, 16767, 1, 963, 59, 1, 962, 59, 1, 962, 4, 8, 59, 100, 101, 103, 108, 110, 112, 114, 16788, 16790, 16795, 16806, 16817, 16828, 16832, 16838, 1, 8764, 111, 116, 59, 1, 10858, 4, 2, 59, 113, 16801, 16803, 1, 8771, 59, 1, 8771, 4, 2, 59, 69, 16812, 16814, 1, 10910, 59, 1, 10912, 4, 2, 59, 69, 16823, 16825, 1, 10909, 59, 1, 10911, 101, 59, 1, 8774, 108, 117, 115, 59, 1, 10788, 97, 114, 114, 59, 1, 10610, 97, 114, 114, 59, 1, 8592, 4, 4, 97, 101, 105, 116, 16860, 16883, 16891, 16904, 4, 2, 108, 115, 16866, 16878, 108, 115, 101, 116, 109, 105, 110, 117, 115, 59, 1, 8726, 104, 112, 59, 1, 10803, 112, 97, 114, 115, 108, 59, 1, 10724, 4, 2, 100, 108, 16897, 16900, 59, 1, 8739, 101, 59, 1, 8995, 4, 2, 59, 101, 16910, 16912, 1, 10922, 4, 2, 59, 115, 16918, 16920, 1, 10924, 59, 3, 10924, 65024, 4, 3, 102, 108, 112, 16932, 16938, 16958, 116, 99, 121, 59, 1, 1100, 4, 2, 59, 98, 16944, 16946, 1, 47, 4, 2, 59, 97, 16952, 16954, 1, 10692, 114, 59, 1, 9023, 102, 59, 3, 55349, 56676, 97, 4, 2, 100, 114, 16970, 16985, 101, 115, 4, 2, 59, 117, 16978, 16980, 1, 9824, 105, 116, 59, 1, 9824, 59, 1, 8741, 4, 3, 99, 115, 117, 16996, 17028, 17089, 4, 2, 97, 117, 17002, 17015, 112, 4, 2, 59, 115, 17009, 17011, 1, 8851, 59, 3, 8851, 65024, 112, 4, 2, 59, 115, 17022, 17024, 1, 8852, 59, 3, 8852, 65024, 117, 4, 2, 98, 112, 17035, 17062, 4, 3, 59, 101, 115, 17043, 17045, 17048, 1, 8847, 59, 1, 8849, 101, 116, 4, 2, 59, 101, 17056, 17058, 1, 8847, 113, 59, 1, 8849, 4, 3, 59, 101, 115, 17070, 17072, 17075, 1, 8848, 59, 1, 8850, 101, 116, 4, 2, 59, 101, 17083, 17085, 1, 8848, 113, 59, 1, 8850, 4, 3, 59, 97, 102, 17097, 17099, 17112, 1, 9633, 114, 4, 2, 101, 102, 17106, 17109, 59, 1, 9633, 59, 1, 9642, 59, 1, 9642, 97, 114, 114, 59, 1, 8594, 4, 4, 99, 101, 109, 116, 17131, 17136, 17142, 17148, 114, 59, 3, 55349, 56520, 116, 109, 110, 59, 1, 8726, 105, 108, 101, 59, 1, 8995, 97, 114, 102, 59, 1, 8902, 4, 2, 97, 114, 17160, 17172, 114, 4, 2, 59, 102, 17167, 17169, 1, 9734, 59, 1, 9733, 4, 2, 97, 110, 17178, 17202, 105, 103, 104, 116, 4, 2, 101, 112, 17188, 17197, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 104, 105, 59, 1, 981, 115, 59, 1, 175, 4, 5, 98, 99, 109, 110, 112, 17218, 17351, 17420, 17423, 17427, 4, 9, 59, 69, 100, 101, 109, 110, 112, 114, 115, 17238, 17240, 17243, 17248, 17261, 17267, 17279, 17285, 17291, 1, 8834, 59, 1, 10949, 111, 116, 59, 1, 10941, 4, 2, 59, 100, 17254, 17256, 1, 8838, 111, 116, 59, 1, 10947, 117, 108, 116, 59, 1, 10945, 4, 2, 69, 101, 17273, 17276, 59, 1, 10955, 59, 1, 8842, 108, 117, 115, 59, 1, 10943, 97, 114, 114, 59, 1, 10617, 4, 3, 101, 105, 117, 17299, 17335, 17339, 116, 4, 3, 59, 101, 110, 17308, 17310, 17322, 1, 8834, 113, 4, 2, 59, 113, 17317, 17319, 1, 8838, 59, 1, 10949, 101, 113, 4, 2, 59, 113, 17330, 17332, 1, 8842, 59, 1, 10955, 109, 59, 1, 10951, 4, 2, 98, 112, 17345, 17348, 59, 1, 10965, 59, 1, 10963, 99, 4, 6, 59, 97, 99, 101, 110, 115, 17366, 17368, 17376, 17385, 17389, 17415, 1, 8827, 112, 112, 114, 111, 120, 59, 1, 10936, 117, 114, 108, 121, 101, 113, 59, 1, 8829, 113, 59, 1, 10928, 4, 3, 97, 101, 115, 17397, 17405, 17410, 112, 112, 114, 111, 120, 59, 1, 10938, 113, 113, 59, 1, 10934, 105, 109, 59, 1, 8937, 105, 109, 59, 1, 8831, 59, 1, 8721, 103, 59, 1, 9834, 4, 13, 49, 50, 51, 59, 69, 100, 101, 104, 108, 109, 110, 112, 115, 17455, 17462, 17469, 17476, 17478, 17481, 17496, 17509, 17524, 17530, 17536, 17548, 17554, 5, 185, 1, 59, 17460, 1, 185, 5, 178, 1, 59, 17467, 1, 178, 5, 179, 1, 59, 17474, 1, 179, 1, 8835, 59, 1, 10950, 4, 2, 111, 115, 17487, 17491, 116, 59, 1, 10942, 117, 98, 59, 1, 10968, 4, 2, 59, 100, 17502, 17504, 1, 8839, 111, 116, 59, 1, 10948, 115, 4, 2, 111, 117, 17516, 17520, 108, 59, 1, 10185, 98, 59, 1, 10967, 97, 114, 114, 59, 1, 10619, 117, 108, 116, 59, 1, 10946, 4, 2, 69, 101, 17542, 17545, 59, 1, 10956, 59, 1, 8843, 108, 117, 115, 59, 1, 10944, 4, 3, 101, 105, 117, 17562, 17598, 17602, 116, 4, 3, 59, 101, 110, 17571, 17573, 17585, 1, 8835, 113, 4, 2, 59, 113, 17580, 17582, 1, 8839, 59, 1, 10950, 101, 113, 4, 2, 59, 113, 17593, 17595, 1, 8843, 59, 1, 10956, 109, 59, 1, 10952, 4, 2, 98, 112, 17608, 17611, 59, 1, 10964, 59, 1, 10966, 4, 3, 65, 97, 110, 17622, 17627, 17650, 114, 114, 59, 1, 8665, 114, 4, 2, 104, 114, 17634, 17638, 107, 59, 1, 10534, 4, 2, 59, 111, 17644, 17646, 1, 8601, 119, 59, 1, 8601, 119, 97, 114, 59, 1, 10538, 108, 105, 103, 5, 223, 1, 59, 17664, 1, 223, 4, 13, 97, 98, 99, 100, 101, 102, 104, 105, 111, 112, 114, 115, 119, 17694, 17709, 17714, 17737, 17742, 17749, 17754, 17860, 17905, 17957, 17964, 18090, 18122, 4, 2, 114, 117, 17700, 17706, 103, 101, 116, 59, 1, 8982, 59, 1, 964, 114, 107, 59, 1, 9140, 4, 3, 97, 101, 121, 17722, 17728, 17734, 114, 111, 110, 59, 1, 357, 100, 105, 108, 59, 1, 355, 59, 1, 1090, 111, 116, 59, 1, 8411, 108, 114, 101, 99, 59, 1, 8981, 114, 59, 3, 55349, 56625, 4, 4, 101, 105, 107, 111, 17764, 17805, 17836, 17851, 4, 2, 114, 116, 17770, 17786, 101, 4, 2, 52, 102, 17777, 17780, 59, 1, 8756, 111, 114, 101, 59, 1, 8756, 97, 4, 3, 59, 115, 118, 17795, 17797, 17802, 1, 952, 121, 109, 59, 1, 977, 59, 1, 977, 4, 2, 99, 110, 17811, 17831, 107, 4, 2, 97, 115, 17818, 17826, 112, 112, 114, 111, 120, 59, 1, 8776, 105, 109, 59, 1, 8764, 115, 112, 59, 1, 8201, 4, 2, 97, 115, 17842, 17846, 112, 59, 1, 8776, 105, 109, 59, 1, 8764, 114, 110, 5, 254, 1, 59, 17858, 1, 254, 4, 3, 108, 109, 110, 17868, 17873, 17901, 100, 101, 59, 1, 732, 101, 115, 5, 215, 3, 59, 98, 100, 17884, 17886, 17898, 1, 215, 4, 2, 59, 97, 17892, 17894, 1, 8864, 114, 59, 1, 10801, 59, 1, 10800, 116, 59, 1, 8749, 4, 3, 101, 112, 115, 17913, 17917, 17953, 97, 59, 1, 10536, 4, 4, 59, 98, 99, 102, 17927, 17929, 17934, 17939, 1, 8868, 111, 116, 59, 1, 9014, 105, 114, 59, 1, 10993, 4, 2, 59, 111, 17945, 17948, 3, 55349, 56677, 114, 107, 59, 1, 10970, 97, 59, 1, 10537, 114, 105, 109, 101, 59, 1, 8244, 4, 3, 97, 105, 112, 17972, 17977, 18082, 100, 101, 59, 1, 8482, 4, 7, 97, 100, 101, 109, 112, 115, 116, 17993, 18051, 18056, 18059, 18066, 18072, 18076, 110, 103, 108, 101, 4, 5, 59, 100, 108, 113, 114, 18009, 18011, 18017, 18032, 18035, 1, 9653, 111, 119, 110, 59, 1, 9663, 101, 102, 116, 4, 2, 59, 101, 18026, 18028, 1, 9667, 113, 59, 1, 8884, 59, 1, 8796, 105, 103, 104, 116, 4, 2, 59, 101, 18045, 18047, 1, 9657, 113, 59, 1, 8885, 111, 116, 59, 1, 9708, 59, 1, 8796, 105, 110, 117, 115, 59, 1, 10810, 108, 117, 115, 59, 1, 10809, 98, 59, 1, 10701, 105, 109, 101, 59, 1, 10811, 101, 122, 105, 117, 109, 59, 1, 9186, 4, 3, 99, 104, 116, 18098, 18111, 18116, 4, 2, 114, 121, 18104, 18108, 59, 3, 55349, 56521, 59, 1, 1094, 99, 121, 59, 1, 1115, 114, 111, 107, 59, 1, 359, 4, 2, 105, 111, 18128, 18133, 120, 116, 59, 1, 8812, 104, 101, 97, 100, 4, 2, 108, 114, 18143, 18154, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8606, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8608, 4, 18, 65, 72, 97, 98, 99, 100, 102, 103, 104, 108, 109, 111, 112, 114, 115, 116, 117, 119, 18204, 18209, 18214, 18234, 18250, 18268, 18292, 18308, 18319, 18343, 18379, 18397, 18413, 18504, 18547, 18553, 18584, 18603, 114, 114, 59, 1, 8657, 97, 114, 59, 1, 10595, 4, 2, 99, 114, 18220, 18230, 117, 116, 101, 5, 250, 1, 59, 18228, 1, 250, 114, 59, 1, 8593, 114, 4, 2, 99, 101, 18241, 18245, 121, 59, 1, 1118, 118, 101, 59, 1, 365, 4, 2, 105, 121, 18256, 18265, 114, 99, 5, 251, 1, 59, 18263, 1, 251, 59, 1, 1091, 4, 3, 97, 98, 104, 18276, 18281, 18287, 114, 114, 59, 1, 8645, 108, 97, 99, 59, 1, 369, 97, 114, 59, 1, 10606, 4, 2, 105, 114, 18298, 18304, 115, 104, 116, 59, 1, 10622, 59, 3, 55349, 56626, 114, 97, 118, 101, 5, 249, 1, 59, 18317, 1, 249, 4, 2, 97, 98, 18325, 18338, 114, 4, 2, 108, 114, 18332, 18335, 59, 1, 8639, 59, 1, 8638, 108, 107, 59, 1, 9600, 4, 2, 99, 116, 18349, 18374, 4, 2, 111, 114, 18355, 18369, 114, 110, 4, 2, 59, 101, 18363, 18365, 1, 8988, 114, 59, 1, 8988, 111, 112, 59, 1, 8975, 114, 105, 59, 1, 9720, 4, 2, 97, 108, 18385, 18390, 99, 114, 59, 1, 363, 5, 168, 1, 59, 18395, 1, 168, 4, 2, 103, 112, 18403, 18408, 111, 110, 59, 1, 371, 102, 59, 3, 55349, 56678, 4, 6, 97, 100, 104, 108, 115, 117, 18427, 18434, 18445, 18470, 18475, 18494, 114, 114, 111, 119, 59, 1, 8593, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8597, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 18457, 18463, 101, 102, 116, 59, 1, 8639, 105, 103, 104, 116, 59, 1, 8638, 117, 115, 59, 1, 8846, 105, 4, 3, 59, 104, 108, 18484, 18486, 18489, 1, 965, 59, 1, 978, 111, 110, 59, 1, 965, 112, 97, 114, 114, 111, 119, 115, 59, 1, 8648, 4, 3, 99, 105, 116, 18512, 18537, 18542, 4, 2, 111, 114, 18518, 18532, 114, 110, 4, 2, 59, 101, 18526, 18528, 1, 8989, 114, 59, 1, 8989, 111, 112, 59, 1, 8974, 110, 103, 59, 1, 367, 114, 105, 59, 1, 9721, 99, 114, 59, 3, 55349, 56522, 4, 3, 100, 105, 114, 18561, 18566, 18572, 111, 116, 59, 1, 8944, 108, 100, 101, 59, 1, 361, 105, 4, 2, 59, 102, 18579, 18581, 1, 9653, 59, 1, 9652, 4, 2, 97, 109, 18590, 18595, 114, 114, 59, 1, 8648, 108, 5, 252, 1, 59, 18601, 1, 252, 97, 110, 103, 108, 101, 59, 1, 10663, 4, 15, 65, 66, 68, 97, 99, 100, 101, 102, 108, 110, 111, 112, 114, 115, 122, 18643, 18648, 18661, 18667, 18847, 18851, 18857, 18904, 18909, 18915, 18931, 18937, 18943, 18949, 18996, 114, 114, 59, 1, 8661, 97, 114, 4, 2, 59, 118, 18656, 18658, 1, 10984, 59, 1, 10985, 97, 115, 104, 59, 1, 8872, 4, 2, 110, 114, 18673, 18679, 103, 114, 116, 59, 1, 10652, 4, 7, 101, 107, 110, 112, 114, 115, 116, 18695, 18704, 18711, 18720, 18742, 18754, 18810, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 97, 112, 112, 97, 59, 1, 1008, 111, 116, 104, 105, 110, 103, 59, 1, 8709, 4, 3, 104, 105, 114, 18728, 18732, 18735, 105, 59, 1, 981, 59, 1, 982, 111, 112, 116, 111, 59, 1, 8733, 4, 2, 59, 104, 18748, 18750, 1, 8597, 111, 59, 1, 1009, 4, 2, 105, 117, 18760, 18766, 103, 109, 97, 59, 1, 962, 4, 2, 98, 112, 18772, 18791, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18784, 18787, 3, 8842, 65024, 59, 3, 10955, 65024, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18803, 18806, 3, 8843, 65024, 59, 3, 10956, 65024, 4, 2, 104, 114, 18816, 18822, 101, 116, 97, 59, 1, 977, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 18834, 18840, 101, 102, 116, 59, 1, 8882, 105, 103, 104, 116, 59, 1, 8883, 121, 59, 1, 1074, 97, 115, 104, 59, 1, 8866, 4, 3, 101, 108, 114, 18865, 18884, 18890, 4, 3, 59, 98, 101, 18873, 18875, 18880, 1, 8744, 97, 114, 59, 1, 8891, 113, 59, 1, 8794, 108, 105, 112, 59, 1, 8942, 4, 2, 98, 116, 18896, 18901, 97, 114, 59, 1, 124, 59, 1, 124, 114, 59, 3, 55349, 56627, 116, 114, 105, 59, 1, 8882, 115, 117, 4, 2, 98, 112, 18923, 18927, 59, 3, 8834, 8402, 59, 3, 8835, 8402, 112, 102, 59, 3, 55349, 56679, 114, 111, 112, 59, 1, 8733, 116, 114, 105, 59, 1, 8883, 4, 2, 99, 117, 18955, 18960, 114, 59, 3, 55349, 56523, 4, 2, 98, 112, 18966, 18981, 110, 4, 2, 69, 101, 18973, 18977, 59, 3, 10955, 65024, 59, 3, 8842, 65024, 110, 4, 2, 69, 101, 18988, 18992, 59, 3, 10956, 65024, 59, 3, 8843, 65024, 105, 103, 122, 97, 103, 59, 1, 10650, 4, 7, 99, 101, 102, 111, 112, 114, 115, 19020, 19026, 19061, 19066, 19072, 19075, 19089, 105, 114, 99, 59, 1, 373, 4, 2, 100, 105, 19032, 19055, 4, 2, 98, 103, 19038, 19043, 97, 114, 59, 1, 10847, 101, 4, 2, 59, 113, 19050, 19052, 1, 8743, 59, 1, 8793, 101, 114, 112, 59, 1, 8472, 114, 59, 3, 55349, 56628, 112, 102, 59, 3, 55349, 56680, 59, 1, 8472, 4, 2, 59, 101, 19081, 19083, 1, 8768, 97, 116, 104, 59, 1, 8768, 99, 114, 59, 3, 55349, 56524, 4, 14, 99, 100, 102, 104, 105, 108, 109, 110, 111, 114, 115, 117, 118, 119, 19125, 19146, 19152, 19157, 19173, 19176, 19192, 19197, 19202, 19236, 19252, 19269, 19286, 19291, 4, 3, 97, 105, 117, 19133, 19137, 19142, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 116, 114, 105, 59, 1, 9661, 114, 59, 3, 55349, 56629, 4, 2, 65, 97, 19163, 19168, 114, 114, 59, 1, 10234, 114, 114, 59, 1, 10231, 59, 1, 958, 4, 2, 65, 97, 19182, 19187, 114, 114, 59, 1, 10232, 114, 114, 59, 1, 10229, 97, 112, 59, 1, 10236, 105, 115, 59, 1, 8955, 4, 3, 100, 112, 116, 19210, 19215, 19230, 111, 116, 59, 1, 10752, 4, 2, 102, 108, 19221, 19225, 59, 3, 55349, 56681, 117, 115, 59, 1, 10753, 105, 109, 101, 59, 1, 10754, 4, 2, 65, 97, 19242, 19247, 114, 114, 59, 1, 10233, 114, 114, 59, 1, 10230, 4, 2, 99, 113, 19258, 19263, 114, 59, 3, 55349, 56525, 99, 117, 112, 59, 1, 10758, 4, 2, 112, 116, 19275, 19281, 108, 117, 115, 59, 1, 10756, 114, 105, 59, 1, 9651, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 19316, 19335, 19349, 19357, 19362, 19367, 19373, 19379, 99, 4, 2, 117, 121, 19323, 19332, 116, 101, 5, 253, 1, 59, 19330, 1, 253, 59, 1, 1103, 4, 2, 105, 121, 19341, 19346, 114, 99, 59, 1, 375, 59, 1, 1099, 110, 5, 165, 1, 59, 19355, 1, 165, 114, 59, 3, 55349, 56630, 99, 121, 59, 1, 1111, 112, 102, 59, 3, 55349, 56682, 99, 114, 59, 3, 55349, 56526, 4, 2, 99, 109, 19385, 19389, 121, 59, 1, 1102, 108, 5, 255, 1, 59, 19395, 1, 255, 4, 10, 97, 99, 100, 101, 102, 104, 105, 111, 115, 119, 19419, 19426, 19441, 19446, 19462, 19467, 19472, 19480, 19486, 19492, 99, 117, 116, 101, 59, 1, 378, 4, 2, 97, 121, 19432, 19438, 114, 111, 110, 59, 1, 382, 59, 1, 1079, 111, 116, 59, 1, 380, 4, 2, 101, 116, 19452, 19458, 116, 114, 102, 59, 1, 8488, 97, 59, 1, 950, 114, 59, 3, 55349, 56631, 99, 121, 59, 1, 1078, 103, 114, 97, 114, 114, 59, 1, 8669, 112, 102, 59, 3, 55349, 56683, 99, 114, 59, 3, 55349, 56527, 4, 2, 106, 110, 19498, 19501, 59, 1, 8205, 106, 59, 1, 8204]);
const tee = JJ, Ur = Ao, Wu = eee, Ne = BD, re = Ur.CODE_POINTS, Ru = Ur.CODE_POINT_SEQUENCES, ree = {
  128: 8364,
  130: 8218,
  131: 402,
  132: 8222,
  133: 8230,
  134: 8224,
  135: 8225,
  136: 710,
  137: 8240,
  138: 352,
  139: 8249,
  140: 338,
  142: 381,
  145: 8216,
  146: 8217,
  147: 8220,
  148: 8221,
  149: 8226,
  150: 8211,
  151: 8212,
  152: 732,
  153: 8482,
  154: 353,
  155: 8250,
  156: 339,
  158: 382,
  159: 376
}, r7 = 1, i7 = 2, n7 = 4, iee = r7 | i7 | n7, ir = "DATA_STATE", Fd = "RCDATA_STATE", U0 = "RAWTEXT_STATE", Bs = "SCRIPT_DATA_STATE", a7 = "PLAINTEXT_STATE", lC = "TAG_OPEN_STATE", uC = "END_TAG_OPEN_STATE", ib = "TAG_NAME_STATE", cC = "RCDATA_LESS_THAN_SIGN_STATE", dC = "RCDATA_END_TAG_OPEN_STATE", pC = "RCDATA_END_TAG_NAME_STATE", hC = "RAWTEXT_LESS_THAN_SIGN_STATE", fC = "RAWTEXT_END_TAG_OPEN_STATE", gC = "RAWTEXT_END_TAG_NAME_STATE", mC = "SCRIPT_DATA_LESS_THAN_SIGN_STATE", vC = "SCRIPT_DATA_END_TAG_OPEN_STATE", kC = "SCRIPT_DATA_END_TAG_NAME_STATE", bC = "SCRIPT_DATA_ESCAPE_START_STATE", _C = "SCRIPT_DATA_ESCAPE_START_DASH_STATE", uo = "SCRIPT_DATA_ESCAPED_STATE", DC = "SCRIPT_DATA_ESCAPED_DASH_STATE", nb = "SCRIPT_DATA_ESCAPED_DASH_DASH_STATE", Df = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE", yC = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE", EC = "SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE", CC = "SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE", As = "SCRIPT_DATA_DOUBLE_ESCAPED_STATE", xC = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE", AC = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE", yf = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE", wC = "SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE", Mo = "BEFORE_ATTRIBUTE_NAME_STATE", Ef = "ATTRIBUTE_NAME_STATE", ab = "AFTER_ATTRIBUTE_NAME_STATE", ob = "BEFORE_ATTRIBUTE_VALUE_STATE", Cf = "ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE", xf = "ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE", Af = "ATTRIBUTE_VALUE_UNQUOTED_STATE", sb = "AFTER_ATTRIBUTE_VALUE_QUOTED_STATE", cl = "SELF_CLOSING_START_TAG_STATE", T0 = "BOGUS_COMMENT_STATE", FC = "MARKUP_DECLARATION_OPEN_STATE", TC = "COMMENT_START_STATE", SC = "COMMENT_START_DASH_STATE", dl = "COMMENT_STATE", IC = "COMMENT_LESS_THAN_SIGN_STATE", BC = "COMMENT_LESS_THAN_SIGN_BANG_STATE", RC = "COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE", OC = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE", wf = "COMMENT_END_DASH_STATE", Ff = "COMMENT_END_STATE", PC = "COMMENT_END_BANG_STATE", NC = "DOCTYPE_STATE", Tf = "BEFORE_DOCTYPE_NAME_STATE", Sf = "DOCTYPE_NAME_STATE", zC = "AFTER_DOCTYPE_NAME_STATE", LC = "AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE", MC = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE", lb = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE", ub = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE", cb = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE", jC = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE", HC = "AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE", $C = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE", S0 = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE", I0 = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE", db = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE", ws = "BOGUS_DOCTYPE_STATE", If = "CDATA_SECTION_STATE", UC = "CDATA_SECTION_BRACKET_STATE", VC = "CDATA_SECTION_END_STATE", vd = "CHARACTER_REFERENCE_STATE", WC = "NAMED_CHARACTER_REFERENCE_STATE", GC = "AMBIGUOS_AMPERSAND_STATE", KC = "NUMERIC_CHARACTER_REFERENCE_STATE", YC = "HEXADEMICAL_CHARACTER_REFERENCE_START_STATE", qC = "DECIMAL_CHARACTER_REFERENCE_START_STATE", QC = "HEXADEMICAL_CHARACTER_REFERENCE_STATE", XC = "DECIMAL_CHARACTER_REFERENCE_STATE", B0 = "NUMERIC_CHARACTER_REFERENCE_END_STATE";
function li(e) {
  return e === re.SPACE || e === re.LINE_FEED || e === re.TABULATION || e === re.FORM_FEED;
}
function e1(e) {
  return e >= re.DIGIT_0 && e <= re.DIGIT_9;
}
function co(e) {
  return e >= re.LATIN_CAPITAL_A && e <= re.LATIN_CAPITAL_Z;
}
function zu(e) {
  return e >= re.LATIN_SMALL_A && e <= re.LATIN_SMALL_Z;
}
function ml(e) {
  return zu(e) || co(e);
}
function pb(e) {
  return ml(e) || e1(e);
}
function o7(e) {
  return e >= re.LATIN_CAPITAL_A && e <= re.LATIN_CAPITAL_F;
}
function s7(e) {
  return e >= re.LATIN_SMALL_A && e <= re.LATIN_SMALL_F;
}
function nee(e) {
  return e1(e) || o7(e) || s7(e);
}
function eg(e) {
  return e + 32;
}
function ki(e) {
  return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode(e >>> 10 & 1023 | 55296) + String.fromCharCode(56320 | e & 1023));
}
function pl(e) {
  return String.fromCharCode(eg(e));
}
function ZC(e, t) {
  const r = Wu[++e];
  let i = ++e, n = i + r - 1;
  for (; i <= n; ) {
    const a = i + n >>> 1, o = Wu[a];
    if (o < t)
      i = a + 1;
    else if (o > t)
      n = a - 1;
    else
      return Wu[a + r];
  }
  return -1;
}
let Ja = class Jn {
  constructor() {
    this.preprocessor = new tee(), this.tokenQueue = [], this.allowCDATA = !1, this.state = ir, this.returnState = "", this.charRefCode = -1, this.tempBuff = [], this.lastStartTagName = "", this.consumedAfterSnapshot = -1, this.active = !1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = null;
  }
  //Errors
  _err() {
  }
  _errOnNextCodePoint(t) {
    this._consume(), this._err(t), this._unconsume();
  }
  //API
  getNextToken() {
    for (; !this.tokenQueue.length && this.active; ) {
      this.consumedAfterSnapshot = 0;
      const t = this._consume();
      this._ensureHibernation() || this[this.state](t);
    }
    return this.tokenQueue.shift();
  }
  write(t, r) {
    this.active = !0, this.preprocessor.write(t, r);
  }
  insertHtmlAtCurrentPos(t) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(t);
  }
  //Hibernation
  _ensureHibernation() {
    if (this.preprocessor.endOfChunkHit) {
      for (; this.consumedAfterSnapshot > 0; this.consumedAfterSnapshot--)
        this.preprocessor.retreat();
      return this.active = !1, this.tokenQueue.push({ type: Jn.HIBERNATION_TOKEN }), !0;
    }
    return !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _unconsume() {
    this.consumedAfterSnapshot--, this.preprocessor.retreat();
  }
  _reconsumeInState(t) {
    this.state = t, this._unconsume();
  }
  _consumeSequenceIfMatch(t, r, i) {
    let n = 0, a = !0;
    const o = t.length;
    let s = 0, l = r, u;
    for (; s < o; s++) {
      if (s > 0 && (l = this._consume(), n++), l === re.EOF) {
        a = !1;
        break;
      }
      if (u = t[s], l !== u && (i || l !== eg(u))) {
        a = !1;
        break;
      }
    }
    if (!a)
      for (; n--; )
        this._unconsume();
    return a;
  }
  //Temp buffer
  _isTempBufferEqualToScriptString() {
    if (this.tempBuff.length !== Ru.SCRIPT_STRING.length)
      return !1;
    for (let t = 0; t < this.tempBuff.length; t++)
      if (this.tempBuff[t] !== Ru.SCRIPT_STRING[t])
        return !1;
    return !0;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: Jn.START_TAG_TOKEN,
      tagName: "",
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: []
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: Jn.END_TAG_TOKEN,
      tagName: "",
      selfClosing: !1,
      attrs: []
    };
  }
  _createCommentToken() {
    this.currentToken = {
      type: Jn.COMMENT_TOKEN,
      data: ""
    };
  }
  _createDoctypeToken(t) {
    this.currentToken = {
      type: Jn.DOCTYPE_TOKEN,
      name: t,
      forceQuirks: !1,
      publicId: null,
      systemId: null
    };
  }
  _createCharacterToken(t, r) {
    this.currentCharacterToken = {
      type: t,
      chars: r
    };
  }
  _createEOFToken() {
    this.currentToken = { type: Jn.EOF_TOKEN };
  }
  //Tag attributes
  _createAttr(t) {
    this.currentAttr = {
      name: t,
      value: ""
    };
  }
  _leaveAttrName(t) {
    Jn.getTokenAttr(this.currentToken, this.currentAttr.name) === null ? this.currentToken.attrs.push(this.currentAttr) : this._err(Ne.duplicateAttribute), this.state = t;
  }
  _leaveAttrValue(t) {
    this.state = t;
  }
  //Token emission
  _emitCurrentToken() {
    this._emitCurrentCharacterToken();
    const t = this.currentToken;
    this.currentToken = null, t.type === Jn.START_TAG_TOKEN ? this.lastStartTagName = t.tagName : t.type === Jn.END_TAG_TOKEN && (t.attrs.length > 0 && this._err(Ne.endTagWithAttributes), t.selfClosing && this._err(Ne.endTagWithTrailingSolidus)), this.tokenQueue.push(t);
  }
  _emitCurrentCharacterToken() {
    this.currentCharacterToken && (this.tokenQueue.push(this.currentCharacterToken), this.currentCharacterToken = null);
  }
  _emitEOFToken() {
    this._createEOFToken(), this._emitCurrentToken();
  }
  //Characters emission
  //OPTIMIZATION: specification uses only one type of character tokens (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)NULL_CHARACTER_TOKEN - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)WHITESPACE_CHARACTER_TOKEN - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)CHARACTER_TOKEN - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(t, r) {
    this.currentCharacterToken && this.currentCharacterToken.type !== t && this._emitCurrentCharacterToken(), this.currentCharacterToken ? this.currentCharacterToken.chars += r : this._createCharacterToken(t, r);
  }
  _emitCodePoint(t) {
    let r = Jn.CHARACTER_TOKEN;
    li(t) ? r = Jn.WHITESPACE_CHARACTER_TOKEN : t === re.NULL && (r = Jn.NULL_CHARACTER_TOKEN), this._appendCharToCurrentCharacterToken(r, ki(t));
  }
  _emitSeveralCodePoints(t) {
    for (let r = 0; r < t.length; r++)
      this._emitCodePoint(t[r]);
  }
  //NOTE: used then we emit character explicitly. This is always a non-whitespace and a non-null character.
  //So we can avoid additional checks here.
  _emitChars(t) {
    this._appendCharToCurrentCharacterToken(Jn.CHARACTER_TOKEN, t);
  }
  // Character reference helpers
  _matchNamedCharacterReference(t) {
    let r = null, i = 1, n = ZC(0, t);
    for (this.tempBuff.push(t); n > -1; ) {
      const a = Wu[n], o = a < iee;
      o && a & r7 && (r = a & i7 ? [Wu[++n], Wu[++n]] : [Wu[++n]], i = 0);
      const l = this._consume();
      if (this.tempBuff.push(l), i++, l === re.EOF)
        break;
      o ? n = a & n7 ? ZC(n, l) : -1 : n = l === a ? ++n : -1;
    }
    for (; i--; )
      this.tempBuff.pop(), this._unconsume();
    return r;
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === Cf || this.returnState === xf || this.returnState === Af;
  }
  _isCharacterReferenceAttributeQuirk(t) {
    if (!t && this._isCharacterReferenceInAttribute()) {
      const r = this._consume();
      return this._unconsume(), r === re.EQUALS_SIGN || pb(r);
    }
    return !1;
  }
  _flushCodePointsConsumedAsCharacterReference() {
    if (this._isCharacterReferenceInAttribute())
      for (let t = 0; t < this.tempBuff.length; t++)
        this.currentAttr.value += ki(this.tempBuff[t]);
    else
      this._emitSeveralCodePoints(this.tempBuff);
    this.tempBuff = [];
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  [ir](t) {
    this.preprocessor.dropParsedChunk(), t === re.LESS_THAN_SIGN ? this.state = lC : t === re.AMPERSAND ? (this.returnState = ir, this.state = vd) : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this._emitCodePoint(t)) : t === re.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  //  RCDATA state
  //------------------------------------------------------------------
  [Fd](t) {
    this.preprocessor.dropParsedChunk(), t === re.AMPERSAND ? (this.returnState = Fd, this.state = vd) : t === re.LESS_THAN_SIGN ? this.state = cC : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this._emitChars(Ur.REPLACEMENT_CHARACTER)) : t === re.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  [U0](t) {
    this.preprocessor.dropParsedChunk(), t === re.LESS_THAN_SIGN ? this.state = hC : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this._emitChars(Ur.REPLACEMENT_CHARACTER)) : t === re.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  // Script data state
  //------------------------------------------------------------------
  [Bs](t) {
    this.preprocessor.dropParsedChunk(), t === re.LESS_THAN_SIGN ? this.state = mC : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this._emitChars(Ur.REPLACEMENT_CHARACTER)) : t === re.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  [a7](t) {
    this.preprocessor.dropParsedChunk(), t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this._emitChars(Ur.REPLACEMENT_CHARACTER)) : t === re.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  // Tag open state
  //------------------------------------------------------------------
  [lC](t) {
    t === re.EXCLAMATION_MARK ? this.state = FC : t === re.SOLIDUS ? this.state = uC : ml(t) ? (this._createStartTagToken(), this._reconsumeInState(ib)) : t === re.QUESTION_MARK ? (this._err(Ne.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(), this._reconsumeInState(T0)) : t === re.EOF ? (this._err(Ne.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken()) : (this._err(Ne.invalidFirstCharacterOfTagName), this._emitChars("<"), this._reconsumeInState(ir));
  }
  // End tag open state
  //------------------------------------------------------------------
  [uC](t) {
    ml(t) ? (this._createEndTagToken(), this._reconsumeInState(ib)) : t === re.GREATER_THAN_SIGN ? (this._err(Ne.missingEndTagName), this.state = ir) : t === re.EOF ? (this._err(Ne.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken()) : (this._err(Ne.invalidFirstCharacterOfTagName), this._createCommentToken(), this._reconsumeInState(T0));
  }
  // Tag name state
  //------------------------------------------------------------------
  [ib](t) {
    li(t) ? this.state = Mo : t === re.SOLIDUS ? this.state = cl : t === re.GREATER_THAN_SIGN ? (this.state = ir, this._emitCurrentToken()) : co(t) ? this.currentToken.tagName += pl(t) : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this.currentToken.tagName += Ur.REPLACEMENT_CHARACTER) : t === re.EOF ? (this._err(Ne.eofInTag), this._emitEOFToken()) : this.currentToken.tagName += ki(t);
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  [cC](t) {
    t === re.SOLIDUS ? (this.tempBuff = [], this.state = dC) : (this._emitChars("<"), this._reconsumeInState(Fd));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  [dC](t) {
    ml(t) ? (this._createEndTagToken(), this._reconsumeInState(pC)) : (this._emitChars("</"), this._reconsumeInState(Fd));
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  [pC](t) {
    if (co(t))
      this.currentToken.tagName += pl(t), this.tempBuff.push(t);
    else if (zu(t))
      this.currentToken.tagName += ki(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (li(t)) {
          this.state = Mo;
          return;
        }
        if (t === re.SOLIDUS) {
          this.state = cl;
          return;
        }
        if (t === re.GREATER_THAN_SIGN) {
          this.state = ir, this._emitCurrentToken();
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(Fd);
    }
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  [hC](t) {
    t === re.SOLIDUS ? (this.tempBuff = [], this.state = fC) : (this._emitChars("<"), this._reconsumeInState(U0));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  [fC](t) {
    ml(t) ? (this._createEndTagToken(), this._reconsumeInState(gC)) : (this._emitChars("</"), this._reconsumeInState(U0));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  [gC](t) {
    if (co(t))
      this.currentToken.tagName += pl(t), this.tempBuff.push(t);
    else if (zu(t))
      this.currentToken.tagName += ki(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (li(t)) {
          this.state = Mo;
          return;
        }
        if (t === re.SOLIDUS) {
          this.state = cl;
          return;
        }
        if (t === re.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = ir;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(U0);
    }
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  [mC](t) {
    t === re.SOLIDUS ? (this.tempBuff = [], this.state = vC) : t === re.EXCLAMATION_MARK ? (this.state = bC, this._emitChars("<!")) : (this._emitChars("<"), this._reconsumeInState(Bs));
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  [vC](t) {
    ml(t) ? (this._createEndTagToken(), this._reconsumeInState(kC)) : (this._emitChars("</"), this._reconsumeInState(Bs));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  [kC](t) {
    if (co(t))
      this.currentToken.tagName += pl(t), this.tempBuff.push(t);
    else if (zu(t))
      this.currentToken.tagName += ki(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (li(t)) {
          this.state = Mo;
          return;
        } else if (t === re.SOLIDUS) {
          this.state = cl;
          return;
        } else if (t === re.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = ir;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(Bs);
    }
  }
  // Script data escape start state
  //------------------------------------------------------------------
  [bC](t) {
    t === re.HYPHEN_MINUS ? (this.state = _C, this._emitChars("-")) : this._reconsumeInState(Bs);
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  [_C](t) {
    t === re.HYPHEN_MINUS ? (this.state = nb, this._emitChars("-")) : this._reconsumeInState(Bs);
  }
  // Script data escaped state
  //------------------------------------------------------------------
  [uo](t) {
    t === re.HYPHEN_MINUS ? (this.state = DC, this._emitChars("-")) : t === re.LESS_THAN_SIGN ? this.state = Df : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this._emitChars(Ur.REPLACEMENT_CHARACTER)) : t === re.EOF ? (this._err(Ne.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : this._emitCodePoint(t);
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  [DC](t) {
    t === re.HYPHEN_MINUS ? (this.state = nb, this._emitChars("-")) : t === re.LESS_THAN_SIGN ? this.state = Df : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this.state = uo, this._emitChars(Ur.REPLACEMENT_CHARACTER)) : t === re.EOF ? (this._err(Ne.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = uo, this._emitCodePoint(t));
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  [nb](t) {
    t === re.HYPHEN_MINUS ? this._emitChars("-") : t === re.LESS_THAN_SIGN ? this.state = Df : t === re.GREATER_THAN_SIGN ? (this.state = Bs, this._emitChars(">")) : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this.state = uo, this._emitChars(Ur.REPLACEMENT_CHARACTER)) : t === re.EOF ? (this._err(Ne.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = uo, this._emitCodePoint(t));
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  [Df](t) {
    t === re.SOLIDUS ? (this.tempBuff = [], this.state = yC) : ml(t) ? (this.tempBuff = [], this._emitChars("<"), this._reconsumeInState(CC)) : (this._emitChars("<"), this._reconsumeInState(uo));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  [yC](t) {
    ml(t) ? (this._createEndTagToken(), this._reconsumeInState(EC)) : (this._emitChars("</"), this._reconsumeInState(uo));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  [EC](t) {
    if (co(t))
      this.currentToken.tagName += pl(t), this.tempBuff.push(t);
    else if (zu(t))
      this.currentToken.tagName += ki(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (li(t)) {
          this.state = Mo;
          return;
        }
        if (t === re.SOLIDUS) {
          this.state = cl;
          return;
        }
        if (t === re.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = ir;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(uo);
    }
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  [CC](t) {
    li(t) || t === re.SOLIDUS || t === re.GREATER_THAN_SIGN ? (this.state = this._isTempBufferEqualToScriptString() ? As : uo, this._emitCodePoint(t)) : co(t) ? (this.tempBuff.push(eg(t)), this._emitCodePoint(t)) : zu(t) ? (this.tempBuff.push(t), this._emitCodePoint(t)) : this._reconsumeInState(uo);
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  [As](t) {
    t === re.HYPHEN_MINUS ? (this.state = xC, this._emitChars("-")) : t === re.LESS_THAN_SIGN ? (this.state = yf, this._emitChars("<")) : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this._emitChars(Ur.REPLACEMENT_CHARACTER)) : t === re.EOF ? (this._err(Ne.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : this._emitCodePoint(t);
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  [xC](t) {
    t === re.HYPHEN_MINUS ? (this.state = AC, this._emitChars("-")) : t === re.LESS_THAN_SIGN ? (this.state = yf, this._emitChars("<")) : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this.state = As, this._emitChars(Ur.REPLACEMENT_CHARACTER)) : t === re.EOF ? (this._err(Ne.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = As, this._emitCodePoint(t));
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  [AC](t) {
    t === re.HYPHEN_MINUS ? this._emitChars("-") : t === re.LESS_THAN_SIGN ? (this.state = yf, this._emitChars("<")) : t === re.GREATER_THAN_SIGN ? (this.state = Bs, this._emitChars(">")) : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this.state = As, this._emitChars(Ur.REPLACEMENT_CHARACTER)) : t === re.EOF ? (this._err(Ne.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = As, this._emitCodePoint(t));
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  [yf](t) {
    t === re.SOLIDUS ? (this.tempBuff = [], this.state = wC, this._emitChars("/")) : this._reconsumeInState(As);
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  [wC](t) {
    li(t) || t === re.SOLIDUS || t === re.GREATER_THAN_SIGN ? (this.state = this._isTempBufferEqualToScriptString() ? uo : As, this._emitCodePoint(t)) : co(t) ? (this.tempBuff.push(eg(t)), this._emitCodePoint(t)) : zu(t) ? (this.tempBuff.push(t), this._emitCodePoint(t)) : this._reconsumeInState(As);
  }
  // Before attribute name state
  //------------------------------------------------------------------
  [Mo](t) {
    li(t) || (t === re.SOLIDUS || t === re.GREATER_THAN_SIGN || t === re.EOF ? this._reconsumeInState(ab) : t === re.EQUALS_SIGN ? (this._err(Ne.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = Ef) : (this._createAttr(""), this._reconsumeInState(Ef)));
  }
  // Attribute name state
  //------------------------------------------------------------------
  [Ef](t) {
    li(t) || t === re.SOLIDUS || t === re.GREATER_THAN_SIGN || t === re.EOF ? (this._leaveAttrName(ab), this._unconsume()) : t === re.EQUALS_SIGN ? this._leaveAttrName(ob) : co(t) ? this.currentAttr.name += pl(t) : t === re.QUOTATION_MARK || t === re.APOSTROPHE || t === re.LESS_THAN_SIGN ? (this._err(Ne.unexpectedCharacterInAttributeName), this.currentAttr.name += ki(t)) : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this.currentAttr.name += Ur.REPLACEMENT_CHARACTER) : this.currentAttr.name += ki(t);
  }
  // After attribute name state
  //------------------------------------------------------------------
  [ab](t) {
    li(t) || (t === re.SOLIDUS ? this.state = cl : t === re.EQUALS_SIGN ? this.state = ob : t === re.GREATER_THAN_SIGN ? (this.state = ir, this._emitCurrentToken()) : t === re.EOF ? (this._err(Ne.eofInTag), this._emitEOFToken()) : (this._createAttr(""), this._reconsumeInState(Ef)));
  }
  // Before attribute value state
  //------------------------------------------------------------------
  [ob](t) {
    li(t) || (t === re.QUOTATION_MARK ? this.state = Cf : t === re.APOSTROPHE ? this.state = xf : t === re.GREATER_THAN_SIGN ? (this._err(Ne.missingAttributeValue), this.state = ir, this._emitCurrentToken()) : this._reconsumeInState(Af));
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  [Cf](t) {
    t === re.QUOTATION_MARK ? this.state = sb : t === re.AMPERSAND ? (this.returnState = Cf, this.state = vd) : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this.currentAttr.value += Ur.REPLACEMENT_CHARACTER) : t === re.EOF ? (this._err(Ne.eofInTag), this._emitEOFToken()) : this.currentAttr.value += ki(t);
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  [xf](t) {
    t === re.APOSTROPHE ? this.state = sb : t === re.AMPERSAND ? (this.returnState = xf, this.state = vd) : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this.currentAttr.value += Ur.REPLACEMENT_CHARACTER) : t === re.EOF ? (this._err(Ne.eofInTag), this._emitEOFToken()) : this.currentAttr.value += ki(t);
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  [Af](t) {
    li(t) ? this._leaveAttrValue(Mo) : t === re.AMPERSAND ? (this.returnState = Af, this.state = vd) : t === re.GREATER_THAN_SIGN ? (this._leaveAttrValue(ir), this._emitCurrentToken()) : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this.currentAttr.value += Ur.REPLACEMENT_CHARACTER) : t === re.QUOTATION_MARK || t === re.APOSTROPHE || t === re.LESS_THAN_SIGN || t === re.EQUALS_SIGN || t === re.GRAVE_ACCENT ? (this._err(Ne.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += ki(t)) : t === re.EOF ? (this._err(Ne.eofInTag), this._emitEOFToken()) : this.currentAttr.value += ki(t);
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  [sb](t) {
    li(t) ? this._leaveAttrValue(Mo) : t === re.SOLIDUS ? this._leaveAttrValue(cl) : t === re.GREATER_THAN_SIGN ? (this._leaveAttrValue(ir), this._emitCurrentToken()) : t === re.EOF ? (this._err(Ne.eofInTag), this._emitEOFToken()) : (this._err(Ne.missingWhitespaceBetweenAttributes), this._reconsumeInState(Mo));
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  [cl](t) {
    t === re.GREATER_THAN_SIGN ? (this.currentToken.selfClosing = !0, this.state = ir, this._emitCurrentToken()) : t === re.EOF ? (this._err(Ne.eofInTag), this._emitEOFToken()) : (this._err(Ne.unexpectedSolidusInTag), this._reconsumeInState(Mo));
  }
  // Bogus comment state
  //------------------------------------------------------------------
  [T0](t) {
    t === re.GREATER_THAN_SIGN ? (this.state = ir, this._emitCurrentToken()) : t === re.EOF ? (this._emitCurrentToken(), this._emitEOFToken()) : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this.currentToken.data += Ur.REPLACEMENT_CHARACTER) : this.currentToken.data += ki(t);
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  [FC](t) {
    this._consumeSequenceIfMatch(Ru.DASH_DASH_STRING, t, !0) ? (this._createCommentToken(), this.state = TC) : this._consumeSequenceIfMatch(Ru.DOCTYPE_STRING, t, !1) ? this.state = NC : this._consumeSequenceIfMatch(Ru.CDATA_START_STRING, t, !0) ? this.allowCDATA ? this.state = If : (this._err(Ne.cdataInHtmlContent), this._createCommentToken(), this.currentToken.data = "[CDATA[", this.state = T0) : this._ensureHibernation() || (this._err(Ne.incorrectlyOpenedComment), this._createCommentToken(), this._reconsumeInState(T0));
  }
  // Comment start state
  //------------------------------------------------------------------
  [TC](t) {
    t === re.HYPHEN_MINUS ? this.state = SC : t === re.GREATER_THAN_SIGN ? (this._err(Ne.abruptClosingOfEmptyComment), this.state = ir, this._emitCurrentToken()) : this._reconsumeInState(dl);
  }
  // Comment start dash state
  //------------------------------------------------------------------
  [SC](t) {
    t === re.HYPHEN_MINUS ? this.state = Ff : t === re.GREATER_THAN_SIGN ? (this._err(Ne.abruptClosingOfEmptyComment), this.state = ir, this._emitCurrentToken()) : t === re.EOF ? (this._err(Ne.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "-", this._reconsumeInState(dl));
  }
  // Comment state
  //------------------------------------------------------------------
  [dl](t) {
    t === re.HYPHEN_MINUS ? this.state = wf : t === re.LESS_THAN_SIGN ? (this.currentToken.data += "<", this.state = IC) : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this.currentToken.data += Ur.REPLACEMENT_CHARACTER) : t === re.EOF ? (this._err(Ne.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.data += ki(t);
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  [IC](t) {
    t === re.EXCLAMATION_MARK ? (this.currentToken.data += "!", this.state = BC) : t === re.LESS_THAN_SIGN ? this.currentToken.data += "!" : this._reconsumeInState(dl);
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  [BC](t) {
    t === re.HYPHEN_MINUS ? this.state = RC : this._reconsumeInState(dl);
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  [RC](t) {
    t === re.HYPHEN_MINUS ? this.state = OC : this._reconsumeInState(wf);
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  [OC](t) {
    t !== re.GREATER_THAN_SIGN && t !== re.EOF && this._err(Ne.nestedComment), this._reconsumeInState(Ff);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  [wf](t) {
    t === re.HYPHEN_MINUS ? this.state = Ff : t === re.EOF ? (this._err(Ne.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "-", this._reconsumeInState(dl));
  }
  // Comment end state
  //------------------------------------------------------------------
  [Ff](t) {
    t === re.GREATER_THAN_SIGN ? (this.state = ir, this._emitCurrentToken()) : t === re.EXCLAMATION_MARK ? this.state = PC : t === re.HYPHEN_MINUS ? this.currentToken.data += "-" : t === re.EOF ? (this._err(Ne.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "--", this._reconsumeInState(dl));
  }
  // Comment end bang state
  //------------------------------------------------------------------
  [PC](t) {
    t === re.HYPHEN_MINUS ? (this.currentToken.data += "--!", this.state = wf) : t === re.GREATER_THAN_SIGN ? (this._err(Ne.incorrectlyClosedComment), this.state = ir, this._emitCurrentToken()) : t === re.EOF ? (this._err(Ne.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "--!", this._reconsumeInState(dl));
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  [NC](t) {
    li(t) ? this.state = Tf : t === re.GREATER_THAN_SIGN ? this._reconsumeInState(Tf) : t === re.EOF ? (this._err(Ne.eofInDoctype), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(Ne.missingWhitespaceBeforeDoctypeName), this._reconsumeInState(Tf));
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  [Tf](t) {
    li(t) || (co(t) ? (this._createDoctypeToken(pl(t)), this.state = Sf) : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this._createDoctypeToken(Ur.REPLACEMENT_CHARACTER), this.state = Sf) : t === re.GREATER_THAN_SIGN ? (this._err(Ne.missingDoctypeName), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = ir) : t === re.EOF ? (this._err(Ne.eofInDoctype), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._createDoctypeToken(ki(t)), this.state = Sf));
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  [Sf](t) {
    li(t) ? this.state = zC : t === re.GREATER_THAN_SIGN ? (this.state = ir, this._emitCurrentToken()) : co(t) ? this.currentToken.name += pl(t) : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this.currentToken.name += Ur.REPLACEMENT_CHARACTER) : t === re.EOF ? (this._err(Ne.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.name += ki(t);
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  [zC](t) {
    li(t) || (t === re.GREATER_THAN_SIGN ? (this.state = ir, this._emitCurrentToken()) : t === re.EOF ? (this._err(Ne.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this._consumeSequenceIfMatch(Ru.PUBLIC_STRING, t, !1) ? this.state = LC : this._consumeSequenceIfMatch(Ru.SYSTEM_STRING, t, !1) ? this.state = HC : this._ensureHibernation() || (this._err(Ne.invalidCharacterSequenceAfterDoctypeName), this.currentToken.forceQuirks = !0, this._reconsumeInState(ws)));
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  [LC](t) {
    li(t) ? this.state = MC : t === re.QUOTATION_MARK ? (this._err(Ne.missingWhitespaceAfterDoctypePublicKeyword), this.currentToken.publicId = "", this.state = lb) : t === re.APOSTROPHE ? (this._err(Ne.missingWhitespaceAfterDoctypePublicKeyword), this.currentToken.publicId = "", this.state = ub) : t === re.GREATER_THAN_SIGN ? (this._err(Ne.missingDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this.state = ir, this._emitCurrentToken()) : t === re.EOF ? (this._err(Ne.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(Ne.missingQuoteBeforeDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(ws));
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  [MC](t) {
    li(t) || (t === re.QUOTATION_MARK ? (this.currentToken.publicId = "", this.state = lb) : t === re.APOSTROPHE ? (this.currentToken.publicId = "", this.state = ub) : t === re.GREATER_THAN_SIGN ? (this._err(Ne.missingDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this.state = ir, this._emitCurrentToken()) : t === re.EOF ? (this._err(Ne.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(Ne.missingQuoteBeforeDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(ws)));
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  [lb](t) {
    t === re.QUOTATION_MARK ? this.state = cb : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this.currentToken.publicId += Ur.REPLACEMENT_CHARACTER) : t === re.GREATER_THAN_SIGN ? (this._err(Ne.abruptDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = ir) : t === re.EOF ? (this._err(Ne.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.publicId += ki(t);
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  [ub](t) {
    t === re.APOSTROPHE ? this.state = cb : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this.currentToken.publicId += Ur.REPLACEMENT_CHARACTER) : t === re.GREATER_THAN_SIGN ? (this._err(Ne.abruptDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = ir) : t === re.EOF ? (this._err(Ne.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.publicId += ki(t);
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  [cb](t) {
    li(t) ? this.state = jC : t === re.GREATER_THAN_SIGN ? (this.state = ir, this._emitCurrentToken()) : t === re.QUOTATION_MARK ? (this._err(Ne.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), this.currentToken.systemId = "", this.state = S0) : t === re.APOSTROPHE ? (this._err(Ne.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), this.currentToken.systemId = "", this.state = I0) : t === re.EOF ? (this._err(Ne.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(Ne.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(ws));
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  [jC](t) {
    li(t) || (t === re.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = ir) : t === re.QUOTATION_MARK ? (this.currentToken.systemId = "", this.state = S0) : t === re.APOSTROPHE ? (this.currentToken.systemId = "", this.state = I0) : t === re.EOF ? (this._err(Ne.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(Ne.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(ws)));
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  [HC](t) {
    li(t) ? this.state = $C : t === re.QUOTATION_MARK ? (this._err(Ne.missingWhitespaceAfterDoctypeSystemKeyword), this.currentToken.systemId = "", this.state = S0) : t === re.APOSTROPHE ? (this._err(Ne.missingWhitespaceAfterDoctypeSystemKeyword), this.currentToken.systemId = "", this.state = I0) : t === re.GREATER_THAN_SIGN ? (this._err(Ne.missingDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this.state = ir, this._emitCurrentToken()) : t === re.EOF ? (this._err(Ne.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(Ne.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(ws));
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  [$C](t) {
    li(t) || (t === re.QUOTATION_MARK ? (this.currentToken.systemId = "", this.state = S0) : t === re.APOSTROPHE ? (this.currentToken.systemId = "", this.state = I0) : t === re.GREATER_THAN_SIGN ? (this._err(Ne.missingDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this.state = ir, this._emitCurrentToken()) : t === re.EOF ? (this._err(Ne.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(Ne.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(ws)));
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  [S0](t) {
    t === re.QUOTATION_MARK ? this.state = db : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this.currentToken.systemId += Ur.REPLACEMENT_CHARACTER) : t === re.GREATER_THAN_SIGN ? (this._err(Ne.abruptDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = ir) : t === re.EOF ? (this._err(Ne.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.systemId += ki(t);
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  [I0](t) {
    t === re.APOSTROPHE ? this.state = db : t === re.NULL ? (this._err(Ne.unexpectedNullCharacter), this.currentToken.systemId += Ur.REPLACEMENT_CHARACTER) : t === re.GREATER_THAN_SIGN ? (this._err(Ne.abruptDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = ir) : t === re.EOF ? (this._err(Ne.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.systemId += ki(t);
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  [db](t) {
    li(t) || (t === re.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = ir) : t === re.EOF ? (this._err(Ne.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(Ne.unexpectedCharacterAfterDoctypeSystemIdentifier), this._reconsumeInState(ws)));
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  [ws](t) {
    t === re.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = ir) : t === re.NULL ? this._err(Ne.unexpectedNullCharacter) : t === re.EOF && (this._emitCurrentToken(), this._emitEOFToken());
  }
  // CDATA section state
  //------------------------------------------------------------------
  [If](t) {
    t === re.RIGHT_SQUARE_BRACKET ? this.state = UC : t === re.EOF ? (this._err(Ne.eofInCdata), this._emitEOFToken()) : this._emitCodePoint(t);
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  [UC](t) {
    t === re.RIGHT_SQUARE_BRACKET ? this.state = VC : (this._emitChars("]"), this._reconsumeInState(If));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  [VC](t) {
    t === re.GREATER_THAN_SIGN ? this.state = ir : t === re.RIGHT_SQUARE_BRACKET ? this._emitChars("]") : (this._emitChars("]]"), this._reconsumeInState(If));
  }
  // Character reference state
  //------------------------------------------------------------------
  [vd](t) {
    this.tempBuff = [re.AMPERSAND], t === re.NUMBER_SIGN ? (this.tempBuff.push(t), this.state = KC) : pb(t) ? this._reconsumeInState(WC) : (this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  // Named character reference state
  //------------------------------------------------------------------
  [WC](t) {
    const r = this._matchNamedCharacterReference(t);
    if (this._ensureHibernation())
      this.tempBuff = [re.AMPERSAND];
    else if (r) {
      const i = this.tempBuff[this.tempBuff.length - 1] === re.SEMICOLON;
      this._isCharacterReferenceAttributeQuirk(i) || (i || this._errOnNextCodePoint(Ne.missingSemicolonAfterCharacterReference), this.tempBuff = r), this._flushCodePointsConsumedAsCharacterReference(), this.state = this.returnState;
    } else
      this._flushCodePointsConsumedAsCharacterReference(), this.state = GC;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  [GC](t) {
    pb(t) ? this._isCharacterReferenceInAttribute() ? this.currentAttr.value += ki(t) : this._emitCodePoint(t) : (t === re.SEMICOLON && this._err(Ne.unknownNamedCharacterReference), this._reconsumeInState(this.returnState));
  }
  // Numeric character reference state
  //------------------------------------------------------------------
  [KC](t) {
    this.charRefCode = 0, t === re.LATIN_SMALL_X || t === re.LATIN_CAPITAL_X ? (this.tempBuff.push(t), this.state = YC) : this._reconsumeInState(qC);
  }
  // Hexademical character reference start state
  //------------------------------------------------------------------
  [YC](t) {
    nee(t) ? this._reconsumeInState(QC) : (this._err(Ne.absenceOfDigitsInNumericCharacterReference), this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  // Decimal character reference start state
  //------------------------------------------------------------------
  [qC](t) {
    e1(t) ? this._reconsumeInState(XC) : (this._err(Ne.absenceOfDigitsInNumericCharacterReference), this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  // Hexademical character reference state
  //------------------------------------------------------------------
  [QC](t) {
    o7(t) ? this.charRefCode = this.charRefCode * 16 + t - 55 : s7(t) ? this.charRefCode = this.charRefCode * 16 + t - 87 : e1(t) ? this.charRefCode = this.charRefCode * 16 + t - 48 : t === re.SEMICOLON ? this.state = B0 : (this._err(Ne.missingSemicolonAfterCharacterReference), this._reconsumeInState(B0));
  }
  // Decimal character reference state
  //------------------------------------------------------------------
  [XC](t) {
    e1(t) ? this.charRefCode = this.charRefCode * 10 + t - 48 : t === re.SEMICOLON ? this.state = B0 : (this._err(Ne.missingSemicolonAfterCharacterReference), this._reconsumeInState(B0));
  }
  // Numeric character reference end state
  //------------------------------------------------------------------
  [B0]() {
    if (this.charRefCode === re.NULL)
      this._err(Ne.nullCharacterReference), this.charRefCode = re.REPLACEMENT_CHARACTER;
    else if (this.charRefCode > 1114111)
      this._err(Ne.characterReferenceOutsideUnicodeRange), this.charRefCode = re.REPLACEMENT_CHARACTER;
    else if (Ur.isSurrogate(this.charRefCode))
      this._err(Ne.surrogateCharacterReference), this.charRefCode = re.REPLACEMENT_CHARACTER;
    else if (Ur.isUndefinedCodePoint(this.charRefCode))
      this._err(Ne.noncharacterCharacterReference);
    else if (Ur.isControlCodePoint(this.charRefCode) || this.charRefCode === re.CARRIAGE_RETURN) {
      this._err(Ne.controlCharacterReference);
      const t = ree[this.charRefCode];
      t && (this.charRefCode = t);
    }
    this.tempBuff = [this.charRefCode], this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState);
  }
};
Ja.CHARACTER_TOKEN = "CHARACTER_TOKEN";
Ja.NULL_CHARACTER_TOKEN = "NULL_CHARACTER_TOKEN";
Ja.WHITESPACE_CHARACTER_TOKEN = "WHITESPACE_CHARACTER_TOKEN";
Ja.START_TAG_TOKEN = "START_TAG_TOKEN";
Ja.END_TAG_TOKEN = "END_TAG_TOKEN";
Ja.COMMENT_TOKEN = "COMMENT_TOKEN";
Ja.DOCTYPE_TOKEN = "DOCTYPE_TOKEN";
Ja.EOF_TOKEN = "EOF_TOKEN";
Ja.HIBERNATION_TOKEN = "HIBERNATION_TOKEN";
Ja.MODE = {
  DATA: ir,
  RCDATA: Fd,
  RAWTEXT: U0,
  SCRIPT_DATA: Bs,
  PLAINTEXT: a7
};
Ja.getTokenAttr = function(e, t) {
  for (let r = e.attrs.length - 1; r >= 0; r--)
    if (e.attrs[r].name === t)
      return e.attrs[r].value;
  return null;
};
var Hm = Ja, wo = {};
const hb = wo.NAMESPACES = {
  HTML: "http://www.w3.org/1999/xhtml",
  MATHML: "http://www.w3.org/1998/Math/MathML",
  SVG: "http://www.w3.org/2000/svg",
  XLINK: "http://www.w3.org/1999/xlink",
  XML: "http://www.w3.org/XML/1998/namespace",
  XMLNS: "http://www.w3.org/2000/xmlns/"
};
wo.ATTRS = {
  TYPE: "type",
  ACTION: "action",
  ENCODING: "encoding",
  PROMPT: "prompt",
  NAME: "name",
  COLOR: "color",
  FACE: "face",
  SIZE: "size"
};
wo.DOCUMENT_MODE = {
  NO_QUIRKS: "no-quirks",
  QUIRKS: "quirks",
  LIMITED_QUIRKS: "limited-quirks"
};
const Xe = wo.TAG_NAMES = {
  A: "a",
  ADDRESS: "address",
  ANNOTATION_XML: "annotation-xml",
  APPLET: "applet",
  AREA: "area",
  ARTICLE: "article",
  ASIDE: "aside",
  B: "b",
  BASE: "base",
  BASEFONT: "basefont",
  BGSOUND: "bgsound",
  BIG: "big",
  BLOCKQUOTE: "blockquote",
  BODY: "body",
  BR: "br",
  BUTTON: "button",
  CAPTION: "caption",
  CENTER: "center",
  CODE: "code",
  COL: "col",
  COLGROUP: "colgroup",
  DD: "dd",
  DESC: "desc",
  DETAILS: "details",
  DIALOG: "dialog",
  DIR: "dir",
  DIV: "div",
  DL: "dl",
  DT: "dt",
  EM: "em",
  EMBED: "embed",
  FIELDSET: "fieldset",
  FIGCAPTION: "figcaption",
  FIGURE: "figure",
  FONT: "font",
  FOOTER: "footer",
  FOREIGN_OBJECT: "foreignObject",
  FORM: "form",
  FRAME: "frame",
  FRAMESET: "frameset",
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  H6: "h6",
  HEAD: "head",
  HEADER: "header",
  HGROUP: "hgroup",
  HR: "hr",
  HTML: "html",
  I: "i",
  IMG: "img",
  IMAGE: "image",
  INPUT: "input",
  IFRAME: "iframe",
  KEYGEN: "keygen",
  LABEL: "label",
  LI: "li",
  LINK: "link",
  LISTING: "listing",
  MAIN: "main",
  MALIGNMARK: "malignmark",
  MARQUEE: "marquee",
  MATH: "math",
  MENU: "menu",
  META: "meta",
  MGLYPH: "mglyph",
  MI: "mi",
  MO: "mo",
  MN: "mn",
  MS: "ms",
  MTEXT: "mtext",
  NAV: "nav",
  NOBR: "nobr",
  NOFRAMES: "noframes",
  NOEMBED: "noembed",
  NOSCRIPT: "noscript",
  OBJECT: "object",
  OL: "ol",
  OPTGROUP: "optgroup",
  OPTION: "option",
  P: "p",
  PARAM: "param",
  PLAINTEXT: "plaintext",
  PRE: "pre",
  RB: "rb",
  RP: "rp",
  RT: "rt",
  RTC: "rtc",
  RUBY: "ruby",
  S: "s",
  SCRIPT: "script",
  SECTION: "section",
  SELECT: "select",
  SOURCE: "source",
  SMALL: "small",
  SPAN: "span",
  STRIKE: "strike",
  STRONG: "strong",
  STYLE: "style",
  SUB: "sub",
  SUMMARY: "summary",
  SUP: "sup",
  TABLE: "table",
  TBODY: "tbody",
  TEMPLATE: "template",
  TEXTAREA: "textarea",
  TFOOT: "tfoot",
  TD: "td",
  TH: "th",
  THEAD: "thead",
  TITLE: "title",
  TR: "tr",
  TRACK: "track",
  TT: "tt",
  U: "u",
  UL: "ul",
  SVG: "svg",
  VAR: "var",
  WBR: "wbr",
  XMP: "xmp"
};
wo.SPECIAL_ELEMENTS = {
  [hb.HTML]: {
    [Xe.ADDRESS]: !0,
    [Xe.APPLET]: !0,
    [Xe.AREA]: !0,
    [Xe.ARTICLE]: !0,
    [Xe.ASIDE]: !0,
    [Xe.BASE]: !0,
    [Xe.BASEFONT]: !0,
    [Xe.BGSOUND]: !0,
    [Xe.BLOCKQUOTE]: !0,
    [Xe.BODY]: !0,
    [Xe.BR]: !0,
    [Xe.BUTTON]: !0,
    [Xe.CAPTION]: !0,
    [Xe.CENTER]: !0,
    [Xe.COL]: !0,
    [Xe.COLGROUP]: !0,
    [Xe.DD]: !0,
    [Xe.DETAILS]: !0,
    [Xe.DIR]: !0,
    [Xe.DIV]: !0,
    [Xe.DL]: !0,
    [Xe.DT]: !0,
    [Xe.EMBED]: !0,
    [Xe.FIELDSET]: !0,
    [Xe.FIGCAPTION]: !0,
    [Xe.FIGURE]: !0,
    [Xe.FOOTER]: !0,
    [Xe.FORM]: !0,
    [Xe.FRAME]: !0,
    [Xe.FRAMESET]: !0,
    [Xe.H1]: !0,
    [Xe.H2]: !0,
    [Xe.H3]: !0,
    [Xe.H4]: !0,
    [Xe.H5]: !0,
    [Xe.H6]: !0,
    [Xe.HEAD]: !0,
    [Xe.HEADER]: !0,
    [Xe.HGROUP]: !0,
    [Xe.HR]: !0,
    [Xe.HTML]: !0,
    [Xe.IFRAME]: !0,
    [Xe.IMG]: !0,
    [Xe.INPUT]: !0,
    [Xe.LI]: !0,
    [Xe.LINK]: !0,
    [Xe.LISTING]: !0,
    [Xe.MAIN]: !0,
    [Xe.MARQUEE]: !0,
    [Xe.MENU]: !0,
    [Xe.META]: !0,
    [Xe.NAV]: !0,
    [Xe.NOEMBED]: !0,
    [Xe.NOFRAMES]: !0,
    [Xe.NOSCRIPT]: !0,
    [Xe.OBJECT]: !0,
    [Xe.OL]: !0,
    [Xe.P]: !0,
    [Xe.PARAM]: !0,
    [Xe.PLAINTEXT]: !0,
    [Xe.PRE]: !0,
    [Xe.SCRIPT]: !0,
    [Xe.SECTION]: !0,
    [Xe.SELECT]: !0,
    [Xe.SOURCE]: !0,
    [Xe.STYLE]: !0,
    [Xe.SUMMARY]: !0,
    [Xe.TABLE]: !0,
    [Xe.TBODY]: !0,
    [Xe.TD]: !0,
    [Xe.TEMPLATE]: !0,
    [Xe.TEXTAREA]: !0,
    [Xe.TFOOT]: !0,
    [Xe.TH]: !0,
    [Xe.THEAD]: !0,
    [Xe.TITLE]: !0,
    [Xe.TR]: !0,
    [Xe.TRACK]: !0,
    [Xe.UL]: !0,
    [Xe.WBR]: !0,
    [Xe.XMP]: !0
  },
  [hb.MATHML]: {
    [Xe.MI]: !0,
    [Xe.MO]: !0,
    [Xe.MN]: !0,
    [Xe.MS]: !0,
    [Xe.MTEXT]: !0,
    [Xe.ANNOTATION_XML]: !0
  },
  [hb.SVG]: {
    [Xe.TITLE]: !0,
    [Xe.FOREIGN_OBJECT]: !0,
    [Xe.DESC]: !0
  }
};
const l7 = wo, et = l7.TAG_NAMES, Vr = l7.NAMESPACES;
function JC(e) {
  switch (e.length) {
    case 1:
      return e === et.P;
    case 2:
      return e === et.RB || e === et.RP || e === et.RT || e === et.DD || e === et.DT || e === et.LI;
    case 3:
      return e === et.RTC;
    case 6:
      return e === et.OPTION;
    case 8:
      return e === et.OPTGROUP;
  }
  return !1;
}
function aee(e) {
  switch (e.length) {
    case 1:
      return e === et.P;
    case 2:
      return e === et.RB || e === et.RP || e === et.RT || e === et.DD || e === et.DT || e === et.LI || e === et.TD || e === et.TH || e === et.TR;
    case 3:
      return e === et.RTC;
    case 5:
      return e === et.TBODY || e === et.TFOOT || e === et.THEAD;
    case 6:
      return e === et.OPTION;
    case 7:
      return e === et.CAPTION;
    case 8:
      return e === et.OPTGROUP || e === et.COLGROUP;
  }
  return !1;
}
function Bf(e, t) {
  switch (e.length) {
    case 2:
      if (e === et.TD || e === et.TH)
        return t === Vr.HTML;
      if (e === et.MI || e === et.MO || e === et.MN || e === et.MS)
        return t === Vr.MATHML;
      break;
    case 4:
      if (e === et.HTML)
        return t === Vr.HTML;
      if (e === et.DESC)
        return t === Vr.SVG;
      break;
    case 5:
      if (e === et.TABLE)
        return t === Vr.HTML;
      if (e === et.MTEXT)
        return t === Vr.MATHML;
      if (e === et.TITLE)
        return t === Vr.SVG;
      break;
    case 6:
      return (e === et.APPLET || e === et.OBJECT) && t === Vr.HTML;
    case 7:
      return (e === et.CAPTION || e === et.MARQUEE) && t === Vr.HTML;
    case 8:
      return e === et.TEMPLATE && t === Vr.HTML;
    case 13:
      return e === et.FOREIGN_OBJECT && t === Vr.SVG;
    case 14:
      return e === et.ANNOTATION_XML && t === Vr.MATHML;
  }
  return !1;
}
let oee = class {
  constructor(t, r) {
    this.stackTop = -1, this.items = [], this.current = t, this.currentTagName = null, this.currentTmplContent = null, this.tmplCount = 0, this.treeAdapter = r;
  }
  //Index of element
  _indexOf(t) {
    let r = -1;
    for (let i = this.stackTop; i >= 0; i--)
      if (this.items[i] === t) {
        r = i;
        break;
      }
    return r;
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagName === et.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === Vr.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagName = this.current && this.treeAdapter.getTagName(this.current), this.currentTmplContent = this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : null;
  }
  //Mutations
  push(t) {
    this.items[++this.stackTop] = t, this._updateCurrentElement(), this._isInTemplate() && this.tmplCount++;
  }
  pop() {
    this.stackTop--, this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this._updateCurrentElement();
  }
  replace(t, r) {
    const i = this._indexOf(t);
    this.items[i] = r, i === this.stackTop && this._updateCurrentElement();
  }
  insertAfter(t, r) {
    const i = this._indexOf(t) + 1;
    this.items.splice(i, 0, r), i === ++this.stackTop && this._updateCurrentElement();
  }
  popUntilTagNamePopped(t) {
    for (; this.stackTop > -1; ) {
      const r = this.currentTagName, i = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), r === t && i === Vr.HTML)
        break;
    }
  }
  popUntilElementPopped(t) {
    for (; this.stackTop > -1; ) {
      const r = this.current;
      if (this.pop(), r === t)
        break;
    }
  }
  popUntilNumberedHeaderPopped() {
    for (; this.stackTop > -1; ) {
      const t = this.currentTagName, r = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), t === et.H1 || t === et.H2 || t === et.H3 || t === et.H4 || t === et.H5 || t === et.H6 && r === Vr.HTML)
        break;
    }
  }
  popUntilTableCellPopped() {
    for (; this.stackTop > -1; ) {
      const t = this.currentTagName, r = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), t === et.TD || t === et.TH && r === Vr.HTML)
        break;
    }
  }
  popAllUpToHtmlElement() {
    this.stackTop = 0, this._updateCurrentElement();
  }
  clearBackToTableContext() {
    for (; this.currentTagName !== et.TABLE && this.currentTagName !== et.TEMPLATE && this.currentTagName !== et.HTML || this.treeAdapter.getNamespaceURI(this.current) !== Vr.HTML; )
      this.pop();
  }
  clearBackToTableBodyContext() {
    for (; this.currentTagName !== et.TBODY && this.currentTagName !== et.TFOOT && this.currentTagName !== et.THEAD && this.currentTagName !== et.TEMPLATE && this.currentTagName !== et.HTML || this.treeAdapter.getNamespaceURI(this.current) !== Vr.HTML; )
      this.pop();
  }
  clearBackToTableRowContext() {
    for (; this.currentTagName !== et.TR && this.currentTagName !== et.TEMPLATE && this.currentTagName !== et.HTML || this.treeAdapter.getNamespaceURI(this.current) !== Vr.HTML; )
      this.pop();
  }
  remove(t) {
    for (let r = this.stackTop; r >= 0; r--)
      if (this.items[r] === t) {
        this.items.splice(r, 1), this.stackTop--, this._updateCurrentElement();
        break;
      }
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    const t = this.items[1];
    return t && this.treeAdapter.getTagName(t) === et.BODY ? t : null;
  }
  contains(t) {
    return this._indexOf(t) > -1;
  }
  getCommonAncestor(t) {
    let r = this._indexOf(t);
    return --r >= 0 ? this.items[r] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.currentTagName === et.HTML;
  }
  //Element in scope
  hasInScope(t) {
    for (let r = this.stackTop; r >= 0; r--) {
      const i = this.treeAdapter.getTagName(this.items[r]), n = this.treeAdapter.getNamespaceURI(this.items[r]);
      if (i === t && n === Vr.HTML)
        return !0;
      if (Bf(i, n))
        return !1;
    }
    return !0;
  }
  hasNumberedHeaderInScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const r = this.treeAdapter.getTagName(this.items[t]), i = this.treeAdapter.getNamespaceURI(this.items[t]);
      if ((r === et.H1 || r === et.H2 || r === et.H3 || r === et.H4 || r === et.H5 || r === et.H6) && i === Vr.HTML)
        return !0;
      if (Bf(r, i))
        return !1;
    }
    return !0;
  }
  hasInListItemScope(t) {
    for (let r = this.stackTop; r >= 0; r--) {
      const i = this.treeAdapter.getTagName(this.items[r]), n = this.treeAdapter.getNamespaceURI(this.items[r]);
      if (i === t && n === Vr.HTML)
        return !0;
      if ((i === et.UL || i === et.OL) && n === Vr.HTML || Bf(i, n))
        return !1;
    }
    return !0;
  }
  hasInButtonScope(t) {
    for (let r = this.stackTop; r >= 0; r--) {
      const i = this.treeAdapter.getTagName(this.items[r]), n = this.treeAdapter.getNamespaceURI(this.items[r]);
      if (i === t && n === Vr.HTML)
        return !0;
      if (i === et.BUTTON && n === Vr.HTML || Bf(i, n))
        return !1;
    }
    return !0;
  }
  hasInTableScope(t) {
    for (let r = this.stackTop; r >= 0; r--) {
      const i = this.treeAdapter.getTagName(this.items[r]);
      if (this.treeAdapter.getNamespaceURI(this.items[r]) === Vr.HTML) {
        if (i === t)
          return !0;
        if (i === et.TABLE || i === et.TEMPLATE || i === et.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const r = this.treeAdapter.getTagName(this.items[t]);
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === Vr.HTML) {
        if (r === et.TBODY || r === et.THEAD || r === et.TFOOT)
          return !0;
        if (r === et.TABLE || r === et.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasInSelectScope(t) {
    for (let r = this.stackTop; r >= 0; r--) {
      const i = this.treeAdapter.getTagName(this.items[r]);
      if (this.treeAdapter.getNamespaceURI(this.items[r]) === Vr.HTML) {
        if (i === t)
          return !0;
        if (i !== et.OPTION && i !== et.OPTGROUP)
          return !1;
      }
    }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; JC(this.currentTagName); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; aee(this.currentTagName); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(t) {
    for (; JC(this.currentTagName) && this.currentTagName !== t; )
      this.pop();
  }
};
var see = oee;
const Rf = 3;
let RD = class vl {
  constructor(t) {
    this.length = 0, this.entries = [], this.treeAdapter = t, this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(t) {
    const r = [];
    if (this.length >= Rf) {
      const i = this.treeAdapter.getAttrList(t).length, n = this.treeAdapter.getTagName(t), a = this.treeAdapter.getNamespaceURI(t);
      for (let o = this.length - 1; o >= 0; o--) {
        const s = this.entries[o];
        if (s.type === vl.MARKER_ENTRY)
          break;
        const l = s.element, u = this.treeAdapter.getAttrList(l);
        this.treeAdapter.getTagName(l) === n && this.treeAdapter.getNamespaceURI(l) === a && u.length === i && r.push({ idx: o, attrs: u });
      }
    }
    return r.length < Rf ? [] : r;
  }
  _ensureNoahArkCondition(t) {
    const r = this._getNoahArkConditionCandidates(t);
    let i = r.length;
    if (i) {
      const n = this.treeAdapter.getAttrList(t), a = n.length, o = /* @__PURE__ */ Object.create(null);
      for (let s = 0; s < a; s++) {
        const l = n[s];
        o[l.name] = l.value;
      }
      for (let s = 0; s < a; s++)
        for (let l = 0; l < i; l++) {
          const u = r[l].attrs[s];
          if (o[u.name] !== u.value && (r.splice(l, 1), i--), r.length < Rf)
            return;
        }
      for (let s = i - 1; s >= Rf - 1; s--)
        this.entries.splice(r[s].idx, 1), this.length--;
    }
  }
  //Mutations
  insertMarker() {
    this.entries.push({ type: vl.MARKER_ENTRY }), this.length++;
  }
  pushElement(t, r) {
    this._ensureNoahArkCondition(t), this.entries.push({
      type: vl.ELEMENT_ENTRY,
      element: t,
      token: r
    }), this.length++;
  }
  insertElementAfterBookmark(t, r) {
    let i = this.length - 1;
    for (; i >= 0 && this.entries[i] !== this.bookmark; i--)
      ;
    this.entries.splice(i + 1, 0, {
      type: vl.ELEMENT_ENTRY,
      element: t,
      token: r
    }), this.length++;
  }
  removeEntry(t) {
    for (let r = this.length - 1; r >= 0; r--)
      if (this.entries[r] === t) {
        this.entries.splice(r, 1), this.length--;
        break;
      }
  }
  clearToLastMarker() {
    for (; this.length; ) {
      const t = this.entries.pop();
      if (this.length--, t.type === vl.MARKER_ENTRY)
        break;
    }
  }
  //Search
  getElementEntryInScopeWithTagName(t) {
    for (let r = this.length - 1; r >= 0; r--) {
      const i = this.entries[r];
      if (i.type === vl.MARKER_ENTRY)
        return null;
      if (this.treeAdapter.getTagName(i.element) === t)
        return i;
    }
    return null;
  }
  getElementEntry(t) {
    for (let r = this.length - 1; r >= 0; r--) {
      const i = this.entries[r];
      if (i.type === vl.ELEMENT_ENTRY && i.element === t)
        return i;
    }
    return null;
  }
};
RD.MARKER_ENTRY = "MARKER_ENTRY";
RD.ELEMENT_ENTRY = "ELEMENT_ENTRY";
var lee = RD;
let u7 = class {
  constructor(t) {
    const r = {}, i = this._getOverriddenMethods(this, r);
    for (const n of Object.keys(i))
      typeof i[n] == "function" && (r[n] = t[n], t[n] = i[n]);
  }
  _getOverriddenMethods() {
    throw new Error("Not implemented");
  }
};
u7.install = function(e, t, r) {
  e.__mixins || (e.__mixins = []);
  for (let n = 0; n < e.__mixins.length; n++)
    if (e.__mixins[n].constructor === t)
      return e.__mixins[n];
  const i = new t(e, r);
  return e.__mixins.push(i), i;
};
var Ws = u7;
const uee = Ws;
let cee = class extends uee {
  constructor(t) {
    super(t), this.preprocessor = t, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.offset = 0, this.col = 0, this.line = 1;
  }
  _getOverriddenMethods(t, r) {
    return {
      advance() {
        const i = this.pos + 1, n = this.html[i];
        return t.isEol && (t.isEol = !1, t.line++, t.lineStartPos = i), (n === `
` || n === "\r" && this.html[i + 1] !== `
`) && (t.isEol = !0), t.col = i - t.lineStartPos + 1, t.offset = t.droppedBufferSize + i, r.advance.call(this);
      },
      retreat() {
        r.retreat.call(this), t.isEol = !1, t.col = this.pos - t.lineStartPos + 1;
      },
      dropParsedChunk() {
        const i = this.pos;
        r.dropParsedChunk.call(this);
        const n = i - this.pos;
        t.lineStartPos -= n, t.droppedBufferSize += n, t.offset = t.droppedBufferSize + this.pos;
      }
    };
  }
};
var c7 = cee;
const ex = Ws, fb = Hm, dee = c7;
let pee = class extends ex {
  constructor(t) {
    super(t), this.tokenizer = t, this.posTracker = ex.install(t.preprocessor, dee), this.currentAttrLocation = null, this.ctLoc = null;
  }
  _getCurrentLocation() {
    return {
      startLine: this.posTracker.line,
      startCol: this.posTracker.col,
      startOffset: this.posTracker.offset,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
  }
  _attachCurrentAttrLocationInfo() {
    this.currentAttrLocation.endLine = this.posTracker.line, this.currentAttrLocation.endCol = this.posTracker.col, this.currentAttrLocation.endOffset = this.posTracker.offset;
    const t = this.tokenizer.currentToken, r = this.tokenizer.currentAttr;
    t.location.attrs || (t.location.attrs = /* @__PURE__ */ Object.create(null)), t.location.attrs[r.name] = this.currentAttrLocation;
  }
  _getOverriddenMethods(t, r) {
    const i = {
      _createStartTagToken() {
        r._createStartTagToken.call(this), this.currentToken.location = t.ctLoc;
      },
      _createEndTagToken() {
        r._createEndTagToken.call(this), this.currentToken.location = t.ctLoc;
      },
      _createCommentToken() {
        r._createCommentToken.call(this), this.currentToken.location = t.ctLoc;
      },
      _createDoctypeToken(n) {
        r._createDoctypeToken.call(this, n), this.currentToken.location = t.ctLoc;
      },
      _createCharacterToken(n, a) {
        r._createCharacterToken.call(this, n, a), this.currentCharacterToken.location = t.ctLoc;
      },
      _createEOFToken() {
        r._createEOFToken.call(this), this.currentToken.location = t._getCurrentLocation();
      },
      _createAttr(n) {
        r._createAttr.call(this, n), t.currentAttrLocation = t._getCurrentLocation();
      },
      _leaveAttrName(n) {
        r._leaveAttrName.call(this, n), t._attachCurrentAttrLocationInfo();
      },
      _leaveAttrValue(n) {
        r._leaveAttrValue.call(this, n), t._attachCurrentAttrLocationInfo();
      },
      _emitCurrentToken() {
        const n = this.currentToken.location;
        this.currentCharacterToken && (this.currentCharacterToken.location.endLine = n.startLine, this.currentCharacterToken.location.endCol = n.startCol, this.currentCharacterToken.location.endOffset = n.startOffset), this.currentToken.type === fb.EOF_TOKEN ? (n.endLine = n.startLine, n.endCol = n.startCol, n.endOffset = n.startOffset) : (n.endLine = t.posTracker.line, n.endCol = t.posTracker.col + 1, n.endOffset = t.posTracker.offset + 1), r._emitCurrentToken.call(this);
      },
      _emitCurrentCharacterToken() {
        const n = this.currentCharacterToken && this.currentCharacterToken.location;
        n && n.endOffset === -1 && (n.endLine = t.posTracker.line, n.endCol = t.posTracker.col, n.endOffset = t.posTracker.offset), r._emitCurrentCharacterToken.call(this);
      }
    };
    return Object.keys(fb.MODE).forEach((n) => {
      const a = fb.MODE[n];
      i[a] = function(o) {
        t.ctLoc = t._getCurrentLocation(), r[a].call(this, o);
      };
    }), i;
  }
};
var d7 = pee;
const hee = Ws;
let fee = class extends hee {
  constructor(t, r) {
    super(t), this.onItemPop = r.onItemPop;
  }
  _getOverriddenMethods(t, r) {
    return {
      pop() {
        t.onItemPop(this.current), r.pop.call(this);
      },
      popAllUpToHtmlElement() {
        for (let i = this.stackTop; i > 0; i--)
          t.onItemPop(this.items[i]);
        r.popAllUpToHtmlElement.call(this);
      },
      remove(i) {
        t.onItemPop(this.current), r.remove.call(this, i);
      }
    };
  }
};
var gee = fee;
const gb = Ws, tx = Hm, mee = d7, vee = gee, kee = wo, mb = kee.TAG_NAMES;
let bee = class extends gb {
  constructor(t) {
    super(t), this.parser = t, this.treeAdapter = this.parser.treeAdapter, this.posTracker = null, this.lastStartTagToken = null, this.lastFosterParentingLocation = null, this.currentToken = null;
  }
  _setStartLocation(t) {
    let r = null;
    this.lastStartTagToken && (r = Object.assign({}, this.lastStartTagToken.location), r.startTag = this.lastStartTagToken.location), this.treeAdapter.setNodeSourceCodeLocation(t, r);
  }
  _setEndLocation(t, r) {
    if (this.treeAdapter.getNodeSourceCodeLocation(t) && r.location) {
      const n = r.location, a = this.treeAdapter.getTagName(t), o = r.type === tx.END_TAG_TOKEN && a === r.tagName, s = {};
      o ? (s.endTag = Object.assign({}, n), s.endLine = n.endLine, s.endCol = n.endCol, s.endOffset = n.endOffset) : (s.endLine = n.startLine, s.endCol = n.startCol, s.endOffset = n.startOffset), this.treeAdapter.updateNodeSourceCodeLocation(t, s);
    }
  }
  _getOverriddenMethods(t, r) {
    return {
      _bootstrap(i, n) {
        r._bootstrap.call(this, i, n), t.lastStartTagToken = null, t.lastFosterParentingLocation = null, t.currentToken = null;
        const a = gb.install(this.tokenizer, mee);
        t.posTracker = a.posTracker, gb.install(this.openElements, vee, {
          onItemPop: function(o) {
            t._setEndLocation(o, t.currentToken);
          }
        });
      },
      _runParsingLoop(i) {
        r._runParsingLoop.call(this, i);
        for (let n = this.openElements.stackTop; n >= 0; n--)
          t._setEndLocation(this.openElements.items[n], t.currentToken);
      },
      //Token processing
      _processTokenInForeignContent(i) {
        t.currentToken = i, r._processTokenInForeignContent.call(this, i);
      },
      _processToken(i) {
        if (t.currentToken = i, r._processToken.call(this, i), i.type === tx.END_TAG_TOKEN && (i.tagName === mb.HTML || i.tagName === mb.BODY && this.openElements.hasInScope(mb.BODY)))
          for (let a = this.openElements.stackTop; a >= 0; a--) {
            const o = this.openElements.items[a];
            if (this.treeAdapter.getTagName(o) === i.tagName) {
              t._setEndLocation(o, i);
              break;
            }
          }
      },
      //Doctype
      _setDocumentType(i) {
        r._setDocumentType.call(this, i);
        const n = this.treeAdapter.getChildNodes(this.document), a = n.length;
        for (let o = 0; o < a; o++) {
          const s = n[o];
          if (this.treeAdapter.isDocumentTypeNode(s)) {
            this.treeAdapter.setNodeSourceCodeLocation(s, i.location);
            break;
          }
        }
      },
      //Elements
      _attachElementToTree(i) {
        t._setStartLocation(i), t.lastStartTagToken = null, r._attachElementToTree.call(this, i);
      },
      _appendElement(i, n) {
        t.lastStartTagToken = i, r._appendElement.call(this, i, n);
      },
      _insertElement(i, n) {
        t.lastStartTagToken = i, r._insertElement.call(this, i, n);
      },
      _insertTemplate(i) {
        t.lastStartTagToken = i, r._insertTemplate.call(this, i);
        const n = this.treeAdapter.getTemplateContent(this.openElements.current);
        this.treeAdapter.setNodeSourceCodeLocation(n, null);
      },
      _insertFakeRootElement() {
        r._insertFakeRootElement.call(this), this.treeAdapter.setNodeSourceCodeLocation(this.openElements.current, null);
      },
      //Comments
      _appendCommentNode(i, n) {
        r._appendCommentNode.call(this, i, n);
        const a = this.treeAdapter.getChildNodes(n), o = a[a.length - 1];
        this.treeAdapter.setNodeSourceCodeLocation(o, i.location);
      },
      //Text
      _findFosterParentingLocation() {
        return t.lastFosterParentingLocation = r._findFosterParentingLocation.call(this), t.lastFosterParentingLocation;
      },
      _insertCharacters(i) {
        r._insertCharacters.call(this, i);
        const n = this._shouldFosterParentOnInsertion(), a = n && t.lastFosterParentingLocation.parent || this.openElements.currentTmplContent || this.openElements.current, o = this.treeAdapter.getChildNodes(a), s = n && t.lastFosterParentingLocation.beforeElement ? o.indexOf(t.lastFosterParentingLocation.beforeElement) - 1 : o.length - 1, l = o[s];
        if (this.treeAdapter.getNodeSourceCodeLocation(l)) {
          const { endLine: d, endCol: c, endOffset: p } = i.location;
          this.treeAdapter.updateNodeSourceCodeLocation(l, { endLine: d, endCol: c, endOffset: p });
        } else
          this.treeAdapter.setNodeSourceCodeLocation(l, i.location);
      }
    };
  }
};
var _ee = bee;
const Dee = Ws;
let yee = class extends Dee {
  constructor(t, r) {
    super(t), this.posTracker = null, this.onParseError = r.onParseError;
  }
  _setErrorLocation(t) {
    t.startLine = t.endLine = this.posTracker.line, t.startCol = t.endCol = this.posTracker.col, t.startOffset = t.endOffset = this.posTracker.offset;
  }
  _reportError(t) {
    const r = {
      code: t,
      startLine: -1,
      startCol: -1,
      startOffset: -1,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
    this._setErrorLocation(r), this.onParseError(r);
  }
  _getOverriddenMethods(t) {
    return {
      _err(r) {
        t._reportError(r);
      }
    };
  }
};
var OD = yee;
const Eee = OD, Cee = c7, xee = Ws;
let Aee = class extends Eee {
  constructor(t, r) {
    super(t, r), this.posTracker = xee.install(t, Cee), this.lastErrOffset = -1;
  }
  _reportError(t) {
    this.lastErrOffset !== this.posTracker.offset && (this.lastErrOffset = this.posTracker.offset, super._reportError(t));
  }
};
var wee = Aee;
const Fee = OD, Tee = wee, See = Ws;
let Iee = class extends Fee {
  constructor(t, r) {
    super(t, r);
    const i = See.install(t.preprocessor, Tee, r);
    this.posTracker = i.posTracker;
  }
};
var Bee = Iee;
const Ree = OD, Oee = Bee, Pee = d7, rx = Ws;
let Nee = class extends Ree {
  constructor(t, r) {
    super(t, r), this.opts = r, this.ctLoc = null, this.locBeforeToken = !1;
  }
  _setErrorLocation(t) {
    this.ctLoc && (t.startLine = this.ctLoc.startLine, t.startCol = this.ctLoc.startCol, t.startOffset = this.ctLoc.startOffset, t.endLine = this.locBeforeToken ? this.ctLoc.startLine : this.ctLoc.endLine, t.endCol = this.locBeforeToken ? this.ctLoc.startCol : this.ctLoc.endCol, t.endOffset = this.locBeforeToken ? this.ctLoc.startOffset : this.ctLoc.endOffset);
  }
  _getOverriddenMethods(t, r) {
    return {
      _bootstrap(i, n) {
        r._bootstrap.call(this, i, n), rx.install(this.tokenizer, Oee, t.opts), rx.install(this.tokenizer, Pee);
      },
      _processInputToken(i) {
        t.ctLoc = i.location, r._processInputToken.call(this, i);
      },
      _err(i, n) {
        t.locBeforeToken = n && n.beforeToken, t._reportError(i);
      }
    };
  }
};
var zee = Nee, fr = {};
const { DOCUMENT_MODE: Lee } = wo;
fr.createDocument = function() {
  return {
    nodeName: "#document",
    mode: Lee.NO_QUIRKS,
    childNodes: []
  };
};
fr.createDocumentFragment = function() {
  return {
    nodeName: "#document-fragment",
    childNodes: []
  };
};
fr.createElement = function(e, t, r) {
  return {
    nodeName: e,
    tagName: e,
    attrs: r,
    namespaceURI: t,
    childNodes: [],
    parentNode: null
  };
};
fr.createCommentNode = function(e) {
  return {
    nodeName: "#comment",
    data: e,
    parentNode: null
  };
};
const p7 = function(e) {
  return {
    nodeName: "#text",
    value: e,
    parentNode: null
  };
}, h7 = fr.appendChild = function(e, t) {
  e.childNodes.push(t), t.parentNode = e;
}, Mee = fr.insertBefore = function(e, t, r) {
  const i = e.childNodes.indexOf(r);
  e.childNodes.splice(i, 0, t), t.parentNode = e;
};
fr.setTemplateContent = function(e, t) {
  e.content = t;
};
fr.getTemplateContent = function(e) {
  return e.content;
};
fr.setDocumentType = function(e, t, r, i) {
  let n = null;
  for (let a = 0; a < e.childNodes.length; a++)
    if (e.childNodes[a].nodeName === "#documentType") {
      n = e.childNodes[a];
      break;
    }
  n ? (n.name = t, n.publicId = r, n.systemId = i) : h7(e, {
    nodeName: "#documentType",
    name: t,
    publicId: r,
    systemId: i
  });
};
fr.setDocumentMode = function(e, t) {
  e.mode = t;
};
fr.getDocumentMode = function(e) {
  return e.mode;
};
fr.detachNode = function(e) {
  if (e.parentNode) {
    const t = e.parentNode.childNodes.indexOf(e);
    e.parentNode.childNodes.splice(t, 1), e.parentNode = null;
  }
};
fr.insertText = function(e, t) {
  if (e.childNodes.length) {
    const r = e.childNodes[e.childNodes.length - 1];
    if (r.nodeName === "#text") {
      r.value += t;
      return;
    }
  }
  h7(e, p7(t));
};
fr.insertTextBefore = function(e, t, r) {
  const i = e.childNodes[e.childNodes.indexOf(r) - 1];
  i && i.nodeName === "#text" ? i.value += t : Mee(e, p7(t), r);
};
fr.adoptAttributes = function(e, t) {
  const r = [];
  for (let i = 0; i < e.attrs.length; i++)
    r.push(e.attrs[i].name);
  for (let i = 0; i < t.length; i++)
    r.indexOf(t[i].name) === -1 && e.attrs.push(t[i]);
};
fr.getFirstChild = function(e) {
  return e.childNodes[0];
};
fr.getChildNodes = function(e) {
  return e.childNodes;
};
fr.getParentNode = function(e) {
  return e.parentNode;
};
fr.getAttrList = function(e) {
  return e.attrs;
};
fr.getTagName = function(e) {
  return e.tagName;
};
fr.getNamespaceURI = function(e) {
  return e.namespaceURI;
};
fr.getTextNodeContent = function(e) {
  return e.value;
};
fr.getCommentNodeContent = function(e) {
  return e.data;
};
fr.getDocumentTypeNodeName = function(e) {
  return e.name;
};
fr.getDocumentTypeNodePublicId = function(e) {
  return e.publicId;
};
fr.getDocumentTypeNodeSystemId = function(e) {
  return e.systemId;
};
fr.isTextNode = function(e) {
  return e.nodeName === "#text";
};
fr.isCommentNode = function(e) {
  return e.nodeName === "#comment";
};
fr.isDocumentTypeNode = function(e) {
  return e.nodeName === "#documentType";
};
fr.isElementNode = function(e) {
  return !!e.tagName;
};
fr.setNodeSourceCodeLocation = function(e, t) {
  e.sourceCodeLocation = t;
};
fr.getNodeSourceCodeLocation = function(e) {
  return e.sourceCodeLocation;
};
fr.updateNodeSourceCodeLocation = function(e, t) {
  e.sourceCodeLocation = Object.assign(e.sourceCodeLocation, t);
};
var jee = function(t, r) {
  return r = r || /* @__PURE__ */ Object.create(null), [t, r].reduce((i, n) => (Object.keys(n).forEach((a) => {
    i[a] = n[a];
  }), i), /* @__PURE__ */ Object.create(null));
}, $m = {};
const { DOCUMENT_MODE: kd } = wo, f7 = "html", Hee = "about:legacy-compat", $ee = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", g7 = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], Uee = g7.concat([
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
]), Vee = ["-//w3o//dtd w3 html strict 3.0//en//", "-/w3c/dtd html 4.0 transitional/en", "html"], m7 = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], Wee = m7.concat([
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
]);
function ix(e) {
  const t = e.indexOf('"') !== -1 ? "'" : '"';
  return t + e + t;
}
function nx(e, t) {
  for (let r = 0; r < t.length; r++)
    if (e.indexOf(t[r]) === 0)
      return !0;
  return !1;
}
$m.isConforming = function(e) {
  return e.name === f7 && e.publicId === null && (e.systemId === null || e.systemId === Hee);
};
$m.getDocumentMode = function(e) {
  if (e.name !== f7)
    return kd.QUIRKS;
  const t = e.systemId;
  if (t && t.toLowerCase() === $ee)
    return kd.QUIRKS;
  let r = e.publicId;
  if (r !== null) {
    if (r = r.toLowerCase(), Vee.indexOf(r) > -1)
      return kd.QUIRKS;
    let i = t === null ? Uee : g7;
    if (nx(r, i))
      return kd.QUIRKS;
    if (i = t === null ? m7 : Wee, nx(r, i))
      return kd.LIMITED_QUIRKS;
  }
  return kd.NO_QUIRKS;
};
$m.serializeContent = function(e, t, r) {
  let i = "!DOCTYPE ";
  return e && (i += e), t ? i += " PUBLIC " + ix(t) : r && (i += " SYSTEM"), r !== null && (i += " " + ix(r)), i;
};
var Zl = {};
const vb = Hm, PD = wo, Ft = PD.TAG_NAMES, ln = PD.NAMESPACES, tg = PD.ATTRS, ax = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, Gee = "definitionurl", Kee = "definitionURL", Yee = {
  attributename: "attributeName",
  attributetype: "attributeType",
  basefrequency: "baseFrequency",
  baseprofile: "baseProfile",
  calcmode: "calcMode",
  clippathunits: "clipPathUnits",
  diffuseconstant: "diffuseConstant",
  edgemode: "edgeMode",
  filterunits: "filterUnits",
  glyphref: "glyphRef",
  gradienttransform: "gradientTransform",
  gradientunits: "gradientUnits",
  kernelmatrix: "kernelMatrix",
  kernelunitlength: "kernelUnitLength",
  keypoints: "keyPoints",
  keysplines: "keySplines",
  keytimes: "keyTimes",
  lengthadjust: "lengthAdjust",
  limitingconeangle: "limitingConeAngle",
  markerheight: "markerHeight",
  markerunits: "markerUnits",
  markerwidth: "markerWidth",
  maskcontentunits: "maskContentUnits",
  maskunits: "maskUnits",
  numoctaves: "numOctaves",
  pathlength: "pathLength",
  patterncontentunits: "patternContentUnits",
  patterntransform: "patternTransform",
  patternunits: "patternUnits",
  pointsatx: "pointsAtX",
  pointsaty: "pointsAtY",
  pointsatz: "pointsAtZ",
  preservealpha: "preserveAlpha",
  preserveaspectratio: "preserveAspectRatio",
  primitiveunits: "primitiveUnits",
  refx: "refX",
  refy: "refY",
  repeatcount: "repeatCount",
  repeatdur: "repeatDur",
  requiredextensions: "requiredExtensions",
  requiredfeatures: "requiredFeatures",
  specularconstant: "specularConstant",
  specularexponent: "specularExponent",
  spreadmethod: "spreadMethod",
  startoffset: "startOffset",
  stddeviation: "stdDeviation",
  stitchtiles: "stitchTiles",
  surfacescale: "surfaceScale",
  systemlanguage: "systemLanguage",
  tablevalues: "tableValues",
  targetx: "targetX",
  targety: "targetY",
  textlength: "textLength",
  viewbox: "viewBox",
  viewtarget: "viewTarget",
  xchannelselector: "xChannelSelector",
  ychannelselector: "yChannelSelector",
  zoomandpan: "zoomAndPan"
}, qee = {
  "xlink:actuate": { prefix: "xlink", name: "actuate", namespace: ln.XLINK },
  "xlink:arcrole": { prefix: "xlink", name: "arcrole", namespace: ln.XLINK },
  "xlink:href": { prefix: "xlink", name: "href", namespace: ln.XLINK },
  "xlink:role": { prefix: "xlink", name: "role", namespace: ln.XLINK },
  "xlink:show": { prefix: "xlink", name: "show", namespace: ln.XLINK },
  "xlink:title": { prefix: "xlink", name: "title", namespace: ln.XLINK },
  "xlink:type": { prefix: "xlink", name: "type", namespace: ln.XLINK },
  "xml:base": { prefix: "xml", name: "base", namespace: ln.XML },
  "xml:lang": { prefix: "xml", name: "lang", namespace: ln.XML },
  "xml:space": { prefix: "xml", name: "space", namespace: ln.XML },
  xmlns: { prefix: "", name: "xmlns", namespace: ln.XMLNS },
  "xmlns:xlink": { prefix: "xmlns", name: "xlink", namespace: ln.XMLNS }
}, Qee = Zl.SVG_TAG_NAMES_ADJUSTMENT_MAP = {
  altglyph: "altGlyph",
  altglyphdef: "altGlyphDef",
  altglyphitem: "altGlyphItem",
  animatecolor: "animateColor",
  animatemotion: "animateMotion",
  animatetransform: "animateTransform",
  clippath: "clipPath",
  feblend: "feBlend",
  fecolormatrix: "feColorMatrix",
  fecomponenttransfer: "feComponentTransfer",
  fecomposite: "feComposite",
  feconvolvematrix: "feConvolveMatrix",
  fediffuselighting: "feDiffuseLighting",
  fedisplacementmap: "feDisplacementMap",
  fedistantlight: "feDistantLight",
  feflood: "feFlood",
  fefunca: "feFuncA",
  fefuncb: "feFuncB",
  fefuncg: "feFuncG",
  fefuncr: "feFuncR",
  fegaussianblur: "feGaussianBlur",
  feimage: "feImage",
  femerge: "feMerge",
  femergenode: "feMergeNode",
  femorphology: "feMorphology",
  feoffset: "feOffset",
  fepointlight: "fePointLight",
  fespecularlighting: "feSpecularLighting",
  fespotlight: "feSpotLight",
  fetile: "feTile",
  feturbulence: "feTurbulence",
  foreignobject: "foreignObject",
  glyphref: "glyphRef",
  lineargradient: "linearGradient",
  radialgradient: "radialGradient",
  textpath: "textPath"
}, Xee = {
  [Ft.B]: !0,
  [Ft.BIG]: !0,
  [Ft.BLOCKQUOTE]: !0,
  [Ft.BODY]: !0,
  [Ft.BR]: !0,
  [Ft.CENTER]: !0,
  [Ft.CODE]: !0,
  [Ft.DD]: !0,
  [Ft.DIV]: !0,
  [Ft.DL]: !0,
  [Ft.DT]: !0,
  [Ft.EM]: !0,
  [Ft.EMBED]: !0,
  [Ft.H1]: !0,
  [Ft.H2]: !0,
  [Ft.H3]: !0,
  [Ft.H4]: !0,
  [Ft.H5]: !0,
  [Ft.H6]: !0,
  [Ft.HEAD]: !0,
  [Ft.HR]: !0,
  [Ft.I]: !0,
  [Ft.IMG]: !0,
  [Ft.LI]: !0,
  [Ft.LISTING]: !0,
  [Ft.MENU]: !0,
  [Ft.META]: !0,
  [Ft.NOBR]: !0,
  [Ft.OL]: !0,
  [Ft.P]: !0,
  [Ft.PRE]: !0,
  [Ft.RUBY]: !0,
  [Ft.S]: !0,
  [Ft.SMALL]: !0,
  [Ft.SPAN]: !0,
  [Ft.STRONG]: !0,
  [Ft.STRIKE]: !0,
  [Ft.SUB]: !0,
  [Ft.SUP]: !0,
  [Ft.TABLE]: !0,
  [Ft.TT]: !0,
  [Ft.U]: !0,
  [Ft.UL]: !0,
  [Ft.VAR]: !0
};
Zl.causesExit = function(e) {
  const t = e.tagName;
  return t === Ft.FONT && (vb.getTokenAttr(e, tg.COLOR) !== null || vb.getTokenAttr(e, tg.SIZE) !== null || vb.getTokenAttr(e, tg.FACE) !== null) ? !0 : Xee[t];
};
Zl.adjustTokenMathMLAttrs = function(e) {
  for (let t = 0; t < e.attrs.length; t++)
    if (e.attrs[t].name === Gee) {
      e.attrs[t].name = Kee;
      break;
    }
};
Zl.adjustTokenSVGAttrs = function(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const r = Yee[e.attrs[t].name];
    r && (e.attrs[t].name = r);
  }
};
Zl.adjustTokenXMLAttrs = function(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const r = qee[e.attrs[t].name];
    r && (e.attrs[t].prefix = r.prefix, e.attrs[t].name = r.name, e.attrs[t].namespace = r.namespace);
  }
};
Zl.adjustTokenSVGTagName = function(e) {
  const t = Qee[e.tagName];
  t && (e.tagName = t);
};
function Zee(e, t) {
  return t === ln.MATHML && (e === Ft.MI || e === Ft.MO || e === Ft.MN || e === Ft.MS || e === Ft.MTEXT);
}
function Jee(e, t, r) {
  if (t === ln.MATHML && e === Ft.ANNOTATION_XML) {
    for (let i = 0; i < r.length; i++)
      if (r[i].name === tg.ENCODING) {
        const n = r[i].value.toLowerCase();
        return n === ax.TEXT_HTML || n === ax.APPLICATION_XML;
      }
  }
  return t === ln.SVG && (e === Ft.FOREIGN_OBJECT || e === Ft.DESC || e === Ft.TITLE);
}
Zl.isIntegrationPoint = function(e, t, r, i) {
  return !!((!i || i === ln.HTML) && Jee(e, t, r) || (!i || i === ln.MATHML) && Zee(e, t));
};
const ae = Hm, ete = see, ox = lee, tte = _ee, rte = zee, sx = Ws, ite = fr, nte = jee, lx = $m, Vo = Zl, un = BD, ate = Ao, hc = wo, w = hc.TAG_NAMES, vt = hc.NAMESPACES, v7 = hc.ATTRS, ote = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  onParseError: null,
  treeAdapter: ite
}, k7 = "hidden", ste = 8, lte = 3, b7 = "INITIAL_MODE", ND = "BEFORE_HTML_MODE", Um = "BEFORE_HEAD_MODE", mp = "IN_HEAD_MODE", _7 = "IN_HEAD_NO_SCRIPT_MODE", Vm = "AFTER_HEAD_MODE", Qo = "IN_BODY_MODE", Vg = "TEXT_MODE", vn = "IN_TABLE_MODE", D7 = "IN_TABLE_TEXT_MODE", Wm = "IN_CAPTION_MODE", Z1 = "IN_COLUMN_GROUP_MODE", Wa = "IN_TABLE_BODY_MODE", js = "IN_ROW_MODE", Gm = "IN_CELL_MODE", zD = "IN_SELECT_MODE", LD = "IN_SELECT_IN_TABLE_MODE", Wg = "IN_TEMPLATE_MODE", MD = "AFTER_BODY_MODE", Km = "IN_FRAMESET_MODE", y7 = "AFTER_FRAMESET_MODE", E7 = "AFTER_AFTER_BODY_MODE", C7 = "AFTER_AFTER_FRAMESET_MODE", ute = {
  [w.TR]: js,
  [w.TBODY]: Wa,
  [w.THEAD]: Wa,
  [w.TFOOT]: Wa,
  [w.CAPTION]: Wm,
  [w.COLGROUP]: Z1,
  [w.TABLE]: vn,
  [w.BODY]: Qo,
  [w.FRAMESET]: Km
}, cte = {
  [w.CAPTION]: vn,
  [w.COLGROUP]: vn,
  [w.TBODY]: vn,
  [w.TFOOT]: vn,
  [w.THEAD]: vn,
  [w.COL]: Z1,
  [w.TR]: Wa,
  [w.TD]: js,
  [w.TH]: js
}, ux = {
  [b7]: {
    [ae.CHARACTER_TOKEN]: O0,
    [ae.NULL_CHARACTER_TOKEN]: O0,
    [ae.WHITESPACE_CHARACTER_TOKEN]: lr,
    [ae.COMMENT_TOKEN]: Vi,
    [ae.DOCTYPE_TOKEN]: _te,
    [ae.START_TAG_TOKEN]: O0,
    [ae.END_TAG_TOKEN]: O0,
    [ae.EOF_TOKEN]: O0
  },
  [ND]: {
    [ae.CHARACTER_TOKEN]: t1,
    [ae.NULL_CHARACTER_TOKEN]: t1,
    [ae.WHITESPACE_CHARACTER_TOKEN]: lr,
    [ae.COMMENT_TOKEN]: Vi,
    [ae.DOCTYPE_TOKEN]: lr,
    [ae.START_TAG_TOKEN]: Dte,
    [ae.END_TAG_TOKEN]: yte,
    [ae.EOF_TOKEN]: t1
  },
  [Um]: {
    [ae.CHARACTER_TOKEN]: r1,
    [ae.NULL_CHARACTER_TOKEN]: r1,
    [ae.WHITESPACE_CHARACTER_TOKEN]: lr,
    [ae.COMMENT_TOKEN]: Vi,
    [ae.DOCTYPE_TOKEN]: Of,
    [ae.START_TAG_TOKEN]: Ete,
    [ae.END_TAG_TOKEN]: Cte,
    [ae.EOF_TOKEN]: r1
  },
  [mp]: {
    [ae.CHARACTER_TOKEN]: i1,
    [ae.NULL_CHARACTER_TOKEN]: i1,
    [ae.WHITESPACE_CHARACTER_TOKEN]: ea,
    [ae.COMMENT_TOKEN]: Vi,
    [ae.DOCTYPE_TOKEN]: Of,
    [ae.START_TAG_TOKEN]: Qi,
    [ae.END_TAG_TOKEN]: fc,
    [ae.EOF_TOKEN]: i1
  },
  [_7]: {
    [ae.CHARACTER_TOKEN]: n1,
    [ae.NULL_CHARACTER_TOKEN]: n1,
    [ae.WHITESPACE_CHARACTER_TOKEN]: ea,
    [ae.COMMENT_TOKEN]: Vi,
    [ae.DOCTYPE_TOKEN]: Of,
    [ae.START_TAG_TOKEN]: xte,
    [ae.END_TAG_TOKEN]: Ate,
    [ae.EOF_TOKEN]: n1
  },
  [Vm]: {
    [ae.CHARACTER_TOKEN]: a1,
    [ae.NULL_CHARACTER_TOKEN]: a1,
    [ae.WHITESPACE_CHARACTER_TOKEN]: ea,
    [ae.COMMENT_TOKEN]: Vi,
    [ae.DOCTYPE_TOKEN]: Of,
    [ae.START_TAG_TOKEN]: wte,
    [ae.END_TAG_TOKEN]: Fte,
    [ae.EOF_TOKEN]: a1
  },
  [Qo]: {
    [ae.CHARACTER_TOKEN]: Pf,
    [ae.NULL_CHARACTER_TOKEN]: lr,
    [ae.WHITESPACE_CHARACTER_TOKEN]: Ou,
    [ae.COMMENT_TOKEN]: Vi,
    [ae.DOCTYPE_TOKEN]: lr,
    [ae.START_TAG_TOKEN]: ua,
    [ae.END_TAG_TOKEN]: jD,
    [ae.EOF_TOKEN]: Ts
  },
  [Vg]: {
    [ae.CHARACTER_TOKEN]: ea,
    [ae.NULL_CHARACTER_TOKEN]: ea,
    [ae.WHITESPACE_CHARACTER_TOKEN]: ea,
    [ae.COMMENT_TOKEN]: lr,
    [ae.DOCTYPE_TOKEN]: lr,
    [ae.START_TAG_TOKEN]: lr,
    [ae.END_TAG_TOKEN]: are,
    [ae.EOF_TOKEN]: ore
  },
  [vn]: {
    [ae.CHARACTER_TOKEN]: Ss,
    [ae.NULL_CHARACTER_TOKEN]: Ss,
    [ae.WHITESPACE_CHARACTER_TOKEN]: Ss,
    [ae.COMMENT_TOKEN]: Vi,
    [ae.DOCTYPE_TOKEN]: lr,
    [ae.START_TAG_TOKEN]: HD,
    [ae.END_TAG_TOKEN]: $D,
    [ae.EOF_TOKEN]: Ts
  },
  [D7]: {
    [ae.CHARACTER_TOKEN]: mre,
    [ae.NULL_CHARACTER_TOKEN]: lr,
    [ae.WHITESPACE_CHARACTER_TOKEN]: gre,
    [ae.COMMENT_TOKEN]: P0,
    [ae.DOCTYPE_TOKEN]: P0,
    [ae.START_TAG_TOKEN]: P0,
    [ae.END_TAG_TOKEN]: P0,
    [ae.EOF_TOKEN]: P0
  },
  [Wm]: {
    [ae.CHARACTER_TOKEN]: Pf,
    [ae.NULL_CHARACTER_TOKEN]: lr,
    [ae.WHITESPACE_CHARACTER_TOKEN]: Ou,
    [ae.COMMENT_TOKEN]: Vi,
    [ae.DOCTYPE_TOKEN]: lr,
    [ae.START_TAG_TOKEN]: vre,
    [ae.END_TAG_TOKEN]: kre,
    [ae.EOF_TOKEN]: Ts
  },
  [Z1]: {
    [ae.CHARACTER_TOKEN]: Gg,
    [ae.NULL_CHARACTER_TOKEN]: Gg,
    [ae.WHITESPACE_CHARACTER_TOKEN]: ea,
    [ae.COMMENT_TOKEN]: Vi,
    [ae.DOCTYPE_TOKEN]: lr,
    [ae.START_TAG_TOKEN]: bre,
    [ae.END_TAG_TOKEN]: _re,
    [ae.EOF_TOKEN]: Ts
  },
  [Wa]: {
    [ae.CHARACTER_TOKEN]: Ss,
    [ae.NULL_CHARACTER_TOKEN]: Ss,
    [ae.WHITESPACE_CHARACTER_TOKEN]: Ss,
    [ae.COMMENT_TOKEN]: Vi,
    [ae.DOCTYPE_TOKEN]: lr,
    [ae.START_TAG_TOKEN]: Dre,
    [ae.END_TAG_TOKEN]: yre,
    [ae.EOF_TOKEN]: Ts
  },
  [js]: {
    [ae.CHARACTER_TOKEN]: Ss,
    [ae.NULL_CHARACTER_TOKEN]: Ss,
    [ae.WHITESPACE_CHARACTER_TOKEN]: Ss,
    [ae.COMMENT_TOKEN]: Vi,
    [ae.DOCTYPE_TOKEN]: lr,
    [ae.START_TAG_TOKEN]: Ere,
    [ae.END_TAG_TOKEN]: Cre,
    [ae.EOF_TOKEN]: Ts
  },
  [Gm]: {
    [ae.CHARACTER_TOKEN]: Pf,
    [ae.NULL_CHARACTER_TOKEN]: lr,
    [ae.WHITESPACE_CHARACTER_TOKEN]: Ou,
    [ae.COMMENT_TOKEN]: Vi,
    [ae.DOCTYPE_TOKEN]: lr,
    [ae.START_TAG_TOKEN]: xre,
    [ae.END_TAG_TOKEN]: Are,
    [ae.EOF_TOKEN]: Ts
  },
  [zD]: {
    [ae.CHARACTER_TOKEN]: ea,
    [ae.NULL_CHARACTER_TOKEN]: lr,
    [ae.WHITESPACE_CHARACTER_TOKEN]: ea,
    [ae.COMMENT_TOKEN]: Vi,
    [ae.DOCTYPE_TOKEN]: lr,
    [ae.START_TAG_TOKEN]: x7,
    [ae.END_TAG_TOKEN]: A7,
    [ae.EOF_TOKEN]: Ts
  },
  [LD]: {
    [ae.CHARACTER_TOKEN]: ea,
    [ae.NULL_CHARACTER_TOKEN]: lr,
    [ae.WHITESPACE_CHARACTER_TOKEN]: ea,
    [ae.COMMENT_TOKEN]: Vi,
    [ae.DOCTYPE_TOKEN]: lr,
    [ae.START_TAG_TOKEN]: wre,
    [ae.END_TAG_TOKEN]: Fre,
    [ae.EOF_TOKEN]: Ts
  },
  [Wg]: {
    [ae.CHARACTER_TOKEN]: Pf,
    [ae.NULL_CHARACTER_TOKEN]: lr,
    [ae.WHITESPACE_CHARACTER_TOKEN]: Ou,
    [ae.COMMENT_TOKEN]: Vi,
    [ae.DOCTYPE_TOKEN]: lr,
    [ae.START_TAG_TOKEN]: Tre,
    [ae.END_TAG_TOKEN]: Sre,
    [ae.EOF_TOKEN]: w7
  },
  [MD]: {
    [ae.CHARACTER_TOKEN]: Kg,
    [ae.NULL_CHARACTER_TOKEN]: Kg,
    [ae.WHITESPACE_CHARACTER_TOKEN]: Ou,
    [ae.COMMENT_TOKEN]: bte,
    [ae.DOCTYPE_TOKEN]: lr,
    [ae.START_TAG_TOKEN]: Ire,
    [ae.END_TAG_TOKEN]: Bre,
    [ae.EOF_TOKEN]: R0
  },
  [Km]: {
    [ae.CHARACTER_TOKEN]: lr,
    [ae.NULL_CHARACTER_TOKEN]: lr,
    [ae.WHITESPACE_CHARACTER_TOKEN]: ea,
    [ae.COMMENT_TOKEN]: Vi,
    [ae.DOCTYPE_TOKEN]: lr,
    [ae.START_TAG_TOKEN]: Rre,
    [ae.END_TAG_TOKEN]: Ore,
    [ae.EOF_TOKEN]: R0
  },
  [y7]: {
    [ae.CHARACTER_TOKEN]: lr,
    [ae.NULL_CHARACTER_TOKEN]: lr,
    [ae.WHITESPACE_CHARACTER_TOKEN]: ea,
    [ae.COMMENT_TOKEN]: Vi,
    [ae.DOCTYPE_TOKEN]: lr,
    [ae.START_TAG_TOKEN]: Pre,
    [ae.END_TAG_TOKEN]: Nre,
    [ae.EOF_TOKEN]: R0
  },
  [E7]: {
    [ae.CHARACTER_TOKEN]: rg,
    [ae.NULL_CHARACTER_TOKEN]: rg,
    [ae.WHITESPACE_CHARACTER_TOKEN]: Ou,
    [ae.COMMENT_TOKEN]: cx,
    [ae.DOCTYPE_TOKEN]: lr,
    [ae.START_TAG_TOKEN]: zre,
    [ae.END_TAG_TOKEN]: rg,
    [ae.EOF_TOKEN]: R0
  },
  [C7]: {
    [ae.CHARACTER_TOKEN]: lr,
    [ae.NULL_CHARACTER_TOKEN]: lr,
    [ae.WHITESPACE_CHARACTER_TOKEN]: Ou,
    [ae.COMMENT_TOKEN]: cx,
    [ae.DOCTYPE_TOKEN]: lr,
    [ae.START_TAG_TOKEN]: Lre,
    [ae.END_TAG_TOKEN]: lr,
    [ae.EOF_TOKEN]: R0
  }
};
class dte {
  constructor(t) {
    this.options = nte(ote, t), this.treeAdapter = this.options.treeAdapter, this.pendingScript = null, this.options.sourceCodeLocationInfo && sx.install(this, tte), this.options.onParseError && sx.install(this, rte, { onParseError: this.options.onParseError });
  }
  // API
  parse(t) {
    const r = this.treeAdapter.createDocument();
    return this._bootstrap(r, null), this.tokenizer.write(t, !0), this._runParsingLoop(null), r;
  }
  parseFragment(t, r) {
    r || (r = this.treeAdapter.createElement(w.TEMPLATE, vt.HTML, []));
    const i = this.treeAdapter.createElement("documentmock", vt.HTML, []);
    this._bootstrap(i, r), this.treeAdapter.getTagName(r) === w.TEMPLATE && this._pushTmplInsertionMode(Wg), this._initTokenizerForFragmentParsing(), this._insertFakeRootElement(), this._resetInsertionMode(), this._findFormInFragmentContext(), this.tokenizer.write(t, !0), this._runParsingLoop(null);
    const n = this.treeAdapter.getFirstChild(i), a = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(n, a), a;
  }
  //Bootstrap parser
  _bootstrap(t, r) {
    this.tokenizer = new ae(this.options), this.stopped = !1, this.insertionMode = b7, this.originalInsertionMode = "", this.document = t, this.fragmentContext = r, this.headElement = null, this.formElement = null, this.openElements = new ete(this.document, this.treeAdapter), this.activeFormattingElements = new ox(this.treeAdapter), this.tmplInsertionModeStack = [], this.tmplInsertionModeStackTop = -1, this.currentTmplInsertionMode = null, this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1;
  }
  //Errors
  _err() {
  }
  //Parsing loop
  _runParsingLoop(t) {
    for (; !this.stopped; ) {
      this._setupTokenizerCDATAMode();
      const r = this.tokenizer.getNextToken();
      if (r.type === ae.HIBERNATION_TOKEN)
        break;
      if (this.skipNextNewLine && (this.skipNextNewLine = !1, r.type === ae.WHITESPACE_CHARACTER_TOKEN && r.chars[0] === `
`)) {
        if (r.chars.length === 1)
          continue;
        r.chars = r.chars.substr(1);
      }
      if (this._processInputToken(r), t && this.pendingScript)
        break;
    }
  }
  runParsingLoopForCurrentChunk(t, r) {
    if (this._runParsingLoop(r), r && this.pendingScript) {
      const i = this.pendingScript;
      this.pendingScript = null, r(i);
      return;
    }
    t && t();
  }
  //Text parsing
  _setupTokenizerCDATAMode() {
    const t = this._getAdjustedCurrentElement();
    this.tokenizer.allowCDATA = t && t !== this.document && this.treeAdapter.getNamespaceURI(t) !== vt.HTML && !this._isIntegrationPoint(t);
  }
  _switchToTextParsing(t, r) {
    this._insertElement(t, vt.HTML), this.tokenizer.state = r, this.originalInsertionMode = this.insertionMode, this.insertionMode = Vg;
  }
  switchToPlaintextParsing() {
    this.insertionMode = Vg, this.originalInsertionMode = Qo, this.tokenizer.state = ae.MODE.PLAINTEXT;
  }
  //Fragment parsing
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  _findFormInFragmentContext() {
    let t = this.fragmentContext;
    do {
      if (this.treeAdapter.getTagName(t) === w.FORM) {
        this.formElement = t;
        break;
      }
      t = this.treeAdapter.getParentNode(t);
    } while (t);
  }
  _initTokenizerForFragmentParsing() {
    if (this.treeAdapter.getNamespaceURI(this.fragmentContext) === vt.HTML) {
      const t = this.treeAdapter.getTagName(this.fragmentContext);
      t === w.TITLE || t === w.TEXTAREA ? this.tokenizer.state = ae.MODE.RCDATA : t === w.STYLE || t === w.XMP || t === w.IFRAME || t === w.NOEMBED || t === w.NOFRAMES || t === w.NOSCRIPT ? this.tokenizer.state = ae.MODE.RAWTEXT : t === w.SCRIPT ? this.tokenizer.state = ae.MODE.SCRIPT_DATA : t === w.PLAINTEXT && (this.tokenizer.state = ae.MODE.PLAINTEXT);
    }
  }
  //Tree mutation
  _setDocumentType(t) {
    const r = t.name || "", i = t.publicId || "", n = t.systemId || "";
    this.treeAdapter.setDocumentType(this.document, r, i, n);
  }
  _attachElementToTree(t) {
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(t);
    else {
      const r = this.openElements.currentTmplContent || this.openElements.current;
      this.treeAdapter.appendChild(r, t);
    }
  }
  _appendElement(t, r) {
    const i = this.treeAdapter.createElement(t.tagName, r, t.attrs);
    this._attachElementToTree(i);
  }
  _insertElement(t, r) {
    const i = this.treeAdapter.createElement(t.tagName, r, t.attrs);
    this._attachElementToTree(i), this.openElements.push(i);
  }
  _insertFakeElement(t) {
    const r = this.treeAdapter.createElement(t, vt.HTML, []);
    this._attachElementToTree(r), this.openElements.push(r);
  }
  _insertTemplate(t) {
    const r = this.treeAdapter.createElement(t.tagName, vt.HTML, t.attrs), i = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(r, i), this._attachElementToTree(r), this.openElements.push(r);
  }
  _insertFakeRootElement() {
    const t = this.treeAdapter.createElement(w.HTML, vt.HTML, []);
    this.treeAdapter.appendChild(this.openElements.current, t), this.openElements.push(t);
  }
  _appendCommentNode(t, r) {
    const i = this.treeAdapter.createCommentNode(t.data);
    this.treeAdapter.appendChild(r, i);
  }
  _insertCharacters(t) {
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentText(t.chars);
    else {
      const r = this.openElements.currentTmplContent || this.openElements.current;
      this.treeAdapter.insertText(r, t.chars);
    }
  }
  _adoptNodes(t, r) {
    for (let i = this.treeAdapter.getFirstChild(t); i; i = this.treeAdapter.getFirstChild(t))
      this.treeAdapter.detachNode(i), this.treeAdapter.appendChild(r, i);
  }
  //Token processing
  _shouldProcessTokenInForeignContent(t) {
    const r = this._getAdjustedCurrentElement();
    if (!r || r === this.document)
      return !1;
    const i = this.treeAdapter.getNamespaceURI(r);
    if (i === vt.HTML || this.treeAdapter.getTagName(r) === w.ANNOTATION_XML && i === vt.MATHML && t.type === ae.START_TAG_TOKEN && t.tagName === w.SVG)
      return !1;
    const n = t.type === ae.CHARACTER_TOKEN || t.type === ae.NULL_CHARACTER_TOKEN || t.type === ae.WHITESPACE_CHARACTER_TOKEN;
    return (t.type === ae.START_TAG_TOKEN && t.tagName !== w.MGLYPH && t.tagName !== w.MALIGNMARK || n) && this._isIntegrationPoint(r, vt.MATHML) || (t.type === ae.START_TAG_TOKEN || n) && this._isIntegrationPoint(r, vt.HTML) ? !1 : t.type !== ae.EOF_TOKEN;
  }
  _processToken(t) {
    ux[this.insertionMode][t.type](this, t);
  }
  _processTokenInBodyMode(t) {
    ux[Qo][t.type](this, t);
  }
  _processTokenInForeignContent(t) {
    t.type === ae.CHARACTER_TOKEN ? jre(this, t) : t.type === ae.NULL_CHARACTER_TOKEN ? Mre(this, t) : t.type === ae.WHITESPACE_CHARACTER_TOKEN ? ea(this, t) : t.type === ae.COMMENT_TOKEN ? Vi(this, t) : t.type === ae.START_TAG_TOKEN ? Hre(this, t) : t.type === ae.END_TAG_TOKEN && $re(this, t);
  }
  _processInputToken(t) {
    this._shouldProcessTokenInForeignContent(t) ? this._processTokenInForeignContent(t) : this._processToken(t), t.type === ae.START_TAG_TOKEN && t.selfClosing && !t.ackSelfClosing && this._err(un.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  //Integration points
  _isIntegrationPoint(t, r) {
    const i = this.treeAdapter.getTagName(t), n = this.treeAdapter.getNamespaceURI(t), a = this.treeAdapter.getAttrList(t);
    return Vo.isIntegrationPoint(i, n, a, r);
  }
  //Active formatting elements reconstruction
  _reconstructActiveFormattingElements() {
    const t = this.activeFormattingElements.length;
    if (t) {
      let r = t, i = null;
      do
        if (r--, i = this.activeFormattingElements.entries[r], i.type === ox.MARKER_ENTRY || this.openElements.contains(i.element)) {
          r++;
          break;
        }
      while (r > 0);
      for (let n = r; n < t; n++)
        i = this.activeFormattingElements.entries[n], this._insertElement(i.token, this.treeAdapter.getNamespaceURI(i.element)), i.element = this.openElements.current;
    }
  }
  //Close elements
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = js;
  }
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(w.P), this.openElements.popUntilTagNamePopped(w.P);
  }
  //Insertion modes
  _resetInsertionMode() {
    for (let t = this.openElements.stackTop, r = !1; t >= 0; t--) {
      let i = this.openElements.items[t];
      t === 0 && (r = !0, this.fragmentContext && (i = this.fragmentContext));
      const n = this.treeAdapter.getTagName(i), a = ute[n];
      if (a) {
        this.insertionMode = a;
        break;
      } else if (!r && (n === w.TD || n === w.TH)) {
        this.insertionMode = Gm;
        break;
      } else if (!r && n === w.HEAD) {
        this.insertionMode = mp;
        break;
      } else if (n === w.SELECT) {
        this._resetInsertionModeForSelect(t);
        break;
      } else if (n === w.TEMPLATE) {
        this.insertionMode = this.currentTmplInsertionMode;
        break;
      } else if (n === w.HTML) {
        this.insertionMode = this.headElement ? Vm : Um;
        break;
      } else if (r) {
        this.insertionMode = Qo;
        break;
      }
    }
  }
  _resetInsertionModeForSelect(t) {
    if (t > 0)
      for (let r = t - 1; r > 0; r--) {
        const i = this.openElements.items[r], n = this.treeAdapter.getTagName(i);
        if (n === w.TEMPLATE)
          break;
        if (n === w.TABLE) {
          this.insertionMode = LD;
          return;
        }
      }
    this.insertionMode = zD;
  }
  _pushTmplInsertionMode(t) {
    this.tmplInsertionModeStack.push(t), this.tmplInsertionModeStackTop++, this.currentTmplInsertionMode = t;
  }
  _popTmplInsertionMode() {
    this.tmplInsertionModeStack.pop(), this.tmplInsertionModeStackTop--, this.currentTmplInsertionMode = this.tmplInsertionModeStack[this.tmplInsertionModeStackTop];
  }
  //Foster parenting
  _isElementCausesFosterParenting(t) {
    const r = this.treeAdapter.getTagName(t);
    return r === w.TABLE || r === w.TBODY || r === w.TFOOT || r === w.THEAD || r === w.TR;
  }
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.current);
  }
  _findFosterParentingLocation() {
    const t = {
      parent: null,
      beforeElement: null
    };
    for (let r = this.openElements.stackTop; r >= 0; r--) {
      const i = this.openElements.items[r], n = this.treeAdapter.getTagName(i), a = this.treeAdapter.getNamespaceURI(i);
      if (n === w.TEMPLATE && a === vt.HTML) {
        t.parent = this.treeAdapter.getTemplateContent(i);
        break;
      } else if (n === w.TABLE) {
        t.parent = this.treeAdapter.getParentNode(i), t.parent ? t.beforeElement = i : t.parent = this.openElements.items[r - 1];
        break;
      }
    }
    return t.parent || (t.parent = this.openElements.items[0]), t;
  }
  _fosterParentElement(t) {
    const r = this._findFosterParentingLocation();
    r.beforeElement ? this.treeAdapter.insertBefore(r.parent, t, r.beforeElement) : this.treeAdapter.appendChild(r.parent, t);
  }
  _fosterParentText(t) {
    const r = this._findFosterParentingLocation();
    r.beforeElement ? this.treeAdapter.insertTextBefore(r.parent, t, r.beforeElement) : this.treeAdapter.insertText(r.parent, t);
  }
  //Special elements
  _isSpecialElement(t) {
    const r = this.treeAdapter.getTagName(t), i = this.treeAdapter.getNamespaceURI(t);
    return hc.SPECIAL_ELEMENTS[i][r];
  }
}
var pte = dte;
function hte(e, t) {
  let r = e.activeFormattingElements.getElementEntryInScopeWithTagName(t.tagName);
  return r ? e.openElements.contains(r.element) ? e.openElements.hasInScope(t.tagName) || (r = null) : (e.activeFormattingElements.removeEntry(r), r = null) : po(e, t), r;
}
function fte(e, t) {
  let r = null;
  for (let i = e.openElements.stackTop; i >= 0; i--) {
    const n = e.openElements.items[i];
    if (n === t.element)
      break;
    e._isSpecialElement(n) && (r = n);
  }
  return r || (e.openElements.popUntilElementPopped(t.element), e.activeFormattingElements.removeEntry(t)), r;
}
function gte(e, t, r) {
  let i = t, n = e.openElements.getCommonAncestor(t);
  for (let a = 0, o = n; o !== r; a++, o = n) {
    n = e.openElements.getCommonAncestor(o);
    const s = e.activeFormattingElements.getElementEntry(o), l = s && a >= lte;
    !s || l ? (l && e.activeFormattingElements.removeEntry(s), e.openElements.remove(o)) : (o = mte(e, s), i === t && (e.activeFormattingElements.bookmark = s), e.treeAdapter.detachNode(i), e.treeAdapter.appendChild(o, i), i = o);
  }
  return i;
}
function mte(e, t) {
  const r = e.treeAdapter.getNamespaceURI(t.element), i = e.treeAdapter.createElement(t.token.tagName, r, t.token.attrs);
  return e.openElements.replace(t.element, i), t.element = i, i;
}
function vte(e, t, r) {
  if (e._isElementCausesFosterParenting(t))
    e._fosterParentElement(r);
  else {
    const i = e.treeAdapter.getTagName(t), n = e.treeAdapter.getNamespaceURI(t);
    i === w.TEMPLATE && n === vt.HTML && (t = e.treeAdapter.getTemplateContent(t)), e.treeAdapter.appendChild(t, r);
  }
}
function kte(e, t, r) {
  const i = e.treeAdapter.getNamespaceURI(r.element), n = r.token, a = e.treeAdapter.createElement(n.tagName, i, n.attrs);
  e._adoptNodes(t, a), e.treeAdapter.appendChild(t, a), e.activeFormattingElements.insertElementAfterBookmark(a, r.token), e.activeFormattingElements.removeEntry(r), e.openElements.remove(r.element), e.openElements.insertAfter(t, a);
}
function Dl(e, t) {
  let r;
  for (let i = 0; i < ste && (r = hte(e, t), !!r); i++) {
    const n = fte(e, r);
    if (!n)
      break;
    e.activeFormattingElements.bookmark = r;
    const a = gte(e, n, r.element), o = e.openElements.getCommonAncestor(r.element);
    e.treeAdapter.detachNode(a), vte(e, o, a), kte(e, n, r);
  }
}
function lr() {
}
function Of(e) {
  e._err(un.misplacedDoctype);
}
function Vi(e, t) {
  e._appendCommentNode(t, e.openElements.currentTmplContent || e.openElements.current);
}
function bte(e, t) {
  e._appendCommentNode(t, e.openElements.items[0]);
}
function cx(e, t) {
  e._appendCommentNode(t, e.document);
}
function ea(e, t) {
  e._insertCharacters(t);
}
function R0(e) {
  e.stopped = !0;
}
function _te(e, t) {
  e._setDocumentType(t);
  const r = t.forceQuirks ? hc.DOCUMENT_MODE.QUIRKS : lx.getDocumentMode(t);
  lx.isConforming(t) || e._err(un.nonConformingDoctype), e.treeAdapter.setDocumentMode(e.document, r), e.insertionMode = ND;
}
function O0(e, t) {
  e._err(un.missingDoctype, { beforeToken: !0 }), e.treeAdapter.setDocumentMode(e.document, hc.DOCUMENT_MODE.QUIRKS), e.insertionMode = ND, e._processToken(t);
}
function Dte(e, t) {
  t.tagName === w.HTML ? (e._insertElement(t, vt.HTML), e.insertionMode = Um) : t1(e, t);
}
function yte(e, t) {
  const r = t.tagName;
  (r === w.HTML || r === w.HEAD || r === w.BODY || r === w.BR) && t1(e, t);
}
function t1(e, t) {
  e._insertFakeRootElement(), e.insertionMode = Um, e._processToken(t);
}
function Ete(e, t) {
  const r = t.tagName;
  r === w.HTML ? ua(e, t) : r === w.HEAD ? (e._insertElement(t, vt.HTML), e.headElement = e.openElements.current, e.insertionMode = mp) : r1(e, t);
}
function Cte(e, t) {
  const r = t.tagName;
  r === w.HEAD || r === w.BODY || r === w.HTML || r === w.BR ? r1(e, t) : e._err(un.endTagWithoutMatchingOpenElement);
}
function r1(e, t) {
  e._insertFakeElement(w.HEAD), e.headElement = e.openElements.current, e.insertionMode = mp, e._processToken(t);
}
function Qi(e, t) {
  const r = t.tagName;
  r === w.HTML ? ua(e, t) : r === w.BASE || r === w.BASEFONT || r === w.BGSOUND || r === w.LINK || r === w.META ? (e._appendElement(t, vt.HTML), t.ackSelfClosing = !0) : r === w.TITLE ? e._switchToTextParsing(t, ae.MODE.RCDATA) : r === w.NOSCRIPT ? e.options.scriptingEnabled ? e._switchToTextParsing(t, ae.MODE.RAWTEXT) : (e._insertElement(t, vt.HTML), e.insertionMode = _7) : r === w.NOFRAMES || r === w.STYLE ? e._switchToTextParsing(t, ae.MODE.RAWTEXT) : r === w.SCRIPT ? e._switchToTextParsing(t, ae.MODE.SCRIPT_DATA) : r === w.TEMPLATE ? (e._insertTemplate(t, vt.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1, e.insertionMode = Wg, e._pushTmplInsertionMode(Wg)) : r === w.HEAD ? e._err(un.misplacedStartTagForHeadElement) : i1(e, t);
}
function fc(e, t) {
  const r = t.tagName;
  r === w.HEAD ? (e.openElements.pop(), e.insertionMode = Vm) : r === w.BODY || r === w.BR || r === w.HTML ? i1(e, t) : r === w.TEMPLATE && e.openElements.tmplCount > 0 ? (e.openElements.generateImpliedEndTagsThoroughly(), e.openElements.currentTagName !== w.TEMPLATE && e._err(un.closingOfElementWithOpenChildElements), e.openElements.popUntilTagNamePopped(w.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e._popTmplInsertionMode(), e._resetInsertionMode()) : e._err(un.endTagWithoutMatchingOpenElement);
}
function i1(e, t) {
  e.openElements.pop(), e.insertionMode = Vm, e._processToken(t);
}
function xte(e, t) {
  const r = t.tagName;
  r === w.HTML ? ua(e, t) : r === w.BASEFONT || r === w.BGSOUND || r === w.HEAD || r === w.LINK || r === w.META || r === w.NOFRAMES || r === w.STYLE ? Qi(e, t) : r === w.NOSCRIPT ? e._err(un.nestedNoscriptInHead) : n1(e, t);
}
function Ate(e, t) {
  const r = t.tagName;
  r === w.NOSCRIPT ? (e.openElements.pop(), e.insertionMode = mp) : r === w.BR ? n1(e, t) : e._err(un.endTagWithoutMatchingOpenElement);
}
function n1(e, t) {
  const r = t.type === ae.EOF_TOKEN ? un.openElementsLeftAfterEof : un.disallowedContentInNoscriptInHead;
  e._err(r), e.openElements.pop(), e.insertionMode = mp, e._processToken(t);
}
function wte(e, t) {
  const r = t.tagName;
  r === w.HTML ? ua(e, t) : r === w.BODY ? (e._insertElement(t, vt.HTML), e.framesetOk = !1, e.insertionMode = Qo) : r === w.FRAMESET ? (e._insertElement(t, vt.HTML), e.insertionMode = Km) : r === w.BASE || r === w.BASEFONT || r === w.BGSOUND || r === w.LINK || r === w.META || r === w.NOFRAMES || r === w.SCRIPT || r === w.STYLE || r === w.TEMPLATE || r === w.TITLE ? (e._err(un.abandonedHeadElementChild), e.openElements.push(e.headElement), Qi(e, t), e.openElements.remove(e.headElement)) : r === w.HEAD ? e._err(un.misplacedStartTagForHeadElement) : a1(e, t);
}
function Fte(e, t) {
  const r = t.tagName;
  r === w.BODY || r === w.HTML || r === w.BR ? a1(e, t) : r === w.TEMPLATE ? fc(e, t) : e._err(un.endTagWithoutMatchingOpenElement);
}
function a1(e, t) {
  e._insertFakeElement(w.BODY), e.insertionMode = Qo, e._processToken(t);
}
function Ou(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t);
}
function Pf(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t), e.framesetOk = !1;
}
function Tte(e, t) {
  e.openElements.tmplCount === 0 && e.treeAdapter.adoptAttributes(e.openElements.items[0], t.attrs);
}
function Ste(e, t) {
  const r = e.openElements.tryPeekProperlyNestedBodyElement();
  r && e.openElements.tmplCount === 0 && (e.framesetOk = !1, e.treeAdapter.adoptAttributes(r, t.attrs));
}
function Ite(e, t) {
  const r = e.openElements.tryPeekProperlyNestedBodyElement();
  e.framesetOk && r && (e.treeAdapter.detachNode(r), e.openElements.popAllUpToHtmlElement(), e._insertElement(t, vt.HTML), e.insertionMode = Km);
}
function Fs(e, t) {
  e.openElements.hasInButtonScope(w.P) && e._closePElement(), e._insertElement(t, vt.HTML);
}
function Bte(e, t) {
  e.openElements.hasInButtonScope(w.P) && e._closePElement();
  const r = e.openElements.currentTagName;
  (r === w.H1 || r === w.H2 || r === w.H3 || r === w.H4 || r === w.H5 || r === w.H6) && e.openElements.pop(), e._insertElement(t, vt.HTML);
}
function dx(e, t) {
  e.openElements.hasInButtonScope(w.P) && e._closePElement(), e._insertElement(t, vt.HTML), e.skipNextNewLine = !0, e.framesetOk = !1;
}
function Rte(e, t) {
  const r = e.openElements.tmplCount > 0;
  (!e.formElement || r) && (e.openElements.hasInButtonScope(w.P) && e._closePElement(), e._insertElement(t, vt.HTML), r || (e.formElement = e.openElements.current));
}
function Ote(e, t) {
  e.framesetOk = !1;
  const r = t.tagName;
  for (let i = e.openElements.stackTop; i >= 0; i--) {
    const n = e.openElements.items[i], a = e.treeAdapter.getTagName(n);
    let o = null;
    if (r === w.LI && a === w.LI ? o = w.LI : (r === w.DD || r === w.DT) && (a === w.DD || a === w.DT) && (o = a), o) {
      e.openElements.generateImpliedEndTagsWithExclusion(o), e.openElements.popUntilTagNamePopped(o);
      break;
    }
    if (a !== w.ADDRESS && a !== w.DIV && a !== w.P && e._isSpecialElement(n))
      break;
  }
  e.openElements.hasInButtonScope(w.P) && e._closePElement(), e._insertElement(t, vt.HTML);
}
function Pte(e, t) {
  e.openElements.hasInButtonScope(w.P) && e._closePElement(), e._insertElement(t, vt.HTML), e.tokenizer.state = ae.MODE.PLAINTEXT;
}
function Nte(e, t) {
  e.openElements.hasInScope(w.BUTTON) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(w.BUTTON)), e._reconstructActiveFormattingElements(), e._insertElement(t, vt.HTML), e.framesetOk = !1;
}
function zte(e, t) {
  const r = e.activeFormattingElements.getElementEntryInScopeWithTagName(w.A);
  r && (Dl(e, t), e.openElements.remove(r.element), e.activeFormattingElements.removeEntry(r)), e._reconstructActiveFormattingElements(), e._insertElement(t, vt.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function bd(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, vt.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function Lte(e, t) {
  e._reconstructActiveFormattingElements(), e.openElements.hasInScope(w.NOBR) && (Dl(e, t), e._reconstructActiveFormattingElements()), e._insertElement(t, vt.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function px(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, vt.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1;
}
function Mte(e, t) {
  e.treeAdapter.getDocumentMode(e.document) !== hc.DOCUMENT_MODE.QUIRKS && e.openElements.hasInButtonScope(w.P) && e._closePElement(), e._insertElement(t, vt.HTML), e.framesetOk = !1, e.insertionMode = vn;
}
function Td(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, vt.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function jte(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, vt.HTML);
  const r = ae.getTokenAttr(t, v7.TYPE);
  (!r || r.toLowerCase() !== k7) && (e.framesetOk = !1), t.ackSelfClosing = !0;
}
function hx(e, t) {
  e._appendElement(t, vt.HTML), t.ackSelfClosing = !0;
}
function Hte(e, t) {
  e.openElements.hasInButtonScope(w.P) && e._closePElement(), e._appendElement(t, vt.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function $te(e, t) {
  t.tagName = w.IMG, Td(e, t);
}
function Ute(e, t) {
  e._insertElement(t, vt.HTML), e.skipNextNewLine = !0, e.tokenizer.state = ae.MODE.RCDATA, e.originalInsertionMode = e.insertionMode, e.framesetOk = !1, e.insertionMode = Vg;
}
function Vte(e, t) {
  e.openElements.hasInButtonScope(w.P) && e._closePElement(), e._reconstructActiveFormattingElements(), e.framesetOk = !1, e._switchToTextParsing(t, ae.MODE.RAWTEXT);
}
function Wte(e, t) {
  e.framesetOk = !1, e._switchToTextParsing(t, ae.MODE.RAWTEXT);
}
function fx(e, t) {
  e._switchToTextParsing(t, ae.MODE.RAWTEXT);
}
function Gte(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, vt.HTML), e.framesetOk = !1, e.insertionMode === vn || e.insertionMode === Wm || e.insertionMode === Wa || e.insertionMode === js || e.insertionMode === Gm ? e.insertionMode = LD : e.insertionMode = zD;
}
function gx(e, t) {
  e.openElements.currentTagName === w.OPTION && e.openElements.pop(), e._reconstructActiveFormattingElements(), e._insertElement(t, vt.HTML);
}
function mx(e, t) {
  e.openElements.hasInScope(w.RUBY) && e.openElements.generateImpliedEndTags(), e._insertElement(t, vt.HTML);
}
function Kte(e, t) {
  e.openElements.hasInScope(w.RUBY) && e.openElements.generateImpliedEndTagsWithExclusion(w.RTC), e._insertElement(t, vt.HTML);
}
function Yte(e, t) {
  e.openElements.hasInButtonScope(w.P) && e._closePElement(), e._insertElement(t, vt.HTML);
}
function qte(e, t) {
  e._reconstructActiveFormattingElements(), Vo.adjustTokenMathMLAttrs(t), Vo.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, vt.MATHML) : e._insertElement(t, vt.MATHML), t.ackSelfClosing = !0;
}
function Qte(e, t) {
  e._reconstructActiveFormattingElements(), Vo.adjustTokenSVGAttrs(t), Vo.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, vt.SVG) : e._insertElement(t, vt.SVG), t.ackSelfClosing = !0;
}
function za(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, vt.HTML);
}
function ua(e, t) {
  const r = t.tagName;
  switch (r.length) {
    case 1:
      r === w.I || r === w.S || r === w.B || r === w.U ? bd(e, t) : r === w.P ? Fs(e, t) : r === w.A ? zte(e, t) : za(e, t);
      break;
    case 2:
      r === w.DL || r === w.OL || r === w.UL ? Fs(e, t) : r === w.H1 || r === w.H2 || r === w.H3 || r === w.H4 || r === w.H5 || r === w.H6 ? Bte(e, t) : r === w.LI || r === w.DD || r === w.DT ? Ote(e, t) : r === w.EM || r === w.TT ? bd(e, t) : r === w.BR ? Td(e, t) : r === w.HR ? Hte(e, t) : r === w.RB ? mx(e, t) : r === w.RT || r === w.RP ? Kte(e, t) : r !== w.TH && r !== w.TD && r !== w.TR && za(e, t);
      break;
    case 3:
      r === w.DIV || r === w.DIR || r === w.NAV ? Fs(e, t) : r === w.PRE ? dx(e, t) : r === w.BIG ? bd(e, t) : r === w.IMG || r === w.WBR ? Td(e, t) : r === w.XMP ? Vte(e, t) : r === w.SVG ? Qte(e, t) : r === w.RTC ? mx(e, t) : r !== w.COL && za(e, t);
      break;
    case 4:
      r === w.HTML ? Tte(e, t) : r === w.BASE || r === w.LINK || r === w.META ? Qi(e, t) : r === w.BODY ? Ste(e, t) : r === w.MAIN || r === w.MENU ? Fs(e, t) : r === w.FORM ? Rte(e, t) : r === w.CODE || r === w.FONT ? bd(e, t) : r === w.NOBR ? Lte(e, t) : r === w.AREA ? Td(e, t) : r === w.MATH ? qte(e, t) : r === w.MENU ? Yte(e, t) : r !== w.HEAD && za(e, t);
      break;
    case 5:
      r === w.STYLE || r === w.TITLE ? Qi(e, t) : r === w.ASIDE ? Fs(e, t) : r === w.SMALL ? bd(e, t) : r === w.TABLE ? Mte(e, t) : r === w.EMBED ? Td(e, t) : r === w.INPUT ? jte(e, t) : r === w.PARAM || r === w.TRACK ? hx(e, t) : r === w.IMAGE ? $te(e, t) : r !== w.FRAME && r !== w.TBODY && r !== w.TFOOT && r !== w.THEAD && za(e, t);
      break;
    case 6:
      r === w.SCRIPT ? Qi(e, t) : r === w.CENTER || r === w.FIGURE || r === w.FOOTER || r === w.HEADER || r === w.HGROUP || r === w.DIALOG ? Fs(e, t) : r === w.BUTTON ? Nte(e, t) : r === w.STRIKE || r === w.STRONG ? bd(e, t) : r === w.APPLET || r === w.OBJECT ? px(e, t) : r === w.KEYGEN ? Td(e, t) : r === w.SOURCE ? hx(e, t) : r === w.IFRAME ? Wte(e, t) : r === w.SELECT ? Gte(e, t) : r === w.OPTION ? gx(e, t) : za(e, t);
      break;
    case 7:
      r === w.BGSOUND ? Qi(e, t) : r === w.DETAILS || r === w.ADDRESS || r === w.ARTICLE || r === w.SECTION || r === w.SUMMARY ? Fs(e, t) : r === w.LISTING ? dx(e, t) : r === w.MARQUEE ? px(e, t) : r === w.NOEMBED ? fx(e, t) : r !== w.CAPTION && za(e, t);
      break;
    case 8:
      r === w.BASEFONT ? Qi(e, t) : r === w.FRAMESET ? Ite(e, t) : r === w.FIELDSET ? Fs(e, t) : r === w.TEXTAREA ? Ute(e, t) : r === w.TEMPLATE ? Qi(e, t) : r === w.NOSCRIPT ? e.options.scriptingEnabled ? fx(e, t) : za(e, t) : r === w.OPTGROUP ? gx(e, t) : r !== w.COLGROUP && za(e, t);
      break;
    case 9:
      r === w.PLAINTEXT ? Pte(e, t) : za(e, t);
      break;
    case 10:
      r === w.BLOCKQUOTE || r === w.FIGCAPTION ? Fs(e, t) : za(e, t);
      break;
    default:
      za(e, t);
  }
}
function Xte(e) {
  e.openElements.hasInScope(w.BODY) && (e.insertionMode = MD);
}
function Zte(e, t) {
  e.openElements.hasInScope(w.BODY) && (e.insertionMode = MD, e._processToken(t));
}
function hl(e, t) {
  const r = t.tagName;
  e.openElements.hasInScope(r) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(r));
}
function Jte(e) {
  const t = e.openElements.tmplCount > 0, r = e.formElement;
  t || (e.formElement = null), (r || t) && e.openElements.hasInScope(w.FORM) && (e.openElements.generateImpliedEndTags(), t ? e.openElements.popUntilTagNamePopped(w.FORM) : e.openElements.remove(r));
}
function ere(e) {
  e.openElements.hasInButtonScope(w.P) || e._insertFakeElement(w.P), e._closePElement();
}
function tre(e) {
  e.openElements.hasInListItemScope(w.LI) && (e.openElements.generateImpliedEndTagsWithExclusion(w.LI), e.openElements.popUntilTagNamePopped(w.LI));
}
function rre(e, t) {
  const r = t.tagName;
  e.openElements.hasInScope(r) && (e.openElements.generateImpliedEndTagsWithExclusion(r), e.openElements.popUntilTagNamePopped(r));
}
function ire(e) {
  e.openElements.hasNumberedHeaderInScope() && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilNumberedHeaderPopped());
}
function vx(e, t) {
  const r = t.tagName;
  e.openElements.hasInScope(r) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(r), e.activeFormattingElements.clearToLastMarker());
}
function nre(e) {
  e._reconstructActiveFormattingElements(), e._insertFakeElement(w.BR), e.openElements.pop(), e.framesetOk = !1;
}
function po(e, t) {
  const r = t.tagName;
  for (let i = e.openElements.stackTop; i > 0; i--) {
    const n = e.openElements.items[i];
    if (e.treeAdapter.getTagName(n) === r) {
      e.openElements.generateImpliedEndTagsWithExclusion(r), e.openElements.popUntilElementPopped(n);
      break;
    }
    if (e._isSpecialElement(n))
      break;
  }
}
function jD(e, t) {
  const r = t.tagName;
  switch (r.length) {
    case 1:
      r === w.A || r === w.B || r === w.I || r === w.S || r === w.U ? Dl(e, t) : r === w.P ? ere(e) : po(e, t);
      break;
    case 2:
      r === w.DL || r === w.UL || r === w.OL ? hl(e, t) : r === w.LI ? tre(e) : r === w.DD || r === w.DT ? rre(e, t) : r === w.H1 || r === w.H2 || r === w.H3 || r === w.H4 || r === w.H5 || r === w.H6 ? ire(e) : r === w.BR ? nre(e) : r === w.EM || r === w.TT ? Dl(e, t) : po(e, t);
      break;
    case 3:
      r === w.BIG ? Dl(e, t) : r === w.DIR || r === w.DIV || r === w.NAV || r === w.PRE ? hl(e, t) : po(e, t);
      break;
    case 4:
      r === w.BODY ? Xte(e) : r === w.HTML ? Zte(e, t) : r === w.FORM ? Jte(e) : r === w.CODE || r === w.FONT || r === w.NOBR ? Dl(e, t) : r === w.MAIN || r === w.MENU ? hl(e, t) : po(e, t);
      break;
    case 5:
      r === w.ASIDE ? hl(e, t) : r === w.SMALL ? Dl(e, t) : po(e, t);
      break;
    case 6:
      r === w.CENTER || r === w.FIGURE || r === w.FOOTER || r === w.HEADER || r === w.HGROUP || r === w.DIALOG ? hl(e, t) : r === w.APPLET || r === w.OBJECT ? vx(e, t) : r === w.STRIKE || r === w.STRONG ? Dl(e, t) : po(e, t);
      break;
    case 7:
      r === w.ADDRESS || r === w.ARTICLE || r === w.DETAILS || r === w.SECTION || r === w.SUMMARY || r === w.LISTING ? hl(e, t) : r === w.MARQUEE ? vx(e, t) : po(e, t);
      break;
    case 8:
      r === w.FIELDSET ? hl(e, t) : r === w.TEMPLATE ? fc(e, t) : po(e, t);
      break;
    case 10:
      r === w.BLOCKQUOTE || r === w.FIGCAPTION ? hl(e, t) : po(e, t);
      break;
    default:
      po(e, t);
  }
}
function Ts(e, t) {
  e.tmplInsertionModeStackTop > -1 ? w7(e, t) : e.stopped = !0;
}
function are(e, t) {
  t.tagName === w.SCRIPT && (e.pendingScript = e.openElements.current), e.openElements.pop(), e.insertionMode = e.originalInsertionMode;
}
function ore(e, t) {
  e._err(un.eofInElementThatCanContainOnlyText), e.openElements.pop(), e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
function Ss(e, t) {
  const r = e.openElements.currentTagName;
  r === w.TABLE || r === w.TBODY || r === w.TFOOT || r === w.THEAD || r === w.TR ? (e.pendingCharacterTokens = [], e.hasNonWhitespacePendingCharacterToken = !1, e.originalInsertionMode = e.insertionMode, e.insertionMode = D7, e._processToken(t)) : La(e, t);
}
function sre(e, t) {
  e.openElements.clearBackToTableContext(), e.activeFormattingElements.insertMarker(), e._insertElement(t, vt.HTML), e.insertionMode = Wm;
}
function lre(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, vt.HTML), e.insertionMode = Z1;
}
function ure(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(w.COLGROUP), e.insertionMode = Z1, e._processToken(t);
}
function cre(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, vt.HTML), e.insertionMode = Wa;
}
function dre(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(w.TBODY), e.insertionMode = Wa, e._processToken(t);
}
function pre(e, t) {
  e.openElements.hasInTableScope(w.TABLE) && (e.openElements.popUntilTagNamePopped(w.TABLE), e._resetInsertionMode(), e._processToken(t));
}
function hre(e, t) {
  const r = ae.getTokenAttr(t, v7.TYPE);
  r && r.toLowerCase() === k7 ? e._appendElement(t, vt.HTML) : La(e, t), t.ackSelfClosing = !0;
}
function fre(e, t) {
  !e.formElement && e.openElements.tmplCount === 0 && (e._insertElement(t, vt.HTML), e.formElement = e.openElements.current, e.openElements.pop());
}
function HD(e, t) {
  const r = t.tagName;
  switch (r.length) {
    case 2:
      r === w.TD || r === w.TH || r === w.TR ? dre(e, t) : La(e, t);
      break;
    case 3:
      r === w.COL ? ure(e, t) : La(e, t);
      break;
    case 4:
      r === w.FORM ? fre(e, t) : La(e, t);
      break;
    case 5:
      r === w.TABLE ? pre(e, t) : r === w.STYLE ? Qi(e, t) : r === w.TBODY || r === w.TFOOT || r === w.THEAD ? cre(e, t) : r === w.INPUT ? hre(e, t) : La(e, t);
      break;
    case 6:
      r === w.SCRIPT ? Qi(e, t) : La(e, t);
      break;
    case 7:
      r === w.CAPTION ? sre(e, t) : La(e, t);
      break;
    case 8:
      r === w.COLGROUP ? lre(e, t) : r === w.TEMPLATE ? Qi(e, t) : La(e, t);
      break;
    default:
      La(e, t);
  }
}
function $D(e, t) {
  const r = t.tagName;
  r === w.TABLE ? e.openElements.hasInTableScope(w.TABLE) && (e.openElements.popUntilTagNamePopped(w.TABLE), e._resetInsertionMode()) : r === w.TEMPLATE ? fc(e, t) : r !== w.BODY && r !== w.CAPTION && r !== w.COL && r !== w.COLGROUP && r !== w.HTML && r !== w.TBODY && r !== w.TD && r !== w.TFOOT && r !== w.TH && r !== w.THEAD && r !== w.TR && La(e, t);
}
function La(e, t) {
  const r = e.fosterParentingEnabled;
  e.fosterParentingEnabled = !0, e._processTokenInBodyMode(t), e.fosterParentingEnabled = r;
}
function gre(e, t) {
  e.pendingCharacterTokens.push(t);
}
function mre(e, t) {
  e.pendingCharacterTokens.push(t), e.hasNonWhitespacePendingCharacterToken = !0;
}
function P0(e, t) {
  let r = 0;
  if (e.hasNonWhitespacePendingCharacterToken)
    for (; r < e.pendingCharacterTokens.length; r++)
      La(e, e.pendingCharacterTokens[r]);
  else
    for (; r < e.pendingCharacterTokens.length; r++)
      e._insertCharacters(e.pendingCharacterTokens[r]);
  e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
function vre(e, t) {
  const r = t.tagName;
  r === w.CAPTION || r === w.COL || r === w.COLGROUP || r === w.TBODY || r === w.TD || r === w.TFOOT || r === w.TH || r === w.THEAD || r === w.TR ? e.openElements.hasInTableScope(w.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(w.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = vn, e._processToken(t)) : ua(e, t);
}
function kre(e, t) {
  const r = t.tagName;
  r === w.CAPTION || r === w.TABLE ? e.openElements.hasInTableScope(w.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(w.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = vn, r === w.TABLE && e._processToken(t)) : r !== w.BODY && r !== w.COL && r !== w.COLGROUP && r !== w.HTML && r !== w.TBODY && r !== w.TD && r !== w.TFOOT && r !== w.TH && r !== w.THEAD && r !== w.TR && jD(e, t);
}
function bre(e, t) {
  const r = t.tagName;
  r === w.HTML ? ua(e, t) : r === w.COL ? (e._appendElement(t, vt.HTML), t.ackSelfClosing = !0) : r === w.TEMPLATE ? Qi(e, t) : Gg(e, t);
}
function _re(e, t) {
  const r = t.tagName;
  r === w.COLGROUP ? e.openElements.currentTagName === w.COLGROUP && (e.openElements.pop(), e.insertionMode = vn) : r === w.TEMPLATE ? fc(e, t) : r !== w.COL && Gg(e, t);
}
function Gg(e, t) {
  e.openElements.currentTagName === w.COLGROUP && (e.openElements.pop(), e.insertionMode = vn, e._processToken(t));
}
function Dre(e, t) {
  const r = t.tagName;
  r === w.TR ? (e.openElements.clearBackToTableBodyContext(), e._insertElement(t, vt.HTML), e.insertionMode = js) : r === w.TH || r === w.TD ? (e.openElements.clearBackToTableBodyContext(), e._insertFakeElement(w.TR), e.insertionMode = js, e._processToken(t)) : r === w.CAPTION || r === w.COL || r === w.COLGROUP || r === w.TBODY || r === w.TFOOT || r === w.THEAD ? e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = vn, e._processToken(t)) : HD(e, t);
}
function yre(e, t) {
  const r = t.tagName;
  r === w.TBODY || r === w.TFOOT || r === w.THEAD ? e.openElements.hasInTableScope(r) && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = vn) : r === w.TABLE ? e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = vn, e._processToken(t)) : (r !== w.BODY && r !== w.CAPTION && r !== w.COL && r !== w.COLGROUP || r !== w.HTML && r !== w.TD && r !== w.TH && r !== w.TR) && $D(e, t);
}
function Ere(e, t) {
  const r = t.tagName;
  r === w.TH || r === w.TD ? (e.openElements.clearBackToTableRowContext(), e._insertElement(t, vt.HTML), e.insertionMode = Gm, e.activeFormattingElements.insertMarker()) : r === w.CAPTION || r === w.COL || r === w.COLGROUP || r === w.TBODY || r === w.TFOOT || r === w.THEAD || r === w.TR ? e.openElements.hasInTableScope(w.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = Wa, e._processToken(t)) : HD(e, t);
}
function Cre(e, t) {
  const r = t.tagName;
  r === w.TR ? e.openElements.hasInTableScope(w.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = Wa) : r === w.TABLE ? e.openElements.hasInTableScope(w.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = Wa, e._processToken(t)) : r === w.TBODY || r === w.TFOOT || r === w.THEAD ? (e.openElements.hasInTableScope(r) || e.openElements.hasInTableScope(w.TR)) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = Wa, e._processToken(t)) : (r !== w.BODY && r !== w.CAPTION && r !== w.COL && r !== w.COLGROUP || r !== w.HTML && r !== w.TD && r !== w.TH) && $D(e, t);
}
function xre(e, t) {
  const r = t.tagName;
  r === w.CAPTION || r === w.COL || r === w.COLGROUP || r === w.TBODY || r === w.TD || r === w.TFOOT || r === w.TH || r === w.THEAD || r === w.TR ? (e.openElements.hasInTableScope(w.TD) || e.openElements.hasInTableScope(w.TH)) && (e._closeTableCell(), e._processToken(t)) : ua(e, t);
}
function Are(e, t) {
  const r = t.tagName;
  r === w.TD || r === w.TH ? e.openElements.hasInTableScope(r) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(r), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = js) : r === w.TABLE || r === w.TBODY || r === w.TFOOT || r === w.THEAD || r === w.TR ? e.openElements.hasInTableScope(r) && (e._closeTableCell(), e._processToken(t)) : r !== w.BODY && r !== w.CAPTION && r !== w.COL && r !== w.COLGROUP && r !== w.HTML && jD(e, t);
}
function x7(e, t) {
  const r = t.tagName;
  r === w.HTML ? ua(e, t) : r === w.OPTION ? (e.openElements.currentTagName === w.OPTION && e.openElements.pop(), e._insertElement(t, vt.HTML)) : r === w.OPTGROUP ? (e.openElements.currentTagName === w.OPTION && e.openElements.pop(), e.openElements.currentTagName === w.OPTGROUP && e.openElements.pop(), e._insertElement(t, vt.HTML)) : r === w.INPUT || r === w.KEYGEN || r === w.TEXTAREA || r === w.SELECT ? e.openElements.hasInSelectScope(w.SELECT) && (e.openElements.popUntilTagNamePopped(w.SELECT), e._resetInsertionMode(), r !== w.SELECT && e._processToken(t)) : (r === w.SCRIPT || r === w.TEMPLATE) && Qi(e, t);
}
function A7(e, t) {
  const r = t.tagName;
  if (r === w.OPTGROUP) {
    const i = e.openElements.items[e.openElements.stackTop - 1], n = i && e.treeAdapter.getTagName(i);
    e.openElements.currentTagName === w.OPTION && n === w.OPTGROUP && e.openElements.pop(), e.openElements.currentTagName === w.OPTGROUP && e.openElements.pop();
  } else
    r === w.OPTION ? e.openElements.currentTagName === w.OPTION && e.openElements.pop() : r === w.SELECT && e.openElements.hasInSelectScope(w.SELECT) ? (e.openElements.popUntilTagNamePopped(w.SELECT), e._resetInsertionMode()) : r === w.TEMPLATE && fc(e, t);
}
function wre(e, t) {
  const r = t.tagName;
  r === w.CAPTION || r === w.TABLE || r === w.TBODY || r === w.TFOOT || r === w.THEAD || r === w.TR || r === w.TD || r === w.TH ? (e.openElements.popUntilTagNamePopped(w.SELECT), e._resetInsertionMode(), e._processToken(t)) : x7(e, t);
}
function Fre(e, t) {
  const r = t.tagName;
  r === w.CAPTION || r === w.TABLE || r === w.TBODY || r === w.TFOOT || r === w.THEAD || r === w.TR || r === w.TD || r === w.TH ? e.openElements.hasInTableScope(r) && (e.openElements.popUntilTagNamePopped(w.SELECT), e._resetInsertionMode(), e._processToken(t)) : A7(e, t);
}
function Tre(e, t) {
  const r = t.tagName;
  if (r === w.BASE || r === w.BASEFONT || r === w.BGSOUND || r === w.LINK || r === w.META || r === w.NOFRAMES || r === w.SCRIPT || r === w.STYLE || r === w.TEMPLATE || r === w.TITLE)
    Qi(e, t);
  else {
    const i = cte[r] || Qo;
    e._popTmplInsertionMode(), e._pushTmplInsertionMode(i), e.insertionMode = i, e._processToken(t);
  }
}
function Sre(e, t) {
  t.tagName === w.TEMPLATE && fc(e, t);
}
function w7(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.popUntilTagNamePopped(w.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e._popTmplInsertionMode(), e._resetInsertionMode(), e._processToken(t)) : e.stopped = !0;
}
function Ire(e, t) {
  t.tagName === w.HTML ? ua(e, t) : Kg(e, t);
}
function Bre(e, t) {
  t.tagName === w.HTML ? e.fragmentContext || (e.insertionMode = E7) : Kg(e, t);
}
function Kg(e, t) {
  e.insertionMode = Qo, e._processToken(t);
}
function Rre(e, t) {
  const r = t.tagName;
  r === w.HTML ? ua(e, t) : r === w.FRAMESET ? e._insertElement(t, vt.HTML) : r === w.FRAME ? (e._appendElement(t, vt.HTML), t.ackSelfClosing = !0) : r === w.NOFRAMES && Qi(e, t);
}
function Ore(e, t) {
  t.tagName === w.FRAMESET && !e.openElements.isRootHtmlElementCurrent() && (e.openElements.pop(), !e.fragmentContext && e.openElements.currentTagName !== w.FRAMESET && (e.insertionMode = y7));
}
function Pre(e, t) {
  const r = t.tagName;
  r === w.HTML ? ua(e, t) : r === w.NOFRAMES && Qi(e, t);
}
function Nre(e, t) {
  t.tagName === w.HTML && (e.insertionMode = C7);
}
function zre(e, t) {
  t.tagName === w.HTML ? ua(e, t) : rg(e, t);
}
function rg(e, t) {
  e.insertionMode = Qo, e._processToken(t);
}
function Lre(e, t) {
  const r = t.tagName;
  r === w.HTML ? ua(e, t) : r === w.NOFRAMES && Qi(e, t);
}
function Mre(e, t) {
  t.chars = ate.REPLACEMENT_CHARACTER, e._insertCharacters(t);
}
function jre(e, t) {
  e._insertCharacters(t), e.framesetOk = !1;
}
function Hre(e, t) {
  if (Vo.causesExit(t) && !e.fragmentContext) {
    for (; e.treeAdapter.getNamespaceURI(e.openElements.current) !== vt.HTML && !e._isIntegrationPoint(e.openElements.current); )
      e.openElements.pop();
    e._processToken(t);
  } else {
    const r = e._getAdjustedCurrentElement(), i = e.treeAdapter.getNamespaceURI(r);
    i === vt.MATHML ? Vo.adjustTokenMathMLAttrs(t) : i === vt.SVG && (Vo.adjustTokenSVGTagName(t), Vo.adjustTokenSVGAttrs(t)), Vo.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, i) : e._insertElement(t, i), t.ackSelfClosing = !0;
  }
}
function $re(e, t) {
  for (let r = e.openElements.stackTop; r > 0; r--) {
    const i = e.openElements.items[r];
    if (e.treeAdapter.getNamespaceURI(i) === vt.HTML) {
      e._processToken(t);
      break;
    }
    if (e.treeAdapter.getTagName(i).toLowerCase() === t.tagName) {
      e.openElements.popUntilElementPopped(i);
      break;
    }
  }
}
const Ure = /* @__PURE__ */ is(pte), kx = /[#.]/g;
function Vre(e, t) {
  const r = e || "", i = {};
  let n = 0, a, o;
  for (; n < r.length; ) {
    kx.lastIndex = n;
    const s = kx.exec(r), l = r.slice(n, s ? s.index : r.length);
    l && (a ? a === "#" ? i.id = l : Array.isArray(i.className) ? i.className.push(l) : i.className = [l] : o = l, n += l.length), s && (a = s[0], n++);
  }
  return {
    type: "element",
    // @ts-expect-error: fine.
    tagName: o || t || "div",
    properties: i,
    children: []
  };
}
const Wre = /* @__PURE__ */ new Set(["menu", "submit", "reset", "button"]), j_ = {}.hasOwnProperty;
function F7(e, t, r) {
  const i = r && qre(r);
  return (
    /**
     * @type {{
     *   (): Root
     *   (selector: null | undefined, ...children: Array<HChild>): Root
     *   (selector: string, properties?: HProperties, ...children: Array<HChild>): Element
     *   (selector: string, ...children: Array<HChild>): Element
     * }}
     */
    /**
     * Hyperscript compatible DSL for creating virtual hast trees.
     *
     * @param {string | null} [selector]
     * @param {HProperties | HChild} [properties]
     * @param {Array<HChild>} children
     * @returns {HResult}
     */
    function(a, o, ...s) {
      let l = -1, u;
      if (a == null)
        u = { type: "root", children: [] }, s.unshift(o);
      else if (u = Vre(a, t), u.tagName = u.tagName.toLowerCase(), i && j_.call(i, u.tagName) && (u.tagName = i[u.tagName]), Gre(o, u.tagName)) {
        let d;
        for (d in o)
          j_.call(o, d) && Kre(e, u.properties, d, o[d]);
      } else
        s.unshift(o);
      for (; ++l < s.length; )
        H_(u.children, s[l]);
      return u.type === "element" && u.tagName === "template" && (u.content = { type: "root", children: u.children }, u.children = []), u;
    }
  );
}
function Gre(e, t) {
  return e == null || typeof e != "object" || Array.isArray(e) ? !1 : t === "input" || !e.type || typeof e.type != "string" ? !0 : "children" in e && Array.isArray(e.children) ? !1 : t === "button" ? Wre.has(e.type.toLowerCase()) : !("value" in e);
}
function Kre(e, t, r, i) {
  const n = jm(e, r);
  let a = -1, o;
  if (i != null) {
    if (typeof i == "number") {
      if (Number.isNaN(i))
        return;
      o = i;
    } else
      typeof i == "boolean" ? o = i : typeof i == "string" ? n.spaceSeparated ? o = tC(i) : n.commaSeparated ? o = rC(i) : n.commaOrSpaceSeparated ? o = tC(rC(i).join(" ")) : o = bx(n, n.property, i) : Array.isArray(i) ? o = i.concat() : o = n.property === "style" ? Yre(i) : String(i);
    if (Array.isArray(o)) {
      const s = [];
      for (; ++a < o.length; )
        s[a] = bx(n, n.property, o[a]);
      o = s;
    }
    n.property === "className" && Array.isArray(t.className) && (o = t.className.concat(o)), t[n.property] = o;
  }
}
function H_(e, t) {
  let r = -1;
  if (t != null)
    if (typeof t == "string" || typeof t == "number")
      e.push({ type: "text", value: String(t) });
    else if (Array.isArray(t))
      for (; ++r < t.length; )
        H_(e, t[r]);
    else if (typeof t == "object" && "type" in t)
      t.type === "root" ? H_(e, t.children) : e.push(t);
    else
      throw new Error("Expected node, nodes, or string, got `" + t + "`");
}
function bx(e, t, r) {
  if (typeof r == "string") {
    if (e.number && r && !Number.isNaN(Number(r)))
      return Number(r);
    if ((e.boolean || e.overloadedBoolean) && (r === "" || A1(r) === A1(t)))
      return !0;
  }
  return r;
}
function Yre(e) {
  const t = [];
  let r;
  for (r in e)
    j_.call(e, r) && t.push([r, e[r]].join(": "));
  return t.join("; ");
}
function qre(e) {
  const t = {};
  let r = -1;
  for (; ++r < e.length; )
    t[e[r].toLowerCase()] = e[r];
  return t;
}
const Qre = F7(X1, "div"), Xre = [
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "solidColor",
  "textArea",
  "textPath"
], Zre = F7(gp, "g", Xre);
function Jre(e) {
  const t = String(e), r = [], i = /\r?\n|\r/g;
  for (; i.test(t); )
    r.push(i.lastIndex);
  return r.push(t.length + 1), { toPoint: n, toOffset: a };
  function n(o) {
    let s = -1;
    if (typeof o == "number" && o > -1 && o < r[r.length - 1]) {
      for (; ++s < r.length; )
        if (r[s] > o)
          return {
            line: s + 1,
            column: o - (s > 0 ? r[s - 1] : 0) + 1,
            offset: o
          };
    }
    return { line: void 0, column: void 0, offset: void 0 };
  }
  function a(o) {
    const s = o && o.line, l = o && o.column;
    if (typeof s == "number" && typeof l == "number" && !Number.isNaN(s) && !Number.isNaN(l) && s - 1 in r) {
      const u = (r[s - 2] || 0) + l - 1 || 0;
      if (u > -1 && u < r[r.length - 1])
        return u;
    }
    return -1;
  }
}
const w1 = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg",
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
}, T7 = {}.hasOwnProperty, eie = Object.prototype;
function tie(e, t) {
  const r = t || {};
  let i, n;
  return nie(r) ? (n = r, i = {}) : (n = r.file || void 0, i = r), UD(
    {
      schema: i.space === "svg" ? gp : X1,
      file: n,
      verbose: i.verbose,
      location: !1
    },
    e
  );
}
function UD(e, t) {
  let r;
  switch (t.nodeName) {
    case "#comment": {
      const i = (
        /** @type {P5Comment} */
        t
      );
      return r = { type: "comment", value: i.data }, ig(e, i, r), r;
    }
    case "#document":
    case "#document-fragment": {
      const i = (
        /** @type {P5Document | P5DocumentFragment} */
        t
      ), n = "mode" in i ? i.mode === "quirks" || i.mode === "limited-quirks" : !1;
      if (r = {
        type: "root",
        children: S7(e, t.childNodes),
        data: { quirksMode: n }
      }, e.file && e.location) {
        const a = String(e.file), o = Jre(a), s = o.toPoint(0), l = o.toPoint(a.length);
        r.position = { start: s, end: l };
      }
      return r;
    }
    case "#documentType": {
      const i = (
        /** @type {P5DocumentType} */
        t
      );
      return r = { type: "doctype" }, ig(e, i, r), r;
    }
    case "#text": {
      const i = (
        /** @type {P5Text} */
        t
      );
      return r = { type: "text", value: i.value }, ig(e, i, r), r;
    }
    default:
      return r = rie(
        e,
        /** @type {P5Element} */
        t
      ), r;
  }
}
function S7(e, t) {
  let r = -1;
  const i = [];
  for (; ++r < t.length; )
    i[r] = UD(e, t[r]);
  return i;
}
function rie(e, t) {
  const r = e.schema;
  e.schema = t.namespaceURI === w1.svg ? gp : X1;
  let i = -1;
  const n = {};
  for (; ++i < t.attrs.length; ) {
    const s = t.attrs[i], l = (s.prefix ? s.prefix + ":" : "") + s.name;
    T7.call(eie, l) || (n[l] = s.value);
  }
  const o = (e.schema.space === "svg" ? Zre : Qre)(t.tagName, n, S7(e, t.childNodes));
  if (ig(e, t, o), o.tagName === "template") {
    const s = (
      /** @type {P5Template} */
      t
    ), l = s.sourceCodeLocation, u = l && l.startTag && Od(l.startTag), d = l && l.endTag && Od(l.endTag), c = UD(e, s.content);
    u && d && e.file && (c.position = { start: u.end, end: d.start }), o.content = c;
  }
  return e.schema = r, o;
}
function ig(e, t, r) {
  if ("sourceCodeLocation" in t && t.sourceCodeLocation && e.file) {
    const i = iie(e, r, t.sourceCodeLocation);
    i && (e.location = !0, r.position = i);
  }
}
function iie(e, t, r) {
  const i = Od(r);
  if (t.type === "element") {
    const n = t.children[t.children.length - 1];
    if (i && !r.endTag && n && n.position && n.position.end && (i.end = Object.assign({}, n.position.end)), e.verbose) {
      const a = {};
      let o;
      if (r.attrs)
        for (o in r.attrs)
          T7.call(r.attrs, o) && (a[jm(e.schema, o).property] = Od(
            r.attrs[o]
          ));
      t.data = {
        position: {
          // @ts-expect-error: assume not `undefined`.
          opening: Od(r.startTag),
          closing: r.endTag ? Od(r.endTag) : null,
          properties: a
        }
      };
    }
  }
  return i;
}
function Od(e) {
  const t = _x({
    line: e.startLine,
    column: e.startCol,
    offset: e.startOffset
  }), r = _x({
    line: e.endLine,
    column: e.endCol,
    offset: e.endOffset
  });
  return t || r ? { start: t, end: r } : void 0;
}
function _x(e) {
  return e.line && e.column ? e : void 0;
}
function nie(e) {
  return "messages" in e;
}
const Dx = {}.hasOwnProperty;
function I7(e, t) {
  const r = t || {};
  function i(n, ...a) {
    let o = i.invalid;
    const s = i.handlers;
    if (n && Dx.call(n, e)) {
      const l = String(n[e]);
      o = Dx.call(s, l) ? s[l] : i.unknown;
    }
    if (o)
      return o.call(this, n, ...a);
  }
  return i.handlers = r.handlers || {}, i.invalid = r.invalid, i.unknown = r.unknown, i;
}
const aie = {}.hasOwnProperty, B7 = I7("type", { handlers: { root: sie, element: pie, text: cie, comment: die, doctype: uie } });
function oie(e, t) {
  const r = t && typeof t == "object" ? t.space : t;
  return B7(e, r === "svg" ? gp : X1);
}
function sie(e, t) {
  const r = {
    nodeName: "#document",
    // @ts-expect-error: `parse5` uses enums, which are actually strings.
    mode: (e.data || {}).quirksMode ? "quirks" : "no-quirks",
    childNodes: []
  };
  return r.childNodes = VD(e.children, r, t), vp(e, r), r;
}
function lie(e, t) {
  const r = { nodeName: "#document-fragment", childNodes: [] };
  return r.childNodes = VD(e.children, r, t), vp(e, r), r;
}
function uie(e) {
  const t = {
    nodeName: "#documentType",
    name: "html",
    publicId: "",
    systemId: "",
    // @ts-expect-error: change to `null` in a major?
    parentNode: void 0
  };
  return vp(e, t), t;
}
function cie(e) {
  const t = {
    nodeName: "#text",
    value: e.value,
    // @ts-expect-error: no `parentNode`
    parentNode: void 0
  };
  return vp(e, t), t;
}
function die(e) {
  const t = {
    nodeName: "#comment",
    data: e.value,
    // @ts-expect-error: no `parentNode`
    parentNode: void 0
  };
  return vp(e, t), t;
}
function pie(e, t) {
  const r = t;
  let i = r;
  e.type === "element" && e.tagName.toLowerCase() === "svg" && r.space === "html" && (i = gp);
  const n = [];
  let a;
  if (e.properties) {
    for (a in e.properties)
      if (a !== "children" && aie.call(e.properties, a)) {
        const s = hie(
          i,
          a,
          e.properties[a]
        );
        s && n.push(s);
      }
  }
  const o = {
    nodeName: e.tagName,
    tagName: e.tagName,
    attrs: n,
    // @ts-expect-error: html and svg both have a space.
    namespaceURI: w1[i.space],
    childNodes: [],
    // @ts-expect-error: no `parentNode`
    parentNode: void 0
  };
  return o.childNodes = VD(e.children, o, i), vp(e, o), e.tagName === "template" && e.content && (o.content = lie(e.content, i)), o;
}
function hie(e, t, r) {
  const i = jm(e, t);
  if (r == null || r === !1 || typeof r == "number" && Number.isNaN(r) || !r && i.boolean)
    return;
  Array.isArray(r) && (r = i.commaSeparated ? ZF(r) : XF(r));
  const n = {
    name: i.attribute,
    value: r === !0 ? "" : String(r)
  };
  if (i.space && i.space !== "html" && i.space !== "svg") {
    const a = n.name.indexOf(":");
    a < 0 ? n.prefix = "" : (n.name = n.name.slice(a + 1), n.prefix = i.attribute.slice(0, a)), n.namespace = w1[i.space];
  }
  return n;
}
function VD(e, t, r) {
  let i = -1;
  const n = [];
  if (e)
    for (; ++i < e.length; ) {
      const a = B7(e[i], r);
      a.parentNode = t, n.push(a);
    }
  return n;
}
function vp(e, t) {
  const r = e.position;
  r && r.start && r.end && (t.sourceCodeLocation = {
    startLine: r.start.line,
    startCol: r.start.column,
    // @ts-expect-error assume this is set.
    startOffset: r.start.offset,
    endLine: r.end.line,
    endCol: r.end.column,
    // @ts-expect-error assume this is set.
    endOffset: r.end.offset
  });
}
const fie = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "menuitem",
  "meta",
  "nextid",
  "param",
  "source",
  "track",
  "wbr"
], gie = "IN_TEMPLATE_MODE", mie = "DATA_STATE", vie = "CHARACTER_TOKEN", kie = "START_TAG_TOKEN", bie = "END_TAG_TOKEN", _ie = "COMMENT_TOKEN", Die = "DOCTYPE_TOKEN", yie = { sourceCodeLocationInfo: !0, scriptingEnabled: !1 }, R7 = (
  /**
   * @type {(
   *   ((tree: Node, file: VFile|undefined, options?: Options) => Node) &
   *   ((tree: Node, options?: Options) => Node)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {VFile} [file]
   * @param {Options} [options]
   */
  function(e, t, r) {
    let i = -1;
    const n = new Ure(yie), a = I7("type", {
      handlers: { root: k, element: y, text: _, comment: T, doctype: A, raw: N },
      // @ts-expect-error: hush.
      unknown: Aie
    });
    let o, s, l, u, d;
    if (Fie(t) && (r = t, t = void 0), r && r.passThrough)
      for (; ++i < r.passThrough.length; )
        a.handlers[r.passThrough[i]] = P;
    const c = tie(
      wie(e) ? f() : p(),
      t
    );
    if (o && Mm(c, "comment", (M, X, U) => {
      const K = (
        /** @type {Stitch} */
        /** @type {unknown} */
        M
      );
      if (K.value.stitch && U !== null && X !== null)
        return U.children[X] = K.value.stitch, X;
    }), e.type !== "root" && c.type === "root" && c.children.length === 1)
      return c.children[0];
    return c;
    function p() {
      const M = {
        nodeName: "template",
        tagName: "template",
        attrs: [],
        namespaceURI: w1.html,
        childNodes: []
      }, X = {
        nodeName: "documentmock",
        tagName: "documentmock",
        attrs: [],
        namespaceURI: w1.html,
        childNodes: []
      }, U = { nodeName: "#document-fragment", childNodes: [] };
      if (n._bootstrap(X, M), n._pushTmplInsertionMode(gie), n._initTokenizerForFragmentParsing(), n._insertFakeRootElement(), n._resetInsertionMode(), n._findFormInFragmentContext(), s = n.tokenizer, !s)
        throw new Error("Expected `tokenizer`");
      return l = s.preprocessor, d = s.__mixins[0], u = d.posTracker, a(e), B(), n._adoptNodes(X.childNodes[0], U), U;
    }
    function f() {
      const M = n.treeAdapter.createDocument();
      if (n._bootstrap(M, void 0), s = n.tokenizer, !s)
        throw new Error("Expected `tokenizer`");
      return l = s.preprocessor, d = s.__mixins[0], u = d.posTracker, a(e), B(), M;
    }
    function g(M) {
      let X = -1;
      if (M)
        for (; ++X < M.length; )
          a(M[X]);
    }
    function k(M) {
      g(M.children);
    }
    function y(M) {
      B(), n._processInputToken(Eie(M)), g(M.children), fie.includes(M.tagName) || (B(), n._processInputToken(xie(M)));
    }
    function _(M) {
      B(), n._processInputToken({
        type: vie,
        chars: M.value,
        location: Pd(M)
      });
    }
    function A(M) {
      B(), n._processInputToken({
        type: Die,
        name: "html",
        forceQuirks: !1,
        publicId: "",
        systemId: "",
        location: Pd(M)
      });
    }
    function T(M) {
      B(), n._processInputToken({
        type: _ie,
        data: M.value,
        location: Pd(M)
      });
    }
    function N(M) {
      const X = q1(M), U = X.line || 1, K = X.column || 1, z = X.offset || 0;
      if (!l)
        throw new Error("Expected `preprocessor`");
      if (!s)
        throw new Error("Expected `tokenizer`");
      if (!u)
        throw new Error("Expected `posTracker`");
      if (!d)
        throw new Error("Expected `locationTracker`");
      l.html = void 0, l.pos = -1, l.lastGapPos = -1, l.lastCharPos = -1, l.gapStack = [], l.skipNextNewLine = !1, l.lastChunkWritten = !1, l.endOfChunkHit = !1, u.isEol = !1, u.lineStartPos = -K + 1, u.droppedBufferSize = z, u.offset = 0, u.col = 1, u.line = U, d.currentAttrLocation = void 0, d.ctLoc = Pd(M), s.write(M.value), n._runParsingLoop(null), (s.state === "NAMED_CHARACTER_REFERENCE_STATE" || s.state === "NUMERIC_CHARACTER_REFERENCE_END_STATE") && (l.lastChunkWritten = !0, s[s.state](s._consume()));
    }
    function P(M) {
      o = !0;
      let X;
      "children" in M ? X = {
        ...M,
        children: R7(
          { type: "root", children: M.children },
          t,
          r
          // @ts-expect-error Assume a given parent yields a parent.
        ).children
      } : X = { ...M }, T({ type: "comment", value: { stitch: X } });
    }
    function B() {
      if (!s)
        throw new Error("Expected `tokenizer`");
      if (!u)
        throw new Error("Expected `posTracker`");
      const M = s.currentCharacterToken;
      M && (M.location.endLine = u.line, M.location.endCol = u.col + 1, M.location.endOffset = u.offset + 1, n._processInputToken(M)), s.tokenQueue = [], s.state = mie, s.returnState = "", s.charRefCode = -1, s.tempBuff = [], s.lastStartTagName = "", s.consumedAfterSnapshot = -1, s.active = !1, s.currentCharacterToken = void 0, s.currentToken = void 0, s.currentAttr = void 0;
    }
  }
);
function Eie(e) {
  const t = Object.assign(Pd(e));
  return t.startTag = Object.assign({}, t), {
    type: kie,
    tagName: e.tagName,
    selfClosing: !1,
    attrs: Cie(e),
    location: t
  };
}
function Cie(e) {
  return oie({
    tagName: e.tagName,
    type: "element",
    properties: e.properties,
    children: []
    // @ts-expect-error Assume element.
  }).attrs;
}
function xie(e) {
  const t = Object.assign(Pd(e));
  return t.startTag = Object.assign({}, t), {
    type: bie,
    tagName: e.tagName,
    attrs: [],
    location: t
  };
}
function Aie(e) {
  throw new Error("Cannot compile `" + e.type + "` node");
}
function wie(e) {
  const t = e.type === "root" ? e.children[0] : e;
  return !!(t && (t.type === "doctype" || t.type === "element" && t.tagName === "html"));
}
function Pd(e) {
  const t = q1(e), r = zm(e);
  return {
    startLine: t.line,
    startCol: t.column,
    startOffset: t.offset,
    endLine: r.line,
    endCol: r.column,
    endOffset: r.offset
  };
}
function Fie(e) {
  return !!(e && !("message" in e && "messages" in e));
}
function Tie(e = {}) {
  return (t, r) => (
    /** @type {Root} */
    R7(t, r, e)
  );
}
const Sie = (e, t) => {
  if (!t)
    return e;
  try {
    const r = new URL(e);
    return Object.keys(t).forEach((i) => {
      t[i] && r.searchParams.append(i, t[i]);
    }), r.href;
  } catch {
    return e;
  }
}, Iie = Je(
  ({ href: e, children: t, additionalQueryParams: r, ...i }, n) => {
    const { appendQueryParamsToUrls: a } = Xi(), o = a || r ? {
      ...a,
      ...r
    } : void 0, s = e && Sie(e, o);
    return /* @__PURE__ */ v.jsx(dm, { ref: n, href: s, ...i, children: t });
  }
), Yg = Iie, Bie = B2.oneLight, Rie = B2.vsDark, Oie = ({ codeString: e, language: t }) => {
  const { theme: r, prism: i } = Xi(), n = r == null ? void 0 : r.syntaxHighlighter, { lightTheme: a = Bie, darkTheme: o = Rie } = n ?? {}, s = ia(a, o), l = ia(
    Nr.var("colors.gray.50"),
    Nr.var("colors.grayDark.800")
  ), u = ia(
    Nr.var("colors.gray.300"),
    Nr.var("colors.grayDark.600")
  );
  return /* @__PURE__ */ v.jsx(
    qj,
    {
      theme: s,
      code: e,
      language: t,
      prism: i,
      children: ({
        className: d,
        style: c,
        tokens: p,
        getLineProps: f,
        getTokenProps: g
      }) => /* @__PURE__ */ v.jsx(
        "div",
        {
          className: `${d} ${ye}-codeblock-highlighter`,
          style: {
            ...c,
            fontSize: "13px",
            borderRadius: "0 0 6px 6px",
            background: l,
            overflowX: "auto",
            padding: "1em",
            whiteSpace: "pre",
            margin: "0px 0px 0.5em",
            scrollbarWidth: "thin",
            scrollbarColor: `${u} transparent`
          },
          children: /* @__PURE__ */ v.jsx("code", { style: { fontFamily: Nr.var("fonts.mono") }, children: p.map((k, y) => (
            // eslint-disable-next-line react/no-array-index-key
            /* @__PURE__ */ v.jsx("div", { ...f({ line: k }), children: k.map((_, A) => /* @__PURE__ */ v.jsx(
              "span",
              {
                ...g({ token: _ })
              },
              A
            )) }, y)
          )) })
        }
      )
    }
  );
}, Pie = Oie, Gs = Je(
  ({ children: e, ...t }, r) => {
    const i = MH();
    return (
      // @ts-ignore
      /* @__PURE__ */ v.jsx(F6, { ...i, ...t, ref: r, children: /* @__PURE__ */ v.jsx(U1, { children: e }) })
    );
  }
), Nie = ({
  codeString: e,
  language: t,
  chatSessionId: r
}) => {
  const i = la(), [n, a] = rt("Copy to clipboard"), [o, s] = rt(!1);
  function l() {
    i.capture({
      eventName: "chat_code_block_copied",
      properties: {
        chatSessionId: r || null
      }
    }), navigator.clipboard.writeText(e), a("Copied!"), setTimeout(() => void a("Copy to clipboard"), 1500), setTimeout(() => void s(!1), 500);
  }
  return /* @__PURE__ */ v.jsxs(
    mt,
    {
      className: `${ye}-codeblock-header`,
      alignItems: "center",
      justifyContent: "space-between",
      _light: {
        bg: "gray.100",
        color: "gray.700"
      },
      _dark: {
        bg: "grayDark.700",
        color: "gray.400"
      },
      marginBottom: "0",
      lineHeight: "shorter",
      px: 2,
      fontSize: "xs",
      transform: "all 0.2s ease-in-out",
      borderRadius: "6px 6px 0 0",
      children: [
        /* @__PURE__ */ v.jsx(mt, { className: `${ye}-codeblock-header__language-wrapper`, children: /* @__PURE__ */ v.jsx(
          cn,
          {
            display: "inline-flex",
            className: `${ye}-codeblock-header__language`,
            children: t
          }
        ) }),
        /* @__PURE__ */ v.jsx(
          mt,
          {
            onClick: l,
            alignItems: "center",
            borderRadius: 8,
            _dark: {
              color: "gray.400",
              _hover: {
                color: "white"
              }
            },
            _light: {
              color: "gray.600",
              _hover: {
                color: "gray.700"
              }
            },
            className: `${ye}-codeblock-header__copy-button-wrapper`,
            children: /* @__PURE__ */ v.jsxs(
              Ir,
              {
                positioning: { placement: "top" },
                open: o,
                closeOnPointerDown: !1,
                openDelay: 0,
                closeDelay: 0,
                children: [
                  /* @__PURE__ */ v.jsx(Ir.Trigger, { asChild: !0, children: /* @__PURE__ */ v.jsx(
                    tL,
                    {
                      "aria-label": "Copy to clipboard",
                      size: "sm",
                      bg: "inherit",
                      color: "inherit",
                      _hover: {
                        backgroundColor: "transparent !important"
                      },
                      _dark: {
                        _hover: {
                          color: "white"
                        }
                      },
                      _light: {
                        _hover: {
                          color: "gray.700"
                        }
                      },
                      onMouseOver: () => void s(!0),
                      onMouseOut: () => void s(!1),
                      className: `${ye}-codeblock-header__copy-button`,
                      children: /* @__PURE__ */ v.jsx(
                        zn,
                        {
                          iconKey: "codeCopy",
                          className: `${ye}-copy-code-icon`
                        }
                      )
                    }
                  ) }),
                  /* @__PURE__ */ v.jsx(Gs, { children: /* @__PURE__ */ v.jsx(Ir.Positioner, { zIndex: "tooltip", children: /* @__PURE__ */ v.jsxs(Ir.Content, { fontSize: "sm", present: o, children: [
                    /* @__PURE__ */ v.jsx(Ir.Arrow, { children: /* @__PURE__ */ v.jsx(Ir.ArrowTip, {}) }),
                    n
                  ] }) }) })
                ]
              }
            )
          }
        )
      ]
    }
  );
}, zie = Nie, Lie = ({
  node: e,
  inline: t,
  className: r = "",
  children: i,
  chatSessionId: n,
  inlineCodeClassName: a
}) => {
  const o = We.replace(r, We("^language-", ""), ""), s = We("\\n$"), l = We.replace(String(i), s, "");
  return t ? /* @__PURE__ */ v.jsx(
    Wz,
    {
      variant: "solid",
      background: "inkeepPrimary.medium",
      color: "inkeepPrimary.textColorOnPrimary",
      className: a,
      children: i
    }
  ) : /* @__PURE__ */ v.jsxs(
    Ct,
    {
      overflowY: "auto",
      marginBottom: "12px",
      className: `${ye}-codeblock-container`,
      children: [
        /* @__PURE__ */ v.jsx(
          zie,
          {
            codeString: l,
            language: o,
            chatSessionId: n
          }
        ),
        /* @__PURE__ */ v.jsx("div", { className: `${ye}-codeblock-highlighter-wrapper`, children: /* @__PURE__ */ v.jsx(Pie, { codeString: l, language: o }) })
      ]
    }
  );
}, Mie = Lie, jie = ({
  children: e,
  citationNumberToDisplayOrderMap: t,
  citationNumberToChatCitationMap: r,
  className: i,
  chatSessionId: n,
  messageId: a,
  shouldOpenLinksInNewTab: o
}) => {
  const s = la();
  return Jt(() => {
    const u = ht.Children.toArray(e).find(
      (p) => ht.isValidElement(p) && p.props.node.tagName === "a"
    ), d = !!u, c = u == null ? void 0 : u.props.children[0];
    return d && c && t ? /* @__PURE__ */ v.jsx("sup", { className: i, children: /* @__PURE__ */ v.jsx(
      Yg,
      {
        className: `${i}-link`,
        onClick: () => {
          var p, f;
          s.capture({
            eventName: "chat_response_citation_clicked",
            properties: {
              chatSessionId: n || "",
              messageId: a,
              citationType: "INLINE",
              title: ((p = r == null ? void 0 : r[c]) == null ? void 0 : p.title) || void 0,
              url: ((f = r == null ? void 0 : r[c]) == null ? void 0 : f.url) || void 0
            }
          });
        },
        isExternal: o,
        href: r && Object.keys(r).length > 0 && r[c] && r[c].url || "",
        children: t[c]
      }
    ) }) : /* @__PURE__ */ v.jsx("span", {});
  }, [
    e,
    t,
    r,
    i
  ]);
}, Hie = jie, Qn = _B(), $ie = [
  "script",
  "iframe",
  "frame",
  "embed",
  "meta",
  "base",
  "form",
  "style",
  "object"
], Uie = ({
  markdown: e,
  urlToChatCitationMap: t,
  citationNumberToChatCitationMap: r,
  citationNumberToDisplayOrderMap: i,
  chatSessionId: n,
  messageId: a,
  shouldOpenLinksInNewTab: o
}) => {
  const [s, l] = rt({}), u = {
    // Use Chakra UI components and their corresponding styles
    // for rendering Markdown content
    h1: ({ children: d }) => /* @__PURE__ */ v.jsx(Eg, { size: "md", children: d }),
    h2: ({ children: d }) => /* @__PURE__ */ v.jsx(Eg, { size: "sm", children: d }),
    p: ({ children: d }) => /* @__PURE__ */ v.jsx("p", { className: Qn.text, children: d }),
    section: ({ children: d, className: c }) => {
      if (c !== "footnotes")
        return /* @__PURE__ */ v.jsx("section", { className: c, children: d });
      const p = [], f = (k) => {
        if (ht.isValidElement(k) && k.props.node.tagName === "a" && k.props.href && p.push(k.props.href), ht.isValidElement(k) && k.props) {
          const _ = k.props.children;
          _ && ht.Children.toArray(_).forEach(f);
        }
      };
      ht.Children.toArray(d).forEach(f);
      const g = p.reduce(
        (k, y, _, A) => (_ > 0 && !A[_ - 1].startsWith("#") && (k[y] = A[_ - 1]), k),
        {}
      );
      return Object.keys(g).length != Object.keys(s).length && l(g), /* @__PURE__ */ v.jsxs("section", { children: [
        /* @__PURE__ */ v.jsx(cn, { display: "block", children: "Learn more:" }),
        /* @__PURE__ */ v.jsx(ef.Ordered, { className: Qn.ol, children: Object.entries(g).map(
          ([k, y], _) => /* @__PURE__ */ v.jsx("li", { children: /* @__PURE__ */ v.jsx(
            Yg,
            {
              className: Qn.link,
              href: y,
              isExternal: o,
              overflowWrap: "break-word",
              children: t == null ? void 0 : t[y].title
            }
          ) })
        ) })
      ] });
    },
    sup: ({ children: d, ...c }) => i && a ? /* @__PURE__ */ v.jsx(
      Hie,
      {
        children: d,
        chatSessionId: n || "",
        messageId: a,
        citationNumberToDisplayOrderMap: i,
        citationNumberToChatCitationMap: r,
        className: Qn.sup,
        shouldOpenLinksInNewTab: o
      }
    ) : /* @__PURE__ */ v.jsx(v.Fragment, { children: d }),
    li: ({
      ordered: d,
      children: c
    }) => /* @__PURE__ */ v.jsx(ef.Item, { className: Qn.li, overflowWrap: "break-word", children: c }),
    ul: ({ children: d }) => /* @__PURE__ */ v.jsx(
      ef.Unordered,
      {
        className: Qn.ul,
        overflowWrap: "break-word",
        children: d
      }
    ),
    ol: ({ children: d, node: c }) => {
      var f;
      const p = (f = c == null ? void 0 : c.properties) == null ? void 0 : f.start;
      return /* @__PURE__ */ v.jsx(
        ef.Ordered,
        {
          className: Qn.ol,
          style: {
            counterReset: `item ${(Number.parseInt(p) - 1).toString()}`
          },
          start: p,
          overflowWrap: "break-word",
          children: d
        }
      );
    },
    a: ({ href: d, children: c }) => /* @__PURE__ */ v.jsx(
      Yg,
      {
        className: Qn.link,
        href: d,
        isExternal: o,
        overflowWrap: "break-word",
        children: c
      }
    ),
    img: ({ src: d, alt: c }) => `![${c || ""}](${d || ""})`,
    table: ({ children: d }) => /* @__PURE__ */ v.jsx(hd, { className: Qn.table, children: d }),
    thead: ({ children: d }) => /* @__PURE__ */ v.jsx(hd.Header, { className: Qn.thead, children: d }),
    tbody: ({ children: d }) => /* @__PURE__ */ v.jsx(hd.Body, { className: Qn.tbody, children: d }),
    tr: ({ children: d }) => /* @__PURE__ */ v.jsx(hd.Row, { className: Qn.tr, children: d }),
    th: ({
      children: d,
      isHeader: c
    }) => {
      const p = c ? hd.Head : hd.Cell;
      return /* @__PURE__ */ v.jsx(p, { className: Qn.td, children: d });
    },
    code: ({ children: d, ...c }) => /* @__PURE__ */ v.jsx(
      Mie,
      {
        chatSessionId: n,
        inlineCodeClassName: Qn.code,
        ...c,
        children: d
      }
    )
  };
  return /* @__PURE__ */ v.jsx(
    Ct,
    {
      fontSize: "15px",
      flexWrap: "wrap",
      overflowWrap: "break-word",
      minWidth: "0",
      flexShrink: 1,
      maxWidth: "100%",
      children: /* @__PURE__ */ v.jsx(
        t7,
        {
          rehypePlugins: [Tie],
          components: u,
          children: e,
          disallowedElements: $ie
        }
      )
    }
  );
}, Ym = Uie;
function Vie({
  heading: e = "Thank you!",
  message: t = "Your form has been submitted successfully.",
  onClose: r,
  successConfirmationButton: i
}) {
  const { label: n, icon: a } = i || {}, { shouldOpenLinksInNewTab: o } = Qr();
  return /* @__PURE__ */ v.jsxs(
    mt,
    {
      direction: "column",
      alignItems: "center",
      justifyContent: "center",
      margin: "auto",
      className: `${ye}-success-confirmation`,
      children: [
        /* @__PURE__ */ v.jsx(
          Eg,
          {
            mb: 6,
            fontWeight: "bold",
            letterSpacing: "tight",
            className: `${ye}-success-confirmation__heading`,
            children: e
          }
        ),
        /* @__PURE__ */ v.jsx("div", { className: `${ye}-success-confirmation__message`, children: /* @__PURE__ */ v.jsx(
          Ym,
          {
            markdown: t,
            shouldOpenLinksInNewTab: o
          }
        ) }),
        i && /* @__PURE__ */ v.jsx(
          di,
          {
            variant: "neutralFilled",
            onClick: r,
            mt: 16,
            leftIcon: a && /* @__PURE__ */ v.jsx(
              cp,
              {
                iconSettings: a,
                className: `${ye}-success-confirmation__button-icon`
              }
            ),
            width: "100%",
            className: `${ye}-success-confirmation__button`,
            children: n
          }
        )
      ]
    }
  );
}
var J1 = (e) => e.type === "checkbox", Nd = (e) => e instanceof Date, On = (e) => e == null;
const O7 = (e) => typeof e == "object";
var Gi = (e) => !On(e) && !Array.isArray(e) && O7(e) && !Nd(e), P7 = (e) => Gi(e) && e.target ? J1(e.target) ? e.target.checked : e.target.value : e, Wie = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, N7 = (e, t) => e.has(Wie(t)), Gie = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Gi(t) && t.hasOwnProperty("isPrototypeOf");
}, WD = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function ta(e) {
  let t;
  const r = Array.isArray(e);
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(WD && (e instanceof Blob || e instanceof FileList)) && (r || Gi(e)))
    if (t = r ? [] : {}, !r && !Gie(e))
      t = e;
    else
      for (const i in e)
        e.hasOwnProperty(i) && (t[i] = ta(e[i]));
  else
    return e;
  return t;
}
var eh = (e) => Array.isArray(e) ? e.filter(Boolean) : [], bi = (e) => e === void 0, st = (e, t, r) => {
  if (!t || !Gi(e))
    return r;
  const i = eh(t.split(/[,[\].]+?/)).reduce((n, a) => On(n) ? n : n[a], e);
  return bi(i) || i === e ? bi(e[t]) ? r : e[t] : i;
}, mo = (e) => typeof e == "boolean";
const qg = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, vo = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Is = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Kie = ht.createContext(null), GD = () => ht.useContext(Kie);
var z7 = (e, t, r, i = !0) => {
  const n = {
    defaultValues: t._defaultValues
  };
  for (const a in e)
    Object.defineProperty(n, a, {
      get: () => {
        const o = a;
        return t._proxyFormState[o] !== vo.all && (t._proxyFormState[o] = !i || vo.all), r && (r[o] = !0), e[o];
      }
    });
  return n;
}, Ma = (e) => Gi(e) && !Object.keys(e).length, L7 = (e, t, r, i) => {
  r(e);
  const { name: n, ...a } = e;
  return Ma(a) || Object.keys(a).length >= Object.keys(t).length || Object.keys(a).find((o) => t[o] === (!i || vo.all));
}, ng = (e) => Array.isArray(e) ? e : [e], M7 = (e, t, r) => !e || !t || e === t || ng(e).some((i) => i && (r ? i === t : i.startsWith(t) || t.startsWith(i)));
function KD(e) {
  const t = ht.useRef(e);
  t.current = e, ht.useEffect(() => {
    const r = !e.disabled && t.current.subject && t.current.subject.subscribe({
      next: t.current.next
    });
    return () => {
      r && r.unsubscribe();
    };
  }, [e.disabled]);
}
function Yie(e) {
  const t = GD(), { control: r = t.control, disabled: i, name: n, exact: a } = e || {}, [o, s] = ht.useState(r._formState), l = ht.useRef(!0), u = ht.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), d = ht.useRef(n);
  return d.current = n, KD({
    disabled: i,
    next: (c) => l.current && M7(d.current, c.name, a) && L7(c, u.current, r._updateFormState) && s({
      ...r._formState,
      ...c
    }),
    subject: r._subjects.state
  }), ht.useEffect(() => (l.current = !0, u.current.isValid && r._updateValid(!0), () => {
    l.current = !1;
  }), [r]), z7(o, r, u.current, !1);
}
var Ko = (e) => typeof e == "string", j7 = (e, t, r, i, n) => Ko(e) ? (i && t.watch.add(e), st(r, e, n)) : Array.isArray(e) ? e.map((a) => (i && t.watch.add(a), st(r, a))) : (i && (t.watchAll = !0), r);
function qie(e) {
  const t = GD(), { control: r = t.control, name: i, defaultValue: n, disabled: a, exact: o } = e || {}, s = ht.useRef(i);
  s.current = i, KD({
    disabled: a,
    subject: r._subjects.values,
    next: (d) => {
      M7(s.current, d.name, o) && u(ta(j7(s.current, r._names, d.values || r._formValues, !1, n)));
    }
  });
  const [l, u] = ht.useState(r._getWatch(i, n));
  return ht.useEffect(() => r._removeUnmounted()), l;
}
var YD = (e) => /^\w*$/.test(e), H7 = (e) => eh(e.replace(/["|']|\]/g, "").split(/\.|\[/)), ei = (e, t, r) => {
  let i = -1;
  const n = YD(t) ? [t] : H7(t), a = n.length, o = a - 1;
  for (; ++i < a; ) {
    const s = n[i];
    let l = r;
    if (i !== o) {
      const u = e[s];
      l = Gi(u) || Array.isArray(u) ? u : isNaN(+n[i + 1]) ? {} : [];
    }
    e[s] = l, e = e[s];
  }
  return e;
};
function Qie(e) {
  const t = GD(), { name: r, disabled: i, control: n = t.control, shouldUnregister: a } = e, o = N7(n._names.array, r), s = qie({
    control: n,
    name: r,
    defaultValue: st(n._formValues, r, st(n._defaultValues, r, e.defaultValue)),
    exact: !0
  }), l = Yie({
    control: n,
    name: r
  }), u = ht.useRef(n.register(r, {
    ...e.rules,
    value: s,
    ...mo(e.disabled) ? { disabled: e.disabled } : {}
  }));
  return ht.useEffect(() => {
    const d = n._options.shouldUnregister || a, c = (p, f) => {
      const g = st(n._fields, p);
      g && (g._f.mount = f);
    };
    if (c(r, !0), d) {
      const p = ta(st(n._options.defaultValues, r));
      ei(n._defaultValues, r, p), bi(st(n._formValues, r)) && ei(n._formValues, r, p);
    }
    return () => {
      (o ? d && !n._state.action : d) ? n.unregister(r) : c(r, !1);
    };
  }, [r, n, o, a]), ht.useEffect(() => {
    st(n._fields, r) && n._updateDisabledField({
      disabled: i,
      fields: n._fields,
      name: r,
      value: st(n._fields, r)._f.value
    });
  }, [i, r, n]), {
    field: {
      name: r,
      value: s,
      ...mo(i) || l.disabled ? { disabled: l.disabled || i } : {},
      onChange: ht.useCallback((d) => u.current.onChange({
        target: {
          value: P7(d),
          name: r
        },
        type: qg.CHANGE
      }), [r]),
      onBlur: ht.useCallback(() => u.current.onBlur({
        target: {
          value: st(n._formValues, r),
          name: r
        },
        type: qg.BLUR
      }), [r, n]),
      ref: (d) => {
        const c = st(n._fields, r);
        c && d && (c._f.ref = {
          focus: () => d.focus(),
          select: () => d.select(),
          setCustomValidity: (p) => d.setCustomValidity(p),
          reportValidity: () => d.reportValidity()
        });
      }
    },
    formState: l,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!st(l.errors, r)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!st(l.dirtyFields, r)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!st(l.touchedFields, r)
      },
      error: {
        enumerable: !0,
        get: () => st(l.errors, r)
      }
    })
  };
}
const $7 = (e) => e.render(Qie(e));
var Xie = (e, t, r, i, n) => t ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: n || !0
  }
} : {}, yx = (e) => ({
  isOnSubmit: !e || e === vo.onSubmit,
  isOnBlur: e === vo.onBlur,
  isOnChange: e === vo.onChange,
  isOnAll: e === vo.all,
  isOnTouch: e === vo.onTouched
}), Ex = (e, t, r) => !r && (t.watchAll || t.watch.has(e) || [...t.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const o1 = (e, t, r, i) => {
  for (const n of r || Object.keys(e)) {
    const a = st(e, n);
    if (a) {
      const { _f: o, ...s } = a;
      if (o) {
        if (o.refs && o.refs[0] && t(o.refs[0], n) && !i)
          break;
        if (o.ref && t(o.ref, o.name) && !i)
          break;
        o1(s, t);
      } else
        Gi(s) && o1(s, t);
    }
  }
};
var Zie = (e, t, r) => {
  const i = eh(st(e, r));
  return ei(i, "root", t[r]), ei(e, r, i), e;
}, qD = (e) => e.type === "file", Al = (e) => typeof e == "function", Qg = (e) => {
  if (!WD)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, ag = (e) => Ko(e), QD = (e) => e.type === "radio", Xg = (e) => e instanceof RegExp;
const Cx = {
  value: !1,
  isValid: !1
}, xx = { value: !0, isValid: !0 };
var U7 = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !bi(e[0].attributes.value) ? bi(e[0].value) || e[0].value === "" ? xx : { value: e[0].value, isValid: !0 } : xx
    ) : Cx;
  }
  return Cx;
};
const Ax = {
  isValid: !1,
  value: null
};
var V7 = (e) => Array.isArray(e) ? e.reduce((t, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : t, Ax) : Ax;
function wx(e, t, r = "validate") {
  if (ag(e) || Array.isArray(e) && e.every(ag) || mo(e) && !e)
    return {
      type: r,
      message: ag(e) ? e : "",
      ref: t
    };
}
var _d = (e) => Gi(e) && !Xg(e) ? e : {
  value: e,
  message: ""
}, Fx = async (e, t, r, i, n) => {
  const { ref: a, refs: o, required: s, maxLength: l, minLength: u, min: d, max: c, pattern: p, validate: f, name: g, valueAsNumber: k, mount: y, disabled: _ } = e._f, A = st(t, g);
  if (!y || _)
    return {};
  const T = o ? o[0] : a, N = (j) => {
    i && T.reportValidity && (T.setCustomValidity(mo(j) ? "" : j || ""), T.reportValidity());
  }, P = {}, B = QD(a), M = J1(a), X = B || M, U = (k || qD(a)) && bi(a.value) && bi(A) || Qg(a) && a.value === "" || A === "" || Array.isArray(A) && !A.length, K = Xie.bind(null, g, r, P), z = (j, J, ie, ue = Is.maxLength, de = Is.minLength) => {
    const he = j ? J : ie;
    P[g] = {
      type: j ? ue : de,
      message: he,
      ref: a,
      ...K(j ? ue : de, he)
    };
  };
  if (n ? !Array.isArray(A) || !A.length : s && (!X && (U || On(A)) || mo(A) && !A || M && !U7(o).isValid || B && !V7(o).isValid)) {
    const { value: j, message: J } = ag(s) ? { value: !!s, message: s } : _d(s);
    if (j && (P[g] = {
      type: Is.required,
      message: J,
      ref: T,
      ...K(Is.required, J)
    }, !r))
      return N(J), P;
  }
  if (!U && (!On(d) || !On(c))) {
    let j, J;
    const ie = _d(c), ue = _d(d);
    if (!On(A) && !isNaN(A)) {
      const de = a.valueAsNumber || A && +A;
      On(ie.value) || (j = de > ie.value), On(ue.value) || (J = de < ue.value);
    } else {
      const de = a.valueAsDate || new Date(A), he = (L) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + L), Ee = a.type == "time", Le = a.type == "week";
      Ko(ie.value) && A && (j = Ee ? he(A) > he(ie.value) : Le ? A > ie.value : de > new Date(ie.value)), Ko(ue.value) && A && (J = Ee ? he(A) < he(ue.value) : Le ? A < ue.value : de < new Date(ue.value));
    }
    if ((j || J) && (z(!!j, ie.message, ue.message, Is.max, Is.min), !r))
      return N(P[g].message), P;
  }
  if ((l || u) && !U && (Ko(A) || n && Array.isArray(A))) {
    const j = _d(l), J = _d(u), ie = !On(j.value) && A.length > +j.value, ue = !On(J.value) && A.length < +J.value;
    if ((ie || ue) && (z(ie, j.message, J.message), !r))
      return N(P[g].message), P;
  }
  if (p && !U && Ko(A)) {
    const { value: j, message: J } = _d(p);
    if (Xg(j) && !A.match(j) && (P[g] = {
      type: Is.pattern,
      message: J,
      ref: a,
      ...K(Is.pattern, J)
    }, !r))
      return N(J), P;
  }
  if (f) {
    if (Al(f)) {
      const j = await f(A, t), J = wx(j, T);
      if (J && (P[g] = {
        ...J,
        ...K(Is.validate, J.message)
      }, !r))
        return N(J.message), P;
    } else if (Gi(f)) {
      let j = {};
      for (const J in f) {
        if (!Ma(j) && !r)
          break;
        const ie = wx(await f[J](A, t), T, J);
        ie && (j = {
          ...ie,
          ...K(J, ie.message)
        }, N(ie.message), r && (P[g] = j));
      }
      if (!Ma(j) && (P[g] = {
        ref: T,
        ...j
      }, !r))
        return P;
    }
  }
  return N(!0), P;
};
function Jie(e, t) {
  const r = t.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = bi(e) ? i++ : e[t[i++]];
  return e;
}
function ene(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !bi(e[t]))
      return !1;
  return !0;
}
function sn(e, t) {
  const r = Array.isArray(t) ? t : YD(t) ? [t] : H7(t), i = r.length === 1 ? e : Jie(e, r), n = r.length - 1, a = r[n];
  return i && delete i[a], n !== 0 && (Gi(i) && Ma(i) || Array.isArray(i) && ene(i)) && sn(e, r.slice(0, -1)), e;
}
var kb = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const a of e)
        a.next && a.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((a) => a !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Zg = (e) => On(e) || !O7(e);
function Gu(e, t) {
  if (Zg(e) || Zg(t))
    return e === t;
  if (Nd(e) && Nd(t))
    return e.getTime() === t.getTime();
  const r = Object.keys(e), i = Object.keys(t);
  if (r.length !== i.length)
    return !1;
  for (const n of r) {
    const a = e[n];
    if (!i.includes(n))
      return !1;
    if (n !== "ref") {
      const o = t[n];
      if (Nd(a) && Nd(o) || Gi(a) && Gi(o) || Array.isArray(a) && Array.isArray(o) ? !Gu(a, o) : a !== o)
        return !1;
    }
  }
  return !0;
}
var W7 = (e) => e.type === "select-multiple", tne = (e) => QD(e) || J1(e), bb = (e) => Qg(e) && e.isConnected, G7 = (e) => {
  for (const t in e)
    if (Al(e[t]))
      return !0;
  return !1;
};
function Jg(e, t = {}) {
  const r = Array.isArray(e);
  if (Gi(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || Gi(e[i]) && !G7(e[i]) ? (t[i] = Array.isArray(e[i]) ? [] : {}, Jg(e[i], t[i])) : On(e[i]) || (t[i] = !0);
  return t;
}
function K7(e, t, r) {
  const i = Array.isArray(e);
  if (Gi(e) || i)
    for (const n in e)
      Array.isArray(e[n]) || Gi(e[n]) && !G7(e[n]) ? bi(t) || Zg(r[n]) ? r[n] = Array.isArray(e[n]) ? Jg(e[n], []) : { ...Jg(e[n]) } : K7(e[n], On(t) ? {} : t[n], r[n]) : r[n] = !Gu(e[n], t[n]);
  return r;
}
var Nf = (e, t) => K7(e, t, Jg(t)), Y7 = (e, { valueAsNumber: t, valueAsDate: r, setValueAs: i }) => bi(e) ? e : t ? e === "" ? NaN : e && +e : r && Ko(e) ? new Date(e) : i ? i(e) : e;
function _b(e) {
  const t = e.ref;
  if (!(e.refs ? e.refs.every((r) => r.disabled) : t.disabled))
    return qD(t) ? t.files : QD(t) ? V7(e.refs).value : W7(t) ? [...t.selectedOptions].map(({ value: r }) => r) : J1(t) ? U7(e.refs).value : Y7(bi(t.value) ? e.ref.value : t.value, e);
}
var rne = (e, t, r, i) => {
  const n = {};
  for (const a of e) {
    const o = st(t, a);
    o && ei(n, a, o._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: n,
    shouldUseNativeValidation: i
  };
}, N0 = (e) => bi(e) ? e : Xg(e) ? e.source : Gi(e) ? Xg(e.value) ? e.value.source : e.value : e, ine = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function Tx(e, t, r) {
  const i = st(e, r);
  if (i || YD(r))
    return {
      error: i,
      name: r
    };
  const n = r.split(".");
  for (; n.length; ) {
    const a = n.join("."), o = st(t, a), s = st(e, a);
    if (o && !Array.isArray(o) && r !== a)
      return { name: r };
    if (s && s.type)
      return {
        name: a,
        error: s
      };
    n.pop();
  }
  return {
    name: r
  };
}
var nne = (e, t, r, i, n) => n.isOnAll ? !1 : !r && n.isOnTouch ? !(t || e) : (r ? i.isOnBlur : n.isOnBlur) ? !e : (r ? i.isOnChange : n.isOnChange) ? e : !0, ane = (e, t) => !eh(st(e, t)).length && sn(e, t);
const one = {
  mode: vo.onSubmit,
  reValidateMode: vo.onChange,
  shouldFocusError: !0
};
function sne(e = {}, t) {
  let r = {
    ...one,
    ...e
  }, i = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Al(r.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    errors: r.errors || {},
    disabled: r.disabled || !1
  }, n = {}, a = Gi(r.values) || Gi(r.defaultValues) ? ta(r.values || r.defaultValues) || {} : {}, o = r.shouldUnregister ? {} : ta(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, u, d = 0;
  const c = {
    isDirty: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, p = {
    values: kb(),
    array: kb(),
    state: kb()
  }, f = yx(r.mode), g = yx(r.reValidateMode), k = r.criteriaMode === vo.all, y = (ne) => (pe) => {
    clearTimeout(d), d = setTimeout(ne, pe);
  }, _ = async (ne) => {
    if (c.isValid || ne) {
      const pe = r.resolver ? Ma((await U()).errors) : await z(n, !0);
      pe !== i.isValid && p.state.next({
        isValid: pe
      });
    }
  }, A = (ne) => c.isValidating && p.state.next({
    isValidating: ne
  }), T = (ne, pe = [], Fe, Ye, Ue = !0, Re = !0) => {
    if (Ye && Fe) {
      if (s.action = !0, Re && Array.isArray(st(n, ne))) {
        const ot = Fe(st(n, ne), Ye.argA, Ye.argB);
        Ue && ei(n, ne, ot);
      }
      if (Re && Array.isArray(st(i.errors, ne))) {
        const ot = Fe(st(i.errors, ne), Ye.argA, Ye.argB);
        Ue && ei(i.errors, ne, ot), ane(i.errors, ne);
      }
      if (c.touchedFields && Re && Array.isArray(st(i.touchedFields, ne))) {
        const ot = Fe(st(i.touchedFields, ne), Ye.argA, Ye.argB);
        Ue && ei(i.touchedFields, ne, ot);
      }
      c.dirtyFields && (i.dirtyFields = Nf(a, o)), p.state.next({
        name: ne,
        isDirty: J(ne, pe),
        dirtyFields: i.dirtyFields,
        errors: i.errors,
        isValid: i.isValid
      });
    } else
      ei(o, ne, pe);
  }, N = (ne, pe) => {
    ei(i.errors, ne, pe), p.state.next({
      errors: i.errors
    });
  }, P = (ne) => {
    i.errors = ne, p.state.next({
      errors: i.errors,
      isValid: !1
    });
  }, B = (ne, pe, Fe, Ye) => {
    const Ue = st(n, ne);
    if (Ue) {
      const Re = st(o, ne, bi(Fe) ? st(a, ne) : Fe);
      bi(Re) || Ye && Ye.defaultChecked || pe ? ei(o, ne, pe ? Re : _b(Ue._f)) : de(ne, Re), s.mount && _();
    }
  }, M = (ne, pe, Fe, Ye, Ue) => {
    let Re = !1, ot = !1;
    const Ut = {
      name: ne
    }, ge = !!(st(n, ne) && st(n, ne)._f.disabled);
    if (!Fe || Ye) {
      c.isDirty && (ot = i.isDirty, i.isDirty = Ut.isDirty = J(), Re = ot !== Ut.isDirty);
      const Ie = ge || Gu(st(a, ne), pe);
      ot = !!(!ge && st(i.dirtyFields, ne)), Ie || ge ? sn(i.dirtyFields, ne) : ei(i.dirtyFields, ne, !0), Ut.dirtyFields = i.dirtyFields, Re = Re || c.dirtyFields && ot !== !Ie;
    }
    if (Fe) {
      const Ie = st(i.touchedFields, ne);
      Ie || (ei(i.touchedFields, ne, Fe), Ut.touchedFields = i.touchedFields, Re = Re || c.touchedFields && Ie !== Fe);
    }
    return Re && Ue && p.state.next(Ut), Re ? Ut : {};
  }, X = (ne, pe, Fe, Ye) => {
    const Ue = st(i.errors, ne), Re = c.isValid && mo(pe) && i.isValid !== pe;
    if (e.delayError && Fe ? (u = y(() => N(ne, Fe)), u(e.delayError)) : (clearTimeout(d), u = null, Fe ? ei(i.errors, ne, Fe) : sn(i.errors, ne)), (Fe ? !Gu(Ue, Fe) : Ue) || !Ma(Ye) || Re) {
      const ot = {
        ...Ye,
        ...Re && mo(pe) ? { isValid: pe } : {},
        errors: i.errors,
        name: ne
      };
      i = {
        ...i,
        ...ot
      }, p.state.next(ot);
    }
    A(!1);
  }, U = async (ne) => r.resolver(o, r.context, rne(ne || l.mount, n, r.criteriaMode, r.shouldUseNativeValidation)), K = async (ne) => {
    const { errors: pe } = await U(ne);
    if (ne)
      for (const Fe of ne) {
        const Ye = st(pe, Fe);
        Ye ? ei(i.errors, Fe, Ye) : sn(i.errors, Fe);
      }
    else
      i.errors = pe;
    return pe;
  }, z = async (ne, pe, Fe = {
    valid: !0
  }) => {
    for (const Ye in ne) {
      const Ue = ne[Ye];
      if (Ue) {
        const { _f: Re, ...ot } = Ue;
        if (Re) {
          const Ut = l.array.has(Re.name), ge = await Fx(Ue, o, k, r.shouldUseNativeValidation && !pe, Ut);
          if (ge[Re.name] && (Fe.valid = !1, pe))
            break;
          !pe && (st(ge, Re.name) ? Ut ? Zie(i.errors, ge, Re.name) : ei(i.errors, Re.name, ge[Re.name]) : sn(i.errors, Re.name));
        }
        ot && await z(ot, pe, Fe);
      }
    }
    return Fe.valid;
  }, j = () => {
    for (const ne of l.unMount) {
      const pe = st(n, ne);
      pe && (pe._f.refs ? pe._f.refs.every((Fe) => !bb(Fe)) : !bb(pe._f.ref)) && Ze(ne);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, J = (ne, pe) => (ne && pe && ei(o, ne, pe), !Gu(Se(), a)), ie = (ne, pe, Fe) => j7(ne, l, {
    ...s.mount ? o : bi(pe) ? a : Ko(ne) ? { [ne]: pe } : pe
  }, Fe, pe), ue = (ne) => eh(st(s.mount ? o : a, ne, e.shouldUnregister ? st(a, ne, []) : [])), de = (ne, pe, Fe = {}) => {
    const Ye = st(n, ne);
    let Ue = pe;
    if (Ye) {
      const Re = Ye._f;
      Re && (!Re.disabled && ei(o, ne, Y7(pe, Re)), Ue = Qg(Re.ref) && On(pe) ? "" : pe, W7(Re.ref) ? [...Re.ref.options].forEach((ot) => ot.selected = Ue.includes(ot.value)) : Re.refs ? J1(Re.ref) ? Re.refs.length > 1 ? Re.refs.forEach((ot) => (!ot.defaultChecked || !ot.disabled) && (ot.checked = Array.isArray(Ue) ? !!Ue.find((Ut) => Ut === ot.value) : Ue === ot.value)) : Re.refs[0] && (Re.refs[0].checked = !!Ue) : Re.refs.forEach((ot) => ot.checked = ot.value === Ue) : qD(Re.ref) ? Re.ref.value = "" : (Re.ref.value = Ue, Re.ref.type || p.values.next({
        name: ne,
        values: { ...o }
      })));
    }
    (Fe.shouldDirty || Fe.shouldTouch) && M(ne, Ue, Fe.shouldTouch, Fe.shouldDirty, !0), Fe.shouldValidate && me(ne);
  }, he = (ne, pe, Fe) => {
    for (const Ye in pe) {
      const Ue = pe[Ye], Re = `${ne}.${Ye}`, ot = st(n, Re);
      (l.array.has(ne) || !Zg(Ue) || ot && !ot._f) && !Nd(Ue) ? he(Re, Ue, Fe) : de(Re, Ue, Fe);
    }
  }, Ee = (ne, pe, Fe = {}) => {
    const Ye = st(n, ne), Ue = l.array.has(ne), Re = ta(pe);
    ei(o, ne, Re), Ue ? (p.array.next({
      name: ne,
      values: { ...o }
    }), (c.isDirty || c.dirtyFields) && Fe.shouldDirty && p.state.next({
      name: ne,
      dirtyFields: Nf(a, o),
      isDirty: J(ne, Re)
    })) : Ye && !Ye._f && !On(Re) ? he(ne, Re, Fe) : de(ne, Re, Fe), Ex(ne, l) && p.state.next({ ...i }), p.values.next({
      name: ne,
      values: { ...o }
    }), !s.mount && t();
  }, Le = async (ne) => {
    const pe = ne.target;
    let Fe = pe.name, Ye = !0;
    const Ue = st(n, Fe), Re = () => pe.type ? _b(Ue._f) : P7(ne), ot = (Ut) => {
      Ye = Number.isNaN(Ut) || Ut === st(o, Fe, Ut);
    };
    if (Ue) {
      let Ut, ge;
      const Ie = Re(), ut = ne.type === qg.BLUR || ne.type === qg.FOCUS_OUT, xt = !ine(Ue._f) && !r.resolver && !st(i.errors, Fe) && !Ue._f.deps || nne(ut, st(i.touchedFields, Fe), i.isSubmitted, g, f), Bt = Ex(Fe, l, ut);
      ei(o, Fe, Ie), ut ? (Ue._f.onBlur && Ue._f.onBlur(ne), u && u(0)) : Ue._f.onChange && Ue._f.onChange(ne);
      const gr = M(Fe, Ie, ut, !1), Gr = !Ma(gr) || Bt;
      if (!ut && p.values.next({
        name: Fe,
        type: ne.type,
        values: { ...o }
      }), xt)
        return c.isValid && _(), Gr && p.state.next({ name: Fe, ...Bt ? {} : gr });
      if (!ut && Bt && p.state.next({ ...i }), A(!0), r.resolver) {
        const { errors: kr } = await U([Fe]);
        if (ot(Ie), Ye) {
          const Xr = Tx(i.errors, n, Fe), Er = Tx(kr, n, Xr.name || Fe);
          Ut = Er.error, Fe = Er.name, ge = Ma(kr);
        }
      } else
        Ut = (await Fx(Ue, o, k, r.shouldUseNativeValidation))[Fe], ot(Ie), Ye && (Ut ? ge = !1 : c.isValid && (ge = await z(n, !0)));
      Ye && (Ue._f.deps && me(Ue._f.deps), X(Fe, ge, Ut, gr));
    }
  }, L = (ne, pe) => {
    if (st(i.errors, pe) && ne.focus)
      return ne.focus(), 1;
  }, me = async (ne, pe = {}) => {
    let Fe, Ye;
    const Ue = ng(ne);
    if (A(!0), r.resolver) {
      const Re = await K(bi(ne) ? ne : Ue);
      Fe = Ma(Re), Ye = ne ? !Ue.some((ot) => st(Re, ot)) : Fe;
    } else
      ne ? (Ye = (await Promise.all(Ue.map(async (Re) => {
        const ot = st(n, Re);
        return await z(ot && ot._f ? { [Re]: ot } : ot);
      }))).every(Boolean), !(!Ye && !i.isValid) && _()) : Ye = Fe = await z(n);
    return p.state.next({
      ...!Ko(ne) || c.isValid && Fe !== i.isValid ? {} : { name: ne },
      ...r.resolver || !ne ? { isValid: Fe } : {},
      errors: i.errors,
      isValidating: !1
    }), pe.shouldFocus && !Ye && o1(n, L, ne ? Ue : l.mount), Ye;
  }, Se = (ne) => {
    const pe = {
      ...a,
      ...s.mount ? o : {}
    };
    return bi(ne) ? pe : Ko(ne) ? st(pe, ne) : ne.map((Fe) => st(pe, Fe));
  }, G = (ne, pe) => ({
    invalid: !!st((pe || i).errors, ne),
    isDirty: !!st((pe || i).dirtyFields, ne),
    isTouched: !!st((pe || i).touchedFields, ne),
    error: st((pe || i).errors, ne)
  }), He = (ne) => {
    ne && ng(ne).forEach((pe) => sn(i.errors, pe)), p.state.next({
      errors: ne ? i.errors : {}
    });
  }, xe = (ne, pe, Fe) => {
    const Ye = (st(n, ne, { _f: {} })._f || {}).ref;
    ei(i.errors, ne, {
      ...pe,
      ref: Ye
    }), p.state.next({
      name: ne,
      errors: i.errors,
      isValid: !1
    }), Fe && Fe.shouldFocus && Ye && Ye.focus && Ye.focus();
  }, _e = (ne, pe) => Al(ne) ? p.values.subscribe({
    next: (Fe) => ne(ie(void 0, pe), Fe)
  }) : ie(ne, pe, !0), Ze = (ne, pe = {}) => {
    for (const Fe of ne ? ng(ne) : l.mount)
      l.mount.delete(Fe), l.array.delete(Fe), pe.keepValue || (sn(n, Fe), sn(o, Fe)), !pe.keepError && sn(i.errors, Fe), !pe.keepDirty && sn(i.dirtyFields, Fe), !pe.keepTouched && sn(i.touchedFields, Fe), !r.shouldUnregister && !pe.keepDefaultValue && sn(a, Fe);
    p.values.next({
      values: { ...o }
    }), p.state.next({
      ...i,
      ...pe.keepDirty ? { isDirty: J() } : {}
    }), !pe.keepIsValid && _();
  }, qe = ({ disabled: ne, name: pe, field: Fe, fields: Ye, value: Ue }) => {
    if (mo(ne)) {
      const Re = ne ? void 0 : bi(Ue) ? _b(Fe ? Fe._f : st(Ye, pe)._f) : Ue;
      ei(o, pe, Re), M(pe, Re, !1, !1, !0);
    }
  }, nt = (ne, pe = {}) => {
    let Fe = st(n, ne);
    const Ye = mo(pe.disabled);
    return ei(n, ne, {
      ...Fe || {},
      _f: {
        ...Fe && Fe._f ? Fe._f : { ref: { name: ne } },
        name: ne,
        mount: !0,
        ...pe
      }
    }), l.mount.add(ne), Fe ? qe({
      field: Fe,
      disabled: pe.disabled,
      name: ne,
      value: pe.value
    }) : B(ne, !0, pe.value), {
      ...Ye ? { disabled: pe.disabled } : {},
      ...r.progressive ? {
        required: !!pe.required,
        min: N0(pe.min),
        max: N0(pe.max),
        minLength: N0(pe.minLength),
        maxLength: N0(pe.maxLength),
        pattern: N0(pe.pattern)
      } : {},
      name: ne,
      onChange: Le,
      onBlur: Le,
      ref: (Ue) => {
        if (Ue) {
          nt(ne, pe), Fe = st(n, ne);
          const Re = bi(Ue.value) && Ue.querySelectorAll && Ue.querySelectorAll("input,select,textarea")[0] || Ue, ot = tne(Re), Ut = Fe._f.refs || [];
          if (ot ? Ut.find((ge) => ge === Re) : Re === Fe._f.ref)
            return;
          ei(n, ne, {
            _f: {
              ...Fe._f,
              ...ot ? {
                refs: [
                  ...Ut.filter(bb),
                  Re,
                  ...Array.isArray(st(a, ne)) ? [{}] : []
                ],
                ref: { type: Re.type, name: ne }
              } : { ref: Re }
            }
          }), B(ne, !1, void 0, Re);
        } else
          Fe = st(n, ne, {}), Fe._f && (Fe._f.mount = !1), (r.shouldUnregister || pe.shouldUnregister) && !(N7(l.array, ne) && s.action) && l.unMount.add(ne);
      }
    };
  }, at = () => r.shouldFocusError && o1(n, L, l.mount), At = (ne) => {
    mo(ne) && (p.state.next({ disabled: ne }), o1(n, (pe, Fe) => {
      let Ye = ne;
      const Ue = st(n, Fe);
      Ue && mo(Ue._f.disabled) && (Ye || (Ye = Ue._f.disabled)), pe.disabled = Ye;
    }, 0, !1));
  }, Oe = (ne, pe) => async (Fe) => {
    let Ye;
    Fe && (Fe.preventDefault && Fe.preventDefault(), Fe.persist && Fe.persist());
    let Ue = ta(o);
    if (p.state.next({
      isSubmitting: !0
    }), r.resolver) {
      const { errors: Re, values: ot } = await U();
      i.errors = Re, Ue = ot;
    } else
      await z(n);
    if (sn(i.errors, "root"), Ma(i.errors)) {
      p.state.next({
        errors: {}
      });
      try {
        await ne(Ue, Fe);
      } catch (Re) {
        Ye = Re;
      }
    } else
      pe && await pe({ ...i.errors }, Fe), at(), setTimeout(at);
    if (p.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Ma(i.errors) && !Ye,
      submitCount: i.submitCount + 1,
      errors: i.errors
    }), Ye)
      throw Ye;
  }, wt = (ne, pe = {}) => {
    st(n, ne) && (bi(pe.defaultValue) ? Ee(ne, ta(st(a, ne))) : (Ee(ne, pe.defaultValue), ei(a, ne, ta(pe.defaultValue))), pe.keepTouched || sn(i.touchedFields, ne), pe.keepDirty || (sn(i.dirtyFields, ne), i.isDirty = pe.defaultValue ? J(ne, ta(st(a, ne))) : J()), pe.keepError || (sn(i.errors, ne), c.isValid && _()), p.state.next({ ...i }));
  }, Ge = (ne, pe = {}) => {
    const Fe = ne ? ta(ne) : a, Ye = ta(Fe), Ue = ne && !Ma(ne) ? Ye : a;
    if (pe.keepDefaultValues || (a = Fe), !pe.keepValues) {
      if (pe.keepDirtyValues)
        for (const Re of l.mount)
          st(i.dirtyFields, Re) ? ei(Ue, Re, st(o, Re)) : Ee(Re, st(Ue, Re));
      else {
        if (WD && bi(ne))
          for (const Re of l.mount) {
            const ot = st(n, Re);
            if (ot && ot._f) {
              const Ut = Array.isArray(ot._f.refs) ? ot._f.refs[0] : ot._f.ref;
              if (Qg(Ut)) {
                const ge = Ut.closest("form");
                if (ge) {
                  ge.reset();
                  break;
                }
              }
            }
          }
        n = {};
      }
      o = e.shouldUnregister ? pe.keepDefaultValues ? ta(a) : {} : ta(Ue), p.array.next({
        values: { ...Ue }
      }), p.values.next({
        values: { ...Ue }
      });
    }
    l = {
      mount: /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, !s.mount && t(), s.mount = !c.isValid || !!pe.keepIsValid || !!pe.keepDirtyValues, s.watch = !!e.shouldUnregister, p.state.next({
      submitCount: pe.keepSubmitCount ? i.submitCount : 0,
      isDirty: pe.keepDirty ? i.isDirty : !!(pe.keepDefaultValues && !Gu(ne, a)),
      isSubmitted: pe.keepIsSubmitted ? i.isSubmitted : !1,
      dirtyFields: pe.keepDirtyValues ? pe.keepDefaultValues && o ? Nf(a, o) : i.dirtyFields : pe.keepDefaultValues && ne ? Nf(a, ne) : {},
      touchedFields: pe.keepTouched ? i.touchedFields : {},
      errors: pe.keepErrors ? i.errors : {},
      isSubmitSuccessful: pe.keepIsSubmitSuccessful ? i.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, nr = (ne, pe) => Ge(Al(ne) ? ne(o) : ne, pe);
  return {
    control: {
      register: nt,
      unregister: Ze,
      getFieldState: G,
      handleSubmit: Oe,
      setError: xe,
      _executeSchema: U,
      _getWatch: ie,
      _getDirty: J,
      _updateValid: _,
      _removeUnmounted: j,
      _updateFieldArray: T,
      _updateDisabledField: qe,
      _getFieldArray: ue,
      _reset: Ge,
      _resetDefaultValues: () => Al(r.defaultValues) && r.defaultValues().then((ne) => {
        nr(ne, r.resetOptions), p.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (ne) => {
        i = {
          ...i,
          ...ne
        };
      },
      _disableForm: At,
      _subjects: p,
      _proxyFormState: c,
      _setErrors: P,
      get _fields() {
        return n;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(ne) {
        s = ne;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(ne) {
        l = ne;
      },
      get _formState() {
        return i;
      },
      set _formState(ne) {
        i = ne;
      },
      get _options() {
        return r;
      },
      set _options(ne) {
        r = {
          ...r,
          ...ne
        };
      }
    },
    trigger: me,
    register: nt,
    handleSubmit: Oe,
    watch: _e,
    setValue: Ee,
    getValues: Se,
    reset: nr,
    resetField: wt,
    clearErrors: He,
    unregister: Ze,
    setError: xe,
    setFocus: (ne, pe = {}) => {
      const Fe = st(n, ne), Ye = Fe && Fe._f;
      if (Ye) {
        const Ue = Ye.refs ? Ye.refs[0] : Ye.ref;
        Ue.focus && (Ue.focus(), pe.shouldSelect && Ue.select());
      }
    },
    getFieldState: G
  };
}
function lne(e = {}) {
  const t = ht.useRef(), r = ht.useRef(), [i, n] = ht.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Al(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Al(e.defaultValues) ? void 0 : e.defaultValues
  });
  t.current || (t.current = {
    ...sne(e, () => n((o) => ({ ...o }))),
    formState: i
  });
  const a = t.current.control;
  return a._options = e, KD({
    subject: a._subjects.state,
    next: (o) => {
      L7(o, a._proxyFormState, a._updateFormState, !0) && n({ ...a._formState });
    }
  }), ht.useEffect(() => a._disableForm(e.disabled), [a, e.disabled]), ht.useEffect(() => {
    if (a._proxyFormState.isDirty) {
      const o = a._getDirty();
      o !== i.isDirty && a._subjects.state.next({
        isDirty: o
      });
    }
  }, [a, i.isDirty]), ht.useEffect(() => {
    e.values && !Gu(e.values, r.current) ? (a._reset(e.values, a._options.resetOptions), r.current = e.values, n((o) => ({ ...o }))) : a._resetDefaultValues();
  }, [e.values, a]), ht.useEffect(() => {
    e.errors && a._setErrors(e.errors);
  }, [e.errors, a]), ht.useEffect(() => {
    a._state.mount || (a._updateValid(), a._state.mount = !0), a._state.watch && (a._state.watch = !1, a._subjects.state.next({ ...a._formState })), a._removeUnmounted();
  }), ht.useEffect(() => {
    e.shouldUnregister && a._subjects.values.next({
      values: a._getWatch()
    });
  }, [e.shouldUnregister, a]), t.current.formState = z7(i, a), t.current;
}
const une = {
  TEXT: "",
  EMAIL: "",
  CHECKBOX: !1,
  TEXTAREA: "",
  FILE: void 0,
  // file inputs are always uncontrolled since their value can only be set by the user so it's ok to use undefined here
  SELECT: ""
};
var q7 = /* @__PURE__ */ ((e) => (e.IncludeChatSession = "include_chat_session", e))(q7 || {});
const cne = {
  inputType: "CHECKBOX",
  label: "Include chat history",
  name: "include_chat_session"
  /* IncludeChatSession */
}, dne = {
  INCLUDE_CHAT_SESSION: cne
}, pne = (e, t) => {
  var r;
  return !t || !t.chatSessionId && !((r = t == null ? void 0 : t.messages) != null && r.length) ? e.map((i) => i.type === "INCLUDE_CHAT_SESSION" ? { ...i, isHidden: !0, required: !1 } : i) : e;
}, hne = (e) => e.reduce((t, r) => (t[r.name] = r.defaultValue ?? une[r.inputType], t), {}), fne = (e) => e.map((t) => t.type !== "STANDARD_FIELD" ? {
  ...dne[t.type],
  ...t,
  type: "STANDARD_FIELD"
} : t);
function gne(e, t) {
  let r = null;
  if (e[q7.IncludeChatSession]) {
    const { messages: n, chatSessionId: a } = t || {
      messages: [],
      chatSessionId: ""
    };
    r = {
      messages: n,
      chatSessionId: a
    };
  }
  return {
    formDetails: { ...e },
    chatSession: r,
    client: {
      currentUrl: typeof window > "u" ? "" : window.location.href
    }
  };
}
function mne({
  name: e,
  label: t,
  required: r,
  control: i
}) {
  return /* @__PURE__ */ v.jsx(
    $7,
    {
      name: e,
      control: i,
      rules: { required: r },
      render: ({ field: n }) => /* @__PURE__ */ v.jsx(
        El,
        {
          id: e,
          checked: !!n.value,
          ...n,
          onChange: (a) => {
            n.onChange(a.checked);
          },
          variant: "neutral",
          children: ({ isChecked: a, isIndeterminate: o }) => /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
            /* @__PURE__ */ v.jsx(El.Control, { children: /* @__PURE__ */ v.jsx(
              El.Icon,
              {
                isChecked: a,
                isIndeterminate: o
              }
            ) }),
            /* @__PURE__ */ v.jsxs(
              El.Label,
              {
                fontWeight: "medium",
                fontSize: "sm",
                color: "gray.700",
                _dark: { color: "whiteAlpha.700" },
                children: [
                  t,
                  /* @__PURE__ */ v.jsx(Go.RequiredIndicator, {})
                ]
              }
            )
          ] })
        }
      )
    }
  );
}
function vne({
  name: e,
  placeholder: t,
  autoFocus: r,
  register: i,
  required: n
}) {
  return /* @__PURE__ */ v.jsx(
    N1,
    {
      id: e,
      type: "email",
      placeholder: t,
      autoFocus: r,
      ...i(e, { required: n })
    }
  );
}
function kne({
  name: e,
  placeholder: t,
  autoFocus: r,
  register: i,
  required: n
}) {
  return /* @__PURE__ */ v.jsx(
    N1,
    {
      id: e,
      type: "file",
      multiple: !0,
      placeholder: t,
      autoFocus: r,
      ...i(e, { required: n }),
      fontSize: "sm",
      paddingLeft: 2,
      _file: {
        height: "100%",
        cursor: "pointer",
        background: "transparent",
        border: "none",
        fontSize: "sm",
        fontWeight: "medium",
        color: "gray.700",
        _dark: { color: "whiteAlpha.700" }
      }
    }
  );
}
function bne({
  name: e,
  placeholder: t,
  autoFocus: r,
  required: i,
  selectOptions: n = [],
  control: a
}) {
  return /* @__PURE__ */ v.jsx(
    $7,
    {
      name: e,
      control: a,
      rules: { required: i },
      render: ({ field: o }) => /* @__PURE__ */ v.jsxs(
        Po,
        {
          positioning: { sameWidth: !0 },
          variant: "ikpOutline",
          items: n,
          multiple: !1,
          ...o,
          onChange: (s) => {
            const { value: l } = s;
            o.onChange((l == null ? void 0 : l[0]) || "");
          },
          value: [o.value],
          children: [
            /* @__PURE__ */ v.jsx(Po.Control, { children: /* @__PURE__ */ v.jsxs(Po.Trigger, { autoFocus: r, children: [
              /* @__PURE__ */ v.jsx(Po.Value, { placeholder: t }),
              /* @__PURE__ */ v.jsx(AW, {})
            ] }) }),
            /* @__PURE__ */ v.jsx(Po.Positioner, { children: /* @__PURE__ */ v.jsx(Po.Content, { children: /* @__PURE__ */ v.jsx(Po.ItemGroup, { id: "", children: n.map((s) => /* @__PURE__ */ v.jsxs(Po.Item, { item: s, py: "8px", px: "16px", children: [
              /* @__PURE__ */ v.jsx(Po.ItemText, { children: s.label }),
              /* @__PURE__ */ v.jsx(Po.ItemIndicator, { children: /* @__PURE__ */ v.jsx(
                cm,
                {
                  asChild: !0,
                  color: "gray.600",
                  _dark: { color: "whiteAlpha.600" },
                  children: /* @__PURE__ */ v.jsx(xW, {})
                }
              ) })
            ] }, s.value)) }) }) })
          ]
        }
      )
    }
  );
}
function $_() {
  return $_ = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, $_.apply(this, arguments);
}
function _ne(e, t) {
  if (e == null)
    return {};
  var r = {}, i = Object.keys(e), n, a;
  for (a = 0; a < i.length; a++)
    n = i[a], !(t.indexOf(n) >= 0) && (r[n] = e[n]);
  return r;
}
var Dne = Xu, yne = function(t) {
  var r = we.useRef(t);
  return Dne(function() {
    r.current = t;
  }), r;
}, Sx = function(t, r) {
  if (typeof t == "function") {
    t(r);
    return;
  }
  t.current = r;
}, Ene = function(t, r) {
  var i = qt();
  return Nt(function(n) {
    t.current = n, i.current && Sx(i.current, null), i.current = r, r && Sx(r, n);
  }, [r]);
}, Ix = {
  "min-height": "0",
  "max-height": "none",
  height: "0",
  visibility: "hidden",
  overflow: "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0"
}, Cne = function(t) {
  Object.keys(Ix).forEach(function(r) {
    t.style.setProperty(r, Ix[r], "important");
  });
}, Bx = Cne, Rn = null, Rx = function(t, r) {
  var i = t.scrollHeight;
  return r.sizingStyle.boxSizing === "border-box" ? i + r.borderSize : i - r.paddingSize;
};
function xne(e, t, r, i) {
  r === void 0 && (r = 1), i === void 0 && (i = 1 / 0), Rn || (Rn = document.createElement("textarea"), Rn.setAttribute("tabindex", "-1"), Rn.setAttribute("aria-hidden", "true"), Bx(Rn)), Rn.parentNode === null && document.body.appendChild(Rn);
  var n = e.paddingSize, a = e.borderSize, o = e.sizingStyle, s = o.boxSizing;
  Object.keys(o).forEach(function(p) {
    var f = p;
    Rn.style[f] = o[f];
  }), Bx(Rn), Rn.value = t;
  var l = Rx(Rn, e);
  Rn.value = t, l = Rx(Rn, e), Rn.value = "x";
  var u = Rn.scrollHeight - n, d = u * r;
  s === "border-box" && (d = d + n + a), l = Math.max(d, l);
  var c = u * i;
  return s === "border-box" && (c = c + n + a), l = Math.min(c, l), [l, u];
}
var Ox = function() {
}, Ane = function(t, r) {
  return t.reduce(function(i, n) {
    return i[n] = r[n], i;
  }, {});
}, wne = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak"
], Fne = !!document.documentElement.currentStyle, Tne = function(t) {
  var r = window.getComputedStyle(t);
  if (r === null)
    return null;
  var i = Ane(wne, r), n = i.boxSizing;
  if (n === "")
    return null;
  Fne && n === "border-box" && (i.width = parseFloat(i.width) + parseFloat(i.borderRightWidth) + parseFloat(i.borderLeftWidth) + parseFloat(i.paddingRight) + parseFloat(i.paddingLeft) + "px");
  var a = parseFloat(i.paddingBottom) + parseFloat(i.paddingTop), o = parseFloat(i.borderBottomWidth) + parseFloat(i.borderTopWidth);
  return {
    sizingStyle: i,
    paddingSize: a,
    borderSize: o
  };
}, Sne = Tne;
function Q7(e, t, r) {
  var i = yne(r);
  we.useLayoutEffect(function() {
    var n = function(o) {
      return i.current(o);
    };
    if (e)
      return e.addEventListener(t, n), function() {
        return e.removeEventListener(t, n);
      };
  }, []);
}
var Ine = function(t) {
  Q7(window, "resize", t);
}, Bne = function(t) {
  Q7(document.fonts, "loadingdone", t);
}, Rne = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"], One = function(t, r) {
  var i = t.cacheMeasurements, n = t.maxRows, a = t.minRows, o = t.onChange, s = o === void 0 ? Ox : o, l = t.onHeightChange, u = l === void 0 ? Ox : l, d = _ne(t, Rne), c = d.value !== void 0, p = we.useRef(null), f = Ene(p, r), g = we.useRef(0), k = we.useRef(), y = function() {
    var T = p.current, N = i && k.current ? k.current : Sne(T);
    if (N) {
      k.current = N;
      var P = xne(N, T.value || T.placeholder || "x", a, n), B = P[0], M = P[1];
      g.current !== B && (g.current = B, T.style.setProperty("height", B + "px", "important"), u(B, {
        rowHeight: M
      }));
    }
  }, _ = function(T) {
    c || y(), s(T);
  };
  return we.useLayoutEffect(y), Ine(y), Bne(y), /* @__PURE__ */ we.createElement("textarea", $_({}, d, {
    onChange: _,
    ref: f
  }));
}, XD = /* @__PURE__ */ we.forwardRef(One);
function Pne({
  name: e,
  placeholder: t,
  autoFocus: r,
  register: i,
  required: n
}) {
  return /* @__PURE__ */ v.jsx(
    zs,
    {
      as: XD,
      maxRows: 8,
      id: e,
      placeholder: t,
      autoFocus: r,
      ...i(e, { required: n })
    }
  );
}
function Db({
  name: e,
  placeholder: t,
  autoFocus: r,
  register: i,
  required: n
}) {
  return /* @__PURE__ */ v.jsx(
    N1,
    {
      id: e,
      type: "text",
      placeholder: t,
      autoFocus: r,
      ...i(e, { required: n })
    }
  );
}
function Nne({
  name: e,
  label: t,
  inputType: r,
  placeholder: i,
  required: n,
  errors: a,
  register: o,
  control: s,
  autoFocus: l,
  isHidden: u,
  selectOptions: d
}) {
  var f, g, k;
  let c = Db, p = !0;
  switch (r) {
    case "TEXT":
      c = Db;
      break;
    case "EMAIL":
      c = vne;
      break;
    case "CHECKBOX":
      c = mne, p = !1;
      break;
    case "TEXTAREA":
      c = Pne;
      break;
    case "FILE":
      c = kne;
      break;
    case "SELECT":
      c = bne;
      break;
    default:
      c = Db;
      break;
  }
  return /* @__PURE__ */ v.jsxs(
    Go,
    {
      isInvalid: !!a[e],
      mb: 8,
      isRequired: n,
      display: u ? "none" : "block",
      children: [
        p && /* @__PURE__ */ v.jsxs(
          Go.Label,
          {
            fontWeight: "medium",
            fontSize: "sm",
            htmlFor: e,
            color: "gray.700",
            _dark: { color: "whiteAlpha.700" },
            className: `${ye}-form__field-label`,
            children: [
              t,
              /* @__PURE__ */ v.jsx(Go.RequiredIndicator, {})
            ]
          }
        ),
        /* @__PURE__ */ v.jsx(
          c,
          {
            name: e,
            errors: a,
            autoFocus: l,
            placeholder: i,
            register: o,
            control: s,
            required: n ? `${t} is required.` : !1,
            label: t,
            selectOptions: d
          }
        ),
        ((f = a[e]) == null ? void 0 : f.message) && /* @__PURE__ */ v.jsx(Go.Error, { className: `${ye}-form__field-error`, children: (k = (g = a[e]) == null ? void 0 : g.message) == null ? void 0 : k.toString() })
      ]
    }
  );
}
function zne({
  fields: e,
  submitButtonLabel: t,
  submitCallback: r,
  onClose: i,
  successCallback: n,
  chatSession: a
}) {
  var _;
  const o = pne(e, a), s = fne(o), l = hne(s), {
    register: u,
    control: d,
    handleSubmit: c,
    formState: { errors: p, isSubmitting: f },
    setError: g
  } = lne({ defaultValues: l }), { log: k } = dn(), y = async (A) => {
    const T = gne(A, a);
    await r(T).then((N) => {
      N != null && N.success ? n() : (k(
        `Submit callback did not return success. Response was: ${JSON.stringify(
          N
        )}`
      ), g("root.serverError", {
        message: "Something went wrong."
      }));
    }).catch((N) => {
      k(`Form submission error: ${N}`), g("root.serverError", {
        message: "Something went wrong."
      });
    });
  };
  return /* @__PURE__ */ v.jsxs(
    Ct,
    {
      width: "100%",
      as: "form",
      onSubmit: c(y),
      className: `${ye}-form__body`,
      children: [
        s.map((A, T) => /* @__PURE__ */ v.jsx(
          Nne,
          {
            errors: p,
            autoFocus: T === 0,
            register: u,
            control: d,
            ...A
          },
          A.name
        )),
        ((_ = p == null ? void 0 : p.root) == null ? void 0 : _.serverError) && /* @__PURE__ */ v.jsx(
          cn,
          {
            color: "red.500",
            _dark: { color: "red.300" },
            className: `${ye}-form__error`,
            children: p.root.serverError.message
          }
        ),
        /* @__PURE__ */ v.jsxs(mt, { alignItems: "center", justifyContent: "flex-end", gap: 6, children: [
          /* @__PURE__ */ v.jsx(
            di,
            {
              type: "button",
              variant: "outline",
              onClick: i,
              className: `${ye}-form__cancel-button`,
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ v.jsx(
            di,
            {
              type: "submit",
              variant: "neutralFilled",
              disabled: f,
              className: `${ye}-form__submit-button`,
              children: t || "Submit"
            }
          )
        ] })
      ]
    }
  );
}
function Lne({ children: e }) {
  return /* @__PURE__ */ v.jsx(
    cn,
    {
      color: "gray.700",
      _dark: { color: "whiteAlpha.700" },
      fontSize: "sm",
      width: "100%",
      className: `${ye}-form__description`,
      children: e
    }
  );
}
function ZD({ heading: e, description: t }) {
  return !e && !t ? null : /* @__PURE__ */ v.jsxs(mt, { direction: "column", gap: 6, className: `${ye}-form__header`, children: [
    e && /* @__PURE__ */ v.jsx(
      Eg,
      {
        size: "md",
        fontWeight: "semibold",
        width: "100%",
        className: `${ye}-form__heading`,
        children: e
      }
    ),
    t && /* @__PURE__ */ v.jsx(Lne, { children: t })
  ] });
}
function Mne({
  formConfig: e,
  onClose: t,
  successCallback: r,
  chatSession: i
}) {
  const { heading: n, description: a, fields: o, submitButtonLabel: s, submitCallback: l } = e;
  return /* @__PURE__ */ v.jsxs(
    mt,
    {
      direction: "column",
      alignItems: "start",
      justifyContent: "center",
      width: "100%",
      gap: 8,
      children: [
        /* @__PURE__ */ v.jsx(ZD, { heading: n, description: a }),
        /* @__PURE__ */ v.jsx(
          zne,
          {
            fields: o,
            submitButtonLabel: s,
            submitCallback: l,
            onClose: t,
            successCallback: r,
            chatSession: i
          }
        )
      ]
    }
  );
}
function jne({
  formConfig: e,
  onClose: t,
  onModalClose: r,
  isMdContainer: i = !0,
  chatSession: n
}) {
  const [a, o] = rt(!1), { successConfirmationPage: s, closeFormAction: l } = e || {}, u = (d) => {
    t(), (d == null ? void 0 : d.type) === "CLOSE_MODAL" && r && r();
  };
  return /* @__PURE__ */ v.jsxs($g, { maxHeight: "100%", display: "flex", children: [
    /* @__PURE__ */ v.jsx(CD, { children: /* @__PURE__ */ v.jsx(mt, { justifyContent: "flex-end", px: 2, py: 1, children: /* @__PURE__ */ v.jsx(Yq, { onClick: () => void u(l) }) }) }),
    /* @__PURE__ */ v.jsx(xD, { children: /* @__PURE__ */ v.jsx(Ct, { w: "100%", h: "100%", overflow: "hidden", children: /* @__PURE__ */ v.jsx(
      mt,
      {
        direction: "column",
        alignItems: "center",
        overflowY: "auto",
        minHeight: "0px",
        height: "100%",
        px: i ? 14 : 6,
        pb: i ? 14 : 8,
        pt: 4,
        children: a ? /* @__PURE__ */ v.jsx(
          Vie,
          {
            ...s,
            onClose: () => {
              var d;
              return void u(
                (d = s == null ? void 0 : s.successConfirmationButton) == null ? void 0 : d.closeFormAction
              );
            }
          }
        ) : /* @__PURE__ */ v.jsx(
          Mne,
          {
            formConfig: e,
            onClose: () => void u(l),
            successCallback: () => void o(!0),
            chatSession: n
          }
        )
      }
    ) }) })
  ] });
}
const Hne = ts(
  /* GraphQL */
  `
  query GetChatSession($id: ID!) {
    getChatSession(id: $id) {
      id
      organizationId
      chatMode
      workflowId
      messages {
        id
        content
        ... on UserMessage {
          context
          attributes
        }
        ... on BotMessage {
          citations {
            citationNumber
            title
            url
            rootRecordId
            rootRecordType
          }
        }
      }
      filters {
        product
        productVersion
        attributes
      }
    }
  }
`
);
function $ne({
  messages: e,
  inputMessage: t,
  setMessages: r,
  responseError: i,
  setResponseError: n,
  setIsLoadedFromSavedChat: a,
  setIsLoadingExistingChat: o,
  isListeningForResponse: s
}) {
  const { chatId: l } = Qr(), u = ED(), d = l || u, c = la(), { log: p } = dn(), [f, g] = rt(!1);
  gt(() => {
    p("resolvedChatId has new value"), p(d), d ? (p("setting query session id to the id from props or from url"), N(d), o(!0), a(!0), c.capture({
      eventName: "chat_shared_session_loaded",
      properties: {
        sharedChatSessionId: d
      }
    })) : N("");
  }, [d]);
  const [k, y] = Ql(), [_, A] = rt(
    d || ""
    // || tabChatSessionId
  ), [T, N] = rt(
    d || ""
    // || tabChatSessionId
  ), { loading: P, error: B, data: M } = aF(Hne, {
    variables: {
      id: T || "00000000-0000-0000-0000-000000000000"
    },
    skip: !T
  });
  gt(() => {
    p("querySessionId changed"), p(T), g(!1);
  }, [T]);
  const { setChatMode: X } = Qr();
  return gt(() => {
    if (P && (p("Loading existing chat from the below session id"), p(T)), !P && !B && (M != null && M.getChatSession) && !f) {
      p(
        "Set current messages, chat mode, and session id from a chat loaded from the backend"
      ), p(M.getChatSession), g(!0);
      const U = M.getChatSession.chatMode;
      A(M.getChatSession.id), r(M.getChatSession.messages), o(!1), X(U), y("chatMode", U);
    }
    B && (n(B), o(!1));
  }, [P, B, M, f]), { chatSessionId: _, setChatSessionId: A, loading: P };
}
const Une = ts`
  mutation CopyChatSession($sessionId: ID!, $isSharedSession: Boolean!) {
    copyChatSession(sessionId: $sessionId, isSharedSession: $isSharedSession)
  }
`;
function Vne() {
  const { log: e } = dn(), [t] = sF(Une);
  return { handleCopyChatSession: async (i, n) => {
    e("handling copy chat session");
    try {
      if (i) {
        const { data: a } = await t({
          variables: { sessionId: i, isSharedSession: n }
        });
        return e("copied chat session data"), e(a), a.copyChatSession;
      }
    } catch (a) {
      throw console.error("Error copying chat session:", a), a;
    }
  } };
}
const Wne = () => {
  const [e, t] = rt({}), r = Nt(
    (n) => e[n] ?? 0,
    [e]
  ), i = Nt(
    (n, a) => {
      t((o) => ({ ...o, [n]: a }));
    },
    [t]
  );
  return { getFeedback: r, setMessageFeedback: i };
}, Px = () => {
  const e = typeof window > "u" ? new URL("") : new URL(window.location.href), t = new URLSearchParams(e.search);
  if (t.has("chatId")) {
    t.delete("chatId");
    const r = t.toString(), i = r ? `${e.origin}${e.pathname}?${r}` : `${e.origin}${e.pathname}`;
    typeof window < "u" && window.history.pushState({}, "", i);
  }
};
function qm(e) {
  return e.map((t) => t.__typename === "UserMessage" ? {
    role: "user",
    content: t.content
  } : {
    role: "assistant",
    content: t.content
  });
}
const Gne = "0.0.1";
function kp(e) {
  return Array.isArray(e) && e.length > 0;
}
function Kne(e) {
  if (!e.supportedInputs)
    return e;
  const t = { ...e };
  return t.supportedInputs = e.supportedInputs.map((r) => {
    const i = { ...r };
    return i.type === "MODAL" && delete i.workflowModalProps, i;
  }), t;
}
function Nx(e) {
  if (kp(e))
    return e.filter((t) => t != null).map((t, r) => `${r + 1}. ${t}`).join(`
`);
}
function yb(e) {
  if (kp(e))
    return e.filter((t) => t != null).map((t) => `- ${t}`).join(`
`);
}
function ep(e) {
  if (kp(e))
    return e.filter((t) => t != null).join(`
`);
}
function Rs({
  title: e,
  content: t,
  note: r,
  depth: i = 2
}) {
  const n = ep(t);
  if (!n && !r)
    return;
  const o = `${"#".repeat(i)} ${e}
`, s = ep([r, n]);
  return s ? `${o}${s}
` : void 0;
}
function Yne(e) {
  if ((e == null ? void 0 : e.type) === "CODE")
    return e.language || "";
}
function qne(e) {
  const {
    displayName: t,
    goals: r,
    informationToCollect: i,
    guidance: n,
    botPersona: a,
    context: o
  } = e, s = Rs({
    title: "Guidance",
    content: [Nx(n)],
    note: a,
    depth: 2
  }), l = yb(
    i == null ? void 0 : i.filter((A) => A.required).map((A) => A.description)
  ), u = yb(
    i == null ? void 0 : i.filter((A) => !A.required).map((A) => A.description)
  ), d = Rs({
    title: "Required",
    content: [l],
    note: "IMPORTANT: This information is REQUIRED for this workflow. If not provided in the conversation, prompt the user to provide it and don't otherwise answer their question.",
    depth: 3
  }), c = Rs({
    title: "Optional",
    content: [u],
    depth: 3
  }), p = Rs({
    title: "Information to collect",
    content: [d, c],
    note: "This is information that should be collected from the user.",
    depth: 2
  }), f = yb(o), g = Rs({
    title: "Context",
    content: [f],
    depth: 2
  }), k = Rs({
    title: "Workflow Name",
    content: [t],
    depth: 2
  }), y = Rs({
    title: "Goals",
    content: [Nx(r)],
    depth: 2
  });
  return Rs({
    title: "Workflow",
    content: [
      "I am a user being guided through a “workflow” defined by the organization that provides this chat experience.",
      "**IMPORTANT: Follow the instructions outlined in this workflow. Follow the instructions in the workflow configuration below. Do not answer questions unrelated to the workflow.**",
      k,
      y,
      g,
      p,
      s
    ],
    depth: 1
  });
}
function Qne(e, t) {
  return t ? `\`\`\`${t}
${e}
\`\`\`` : e;
}
function X7({
  attachment: e,
  index: t
}) {
  const { title: r, content: i, contentType: n, context: a } = e, { contentInputLabel: o, type: s } = n, l = Yne(n), u = Qne(i, l), d = kp(a) ? [`
Additional Context:`, ep(a)] : [];
  return [
    `#### ATTACHMENT #${t + 1}`,
    `Title: ${r}`,
    `Label: ${o}`,
    `Type: ${s}`,
    "Content:",
    u,
    ...d
  ].join(`
`);
}
function Xne(e) {
  if (!kp(e))
    return;
  const t = e.map(
    (i, n) => X7({ attachment: i, index: n })
  );
  return `**Attachments** 

 ${ep(t)}`;
}
function Zne(e) {
  if (!kp(e))
    return;
  const t = e.map(
    (i, n) => X7({ attachment: i, index: n })
  ), r = ep(t);
  return Rs({
    title: "User-provided Attachments",
    content: [
      "The user has provided the following attachments to their message:",
      r
    ],
    depth: 1
  });
}
function Jne(e, t, r) {
  const i = r ? qne(e) : "", n = Zne(t), a = {
    workflow: Kne(e),
    workflowSchemaVersion: Gne,
    attachments: t
  };
  return {
    context: ep([i, n]),
    attributes: a
  };
}
function eae() {
  const e = ia(
    Nr.var("colors.gray.500"),
    Nr.var("colors.whiteAlpha.500")
  ), t = kl("gradient_");
  return /* @__PURE__ */ v.jsxs(
    Te.svg,
    {
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ v.jsx(
          "path",
          {
            d: "M32 4.01845V25.1411C32 26.3154 30.9971 27.2462 29.8223 27.1531L16.9277 26.1507C15.409 26.0361 13.8903 26.3727 12.565 27.1173L8.11641 29.6234C7.72241 29.8454 7.29259 29.3943 7.54332 29.0148L9.77121 25.5922L11.8415 22.4131C12.0636 22.0694 12.4934 21.9119 12.8874 22.0336C16.1397 23.079 19.8075 21.8761 21.7631 18.8831C24.0913 15.2886 23.0741 10.4913 19.4851 8.15706C15.8961 5.82282 11.0965 6.83958 8.76114 10.4269C6.81263 13.427 7.19946 17.272 9.4775 19.8139C9.74972 20.1218 9.77837 20.5729 9.5563 20.9237L6.92724 24.9621C6.76964 25.1984 6.49743 25.3344 6.21804 25.313L1.4184 24.9406C0.616073 24.8834 0 24.2175 0 23.4155V5.7369C0 4.93496 0.616073 4.26905 1.4184 4.21177L29.8294 2.00642C31.0043 1.91334 32 2.84417 32 4.01845ZM15.2586 9.35282C12.3286 9.35282 9.95747 11.7229 9.95747 14.6514C9.95747 16.0763 10.5234 17.3723 11.4403 18.3246C11.9991 18.9046 12.6868 19.3557 13.4605 19.6349C14.0264 19.8354 14.6282 19.95 15.2657 19.95C18.1957 19.95 20.5668 17.5799 20.5668 14.6514C20.5597 11.73 18.1885 9.35282 15.2586 9.35282Z",
            fill: `url(#${t})`
          }
        ),
        /* @__PURE__ */ v.jsx("defs", { children: /* @__PURE__ */ v.jsxs(
          "linearGradient",
          {
            id: `${t}`,
            x1: "1.5893",
            y1: "25.285",
            x2: "24.0784",
            y2: "10.1057",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ v.jsx("stop", { stopColor: e }),
              /* @__PURE__ */ v.jsx("stop", { offset: "1", stopColor: e })
            ]
          }
        ) })
      ]
    }
  );
}
const tae = "https://www.inkeep.com/", rae = () => /* @__PURE__ */ v.jsxs(mt, { className: `${ye}-tagline`, whiteSpace: "nowrap", children: [
  /* @__PURE__ */ v.jsx(
    Ct,
    {
      _dark: { color: "whiteAlpha.600" },
      _light: { color: "gray.600" },
      fontSize: { base: "xs", md: "sm" },
      children: "Powered by"
    }
  ),
  /* @__PURE__ */ v.jsx(
    dm,
    {
      isExternal: !0,
      _dark: { color: "whiteAlpha.600" },
      _light: { color: "gray.600" },
      fontSize: { base: "xs", md: "sm" },
      fontWeight: "bold",
      href: tae,
      children: /* @__PURE__ */ v.jsxs(mt, { alignItems: "center", children: [
        /* @__PURE__ */ v.jsx(Ct, { ml: 2, mr: 1, w: "18px", children: /* @__PURE__ */ v.jsx(eae, {}) }),
        /* @__PURE__ */ v.jsx(cn, { display: "inline-flex", children: "inkeep" })
      ] })
    }
  )
] }), Z7 = rae, iae = ({
  isDisabled: e = !1,
  tooltipPosition: t = "top"
}) => {
  const {
    chatMode: r,
    setChatMode: i,
    toggleButtonSettings: n,
    defaultChatMode: a = "AUTO"
  } = Qr(), {
    isChatModeToggleEnabled: o,
    chatModeToggleValue: s,
    chatModeToggleLabel: l,
    chatModeToggleTooltip: u
  } = n ?? {}, [d, c] = Ql();
  if (!o || s === a || !s)
    return null;
  const p = () => {
    const k = r === s ? a : s;
    i(k), c("chatMode", k);
  };
  let f, g;
  switch (s) {
    case "AUTO":
      f = l || "Expert mode", g = u || "Expert mode is great for more complex questions, but can be slower.";
      break;
    case "TURBO":
      f = l || "Turbo mode", g = u || "Turbo mode is fast and effective for less complex questions, but can be less accurate.";
      break;
  }
  return g += e ? r === "TURBO" ? " Start a new chat to turn it off." : " Start a new chat to try it." : "", /* @__PURE__ */ v.jsx(
    Tl,
    {
      alignItems: "center",
      gap: 1,
      height: "24px",
      ml: 0,
      whiteSpace: "nowrap",
      className: `${ye}-chat-mode-toggle`,
      children: /* @__PURE__ */ v.jsx(Ct, { position: "relative", display: "inline-flex", children: /* @__PURE__ */ v.jsx(
        rf,
        {
          size: "sm",
          disabled: e,
          checked: r === s,
          onChange: p,
          colorPalette: "inkeepExpandedPrimary",
          className: `${ye}-chat-mode-toggle__switch`,
          children: /* @__PURE__ */ v.jsxs(Tl, { alignItems: "center", gap: 1, height: "24px", ml: 0, children: [
            /* @__PURE__ */ v.jsx(
              rf.Label,
              {
                ml: "0",
                lineHeight: { base: "normal", md: "24px" },
                fontWeight: "medium",
                className: `${ye}-chat-mode-toggle__label`,
                fontSize: { base: "xs", md: "sm" },
                children: f
              }
            ),
            /* @__PURE__ */ v.jsxs(
              Ir,
              {
                positioning: {
                  placement: t,
                  offset: { crossAxis: 10, mainAxis: 10 }
                },
                openDelay: 0,
                closeDelay: 0,
                children: [
                  /* @__PURE__ */ v.jsx(Ir.Trigger, { children: /* @__PURE__ */ v.jsx(mt, { alignItems: "center", children: /* @__PURE__ */ v.jsx(
                    zn,
                    {
                      iconKey: "info",
                      fontSize: "sm",
                      _light: { color: "gray.600" },
                      _dark: { color: "whiteAlpha.800" },
                      cursor: "pointer",
                      transform: "translateY(1px)",
                      className: `${ye}-chat-mode-toggle__tooltip-icon`
                    }
                  ) }) }),
                  /* @__PURE__ */ v.jsx(Gs, { children: /* @__PURE__ */ v.jsx(Ir.Positioner, { zIndex: "tooltip", children: /* @__PURE__ */ v.jsxs(Ir.Content, { fontSize: "sm", maxW: "200px", children: [
                    /* @__PURE__ */ v.jsx(Ir.Arrow, { children: /* @__PURE__ */ v.jsx(Ir.ArrowTip, {}) }),
                    g
                  ] }) }) })
                ]
              }
            ),
            /* @__PURE__ */ v.jsx(rf.Control, { ml: 1, children: /* @__PURE__ */ v.jsx(rf.Thumb, {}) })
          ] })
        }
      ) })
    }
  );
}, nae = iae, aae = {
  is: "closed",
  text: "Copy"
}, oae = (e, t) => {
  switch (t.type) {
    case "click":
      return { is: "clicked", text: t.text ?? "Copied!" };
    case "hide":
      return { is: "hiding", text: t.text ?? e.text };
    case "reset":
      return { is: "closed", text: t.text ?? "Copy" };
    default:
      throw new Error(`Unhandled action type: ${t.type}`);
  }
}, sae = ({
  textToCopy: e,
  isTooltipEnabled: t = !0,
  showTooltipOnHover: r = !1,
  unclickedText: i = "Copy",
  clickedText: n = "Copied!",
  buttonProps: a,
  children: o,
  onCopy: s
}) => {
  const { log: l } = dn(), [u, d] = Jx(oae, aae), c = () => {
    navigator.clipboard.writeText(e).then(
      () => {
        l("Text copied to clipboard"), d({ type: "click", text: n }), setTimeout(() => {
          d({ type: "hide" }), setTimeout(() => {
            d({ type: "reset", text: i });
          }, 250);
        }, 750), s && s();
      },
      (g) => {
        console.error("Could not copy text:", g);
      }
    );
  }, p = u.text, f = /* @__PURE__ */ v.jsx(
    di,
    {
      onClick: c,
      variant: "iconButton",
      className: `${ye}-copy-button`,
      ...a,
      children: o || /* @__PURE__ */ v.jsx(
        zn,
        {
          iconKey: "messageCopy",
          className: `${ye}-copy-button__icon`
        }
      )
    }
  );
  return t ? /* @__PURE__ */ v.jsxs(
    Ir,
    {
      positioning: { placement: "top-end" },
      open: r ? void 0 : u.is !== "closed",
      closeOnPointerDown: !1,
      children: [
        /* @__PURE__ */ v.jsx(Ir.Trigger, { asChild: !0, children: f }),
        /* @__PURE__ */ v.jsx(Gs, { children: /* @__PURE__ */ v.jsx(Ir.Positioner, { zIndex: "tooltip", children: /* @__PURE__ */ v.jsxs(
          Ir.Content,
          {
            fontSize: "sm",
            present: r ? !0 : u.is === "clicked",
            children: [
              /* @__PURE__ */ v.jsx(Ir.Arrow, { children: /* @__PURE__ */ v.jsx(Ir.ArrowTip, {}) }),
              p
            ]
          }
        ) }) })
      ]
    }
  ) : f;
}, JD = sae;
function lae(e) {
  const t = /\[\^\d+](,\s)?/g;
  return e.replace(t, (i, n) => n && /\[\^\d+]|\.$/.test(e.slice(e.indexOf(i) + i.length)) ? "" : n ? ", " : "").replace(/\s+([!,.;?])/g, "$1");
}
function uae(e) {
  return e.map((r) => {
    const i = r.__typename === "UserMessage", { content: n } = r, a = i ? "**User**" : "**AI Assistant**", o = i ? n : lae(n), s = i ? r.attributes : null, l = (s == null ? void 0 : s.attachments) || null, u = l ? `

${Xne(l)}` : "";
    return `${a}

${o}${u}`;
  }).join(`

---

`);
}
const cae = ({
  buttonProps: e,
  children: t,
  messages: r
}) => {
  const i = uae(r);
  return /* @__PURE__ */ v.jsx(
    JD,
    {
      textToCopy: i,
      isTooltipEnabled: !0,
      showTooltipOnHover: !1,
      unclickedText: "Copy conversation",
      clickedText: "Copied!",
      buttonProps: { ...e, className: `${ye}-copy-chat-button` },
      children: t
    }
  );
}, dae = cae, pae = (e) => `${Qr().shareChatUrlBasePath}?chatId=${e}`, hae = ({
  chatSessionId: e,
  buttonProps: t,
  children: r
}) => {
  const i = la(), n = Qr().isChatSharingEnabled && e, a = pae(e), o = () => {
    i.capture({
      eventName: "chat_share_button_clicked",
      properties: {
        sharedChatUrl: a,
        chatSessionId: e
      }
    });
  };
  return n ? /* @__PURE__ */ v.jsx(
    JD,
    {
      textToCopy: a,
      isTooltipEnabled: !0,
      showTooltipOnHover: !1,
      unclickedText: "Copy Chat URL",
      clickedText: "Link copied!",
      buttonProps: t,
      onCopy: o,
      children: r
    }
  ) : null;
}, fae = hae, og = (e, t, r) => {
  const i = r.at(-2), n = r.at(-1);
  return {
    eventName: "get_help_option_clicked",
    properties: {
      chatSessionId: e,
      actionType: t.type || "OPEN_LINK",
      url: t.url,
      question: i == null ? void 0 : i.content,
      answer: n == null ? void 0 : n.content,
      answerId: n == null ? void 0 : n.id
    }
  };
};
function zx({ name: e, onClick: t }) {
  return /* @__PURE__ */ v.jsx(
    di,
    {
      onClick: t,
      _light: {
        color: "gray.800"
      },
      _dark: {
        color: "whiteAlpha.800"
      },
      className: `${ye}-get-help__menu-item-link`,
      variant: "link",
      fontSize: "inherit",
      children: e
    }
  );
}
function Lx({ name: e, url: t, ...r }) {
  return /* @__PURE__ */ v.jsx(
    dm,
    {
      href: t,
      _light: {
        color: "gray.800"
      },
      _dark: {
        color: "whiteAlpha.800"
      },
      isExternal: !0,
      className: `${ye}-get-help__menu-item-link`,
      ...r,
      children: e
    }
  );
}
const gae = ({
  action: e,
  openForm: t,
  onClose: r,
  onModalClose: i,
  chatSessionId: n,
  messages: a
}) => {
  const { icon: o, type: s, name: l } = e, u = la();
  let d = Lx, c = {
    name: l,
    url: e.url || "",
    onClick: () => {
      u.capture(og(n, e, a));
    }
  };
  switch (s) {
    case "OPEN_FORM": {
      d = zx, c = {
        name: l,
        onClick: () => {
          u.capture(og(n, e, a)), r == null || r(), t == null || t(e.formConfig);
        }
      };
      break;
    }
    case "INVOKE_CALLBACK": {
      d = zx, c = {
        name: l,
        onClick: () => {
          u.capture(og(n, e, a));
          const f = qm(a);
          e.callback({ messages: f, chatSessionId: n }), e.shouldCloseModal && (i == null || i());
        }
      };
      break;
    }
    default:
      d = Lx;
      break;
  }
  return /* @__PURE__ */ v.jsx(
    mt,
    {
      direction: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      className: `${ye}-get-help__menu-item`,
      children: /* @__PURE__ */ v.jsxs(mt, { direction: "row", alignItems: "center", children: [
        o && /* @__PURE__ */ v.jsx(
          cp,
          {
            iconSettings: o,
            color: "inkeepPrimary.medium",
            mr: 2,
            _dark: {
              color: "inkeepExpandedPrimary.300"
            },
            fontSize: "md"
          }
        ),
        /* @__PURE__ */ v.jsx(
          d,
          {
            ...c
          }
        )
      ] })
    }
  );
}, mae = gae, vae = ({
  actions: e,
  openForm: t,
  onClose: r,
  onModalClose: i,
  chatSessionId: n,
  messages: a
}) => /* @__PURE__ */ v.jsx(S1, { gap: 3, className: `${ye}-get-help__menu`, fontSize: "sm", children: e.map((o) => /* @__PURE__ */ v.jsx(
  mae,
  {
    action: o,
    openForm: t,
    onClose: r,
    onModalClose: i,
    chatSessionId: n,
    messages: a
  },
  o.name
)) }), kae = vae, bae = qd.create("popper-arrow-shadow-color"), _ae = ({
  getHelpButtonLabel: e = "Get help",
  openForm: t,
  onModalClose: r,
  chatSessionId: i,
  messages: n
}) => {
  const { getHelpCallToActions: a } = Qr(), [o, s] = rt(!1), l = la();
  if (!a || (a ?? []).length === 0)
    return null;
  const u = () => {
    s(!1);
  }, { pinnedItems: d, unpinnedItems: c } = a.reduce(
    (g, k) => (k.pinToToolbar ? g.pinnedItems.push(k) : g.unpinnedItems.push(k), g),
    // eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter
    { pinnedItems: [], unpinnedItems: [] }
  ), p = c.length === 1 ? [...d, c[0]] : d, f = c.length === 1 ? [] : c;
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    p.map((g) => /* @__PURE__ */ v.jsx(
      di,
      {
        size: "xs",
        variant: "outline",
        _light: {
          color: "gray.700"
        },
        className: `${ye}-get-help__button`,
        onClick: () => {
          if (l.capture(og(i, g, n)), g.type === "OPEN_FORM")
            u(), t == null || t(g.formConfig);
          else if (g.type === "INVOKE_CALLBACK") {
            const k = qm(n);
            g.callback({ messages: k, chatSessionId: i }), g.shouldCloseModal && (r == null || r());
          }
        },
        ...(g.type === "OPEN_LINK" || !g.type) && {
          as: "a",
          href: g.url,
          target: "_blank"
        },
        children: g.name
      },
      g.name
    )),
    f.length > 0 && /* @__PURE__ */ v.jsxs(
      Da,
      {
        positioning: { placement: "top", gutter: 12 },
        open: o,
        onInteractOutside: () => {
          s(!1);
        },
        children: [
          /* @__PURE__ */ v.jsx(Da.Trigger, { asChild: !0, children: /* @__PURE__ */ v.jsx(
            di,
            {
              size: "xs",
              variant: "outline",
              _light: {
                color: "gray.700"
              },
              className: `${ye}-get-help__button`,
              onClick: () => {
                s(!o);
              },
              children: e
            }
          ) }),
          /* @__PURE__ */ v.jsx(Gs, { children: /* @__PURE__ */ v.jsx(Da.Positioner, { children: /* @__PURE__ */ v.jsx(Ct, { zIndex: "popover", position: "relative", children: /* @__PURE__ */ v.jsxs(
            Da.Content,
            {
              width: "2xs",
              _dark: {
                background: "grayDark.800",
                color: "whiteAlpha.300 !important",
                [bae.name]: "colors.grayDark.400"
              },
              _light: {
                boxShadow: "lg"
              },
              children: [
                /* @__PURE__ */ v.jsx(Da.Arrow, { children: /* @__PURE__ */ v.jsx(Da.ArrowTip, {}) }),
                /* @__PURE__ */ v.jsx(Ct, { px: 3, py: 4, children: /* @__PURE__ */ v.jsx(
                  kae,
                  {
                    actions: f,
                    openForm: t,
                    onClose: u,
                    onModalClose: r,
                    chatSessionId: i,
                    messages: n
                  }
                ) }),
                /* @__PURE__ */ v.jsx(Da.CloseTrigger, {})
              ]
            }
          ) }) }) })
        ]
      }
    )
  ] });
}, Dae = _ae, yae = ({
  chatSessionId: e,
  messageCount: t,
  isListeningForResponse: r,
  handleStopResponse: i,
  clearConversation: n,
  isViewOnly: a = !1,
  isInputDisabled: o = !1,
  inWorkflow: s = !1,
  openForm: l,
  onModalClose: u,
  messages: d
}) => {
  const { actionButtonLabels: c, shouldShowCopyChatButton: p } = Qr(), {
    getHelpButtonLabel: f,
    clearButtonLabel: g,
    shareButtonLabel: k,
    stopButtonLabel: y,
    copyChatButtonLabel: _
  } = c ?? {};
  return /* @__PURE__ */ v.jsxs(
    mt,
    {
      alignItems: "start",
      justifyContent: "space-between",
      mt: 4,
      className: `${ye}-ai-chat-footer__footer`,
      flexWrap: "wrap-reverse",
      gap: "10px",
      children: [
        /* @__PURE__ */ v.jsx(Ct, { display: "inline-block", children: /* @__PURE__ */ v.jsx(Z7, {}) }),
        /* @__PURE__ */ v.jsxs(Tl, { flexWrap: "wrap", children: [
          /* @__PURE__ */ v.jsx(
            Dae,
            {
              getHelpButtonLabel: f,
              openForm: l,
              onModalClose: u,
              chatSessionId: e,
              messages: d
            }
          ),
          t > 0 && !r && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
            p && /* @__PURE__ */ v.jsx(
              dae,
              {
                buttonProps: {
                  variant: "outline",
                  size: "xs",
                  _light: {
                    color: "gray.700"
                  }
                },
                messages: d,
                children: _ || "Copy"
              }
            ),
            !s && /* @__PURE__ */ v.jsx(
              fae,
              {
                buttonProps: {
                  variant: "outline",
                  size: "xs",
                  _light: {
                    color: "gray.700"
                  }
                },
                chatSessionId: e,
                children: k || "Share"
              }
            ),
            !a && /* @__PURE__ */ v.jsx(
              di,
              {
                _light: {
                  color: "gray.700"
                },
                size: "xs",
                variant: "outline",
                onClick: n,
                children: g || "Clear"
              }
            )
          ] }),
          t === 0 && !o && /* @__PURE__ */ v.jsx(Ct, { display: "inline-block", children: /* @__PURE__ */ v.jsx(nae, { tooltipPosition: "top-end" }) }),
          r && /* @__PURE__ */ v.jsx(
            di,
            {
              _light: {
                color: "gray.700"
              },
              size: "xs",
              variant: "outline",
              onClick: i,
              children: y || "Stop"
            }
          )
        ] })
      ]
    }
  );
}, Eae = yae, Cae = Om(!1), xae = Om(null), em = Om(0), J7 = Je((e, t) => /* @__PURE__ */ v.jsx(
  zs,
  {
    maxLength: 1e3,
    minH: "unset",
    overflow: "hidden",
    w: "100%",
    resize: "none",
    ref: t,
    minRows: 1,
    asChild: !0,
    css: {
      _light: {
        "&::placeholder": { color: "gray.600" }
      },
      _dark: {
        "&::placeholder": { color: "grayDark.200" }
      }
    },
    ...e,
    children: /* @__PURE__ */ v.jsx(XD, {})
  }
));
function Aae({
  contentType: e,
  modalProps: t,
  addAttachment: r,
  onClose: i
}) {
  const [n, a] = rt({
    title: "",
    content: ""
  }), [o, s] = rt({ title: "", content: "" }), { contentInputLabel: l } = e, { titleInputLabel: u } = t ?? {}, d = u || "Title", c = l || "Content", p = (k) => {
    const y = { title: "", content: "" };
    return k.title || (y.title = `${d} is required.`), k.content || (y.content = `${c} is required.`), y;
  }, f = (k) => {
    const y = k.target, { name: _, value: A } = y;
    a({ ...n, [_]: A });
  }, g = (k) => {
    k.preventDefault();
    const y = p(n);
    if (y.title || y.content) {
      s(y);
      return;
    }
    const _ = {
      ...n,
      id: H6(),
      contentType: e
    };
    r(_), i();
  };
  return /* @__PURE__ */ v.jsxs("form", { onSubmit: g, children: [
    /* @__PURE__ */ v.jsxs(Go, { isInvalid: !!o.title, mb: 8, children: [
      /* @__PURE__ */ v.jsx(
        Wb,
        {
          htmlFor: "title",
          fontWeight: "medium",
          fontSize: "sm",
          color: "gray.700",
          _dark: { color: "whiteAlpha.700" },
          children: d
        }
      ),
      /* @__PURE__ */ v.jsx(
        N1,
        {
          id: "title",
          name: "title",
          onChange: f,
          value: n.title
        }
      ),
      o.title && /* @__PURE__ */ v.jsx(Go.Error, { children: o.title })
    ] }),
    /* @__PURE__ */ v.jsxs(Go, { isInvalid: !!o.content, mb: 8, children: [
      /* @__PURE__ */ v.jsx(
        Wb,
        {
          htmlFor: "content",
          fontWeight: "medium",
          fontSize: "sm",
          color: "gray.700",
          _dark: { color: "whiteAlpha.700" },
          children: c
        }
      ),
      /* @__PURE__ */ v.jsx(
        zs,
        {
          as: XD,
          maxRows: 10,
          id: "content",
          name: "content",
          onChange: f,
          value: n.content
        }
      ),
      o.content && /* @__PURE__ */ v.jsx(Go.Error, { children: o.content })
    ] }),
    /* @__PURE__ */ v.jsx(mt, { alignItems: "center", justifyContent: "flex-end", children: /* @__PURE__ */ v.jsx(di, { type: "submit", variant: "neutralFilled", children: "Upload" }) })
  ] });
}
function wae({
  isOpen: e,
  onClose: t,
  inputType: r,
  addAttachment: i
}) {
  var o, s;
  const n = (o = r == null ? void 0 : r.workflowModalProps) == null ? void 0 : o.modalHelpElement, a = (s = r == null ? void 0 : r.workflowModalProps) == null ? void 0 : s.modalHelpText;
  return /* @__PURE__ */ v.jsx(Gs, { children: /* @__PURE__ */ v.jsxs(ri, { open: e, size: "2xl", onClose: t, isCentered: !1, children: [
    /* @__PURE__ */ v.jsx(ri.Overlay, {}),
    r && /* @__PURE__ */ v.jsx(ri.Container, { children: /* @__PURE__ */ v.jsxs(ri.Content, { px: { base: 8, md: 10 }, py: { base: 8, md: 10 }, children: [
      /* @__PURE__ */ v.jsxs(Ct, { pb: 8, children: [
        /* @__PURE__ */ v.jsx(
          ZD,
          {
            heading: `Add ${r.displayName}`,
            description: a
          }
        ),
        n && n
      ] }),
      /* @__PURE__ */ v.jsx(
        ri.Close,
        {
          _dark: { color: "whiteAlpha.500" },
          _light: { color: "gray.600" },
          children: /* @__PURE__ */ v.jsx(pp, {})
        }
      ),
      /* @__PURE__ */ v.jsx(ri.Body, { p: 0, children: /* @__PURE__ */ v.jsx(
        Aae,
        {
          contentType: r.contentType,
          modalProps: r.workflowModalProps,
          addAttachment: i,
          onClose: t
        }
      ) })
    ] }) })
  ] }) });
}
const Fae = ({
  label: e,
  handleClick: t
}) => /* @__PURE__ */ v.jsx(
  di,
  {
    variant: "outline",
    size: "xs",
    _light: {
      color: "gray.700"
    },
    onClick: t,
    leftIcon: /* @__PURE__ */ v.jsx(WV, {}),
    className: `${ye}-add-attachment-button`,
    children: e
  }
), Tae = Fae, Sae = ({
  attachment: e,
  removable: t = !1,
  handleDelete: r,
  icon: i,
  ...n
}) => /* @__PURE__ */ v.jsxs(
  mt,
  {
    paddingLeft: 2,
    paddingRight: t ? 0 : 2,
    fontSize: "xs",
    borderRadius: "md",
    h: 6,
    bg: "gray.300",
    _dark: {
      bg: "whiteAlpha.300"
    },
    alignItems: "center",
    className: `${ye}-attachment-item`,
    minW: "0px",
    ...n,
    children: [
      i && /* @__PURE__ */ v.jsx(
        cp,
        {
          iconSettings: i,
          mr: "0.5em",
          color: "gray.600",
          _dark: {
            color: "whiteAlpha.600"
          }
        }
      ),
      /* @__PURE__ */ v.jsx(
        cn,
        {
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          display: "inline-block",
          children: e.title
        }
      ),
      t && /* @__PURE__ */ v.jsx(
        di,
        {
          variant: "iconButton",
          size: "xs",
          "aria-label": "Remove attachment",
          onClick: r,
          height: 4,
          color: "gray.600",
          _dark: {
            color: "whiteAlpha.600"
          },
          _hover: {
            bg: "transparent",
            color: "gray.700",
            _dark: {
              color: "whiteAlpha.500"
            }
          },
          children: /* @__PURE__ */ v.jsx(pp, { w: 4, h: 4 })
        }
      )
    ]
  }
), eT = Te(Sae), Iae = () => /* @__PURE__ */ v.jsxs(Ir, { openDelay: 0, closeDelay: 0, children: [
  /* @__PURE__ */ v.jsx(Ir.Trigger, { children: /* @__PURE__ */ v.jsx(mt, { alignItems: "center", children: /* @__PURE__ */ v.jsx(
    zn,
    {
      iconKey: "info",
      fontSize: "sm",
      _light: { color: "gray.600" },
      _dark: { color: "whiteAlpha.600" },
      cursor: "pointer",
      transform: "translateY(1px)",
      className: `${ye}-attachments-info-tip__icon`
    }
  ) }) }),
  /* @__PURE__ */ v.jsx(Gs, { children: /* @__PURE__ */ v.jsx(Ir.Positioner, { zIndex: "tooltip", children: /* @__PURE__ */ v.jsxs(
    Ir.Content,
    {
      fontSize: "sm",
      maxW: "200px",
      className: `${ye}-attachments-info-tip__content`,
      children: [
        /* @__PURE__ */ v.jsx(Ir.Arrow, { children: /* @__PURE__ */ v.jsx(Ir.ArrowTip, {}) }),
        "Attachments will be kept in context for the entire conversation."
      ]
    }
  ) }) })
] }), Bae = Iae, Rae = ({
  selectedWorkflow: e,
  messageAttachments: t = [],
  setMessageAttachments: r
}) => {
  const { isOpen: i, onClose: n, onOpen: a } = pm(), o = (e == null ? void 0 : e.supportedInputs) ?? [], [s, l] = rt(null), u = (c) => {
    const p = [...t];
    p.splice(c, 1), r(p);
  }, d = (c) => {
    r([...t, c]);
  };
  return /* @__PURE__ */ v.jsxs(
    bo,
    {
      direction: "row",
      alignItems: "center",
      justify: "space-between",
      gap: 2,
      flexWrap: "wrap",
      px: "4px",
      pt: 2,
      pb: 1,
      className: `${ye}-attachments-bar`,
      children: [
        /* @__PURE__ */ v.jsx(
          bo,
          {
            direction: "row",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
            px: 3,
            minW: "0px",
            children: (t || []).map((c, p) => {
              var f;
              return /* @__PURE__ */ v.jsx(
                eT,
                {
                  attachment: c,
                  removable: !0,
                  handleDelete: () => void u(p),
                  icon: (f = c.contentType) == null ? void 0 : f.attachmentIcon
                },
                c.id
              );
            })
          }
        ),
        /* @__PURE__ */ v.jsxs(
          bo,
          {
            direction: "row",
            alignItems: "center",
            justify: "space-between",
            gap: 2,
            flexWrap: "wrap",
            px: 3,
            children: [
              /* @__PURE__ */ v.jsx(Bae, {}),
              o.map((c) => /* @__PURE__ */ v.jsx(
                Tae,
                {
                  label: c.displayName,
                  handleClick: () => {
                    c.type === "FUNCTIONAL_MULTI_ATTACHMENT" ? c.onInvoke(
                      e,
                      c,
                      r,
                      [...t]
                    ) : (l(c), a());
                  }
                },
                c.id
              ))
            ]
          }
        ),
        /* @__PURE__ */ v.jsx(
          wae,
          {
            isOpen: i,
            onClose: () => {
              l(null), n();
            },
            inputType: s,
            addAttachment: d
          }
        )
      ]
    }
  );
}, Oae = Rae, Pae = Je(
  (e, t) => {
    const {
      inputMessage: r,
      handleSubmitInputMessage: i,
      inputMessageRef: n,
      isDisabled: a,
      isSubmitDisabled: o,
      handleInputMessageChange: s,
      selectedWorkflow: l,
      messageAttachments: u,
      setMessageAttachments: d
    } = e, c = e.narrowView || !1, { placeholder: p } = Qr(), f = qt(null);
    x1(em);
    const g = () => {
      setTimeout(() => {
        s("");
      }, 50), i(r);
    }, k = (_) => {
      _.key === "Enter" && !_.shiftKey && o ? _.preventDefault() : _.key === "Enter" && !_.shiftKey && !o && !_.nativeEvent.isComposing && g();
    }, y = /* @__PURE__ */ v.jsx(
      J7,
      {
        border: "none !important",
        outline: "none !important",
        boxShadow: "none !important",
        background: "transparent",
        px: c ? 0 : 3,
        py: c ? 0 : 2,
        placeholder: p,
        value: r,
        marginLeft: 1,
        marginRight: 2,
        maxHeight: "200px",
        maxLength: 99999,
        onChange: (_) => {
          const A = _.target.value;
          s(A);
        },
        ref: n,
        disabled: a,
        overflowY: "auto !important",
        onKeyDown: k,
        className: `${ye}-ai-chat__message-input`
      }
    );
    return /* @__PURE__ */ v.jsxs(
      mt,
      {
        direction: "column",
        top: "0 !important",
        position: "relative",
        _light: { bg: "gray.50" },
        _dark: { bg: "whiteAlpha.50", boxShadow: "none" },
        width: "100%",
        overflow: "hidden",
        ref: f,
        py: 2,
        px: 2,
        borderRadius: "lg",
        alignItems: "stretch",
        boxShadow: "md",
        className: `${ye}-ai-chat__message-box`,
        children: [
          /* @__PURE__ */ v.jsxs(mt, { direction: "row", className: `${ye}-ai-chat__message-box-row`, children: [
            y,
            /* @__PURE__ */ v.jsx(
              mt,
              {
                justify: "flex-end",
                alignItems: "flex-end",
                direction: "column",
                position: "relative",
                children: /* @__PURE__ */ v.jsx(
                  di,
                  {
                    "aria-label": "Send message",
                    background: "none",
                    position: "relative",
                    right: "0",
                    bottom: "0",
                    width: "40px",
                    height: "40px",
                    borderRadius: "lg",
                    alignSelf: "flex-end",
                    transitionProperty: "all",
                    transition: "linear",
                    _disabled: {
                      cursor: "not-allowed",
                      _hover: {
                        background: "none !important"
                      },
                      _active: {
                        background: "none !important"
                      }
                    },
                    _light: {
                      color: "inkeepPrimary.medium",
                      _disabled: {
                        color: "gray.500"
                      },
                      _active: {
                        background: "gray.300"
                      },
                      _hover: o ? {} : {
                        background: "gray.200",
                        color: "inkeepPrimary.strong"
                      }
                    },
                    _dark: {
                      color: "inkeepExpandedPrimary.100",
                      _disabled: {
                        color: "whiteAlpha.300"
                      },
                      _active: {
                        background: "whiteAlpha.200"
                      },
                      _hover: o ? void 0 : {
                        background: "whiteAlpha.100",
                        color: "inkeepExpandedPrimary.300"
                      }
                    },
                    disabled: o,
                    onClick: () => void i(r),
                    className: `${ye}-ai-chat__send-button`,
                    children: /* @__PURE__ */ v.jsx(
                      zn,
                      {
                        iconKey: "chatSubmit",
                        className: `${ye}-ai-chat__send-icon`,
                        color: "inherit",
                        transform: "rotate(-30deg)"
                      }
                    )
                  }
                )
              }
            )
          ] }),
          l && ((l == null ? void 0 : l.supportedInputs) ?? []).length > 0 && /* @__PURE__ */ v.jsx(
            Oae,
            {
              selectedWorkflow: l,
              messageAttachments: u,
              setMessageAttachments: d
            }
          )
        ]
      }
    );
  }
), Nae = Je(
  (e, t) => {
    const {
      inputMessage: r,
      handleInputMessageChange: i,
      inputMessageRef: n,
      shouldAutoFocusInput: a = !0
    } = e;
    gt(() => {
      n != null && typeof n != "function" && n.current && a && (n.current.focus(), n.current.selectionStart = n.current.value.length);
    }, [n]);
    const o = () => {
      i("");
    };
    return rw(
      "ctrl+x",
      () => {
        o();
      },
      [r]
    ), /* @__PURE__ */ v.jsx(mt, { ref: t, children: /* @__PURE__ */ v.jsx(
      Pae,
      {
        ...e,
        handleInputMessageChange: i,
        inputMessage: r,
        inputMessageRef: n
      }
    ) });
  }
), zae = Nae, Lae = ({
  label: e,
  name: t,
  isChecked: r,
  onChange: i,
  children: n,
  focusChildRef: a
}) => (gt(() => {
  r && (() => {
    a != null && a.current && typeof a != "function" && a.current.focus();
  })();
}, [r, a]), /* @__PURE__ */ v.jsxs(Go, { mb: 8, children: [
  /* @__PURE__ */ v.jsx(mt, { alignItems: "center", children: /* @__PURE__ */ v.jsx(
    El,
    {
      name: t,
      checked: r,
      id: t,
      onChange: (o) => void i(o.checked, t),
      variant: "neutral",
      children: (o) => /* @__PURE__ */ v.jsxs(mt, { alignItems: "center", mb: 4, children: [
        /* @__PURE__ */ v.jsx(El.Control, { children: /* @__PURE__ */ v.jsx(
          El.Icon,
          {
            isChecked: o.isChecked,
            isIndeterminate: o.isIndeterminate
          }
        ) }),
        /* @__PURE__ */ v.jsx(
          El.Label,
          {
            ml: "0.5rem",
            fontWeight: "medium",
            fontSize: "sm",
            color: "gray.700",
            _dark: { color: "whiteAlpha.700" },
            children: e
          }
        )
      ] })
    }
  ) }),
  /* @__PURE__ */ v.jsx(S1, { children: n })
] })), Dd = Lae, Mae = (e) => {
  const {
    onClose: t,
    messages: r,
    chatSessionId: i,
    messageInd: n,
    workflowId: a,
    setMessageFeedback: o
  } = e, { userType: s } = Xi(), l = s === "INTERNAL", u = la(), [d, c] = rt({
    unrelated_response: !1,
    unrelated_response_description: "",
    inaccurate_statement: !1,
    inaccurate_statement_description: "",
    inaccurate_code_snippet: !1,
    inaccurate_code_snippet_description: "",
    irrelevant_citations: !1
  }), [p, f] = rt({
    risky_action: !1,
    risky_action_description: "",
    poor_perception: !1,
    poor_perception_description: "",
    poor_perception_reason: "HIGHLIGHTED_UNRELATED_ISSUES",
    poor_perception_reason_other_description: ""
    // TODO this is always an empty string?
  }), g = async () => {
    const X = {
      ...d,
      ...l ? p : {}
    }, U = r.at(n - 1), K = r.at(n);
    if (!(U && K)) {
      console.error("messages length is less than 2 when submitting feedback"), t();
      return;
    }
    const z = {
      eventName: "chat_thumbs_down_feedback_submitted",
      properties: {
        chatSessionId: i,
        question: U.content,
        answer: K.content,
        answerId: K.id,
        workflowId: a,
        ...X
      }
    };
    u.capture(z), o(K.id, -1), t();
  }, k = (X, U) => {
    f((K) => ({
      ...K,
      [U]: X
    }));
  }, y = (X) => {
    const { name: U, value: K } = X.target;
    f((z) => ({
      ...z,
      [U]: K
    }));
  }, _ = (X, U) => {
    c((K) => ({
      ...K,
      [U]: X
    }));
  }, A = (X) => {
    const { name: U, value: K } = X.target;
    c((z) => ({
      ...z,
      [U]: K
    }));
  }, T = qt(null), N = qt(null), P = qt(null), B = qt(null), M = qt(null);
  return /* @__PURE__ */ v.jsxs(mt, { flexDirection: "column", className: `${ye}-feedback-form`, children: [
    /* @__PURE__ */ v.jsx(
      Dd,
      {
        label: "Didn't answer my question",
        isChecked: d.unrelated_response,
        onChange: _,
        name: "unrelated_response",
        focusChildRef: T,
        children: /* @__PURE__ */ v.jsx(
          zs,
          {
            ref: T,
            id: "unrelated_response_description",
            name: "unrelated_response_description",
            placeholder: "Please describe",
            value: d.unrelated_response_description,
            onChange: A
          }
        )
      }
    ),
    /* @__PURE__ */ v.jsx(
      Dd,
      {
        label: "Inaccurate statement",
        isChecked: d.inaccurate_statement,
        onChange: _,
        name: "inaccurate_statement",
        focusChildRef: N,
        children: /* @__PURE__ */ v.jsx(
          zs,
          {
            ref: N,
            id: "inaccurate_statement_description",
            name: "inaccurate_statement_description",
            placeholder: "Please describe",
            value: d.inaccurate_statement_description,
            onChange: A
          }
        )
      }
    ),
    /* @__PURE__ */ v.jsx(
      Dd,
      {
        label: "Inaccurate code snippet",
        isChecked: d.inaccurate_code_snippet,
        onChange: _,
        name: "inaccurate_code_snippet",
        focusChildRef: P,
        children: /* @__PURE__ */ v.jsx(
          zs,
          {
            ref: P,
            id: "inaccurate_code_snippet_description",
            name: "inaccurate_code_snippet_description",
            placeholder: "Please describe",
            value: d.inaccurate_code_snippet_description,
            onChange: A
          }
        )
      }
    ),
    /* @__PURE__ */ v.jsx(
      Dd,
      {
        label: "Irrelevant citations",
        isChecked: d.irrelevant_citations,
        onChange: _,
        name: "irrelevant_citations"
      }
    ),
    l && /* @__PURE__ */ v.jsxs(Ct, { mt: 4, children: [
      /* @__PURE__ */ v.jsxs(Tl, { mb: 2, children: [
        /* @__PURE__ */ v.jsx(sg, {}),
        /* @__PURE__ */ v.jsx(Te.h3, { fontSize: "lg", fontWeight: "medium", whiteSpace: "nowrap", children: "Admin-only feedback" }),
        /* @__PURE__ */ v.jsx(sg, {})
      ] }),
      /* @__PURE__ */ v.jsxs(
        Dd,
        {
          label: "Risky suggested action",
          isChecked: p.risky_action,
          onChange: k,
          name: "risky_action",
          focusChildRef: B,
          children: [
            " ",
            /* @__PURE__ */ v.jsx(
              zs,
              {
                id: "risky_action_description",
                name: "risky_action_description",
                placeholder: "Please describe",
                value: p.risky_action_description,
                onChange: y
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ v.jsx(
        Dd,
        {
          name: "poor_perception",
          label: "Poor perception",
          isChecked: p.poor_perception,
          onChange: k,
          focusChildRef: M,
          children: /* @__PURE__ */ v.jsxs(S1, { paddingLeft: 4, width: "100%", children: [
            /* @__PURE__ */ v.jsxs(mt, { alignItems: "center", width: "100%", children: [
              /* @__PURE__ */ v.jsx(Wb, { mr: "0.5rem", marginRight: 8, children: "Reason" }),
              /* @__PURE__ */ v.jsxs(
                N1,
                {
                  as: "select",
                  ref: M,
                  id: "poor_perception_reason",
                  name: "poor_perception_reason",
                  value: p.poor_perception_reason,
                  onChange: y,
                  ml: "auto",
                  children: [
                    /* @__PURE__ */ v.jsx("option", { value: "HIGHLIGHTED_UNRELATED_ISSUES", children: "Highlighted unrelated issues" }),
                    /* @__PURE__ */ v.jsx("option", { value: "SUGGESTED_A_COMPETITOR", children: "Suggested a competitor" }),
                    /* @__PURE__ */ v.jsx("option", { value: "OTHER", children: "Other" })
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ v.jsx(
              zs,
              {
                id: "poor_perception_description",
                name: "poor_perception_description",
                placeholder: "Please describe",
                value: p.poor_perception_description,
                onChange: y
              }
            )
          ] })
        }
      )
    ] }),
    /* @__PURE__ */ v.jsx(
      di,
      {
        onClick: g,
        maxWidth: "180px",
        ml: "auto",
        size: "md",
        className: `${ye}-feedback-form__submit-button`,
        variant: "neutralFilled",
        children: "Submit"
      }
    )
  ] });
}, jae = Mae, Hae = (e) => {
  const { isOpen: t, onClose: r } = e;
  return /* @__PURE__ */ v.jsxs(ri, { open: t, onClose: r, isCentered: !1, children: [
    /* @__PURE__ */ v.jsx(ri.Overlay, {}),
    /* @__PURE__ */ v.jsx(ri.Container, { children: /* @__PURE__ */ v.jsxs(
      ri.Content,
      {
        px: { base: 8, md: 10 },
        py: { base: 8, md: 10 },
        maxWidth: "480px",
        position: "relative",
        top: "5%",
        children: [
          /* @__PURE__ */ v.jsx(
            ri.Header,
            {
              px: 0,
              pt: 0,
              pb: 8,
              className: `${ye}-feedback-form__header`,
              children: /* @__PURE__ */ v.jsx(ZD, { heading: "Help improve my answers!" })
            }
          ),
          /* @__PURE__ */ v.jsx(
            ri.Close,
            {
              _dark: { color: "whiteAlpha.500" },
              _light: { color: "gray.600" },
              children: /* @__PURE__ */ v.jsx(pp, {})
            }
          ),
          /* @__PURE__ */ v.jsx(ri.Body, { p: 0, children: /* @__PURE__ */ v.jsx(jae, { ...e }) })
        ]
      }
    ) })
  ] });
}, $ae = Hae;
function Uae() {
  const e = ia(
    Nr.var("colors.gray.100"),
    Nr.var("colors.whiteAlpha.100")
  ), t = ia(
    Nr.var("colors.gray.300"),
    Nr.var("colors.whiteAlpha.300")
  );
  return /* @__PURE__ */ v.jsx(
    bo,
    {
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      gap: 12,
      flex: 1,
      p: 8,
      children: Array.from({ length: 3 }).map((r, i) => {
        const n = i % 2 === 0;
        return /* @__PURE__ */ v.jsxs(
          mt,
          {
            alignItems: "center",
            direction: n ? "row" : "row-reverse",
            children: [
              /* @__PURE__ */ v.jsx(
                Uf,
                {
                  borderRadius: "full",
                  marginRight: n ? 4 : 0,
                  marginLeft: n ? 0 : 4,
                  startColor: e,
                  endColor: t,
                  height: 12,
                  width: 12
                }
              ),
              /* @__PURE__ */ v.jsxs(S1, { gap: 2, alignItems: n ? "flex-start" : "flex-end", children: [
                /* @__PURE__ */ v.jsx(
                  Uf,
                  {
                    startColor: e,
                    endColor: t,
                    height: 4,
                    width: "250px",
                    borderRadius: "lg"
                  }
                ),
                /* @__PURE__ */ v.jsx(
                  Uf,
                  {
                    startColor: e,
                    endColor: t,
                    height: 4,
                    width: "200px",
                    borderRadius: "lg"
                  }
                )
              ] })
            ]
          },
          i
        );
      })
    }
  );
}
const Vae = (e) => {
  const { log: t } = dn(), [r, i] = rt([!0]), n = Nt(
    (o, s) => {
      t("updating chat bubble loading status"), t(o), t(s), i((l) => {
        if (l[o] !== s) {
          const u = l.map((d) => d);
          return u[o] = s, t("new status"), t(u), u;
        }
        return l;
      });
    },
    []
  ), a = Nt(
    (o) => {
      t("onLoadedCitations callback invoked"), t(o), n(o, !0);
    },
    [n]
  );
  return gt(() => {
    t("initializing chat bubble loading status when a new session id is set"), i([!0]);
  }, [e]), [
    r,
    n,
    a
  ];
}, tT = () => {
  var i, n;
  if (typeof window > "u")
    return !1;
  const e = (n = (i = window.navigator) == null ? void 0 : i.userAgent) == null ? void 0 : n.toLowerCase();
  let t = e.includes("safari");
  return e.includes("chrome") && t && (t = !1), t;
}, Wae = ({
  containerRef: e,
  debounceTime: t = 300
}) => {
  const r = qt(null), [i, n] = rt(!1), a = qt(0), o = qt(null), s = tT() ? "auto" : "smooth", l = Nt(() => {
    if (e.current) {
      const { scrollTop: c, scrollHeight: p, clientHeight: f } = e.current;
      p - c - f > 20 && c < a.current && n(!0), a.current = c;
    }
  }, [e]);
  gt(() => (e.current && e.current.addEventListener("scroll", l), () => {
    e.current && e.current.removeEventListener("scroll", l);
  }), [e, l]);
  const u = Nt(
    ({
      shouldScrollSmoothly: c = !1,
      bypassUserScrollUpLock: p = !1
    }) => {
      if (!p && i)
        return;
      const { current: f } = r;
      setTimeout(() => {
        f && f.scrollIntoView({
          behavior: c ? s : void 0,
          block: "nearest"
        });
      }, 50);
    },
    [r, i]
  ), d = Nt(
    ({
      shouldScrollSmoothly: c = !1,
      bypassDebounce: p = !1,
      bypassUserScrollUpLock: f
    }) => {
      const g = Date.now();
      p ? (u({ shouldScrollSmoothly: c, bypassUserScrollUpLock: f }), o.current = g) : (!o.current || g - o.current >= t) && (u({ shouldScrollSmoothly: c, bypassUserScrollUpLock: f }), o.current = g);
    },
    [u, t]
  );
  return {
    scrollToBottomEl: r,
    scrollToBottom: d,
    userScrolledUp: i,
    setUserScrolledUp: n
  };
};
function Gae(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function rT(...e) {
  return (t) => e.forEach((r) => Gae(r, t));
}
function gc(...e) {
  return we.useCallback(rT(...e), e);
}
var iT = we.forwardRef((e, t) => {
  const { children: r, ...i } = e, n = we.Children.toArray(r), a = n.find(Yae);
  if (a) {
    const o = a.props.children, s = n.map((l) => l === a ? we.Children.count(o) > 1 ? we.Children.only(null) : we.isValidElement(o) ? o.props.children : null : l);
    return /* @__PURE__ */ v.jsx(U_, { ...i, ref: t, children: we.isValidElement(o) ? we.cloneElement(o, void 0, s) : null });
  }
  return /* @__PURE__ */ v.jsx(U_, { ...i, ref: t, children: r });
});
iT.displayName = "Slot";
var U_ = we.forwardRef((e, t) => {
  const { children: r, ...i } = e;
  if (we.isValidElement(r)) {
    const n = Qae(r);
    return we.cloneElement(r, {
      ...qae(i, r.props),
      // @ts-ignore
      ref: t ? rT(t, n) : n
    });
  }
  return we.Children.count(r) > 1 ? we.Children.only(null) : null;
});
U_.displayName = "SlotClone";
var Kae = ({ children: e }) => /* @__PURE__ */ v.jsx(v.Fragment, { children: e });
function Yae(e) {
  return we.isValidElement(e) && e.type === Kae;
}
function qae(e, t) {
  const r = { ...t };
  for (const i in t) {
    const n = e[i], a = t[i];
    /^on[A-Z]/.test(i) ? n && a ? r[i] = (...s) => {
      a(...s), n(...s);
    } : n && (r[i] = n) : i === "style" ? r[i] = { ...n, ...a } : i === "className" && (r[i] = [n, a].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function Qae(e) {
  var i, n;
  let t = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var Xae = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], th = Xae.reduce((e, t) => {
  const r = we.forwardRef((i, n) => {
    const { asChild: a, ...o } = i, s = a ? iT : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ v.jsx(s, { ...o, ref: n });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), V_ = globalThis != null && globalThis.document ? we.useLayoutEffect : () => {
};
function Zae(e, t) {
  return we.useReducer((r, i) => t[r][i] ?? r, e);
}
var rh = (e) => {
  const { present: t, children: r } = e, i = Jae(t), n = typeof r == "function" ? r({ present: i.isPresent }) : we.Children.only(r), a = gc(i.ref, eoe(n));
  return typeof r == "function" || i.isPresent ? we.cloneElement(n, { ref: a }) : null;
};
rh.displayName = "Presence";
function Jae(e) {
  const [t, r] = we.useState(), i = we.useRef({}), n = we.useRef(e), a = we.useRef("none"), o = e ? "mounted" : "unmounted", [s, l] = Zae(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return we.useEffect(() => {
    const u = zf(i.current);
    a.current = s === "mounted" ? u : "none";
  }, [s]), V_(() => {
    const u = i.current, d = n.current;
    if (d !== e) {
      const p = a.current, f = zf(u);
      e ? l("MOUNT") : f === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(d && p !== f ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, l]), V_(() => {
    if (t) {
      const u = (c) => {
        const f = zf(i.current).includes(c.animationName);
        c.target === t && f && GT.flushSync(() => l("ANIMATION_END"));
      }, d = (c) => {
        c.target === t && (a.current = zf(i.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: we.useCallback((u) => {
      u && (i.current = getComputedStyle(u)), r(u);
    }, [])
  };
}
function zf(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function eoe(e) {
  var i, n;
  let t = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
function toe(e, t = []) {
  let r = [];
  function i(a, o) {
    const s = we.createContext(o), l = r.length;
    r = [...r, o];
    function u(c) {
      const { scope: p, children: f, ...g } = c, k = (p == null ? void 0 : p[e][l]) || s, y = we.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ v.jsx(k.Provider, { value: y, children: f });
    }
    function d(c, p) {
      const f = (p == null ? void 0 : p[e][l]) || s, g = we.useContext(f);
      if (g)
        return g;
      if (o !== void 0)
        return o;
      throw new Error(`\`${c}\` must be used within \`${a}\``);
    }
    return u.displayName = a + "Provider", [u, d];
  }
  const n = () => {
    const a = r.map((o) => we.createContext(o));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || a;
      return we.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return n.scopeName = e, [i, roe(n, ...t)];
}
function roe(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const r = () => {
    const i = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(a) {
      const o = i.reduce((s, { useScope: l, scopeName: u }) => {
        const c = l(a)[`__scope${u}`];
        return { ...s, ...c };
      }, {});
      return we.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
function $u(e) {
  const t = we.useRef(e);
  return we.useEffect(() => {
    t.current = e;
  }), we.useMemo(() => (...r) => {
    var i;
    return (i = t.current) == null ? void 0 : i.call(t, ...r);
  }, []);
}
var ioe = we.createContext(void 0);
function noe(e) {
  const t = we.useContext(ioe);
  return e || t || "ltr";
}
function aoe(e, [t, r]) {
  return Math.min(r, Math.max(t, e));
}
function Qu(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(n) {
    if (e == null || e(n), r === !1 || !n.defaultPrevented)
      return t == null ? void 0 : t(n);
  };
}
function ooe(e, t) {
  return we.useReducer((r, i) => t[r][i] ?? r, e);
}
var e5 = "ScrollArea", [nT, Sue] = toe(e5), [soe, eo] = nT(e5), aT = we.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: r,
      type: i = "hover",
      dir: n,
      scrollHideDelay: a = 600,
      ...o
    } = e, [s, l] = we.useState(null), [u, d] = we.useState(null), [c, p] = we.useState(null), [f, g] = we.useState(null), [k, y] = we.useState(null), [_, A] = we.useState(0), [T, N] = we.useState(0), [P, B] = we.useState(!1), [M, X] = we.useState(!1), U = gc(t, (z) => l(z)), K = noe(n);
    return /* @__PURE__ */ v.jsx(
      soe,
      {
        scope: r,
        type: i,
        dir: K,
        scrollHideDelay: a,
        scrollArea: s,
        viewport: u,
        onViewportChange: d,
        content: c,
        onContentChange: p,
        scrollbarX: f,
        onScrollbarXChange: g,
        scrollbarXEnabled: P,
        onScrollbarXEnabledChange: B,
        scrollbarY: k,
        onScrollbarYChange: y,
        scrollbarYEnabled: M,
        onScrollbarYEnabledChange: X,
        onCornerWidthChange: A,
        onCornerHeightChange: N,
        children: /* @__PURE__ */ v.jsx(
          th.div,
          {
            dir: K,
            ...o,
            ref: U,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": _ + "px",
              "--radix-scroll-area-corner-height": T + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
aT.displayName = e5;
var oT = "ScrollAreaViewport", sT = we.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: r, children: i, nonce: n, ...a } = e, o = eo(oT, r), s = we.useRef(null), l = gc(t, s, o.onViewportChange);
    return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: n
        }
      ),
      /* @__PURE__ */ v.jsx(
        th.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...a,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflowed#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: o.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: o.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ v.jsx("div", { ref: o.onContentChange, style: { minWidth: "100%", display: "table" }, children: i })
        }
      )
    ] });
  }
);
sT.displayName = oT;
var ds = "ScrollAreaScrollbar", t5 = we.forwardRef(
  (e, t) => {
    const { forceMount: r, ...i } = e, n = eo(ds, e.__scopeScrollArea), { onScrollbarXEnabledChange: a, onScrollbarYEnabledChange: o } = n, s = e.orientation === "horizontal";
    return we.useEffect(() => (s ? a(!0) : o(!0), () => {
      s ? a(!1) : o(!1);
    }), [s, a, o]), n.type === "hover" ? /* @__PURE__ */ v.jsx(loe, { ...i, ref: t, forceMount: r }) : n.type === "scroll" ? /* @__PURE__ */ v.jsx(uoe, { ...i, ref: t, forceMount: r }) : n.type === "auto" ? /* @__PURE__ */ v.jsx(lT, { ...i, ref: t, forceMount: r }) : n.type === "always" ? /* @__PURE__ */ v.jsx(r5, { ...i, ref: t }) : null;
  }
);
t5.displayName = ds;
var loe = we.forwardRef((e, t) => {
  const { forceMount: r, ...i } = e, n = eo(ds, e.__scopeScrollArea), [a, o] = we.useState(!1);
  return we.useEffect(() => {
    const s = n.scrollArea;
    let l = 0;
    if (s) {
      const u = () => {
        window.clearTimeout(l), o(!0);
      }, d = () => {
        l = window.setTimeout(() => o(!1), n.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", u), s.addEventListener("pointerleave", d), () => {
        window.clearTimeout(l), s.removeEventListener("pointerenter", u), s.removeEventListener("pointerleave", d);
      };
    }
  }, [n.scrollArea, n.scrollHideDelay]), /* @__PURE__ */ v.jsx(rh, { present: r || a, children: /* @__PURE__ */ v.jsx(
    lT,
    {
      "data-state": a ? "visible" : "hidden",
      ...i,
      ref: t
    }
  ) });
}), uoe = we.forwardRef((e, t) => {
  const { forceMount: r, ...i } = e, n = eo(ds, e.__scopeScrollArea), a = e.orientation === "horizontal", o = Xm(() => l("SCROLL_END"), 100), [s, l] = ooe("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return we.useEffect(() => {
    if (s === "idle") {
      const u = window.setTimeout(() => l("HIDE"), n.scrollHideDelay);
      return () => window.clearTimeout(u);
    }
  }, [s, n.scrollHideDelay, l]), we.useEffect(() => {
    const u = n.viewport, d = a ? "scrollLeft" : "scrollTop";
    if (u) {
      let c = u[d];
      const p = () => {
        const f = u[d];
        c !== f && (l("SCROLL"), o()), c = f;
      };
      return u.addEventListener("scroll", p), () => u.removeEventListener("scroll", p);
    }
  }, [n.viewport, a, l, o]), /* @__PURE__ */ v.jsx(rh, { present: r || s !== "hidden", children: /* @__PURE__ */ v.jsx(
    r5,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...i,
      ref: t,
      onPointerEnter: Qu(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: Qu(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), lT = we.forwardRef((e, t) => {
  const r = eo(ds, e.__scopeScrollArea), { forceMount: i, ...n } = e, [a, o] = we.useState(!1), s = e.orientation === "horizontal", l = Xm(() => {
    if (r.viewport) {
      const u = r.viewport.offsetWidth < r.viewport.scrollWidth, d = r.viewport.offsetHeight < r.viewport.scrollHeight;
      o(s ? u : d);
    }
  }, 10);
  return tp(r.viewport, l), tp(r.content, l), /* @__PURE__ */ v.jsx(rh, { present: i || a, children: /* @__PURE__ */ v.jsx(
    r5,
    {
      "data-state": a ? "visible" : "hidden",
      ...n,
      ref: t
    }
  ) });
}), r5 = we.forwardRef((e, t) => {
  const { orientation: r = "vertical", ...i } = e, n = eo(ds, e.__scopeScrollArea), a = we.useRef(null), o = we.useRef(0), [s, l] = we.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), u = hT(s.viewport, s.content), d = {
    ...i,
    sizes: s,
    onSizesChange: l,
    hasThumb: u > 0 && u < 1,
    onThumbChange: (p) => a.current = p,
    onThumbPointerUp: () => o.current = 0,
    onThumbPointerDown: (p) => o.current = p
  };
  function c(p, f) {
    return goe(p, o.current, s, f);
  }
  return r === "horizontal" ? /* @__PURE__ */ v.jsx(
    coe,
    {
      ...d,
      ref: t,
      onThumbPositionChange: () => {
        if (n.viewport && a.current) {
          const p = n.viewport.scrollLeft, f = Mx(p, s, n.dir);
          a.current.style.transform = `translate3d(${f}px, 0, 0)`;
        }
      },
      onWheelScroll: (p) => {
        n.viewport && (n.viewport.scrollLeft = p);
      },
      onDragScroll: (p) => {
        n.viewport && (n.viewport.scrollLeft = c(p, n.dir));
      }
    }
  ) : r === "vertical" ? /* @__PURE__ */ v.jsx(
    doe,
    {
      ...d,
      ref: t,
      onThumbPositionChange: () => {
        if (n.viewport && a.current) {
          const p = n.viewport.scrollTop, f = Mx(p, s);
          a.current.style.transform = `translate3d(0, ${f}px, 0)`;
        }
      },
      onWheelScroll: (p) => {
        n.viewport && (n.viewport.scrollTop = p);
      },
      onDragScroll: (p) => {
        n.viewport && (n.viewport.scrollTop = c(p));
      }
    }
  ) : null;
}), coe = we.forwardRef((e, t) => {
  const { sizes: r, onSizesChange: i, ...n } = e, a = eo(ds, e.__scopeScrollArea), [o, s] = we.useState(), l = we.useRef(null), u = gc(t, l, a.onScrollbarXChange);
  return we.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v.jsx(
    cT,
    {
      "data-orientation": "horizontal",
      ...n,
      ref: u,
      sizes: r,
      style: {
        bottom: 0,
        left: a.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: a.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": Qm(r) + "px",
        ...e.style
      },
      onThumbPointerDown: (d) => e.onThumbPointerDown(d.x),
      onDragScroll: (d) => e.onDragScroll(d.x),
      onWheelScroll: (d, c) => {
        if (a.viewport) {
          const p = a.viewport.scrollLeft + d.deltaX;
          e.onWheelScroll(p), gT(p, c) && d.preventDefault();
        }
      },
      onResize: () => {
        l.current && a.viewport && o && i({
          content: a.viewport.scrollWidth,
          viewport: a.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: rm(o.paddingLeft),
            paddingEnd: rm(o.paddingRight)
          }
        });
      }
    }
  );
}), doe = we.forwardRef((e, t) => {
  const { sizes: r, onSizesChange: i, ...n } = e, a = eo(ds, e.__scopeScrollArea), [o, s] = we.useState(), l = we.useRef(null), u = gc(t, l, a.onScrollbarYChange);
  return we.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v.jsx(
    cT,
    {
      "data-orientation": "vertical",
      ...n,
      ref: u,
      sizes: r,
      style: {
        top: 0,
        right: a.dir === "ltr" ? 0 : void 0,
        left: a.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": Qm(r) + "px",
        ...e.style
      },
      onThumbPointerDown: (d) => e.onThumbPointerDown(d.y),
      onDragScroll: (d) => e.onDragScroll(d.y),
      onWheelScroll: (d, c) => {
        if (a.viewport) {
          const p = a.viewport.scrollTop + d.deltaY;
          e.onWheelScroll(p), gT(p, c) && d.preventDefault();
        }
      },
      onResize: () => {
        l.current && a.viewport && o && i({
          content: a.viewport.scrollHeight,
          viewport: a.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: rm(o.paddingTop),
            paddingEnd: rm(o.paddingBottom)
          }
        });
      }
    }
  );
}), [poe, uT] = nT(ds), cT = we.forwardRef((e, t) => {
  const {
    __scopeScrollArea: r,
    sizes: i,
    hasThumb: n,
    onThumbChange: a,
    onThumbPointerUp: o,
    onThumbPointerDown: s,
    onThumbPositionChange: l,
    onDragScroll: u,
    onWheelScroll: d,
    onResize: c,
    ...p
  } = e, f = eo(ds, r), [g, k] = we.useState(null), y = gc(t, (U) => k(U)), _ = we.useRef(null), A = we.useRef(""), T = f.viewport, N = i.content - i.viewport, P = $u(d), B = $u(l), M = Xm(c, 10);
  function X(U) {
    if (_.current) {
      const K = U.clientX - _.current.left, z = U.clientY - _.current.top;
      u({ x: K, y: z });
    }
  }
  return we.useEffect(() => {
    const U = (K) => {
      const z = K.target;
      (g == null ? void 0 : g.contains(z)) && P(K, N);
    };
    return document.addEventListener("wheel", U, { passive: !1 }), () => document.removeEventListener("wheel", U, { passive: !1 });
  }, [T, g, N, P]), we.useEffect(B, [i, B]), tp(g, M), tp(f.content, M), /* @__PURE__ */ v.jsx(
    poe,
    {
      scope: r,
      scrollbar: g,
      hasThumb: n,
      onThumbChange: $u(a),
      onThumbPointerUp: $u(o),
      onThumbPositionChange: B,
      onThumbPointerDown: $u(s),
      children: /* @__PURE__ */ v.jsx(
        th.div,
        {
          ...p,
          ref: y,
          style: { position: "absolute", ...p.style },
          onPointerDown: Qu(e.onPointerDown, (U) => {
            U.button === 0 && (U.target.setPointerCapture(U.pointerId), _.current = g.getBoundingClientRect(), A.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", f.viewport && (f.viewport.style.scrollBehavior = "auto"), X(U));
          }),
          onPointerMove: Qu(e.onPointerMove, X),
          onPointerUp: Qu(e.onPointerUp, (U) => {
            const K = U.target;
            K.hasPointerCapture(U.pointerId) && K.releasePointerCapture(U.pointerId), document.body.style.webkitUserSelect = A.current, f.viewport && (f.viewport.style.scrollBehavior = ""), _.current = null;
          })
        }
      )
    }
  );
}), tm = "ScrollAreaThumb", dT = we.forwardRef(
  (e, t) => {
    const { forceMount: r, ...i } = e, n = uT(tm, e.__scopeScrollArea);
    return /* @__PURE__ */ v.jsx(rh, { present: r || n.hasThumb, children: /* @__PURE__ */ v.jsx(hoe, { ref: t, ...i }) });
  }
), hoe = we.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: r, style: i, ...n } = e, a = eo(tm, r), o = uT(tm, r), { onThumbPositionChange: s } = o, l = gc(
      t,
      (c) => o.onThumbChange(c)
    ), u = we.useRef(), d = Xm(() => {
      u.current && (u.current(), u.current = void 0);
    }, 100);
    return we.useEffect(() => {
      const c = a.viewport;
      if (c) {
        const p = () => {
          if (d(), !u.current) {
            const f = moe(c, s);
            u.current = f, s();
          }
        };
        return s(), c.addEventListener("scroll", p), () => c.removeEventListener("scroll", p);
      }
    }, [a.viewport, d, s]), /* @__PURE__ */ v.jsx(
      th.div,
      {
        "data-state": o.hasThumb ? "visible" : "hidden",
        ...n,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...i
        },
        onPointerDownCapture: Qu(e.onPointerDownCapture, (c) => {
          const f = c.target.getBoundingClientRect(), g = c.clientX - f.left, k = c.clientY - f.top;
          o.onThumbPointerDown({ x: g, y: k });
        }),
        onPointerUp: Qu(e.onPointerUp, o.onThumbPointerUp)
      }
    );
  }
);
dT.displayName = tm;
var i5 = "ScrollAreaCorner", pT = we.forwardRef(
  (e, t) => {
    const r = eo(i5, e.__scopeScrollArea), i = !!(r.scrollbarX && r.scrollbarY);
    return r.type !== "scroll" && i ? /* @__PURE__ */ v.jsx(foe, { ...e, ref: t }) : null;
  }
);
pT.displayName = i5;
var foe = we.forwardRef((e, t) => {
  const { __scopeScrollArea: r, ...i } = e, n = eo(i5, r), [a, o] = we.useState(0), [s, l] = we.useState(0), u = !!(a && s);
  return tp(n.scrollbarX, () => {
    var c;
    const d = ((c = n.scrollbarX) == null ? void 0 : c.offsetHeight) || 0;
    n.onCornerHeightChange(d), l(d);
  }), tp(n.scrollbarY, () => {
    var c;
    const d = ((c = n.scrollbarY) == null ? void 0 : c.offsetWidth) || 0;
    n.onCornerWidthChange(d), o(d);
  }), u ? /* @__PURE__ */ v.jsx(
    th.div,
    {
      ...i,
      ref: t,
      style: {
        width: a,
        height: s,
        position: "absolute",
        right: n.dir === "ltr" ? 0 : void 0,
        left: n.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function rm(e) {
  return e ? parseInt(e, 10) : 0;
}
function hT(e, t) {
  const r = e / t;
  return isNaN(r) ? 0 : r;
}
function Qm(e) {
  const t = hT(e.viewport, e.content), r = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, i = (e.scrollbar.size - r) * t;
  return Math.max(i, 18);
}
function goe(e, t, r, i = "ltr") {
  const n = Qm(r), a = n / 2, o = t || a, s = n - o, l = r.scrollbar.paddingStart + o, u = r.scrollbar.size - r.scrollbar.paddingEnd - s, d = r.content - r.viewport, c = i === "ltr" ? [0, d] : [d * -1, 0];
  return fT([l, u], c)(e);
}
function Mx(e, t, r = "ltr") {
  const i = Qm(t), n = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, a = t.scrollbar.size - n, o = t.content - t.viewport, s = a - i, l = r === "ltr" ? [0, o] : [o * -1, 0], u = aoe(e, l);
  return fT([0, o], [0, s])(u);
}
function fT(e, t) {
  return (r) => {
    if (e[0] === e[1] || t[0] === t[1])
      return t[0];
    const i = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + i * (r - e[0]);
  };
}
function gT(e, t) {
  return e > 0 && e < t;
}
var moe = (e, t = () => {
}) => {
  let r = { left: e.scrollLeft, top: e.scrollTop }, i = 0;
  return function n() {
    const a = { left: e.scrollLeft, top: e.scrollTop }, o = r.left !== a.left, s = r.top !== a.top;
    (o || s) && t(), r = a, i = window.requestAnimationFrame(n);
  }(), () => window.cancelAnimationFrame(i);
};
function Xm(e, t) {
  const r = $u(e), i = we.useRef(0);
  return we.useEffect(() => () => window.clearTimeout(i.current), []), we.useCallback(() => {
    window.clearTimeout(i.current), i.current = window.setTimeout(r, t);
  }, [r, t]);
}
function tp(e, t) {
  const r = $u(t);
  V_(() => {
    let i = 0;
    if (e) {
      const n = new ResizeObserver(() => {
        cancelAnimationFrame(i), i = window.requestAnimationFrame(r);
      });
      return n.observe(e), () => {
        window.cancelAnimationFrame(i), n.unobserve(e);
      };
    }
  }, [e, r]);
}
var mT = aT, voe = sT, koe = pT;
const boe = Te(dT), _oe = Te(t5), vT = we.forwardRef(({ className: e, orientation: t = "vertical", ...r }, i) => /* @__PURE__ */ v.jsx(
  _oe,
  {
    ref: i,
    orientation: t,
    className: Eo("", e),
    display: "flex",
    touchAction: "none",
    userSelect: "none",
    height: t === "vertical" ? "100%" : "10px",
    width: t === "vertical" ? "10px" : "100%",
    borderLeft: t === "vertical" ? "1px solid transparent" : "none",
    borderTop: t === "horizontal" ? "1px solid transparent" : "none",
    padding: "1px",
    ...r,
    children: /* @__PURE__ */ v.jsx(
      boe,
      {
        backgroundColor: "gray.300",
        _dark: {
          backgroundColor: "whiteAlpha.300"
        },
        borderRadius: "full",
        position: "relative",
        flex: "1"
      }
    )
  }
)), n5 = we.forwardRef(({ className: e, children: t, onScroll: r = () => {
}, viewportRef: i, ...n }, a) => /* @__PURE__ */ v.jsxs(
  mT,
  {
    ref: a,
    className: Eo("", e),
    ...n,
    style: {
      overflow: "hidden",
      position: "relative",
      ...n.style
    },
    children: [
      /* @__PURE__ */ v.jsx(
        voe,
        {
          ref: i,
          onScroll: r,
          style: {
            height: "100%",
            width: "100%",
            borderRadius: "inherit"
          },
          children: /* @__PURE__ */ v.jsx("div", { style: { display: "grid" }, children: t })
        }
      ),
      /* @__PURE__ */ v.jsx(vT, {}),
      /* @__PURE__ */ v.jsx(koe, {})
    ]
  }
));
n5.displayName = mT.displayName;
vT.displayName = t5.displayName;
function Doe({
  label: e,
  icon: t,
  onClick: r,
  ...i
}) {
  return /* @__PURE__ */ v.jsxs(di, { variant: "outline", onClick: r, ...i, children: [
    t && /* @__PURE__ */ v.jsx(cp, { iconSettings: t, mr: 1, fontSize: "sm" }),
    e
  ] });
}
const yoe = Te(Doe);
function Eoe({ action: e, onClick: t }) {
  const { icon: r, label: i } = e;
  return /* @__PURE__ */ v.jsx(
    yoe,
    {
      label: i || "Contact Support",
      icon: r,
      onClick: t,
      size: "sm",
      fontSize: "xs",
      height: "30px",
      className: `${ye}-support-button`
    }
  );
}
const Coe = {
  STANDARD: "standard",
  STRICT: "strict"
};
function xoe({
  openForm: e,
  shouldEscalateToSupport: t,
  onModalClose: r,
  chatSessionId: i,
  messages: n,
  messageInd: a
}) {
  const o = la(), { aiAnnotationPolicies: s } = Qr(), l = s == null ? void 0 : s.shouldEscalateToSupport;
  return l ? l.map(({ action: u, threshold: d }, c) => {
    const p = Coe[d];
    if (!t[p])
      return null;
    const f = n.at(a - 1), g = n.at(a), { action: k } = u, y = {
      eventName: "support_button_clicked",
      properties: {
        chatSessionId: i,
        actionType: k.type,
        question: f == null ? void 0 : f.content,
        answer: g == null ? void 0 : g.content,
        answerId: g == null ? void 0 : g.id
      }
    }, _ = k.type === "OPEN_FORM" ? () => {
      o.capture(y), e == null || e(k.formConfig);
    } : () => {
      o.capture(y);
      const A = qm(n);
      k.callback({ chatSessionId: i, messages: A }), k.shouldCloseModal && (r == null || r());
    };
    return /* @__PURE__ */ v.jsx(
      Eoe,
      {
        action: u,
        onClick: _
      },
      c
    );
  }) : null;
}
function Aoe({ label: e, handleClick: t }) {
  return /* @__PURE__ */ v.jsx(
    di,
    {
      className: `${ye}-workflow-button`,
      fontWeight: "medium",
      height: "auto",
      minH: 9,
      leftIcon: /* @__PURE__ */ v.jsx(VV, { fontSize: "16px" }),
      size: "sm",
      variant: "outlinePrimary",
      onClick: t,
      width: "100%",
      whiteSpace: "normal",
      py: 2,
      children: /* @__PURE__ */ v.jsx("span", { children: e })
    }
  );
}
function woe({ isMdContainer: e, handleWorkflowSelection: t }) {
  const { workflowsHeader: r, workflows: i } = Qr();
  return /* @__PURE__ */ v.jsxs(Ct, { mt: 4, children: [
    /* @__PURE__ */ v.jsx(
      Te.h3,
      {
        fontSize: "2xs",
        textTransform: "uppercase",
        fontWeight: "semibold",
        letterSpacing: "widest",
        color: "gray.600",
        mb: 2,
        _light: {
          color: "gray.600"
        },
        _dark: {
          color: "whiteAlpha.500"
        },
        className: `${ye}-workflows__header`,
        children: r
      }
    ),
    /* @__PURE__ */ v.jsx(
      bo,
      {
        flexWrap: "wrap",
        gap: 0,
        direction: e ? "row" : "column",
        children: (i || []).map((n) => /* @__PURE__ */ v.jsx(
          Ct,
          {
            mb: 2,
            mr: e ? 2 : 0,
            maxWidth: "100%",
            children: /* @__PURE__ */ v.jsx(
              Aoe,
              {
                handleClick: () => {
                  t(n);
                },
                label: n.displayName
              }
            )
          },
          n.id
        ))
      }
    )
  ] });
}
const Foe = {
  base: { bg: "white", boxShadow: "lg", color: "gray.800" },
  _dark: {
    bg: "grayDark.800",
    color: "whiteAlpha.800"
  }
}, Toe = ({ placement: e = "top-end" }) => {
  const { disclaimerSettings: t, botName: r } = Qr(), { disclaimerTooltip: i } = t ?? Hl.disclaimerSettings, n = i || `Information provided by ${r || "this AI assistant"} is not guaranteed to be accurate or comprehensive.`, { shouldOpenLinksInNewTab: a } = Qr();
  return /* @__PURE__ */ v.jsxs(Da, { positioning: { placement: e }, children: [
    /* @__PURE__ */ v.jsx(Da.Trigger, { display: "flex", alignItems: "center", children: /* @__PURE__ */ v.jsx(
      zn,
      {
        _light: { color: "gray.700" },
        _dark: { color: "whiteAlpha.800" },
        iconKey: "info",
        fontSize: "sm",
        ml: 2,
        transform: "translateY(1px) translateX(-4px)",
        className: `${ye}-disclaimer-icon`
      }
    ) }),
    /* @__PURE__ */ v.jsx(Gs, { children: /* @__PURE__ */ v.jsx(Da.Positioner, { children: /* @__PURE__ */ v.jsx(Ct, { zIndex: "popover", position: "relative", children: /* @__PURE__ */ v.jsxs(
      Da.Content,
      {
        css: Foe,
        py: 2,
        px: 4,
        width: {
          base: "250px",
          sm: "420px"
        },
        fontWeight: "normal",
        children: [
          /* @__PURE__ */ v.jsx(Da.Arrow, { children: /* @__PURE__ */ v.jsx(Da.ArrowTip, {}) }),
          /* @__PURE__ */ v.jsx(
            Ym,
            {
              markdown: n,
              shouldOpenLinksInNewTab: a
            }
          )
        ]
      }
    ) }) }) })
  ] });
}, kT = Toe, Soe = ({ userAvatarSrcUrl: e }) => /* @__PURE__ */ v.jsx(w2, { src: e, alt: "user avatar" }), Ioe = Soe, Boe = ({ width: e, height: t }) => {
  const r = Nr("colors.inkeepPrimary.medium"), i = Nr("colors.inkeepExpandedPrimary.300"), n = ia(r, i);
  return /* @__PURE__ */ v.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      height: t,
      viewBox: "0 96 960 960",
      width: e,
      children: /* @__PURE__ */ v.jsx(
        "path",
        {
          d: "M222 801q63-40 124.5-60.5T480 720q72 0 134 20.5T739 801q44-54 62.5-109T820 576q0-145-97.5-242.5T480 236q-145 0-242.5 97.5T140 576q0 61 19 116t63 109Zm257.814-195Q422 606 382.5 566.314q-39.5-39.686-39.5-97.5t39.686-97.314q39.686-39.5 97.5-39.5t97.314 39.686q39.5 39.686 39.5 97.5T577.314 566.5q-39.686 39.5-97.5 39.5Zm-.219 370q-83.146 0-156.275-31.5t-127.225-86Q142 804 111 731.159 80 658.319 80 575.5q0-82.819 31.5-155.659Q143 347 197.5 293t127.341-85.5Q397.681 176 480.5 176q82.819 0 155.659 31.5Q709 239 763 293t85.5 127Q880 493 880 575.734q0 82.734-31.5 155.5T763 858.5q-54 54.5-127.129 86T479.595 976Z",
          fill: n
        }
      )
    }
  );
}, Roe = Boe, Ooe = ({ isMdContainer: e, isUser: t }) => {
  const { userAvatarSrcUrl: r, botName: i } = Qr(), { userName: n } = Xi();
  return /* @__PURE__ */ v.jsxs(
    mt,
    {
      direction: e ? "column" : "row",
      justifyContent: "flex-start",
      alignItems: e ? "flex-start" : "center",
      overflow: "hidden",
      flexShrink: 0,
      paddingRight: e ? 6 : 0,
      paddingLeft: e ? 3 : 0,
      userSelect: "none",
      mb: e ? 0 : 6,
      className: `${ye}-message-header`,
      children: [
        /* @__PURE__ */ v.jsx(
          m8,
          {
            height: e ? "48px" : "auto",
            borderRadius: "full",
            className: `${ye}-message-header__avatar-box`,
            children: t ? /* @__PURE__ */ v.jsxs(
              oy,
              {
                size: "sm",
                bg: n ? "inkeepPrimary.lighter" : "none",
                color: "inkeepPrimary.stronger",
                fontWeight: "semibold",
                display: e ? "flex" : "none !important",
                _dark: {
                  bg: n ? "inkeepExpandedPrimary.300" : "none"
                },
                className: `${ye}-message-header__avatar-user`,
                children: [
                  n && /* @__PURE__ */ v.jsx(oy.Fallback, { children: Qz(n) }),
                  r ? /* @__PURE__ */ v.jsx(Ioe, { userAvatarSrcUrl: r }) : /* @__PURE__ */ v.jsx(Roe, { width: "32px", height: "32px" }),
                  /* @__PURE__ */ v.jsx(Ct, { srOnly: !0, children: n })
                ]
              }
            ) : /* @__PURE__ */ v.jsx(G2, {})
          }
        ),
        !e && /* @__PURE__ */ v.jsx(
          Ct,
          {
            px: 3,
            py: 1,
            ml: t ? 0 : 4,
            fontSize: "sm",
            borderRadius: "full",
            bg: t ? "gray.50" : "inkeepPrimary.lighter",
            color: t ? "gray.700" : "inkeepPrimary.stronger",
            _dark: {
              bg: "grayDark.700",
              color: t ? "whiteAlpha.700" : "inkeepExpandedPrimary.300"
            },
            className: `${ye}-message-header__name`,
            children: t ? n ?? "You" : i ?? "AI assistant"
          }
        )
      ]
    }
  );
}, bT = Ooe, Poe = ({
  label: e,
  handleClick: t,
  highlightQuestion: r = !1
}) => {
  const i = qt(null), [n, a] = mF(), { height: o, width: s } = a, l = Math.max(o, s);
  return gt(() => {
    if (i.current) {
      const u = i.current;
      u.style.width = `${l + 100}px`, u.style.height = `${l + 100}px`;
    }
  }, [l]), /* @__PURE__ */ v.jsx(Ct, { ref: n, children: /* @__PURE__ */ v.jsxs(
    Ct,
    {
      className: `${ye}-quick-question-button__wrapper`,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      zIndex: "0",
      minH: 9,
      borderRadius: "md",
      overflow: "hidden",
      _after: {
        content: '""',
        position: "absolute",
        zIndex: "-1",
        left: "1px",
        top: "1px",
        width: "calc(100% - 2px)",
        height: "calc(100% - 2px)",
        borderRadius: "5px",
        backgroundColor: "white"
      },
      _dark: {
        _after: {
          backgroundColor: "grayDark.900"
        }
      },
      children: [
        /* @__PURE__ */ v.jsx(
          Ct,
          {
            ref: i,
            position: "absolute",
            zIndex: "-2",
            width: "100%",
            height: "100%",
            backgroundColor: "gray.300",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "0 0",
            backgroundSize: "cover",
            backgroundImage: r ? "conic-gradient(transparent, token(colors.inkeepExpandedPrimary.600), transparent 30%)" : "none",
            margin: "auto",
            animation: r ? "4s spin linear infinite" : "none",
            _dark: {
              backgroundColor: "whiteAlpha.300",
              backgroundImage: r ? "conic-gradient(transparent, token(colors.inkeepExpandedPrimary.300), transparent 30%) !important" : "none"
            },
            className: `${ye}-quick-question-button__highlight`
          }
        ),
        /* @__PURE__ */ v.jsx(
          di,
          {
            className: `${ye}-quick-question-button`,
            onClick: t,
            value: e,
            size: "sm",
            fontSize: "sm",
            fontWeight: "normal",
            variant: "ghost",
            color: "gray.800",
            height: "auto",
            width: "100%",
            py: 2,
            whiteSpace: "normal",
            textAlign: "center",
            lineHeight: "unset",
            border: "1px solid transparent",
            _hover: {
              backgroundColor: "grayAlpha.50 !important",
              borderColor: "grayAlpha.50"
            },
            _focus: {
              backgroundColor: "grayAlpha.50",
              borderColor: "grayAlpha.50"
            },
            _dark: {
              color: "whiteAlpha.800",
              _hover: {
                backgroundColor: "whiteAlpha.200 !important",
                borderColor: "whiteAlpha.300"
              },
              _focus: {
                backgroundColor: "whiteAlpha.200",
                borderColor: "whiteAlpha.300"
              }
            },
            children: e
          }
        )
      ]
    }
  ) });
}, Noe = Poe, zoe = ({
  isMdContainer: e,
  handleAutoSubmitNewMessage: t,
  quickQuestions: r,
  quickQuestionsLabel: i = "",
  shouldHighlightFirstQuickQuestion: n = !1
}) => {
  const a = Nt(
    (o) => {
      const s = o.target;
      t(s.value);
    },
    [t]
  );
  return /* @__PURE__ */ v.jsxs(Ct, { mt: 4, children: [
    /* @__PURE__ */ v.jsx(
      Te.h3,
      {
        fontSize: "2xs",
        textTransform: "uppercase",
        fontWeight: "semibold",
        letterSpacing: "widest",
        color: "gray.600",
        mb: 2,
        _light: {
          color: "gray.600"
        },
        _dark: {
          color: "whiteAlpha.500"
        },
        className: `${ye}-quick-questions__label`,
        children: i
      }
    ),
    /* @__PURE__ */ v.jsx(
      bo,
      {
        flexWrap: "wrap",
        gap: 0,
        direction: e ? "row" : "column",
        children: (r ?? []).map((o, s) => /* @__PURE__ */ v.jsx(Ct, { mr: e ? 2 : 0, mb: 2, maxWidth: "100%", children: /* @__PURE__ */ v.jsx(
          Noe,
          {
            label: o,
            handleClick: a,
            highlightQuestion: n && s === 0
          }
        ) }, o))
      }
    )
  ] });
}, Loe = zoe, Moe = ({
  isMdContainer: e = !1,
  showQuickQuestions: t = !1,
  handleAutoSubmitNewMessage: r,
  showWorkflows: i = !1,
  handleWorkflowSelection: n
}) => {
  const {
    introMessage: a,
    disclaimerSettings: o = Hl.disclaimerSettings,
    botName: s
  } = Qr(), { isDisclaimerEnabled: l, disclaimerLabel: u } = o, { organizationDisplayName: d } = Xi(), {
    chatSubjectName: c,
    quickQuestions: p,
    quickQuestionsLabel: f,
    shouldHighlightFirstQuickQuestion: g
  } = Qr();
  let y = `${s ? `Hi, I'm ${s}!` : "Hi!"} 

 I'm an AI assistant trained on documentation, help articles, and other content.`;
  const _ = c ?? d;
  return y += _ ? `

 Ask me anything about \`${_}\`.` : `

 Let me know how I can help.`, /* @__PURE__ */ v.jsxs(
    mt,
    {
      position: "relative",
      w: "100%",
      overflow: "visible",
      flexDirection: e ? "row" : "column",
      py: 4,
      px: e ? 8 : 6,
      children: [
        /* @__PURE__ */ v.jsx(bT, { isMdContainer: e, isUser: !1 }),
        /* @__PURE__ */ v.jsxs(
          mt,
          {
            justifyContent: "flex-end",
            overflow: "visible",
            direction: "column",
            flexGrow: "2",
            pr: e ? 3 : 0,
            children: [
              /* @__PURE__ */ v.jsx(
                Ym,
                {
                  markdown: a || y,
                  shouldOpenLinksInNewTab: !0
                }
              ),
              l && /* @__PURE__ */ v.jsxs(
                mt,
                {
                  justifyContent: "flex-end",
                  alignItems: "center",
                  _light: {
                    color: "gray.700"
                  },
                  _dark: {
                    color: "grayDark.100"
                  },
                  fontSize: "sm",
                  className: `${ye}-ai-chat__disclaimer`,
                  children: [
                    /* @__PURE__ */ v.jsx("div", { className: `${ye}-ai-chat__disclaimer-label`, children: u }),
                    /* @__PURE__ */ v.jsx(kT, {})
                  ]
                }
              ),
              t && /* @__PURE__ */ v.jsx(
                Loe,
                {
                  isMdContainer: e,
                  handleAutoSubmitNewMessage: r,
                  quickQuestions: p,
                  quickQuestionsLabel: f,
                  shouldHighlightFirstQuickQuestion: g
                }
              ),
              i && /* @__PURE__ */ v.jsx(
                woe,
                {
                  isMdContainer: e,
                  handleWorkflowSelection: n
                }
              )
            ]
          }
        )
      ]
    }
  );
}, joe = ht.memo(Moe);
function Hoe({
  isOpen: e,
  onClose: t,
  attachment: r
}) {
  return /* @__PURE__ */ v.jsxs(ri, { open: e, size: "2xl", onClose: t, isCentered: !1, children: [
    /* @__PURE__ */ v.jsx(ri.Overlay, {}),
    /* @__PURE__ */ v.jsx(ri.Container, { children: /* @__PURE__ */ v.jsxs(ri.Content, { px: { base: 8, md: 10 }, py: { base: 8, md: 10 }, children: [
      /* @__PURE__ */ v.jsx(ri.Header, { px: 0, pt: 0, pb: 8, children: (r == null ? void 0 : r.title) || "Attachment" }),
      /* @__PURE__ */ v.jsx(
        ri.Close,
        {
          _dark: { color: "whiteAlpha.500" },
          _light: { color: "gray.600" },
          children: /* @__PURE__ */ v.jsx(pp, {})
        }
      ),
      /* @__PURE__ */ v.jsx(ri.Body, { p: 0, children: (r == null ? void 0 : r.content) || "" }),
      /* @__PURE__ */ v.jsx(ri.Footer, {})
    ] }) })
  ] });
}
function $oe({
  attachments: e,
  messageId: t
}) {
  const { isOpen: r, onClose: i, onOpen: n } = pm(), [a, o] = rt(null), s = (l) => {
    o(l), n();
  };
  return /* @__PURE__ */ v.jsxs(
    bo,
    {
      className: `${ye}-message-attachments`,
      gap: 2,
      direction: "row",
      flexWrap: "wrap",
      children: [
        e.map((l) => {
          var u;
          return /* @__PURE__ */ v.jsx(
            di,
            {
              onClick: () => void s(l),
              padding: 0,
              height: "auto",
              variant: "ghost",
              fontWeight: "normal",
              className: `${ye}-message-attachment-item`,
              children: /* @__PURE__ */ v.jsx(
                eT,
                {
                  attachment: l,
                  removable: !1,
                  bg: "gray.100",
                  icon: (u = l.contentType) == null ? void 0 : u.attachmentIcon
                }
              )
            },
            `${t}-${l.id}`
          );
        }),
        /* @__PURE__ */ v.jsx(
          Hoe,
          {
            isOpen: r,
            onClose: () => {
              o(null), i();
            },
            attachment: a
          }
        )
      ]
    }
  );
}
const Uoe = ({ textToCopy: e, onCopy: t }) => /* @__PURE__ */ v.jsx(
  JD,
  {
    onCopy: t,
    textToCopy: e,
    isTooltipEnabled: !0,
    clickedText: "Message copied!",
    buttonProps: { px: 2, h: 8, minW: 8 }
  }
), Voe = Uoe, Woe = Te(({ onClick: e, isActive: t }) => /* @__PURE__ */ v.jsx(
  di,
  {
    px: 2,
    h: 8,
    minW: 8,
    variant: "iconButton",
    onClick: e,
    className: `${ye}-thumbs-down__button`,
    "data-state": t ? "active" : "inactive",
    children: /* @__PURE__ */ v.jsx(zn, { iconKey: "thumbsDown", className: `${ye}-thumbs-down-icon` })
  }
)), Goe = Te(({ onClick: e, isActive: t }) => {
  const r = "Thanks for the feedback!", [i, n] = rt(!1), a = () => {
    e(), n(!0), setTimeout(() => void n(!1), 750);
  };
  return /* @__PURE__ */ v.jsxs(
    Ir,
    {
      positioning: { placement: "top-end" },
      open: i,
      closeOnPointerDown: !1,
      children: [
        /* @__PURE__ */ v.jsx(Ir.Trigger, { asChild: !0, children: /* @__PURE__ */ v.jsx(
          di,
          {
            px: 2,
            h: 8,
            minW: 8,
            variant: "iconButton",
            onClick: a,
            color: {
              _expanded: {
                base: "inkeepPrimary.stronger",
                _dark: "inkeepExpandedPrimary.300"
              }
            },
            className: `${ye}-thumbs-up__button`,
            "data-state": t ? "active" : "inactive",
            children: /* @__PURE__ */ v.jsx(
              zn,
              {
                iconKey: "thumbsUp",
                className: `${ye}-thumbs-up-icon`
              }
            )
          }
        ) }),
        /* @__PURE__ */ v.jsx(Gs, { children: /* @__PURE__ */ v.jsx(Ir.Positioner, { zIndex: "tooltip", children: /* @__PURE__ */ v.jsxs(Ir.Content, { fontSize: "sm", position: "relative", present: i, children: [
          /* @__PURE__ */ v.jsx(Ir.Arrow, { children: /* @__PURE__ */ v.jsx(Ir.ArrowTip, {}) }),
          r
        ] }) }) })
      ]
    }
  );
}), Koe = Te(
  ({
    showFeedbackModal: e,
    submitPositiveFeedback: t,
    feedback: r
  }) => /* @__PURE__ */ v.jsxs(mt, { align: "center", className: `${ye}-thumbs-up-down__wrapper`, children: [
    /* @__PURE__ */ v.jsx(Goe, { onClick: t, isActive: r === 1 }),
    /* @__PURE__ */ v.jsx(Woe, { onClick: e, isActive: r === -1 })
  ] })
);
function Yoe({
  ind: e,
  isHidden: t,
  setShowFeedbackModal: r,
  submitPositiveFeedback: i,
  feedback: n,
  handleCopyMessage: a,
  copyableMessage: o,
  supportEscalation: s
}) {
  return /* @__PURE__ */ v.jsxs(
    mt,
    {
      direction: "row",
      justifyContent: "space-between",
      alignItems: "center",
      mt: 2,
      mb: 3,
      opacity: t ? 0 : 1,
      visibility: t ? "hidden" : "visible",
      className: `${ye}-chat-bubble__message-actions`,
      children: [
        /* @__PURE__ */ v.jsx(mt, { align: "center", gap: 2, children: s }),
        /* @__PURE__ */ v.jsxs(mt, { align: "center", children: [
          /* @__PURE__ */ v.jsx(
            mt,
            {
              align: "center",
              className: `${ye}-chat-bubble__message-actions-copy`,
              children: /* @__PURE__ */ v.jsx(Voe, { onCopy: a, textToCopy: o })
            }
          ),
          /* @__PURE__ */ v.jsx(
            Koe,
            {
              submitPositiveFeedback: () => i && void i(e),
              showFeedbackModal: () => r && void r(e),
              feedback: n
            }
          )
        ] })
      ]
    }
  );
}
const a5 = We("\\[\\^(\\d+)(?:\\^)?\\]", "g");
function qoe(e, t, r) {
  return We.replace(e, a5, function(i, n, a, o, s) {
    const l = t[n], u = r[n];
    return u ? ` [(${l})](${u.url}) ` : ` [(${l})](URL_NOT_FOUND) `;
  });
}
function Qoe(e) {
  return We.replace(e, a5, function(t, r, i, n, a, o) {
    return `<sup><a href="#">${Number.parseInt(r, 10)}</a></sup>`;
  });
}
function Xoe(e) {
  const t = /(\[\^\d+][^\S\r\n]*)+/g;
  let r, i = "";
  for (; (r = t.exec(e)) !== null; ) {
    const n = r[0].replace(/[^\S\r\n]+/g, "");
    n === i ? (e = e.slice(0, r.index) + e.slice(t.lastIndex), t.lastIndex = r.index) : i = n;
  }
  return e;
}
const Zoe = (e) => e.reduce((t, r) => (t[r.url] = r, t), {}), Joe = (e) => e.reduce((t, r) => (t[r.citationNumber] = r, t), {}), ese = (e, t) => {
  const i = (e.match(a5) || []).map(
    (o) => Number.parseInt(We.replace(o, We("[^\\d]", "g"), ""))
  ), n = [...new Set(i)];
  return (t || []).filter(
    (o) => n.includes(o.citationNumber)
  ).map((o) => ({
    ...o,
    displayOrder: n.indexOf(o.citationNumber) + 1
  }));
}, tse = (e) => "ALL" in e, rse = (e) => "RecordType" in e, ise = (e) => "ContentType" in e, nse = (e) => "RootBreadcrumb" in e, ase = (e) => "AND" in e, ose = (e) => "OR" in e, sse = (e) => "NOT" in e, lse = (e) => "UrlMatch" in e;
function Wd(e, t) {
  const r = t.rootRecord.__typename;
  if (tse(e))
    return e.ALL;
  if (rse(e) && e.RecordType === r || ise(e) && r === "DocumentationRecord" && e.ContentType === t.rootRecord.contentType)
    return !0;
  if (nse(e) && r === "DocumentationRecord") {
    const i = t.rootRecord.pathBreadcrumbs ? t.rootRecord.pathBreadcrumbs[0] : void 0;
    if (e.RootBreadcrumb === i)
      return !0;
  }
  return lse(e) ? t.url ? _T({
    fullUrl: t.url,
    partialUrl: t.url,
    urlRule: e.UrlMatch
  }).matches : !1 : ase(e) ? e.AND.every(
    (i) => Wd(i, t)
  ) : ose(e) ? e.OR.some(
    (i) => Wd(i, t)
  ) : sse(e) ? !Wd(e.NOT, t) : !1;
}
const use = {
  searchTabLabel: "All",
  filters: { ALL: !0 }
}, cse = [
  {
    searchTabLabel: "Publications",
    filters: {
      AND: [{ RecordType: "DocumentationRecord" }, { ContentType: "book" }]
    },
    icon: { builtIn: "IoBookOutline" }
  },
  {
    searchTabLabel: "PDFs",
    filters: {
      AND: [{ RecordType: "DocumentationRecord" }, { ContentType: "pdf" }]
    },
    icon: { builtIn: "FaFilePdf" }
  },
  {
    filters: {
      OR: [
        { RecordType: "GitHubIssueRecord" },
        {
          UrlMatch: { partialUrl: "github.com", ruleType: "PartialUrl" }
        }
      ]
    },
    searchTabLabel: "GitHub",
    icon: { builtIn: "FaGithub" }
  },
  {
    filters: { RecordType: "DiscourseRecord" },
    searchTabLabel: "Forums",
    icon: { builtIn: "FaDiscourse" }
  },
  {
    filters: { RecordType: "DiscordRecord" },
    searchTabLabel: "Discord",
    icon: { builtIn: "FaDiscord" }
  },
  {
    searchTabLabel: "Slack",
    filters: { RecordType: "SlackEntry" },
    icon: { builtIn: "FaSlack" }
  },
  {
    filters: { RecordType: "StackOverflowRecord" },
    searchTabLabel: "Stack Overflow",
    icon: { builtIn: "FaStackOverflow" }
  }
];
function dse(e, t) {
  return t ? e.filter(
    (r) => !t.includes(r.searchTabLabel || "") && r.searchTabLabel
  ) : e;
}
const pse = (e, t) => e.reduce(
  (r, i, n) => r === null ? [i] : [
    ...r,
    ht.cloneElement(t, { key: `separator${n}` }),
    i
  ],
  // appending chevron and element ( > {el} )
  null
), Hs = ({
  str: e
}) => {
  if (e == null)
    return null;
  const t = /<em>(.*?)<\/em>/gs;
  let r;
  const i = [];
  let n = 0;
  for (; (r = t.exec(e)) !== null; ) {
    const [a, o] = r;
    r.index > n && i.push(e.slice(n, r.index)), i.push({ content: o, highlighted: !0 }), n = r.index + a.length;
  }
  return n < e.length && i.push(e.slice(n)), /* @__PURE__ */ v.jsx(
    Ct,
    {
      display: "inline",
      className: `${ye}-preview-content`,
      children: i.map((a, o) => typeof a == "string" ? a : /* @__PURE__ */ v.jsx(
        cn,
        {
          color: "inkeepPrimary.textSubtle",
          _dark: {
            color: "grayDark.50"
          },
          fontWeight: "semibold",
          className: `${ye}-preview-content__highlight`,
          children: a.content
        },
        `highlight-${o}`
      ))
    }
  );
};
function hse(e, t = !1) {
  if (e.split("```").length % 2 === 0)
    return e;
  const r = We(
    "\\[(?<title1>[^\\[\\]\\(\\)]+)\\]\\((?<url1>[^\\[\\]\\(\\)]+)\\)$"
  ), i = We(
    "\\[(?<title2>[^\\[\\]\\(\\)]+)\\]\\((?<url2>[^\\[\\]\\(\\)]+)?$"
  ), n = We("\\[(?<title3>[^\\[\\]\\(\\)]+)\\]$"), a = We("\\[(?<title4>[^\\[\\]\\(\\)]+)$"), o = We("\\[\\^(?<int>[0-9]+)\\^\\]$"), s = We("\\[\\^(?!([0-9]+)\\^\\])[^\\[\\]\\(\\)]*$");
  if (o.test(e))
    return e;
  if (s.test(e))
    return We.replace(e, s, "");
  if (!t) {
    if (r.test(e))
      return e;
    if (e.endsWith("["))
      return e.slice(0, -1);
    const l = We.exec(e, i), u = We.exec(e, n), d = We.exec(e, a);
    if (l != null && l.groups)
      return We.replace(e, i, l.groups.title2);
    if (u != null && u.groups)
      return We.replace(e, n, u.groups.title3);
    if (d != null && d.groups)
      return We.replace(e, a, d.groups.title4);
  }
  return e;
}
const Lf = (e) => e.replace(/(^\w+:|^)\/\//, "").replace(/^www\./, "").replace(/\/$/, ""), fse = (e, t) => {
  const r = e.split("/"), i = t.split("/"), n = r.indexOf(i[0]);
  return n === -1 ? [] : r.slice(n + i.length);
}, _T = ({
  fullUrl: e,
  partialUrl: t,
  urlRule: r
}) => {
  const i = { matches: !1 };
  if (!r)
    return i;
  const n = Lf(e), a = Lf(t);
  let o = "", s = 20;
  if (r.ruleType === "PartialUrl")
    o = Lf(r.partialUrl), s = r.maxNChildSubpaths ?? 20;
  else if (r.ruleType === "SubpathOnly") {
    const d = new URL(e);
    o = Lf(
      `${d.protocol}//${d.host}/${r.subpath}`
    );
  }
  const l = a.startsWith(o), u = fse(n, o);
  return l && u.length <= s && u.length >= 0 ? {
    matches: !0,
    remainingChildPaths: u
  } : i;
}, jx = ({
  fullUrl: e,
  partialPath: t,
  urlToBreadcrumbMapper: r
}) => {
  const i = { breadcrumbName: null, replaceLeading: !1 };
  if (!r)
    return i;
  const n = [...r].reverse();
  for (const a of n)
    if (_T({
      fullUrl: e,
      partialUrl: t,
      urlRule: a.matchingRule
    }).matches) {
      const s = a.replaceLeading || !1;
      return { breadcrumbName: a.breadcrumbName, replaceLeading: s };
    }
  return i;
};
function gse(e) {
  const t = new URL(e), r = t.hostname, i = t.pathname.slice(1).split("/").filter((n) => n !== "");
  return { domain: r, subpaths: i };
}
const DT = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase(), mse = (e) => {
  const t = e.split(/[ _~-]/);
  return t.map(
    (r, i) => oA.includes(r) && i !== 0 && i !== t.length - 1 ? r.toLowerCase() : DT(r)
  ).join(" ");
}, vse = (e, t) => t ? e.map(
  (r) => aA({
    input: r,
    stringReplacementRules: t,
    applyRulePredicate: (i) => i.replaceInBreadCrumbs !== !1
  })
).filter((r) => !!r) : e, kse = (e, t) => {
  switch (t) {
    case "UPPER_CASE":
      return DT(e);
    case "LOWER_CASE":
      return e.toLowerCase();
    default:
      return e;
  }
}, bse = (e, t, r) => {
  const n = e.rootRecord.pathBreadcrumbs, a = n && n.length > 0;
  let o = a ? [...n] : _se(e, t);
  if (t.prependBreadcrumbs)
    for (const l of t.prependBreadcrumbs)
      Wd(l.matchingRule, e) && o.unshift(l.breadcrumbToPrepend);
  o.at(-1) == e.title && (o = o.slice(0, -1));
  const s = t.style || "TITLE_CASE";
  return s !== "TITLE_CASE" && o.map((l) => kse(l, s)), o = a ? o : vse(o, r), o;
}, _se = (e, t) => {
  var u;
  if (e.__typename !== "DocumentationHit")
    return [];
  const r = t || F1.breadcrumbRules, { url: i } = e;
  if (!i)
    return [];
  const { domain: n, subpaths: a } = gse(i);
  let o = [], s = n;
  const { breadcrumbName: l } = jx({
    fullUrl: i,
    partialPath: s,
    urlToBreadcrumbMapper: r.urlToBreadcrumbMapper
  });
  l && o.push(l);
  for (let d = 0; d < a.length; d += 1) {
    s += `/${a[d]}`;
    let c = (u = r.urlToBreadcrumbMapper) == null ? void 0 : u.slice().map((g) => g.matchingRule.ruleType === "PartialUrl" ? {
      ...g,
      matchingRule: {
        ...g.matchingRule,
        maxNChildSubpaths: 0
      }
    } : g);
    const { breadcrumbName: p, replaceLeading: f } = jx({
      fullUrl: s,
      partialPath: s,
      urlToBreadcrumbMapper: c
    });
    p ? f ? o = [p] : o.push(p) : d !== a.length - 1 && o.push(mse(a[d]));
  }
  return o;
}, Dse = (e, t) => {
  if (e.__typename !== "DocumentationHit")
    return [];
  const r = e.rootRecord;
  if (!r.pathBreadcrumbs || r.pathBreadcrumbs.length === 0)
    return [];
  let i = r.pathBreadcrumbs;
  return i[0] == t && (i = i.slice(1)), i.map((a, o) => /* @__PURE__ */ v.jsx(
    Hs,
    {
      str: a
    },
    a + o.toString()
  ));
}, yse = (e, t) => e.length === t.length && e.every((r, i) => r === t[i]);
function yT({
  hits: e,
  breadcrumbRules: t,
  stringReplacementRules: r
}) {
  return e.map((i) => {
    var c;
    const { title: n } = i, a = (c = i.rootRecord) == null ? void 0 : c.title, o = fE({ title: n, stringReplacementRules: r }), s = fE({ title: n, stringReplacementRules: r }), l = o !== n, u = s !== a, d = { ...i };
    if (i && i.__typename === "DocumentationHit") {
      const p = d.rootRecord, f = bse(
        i,
        t,
        r
      );
      !yse(
        p.pathBreadcrumbs || [],
        f
      ) && (d.rootRecord = { ...p, pathBreadcrumbs: f });
    }
    return l && (d.title = o), i.rootRecord && "title" in i.rootRecord && u && (d.rootRecord = { ...d.rootRecord, title: s }), d;
  });
}
const Ese = ({
  isTop: e,
  isBottom: t
}) => {
  const r = { base: "white", _dark: "grayDark.900" };
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(
      Ct,
      {
        position: "absolute",
        top: "0",
        left: "0",
        right: "0",
        height: "10",
        bgGradient: "to-b",
        gradientFrom: r,
        gradientTo: "transparent",
        opacity: e ? "0 !important" : 1,
        zIndex: "1",
        className: `${ye}-scroll-shadow-top`,
        pointerEvents: "none"
      }
    ),
    /* @__PURE__ */ v.jsx(
      Ct,
      {
        position: "absolute",
        bottom: "0",
        left: "0",
        right: "0",
        height: "10",
        bgGradient: "to-t",
        gradientFrom: r,
        gradientTo: "transparent",
        opacity: t ? "0 !important" : 1,
        zIndex: "1",
        className: `${ye}-scroll-shadow-bottom`,
        pointerEvents: "none"
      }
    )
  ] });
}, ET = {
  base: "rgb(200 200 200 / .4)",
  _dark: "rgb(56 56 56 / .7)"
}, Hx = `inset 0 8px 10px -7px ${ET}`, $x = `inset 0 -8px 10px -7px ${ET}`;
function Cse(e) {
  const [t, r] = rt(!1), [i, n] = rt(!1), [a, o] = rt("none"), s = qt({
    scrollTop: 0,
    scrollHeight: 0,
    clientHeight: 0
  }), l = (p) => {
    p.target instanceof Element && (s.current.scrollTop = p.target.scrollTop, s.current.scrollHeight = p.target.scrollHeight, s.current.clientHeight = p.target.clientHeight, u());
  };
  gt(() => {
    e.current && (s.current.scrollTop = e.current.scrollTop, s.current.scrollHeight = e.current.scrollHeight, s.current.clientHeight = e.current.clientHeight, u());
  }, [e]);
  const u = () => {
    const { scrollTop: p, scrollHeight: f, clientHeight: g } = s.current, k = 10, y = g + p, _ = p === 0, A = y + k >= f, T = !_ && !A, N = f > g;
    let P = "none";
    if (!g || !f || f == g) {
      o(P), r(_), n(A);
      return;
    }
    N && _ ? P = $x : T ? P = `${Hx}, ${$x}` : A && (P = Hx), P !== a && o(P), _ !== t && r(_), A !== i && n(A);
  };
  return { boxShadow: a, onScrollHandler: l, triggerLoading: () => {
    const { current: p } = e;
    p && (s.current.scrollTop = p.scrollTop, s.current.scrollHeight = p.scrollHeight, s.current.clientHeight = p.clientHeight, u());
  }, Shadows: /* @__PURE__ */ v.jsx(Ese, { isTop: t, isBottom: i }) };
}
const xse = 25, Ase = ({
  tabOrderByLabel: e,
  tabLabels: t,
  rootBreadcrumbsAsTabs: r,
  alwaysDisplayedTabs: i
}) => {
  const n = [
    .../* @__PURE__ */ new Set([...i, ...r])
  ], a = e || n, o = a.filter(
    (u) => t.includes(u)
  ), s = t.filter(
    (u) => !a.includes(u)
  );
  return [.../* @__PURE__ */ new Set([...o, ...s])];
}, wse = (e) => e.map((t) => ({
  searchTabLabel: t,
  filters: { RootBreadcrumb: t },
  builtInIcon: "LuBookOpen"
})), Fse = (e) => e.map((t) => ({
  searchTabLabel: t,
  filters: { ALL: !1 },
  builtInIcon: "LuBookOpen"
})), Tse = (e) => {
  const t = Object.values(e).map(
    (i) => i && i.length > 0 ? i[0] : null
  );
  return [...new Set(t)].filter(
    Boolean
  );
}, CT = () => {
  try {
    const e = nc().tabSettings;
    let t = [], r = !0;
    return e && (e.alwaysDisplayedTabs ? t = [...e.alwaysDisplayedTabs] : e.rootBreadcrumbsToUseAsTabs && (t = [...e.rootBreadcrumbsToUseAsTabs]), e.isAllTabEnabled !== void 0 && (r = e.isAllTabEnabled), r && !t.includes("All") && t.unshift("All")), {
      ...l1.tabSettings,
      ...e,
      alwaysDisplayedTabs: t,
      isAllTabEnabled: r
    };
  } catch (e) {
    if (e instanceof Error)
      return {
        ...l1.tabSettings,
        alwaysDisplayedTabs: []
      };
    throw e;
  }
}, xT = (e = []) => {
  const {
    isAllTabEnabled: t = !0,
    rootBreadcrumbsToUseAsTabs: r,
    tabOrderByLabel: i,
    disabledDefaultTabs: n,
    alwaysDisplayedTabs: a
  } = CT(), { customCardSettings: o } = Xi(), s = e.length > 0 ? [
    e[0].id,
    e[e.length - 1].id,
    e.length
  ].join("-") : "no-search-results", l = Jt(
    () => e.filter(
      (p) => p.__typename === "DocumentationHit"
    ),
    [s]
  ), u = Jt(() => {
    if (r && r.length > 0) {
      const p = l.reduce((g, k) => {
        const y = k.rootRecord;
        return y.pathBreadcrumbs && y.pathBreadcrumbs.length > 0 && (g[k.id] = y.pathBreadcrumbs), g;
      }, {});
      return Tse(
        p
      ).filter(
        (g) => r.includes(g)
      );
    }
    return [];
  }, [r, s]), [d, c] = rt({
    tabLabels: [],
    searchResultIconsMap: {},
    searchResultsByTab: {},
    countsByTab: {}
  });
  return gt(() => {
    const p = wse(
      u
    ), g = dse(
      [
        ...o ?? [],
        ...p,
        ...cse
      ],
      n
    ), k = g.map(
      (U) => U.searchTabLabel
    ), y = Fse(
      (a == null ? void 0 : a.filter(
        (U) => !k.includes(U) && U !== "All"
      )) || []
    ), _ = [
      ...t ? [use] : [],
      ...y,
      ...g
    ], A = _.map(
      (U) => U.searchTabLabel
    ), T = Ase({
      tabOrderByLabel: i,
      tabLabels: A,
      rootBreadcrumbsAsTabs: u,
      alwaysDisplayedTabs: a || []
    });
    _.sort(
      (U, K) => T.indexOf(U.searchTabLabel) - T.indexOf(K.searchTabLabel)
    );
    const N = /* @__PURE__ */ new Set(), P = [];
    for (const U of _)
      U.searchTabLabel && !N.has(U.searchTabLabel) && (N.add(U.searchTabLabel), P.push(U));
    const B = {}, M = {};
    P.forEach((U) => {
      if (U.searchTabLabel) {
        const K = e.filter((z) => Wd(U.filters, z)).slice(0, xse);
        B[U.searchTabLabel] = K, M[U.searchTabLabel] = K.length;
      }
    });
    const X = {};
    e.forEach((U) => {
      let K = {
        builtIn: "LuBookOpen"
      };
      for (const z of [
        ...P
      ].reverse())
        if (Wd(z.filters, U) && z.icon) {
          K = z.icon;
          break;
        }
      X[U.id] = K;
    }), c({
      tabLabels: P.map(
        (U) => U.searchTabLabel
      ),
      searchResultIconsMap: X,
      searchResultsByTab: B,
      countsByTab: M
    });
  }, [
    t,
    i,
    u,
    o,
    s
  ]), d;
}, Ux = (e) => {
  try {
    const t = new URL(e);
    return t.origin + t.pathname;
  } catch (t) {
    return console.error("Invalid URL:", t), null;
  }
};
function Sse(e) {
  if (typeof window > "u")
    return null;
  const t = Ux(window.location.href), r = Ux(e);
  return !t || !r ? null : t === r;
}
const W_ = new EventTarget(), Ise = (e) => {
  const {
    newTab: t,
    url: r,
    index: i,
    content: n,
    isFocused: a,
    focusResult: o,
    selfContainedFocus: s,
    verticallyCondensed: l = !1,
    openLink: u = !0,
    onClick: d,
    query: c,
    searchQueryParamKey: p
  } = e, [f, g] = rt(!1), k = s ? f : a, y = ht.useRef(null), _ = tT() ? "auto" : "smooth";
  ht.useEffect(() => {
    a && y.current && y.current.scrollIntoView({
      behavior: _,
      block: "nearest"
    });
  }, [a, _]), ht.useEffect(() => {
    const T = (N) => {
      var P;
      N.detail.focusedItem === i && a && ((P = y.current) == null || P.click());
    };
    return W_.addEventListener("open-result-card", T), () => {
      W_.removeEventListener("open-result-card", T);
    };
  }, [i, d]);
  const A = p && c ? { [p]: c } : void 0;
  return /* @__PURE__ */ v.jsx(
    Yg,
    {
      ref: y,
      onClick: d,
      onMouseMove: () => {
        g(!0), o == null || o();
      },
      onMouseLeave: () => {
        g(!1);
      },
      href: r && u ? r : void 0,
      target: r && u && t ? "_blank" : "",
      _hover: {
        textDecoration: "none"
      },
      width: "100%",
      className: `group ${ye}-result-card ${k ? `${ye}-result-card--focused` : ""}`,
      borderRadius: "lg",
      additionalQueryParams: A,
      children: /* @__PURE__ */ v.jsx(
        jy,
        {
          overflow: "hidden",
          borderWidth: "1px",
          borderRadius: "lg",
          color: k ? "inkeepPrimary.strong" : "inkeepPrimary.textBold",
          backgroundColor: k ? "inkeepPrimary.lightSubtle" : "white",
          borderColor: k ? "inkeepPrimary.mediumSubtle" : "gray.300",
          _dark: {
            color: k ? "inkeepExpandedPrimary.300" : "whiteAlpha.800",
            backgroundColor: k ? "whiteAlpha.200" : "transparent",
            borderColor: k ? "inkeepExpandedPrimary.300" : "whiteAlpha.300"
          },
          _groupFocus: {
            borderColor: "inkeepPrimary.mediumSubtle",
            backgroundColor: "inkeepPrimary.lightSubtle",
            color: "inkeepPrimary.strong",
            _dark: {
              borderColor: "inkeepExpandedPrimary.300",
              backgroundColor: "whiteAlpha.200",
              color: "inkeepExpandedPrimary.300"
            }
          },
          _hover: {
            cursor: "pointer",
            textDecoration: "none"
          },
          variant: "unstyled",
          px: 5,
          className: `${ye}-result-card__container ${k ? `${ye}-result-card__container--focused` : ""}`,
          children: /* @__PURE__ */ v.jsx(jy.Body, { py: 2, className: `${ye}-result-card__body`, children: /* @__PURE__ */ v.jsxs(
            mt,
            {
              justifyContent: "space-between",
              alignItems: "center",
              flexGrow: 5,
              alignContent: "stretch",
              className: `${ye}-result-card__content`,
              children: [
                n,
                /* @__PURE__ */ v.jsx(
                  m8,
                  {
                    flexShrink: 0,
                    alignSelf: "center",
                    className: `${ye}-result-card__hover-icon`,
                    children: k && /* @__PURE__ */ v.jsx(
                      zn,
                      {
                        className: t ? `${ye}-open-link-in-new-tab-icon` : `${ye}-open-link-in-same-tab-icon`,
                        iconKey: t ? "openLinkInNewTab" : "openLinkInSameTab",
                        w: 4,
                        h: 4
                      }
                    )
                  }
                )
              ]
            }
          ) })
        }
      )
    }
  );
}, Bse = Ise, Rse = () => {
  const e = ia(
    Nr.var("colors.gray.100"),
    Nr.var("colors.whiteAlpha.100")
  ), t = ia(
    Nr.var("colors.gray.300"),
    Nr.var("colors.whiteAlpha.300")
  );
  return /* @__PURE__ */ v.jsx(
    bo,
    {
      display: "block",
      position: "relative",
      width: "100%",
      children: Array.apply(null, Array.from({ length: 3 })).map((r, i) => /* @__PURE__ */ v.jsx(mt, { paddingBottom: 2.5, alignItems: "center", width: "100%", children: /* @__PURE__ */ v.jsx(
        Uf,
        {
          flexGrow: 1,
          startColor: e,
          endColor: t,
          height: 20,
          borderRadius: "lg"
        }
      ) }, i))
    }
  );
}, Ose = Rse, Pse = ({
  isFocused: e,
  main: t,
  auxillary: r,
  overides: i,
  verticallyCondensed: n,
  hasSecondLine: a = !1
}) => /* @__PURE__ */ v.jsxs(
  mt,
  {
    lineHeight: [n ? "short" : "base"],
    className: `${ye}-search-result-line__first`,
    children: [
      /* @__PURE__ */ v.jsx(
        cn,
        {
          _light: {
            color: e ? "inkeepPrimary.textBold" : "gray.800"
          },
          _dark: {
            color: e ? "white" : "whiteAlpha.900"
          },
          _groupHover: {
            color: "inkeepPrimary.textBold",
            _dark: {
              color: "whiteAlpha.900"
            }
          },
          fontWeight: "medium",
          noOfLines: 1,
          fontSize: n ? "sm" : "md",
          flexShrink: 1,
          ...i,
          children: t
        }
      ),
      /* @__PURE__ */ v.jsx(Tl, { marginLeft: 3, flexGrow: 0, marginRight: 3, overflow: "hidden", children: r })
    ]
  }
), Vx = ({
  main: e,
  isFocused: t,
  verticallyCondensed: r,
  ...i
}) => /* @__PURE__ */ v.jsx(
  cn,
  {
    lineHeight: "base",
    _light: {
      color: "gray.700"
    },
    _dark: {
      color: "whiteAlpha.700"
    },
    fontSize: r ? "xs" : "sm",
    fontWeight: "normal",
    noOfLines: 1,
    className: `${ye}-search-result-line__second`,
    ...i,
    children: e
  }
), Nse = ({
  isFocused: e = !1,
  verticallyCondensed: t = !1,
  icon: r,
  content: i,
  reverseLines: n
}) => {
  var a, o;
  return /* @__PURE__ */ v.jsxs(
    bo,
    {
      gap: (a = i.third) != null && a.main ? 0.5 : 0,
      minWidth: 0,
      overflow: "hidden",
      py: "0.5",
      children: [
        /* @__PURE__ */ v.jsxs(
          bo,
          {
            gap: (o = i.first) != null && o.hasSecondLine ? 1 : 0,
            overflow: "hidden",
            "data-reversed": n ? "" : void 0,
            css: {
              "&[data-reversed]": {
                flexDirection: "column-reverse"
              }
            },
            children: [
              /* @__PURE__ */ v.jsxs(mt, { gap: "3", align: "center", children: [
                /* @__PURE__ */ v.jsx(
                  mt,
                  {
                    align: "center",
                    _light: {
                      color: e ? "inkeepPrimary.textSubtle" : "gray.600"
                    },
                    _dark: {
                      color: e ? "grayDark.100" : "grayDark.300"
                    },
                    _groupHover: {
                      color: "inkeepPrimary.textSubtle",
                      _dark: {
                        color: "grayDark.100"
                      }
                    },
                    className: `${ye}-result-card__icon`,
                    children: /* @__PURE__ */ v.jsx(cp, { width: "16px", minH: "16px", iconSettings: r })
                  }
                ),
                /* @__PURE__ */ v.jsx(
                  Pse,
                  {
                    isFocused: e,
                    verticallyCondensed: t,
                    ...i.first
                  }
                )
              ] }),
              /* @__PURE__ */ v.jsx(
                Vx,
                {
                  isFocused: e,
                  verticallyCondensed: t,
                  fontSize: "13px",
                  _light: {
                    color: "gray.600"
                  },
                  _dark: {
                    color: "whiteAlpha.600"
                  },
                  ...i.second
                }
              )
            ]
          }
        ),
        i.third && /* @__PURE__ */ v.jsx(
          Vx,
          {
            isFocused: e,
            verticallyCondensed: t,
            ...i.third
          }
        )
      ]
    }
  );
}, Zm = Nse, zse = ({
  searchResult: e,
  isFocused: t = !1,
  verticallyCondensed: r = !1,
  icon: i
}) => (
  // log('---Discourse result---');
  // log(ParseStrWithHighlight(searchResult.previewContent, isFocused));
  // log(searchResult.previewContent);
  /* @__PURE__ */ v.jsx(
    Zm,
    {
      isFocused: t,
      verticallyCondensed: r,
      icon: i,
      content: {
        first: {
          main: /* @__PURE__ */ v.jsx(Hs, { str: e.title })
        },
        second: {
          main: /* @__PURE__ */ v.jsx(
            Hs,
            {
              str: e.rootRecord.body
            }
          )
        }
      }
    }
  )
), Lse = zse, Mse = () => /* @__PURE__ */ v.jsx(
  zn,
  {
    iconKey: "breadcrumbSeparator",
    mx: "5px",
    fontSize: ".45rem",
    position: "relative",
    transform: "translateY(-1px)",
    className: `${ye}-bread-crumb-separator`
  }
), Wx = (e) => {
  const t = /(https?:\/\/\S+)/g;
  return e.replace(t, (r) => {
    const i = r.split("/");
    return i.length > 3 ? `...${i.slice(-2).join("/")}` : r;
  });
}, jse = (e, t) => {
  const r = e.trim(), i = `<em>${r}</em>`;
  return t.startsWith(r) ? t.slice(r.length).trim() : t.startsWith(i) ? t.slice(i.length).trim() : t;
}, Hse = ({
  searchResult: e,
  isFocused: t = !1,
  verticallyCondensed: r = !1,
  tabLabel: i,
  icon: n
}) => {
  var A, T, N, P;
  const a = Dse(
    e,
    i
  ), o = Wx(
    ((T = (A = e.pathHeadings) == null ? void 0 : A.at(-1)) == null ? void 0 : T.content) || ""
  ), s = Wx(
    ((N = e.content) == null ? void 0 : N.content) || ""
  ), { title: l, preview: u } = e, d = (a == null ? void 0 : a.length) > 0 ? a[a.length - 1] : null, c = d ? (P = d == null ? void 0 : d.props) == null ? void 0 : P.str : null, p = l || c || null, f = u || s || o || null, g = Jt(() => p && f ? jse(p, f) : f, [p, f]), k = p ? /* @__PURE__ */ v.jsx(Hs, { str: p }) : null, y = g ? /* @__PURE__ */ v.jsx(Hs, { str: g }) : null, _ = /* @__PURE__ */ v.jsx(Ct, { display: "inline", alignItems: "baseline", children: pse(
    a.slice(
      Math.max(0, a.length - 3),
      a.length
    ),
    /* @__PURE__ */ v.jsx(Mse, {})
  ) });
  return /* @__PURE__ */ v.jsx(
    Zm,
    {
      isFocused: t,
      verticallyCondensed: r,
      reverseLines: a && a.length > 0,
      icon: n,
      content: {
        first: {
          main: k,
          hasSecondLine: a && a.length > 0
        },
        second: {
          main: _
        },
        third: {
          main: y
        }
      }
    }
  );
}, $se = Hse, Use = ({
  searchResult: e,
  isFocused: t = !1,
  verticallyCondensed: r = !1,
  icon: i
}) => {
  const n = /* @__PURE__ */ v.jsx(
    Z8,
    {
      flexGrow: 1,
      colorPalette: "purple",
      variant: "outline",
      children: "Closed"
    }
  ), a = /* @__PURE__ */ v.jsx(Hs, { str: e.title }), o = e.rootRecord.body;
  return /* @__PURE__ */ v.jsx(
    Zm,
    {
      isFocused: t,
      verticallyCondensed: r,
      icon: i,
      content: {
        first: {
          main: /* @__PURE__ */ v.jsx(v.Fragment, { children: a }),
          auxillary: e.rootRecord.state === N6.Closed ? n : void 0
        },
        second: {
          main: /* @__PURE__ */ v.jsx(Hs, { str: o })
        }
      }
    }
  );
}, Vse = Use, Gx = (e) => {
  if (typeof e != "string")
    return console.error("removeHTMLTags: input must be a string"), "";
  const t = We("(<([^>]+)>)", "gi");
  return We.replace(e, t, "");
}, Wse = ({
  searchResult: e,
  isFocused: t = !1,
  verticallyCondensed: r,
  icon: i
}) => {
  const n = e.rootRecord.markedAsCorrectAnswer && /* @__PURE__ */ v.jsx(Z8, { colorPalette: "green", variant: "outline", children: "Resolved" }), a = e.rootRecord.body;
  return /* @__PURE__ */ v.jsx(
    Zm,
    {
      isFocused: t,
      verticallyCondensed: r,
      icon: i,
      content: {
        first: {
          main: /* @__PURE__ */ v.jsx(
            Hs,
            {
              str: Gx(e.title || "")
            }
          ),
          auxillary: n || null
        },
        second: {
          main: /* @__PURE__ */ v.jsx(
            Hs,
            {
              str: Gx(a || "")
            }
          )
        }
      }
    }
  );
}, Gse = Wse, Kse = (e) => {
  x1(Cae), x1(xae);
  const {
    showLoading: t = !1,
    searchResults: r,
    activeTab: i,
    isAllTab: n,
    tabLabel: a,
    spaceBetweenResults: o,
    verticallyCondensed: s,
    openLink: l,
    selfContainedFocusForCards: u,
    shouldOpenLinksInNewTab: d = !1,
    onClose: c,
    focusedItem: p,
    setFocusedItem: f,
    showShadows: g = !0,
    messageId: k,
    chatSessionId: y,
    query: _,
    searchQueryParamKey: A
  } = e, { searchResultIconsMap: T } = xT(r), N = la(), P = qt(null), { boxShadow: B, onScrollHandler: M, triggerLoading: X, Shadows: U } = Cse(P);
  gt(() => {
    !t && i && X();
  }, [t, i]);
  const K = (z, j) => {
    const J = T[z.id];
    switch (z.__typename) {
      case "DocumentationHit":
        return /* @__PURE__ */ v.jsx(
          $se,
          {
            isFocused: j,
            searchResult: z,
            verticallyCondensed: s,
            tabLabel: a,
            icon: J
          },
          z.rootRecord.id
        );
      case "GitHubIssueHit":
        return /* @__PURE__ */ v.jsx(
          Vse,
          {
            isFocused: j,
            searchResult: z,
            verticallyCondensed: s,
            icon: J
          },
          z.rootRecord.id
        );
      case "StackOverflowHit":
        return /* @__PURE__ */ v.jsx(
          Gse,
          {
            isFocused: j,
            searchResult: z,
            verticallyCondensed: s,
            icon: J
          },
          z.rootRecord.id
        );
      case "DiscourseHit":
        return /* @__PURE__ */ v.jsx(
          Lse,
          {
            isFocused: j,
            searchResult: z,
            verticallyCondensed: s,
            icon: J
          },
          z.rootRecord.id
        );
      default:
        return /* @__PURE__ */ v.jsx(v.Fragment, {});
    }
  };
  return i ? !t && r.length === 0 ? /* @__PURE__ */ v.jsx(
    mt,
    {
      direction: "row",
      width: "100%",
      height: "100%",
      overflow: "hidden",
      position: "relative",
      flexGrow: 2,
      alignItems: "center",
      justifyContent: "center",
      _light: {
        color: "gray.600"
      },
      _dark: {
        color: "grayDark.400"
      },
      mt: 8,
      children: /* @__PURE__ */ v.jsx("span", { children: "No results found." })
    }
  ) : /* @__PURE__ */ v.jsxs(Ct, { height: "100%", width: "100%", position: "relative", children: [
    !t && g && U,
    /* @__PURE__ */ v.jsx(n5, { onScroll: M, style: { height: "100%" }, children: /* @__PURE__ */ v.jsx(
      S1,
      {
        w: "100%",
        ref: P,
        gap: o || void 0,
        alignContent: "center",
        position: "relative",
        flexShrink: 0,
        height: "100%",
        px: s ? 0 : 5,
        py: "1px",
        my: "-1px",
        minW: 0,
        children: t ? /* @__PURE__ */ v.jsx(Ose, {}) : r.map((z, j) => {
          const { url: J } = z, ie = J ? Sse(J) : !1, ue = k && y ? {
            eventName: "chat_response_citation_clicked",
            properties: {
              chatSessionId: y,
              messageId: k,
              citationType: "CARD",
              title: (z == null ? void 0 : z.title) || void 0,
              url: J || ""
            }
          } : {
            eventName: "search_result_clicked",
            properties: {
              query: _ || "",
              title: (z == null ? void 0 : z.title) || void 0,
              url: J || ""
            }
          };
          return /* @__PURE__ */ v.jsx(
            Bse,
            {
              index: j,
              url: J || "",
              newTab: d,
              isFocused: j === p,
              focusResult: () => f == null ? void 0 : f(j),
              selfContainedFocus: u,
              content: K(
                z,
                j === p
              ),
              verticallyCondensed: s,
              openLink: l,
              onClick: () => {
                ue && N.capture(ue), ie && !d && (c == null || c());
              },
              query: _,
              searchQueryParamKey: A
            },
            `resultCard${z.rootRecord.id}`
          );
        })
      }
    ) })
  ] }) : /* @__PURE__ */ v.jsx(v.Fragment, {});
}, AT = Kse, Yse = ts`
  query GetSearchRootRecords($ids: [ID!]!) {
    getSearchRootRecords(ids: $ids) {
      __typename
      id
      title
      url
      preview
      ... on DocumentationRecord {
        pathBreadcrumbs
        contentType
      }
      ... on GitHubIssueRecord {
        body
        state
        createdAt
      }
      ... on DiscourseRecord {
        body
        categoryBreadcrumbs
        createdAt
      }
      ... on StackOverflowRecord {
        body
        tags
        createdAt
      }
    }
  }
`, qse = (e) => e.split("#")[0], Qse = (e) => {
  const t = /* @__PURE__ */ new Set();
  return e.filter((r) => r.url && !t.has(r.url) ? (t.add(r.url), !0) : !1);
}, Xse = (e, t) => e.filter(
  (r) => t.hasOwnProperty(
    r.citationNumber.toString()
  )
), Zse = (e) => {
  const t = /* @__PURE__ */ new Map();
  return e.forEach((r) => {
    const i = qse(r.url);
    t.has(i) ? t.get(i).push(r) : t.set(i, [r]);
  }), t;
}, Jse = (e, t) => t.map(
  (r) => e.find(
    (i) => i.rootRecord.id === r.rootRecordId
  )
).filter((r) => r !== void 0), ele = (e, t, r) => e.map(
  (i) => (
    // turning off for now, like Discord. Will add once we have proper citations.
    // if (searchResult.url) {
    //   const trimmedUrl = urlTrimmer(searchResult.url);
    //   const citations = trimmedUrlToCitationsMap.get(trimmedUrl);
    //   if (citations && citations.length > 0) {
    //     const citationNumbers = citations
    //       .map((citation) => citationNumberToDisplayOrderMap[citation.citationNumber])
    //       .join(", ");
    //     return {
    //       ...searchResult,
    //       title: `${citationNumbers}. ${searchResult.title}`,
    //     };
    //   }
    // }
    i
  )
), tle = ({
  citations: e,
  citationNumberToDisplayOrderMap: t,
  isHidden: r = !1,
  isLast: i = !1,
  setCitationsLoaded: n,
  citationsLoaded: a,
  messageId: o,
  chatSessionId: s
}) => {
  const { log: l } = dn(), u = Xse(
    e,
    t
  ), d = u.sort((B, M) => {
    const X = t[B.citationNumber], U = t[M.citationNumber];
    return Number.parseInt(X) - Number.parseInt(U);
  }), c = Jt(
    () => e.filter(
      (B) => B.rootRecordId !== null && B.rootRecordId !== void 0
    ).map((B) => B.rootRecordId),
    [e]
  ), [p, { loading: f, data: g, error: k }] = Iq(Yse);
  gt(() => {
    c.length > 0 && p({ variables: { ids: c } });
  }, [c]), gt(() => {
    (!f && !k && (g != null && g.getSearchRootRecords) && !r || c.length === 0) && !a && n(!0);
  }, [g, f, k, r, c, a]), gt(() => (l("CitationCards mounted"), () => {
    l("unmounting CitationCards");
  }), []);
  const y = Jt(() => {
    var B;
    return g != null && g.getSearchRootRecords ? ((B = g == null ? void 0 : g.getSearchRootRecords) == null ? void 0 : B.map((M) => {
      let X;
      switch (M.__typename) {
        case "DocumentationRecord":
          X = "DocumentationHit";
          break;
        case "GitHubIssueRecord":
          X = "GitHubIssueHit";
          break;
        case "DiscourseRecord":
          X = "DiscourseHit";
          break;
        case "StackOverflowRecord":
          X = "StackOverflowHit";
          break;
        default:
          return l("Unknown record type: ", M), {};
      }
      return {
        __typename: X,
        id: M.id,
        rootRecord: M,
        hitOnRoot: !0,
        url: M.url,
        title: M.title,
        preview: M.preview
      };
    })) ?? [] : [];
  }, [c, !!g]);
  Zse(u);
  const _ = ele(
    y
  );
  let A = Jse(
    _,
    d
  );
  const { shouldOpenLinksInNewTab: T } = Qr(), { stringReplacementRules: N, breadcrumbRules: P = {} } = Xi();
  return A = yT({
    hits: Qse(A),
    breadcrumbRules: P,
    stringReplacementRules: N
  }), A && A.length > 0 ? /* @__PURE__ */ v.jsxs(Ct, { display: r ? "none" : "block", children: [
    /* @__PURE__ */ v.jsx(
      cn,
      {
        display: "block",
        fontSize: { base: "xs" },
        fontWeight: "medium",
        marginBottom: 2,
        marginTop: 2,
        _light: { color: "gray.700" },
        _dark: { color: "grayDark.300" },
        className: `${ye}-citation-sources-header`,
        children: "Sources"
      }
    ),
    /* @__PURE__ */ v.jsx(
      AT,
      {
        searchResults: A,
        showLoading: !1,
        isAllTab: !0,
        activeTab: !0,
        spaceBetweenResults: 3,
        selfContainedFocusForCards: !0,
        verticallyCondensed: !0,
        shouldOpenLinksInNewTab: T,
        showShadows: !1,
        messageId: o,
        chatSessionId: s
      }
    )
  ] }) : null;
}, rle = tle, ile = [
  Nr.var("colors.gray.300"),
  Nr.var("colors.gray.400"),
  Nr.var("colors.gray.500")
], nle = [
  Nr.var("colors.grayDark.700"),
  Nr.var("colors.grayDark.400"),
  Nr.var("colors.grayDark.200")
], Kx = "--loading-bg-color", ale = () => {
  const [e, t] = rt([1, 2, 0, 0, 0, 0, 0, 0]), [r, i] = rt("");
  gt(() => {
    const o = [
      { text: "Understanding question", timeout: 1750 },
      { text: "Looking for relevant content", timeout: 2e3 },
      { text: "Analyzing", timeout: -1 }
    ];
    let s = 0;
    const l = () => {
      i(o[s].text), o[s].timeout !== -1 && setTimeout(() => {
        s++, s < o.length && l();
      }, o[s].timeout);
    };
    l();
  }, []);
  const n = 60;
  gt(() => {
    const o = [
      [1, 2, 0, 0, 0, 0],
      [0, 1, 0, 2, 0, 0],
      [0, 0, 0, 1, 0, 2],
      [0, 0, 0, 0, 2, 1],
      [0, 0, 2, 0, 1, 0],
      [2, 0, 1, 0, 0, 0]
    ];
    let s = 0;
    const l = setInterval(() => {
      t(o[s]), s++, s >= o.length && (s = 0);
    }, n);
    return () => void clearInterval(l);
  }, []);
  const a = ia(ile, nle);
  return /* @__PURE__ */ v.jsxs(Tl, { gap: 3, height: "48px", alignItems: "center", children: [
    /* @__PURE__ */ v.jsx(
      Ct,
      {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        columnGap: 1,
        rowGap: 1,
        className: `${ye}-loading__dots`,
        children: e.map((o, s) => /* @__PURE__ */ v.jsx(
          cn,
          {
            width: 1,
            height: 1,
            borderRadius: "full",
            backgroundColor: `var(${Kx})`,
            style: { [Kx]: a[o] },
            transition: `all ease-in-out ${n / 1e3}s`,
            className: `${ye}-loading__dot`
          },
          s
        ))
      }
    ),
    /* @__PURE__ */ v.jsx(
      cn,
      {
        fontWeight: "medium",
        _light: { color: "inkeepPrimary.textSubtle" },
        _dark: { color: "whiteAlpha.700" },
        className: `${ye}-loading__status-text`,
        children: r
      }
    )
  ] });
}, ole = ale, sle = (e) => {
  const t = {};
  return e.forEach((r) => {
    t[r.citationNumber.toString()] = r.displayOrder.toString();
  }), t;
}, lle = (e) => {
  const t = qt({}), r = Jt(() => e.length === 0 ? {} : sle(e), [e]);
  return gt(() => {
    ql(r, t.current) || (t.current = r);
  }, [r]), t.current;
}, o5 = (e, t) => {
  if (t.length === 0)
    return [];
  const r = ese(e.content, t);
  return ql(r, []) ? [] : r;
}, ule = ({
  message: e,
  loading: t = !1,
  isListeningForResponse: r = !1,
  ind: i,
  isLast: n = !1,
  setShowFeedbackModal: a,
  setShowResponseEditor: o,
  submitPositiveFeedback: s,
  onLoadedCitations: l,
  isMdContainer: u = !1,
  chatSessionId: d,
  feedback: c,
  supportEscalation: p
}) => {
  var J;
  const { log: f } = dn(), g = e.content, k = e.__typename === "UserMessage", y = k ? e.attributes : null, _ = Jt(
    () => (e == null ? void 0 : e.__typename) === "BotMessage" ? e.citations ?? [] : [],
    [e.id]
  ), A = Jt(
    () => o5(e, _),
    [e.content, _]
  ), T = lle(A), N = Zoe(_), P = Joe(_), [B, M] = rt(!1);
  gt(() => {
    (e.__typename == "UserMessage" || B) && (M(!0), l == null || l(i));
  }, [e.__typename, B]);
  const [X, U] = rt(!0);
  gt(() => {
    _ && n && (r ? U(!1) : setTimeout(() => {
      U(!0);
    }, 300));
  }, [_, r, n]);
  const K = la(), z = () => {
    K.capture({
      eventName: "chat_message_copied",
      properties: {
        chatSessionId: d,
        messageId: e.id,
        authorType: e.__typename || null
      }
    });
  }, { shouldOpenLinksInNewTab: j } = Qr();
  return gt(() => (f("Chat bubble mounted"), () => {
    f("Chat bubble unmounted");
  }), []), /* @__PURE__ */ v.jsx(
    mt,
    {
      position: "relative",
      w: "100%",
      overflow: "hidden",
      flexDirection: "column",
      py: 8,
      px: u ? 8 : 6,
      className: `${ye}-chat-bubble__wrapper`,
      children: /* @__PURE__ */ v.jsxs(
        mt,
        {
          flexDirection: u ? "row" : "column",
          minW: 0,
          flexGrow: k ? 0 : 2,
          className: `${ye}-chat-bubble__${k ? "user" : "bot"}-message`,
          children: [
            /* @__PURE__ */ v.jsx(bT, { isMdContainer: u, isUser: k }),
            /* @__PURE__ */ v.jsx(
              mt,
              {
                justifyContent: k ? "flex-end" : "flex-start",
                overflow: "hidden",
                direction: "column",
                flexShrink: k ? 2 : void 0,
                flexGrow: k ? 0 : 2,
                pr: u ? 3 : 0,
                className: `${ye}-chat-bubble__message-content-wrapper`,
                children: k ? /* @__PURE__ */ v.jsxs(
                  Ct,
                  {
                    fontSize: "15px",
                    flexWrap: "wrap",
                    overflowWrap: "break-word",
                    minWidth: "0",
                    flexShrink: 1,
                    maxWidth: "100%",
                    className: `${ye}-chat-bubble__user-message-content-wrapper`,
                    children: [
                      /* @__PURE__ */ v.jsx(
                        cn,
                        {
                          whiteSpace: "pre-wrap",
                          marginBottom: "12px",
                          display: "inline-block",
                          maxWidth: "100%",
                          className: `${ye}-chat-bubble__user-message-content`,
                          children: g
                        }
                      ),
                      (J = y == null ? void 0 : y.attachments) != null && J.length ? /* @__PURE__ */ v.jsx(
                        $oe,
                        {
                          attachments: y.attachments,
                          messageId: e.id
                        }
                      ) : null
                    ]
                  }
                ) : t && n ? /* @__PURE__ */ v.jsx(ole, {}) : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
                  /* @__PURE__ */ v.jsx(
                    Ym,
                    {
                      markdown: _.length > 0 ? Qoe(g) : g,
                      urlToChatCitationMap: N || void 0,
                      citationNumberToChatCitationMap: P,
                      citationNumberToDisplayOrderMap: T,
                      messageId: e.id,
                      shouldOpenLinksInNewTab: j,
                      chatSessionId: d
                    }
                  ),
                  !k && /* @__PURE__ */ v.jsx(
                    Yoe,
                    {
                      ind: i,
                      isHidden: n && (r || t),
                      setShowFeedbackModal: a,
                      submitPositiveFeedback: s,
                      feedback: c,
                      handleCopyMessage: z,
                      copyableMessage: qoe(
                        g,
                        T,
                        P
                      ),
                      supportEscalation: p
                    }
                  ),
                  /* @__PURE__ */ v.jsx(
                    rle,
                    {
                      citations: _,
                      isHidden: !X,
                      citationNumberToDisplayOrderMap: T,
                      setCitationsLoaded: M,
                      citationsLoaded: B,
                      messageId: e.id,
                      chatSessionId: d,
                      isLast: !0
                    },
                    e.id
                  )
                ] })
              }
            )
          ]
        }
      )
    }
  );
}, cle = ule, s5 = (e) => !!(e && e.shouldEscalateToSupport), dle = (e, t) => e.isMdContainer !== t.isMdContainer || e.feedback !== t.feedback ? !1 : !e.isLast && !t.isLast || e.index === 0 ? !0 : ql(e, t), ple = ht.memo(
  ({
    message: e,
    index: t,
    chatSessionId: r,
    loading: i,
    isListeningForResponse: n,
    memoizedSetShowFeedbackModal: a,
    memoizedSetShowResponseEditor: o,
    memoizedSubmitPositiveFeedback: s,
    memoizedOnLoadedCitations: l,
    isMdContainer: u,
    isLast: d,
    feedback: c,
    supportEscalation: p
  }) => /* @__PURE__ */ v.jsxs(Ct, { className: `${ye}-message__wrapper`, children: [
    /* @__PURE__ */ v.jsx(
      cle,
      {
        chatSessionId: r,
        loading: i,
        isLast: d,
        isListeningForResponse: n,
        ind: t,
        setShowFeedbackModal: a,
        setShowResponseEditor: o,
        submitPositiveFeedback: s,
        message: e,
        onLoadedCitations: l,
        isMdContainer: u,
        feedback: c,
        supportEscalation: p
      }
    ),
    d ? null : /* @__PURE__ */ v.jsx(
      Ct,
      {
        px: u ? 8 : 4,
        className: `${ye}-message__divider-wrapper`,
        children: /* @__PURE__ */ v.jsx(sg, { className: `${ye}-message__divider`, margin: "auto" })
      }
    )
  ] }, e.id),
  dle
), hle = ({
  messages: e,
  loading: t,
  isListeningForResponse: r = !1,
  setShowFeedbackModal: i,
  setShowResponseEditor: n,
  submitPositiveFeedback: a,
  isResponseTruncated: o = !1,
  isMdContainer: s = !1,
  chatSessionId: l,
  handleAutoSubmitNewMessage: u,
  aiAnnotations: d,
  handleWorkflowSelection: c,
  getFeedback: p,
  openForm: f,
  onModalClose: g
}) => {
  const { log: k } = dn(), y = qt(null), {
    scrollToBottomEl: _,
    scrollToBottom: A,
    userScrolledUp: T,
    setUserScrolledUp: N
  } = Wae({
    containerRef: y
  }), [
    P,
    B,
    M
  ] = Vae(l), {
    chatMode: X,
    quickQuestions: U,
    shouldScrollToBottomOnLoad: K,
    workflows: z,
    includeAIAnnotations: j
  } = Qr(), [J, ie] = rt(
    K ?? !1
  );
  gt(() => (k("Messages mounted"), () => {
    k("Messages unmounted CitationCards");
  }), []), gt(() => {
    t && N(!1);
  }, [t, N]), gt(() => {
    r && A({ shouldScrollSmoothly: X == xg.Auto }), t && A({
      shouldScrollSmoothly: !0,
      bypassDebounce: !0,
      bypassUserScrollUpLock: !0
    });
  }), gt(() => {
    t && !J && ie(!0);
  }, [t, J]);
  const de = s5(j) ? !!d : !0;
  gt(() => {
    l && e.length > 0 && P.length === e.length && P.every(Boolean) && de && !T && J && A({ shouldScrollSmoothly: !0 }), !l && e.length > 0 && P.length === e.length && P.every(Boolean) && !T && A({ shouldScrollSmoothly: !0 });
  }, [
    P,
    e,
    l,
    J,
    de
  ]);
  const he = Nt(
    (G) => {
      i && i(G);
    },
    [i]
  ), Ee = Nt(
    (G) => {
      n && n(G);
    },
    [n]
  ), Le = Nt(
    (G) => {
      a && a(G);
    },
    [a]
  ), L = Nt(
    (G) => {
      M(G);
    },
    [M]
  ), me = e.length === 0 && (U ?? []).length > 0, Se = e.length === 0 && (z ?? []).length > 0;
  return /* @__PURE__ */ v.jsx(n5, { viewportRef: y, children: /* @__PURE__ */ v.jsxs(
    Ct,
    {
      w: "100%",
      flexDirection: "column",
      minW: 0,
      minHeight: "0",
      fontSize: "15px",
      className: `${ye}-messages__wrapper`,
      children: [
        /* @__PURE__ */ v.jsx(
          joe,
          {
            isMdContainer: s,
            showQuickQuestions: me,
            handleAutoSubmitNewMessage: u,
            showWorkflows: Se,
            handleWorkflowSelection: c
          }
        ),
        /* @__PURE__ */ v.jsx(
          Ct,
          {
            px: s ? 8 : 4,
            className: `${ye}-message__divider-wrapper`,
            children: /* @__PURE__ */ v.jsx(sg, { className: `${ye}-message__divider`, margin: "auto" })
          }
        ),
        e.map((G, He) => /* @__PURE__ */ v.jsx(
          ple,
          {
            message: G,
            index: He,
            chatSessionId: l,
            loading: t,
            isListeningForResponse: r,
            memoizedSetShowFeedbackModal: he,
            memoizedSetShowResponseEditor: Ee,
            memoizedSubmitPositiveFeedback: Le,
            memoizedOnLoadedCitations: L,
            isMdContainer: s,
            isLast: He === e.length - 1,
            feedback: p(G.id),
            supportEscalation: He === e.length - 1 && (d != null && d.shouldEscalateToSupport) ? /* @__PURE__ */ v.jsx(
              xoe,
              {
                openForm: f,
                shouldEscalateToSupport: d.shouldEscalateToSupport,
                onModalClose: g,
                chatSessionId: l,
                messages: e,
                messageInd: He
              }
            ) : null
          },
          G.id
        )),
        o && /* @__PURE__ */ v.jsx(Ct, { px: 4, children: /* @__PURE__ */ v.jsxs(
          Q5,
          {
            colorPalette: "inkeepExpandedPrimary",
            className: `${ye}-messages__error`,
            children: [
              /* @__PURE__ */ v.jsx(Q5.WarningIcon, {}),
              "The response was unable to be fully processed. Please start a new conversation."
            ]
          }
        ) }),
        /* @__PURE__ */ v.jsx(Ct, { ref: _ })
      ]
    }
  ) });
}, fle = hle, gle = {
  "\n  query GetSearchRootRecords($ids: [ID!]!) {\n    getSearchRootRecords(ids: $ids) {\n      __typename\n      id\n      title\n      url\n      preview\n      ... on DocumentationRecord {\n        pathBreadcrumbs\n        contentType\n      }\n      ... on GitHubIssueRecord {\n        body\n        state\n        createdAt\n      }\n      ... on DiscourseRecord {\n        body\n        categoryBreadcrumbs\n        createdAt\n      }\n      ... on StackOverflowRecord {\n        body\n        tags\n        createdAt\n      }\n    }\n  }\n": VM,
  "\n  subscription OnNewSessionChatResult(\n    $messageInput: String!\n    $messageContext: String\n    $organizationId: ID!\n    $integrationId: ID\n    $chatMode: ChatMode\n    $filters: ChatFiltersInput\n    $messageAttributes: JSON\n    $tags: [String!]\n    $workflowId: String\n    $context: String\n    $guidance: String\n    $includeAIAnnotations: Boolean!\n    $environment: String\n  ) {\n    newSessionChatResult(\n      input: {\n        messageInput: $messageInput\n        messageContext: $messageContext\n        organizationId: $organizationId\n        integrationId: $integrationId\n        chatMode: $chatMode\n        filters: $filters\n        messageAttributes: $messageAttributes\n        tags: $tags\n        workflowId: $workflowId\n        context: $context\n        guidance: $guidance\n        environment: $environment\n      }\n    ) {\n      isEnd\n      sessionId\n      message {\n        id\n        content\n        __typename\n        ... on BotMessage {\n          citations {\n            citationNumber\n            title\n            url\n            rootRecordId\n            rootRecordType\n          }\n        }\n      }\n      aiAnnotations @include(if: $includeAIAnnotations) {\n        shouldEscalateToSupport {\n          strict\n          standard\n        }\n      }\n    }\n  }\n": L6,
  "\n  subscription OnContinueChatResult(\n    $messageInput: String!\n    $sessionId: ID!\n    $messageContext: String\n    $messageAttributes: JSON\n    $includeAIAnnotations: Boolean!\n  ) {\n    continueChatResult(\n      input: {\n        messageInput: $messageInput\n        sessionId: $sessionId\n        messageContext: $messageContext\n        messageAttributes: $messageAttributes\n      }\n    ) {\n      isEnd\n      sessionId\n      message {\n        id\n        content\n        __typename\n        ... on BotMessage {\n          citations {\n            citationNumber\n            title\n            url\n            rootRecordId\n            rootRecordType\n          }\n        }\n      }\n      aiAnnotations @include(if: $includeAIAnnotations) {\n        shouldEscalateToSupport {\n          strict\n          standard\n        }\n      }\n    }\n  }\n": M6,
  "\n  mutation LogUsageEvent($input: LogUsageEventInput!) {\n    logUsageEvent(input: $input) {\n      success\n    }\n  }\n": WM,
  "\n  query GetSearchResults($searchInput: SearchInput!) {\n    search(searchInput: $searchInput) {\n      searchHits {\n        id\n        hitOnRoot\n        url\n        title\n        preview\n\n        ... on DocumentationHit {\n          rootRecord {\n            __typename\n            id\n            title\n            url\n            preview\n            ... on DocumentationRecord {\n              pathBreadcrumbs\n              contentType\n              topLevelHeadings {\n                anchor\n                url\n                htmlTag\n                content\n              }\n              firstContentPath {\n                anchor\n                url\n                htmlTag\n                content\n              }\n              firstContent\n            }\n          }\n          pathHeadings {\n            anchor\n            url\n            htmlTag\n            content\n          }\n          content {\n            anchor\n            url\n            htmlTag\n            content\n            contentHtml\n          }\n        }\n\n        ... on StackOverflowHit {\n          rootRecord {\n            __typename\n            id\n            title\n            url\n            preview\n            ... on StackOverflowRecord {\n              body\n              tags\n              createdAt\n              score\n              topVotedAnswer {\n                url\n                score\n                content\n              }\n              markedAsCorrectAnswer {\n                url\n                score\n                content\n              }\n            }\n          }\n        }\n        ... on GitHubIssueHit {\n          rootRecord {\n            __typename\n            id\n            title\n            url\n            preview\n            ... on GitHubIssueRecord {\n              body\n              state\n              createdAt\n              reactions {\n                reactionType\n                count\n              }\n              commentsWithMostPositiveReactions {\n                id\n                url\n                body\n                commentDate\n                reactions {\n                  reactionType\n                  count\n                }\n              }\n            }\n          }\n        }\n\n        ... on DiscourseHit {\n          rootRecord {\n            __typename\n            id\n            title\n            url\n            preview\n            ... on DiscourseRecord {\n              body\n              bodyHtml\n              categoryBreadcrumbs\n              createdAt\n            }\n          }\n        }\n      }\n      searchQuery\n    }\n  }\n": GM,
  "\n  query GetChatSession($id: ID!) {\n    getChatSession(id: $id) {\n      id\n      organizationId\n      chatMode\n      workflowId\n      messages {\n        id\n        content\n        ... on UserMessage {\n          context\n          attributes\n        }\n        ... on BotMessage {\n          citations {\n            citationNumber\n            title\n            url\n            rootRecordId\n            rootRecordType\n          }\n        }\n      }\n      filters {\n        product\n        productVersion\n        attributes\n      }\n    }\n  }\n": KM,
  "\n  mutation CopyChatSession($sessionId: ID!, $isSharedSession: Boolean!) {\n    copyChatSession(sessionId: $sessionId, isSharedSession: $isSharedSession)\n  }\n": YM
};
function wT(e) {
  return gle[e] ?? {};
}
const FT = () => {
  const [e, t] = rt(null), [
    r,
    i
  ] = rt(null), [n, a] = rt(null), o = Nt(() => {
    t(Date.now());
  }, []), s = Nt(() => {
    e && r === null && i(Date.now() - e);
  }, [e, r]), l = Nt(() => {
    e && r && n === null && a(
      Date.now() - r
    );
  }, [
    e,
    r,
    n
  ]);
  return {
    requestStartTime: e,
    elapsedTimeToStartStreamedResponse: r,
    elapsedTimeToCompleteResponse: n,
    startRequest: o,
    startStreamedResponse: s,
    completeResponse: l
  };
};
class TT extends Error {
  constructor(r, i) {
    super(r);
    c0(this, "variables");
    this.name = "ResponseTimeoutError", this.variables = i;
  }
}
class ST extends Error {
  constructor(r, i) {
    super(r);
    c0(this, "variables");
    this.name = "ResponseTruncatedError", this.variables = i;
  }
}
function IT({
  messages: e,
  handleTimeout: t,
  handleMessageTimeout: r
}) {
  const i = qt(
    null
  );
  gt(() => {
    var a;
    return e.length > 0 && ((a = e.at(-1).content) == null ? void 0 : a.length) > 0 ? i.current && clearTimeout(i.current) : i.current = setTimeout(t, 75e3), () => {
      i.current && clearTimeout(i.current);
    };
  }, [t, e]);
  const n = qt(null);
  gt(() => {
    var a;
    return e.length > 0 && ((a = e.at(-1).content) == null ? void 0 : a.length) > 0 && (n.current && clearTimeout(n.current), n.current = setTimeout(r, 2e4)), () => {
      n.current && clearTimeout(n.current);
    };
  }, [r, e]);
}
function BT(e, t, r) {
  const i = e ? t : hse(t, r != "TURBO");
  return Xoe(i);
}
wT(
  /* GraphQL */
  `
  subscription OnNewSessionChatResult(
    $messageInput: String!
    $messageContext: String
    $organizationId: ID!
    $integrationId: ID
    $chatMode: ChatMode
    $filters: ChatFiltersInput
    $messageAttributes: JSON
    $tags: [String!]
    $workflowId: String
    $context: String
    $guidance: String
    $includeAIAnnotations: Boolean!
    $environment: String
  ) {
    newSessionChatResult(
      input: {
        messageInput: $messageInput
        messageContext: $messageContext
        organizationId: $organizationId
        integrationId: $integrationId
        chatMode: $chatMode
        filters: $filters
        messageAttributes: $messageAttributes
        tags: $tags
        workflowId: $workflowId
        context: $context
        guidance: $guidance
        environment: $environment
      }
    ) {
      isEnd
      sessionId
      message {
        id
        content
        __typename
        ... on BotMessage {
          citations {
            citationNumber
            title
            url
            rootRecordId
            rootRecordType
          }
        }
      }
      aiAnnotations @include(if: $includeAIAnnotations) {
        shouldEscalateToSupport {
          strict
          standard
        }
      }
    }
  }
`
);
const mle = (e, t) => e.messages === t.messages && e.sessionId === t.sessionId, vle = ht.memo(
  ({
    messages: e,
    setMessages: t,
    setIsListeningForResponseNewChat: r,
    sessionId: i,
    setSessionId: n,
    setResponseError: a,
    setIsResponseTruncated: o,
    setAIAnnotations: s
  }) => {
    var Ee, Le, L, me;
    const l = (Ee = e.at(-2)) == null ? void 0 : Ee.content, u = (Le = e.at(-2)) == null ? void 0 : Le.context, d = (L = e.at(-2)) == null ? void 0 : L.attributes, { organizationId: c, filters: p, integrationId: f, tags: g, env: k } = Xi(), y = (k || "").toLowerCase(), {
      chatMode: _,
      messageAttributes: A,
      context: T,
      guidance: N,
      includeAIAnnotations: P
    } = Qr(), B = {
      ...A,
      ...d
    }, M = (me = B == null ? void 0 : B.workflow) == null ? void 0 : me.id, { log: X } = dn(), U = la(), {
      requestStartTime: K,
      elapsedTimeToStartStreamedResponse: z,
      startRequest: j,
      startStreamedResponse: J
    } = FT(), ie = s5(P);
    lF(
      L6,
      {
        variables: {
          messageInput: l || "",
          messageContext: u || null,
          organizationId: c,
          integrationId: f,
          chatMode: _,
          filters: p,
          messageAttributes: B,
          tags: g,
          workflowId: M,
          context: T,
          guidance: N,
          includeAIAnnotations: ie,
          environment: y
        },
        shouldResubscribe: !1,
        onData: ({
          data: Se
        }) => {
          var _e;
          const { data: G, loading: He, error: xe } = Se;
          if (He && K === null && j(), xe && a(xe), !He && ((_e = G == null ? void 0 : G.newSessionChatResult) != null && _e.message)) {
            const {
              sessionId: Ze,
              message: qe,
              isEnd: nt,
              aiAnnotations: at
            } = G.newSessionChatResult;
            if (qe.content && (t([
              ...e.slice(0, -1),
              {
                ...qe,
                content: BT(nt, qe.content, _)
              }
            ]), z === null && J()), i != Ze && n(Ze), nt && (ie ? !!at : !0)) {
              r(!1);
              const Oe = Date.now() - (K || 0), wt = o5(
                qe,
                qe.citations
              );
              s(at), U.capture({
                eventName: "chat_message_bot_response_received",
                properties: {
                  chatSessionId: i,
                  question: l,
                  responseMessage: qe,
                  elapsedTimeToCompleteStreamedResponse: Oe,
                  elapsedTimeToStartStreamedResponse: z,
                  numberOfCitationsUsedInResponse: wt.length,
                  citationsUsedInResponse: wt,
                  workflowId: M
                }
              });
            }
          }
        }
      }
    );
    const { handleError: ue } = pF(), de = Nt(() => {
      a("Backend did not response in a timely way"), r(!1);
      const Se = new TT(
        "Backend did not respond in a timely way to new chat request",
        {
          messageInput: l,
          organizationId: c,
          chatMode: _,
          filters: p
        }
      );
      ue == null || ue(Se);
    }, [l, c, _, p]), he = Nt(() => {
      const Se = new ST(
        "Response message is truncated in new chat request",
        {
          messageInput: l,
          organizationId: c,
          chatMode: _,
          filters: p
        }
      );
      ue == null || ue(Se), o(!0), r(!1);
    }, [l, c, _, p]);
    return IT({
      messages: e,
      handleTimeout: de,
      handleMessageTimeout: he
    }), gt(() => (X("START: mounting subscription for new chat"), () => {
      X("STOP: new chat unmounting"), X(l);
    }), []), /* @__PURE__ */ v.jsx(v.Fragment, {});
  },
  mle
), kle = vle;
wT(
  /* GraphQL */
  `
  subscription OnContinueChatResult(
    $messageInput: String!
    $sessionId: ID!
    $messageContext: String
    $messageAttributes: JSON
    $includeAIAnnotations: Boolean!
  ) {
    continueChatResult(
      input: {
        messageInput: $messageInput
        sessionId: $sessionId
        messageContext: $messageContext
        messageAttributes: $messageAttributes
      }
    ) {
      isEnd
      sessionId
      message {
        id
        content
        __typename
        ... on BotMessage {
          citations {
            citationNumber
            title
            url
            rootRecordId
            rootRecordType
          }
        }
      }
      aiAnnotations @include(if: $includeAIAnnotations) {
        shouldEscalateToSupport {
          strict
          standard
        }
      }
    }
  }
`
);
const ble = ({
  messages: e,
  setMessages: t,
  sessionId: r,
  setIsListeningForResponseContinuedChat: i,
  setResponseError: n,
  setIsResponseTruncated: a,
  setAIAnnotations: o
}) => {
  var U, K, z, j;
  const { log: s } = dn(), l = (U = e.at(-2)) == null ? void 0 : U.content, u = (K = e.at(-2)) == null ? void 0 : K.context, d = (z = e.at(-2)) == null ? void 0 : z.attributes, {
    chatMode: c,
    messageAttributes: p,
    includeAIAnnotations: f
  } = Qr(), g = {
    ...p,
    ...d
  }, k = (j = g == null ? void 0 : g.workflow) == null ? void 0 : j.id, y = la(), {
    requestStartTime: _,
    elapsedTimeToStartStreamedResponse: A,
    startRequest: T,
    startStreamedResponse: N
  } = FT(), P = s5(f);
  lF(
    M6,
    {
      variables: {
        messageInput: l || "",
        sessionId: r,
        messageContext: u || null,
        messageAttributes: g,
        includeAIAnnotations: P
      },
      // skip: subscriptionExecuted,
      shouldResubscribe: !1,
      onData: ({
        data: J
      }) => {
        const { data: ie, loading: ue, error: de } = J;
        if (ue && _ === null && T(), de && (s("error"), s(de), n(de)), !ue && (ie != null && ie.continueChatResult)) {
          const { message: he, isEnd: Ee, aiAnnotations: Le } = ie.continueChatResult;
          if (he.content && (t([
            ...e.slice(0, -1),
            {
              ...he,
              content: BT(Ee, he.content, c)
            }
          ]), A === null && N()), Ee && (P ? !!Le : !0)) {
            i(!1);
            const me = Date.now() - (_ || 0), Se = o5(
              he,
              he.citations
            );
            o(Le), y.capture({
              eventName: "chat_message_bot_response_received",
              properties: {
                chatSessionId: r,
                question: l,
                responseMessage: he,
                elapsedTimeToCompleteStreamedResponse: me,
                elapsedTimeToStartStreamedResponse: A,
                numberOfCitationsUsedInResponse: Se.length,
                citationsUsedInResponse: Se,
                workflowId: k
              }
            });
          }
        }
      }
    }
  );
  const { handleError: B } = pF(), M = Nt(() => {
    n("Backend did not response in a timely way"), i(!1);
    const J = new TT(
      "Backend did not respond in a timely way to new chat request",
      {
        messageInput: l,
        sessionId: r
      }
    );
    B == null || B(J);
  }, [n]), X = Nt(() => {
    a(!0), i(!1);
    const J = new ST(
      "Response message is truncated in continue chat request",
      {
        messageInput: l,
        sessionId: r
      }
    );
    B == null || B(J);
  }, [a]);
  return IT({
    messages: e,
    handleTimeout: M,
    handleMessageTimeout: X
  }), gt(() => (s("START: mounting subscription for continued chat"), s(e), s(l), s(c), () => {
    s("STOP: continued chat unmounting"), s(l);
  }), []), /* @__PURE__ */ v.jsx(v.Fragment, {});
}, _le = ble, Dle = ({ children: e, onClick: t, isActive: r, iconKey: i, iconClassName: n }) => /* @__PURE__ */ v.jsxs(
  di,
  {
    type: "button",
    size: "xs",
    onClick: t,
    variant: "unstyled",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    boxShadow: r ? "sm" : "none",
    bg: r ? "white" : "transparent",
    color: r ? "gray.800" : "gray.600",
    _dark: {
      bg: r ? "grayDark.700" : "transparent",
      color: r ? "whiteAlpha.800" : "whiteAlpha.600",
      boxShadow: "none"
    },
    className: `group ${ye}-switch-view-toggle__button ${r ? `${ye}-switch-view-toggle__button--active` : ""}`,
    _hover: {
      color: "gray.800",
      _dark: {
        color: "whiteAlpha.800"
      }
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    children: [
      /* @__PURE__ */ v.jsx(
        zn,
        {
          iconKey: i,
          color: r ? "gray.600" : "gray.500",
          _dark: {
            color: r ? "whiteAlpha.600" : "whiteAlpha.500"
          },
          _groupHover: {
            color: "gray.600",
            _dark: {
              color: "whiteAlpha.600"
            }
          },
          className: `${ye}-${n}`,
          marginRight: 1
        }
      ),
      e
    ]
  }
), Yx = Dle, yle = ({
  activePage: e,
  setActivePage: t
}) => {
  const [r, i] = Ql(), { askAILabel: n, switchToSearchMessage: a } = Ka(), o = (l) => {
    l.stopPropagation(), i("defaultView", "SEARCH"), t("searchResults");
  }, s = (l) => {
    l.stopPropagation(), i("defaultView", "AI_CHAT"), t("aiChat");
  };
  return /* @__PURE__ */ v.jsxs(
    mt,
    {
      className: `${ye}-switch-view-toggle`,
      bg: "gray.50",
      _dark: {
        bg: "transparent",
        borderColor: "grayDark.700"
      },
      borderRadius: "md",
      p: 0.5,
      border: "1px solid transparent",
      children: [
        /* @__PURE__ */ v.jsx(
          Yx,
          {
            onClick: o,
            isActive: e === "searchResults",
            iconKey: "switchToSearch",
            iconClassName: "switch-to-search-icon",
            children: a || "Search"
          }
        ),
        /* @__PURE__ */ v.jsx(
          Yx,
          {
            onClick: s,
            isActive: e === "aiChat",
            iconKey: "switchToChat",
            iconClassName: "switch-to-chat-icon",
            children: n || "Ask AI"
          }
        )
      ]
    }
  );
}, RT = yle, Ele = ({
  showCloseButton: e = !1,
  showSwitchToSearchButton: t = !1,
  setActivePage: r = () => {
  },
  activePage: i
}) => {
  const {
    disclaimerSettings: n = Hl.disclaimerSettings,
    botName: a
  } = Qr(), { isDisclaimerEnabled: o } = n, s = `Ask ${a || "AI"}`;
  return /* @__PURE__ */ v.jsxs(
    mt,
    {
      flex: 1,
      justifyContent: "space-between",
      className: `${ye}-ai-chat__toolbar`,
      children: [
        /* @__PURE__ */ v.jsxs(
          mt,
          {
            _dark: {
              color: "whiteAlpha.700"
            },
            _light: {
              color: "gray.700"
            },
            alignItems: "center",
            children: [
              /* @__PURE__ */ v.jsx(
                cn,
                {
                  fontSize: "sm",
                  display: "inline-block",
                  className: `${ye}-ai-chat__toolbar-header`,
                  children: s
                }
              ),
              o && /* @__PURE__ */ v.jsx(kT, { placement: "bottom-start" })
            ]
          }
        ),
        /* @__PURE__ */ v.jsxs(mt, { alignItems: "center", children: [
          t && /* @__PURE__ */ v.jsx(RT, { activePage: i, setActivePage: r }),
          e && /* @__PURE__ */ v.jsx(
            ri.Close,
            {
              _dark: { color: "whiteAlpha.500" },
              _light: { color: "gray.600" },
              ml: 1,
              position: "relative",
              right: "auto",
              size: "sm",
              top: "auto",
              children: /* @__PURE__ */ v.jsx(pp, {})
            }
          )
        ] })
      ]
    }
  );
}, Cle = ht.memo(Ele), xle = ({
  aiChatInputRef: e,
  showCloseButton: t = !1,
  isModeSwitchingEnabled: r = !1,
  activePage: i,
  setActivePage: n,
  query: a = "",
  isMdContainer: o = !0,
  openForm: s,
  isHidden: l = !1,
  onModalClose: u,
  shouldAutoSubmitQuery: d,
  setShouldAutoSubmitQuery: c
}) => {
  const { log: p } = dn(), f = a, {
    handleMessageChange: g,
    isControlledMessage: k,
    shouldAutoFocusInput: y,
    isViewOnly: _,
    chatFunctionsRef: A,
    alignMessagesToTop: T
  } = Qr(), [N, P] = rt(f), [B, M] = rt(!1), [
    X,
    U
  ] = rt(!1), K = X || B, [z, j] = rt(null), [J, ie] = rt(null), [ue, de] = rt(!1), [he, Ee] = rt(!1), [Le, L] = rt(!1), [me, Se] = rt(-1), { getFeedback: G, setMessageFeedback: He } = Wne(), xe = la(), [_e, Ze] = rt([]), [qe, nt] = rt(!1), [at, At] = rt(null), [Oe, wt] = rt(
    null
  ), [Ge, nr] = rt([]), vr = qt(null), zr = e ?? vr, Wr = N.trim().length === 0 && Ge.length === 0;
  gt(() => (p("AIChatPage mounted"), () => {
    p("AIChatPage unmounted");
  }), []), gt(() => {
    i == "aiChat" && r && zr && zr.current && (zr.current.focus(), zr.current.selectionStart = zr.current.value.length);
  }, [i, zr, r]), gt(() => {
    !N && i == "aiChat" && r && P(f);
  }, [i]);
  const ne = Nt(
    (lt) => {
      k ? g && g(lt) : P(lt);
    },
    [k, g, P]
  ), {
    chatSessionId: pe,
    setChatSessionId: Fe,
    loading: Ye
  } = $ne({
    messages: _e,
    inputMessage: N,
    setMessages: Ze,
    responseError: J,
    setResponseError: ie,
    setIsLoadedFromSavedChat: nt,
    setIsLoadingExistingChat: Ee,
    isListeningForResponse: K
  }), { handleCopyChatSession: Ue } = Vne();
  e8(A, () => ({
    submitCurrentInputMessage: () => {
      ge();
    },
    updateInputMessage: (lt) => {
      P(lt);
    },
    submitNewMessage: (lt) => {
      ot(lt);
    },
    clearChat: () => {
      gr();
    },
    openForm: (lt) => {
      n && n("aiChat"), Er(lt);
    }
  })), gt(() => {
    if (J) {
      p("---RESPONSE ERROR---"), p(J), U(!1), M(!1);
      const lt = {
        content: `Hmm.. 

 It seems I might be having some issues right now. Please clear the chat and try again.`,
        id: "9999",
        __typename: "BotMessage",
        citations: []
      };
      Ze([..._e.slice(0, -1), lt]), j(null);
    }
  }, [J]);
  const Re = Nt(
    (lt) => {
      const _r = _e.at(lt - 1), hr = _e.at(lt);
      if (!(_r && hr)) {
        console.error(
          "messages length is less than 2 when submitting feedback"
        );
        return;
      }
      xe.capture({
        eventName: "chat_thumbs_up_feedback_submitted",
        properties: {
          chatSessionId: pe,
          question: _r.content,
          answer: hr.content,
          answerId: hr.id,
          workflowId: Oe == null ? void 0 : Oe.id
        }
      }), He(hr.id, 1);
    },
    [
      xe,
      _e,
      pe,
      Oe == null ? void 0 : Oe.id,
      He
    ]
  ), ot = (lt) => {
    if (p("handling auto-submit new message"), lt.trim().length === 0)
      return;
    const _r = () => {
      const hr = [
        ..._e,
        {
          id: _e.length.toString(),
          content: lt,
          __typename: "UserMessage"
        },
        {
          id: (_e.length + 1).toString(),
          content: "",
          __typename: "BotMessage",
          citations: []
        }
      ];
      Ze(hr), j(null), hr.length === 2 ? M(!0) : U(!0), ne(""), xe.capture({
        eventName: "chat_message_submitted",
        properties: {
          chatSessionId: pe,
          content: lt,
          prefilledAutoSubmitted: !0
        }
      });
    };
    if (he) {
      p("isloading existing chat: ", he), At(lt);
      return;
    }
    K ? (p("stopping response because it's still runing"), Ie(), setTimeout(() => {
      _r();
    }, 300)) : _r();
  };
  gt(() => {
    d && c && (ot(f), c(!1));
  }, [d]);
  const Ut = (lt) => {
    p("handling selecting workflow"), wt(lt);
    const { initialReplyMessage: _r, displayName: hr } = lt, $t = {
      id: _e.length.toString(),
      content: hr,
      __typename: "UserMessage"
    }, pi = {
      id: (_e.length + 1).toString(),
      content: _r,
      __typename: "BotMessage",
      citations: []
    }, Di = [..._e, $t, pi];
    Ze(Di), nr([]);
  };
  gt(() => {
    !he && at && (p("submitted pending message"), ot(at), At(null));
  }, [he, at]);
  const ge = async () => {
    if (Wr)
      return;
    const lt = Oe ? _e.length === 2 : _e.length === 0;
    let _r = {};
    Oe && (_r = Jne(
      Oe,
      Ge,
      lt
    ));
    const hr = [
      ..._e,
      {
        id: _e.length.toString(),
        content: N,
        ..._r,
        __typename: "UserMessage"
      },
      {
        id: (_e.length + 1).toString(),
        content: "",
        __typename: "BotMessage",
        citations: []
      }
    ];
    p("--handling new message"), p("new message: ", N), p("prev messages:"), p(_e), p("new messages:"), p(hr), Ze(hr), j(null), nr([]), lt ? M(!0) : U(!0), ne("");
    let $t = pe;
    if (qe) {
      p("is loaded from saved chat");
      try {
        $t = await Ue(pe, !0), p("new session id: ", $t), Fe($t), Px(), xe.capture({
          eventName: "chat_shared_session_continued",
          properties: {
            sharedChatSessionId: pe,
            newChatSessionId: $t
          }
        });
      } catch (pi) {
        console.error("Error while copying chat session:", pi);
      }
    }
    xe.capture({
      eventName: "chat_message_submitted",
      properties: {
        chatSessionId: pe,
        content: N,
        prefilledAutoSubmitted: !1,
        workflowId: Oe == null ? void 0 : Oe.id
      }
    });
  }, Ie = () => {
    p("stopping response"), U(!1), M(!1);
  }, [ut, xt] = Ql(), Bt = (lt) => {
    p("setting new session id"), Fe(lt), xt("inkeepChatSessionId", lt);
  }, gr = () => {
    U(!1), M(!1), ie(null), de(!1), Ze([]), j(null), ne(""), Bt(""), Px(), wt(null), nr([]), xt("inkeepChatSessionId", void 0), xe.capture({
      eventName: "chat_history_cleared",
      properties: {
        chatSessionId: pe || null
      }
    });
  }, Gr = qt(null);
  gt(() => {
    K ? (p("------PARENT START: is listening for response changed"), p(
      "is listening for response new chat: ",
      B
    ), p(
      "is listening for response continued chat: ",
      X
    )) : (p("------PARENT stop: is no longer listening for new chat"), p(
      "is listening for response new chat: ",
      B
    ), p(
      "is listening for response continued chat: ",
      X
    ));
  }, [K]);
  const kr = { base: "white", _dark: "grayDark.900" }, Xr = Nt((lt) => {
    Se(lt), L(!0);
  }, []), Er = Nt(
    (lt) => {
      s({
        formConfig: lt,
        chatSession: {
          chatSessionId: pe,
          messages: qm(_e)
        }
      });
    },
    [pe, _e, s]
  ), tr = t || r, Ti = ue || !!J || _;
  return pe && Ye && !l ? /* @__PURE__ */ v.jsx(Uae, {}) : /* @__PURE__ */ v.jsxs(
    $g,
    {
      maxHeight: "100%",
      display: l ? "none" : "flex",
      className: `${ye}-ai-chat__scrollable-page-wrapper`,
      borderRadius: "inherit",
      children: [
        B && /* @__PURE__ */ v.jsx(
          kle,
          {
            messages: _e,
            sessionId: pe,
            setIsListeningForResponseNewChat: M,
            setIsResponseTruncated: de,
            setMessages: Ze,
            setResponseError: ie,
            setSessionId: Bt,
            setAIAnnotations: j
          }
        ),
        X && /* @__PURE__ */ v.jsx(
          _le,
          {
            messages: _e,
            sessionId: pe || "",
            setIsListeningForResponseContinuedChat: U,
            setIsResponseTruncated: de,
            setMessages: Ze,
            setResponseError: ie,
            setAIAnnotations: j
          }
        ),
        Le && /* @__PURE__ */ v.jsx(
          $ae,
          {
            chatSessionId: pe,
            isOpen: Le,
            messageInd: me,
            messages: _e,
            onClose: () => void L(!1),
            workflowId: Oe == null ? void 0 : Oe.id,
            setMessageFeedback: He
          }
        ),
        /* @__PURE__ */ v.jsx(
          CD,
          {
            bg: kr,
            className: `${ye}-ai-chat__header`,
            css: tr ? {
              "&::after": {
                position: "absolute",
                content: '""',
                left: "0px",
                top: "100%",
                height: "1rem",
                width: "100%",
                color: kr,
                background: "linear-gradient(currentColor, transparent)",
                zIndex: 1
              }
            } : {},
            children: /* @__PURE__ */ v.jsx(
              Tl,
              {
                alignItems: "center",
                flexShrink: 0,
                px: o ? 4 : 6,
                py: 2,
                gap: 2,
                w: "100%",
                className: `${ye}-ai-chat__header-toolbar`,
                children: tr && /* @__PURE__ */ v.jsx(
                  Cle,
                  {
                    showCloseButton: t,
                    showSwitchToSearchButton: r,
                    setActivePage: n,
                    activePage: i
                  }
                )
              }
            )
          }
        ),
        /* @__PURE__ */ v.jsx(
          xD,
          {
            bg: kr,
            className: `${ye}-ai-chat__scrollable-page-content`,
            children: /* @__PURE__ */ v.jsx(
              mt,
              {
                direction: "column",
                flexGrow: 4,
                justifyContent: T ? "flex-start" : "flex-end",
                overflowY: "hidden",
                className: `${ye}-ai-chat__scrollable-page-content__inner`,
                children: /* @__PURE__ */ v.jsx(
                  fle,
                  {
                    chatSessionId: pe,
                    isListeningForResponse: K,
                    isMdContainer: o,
                    isResponseTruncated: ue,
                    loading: K && _e.length > 0 && _e.at(-1).content == "",
                    aiAnnotations: z,
                    messages: _e,
                    setShowFeedbackModal: Xr,
                    submitPositiveFeedback: Re,
                    handleAutoSubmitNewMessage: ot,
                    handleWorkflowSelection: Ut,
                    getFeedback: G,
                    onModalClose: u,
                    openForm: Er
                  }
                )
              }
            )
          }
        ),
        /* @__PURE__ */ v.jsx(
          vF,
          {
            bg: kr,
            className: `${ye}-ai-chat-footer`,
            children: /* @__PURE__ */ v.jsx(
              mt,
              {
                bgGradient: "to-b",
                gradientFrom: "rgba(255, 255, 255, 0)",
                gradientTo: kr,
                flexDir: "column",
                pt: 6,
                pb: 4,
                css: {
                  "&::before": {
                    bgGradient: "to-b",
                    gradientFrom: "rgba(255, 255, 255, 0)",
                    gradientTo: kr,
                    content: '""',
                    display: "block",
                    height: 3,
                    left: 0,
                    top: 0,
                    transform: "translateY(-100%)",
                    pointerEvents: "none",
                    position: "absolute",
                    width: "100%"
                  }
                },
                className: `${ye}-ai-chat-footer__content-wrapper`,
                children: /* @__PURE__ */ v.jsx(
                  Tl,
                  {
                    alignItems: "start",
                    display: "flex",
                    justifyContent: "center",
                    px: o ? 8 : 6,
                    gap: { base: 0, md: 2 },
                    width: "100%",
                    className: `${ye}-ai-chat-footer__content`,
                    children: /* @__PURE__ */ v.jsxs(
                      Ct,
                      {
                        flexGrow: 2,
                        width: "100%",
                        className: `${ye}-ai-chat__message-box-wrapper`,
                        children: [
                          /* @__PURE__ */ v.jsx(
                            zae,
                            {
                              ref: Gr,
                              handleInputMessageChange: ne,
                              handleSubmitInputMessage: ge,
                              inputMessage: N,
                              inputMessageRef: zr,
                              isDisabled: Ti,
                              isSubmitDisabled: K || Ti || Wr,
                              shouldAutoFocusInput: y,
                              selectedWorkflow: Oe,
                              messageAttachments: Ge,
                              setMessageAttachments: nr
                            }
                          ),
                          /* @__PURE__ */ v.jsx(
                            Eae,
                            {
                              chatSessionId: pe,
                              messageCount: _e.length,
                              isListeningForResponse: K,
                              handleStopResponse: Ie,
                              clearConversation: gr,
                              isViewOnly: _,
                              isInputDisabled: Ti,
                              inWorkflow: !!Oe,
                              openForm: Er,
                              onModalClose: u,
                              messages: _e
                            }
                          )
                        ]
                      }
                    )
                  }
                )
              }
            )
          }
        )
      ]
    }
  );
}, Ale = xle, wle = _i(
  Te("div", hB),
  "AIChatPageWrapper"
), Fle = ({
  size: e,
  maxHeight: t,
  isHidden: r = !1,
  onModalClose: i,
  ...n
}) => {
  const { log: a } = dn(), [o, s] = rt(
    "AI_CHAT"
    /* AIChat */
  ), [l, u] = rt(null), [d, c] = mF(), p = (k) => {
    u(k), s(
      "FORM"
      /* Form */
    );
  }, f = () => {
    u(null), s(
      "AI_CHAT"
      /* AIChat */
    );
  };
  gt(() => (a("AIChatPage mounted"), () => {
    a("AIChatPage unmounted");
  }), []);
  const g = c != null && c.width ? c.width > 580 : !0;
  return /* @__PURE__ */ v.jsxs(
    wle,
    {
      variant: "container-with-shadow",
      size: e,
      ref: d,
      style: {
        maxHeight: t == null ? void 0 : t.toString()
      },
      display: r ? "none" : "flex",
      backgroundColor: { base: "white", _dark: "grayDark.900" },
      borderRadius: "md",
      children: [
        /* @__PURE__ */ v.jsx(
          Ale,
          {
            ...n,
            openForm: p,
            isMdContainer: g,
            isHidden: o !== "AI_CHAT",
            onModalClose: i
          }
        ),
        o === "FORM" && l && /* @__PURE__ */ v.jsx(
          jne,
          {
            isMdContainer: g,
            formConfig: l.formConfig,
            onClose: f,
            chatSession: l.chatSession,
            onModalClose: i
          }
        )
      ]
    }
  );
}, OT = Fle, PT = kn(void 0), Jm = () => {
  const e = Pn(PT);
  if (e === void 0)
    throw new Error(
      "useFocusedSearchResultContext must be used within a InkeepCustomTrigger provider"
    );
  return e;
}, Tle = ({
  children: e,
  ...t
}) => /* @__PURE__ */ v.jsx(PT.Provider, { value: t, children: e }), Sle = ({
  mainContent: e,
  actionItems: t
}) => /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
  /* @__PURE__ */ v.jsx(xD, { children: e }),
  t && /* @__PURE__ */ v.jsxs(
    vF,
    {
      pt: 1,
      pb: 3,
      px: 5,
      className: `${ye}-modal-page__footer`,
      children: [
        " ",
        /* @__PURE__ */ v.jsx(mt, { width: "100%", children: t })
      ]
    }
  )
] });
function Ile(e, t) {
  const { active: r, ...i } = e, { active: n, ...a } = t;
  if (!n && !r)
    return !0;
  const o = /* @__PURE__ */ new Set([
    ...Object.keys(i),
    ...Object.keys(a)
  ]);
  for (const s of o)
    if (i[s] !== a[s])
      return !1;
  return !0;
}
const Ble = ht.memo(Sle, Ile), Rle = ({
  mainContent: e,
  actionItems: t,
  pageName: r,
  height: i = "100%",
  maxHeight: n = "100%",
  activePage: a,
  css: o
}) => {
  const s = a === r;
  return /* @__PURE__ */ v.jsx(
    mt,
    {
      css: o,
      direction: "column",
      height: i,
      maxHeight: n,
      transition: "all .3s ease-in-out",
      display: s ? "flex" : "none",
      children: /* @__PURE__ */ v.jsx(
        Ble,
        {
          active: s,
          mainContent: e,
          actionItems: t
        }
      )
    }
  );
}, NT = Rle, Ole = ({
  searchResults: e,
  showLoading: t,
  shouldOpenLinksInNewTab: r,
  query: i,
  searchQueryParamKey: n,
  onClose: a
}) => {
  const [o, s] = rt(String(0)), { tabLabels: l, searchResultsByTab: u, countsByTab: d } = xT(e), { alwaysDisplayedTabs: c } = CT(), { focusedItem: p, setFocusedItem: f } = Jm(), g = l.filter(
    (_) => c.includes(_) || d[_] > 0
  ), k = g.reduce(
    (_, A, T) => (_.push(
      /* @__PURE__ */ v.jsxs(
        _0.Trigger,
        {
          value: String(T),
          flexShrink: 0,
          className: `${ye}-search-result-tab`,
          border: "1px solid gray",
          _light: {
            borderColor: "gray.300"
          },
          _dark: {
            borderColor: "grayDark.500"
          },
          _hover: {
            bg: "gray.50",
            _dark: {
              bg: "whiteAlpha.50"
            }
          },
          px: "3",
          fontSize: "13px",
          fontWeight: "medium",
          borderRadius: "full",
          transition: "all 0.2s",
          _selected: {
            bg: "inkeepPrimary.lightSubtle",
            borderColor: "inkeepPrimary.mediumSubtle",
            color: "inkeepExpandedPrimary.900",
            _hover: {
              bg: "inkeepPrimary.lightSubtle"
            },
            _dark: {
              color: "inkeepExpandedPrimary.300",
              bg: "whiteAlpha.200",
              borderColor: "inkeepExpandedPrimary.300",
              _hover: {
                bg: "whiteAlpha.200"
              }
            }
          },
          lineHeight: "short",
          children: [
            A,
            t ? "" : ` (${d[A]})`
          ]
        },
        `tab${A}`
      )
    ), _),
    []
  ), y = g.reduce(
    (_, A, T) => {
      const N = o === String(T);
      return N && _.push(
        /* @__PURE__ */ v.jsx(
          _0.Content,
          {
            py: 0,
            px: 0,
            display: "flex",
            minHeight: "0px",
            flexDirection: "column",
            fontSize: "md",
            flexGrow: 1,
            value: String(T),
            className: `${ye}-search-result-tab__content`,
            children: /* @__PURE__ */ v.jsx(
              AT,
              {
                activeTab: N,
                showLoading: t,
                searchResults: u[A],
                isAllTab: A === "All",
                shouldOpenLinksInNewTab: r,
                tabLabel: A,
                onClose: a,
                focusedItem: p,
                setFocusedItem: f,
                query: i,
                searchQueryParamKey: n
              },
              `searchResultsBySource${A}`
            )
          },
          `label${A}`
        )
      ), _;
    },
    []
  );
  return /* @__PURE__ */ v.jsxs(
    _0,
    {
      colorPalette: "inkeepExpandedPrimary",
      variant: "line",
      size: "sm",
      width: "100%",
      height: "100%",
      paddingBottom: "2",
      bg: "transparent",
      onChange: (_) => {
        s(_.value), f(0);
      },
      display: i === "" ? "none" : "flex",
      flexDirection: "column",
      _dark: {
        borderColor: "grayDark.700"
      },
      value: String(o),
      className: `${ye}-search-result-tabs`,
      children: [
        g.length > 1 && /* @__PURE__ */ v.jsx(
          Ct,
          {
            overflowX: "auto",
            maxW: "100%",
            flexShrink: 0,
            scrollbarWidth: "thin",
            scrollbarColor: "var(--ikp-colors-gray-300) transparent",
            _dark: {
              scrollbarColor: "var(--ikp-colors-gray-dark-600) transparent"
            },
            children: /* @__PURE__ */ v.jsx(
              _0.List,
              {
                className: `${ye}-search-result-tabs__list`,
                border: "none",
                px: "5",
                pb: "1",
                pt: "1px",
                gap: "3",
                children: k
              }
            )
          }
        ),
        /* @__PURE__ */ v.jsx(
          _0.Panels,
          {
            paddingTop: g.length > 1 ? 2 : 0,
            display: "flex",
            flexDirection: "column",
            height: "100%",
            maxHeight: g.length > 1 ? "calc(100% - 33px)" : "100%",
            children: y
          }
        )
      ]
    }
  );
}, Ple = Ole, Nle = ts(
  /* GraphQL */
  `
  query GetSearchResults($searchInput: SearchInput!) {
    search(searchInput: $searchInput) {
      searchHits {
        id
        hitOnRoot
        url
        title
        preview

        ... on DocumentationHit {
          rootRecord {
            __typename
            id
            title
            url
            preview
            ... on DocumentationRecord {
              pathBreadcrumbs
              contentType
              topLevelHeadings {
                anchor
                url
                htmlTag
                content
              }
              firstContentPath {
                anchor
                url
                htmlTag
                content
              }
              firstContent
            }
          }
          pathHeadings {
            anchor
            url
            htmlTag
            content
          }
          content {
            anchor
            url
            htmlTag
            content
            contentHtml
          }
        }

        ... on StackOverflowHit {
          rootRecord {
            __typename
            id
            title
            url
            preview
            ... on StackOverflowRecord {
              body
              tags
              createdAt
              score
              topVotedAnswer {
                url
                score
                content
              }
              markedAsCorrectAnswer {
                url
                score
                content
              }
            }
          }
        }
        ... on GitHubIssueHit {
          rootRecord {
            __typename
            id
            title
            url
            preview
            ... on GitHubIssueRecord {
              body
              state
              createdAt
              reactions {
                reactionType
                count
              }
              commentsWithMostPositiveReactions {
                id
                url
                body
                commentDate
                reactions {
                  reactionType
                  count
                }
              }
            }
          }
        }

        ... on DiscourseHit {
          rootRecord {
            __typename
            id
            title
            url
            preview
            ... on DiscourseRecord {
              body
              bodyHtml
              categoryBreadcrumbs
              createdAt
            }
          }
        }
      }
      searchQuery
    }
  }
`
), zle = ({
  query: e
}) => {
  const t = e.trim(), { shouldOpenLinksInNewTab: r, maximumHitsLimit: i, searchQueryParamKey: n } = nc(), {
    organizationId: a,
    integrationId: o,
    filters: s = {}
  } = Xi(), { onClose: l } = Ka(), { loading: u, data: d } = aF(Nle, {
    variables: {
      searchInput: {
        searchQuery: t,
        organizationId: a,
        integrationId: o,
        searchMode: z6.Auto,
        filters: {
          ...s,
          limit: i
        }
      }
    },
    skip: !t
  });
  gt(() => {
    t.length > 0 && g.capture({
      eventName: "search_query_submitted",
      properties: {
        query: t
      }
    });
  }, [t]);
  const c = u, p = c || !(d && d.search) ? [] : d.search.searchHits, f = d == null ? void 0 : d.search.searchHits, g = la();
  gt(() => {
    f && g.capture({
      eventName: "search_query_response_received",
      properties: {
        query: t,
        totalHits: f.length
      }
    });
  }, [f]);
  const { breadcrumbRules: k = {}, stringReplacementRules: y } = Xi(), _ = yT({
    hits: p,
    breadcrumbRules: k,
    stringReplacementRules: y
  });
  return /* @__PURE__ */ v.jsx(
    Ple,
    {
      searchResults: _,
      showLoading: c,
      shouldOpenLinksInNewTab: r,
      query: e,
      searchQueryParamKey: n,
      onClose: l
    }
  );
}, Lle = zle, Mle = () => /* @__PURE__ */ v.jsx(mt, { width: "100%", justifyContent: "space-between", children: /* @__PURE__ */ v.jsx(Ct, { alignSelf: "flex-end", children: /* @__PURE__ */ v.jsx(Z7, {}) }) }), jle = Mle;
function G_(e) {
  return `min(${e.join(", ")})`;
}
const z0 = {
  /** height in small screens */
  maxHeightSmall: "85vh",
  /** height in large screens */
  maxHeightLarge: "850px",
  // maxHeightSearchModalLarge: '662px',
  /** width in small screens */
  maxWidthSmall: "90vw",
  /** width in large screens */
  maxWidthSearchModalLarge: "1000px",
  maxWidthChatModalLarge: "720px",
  /** how much smaller to make the search results height than the ai chat height */
  searchResultsHeightOffset: "275px"
}, Gd = {
  ...z0,
  modalHeight: G_([
    z0.maxHeightSmall,
    z0.maxHeightLarge
  ]),
  modalInitialWidth: G_([
    z0.maxWidthSmall,
    z0.maxWidthChatModalLarge
  ])
}, Hle = T1({
  variants: {
    showSearchResults: {
      true: {
        height: G_([
          `calc( ${Gd.maxHeightSmall} - 72px )`,
          `calc( ${Gd.maxHeightLarge} - 72px - ${Gd.searchResultsHeightOffset} )`
        ])
      },
      false: {
        height: "0px"
      }
    }
  },
  defaultVariants: {
    showSearchResults: !1
  }
}), $le = ({
  switchToChat: e,
  askAILabel: t,
  query: r
}) => {
  const { focusedItem: i } = Jm();
  return /* @__PURE__ */ v.jsx(
    Ct,
    {
      pb: "3",
      children: /* @__PURE__ */ v.jsxs(
        di,
        {
          onClick: e,
          className: Eo(
            `${ye}-ask-ai-card`,
            "group",
            yo({ w: "100%", justifyContent: "start" })
          ),
          "data-hover": i === -1 ? "" : void 0,
          variant: "ghost",
          _light: {
            _hover: {
              bg: "inkeepPrimary.lightSubtle",
              borderColor: "inkeepPrimary.mediumSubtle",
              color: "inkeepPrimary.textBold"
            },
            _focus: {
              bg: "inkeepPrimary.lightSubtle",
              borderColor: "inkeepPrimary.mediumSubtle",
              color: "inkeepPrimary.textBold"
            }
          },
          _dark: {
            _hover: {
              borderColor: "inkeepExpandedPrimary.300"
            },
            _focus: {
              borderColor: "inkeepExpandedPrimary.300"
            }
          },
          border: "1px solid transparent",
          height: 11,
          borderRadius: "lg",
          children: [
            /* @__PURE__ */ v.jsx(Ct, { mr: "2", className: `${ye}-switch-to-chat-icon`, children: /* @__PURE__ */ v.jsx(
              G2,
              {
                height: "20px",
                width: "20px"
              }
            ) }),
            /* @__PURE__ */ v.jsxs(
              Ct,
              {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                w: "full",
                noOfLines: 1,
                children: [
                  /* @__PURE__ */ v.jsxs(
                    Ct,
                    {
                      display: "flex",
                      noOfLines: 1,
                      children: [
                        /* @__PURE__ */ v.jsx(
                          Ct,
                          {
                            fontWeight: "medium",
                            children: t || "Ask AI"
                          }
                        ),
                        /* @__PURE__ */ v.jsx(
                          Ct,
                          {
                            ml: 2,
                            fontWeight: "normal",
                            noOfLines: 1,
                            display: "block",
                            children: r && ` "${r}"`
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ v.jsx(
                    zn,
                    {
                      iconKey: "openLinkInSameTab",
                      w: 4,
                      h: 4,
                      visibility: "hidden",
                      _groupHover: {
                        visibility: "visible"
                      },
                      color: "inkeepPrimary.strong",
                      _dark: {
                        color: "inkeepExpandedPrimary.300"
                      }
                    }
                  )
                ]
              }
            )
          ]
        }
      )
    }
  );
}, Ule = $le;
function Vle({ ...e }) {
  return /* @__PURE__ */ v.jsx(
    zn,
    {
      iconKey: "search",
      w: 5,
      h: 5,
      fontSize: "xl",
      display: "flex",
      alignItems: "center",
      color: "gray.600",
      _dark: { color: "whiteAlpha.600" },
      ...e
    }
  );
}
const zT = Te(Vle), Wle = Je(
  ({ value: e, onChange: t, onKeyDown: r, placeholder: i, narrowView: n, onFocus: a, onBlur: o }, s) => /* @__PURE__ */ v.jsx(
    J7,
    {
      border: "none !important",
      boxShadow: "none !important",
      maxHeight: "10vh",
      minHeight: "38px",
      outline: "none !important",
      placeholder: i,
      px: n ? 0 : 3,
      py: n ? 0 : 2,
      value: e,
      onChange: t,
      onKeyDown: r,
      onFocus: a,
      onBlur: o,
      ref: s,
      className: `${ye}-search-bar-stand-alone__search-input`
    }
  )
), Gle = Wle, Kle = Je(
  ({
    setQuery: e,
    query: t,
    onKeyDown: r,
    switchToChat: i,
    narrowView: n = !1,
    activePage: a,
    setActivePage: o,
    showSearchResults: s,
    isMobile: l
  }, u) => {
    var N;
    const { placeholder: d, shouldShowAskAICard: c } = nc(), {
      isModeSwitchingEnabled: p,
      // closeOnBlur,
      askAILabel: f
    } = Ka(), g = qt(null);
    x1(em);
    const { setFocusedItem: k } = Jm();
    gt(() => {
      var P;
      em((P = g == null ? void 0 : g.current) == null ? void 0 : P.offsetHeight);
    }, [(N = g == null ? void 0 : g.current) == null ? void 0 : N.offsetHeight]);
    const y = (P) => {
      const B = P.target.value.length > 1e3 ? P.target.value.slice(0, 1e3) : P.target.value;
      e && e(B);
    }, _ = () => {
      k(0);
    }, A = () => {
      k(null);
    }, T = p && c;
    return /* @__PURE__ */ v.jsxs(bo, { px: n ? 2 : 5, gap: "0", children: [
      /* @__PURE__ */ v.jsxs(mt, { alignItems: "center", pt: "3", pb: s || T ? "1" : "3", direction: "row", children: [
        /* @__PURE__ */ v.jsxs(
          mt,
          {
            alignItems: "center",
            borderRadius: n ? "md" : "2xl",
            direction: "row",
            overflow: "hidden",
            position: "relative",
            top: "0 !important",
            width: "100%",
            ref: g,
            className: `${ye}-search-bar-stand-alone`,
            children: [
              /* @__PURE__ */ v.jsx(
                mt,
                {
                  alignItems: "flex-end",
                  direction: "column",
                  justify: "space-between",
                  position: "relative",
                  py: 2,
                  children: !n && /* @__PURE__ */ v.jsx(mt, { align: "center", children: /* @__PURE__ */ v.jsx(Ct, { minW: "20px", w: { base: "20px", sm: "24px" }, children: /* @__PURE__ */ v.jsx(
                    zT,
                    {
                      minW: "20px",
                      w: { base: "20px", sm: "24px" },
                      fontSize: { base: "20px", sm: "24px" },
                      className: `${ye}-search-bar-stand-alone__search-icon`
                    }
                  ) }) })
                }
              ),
              /* @__PURE__ */ v.jsx(
                Gle,
                {
                  ref: u,
                  value: t,
                  onChange: y,
                  onKeyDown: r,
                  placeholder: d || (l ? "Search..." : "Search for anything..."),
                  narrowView: n,
                  onFocus: _,
                  onBlur: A
                }
              )
            ]
          }
        ),
        p && /* @__PURE__ */ v.jsx(RT, { activePage: a, setActivePage: o })
      ] }),
      T && /* @__PURE__ */ v.jsx(
        Ule,
        {
          switchToChat: i,
          askAILabel: f,
          query: t
        }
      )
    ] });
  }
), Yle = Kle, qle = Je(
  ({
    setActivePage: e,
    setQuery: t,
    query: r,
    contentRef: i,
    switchToChat: n,
    activePage: a,
    ...o
  }, s) => {
    const {
      handleSearchQueryChange: l,
      searchFunctionsRef: u,
      isControlledSearchQuery: d,
      debounceTime: c = 0
    } = nc(), [p, f] = rt(r), g = qt(null), { focusedItem: k, setFocusedItem: y } = Jm(), _ = Nt(
      (B) => {
        f(B), y(0), c > 0 ? (g.current && clearTimeout(g.current), g.current = setTimeout(() => {
          d ? l == null || l(B) : (t(B), e("searchResults"));
        }, c)) : d ? l == null || l(B) : (t(B), e("searchResults"));
      },
      [
        d,
        l,
        e,
        c
      ]
    ), { shouldShowAskAICard: A } = nc(), { isModeSwitchingEnabled: T } = Ka(), N = T && A, P = (B) => {
      var J;
      const X = B.ctrlKey || B.metaKey || B.shiftKey || B.nativeEvent.isComposing, U = (J = i.current) == null ? void 0 : J.querySelectorAll(".ikp-result-card"), K = {
        Enter: () => {
          if (p) {
            if (B.preventDefault(), X)
              return;
            t(p), e("searchResults");
          }
          if (!B.shiftKey)
            if (B.preventDefault(), k === -1)
              n();
            else {
              if (!r)
                return;
              const ie = new CustomEvent("open-result-card", {
                detail: { focusedItem: k }
              });
              W_.dispatchEvent(ie);
            }
        },
        ArrowUp: () => {
          if (!X) {
            if (k || y(0), !r) {
              y(N ? -1 : 0);
              return;
            }
            k !== (N ? -1 : 0) && (y((ie) => ie - 1), B.preventDefault());
          }
        },
        ArrowDown: () => {
          if (!X) {
            if (k || y(0), !r) {
              y(N ? -1 : 0);
              return;
            }
            U.length - 1 !== k && (y((ie) => ie + 1), B.preventDefault());
          }
        }
      }, { key: z } = B, j = K[z];
      j == null || j();
    };
    return e8(u, () => ({
      updateSearchQuery: (B) => {
        t(B), e("searchResults");
      }
    })), gt(() => {
      s && typeof s != "function" && s.current && (s.current.focus(), s.current.selectionStart = s.current.value.length);
    }, [s]), /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx(CD, { children: /* @__PURE__ */ v.jsx(
        Yle,
        {
          ref: s,
          setQuery: _,
          switchToChat: n,
          ...o,
          query: d ? r : p,
          onKeyDown: P,
          setActivePage: e,
          activePage: a
        }
      ) }),
      /* @__PURE__ */ v.jsx(
        NT,
        {
          actionItems: /* @__PURE__ */ v.jsx(jle, {}),
          css: Hle.raw({
            showSearchResults: o.showSearchResults
          }),
          mainContent: o.showSearchResults ? /* @__PURE__ */ v.jsx(Lle, { query: r ?? "" }) : null,
          pageName: "searchResults",
          activePage: a
        }
      )
    ] });
  }
), Qle = qle, Xle = () => {
  x1(em);
  const {
    isModeSwitchingEnabled: e,
    openShortcutKey: t,
    onShortcutKeyPressed: r,
    isShortcutKeyEnabled: i,
    isAlignedToTop: n,
    isAlignedToRight: a,
    isOpen: o,
    onClose: s,
    closeOnBlur: l,
    defaultView: u,
    forceInitialDefaultView: d
  } = Ka(), [c, p] = Ql(), { prefilledQuery: f } = nc(), [g, k] = rt(f || ""), [y, _] = rt(!1), A = ED(), N = (d ? u : c.defaultView || u) === "AI_CHAT" || A && !d ? "aiChat" : "searchResults", [P, B] = rt(N), M = `mod+${t || "k"}`;
  rw(M, r || (() => {
  }), { preventDefault: !0 }, [
    i
  ]);
  const U = () => {
    p("defaultView", "AI_CHAT"), B("aiChat"), _(!0);
  };
  gt(() => {
    B(N), f && k(f);
  }, [N, f, B]), gt(() => {
    d && B(N);
  }, [o, N, d]);
  const K = ht.useRef(null), z = ht.useRef(null), j = ht.useRef(null), [J] = MM(`(max-width: ${Nr("breakpoints.sm")})`), [ie, ue] = rt(!1), [de, he] = rt(
    setTimeout(() => {
    }, 0)
  );
  Xu(() => {
    const He = g && P == "searchResults";
    return clearTimeout(de), He ? (he(
      setTimeout(() => {
        ue(!0);
      }, 400)
    ), () => void clearTimeout(de)) : (ue(!1), () => void clearTimeout(de));
  }, [g]), Xu(() => {
    g && P == "searchResults" && ue(!0);
  }, [P]);
  const Ee = Gd.modalInitialWidth, Le = n, L = a, me = J && P === "aiChat", [Se, G] = rt(0);
  return /* @__PURE__ */ v.jsx(
    Tle,
    {
      focusedItem: Se,
      setFocusedItem: G,
      children: /* @__PURE__ */ v.jsx(
        ri,
        {
          isCentered: !0,
          preventScroll: l,
          closeOnOutsideClick: l,
          closeOnEsc: !0,
          initialFocusEl: () => P == "aiChat" ? z.current : K.current,
          open: o,
          variant: l ? void 0 : "clickThrough",
          onClose: s,
          trapFocus: l,
          size: me ? "full" : void 0,
          children: /* @__PURE__ */ v.jsxs(Gs, { children: [
            l && /* @__PURE__ */ v.jsx(ri.Overlay, { backdropFilter: "blur(3px)" }),
            /* @__PURE__ */ v.jsx(ri.Container, { className: `${ye}-modal-widget__container`, children: /* @__PURE__ */ v.jsxs(
              ri.Content,
              {
                ref: j,
                className: `${ye}-modal-widget__content ${g8()}`,
                display: o ? void 0 : "none",
                _dark: { bgColor: "grayDark.900" },
                _light: { bgColor: "white" },
                borderRadius: me ? "none" : "lg",
                left: me ? "0px" : L ? void 0 : "auto",
                m: 0,
                overflow: "hidden",
                p: [0],
                position: "absolute",
                right: {
                  base: L ? P == "aiChat" ? "0px" : 6 : void 0,
                  md: L ? 6 : void 0
                },
                textAlign: "left",
                top: me ? "0px" : Le ? "5%" : void 0,
                transition: "width, min-width .3s ease-in-out",
                height: me ? "var(--chakra-vh)" : void 0,
                style: {
                  minWidth: Ee,
                  width: me ? "100vw" : Ee
                },
                children: [
                  /* @__PURE__ */ v.jsx(
                    $g,
                    {
                      overflow: "hidden",
                      flexGrow: me ? 0 : 5,
                      children: P != "aiChat" && /* @__PURE__ */ v.jsx(
                        Qle,
                        {
                          ref: K,
                          setActivePage: B,
                          activePage: P,
                          setQuery: k,
                          query: g,
                          showSearchResults: ie,
                          switchToChat: U,
                          contentRef: j,
                          isMobile: J
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ v.jsx($g, { overflow: "hidden", children: /* @__PURE__ */ v.jsx(
                    NT,
                    {
                      mainContent: /* @__PURE__ */ v.jsx(
                        Ct,
                        {
                          height: me ? "var(--chakra-vh)" : void 0,
                          style: {
                            maxHeight: me ? "unset" : Gd.modalHeight
                          },
                          children: /* @__PURE__ */ v.jsx(
                            OT,
                            {
                              aiChatInputRef: z,
                              isModeSwitchingEnabled: e,
                              showCloseButton: !l || me,
                              maxHeight: me ? "unset" : Gd.modalHeight,
                              activePage: P,
                              setActivePage: B,
                              query: g,
                              size: J ? "expand" : "shrink-vertically",
                              onModalClose: s,
                              shouldAutoSubmitQuery: y,
                              setShouldAutoSubmitQuery: _
                            }
                          )
                        }
                      ),
                      pageName: "aiChat",
                      activePage: P
                    }
                  ) })
                ]
              }
            ) })
          ] })
        }
      )
    }
  );
}, l5 = qM(
  T2(
    ({ baseProps: e, modalProps: t, searchProps: r, aiChatProps: i }) => /* @__PURE__ */ v.jsx(Em, { children: /* @__PURE__ */ v.jsx(vm, { ...e, children: /* @__PURE__ */ v.jsx(ym, { children: /* @__PURE__ */ v.jsx(hF, { children: /* @__PURE__ */ v.jsx(cF, { children: /* @__PURE__ */ v.jsx(tw, { initiallyActiveScopes: ["inkeep-initial"], children: /* @__PURE__ */ v.jsx(U1, { children: /* @__PURE__ */ v.jsx(L2, { ...t, children: /* @__PURE__ */ v.jsx(M2, { ...r, children: /* @__PURE__ */ v.jsx(z2, { ...i, children: /* @__PURE__ */ v.jsx(gF, { children: /* @__PURE__ */ v.jsx(Xle, {}) }) }) }) }) }) }) }) }) }) }) })
  )
), Zle = ht.memo(
  ({
    baseSettings: e,
    searchSettings: t,
    aiChatSettings: r,
    modalSettings: i,
    customStyles: n,
    shouldRender: a,
    ...o
  }) => {
    const s = (e == null ? void 0 : e.prism) || void 0;
    mm(s);
    const { isOpen: l, onOpen: u, onClose: d } = pm(), c = Jt(
      () => ({
        ...K_,
        ...u5.modalSettings,
        isShortcutKeyEnabled: (o == null ? void 0 : o.chatButtonType) === "RECTANGLE_SHORTCUT",
        ...i
      }),
      [i, o == null ? void 0 : o.chatButtonType]
    ), p = Jt(
      () => ({
        ...u5,
        ...o,
        ...c,
        isOpen: l,
        onOpen: u,
        onClose: d,
        onShortcutKeyPressed: c != null && c.isShortcutKeyEnabled ? u : () => {
        }
      }),
      [o, l, u, d, c]
    ), f = Jt(
      () => ({ ...l1, ...t }),
      [t]
    ), g = Jt(
      () => ({
        ...Hl,
        ...r,
        shouldAutoFocusInput: !0
      }),
      [r]
    ), k = Jt(
      () => ({
        ...F1,
        ...e,
        interactionType: hm.ChatButton
      }),
      [e]
    );
    return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx(
        l5,
        {
          baseProps: k,
          modalProps: p,
          searchProps: f,
          aiChatProps: g,
          customStyles: n,
          shouldRender: a
        }
      ),
      /* @__PURE__ */ v.jsx(
        qW,
        {
          baseProps: k,
          modalProps: p,
          searchProps: f,
          aiChatProps: g,
          customStyles: n,
          shouldRender: a,
          inkeepShadowProps: {
            wrapperStyles: {
              display: "contents"
            }
          }
        }
      )
    ] });
  },
  (e, t) => ql(e, t)
), Iue = S2(Zle), Jle = ht.memo(
  ({
    baseSettings: e,
    searchSettings: t,
    aiChatSettings: r,
    modalSettings: i,
    customStyles: n,
    shouldRender: a,
    ...o
  }) => {
    const s = (e == null ? void 0 : e.prism) || void 0;
    mm(s);
    const l = Jt(
      () => ({
        ...K_,
        ...i
      }),
      [i]
    ), u = Jt(
      () => ({
        ...l,
        ...o,
        onShortcutKeyPressed: l != null && l.isShortcutKeyEnabled ? i == null ? void 0 : i.onShortcutKeyPressed : () => {
        }
      }),
      [o, l, i == null ? void 0 : i.onShortcutKeyPressed]
    ), d = Jt(
      () => ({ ...l1, ...t }),
      [t]
    ), c = Jt(
      () => ({
        ...Hl,
        ...r,
        shouldAutoFocusInput: !0
      }),
      [r]
    ), p = Jt(
      () => ({
        ...F1,
        ...e,
        interactionType: hm.CustomTrigger
      }),
      [e]
    );
    return /* @__PURE__ */ v.jsx(
      l5,
      {
        baseProps: p,
        modalProps: u,
        searchProps: d,
        aiChatProps: c,
        customStyles: n,
        shouldRender: a
      }
    );
  },
  (e, t) => e.isOpen === t.isOpen && ql(e, t)
), Bue = S2(Jle), eue = ht.memo(
  ({
    baseSettings: e,
    aiChatSettings: t,
    shouldAutoFocusInput: r,
    isHidden: i
  }) => {
    const n = (e == null ? void 0 : e.prism) || void 0;
    mm(n);
    const o = {
      ...Hl,
      shouldAutoFocusInput: r ?? !0,
      ...t
    }, s = {
      ...F1,
      ...e
    };
    return /* @__PURE__ */ v.jsx(Em, { children: /* @__PURE__ */ v.jsx(
      vm,
      {
        ...s,
        interactionType: "EMBEDDED_CHAT",
        children: /* @__PURE__ */ v.jsx(ym, { children: /* @__PURE__ */ v.jsx(hF, { children: /* @__PURE__ */ v.jsx(cF, { children: /* @__PURE__ */ v.jsx(tw, { initiallyActiveScopes: ["inkeep-initial"], children: /* @__PURE__ */ v.jsx(U1, { children: /* @__PURE__ */ v.jsx(z2, { ...o, children: /* @__PURE__ */ v.jsx(gF, { children: /* @__PURE__ */ v.jsx(OT, { isHidden: i }) }) }) }) }) }) }) })
      }
    ) });
  },
  (e, t) => ql(e, t)
), Rue = ({
  ...e
}) => {
  var l;
  const t = (l = e.baseSettings) == null ? void 0 : l.theme, r = (t == null ? void 0 : t.stylesheetUrls) || [], i = t == null ? void 0 : t.stylesheets, n = j6(r), [a, o] = $6(n), s = Jt(
    () => /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      i,
      a
    ] }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n, i == null ? void 0 : i.length]
  );
  return /* @__PURE__ */ v.jsxs(P6, { wrapperStyles: { height: "inherit", width: "inherit" }, children: [
    s,
    o && /* @__PURE__ */ v.jsx(eue, { ...e })
  ] });
}, { withProvider: tue, withContext: ev } = Nn(LB), qx = _i(
  tue(Te("div"), "wrapper"),
  "SearchBarTrigger"
), rue = ev(
  Te(St.button, x8, { defaultProps: { variant: "ghost" } }),
  "container"
), iue = ev(Te("span"), "text"), nue = ev(Te("kbd", AB), "kbd"), aue = ev(Te("div"), "icon"), V0 = Object.assign(qx, {
  Wrapper: qx,
  Container: rue,
  Text: iue,
  Kbd: nue,
  Icon: aue
}), oue = ({
  onOpen: e,
  openShortcutKey: t,
  isShortcutKeyEnabled: r
}) => {
  const { placeholder: i } = nc();
  return /* @__PURE__ */ v.jsxs(V0.Container, { w: "100%", onClick: e, children: [
    /* @__PURE__ */ v.jsxs(mt, { alignItems: "center", minW: "0px", children: [
      /* @__PURE__ */ v.jsx(V0.Icon, { mr: 2, children: /* @__PURE__ */ v.jsx(zT, { className: `${ye}-search-bar-trigger__search-icon` }) }),
      /* @__PURE__ */ v.jsx(V0.Text, { children: i || "Search for anything..." })
    ] }),
    t && r && /* @__PURE__ */ v.jsx(V0.Kbd, { children: /* @__PURE__ */ v.jsx(YA, { openShortcutKey: t }) })
  ] });
}, sue = oue, lue = () => {
  const { onOpen: e, openShortcutKey: t, isShortcutKeyEnabled: r } = Ka();
  return /* @__PURE__ */ v.jsx(
    V0.Wrapper,
    {
      alignSelf: "center",
      justifySelf: "center",
      background: "transparent",
      children: /* @__PURE__ */ v.jsx(
        sue,
        {
          isShortcutKeyEnabled: r,
          openShortcutKey: t,
          onOpen: e
        }
      )
    }
  );
}, uue = T2(({ baseProps: e, modalProps: t, searchProps: r }) => /* @__PURE__ */ v.jsx(Em, { children: /* @__PURE__ */ v.jsx(vm, { ...e, children: /* @__PURE__ */ v.jsx(ym, { children: /* @__PURE__ */ v.jsx(U1, { children: /* @__PURE__ */ v.jsx(L2, { ...t, children: /* @__PURE__ */ v.jsx(M2, { ...r, children: /* @__PURE__ */ v.jsx(lue, {}) }) }) }) }) }) })), cue = ht.memo(
  ({
    baseSettings: e,
    searchSettings: t,
    aiChatSettings: r,
    modalSettings: i,
    customStyles: n,
    shouldRender: a,
    ...o
  }) => {
    const s = (e == null ? void 0 : e.prism) || void 0;
    mm(s);
    const { isOpen: l, onOpen: u, onClose: d } = pm(), c = Jt(
      () => ({
        ...K_,
        ...c5.modalSettings,
        ...i
      }),
      [i]
    ), p = Jt(
      () => ({
        ...c5,
        ...c,
        ...o,
        isOpen: l,
        onOpen: u,
        onClose: d,
        onShortcutKeyPressed: c != null && c.isShortcutKeyEnabled ? u : () => {
        }
      }),
      [o, l, u, d, c]
    ), f = Jt(
      () => ({ ...l1, ...t }),
      [t]
    ), g = Jt(
      () => ({
        ...Hl,
        ...r,
        shouldAutoFocusInput: !0
      }),
      [r]
    ), k = Jt(
      () => ({
        ...F1,
        ...e,
        interactionType: hm.SearchBar
      }),
      [e]
    );
    return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx(
        l5,
        {
          baseProps: k,
          modalProps: p,
          searchProps: f,
          aiChatProps: g,
          customStyles: n,
          shouldRender: a
        }
      ),
      /* @__PURE__ */ v.jsx(
        uue,
        {
          baseProps: k,
          modalProps: p,
          searchProps: f,
          customStyles: n,
          shouldRender: a,
          inkeepShadowProps: {
            wrapperStyles: { height: "inherit" }
          }
        }
      )
    ] });
  },
  (e, t) => ql(e, t)
), Oue = S2(cue);
export {
  s1 as ConsoleDebugLevel,
  Iue as InkeepChatButton,
  Zle as InkeepChatButtonCore,
  Bue as InkeepCustomTrigger,
  Jle as InkeepCustomTriggerCore,
  Rue as InkeepEmbeddedChat,
  eue as InkeepEmbeddedChatCore,
  Oue as InkeepSearchBar,
  cue as InkeepSearchBarCore,
  P6 as InkeepShadow,
  r8 as RemoteErrorLogsLevel,
  fue as chatMethods,
  u5 as defaultChatButtonModalProps,
  Hl as defaultInkeepAIChatSettings,
  F1 as defaultInkeepBaseSettings,
  l1 as defaultInkeepSearchSettings,
  K_ as defaultModalSettings,
  c5 as defaultSearchBarModalProps,
  gue as searchMethods,
  O6 as useShadowContext
};
